
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec808"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec808"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("86Wyx", function(module, exports) {
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.41
   Copyright © 2012-2025 Faisal Salman <f@faisalman.com>
   MIT License */ /*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */ /////////////////////////////////////////////////////////////////////////////////
(function(window1, undefined) {
    'use strict';
    //////////////
    // Constants
    /////////////
    var LIBVERSION = '1.0.41', EMPTY = '', UNKNOWN = '?', FUNC_TYPE = 'function', UNDEF_TYPE = 'undefined', OBJ_TYPE = 'object', STR_TYPE = 'string', MAJOR = 'major', MODEL = 'model', NAME = 'name', TYPE = 'type', VENDOR = 'vendor', VERSION = 'version', ARCHITECTURE = 'architecture', CONSOLE = 'console', MOBILE = 'mobile', TABLET = 'tablet', SMARTTV = 'smarttv', WEARABLE = 'wearable', EMBEDDED = 'embedded', UA_MAX_LENGTH = 500;
    var AMAZON = 'Amazon', APPLE = 'Apple', ASUS = 'ASUS', BLACKBERRY = 'BlackBerry', BROWSER = 'Browser', CHROME = 'Chrome', EDGE = 'Edge', FIREFOX = 'Firefox', GOOGLE = 'Google', HONOR = 'Honor', HUAWEI = 'Huawei', LENOVO = 'Lenovo', LG = 'LG', MICROSOFT = 'Microsoft', MOTOROLA = 'Motorola', NVIDIA = 'Nvidia', ONEPLUS = 'OnePlus', OPERA = 'Opera', OPPO = 'OPPO', SAMSUNG = 'Samsung', SHARP = 'Sharp', SONY = 'Sony', XIAOMI = 'Xiaomi', ZEBRA = 'Zebra', FACEBOOK = 'Facebook', CHROMIUM_OS = 'Chromium OS', MAC_OS = 'Mac OS', SUFFIX_BROWSER = ' Browser';
    ///////////
    // Helper
    //////////
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    ///////////////
    // Map helper
    //////////////
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        // loop through all regexes maps
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1]; // odd sequence (1,3,5,..)
            j = k = 0;
            // try matching uastring with regexes
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    // check if given property is actually array
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) // assign modified match
                            this[q[0]] = q[1].call(this, match);
                            else // assign given value, ignore regex match
                            this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            // check whether function or regex
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) // call function (usually string mapper)
                            this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else // sanitize match using given regex
                            this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            // check if current value is array
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return map.hasOwnProperty('*') ? map['*'] : str;
    };
    ///////////////
    // String map
    //////////////
    // Safari < 3.0
    var oldSafariMap = {
        '1.0': '/8',
        '1.2': '/1',
        '1.3': '/3',
        '2.0': '/412',
        '2.0.2': '/416',
        '2.0.3': '/417',
        '2.0.4': '/419',
        '?': '/'
    }, windowsVersionMap = {
        'ME': '4.90',
        'NT 3.11': 'NT3.51',
        'NT 4.0': 'NT4.0',
        '2000': 'NT 5.0',
        'XP': [
            'NT 5.1',
            'NT 5.2'
        ],
        'Vista': 'NT 6.0',
        '7': 'NT 6.1',
        '8': 'NT 6.2',
        '8.1': 'NT 6.3',
        '10': [
            'NT 6.4',
            'NT 10.0'
        ],
        'RT': 'ARM'
    };
    //////////////
    // Regex map
    /////////////
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'Chrome'
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
            ],
            [
                VERSION,
                [
                    NAME,
                    'Edge'
                ]
            ],
            [
                // Presto based
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Mini'
                ]
            ],
            [
                /\bop(?:rg)?x\/([\w\.]+)/i // Opera GX
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' GX'
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i // Opera Webkit
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                // Mixed
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i // Baidu
            ],
            [
                VERSION,
                [
                    NAME,
                    'Baidu'
                ]
            ],
            [
                /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i // Maxthon
            ],
            [
                VERSION,
                [
                    NAME,
                    'Maxthon'
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
                // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
                // Trident based
                /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
                /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
                /(heytap|ovi|115)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i // Weibo
            ],
            [
                NAME,
                VERSION
            ],
            [
                /quark(?:pc)?\/([-\w\.]+)/i // Quark
            ],
            [
                VERSION,
                [
                    NAME,
                    'Quark'
                ]
            ],
            [
                /\bddg\/([\w\.]+)/i // DuckDuckGo
            ],
            [
                VERSION,
                [
                    NAME,
                    'DuckDuckGo'
                ]
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
            ],
            [
                VERSION,
                [
                    NAME,
                    'UC' + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i // WeChat
            ],
            [
                VERSION,
                [
                    NAME,
                    'WeChat'
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i // Konqueror
            ],
            [
                VERSION,
                [
                    NAME,
                    'Konqueror'
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
            ],
            [
                VERSION,
                [
                    NAME,
                    'IE'
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i // Yandex
            ],
            [
                VERSION,
                [
                    NAME,
                    'Yandex'
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i // Smart Lenovo Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Smart Lenovo ' + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1 Secure ' + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i // Firefox Focus
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' Focus'
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i // Opera Touch
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Touch'
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Coc Coc'
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i // Dolphin
            ],
            [
                VERSION,
                [
                    NAME,
                    'Dolphin'
                ]
            ],
            [
                /coast\/([\w\.]+)/i // Opera Coast
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Coast'
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i // MIUI Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'MIUI' + SUFFIX_BROWSER
                ]
            ],
            [
                /fxios\/([\w\.-]+)/i // Firefox for iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihoobrowser\/?([\w\.]*)/i // 360
            ],
            [
                VERSION,
                [
                    NAME,
                    '360'
                ]
            ],
            [
                /\b(qq)\/([\w\.]+)/i // QQ
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1Browser'
                ],
                VERSION
            ],
            [
                /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1' + SUFFIX_BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i // Samsung Internet
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + ' Internet'
                ]
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i // Sogou Explorer
            ],
            [
                VERSION,
                [
                    NAME,
                    'Sogou Explorer'
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i // Sogou Mobile
            ],
            [
                [
                    NAME,
                    'Sogou Mobile'
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i // QQ/2345
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser|rekonq)/i,
                /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
            ],
            [
                NAME
            ],
            [
                /ome\/([\w\.]+) \w* ?(iron) saf/i,
                /ome\/([\w\.]+).+qihu (360)[es]e/i // 360
            ],
            [
                VERSION,
                NAME
            ],
            [
                // WebView
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /(daum)apps[\/ ]([\w\.]+)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i // Chromium/Instagram/Snapchat
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'GSA'
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i // TikTok
            ],
            [
                VERSION,
                [
                    NAME,
                    'TikTok'
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + ' Headless'
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
            ],
            [
                [
                    NAME,
                    CHROME + ' WebView'
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Android ' + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
            ],
            [
                VERSION,
                [
                    NAME,
                    'Mobile Safari'
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                // Gecko based
                /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
            ],
            [
                [
                    NAME,
                    'Netscape'
                ],
                VERSION
            ],
            [
                /(wolvic|librewolf)\/([\w\.]+)/i // Wolvic/LibreWolf
            ],
            [
                NAME,
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' Reality'
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                // Other
                /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser/Ladybird
                /\b(links) \(([\w\.]+)/i // Links
            ],
            [
                NAME,
                [
                    VERSION,
                    /_/g,
                    '.'
                ]
            ],
            [
                /(cobalt)\/([\w\.]+)/i // Cobalt
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /\b((amd|x|x86[-_]?|wow|win)64)\b/i // AMD64 (x64)
            ],
            [
                [
                    ARCHITECTURE,
                    'amd64'
                ]
            ],
            [
                /(ia32(?=;))/i,
                /\b((i[346]|x)86)(pc)?\b/i // IA32 (x86)
            ],
            [
                [
                    ARCHITECTURE,
                    'ia32'
                ]
            ],
            [
                /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i // ARM64
            ],
            [
                [
                    ARCHITECTURE,
                    'arm64'
                ]
            ],
            [
                /\b(arm(v[67])?ht?n?[fl]p?)\b/i // ARMHF
            ],
            [
                [
                    ARCHITECTURE,
                    'armhf'
                ]
            ],
            [
                // PocketPC mistakenly identified as PowerPC
                /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
            ],
            [
                [
                    ARCHITECTURE,
                    'arm'
                ]
            ],
            [
                /((ppc|powerpc)(64)?)( mac|;|\))/i // PowerPC
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                / sun4\w[;\)]/i // SPARC
            ],
            [
                [
                    ARCHITECTURE,
                    'sparc'
                ]
            ],
            [
                /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                //////////////////////////
                // MOBILES & TABLETS
                /////////////////////////
                // Samsung
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]((?!sm-[lr])[-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Apple
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i // iPod/iPhone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                // Sharp
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Honor
                /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HONOR
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /honor([-\w ]+)[;\)]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HONOR
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Huawei
                /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Xiaomi
                /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
                /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i // Mi Pad tablets
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
                / ([\w ]+) miui\/v?\d/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // OPPO
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    OPPO
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(opd2(\d{3}a?))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    strMapper,
                    {
                        'OnePlus': [
                            '304',
                            '403',
                            '203'
                        ],
                        '*': OPPO
                    }
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Vivo
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Vivo'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Realme
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Realme'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Motorola
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // LG
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Lenovo
                /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
                /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LENOVO
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Nokia
                /(nokia) (t[12][01])/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
                /nokia[-_ ]?(([-\w\. ]*))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    TYPE,
                    MOBILE
                ],
                [
                    VENDOR,
                    'Nokia'
                ]
            ],
            [
                // Google
                /(pixel (c|tablet))\b/i // Google Pixel C/Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Sony
                /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    'Xperia Tablet'
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OnePlus
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ONEPLUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Amazon
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    'Fire Phone $1'
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // BlackBerry
                /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i // BlackBerry 10
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Asus
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // HTC
                /(nexus 9)/i // HTC Nexus 9
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'HTC'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                // ZTE
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // TCL
                /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'TCL'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // itel
                /(itel) ((\w+))/i
            ],
            [
                [
                    VENDOR,
                    lowerize
                ],
                MODEL,
                [
                    TYPE,
                    strMapper,
                    {
                        'tablet': [
                            'p10001l',
                            'w7001'
                        ],
                        '*': 'mobile'
                    }
                ]
            ],
            [
                // Acer
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Acer'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Meizu
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Meizu'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Ulefone
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Ulefone'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Energizer
                /; (energy ?\w+)(?: bui|\))/i,
                /; energizer ([\w ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Energizer'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Cat
                /; cat (b35);/i,
                /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Cat'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Smartfren
                /((?:new )?andromax[\w- ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Smartfren'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Nothing
                /droid.+; (a(?:015|06[35]|142p?))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Nothing'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Archos
                /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
                /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Archos'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /archos ([\w ]+)( b|\))/i,
                /; (ac[3-6]\d\w{2,8})( b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Archos'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // MIXED
                /(imo) (tab \w+)/i,
                /(infinix) (x1101b?)/i // Infinix XPad
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Infinix/Tecno/Micromax/Advan
                /; (hmd|imo) ([\w ]+?)(?: bui|\))/i,
                /(hp) ([\w ]+\w)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,
                /(oppo) ?([\w ]+) bui/i // OPPO
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i // Surface Duo
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Fairphone'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i // AT&T
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'AT&T'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i // Siemens
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Siemens'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i // RCA Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'RCA'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Dell'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Verizon'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Barnes & Noble'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'NuVision'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i // ZTE K Series Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'ZTE'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i // ZTE Nubia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'ZTE'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Swiss'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i // Swiss ZUR Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Swiss'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i // Zeki Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Zeki'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
            ],
            [
                [
                    VENDOR,
                    'Dragon Touch'
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i // Insignia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Insignia'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'NextBook'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
            ],
            [
                [
                    VENDOR,
                    'Voice'
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
            ],
            [
                [
                    VENDOR,
                    'LvTel'
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i // Essential PH-1
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Essential'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Envizen'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'MachSpeed'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i // Rotor Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Rotor'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i // Nvidia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i // Sprint Phones
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i // Microsoft Kin
            ],
            [
                [
                    MODEL,
                    /\./g,
                    ' '
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                ///////////////////
                // SMARTTVS
                ///////////////////
                /smart-tv.+(samsung)/i // Samsung
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    'SmartTV'
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i // Apple TV
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + ' TV'
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i // Google Chromecast
            ],
            [
                [
                    MODEL,
                    CHROME + 'cast'
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i // Fire TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(shield \w+ tv)/i // Nvidia Shield TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i // Sharp
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i // Sony
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mi(tv|box)-?\w+) bui/i // Xiaomi
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i // TechniSAT
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i // HbbTV devices
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                // SmartTV from Unidentified Vendors
                /droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                ///////////////////
                // CONSOLES
                ///////////////////
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i // Nintendo
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield)( bui|\))/i // Nvidia Portable
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation \w+)/i // Playstation
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                ///////////////////
                // WEARABLES
                ///////////////////
                /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i // Samsung Galaxy Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /((pebble))app/i,
                /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i // Asus ZenWatch / LG Watch / Pixel Watch
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(ow(?:19|20)?we?[1-3]{1,3})/i // Oppo Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    OPPO
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i // Apple Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(opwwe\d{3})/i // OnePlus Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ONEPLUS
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(moto 360)/i // Motorola 360
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(smartwatch 3)/i // Sony SmartWatch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(g watch r)/i // LG G Watch R
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // XR
                ///////////////////
                /droid.+; (glass) \d/i // Google Glass
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(pico) (4|neo3(?: link|pro)?)/i // Pico
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /; (quest( \d| pro)?)/i // Oculus Quest
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // EMBEDDED
                ///////////////////
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i // Echo Dot
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(homepod).+mac os/i // Apple HomePod
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /windows iot/i
            ],
            [
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                ////////////////////
                // MIXED (GENERIC)
                ///////////////////
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([\w\. -]+)( bui|\))/i // Generic Android Device
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Generic'
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i // EdgeHTML
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + 'HTML'
                ]
            ],
            [
                /(arkweb)\/([\w\.]+)/i // ArkWeb
            ],
            [
                NAME,
                VERSION
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
            ],
            [
                VERSION,
                [
                    NAME,
                    'Blink'
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i // LibWeb
            ],
            [
                NAME,
                VERSION
            ],
            [
                /ladybird\//i
            ],
            [
                [
                    NAME,
                    'LibWeb'
                ]
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                // Windows
                /microsoft (windows) (vista|xp)/i // Windows (iTunes)
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i // Windows Phone
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    'Windows'
                ]
            ],
            [
                // iOS/macOS
                /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    '.'
                ],
                [
                    NAME,
                    'iOS'
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    '.'
                ]
            ],
            [
                // Mobile OSes
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(ubuntu) ([\w\.]+) like android/i // Ubuntu Touch
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1 Touch'
                ],
                VERSION
            ],
            [
                // Android/Blackberry/WebOS/QNX/Bada/RIM/KaiOS/Maemo/MeeGo/S40/Sailfish OS/OpenHarmony/Tizen
                /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i // BlackBerry 10
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i // Symbian
            ],
            [
                VERSION,
                [
                    NAME,
                    'Symbian'
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' OS'
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'webOS'
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i // watchOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'watchOS'
                ]
            ],
            [
                // Google Chromecast
                /crkey\/([\d\.]+)/i // Google Chromecast
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + 'cast'
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i // Chromium OS
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                // Smart TVs
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                // Console
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                // Other
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
                /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i // Haiku
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i // Solaris
            ],
            [
                [
                    NAME,
                    'Solaris'
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i // UNIX
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    /////////////////
    // Constructor
    ////////////////
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = 'Brave';
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == 'Macintosh' && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = 'iPad';
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != 'Unknown') _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS); // backward compatibility
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    ///////////
    // Export
    //////////
    // check js environment
    if (typeof exports !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) // browser env
        window1.UAParser = UAParser;
    }
    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === 'object' ? window : this);

});

parcelRegister("4HTAf", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1luWu = parcelRequire("1luWu");

var $2BI5W = parcelRequire("2BI5W");

var $14Wv2 = parcelRequire("14Wv2");

var $9pBcX = parcelRequire("9pBcX");

var $l7div = parcelRequire("l7div");

var $kJznu = parcelRequire("kJznu");

var $3su1E = parcelRequire("3su1E");

var $d7AD6 = parcelRequire("d7AD6");

var $hz1oH = parcelRequire("hz1oH");

var $boK9h = parcelRequire("boK9h");

var $3wAM2 = parcelRequire("3wAM2");

var $5pv9T = parcelRequire("5pv9T");

var $3pVDh = parcelRequire("3pVDh");

var $3rSi0 = parcelRequire("3rSi0");

var $dknph = parcelRequire("dknph");

var $aRHOP = parcelRequire("aRHOP");

var $i98W3 = parcelRequire("i98W3");

var $8DrvK = parcelRequire("8DrvK");

var $lONWe = parcelRequire("lONWe");

var $1xFq0 = parcelRequire("1xFq0");

var $4bnGa = parcelRequire("4bnGa");

var $6FBPf = parcelRequire("6FBPf");

var $iS3Yk = parcelRequire("iS3Yk");

var $htzrJ = parcelRequire("htzrJ");

var $jukkv = parcelRequire("jukkv");

var $bsUcA = parcelRequire("bsUcA");

var $3XVPB = parcelRequire("3XVPB");

var $bzcaU = parcelRequire("bzcaU");

var $dXGj2 = parcelRequire("dXGj2");

var $io2GI = parcelRequire("io2GI");

var $02PaP = parcelRequire("02PaP");

var $k2EST = parcelRequire("k2EST");

var $71viH = parcelRequire("71viH");

var $cI72D = parcelRequire("cI72D");

var $c8o8z = parcelRequire("c8o8z");

var $9EfhF = parcelRequire("9EfhF");

var $cu5Ya = parcelRequire("cu5Ya");

var $cXaTJ = parcelRequire("cXaTJ");

var $1JmGh = parcelRequire("1JmGh");

var $jTC4y = parcelRequire("jTC4y");

var $13jPF = parcelRequire("13jPF");

var $5ob0u = parcelRequire("5ob0u");

var $9ZOjK = parcelRequire("9ZOjK");

var $ciHXl = parcelRequire("ciHXl");

var $lNccF = parcelRequire("lNccF");

var $dQEGN = parcelRequire("dQEGN");

var $ixEJH = parcelRequire("ixEJH");

var $eXvrd = parcelRequire("eXvrd");

var $b3Isg = parcelRequire("b3Isg");

var $ljBvc = parcelRequire("ljBvc");

var $hhWrw = parcelRequire("hhWrw");

var $ft8tx = parcelRequire("ft8tx");

var $jCSeW = parcelRequire("jCSeW");

var $3mhH9 = parcelRequire("3mhH9");

var $5lbpt = parcelRequire("5lbpt");

var $h1aOQ = parcelRequire("h1aOQ");

var $3AKo2 = parcelRequire("3AKo2");

var $2aQlx = parcelRequire("2aQlx");

var $fTqrd = parcelRequire("fTqrd");

var $jf5XH = parcelRequire("jf5XH");

var $667w2 = parcelRequire("667w2");

var $85QQN = parcelRequire("85QQN");

var $kSd27 = parcelRequire("kSd27");

var $3HHYv = parcelRequire("3HHYv");

var $7RlKL = parcelRequire("7RlKL");

var $wImw7 = parcelRequire("wImw7");

var $dToAN = parcelRequire("dToAN");

var $fF0Ei = parcelRequire("fF0Ei");

var $aKXLl = parcelRequire("aKXLl");

var $6qA6p = parcelRequire("6qA6p");

var $cNTun = parcelRequire("cNTun");

var $2cJCG = parcelRequire("2cJCG");

var $hPYiy = parcelRequire("hPYiy");

var $fmpEn = parcelRequire("fmpEn");

var $lUkJd = parcelRequire("lUkJd");

var $jTUhJ = parcelRequire("jTUhJ");

var $4XFa2 = parcelRequire("4XFa2");

var $iMpUn = parcelRequire("iMpUn");

var $igLrB = parcelRequire("igLrB");

var $eVEl3 = parcelRequire("eVEl3");

var $3uYc3 = parcelRequire("3uYc3");

var $44TbO = parcelRequire("44TbO");

var $bmhFg = parcelRequire("bmhFg");

var $dKoIL = parcelRequire("dKoIL");

var $dpToc = parcelRequire("dpToc");

var $9ysLw = parcelRequire("9ysLw");

var $5A7F2 = parcelRequire("5A7F2");

var $aIgLw = parcelRequire("aIgLw");

var $4htth = parcelRequire("4htth");

var $9QwBg = parcelRequire("9QwBg");

var $9dzpp = parcelRequire("9dzpp");

var $6WjYJ = parcelRequire("6WjYJ");

var $fJO1p = parcelRequire("fJO1p");

var $df0Nw = parcelRequire("df0Nw");

var $1tLsV = parcelRequire("1tLsV");

var $lQTuS = parcelRequire("lQTuS");

var $gS6wu = parcelRequire("gS6wu");

var $2Gnkt = parcelRequire("2Gnkt");

var $evMTG = parcelRequire("evMTG");

var $faKNH = parcelRequire("faKNH");

var $boXIs = parcelRequire("boXIs");

var $bfQBA = parcelRequire("bfQBA");

var $4PbDj = parcelRequire("4PbDj");

var $ebmb1 = parcelRequire("ebmb1");

var $cFmVy = parcelRequire("cFmVy");

var $jpH30 = parcelRequire("jpH30");

var $6ZCTz = parcelRequire("6ZCTz");

var $jEfDT = parcelRequire("jEfDT");

var $kYMFh = parcelRequire("kYMFh");

var $g9OND = parcelRequire("g9OND");

var $b5AAT = parcelRequire("b5AAT");

var $cGnx0 = parcelRequire("cGnx0");

var $jOIOA = parcelRequire("jOIOA");

var $3q75X = parcelRequire("3q75X");

var $iThCW = parcelRequire("iThCW");

var $4q8ZE = parcelRequire("4q8ZE");

var $dXYuT = parcelRequire("dXYuT");

var $hvGoi = parcelRequire("hvGoi");

var $YfOkS = parcelRequire("YfOkS");

var $hvU0C = parcelRequire("hvU0C");

var $ljke5 = parcelRequire("ljke5");

var $aztsl = parcelRequire("aztsl");

var $79d7h = parcelRequire("79d7h");

var $1aID7 = parcelRequire("1aID7");

var $eMfEg = parcelRequire("eMfEg");

var $aFZw5 = parcelRequire("aFZw5");

var $1UPRv = parcelRequire("1UPRv");

var $8iRTV = parcelRequire("8iRTV");

var $aaVDI = parcelRequire("aaVDI");

var $l8ak2 = parcelRequire("l8ak2");

var $kzIHY = parcelRequire("kzIHY");

var $8We3n = parcelRequire("8We3n");

var $75YtR = parcelRequire("75YtR");

var $1Vg0b = parcelRequire("1Vg0b");

var $9leca = parcelRequire("9leca");

var $82RPZ = parcelRequire("82RPZ");

var $erV30 = parcelRequire("erV30");

var $1HyJh = parcelRequire("1HyJh");

var $kzgET = parcelRequire("kzgET");

var $1MCl5 = parcelRequire("1MCl5");

var $jrPYE = parcelRequire("jrPYE");

var $8zi2C = parcelRequire("8zi2C");

var $5gI17 = parcelRequire("5gI17");

var $gFX5W = parcelRequire("gFX5W");

var $iMxjn = parcelRequire("iMxjn");

var $lJcxl = parcelRequire("lJcxl");

var $9NHnC = parcelRequire("9NHnC");

var $2TyT2 = parcelRequire("2TyT2");

var $gqrdu = parcelRequire("gqrdu");

var $3Xjyi = parcelRequire("3Xjyi");

var $88W3d = parcelRequire("88W3d");

var $fmNiC = parcelRequire("fmNiC");

var $lw8Ay = parcelRequire("lw8Ay");

var $jONpA = parcelRequire("jONpA");

var $8odom = parcelRequire("8odom");

var $6J2LB = parcelRequire("6J2LB");
module.exports.registerSpanErrorInstrumentation = $1luWu.registerSpanErrorInstrumentation;
module.exports.getCapturedScopesOnSpan = $2BI5W.getCapturedScopesOnSpan;
module.exports.markSpanAsTracerProviderSpan = $2BI5W.markSpanAsTracerProviderSpan;
module.exports.markSpanForOtelSourceInference = $2BI5W.markSpanForOtelSourceInference;
module.exports.markSpanSourceAsExplicit = $2BI5W.markSpanSourceAsExplicit;
module.exports.setCapturedScopesOnSpan = $2BI5W.setCapturedScopesOnSpan;
module.exports.spanIsTracerProviderSpan = $2BI5W.spanIsTracerProviderSpan;
module.exports.spanShouldInferOtelSource = $2BI5W.spanShouldInferOtelSource;
module.exports.spanSourceWasExplicitlySet = $2BI5W.spanSourceWasExplicitlySet;
module.exports.TRACING_DEFAULTS = $14Wv2.TRACING_DEFAULTS;
module.exports.startIdleSpan = $14Wv2.startIdleSpan;
module.exports.SentrySpan = $9pBcX.SentrySpan;
module.exports._INTERNAL_setDeferSegmentSpanCapture = $l7div._INTERNAL_setDeferSegmentSpanCapture;
module.exports.SentryNonRecordingSpan = $kJznu.SentryNonRecordingSpan;
module.exports.SPAN_STATUS_ERROR = $3su1E.SPAN_STATUS_ERROR;
module.exports.SPAN_STATUS_OK = $3su1E.SPAN_STATUS_OK;
module.exports.SPAN_STATUS_UNSET = $3su1E.SPAN_STATUS_UNSET;
module.exports.getSpanStatusFromHttpCode = $3su1E.getSpanStatusFromHttpCode;
module.exports.setHttpStatus = $3su1E.setHttpStatus;
module.exports.SUPPRESS_TRACING_KEY = $d7AD6.SUPPRESS_TRACING_KEY;
module.exports._INTERNAL_startInactiveSpan = $d7AD6._INTERNAL_startInactiveSpan;
module.exports.continueTrace = $d7AD6.continueTrace;
module.exports.isTracingSuppressed = $d7AD6.isTracingSuppressed;
module.exports.spanIsIgnored = $d7AD6.spanIsIgnored;
module.exports.startInactiveSpan = $d7AD6.startInactiveSpan;
module.exports.startNewTrace = $d7AD6.startNewTrace;
module.exports.startSpan = $d7AD6.startSpan;
module.exports.startSpanManual = $d7AD6.startSpanManual;
module.exports.suppressTracing = $d7AD6.suppressTracing;
module.exports.withActiveSpan = $d7AD6.withActiveSpan;
module.exports.bindScopeToEmitter = $hz1oH.bindScopeToEmitter;
module.exports.getDynamicSamplingContextFromClient = $boK9h.getDynamicSamplingContextFromClient;
module.exports.getDynamicSamplingContextFromScope = $boK9h.getDynamicSamplingContextFromScope;
module.exports.getDynamicSamplingContextFromSpan = $boK9h.getDynamicSamplingContextFromSpan;
module.exports.spanToBaggageHeader = $boK9h.spanToBaggageHeader;
module.exports.setMeasurement = $3wAM2.setMeasurement;
module.exports.timedEventsToMeasurements = $3wAM2.timedEventsToMeasurements;
module.exports.sampleSpan = $5pv9T.sampleSpan;
module.exports.logSpanEnd = $3pVDh.logSpanEnd;
module.exports.logSpanStart = $3pVDh.logSpanStart;
module.exports.captureSpan = $3rSi0.captureSpan;
module.exports.safeSetSpanJSONAttributes = $3rSi0.safeSetSpanJSONAttributes;
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $dknph.GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_HIT = $dknph.SEMANTIC_ATTRIBUTE_CACHE_HIT;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = $dknph.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_KEY = $dknph.SEMANTIC_ATTRIBUTE_CACHE_KEY;
module.exports.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = $dknph.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
module.exports.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = $dknph.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
module.exports.SEMANTIC_ATTRIBUTE_PROFILE_ID = $dknph.SEMANTIC_ATTRIBUTE_PROFILE_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = $dknph.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = $dknph.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = $dknph.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = $dknph.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = $dknph.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_OP = $dknph.SEMANTIC_ATTRIBUTE_SENTRY_OP;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = $dknph.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = $dknph.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = $dknph.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = $dknph.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = $dknph.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = $dknph.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = $dknph.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = $dknph.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = $dknph.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = $dknph.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE = $dknph.SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE;
module.exports.SEMANTIC_ATTRIBUTE_URL_FULL = $dknph.SEMANTIC_ATTRIBUTE_URL_FULL;
module.exports.SEMANTIC_ATTRIBUTE_USER_EMAIL = $dknph.SEMANTIC_ATTRIBUTE_USER_EMAIL;
module.exports.SEMANTIC_ATTRIBUTE_USER_ID = $dknph.SEMANTIC_ATTRIBUTE_USER_ID;
module.exports.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = $dknph.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS;
module.exports.SEMANTIC_ATTRIBUTE_USER_USERNAME = $dknph.SEMANTIC_ATTRIBUTE_USER_USERNAME;
module.exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = $dknph.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;
module.exports.createEventEnvelope = $aRHOP.createEventEnvelope;
module.exports.createSessionEnvelope = $aRHOP.createSessionEnvelope;
module.exports.createSpanEnvelope = $aRHOP.createSpanEnvelope;
module.exports.addEventProcessor = $i98W3.addEventProcessor;
module.exports.captureCheckIn = $i98W3.captureCheckIn;
module.exports.captureEvent = $i98W3.captureEvent;
module.exports.captureException = $i98W3.captureException;
module.exports.captureMessage = $i98W3.captureMessage;
module.exports.captureSession = $i98W3.captureSession;
module.exports.close = $i98W3.close;
module.exports.endSession = $i98W3.endSession;
module.exports.flush = $i98W3.flush;
module.exports.isEnabled = $i98W3.isEnabled;
module.exports.isInitialized = $i98W3.isInitialized;
module.exports.lastEventId = $i98W3.lastEventId;
module.exports.setAttribute = $i98W3.setAttribute;
module.exports.setAttributes = $i98W3.setAttributes;
module.exports.setContext = $i98W3.setContext;
module.exports.setConversationId = $i98W3.setConversationId;
module.exports.setExtra = $i98W3.setExtra;
module.exports.setExtras = $i98W3.setExtras;
module.exports.setTag = $i98W3.setTag;
module.exports.setTags = $i98W3.setTags;
module.exports.setUser = $i98W3.setUser;
module.exports.startSession = $i98W3.startSession;
module.exports.withMonitor = $i98W3.withMonitor;
module.exports.getClient = $8DrvK.getClient;
module.exports.getCurrentScope = $8DrvK.getCurrentScope;
module.exports.getExternalPropagationContext = $8DrvK.getExternalPropagationContext;
module.exports.getGlobalScope = $8DrvK.getGlobalScope;
module.exports.getIsolationScope = $8DrvK.getIsolationScope;
module.exports.getTraceContextFromScope = $8DrvK.getTraceContextFromScope;
module.exports.hasExternalPropagationContext = $8DrvK.hasExternalPropagationContext;
module.exports.registerExternalPropagationContext = $8DrvK.registerExternalPropagationContext;
module.exports.withIsolationScope = $8DrvK.withIsolationScope;
module.exports.withScope = $8DrvK.withScope;
module.exports.getDefaultCurrentScope = $lONWe.getDefaultCurrentScope;
module.exports.getDefaultIsolationScope = $lONWe.getDefaultIsolationScope;
module.exports.getAsyncContextStrategy = $1xFq0.getAsyncContextStrategy;
module.exports.setAsyncContextStrategy = $1xFq0.setAsyncContextStrategy;
module.exports._INTERNAL_createTracingChannelBinding = $4bnGa._INTERNAL_createTracingChannelBinding;
module.exports.waitForTracingChannelBinding = $4bnGa.waitForTracingChannelBinding;
module.exports.getGlobalSingleton = $6FBPf.getGlobalSingleton;
module.exports.getMainCarrier = $6FBPf.getMainCarrier;
module.exports.closeSession = $iS3Yk.closeSession;
module.exports.makeSession = $iS3Yk.makeSession;
module.exports.updateSession = $iS3Yk.updateSession;
module.exports.Scope = $htzrJ.Scope;
module.exports.notifyEventProcessors = $jukkv.notifyEventProcessors;
module.exports.SENTRY_API_VERSION = $bsUcA.SENTRY_API_VERSION;
module.exports.getEnvelopeEndpointWithUrlEncodedAuth = $bsUcA.getEnvelopeEndpointWithUrlEncodedAuth;
module.exports.getReportDialogEndpoint = $bsUcA.getReportDialogEndpoint;
module.exports.Client = $3XVPB.Client;
module.exports.initAndBind = $bzcaU.initAndBind;
module.exports.setCurrentClient = $bzcaU.setCurrentClient;
module.exports.createTransport = $dXGj2.createTransport;
module.exports.makeOfflineTransport = $io2GI.makeOfflineTransport;
module.exports.MULTIPLEXED_TRANSPORT_EXTRA_KEY = $02PaP.MULTIPLEXED_TRANSPORT_EXTRA_KEY;
module.exports.makeMultiplexedTransport = $02PaP.makeMultiplexedTransport;
module.exports.addIntegration = $k2EST.addIntegration;
module.exports.defineIntegration = $k2EST.defineIntegration;
module.exports.extendIntegration = $k2EST.extendIntegration;
module.exports.getIntegrationsToSetup = $k2EST.getIntegrationsToSetup;
module.exports.installedIntegrations = $k2EST.installedIntegrations;
module.exports._INTERNAL_clearAiProviderSkips = $71viH._INTERNAL_clearAiProviderSkips;
module.exports._INTERNAL_shouldSkipAiProviderWrapping = $71viH._INTERNAL_shouldSkipAiProviderWrapping;
module.exports._INTERNAL_skipAiProviderWrapping = $71viH._INTERNAL_skipAiProviderWrapping;
module.exports._INTERNAL_filterKeyValueData = $cI72D.filterKeyValueData;
module.exports._INTERNAL_filterCookies = $c8o8z.filterCookies;
module.exports._INTERNAL_filterQueryParams = $9EfhF.filterQueryParams;
module.exports.envToBool = $cu5Ya.envToBool;
module.exports.applyScopeDataToEvent = $cXaTJ.applyScopeDataToEvent;
module.exports.getCombinedScopeData = $cXaTJ.getCombinedScopeData;
module.exports.mergeScopeData = $cXaTJ.mergeScopeData;
module.exports.prepareEvent = $1JmGh.prepareEvent;
module.exports.createCheckInEnvelope = $jTC4y.createCheckInEnvelope;
module.exports.hasSpansEnabled = $13jPF.hasSpansEnabled;
module.exports.isStreamedBeforeSendSpanCallback = $5ob0u.isStreamedBeforeSendSpanCallback;
module.exports.withStreamedSpan = $5ob0u.withStreamedSpan;
module.exports.isSentryRequestUrl = $9ZOjK.isSentryRequestUrl;
module.exports.handleCallbackErrors = $ciHXl.handleCallbackErrors;
module.exports.fmt = $lNccF.fmt;
module.exports.parameterize = $lNccF.parameterize;
module.exports.handleTunnelRequest = $dQEGN.handleTunnelRequest;
module.exports.addAutoIpAddressToSession = $ixEJH.addAutoIpAddressToSession;
module.exports.addAutoIpAddressToUser = $ixEJH.addAutoIpAddressToUser;
module.exports.INTERNAL_getSegmentSpan = $eXvrd.INTERNAL_getSegmentSpan;
module.exports.addChildSpanToSpan = $eXvrd.addChildSpanToSpan;
module.exports.convertSpanLinksForEnvelope = $eXvrd.convertSpanLinksForEnvelope;
module.exports.getActiveSpan = $eXvrd.getActiveSpan;
module.exports.getRootSpan = $eXvrd.getRootSpan;
module.exports.getSpanDescendants = $eXvrd.getSpanDescendants;
module.exports.getStatusMessage = $eXvrd.getStatusMessage;
module.exports.spanIsSampled = $eXvrd.spanIsSampled;
module.exports.spanIsSentrySpan = $eXvrd.spanIsSentrySpan;
module.exports.spanTimeInputToSeconds = $eXvrd.spanTimeInputToSeconds;
module.exports.spanToJSON = $eXvrd.spanToJSON;
module.exports.spanToStreamedSpanJSON = $eXvrd.spanToStreamedSpanJSON;
module.exports.spanToTraceContext = $eXvrd.spanToTraceContext;
module.exports.spanToTraceHeader = $eXvrd.spanToTraceHeader;
module.exports.updateSpanName = $eXvrd.updateSpanName;
module.exports._INTERNAL_setSpanForScope = $b3Isg._setSpanForScope;
module.exports.parseSampleRate = $ljBvc.parseSampleRate;
module.exports.applySdkMetadata = $hhWrw.applySdkMetadata;
module.exports.getTraceData = $ft8tx.getTraceData;
module.exports.shouldPropagateTraceForUrl = $jCSeW.shouldPropagateTraceForUrl;
module.exports.getTraceMetaTags = $3mhH9.getTraceMetaTags;
module.exports.debounce = $5lbpt.debounce;
module.exports.uniq = $h1aOQ.uniq;
module.exports.derefWeakRef = $3AKo2.derefWeakRef;
module.exports.makeWeakRef = $3AKo2.makeWeakRef;
module.exports.shouldIgnoreSpan = $2aQlx.shouldIgnoreSpan;
module.exports.MAX_BODY_BYTE_LENGTH = $fTqrd.MAX_BODY_BYTE_LENGTH;
module.exports.captureBodyFromWinterCGRequest = $fTqrd.captureBodyFromWinterCGRequest;
module.exports.extractQueryParamsFromUrl = $fTqrd.extractQueryParamsFromUrl;
module.exports.getMaxBodyByteLength = $fTqrd.getMaxBodyByteLength;
module.exports.headersToDict = $fTqrd.headersToDict;
module.exports.httpHeadersToSpanAttributes = $fTqrd.httpHeadersToSpanAttributes;
module.exports.httpRequestToRequestData = $fTqrd.httpRequestToRequestData;
module.exports.winterCGHeadersToDict = $fTqrd.winterCGHeadersToDict;
module.exports.winterCGRequestToRequestData = $fTqrd.winterCGRequestToRequestData;
module.exports.DEFAULT_ENVIRONMENT = $jf5XH.DEFAULT_ENVIRONMENT;
module.exports.DEV_ENVIRONMENT = $jf5XH.DEV_ENVIRONMENT;
module.exports.SPAN_KIND = $667w2.SPAN_KIND;
module.exports.spanKindToName = $667w2.spanKindToName;
module.exports.addBreadcrumb = $85QQN.addBreadcrumb;
module.exports.functionToStringIntegration = $kSd27.functionToStringIntegration;
module.exports.eventFiltersIntegration = $3HHYv.eventFiltersIntegration;
module.exports.inboundFiltersIntegration = $3HHYv.inboundFiltersIntegration;
module.exports.linkedErrorsIntegration = $7RlKL.linkedErrorsIntegration;
module.exports.moduleMetadataIntegration = $wImw7.moduleMetadataIntegration;
module.exports.requestDataIntegration = $dToAN.requestDataIntegration;
module.exports.captureConsoleIntegration = $fF0Ei.captureConsoleIntegration;
module.exports.dedupeIntegration = $aKXLl.dedupeIntegration;
module.exports.extraErrorDataIntegration = $6qA6p.extraErrorDataIntegration;
module.exports.rewriteFramesIntegration = $cNTun.rewriteFramesIntegration;
module.exports.instrumentSupabaseClient = $2cJCG.instrumentSupabaseClient;
module.exports.supabaseIntegration = $2cJCG.supabaseIntegration;
module.exports.zodErrorsIntegration = $hPYiy.zodErrorsIntegration;
module.exports.thirdPartyErrorFilterIntegration = $fmpEn.thirdPartyErrorFilterIntegration;
module.exports.consoleIntegration = $lUkJd.consoleIntegration;
module.exports.featureFlagsIntegration = $jTUhJ.featureFlagsIntegration;
module.exports.growthbookIntegration = $4XFa2.growthbookIntegration;
module.exports.conversationIdIntegration = $iMpUn.conversationIdIntegration;
module.exports.profiler = $igLrB.profiler;
module.exports._INTERNAL_getTracingHeadersForFetchRequest = $eVEl3._INTERNAL_getTracingHeadersForFetchRequest;
module.exports.instrumentFetchRequest = $eVEl3.instrumentFetchRequest;
module.exports.captureFeedback = $3uYc3.captureFeedback;
module.exports._INTERNAL_captureLog = $44TbO._INTERNAL_captureLog;
module.exports._INTERNAL_captureSerializedLog = $44TbO._INTERNAL_captureSerializedLog;
module.exports._INTERNAL_flushLogsBuffer = $44TbO._INTERNAL_flushLogsBuffer;
module.exports.logger = $bmhFg;
module.exports.consoleLoggingIntegration = $dKoIL.consoleLoggingIntegration;
module.exports._INTERNAL_captureMetric = $dpToc._INTERNAL_captureMetric;
module.exports._INTERNAL_captureSerializedMetric = $dpToc._INTERNAL_captureSerializedMetric;
module.exports._INTERNAL_flushMetricsBuffer = $dpToc._INTERNAL_flushMetricsBuffer;
module.exports.metrics = $9ysLw;
module.exports.createConsolaReporter = $5A7F2.createConsolaReporter;
module.exports.addVercelAiProcessors = $aIgLw.addVercelAiProcessors;
module.exports.getProviderMetadataAttributes = $aIgLw.getProviderMetadataAttributes;
module.exports.getTruncatedJsonString = $4htth.getTruncatedJsonString;
module.exports.resolveAIRecordingOptions = $4htth.resolveAIRecordingOptions;
module.exports.shouldEnableTruncation = $4htth.shouldEnableTruncation;
module.exports.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = $9QwBg.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_MODEL_ATTRIBUTE = $9QwBg.GEN_AI_REQUEST_MODEL_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = $9QwBg.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE;
module.exports._INTERNAL_cleanupToolCallSpanContext = $9dzpp._INTERNAL_cleanupToolCallSpanContext;
module.exports._INTERNAL_getSpanContextForToolCallId = $9dzpp._INTERNAL_getSpanContextForToolCallId;
module.exports._INTERNAL_toolCallSpanContextMap = $6WjYJ.toolCallSpanContextMap;
module.exports.addOpenAiRequestAttributes = $fJO1p.addRequestAttributes;
module.exports.extractOpenAiRequestAttributes = $fJO1p.extractRequestAttributes;
module.exports.instrumentOpenAiClient = $fJO1p.instrumentOpenAiClient;
module.exports.addOpenAiResponseAttributes = $df0Nw.addResponseAttributes;
module.exports.extractOpenAiRequestParameters = $df0Nw.extractRequestParameters;
module.exports.instrumentOpenAiStream = $1tLsV.instrumentStream;
module.exports.OPENAI_INTEGRATION_NAME = $lQTuS.OPENAI_INTEGRATION_NAME;
module.exports.addAnthropicRequestAttributes = $gS6wu.addPrivateRequestAttributes;
module.exports.addAnthropicResponseAttributes = $gS6wu.addResponseAttributes;
module.exports.extractAnthropicRequestAttributes = $gS6wu.extractRequestAttributes;
module.exports.instrumentAnthropicAiClient = $gS6wu.instrumentAnthropicAiClient;
module.exports.instrumentAsyncIterableStream = $2Gnkt.instrumentAsyncIterableStream;
module.exports.instrumentMessageStream = $2Gnkt.instrumentMessageStream;
module.exports.ANTHROPIC_AI_INTEGRATION_NAME = $evMTG.ANTHROPIC_AI_INTEGRATION_NAME;
module.exports.addGoogleGenAIRequestAttributes = $faKNH.addPrivateRequestAttributes;
module.exports.addGoogleGenAIResponseAttributes = $faKNH.addResponseAttributes;
module.exports.extractGoogleGenAIRequestAttributes = $faKNH.extractRequestAttributes;
module.exports.instrumentGoogleGenAIClient = $faKNH.instrumentGoogleGenAIClient;
module.exports.instrumentGoogleGenAIStream = $boXIs.instrumentStream;
module.exports.GOOGLE_GENAI_INTEGRATION_NAME = $bfQBA.GOOGLE_GENAI_INTEGRATION_NAME;
module.exports.createLangChainCallbackHandler = $4PbDj.createLangChainCallbackHandler;
module.exports._INTERNAL_getLangChainEmbeddingsSpanOptions = $ebmb1._INTERNAL_getLangChainEmbeddingsSpanOptions;
module.exports.instrumentLangChainEmbeddings = $ebmb1.instrumentLangChainEmbeddings;
module.exports._INTERNAL_mergeLangChainCallbackHandler = $cFmVy._INTERNAL_mergeLangChainCallbackHandler;
module.exports.LANGCHAIN_INTEGRATION_NAME = $jpH30.LANGCHAIN_INTEGRATION_NAME;
module.exports._INTERNAL_getLangGraphCreateAgentSpanOptions = $6ZCTz._INTERNAL_getLangGraphCreateAgentSpanOptions;
module.exports.instrumentCompiledGraphInvoke = $6ZCTz.instrumentCompiledGraphInvoke;
module.exports.instrumentCreateReactAgent = $6ZCTz.instrumentCreateReactAgent;
module.exports.instrumentLangGraph = $6ZCTz.instrumentLangGraph;
module.exports.instrumentStateGraph = $6ZCTz.instrumentStateGraph;
module.exports.instrumentStateGraphCompile = $6ZCTz.instrumentStateGraphCompile;
module.exports.extractAgentNameFromParams = $jEfDT.extractAgentNameFromParams;
module.exports.extractLLMFromParams = $jEfDT.extractLLMFromParams;
module.exports.wrapToolsWithSpans = $jEfDT.wrapToolsWithSpans;
module.exports.LANGGRAPH_INTEGRATION_NAME = $kYMFh.LANGGRAPH_INTEGRATION_NAME;
module.exports.instrumentWorkersAiClient = $g9OND.instrumentWorkersAiClient;
module.exports.SpanBuffer = $b5AAT.SpanBuffer;
module.exports.hasSpanStreamingEnabled = $cGnx0.hasSpanStreamingEnabled;
module.exports.spanStreamingIntegration = $jOIOA.spanStreamingIntegration;
module.exports._INTERNAL_FLAG_BUFFER_SIZE = $3q75X._INTERNAL_FLAG_BUFFER_SIZE;
module.exports._INTERNAL_MAX_FLAGS_PER_SPAN = $3q75X._INTERNAL_MAX_FLAGS_PER_SPAN;
module.exports._INTERNAL_addFeatureFlagToActiveSpan = $3q75X._INTERNAL_addFeatureFlagToActiveSpan;
module.exports._INTERNAL_copyFlagsFromScopeToEvent = $3q75X._INTERNAL_copyFlagsFromScopeToEvent;
module.exports._INTERNAL_insertFlagToScope = $3q75X._INTERNAL_insertFlagToScope;
module.exports.applyAggregateErrorsToEvent = $iThCW.applyAggregateErrorsToEvent;
module.exports.getBreadcrumbLogLevelFromHttpStatusCode = $4q8ZE.getBreadcrumbLogLevelFromHttpStatusCode;
module.exports.dsnFromString = $dXYuT.dsnFromString;
module.exports.dsnToString = $dXYuT.dsnToString;
module.exports.makeDsn = $dXYuT.makeDsn;
module.exports.SentryError = $hvGoi.SentryError;
module.exports.GLOBAL_OBJ = $YfOkS.GLOBAL_OBJ;
module.exports.addConsoleInstrumentationFilter = $hvU0C.addConsoleInstrumentationFilter;
module.exports.addConsoleInstrumentationHandler = $hvU0C.addConsoleInstrumentationHandler;
module.exports.addFetchEndInstrumentationHandler = $ljke5.addFetchEndInstrumentationHandler;
module.exports.addFetchInstrumentationHandler = $ljke5.addFetchInstrumentationHandler;
module.exports.addGlobalErrorInstrumentationHandler = $aztsl.addGlobalErrorInstrumentationHandler;
module.exports.addGlobalUnhandledRejectionInstrumentationHandler = $79d7h.addGlobalUnhandledRejectionInstrumentationHandler;
module.exports.addHandler = $1aID7.addHandler;
module.exports.maybeInstrument = $1aID7.maybeInstrument;
module.exports.resetInstrumentationHandlers = $1aID7.resetInstrumentationHandlers;
module.exports.triggerHandlers = $1aID7.triggerHandlers;
module.exports.isDOMError = $eMfEg.isDOMError;
module.exports.isDOMException = $eMfEg.isDOMException;
module.exports.isElement = $eMfEg.isElement;
module.exports.isError = $eMfEg.isError;
module.exports.isErrorEvent = $eMfEg.isErrorEvent;
module.exports.isEvent = $eMfEg.isEvent;
module.exports.isInstanceOf = $eMfEg.isInstanceOf;
module.exports.isObjectLike = $eMfEg.isObjectLike;
module.exports.isParameterizedString = $eMfEg.isParameterizedString;
module.exports.isPlainObject = $eMfEg.isPlainObject;
module.exports.isPrimitive = $eMfEg.isPrimitive;
module.exports.isRegExp = $eMfEg.isRegExp;
module.exports.isString = $eMfEg.isString;
module.exports.isSyntheticEvent = $eMfEg.isSyntheticEvent;
module.exports.isThenable = $eMfEg.isThenable;
module.exports.isVueViewModel = $eMfEg.isVueViewModel;
module.exports.isBrowser = $aFZw5.isBrowser;
module.exports.CONSOLE_LEVELS = $1UPRv.CONSOLE_LEVELS;
module.exports.consoleSandbox = $1UPRv.consoleSandbox;
module.exports.debug = $1UPRv.debug;
module.exports.originalConsoleMethods = $1UPRv.originalConsoleMethods;
module.exports.addContextToFrame = $8iRTV.addContextToFrame;
module.exports.addExceptionMechanism = $8iRTV.addExceptionMechanism;
module.exports.addExceptionTypeValue = $8iRTV.addExceptionTypeValue;
module.exports.checkOrSetAlreadyCaught = $8iRTV.checkOrSetAlreadyCaught;
module.exports.getEventDescription = $8iRTV.getEventDescription;
module.exports.isAlreadyCaptured = $8iRTV.isAlreadyCaptured;
module.exports.parseSemver = $8iRTV.parseSemver;
module.exports.uuid4 = $8iRTV.uuid4;
module.exports.normalize = $aaVDI.normalize;
module.exports.normalizeToSize = $aaVDI.normalizeToSize;
module.exports.normalizeUrlToBase = $aaVDI.normalizeUrlToBase;
module.exports.setNormalizeStringifier = $aaVDI.setNormalizeStringifier;
module.exports.setNormalizationDepthOverrideHint = $l8ak2.setNormalizationDepthOverrideHint;
module.exports.setSkipNormalizationHint = $l8ak2.setSkipNormalizationHint;
module.exports.addNonEnumerableProperty = $kzIHY.addNonEnumerableProperty;
module.exports.convertToPlainObject = $kzIHY.convertToPlainObject;
module.exports.dropUndefinedKeys = $kzIHY.dropUndefinedKeys;
module.exports.extractExceptionKeysForMessage = $kzIHY.extractExceptionKeysForMessage;
module.exports.fill = $kzIHY.fill;
module.exports.getOriginalFunction = $kzIHY.getOriginalFunction;
module.exports.markFunctionWrapped = $kzIHY.markFunctionWrapped;
module.exports.objectify = $kzIHY.objectify;
module.exports.basename = $8We3n.basename;
module.exports.dirname = $8We3n.dirname;
module.exports.isAbsolute = $8We3n.isAbsolute;
module.exports.join = $8We3n.join;
module.exports.normalizePath = $8We3n.normalizePath;
module.exports.relative = $8We3n.relative;
module.exports.resolve = $8We3n.resolve;
module.exports.SENTRY_BUFFER_FULL_ERROR = $75YtR.SENTRY_BUFFER_FULL_ERROR;
module.exports.makePromiseBuffer = $75YtR.makePromiseBuffer;
module.exports.severityLevelFromString = $1Vg0b.severityLevelFromString;
module.exports.replaceExports = $9leca.replaceExports;
module.exports.UNKNOWN_FUNCTION = $82RPZ.UNKNOWN_FUNCTION;
module.exports.createStackParser = $82RPZ.createStackParser;
module.exports.getFramesFromEvent = $82RPZ.getFramesFromEvent;
module.exports.getFunctionName = $82RPZ.getFunctionName;
module.exports.stackParserFromStackParserOptions = $82RPZ.stackParserFromStackParserOptions;
module.exports.stripSentryFramesAndReverse = $82RPZ.stripSentryFramesAndReverse;
module.exports.isMatchingPattern = $erV30.isMatchingPattern;
module.exports.safeJoin = $erV30.safeJoin;
module.exports.snipLine = $erV30.snipLine;
module.exports.stringMatchesSomePattern = $erV30.stringMatchesSomePattern;
module.exports.stringify = $erV30.stringify;
module.exports.truncate = $erV30.truncate;
module.exports.isNativeFunction = $1HyJh.isNativeFunction;
module.exports.supportsDOMError = $1HyJh.supportsDOMError;
module.exports.supportsDOMException = $1HyJh.supportsDOMException;
module.exports.supportsErrorEvent = $1HyJh.supportsErrorEvent;
module.exports.supportsFetch = $1HyJh.supportsFetch;
module.exports.supportsHistory = $1HyJh.supportsHistory;
module.exports.supportsNativeFetch = $1HyJh.supportsNativeFetch;
module.exports.supportsReferrerPolicy = $1HyJh.supportsReferrerPolicy;
module.exports.supportsReportingObserver = $1HyJh.supportsReportingObserver;
module.exports.SyncPromise = $kzgET.SyncPromise;
module.exports.rejectedSyncPromise = $kzgET.rejectedSyncPromise;
module.exports.resolvedSyncPromise = $kzgET.resolvedSyncPromise;
module.exports.browserPerformanceTimeOrigin = $1MCl5.browserPerformanceTimeOrigin;
module.exports.dateTimestampInSeconds = $1MCl5.dateTimestampInSeconds;
module.exports.timestampInSeconds = $1MCl5.timestampInSeconds;
module.exports.TRACEPARENT_REGEXP = $jrPYE.TRACEPARENT_REGEXP;
module.exports.extractTraceparentData = $jrPYE.extractTraceparentData;
module.exports.generateSentryTraceHeader = $jrPYE.generateSentryTraceHeader;
module.exports.generateTraceparentHeader = $jrPYE.generateTraceparentHeader;
module.exports.propagationContextFromHeaders = $jrPYE.propagationContextFromHeaders;
module.exports.shouldContinueTrace = $jrPYE.shouldContinueTrace;
module.exports.getSDKSource = $8zi2C.getSDKSource;
module.exports.isBrowserBundle = $8zi2C.isBrowserBundle;
module.exports.addItemToEnvelope = $5gI17.addItemToEnvelope;
module.exports.createAttachmentEnvelopeItem = $5gI17.createAttachmentEnvelopeItem;
module.exports.createEnvelope = $5gI17.createEnvelope;
module.exports.createEventEnvelopeHeaders = $5gI17.createEventEnvelopeHeaders;
module.exports.createSpanEnvelopeItem = $5gI17.createSpanEnvelopeItem;
module.exports.envelopeContainsItemType = $5gI17.envelopeContainsItemType;
module.exports.envelopeItemTypeToDataCategory = $5gI17.envelopeItemTypeToDataCategory;
module.exports.forEachEnvelopeItem = $5gI17.forEachEnvelopeItem;
module.exports.getSdkMetadataForEnvelopeHeader = $5gI17.getSdkMetadataForEnvelopeHeader;
module.exports.parseEnvelope = $5gI17.parseEnvelope;
module.exports.serializeEnvelope = $5gI17.serializeEnvelope;
module.exports.createClientReportEnvelope = $gFX5W.createClientReportEnvelope;
module.exports.DEFAULT_RETRY_AFTER = $iMxjn.DEFAULT_RETRY_AFTER;
module.exports.disabledUntil = $iMxjn.disabledUntil;
module.exports.isRateLimited = $iMxjn.isRateLimited;
module.exports.parseRetryAfterHeader = $iMxjn.parseRetryAfterHeader;
module.exports.updateRateLimits = $iMxjn.updateRateLimits;
module.exports.MAX_BAGGAGE_STRING_LENGTH = $lJcxl.MAX_BAGGAGE_STRING_LENGTH;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX = $lJcxl.SENTRY_BAGGAGE_KEY_PREFIX;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX_REGEX = $lJcxl.SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
module.exports.baggageHeaderToDynamicSamplingContext = $lJcxl.baggageHeaderToDynamicSamplingContext;
module.exports.dynamicSamplingContextToSentryBaggageHeader = $lJcxl.dynamicSamplingContextToSentryBaggageHeader;
module.exports.mergeBaggageHeaders = $lJcxl.mergeBaggageHeaders;
module.exports.objectToBaggageHeader = $lJcxl.objectToBaggageHeader;
module.exports.parseBaggageHeader = $lJcxl.parseBaggageHeader;
module.exports.getHttpSpanDetailsFromUrlObject = $9NHnC.getHttpSpanDetailsFromUrlObject;
module.exports.getSanitizedUrlString = $9NHnC.getSanitizedUrlString;
module.exports.getSanitizedUrlStringFromUrlObject = $9NHnC.getSanitizedUrlStringFromUrlObject;
module.exports.isURLObjectRelative = $9NHnC.isURLObjectRelative;
module.exports.parseStringToURLObject = $9NHnC.parseStringToURLObject;
module.exports.parseUrl = $9NHnC.parseUrl;
module.exports.stripDataUrlContent = $9NHnC.stripDataUrlContent;
module.exports.stripUrlQueryAndFragment = $9NHnC.stripUrlQueryAndFragment;
module.exports._INTERNAL_enhanceErrorWithSentryInfo = $2TyT2._enhanceErrorWithSentryInfo;
module.exports.eventFromMessage = $2TyT2.eventFromMessage;
module.exports.eventFromUnknownInput = $2TyT2.eventFromUnknownInput;
module.exports.exceptionFromError = $2TyT2.exceptionFromError;
module.exports.parseStackFrames = $2TyT2.parseStackFrames;
module.exports.LRUMap = $gqrdu.LRUMap;
module.exports.generateSpanId = $3Xjyi.generateSpanId;
module.exports.generateTraceId = $3Xjyi.generateTraceId;
module.exports.SDK_VERSION = $88W3d.SDK_VERSION;
module.exports.getDebugImagesForResources = $fmNiC.getDebugImagesForResources;
module.exports.getFilenameToDebugIdMap = $fmNiC.getFilenameToDebugIdMap;
module.exports.getFilenameToMetadataMap = $lw8Ay.getFilenameToMetadataMap;
module.exports.escapeStringForRegex = $jONpA.escapeStringForRegex;
module.exports._INTERNAL_safeDateNow = $8odom.safeDateNow;
module.exports._INTERNAL_safeMathRandom = $8odom.safeMathRandom;
module.exports._INTERNAL_withRandomSafeContext = $8odom.withRandomSafeContext;
module.exports.getComponentName = $6J2LB.getComponentName;
module.exports.getLocationHref = $6J2LB.getLocationHref;
module.exports.htmlTreeAsString = $6J2LB.htmlTreeAsString;

});
parcelRegister("1luWu", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9Yejo = parcelRequire("9Yejo");

var $aztsl = parcelRequire("aztsl");

var $79d7h = parcelRequire("79d7h");

var $1UPRv = parcelRequire("1UPRv");

var $eXvrd = parcelRequire("eXvrd");

var $3su1E = parcelRequire("3su1E");
let $0fafc11eeaa0e50b$var$errorsInstrumented = false;
function $0fafc11eeaa0e50b$var$registerSpanErrorInstrumentation() {
    if ($0fafc11eeaa0e50b$var$errorsInstrumented) return;
    function errorCallback() {
        const activeSpan = $eXvrd.getActiveSpan();
        const rootSpan = activeSpan && $eXvrd.getRootSpan(activeSpan);
        if (rootSpan) {
            const message = "internal_error";
            $9Yejo.DEBUG_BUILD && $1UPRv.debug.log(`[Tracing] Root span: ${message} -> Global error occurred`);
            rootSpan.setStatus({
                code: $3su1E.SPAN_STATUS_ERROR,
                message: message
            });
        }
    }
    $0fafc11eeaa0e50b$var$errorsInstrumented = true;
    $aztsl.addGlobalErrorInstrumentationHandler(errorCallback);
    $79d7h.addGlobalUnhandledRejectionInstrumentationHandler(errorCallback);
}
module.exports.registerSpanErrorInstrumentation = $0fafc11eeaa0e50b$var$registerSpanErrorInstrumentation;

});
parcelRegister("9Yejo", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $7424d1b21911d9ab$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
module.exports.DEBUG_BUILD = $7424d1b21911d9ab$var$DEBUG_BUILD;

});

parcelRegister("aztsl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $YfOkS = parcelRequire("YfOkS");

var $1aID7 = parcelRequire("1aID7");
let $7b2405a21e808980$var$_oldOnErrorHandler = null;
function $7b2405a21e808980$var$addGlobalErrorInstrumentationHandler(handler) {
    const type = "error";
    $1aID7.addHandler(type, handler);
    $1aID7.maybeInstrument(type, $7b2405a21e808980$var$instrumentError);
}
function $7b2405a21e808980$var$instrumentError() {
    $7b2405a21e808980$var$_oldOnErrorHandler = $YfOkS.GLOBAL_OBJ.onerror;
    $YfOkS.GLOBAL_OBJ.onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        $1aID7.triggerHandlers("error", handlerData);
        if ($7b2405a21e808980$var$_oldOnErrorHandler) return $7b2405a21e808980$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    $YfOkS.GLOBAL_OBJ.onerror.__SENTRY_INSTRUMENTED__ = true;
}
module.exports.addGlobalErrorInstrumentationHandler = $7b2405a21e808980$var$addGlobalErrorInstrumentationHandler;

});
parcelRegister("YfOkS", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $0b51de6b95fa6de0$var$GLOBAL_OBJ = globalThis;
module.exports.GLOBAL_OBJ = $0b51de6b95fa6de0$var$GLOBAL_OBJ;

});

parcelRegister("1aID7", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9Yejo = parcelRequire("9Yejo");

var $1UPRv = parcelRequire("1UPRv");

var $82RPZ = parcelRequire("82RPZ");
const $0da958315bda2c85$var$handlers = {};
const $0da958315bda2c85$var$instrumented = {};
function $0da958315bda2c85$var$addHandler(type, handler) {
    $0da958315bda2c85$var$handlers[type] = $0da958315bda2c85$var$handlers[type] || [];
    $0da958315bda2c85$var$handlers[type].push(handler);
    return ()=>{
        const typeHandlers = $0da958315bda2c85$var$handlers[type];
        if (typeHandlers) {
            const index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
function $0da958315bda2c85$var$resetInstrumentationHandlers() {
    Object.keys($0da958315bda2c85$var$handlers).forEach((key)=>{
        $0da958315bda2c85$var$handlers[key] = void 0;
    });
}
function $0da958315bda2c85$var$maybeInstrument(type, instrumentFn) {
    if (!$0da958315bda2c85$var$instrumented[type]) {
        $0da958315bda2c85$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            $9Yejo.DEBUG_BUILD && $1UPRv.debug.error(`Error while instrumenting ${type}`, e);
        }
    }
}
function $0da958315bda2c85$var$triggerHandlers(type, data) {
    const typeHandlers = type && $0da958315bda2c85$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${$82RPZ.getFunctionName(handler)}
Error:`, e);
    }
}
module.exports.addHandler = $0da958315bda2c85$var$addHandler;
module.exports.maybeInstrument = $0da958315bda2c85$var$maybeInstrument;
module.exports.resetInstrumentationHandlers = $0da958315bda2c85$var$resetInstrumentationHandlers;
module.exports.triggerHandlers = $0da958315bda2c85$var$triggerHandlers;

});
parcelRegister("1UPRv", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6FBPf = parcelRequire("6FBPf");

var $9Yejo = parcelRequire("9Yejo");

var $YfOkS = parcelRequire("YfOkS");
const $16534020d2a45cfe$var$CONSOLE_LEVELS = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
const $16534020d2a45cfe$var$PREFIX = "Sentry Logger ";
const $16534020d2a45cfe$var$originalConsoleMethods = {};
function $16534020d2a45cfe$var$consoleSandbox(callback) {
    if (!("console" in $YfOkS.GLOBAL_OBJ)) return callback();
    const console = $YfOkS.GLOBAL_OBJ.console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($16534020d2a45cfe$var$originalConsoleMethods);
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $16534020d2a45cfe$var$originalConsoleMethods[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $16534020d2a45cfe$var$enable() {
    $16534020d2a45cfe$var$_getLoggerSettings().enabled = true;
}
function $16534020d2a45cfe$var$disable() {
    $16534020d2a45cfe$var$_getLoggerSettings().enabled = false;
}
function $16534020d2a45cfe$var$isEnabled() {
    return $16534020d2a45cfe$var$_getLoggerSettings().enabled;
}
function $16534020d2a45cfe$var$log(...args) {
    $16534020d2a45cfe$var$_maybeLog("log", ...args);
}
function $16534020d2a45cfe$var$warn(...args) {
    $16534020d2a45cfe$var$_maybeLog("warn", ...args);
}
function $16534020d2a45cfe$var$error(...args) {
    $16534020d2a45cfe$var$_maybeLog("error", ...args);
}
function $16534020d2a45cfe$var$_maybeLog(level, ...args) {
    if (!$9Yejo.DEBUG_BUILD) return;
    if ($16534020d2a45cfe$var$isEnabled()) $16534020d2a45cfe$var$consoleSandbox(()=>{
        $YfOkS.GLOBAL_OBJ.console[level](`${$16534020d2a45cfe$var$PREFIX}[${level}]:`, ...args);
    });
}
function $16534020d2a45cfe$var$_getLoggerSettings() {
    if (!$9Yejo.DEBUG_BUILD) return {
        enabled: false
    };
    return $6FBPf.getGlobalSingleton("loggerSettings", ()=>({
            enabled: false
        }));
}
const $16534020d2a45cfe$var$debug = {
    enable: /** Enable logging. */ $16534020d2a45cfe$var$enable,
    disable: /** Disable logging. */ $16534020d2a45cfe$var$disable,
    isEnabled: /** Check if logging is enabled. */ $16534020d2a45cfe$var$isEnabled,
    log: /** Log a message. */ $16534020d2a45cfe$var$log,
    warn: /** Log a warning. */ $16534020d2a45cfe$var$warn,
    error: /** Log an error. */ $16534020d2a45cfe$var$error
};
module.exports.CONSOLE_LEVELS = $16534020d2a45cfe$var$CONSOLE_LEVELS;
module.exports.consoleSandbox = $16534020d2a45cfe$var$consoleSandbox;
module.exports.debug = $16534020d2a45cfe$var$debug;
module.exports.originalConsoleMethods = $16534020d2a45cfe$var$originalConsoleMethods;

});
parcelRegister("6FBPf", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $88W3d = parcelRequire("88W3d");

var $YfOkS = parcelRequire("YfOkS");
function $4db3e9cbfe494c30$var$getMainCarrier() {
    $4db3e9cbfe494c30$var$getSentryCarrier($YfOkS.GLOBAL_OBJ);
    return $YfOkS.GLOBAL_OBJ;
}
function $4db3e9cbfe494c30$var$getSentryCarrier(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.version = __SENTRY__.version || $88W3d.SDK_VERSION;
    return __SENTRY__[$88W3d.SDK_VERSION] = __SENTRY__[$88W3d.SDK_VERSION] || {};
}
function $4db3e9cbfe494c30$var$getGlobalSingleton(name, creator, obj = $YfOkS.GLOBAL_OBJ) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[$88W3d.SDK_VERSION] = __SENTRY__[$88W3d.SDK_VERSION] || {};
    return carrier[name] || (carrier[name] = creator());
}
module.exports.getGlobalSingleton = $4db3e9cbfe494c30$var$getGlobalSingleton;
module.exports.getMainCarrier = $4db3e9cbfe494c30$var$getMainCarrier;
module.exports.getSentryCarrier = $4db3e9cbfe494c30$var$getSentryCarrier;

});
parcelRegister("88W3d", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $5edc19c3bb2ea9c1$var$SDK_VERSION = "10.73.0";
module.exports.SDK_VERSION = $5edc19c3bb2ea9c1$var$SDK_VERSION;

});



parcelRegister("82RPZ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $5db845a544bf4f41$var$STACKTRACE_FRAME_LIMIT = 50;
const $5db845a544bf4f41$var$UNKNOWN_FUNCTION = "?";
const $5db845a544bf4f41$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $5db845a544bf4f41$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
function $5db845a544bf4f41$var$createStackParser(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            if (line.length > 1024) line = line.slice(0, 1024);
            const cleanedLine = $5db845a544bf4f41$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($5db845a544bf4f41$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            if (cleanedLine.includes("Error: ")) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $5db845a544bf4f41$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $5db845a544bf4f41$var$stripSentryFramesAndReverse(frames.slice(framesToPop));
    };
}
function $5db845a544bf4f41$var$stackParserFromStackParserOptions(stackParser) {
    if (Array.isArray(stackParser)) return $5db845a544bf4f41$var$createStackParser(...stackParser);
    return stackParser;
}
function $5db845a544bf4f41$var$stripSentryFramesAndReverse(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    if (/sentryWrapped/.test($5db845a544bf4f41$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    localStack.reverse();
    if ($5db845a544bf4f41$var$STRIP_FRAME_REGEXP.test($5db845a544bf4f41$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        if ($5db845a544bf4f41$var$STRIP_FRAME_REGEXP.test($5db845a544bf4f41$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $5db845a544bf4f41$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $5db845a544bf4f41$var$getLastStackFrame(localStack).filename,
            function: frame.function || $5db845a544bf4f41$var$UNKNOWN_FUNCTION
        }));
}
function $5db845a544bf4f41$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $5db845a544bf4f41$var$defaultFunctionName = "<anonymous>";
function $5db845a544bf4f41$var$getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== "function") return $5db845a544bf4f41$var$defaultFunctionName;
        return fn.name || $5db845a544bf4f41$var$defaultFunctionName;
    } catch  {
        return $5db845a544bf4f41$var$defaultFunctionName;
    }
}
function $5db845a544bf4f41$var$getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            exception.values.forEach((value)=>{
                if (value.stacktrace.frames) frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return void 0;
        }
    }
    return void 0;
}
function $5db845a544bf4f41$var$normalizeStackTracePath(path) {
    let filename = path?.startsWith("file://") ? path.slice(7) : path;
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}
module.exports.UNKNOWN_FUNCTION = $5db845a544bf4f41$var$UNKNOWN_FUNCTION;
module.exports.createStackParser = $5db845a544bf4f41$var$createStackParser;
module.exports.getFramesFromEvent = $5db845a544bf4f41$var$getFramesFromEvent;
module.exports.getFunctionName = $5db845a544bf4f41$var$getFunctionName;
module.exports.normalizeStackTracePath = $5db845a544bf4f41$var$normalizeStackTracePath;
module.exports.stackParserFromStackParserOptions = $5db845a544bf4f41$var$stackParserFromStackParserOptions;
module.exports.stripSentryFramesAndReverse = $5db845a544bf4f41$var$stripSentryFramesAndReverse;

});



parcelRegister("79d7h", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $YfOkS = parcelRequire("YfOkS");

var $1aID7 = parcelRequire("1aID7");
let $53438c5686582989$var$_oldOnUnhandledRejectionHandler = null;
function $53438c5686582989$var$addGlobalUnhandledRejectionInstrumentationHandler(handler) {
    const type = "unhandledrejection";
    $1aID7.addHandler(type, handler);
    $1aID7.maybeInstrument(type, $53438c5686582989$var$instrumentUnhandledRejection);
}
function $53438c5686582989$var$instrumentUnhandledRejection() {
    $53438c5686582989$var$_oldOnUnhandledRejectionHandler = $YfOkS.GLOBAL_OBJ.onunhandledrejection;
    $YfOkS.GLOBAL_OBJ.onunhandledrejection = function(e) {
        const handlerData = e;
        $1aID7.triggerHandlers("unhandledrejection", handlerData);
        if ($53438c5686582989$var$_oldOnUnhandledRejectionHandler) return $53438c5686582989$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    $YfOkS.GLOBAL_OBJ.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}
module.exports.addGlobalUnhandledRejectionInstrumentationHandler = $53438c5686582989$var$addGlobalUnhandledRejectionInstrumentationHandler;

});

parcelRegister("eXvrd", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1xFq0 = parcelRequire("1xFq0");

var $9eCUH = parcelRequire("9eCUH");

var $6FBPf = parcelRequire("6FBPf");

var $8DrvK = parcelRequire("8DrvK");

var $dknph = parcelRequire("dknph");

var $3su1E = parcelRequire("3su1E");

var $2BI5W = parcelRequire("2BI5W");

var $kzIHY = parcelRequire("kzIHY");

var $3Xjyi = parcelRequire("3Xjyi");

var $1MCl5 = parcelRequire("1MCl5");

var $jrPYE = parcelRequire("jrPYE");

var $1UPRv = parcelRequire("1UPRv");

var $b3Isg = parcelRequire("b3Isg");
const $ae3ef6501f8b97ee$var$TRACE_FLAG_NONE = 0;
const $ae3ef6501f8b97ee$var$TRACE_FLAG_SAMPLED = 1;
let $ae3ef6501f8b97ee$var$hasShownSpanDropWarning = false;
function $ae3ef6501f8b97ee$var$spanToTransactionTraceContext(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $ae3ef6501f8b97ee$var$spanToJSON(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
function $ae3ef6501f8b97ee$var$spanToTraceContext(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    const parent_span_id = isRemote ? spanId : $ae3ef6501f8b97ee$var$spanToJSON(span).parent_span_id;
    const scope = $2BI5W.getCapturedScopesOnSpan(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || $3Xjyi.generateSpanId() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
function $ae3ef6501f8b97ee$var$spanToTraceHeader(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $ae3ef6501f8b97ee$var$spanIsSampled(span);
    return $jrPYE.generateSentryTraceHeader(traceId, spanId, sampled);
}
function $ae3ef6501f8b97ee$var$spanToTraceparentHeader(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $ae3ef6501f8b97ee$var$spanIsSampled(span);
    return $jrPYE.generateTraceparentHeader(traceId, spanId, sampled);
}
function $ae3ef6501f8b97ee$var$convertSpanLinksForEnvelope(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $ae3ef6501f8b97ee$var$TRACE_FLAG_SAMPLED,
            attributes: attributes,
            ...restContext
        }));
    else return void 0;
}
function $ae3ef6501f8b97ee$var$getStreamedSpanLinks(links) {
    if (links?.length) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $ae3ef6501f8b97ee$var$TRACE_FLAG_SAMPLED,
            attributes: attributes
        }));
    else return void 0;
}
function $ae3ef6501f8b97ee$var$spanTimeInputToSeconds(input) {
    if (typeof input === "number") return $ae3ef6501f8b97ee$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $ae3ef6501f8b97ee$var$ensureTimestampInSeconds(input.getTime());
    return $1MCl5.timestampInSeconds();
}
function $ae3ef6501f8b97ee$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1e3 : timestamp;
}
function $ae3ef6501f8b97ee$var$spanToJSON(span) {
    if ($ae3ef6501f8b97ee$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($ae3ef6501f8b97ee$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: $ae3ef6501f8b97ee$var$getOtelParentSpanId(span),
            start_timestamp: $ae3ef6501f8b97ee$var$spanTimeInputToSeconds(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $ae3ef6501f8b97ee$var$spanTimeInputToSeconds(endTime) || void 0,
            status: $ae3ef6501f8b97ee$var$getStatusMessage(status),
            op: attributes[$dknph.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            origin: attributes[$dknph.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            links: $ae3ef6501f8b97ee$var$convertSpanLinksForEnvelope(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $ae3ef6501f8b97ee$var$spanToStreamedSpanJSON(span) {
    if ($ae3ef6501f8b97ee$var$spanIsSentrySpan(span)) return span.getStreamedSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($ae3ef6501f8b97ee$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            name: name,
            span_id: span_id,
            trace_id: trace_id,
            parent_span_id: $ae3ef6501f8b97ee$var$getOtelParentSpanId(span),
            start_timestamp: $ae3ef6501f8b97ee$var$spanTimeInputToSeconds(startTime),
            end_timestamp: $ae3ef6501f8b97ee$var$spanTimeInputToSeconds(endTime),
            is_segment: span === $ae3ef6501f8b97ee$var$INTERNAL_getSegmentSpan(span),
            status: $ae3ef6501f8b97ee$var$getSimpleStatus(status),
            attributes: $ae3ef6501f8b97ee$var$addStatusMessageAttribute(attributes, status),
            links: $ae3ef6501f8b97ee$var$getStreamedSpanLinks(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        name: "",
        end_timestamp: 0,
        status: "ok",
        is_segment: span === $ae3ef6501f8b97ee$var$INTERNAL_getSegmentSpan(span)
    };
}
function $ae3ef6501f8b97ee$var$getOtelParentSpanId(span) {
    return "parentSpanId" in span ? span.parentSpanId : "parentSpanContext" in span ? span.parentSpanContext?.spanId : void 0;
}
function $ae3ef6501f8b97ee$var$streamedSpanJsonToSerializedSpan(spanJson) {
    return {
        ...spanJson,
        attributes: $9eCUH.serializeAttributes(spanJson.attributes),
        links: spanJson.links?.map((link)=>({
                ...link,
                attributes: $9eCUH.serializeAttributes(link.attributes)
            }))
    };
}
function $ae3ef6501f8b97ee$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
function $ae3ef6501f8b97ee$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === "function";
}
function $ae3ef6501f8b97ee$var$spanIsSampled(span) {
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $ae3ef6501f8b97ee$var$TRACE_FLAG_SAMPLED;
}
function $ae3ef6501f8b97ee$var$getStatusMessage(status) {
    if (!status || status.code === $3su1E.SPAN_STATUS_UNSET) return void 0;
    if (status.code === $3su1E.SPAN_STATUS_OK) return "ok";
    return status.message || "internal_error";
}
function $ae3ef6501f8b97ee$var$getSimpleStatus(status) {
    return !status || status.code === $3su1E.SPAN_STATUS_OK || status.code === $3su1E.SPAN_STATUS_UNSET || status.message === "cancelled" ? "ok" : "error";
}
function $ae3ef6501f8b97ee$var$addStatusMessageAttribute(attributes, status) {
    const statusMessage = $ae3ef6501f8b97ee$var$getSimpleStatus(status) === "error" ? status?.message : void 0;
    return {
        ...statusMessage && {
            [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE]: statusMessage
        },
        ...attributes
    };
}
const $ae3ef6501f8b97ee$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $ae3ef6501f8b97ee$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
function $ae3ef6501f8b97ee$var$addChildSpanToSpan(span, childSpan) {
    const rootSpan = span[$ae3ef6501f8b97ee$var$ROOT_SPAN_FIELD] || span;
    $kzIHY.addNonEnumerableProperty(childSpan, $ae3ef6501f8b97ee$var$ROOT_SPAN_FIELD, rootSpan);
    if (!$ae3ef6501f8b97ee$var$spanIsSampled(span)) return;
    if (!span.isRecording() && !rootSpan.isRecording()) return;
    if (span[$ae3ef6501f8b97ee$var$CHILD_SPANS_FIELD]) span[$ae3ef6501f8b97ee$var$CHILD_SPANS_FIELD].add(childSpan);
    else $kzIHY.addNonEnumerableProperty(span, $ae3ef6501f8b97ee$var$CHILD_SPANS_FIELD, /* @__PURE__ */ new Set([
        childSpan
    ]));
}
function $ae3ef6501f8b97ee$var$removeChildSpanFromSpan(span, childSpan) {
    if (span[$ae3ef6501f8b97ee$var$CHILD_SPANS_FIELD]) span[$ae3ef6501f8b97ee$var$CHILD_SPANS_FIELD].delete(childSpan);
}
function $ae3ef6501f8b97ee$var$getSpanDescendants(span) {
    const resultSet = /* @__PURE__ */ new Set();
    function addSpanChildren(span2) {
        if (resultSet.has(span2)) return;
        else if ($ae3ef6501f8b97ee$var$spanIsSampled(span2)) {
            resultSet.add(span2);
            const childSpans = span2[$ae3ef6501f8b97ee$var$CHILD_SPANS_FIELD] ? Array.from(span2[$ae3ef6501f8b97ee$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
const $ae3ef6501f8b97ee$var$getRootSpan = $ae3ef6501f8b97ee$var$INTERNAL_getSegmentSpan;
function $ae3ef6501f8b97ee$var$INTERNAL_getSegmentSpan(span) {
    return span[$ae3ef6501f8b97ee$var$ROOT_SPAN_FIELD] || span;
}
function $ae3ef6501f8b97ee$var$getActiveSpan() {
    const carrier$1 = $6FBPf.getMainCarrier();
    const acs = $1xFq0.getAsyncContextStrategy(carrier$1);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return $b3Isg._getSpanForScope($8DrvK.getCurrentScope());
}
function $ae3ef6501f8b97ee$var$showSpanDropWarning() {
    if (!$ae3ef6501f8b97ee$var$hasShownSpanDropWarning) {
        $1UPRv.consoleSandbox(()=>{
            console.warn("[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.");
        });
        $ae3ef6501f8b97ee$var$hasShownSpanDropWarning = true;
    }
}
function $ae3ef6501f8b97ee$var$updateSpanName(span, name) {
    span.updateName(name);
    span.setAttributes({
        [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "custom",
        [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME]: name
    });
}
module.exports.INTERNAL_getSegmentSpan = $ae3ef6501f8b97ee$var$INTERNAL_getSegmentSpan;
module.exports.TRACE_FLAG_NONE = $ae3ef6501f8b97ee$var$TRACE_FLAG_NONE;
module.exports.TRACE_FLAG_SAMPLED = $ae3ef6501f8b97ee$var$TRACE_FLAG_SAMPLED;
module.exports.addChildSpanToSpan = $ae3ef6501f8b97ee$var$addChildSpanToSpan;
module.exports.addStatusMessageAttribute = $ae3ef6501f8b97ee$var$addStatusMessageAttribute;
module.exports.convertSpanLinksForEnvelope = $ae3ef6501f8b97ee$var$convertSpanLinksForEnvelope;
module.exports.getActiveSpan = $ae3ef6501f8b97ee$var$getActiveSpan;
module.exports.getRootSpan = $ae3ef6501f8b97ee$var$getRootSpan;
module.exports.getSimpleStatus = $ae3ef6501f8b97ee$var$getSimpleStatus;
module.exports.getSpanDescendants = $ae3ef6501f8b97ee$var$getSpanDescendants;
module.exports.getStatusMessage = $ae3ef6501f8b97ee$var$getStatusMessage;
module.exports.getStreamedSpanLinks = $ae3ef6501f8b97ee$var$getStreamedSpanLinks;
module.exports.removeChildSpanFromSpan = $ae3ef6501f8b97ee$var$removeChildSpanFromSpan;
module.exports.showSpanDropWarning = $ae3ef6501f8b97ee$var$showSpanDropWarning;
module.exports.spanIsSampled = $ae3ef6501f8b97ee$var$spanIsSampled;
module.exports.spanIsSentrySpan = $ae3ef6501f8b97ee$var$spanIsSentrySpan;
module.exports.spanTimeInputToSeconds = $ae3ef6501f8b97ee$var$spanTimeInputToSeconds;
module.exports.spanToJSON = $ae3ef6501f8b97ee$var$spanToJSON;
module.exports.spanToStreamedSpanJSON = $ae3ef6501f8b97ee$var$spanToStreamedSpanJSON;
module.exports.spanToTraceContext = $ae3ef6501f8b97ee$var$spanToTraceContext;
module.exports.spanToTraceHeader = $ae3ef6501f8b97ee$var$spanToTraceHeader;
module.exports.spanToTraceparentHeader = $ae3ef6501f8b97ee$var$spanToTraceparentHeader;
module.exports.spanToTransactionTraceContext = $ae3ef6501f8b97ee$var$spanToTransactionTraceContext;
module.exports.streamedSpanJsonToSerializedSpan = $ae3ef6501f8b97ee$var$streamedSpanJsonToSerializedSpan;
module.exports.updateSpanName = $ae3ef6501f8b97ee$var$updateSpanName;

});
parcelRegister("1xFq0", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6FBPf = parcelRequire("6FBPf");

var $2yOkJ = parcelRequire("2yOkJ");
function $11f90055ea68b575$var$setAsyncContextStrategy(strategy) {
    const registry = $6FBPf.getMainCarrier();
    const sentry = $6FBPf.getSentryCarrier(registry);
    sentry.acs = strategy;
}
function $11f90055ea68b575$var$getAsyncContextStrategy(carrier$1) {
    const sentry = $6FBPf.getSentryCarrier(carrier$1);
    if (sentry.acs) return sentry.acs;
    return $2yOkJ.getStackAsyncContextStrategy();
}
module.exports.getAsyncContextStrategy = $11f90055ea68b575$var$getAsyncContextStrategy;
module.exports.setAsyncContextStrategy = $11f90055ea68b575$var$setAsyncContextStrategy;

});
parcelRegister("2yOkJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lONWe = parcelRequire("lONWe");

var $htzrJ = parcelRequire("htzrJ");

var $kHnXn = parcelRequire("kHnXn");

var $eMfEg = parcelRequire("eMfEg");

var $6FBPf = parcelRequire("6FBPf");
class $1dd5cce38dee35b4$var$AsyncContextStack {
    constructor(scope$1, isolationScope){
        let assignedScope;
        if (!scope$1) assignedScope = new $htzrJ.Scope();
        else assignedScope = scope$1;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new $htzrJ.Scope();
        else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ($eMfEg.isThenable(maybePromiseResult)) return $kHnXn.chainAndCopyPromiseLike(maybePromiseResult, ()=>this._popScope(), ()=>this._popScope());
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
function $1dd5cce38dee35b4$var$getAsyncContextStack() {
    const registry = $6FBPf.getMainCarrier();
    const sentry = $6FBPf.getSentryCarrier(registry);
    return sentry.stack = sentry.stack || new $1dd5cce38dee35b4$var$AsyncContextStack($lONWe.getDefaultCurrentScope(), $lONWe.getDefaultIsolationScope());
}
function $1dd5cce38dee35b4$var$withScope(callback) {
    return $1dd5cce38dee35b4$var$getAsyncContextStack().withScope(callback);
}
function $1dd5cce38dee35b4$var$withSetScope(scope, callback) {
    const stack = $1dd5cce38dee35b4$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $1dd5cce38dee35b4$var$withIsolationScope(callback) {
    return $1dd5cce38dee35b4$var$getAsyncContextStack().withScope(()=>{
        return callback($1dd5cce38dee35b4$var$getAsyncContextStack().getIsolationScope());
    });
}
function $1dd5cce38dee35b4$var$getStackAsyncContextStrategy() {
    return {
        withIsolationScope: $1dd5cce38dee35b4$var$withIsolationScope,
        withScope: $1dd5cce38dee35b4$var$withScope,
        withSetScope: $1dd5cce38dee35b4$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $1dd5cce38dee35b4$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$1dd5cce38dee35b4$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$1dd5cce38dee35b4$var$getAsyncContextStack().getIsolationScope()
    };
}
module.exports.AsyncContextStack = $1dd5cce38dee35b4$var$AsyncContextStack;
module.exports.getStackAsyncContextStrategy = $1dd5cce38dee35b4$var$getStackAsyncContextStrategy;

});
parcelRegister("lONWe", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6FBPf = parcelRequire("6FBPf");

var $htzrJ = parcelRequire("htzrJ");
function $fe250131005c92e1$var$getDefaultCurrentScope() {
    return $6FBPf.getGlobalSingleton("defaultCurrentScope", ()=>new $htzrJ.Scope());
}
function $fe250131005c92e1$var$getDefaultIsolationScope() {
    return $6FBPf.getGlobalSingleton("defaultIsolationScope", ()=>new $htzrJ.Scope());
}
module.exports.getDefaultCurrentScope = $fe250131005c92e1$var$getDefaultCurrentScope;
module.exports.getDefaultIsolationScope = $fe250131005c92e1$var$getDefaultIsolationScope;

});
parcelRegister("htzrJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9Yejo = parcelRequire("9Yejo");

var $iS3Yk = parcelRequire("iS3Yk");

var $1UPRv = parcelRequire("1UPRv");

var $eMfEg = parcelRequire("eMfEg");

var $abhMj = parcelRequire("abhMj");

var $8iRTV = parcelRequire("8iRTV");

var $3Xjyi = parcelRequire("3Xjyi");

var $8odom = parcelRequire("8odom");

var $b3Isg = parcelRequire("b3Isg");

var $erV30 = parcelRequire("erV30");

var $1MCl5 = parcelRequire("1MCl5");
const $cb90a3f84e92abbf$var$DEFAULT_MAX_BREADCRUMBS = 100;
class $cb90a3f84e92abbf$var$Scope {
    // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: $3Xjyi.generateTraceId(),
            sampleRand: $8odom.safeMathRandom()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $cb90a3f84e92abbf$var$Scope();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._attributes = {
            ...this._attributes
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        newScope._conversationId = this._conversationId;
        $b3Isg._setSpanForScope(newScope, $b3Isg._getSpanForScope(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        this._user = user || {
            email: void 0,
            id: void 0,
            ip_address: void 0,
            username: void 0
        };
        if (this._session) $iS3Yk.updateSession(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ setConversationId(conversationId) {
        this._conversationId = conversationId || void 0;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        return this.setTags({
            [key]: value
        });
    }
    /**
   * Sets attributes onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param newAttributes - The attributes to set on the scope, as key-value pairs.
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: 150,
   * });
   * ```
   */ setAttributes(newAttributes) {
        this._attributes = {
            ...this._attributes,
            ...newAttributes
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets an attribute onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param key - The attribute key.
   * @param value - The attribute value.
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', 150);
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAttribute(key, value) {
        return this.setAttributes({
            [key]: value
        });
    }
    /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ removeAttribute(key) {
        if (key in this._attributes) {
            delete this._attributes[key];
            this._notifyScopeListeners();
        }
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $cb90a3f84e92abbf$var$Scope ? scopeToMerge.getScopeData() : $eMfEg.isPlainObject(scopeToMerge) ? captureContext : void 0;
        const { tags: tags, attributes: attributes, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext, conversationId: conversationId } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._attributes = {
            ...this._attributes,
            ...attributes
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (conversationId) this._conversationId = conversationId;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   *
   * @deprecated This method will be removed in v11. To reset scope state, re-initialize the SDK or run
   * your code in a fresh scope via `withScope` instead.
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = void 0;
        this._transactionName = void 0;
        this._fingerprint = void 0;
        this._session = void 0;
        this._conversationId = void 0;
        $b3Isg._setSpanForScope(this, void 0);
        this._attachments = [];
        this.setPropagationContext({
            traceId: $3Xjyi.generateTraceId(),
            sampleRand: $8odom.safeMathRandom()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $cb90a3f84e92abbf$var$DEFAULT_MAX_BREADCRUMBS;
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: $1MCl5.dateTimestampInSeconds(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? $erV30.truncate(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            attributes: this._attributes,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: $b3Isg._getSpanForScope(this),
            conversationId: this._conversationId
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = $abhMj.merge(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || $8iRTV.uuid4();
        if (!this._client) {
            $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || $8iRTV.uuid4();
        if (!this._client) {
            $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = hint?.syntheticException ?? new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = event.event_id || hint?.event_id || $8iRTV.uuid4();
        if (!this._client) {
            $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
module.exports.Scope = $cb90a3f84e92abbf$var$Scope;

});
parcelRegister("iS3Yk", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8iRTV = parcelRequire("8iRTV");

var $1MCl5 = parcelRequire("1MCl5");
function $dbd059ea5e84ef87$var$makeSession(context) {
    const startingTime = $1MCl5.timestampInSeconds();
    const session = {
        sid: $8iRTV.uuid4(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$dbd059ea5e84ef87$var$sessionToJSON(session)
    };
    if (context) $dbd059ea5e84ef87$var$updateSession(session, context);
    return session;
}
function $dbd059ea5e84ef87$var$updateSession(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || $1MCl5.timestampInSeconds();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) session.sid = context.sid.length === 32 ? context.sid : $8iRTV.uuid4();
    if (context.init !== void 0) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = void 0;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
function $dbd059ea5e84ef87$var$closeSession(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $dbd059ea5e84ef87$var$updateSession(session, context);
}
function $dbd059ea5e84ef87$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1e3).toISOString(),
        timestamp: new Date(session.timestamp * 1e3).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : void 0,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}
module.exports.closeSession = $dbd059ea5e84ef87$var$closeSession;
module.exports.makeSession = $dbd059ea5e84ef87$var$makeSession;
module.exports.updateSession = $dbd059ea5e84ef87$var$updateSession;

});
parcelRegister("8iRTV", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kzIHY = parcelRequire("kzIHY");

var $8odom = parcelRequire("8odom");

var $erV30 = parcelRequire("erV30");

var $YfOkS = parcelRequire("YfOkS");
function $60b9d0c7f0cb2f31$var$getCrypto() {
    const gbl = $YfOkS.GLOBAL_OBJ;
    return gbl.crypto || gbl.msCrypto;
}
let $60b9d0c7f0cb2f31$var$emptyUuid;
function $60b9d0c7f0cb2f31$var$getRandomByte() {
    return $8odom.safeMathRandom() * 16;
}
function $60b9d0c7f0cb2f31$var$uuid4(crypto = $60b9d0c7f0cb2f31$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) return $8odom.withRandomSafeContext(()=>crypto.randomUUID()).replace(/-/g, "");
    } catch  {}
    if (!$60b9d0c7f0cb2f31$var$emptyUuid) $60b9d0c7f0cb2f31$var$emptyUuid = "10000000100040008000100000000000";
    return $60b9d0c7f0cb2f31$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($60b9d0c7f0cb2f31$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $60b9d0c7f0cb2f31$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
function $60b9d0c7f0cb2f31$var$getEventDescription(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $60b9d0c7f0cb2f31$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
function $60b9d0c7f0cb2f31$var$addExceptionTypeValue(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
function $60b9d0c7f0cb2f31$var$addExceptionMechanism(event, newMechanism) {
    const firstException = $60b9d0c7f0cb2f31$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
const $60b9d0c7f0cb2f31$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $60b9d0c7f0cb2f31$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
function $60b9d0c7f0cb2f31$var$parseSemver(input) {
    const match = input.match($60b9d0c7f0cb2f31$var$SEMVER_REGEXP) || [];
    const major = $60b9d0c7f0cb2f31$var$_parseInt(match[1]);
    const minor = $60b9d0c7f0cb2f31$var$_parseInt(match[2]);
    const patch = $60b9d0c7f0cb2f31$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? void 0 : major,
        minor: isNaN(minor) ? void 0 : minor,
        patch: isNaN(patch) ? void 0 : patch,
        prerelease: match[4]
    };
}
function $60b9d0c7f0cb2f31$var$addContextToFrame(lines, frame, linesOfContext = 5) {
    if (frame.lineno === void 0) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>$erV30.snipLine(line, 0));
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    frame.context_line = $erV30.snipLine(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>$erV30.snipLine(line, 0));
}
function $60b9d0c7f0cb2f31$var$checkOrSetAlreadyCaught(exception) {
    if ($60b9d0c7f0cb2f31$var$isAlreadyCaptured(exception)) return true;
    try {
        $kzIHY.addNonEnumerableProperty(exception, "__sentry_captured__", true);
    } catch  {}
    return false;
}
function $60b9d0c7f0cb2f31$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {}
}
module.exports.addContextToFrame = $60b9d0c7f0cb2f31$var$addContextToFrame;
module.exports.addExceptionMechanism = $60b9d0c7f0cb2f31$var$addExceptionMechanism;
module.exports.addExceptionTypeValue = $60b9d0c7f0cb2f31$var$addExceptionTypeValue;
module.exports.checkOrSetAlreadyCaught = $60b9d0c7f0cb2f31$var$checkOrSetAlreadyCaught;
module.exports.getEventDescription = $60b9d0c7f0cb2f31$var$getEventDescription;
module.exports.isAlreadyCaptured = $60b9d0c7f0cb2f31$var$isAlreadyCaptured;
module.exports.parseSemver = $60b9d0c7f0cb2f31$var$parseSemver;
module.exports.uuid4 = $60b9d0c7f0cb2f31$var$uuid4;

});
parcelRegister("kzIHY", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9Yejo = parcelRequire("9Yejo");

var $1UPRv = parcelRequire("1UPRv");

var $eMfEg = parcelRequire("eMfEg");
function $efa9c1ae1b7aec47$var$fill(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    if (typeof wrapped === "function") $efa9c1ae1b7aec47$var$markFunctionWrapped(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.log(`Failed to replace method "${name}" in object`, source);
    }
}
function $efa9c1ae1b7aec47$var$addNonEnumerableProperty(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch  {
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
    }
}
function $efa9c1ae1b7aec47$var$markFunctionWrapped(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $efa9c1ae1b7aec47$var$addNonEnumerableProperty(wrapped, "__sentry_original__", original);
    } catch  {}
}
function $efa9c1ae1b7aec47$var$wrapMethod(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== "function") throw new Error(`Cannot wrap method: ${field} is not a function`);
    if ($efa9c1ae1b7aec47$var$getOriginalFunction(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    $efa9c1ae1b7aec47$var$markFunctionWrapped(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
function $efa9c1ae1b7aec47$var$getOriginalFunction(func) {
    return func.__sentry_original__;
}
function $efa9c1ae1b7aec47$var$convertToPlainObject(value) {
    if ($eMfEg.isError(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$efa9c1ae1b7aec47$var$getOwnProperties(value)
    };
    if ($eMfEg.isEvent(value)) {
        const { type: type, target: target, currentTarget: currentTarget, detail: detail } = value;
        return {
            type: type,
            target: target,
            currentTarget: currentTarget,
            ...detail ? {
                detail: detail
            } : {},
            ...$efa9c1ae1b7aec47$var$getOwnProperties(value)
        };
    }
    return value;
}
function $efa9c1ae1b7aec47$var$getOwnProperties(obj) {
    if ($eMfEg.isObjectLike(obj)) return Object.fromEntries(Object.entries(obj));
    return {};
}
function $efa9c1ae1b7aec47$var$extractExceptionKeysForMessage(exception) {
    const keys = Object.keys($efa9c1ae1b7aec47$var$convertToPlainObject(exception));
    keys.sort();
    return !keys[0] ? "[object has no keys]" : keys.join(", ");
}
function $efa9c1ae1b7aec47$var$dropUndefinedKeys(inputValue) {
    const memoizationMap = /* @__PURE__ */ new Map();
    return $efa9c1ae1b7aec47$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $efa9c1ae1b7aec47$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== void 0) return memoVal;
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($efa9c1ae1b7aec47$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($efa9c1ae1b7aec47$var$isPojo(inputValue)) {
        const returnValue = {};
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== void 0) returnValue[key] = $efa9c1ae1b7aec47$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    return inputValue;
}
function $efa9c1ae1b7aec47$var$isPojo(input) {
    const constructor = input.constructor;
    return constructor === Object || constructor === void 0;
}
function $efa9c1ae1b7aec47$var$objectify(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == void 0:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case $eMfEg.isPrimitive(wat):
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}
module.exports.addNonEnumerableProperty = $efa9c1ae1b7aec47$var$addNonEnumerableProperty;
module.exports.convertToPlainObject = $efa9c1ae1b7aec47$var$convertToPlainObject;
module.exports.dropUndefinedKeys = $efa9c1ae1b7aec47$var$dropUndefinedKeys;
module.exports.extractExceptionKeysForMessage = $efa9c1ae1b7aec47$var$extractExceptionKeysForMessage;
module.exports.fill = $efa9c1ae1b7aec47$var$fill;
module.exports.getOriginalFunction = $efa9c1ae1b7aec47$var$getOriginalFunction;
module.exports.markFunctionWrapped = $efa9c1ae1b7aec47$var$markFunctionWrapped;
module.exports.objectify = $efa9c1ae1b7aec47$var$objectify;
module.exports.wrapMethod = $efa9c1ae1b7aec47$var$wrapMethod;

});
parcelRegister("eMfEg", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $ac21afd9e3376f7b$var$objectToString = Object.prototype.toString;
function $ac21afd9e3376f7b$var$isError(wat) {
    switch($ac21afd9e3376f7b$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $ac21afd9e3376f7b$var$isInstanceOf(wat, Error);
    }
}
function $ac21afd9e3376f7b$var$isBuiltin(wat, className) {
    return $ac21afd9e3376f7b$var$objectToString.call(wat) === `[object ${className}]`;
}
function $ac21afd9e3376f7b$var$isErrorEvent(wat) {
    return $ac21afd9e3376f7b$var$isBuiltin(wat, "ErrorEvent");
}
function $ac21afd9e3376f7b$var$isDOMError(wat) {
    return $ac21afd9e3376f7b$var$isBuiltin(wat, "DOMError");
}
function $ac21afd9e3376f7b$var$isDOMException(wat) {
    return $ac21afd9e3376f7b$var$isBuiltin(wat, "DOMException");
}
function $ac21afd9e3376f7b$var$isString(wat) {
    return $ac21afd9e3376f7b$var$isBuiltin(wat, "String");
}
function $ac21afd9e3376f7b$var$isParameterizedString(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
function $ac21afd9e3376f7b$var$isPrimitive(wat) {
    return wat === null || $ac21afd9e3376f7b$var$isParameterizedString(wat) || typeof wat !== "object" && typeof wat !== "function";
}
function $ac21afd9e3376f7b$var$isPlainObject(wat) {
    return $ac21afd9e3376f7b$var$isBuiltin(wat, "Object");
}
function $ac21afd9e3376f7b$var$isObjectLike(wat) {
    return typeof wat === "object" && wat !== null;
}
function $ac21afd9e3376f7b$var$isEvent(wat) {
    return typeof Event !== "undefined" && $ac21afd9e3376f7b$var$isInstanceOf(wat, Event);
}
function $ac21afd9e3376f7b$var$isElement(wat) {
    return typeof Element !== "undefined" && $ac21afd9e3376f7b$var$isInstanceOf(wat, Element);
}
function $ac21afd9e3376f7b$var$isRegExp(wat) {
    return $ac21afd9e3376f7b$var$isBuiltin(wat, "RegExp");
}
function $ac21afd9e3376f7b$var$isThenable(wat) {
    return Boolean(wat?.then && typeof wat.then === "function");
}
function $ac21afd9e3376f7b$var$isSyntheticEvent(wat) {
    return $ac21afd9e3376f7b$var$isPlainObject(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $ac21afd9e3376f7b$var$isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
function $ac21afd9e3376f7b$var$isVueViewModel(wat) {
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
function $ac21afd9e3376f7b$var$isRequest(request) {
    return typeof Request !== "undefined" && $ac21afd9e3376f7b$var$isInstanceOf(request, Request);
}
module.exports.isDOMError = $ac21afd9e3376f7b$var$isDOMError;
module.exports.isDOMException = $ac21afd9e3376f7b$var$isDOMException;
module.exports.isElement = $ac21afd9e3376f7b$var$isElement;
module.exports.isError = $ac21afd9e3376f7b$var$isError;
module.exports.isErrorEvent = $ac21afd9e3376f7b$var$isErrorEvent;
module.exports.isEvent = $ac21afd9e3376f7b$var$isEvent;
module.exports.isInstanceOf = $ac21afd9e3376f7b$var$isInstanceOf;
module.exports.isObjectLike = $ac21afd9e3376f7b$var$isObjectLike;
module.exports.isParameterizedString = $ac21afd9e3376f7b$var$isParameterizedString;
module.exports.isPlainObject = $ac21afd9e3376f7b$var$isPlainObject;
module.exports.isPrimitive = $ac21afd9e3376f7b$var$isPrimitive;
module.exports.isRegExp = $ac21afd9e3376f7b$var$isRegExp;
module.exports.isRequest = $ac21afd9e3376f7b$var$isRequest;
module.exports.isString = $ac21afd9e3376f7b$var$isString;
module.exports.isSyntheticEvent = $ac21afd9e3376f7b$var$isSyntheticEvent;
module.exports.isThenable = $ac21afd9e3376f7b$var$isThenable;
module.exports.isVueViewModel = $ac21afd9e3376f7b$var$isVueViewModel;

});


parcelRegister("8odom", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $YfOkS = parcelRequire("YfOkS");
let $61baf3fd588e68b4$var$RESOLVED_RUNNER;
function $61baf3fd588e68b4$var$withRandomSafeContext(cb) {
    if ($61baf3fd588e68b4$var$RESOLVED_RUNNER !== void 0) return $61baf3fd588e68b4$var$RESOLVED_RUNNER ? $61baf3fd588e68b4$var$RESOLVED_RUNNER(cb) : cb();
    const sym = /* @__PURE__ */ Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__");
    const globalWithSymbol = $YfOkS.GLOBAL_OBJ;
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === "function") {
        $61baf3fd588e68b4$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $61baf3fd588e68b4$var$RESOLVED_RUNNER(cb);
    }
    $61baf3fd588e68b4$var$RESOLVED_RUNNER = null;
    return cb();
}
function $61baf3fd588e68b4$var$safeMathRandom() {
    return $61baf3fd588e68b4$var$withRandomSafeContext(()=>Math.random());
}
function $61baf3fd588e68b4$var$safeDateNow() {
    return $61baf3fd588e68b4$var$withRandomSafeContext(()=>Date.now());
}
module.exports.safeDateNow = $61baf3fd588e68b4$var$safeDateNow;
module.exports.safeMathRandom = $61baf3fd588e68b4$var$safeMathRandom;
module.exports.withRandomSafeContext = $61baf3fd588e68b4$var$withRandomSafeContext;

});

parcelRegister("erV30", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eMfEg = parcelRequire("eMfEg");

var $aaVDI = parcelRequire("aaVDI");
function $a84fd6c4deb74a5f$var$stringify(value, fallback = "[unserializable]") {
    if (typeof value === "string") return value;
    try {
        return JSON.stringify(value);
    } catch  {
        return typeof fallback === "function" ? fallback(value) : fallback;
    }
}
function $a84fd6c4deb74a5f$var$truncate(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
function $a84fd6c4deb74a5f$var$snipLine(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
function $a84fd6c4deb74a5f$var$safeJoin(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        if ($eMfEg.isPrimitive(value)) output.push(String(value));
        else if (value instanceof Error) output.push(value.message ? `${value.name}: ${value.message}` : value.name);
        else output.push($aaVDI.stringifyValue(void 0, value));
    }
    return output.join(delimiter);
}
function $a84fd6c4deb74a5f$var$isMatchingPattern(value, pattern, requireExactStringMatch = false) {
    if (!$eMfEg.isString(value)) return false;
    if ($eMfEg.isRegExp(pattern)) return pattern.test(value);
    if ($eMfEg.isString(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === "function") return pattern(value);
    return false;
}
function $a84fd6c4deb74a5f$var$stringMatchesSomePattern(testString, patterns = [], requireExactStringMatch = false) {
    for (const pattern of patterns){
        if ($a84fd6c4deb74a5f$var$isMatchingPattern(testString, pattern, requireExactStringMatch)) return true;
    }
    return false;
}
module.exports.isMatchingPattern = $a84fd6c4deb74a5f$var$isMatchingPattern;
module.exports.safeJoin = $a84fd6c4deb74a5f$var$safeJoin;
module.exports.snipLine = $a84fd6c4deb74a5f$var$snipLine;
module.exports.stringMatchesSomePattern = $a84fd6c4deb74a5f$var$stringMatchesSomePattern;
module.exports.stringify = $a84fd6c4deb74a5f$var$stringify;
module.exports.truncate = $a84fd6c4deb74a5f$var$truncate;

});
parcelRegister("aaVDI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $l8ak2 = parcelRequire("l8ak2");

var $kzIHY = parcelRequire("kzIHY");

var $82RPZ = parcelRequire("82RPZ");
let $76878c9501182151$var$stringifier;
function $76878c9501182151$var$setNormalizeStringifier(newStringifier) {
    $76878c9501182151$var$stringifier = newStringifier;
}
function $76878c9501182151$var$normalize(input, depth = 100, maxProperties = Infinity) {
    try {
        return $76878c9501182151$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
function $76878c9501182151$var$normalizeToSize(object, depth = 3, maxSize = 102400) {
    const normalized = $76878c9501182151$var$normalize(object, depth);
    if ($76878c9501182151$var$jsonSize(normalized) > maxSize) return $76878c9501182151$var$normalizeToSize(object, depth - 1, maxSize);
    return normalized;
}
function $76878c9501182151$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $76878c9501182151$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $76878c9501182151$var$stringifyValue(key, value);
    if (!stringified.startsWith("[object ")) return stringified;
    if ($l8ak2.hasSkipNormalizationHint(value)) return value;
    const overrideDepth = $l8ak2.getNormalizationDepthOverrideHint(value);
    const remainingDepth = overrideDepth !== void 0 ? overrideDepth : depth;
    if (remainingDepth === 0) return stringified.replace("object ", "");
    if (memoize(value)) return "[Circular ~]";
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        return $76878c9501182151$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {}
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    const visitable = $kzIHY.convertToPlainObject(value);
    for(const visitKey in visitable){
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $76878c9501182151$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    unmemoize(value);
    return normalized;
}
function $76878c9501182151$var$stringifyValue(key, value) {
    try {
        if ($76878c9501182151$var$stringifier) {
            const stringified = $76878c9501182151$var$stringifier(value);
            if (stringified) return stringified;
        }
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${$82RPZ.getFunctionName(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        const objName = $76878c9501182151$var$getConstructorName(value);
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
function $76878c9501182151$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}
function $76878c9501182151$var$utf8Length(value) {
    return ~-encodeURI(value).split(/%..|./).length;
}
function $76878c9501182151$var$jsonSize(value) {
    return $76878c9501182151$var$utf8Length(JSON.stringify(value));
}
function $76878c9501182151$var$normalizeUrlToBase(url, basePath) {
    const escapedBase = basePath.replace(/\\/g, "/").replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {}
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "").replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
function $76878c9501182151$var$memoBuilder() {
    const inner = /* @__PURE__ */ new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}
module.exports.normalize = $76878c9501182151$var$normalize;
module.exports.normalizeToSize = $76878c9501182151$var$normalizeToSize;
module.exports.normalizeUrlToBase = $76878c9501182151$var$normalizeUrlToBase;
module.exports.setNormalizeStringifier = $76878c9501182151$var$setNormalizeStringifier;
module.exports.stringifyValue = $76878c9501182151$var$stringifyValue;

});
parcelRegister("l8ak2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kzIHY = parcelRequire("kzIHY");
const $f6225a1d5037d6dc$var$SENTRY_SKIP_NORMALIZATION = /* @__PURE__ */ Symbol.for("sentry.skipNormalization");
const $f6225a1d5037d6dc$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH = /* @__PURE__ */ Symbol.for("sentry.overrideNormalizationDepth");
function $f6225a1d5037d6dc$var$setSkipNormalizationHint(obj) {
    $kzIHY.addNonEnumerableProperty(obj, $f6225a1d5037d6dc$var$SENTRY_SKIP_NORMALIZATION, true);
}
function $f6225a1d5037d6dc$var$setNormalizationDepthOverrideHint(obj, depth) {
    $kzIHY.addNonEnumerableProperty(obj, $f6225a1d5037d6dc$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
function $f6225a1d5037d6dc$var$hasSkipNormalizationHint(value) {
    return Boolean(value[$f6225a1d5037d6dc$var$SENTRY_SKIP_NORMALIZATION]);
}
function $f6225a1d5037d6dc$var$getNormalizationDepthOverrideHint(value) {
    const v = value[$f6225a1d5037d6dc$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
    return typeof v === "number" ? v : void 0;
}
module.exports.getNormalizationDepthOverrideHint = $f6225a1d5037d6dc$var$getNormalizationDepthOverrideHint;
module.exports.hasSkipNormalizationHint = $f6225a1d5037d6dc$var$hasSkipNormalizationHint;
module.exports.setNormalizationDepthOverrideHint = $f6225a1d5037d6dc$var$setNormalizationDepthOverrideHint;
module.exports.setSkipNormalizationHint = $f6225a1d5037d6dc$var$setSkipNormalizationHint;

});




parcelRegister("1MCl5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8odom = parcelRequire("8odom");

var $YfOkS = parcelRequire("YfOkS");
const $14c8037813583a97$var$ONE_SECOND_IN_MS = 1e3;
function $14c8037813583a97$var$dateTimestampInSeconds() {
    return $8odom.safeDateNow() / $14c8037813583a97$var$ONE_SECOND_IN_MS;
}
function $14c8037813583a97$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = $YfOkS.GLOBAL_OBJ;
    if (!performance?.now || !performance.timeOrigin) return $14c8037813583a97$var$dateTimestampInSeconds;
    const timeOrigin = performance.timeOrigin;
    return ()=>{
        return (timeOrigin + $8odom.withRandomSafeContext(()=>performance.now())) / $14c8037813583a97$var$ONE_SECOND_IN_MS;
    };
}
let $14c8037813583a97$var$_cachedTimestampInSeconds;
function $14c8037813583a97$var$timestampInSeconds() {
    const func = $14c8037813583a97$var$_cachedTimestampInSeconds ?? ($14c8037813583a97$var$_cachedTimestampInSeconds = $14c8037813583a97$var$createUnixTimestampInSecondsFunc());
    return func();
}
let $14c8037813583a97$var$cachedTimeOrigin = null;
function $14c8037813583a97$var$getBrowserTimeOrigin() {
    const { performance: performance } = $YfOkS.GLOBAL_OBJ;
    if (!performance?.now) return void 0;
    const threshold = 3e5;
    const performanceNow = $8odom.withRandomSafeContext(()=>performance.now());
    const dateNow = $8odom.safeDateNow();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === "number") {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    const navigationStart = performance.timing?.navigationStart;
    if (typeof navigationStart === "number") {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    return dateNow - performanceNow;
}
function $14c8037813583a97$var$browserPerformanceTimeOrigin() {
    if ($14c8037813583a97$var$cachedTimeOrigin === null) $14c8037813583a97$var$cachedTimeOrigin = $14c8037813583a97$var$getBrowserTimeOrigin();
    return $14c8037813583a97$var$cachedTimeOrigin;
}
module.exports.browserPerformanceTimeOrigin = $14c8037813583a97$var$browserPerformanceTimeOrigin;
module.exports.dateTimestampInSeconds = $14c8037813583a97$var$dateTimestampInSeconds;
module.exports.timestampInSeconds = $14c8037813583a97$var$timestampInSeconds;

});


parcelRegister("abhMj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $7698b8d8d37d03cc$var$merge(initialObj, mergeObj, levels = 2) {
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    const output = {
        ...initialObj
    };
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $7698b8d8d37d03cc$var$merge(output[key], mergeObj[key], levels - 1);
    return output;
}
module.exports.merge = $7698b8d8d37d03cc$var$merge;

});

parcelRegister("3Xjyi", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8iRTV = parcelRequire("8iRTV");
function $2e160c6cab787d83$var$generateTraceId() {
    return $8iRTV.uuid4();
}
function $2e160c6cab787d83$var$generateSpanId() {
    return $8iRTV.uuid4().substring(16);
}
module.exports.generateSpanId = $2e160c6cab787d83$var$generateSpanId;
module.exports.generateTraceId = $2e160c6cab787d83$var$generateTraceId;

});

parcelRegister("b3Isg", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kzIHY = parcelRequire("kzIHY");

var $3AKo2 = parcelRequire("3AKo2");
const $80d27550c19757cc$var$SCOPE_SPAN_FIELD = "_sentrySpan";
function $80d27550c19757cc$var$_setSpanForScope(scope, span) {
    if (span) $kzIHY.addNonEnumerableProperty(scope, $80d27550c19757cc$var$SCOPE_SPAN_FIELD, $3AKo2.makeWeakRef(span));
    else delete scope[$80d27550c19757cc$var$SCOPE_SPAN_FIELD];
}
function $80d27550c19757cc$var$_getSpanForScope(scope) {
    return $3AKo2.derefWeakRef(scope[$80d27550c19757cc$var$SCOPE_SPAN_FIELD]);
}
module.exports._getSpanForScope = $80d27550c19757cc$var$_getSpanForScope;
module.exports._setSpanForScope = $80d27550c19757cc$var$_setSpanForScope;

});
parcelRegister("3AKo2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $YfOkS = parcelRequire("YfOkS");
function $29d8b7569a9cedc8$var$makeWeakRef(value) {
    try {
        const WeakRefImpl = $YfOkS.GLOBAL_OBJ.WeakRef;
        if (typeof WeakRefImpl === "function") return new WeakRefImpl(value);
    } catch  {}
    return value;
}
function $29d8b7569a9cedc8$var$derefWeakRef(ref) {
    if (!ref) return void 0;
    if (typeof ref === "object" && "deref" in ref && typeof ref.deref === "function") try {
        return ref.deref();
    } catch  {
        return void 0;
    }
    return ref;
}
module.exports.derefWeakRef = $29d8b7569a9cedc8$var$derefWeakRef;
module.exports.makeWeakRef = $29d8b7569a9cedc8$var$makeWeakRef;

});




parcelRegister("kHnXn", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $f11a681dc5b2f706$var$isActualPromise = (p)=>p instanceof Promise && !p[$f11a681dc5b2f706$var$kChainedCopy];
const $f11a681dc5b2f706$var$kChainedCopy = /* @__PURE__ */ Symbol("chained PromiseLike");
const $f11a681dc5b2f706$var$chainAndCopyPromiseLike = (original, onSuccess, onError)=>{
    const chained = original.then((value)=>{
        onSuccess(value);
        return value;
    }, (err)=>{
        onError(err);
        throw err;
    });
    return $f11a681dc5b2f706$var$isActualPromise(chained) && $f11a681dc5b2f706$var$isActualPromise(original) ? chained : $f11a681dc5b2f706$var$copyProps(original, chained);
};
const $f11a681dc5b2f706$var$copyProps = (original, chained)=>{
    if (!chained) return original;
    let mutated = false;
    for(const key in original){
        if (key in chained) continue;
        mutated = true;
        const value = original[key];
        if (typeof value === "function") Object.defineProperty(chained, key, {
            value: (...args)=>value.apply(original, args),
            enumerable: true,
            configurable: true,
            writable: true
        });
        else chained[key] = value;
    }
    if (mutated) Object.assign(chained, {
        [$f11a681dc5b2f706$var$kChainedCopy]: true
    });
    return chained;
};
module.exports.chainAndCopyPromiseLike = $f11a681dc5b2f706$var$chainAndCopyPromiseLike;

});



parcelRegister("9eCUH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eMfEg = parcelRequire("eMfEg");
function $6b939b48129a1fee$var$isAttributeObject(maybeObj) {
    return typeof maybeObj === "object" && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes("value");
}
function $6b939b48129a1fee$var$attributeValueToTypedAttributeValue(rawValue, useFallback) {
    const { value: value, unit: unit } = $6b939b48129a1fee$var$isAttributeObject(rawValue) ? rawValue : {
        value: rawValue,
        unit: void 0
    };
    const attributeValue = $6b939b48129a1fee$var$getTypedAttributeValue(value);
    const checkedUnit = unit && typeof unit === "string" ? {
        unit: unit
    } : {};
    if (attributeValue) return {
        ...attributeValue,
        ...checkedUnit
    };
    if (!useFallback || useFallback === "skip-undefined" && value === void 0) return;
    let stringValue = "";
    try {
        stringValue = JSON.stringify(value) ?? "";
    } catch  {}
    return {
        value: stringValue,
        type: "string",
        ...checkedUnit
    };
}
function $6b939b48129a1fee$var$serializeAttributes(attributes, fallback = false) {
    const serializedAttributes = {};
    for (const [key, value] of Object.entries(attributes ?? {})){
        const typedValue = $6b939b48129a1fee$var$attributeValueToTypedAttributeValue(value, fallback);
        if (typedValue) serializedAttributes[key] = typedValue;
    }
    return serializedAttributes;
}
function $6b939b48129a1fee$var$estimateTypedAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    for (const [key, attr] of Object.entries(attributes)){
        weight += key.length * 2;
        weight += attr.type.length * 2;
        weight += (attr.unit?.length ?? 0) * 2;
        const val = attr.value;
        if (Array.isArray(val)) weight += $6b939b48129a1fee$var$estimatePrimitiveSizeInBytes(val[0]) * val.length;
        else if ($eMfEg.isPrimitive(val)) weight += $6b939b48129a1fee$var$estimatePrimitiveSizeInBytes(val);
        else weight += 100;
    }
    return weight;
}
function $6b939b48129a1fee$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "boolean") return 4;
    else if (typeof value === "number") return 8;
    return 0;
}
function $6b939b48129a1fee$var$getTypedAttributeValue(value) {
    if (Array.isArray(value)) return {
        value: value,
        type: "array"
    };
    const primitiveType = typeof value === "string" ? "string" : typeof value === "boolean" ? "boolean" : typeof value === "number" && !Number.isNaN(value) ? Number.isInteger(value) ? "integer" : "double" : null;
    if (primitiveType) return {
        value: value,
        type: primitiveType
    };
}
module.exports.attributeValueToTypedAttributeValue = $6b939b48129a1fee$var$attributeValueToTypedAttributeValue;
module.exports.estimateTypedAttributesSizeInBytes = $6b939b48129a1fee$var$estimateTypedAttributesSizeInBytes;
module.exports.isAttributeObject = $6b939b48129a1fee$var$isAttributeObject;
module.exports.serializeAttributes = $6b939b48129a1fee$var$serializeAttributes;

});

parcelRegister("8DrvK", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1xFq0 = parcelRequire("1xFq0");

var $6FBPf = parcelRequire("6FBPf");

var $htzrJ = parcelRequire("htzrJ");

var $3Xjyi = parcelRequire("3Xjyi");
let $64974e61636e4d13$var$_externalPropagationContextProvider;
function $64974e61636e4d13$var$registerExternalPropagationContext(fn) {
    $64974e61636e4d13$var$_externalPropagationContextProvider = fn;
}
function $64974e61636e4d13$var$getExternalPropagationContext() {
    return $64974e61636e4d13$var$_externalPropagationContextProvider?.();
}
function $64974e61636e4d13$var$hasExternalPropagationContext() {
    return $64974e61636e4d13$var$_externalPropagationContextProvider !== void 0;
}
function $64974e61636e4d13$var$getCurrentScope() {
    const carrier$1 = $6FBPf.getMainCarrier();
    const acs = $1xFq0.getAsyncContextStrategy(carrier$1);
    return acs.getCurrentScope();
}
function $64974e61636e4d13$var$getIsolationScope() {
    const carrier$1 = $6FBPf.getMainCarrier();
    const acs = $1xFq0.getAsyncContextStrategy(carrier$1);
    return acs.getIsolationScope();
}
function $64974e61636e4d13$var$getGlobalScope() {
    return $6FBPf.getGlobalSingleton("globalScope", ()=>new $htzrJ.Scope());
}
function $64974e61636e4d13$var$withScope(...rest) {
    const carrier$1 = $6FBPf.getMainCarrier();
    const acs = $1xFq0.getAsyncContextStrategy(carrier$1);
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
function $64974e61636e4d13$var$withIsolationScope(...rest) {
    const carrier$1 = $6FBPf.getMainCarrier();
    const acs = $1xFq0.getAsyncContextStrategy(carrier$1);
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
function $64974e61636e4d13$var$getClient() {
    return $64974e61636e4d13$var$getCurrentScope().getClient();
}
function $64974e61636e4d13$var$getTraceContextFromScope(scope) {
    const externalContext = $64974e61636e4d13$var$getExternalPropagationContext();
    if (externalContext) return {
        trace_id: externalContext.traceId,
        span_id: externalContext.spanId
    };
    const propagationContext$1 = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext$1;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || $3Xjyi.generateSpanId()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}
module.exports.getClient = $64974e61636e4d13$var$getClient;
module.exports.getCurrentScope = $64974e61636e4d13$var$getCurrentScope;
module.exports.getExternalPropagationContext = $64974e61636e4d13$var$getExternalPropagationContext;
module.exports.getGlobalScope = $64974e61636e4d13$var$getGlobalScope;
module.exports.getIsolationScope = $64974e61636e4d13$var$getIsolationScope;
module.exports.getTraceContextFromScope = $64974e61636e4d13$var$getTraceContextFromScope;
module.exports.hasExternalPropagationContext = $64974e61636e4d13$var$hasExternalPropagationContext;
module.exports.registerExternalPropagationContext = $64974e61636e4d13$var$registerExternalPropagationContext;
module.exports.withIsolationScope = $64974e61636e4d13$var$withIsolationScope;
module.exports.withScope = $64974e61636e4d13$var$withScope;

});

parcelRegister("dknph", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = "sentry.source";
const $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = "sentry.sample_rate";
const $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = "sentry.previous_trace_sample_rate";
const $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_OP = "sentry.op";
const $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = "sentry.origin";
const $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE = "sentry.status.message";
const $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = "sentry.idle_span_finish_reason";
const $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = "sentry.measurement_unit";
const $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = "sentry.measurement_value";
const $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = "sentry.release";
const $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = "sentry.environment";
const $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = "sentry.segment.name";
const $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = "sentry.segment.id";
const $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = "sentry.sdk.name";
const $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = "sentry.sdk.version";
const $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = "sentry.sdk.integrations";
const $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_USER_ID = "user.id";
const $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_USER_EMAIL = "user.email";
const $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = "user.ip_address";
const $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_USER_USERNAME = "user.name";
const $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = "sentry.custom_span_name";
const $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_PROFILE_ID = "sentry.profile_id";
const $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = "sentry.exclusive_time";
const $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_CACHE_HIT = "cache.hit";
const $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_CACHE_KEY = "cache.key";
const $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = "cache.item_size";
const $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = "http.request.method";
const $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_URL_FULL = "url.full";
const $9b3f4cb663af0fba$var$SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = "sentry.link.type";
const $9b3f4cb663af0fba$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE = "gen_ai.conversation.id";
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $9b3f4cb663af0fba$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_HIT = $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_CACHE_HIT;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_KEY = $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_CACHE_KEY;
module.exports.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
module.exports.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
module.exports.SEMANTIC_ATTRIBUTE_PROFILE_ID = $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_PROFILE_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_OP = $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_OP;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_RELEASE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE = $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE;
module.exports.SEMANTIC_ATTRIBUTE_URL_FULL = $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_URL_FULL;
module.exports.SEMANTIC_ATTRIBUTE_USER_EMAIL = $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_USER_EMAIL;
module.exports.SEMANTIC_ATTRIBUTE_USER_ID = $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_USER_ID;
module.exports.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS;
module.exports.SEMANTIC_ATTRIBUTE_USER_USERNAME = $9b3f4cb663af0fba$var$SEMANTIC_ATTRIBUTE_USER_USERNAME;
module.exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = $9b3f4cb663af0fba$var$SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;

});

parcelRegister("3su1E", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $284b47131bcac710$var$SPAN_STATUS_UNSET = 0;
const $284b47131bcac710$var$SPAN_STATUS_OK = 1;
const $284b47131bcac710$var$SPAN_STATUS_ERROR = 2;
function $284b47131bcac710$var$getSpanStatusFromHttpCode(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $284b47131bcac710$var$SPAN_STATUS_OK
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $284b47131bcac710$var$SPAN_STATUS_ERROR,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $284b47131bcac710$var$SPAN_STATUS_ERROR,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $284b47131bcac710$var$SPAN_STATUS_ERROR,
                message: "not_found"
            };
        case 409:
            return {
                code: $284b47131bcac710$var$SPAN_STATUS_ERROR,
                message: "already_exists"
            };
        case 413:
            return {
                code: $284b47131bcac710$var$SPAN_STATUS_ERROR,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $284b47131bcac710$var$SPAN_STATUS_ERROR,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $284b47131bcac710$var$SPAN_STATUS_ERROR,
                message: "cancelled"
            };
        default:
            return {
                code: $284b47131bcac710$var$SPAN_STATUS_ERROR,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $284b47131bcac710$var$SPAN_STATUS_ERROR,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $284b47131bcac710$var$SPAN_STATUS_ERROR,
                message: "unavailable"
            };
        case 504:
            return {
                code: $284b47131bcac710$var$SPAN_STATUS_ERROR,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $284b47131bcac710$var$SPAN_STATUS_ERROR,
                message: "internal_error"
            };
    }
    return {
        code: $284b47131bcac710$var$SPAN_STATUS_ERROR,
        message: "internal_error"
    };
}
function $284b47131bcac710$var$setHttpStatus(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $284b47131bcac710$var$getSpanStatusFromHttpCode(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}
module.exports.SPAN_STATUS_ERROR = $284b47131bcac710$var$SPAN_STATUS_ERROR;
module.exports.SPAN_STATUS_OK = $284b47131bcac710$var$SPAN_STATUS_OK;
module.exports.SPAN_STATUS_UNSET = $284b47131bcac710$var$SPAN_STATUS_UNSET;
module.exports.getSpanStatusFromHttpCode = $284b47131bcac710$var$getSpanStatusFromHttpCode;
module.exports.setHttpStatus = $284b47131bcac710$var$setHttpStatus;

});

parcelRegister("2BI5W", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kzIHY = parcelRequire("kzIHY");

var $3AKo2 = parcelRequire("3AKo2");
const $1e613dccd4ad36fa$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $1e613dccd4ad36fa$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
const $1e613dccd4ad36fa$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.otelSourceInference");
const $1e613dccd4ad36fa$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.otelSourceExplicitlySet");
const $1e613dccd4ad36fa$var$TRACER_PROVIDER_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.tracerProviderSpan");
function $1e613dccd4ad36fa$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        $kzIHY.addNonEnumerableProperty(span, $1e613dccd4ad36fa$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, $3AKo2.makeWeakRef(isolationScope));
        $kzIHY.addNonEnumerableProperty(span, $1e613dccd4ad36fa$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
function $1e613dccd4ad36fa$var$getCapturedScopesOnSpan(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[$1e613dccd4ad36fa$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: $3AKo2.derefWeakRef(spanWithScopes[$1e613dccd4ad36fa$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}
function $1e613dccd4ad36fa$var$markSpanForOtelSourceInference(span) {
    $kzIHY.addNonEnumerableProperty(span, $1e613dccd4ad36fa$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD, true);
}
function $1e613dccd4ad36fa$var$spanShouldInferOtelSource(span) {
    return span[$1e613dccd4ad36fa$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD] === true;
}
function $1e613dccd4ad36fa$var$markSpanSourceAsExplicit(span) {
    $kzIHY.addNonEnumerableProperty(span, $1e613dccd4ad36fa$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD, true);
}
function $1e613dccd4ad36fa$var$spanSourceWasExplicitlySet(span) {
    return span[$1e613dccd4ad36fa$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD] === true;
}
function $1e613dccd4ad36fa$var$markSpanAsTracerProviderSpan(span) {
    $kzIHY.addNonEnumerableProperty(span, $1e613dccd4ad36fa$var$TRACER_PROVIDER_SPAN_FIELD, true);
}
function $1e613dccd4ad36fa$var$spanIsTracerProviderSpan(span) {
    return span[$1e613dccd4ad36fa$var$TRACER_PROVIDER_SPAN_FIELD] === true;
}
module.exports.getCapturedScopesOnSpan = $1e613dccd4ad36fa$var$getCapturedScopesOnSpan;
module.exports.markSpanAsTracerProviderSpan = $1e613dccd4ad36fa$var$markSpanAsTracerProviderSpan;
module.exports.markSpanForOtelSourceInference = $1e613dccd4ad36fa$var$markSpanForOtelSourceInference;
module.exports.markSpanSourceAsExplicit = $1e613dccd4ad36fa$var$markSpanSourceAsExplicit;
module.exports.setCapturedScopesOnSpan = $1e613dccd4ad36fa$var$setCapturedScopesOnSpan;
module.exports.spanIsTracerProviderSpan = $1e613dccd4ad36fa$var$spanIsTracerProviderSpan;
module.exports.spanShouldInferOtelSource = $1e613dccd4ad36fa$var$spanShouldInferOtelSource;
module.exports.spanSourceWasExplicitlySet = $1e613dccd4ad36fa$var$spanSourceWasExplicitlySet;

});

parcelRegister("jrPYE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1UPRv = parcelRequire("1UPRv");

var $lJcxl = parcelRequire("lJcxl");

var $dXYuT = parcelRequire("dXYuT");

var $ljBvc = parcelRequire("ljBvc");

var $3Xjyi = parcelRequire("3Xjyi");

var $8odom = parcelRequire("8odom");
const $e288db8d7e2c6992$var$TRACEPARENT_REGEXP = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
function $e288db8d7e2c6992$var$extractTraceparentData(traceparent) {
    if (!traceparent) return void 0;
    const matches = traceparent.match($e288db8d7e2c6992$var$TRACEPARENT_REGEXP);
    if (!matches) return void 0;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
function $e288db8d7e2c6992$var$propagationContextFromHeaders(sentryTrace, baggage$1) {
    const traceparentData = $e288db8d7e2c6992$var$extractTraceparentData(sentryTrace);
    const dynamicSamplingContext = $lJcxl.baggageHeaderToDynamicSamplingContext(baggage$1);
    if (!traceparentData?.traceId) return {
        traceId: $3Xjyi.generateTraceId(),
        sampleRand: $8odom.safeMathRandom()
    };
    const sampleRand = $e288db8d7e2c6992$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
        sampleRand
    };
}
function $e288db8d7e2c6992$var$generateSentryTraceHeader(traceId = $3Xjyi.generateTraceId(), spanId = $3Xjyi.generateSpanId(), sampled) {
    let sampledString = "";
    if (sampled !== void 0) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}
function $e288db8d7e2c6992$var$generateTraceparentHeader(traceId = $3Xjyi.generateTraceId(), spanId = $3Xjyi.generateSpanId(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? "01" : "00"}`;
}
function $e288db8d7e2c6992$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    const parsedSampleRand = $ljBvc.parseSampleRate(dsc?.sample_rand);
    if (parsedSampleRand !== void 0) return parsedSampleRand;
    const parsedSampleRate = $ljBvc.parseSampleRate(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== void 0) return traceparentData.parentSampled ? // Returns a sample rand with positive sampling decision [0, sampleRate)
    $8odom.safeMathRandom() * parsedSampleRate : // Returns a sample rand with negative sampling decision [sampleRate, 1)
    parsedSampleRate + $8odom.safeMathRandom() * (1 - parsedSampleRate);
    else return $8odom.safeMathRandom();
}
function $e288db8d7e2c6992$var$shouldContinueTrace(client, baggageOrgId) {
    const clientOrgId = $dXYuT.extractOrgIdFromClient(client);
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        $1UPRv.debug.log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false;
    if (strictTraceContinuation) {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            $1UPRv.debug.log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}
module.exports.TRACEPARENT_REGEXP = $e288db8d7e2c6992$var$TRACEPARENT_REGEXP;
module.exports.extractTraceparentData = $e288db8d7e2c6992$var$extractTraceparentData;
module.exports.generateSentryTraceHeader = $e288db8d7e2c6992$var$generateSentryTraceHeader;
module.exports.generateTraceparentHeader = $e288db8d7e2c6992$var$generateTraceparentHeader;
module.exports.propagationContextFromHeaders = $e288db8d7e2c6992$var$propagationContextFromHeaders;
module.exports.shouldContinueTrace = $e288db8d7e2c6992$var$shouldContinueTrace;

});
parcelRegister("lJcxl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9Yejo = parcelRequire("9Yejo");

var $1UPRv = parcelRequire("1UPRv");

var $eMfEg = parcelRequire("eMfEg");
const $fd1786820d7b5f00$var$SENTRY_BAGGAGE_KEY_PREFIX = "sentry-";
const $fd1786820d7b5f00$var$SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;
const $fd1786820d7b5f00$var$MAX_BAGGAGE_STRING_LENGTH = 8192;
function $fd1786820d7b5f00$var$baggageHeaderToDynamicSamplingContext(baggageHeader) {
    const baggageObject = $fd1786820d7b5f00$var$parseBaggageHeader(baggageHeader);
    if (!baggageObject) return void 0;
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.startsWith($fd1786820d7b5f00$var$SENTRY_BAGGAGE_KEY_PREFIX)) {
            const nonPrefixedKey = key.slice($fd1786820d7b5f00$var$SENTRY_BAGGAGE_KEY_PREFIX.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return void 0;
}
function $fd1786820d7b5f00$var$dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext) {
    if (!dynamicSamplingContext) return void 0;
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$fd1786820d7b5f00$var$SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $fd1786820d7b5f00$var$objectToBaggageHeader(sentryPrefixedDSC);
}
function $fd1786820d7b5f00$var$parseBaggageHeader(baggageHeader) {
    if (!baggageHeader || !$eMfEg.isString(baggageHeader) && !Array.isArray(baggageHeader)) return void 0;
    if (Array.isArray(baggageHeader)) return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $fd1786820d7b5f00$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $fd1786820d7b5f00$var$baggageHeaderToObject(baggageHeader);
}
function $fd1786820d7b5f00$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf("=");
        if (eqIdx === -1) return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
function $fd1786820d7b5f00$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) return void 0;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $fd1786820d7b5f00$var$MAX_BAGGAGE_STRING_LENGTH) {
            $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}
function $fd1786820d7b5f00$var$mergeBaggageHeaders(existing, incoming) {
    if (!existing) return incoming;
    const existingEntries = $fd1786820d7b5f00$var$parseBaggageHeader(existing);
    const incomingEntries = $fd1786820d7b5f00$var$parseBaggageHeader(incoming);
    if (!incomingEntries) return existing;
    const merged = {};
    let hasNewSentryEntries = false;
    const newSentryEntries = {};
    const newNonSentryEntries = {};
    for (const [key, value] of Object.entries(incomingEntries))if (key.startsWith($fd1786820d7b5f00$var$SENTRY_BAGGAGE_KEY_PREFIX)) {
        newSentryEntries[key] = value;
        hasNewSentryEntries = true;
    } else newNonSentryEntries[key] = value;
    if (existingEntries) {
        for (const [key, value] of Object.entries(existingEntries))if (!hasNewSentryEntries || !key.startsWith($fd1786820d7b5f00$var$SENTRY_BAGGAGE_KEY_PREFIX)) merged[key] = value;
    }
    if (hasNewSentryEntries) Object.assign(merged, newSentryEntries);
    for (const [key, value] of Object.entries(newNonSentryEntries))merged[key] ?? (merged[key] = value);
    return $fd1786820d7b5f00$var$objectToBaggageHeader(merged);
}
module.exports.MAX_BAGGAGE_STRING_LENGTH = $fd1786820d7b5f00$var$MAX_BAGGAGE_STRING_LENGTH;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX = $fd1786820d7b5f00$var$SENTRY_BAGGAGE_KEY_PREFIX;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX_REGEX = $fd1786820d7b5f00$var$SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
module.exports.baggageHeaderToDynamicSamplingContext = $fd1786820d7b5f00$var$baggageHeaderToDynamicSamplingContext;
module.exports.dynamicSamplingContextToSentryBaggageHeader = $fd1786820d7b5f00$var$dynamicSamplingContextToSentryBaggageHeader;
module.exports.mergeBaggageHeaders = $fd1786820d7b5f00$var$mergeBaggageHeaders;
module.exports.objectToBaggageHeader = $fd1786820d7b5f00$var$objectToBaggageHeader;
module.exports.parseBaggageHeader = $fd1786820d7b5f00$var$parseBaggageHeader;

});

parcelRegister("dXYuT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9Yejo = parcelRequire("9Yejo");

var $1UPRv = parcelRequire("1UPRv");
const $a2afb689fd0e3129$var$ORG_ID_REGEX = /^o(\d+)\./;
const $a2afb689fd0e3129$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function $a2afb689fd0e3129$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
function $a2afb689fd0e3129$var$dsnToString(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
function $a2afb689fd0e3129$var$dsnFromString(str) {
    const match = $a2afb689fd0e3129$var$DSN_REGEX.exec(str);
    if (!match) {
        $1UPRv.consoleSandbox(()=>{
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return void 0;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $a2afb689fd0e3129$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $a2afb689fd0e3129$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $a2afb689fd0e3129$var$validateDsn(dsn) {
    if (!$9Yejo.DEBUG_BUILD) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            $1UPRv.debug.error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        $1UPRv.debug.error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$a2afb689fd0e3129$var$isValidProtocol(protocol)) {
        $1UPRv.debug.error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        $1UPRv.debug.error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
function $a2afb689fd0e3129$var$extractOrgIdFromDsnHost(host) {
    const match = host.match($a2afb689fd0e3129$var$ORG_ID_REGEX);
    return match?.[1];
}
function $a2afb689fd0e3129$var$extractOrgIdFromClient(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $a2afb689fd0e3129$var$extractOrgIdFromDsnHost(host);
    return org_id;
}
function $a2afb689fd0e3129$var$makeDsn(from) {
    const components = typeof from === "string" ? $a2afb689fd0e3129$var$dsnFromString(from) : $a2afb689fd0e3129$var$dsnFromComponents(from);
    if (!components || !$a2afb689fd0e3129$var$validateDsn(components)) return void 0;
    return components;
}
module.exports.dsnFromString = $a2afb689fd0e3129$var$dsnFromString;
module.exports.dsnToString = $a2afb689fd0e3129$var$dsnToString;
module.exports.extractOrgIdFromClient = $a2afb689fd0e3129$var$extractOrgIdFromClient;
module.exports.extractOrgIdFromDsnHost = $a2afb689fd0e3129$var$extractOrgIdFromDsnHost;
module.exports.makeDsn = $a2afb689fd0e3129$var$makeDsn;

});

parcelRegister("ljBvc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $f848767eeec31d31$var$parseSampleRate(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) return void 0;
    return rate;
}
module.exports.parseSampleRate = $f848767eeec31d31$var$parseSampleRate;

});




parcelRegister("14Wv2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8DrvK = parcelRequire("8DrvK");

var $9Yejo = parcelRequire("9Yejo");

var $dknph = parcelRequire("dknph");

var $1UPRv = parcelRequire("1UPRv");

var $13jPF = parcelRequire("13jPF");

var $2aQlx = parcelRequire("2aQlx");

var $b3Isg = parcelRequire("b3Isg");

var $eXvrd = parcelRequire("eXvrd");

var $1MCl5 = parcelRequire("1MCl5");

var $kJznu = parcelRequire("kJznu");

var $9pBcX = parcelRequire("9pBcX");

var $3su1E = parcelRequire("3su1E");

var $d7AD6 = parcelRequire("d7AD6");

var $2BI5W = parcelRequire("2BI5W");
const $0c938afe3e6ece39$var$TRACING_DEFAULTS = {
    idleTimeout: 1e3,
    finalTimeout: 3e4,
    childSpanTimeout: 15e3
};
const $0c938afe3e6ece39$var$FINISH_REASON_HEARTBEAT_FAILED = "heartbeatFailed";
const $0c938afe3e6ece39$var$FINISH_REASON_IDLE_TIMEOUT = "idleTimeout";
const $0c938afe3e6ece39$var$FINISH_REASON_FINAL_TIMEOUT = "finalTimeout";
const $0c938afe3e6ece39$var$FINISH_REASON_EXTERNAL_FINISH = "externalFinish";
function $0c938afe3e6ece39$var$startIdleSpan(startSpanOptions, options = {}) {
    const activities = /* @__PURE__ */ new Map();
    let _finished = false;
    let _idleTimeoutID;
    let _childSpanTimeoutID;
    let _finishReason = $0c938afe3e6ece39$var$FINISH_REASON_EXTERNAL_FINISH;
    let _autoFinishAllowed = !options.disableAutoFinish;
    const _cleanupHooks = [];
    const { idleTimeout: idleTimeout = $0c938afe3e6ece39$var$TRACING_DEFAULTS.idleTimeout, finalTimeout: finalTimeout = $0c938afe3e6ece39$var$TRACING_DEFAULTS.finalTimeout, childSpanTimeout: childSpanTimeout = $0c938afe3e6ece39$var$TRACING_DEFAULTS.childSpanTimeout, beforeSpanEnd: beforeSpanEnd, trimIdleSpanEndTimestamp: trimIdleSpanEndTimestamp = true } = options;
    const client = $8DrvK.getClient();
    const scope = $8DrvK.getCurrentScope();
    if (!client || !$13jPF.hasSpansEnabled()) {
        const span2 = new $kJznu.SentryNonRecordingSpan({
            traceId: scope.getPropagationContext().traceId
        });
        $2BI5W.setCapturedScopesOnSpan(span2, scope, $8DrvK.getIsolationScope());
        return span2;
    }
    const previousActiveSpan = $eXvrd.getActiveSpan();
    const span = $0c938afe3e6ece39$var$_startIdleSpan(startSpanOptions);
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span);
            if ($kJznu.spanIsNonRecordingSpan(thisArg)) return;
            const [definedEndTimestamp, ...rest] = args;
            const timestamp = definedEndTimestamp || $1MCl5.timestampInSeconds();
            const spanEndTimestamp = $eXvrd.spanTimeInputToSeconds(timestamp);
            const spans = $eXvrd.getSpanDescendants(span).filter((child)=>child !== span);
            const spanJson = $eXvrd.spanToJSON(span);
            if (!spans.length || !trimIdleSpanEndTimestamp) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp,
                    ...rest
                ]);
            }
            const ignoreSpans = client.getOptions().ignoreSpans;
            const latestSpanEndTimestamp = spans?.reduce((acc, current)=>{
                const currentSpanJson = $eXvrd.spanToJSON(current);
                if (!currentSpanJson.timestamp) return acc;
                if (ignoreSpans && $2aQlx.shouldIgnoreSpan({
                    description: currentSpanJson.description,
                    op: currentSpanJson.op,
                    attributes: currentSpanJson.data
                }, ignoreSpans)) return acc;
                return acc ? Math.max(acc, currentSpanJson.timestamp) : currentSpanJson.timestamp;
            }, void 0);
            const spanStartTimestamp = spanJson.start_timestamp;
            const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1e3 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp,
                ...rest
            ]);
        }
    });
    function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = void 0;
        }
    }
    function _cancelChildSpanTimeout() {
        if (_childSpanTimeoutID) {
            clearTimeout(_childSpanTimeoutID);
            _childSpanTimeoutID = void 0;
        }
    }
    function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = $0c938afe3e6ece39$var$FINISH_REASON_IDLE_TIMEOUT;
                span.end(endTimestamp);
            }
        }, idleTimeout);
    }
    function _restartChildSpanTimeout(endTimestamp) {
        _cancelChildSpanTimeout();
        _childSpanTimeoutID = setTimeout(()=>{
            if (!_finished && _autoFinishAllowed) {
                _finishReason = $0c938afe3e6ece39$var$FINISH_REASON_HEARTBEAT_FAILED;
                span.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        const endTimestamp = $1MCl5.timestampInSeconds();
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1e3);
    }
    function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            const endTimestamp = $1MCl5.timestampInSeconds();
            _restartIdleTimeout(endTimestamp + idleTimeout / 1e3);
            _cancelChildSpanTimeout();
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach((cleanup)=>cleanup());
        $b3Isg._setSpanForScope(scope, previousActiveSpan);
        const spanJSON = $eXvrd.spanToJSON(span);
        const { start_timestamp: startTimestamp } = spanJSON;
        if (!startTimestamp) return;
        const attributes = spanJSON.data;
        if (!attributes[$dknph.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON]) span.setAttribute($dknph.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON, _finishReason);
        const currentStatus = spanJSON.status;
        if (!currentStatus || currentStatus === "unknown") span.setStatus({
            code: $3su1E.SPAN_STATUS_OK
        });
        $1UPRv.debug.log(`[Tracing] Idle span "${spanJSON.op}" finished`);
        const childSpans = $eXvrd.getSpanDescendants(span).filter((child)=>child !== span);
        let discardedSpans = 0;
        childSpans.forEach((childSpan)=>{
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: $3su1E.SPAN_STATUS_ERROR,
                    message: "cancelled"
                });
                childSpan.end(endTimestamp);
                $9Yejo.DEBUG_BUILD && $1UPRv.debug.log("[Tracing] Cancelling span since span ended early", JSON.stringify(childSpan, void 0, 2));
            }
            const childSpanJSON = $eXvrd.spanToJSON(childSpan);
            const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
            const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1e3;
            const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if ($9Yejo.DEBUG_BUILD) {
                const stringifiedSpan = JSON.stringify(childSpan, void 0, 2);
                if (!spanStartedBeforeIdleSpanEnd) $1UPRv.debug.log("[Tracing] Discarding span since it happened after idle span was finished", stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) $1UPRv.debug.log("[Tracing] Discarding span since it finished after idle span final timeout", stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                $eXvrd.removeChildSpanFromSpan(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute("sentry.idle_span_discarded_spans", discardedSpans);
    }
    _cleanupHooks.push(client.on("spanStart", (startedSpan)=>{
        if (_finished || startedSpan === span || !!$eXvrd.spanToJSON(startedSpan).timestamp || startedSpan instanceof $9pBcX.SentrySpan && startedSpan.isStandaloneSpan()) return;
        const allSpans = $eXvrd.getSpanDescendants(span);
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("spanEnd", (endedSpan)=>{
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("idleSpanEnableAutoFinish", (spanToAllowAutoFinish)=>{
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(()=>{
        if (!_finished) {
            span.setStatus({
                code: $3su1E.SPAN_STATUS_ERROR,
                message: "deadline_exceeded"
            });
            _finishReason = $0c938afe3e6ece39$var$FINISH_REASON_FINAL_TIMEOUT;
            span.end();
        }
    }, finalTimeout);
    return span;
}
function $0c938afe3e6ece39$var$_startIdleSpan(options) {
    const span = $d7AD6.startInactiveSpan(options);
    $b3Isg._setSpanForScope($8DrvK.getCurrentScope(), span);
    $9Yejo.DEBUG_BUILD && $1UPRv.debug.log("[Tracing] Started span is an idle span");
    return span;
}
module.exports.TRACING_DEFAULTS = $0c938afe3e6ece39$var$TRACING_DEFAULTS;
module.exports.startIdleSpan = $0c938afe3e6ece39$var$startIdleSpan;

});
parcelRegister("13jPF", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8DrvK = parcelRequire("8DrvK");
function $0c45748c4374950c$var$hasSpansEnabled(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || $8DrvK.getClient()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
module.exports.hasSpansEnabled = $0c45748c4374950c$var$hasSpansEnabled;

});

parcelRegister("2aQlx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9Yejo = parcelRequire("9Yejo");

var $1UPRv = parcelRequire("1UPRv");

var $erV30 = parcelRequire("erV30");
function $19551ed7bfcf2303$var$logIgnoredSpan(droppedSpan) {
    $1UPRv.debug.log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
function $19551ed7bfcf2303$var$shouldIgnoreSpan(span, ignoreSpans) {
    if (!ignoreSpans?.length) return false;
    for (const pattern of ignoreSpans){
        if ($19551ed7bfcf2303$var$isStringOrRegExp(pattern)) {
            if (span.description && $erV30.isMatchingPattern(span.description, pattern)) {
                $9Yejo.DEBUG_BUILD && $19551ed7bfcf2303$var$logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        const hasAttributes = !!pattern.attributes && Object.keys(pattern.attributes).length > 0;
        if (!pattern.name && !pattern.op && !hasAttributes) continue;
        const nameMatches = pattern.name ? span.description && $erV30.isMatchingPattern(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && $erV30.isMatchingPattern(span.op, pattern.op) : true;
        const attrsMatch = pattern.attributes ? Object.entries(pattern.attributes).every(([key, valuePattern])=>$19551ed7bfcf2303$var$_matchesAttributeValue(span.attributes?.[key], valuePattern)) : true;
        if (nameMatches && opMatches && attrsMatch) {
            $9Yejo.DEBUG_BUILD && $19551ed7bfcf2303$var$logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
function $19551ed7bfcf2303$var$_matchesAttributeValue(actual, pat) {
    if (typeof actual === "string" && (typeof pat === "string" || pat instanceof RegExp)) return $erV30.isMatchingPattern(actual, pat);
    if (Array.isArray(actual) && Array.isArray(pat)) return actual.length === pat.length && actual.every((v, i)=>v === pat[i]);
    return actual === pat;
}
function $19551ed7bfcf2303$var$reparentChildSpans(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $19551ed7bfcf2303$var$isStringOrRegExp(value) {
    return typeof value === "string" || value instanceof RegExp;
}
module.exports.reparentChildSpans = $19551ed7bfcf2303$var$reparentChildSpans;
module.exports.shouldIgnoreSpan = $19551ed7bfcf2303$var$shouldIgnoreSpan;

});

parcelRegister("kJznu", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kzIHY = parcelRequire("kzIHY");

var $3Xjyi = parcelRequire("3Xjyi");

var $eXvrd = parcelRequire("eXvrd");
const $f18373f1242c229f$var$NON_RECORDING_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.nonRecordingSpan");
class $f18373f1242c229f$var$SentryNonRecordingSpan {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || $3Xjyi.generateTraceId();
        this._spanId = spanContext.spanId || $3Xjyi.generateSpanId();
        this.dropReason = spanContext.dropReason;
        $kzIHY.addNonEnumerableProperty(this, $f18373f1242c229f$var$NON_RECORDING_SPAN_FIELD, true);
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: $eXvrd.TRACE_FLAG_NONE
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
}
function $f18373f1242c229f$var$spanIsNonRecordingSpan(span) {
    return !!span && span[$f18373f1242c229f$var$NON_RECORDING_SPAN_FIELD] === true;
}
module.exports.SentryNonRecordingSpan = $f18373f1242c229f$var$SentryNonRecordingSpan;
module.exports.spanIsNonRecordingSpan = $f18373f1242c229f$var$spanIsNonRecordingSpan;

});

parcelRegister("9pBcX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8DrvK = parcelRequire("8DrvK");

var $9Yejo = parcelRequire("9Yejo");

var $aRHOP = parcelRequire("aRHOP");

var $dknph = parcelRequire("dknph");

var $1UPRv = parcelRequire("1UPRv");

var $3Xjyi = parcelRequire("3Xjyi");

var $eXvrd = parcelRequire("eXvrd");

var $1MCl5 = parcelRequire("1MCl5");

var $boK9h = parcelRequire("boK9h");

var $3pVDh = parcelRequire("3pVDh");

var $3wAM2 = parcelRequire("3wAM2");

var $5jZZC = parcelRequire("5jZZC");

var $cGnx0 = parcelRequire("cGnx0");

var $2BI5W = parcelRequire("2BI5W");
const $6da34f929ac9916f$var$MAX_SPAN_COUNT = 1e3;
class $6da34f929ac9916f$var$SentrySpan {
    /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || $3Xjyi.generateTraceId();
        this._spanId = spanContext.spanId || $3Xjyi.generateSpanId();
        this._startTime = spanContext.startTimestamp || $1MCl5.timestampInSeconds();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "manual",
            [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_OP]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._frozen) return this;
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._frozen) return this;
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? $eXvrd.TRACE_FLAG_SAMPLED : $eXvrd.TRACE_FLAG_NONE
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (this._frozen) return this;
        if (value === void 0) delete this._attributes[key];
        else this._attributes[key] = value;
        if (key === $dknph.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE && value !== void 0 && $2BI5W.spanShouldInferOtelSource(this)) $2BI5W.markSpanSourceAsExplicit(this);
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        if (this._frozen) return;
        this._startTime = $eXvrd.spanTimeInputToSeconds(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        if (this._frozen) return this;
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        if (this._frozen) return this;
        this._name = name;
        if (!$2BI5W.spanShouldInferOtelSource(this)) this.setAttribute($dknph.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, "custom");
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        if (this._endTime) {
            this._frozen = $2BI5W.spanIsTracerProviderSpan(this);
            return;
        }
        this._endTime = $eXvrd.spanTimeInputToSeconds(endTimestamp);
        $3pVDh.logSpanEnd(this);
        this._onSpanEnded();
        this._frozen = $2BI5W.spanIsTracerProviderSpan(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[$dknph.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: $eXvrd.getStatusMessage(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[$dknph.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            profile_id: this._attributes[$dknph.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._attributes[$dknph.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
            measurements: $3wAM2.timedEventsToMeasurements(this._events),
            is_segment: this._isStandaloneSpan && $eXvrd.getRootSpan(this) === this || void 0,
            segment_id: this._isStandaloneSpan ? $eXvrd.getRootSpan(this).spanContext().spanId : void 0,
            links: $eXvrd.convertSpanLinksForEnvelope(this._links)
        };
    }
    /**
   * Get {@link StreamedSpanJSON} representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToStreamedSpanJSON(span)` instead.
   */ getStreamedSpanJSON() {
        return {
            name: this._name ?? "",
            span_id: this._spanId,
            trace_id: this._traceId,
            parent_span_id: this._parentSpanId,
            start_timestamp: this._startTime,
            // just in case _endTime is not set, we use the start time (i.e. duration 0)
            end_timestamp: this._endTime ?? this._startTime,
            is_segment: this._isStandaloneSpan || this === $eXvrd.getRootSpan(this),
            status: $eXvrd.getSimpleStatus(this._status),
            attributes: $eXvrd.addStatusMessageAttribute(this._attributes, this._status),
            links: $eXvrd.getStreamedSpanLinks(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        if (this._frozen) return this;
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.log("[Tracing] Adding an event to span:", name);
        const time$1 = $6da34f929ac9916f$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || $1MCl5.timestampInSeconds();
        const attributes = $6da34f929ac9916f$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: $eXvrd.spanTimeInputToSeconds(time$1),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = $8DrvK.getClient();
        if (client) {
            client.emit("spanEnd", this);
            if (!this._isStandaloneSpan) client.emit("afterSpanEnd", this);
        }
        const rootSpan = $eXvrd.getRootSpan(this);
        const isSegmentSpan = this._isStandaloneSpan || this === rootSpan;
        if (this._isStandaloneSpan) {
            if (this._sampled) $6da34f929ac9916f$var$sendSpanEnvelope($aRHOP.createSpanEnvelope([
                this
            ], client));
            else {
                $9Yejo.DEBUG_BUILD && $1UPRv.debug.log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                if (client) client.recordDroppedEvent("sample_rate", "span");
            }
            return;
        }
        if (!isSegmentSpan) {
            const strategy2 = $5jZZC.getSegmentSpanCaptureStrategy();
            if (strategy2) {
                const scope2 = $2BI5W.getCapturedScopesOnSpan(this).scope || $8DrvK.getCurrentScope();
                strategy2.onChildSpanEnded(this, rootSpan, (options)=>this._convertSpanToTransaction(options), scope2);
            }
            return;
        }
        if (client && $cGnx0.hasSpanStreamingEnabled(client)) {
            client.emit("afterSegmentSpanEnd", this);
            return;
        }
        const scope = $2BI5W.getCapturedScopesOnSpan(this).scope || $8DrvK.getCurrentScope();
        const strategy = $5jZZC.getSegmentSpanCaptureStrategy();
        if (strategy) strategy.onSegmentSpanEnded((options)=>this._convertSpanToTransaction(options), scope);
        else {
            const transactionEvent = this._convertSpanToTransaction();
            if (transactionEvent) scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction(options = {}) {
        if (!$6da34f929ac9916f$var$isFullFinishedSpan($eXvrd.spanToJSON(this))) return void 0;
        if (!this._name) {
            $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = $2BI5W.getCapturedScopesOnSpan(this);
        const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
        if (this._sampled !== true) return void 0;
        options.onSpanCaptured?.(this);
        const spans = [];
        for (const descendant of $eXvrd.getSpanDescendants(this)){
            if (descendant === this || $6da34f929ac9916f$var$isStandaloneSpan(descendant) || options.isSpanAlreadyCaptured?.(descendant)) continue;
            const spanJSON = $eXvrd.spanToJSON(descendant);
            if (!$6da34f929ac9916f$var$isFullFinishedSpan(spanJSON)) continue;
            options.onSpanCaptured?.(descendant);
            spans.push(spanJSON);
        }
        const source = this._attributes[$dknph.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        delete this._attributes[$dknph.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
        let hasGenAiSpans = false;
        spans.forEach((span)=>{
            delete span.data[$dknph.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
            if (span.op?.startsWith("gen_ai.")) hasGenAiSpans = true;
        });
        const transaction = {
            contexts: {
                trace: $eXvrd.spanToTransactionTraceContext(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $6da34f929ac9916f$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $6da34f929ac9916f$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: $boK9h.getDynamicSamplingContextFromSpan(this),
                hasGenAiSpans: hasGenAiSpans
            },
            request: normalizedRequest,
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = $3wAM2.timedEventsToMeasurements(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            $9Yejo.DEBUG_BUILD && $1UPRv.debug.log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, void 0, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $6da34f929ac9916f$var$isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
function $6da34f929ac9916f$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
function $6da34f929ac9916f$var$isStandaloneSpan(span) {
    return span instanceof $6da34f929ac9916f$var$SentrySpan && span.isStandaloneSpan();
}
function $6da34f929ac9916f$var$sendSpanEnvelope(envelope) {
    const client = $8DrvK.getClient();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    client.sendEnvelope(envelope);
}
module.exports.SentrySpan = $6da34f929ac9916f$var$SentrySpan;

});
parcelRegister("aRHOP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $boK9h = parcelRequire("boK9h");

var $5ob0u = parcelRequire("5ob0u");

var $dXYuT = parcelRequire("dXYuT");

var $5gI17 = parcelRequire("5gI17");

var $8odom = parcelRequire("8odom");

var $2aQlx = parcelRequire("2aQlx");

var $eXvrd = parcelRequire("eXvrd");
function $7e90d8195d0670c0$var$_enhanceEventWithSdkInfo(event, newSdkInfo) {
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = {
        ...eventSdkInfo,
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...event.sdk?.integrations || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...event.sdk?.packages || [],
            ...newSdkInfo.packages || []
        ],
        settings: event.sdk?.settings || newSdkInfo.settings ? {
            ...event.sdk?.settings,
            ...newSdkInfo.settings
        } : void 0
    };
    return event;
}
function $7e90d8195d0670c0$var$createSessionEnvelope(session, dsn$1, metadata, tunnel) {
    const sdkInfo = $5gI17.getSdkMetadataForEnvelopeHeader(metadata);
    const envelopeHeaders = {
        sent_at: new Date($8odom.safeDateNow()).toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn$1 && {
            dsn: $dXYuT.dsnToString(dsn$1)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return $5gI17.createEnvelope(envelopeHeaders, [
        envelopeItem
    ]);
}
function $7e90d8195d0670c0$var$createEventEnvelope(event, dsn, metadata, tunnel) {
    const sdkInfo = $5gI17.getSdkMetadataForEnvelopeHeader(metadata);
    const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $7e90d8195d0670c0$var$_enhanceEventWithSdkInfo(event, metadata?.sdk);
    const envelopeHeaders = $5gI17.createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return $5gI17.createEnvelope(envelopeHeaders, [
        eventItem
    ]);
}
function $7e90d8195d0670c0$var$createSpanEnvelope(spans, client) {
    function dscHasRequiredProps(dsc2) {
        return !!dsc2.trace_id && !!dsc2.public_key;
    }
    const dsc = $boK9h.getDynamicSamplingContextFromSpan(spans[0]);
    const dsn$1 = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date($8odom.safeDateNow()).toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn$1 && {
            dsn: $dXYuT.dsnToString(dsn$1)
        }
    };
    const { beforeSendSpan: beforeSendSpan$1, ignoreSpans: ignoreSpans } = client?.getOptions() || {};
    const filteredSpans = ignoreSpans?.length ? spans.filter((span)=>{
        const json = $eXvrd.spanToJSON(span);
        return !$2aQlx.shouldIgnoreSpan({
            description: json.description,
            op: json.op,
            attributes: json.data
        }, ignoreSpans);
    }) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client?.recordDroppedEvent("before_send", "span", droppedSpans);
    const convertToSpanJSON = beforeSendSpan$1 ? (span)=>{
        const spanJson = $eXvrd.spanToJSON(span);
        const processedSpan = !$5ob0u.isStreamedBeforeSendSpanCallback(beforeSendSpan$1) ? beforeSendSpan$1(spanJson) : spanJson;
        if (!processedSpan) {
            $eXvrd.showSpanDropWarning();
            return spanJson;
        }
        return processedSpan;
    } : $eXvrd.spanToJSON;
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push($5gI17.createSpanEnvelopeItem(spanJson));
    }
    return $5gI17.createEnvelope(headers, items);
}
module.exports._enhanceEventWithSdkInfo = $7e90d8195d0670c0$var$_enhanceEventWithSdkInfo;
module.exports.createEventEnvelope = $7e90d8195d0670c0$var$createEventEnvelope;
module.exports.createSessionEnvelope = $7e90d8195d0670c0$var$createSessionEnvelope;
module.exports.createSpanEnvelope = $7e90d8195d0670c0$var$createSpanEnvelope;

});
parcelRegister("boK9h", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jf5XH = parcelRequire("jf5XH");

var $8DrvK = parcelRequire("8DrvK");

var $dknph = parcelRequire("dknph");

var $lJcxl = parcelRequire("lJcxl");

var $dXYuT = parcelRequire("dXYuT");

var $13jPF = parcelRequire("13jPF");

var $kzIHY = parcelRequire("kzIHY");

var $eXvrd = parcelRequire("eXvrd");

var $kJznu = parcelRequire("kJznu");

var $2BI5W = parcelRequire("2BI5W");
const $84c5bbc016250ce9$var$FROZEN_DSC_FIELD = "_frozenDsc";
function $84c5bbc016250ce9$var$freezeDscOnSpan(span, dsc) {
    const spanWithMaybeDsc = span;
    $kzIHY.addNonEnumerableProperty(spanWithMaybeDsc, $84c5bbc016250ce9$var$FROZEN_DSC_FIELD, dsc);
}
function $84c5bbc016250ce9$var$getDynamicSamplingContextFromClient(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = {
        environment: options.environment || $jf5XH.DEFAULT_ENVIRONMENT,
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: $dXYuT.extractOrgIdFromClient(client)
    };
    client.emit("createDsc", dsc);
    return dsc;
}
function $84c5bbc016250ce9$var$getDynamicSamplingContextFromScope(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $84c5bbc016250ce9$var$getDynamicSamplingContextFromClient(propagationContext.traceId, client);
}
function $84c5bbc016250ce9$var$getDynamicSamplingContextFromSpan(span) {
    const client = $8DrvK.getClient();
    if (!client) return {};
    const rootSpan = $eXvrd.getRootSpan(span);
    const rootSpanJson = $eXvrd.spanToJSON(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    const rootSpanSampleRate = traceState?.get("sentry.sample_rate") ?? rootSpanAttributes[$dknph.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] ?? rootSpanAttributes[$dknph.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE];
    function applyLocalSampleRateToDsc(dsc2) {
        if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") dsc2.sample_rate = `${rootSpanSampleRate}`;
        return dsc2;
    }
    const frozenDsc = rootSpan[$84c5bbc016250ce9$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    const isNonRecordingRoot = $kJznu.spanIsNonRecordingSpan(rootSpan);
    const isIgnoredRoot = isNonRecordingRoot && rootSpan.dropReason === "ignored";
    if (isNonRecordingRoot && (!$13jPF.hasSpansEnabled(client.getOptions()) || isIgnoredRoot)) {
        const capturedScope = $2BI5W.getCapturedScopesOnSpan(rootSpan).scope;
        if (capturedScope) {
            const dsc2 = {
                ...$84c5bbc016250ce9$var$getDynamicSamplingContextFromScope(client, capturedScope)
            };
            if (isIgnoredRoot) dsc2.sampled = "false";
            return applyLocalSampleRateToDsc(dsc2);
        }
    }
    const traceStateDsc = traceState?.get("sentry.dsc");
    const dscOnTraceState = traceStateDsc && $lJcxl.baggageHeaderToDynamicSamplingContext(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    const dsc = $84c5bbc016250ce9$var$getDynamicSamplingContextFromClient(span.spanContext().traceId, client);
    const source = rootSpanAttributes[$dknph.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] ?? rootSpanAttributes["sentry.segment.name.source"];
    const name = rootSpanJson.description;
    if (source !== "url" && name) dsc.transaction = name;
    if ($13jPF.hasSpansEnabled()) {
        dsc.sampled = String($eXvrd.spanIsSampled(rootSpan));
        dsc.sample_rand = // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get("sentry.sample_rand") ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        $2BI5W.getCapturedScopesOnSpan(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
function $84c5bbc016250ce9$var$spanToBaggageHeader(span) {
    const dsc = $84c5bbc016250ce9$var$getDynamicSamplingContextFromSpan(span);
    return $lJcxl.dynamicSamplingContextToSentryBaggageHeader(dsc);
}
module.exports.freezeDscOnSpan = $84c5bbc016250ce9$var$freezeDscOnSpan;
module.exports.getDynamicSamplingContextFromClient = $84c5bbc016250ce9$var$getDynamicSamplingContextFromClient;
module.exports.getDynamicSamplingContextFromScope = $84c5bbc016250ce9$var$getDynamicSamplingContextFromScope;
module.exports.getDynamicSamplingContextFromSpan = $84c5bbc016250ce9$var$getDynamicSamplingContextFromSpan;
module.exports.spanToBaggageHeader = $84c5bbc016250ce9$var$spanToBaggageHeader;

});
parcelRegister("jf5XH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $e0240aed7eb600b9$var$DEFAULT_ENVIRONMENT = "production";
const $e0240aed7eb600b9$var$DEV_ENVIRONMENT = "development";
module.exports.DEFAULT_ENVIRONMENT = $e0240aed7eb600b9$var$DEFAULT_ENVIRONMENT;
module.exports.DEV_ENVIRONMENT = $e0240aed7eb600b9$var$DEV_ENVIRONMENT;

});


parcelRegister("5ob0u", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kzIHY = parcelRequire("kzIHY");
function $3ec7bb62bba208c0$var$withStreamedSpan(callback) {
    $kzIHY.addNonEnumerableProperty(callback, "_streamed", true);
    return callback;
}
function $3ec7bb62bba208c0$var$isStreamedBeforeSendSpanCallback(callback) {
    return !!callback && typeof callback === "function" && "_streamed" in callback && !!callback._streamed;
}
module.exports.isStreamedBeforeSendSpanCallback = $3ec7bb62bba208c0$var$isStreamedBeforeSendSpanCallback;
module.exports.withStreamedSpan = $3ec7bb62bba208c0$var$withStreamedSpan;

});

parcelRegister("5gI17", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6FBPf = parcelRequire("6FBPf");

var $dXYuT = parcelRequire("dXYuT");

var $aaVDI = parcelRequire("aaVDI");

var $8odom = parcelRequire("8odom");

var $YfOkS = parcelRequire("YfOkS");
function $3d60973bcb595ff6$var$createEnvelope(headers, items = []) {
    return [
        headers,
        items
    ];
}
function $3d60973bcb595ff6$var$addItemToEnvelope(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
function $3d60973bcb595ff6$var$forEachEnvelopeItem(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
function $3d60973bcb595ff6$var$envelopeContainsItemType(envelope, types) {
    return $3d60973bcb595ff6$var$forEachEnvelopeItem(envelope, (_, type)=>types.includes(type));
}
function $3d60973bcb595ff6$var$encodeUTF8(input) {
    const carrier$1 = $6FBPf.getSentryCarrier($YfOkS.GLOBAL_OBJ);
    return carrier$1.encodePolyfill ? carrier$1.encodePolyfill(input) : new TextEncoder().encode(input);
}
function $3d60973bcb595ff6$var$decodeUTF8(input) {
    const carrier$1 = $6FBPf.getSentryCarrier($YfOkS.GLOBAL_OBJ);
    return carrier$1.decodePolyfill ? carrier$1.decodePolyfill(input) : new TextDecoder().decode(input);
}
function $3d60973bcb595ff6$var$serializeEnvelope(envelope) {
    const [envHeaders, items] = envelope;
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $3d60973bcb595ff6$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $3d60973bcb595ff6$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`
${JSON.stringify(itemHeaders)}
`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch  {
                stringifiedPayload = JSON.stringify($aaVDI.normalize(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $3d60973bcb595ff6$var$concatBuffers(parts);
}
function $3d60973bcb595ff6$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
function $3d60973bcb595ff6$var$parseEnvelope(env) {
    let buffer = typeof env === "string" ? $3d60973bcb595ff6$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(10);
        if (i < 0) i = buffer.length;
        return JSON.parse($3d60973bcb595ff6$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : void 0;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
function $3d60973bcb595ff6$var$createSpanEnvelopeItem(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
function $3d60973bcb595ff6$var$createAttachmentEnvelopeItem(attachment) {
    const buffer = typeof attachment.data === "string" ? $3d60973bcb595ff6$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $3d60973bcb595ff6$var$DATA_CATEGORY_OVERRIDES = {
    sessions: "session",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    raw_security: "security",
    log: "log_item",
    trace_metric: "metric"
};
function $3d60973bcb595ff6$var$_isOverriddenType(type) {
    return type in $3d60973bcb595ff6$var$DATA_CATEGORY_OVERRIDES;
}
function $3d60973bcb595ff6$var$envelopeItemTypeToDataCategory(type) {
    return $3d60973bcb595ff6$var$_isOverriddenType(type) ? $3d60973bcb595ff6$var$DATA_CATEGORY_OVERRIDES[type] : type;
}
function $3d60973bcb595ff6$var$getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
function $3d60973bcb595ff6$var$createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn$1) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date($8odom.safeDateNow()).toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn$1 && {
            dsn: $dXYuT.dsnToString(dsn$1)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}
module.exports.addItemToEnvelope = $3d60973bcb595ff6$var$addItemToEnvelope;
module.exports.createAttachmentEnvelopeItem = $3d60973bcb595ff6$var$createAttachmentEnvelopeItem;
module.exports.createEnvelope = $3d60973bcb595ff6$var$createEnvelope;
module.exports.createEventEnvelopeHeaders = $3d60973bcb595ff6$var$createEventEnvelopeHeaders;
module.exports.createSpanEnvelopeItem = $3d60973bcb595ff6$var$createSpanEnvelopeItem;
module.exports.envelopeContainsItemType = $3d60973bcb595ff6$var$envelopeContainsItemType;
module.exports.envelopeItemTypeToDataCategory = $3d60973bcb595ff6$var$envelopeItemTypeToDataCategory;
module.exports.forEachEnvelopeItem = $3d60973bcb595ff6$var$forEachEnvelopeItem;
module.exports.getSdkMetadataForEnvelopeHeader = $3d60973bcb595ff6$var$getSdkMetadataForEnvelopeHeader;
module.exports.parseEnvelope = $3d60973bcb595ff6$var$parseEnvelope;
module.exports.serializeEnvelope = $3d60973bcb595ff6$var$serializeEnvelope;

});


parcelRegister("3pVDh", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9Yejo = parcelRequire("9Yejo");

var $1UPRv = parcelRequire("1UPRv");

var $eXvrd = parcelRequire("eXvrd");
function $27d06982c662c0f4$var$logSpanStart(span) {
    if (!$9Yejo.DEBUG_BUILD) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >", parent_span_id: parentSpanId } = $eXvrd.spanToJSON(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = $eXvrd.spanIsSampled(span);
    const rootSpan = $eXvrd.getRootSpan(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op2, description: description2 } = $eXvrd.spanToJSON(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op2) infoParts.push(`root op: ${op2}`);
        if (description2) infoParts.push(`root description: ${description2}`);
    }
    $1UPRv.debug.log(`${header}
  ${infoParts.join("\n  ")}`);
}
function $27d06982c662c0f4$var$logSpanEnd(span) {
    if (!$9Yejo.DEBUG_BUILD) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >" } = $eXvrd.spanToJSON(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = $eXvrd.getRootSpan(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
    $1UPRv.debug.log(msg);
}
module.exports.logSpanEnd = $27d06982c662c0f4$var$logSpanEnd;
module.exports.logSpanStart = $27d06982c662c0f4$var$logSpanStart;

});

parcelRegister("3wAM2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9Yejo = parcelRequire("9Yejo");

var $dknph = parcelRequire("dknph");

var $1UPRv = parcelRequire("1UPRv");

var $eXvrd = parcelRequire("eXvrd");
function $2910e2bffa2cd500$var$setMeasurement(name, value, unit, activeSpan = $eXvrd.getActiveSpan()) {
    const rootSpan = activeSpan && $eXvrd.getRootSpan(activeSpan);
    if (rootSpan) {
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE]: value,
            [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT]: unit
        });
    }
}
function $2910e2bffa2cd500$var$timedEventsToMeasurements(events) {
    if (!events || events.length === 0) return void 0;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[$dknph.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT];
        const value = attributes[$dknph.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}
module.exports.setMeasurement = $2910e2bffa2cd500$var$setMeasurement;
module.exports.timedEventsToMeasurements = $2910e2bffa2cd500$var$timedEventsToMeasurements;

});

parcelRegister("5jZZC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6FBPf = parcelRequire("6FBPf");
function $3dfed094ae1ff6be$var$setSegmentSpanCaptureStrategy(strategy) {
    $6FBPf.getSentryCarrier($6FBPf.getMainCarrier()).segmentSpanCaptureStrategy = strategy;
}
function $3dfed094ae1ff6be$var$getSegmentSpanCaptureStrategy() {
    return $6FBPf.getSentryCarrier($6FBPf.getMainCarrier()).segmentSpanCaptureStrategy;
}
module.exports.getSegmentSpanCaptureStrategy = $3dfed094ae1ff6be$var$getSegmentSpanCaptureStrategy;
module.exports.setSegmentSpanCaptureStrategy = $3dfed094ae1ff6be$var$setSegmentSpanCaptureStrategy;

});

parcelRegister("cGnx0", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $93bba91d3dcb9ba0$var$hasSpanStreamingEnabled(client) {
    return client.getOptions().traceLifecycle === "stream";
}
module.exports.hasSpanStreamingEnabled = $93bba91d3dcb9ba0$var$hasSpanStreamingEnabled;

});


parcelRegister("d7AD6", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1xFq0 = parcelRequire("1xFq0");

var $6FBPf = parcelRequire("6FBPf");

var $8DrvK = parcelRequire("8DrvK");

var $9Yejo = parcelRequire("9Yejo");

var $dknph = parcelRequire("dknph");

var $lJcxl = parcelRequire("lJcxl");

var $1UPRv = parcelRequire("1UPRv");

var $ciHXl = parcelRequire("ciHXl");

var $13jPF = parcelRequire("13jPF");

var $2aQlx = parcelRequire("2aQlx");

var $cGnx0 = parcelRequire("cGnx0");

var $ljBvc = parcelRequire("ljBvc");

var $3Xjyi = parcelRequire("3Xjyi");

var $8odom = parcelRequire("8odom");

var $b3Isg = parcelRequire("b3Isg");

var $eXvrd = parcelRequire("eXvrd");

var $jrPYE = parcelRequire("jrPYE");

var $boK9h = parcelRequire("boK9h");

var $3pVDh = parcelRequire("3pVDh");

var $5pv9T = parcelRequire("5pv9T");

var $kJznu = parcelRequire("kJznu");

var $9pBcX = parcelRequire("9pBcX");

var $3su1E = parcelRequire("3su1E");

var $2BI5W = parcelRequire("2BI5W");
const $98d857b0ebdddd9e$var$SUPPRESS_TRACING_KEY = "__SENTRY_SUPPRESS_TRACING__";
function $98d857b0ebdddd9e$var$startSpan(options, callback) {
    const acs = $98d857b0ebdddd9e$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $98d857b0ebdddd9e$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return $8DrvK.withScope(customForkedScope, ()=>{
        const wrapper = $98d857b0ebdddd9e$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = $8DrvK.getCurrentScope();
            const parentSpan = $98d857b0ebdddd9e$var$getParentSpan(scope, customParentSpan);
            const client = $8DrvK.getClient();
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? $98d857b0ebdddd9e$var$startMissingRequiredParentSpan(scope, client) : $98d857b0ebdddd9e$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (!$98d857b0ebdddd9e$var$spanIsIgnored(activeSpan) || !parentSpan) $b3Isg._setSpanForScope(scope, activeSpan);
            return $ciHXl.handleCallbackErrors(()=>callback(activeSpan), ()=>{
                const { status: status } = $eXvrd.spanToJSON(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: $3su1E.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
function $98d857b0ebdddd9e$var$startSpanManual(options, callback) {
    const acs = $98d857b0ebdddd9e$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $98d857b0ebdddd9e$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return $8DrvK.withScope(customForkedScope, ()=>{
        const wrapper = $98d857b0ebdddd9e$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = $8DrvK.getCurrentScope();
            const parentSpan = $98d857b0ebdddd9e$var$getParentSpan(scope, customParentSpan);
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? $98d857b0ebdddd9e$var$startMissingRequiredParentSpan(scope, $8DrvK.getClient()) : $98d857b0ebdddd9e$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (!$98d857b0ebdddd9e$var$spanIsIgnored(activeSpan) || !parentSpan) $b3Isg._setSpanForScope(scope, activeSpan);
            return $ciHXl.handleCallbackErrors(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                const { status: status } = $eXvrd.spanToJSON(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: $3su1E.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
            });
        });
    });
}
function $98d857b0ebdddd9e$var$startInactiveSpan(options) {
    const acs = $98d857b0ebdddd9e$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    return $98d857b0ebdddd9e$var$_startInactiveSpanImpl(options);
}
function $98d857b0ebdddd9e$var$_INTERNAL_startInactiveSpan(options) {
    return $98d857b0ebdddd9e$var$_startInactiveSpanImpl(options);
}
function $98d857b0ebdddd9e$var$_startInactiveSpanImpl(options) {
    const spanArguments = $98d857b0ebdddd9e$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    const wrapper = options.scope ? (callback)=>$8DrvK.withScope(options.scope, callback) : customParentSpan !== void 0 ? (callback)=>$98d857b0ebdddd9e$var$withActiveSpan(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = $8DrvK.getCurrentScope();
        const parentSpan = $98d857b0ebdddd9e$var$getParentSpan(scope, customParentSpan);
        const client = $8DrvK.getClient();
        const missingRequiredParent = options.onlyIfParent && !parentSpan;
        if (missingRequiredParent) return $98d857b0ebdddd9e$var$startMissingRequiredParentSpan(scope, client);
        return $98d857b0ebdddd9e$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
const $98d857b0ebdddd9e$var$continueTrace = (options, callback)=>{
    const carrier$1 = $6FBPf.getMainCarrier();
    const acs = $1xFq0.getAsyncContextStrategy(carrier$1);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage$1 } = options;
    const client = $8DrvK.getClient();
    const incomingDsc = $lJcxl.baggageHeaderToDynamicSamplingContext(baggage$1);
    if (client && !$jrPYE.shouldContinueTrace(client, incomingDsc?.org_id)) return $98d857b0ebdddd9e$var$startNewTrace(callback);
    return $8DrvK.withScope((scope)=>{
        const propagationContext = $jrPYE.propagationContextFromHeaders(sentryTrace, baggage$1);
        scope.setPropagationContext(propagationContext);
        $b3Isg._setSpanForScope(scope, void 0);
        return callback();
    });
};
function $98d857b0ebdddd9e$var$withActiveSpan(span, callback) {
    const acs = $98d857b0ebdddd9e$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return $8DrvK.withScope((scope)=>{
        $b3Isg._setSpanForScope(scope, span || void 0);
        return callback(scope);
    });
}
function $98d857b0ebdddd9e$var$suppressTracing(callback) {
    const acs = $98d857b0ebdddd9e$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return $8DrvK.withScope((scope)=>{
        scope.setSDKProcessingMetadata({
            [$98d857b0ebdddd9e$var$SUPPRESS_TRACING_KEY]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$98d857b0ebdddd9e$var$SUPPRESS_TRACING_KEY]: void 0
        });
        return res;
    });
}
function $98d857b0ebdddd9e$var$isTracingSuppressed(scope = $8DrvK.getCurrentScope()) {
    const acs = $98d857b0ebdddd9e$var$getAcs();
    if (acs.isTracingSuppressed) return acs.isTracingSuppressed(scope);
    return scope.getScopeData().sdkProcessingMetadata[$98d857b0ebdddd9e$var$SUPPRESS_TRACING_KEY] === true;
}
function $98d857b0ebdddd9e$var$startNewTrace(callback) {
    const acs = $98d857b0ebdddd9e$var$getAcs();
    if (acs.startNewTrace) return acs.startNewTrace(callback);
    return $8DrvK.withScope((scope)=>{
        scope.setPropagationContext({
            traceId: $3Xjyi.generateTraceId(),
            sampleRand: $8odom.safeMathRandom()
        });
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $98d857b0ebdddd9e$var$withActiveSpan(null, callback);
    });
}
function $98d857b0ebdddd9e$var$startMissingRequiredParentSpan(scope, client) {
    client?.recordDroppedEvent("no_parent_span", "span");
    const span = new $kJznu.SentryNonRecordingSpan({
        traceId: scope.getPropagationContext().traceId
    });
    $2BI5W.setCapturedScopesOnSpan(span, scope, $8DrvK.getIsolationScope());
    return span;
}
function $98d857b0ebdddd9e$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    const isolationScope = $8DrvK.getIsolationScope();
    if (!$13jPF.hasSpansEnabled()) {
        const scopePropagationContext = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        const traceId = parentSpan ? parentSpan.spanContext().traceId : scopePropagationContext.traceId;
        const span2 = new $kJznu.SentryNonRecordingSpan({
            traceId: traceId
        });
        if (parentSpan && !forceTransaction) $eXvrd.addChildSpanToSpan(parentSpan, span2);
        $2BI5W.setCapturedScopesOnSpan(span2, scope, isolationScope);
        return span2;
    }
    const client = $8DrvK.getClient();
    if ($98d857b0ebdddd9e$var$_shouldIgnoreStreamedSpan(client, spanArguments)) {
        if (!$98d857b0ebdddd9e$var$isTracingSuppressed(scope)) client?.recordDroppedEvent("ignored", "span");
        const ignoredSpan = new $kJznu.SentryNonRecordingSpan({
            dropReason: "ignored",
            traceId: parentSpan?.spanContext().traceId ?? scope.getPropagationContext().traceId
        });
        if (parentSpan && !forceTransaction) $eXvrd.addChildSpanToSpan(parentSpan, ignoredSpan);
        $2BI5W.setCapturedScopesOnSpan(ignoredSpan, scope, isolationScope);
        return ignoredSpan;
    }
    let span;
    if (parentSpan && !forceTransaction) {
        span = $98d857b0ebdddd9e$var$_startChildSpan(parentSpan, scope, spanArguments, isolationScope);
        $eXvrd.addChildSpanToSpan(parentSpan, span);
    } else if (parentSpan) {
        const dsc = $boK9h.getDynamicSamplingContextFromSpan(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = $eXvrd.spanIsSampled(parentSpan);
        span = $98d857b0ebdddd9e$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, isolationScope, parentSampled);
        $boK9h.freezeDscOnSpan(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $98d857b0ebdddd9e$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, isolationScope, parentSampled);
        if (dsc) $boK9h.freezeDscOnSpan(span, dsc);
    }
    $3pVDh.logSpanStart(span);
    return span;
}
function $98d857b0ebdddd9e$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = $eXvrd.spanTimeInputToSeconds(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $98d857b0ebdddd9e$var$getAcs() {
    const carrier$1 = $6FBPf.getMainCarrier();
    return $1xFq0.getAsyncContextStrategy(carrier$1);
}
function $98d857b0ebdddd9e$var$_startRootSpan(spanArguments, scope, isolationScope, parentSampled) {
    const client = $8DrvK.getClient();
    const options = client?.getOptions() || {};
    const { name: name = "" } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: {
            ...spanArguments.attributes
        },
        spanName: name,
        parentSampled: parentSampled
    };
    client?.emit("beforeSampling", mutableSpanSamplingData, {
        decision: false
    });
    const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const _isTracingSuppressed = $98d857b0ebdddd9e$var$isTracingSuppressed(scope);
    const [sampled, sampleRate, localSampleRateWasApplied] = _isTracingSuppressed ? [
        false
    ] : $5pv9T.sampleSpan(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        normalizedRequest: isolationScope.getScopeData().sdkProcessingMetadata.normalizedRequest,
        parentSampleRate: $ljBvc.parseSampleRate(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new $9pBcX.SentrySpan({
        ...spanArguments,
        attributes: {
            [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "custom",
            [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]: sampleRate !== void 0 && localSampleRateWasApplied ? sampleRate : void 0,
            ...finalAttributes
        },
        sampled: sampled
    });
    if (!sampled && client && !_isTracingSuppressed) {
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.log("[Tracing] Discarding root span because its trace was not chosen to be sampled.");
        client.recordDroppedEvent("sample_rate", $cGnx0.hasSpanStreamingEnabled(client) ? "span" : "transaction");
    }
    $2BI5W.setCapturedScopesOnSpan(rootSpan, scope, isolationScope);
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
function $98d857b0ebdddd9e$var$_startChildSpan(parentSpan, scope, spanArguments, isolationScope) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const _isTracingSuppressed = $98d857b0ebdddd9e$var$isTracingSuppressed(scope);
    const sampled = _isTracingSuppressed ? false : $eXvrd.spanIsSampled(parentSpan);
    const childSpan = sampled ? new $9pBcX.SentrySpan({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new $kJznu.SentryNonRecordingSpan({
        traceId: traceId
    });
    $eXvrd.addChildSpanToSpan(parentSpan, childSpan);
    $2BI5W.setCapturedScopesOnSpan(childSpan, scope, isolationScope);
    const client = $8DrvK.getClient();
    if (!client) return childSpan;
    if ($cGnx0.hasSpanStreamingEnabled(client) && $kJznu.spanIsNonRecordingSpan(childSpan)) {
        if ($kJznu.spanIsNonRecordingSpan(parentSpan) && parentSpan.dropReason) {
            childSpan.dropReason = parentSpan.dropReason;
            client.recordDroppedEvent(parentSpan.dropReason, "span");
        } else if (!_isTracingSuppressed) {
            childSpan.dropReason = "sample_rate";
            client.recordDroppedEvent("sample_rate", "span");
        }
    }
    client.emit("spanStart", childSpan);
    if (spanArguments.endTimestamp) {
        client.emit("spanEnd", childSpan);
        client.emit("afterSpanEnd", childSpan);
    }
    return childSpan;
}
function $98d857b0ebdddd9e$var$getParentSpan(scope, customParentSpan) {
    if (customParentSpan) return customParentSpan;
    if (customParentSpan === null) return void 0;
    const span = $b3Isg._getSpanForScope(scope);
    if (!span) return void 0;
    const client = $8DrvK.getClient();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return $eXvrd.getRootSpan(span);
    return span;
}
function $98d857b0ebdddd9e$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== void 0 ? (callback)=>{
        return $98d857b0ebdddd9e$var$withActiveSpan(parentSpan, callback);
    } : (callback)=>callback();
}
function $98d857b0ebdddd9e$var$_shouldIgnoreStreamedSpan(client, spanArguments) {
    const ignoreSpans = client?.getOptions().ignoreSpans;
    if (!client || !$cGnx0.hasSpanStreamingEnabled(client) || !ignoreSpans?.length) return false;
    return $2aQlx.shouldIgnoreSpan({
        description: spanArguments.name || "",
        op: spanArguments.attributes?.[$dknph.SEMANTIC_ATTRIBUTE_SENTRY_OP] || spanArguments.op,
        attributes: spanArguments.attributes
    }, ignoreSpans);
}
function $98d857b0ebdddd9e$var$spanIsIgnored(span) {
    return $kJznu.spanIsNonRecordingSpan(span) && span.dropReason === "ignored";
}
module.exports.SUPPRESS_TRACING_KEY = $98d857b0ebdddd9e$var$SUPPRESS_TRACING_KEY;
module.exports._INTERNAL_startInactiveSpan = $98d857b0ebdddd9e$var$_INTERNAL_startInactiveSpan;
module.exports.continueTrace = $98d857b0ebdddd9e$var$continueTrace;
module.exports.isTracingSuppressed = $98d857b0ebdddd9e$var$isTracingSuppressed;
module.exports.spanIsIgnored = $98d857b0ebdddd9e$var$spanIsIgnored;
module.exports.startInactiveSpan = $98d857b0ebdddd9e$var$startInactiveSpan;
module.exports.startNewTrace = $98d857b0ebdddd9e$var$startNewTrace;
module.exports.startSpan = $98d857b0ebdddd9e$var$startSpan;
module.exports.startSpanManual = $98d857b0ebdddd9e$var$startSpanManual;
module.exports.suppressTracing = $98d857b0ebdddd9e$var$suppressTracing;
module.exports.withActiveSpan = $98d857b0ebdddd9e$var$withActiveSpan;

});
parcelRegister("ciHXl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kHnXn = parcelRequire("kHnXn");

var $eMfEg = parcelRequire("eMfEg");
function $8f494347e8b2c7d7$var$handleCallbackErrors(fn, onError, onFinally = ()=>{}, onSuccess = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $8f494347e8b2c7d7$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
function $8f494347e8b2c7d7$var$maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ($eMfEg.isThenable(value)) return $kHnXn.chainAndCopyPromiseLike(value, (result)=>{
        onFinally();
        onSuccess(result);
    }, (err)=>{
        onError(err);
        onFinally();
    });
    onFinally();
    onSuccess(value);
    return value;
}
module.exports.handleCallbackErrors = $8f494347e8b2c7d7$var$handleCallbackErrors;

});

parcelRegister("5pv9T", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9Yejo = parcelRequire("9Yejo");

var $1UPRv = parcelRequire("1UPRv");

var $13jPF = parcelRequire("13jPF");

var $ljBvc = parcelRequire("ljBvc");
function $3f0774f8d0cef019$var$sampleSpan(options, samplingContext, sampleRand) {
    if (!$13jPF.hasSpansEnabled(options)) return [
        false
    ];
    let localSampleRateWasApplied = void 0;
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                if (typeof samplingContext.parentSampleRate === "number") return samplingContext.parentSampleRate;
                if (typeof samplingContext.parentSampled === "boolean") return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== void 0) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    const parsedSampleRate = $ljBvc.parseSampleRate(sampleRate);
    if (parsedSampleRate === void 0) {
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    if (!parsedSampleRate) {
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    const shouldSample = sampleRand < parsedSampleRate;
    if (!shouldSample) $9Yejo.DEBUG_BUILD && $1UPRv.debug.log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}
module.exports.sampleSpan = $3f0774f8d0cef019$var$sampleSpan;

});



parcelRegister("l7div", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5lbpt = parcelRequire("5lbpt");

var $5jZZC = parcelRequire("5jZZC");
const $f5f49103142afb61$var$CAPTURED_SPANS = /* @__PURE__ */ new WeakSet();
const $f5f49103142afb61$var$isSpanAlreadyCaptured = (span)=>$f5f49103142afb61$var$CAPTURED_SPANS.has(span);
const $f5f49103142afb61$var$markSpanCaptured = (span)=>{
    $f5f49103142afb61$var$CAPTURED_SPANS.add(span);
};
const $f5f49103142afb61$var$CLIENT_QUEUES = /* @__PURE__ */ new WeakMap();
function $f5f49103142afb61$var$_INTERNAL_setDeferSegmentSpanCapture(client) {
    if (!$5jZZC.getSegmentSpanCaptureStrategy()) $5jZZC.setSegmentSpanCaptureStrategy($f5f49103142afb61$var$deferredSegmentSpanCaptureStrategy);
    if ($f5f49103142afb61$var$CLIENT_QUEUES.has(client)) return;
    const pendingCaptures = /* @__PURE__ */ new Set();
    const debouncedDrain = $5lbpt.debounce(()=>{
        const captures = [
            ...pendingCaptures
        ];
        pendingCaptures.clear();
        for (const capture of captures)capture();
    }, 1, {
        maxWait: 100
    });
    client.on("flush", ()=>{
        debouncedDrain.flush();
    });
    $f5f49103142afb61$var$CLIENT_QUEUES.set(client, (capture)=>{
        pendingCaptures.add(capture);
        debouncedDrain();
    });
}
const $f5f49103142afb61$var$deferredSegmentSpanCaptureStrategy = {
    onSegmentSpanEnded (convert, scope) {
        const client = scope.getClient();
        const enqueue = client && $f5f49103142afb61$var$CLIENT_QUEUES.get(client);
        if (!enqueue) {
            const transactionEvent = convert();
            if (transactionEvent) client?.captureEvent(transactionEvent);
            return;
        }
        enqueue(()=>{
            const transactionEvent = convert({
                isSpanAlreadyCaptured: $f5f49103142afb61$var$isSpanAlreadyCaptured,
                onSpanCaptured: $f5f49103142afb61$var$markSpanCaptured
            });
            if (transactionEvent) client.captureEvent(transactionEvent);
        });
    },
    onChildSpanEnded (span, rootSpan, convert, scope) {
        if ($f5f49103142afb61$var$CAPTURED_SPANS.has(span) || !$f5f49103142afb61$var$CAPTURED_SPANS.has(rootSpan)) return;
        const client = scope.getClient();
        const enqueue = client && $f5f49103142afb61$var$CLIENT_QUEUES.get(client);
        const captureOrphan = ()=>{
            const transactionEvent = convert({
                isSpanAlreadyCaptured: $f5f49103142afb61$var$isSpanAlreadyCaptured,
                onSpanCaptured: $f5f49103142afb61$var$markSpanCaptured
            });
            if (transactionEvent?.contexts?.trace?.data) transactionEvent.contexts.trace.data["sentry.parent_span_already_sent"] = true;
            if (transactionEvent) client?.captureEvent(transactionEvent);
        };
        if (enqueue) enqueue(captureOrphan);
        else captureOrphan();
    }
};
module.exports._INTERNAL_setDeferSegmentSpanCapture = $f5f49103142afb61$var$_INTERNAL_setDeferSegmentSpanCapture;

});
parcelRegister("5lbpt", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $3e37c3a91c9bbe25$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options?.maxWait ? Math.max(options.maxWait, wait) : 0;
    const setTimeoutImpl = options?.setTimeoutImpl || setTimeout;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== void 0 && clearTimeout(timerId);
        maxTimerId !== void 0 && clearTimeout(maxTimerId);
        timerId = maxTimerId = void 0;
    }
    function flush() {
        if (timerId !== void 0 || maxTimerId !== void 0) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeoutImpl(invokeFunc, wait);
        if (maxWait && maxTimerId === void 0) maxTimerId = setTimeoutImpl(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
module.exports.debounce = $3e37c3a91c9bbe25$var$debounce;

});


parcelRegister("hz1oH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8DrvK = parcelRequire("8DrvK");
const $cc96ca1105f1d33d$var$ADD_LISTENER_METHODS = [
    "addListener",
    "on",
    "once",
    "prependListener",
    "prependOnceListener",
    "addEventListener"
];
const $cc96ca1105f1d33d$var$REMOVE_LISTENER_METHODS = [
    "removeListener",
    "off",
    "removeEventListener"
];
const $cc96ca1105f1d33d$var$SCOPE_BOUND_LISTENERS = /* @__PURE__ */ Symbol("SentryScopeBoundListeners");
let $cc96ca1105f1d33d$var$registeringWrapper;
function $cc96ca1105f1d33d$var$isReentrantWrapperRegistration(listener) {
    return $cc96ca1105f1d33d$var$registeringWrapper !== void 0 && (listener === $cc96ca1105f1d33d$var$registeringWrapper || listener.listener === $cc96ca1105f1d33d$var$registeringWrapper);
}
function $cc96ca1105f1d33d$var$bindScopeToEmitter(emitter, scope = $8DrvK.getCurrentScope()) {
    const ee = emitter;
    if ($cc96ca1105f1d33d$var$getPatchMap(ee)) return emitter;
    $cc96ca1105f1d33d$var$createPatchMap(ee);
    for (const methodName of $cc96ca1105f1d33d$var$ADD_LISTENER_METHODS){
        if (typeof ee[methodName] !== "function") continue;
        ee[methodName] = $cc96ca1105f1d33d$var$patchAddListener(ee, ee[methodName], scope);
    }
    for (const methodName of $cc96ca1105f1d33d$var$REMOVE_LISTENER_METHODS){
        if (typeof ee[methodName] !== "function") continue;
        ee[methodName] = $cc96ca1105f1d33d$var$patchRemoveListener(ee, ee[methodName]);
    }
    if (typeof ee.removeAllListeners === "function") ee.removeAllListeners = $cc96ca1105f1d33d$var$patchRemoveAllListeners(ee, ee.removeAllListeners);
    return emitter;
}
function $cc96ca1105f1d33d$var$bindListenerToScope(listener, scope) {
    return function(...args) {
        return $8DrvK.withScope(scope, ()=>listener.apply(this, args));
    };
}
function $cc96ca1105f1d33d$var$isBoundListener(listener) {
    return typeof listener === "function";
}
function $cc96ca1105f1d33d$var$patchAddListener(ee, original, scope) {
    return function(...args) {
        const event = args[0];
        const listener = args[1];
        const rest = args.slice(2);
        if (!$cc96ca1105f1d33d$var$isBoundListener(listener) || $cc96ca1105f1d33d$var$isReentrantWrapperRegistration(listener)) return original.apply(this, args);
        const map = $cc96ca1105f1d33d$var$getPatchMap(ee) || $cc96ca1105f1d33d$var$createPatchMap(ee);
        let listeners = map.get(event);
        if (!listeners) {
            listeners = /* @__PURE__ */ new WeakMap();
            map.set(event, listeners);
        }
        let boundListener = listeners.get(listener);
        if (!boundListener) {
            boundListener = $cc96ca1105f1d33d$var$bindListenerToScope(listener, scope);
            listeners.set(listener, boundListener);
        }
        const previous = $cc96ca1105f1d33d$var$registeringWrapper;
        $cc96ca1105f1d33d$var$registeringWrapper = boundListener;
        try {
            return original.call(this, event, boundListener, ...rest);
        } finally{
            $cc96ca1105f1d33d$var$registeringWrapper = previous;
        }
    };
}
function $cc96ca1105f1d33d$var$patchRemoveListener(ee, original) {
    return function(...args) {
        const event = args[0];
        const listener = args[1];
        const rest = args.slice(2);
        const boundListener = $cc96ca1105f1d33d$var$isBoundListener(listener) ? $cc96ca1105f1d33d$var$getPatchMap(ee)?.get(event)?.get(listener) : void 0;
        if (!boundListener) return original.apply(this, args);
        return original.call(this, event, boundListener, ...rest);
    };
}
function $cc96ca1105f1d33d$var$patchRemoveAllListeners(ee, original) {
    return function(...args) {
        const map = $cc96ca1105f1d33d$var$getPatchMap(ee);
        if (map) {
            if (args.length === 0) $cc96ca1105f1d33d$var$createPatchMap(ee);
            else {
                const event = args[0];
                map.delete(event);
            }
        }
        return original.apply(this, args);
    };
}
function $cc96ca1105f1d33d$var$createPatchMap(ee) {
    const map = /* @__PURE__ */ new Map();
    ee[$cc96ca1105f1d33d$var$SCOPE_BOUND_LISTENERS] = map;
    return map;
}
function $cc96ca1105f1d33d$var$getPatchMap(ee) {
    return ee[$cc96ca1105f1d33d$var$SCOPE_BOUND_LISTENERS];
}
module.exports.bindScopeToEmitter = $cc96ca1105f1d33d$var$bindScopeToEmitter;

});

parcelRegister("3rSi0", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dknph = parcelRequire("dknph");

var $cXaTJ = parcelRequire("cXaTJ");

var $eXvrd = parcelRequire("eXvrd");

var $2BI5W = parcelRequire("2BI5W");

var $5ob0u = parcelRequire("5ob0u");

var $9c11O = parcelRequire("9c11O");

var $jf5XH = parcelRequire("jf5XH");

var $iuxoj = parcelRequire("iuxoj");
function $282e01763a09d0e0$var$captureSpan(span, client) {
    const spanJSON = $eXvrd.spanToStreamedSpanJSON(span);
    const segmentSpan = $eXvrd.INTERNAL_getSegmentSpan(span);
    const serializedSegmentSpan = $eXvrd.spanToStreamedSpanJSON(segmentSpan);
    const { isolationScope: spanIsolationScope, scope: spanScope } = $2BI5W.getCapturedScopesOnSpan(span);
    const finalScopeData = $cXaTJ.getCombinedScopeData(spanIsolationScope, spanScope);
    $282e01763a09d0e0$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, finalScopeData);
    const spanKind = span.kind;
    client.emit("preprocessSpan", spanJSON, {
        spanKind: spanKind
    });
    if (spanJSON.is_segment) {
        $282e01763a09d0e0$var$applyScopeToSegmentSpan(spanJSON, finalScopeData);
        $282e01763a09d0e0$var$applySdkMetadataToSegmentSpan(spanJSON, client);
        client.emit("processSegmentSpan", spanJSON);
    }
    client.emit("processSpan", spanJSON);
    const { beforeSendSpan: beforeSendSpan$1 } = client.getOptions();
    const processedSpan = beforeSendSpan$1 && $5ob0u.isStreamedBeforeSendSpanCallback(beforeSendSpan$1) ? $282e01763a09d0e0$var$applyBeforeSendSpanCallback(spanJSON, beforeSendSpan$1) : spanJSON;
    const spanNameSource = processedSpan.attributes?.[$dknph.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    if (spanJSON.is_segment && spanNameSource) $282e01763a09d0e0$var$safeSetSpanJSONAttributes(processedSpan, {
        ["sentry.segment.name.source"]: spanNameSource
    });
    return {
        ...$eXvrd.streamedSpanJsonToSerializedSpan(processedSpan),
        _segmentSpan: segmentSpan
    };
}
function $282e01763a09d0e0$var$applyScopeToSegmentSpan(segmentSpanJSON, scopeData) {
    const contextAttributes = $9c11O.scopeContextsToSpanAttributes(scopeData.contexts);
    $282e01763a09d0e0$var$safeSetSpanJSONAttributes(segmentSpanJSON, contextAttributes);
}
function $282e01763a09d0e0$var$safeSetSpanJSONAttributes(spanJSON, newAttributes) {
    const originalAttributes = spanJSON.attributes ?? (spanJSON.attributes = {});
    Object.entries(newAttributes).forEach(([key, value])=>{
        if (value != null && !(key in originalAttributes)) originalAttributes[key] = value;
    });
}
function $282e01763a09d0e0$var$applySdkMetadataToSegmentSpan(segmentSpanJSON, client) {
    const integrationNames = client.getIntegrationNames();
    if (!integrationNames.length) return;
    $282e01763a09d0e0$var$safeSetSpanJSONAttributes(segmentSpanJSON, {
        [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS]: integrationNames
    });
}
function $282e01763a09d0e0$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, scopeData) {
    const sdk = client.getSdkMetadata();
    const { release: release, environment: environment } = client.getOptions();
    $282e01763a09d0e0$var$safeSetSpanJSONAttributes(spanJSON, {
        [$iuxoj.SENTRY_TRACE_LIFECYCLE]: "stream",
        [$iuxoj.SENTRY_SEGMENT_NAME]: serializedSegmentSpan.name,
        [$iuxoj.SENTRY_SEGMENT_ID]: serializedSegmentSpan.span_id,
        [$iuxoj.SENTRY_SDK_NAME]: sdk?.sdk?.name,
        [$iuxoj.SENTRY_SDK_VERSION]: sdk?.sdk?.version,
        [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE]: release,
        [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT]: environment || $jf5XH.DEFAULT_ENVIRONMENT,
        [$dknph.SEMANTIC_ATTRIBUTE_USER_ID]: scopeData.user?.id,
        [$dknph.SEMANTIC_ATTRIBUTE_USER_EMAIL]: scopeData.user?.email,
        [$dknph.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS]: scopeData.user?.ip_address,
        [$dknph.SEMANTIC_ATTRIBUTE_USER_USERNAME]: scopeData.user?.username,
        ...scopeData.attributes
    });
}
function $282e01763a09d0e0$var$applyBeforeSendSpanCallback(span, beforeSendSpan) {
    const modifedSpan = beforeSendSpan(span);
    if (!modifedSpan) {
        $eXvrd.showSpanDropWarning();
        return span;
    }
    return modifedSpan;
}
module.exports.applyBeforeSendSpanCallback = $282e01763a09d0e0$var$applyBeforeSendSpanCallback;
module.exports.captureSpan = $282e01763a09d0e0$var$captureSpan;
module.exports.safeSetSpanJSONAttributes = $282e01763a09d0e0$var$safeSetSpanJSONAttributes;

});
parcelRegister("cXaTJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8DrvK = parcelRequire("8DrvK");

var $boK9h = parcelRequire("boK9h");

var $abhMj = parcelRequire("abhMj");

var $eXvrd = parcelRequire("eXvrd");
function $96e372d5c9052d8f$var$applyScopeDataToEvent(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    $96e372d5c9052d8f$var$applyDataToEvent(event, data);
    if (span) $96e372d5c9052d8f$var$applySpanToEvent(event, span);
    $96e372d5c9052d8f$var$applyFingerprintToEvent(event, fingerprint);
    $96e372d5c9052d8f$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $96e372d5c9052d8f$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
function $96e372d5c9052d8f$var$mergeScopeData(data, mergeData) {
    const { extra: extra, tags: tags, attributes: attributes, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $96e372d5c9052d8f$var$mergeAndOverwriteScopeData(data, "extra", extra);
    $96e372d5c9052d8f$var$mergeAndOverwriteScopeData(data, "tags", tags);
    $96e372d5c9052d8f$var$mergeAndOverwriteScopeData(data, "attributes", attributes);
    $96e372d5c9052d8f$var$mergeAndOverwriteScopeData(data, "user", user);
    $96e372d5c9052d8f$var$mergeAndOverwriteScopeData(data, "contexts", contexts);
    data.sdkProcessingMetadata = $abhMj.merge(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
function $96e372d5c9052d8f$var$mergeAndOverwriteScopeData(data, prop, mergeVal) {
    data[prop] = $abhMj.merge(data[prop], mergeVal, 1);
}
function $96e372d5c9052d8f$var$getCombinedScopeData(isolationScope, currentScope) {
    const scopeData = $8DrvK.getGlobalScope().getScopeData();
    isolationScope && $96e372d5c9052d8f$var$mergeScopeData(scopeData, isolationScope.getScopeData());
    currentScope && $96e372d5c9052d8f$var$mergeScopeData(scopeData, currentScope.getScopeData());
    return scopeData;
}
function $96e372d5c9052d8f$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function $96e372d5c9052d8f$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : void 0;
}
function $96e372d5c9052d8f$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $96e372d5c9052d8f$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: $eXvrd.spanToTraceContext(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: $boK9h.getDynamicSamplingContextFromSpan(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = $eXvrd.getRootSpan(span);
    const transactionName = $eXvrd.spanToJSON(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
function $96e372d5c9052d8f$var$applyFingerprintToEvent(event, fingerprint) {
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    if (!event.fingerprint.length) delete event.fingerprint;
}
module.exports.applyScopeDataToEvent = $96e372d5c9052d8f$var$applyScopeDataToEvent;
module.exports.getCombinedScopeData = $96e372d5c9052d8f$var$getCombinedScopeData;
module.exports.mergeAndOverwriteScopeData = $96e372d5c9052d8f$var$mergeAndOverwriteScopeData;
module.exports.mergeScopeData = $96e372d5c9052d8f$var$mergeScopeData;

});

parcelRegister("9c11O", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $6b160839b0c7b221$var$scopeContextsToSpanAttributes(contexts) {
    const attrs = {};
    const { response: response, profile: profile, cloud_resource: cloud_resource, culture: culture, state: state } = contexts;
    if (response) {
        if (response.status_code != null) attrs["http.response.status_code"] = response.status_code;
        if (response.body_size != null) attrs["http.response.body.size"] = response.body_size;
    }
    if (profile) {
        if (profile.profile_id) attrs["sentry.profile_id"] = profile.profile_id;
        if (profile.profiler_id) attrs["sentry.profiler_id"] = profile.profiler_id;
    }
    if (cloud_resource) {
        for (const [key, value] of Object.entries(cloud_resource))if (value != null) attrs[key] = value;
    }
    if (culture) {
        if (culture.locale) attrs["culture.locale"] = culture.locale;
        if (culture.timezone) attrs["culture.timezone"] = culture.timezone;
    }
    if (state?.state && typeof state.state.type === "string") attrs["state.type"] = state.state.type;
    const angular = contexts["angular"];
    if (angular) {
        const version = angular["version"];
        if (typeof version === "string" || typeof version === "number") attrs["angular.version"] = version;
    }
    const react = contexts["react"];
    if (react) {
        const version = react["version"];
        if (typeof version === "string" || typeof version === "number") attrs["react.version"] = version;
    }
    return attrs;
}
module.exports.scopeContextsToSpanAttributes = $6b160839b0c7b221$var$scopeContextsToSpanAttributes;

});

parcelRegister("iuxoj", function(module, exports) {
// This file is a compatibility shim for bundlers (e.g. webpack 4) that do not
// support the package.json `exports` field for resolving subpath exports.

module.exports = (parcelRequire("ijhKs"));

});
parcelRegister("ijhKs", function(module, exports) {

$parcel$export(module.exports, "AI_CITATIONS", () => $c97e36c8d40a3851$export$b60c5e9f9b7b58bd, (v) => $c97e36c8d40a3851$export$b60c5e9f9b7b58bd = v);
$parcel$export(module.exports, "AI_COMPLETION_TOKENS_USED", () => $c97e36c8d40a3851$export$cc06afd6de7f2c10, (v) => $c97e36c8d40a3851$export$cc06afd6de7f2c10 = v);
$parcel$export(module.exports, "AI_DOCUMENTS", () => $c97e36c8d40a3851$export$ced6746028fe2cc, (v) => $c97e36c8d40a3851$export$ced6746028fe2cc = v);
$parcel$export(module.exports, "AI_FINISH_REASON", () => $c97e36c8d40a3851$export$e6f4aa4f4fcb6da8, (v) => $c97e36c8d40a3851$export$e6f4aa4f4fcb6da8 = v);
$parcel$export(module.exports, "AI_FREQUENCY_PENALTY", () => $c97e36c8d40a3851$export$f02d892201cd8d36, (v) => $c97e36c8d40a3851$export$f02d892201cd8d36 = v);
$parcel$export(module.exports, "AI_FUNCTION_CALL", () => $c97e36c8d40a3851$export$f277a7ef9e273960, (v) => $c97e36c8d40a3851$export$f277a7ef9e273960 = v);
$parcel$export(module.exports, "AI_GENERATION_ID", () => $c97e36c8d40a3851$export$1a8c212c3becaa80, (v) => $c97e36c8d40a3851$export$1a8c212c3becaa80 = v);
$parcel$export(module.exports, "AI_INPUT_MESSAGES", () => $c97e36c8d40a3851$export$721b137086c68a47, (v) => $c97e36c8d40a3851$export$721b137086c68a47 = v);
$parcel$export(module.exports, "AI_IS_SEARCH_REQUIRED", () => $c97e36c8d40a3851$export$6afde2bb69d9aa86, (v) => $c97e36c8d40a3851$export$6afde2bb69d9aa86 = v);
$parcel$export(module.exports, "AI_METADATA", () => $c97e36c8d40a3851$export$eadb4b562c974031, (v) => $c97e36c8d40a3851$export$eadb4b562c974031 = v);
$parcel$export(module.exports, "AI_MODEL_ID", () => $c97e36c8d40a3851$export$22a90f0ac1eee843, (v) => $c97e36c8d40a3851$export$22a90f0ac1eee843 = v);
$parcel$export(module.exports, "AI_MODEL_PROVIDER", () => $c97e36c8d40a3851$export$a727f215a0be1dad, (v) => $c97e36c8d40a3851$export$a727f215a0be1dad = v);
$parcel$export(module.exports, "AI_PIPELINE_NAME", () => $c97e36c8d40a3851$export$536bc61b34d995e5, (v) => $c97e36c8d40a3851$export$536bc61b34d995e5 = v);
$parcel$export(module.exports, "AI_PREAMBLE", () => $c97e36c8d40a3851$export$c43ea6115b380e62, (v) => $c97e36c8d40a3851$export$c43ea6115b380e62 = v);
$parcel$export(module.exports, "AI_PRESENCE_PENALTY", () => $c97e36c8d40a3851$export$d2a16e26bada7cf1, (v) => $c97e36c8d40a3851$export$d2a16e26bada7cf1 = v);
$parcel$export(module.exports, "AI_PROMPT_TOKENS_USED", () => $c97e36c8d40a3851$export$604eb1bd2278163b, (v) => $c97e36c8d40a3851$export$604eb1bd2278163b = v);
$parcel$export(module.exports, "AI_RAW_PROMPTING", () => $c97e36c8d40a3851$export$2f8568696c5aa352, (v) => $c97e36c8d40a3851$export$2f8568696c5aa352 = v);
$parcel$export(module.exports, "AI_RESPONSES", () => $c97e36c8d40a3851$export$ccc8efd7dd31d3a9, (v) => $c97e36c8d40a3851$export$ccc8efd7dd31d3a9 = v);
$parcel$export(module.exports, "AI_RESPONSE_FORMAT", () => $c97e36c8d40a3851$export$e176bf5dc45e40df, (v) => $c97e36c8d40a3851$export$e176bf5dc45e40df = v);
$parcel$export(module.exports, "AI_SEARCH_QUERIES", () => $c97e36c8d40a3851$export$c4ea01fd53f64e16, (v) => $c97e36c8d40a3851$export$c4ea01fd53f64e16 = v);
$parcel$export(module.exports, "AI_SEARCH_RESULTS", () => $c97e36c8d40a3851$export$bb5e6f2f31a15da9, (v) => $c97e36c8d40a3851$export$bb5e6f2f31a15da9 = v);
$parcel$export(module.exports, "AI_SEED", () => $c97e36c8d40a3851$export$1762c11b666b026a, (v) => $c97e36c8d40a3851$export$1762c11b666b026a = v);
$parcel$export(module.exports, "AI_STREAMING", () => $c97e36c8d40a3851$export$14ddd4b729910100, (v) => $c97e36c8d40a3851$export$14ddd4b729910100 = v);
$parcel$export(module.exports, "AI_TAGS", () => $c97e36c8d40a3851$export$5311d7c8e1f8eabb, (v) => $c97e36c8d40a3851$export$5311d7c8e1f8eabb = v);
$parcel$export(module.exports, "AI_TEMPERATURE", () => $c97e36c8d40a3851$export$2b748b9eca00828b, (v) => $c97e36c8d40a3851$export$2b748b9eca00828b = v);
$parcel$export(module.exports, "AI_TEXTS", () => $c97e36c8d40a3851$export$5af25308c11addea, (v) => $c97e36c8d40a3851$export$5af25308c11addea = v);
$parcel$export(module.exports, "AI_TOOLS", () => $c97e36c8d40a3851$export$28f78b3b1663cb92, (v) => $c97e36c8d40a3851$export$28f78b3b1663cb92 = v);
$parcel$export(module.exports, "AI_TOOL_CALLS", () => $c97e36c8d40a3851$export$a1d3f09f0f1f066f, (v) => $c97e36c8d40a3851$export$a1d3f09f0f1f066f = v);
$parcel$export(module.exports, "AI_TOP_K", () => $c97e36c8d40a3851$export$322bd4ea9f163663, (v) => $c97e36c8d40a3851$export$322bd4ea9f163663 = v);
$parcel$export(module.exports, "AI_TOP_P", () => $c97e36c8d40a3851$export$95711b9e669edad8, (v) => $c97e36c8d40a3851$export$95711b9e669edad8 = v);
$parcel$export(module.exports, "AI_TOTAL_COST", () => $c97e36c8d40a3851$export$5924d7d72384626a, (v) => $c97e36c8d40a3851$export$5924d7d72384626a = v);
$parcel$export(module.exports, "AI_TOTAL_TOKENS_USED", () => $c97e36c8d40a3851$export$db3b1b877a4ce4db, (v) => $c97e36c8d40a3851$export$db3b1b877a4ce4db = v);
$parcel$export(module.exports, "AI_WARNINGS", () => $c97e36c8d40a3851$export$a434a3e8afec2879, (v) => $c97e36c8d40a3851$export$a434a3e8afec2879 = v);
$parcel$export(module.exports, "ANGULAR_VERSION", () => $c97e36c8d40a3851$export$fe00bb20636d42af, (v) => $c97e36c8d40a3851$export$fe00bb20636d42af = v);
$parcel$export(module.exports, "APP_APP_BUILD", () => $c97e36c8d40a3851$export$712aa698b7ee271e, (v) => $c97e36c8d40a3851$export$712aa698b7ee271e = v);
$parcel$export(module.exports, "APP_APP_IDENTIFIER", () => $c97e36c8d40a3851$export$1fac638b11ec16d9, (v) => $c97e36c8d40a3851$export$1fac638b11ec16d9 = v);
$parcel$export(module.exports, "APP_APP_NAME", () => $c97e36c8d40a3851$export$d132016ea64058e3, (v) => $c97e36c8d40a3851$export$d132016ea64058e3 = v);
$parcel$export(module.exports, "APP_APP_START_TIME", () => $c97e36c8d40a3851$export$53f2f47ec3b2f9ed, (v) => $c97e36c8d40a3851$export$53f2f47ec3b2f9ed = v);
$parcel$export(module.exports, "APP_APP_VERSION", () => $c97e36c8d40a3851$export$9f80c4b11053cef1, (v) => $c97e36c8d40a3851$export$9f80c4b11053cef1 = v);
$parcel$export(module.exports, "APP_BUILD", () => $c97e36c8d40a3851$export$5f7a08466d84e877, (v) => $c97e36c8d40a3851$export$5f7a08466d84e877 = v);
$parcel$export(module.exports, "APP_IDENTIFIER", () => $c97e36c8d40a3851$export$2cea7f14750b8c19, (v) => $c97e36c8d40a3851$export$2cea7f14750b8c19 = v);
$parcel$export(module.exports, "APP_IN_FOREGROUND", () => $c97e36c8d40a3851$export$34c59270f032a6c6, (v) => $c97e36c8d40a3851$export$34c59270f032a6c6 = v);
$parcel$export(module.exports, "APP_NAME", () => $c97e36c8d40a3851$export$5b6c28c7dca07ad7, (v) => $c97e36c8d40a3851$export$5b6c28c7dca07ad7 = v);
$parcel$export(module.exports, "APP_START_COLD", () => $c97e36c8d40a3851$export$1dc8ae58b58d6c50, (v) => $c97e36c8d40a3851$export$1dc8ae58b58d6c50 = v);
$parcel$export(module.exports, "APP_START_TIME", () => $c97e36c8d40a3851$export$ba267414e3c0d822, (v) => $c97e36c8d40a3851$export$ba267414e3c0d822 = v);
$parcel$export(module.exports, "APP_START_TYPE", () => $c97e36c8d40a3851$export$71b176005902b99e, (v) => $c97e36c8d40a3851$export$71b176005902b99e = v);
$parcel$export(module.exports, "APP_START_WARM", () => $c97e36c8d40a3851$export$5c5b5a3c245a0079, (v) => $c97e36c8d40a3851$export$5c5b5a3c245a0079 = v);
$parcel$export(module.exports, "APP_VERSION", () => $c97e36c8d40a3851$export$8ee1df3c6367a60, (v) => $c97e36c8d40a3851$export$8ee1df3c6367a60 = v);
$parcel$export(module.exports, "APP_VITALS_FRAMES_DELAY_VALUE", () => $c97e36c8d40a3851$export$e8c7802ae95beccf, (v) => $c97e36c8d40a3851$export$e8c7802ae95beccf = v);
$parcel$export(module.exports, "APP_VITALS_FRAMES_FROZEN_COUNT", () => $c97e36c8d40a3851$export$bb237734da4d464, (v) => $c97e36c8d40a3851$export$bb237734da4d464 = v);
$parcel$export(module.exports, "APP_VITALS_FRAMES_SLOW_COUNT", () => $c97e36c8d40a3851$export$cdaaf6d1fdcba0b6, (v) => $c97e36c8d40a3851$export$cdaaf6d1fdcba0b6 = v);
$parcel$export(module.exports, "APP_VITALS_FRAMES_TOTAL_COUNT", () => $c97e36c8d40a3851$export$36223ebd4a30e9f5, (v) => $c97e36c8d40a3851$export$36223ebd4a30e9f5 = v);
$parcel$export(module.exports, "APP_VITALS_START_COLD_VALUE", () => $c97e36c8d40a3851$export$8feaa177bb7941e2, (v) => $c97e36c8d40a3851$export$8feaa177bb7941e2 = v);
$parcel$export(module.exports, "APP_VITALS_START_PREWARMED", () => $c97e36c8d40a3851$export$e1ca25240db91d68, (v) => $c97e36c8d40a3851$export$e1ca25240db91d68 = v);
$parcel$export(module.exports, "APP_VITALS_START_REASON", () => $c97e36c8d40a3851$export$404a223fd1ada08b, (v) => $c97e36c8d40a3851$export$404a223fd1ada08b = v);
$parcel$export(module.exports, "APP_VITALS_START_SCREEN", () => $c97e36c8d40a3851$export$53362079310c68, (v) => $c97e36c8d40a3851$export$53362079310c68 = v);
$parcel$export(module.exports, "APP_VITALS_START_TYPE", () => $c97e36c8d40a3851$export$3efb5af0ac379f77, (v) => $c97e36c8d40a3851$export$3efb5af0ac379f77 = v);
$parcel$export(module.exports, "APP_VITALS_START_WARM_VALUE", () => $c97e36c8d40a3851$export$2c10c1ca0612c46d, (v) => $c97e36c8d40a3851$export$2c10c1ca0612c46d = v);
$parcel$export(module.exports, "APP_VITALS_TTFD_VALUE", () => $c97e36c8d40a3851$export$bbb86ad4d6654da6, (v) => $c97e36c8d40a3851$export$bbb86ad4d6654da6 = v);
$parcel$export(module.exports, "APP_VITALS_TTID_VALUE", () => $c97e36c8d40a3851$export$ad6896f00a2b1076, (v) => $c97e36c8d40a3851$export$ad6896f00a2b1076 = v);
$parcel$export(module.exports, "ART_GC_BLOCKING_COUNT", () => $c97e36c8d40a3851$export$300f39d8506a273d, (v) => $c97e36c8d40a3851$export$300f39d8506a273d = v);
$parcel$export(module.exports, "ART_GC_BLOCKING_TIME", () => $c97e36c8d40a3851$export$ecaa0e7f4773ddc7, (v) => $c97e36c8d40a3851$export$ecaa0e7f4773ddc7 = v);
$parcel$export(module.exports, "ART_GC_PRE_OOME_COUNT", () => $c97e36c8d40a3851$export$74b78acb4c54c06b, (v) => $c97e36c8d40a3851$export$74b78acb4c54c06b = v);
$parcel$export(module.exports, "ART_GC_TOTAL_COUNT", () => $c97e36c8d40a3851$export$b15b2c133bc50e33, (v) => $c97e36c8d40a3851$export$b15b2c133bc50e33 = v);
$parcel$export(module.exports, "ART_GC_TOTAL_TIME", () => $c97e36c8d40a3851$export$5f1381d9ae1b1c95, (v) => $c97e36c8d40a3851$export$5f1381d9ae1b1c95 = v);
$parcel$export(module.exports, "ART_GC_WAITING_TIME", () => $c97e36c8d40a3851$export$c170b7ff277132ea, (v) => $c97e36c8d40a3851$export$c170b7ff277132ea = v);
$parcel$export(module.exports, "ART_MEMORY_FREE", () => $c97e36c8d40a3851$export$9459a5df93695e45, (v) => $c97e36c8d40a3851$export$9459a5df93695e45 = v);
$parcel$export(module.exports, "ART_MEMORY_FREE_UNTIL_GC", () => $c97e36c8d40a3851$export$a7902bd57492ebe8, (v) => $c97e36c8d40a3851$export$a7902bd57492ebe8 = v);
$parcel$export(module.exports, "ART_MEMORY_FREE_UNTIL_OOME", () => $c97e36c8d40a3851$export$d2ace0da59da09b7, (v) => $c97e36c8d40a3851$export$d2ace0da59da09b7 = v);
$parcel$export(module.exports, "ART_MEMORY_MAX", () => $c97e36c8d40a3851$export$c15dd8d2461e0aeb, (v) => $c97e36c8d40a3851$export$c15dd8d2461e0aeb = v);
$parcel$export(module.exports, "ART_MEMORY_TOTAL", () => $c97e36c8d40a3851$export$5405b0a98e00e538, (v) => $c97e36c8d40a3851$export$5405b0a98e00e538 = v);
$parcel$export(module.exports, "ATTRIBUTE_METADATA", () => $c97e36c8d40a3851$export$bd393bbb84b309d3, (v) => $c97e36c8d40a3851$export$bd393bbb84b309d3 = v);
$parcel$export(module.exports, "ATTRIBUTE_TYPE", () => $c97e36c8d40a3851$export$96f586f8837b86ae, (v) => $c97e36c8d40a3851$export$96f586f8837b86ae = v);
$parcel$export(module.exports, "AWS_CLOUDWATCH_LOGS_LOG_GROUP", () => $c97e36c8d40a3851$export$5d9f28f388f552d2, (v) => $c97e36c8d40a3851$export$5d9f28f388f552d2 = v);
$parcel$export(module.exports, "AWS_CLOUDWATCH_LOGS_LOG_STREAM", () => $c97e36c8d40a3851$export$b3d2f68e0e769504, (v) => $c97e36c8d40a3851$export$b3d2f68e0e769504 = v);
$parcel$export(module.exports, "AWS_CLOUDWATCH_LOGS_URL", () => $c97e36c8d40a3851$export$2c98412ed43013e8, (v) => $c97e36c8d40a3851$export$2c98412ed43013e8 = v);
$parcel$export(module.exports, "AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS", () => $c97e36c8d40a3851$export$a7bd794d11c19f1b, (v) => $c97e36c8d40a3851$export$a7bd794d11c19f1b = v);
$parcel$export(module.exports, "AWS_DYNAMODB_CONSISTENT_READ", () => $c97e36c8d40a3851$export$df4227832b83fdd0, (v) => $c97e36c8d40a3851$export$df4227832b83fdd0 = v);
$parcel$export(module.exports, "AWS_DYNAMODB_CONSUMED_CAPACITY", () => $c97e36c8d40a3851$export$f131a6d8fbc0534f, (v) => $c97e36c8d40a3851$export$f131a6d8fbc0534f = v);
$parcel$export(module.exports, "AWS_DYNAMODB_COUNT", () => $c97e36c8d40a3851$export$9bdc66d4a70e7e3a, (v) => $c97e36c8d40a3851$export$9bdc66d4a70e7e3a = v);
$parcel$export(module.exports, "AWS_DYNAMODB_EXCLUSIVE_START_TABLE", () => $c97e36c8d40a3851$export$bfbbc3cbcaa90e98, (v) => $c97e36c8d40a3851$export$bfbbc3cbcaa90e98 = v);
$parcel$export(module.exports, "AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES", () => $c97e36c8d40a3851$export$3565fa72459aa4d6, (v) => $c97e36c8d40a3851$export$3565fa72459aa4d6 = v);
$parcel$export(module.exports, "AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES", () => $c97e36c8d40a3851$export$bb67a834ae4bffdc, (v) => $c97e36c8d40a3851$export$bb67a834ae4bffdc = v);
$parcel$export(module.exports, "AWS_DYNAMODB_INDEX_NAME", () => $c97e36c8d40a3851$export$4a06c859a283f06, (v) => $c97e36c8d40a3851$export$4a06c859a283f06 = v);
$parcel$export(module.exports, "AWS_DYNAMODB_ITEM_COLLECTION_METRICS", () => $c97e36c8d40a3851$export$68324fac2038d0f2, (v) => $c97e36c8d40a3851$export$68324fac2038d0f2 = v);
$parcel$export(module.exports, "AWS_DYNAMODB_LIMIT", () => $c97e36c8d40a3851$export$5e1bd62ffd2786fb, (v) => $c97e36c8d40a3851$export$5e1bd62ffd2786fb = v);
$parcel$export(module.exports, "AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES", () => $c97e36c8d40a3851$export$bfdf2261058f56b, (v) => $c97e36c8d40a3851$export$bfdf2261058f56b = v);
$parcel$export(module.exports, "AWS_DYNAMODB_PROJECTION", () => $c97e36c8d40a3851$export$23bf57842d9d53df, (v) => $c97e36c8d40a3851$export$23bf57842d9d53df = v);
$parcel$export(module.exports, "AWS_DYNAMODB_PROVISIONED_READ_CAPACITY", () => $c97e36c8d40a3851$export$bfbd7e060eeb4d35, (v) => $c97e36c8d40a3851$export$bfbd7e060eeb4d35 = v);
$parcel$export(module.exports, "AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY", () => $c97e36c8d40a3851$export$82eb6cccda27c3ff, (v) => $c97e36c8d40a3851$export$82eb6cccda27c3ff = v);
$parcel$export(module.exports, "AWS_DYNAMODB_SCANNED_COUNT", () => $c97e36c8d40a3851$export$8ea68734d455808f, (v) => $c97e36c8d40a3851$export$8ea68734d455808f = v);
$parcel$export(module.exports, "AWS_DYNAMODB_SCAN_FORWARD", () => $c97e36c8d40a3851$export$40050e29324d44ee, (v) => $c97e36c8d40a3851$export$40050e29324d44ee = v);
$parcel$export(module.exports, "AWS_DYNAMODB_SEGMENT", () => $c97e36c8d40a3851$export$5cd7541006d9f467, (v) => $c97e36c8d40a3851$export$5cd7541006d9f467 = v);
$parcel$export(module.exports, "AWS_DYNAMODB_SELECT", () => $c97e36c8d40a3851$export$81c017edd95d692e, (v) => $c97e36c8d40a3851$export$81c017edd95d692e = v);
$parcel$export(module.exports, "AWS_DYNAMODB_TABLE_COUNT", () => $c97e36c8d40a3851$export$120b3897a58cf903, (v) => $c97e36c8d40a3851$export$120b3897a58cf903 = v);
$parcel$export(module.exports, "AWS_DYNAMODB_TABLE_NAMES", () => $c97e36c8d40a3851$export$d4a9de43b4b1076c, (v) => $c97e36c8d40a3851$export$d4a9de43b4b1076c = v);
$parcel$export(module.exports, "AWS_DYNAMODB_TOTAL_SEGMENTS", () => $c97e36c8d40a3851$export$f37f4f9022f1ab17, (v) => $c97e36c8d40a3851$export$f37f4f9022f1ab17 = v);
$parcel$export(module.exports, "AWS_EXTENDED_REQUEST_ID", () => $c97e36c8d40a3851$export$66ac18da14747cfb, (v) => $c97e36c8d40a3851$export$66ac18da14747cfb = v);
$parcel$export(module.exports, "AWS_KINESIS_STREAM_NAME", () => $c97e36c8d40a3851$export$9e49b833525ca49d, (v) => $c97e36c8d40a3851$export$9e49b833525ca49d = v);
$parcel$export(module.exports, "AWS_LAMBDA_AWS_REQUEST_ID", () => $c97e36c8d40a3851$export$b084fea5b3097227, (v) => $c97e36c8d40a3851$export$b084fea5b3097227 = v);
$parcel$export(module.exports, "AWS_LAMBDA_EXECUTION_DURATION_IN_MILLIS", () => $c97e36c8d40a3851$export$e09cd8615652e8d0, (v) => $c97e36c8d40a3851$export$e09cd8615652e8d0 = v);
$parcel$export(module.exports, "AWS_LAMBDA_FUNCTION_NAME", () => $c97e36c8d40a3851$export$a43a60ec723a90ee, (v) => $c97e36c8d40a3851$export$a43a60ec723a90ee = v);
$parcel$export(module.exports, "AWS_LAMBDA_FUNCTION_VERSION", () => $c97e36c8d40a3851$export$34cc955357266287, (v) => $c97e36c8d40a3851$export$34cc955357266287 = v);
$parcel$export(module.exports, "AWS_LAMBDA_INVOKED_ARN", () => $c97e36c8d40a3851$export$d9dd218693ea9bba, (v) => $c97e36c8d40a3851$export$d9dd218693ea9bba = v);
$parcel$export(module.exports, "AWS_LAMBDA_INVOKED_FUNCTION_ARN", () => $c97e36c8d40a3851$export$c9649b7156282a2f, (v) => $c97e36c8d40a3851$export$c9649b7156282a2f = v);
$parcel$export(module.exports, "AWS_LAMBDA_REMAINING_TIME_IN_MILLIS", () => $c97e36c8d40a3851$export$daa8ce1f8adc553e, (v) => $c97e36c8d40a3851$export$daa8ce1f8adc553e = v);
$parcel$export(module.exports, "AWS_LOG_GROUP_NAMES", () => $c97e36c8d40a3851$export$cb93c7b05db202cf, (v) => $c97e36c8d40a3851$export$cb93c7b05db202cf = v);
$parcel$export(module.exports, "AWS_LOG_STREAM_NAMES", () => $c97e36c8d40a3851$export$930f9bd3cc2e5b3d, (v) => $c97e36c8d40a3851$export$930f9bd3cc2e5b3d = v);
$parcel$export(module.exports, "AWS_REQUEST_EXTENDED_ID", () => $c97e36c8d40a3851$export$48c6d4c44afdc0b, (v) => $c97e36c8d40a3851$export$48c6d4c44afdc0b = v);
$parcel$export(module.exports, "AWS_REQUEST_ID", () => $c97e36c8d40a3851$export$c78d41789fe4b1e4, (v) => $c97e36c8d40a3851$export$c78d41789fe4b1e4 = v);
$parcel$export(module.exports, "AWS_S3_BUCKET", () => $c97e36c8d40a3851$export$f462d9921f1f7332, (v) => $c97e36c8d40a3851$export$f462d9921f1f7332 = v);
$parcel$export(module.exports, "AWS_SECRETSMANAGER_SECRET_ARN", () => $c97e36c8d40a3851$export$bc71f8df9a45e243, (v) => $c97e36c8d40a3851$export$bc71f8df9a45e243 = v);
$parcel$export(module.exports, "AWS_SNS_TOPIC_ARN", () => $c97e36c8d40a3851$export$ed840ec4a5f5d053, (v) => $c97e36c8d40a3851$export$ed840ec4a5f5d053 = v);
$parcel$export(module.exports, "AWS_STEP_FUNCTIONS_ACTIVITY_ARN", () => $c97e36c8d40a3851$export$c1a559a4f74a5e8e, (v) => $c97e36c8d40a3851$export$c1a559a4f74a5e8e = v);
$parcel$export(module.exports, "AWS_STEP_FUNCTIONS_STATE_MACHINE_ARN", () => $c97e36c8d40a3851$export$d1c007424092e3f5, (v) => $c97e36c8d40a3851$export$d1c007424092e3f5 = v);
$parcel$export(module.exports, "BLOCKED_MAIN_THREAD", () => $c97e36c8d40a3851$export$9ebb466ce954c49c, (v) => $c97e36c8d40a3851$export$9ebb466ce954c49c = v);
$parcel$export(module.exports, "BROWSER_NAME", () => $c97e36c8d40a3851$export$e9aafc7348984403, (v) => $c97e36c8d40a3851$export$e9aafc7348984403 = v);
$parcel$export(module.exports, "BROWSER_PERFORMANCE_NAVIGATION_ACTIVATION_START", () => $c97e36c8d40a3851$export$faaa46964f075237, (v) => $c97e36c8d40a3851$export$faaa46964f075237 = v);
$parcel$export(module.exports, "BROWSER_PERFORMANCE_TIME_ORIGIN", () => $c97e36c8d40a3851$export$d28c4b3cc4431a87, (v) => $c97e36c8d40a3851$export$d28c4b3cc4431a87 = v);
$parcel$export(module.exports, "BROWSER_REPORT_TYPE", () => $c97e36c8d40a3851$export$734b017b330c8fe6, (v) => $c97e36c8d40a3851$export$734b017b330c8fe6 = v);
$parcel$export(module.exports, "BROWSER_SCRIPT_INVOKER", () => $c97e36c8d40a3851$export$683ebdc48ba3758d, (v) => $c97e36c8d40a3851$export$683ebdc48ba3758d = v);
$parcel$export(module.exports, "BROWSER_SCRIPT_INVOKER_TYPE", () => $c97e36c8d40a3851$export$be0263971250ef44, (v) => $c97e36c8d40a3851$export$be0263971250ef44 = v);
$parcel$export(module.exports, "BROWSER_SCRIPT_SOURCE_CHAR_POSITION", () => $c97e36c8d40a3851$export$36a0cbc35c405232, (v) => $c97e36c8d40a3851$export$36a0cbc35c405232 = v);
$parcel$export(module.exports, "BROWSER_VERSION", () => $c97e36c8d40a3851$export$469f7765ba335497, (v) => $c97e36c8d40a3851$export$469f7765ba335497 = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_CLS_REPORT_EVENT", () => $c97e36c8d40a3851$export$fe6fe2b7af051610, (v) => $c97e36c8d40a3851$export$fe6fe2b7af051610 = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_CLS_SOURCE_KEY", () => $c97e36c8d40a3851$export$8345821877c4dfad, (v) => $c97e36c8d40a3851$export$8345821877c4dfad = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_CLS_SOURCE_KEY_BASE", () => $c97e36c8d40a3851$export$f6c188a7e02335cf, (v) => $c97e36c8d40a3851$export$f6c188a7e02335cf = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_CLS_VALUE", () => $c97e36c8d40a3851$export$aaf709a8971e825f, (v) => $c97e36c8d40a3851$export$aaf709a8971e825f = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_FCP_VALUE", () => $c97e36c8d40a3851$export$def01b82f8c092f7, (v) => $c97e36c8d40a3851$export$def01b82f8c092f7 = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_FP_VALUE", () => $c97e36c8d40a3851$export$23d4264c606a73a6, (v) => $c97e36c8d40a3851$export$23d4264c606a73a6 = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_INP_VALUE", () => $c97e36c8d40a3851$export$af9ece53bb92f66b, (v) => $c97e36c8d40a3851$export$af9ece53bb92f66b = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_ELEMENT", () => $c97e36c8d40a3851$export$25421625a565b69, (v) => $c97e36c8d40a3851$export$25421625a565b69 = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_ID", () => $c97e36c8d40a3851$export$ab0c90d873e69ccb, (v) => $c97e36c8d40a3851$export$ab0c90d873e69ccb = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_LOAD_TIME", () => $c97e36c8d40a3851$export$538c05cc8cb2a2bb, (v) => $c97e36c8d40a3851$export$538c05cc8cb2a2bb = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_RENDER_TIME", () => $c97e36c8d40a3851$export$f86df4de196e1a7c, (v) => $c97e36c8d40a3851$export$f86df4de196e1a7c = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_REPORT_EVENT", () => $c97e36c8d40a3851$export$51e8aa8c0d65e7b8, (v) => $c97e36c8d40a3851$export$51e8aa8c0d65e7b8 = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_SIZE", () => $c97e36c8d40a3851$export$99023486ecc470bd, (v) => $c97e36c8d40a3851$export$99023486ecc470bd = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_URL", () => $c97e36c8d40a3851$export$2f6c85eaf382e81, (v) => $c97e36c8d40a3851$export$2f6c85eaf382e81 = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_VALUE", () => $c97e36c8d40a3851$export$1158d57c0aed42be, (v) => $c97e36c8d40a3851$export$1158d57c0aed42be = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_TTFB_REQUEST_TIME", () => $c97e36c8d40a3851$export$d85c4f947ab776e3, (v) => $c97e36c8d40a3851$export$d85c4f947ab776e3 = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_TTFB_VALUE", () => $c97e36c8d40a3851$export$813ef8386d874918, (v) => $c97e36c8d40a3851$export$813ef8386d874918 = v);
$parcel$export(module.exports, "CACHE_HIT", () => $c97e36c8d40a3851$export$7c2f74ff9251f64, (v) => $c97e36c8d40a3851$export$7c2f74ff9251f64 = v);
$parcel$export(module.exports, "CACHE_ITEM_SIZE", () => $c97e36c8d40a3851$export$993f84dab107b880, (v) => $c97e36c8d40a3851$export$993f84dab107b880 = v);
$parcel$export(module.exports, "CACHE_KEY", () => $c97e36c8d40a3851$export$7b9c2315e94d8d2f, (v) => $c97e36c8d40a3851$export$7b9c2315e94d8d2f = v);
$parcel$export(module.exports, "CACHE_OPERATION", () => $c97e36c8d40a3851$export$f01e5cd42b9ec146, (v) => $c97e36c8d40a3851$export$f01e5cd42b9ec146 = v);
$parcel$export(module.exports, "CACHE_TTL", () => $c97e36c8d40a3851$export$987f6b4367434b55, (v) => $c97e36c8d40a3851$export$987f6b4367434b55 = v);
$parcel$export(module.exports, "CACHE_WRITE", () => $c97e36c8d40a3851$export$d9d145585d5022bb, (v) => $c97e36c8d40a3851$export$d9d145585d5022bb = v);
$parcel$export(module.exports, "CHANNEL", () => $c97e36c8d40a3851$export$44ffba16bd48dac6, (v) => $c97e36c8d40a3851$export$44ffba16bd48dac6 = v);
$parcel$export(module.exports, "CLIENT_ADDRESS", () => $c97e36c8d40a3851$export$3134892c5d2e251a, (v) => $c97e36c8d40a3851$export$3134892c5d2e251a = v);
$parcel$export(module.exports, "CLIENT_PORT", () => $c97e36c8d40a3851$export$8495028d10296058, (v) => $c97e36c8d40a3851$export$8495028d10296058 = v);
$parcel$export(module.exports, "CLOUDFLARE_D1_DURATION", () => $c97e36c8d40a3851$export$d6d0e4fcf46d490c, (v) => $c97e36c8d40a3851$export$d6d0e4fcf46d490c = v);
$parcel$export(module.exports, "CLOUDFLARE_D1_QUERY_TYPE", () => $c97e36c8d40a3851$export$658dced473c19301, (v) => $c97e36c8d40a3851$export$658dced473c19301 = v);
$parcel$export(module.exports, "CLOUDFLARE_D1_ROWS_READ", () => $c97e36c8d40a3851$export$97b0f9c3fbe64076, (v) => $c97e36c8d40a3851$export$97b0f9c3fbe64076 = v);
$parcel$export(module.exports, "CLOUDFLARE_D1_ROWS_WRITTEN", () => $c97e36c8d40a3851$export$cf2c95ed5efbe9eb, (v) => $c97e36c8d40a3851$export$cf2c95ed5efbe9eb = v);
$parcel$export(module.exports, "CLOUDFLARE_DURABLE_OBJECT_QUERY_BINDINGS", () => $c97e36c8d40a3851$export$880007904f61a388, (v) => $c97e36c8d40a3851$export$880007904f61a388 = v);
$parcel$export(module.exports, "CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_READ", () => $c97e36c8d40a3851$export$3e903b72d4d9e07d, (v) => $c97e36c8d40a3851$export$3e903b72d4d9e07d = v);
$parcel$export(module.exports, "CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_WRITTEN", () => $c97e36c8d40a3851$export$34da07180e0e56af, (v) => $c97e36c8d40a3851$export$34da07180e0e56af = v);
$parcel$export(module.exports, "CLOUDFLARE_R2_BUCKET", () => $c97e36c8d40a3851$export$c49aafdaeb061953, (v) => $c97e36c8d40a3851$export$c49aafdaeb061953 = v);
$parcel$export(module.exports, "CLOUDFLARE_R2_OPERATION", () => $c97e36c8d40a3851$export$ceb762c61de2f17f, (v) => $c97e36c8d40a3851$export$ceb762c61de2f17f = v);
$parcel$export(module.exports, "CLOUDFLARE_R2_REQUEST_DELIMITER", () => $c97e36c8d40a3851$export$a5f54ccfb28c0caf, (v) => $c97e36c8d40a3851$export$a5f54ccfb28c0caf = v);
$parcel$export(module.exports, "CLOUDFLARE_R2_REQUEST_KEY", () => $c97e36c8d40a3851$export$1c86a56857b024db, (v) => $c97e36c8d40a3851$export$1c86a56857b024db = v);
$parcel$export(module.exports, "CLOUDFLARE_R2_REQUEST_PART_NUMBER", () => $c97e36c8d40a3851$export$7598f3464be47440, (v) => $c97e36c8d40a3851$export$7598f3464be47440 = v);
$parcel$export(module.exports, "CLOUDFLARE_R2_REQUEST_PREFIX", () => $c97e36c8d40a3851$export$b673289c971fc0ae, (v) => $c97e36c8d40a3851$export$b673289c971fc0ae = v);
$parcel$export(module.exports, "CLOUDFLARE_WORKFLOW_ATTEMPT", () => $c97e36c8d40a3851$export$98b23f3e6f0c2a6f, (v) => $c97e36c8d40a3851$export$98b23f3e6f0c2a6f = v);
$parcel$export(module.exports, "CLOUDFLARE_WORKFLOW_RETRIES_BACKOFF", () => $c97e36c8d40a3851$export$6ddeaf0498614ebb, (v) => $c97e36c8d40a3851$export$6ddeaf0498614ebb = v);
$parcel$export(module.exports, "CLOUDFLARE_WORKFLOW_RETRIES_DELAY", () => $c97e36c8d40a3851$export$97b78f78d64a7232, (v) => $c97e36c8d40a3851$export$97b78f78d64a7232 = v);
$parcel$export(module.exports, "CLOUDFLARE_WORKFLOW_RETRIES_LIMIT", () => $c97e36c8d40a3851$export$5147715be870fff7, (v) => $c97e36c8d40a3851$export$5147715be870fff7 = v);
$parcel$export(module.exports, "CLOUDFLARE_WORKFLOW_TIMEOUT", () => $c97e36c8d40a3851$export$5276bb46e6096fba, (v) => $c97e36c8d40a3851$export$5276bb46e6096fba = v);
$parcel$export(module.exports, "CLOUD_ACCOUNT_ID", () => $c97e36c8d40a3851$export$cbcbc1f67a937cf3, (v) => $c97e36c8d40a3851$export$cbcbc1f67a937cf3 = v);
$parcel$export(module.exports, "CLOUD_AVAILABILITY_ZONE", () => $c97e36c8d40a3851$export$226a2381b8f0cf78, (v) => $c97e36c8d40a3851$export$226a2381b8f0cf78 = v);
$parcel$export(module.exports, "CLOUD_PLATFORM", () => $c97e36c8d40a3851$export$fd35512cae286064, (v) => $c97e36c8d40a3851$export$fd35512cae286064 = v);
$parcel$export(module.exports, "CLOUD_PROVIDER", () => $c97e36c8d40a3851$export$de9bbf95ab1d81e, (v) => $c97e36c8d40a3851$export$de9bbf95ab1d81e = v);
$parcel$export(module.exports, "CLOUD_REGION", () => $c97e36c8d40a3851$export$47fb20e8d18d7d15, (v) => $c97e36c8d40a3851$export$47fb20e8d18d7d15 = v);
$parcel$export(module.exports, "CLOUD_RESOURCE_ID", () => $c97e36c8d40a3851$export$9db7964e4b8cb849, (v) => $c97e36c8d40a3851$export$9db7964e4b8cb849 = v);
$parcel$export(module.exports, "CLS", () => $c97e36c8d40a3851$export$7139adf9d3bace41, (v) => $c97e36c8d40a3851$export$7139adf9d3bace41 = v);
$parcel$export(module.exports, "CLS_SOURCE_KEY", () => $c97e36c8d40a3851$export$8ac3d09060e7f25d, (v) => $c97e36c8d40a3851$export$8ac3d09060e7f25d = v);
$parcel$export(module.exports, "CLS_SOURCE_KEY_BASE", () => $c97e36c8d40a3851$export$dad0e4778ea23971, (v) => $c97e36c8d40a3851$export$dad0e4778ea23971 = v);
$parcel$export(module.exports, "CODE_FILEPATH", () => $c97e36c8d40a3851$export$c14d903ccf9385a8, (v) => $c97e36c8d40a3851$export$c14d903ccf9385a8 = v);
$parcel$export(module.exports, "CODE_FILE_PATH", () => $c97e36c8d40a3851$export$934cded0041affd7, (v) => $c97e36c8d40a3851$export$934cded0041affd7 = v);
$parcel$export(module.exports, "CODE_FUNCTION", () => $c97e36c8d40a3851$export$6386da1dcba88c9d, (v) => $c97e36c8d40a3851$export$6386da1dcba88c9d = v);
$parcel$export(module.exports, "CODE_FUNCTION_NAME", () => $c97e36c8d40a3851$export$a3371797e606e2, (v) => $c97e36c8d40a3851$export$a3371797e606e2 = v);
$parcel$export(module.exports, "CODE_LINENO", () => $c97e36c8d40a3851$export$a5bbef0af83b23e5, (v) => $c97e36c8d40a3851$export$a5bbef0af83b23e5 = v);
$parcel$export(module.exports, "CODE_LINE_NUMBER", () => $c97e36c8d40a3851$export$91ed1f55874222a6, (v) => $c97e36c8d40a3851$export$91ed1f55874222a6 = v);
$parcel$export(module.exports, "CODE_NAMESPACE", () => $c97e36c8d40a3851$export$23de81068d2aed1b, (v) => $c97e36c8d40a3851$export$23de81068d2aed1b = v);
$parcel$export(module.exports, "CONNECTIONTYPE", () => $c97e36c8d40a3851$export$d738320e1fba9e9d, (v) => $c97e36c8d40a3851$export$d738320e1fba9e9d = v);
$parcel$export(module.exports, "CONNECTION_RTT", () => $c97e36c8d40a3851$export$2eacdea75497e8a5, (v) => $c97e36c8d40a3851$export$2eacdea75497e8a5 = v);
$parcel$export(module.exports, "CULTURE_CALENDAR", () => $c97e36c8d40a3851$export$2bc3ea101f86c1d2, (v) => $c97e36c8d40a3851$export$2bc3ea101f86c1d2 = v);
$parcel$export(module.exports, "CULTURE_DISPLAY_NAME", () => $c97e36c8d40a3851$export$c54e27e8d90ee081, (v) => $c97e36c8d40a3851$export$c54e27e8d90ee081 = v);
$parcel$export(module.exports, "CULTURE_IS_24_HOUR_FORMAT", () => $c97e36c8d40a3851$export$4943adcec371c2a6, (v) => $c97e36c8d40a3851$export$4943adcec371c2a6 = v);
$parcel$export(module.exports, "CULTURE_LOCALE", () => $c97e36c8d40a3851$export$f000a5900d0480c2, (v) => $c97e36c8d40a3851$export$f000a5900d0480c2 = v);
$parcel$export(module.exports, "CULTURE_TIMEZONE", () => $c97e36c8d40a3851$export$8f5234893868273b, (v) => $c97e36c8d40a3851$export$8f5234893868273b = v);
$parcel$export(module.exports, "DB_COLLECTION_NAME", () => $c97e36c8d40a3851$export$1a35518f6e81e8c7, (v) => $c97e36c8d40a3851$export$1a35518f6e81e8c7 = v);
$parcel$export(module.exports, "DB_DRIVER_NAME", () => $c97e36c8d40a3851$export$a2d90911eaae60fc, (v) => $c97e36c8d40a3851$export$a2d90911eaae60fc = v);
$parcel$export(module.exports, "DB_NAME", () => $c97e36c8d40a3851$export$3c22ff8b64b8f565, (v) => $c97e36c8d40a3851$export$3c22ff8b64b8f565 = v);
$parcel$export(module.exports, "DB_NAMESPACE", () => $c97e36c8d40a3851$export$b8019c0e2a5b5f0f, (v) => $c97e36c8d40a3851$export$b8019c0e2a5b5f0f = v);
$parcel$export(module.exports, "DB_OPERATION", () => $c97e36c8d40a3851$export$8c11477e471467c8, (v) => $c97e36c8d40a3851$export$8c11477e471467c8 = v);
$parcel$export(module.exports, "DB_OPERATION_BATCH_SIZE", () => $c97e36c8d40a3851$export$92a96f6363488aee, (v) => $c97e36c8d40a3851$export$92a96f6363488aee = v);
$parcel$export(module.exports, "DB_OPERATION_NAME", () => $c97e36c8d40a3851$export$f91beb6088f9ded9, (v) => $c97e36c8d40a3851$export$f91beb6088f9ded9 = v);
$parcel$export(module.exports, "DB_QUERY_PARAMETER_KEY", () => $c97e36c8d40a3851$export$78bc7224576bf289, (v) => $c97e36c8d40a3851$export$78bc7224576bf289 = v);
$parcel$export(module.exports, "DB_QUERY_PARAMETER_KEY_BASE", () => $c97e36c8d40a3851$export$a8027e0ea0d93ca, (v) => $c97e36c8d40a3851$export$a8027e0ea0d93ca = v);
$parcel$export(module.exports, "DB_QUERY_SUMMARY", () => $c97e36c8d40a3851$export$5e59d3aea52e5037, (v) => $c97e36c8d40a3851$export$5e59d3aea52e5037 = v);
$parcel$export(module.exports, "DB_QUERY_TEXT", () => $c97e36c8d40a3851$export$47e408be0da7933f, (v) => $c97e36c8d40a3851$export$47e408be0da7933f = v);
$parcel$export(module.exports, "DB_REDIS_CONNECTION", () => $c97e36c8d40a3851$export$d5772b934ca13e57, (v) => $c97e36c8d40a3851$export$d5772b934ca13e57 = v);
$parcel$export(module.exports, "DB_REDIS_KEY", () => $c97e36c8d40a3851$export$36e47f6a5777561d, (v) => $c97e36c8d40a3851$export$36e47f6a5777561d = v);
$parcel$export(module.exports, "DB_REDIS_PARAMETERS", () => $c97e36c8d40a3851$export$e768cbc99cd68acf, (v) => $c97e36c8d40a3851$export$e768cbc99cd68acf = v);
$parcel$export(module.exports, "DB_RESPONSE_STATUS_CODE", () => $c97e36c8d40a3851$export$dfcc6c69df1343f2, (v) => $c97e36c8d40a3851$export$dfcc6c69df1343f2 = v);
$parcel$export(module.exports, "DB_SQL_BINDINGS", () => $c97e36c8d40a3851$export$69b0a5d9226b5211, (v) => $c97e36c8d40a3851$export$69b0a5d9226b5211 = v);
$parcel$export(module.exports, "DB_STATEMENT", () => $c97e36c8d40a3851$export$da010a4f4fc971ae, (v) => $c97e36c8d40a3851$export$da010a4f4fc971ae = v);
$parcel$export(module.exports, "DB_STORED_PROCEDURE_NAME", () => $c97e36c8d40a3851$export$5d515b35be0601a0, (v) => $c97e36c8d40a3851$export$5d515b35be0601a0 = v);
$parcel$export(module.exports, "DB_SYSTEM", () => $c97e36c8d40a3851$export$3e1b1037a315c5ca, (v) => $c97e36c8d40a3851$export$3e1b1037a315c5ca = v);
$parcel$export(module.exports, "DB_SYSTEM_NAME", () => $c97e36c8d40a3851$export$847fdd494825f0fb, (v) => $c97e36c8d40a3851$export$847fdd494825f0fb = v);
$parcel$export(module.exports, "DB_USER", () => $c97e36c8d40a3851$export$a9d76f26c6c730a9, (v) => $c97e36c8d40a3851$export$a9d76f26c6c730a9 = v);
$parcel$export(module.exports, "DEVICEMEMORY", () => $c97e36c8d40a3851$export$de03f86d1c9866ca, (v) => $c97e36c8d40a3851$export$de03f86d1c9866ca = v);
$parcel$export(module.exports, "DEVICE_ARCHS", () => $c97e36c8d40a3851$export$65798ecab7eef8c, (v) => $c97e36c8d40a3851$export$65798ecab7eef8c = v);
$parcel$export(module.exports, "DEVICE_BATTERY_LEVEL", () => $c97e36c8d40a3851$export$22aa61f48b9c79a0, (v) => $c97e36c8d40a3851$export$22aa61f48b9c79a0 = v);
$parcel$export(module.exports, "DEVICE_BATTERY_TEMPERATURE", () => $c97e36c8d40a3851$export$69f5fb98f5aed812, (v) => $c97e36c8d40a3851$export$69f5fb98f5aed812 = v);
$parcel$export(module.exports, "DEVICE_BOOT_TIME", () => $c97e36c8d40a3851$export$bdea5d1006fd280a, (v) => $c97e36c8d40a3851$export$bdea5d1006fd280a = v);
$parcel$export(module.exports, "DEVICE_BRAND", () => $c97e36c8d40a3851$export$f63a7230c5b1d609, (v) => $c97e36c8d40a3851$export$f63a7230c5b1d609 = v);
$parcel$export(module.exports, "DEVICE_CHARGING", () => $c97e36c8d40a3851$export$6f25e59b05bb8e17, (v) => $c97e36c8d40a3851$export$6f25e59b05bb8e17 = v);
$parcel$export(module.exports, "DEVICE_CHIPSET", () => $c97e36c8d40a3851$export$a56ad13c4afc7421, (v) => $c97e36c8d40a3851$export$a56ad13c4afc7421 = v);
$parcel$export(module.exports, "DEVICE_CLASS", () => $c97e36c8d40a3851$export$d9ce89ce8912bf12, (v) => $c97e36c8d40a3851$export$d9ce89ce8912bf12 = v);
$parcel$export(module.exports, "DEVICE_CONNECTION_TYPE", () => $c97e36c8d40a3851$export$17094e5f380e4162, (v) => $c97e36c8d40a3851$export$17094e5f380e4162 = v);
$parcel$export(module.exports, "DEVICE_CPU_DESCRIPTION", () => $c97e36c8d40a3851$export$28a0ffdf747973a0, (v) => $c97e36c8d40a3851$export$28a0ffdf747973a0 = v);
$parcel$export(module.exports, "DEVICE_EXTERNAL_FREE_STORAGE", () => $c97e36c8d40a3851$export$5480ae1ba5d50bb9, (v) => $c97e36c8d40a3851$export$5480ae1ba5d50bb9 = v);
$parcel$export(module.exports, "DEVICE_EXTERNAL_STORAGE_SIZE", () => $c97e36c8d40a3851$export$edc72ee4a17f5152, (v) => $c97e36c8d40a3851$export$edc72ee4a17f5152 = v);
$parcel$export(module.exports, "DEVICE_FAMILY", () => $c97e36c8d40a3851$export$19e4df138d354f8b, (v) => $c97e36c8d40a3851$export$19e4df138d354f8b = v);
$parcel$export(module.exports, "DEVICE_FREE_MEMORY", () => $c97e36c8d40a3851$export$92b0d20fa482b4b2, (v) => $c97e36c8d40a3851$export$92b0d20fa482b4b2 = v);
$parcel$export(module.exports, "DEVICE_FREE_STORAGE", () => $c97e36c8d40a3851$export$3f638a793d61933f, (v) => $c97e36c8d40a3851$export$3f638a793d61933f = v);
$parcel$export(module.exports, "DEVICE_ID", () => $c97e36c8d40a3851$export$3f511731cc3687d4, (v) => $c97e36c8d40a3851$export$3f511731cc3687d4 = v);
$parcel$export(module.exports, "DEVICE_LOCALE", () => $c97e36c8d40a3851$export$692b08741d6b6265, (v) => $c97e36c8d40a3851$export$692b08741d6b6265 = v);
$parcel$export(module.exports, "DEVICE_LOW_MEMORY", () => $c97e36c8d40a3851$export$cf67f8cb2324428e, (v) => $c97e36c8d40a3851$export$cf67f8cb2324428e = v);
$parcel$export(module.exports, "DEVICE_LOW_POWER_MODE", () => $c97e36c8d40a3851$export$9d4197c1ffc5f359, (v) => $c97e36c8d40a3851$export$9d4197c1ffc5f359 = v);
$parcel$export(module.exports, "DEVICE_MANUFACTURER", () => $c97e36c8d40a3851$export$509634fbff540e75, (v) => $c97e36c8d40a3851$export$509634fbff540e75 = v);
$parcel$export(module.exports, "DEVICE_MEMORY_ESTIMATED_CAPACITY", () => $c97e36c8d40a3851$export$ccbc4fdff4b5eff5, (v) => $c97e36c8d40a3851$export$ccbc4fdff4b5eff5 = v);
$parcel$export(module.exports, "DEVICE_MEMORY_SIZE", () => $c97e36c8d40a3851$export$e0cb371ca548b1d6, (v) => $c97e36c8d40a3851$export$e0cb371ca548b1d6 = v);
$parcel$export(module.exports, "DEVICE_MODEL", () => $c97e36c8d40a3851$export$3c39026d09026bc2, (v) => $c97e36c8d40a3851$export$3c39026d09026bc2 = v);
$parcel$export(module.exports, "DEVICE_MODEL_ID", () => $c97e36c8d40a3851$export$bf9e8248cb72cf00, (v) => $c97e36c8d40a3851$export$bf9e8248cb72cf00 = v);
$parcel$export(module.exports, "DEVICE_NAME", () => $c97e36c8d40a3851$export$1054f22a72121d0f, (v) => $c97e36c8d40a3851$export$1054f22a72121d0f = v);
$parcel$export(module.exports, "DEVICE_ONLINE", () => $c97e36c8d40a3851$export$723b8a59dad2e467, (v) => $c97e36c8d40a3851$export$723b8a59dad2e467 = v);
$parcel$export(module.exports, "DEVICE_ORIENTATION", () => $c97e36c8d40a3851$export$160081ff141bac8e, (v) => $c97e36c8d40a3851$export$160081ff141bac8e = v);
$parcel$export(module.exports, "DEVICE_PROCESSOR_COUNT", () => $c97e36c8d40a3851$export$194f62c84d27310, (v) => $c97e36c8d40a3851$export$194f62c84d27310 = v);
$parcel$export(module.exports, "DEVICE_PROCESSOR_FREQUENCY", () => $c97e36c8d40a3851$export$7ed866d57b018d09, (v) => $c97e36c8d40a3851$export$7ed866d57b018d09 = v);
$parcel$export(module.exports, "DEVICE_SCREEN_DENSITY", () => $c97e36c8d40a3851$export$d50bae4562e03e5, (v) => $c97e36c8d40a3851$export$d50bae4562e03e5 = v);
$parcel$export(module.exports, "DEVICE_SCREEN_DPI", () => $c97e36c8d40a3851$export$649ea67a18fe8e8b, (v) => $c97e36c8d40a3851$export$649ea67a18fe8e8b = v);
$parcel$export(module.exports, "DEVICE_SCREEN_HEIGHT_PIXELS", () => $c97e36c8d40a3851$export$136a5c1b43caaccd, (v) => $c97e36c8d40a3851$export$136a5c1b43caaccd = v);
$parcel$export(module.exports, "DEVICE_SCREEN_WIDTH_PIXELS", () => $c97e36c8d40a3851$export$e33a28ea554b6ddc, (v) => $c97e36c8d40a3851$export$e33a28ea554b6ddc = v);
$parcel$export(module.exports, "DEVICE_SIMULATOR", () => $c97e36c8d40a3851$export$acbe2d25ac76ea64, (v) => $c97e36c8d40a3851$export$acbe2d25ac76ea64 = v);
$parcel$export(module.exports, "DEVICE_STORAGE_SIZE", () => $c97e36c8d40a3851$export$793c13e17d7e5e2b, (v) => $c97e36c8d40a3851$export$793c13e17d7e5e2b = v);
$parcel$export(module.exports, "DEVICE_THERMAL_STATE", () => $c97e36c8d40a3851$export$a5617e33b89fd956, (v) => $c97e36c8d40a3851$export$a5617e33b89fd956 = v);
$parcel$export(module.exports, "DEVICE_TIMEZONE", () => $c97e36c8d40a3851$export$b51f82164fa31e07, (v) => $c97e36c8d40a3851$export$b51f82164fa31e07 = v);
$parcel$export(module.exports, "DEVICE_USABLE_MEMORY", () => $c97e36c8d40a3851$export$f2ef55183c04d202, (v) => $c97e36c8d40a3851$export$f2ef55183c04d202 = v);
$parcel$export(module.exports, "DIST", () => $c97e36c8d40a3851$export$7c98fc0c48a16b1c, (v) => $c97e36c8d40a3851$export$7c98fc0c48a16b1c = v);
$parcel$export(module.exports, "EFFECTIVECONNECTIONTYPE", () => $c97e36c8d40a3851$export$f0511e328234ae83, (v) => $c97e36c8d40a3851$export$f0511e328234ae83 = v);
$parcel$export(module.exports, "ENVIRONMENT", () => $c97e36c8d40a3851$export$be46596bc6608f3b, (v) => $c97e36c8d40a3851$export$be46596bc6608f3b = v);
$parcel$export(module.exports, "ERROR_TYPE", () => $c97e36c8d40a3851$export$f215947b3d76a6b7, (v) => $c97e36c8d40a3851$export$f215947b3d76a6b7 = v);
$parcel$export(module.exports, "EVENT_ID", () => $c97e36c8d40a3851$export$89bbc91416db6670, (v) => $c97e36c8d40a3851$export$89bbc91416db6670 = v);
$parcel$export(module.exports, "EVENT_NAME", () => $c97e36c8d40a3851$export$b4b5eff8a8712c89, (v) => $c97e36c8d40a3851$export$b4b5eff8a8712c89 = v);
$parcel$export(module.exports, "EXCEPTION_ESCAPED", () => $c97e36c8d40a3851$export$f455969a57ab8a03, (v) => $c97e36c8d40a3851$export$f455969a57ab8a03 = v);
$parcel$export(module.exports, "EXCEPTION_MESSAGE", () => $c97e36c8d40a3851$export$13f2f8f42af49cec, (v) => $c97e36c8d40a3851$export$13f2f8f42af49cec = v);
$parcel$export(module.exports, "EXCEPTION_STACKTRACE", () => $c97e36c8d40a3851$export$cd357afe2ffdd2c3, (v) => $c97e36c8d40a3851$export$cd357afe2ffdd2c3 = v);
$parcel$export(module.exports, "EXCEPTION_TYPE", () => $c97e36c8d40a3851$export$d9ca2a279a11be5e, (v) => $c97e36c8d40a3851$export$d9ca2a279a11be5e = v);
$parcel$export(module.exports, "FAAS_COLDSTART", () => $c97e36c8d40a3851$export$bbd59a8c7efad4c9, (v) => $c97e36c8d40a3851$export$bbd59a8c7efad4c9 = v);
$parcel$export(module.exports, "FAAS_CRON", () => $c97e36c8d40a3851$export$8413282a17f1cda5, (v) => $c97e36c8d40a3851$export$8413282a17f1cda5 = v);
$parcel$export(module.exports, "FAAS_DURATION_IN_MS", () => $c97e36c8d40a3851$export$30d19ddc7705e7e8, (v) => $c97e36c8d40a3851$export$30d19ddc7705e7e8 = v);
$parcel$export(module.exports, "FAAS_ENTRY_POINT", () => $c97e36c8d40a3851$export$64a4f09e2444b3d, (v) => $c97e36c8d40a3851$export$64a4f09e2444b3d = v);
$parcel$export(module.exports, "FAAS_EXECUTION", () => $c97e36c8d40a3851$export$645b039fe163809e, (v) => $c97e36c8d40a3851$export$645b039fe163809e = v);
$parcel$export(module.exports, "FAAS_ID", () => $c97e36c8d40a3851$export$b23ef8b8ffa607e1, (v) => $c97e36c8d40a3851$export$b23ef8b8ffa607e1 = v);
$parcel$export(module.exports, "FAAS_IDENTITY", () => $c97e36c8d40a3851$export$8bf64516740c1369, (v) => $c97e36c8d40a3851$export$8bf64516740c1369 = v);
$parcel$export(module.exports, "FAAS_INVOCATION_ID", () => $c97e36c8d40a3851$export$9a0dc8e612f3e10b, (v) => $c97e36c8d40a3851$export$9a0dc8e612f3e10b = v);
$parcel$export(module.exports, "FAAS_INVOKED_NAME", () => $c97e36c8d40a3851$export$abe90fedb3dddda2, (v) => $c97e36c8d40a3851$export$abe90fedb3dddda2 = v);
$parcel$export(module.exports, "FAAS_INVOKED_PROVIDER", () => $c97e36c8d40a3851$export$4a19da9c85ed2ade, (v) => $c97e36c8d40a3851$export$4a19da9c85ed2ade = v);
$parcel$export(module.exports, "FAAS_INVOKED_REGION", () => $c97e36c8d40a3851$export$5e091479f094bdbc, (v) => $c97e36c8d40a3851$export$5e091479f094bdbc = v);
$parcel$export(module.exports, "FAAS_NAME", () => $c97e36c8d40a3851$export$d70909b5aa96a79a, (v) => $c97e36c8d40a3851$export$d70909b5aa96a79a = v);
$parcel$export(module.exports, "FAAS_TIME", () => $c97e36c8d40a3851$export$651d142a8017d83d, (v) => $c97e36c8d40a3851$export$651d142a8017d83d = v);
$parcel$export(module.exports, "FAAS_TRIGGER", () => $c97e36c8d40a3851$export$44382a010a9f7fcf, (v) => $c97e36c8d40a3851$export$44382a010a9f7fcf = v);
$parcel$export(module.exports, "FAAS_VERSION", () => $c97e36c8d40a3851$export$807abfdc6b7b9338, (v) => $c97e36c8d40a3851$export$807abfdc6b7b9338 = v);
$parcel$export(module.exports, "FCP", () => $c97e36c8d40a3851$export$31881d07f2569218, (v) => $c97e36c8d40a3851$export$31881d07f2569218 = v);
$parcel$export(module.exports, "FLAG_EVALUATION_KEY", () => $c97e36c8d40a3851$export$e5bbf306deb709a6, (v) => $c97e36c8d40a3851$export$e5bbf306deb709a6 = v);
$parcel$export(module.exports, "FLAG_EVALUATION_KEY_BASE", () => $c97e36c8d40a3851$export$aa8721167c5c8d2d, (v) => $c97e36c8d40a3851$export$aa8721167c5c8d2d = v);
$parcel$export(module.exports, "FP", () => $c97e36c8d40a3851$export$757b93e5b3adc7cb, (v) => $c97e36c8d40a3851$export$757b93e5b3adc7cb = v);
$parcel$export(module.exports, "FRAMES_DELAY", () => $c97e36c8d40a3851$export$f869eaa92db1dc9b, (v) => $c97e36c8d40a3851$export$f869eaa92db1dc9b = v);
$parcel$export(module.exports, "FRAMES_FROZEN", () => $c97e36c8d40a3851$export$5d1d761e41c32d9e, (v) => $c97e36c8d40a3851$export$5d1d761e41c32d9e = v);
$parcel$export(module.exports, "FRAMES_FROZEN_RATE", () => $c97e36c8d40a3851$export$8aec72d9491f9399, (v) => $c97e36c8d40a3851$export$8aec72d9491f9399 = v);
$parcel$export(module.exports, "FRAMES_SLOW", () => $c97e36c8d40a3851$export$5562635d2be2ab25, (v) => $c97e36c8d40a3851$export$5562635d2be2ab25 = v);
$parcel$export(module.exports, "FRAMES_SLOW_RATE", () => $c97e36c8d40a3851$export$2dc31837ce6f7a3d, (v) => $c97e36c8d40a3851$export$2dc31837ce6f7a3d = v);
$parcel$export(module.exports, "FRAMES_TOTAL", () => $c97e36c8d40a3851$export$b561df15f64d32e3, (v) => $c97e36c8d40a3851$export$b561df15f64d32e3 = v);
$parcel$export(module.exports, "FS_ERROR", () => $c97e36c8d40a3851$export$181f78b28f2ffa57, (v) => $c97e36c8d40a3851$export$181f78b28f2ffa57 = v);
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_EVENT_ID", () => $c97e36c8d40a3851$export$6c97c77b89571c75, (v) => $c97e36c8d40a3851$export$6c97c77b89571c75 = v);
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_EVENT_TYPE", () => $c97e36c8d40a3851$export$51e431eaf1f9bf58, (v) => $c97e36c8d40a3851$export$51e431eaf1f9bf58 = v);
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_ID", () => $c97e36c8d40a3851$export$71429c7ef7cb7063, (v) => $c97e36c8d40a3851$export$71429c7ef7cb7063 = v);
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_RESOURCE", () => $c97e36c8d40a3851$export$99905d7583a6e8ac, (v) => $c97e36c8d40a3851$export$99905d7583a6e8ac = v);
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_SOURCE", () => $c97e36c8d40a3851$export$b6c4be74fd0c06bd, (v) => $c97e36c8d40a3851$export$b6c4be74fd0c06bd = v);
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_SPECVERSION", () => $c97e36c8d40a3851$export$fd23e5b8d261a89, (v) => $c97e36c8d40a3851$export$fd23e5b8d261a89 = v);
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_TIME", () => $c97e36c8d40a3851$export$25fabc9b3d1dd567, (v) => $c97e36c8d40a3851$export$25fabc9b3d1dd567 = v);
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_TIMESTAMP", () => $c97e36c8d40a3851$export$41507f7b07dad151, (v) => $c97e36c8d40a3851$export$41507f7b07dad151 = v);
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_TYPE", () => $c97e36c8d40a3851$export$1352f3699c35dd73, (v) => $c97e36c8d40a3851$export$1352f3699c35dd73 = v);
$parcel$export(module.exports, "GCP_PROJECT_ID", () => $c97e36c8d40a3851$export$fd6c9d5c74d943ac, (v) => $c97e36c8d40a3851$export$fd6c9d5c74d943ac = v);
$parcel$export(module.exports, "GEN_AI_AGENT_NAME", () => $c97e36c8d40a3851$export$c29634e3cf41e479, (v) => $c97e36c8d40a3851$export$c29634e3cf41e479 = v);
$parcel$export(module.exports, "GEN_AI_CONTEXT_UTILIZATION", () => $c97e36c8d40a3851$export$e6a60882cce7a085, (v) => $c97e36c8d40a3851$export$e6a60882cce7a085 = v);
$parcel$export(module.exports, "GEN_AI_CONTEXT_WINDOW_SIZE", () => $c97e36c8d40a3851$export$6773c9098ba5e194, (v) => $c97e36c8d40a3851$export$6773c9098ba5e194 = v);
$parcel$export(module.exports, "GEN_AI_CONVERSATION_ID", () => $c97e36c8d40a3851$export$6ee6b62f50047686, (v) => $c97e36c8d40a3851$export$6ee6b62f50047686 = v);
$parcel$export(module.exports, "GEN_AI_COST_CACHE_CREATION_INPUT_TOKENS", () => $c97e36c8d40a3851$export$efac052bb3661242, (v) => $c97e36c8d40a3851$export$efac052bb3661242 = v);
$parcel$export(module.exports, "GEN_AI_COST_CACHE_READ_INPUT_TOKENS", () => $c97e36c8d40a3851$export$7ccd63b9ca955862, (v) => $c97e36c8d40a3851$export$7ccd63b9ca955862 = v);
$parcel$export(module.exports, "GEN_AI_COST_INPUT_TOKENS", () => $c97e36c8d40a3851$export$50921df5a58cb3ef, (v) => $c97e36c8d40a3851$export$50921df5a58cb3ef = v);
$parcel$export(module.exports, "GEN_AI_COST_OUTPUT_TOKENS", () => $c97e36c8d40a3851$export$8e48efc7acb57a97, (v) => $c97e36c8d40a3851$export$8e48efc7acb57a97 = v);
$parcel$export(module.exports, "GEN_AI_COST_REASONING_OUTPUT_TOKENS", () => $c97e36c8d40a3851$export$cea9121727113f77, (v) => $c97e36c8d40a3851$export$cea9121727113f77 = v);
$parcel$export(module.exports, "GEN_AI_COST_TOTAL_TOKENS", () => $c97e36c8d40a3851$export$bed35ff7f9af3aaa, (v) => $c97e36c8d40a3851$export$bed35ff7f9af3aaa = v);
$parcel$export(module.exports, "GEN_AI_EMBEDDINGS_INPUT", () => $c97e36c8d40a3851$export$6b729e898b9067ce, (v) => $c97e36c8d40a3851$export$6b729e898b9067ce = v);
$parcel$export(module.exports, "GEN_AI_FUNCTION_ID", () => $c97e36c8d40a3851$export$984fbab9b52f7e24, (v) => $c97e36c8d40a3851$export$984fbab9b52f7e24 = v);
$parcel$export(module.exports, "GEN_AI_INPUT_MESSAGES", () => $c97e36c8d40a3851$export$9ea17906a87ada6f, (v) => $c97e36c8d40a3851$export$9ea17906a87ada6f = v);
$parcel$export(module.exports, "GEN_AI_OPERATION_NAME", () => $c97e36c8d40a3851$export$394b443aaff3ef92, (v) => $c97e36c8d40a3851$export$394b443aaff3ef92 = v);
$parcel$export(module.exports, "GEN_AI_OPERATION_TYPE", () => $c97e36c8d40a3851$export$6ddc374adbc06720, (v) => $c97e36c8d40a3851$export$6ddc374adbc06720 = v);
$parcel$export(module.exports, "GEN_AI_OUTPUT_MESSAGES", () => $c97e36c8d40a3851$export$ab8c7ebc9add56b2, (v) => $c97e36c8d40a3851$export$ab8c7ebc9add56b2 = v);
$parcel$export(module.exports, "GEN_AI_PIPELINE_NAME", () => $c97e36c8d40a3851$export$40ecc5bcd633d1ee, (v) => $c97e36c8d40a3851$export$40ecc5bcd633d1ee = v);
$parcel$export(module.exports, "GEN_AI_PROMPT", () => $c97e36c8d40a3851$export$86a8df7fff52fc69, (v) => $c97e36c8d40a3851$export$86a8df7fff52fc69 = v);
$parcel$export(module.exports, "GEN_AI_PROMPT_NAME", () => $c97e36c8d40a3851$export$cf2115d46768f4c5, (v) => $c97e36c8d40a3851$export$cf2115d46768f4c5 = v);
$parcel$export(module.exports, "GEN_AI_PROVIDER_NAME", () => $c97e36c8d40a3851$export$3d7e036e195764db, (v) => $c97e36c8d40a3851$export$3d7e036e195764db = v);
$parcel$export(module.exports, "GEN_AI_REQUEST_AVAILABLE_TOOLS", () => $c97e36c8d40a3851$export$60c1d11221608cee, (v) => $c97e36c8d40a3851$export$60c1d11221608cee = v);
$parcel$export(module.exports, "GEN_AI_REQUEST_FREQUENCY_PENALTY", () => $c97e36c8d40a3851$export$bc3cef164abbc42c, (v) => $c97e36c8d40a3851$export$bc3cef164abbc42c = v);
$parcel$export(module.exports, "GEN_AI_REQUEST_MAX_TOKENS", () => $c97e36c8d40a3851$export$43f9afb62cd79dec, (v) => $c97e36c8d40a3851$export$43f9afb62cd79dec = v);
$parcel$export(module.exports, "GEN_AI_REQUEST_MESSAGES", () => $c97e36c8d40a3851$export$a5ab4ffc4765f75f, (v) => $c97e36c8d40a3851$export$a5ab4ffc4765f75f = v);
$parcel$export(module.exports, "GEN_AI_REQUEST_MODEL", () => $c97e36c8d40a3851$export$ccf46db9ab1743ec, (v) => $c97e36c8d40a3851$export$ccf46db9ab1743ec = v);
$parcel$export(module.exports, "GEN_AI_REQUEST_PRESENCE_PENALTY", () => $c97e36c8d40a3851$export$76c1c247342d776, (v) => $c97e36c8d40a3851$export$76c1c247342d776 = v);
$parcel$export(module.exports, "GEN_AI_REQUEST_REASONING_EFFORT", () => $c97e36c8d40a3851$export$92f5944f0b02c9fb, (v) => $c97e36c8d40a3851$export$92f5944f0b02c9fb = v);
$parcel$export(module.exports, "GEN_AI_REQUEST_SEED", () => $c97e36c8d40a3851$export$867eeefcb1c95b27, (v) => $c97e36c8d40a3851$export$867eeefcb1c95b27 = v);
$parcel$export(module.exports, "GEN_AI_REQUEST_STOP_SEQUENCES", () => $c97e36c8d40a3851$export$5ada4697ae6aa17e, (v) => $c97e36c8d40a3851$export$5ada4697ae6aa17e = v);
$parcel$export(module.exports, "GEN_AI_REQUEST_TEMPERATURE", () => $c97e36c8d40a3851$export$427122300e8d54d0, (v) => $c97e36c8d40a3851$export$427122300e8d54d0 = v);
$parcel$export(module.exports, "GEN_AI_REQUEST_TOP_K", () => $c97e36c8d40a3851$export$bcea8881375c352f, (v) => $c97e36c8d40a3851$export$bcea8881375c352f = v);
$parcel$export(module.exports, "GEN_AI_REQUEST_TOP_P", () => $c97e36c8d40a3851$export$b867715f9a0c04e9, (v) => $c97e36c8d40a3851$export$b867715f9a0c04e9 = v);
$parcel$export(module.exports, "GEN_AI_RESPONSE_FINISH_REASONS", () => $c97e36c8d40a3851$export$69878a39cbdbe097, (v) => $c97e36c8d40a3851$export$69878a39cbdbe097 = v);
$parcel$export(module.exports, "GEN_AI_RESPONSE_ID", () => $c97e36c8d40a3851$export$584c61a1b769552d, (v) => $c97e36c8d40a3851$export$584c61a1b769552d = v);
$parcel$export(module.exports, "GEN_AI_RESPONSE_MODEL", () => $c97e36c8d40a3851$export$8169ebcb0b0331dd, (v) => $c97e36c8d40a3851$export$8169ebcb0b0331dd = v);
$parcel$export(module.exports, "GEN_AI_RESPONSE_STREAMING", () => $c97e36c8d40a3851$export$2c9713b624877853, (v) => $c97e36c8d40a3851$export$2c9713b624877853 = v);
$parcel$export(module.exports, "GEN_AI_RESPONSE_TEXT", () => $c97e36c8d40a3851$export$45942692aeb454e0, (v) => $c97e36c8d40a3851$export$45942692aeb454e0 = v);
$parcel$export(module.exports, "GEN_AI_RESPONSE_TIME_TO_FIRST_CHUNK", () => $c97e36c8d40a3851$export$8e5efeaa031210cd, (v) => $c97e36c8d40a3851$export$8e5efeaa031210cd = v);
$parcel$export(module.exports, "GEN_AI_RESPONSE_TIME_TO_FIRST_TOKEN", () => $c97e36c8d40a3851$export$35a62769ee05a05a, (v) => $c97e36c8d40a3851$export$35a62769ee05a05a = v);
$parcel$export(module.exports, "GEN_AI_RESPONSE_TOKENS_PER_SECOND", () => $c97e36c8d40a3851$export$8ea4f7e986ca4b06, (v) => $c97e36c8d40a3851$export$8ea4f7e986ca4b06 = v);
$parcel$export(module.exports, "GEN_AI_RESPONSE_TOOL_CALLS", () => $c97e36c8d40a3851$export$d2fd9ecaff0285a4, (v) => $c97e36c8d40a3851$export$d2fd9ecaff0285a4 = v);
$parcel$export(module.exports, "GEN_AI_SYSTEM", () => $c97e36c8d40a3851$export$a6c8e656a4f9bb67, (v) => $c97e36c8d40a3851$export$a6c8e656a4f9bb67 = v);
$parcel$export(module.exports, "GEN_AI_SYSTEM_INSTRUCTIONS", () => $c97e36c8d40a3851$export$352a8075b163d53, (v) => $c97e36c8d40a3851$export$352a8075b163d53 = v);
$parcel$export(module.exports, "GEN_AI_SYSTEM_MESSAGE", () => $c97e36c8d40a3851$export$426d7b90ba5d79db, (v) => $c97e36c8d40a3851$export$426d7b90ba5d79db = v);
$parcel$export(module.exports, "GEN_AI_TOOL_CALL_ARGUMENTS", () => $c97e36c8d40a3851$export$f5a1ee40934d19ce, (v) => $c97e36c8d40a3851$export$f5a1ee40934d19ce = v);
$parcel$export(module.exports, "GEN_AI_TOOL_CALL_RESULT", () => $c97e36c8d40a3851$export$1ba812a9756622ce, (v) => $c97e36c8d40a3851$export$1ba812a9756622ce = v);
$parcel$export(module.exports, "GEN_AI_TOOL_DEFINITIONS", () => $c97e36c8d40a3851$export$351120039c36e03, (v) => $c97e36c8d40a3851$export$351120039c36e03 = v);
$parcel$export(module.exports, "GEN_AI_TOOL_DESCRIPTION", () => $c97e36c8d40a3851$export$d42aa25ca09e17c4, (v) => $c97e36c8d40a3851$export$d42aa25ca09e17c4 = v);
$parcel$export(module.exports, "GEN_AI_TOOL_INPUT", () => $c97e36c8d40a3851$export$d268db29b88a4286, (v) => $c97e36c8d40a3851$export$d268db29b88a4286 = v);
$parcel$export(module.exports, "GEN_AI_TOOL_MESSAGE", () => $c97e36c8d40a3851$export$c5deb6018f2d6251, (v) => $c97e36c8d40a3851$export$c5deb6018f2d6251 = v);
$parcel$export(module.exports, "GEN_AI_TOOL_NAME", () => $c97e36c8d40a3851$export$e06baa3034409453, (v) => $c97e36c8d40a3851$export$e06baa3034409453 = v);
$parcel$export(module.exports, "GEN_AI_TOOL_OUTPUT", () => $c97e36c8d40a3851$export$646fdb5910ce3931, (v) => $c97e36c8d40a3851$export$646fdb5910ce3931 = v);
$parcel$export(module.exports, "GEN_AI_TOOL_TYPE", () => $c97e36c8d40a3851$export$662e3d2d4361e29b, (v) => $c97e36c8d40a3851$export$662e3d2d4361e29b = v);
$parcel$export(module.exports, "GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS", () => $c97e36c8d40a3851$export$1de3962f221ba441, (v) => $c97e36c8d40a3851$export$1de3962f221ba441 = v);
$parcel$export(module.exports, "GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS", () => $c97e36c8d40a3851$export$a4b3f0f5499c8738, (v) => $c97e36c8d40a3851$export$a4b3f0f5499c8738 = v);
$parcel$export(module.exports, "GEN_AI_USAGE_COMPLETION_TOKENS", () => $c97e36c8d40a3851$export$1aecdac6cecbdc5b, (v) => $c97e36c8d40a3851$export$1aecdac6cecbdc5b = v);
$parcel$export(module.exports, "GEN_AI_USAGE_INPUT_TOKENS", () => $c97e36c8d40a3851$export$2eb2ab35b317a103, (v) => $c97e36c8d40a3851$export$2eb2ab35b317a103 = v);
$parcel$export(module.exports, "GEN_AI_USAGE_INPUT_TOKENS_CACHED", () => $c97e36c8d40a3851$export$c7e14ea195ede241, (v) => $c97e36c8d40a3851$export$c7e14ea195ede241 = v);
$parcel$export(module.exports, "GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE", () => $c97e36c8d40a3851$export$41ac034e7b9725a2, (v) => $c97e36c8d40a3851$export$41ac034e7b9725a2 = v);
$parcel$export(module.exports, "GEN_AI_USAGE_OUTPUT_TOKENS", () => $c97e36c8d40a3851$export$9e521119d7751e37, (v) => $c97e36c8d40a3851$export$9e521119d7751e37 = v);
$parcel$export(module.exports, "GEN_AI_USAGE_OUTPUT_TOKENS_REASONING", () => $c97e36c8d40a3851$export$cbac8f541a64a150, (v) => $c97e36c8d40a3851$export$cbac8f541a64a150 = v);
$parcel$export(module.exports, "GEN_AI_USAGE_PROMPT_TOKENS", () => $c97e36c8d40a3851$export$93dd08efa94c9dd4, (v) => $c97e36c8d40a3851$export$93dd08efa94c9dd4 = v);
$parcel$export(module.exports, "GEN_AI_USAGE_REASONING_OUTPUT_TOKENS", () => $c97e36c8d40a3851$export$183e3523dac20bca, (v) => $c97e36c8d40a3851$export$183e3523dac20bca = v);
$parcel$export(module.exports, "GEN_AI_USAGE_TOTAL_TOKENS", () => $c97e36c8d40a3851$export$3867ca1d8381d4e3, (v) => $c97e36c8d40a3851$export$3867ca1d8381d4e3 = v);
$parcel$export(module.exports, "GRAPHQL_DOCUMENT", () => $c97e36c8d40a3851$export$11febcf9917c0057, (v) => $c97e36c8d40a3851$export$11febcf9917c0057 = v);
$parcel$export(module.exports, "GRAPHQL_OPERATION_NAME", () => $c97e36c8d40a3851$export$88ae1ee0c0a63398, (v) => $c97e36c8d40a3851$export$88ae1ee0c0a63398 = v);
$parcel$export(module.exports, "GRAPHQL_OPERATION_TYPE", () => $c97e36c8d40a3851$export$d5bd986d1f283f29, (v) => $c97e36c8d40a3851$export$d5bd986d1f283f29 = v);
$parcel$export(module.exports, "HARDWARECONCURRENCY", () => $c97e36c8d40a3851$export$fc4a2d238535d998, (v) => $c97e36c8d40a3851$export$fc4a2d238535d998 = v);
$parcel$export(module.exports, "HTTP_CLIENT_IP", () => $c97e36c8d40a3851$export$57e53a60bf563f41, (v) => $c97e36c8d40a3851$export$57e53a60bf563f41 = v);
$parcel$export(module.exports, "HTTP_DECODED_RESPONSE_CONTENT_LENGTH", () => $c97e36c8d40a3851$export$ffdb1464deb0eedb, (v) => $c97e36c8d40a3851$export$ffdb1464deb0eedb = v);
$parcel$export(module.exports, "HTTP_FLAVOR", () => $c97e36c8d40a3851$export$b52670c950fd640, (v) => $c97e36c8d40a3851$export$b52670c950fd640 = v);
$parcel$export(module.exports, "HTTP_FRAGMENT", () => $c97e36c8d40a3851$export$c499fd8f1db3d18e, (v) => $c97e36c8d40a3851$export$c499fd8f1db3d18e = v);
$parcel$export(module.exports, "HTTP_HOST", () => $c97e36c8d40a3851$export$b2ee2242301eff05, (v) => $c97e36c8d40a3851$export$b2ee2242301eff05 = v);
$parcel$export(module.exports, "HTTP_METHOD", () => $c97e36c8d40a3851$export$2ebf9f7586f16841, (v) => $c97e36c8d40a3851$export$2ebf9f7586f16841 = v);
$parcel$export(module.exports, "HTTP_QUERY", () => $c97e36c8d40a3851$export$6e9ffd608b3e828b, (v) => $c97e36c8d40a3851$export$6e9ffd608b3e828b = v);
$parcel$export(module.exports, "HTTP_REQUEST_BODY_DATA", () => $c97e36c8d40a3851$export$b960c5a73a722e6c, (v) => $c97e36c8d40a3851$export$b960c5a73a722e6c = v);
$parcel$export(module.exports, "HTTP_REQUEST_CONNECTION_END", () => $c97e36c8d40a3851$export$a7a850351369c77e, (v) => $c97e36c8d40a3851$export$a7a850351369c77e = v);
$parcel$export(module.exports, "HTTP_REQUEST_CONNECT_START", () => $c97e36c8d40a3851$export$b18bca78f4736a94, (v) => $c97e36c8d40a3851$export$b18bca78f4736a94 = v);
$parcel$export(module.exports, "HTTP_REQUEST_DOMAIN_LOOKUP_END", () => $c97e36c8d40a3851$export$61a0059f562fb6c2, (v) => $c97e36c8d40a3851$export$61a0059f562fb6c2 = v);
$parcel$export(module.exports, "HTTP_REQUEST_DOMAIN_LOOKUP_START", () => $c97e36c8d40a3851$export$7dc0d5aefb816d91, (v) => $c97e36c8d40a3851$export$7dc0d5aefb816d91 = v);
$parcel$export(module.exports, "HTTP_REQUEST_FETCH_START", () => $c97e36c8d40a3851$export$58f6db56c841bef6, (v) => $c97e36c8d40a3851$export$58f6db56c841bef6 = v);
$parcel$export(module.exports, "HTTP_REQUEST_HEADER_KEY", () => $c97e36c8d40a3851$export$97a3da679f509d5, (v) => $c97e36c8d40a3851$export$97a3da679f509d5 = v);
$parcel$export(module.exports, "HTTP_REQUEST_HEADER_KEY_BASE", () => $c97e36c8d40a3851$export$c387ec65fd1c2638, (v) => $c97e36c8d40a3851$export$c387ec65fd1c2638 = v);
$parcel$export(module.exports, "HTTP_REQUEST_METHOD", () => $c97e36c8d40a3851$export$4d9db82211f308a4, (v) => $c97e36c8d40a3851$export$4d9db82211f308a4 = v);
$parcel$export(module.exports, "HTTP_REQUEST_REDIRECT_END", () => $c97e36c8d40a3851$export$ee4948a3be025123, (v) => $c97e36c8d40a3851$export$ee4948a3be025123 = v);
$parcel$export(module.exports, "HTTP_REQUEST_REDIRECT_START", () => $c97e36c8d40a3851$export$e0021eb2979cddaa, (v) => $c97e36c8d40a3851$export$e0021eb2979cddaa = v);
$parcel$export(module.exports, "HTTP_REQUEST_REQUEST_START", () => $c97e36c8d40a3851$export$7c0ac0c19a45beac, (v) => $c97e36c8d40a3851$export$7c0ac0c19a45beac = v);
$parcel$export(module.exports, "HTTP_REQUEST_RESEND_COUNT", () => $c97e36c8d40a3851$export$6c32e9d84f534ee, (v) => $c97e36c8d40a3851$export$6c32e9d84f534ee = v);
$parcel$export(module.exports, "HTTP_REQUEST_RESPONSE_END", () => $c97e36c8d40a3851$export$d1f9fbdb211dd29b, (v) => $c97e36c8d40a3851$export$d1f9fbdb211dd29b = v);
$parcel$export(module.exports, "HTTP_REQUEST_RESPONSE_START", () => $c97e36c8d40a3851$export$45e7eea99a17d6e4, (v) => $c97e36c8d40a3851$export$45e7eea99a17d6e4 = v);
$parcel$export(module.exports, "HTTP_REQUEST_SAME_ORIGIN", () => $c97e36c8d40a3851$export$20ea34e16c0aa64f, (v) => $c97e36c8d40a3851$export$20ea34e16c0aa64f = v);
$parcel$export(module.exports, "HTTP_REQUEST_SECURE_CONNECTION_START", () => $c97e36c8d40a3851$export$8365b0f03557fae9, (v) => $c97e36c8d40a3851$export$8365b0f03557fae9 = v);
$parcel$export(module.exports, "HTTP_REQUEST_TIME_TO_FIRST_BYTE", () => $c97e36c8d40a3851$export$49ebbb9621675650, (v) => $c97e36c8d40a3851$export$49ebbb9621675650 = v);
$parcel$export(module.exports, "HTTP_REQUEST_WORKER_START", () => $c97e36c8d40a3851$export$842be66a901f093, (v) => $c97e36c8d40a3851$export$842be66a901f093 = v);
$parcel$export(module.exports, "HTTP_RESPONSE_BODY_SIZE", () => $c97e36c8d40a3851$export$a9f5a6cb28adccb1, (v) => $c97e36c8d40a3851$export$a9f5a6cb28adccb1 = v);
$parcel$export(module.exports, "HTTP_RESPONSE_CONTENT_LENGTH", () => $c97e36c8d40a3851$export$57b055d4bc586d67, (v) => $c97e36c8d40a3851$export$57b055d4bc586d67 = v);
$parcel$export(module.exports, "HTTP_RESPONSE_HEADER_CONTENT_LENGTH", () => $c97e36c8d40a3851$export$3ddfd660caa7bf7a, (v) => $c97e36c8d40a3851$export$3ddfd660caa7bf7a = v);
$parcel$export(module.exports, "HTTP_RESPONSE_HEADER_KEY", () => $c97e36c8d40a3851$export$fa7e1f5305153b3d, (v) => $c97e36c8d40a3851$export$fa7e1f5305153b3d = v);
$parcel$export(module.exports, "HTTP_RESPONSE_HEADER_KEY_BASE", () => $c97e36c8d40a3851$export$5674ce9d013eb7bd, (v) => $c97e36c8d40a3851$export$5674ce9d013eb7bd = v);
$parcel$export(module.exports, "HTTP_RESPONSE_SIZE", () => $c97e36c8d40a3851$export$6e8dc14cff6ccf72, (v) => $c97e36c8d40a3851$export$6e8dc14cff6ccf72 = v);
$parcel$export(module.exports, "HTTP_RESPONSE_STATUS_CODE", () => $c97e36c8d40a3851$export$afd59480458e1b57, (v) => $c97e36c8d40a3851$export$afd59480458e1b57 = v);
$parcel$export(module.exports, "HTTP_RESPONSE_TRANSFER_SIZE", () => $c97e36c8d40a3851$export$48e61fb9bccccba9, (v) => $c97e36c8d40a3851$export$48e61fb9bccccba9 = v);
$parcel$export(module.exports, "HTTP_ROUTE", () => $c97e36c8d40a3851$export$d3e674514dd3a3e1, (v) => $c97e36c8d40a3851$export$d3e674514dd3a3e1 = v);
$parcel$export(module.exports, "HTTP_SCHEME", () => $c97e36c8d40a3851$export$97ad02b50c60ef68, (v) => $c97e36c8d40a3851$export$97ad02b50c60ef68 = v);
$parcel$export(module.exports, "HTTP_SERVER_NAME", () => $c97e36c8d40a3851$export$61d053b1b63e82c4, (v) => $c97e36c8d40a3851$export$61d053b1b63e82c4 = v);
$parcel$export(module.exports, "HTTP_SERVER_REQUEST_TIME_IN_QUEUE", () => $c97e36c8d40a3851$export$54256cce0d674dea, (v) => $c97e36c8d40a3851$export$54256cce0d674dea = v);
$parcel$export(module.exports, "HTTP_STATUS_CODE", () => $c97e36c8d40a3851$export$8c01f0f407bcc5ca, (v) => $c97e36c8d40a3851$export$8c01f0f407bcc5ca = v);
$parcel$export(module.exports, "HTTP_TARGET", () => $c97e36c8d40a3851$export$be3f46982f6c7160, (v) => $c97e36c8d40a3851$export$be3f46982f6c7160 = v);
$parcel$export(module.exports, "HTTP_URL", () => $c97e36c8d40a3851$export$778e4213e2788579, (v) => $c97e36c8d40a3851$export$778e4213e2788579 = v);
$parcel$export(module.exports, "HTTP_USER_AGENT", () => $c97e36c8d40a3851$export$8b48ca3594d2b172, (v) => $c97e36c8d40a3851$export$8b48ca3594d2b172 = v);
$parcel$export(module.exports, "ID", () => $c97e36c8d40a3851$export$8be180ec26319f9f, (v) => $c97e36c8d40a3851$export$8be180ec26319f9f = v);
$parcel$export(module.exports, "INP", () => $c97e36c8d40a3851$export$60eccaddefa8fc1c, (v) => $c97e36c8d40a3851$export$60eccaddefa8fc1c = v);
$parcel$export(module.exports, "JSONRPC_PROTOCOL_VERSION", () => $c97e36c8d40a3851$export$c99ce4fe37484d84, (v) => $c97e36c8d40a3851$export$c99ce4fe37484d84 = v);
$parcel$export(module.exports, "JSONRPC_REQUEST_ID", () => $c97e36c8d40a3851$export$fdf432fcac7d8f37, (v) => $c97e36c8d40a3851$export$fdf432fcac7d8f37 = v);
$parcel$export(module.exports, "JVM_GC_ACTION", () => $c97e36c8d40a3851$export$4c21cc9cdf2f5dbd, (v) => $c97e36c8d40a3851$export$4c21cc9cdf2f5dbd = v);
$parcel$export(module.exports, "JVM_GC_NAME", () => $c97e36c8d40a3851$export$dcc1eab7f3f31816, (v) => $c97e36c8d40a3851$export$dcc1eab7f3f31816 = v);
$parcel$export(module.exports, "JVM_MEMORY_POOL_NAME", () => $c97e36c8d40a3851$export$dcb7f1379b2b8f86, (v) => $c97e36c8d40a3851$export$dcb7f1379b2b8f86 = v);
$parcel$export(module.exports, "JVM_MEMORY_TYPE", () => $c97e36c8d40a3851$export$53416edeea4c2d74, (v) => $c97e36c8d40a3851$export$53416edeea4c2d74 = v);
$parcel$export(module.exports, "JVM_THREAD_DAEMON", () => $c97e36c8d40a3851$export$69f7e5d2b74c5c9e, (v) => $c97e36c8d40a3851$export$69f7e5d2b74c5c9e = v);
$parcel$export(module.exports, "JVM_THREAD_STATE", () => $c97e36c8d40a3851$export$8e104aed582a26bc, (v) => $c97e36c8d40a3851$export$8e104aed582a26bc = v);
$parcel$export(module.exports, "KOA_NAME", () => $c97e36c8d40a3851$export$577047501949be9, (v) => $c97e36c8d40a3851$export$577047501949be9 = v);
$parcel$export(module.exports, "KOA_TYPE", () => $c97e36c8d40a3851$export$c4c45b599a2c15e, (v) => $c97e36c8d40a3851$export$c4c45b599a2c15e = v);
$parcel$export(module.exports, "LCP", () => $c97e36c8d40a3851$export$361cb541700d648e, (v) => $c97e36c8d40a3851$export$361cb541700d648e = v);
$parcel$export(module.exports, "LCP_ELEMENT", () => $c97e36c8d40a3851$export$974f160e11f25731, (v) => $c97e36c8d40a3851$export$974f160e11f25731 = v);
$parcel$export(module.exports, "LCP_ID", () => $c97e36c8d40a3851$export$7162f5c702b95903, (v) => $c97e36c8d40a3851$export$7162f5c702b95903 = v);
$parcel$export(module.exports, "LCP_LOADTIME", () => $c97e36c8d40a3851$export$a034d066a9090500, (v) => $c97e36c8d40a3851$export$a034d066a9090500 = v);
$parcel$export(module.exports, "LCP_RENDERTIME", () => $c97e36c8d40a3851$export$70938021e43e047c, (v) => $c97e36c8d40a3851$export$70938021e43e047c = v);
$parcel$export(module.exports, "LCP_SIZE", () => $c97e36c8d40a3851$export$5f6ac460012a73bb, (v) => $c97e36c8d40a3851$export$5f6ac460012a73bb = v);
$parcel$export(module.exports, "LCP_URL", () => $c97e36c8d40a3851$export$d8e498c1c670bcbf, (v) => $c97e36c8d40a3851$export$d8e498c1c670bcbf = v);
$parcel$export(module.exports, "LOGGER_NAME", () => $c97e36c8d40a3851$export$cc1a78a24d947903, (v) => $c97e36c8d40a3851$export$cc1a78a24d947903 = v);
$parcel$export(module.exports, "MCP_CANCELLED_REASON", () => $c97e36c8d40a3851$export$d29b927e0bb0ffea, (v) => $c97e36c8d40a3851$export$d29b927e0bb0ffea = v);
$parcel$export(module.exports, "MCP_CANCELLED_REQUEST_ID", () => $c97e36c8d40a3851$export$b3999cacef245779, (v) => $c97e36c8d40a3851$export$b3999cacef245779 = v);
$parcel$export(module.exports, "MCP_CLIENT_NAME", () => $c97e36c8d40a3851$export$ff168b5f9cf9dcf6, (v) => $c97e36c8d40a3851$export$ff168b5f9cf9dcf6 = v);
$parcel$export(module.exports, "MCP_CLIENT_TITLE", () => $c97e36c8d40a3851$export$2ab876a45bd6e64, (v) => $c97e36c8d40a3851$export$2ab876a45bd6e64 = v);
$parcel$export(module.exports, "MCP_CLIENT_VERSION", () => $c97e36c8d40a3851$export$cb8027e4395c6c0e, (v) => $c97e36c8d40a3851$export$cb8027e4395c6c0e = v);
$parcel$export(module.exports, "MCP_LIFECYCLE_PHASE", () => $c97e36c8d40a3851$export$f5303d1bac3c2660, (v) => $c97e36c8d40a3851$export$f5303d1bac3c2660 = v);
$parcel$export(module.exports, "MCP_LOGGING_DATA_TYPE", () => $c97e36c8d40a3851$export$6c463c5f3b00f64, (v) => $c97e36c8d40a3851$export$6c463c5f3b00f64 = v);
$parcel$export(module.exports, "MCP_LOGGING_LEVEL", () => $c97e36c8d40a3851$export$e25d553065457cab, (v) => $c97e36c8d40a3851$export$e25d553065457cab = v);
$parcel$export(module.exports, "MCP_LOGGING_LOGGER", () => $c97e36c8d40a3851$export$15d24c154ea8a56f, (v) => $c97e36c8d40a3851$export$15d24c154ea8a56f = v);
$parcel$export(module.exports, "MCP_LOGGING_MESSAGE", () => $c97e36c8d40a3851$export$e5065789a6c415d0, (v) => $c97e36c8d40a3851$export$e5065789a6c415d0 = v);
$parcel$export(module.exports, "MCP_METHOD_NAME", () => $c97e36c8d40a3851$export$62662c561d7c7835, (v) => $c97e36c8d40a3851$export$62662c561d7c7835 = v);
$parcel$export(module.exports, "MCP_PROGRESS_CURRENT", () => $c97e36c8d40a3851$export$218f394557fb0a5a, (v) => $c97e36c8d40a3851$export$218f394557fb0a5a = v);
$parcel$export(module.exports, "MCP_PROGRESS_MESSAGE", () => $c97e36c8d40a3851$export$2a5ff6de5448ecdf, (v) => $c97e36c8d40a3851$export$2a5ff6de5448ecdf = v);
$parcel$export(module.exports, "MCP_PROGRESS_PERCENTAGE", () => $c97e36c8d40a3851$export$9d23f3030ed2597e, (v) => $c97e36c8d40a3851$export$9d23f3030ed2597e = v);
$parcel$export(module.exports, "MCP_PROGRESS_TOKEN", () => $c97e36c8d40a3851$export$a26ff217a6124160, (v) => $c97e36c8d40a3851$export$a26ff217a6124160 = v);
$parcel$export(module.exports, "MCP_PROGRESS_TOTAL", () => $c97e36c8d40a3851$export$c8072f5fcfdb5b77, (v) => $c97e36c8d40a3851$export$c8072f5fcfdb5b77 = v);
$parcel$export(module.exports, "MCP_PROMPT_NAME", () => $c97e36c8d40a3851$export$c4e4b74f1ccf3d96, (v) => $c97e36c8d40a3851$export$c4e4b74f1ccf3d96 = v);
$parcel$export(module.exports, "MCP_PROMPT_RESULT_DESCRIPTION", () => $c97e36c8d40a3851$export$328519d02a26ac41, (v) => $c97e36c8d40a3851$export$328519d02a26ac41 = v);
$parcel$export(module.exports, "MCP_PROMPT_RESULT_MESSAGE_CONTENT", () => $c97e36c8d40a3851$export$d2061b291c43d045, (v) => $c97e36c8d40a3851$export$d2061b291c43d045 = v);
$parcel$export(module.exports, "MCP_PROMPT_RESULT_MESSAGE_COUNT", () => $c97e36c8d40a3851$export$d1f04dfd3d695286, (v) => $c97e36c8d40a3851$export$d1f04dfd3d695286 = v);
$parcel$export(module.exports, "MCP_PROMPT_RESULT_MESSAGE_ROLE", () => $c97e36c8d40a3851$export$234fbd86ea0f0bd8, (v) => $c97e36c8d40a3851$export$234fbd86ea0f0bd8 = v);
$parcel$export(module.exports, "MCP_PROTOCOL_READY", () => $c97e36c8d40a3851$export$e795000978a75b12, (v) => $c97e36c8d40a3851$export$e795000978a75b12 = v);
$parcel$export(module.exports, "MCP_PROTOCOL_VERSION", () => $c97e36c8d40a3851$export$9f4683b4d1018ace, (v) => $c97e36c8d40a3851$export$9f4683b4d1018ace = v);
$parcel$export(module.exports, "MCP_REQUEST_ARGUMENT_KEY", () => $c97e36c8d40a3851$export$e431b042fcdb1d63, (v) => $c97e36c8d40a3851$export$e431b042fcdb1d63 = v);
$parcel$export(module.exports, "MCP_REQUEST_ARGUMENT_KEY_BASE", () => $c97e36c8d40a3851$export$a453239171ac9a23, (v) => $c97e36c8d40a3851$export$a453239171ac9a23 = v);
$parcel$export(module.exports, "MCP_REQUEST_ARGUMENT_NAME", () => $c97e36c8d40a3851$export$3a7726a976c18d5f, (v) => $c97e36c8d40a3851$export$3a7726a976c18d5f = v);
$parcel$export(module.exports, "MCP_REQUEST_ARGUMENT_URI", () => $c97e36c8d40a3851$export$7eca7a6c06843b93, (v) => $c97e36c8d40a3851$export$7eca7a6c06843b93 = v);
$parcel$export(module.exports, "MCP_REQUEST_ID", () => $c97e36c8d40a3851$export$f25c55f83e5b0672, (v) => $c97e36c8d40a3851$export$f25c55f83e5b0672 = v);
$parcel$export(module.exports, "MCP_RESOURCE_PROTOCOL", () => $c97e36c8d40a3851$export$9562bfac4eb079cb, (v) => $c97e36c8d40a3851$export$9562bfac4eb079cb = v);
$parcel$export(module.exports, "MCP_RESOURCE_URI", () => $c97e36c8d40a3851$export$c276d164ff91d2f7, (v) => $c97e36c8d40a3851$export$c276d164ff91d2f7 = v);
$parcel$export(module.exports, "MCP_SERVER_NAME", () => $c97e36c8d40a3851$export$2f3e0574f1a99754, (v) => $c97e36c8d40a3851$export$2f3e0574f1a99754 = v);
$parcel$export(module.exports, "MCP_SERVER_TITLE", () => $c97e36c8d40a3851$export$15eecaab68167880, (v) => $c97e36c8d40a3851$export$15eecaab68167880 = v);
$parcel$export(module.exports, "MCP_SERVER_VERSION", () => $c97e36c8d40a3851$export$513c47f6e194086a, (v) => $c97e36c8d40a3851$export$513c47f6e194086a = v);
$parcel$export(module.exports, "MCP_SESSION_ID", () => $c97e36c8d40a3851$export$a3f464c4d5cd9096, (v) => $c97e36c8d40a3851$export$a3f464c4d5cd9096 = v);
$parcel$export(module.exports, "MCP_TOOL_NAME", () => $c97e36c8d40a3851$export$ed366a03a2330b03, (v) => $c97e36c8d40a3851$export$ed366a03a2330b03 = v);
$parcel$export(module.exports, "MCP_TOOL_RESULT_CONTENT", () => $c97e36c8d40a3851$export$9b802c784f235e1d, (v) => $c97e36c8d40a3851$export$9b802c784f235e1d = v);
$parcel$export(module.exports, "MCP_TOOL_RESULT_CONTENT_COUNT", () => $c97e36c8d40a3851$export$add0fc8b8c5726a4, (v) => $c97e36c8d40a3851$export$add0fc8b8c5726a4 = v);
$parcel$export(module.exports, "MCP_TOOL_RESULT_IS_ERROR", () => $c97e36c8d40a3851$export$e7f32463f5bfd554, (v) => $c97e36c8d40a3851$export$e7f32463f5bfd554 = v);
$parcel$export(module.exports, "MCP_TRANSPORT", () => $c97e36c8d40a3851$export$f9346f394edf26a, (v) => $c97e36c8d40a3851$export$f9346f394edf26a = v);
$parcel$export(module.exports, "MDC_KEY", () => $c97e36c8d40a3851$export$16b917774e73ef92, (v) => $c97e36c8d40a3851$export$16b917774e73ef92 = v);
$parcel$export(module.exports, "MDC_KEY_BASE", () => $c97e36c8d40a3851$export$15d2b60bf3b65454, (v) => $c97e36c8d40a3851$export$15d2b60bf3b65454 = v);
$parcel$export(module.exports, "MESSAGING_BATCH_MESSAGE_COUNT", () => $c97e36c8d40a3851$export$db55eca5af256142, (v) => $c97e36c8d40a3851$export$db55eca5af256142 = v);
$parcel$export(module.exports, "MESSAGING_DESTINATION", () => $c97e36c8d40a3851$export$967c74f8b1f3d35, (v) => $c97e36c8d40a3851$export$967c74f8b1f3d35 = v);
$parcel$export(module.exports, "MESSAGING_DESTINATION_CONNECTION", () => $c97e36c8d40a3851$export$7c33ae67962515d1, (v) => $c97e36c8d40a3851$export$7c33ae67962515d1 = v);
$parcel$export(module.exports, "MESSAGING_DESTINATION_NAME", () => $c97e36c8d40a3851$export$9c69839b2d93489b, (v) => $c97e36c8d40a3851$export$9c69839b2d93489b = v);
$parcel$export(module.exports, "MESSAGING_MESSAGE_BODY_SIZE", () => $c97e36c8d40a3851$export$be22d22d4b6cf5d8, (v) => $c97e36c8d40a3851$export$be22d22d4b6cf5d8 = v);
$parcel$export(module.exports, "MESSAGING_MESSAGE_CONVERSATION_ID", () => $c97e36c8d40a3851$export$c529961b911626ac, (v) => $c97e36c8d40a3851$export$c529961b911626ac = v);
$parcel$export(module.exports, "MESSAGING_MESSAGE_ENVELOPE_SIZE", () => $c97e36c8d40a3851$export$e39c4b15d2881f5, (v) => $c97e36c8d40a3851$export$e39c4b15d2881f5 = v);
$parcel$export(module.exports, "MESSAGING_MESSAGE_ID", () => $c97e36c8d40a3851$export$a8ca145161313e7, (v) => $c97e36c8d40a3851$export$a8ca145161313e7 = v);
$parcel$export(module.exports, "MESSAGING_MESSAGE_RECEIVE_LATENCY", () => $c97e36c8d40a3851$export$3c1204d03918d076, (v) => $c97e36c8d40a3851$export$3c1204d03918d076 = v);
$parcel$export(module.exports, "MESSAGING_MESSAGE_RETRY_COUNT", () => $c97e36c8d40a3851$export$eaac3f141165e288, (v) => $c97e36c8d40a3851$export$eaac3f141165e288 = v);
$parcel$export(module.exports, "MESSAGING_OPERATION_NAME", () => $c97e36c8d40a3851$export$4c7e6934714150e6, (v) => $c97e36c8d40a3851$export$4c7e6934714150e6 = v);
$parcel$export(module.exports, "MESSAGING_OPERATION_TYPE", () => $c97e36c8d40a3851$export$6f71f9711d666eb4, (v) => $c97e36c8d40a3851$export$6f71f9711d666eb4 = v);
$parcel$export(module.exports, "MESSAGING_RABBITMQ_DESTINATION_ROUTING_KEY", () => $c97e36c8d40a3851$export$2a3cd2bb71fb63a4, (v) => $c97e36c8d40a3851$export$2a3cd2bb71fb63a4 = v);
$parcel$export(module.exports, "MESSAGING_SYSTEM", () => $c97e36c8d40a3851$export$55478a0b7d2ae98f, (v) => $c97e36c8d40a3851$export$55478a0b7d2ae98f = v);
$parcel$export(module.exports, "METHOD", () => $c97e36c8d40a3851$export$bed10c4da9b8eb0a, (v) => $c97e36c8d40a3851$export$bed10c4da9b8eb0a = v);
$parcel$export(module.exports, "MIDDLEWARE_NAME", () => $c97e36c8d40a3851$export$a82607b6424c06c8, (v) => $c97e36c8d40a3851$export$a82607b6424c06c8 = v);
$parcel$export(module.exports, "NAVIGATION_ORIGIN", () => $c97e36c8d40a3851$export$6b081f3484c7f4e5, (v) => $c97e36c8d40a3851$export$6b081f3484c7f4e5 = v);
$parcel$export(module.exports, "NAVIGATION_ROUTE_ID", () => $c97e36c8d40a3851$export$b7754d85fd39406c, (v) => $c97e36c8d40a3851$export$b7754d85fd39406c = v);
$parcel$export(module.exports, "NAVIGATION_TYPE", () => $c97e36c8d40a3851$export$492856c046eb4728, (v) => $c97e36c8d40a3851$export$492856c046eb4728 = v);
$parcel$export(module.exports, "NEL_ELAPSED_TIME", () => $c97e36c8d40a3851$export$c1678a2059fbe906, (v) => $c97e36c8d40a3851$export$c1678a2059fbe906 = v);
$parcel$export(module.exports, "NEL_PHASE", () => $c97e36c8d40a3851$export$6d384a0bc1011c34, (v) => $c97e36c8d40a3851$export$6d384a0bc1011c34 = v);
$parcel$export(module.exports, "NEL_REFERRER", () => $c97e36c8d40a3851$export$1499a7dbfc01e7d4, (v) => $c97e36c8d40a3851$export$1499a7dbfc01e7d4 = v);
$parcel$export(module.exports, "NEL_SAMPLING_FUNCTION", () => $c97e36c8d40a3851$export$cfcbff40019f0ff1, (v) => $c97e36c8d40a3851$export$cfcbff40019f0ff1 = v);
$parcel$export(module.exports, "NEL_TYPE", () => $c97e36c8d40a3851$export$27157b5f68e583af, (v) => $c97e36c8d40a3851$export$27157b5f68e583af = v);
$parcel$export(module.exports, "NETWORK_CONNECTION_EFFECTIVE_TYPE", () => $c97e36c8d40a3851$export$54bf5ed61532925d, (v) => $c97e36c8d40a3851$export$54bf5ed61532925d = v);
$parcel$export(module.exports, "NETWORK_CONNECTION_RTT", () => $c97e36c8d40a3851$export$60ed0786292ace08, (v) => $c97e36c8d40a3851$export$60ed0786292ace08 = v);
$parcel$export(module.exports, "NETWORK_CONNECTION_TYPE", () => $c97e36c8d40a3851$export$d770bfb8345e146, (v) => $c97e36c8d40a3851$export$d770bfb8345e146 = v);
$parcel$export(module.exports, "NETWORK_LOCAL_ADDRESS", () => $c97e36c8d40a3851$export$bb73817f1290ad28, (v) => $c97e36c8d40a3851$export$bb73817f1290ad28 = v);
$parcel$export(module.exports, "NETWORK_LOCAL_PORT", () => $c97e36c8d40a3851$export$f201c980f2b75802, (v) => $c97e36c8d40a3851$export$f201c980f2b75802 = v);
$parcel$export(module.exports, "NETWORK_PEER_ADDRESS", () => $c97e36c8d40a3851$export$b40e970572afd0ee, (v) => $c97e36c8d40a3851$export$b40e970572afd0ee = v);
$parcel$export(module.exports, "NETWORK_PEER_PORT", () => $c97e36c8d40a3851$export$8850630a3d343488, (v) => $c97e36c8d40a3851$export$8850630a3d343488 = v);
$parcel$export(module.exports, "NETWORK_PROTOCOL_NAME", () => $c97e36c8d40a3851$export$fd0a39a918d6516f, (v) => $c97e36c8d40a3851$export$fd0a39a918d6516f = v);
$parcel$export(module.exports, "NETWORK_PROTOCOL_VERSION", () => $c97e36c8d40a3851$export$e68ef41f8e0335bf, (v) => $c97e36c8d40a3851$export$e68ef41f8e0335bf = v);
$parcel$export(module.exports, "NETWORK_TRANSPORT", () => $c97e36c8d40a3851$export$5bff09650e762829, (v) => $c97e36c8d40a3851$export$5bff09650e762829 = v);
$parcel$export(module.exports, "NETWORK_TYPE", () => $c97e36c8d40a3851$export$21c1adce0e067f37, (v) => $c97e36c8d40a3851$export$21c1adce0e067f37 = v);
$parcel$export(module.exports, "NET_HOST_IP", () => $c97e36c8d40a3851$export$fed6ce86f48c84bc, (v) => $c97e36c8d40a3851$export$fed6ce86f48c84bc = v);
$parcel$export(module.exports, "NET_HOST_NAME", () => $c97e36c8d40a3851$export$500c2675137ac16e, (v) => $c97e36c8d40a3851$export$500c2675137ac16e = v);
$parcel$export(module.exports, "NET_HOST_PORT", () => $c97e36c8d40a3851$export$402c7728623fd8df, (v) => $c97e36c8d40a3851$export$402c7728623fd8df = v);
$parcel$export(module.exports, "NET_PEER_IP", () => $c97e36c8d40a3851$export$15417259f4c0fe6b, (v) => $c97e36c8d40a3851$export$15417259f4c0fe6b = v);
$parcel$export(module.exports, "NET_PEER_NAME", () => $c97e36c8d40a3851$export$2b3b7f579a727f45, (v) => $c97e36c8d40a3851$export$2b3b7f579a727f45 = v);
$parcel$export(module.exports, "NET_PEER_PORT", () => $c97e36c8d40a3851$export$514832a0b029734b, (v) => $c97e36c8d40a3851$export$514832a0b029734b = v);
$parcel$export(module.exports, "NET_PROTOCOL_NAME", () => $c97e36c8d40a3851$export$b0522e6a14dec1a4, (v) => $c97e36c8d40a3851$export$b0522e6a14dec1a4 = v);
$parcel$export(module.exports, "NET_PROTOCOL_VERSION", () => $c97e36c8d40a3851$export$659ea19f71a7ee0b, (v) => $c97e36c8d40a3851$export$659ea19f71a7ee0b = v);
$parcel$export(module.exports, "NET_SOCK_FAMILY", () => $c97e36c8d40a3851$export$1b61d972db315e73, (v) => $c97e36c8d40a3851$export$1b61d972db315e73 = v);
$parcel$export(module.exports, "NET_SOCK_HOST_ADDR", () => $c97e36c8d40a3851$export$fb2970ee11a479ee, (v) => $c97e36c8d40a3851$export$fb2970ee11a479ee = v);
$parcel$export(module.exports, "NET_SOCK_HOST_PORT", () => $c97e36c8d40a3851$export$920aceb2a8fad77e, (v) => $c97e36c8d40a3851$export$920aceb2a8fad77e = v);
$parcel$export(module.exports, "NET_SOCK_PEER_ADDR", () => $c97e36c8d40a3851$export$48f8f6fbc999d187, (v) => $c97e36c8d40a3851$export$48f8f6fbc999d187 = v);
$parcel$export(module.exports, "NET_SOCK_PEER_NAME", () => $c97e36c8d40a3851$export$eed590fa00a8223b, (v) => $c97e36c8d40a3851$export$eed590fa00a8223b = v);
$parcel$export(module.exports, "NET_SOCK_PEER_PORT", () => $c97e36c8d40a3851$export$f2e5bb5cd4a130da, (v) => $c97e36c8d40a3851$export$f2e5bb5cd4a130da = v);
$parcel$export(module.exports, "NET_TRANSPORT", () => $c97e36c8d40a3851$export$779ef03d633a9086, (v) => $c97e36c8d40a3851$export$779ef03d633a9086 = v);
$parcel$export(module.exports, "OS_BUILD", () => $c97e36c8d40a3851$export$d98b87c8d53d0dbc, (v) => $c97e36c8d40a3851$export$d98b87c8d53d0dbc = v);
$parcel$export(module.exports, "OS_BUILD_ID", () => $c97e36c8d40a3851$export$ca719aa57653a0a7, (v) => $c97e36c8d40a3851$export$ca719aa57653a0a7 = v);
$parcel$export(module.exports, "OS_DESCRIPTION", () => $c97e36c8d40a3851$export$74b19c5f48270c05, (v) => $c97e36c8d40a3851$export$74b19c5f48270c05 = v);
$parcel$export(module.exports, "OS_KERNEL_VERSION", () => $c97e36c8d40a3851$export$c351affe7e8098cb, (v) => $c97e36c8d40a3851$export$c351affe7e8098cb = v);
$parcel$export(module.exports, "OS_NAME", () => $c97e36c8d40a3851$export$be7cd6b3ae3ae765, (v) => $c97e36c8d40a3851$export$be7cd6b3ae3ae765 = v);
$parcel$export(module.exports, "OS_RAW_DESCRIPTION", () => $c97e36c8d40a3851$export$ec182524c4c57275, (v) => $c97e36c8d40a3851$export$ec182524c4c57275 = v);
$parcel$export(module.exports, "OS_ROOTED", () => $c97e36c8d40a3851$export$9e45758246a85b07, (v) => $c97e36c8d40a3851$export$9e45758246a85b07 = v);
$parcel$export(module.exports, "OS_THEME", () => $c97e36c8d40a3851$export$9fa5d5f0144954cb, (v) => $c97e36c8d40a3851$export$9fa5d5f0144954cb = v);
$parcel$export(module.exports, "OS_TYPE", () => $c97e36c8d40a3851$export$e66ba5bc4b978023, (v) => $c97e36c8d40a3851$export$e66ba5bc4b978023 = v);
$parcel$export(module.exports, "OS_VERSION", () => $c97e36c8d40a3851$export$2306e23cc611a36d, (v) => $c97e36c8d40a3851$export$2306e23cc611a36d = v);
$parcel$export(module.exports, "OTEL_KIND", () => $c97e36c8d40a3851$export$144f8c1fe01428db, (v) => $c97e36c8d40a3851$export$144f8c1fe01428db = v);
$parcel$export(module.exports, "OTEL_SCOPE_NAME", () => $c97e36c8d40a3851$export$f303b2744d52121c, (v) => $c97e36c8d40a3851$export$f303b2744d52121c = v);
$parcel$export(module.exports, "OTEL_SCOPE_VERSION", () => $c97e36c8d40a3851$export$866b2dbc7bf18ce6, (v) => $c97e36c8d40a3851$export$866b2dbc7bf18ce6 = v);
$parcel$export(module.exports, "OTEL_STATUS_CODE", () => $c97e36c8d40a3851$export$b4c85774878b4841, (v) => $c97e36c8d40a3851$export$b4c85774878b4841 = v);
$parcel$export(module.exports, "OTEL_STATUS_DESCRIPTION", () => $c97e36c8d40a3851$export$1c967a71bc9a3077, (v) => $c97e36c8d40a3851$export$1c967a71bc9a3077 = v);
$parcel$export(module.exports, "PARAMS_KEY", () => $c97e36c8d40a3851$export$5e3884a35a19eb90, (v) => $c97e36c8d40a3851$export$5e3884a35a19eb90 = v);
$parcel$export(module.exports, "PARAMS_KEY_BASE", () => $c97e36c8d40a3851$export$6e7ff99bb3259573, (v) => $c97e36c8d40a3851$export$6e7ff99bb3259573 = v);
$parcel$export(module.exports, "PERFORMANCE_ACTIVATIONSTART", () => $c97e36c8d40a3851$export$7c932cba2d9e7a7, (v) => $c97e36c8d40a3851$export$7c932cba2d9e7a7 = v);
$parcel$export(module.exports, "PERFORMANCE_TIMEORIGIN", () => $c97e36c8d40a3851$export$94091942edce0667, (v) => $c97e36c8d40a3851$export$94091942edce0667 = v);
$parcel$export(module.exports, "PREVIOUS_ROUTE", () => $c97e36c8d40a3851$export$3671a8a524706a9d, (v) => $c97e36c8d40a3851$export$3671a8a524706a9d = v);
$parcel$export(module.exports, "PROCESS_COMMAND_ARGS", () => $c97e36c8d40a3851$export$c288888dc82d233f, (v) => $c97e36c8d40a3851$export$c288888dc82d233f = v);
$parcel$export(module.exports, "PROCESS_EXECUTABLE_NAME", () => $c97e36c8d40a3851$export$8ff188536cebc35, (v) => $c97e36c8d40a3851$export$8ff188536cebc35 = v);
$parcel$export(module.exports, "PROCESS_PID", () => $c97e36c8d40a3851$export$6407d78968c0eabe, (v) => $c97e36c8d40a3851$export$6407d78968c0eabe = v);
$parcel$export(module.exports, "PROCESS_RUNTIME_DESCRIPTION", () => $c97e36c8d40a3851$export$43e9fb9ec28d9743, (v) => $c97e36c8d40a3851$export$43e9fb9ec28d9743 = v);
$parcel$export(module.exports, "PROCESS_RUNTIME_ENGINE_NAME", () => $c97e36c8d40a3851$export$26f31d5c5c201739, (v) => $c97e36c8d40a3851$export$26f31d5c5c201739 = v);
$parcel$export(module.exports, "PROCESS_RUNTIME_ENGINE_VERSION", () => $c97e36c8d40a3851$export$bff85124d2d35b93, (v) => $c97e36c8d40a3851$export$bff85124d2d35b93 = v);
$parcel$export(module.exports, "PROCESS_RUNTIME_NAME", () => $c97e36c8d40a3851$export$495c671ed5a6408c, (v) => $c97e36c8d40a3851$export$495c671ed5a6408c = v);
$parcel$export(module.exports, "PROCESS_RUNTIME_VERSION", () => $c97e36c8d40a3851$export$54b3d4d5548c35c3, (v) => $c97e36c8d40a3851$export$54b3d4d5548c35c3 = v);
$parcel$export(module.exports, "QUERY_KEY", () => $c97e36c8d40a3851$export$2954db6444fe1fa8, (v) => $c97e36c8d40a3851$export$2954db6444fe1fa8 = v);
$parcel$export(module.exports, "QUERY_KEY_BASE", () => $c97e36c8d40a3851$export$15c1c974d16dd678, (v) => $c97e36c8d40a3851$export$15c1c974d16dd678 = v);
$parcel$export(module.exports, "REACT_VERSION", () => $c97e36c8d40a3851$export$9be2ae89a1eac217, (v) => $c97e36c8d40a3851$export$9be2ae89a1eac217 = v);
$parcel$export(module.exports, "RELEASE", () => $c97e36c8d40a3851$export$5c698591c0e586a2, (v) => $c97e36c8d40a3851$export$5c698591c0e586a2 = v);
$parcel$export(module.exports, "REMIX_ACTION_FORM_DATA_KEY", () => $c97e36c8d40a3851$export$b711f2bb9c9a848a, (v) => $c97e36c8d40a3851$export$b711f2bb9c9a848a = v);
$parcel$export(module.exports, "REMIX_ACTION_FORM_DATA_KEY_BASE", () => $c97e36c8d40a3851$export$1d3a8501efd30213, (v) => $c97e36c8d40a3851$export$1d3a8501efd30213 = v);
$parcel$export(module.exports, "REPLAY_ID", () => $c97e36c8d40a3851$export$cebaf684ced5a2c9, (v) => $c97e36c8d40a3851$export$cebaf684ced5a2c9 = v);
$parcel$export(module.exports, "RESOURCE_DEPLOYMENT_ENVIRONMENT", () => $c97e36c8d40a3851$export$d4c658ecdcb7c78c, (v) => $c97e36c8d40a3851$export$d4c658ecdcb7c78c = v);
$parcel$export(module.exports, "RESOURCE_DEPLOYMENT_ENVIRONMENT_NAME", () => $c97e36c8d40a3851$export$b1b162b01baeb044, (v) => $c97e36c8d40a3851$export$b1b162b01baeb044 = v);
$parcel$export(module.exports, "RESOURCE_RENDER_BLOCKING_STATUS", () => $c97e36c8d40a3851$export$8be2d593d7f88ed8, (v) => $c97e36c8d40a3851$export$8be2d593d7f88ed8 = v);
$parcel$export(module.exports, "ROUTE", () => $c97e36c8d40a3851$export$dbd0a3528a97ccc0, (v) => $c97e36c8d40a3851$export$dbd0a3528a97ccc0 = v);
$parcel$export(module.exports, "RPC_GRPC_STATUS_CODE", () => $c97e36c8d40a3851$export$66581dc6d3d083d1, (v) => $c97e36c8d40a3851$export$66581dc6d3d083d1 = v);
$parcel$export(module.exports, "RPC_METHOD", () => $c97e36c8d40a3851$export$e545f99e7abcc499, (v) => $c97e36c8d40a3851$export$e545f99e7abcc499 = v);
$parcel$export(module.exports, "RPC_RESPONSE_STATUS_CODE", () => $c97e36c8d40a3851$export$7e1af5787f8c4aaa, (v) => $c97e36c8d40a3851$export$7e1af5787f8c4aaa = v);
$parcel$export(module.exports, "RPC_SERVICE", () => $c97e36c8d40a3851$export$186c94c351c54768, (v) => $c97e36c8d40a3851$export$186c94c351c54768 = v);
$parcel$export(module.exports, "RPC_SYSTEM", () => $c97e36c8d40a3851$export$2e3fd8dfcb16fe0c, (v) => $c97e36c8d40a3851$export$2e3fd8dfcb16fe0c = v);
$parcel$export(module.exports, "RPC_SYSTEM_NAME", () => $c97e36c8d40a3851$export$7eeeceaa1dbd7cd5, (v) => $c97e36c8d40a3851$export$7eeeceaa1dbd7cd5 = v);
$parcel$export(module.exports, "RUNTIME_BUILD", () => $c97e36c8d40a3851$export$9d5bffdff936d554, (v) => $c97e36c8d40a3851$export$9d5bffdff936d554 = v);
$parcel$export(module.exports, "RUNTIME_NAME", () => $c97e36c8d40a3851$export$dc3a801c9a2c5b79, (v) => $c97e36c8d40a3851$export$dc3a801c9a2c5b79 = v);
$parcel$export(module.exports, "RUNTIME_RAW_DESCRIPTION", () => $c97e36c8d40a3851$export$27933a9557f87e98, (v) => $c97e36c8d40a3851$export$27933a9557f87e98 = v);
$parcel$export(module.exports, "RUNTIME_VERSION", () => $c97e36c8d40a3851$export$eefa737b40a0d535, (v) => $c97e36c8d40a3851$export$eefa737b40a0d535 = v);
$parcel$export(module.exports, "SCORE_KEY", () => $c97e36c8d40a3851$export$92740ffbcb02553b, (v) => $c97e36c8d40a3851$export$92740ffbcb02553b = v);
$parcel$export(module.exports, "SCORE_KEY_BASE", () => $c97e36c8d40a3851$export$500e89753f9f1008, (v) => $c97e36c8d40a3851$export$500e89753f9f1008 = v);
$parcel$export(module.exports, "SCORE_RATIO_KEY", () => $c97e36c8d40a3851$export$d91a18e47fdddefd, (v) => $c97e36c8d40a3851$export$d91a18e47fdddefd = v);
$parcel$export(module.exports, "SCORE_RATIO_KEY_BASE", () => $c97e36c8d40a3851$export$eccbe6f20884ea7f, (v) => $c97e36c8d40a3851$export$eccbe6f20884ea7f = v);
$parcel$export(module.exports, "SCORE_TOTAL", () => $c97e36c8d40a3851$export$9e24f11d79141afb, (v) => $c97e36c8d40a3851$export$9e24f11d79141afb = v);
$parcel$export(module.exports, "SCORE_WEIGHT_KEY", () => $c97e36c8d40a3851$export$f0b96ad9586f8887, (v) => $c97e36c8d40a3851$export$f0b96ad9586f8887 = v);
$parcel$export(module.exports, "SCORE_WEIGHT_KEY_BASE", () => $c97e36c8d40a3851$export$8a92ed5d436a85c6, (v) => $c97e36c8d40a3851$export$8a92ed5d436a85c6 = v);
$parcel$export(module.exports, "SENTRY_ACTION", () => $c97e36c8d40a3851$export$edd59acdf7e86a71, (v) => $c97e36c8d40a3851$export$edd59acdf7e86a71 = v);
$parcel$export(module.exports, "SENTRY_BROWSER_NAME", () => $c97e36c8d40a3851$export$ae81a1ae71952d50, (v) => $c97e36c8d40a3851$export$ae81a1ae71952d50 = v);
$parcel$export(module.exports, "SENTRY_BROWSER_VERSION", () => $c97e36c8d40a3851$export$6101470cd57eac1b, (v) => $c97e36c8d40a3851$export$6101470cd57eac1b = v);
$parcel$export(module.exports, "SENTRY_CANCELLATION_REASON", () => $c97e36c8d40a3851$export$452c0aee9673fe67, (v) => $c97e36c8d40a3851$export$452c0aee9673fe67 = v);
$parcel$export(module.exports, "SENTRY_CATEGORY", () => $c97e36c8d40a3851$export$773dddd1e8667756, (v) => $c97e36c8d40a3851$export$773dddd1e8667756 = v);
$parcel$export(module.exports, "SENTRY_CLIENT_SAMPLE_RATE", () => $c97e36c8d40a3851$export$98815f8579a64a90, (v) => $c97e36c8d40a3851$export$98815f8579a64a90 = v);
$parcel$export(module.exports, "SENTRY_DESCRIPTION", () => $c97e36c8d40a3851$export$7bc4e27428665019, (v) => $c97e36c8d40a3851$export$7bc4e27428665019 = v);
$parcel$export(module.exports, "SENTRY_DIST", () => $c97e36c8d40a3851$export$e7d7477fa9057ee2, (v) => $c97e36c8d40a3851$export$e7d7477fa9057ee2 = v);
$parcel$export(module.exports, "SENTRY_DOMAIN", () => $c97e36c8d40a3851$export$1f4267a3fc018448, (v) => $c97e36c8d40a3851$export$1f4267a3fc018448 = v);
$parcel$export(module.exports, "SENTRY_DSC_ENVIRONMENT", () => $c97e36c8d40a3851$export$c171cae150389952, (v) => $c97e36c8d40a3851$export$c171cae150389952 = v);
$parcel$export(module.exports, "SENTRY_DSC_PROJECT_ID", () => $c97e36c8d40a3851$export$d9bb35e957b22c72, (v) => $c97e36c8d40a3851$export$d9bb35e957b22c72 = v);
$parcel$export(module.exports, "SENTRY_DSC_PUBLIC_KEY", () => $c97e36c8d40a3851$export$b3508a2c95f74e3d, (v) => $c97e36c8d40a3851$export$b3508a2c95f74e3d = v);
$parcel$export(module.exports, "SENTRY_DSC_RELEASE", () => $c97e36c8d40a3851$export$20bb272f4d21532d, (v) => $c97e36c8d40a3851$export$20bb272f4d21532d = v);
$parcel$export(module.exports, "SENTRY_DSC_SAMPLED", () => $c97e36c8d40a3851$export$d7e64fbd0102ce90, (v) => $c97e36c8d40a3851$export$d7e64fbd0102ce90 = v);
$parcel$export(module.exports, "SENTRY_DSC_SAMPLE_RATE", () => $c97e36c8d40a3851$export$c17eae7e86dbba3c, (v) => $c97e36c8d40a3851$export$c17eae7e86dbba3c = v);
$parcel$export(module.exports, "SENTRY_DSC_TRACE_ID", () => $c97e36c8d40a3851$export$349603c0a9165744, (v) => $c97e36c8d40a3851$export$349603c0a9165744 = v);
$parcel$export(module.exports, "SENTRY_DSC_TRANSACTION", () => $c97e36c8d40a3851$export$4dadf693741f0283, (v) => $c97e36c8d40a3851$export$4dadf693741f0283 = v);
$parcel$export(module.exports, "SENTRY_ENVIRONMENT", () => $c97e36c8d40a3851$export$6377864d12f7eeb3, (v) => $c97e36c8d40a3851$export$6377864d12f7eeb3 = v);
$parcel$export(module.exports, "SENTRY_EXCLUSIVE_TIME", () => $c97e36c8d40a3851$export$ba081af9585ed4, (v) => $c97e36c8d40a3851$export$ba081af9585ed4 = v);
$parcel$export(module.exports, "SENTRY_GRAPHQL_OPERATION", () => $c97e36c8d40a3851$export$7841dacb241485d0, (v) => $c97e36c8d40a3851$export$7841dacb241485d0 = v);
$parcel$export(module.exports, "SENTRY_GROUP", () => $c97e36c8d40a3851$export$52c7044cf6301362, (v) => $c97e36c8d40a3851$export$52c7044cf6301362 = v);
$parcel$export(module.exports, "SENTRY_HTTP_PREFETCH", () => $c97e36c8d40a3851$export$56ea1c9e44590e20, (v) => $c97e36c8d40a3851$export$56ea1c9e44590e20 = v);
$parcel$export(module.exports, "SENTRY_IDLE_SPAN_FINISH_REASON", () => $c97e36c8d40a3851$export$7626e389d05f4c36, (v) => $c97e36c8d40a3851$export$7626e389d05f4c36 = v);
$parcel$export(module.exports, "SENTRY_IS_REMOTE", () => $c97e36c8d40a3851$export$5e0a48187329b2e7, (v) => $c97e36c8d40a3851$export$5e0a48187329b2e7 = v);
$parcel$export(module.exports, "SENTRY_KIND", () => $c97e36c8d40a3851$export$c322b150d7667841, (v) => $c97e36c8d40a3851$export$c322b150d7667841 = v);
$parcel$export(module.exports, "SENTRY_MAIN_THREAD", () => $c97e36c8d40a3851$export$4a4797d3c962f753, (v) => $c97e36c8d40a3851$export$4a4797d3c962f753 = v);
$parcel$export(module.exports, "SENTRY_MESSAGE_PARAMETER_KEY", () => $c97e36c8d40a3851$export$767524d5e72e2645, (v) => $c97e36c8d40a3851$export$767524d5e72e2645 = v);
$parcel$export(module.exports, "SENTRY_MESSAGE_TEMPLATE", () => $c97e36c8d40a3851$export$497354ca7b0ee666, (v) => $c97e36c8d40a3851$export$497354ca7b0ee666 = v);
$parcel$export(module.exports, "SENTRY_METRIC_SOURCE", () => $c97e36c8d40a3851$export$cbdc4ad11118116a, (v) => $c97e36c8d40a3851$export$cbdc4ad11118116a = v);
$parcel$export(module.exports, "SENTRY_MOBILE", () => $c97e36c8d40a3851$export$5b890de778c4c2fe, (v) => $c97e36c8d40a3851$export$5b890de778c4c2fe = v);
$parcel$export(module.exports, "SENTRY_MODULE_KEY", () => $c97e36c8d40a3851$export$a78d9803b5e0a83e, (v) => $c97e36c8d40a3851$export$a78d9803b5e0a83e = v);
$parcel$export(module.exports, "SENTRY_MODULE_KEY_BASE", () => $c97e36c8d40a3851$export$df1b536467b3992a, (v) => $c97e36c8d40a3851$export$df1b536467b3992a = v);
$parcel$export(module.exports, "SENTRY_NEXTJS_SSR_FUNCTION_ROUTE", () => $c97e36c8d40a3851$export$73104a329e205998, (v) => $c97e36c8d40a3851$export$73104a329e205998 = v);
$parcel$export(module.exports, "SENTRY_NEXTJS_SSR_FUNCTION_TYPE", () => $c97e36c8d40a3851$export$5740e3da55330b0a, (v) => $c97e36c8d40a3851$export$5740e3da55330b0a = v);
$parcel$export(module.exports, "SENTRY_NORMALIZED_DB_QUERY", () => $c97e36c8d40a3851$export$8dcc2d92ff6d65da, (v) => $c97e36c8d40a3851$export$8dcc2d92ff6d65da = v);
$parcel$export(module.exports, "SENTRY_NORMALIZED_DB_QUERY_HASH", () => $c97e36c8d40a3851$export$e5f1321e53e24810, (v) => $c97e36c8d40a3851$export$e5f1321e53e24810 = v);
$parcel$export(module.exports, "SENTRY_NORMALIZED_DESCRIPTION", () => $c97e36c8d40a3851$export$56dd3098cbca7c8a, (v) => $c97e36c8d40a3851$export$56dd3098cbca7c8a = v);
$parcel$export(module.exports, "SENTRY_OBSERVED_TIMESTAMP_NANOS", () => $c97e36c8d40a3851$export$aa7aff70e4380665, (v) => $c97e36c8d40a3851$export$aa7aff70e4380665 = v);
$parcel$export(module.exports, "SENTRY_OP", () => $c97e36c8d40a3851$export$dacb7d452aa6bcaf, (v) => $c97e36c8d40a3851$export$dacb7d452aa6bcaf = v);
$parcel$export(module.exports, "SENTRY_ORIGIN", () => $c97e36c8d40a3851$export$15dfc6c5e8f9baf6, (v) => $c97e36c8d40a3851$export$15dfc6c5e8f9baf6 = v);
$parcel$export(module.exports, "SENTRY_PLATFORM", () => $c97e36c8d40a3851$export$91ad03bba7909fb5, (v) => $c97e36c8d40a3851$export$91ad03bba7909fb5 = v);
$parcel$export(module.exports, "SENTRY_PROFILER_ID", () => $c97e36c8d40a3851$export$86128e6c0ab71d64, (v) => $c97e36c8d40a3851$export$86128e6c0ab71d64 = v);
$parcel$export(module.exports, "SENTRY_PROFILE_ID", () => $c97e36c8d40a3851$export$745b60c4819aec1d, (v) => $c97e36c8d40a3851$export$745b60c4819aec1d = v);
$parcel$export(module.exports, "SENTRY_RELEASE", () => $c97e36c8d40a3851$export$d2c893bfac1da9a1, (v) => $c97e36c8d40a3851$export$d2c893bfac1da9a1 = v);
$parcel$export(module.exports, "SENTRY_REPLAY_ID", () => $c97e36c8d40a3851$export$1c14ad02f9534b19, (v) => $c97e36c8d40a3851$export$1c14ad02f9534b19 = v);
$parcel$export(module.exports, "SENTRY_REPLAY_IS_BUFFERING", () => $c97e36c8d40a3851$export$db3cb63e0594d014, (v) => $c97e36c8d40a3851$export$db3cb63e0594d014 = v);
$parcel$export(module.exports, "SENTRY_REPORT_EVENT", () => $c97e36c8d40a3851$export$a65c9a0eba2c222d, (v) => $c97e36c8d40a3851$export$a65c9a0eba2c222d = v);
$parcel$export(module.exports, "SENTRY_SDK_INTEGRATIONS", () => $c97e36c8d40a3851$export$68dbcca9c0e339ec, (v) => $c97e36c8d40a3851$export$68dbcca9c0e339ec = v);
$parcel$export(module.exports, "SENTRY_SDK_NAME", () => $c97e36c8d40a3851$export$d59b669d4bb3f006, (v) => $c97e36c8d40a3851$export$d59b669d4bb3f006 = v);
$parcel$export(module.exports, "SENTRY_SDK_VERSION", () => $c97e36c8d40a3851$export$4d88d347aa9667fc, (v) => $c97e36c8d40a3851$export$4d88d347aa9667fc = v);
$parcel$export(module.exports, "SENTRY_SEGMENT_ID", () => $c97e36c8d40a3851$export$9943ffdcaa4bc506, (v) => $c97e36c8d40a3851$export$9943ffdcaa4bc506 = v);
$parcel$export(module.exports, "SENTRY_SEGMENT_NAME", () => $c97e36c8d40a3851$export$d4f25b923533dbba, (v) => $c97e36c8d40a3851$export$d4f25b923533dbba = v);
$parcel$export(module.exports, "SENTRY_SERVER_SAMPLE_RATE", () => $c97e36c8d40a3851$export$35f3396a1cdeea45, (v) => $c97e36c8d40a3851$export$35f3396a1cdeea45 = v);
$parcel$export(module.exports, "SENTRY_SOURCE", () => $c97e36c8d40a3851$export$80e399da474bc98d, (v) => $c97e36c8d40a3851$export$80e399da474bc98d = v);
$parcel$export(module.exports, "SENTRY_SPAN_SOURCE", () => $c97e36c8d40a3851$export$e01809e2dbceac35, (v) => $c97e36c8d40a3851$export$e01809e2dbceac35 = v);
$parcel$export(module.exports, "SENTRY_STATUS", () => $c97e36c8d40a3851$export$41900d5c4e8a9c68, (v) => $c97e36c8d40a3851$export$41900d5c4e8a9c68 = v);
$parcel$export(module.exports, "SENTRY_STATUS_CODE", () => $c97e36c8d40a3851$export$362bb1cb0bb5ca03, (v) => $c97e36c8d40a3851$export$362bb1cb0bb5ca03 = v);
$parcel$export(module.exports, "SENTRY_STATUS_MESSAGE", () => $c97e36c8d40a3851$export$6803ac54f919d9cc, (v) => $c97e36c8d40a3851$export$6803ac54f919d9cc = v);
$parcel$export(module.exports, "SENTRY_SVELTEKIT_NAVIGATION_FROM", () => $c97e36c8d40a3851$export$72f5b47540331169, (v) => $c97e36c8d40a3851$export$72f5b47540331169 = v);
$parcel$export(module.exports, "SENTRY_SVELTEKIT_NAVIGATION_TO", () => $c97e36c8d40a3851$export$6c61a8c9aa5305cb, (v) => $c97e36c8d40a3851$export$6c61a8c9aa5305cb = v);
$parcel$export(module.exports, "SENTRY_SVELTEKIT_NAVIGATION_TYPE", () => $c97e36c8d40a3851$export$6b5244c457b68e65, (v) => $c97e36c8d40a3851$export$6b5244c457b68e65 = v);
$parcel$export(module.exports, "SENTRY_THREAD_ID", () => $c97e36c8d40a3851$export$b7bd0c9a886f3414, (v) => $c97e36c8d40a3851$export$b7bd0c9a886f3414 = v);
$parcel$export(module.exports, "SENTRY_TIMESTAMP_SEQUENCE", () => $c97e36c8d40a3851$export$6b77f2bacac7c93d, (v) => $c97e36c8d40a3851$export$6b77f2bacac7c93d = v);
$parcel$export(module.exports, "SENTRY_TRACE_LIFECYCLE", () => $c97e36c8d40a3851$export$ddbc15c0e8e8a7ea, (v) => $c97e36c8d40a3851$export$ddbc15c0e8e8a7ea = v);
$parcel$export(module.exports, "SENTRY_TRACE_PARENT_SPAN_ID", () => $c97e36c8d40a3851$export$feb4fe753df28a82, (v) => $c97e36c8d40a3851$export$feb4fe753df28a82 = v);
$parcel$export(module.exports, "SENTRY_TRACE_STATUS", () => $c97e36c8d40a3851$export$d6267756132e2175, (v) => $c97e36c8d40a3851$export$d6267756132e2175 = v);
$parcel$export(module.exports, "SENTRY_TRANSACTION", () => $c97e36c8d40a3851$export$570ac5a3fd7e6cc6, (v) => $c97e36c8d40a3851$export$570ac5a3fd7e6cc6 = v);
$parcel$export(module.exports, "SENTRY_USER_EMAIL", () => $c97e36c8d40a3851$export$5b9a0015e1c530ed, (v) => $c97e36c8d40a3851$export$5b9a0015e1c530ed = v);
$parcel$export(module.exports, "SENTRY_USER_GEO_CITY", () => $c97e36c8d40a3851$export$8bbff71c84508218, (v) => $c97e36c8d40a3851$export$8bbff71c84508218 = v);
$parcel$export(module.exports, "SENTRY_USER_GEO_COUNTRY_CODE", () => $c97e36c8d40a3851$export$b55aa07a514a2430, (v) => $c97e36c8d40a3851$export$b55aa07a514a2430 = v);
$parcel$export(module.exports, "SENTRY_USER_GEO_REGION", () => $c97e36c8d40a3851$export$9927ad09f7c084dc, (v) => $c97e36c8d40a3851$export$9927ad09f7c084dc = v);
$parcel$export(module.exports, "SENTRY_USER_GEO_SUBDIVISION", () => $c97e36c8d40a3851$export$52a07a35ff8ec6b6, (v) => $c97e36c8d40a3851$export$52a07a35ff8ec6b6 = v);
$parcel$export(module.exports, "SENTRY_USER_ID", () => $c97e36c8d40a3851$export$a10d277c42e6cae3, (v) => $c97e36c8d40a3851$export$a10d277c42e6cae3 = v);
$parcel$export(module.exports, "SENTRY_USER_IP", () => $c97e36c8d40a3851$export$cdc0ce5c66182801, (v) => $c97e36c8d40a3851$export$cdc0ce5c66182801 = v);
$parcel$export(module.exports, "SENTRY_USER_USERNAME", () => $c97e36c8d40a3851$export$2504d4bd698dd962, (v) => $c97e36c8d40a3851$export$2504d4bd698dd962 = v);
$parcel$export(module.exports, "SERVER_ADDRESS", () => $c97e36c8d40a3851$export$9dc86f3b876e96ef, (v) => $c97e36c8d40a3851$export$9dc86f3b876e96ef = v);
$parcel$export(module.exports, "SERVER_NAME", () => $c97e36c8d40a3851$export$70ff7865f52549ae, (v) => $c97e36c8d40a3851$export$70ff7865f52549ae = v);
$parcel$export(module.exports, "SERVER_PORT", () => $c97e36c8d40a3851$export$f77b53a42be6e6fd, (v) => $c97e36c8d40a3851$export$f77b53a42be6e6fd = v);
$parcel$export(module.exports, "SERVICE_NAME", () => $c97e36c8d40a3851$export$818eb7ab11414506, (v) => $c97e36c8d40a3851$export$818eb7ab11414506 = v);
$parcel$export(module.exports, "SERVICE_VERSION", () => $c97e36c8d40a3851$export$829ef6b2e59d984d, (v) => $c97e36c8d40a3851$export$829ef6b2e59d984d = v);
$parcel$export(module.exports, "SESSION_ID", () => $c97e36c8d40a3851$export$b30f4cb52c088a26, (v) => $c97e36c8d40a3851$export$b30f4cb52c088a26 = v);
$parcel$export(module.exports, "STALL_PERCENTAGE", () => $c97e36c8d40a3851$export$335eace0ff1771cd, (v) => $c97e36c8d40a3851$export$335eace0ff1771cd = v);
$parcel$export(module.exports, "STALL_TOTAL_TIME", () => $c97e36c8d40a3851$export$374d88a2025416ac, (v) => $c97e36c8d40a3851$export$374d88a2025416ac = v);
$parcel$export(module.exports, "STATE_TYPE", () => $c97e36c8d40a3851$export$bb7a91303551eb37, (v) => $c97e36c8d40a3851$export$bb7a91303551eb37 = v);
$parcel$export(module.exports, "THREAD_ID", () => $c97e36c8d40a3851$export$f132ea291a7db56b, (v) => $c97e36c8d40a3851$export$f132ea291a7db56b = v);
$parcel$export(module.exports, "THREAD_NAME", () => $c97e36c8d40a3851$export$f0abd4170bbd2468, (v) => $c97e36c8d40a3851$export$f0abd4170bbd2468 = v);
$parcel$export(module.exports, "TIMBER_TAG", () => $c97e36c8d40a3851$export$50d00a157dc08581, (v) => $c97e36c8d40a3851$export$50d00a157dc08581 = v);
$parcel$export(module.exports, "TIME_TO_FULL_DISPLAY", () => $c97e36c8d40a3851$export$484576567a98833f, (v) => $c97e36c8d40a3851$export$484576567a98833f = v);
$parcel$export(module.exports, "TIME_TO_INITIAL_DISPLAY", () => $c97e36c8d40a3851$export$ec9e491e475d0c97, (v) => $c97e36c8d40a3851$export$ec9e491e475d0c97 = v);
$parcel$export(module.exports, "TRANSACTION", () => $c97e36c8d40a3851$export$a86c59c10992220f, (v) => $c97e36c8d40a3851$export$a86c59c10992220f = v);
$parcel$export(module.exports, "TRPC_PROCEDURE_PATH", () => $c97e36c8d40a3851$export$e12f06597e992fde, (v) => $c97e36c8d40a3851$export$e12f06597e992fde = v);
$parcel$export(module.exports, "TRPC_PROCEDURE_TYPE", () => $c97e36c8d40a3851$export$7ec54678ba28ea59, (v) => $c97e36c8d40a3851$export$7ec54678ba28ea59 = v);
$parcel$export(module.exports, "TTFB", () => $c97e36c8d40a3851$export$433ba14c16717110, (v) => $c97e36c8d40a3851$export$433ba14c16717110 = v);
$parcel$export(module.exports, "TTFB_REQUESTTIME", () => $c97e36c8d40a3851$export$309ee349b8a537f, (v) => $c97e36c8d40a3851$export$309ee349b8a537f = v);
$parcel$export(module.exports, "TYPE", () => $c97e36c8d40a3851$export$b87f371cbc396fcf, (v) => $c97e36c8d40a3851$export$b87f371cbc396fcf = v);
$parcel$export(module.exports, "UI_COMPONENT_NAME", () => $c97e36c8d40a3851$export$60050fc49fe0e7e2, (v) => $c97e36c8d40a3851$export$60050fc49fe0e7e2 = v);
$parcel$export(module.exports, "UI_CONTRIBUTES_TO_TTFD", () => $c97e36c8d40a3851$export$348c8e2b37f276cd, (v) => $c97e36c8d40a3851$export$348c8e2b37f276cd = v);
$parcel$export(module.exports, "UI_CONTRIBUTES_TO_TTID", () => $c97e36c8d40a3851$export$7f47e8a8b2d97cb2, (v) => $c97e36c8d40a3851$export$7f47e8a8b2d97cb2 = v);
$parcel$export(module.exports, "UI_ELEMENT_HEIGHT", () => $c97e36c8d40a3851$export$50d5adc4b543ce95, (v) => $c97e36c8d40a3851$export$50d5adc4b543ce95 = v);
$parcel$export(module.exports, "UI_ELEMENT_ID", () => $c97e36c8d40a3851$export$9221f1d2c934d9f, (v) => $c97e36c8d40a3851$export$9221f1d2c934d9f = v);
$parcel$export(module.exports, "UI_ELEMENT_IDENTIFIER", () => $c97e36c8d40a3851$export$3a56578b3ae09a02, (v) => $c97e36c8d40a3851$export$3a56578b3ae09a02 = v);
$parcel$export(module.exports, "UI_ELEMENT_LOAD_TIME", () => $c97e36c8d40a3851$export$e47b8dab9466c895, (v) => $c97e36c8d40a3851$export$e47b8dab9466c895 = v);
$parcel$export(module.exports, "UI_ELEMENT_PAINT_TYPE", () => $c97e36c8d40a3851$export$4ca52f75cf4889c5, (v) => $c97e36c8d40a3851$export$4ca52f75cf4889c5 = v);
$parcel$export(module.exports, "UI_ELEMENT_RENDER_TIME", () => $c97e36c8d40a3851$export$7343d7d72195067f, (v) => $c97e36c8d40a3851$export$7343d7d72195067f = v);
$parcel$export(module.exports, "UI_ELEMENT_TYPE", () => $c97e36c8d40a3851$export$f334f32f8d4d8063, (v) => $c97e36c8d40a3851$export$f334f32f8d4d8063 = v);
$parcel$export(module.exports, "UI_ELEMENT_URL", () => $c97e36c8d40a3851$export$c7bf2089e89a217c, (v) => $c97e36c8d40a3851$export$c7bf2089e89a217c = v);
$parcel$export(module.exports, "UI_ELEMENT_WIDTH", () => $c97e36c8d40a3851$export$f514f97553a434b2, (v) => $c97e36c8d40a3851$export$f514f97553a434b2 = v);
$parcel$export(module.exports, "URL", () => $c97e36c8d40a3851$export$61abde59b50deb8e, (v) => $c97e36c8d40a3851$export$61abde59b50deb8e = v);
$parcel$export(module.exports, "URL_DOMAIN", () => $c97e36c8d40a3851$export$5a5ce44f9fb51f93, (v) => $c97e36c8d40a3851$export$5a5ce44f9fb51f93 = v);
$parcel$export(module.exports, "URL_FRAGMENT", () => $c97e36c8d40a3851$export$7044ea8d89b6f59d, (v) => $c97e36c8d40a3851$export$7044ea8d89b6f59d = v);
$parcel$export(module.exports, "URL_FULL", () => $c97e36c8d40a3851$export$40eacf1a072c9dbd, (v) => $c97e36c8d40a3851$export$40eacf1a072c9dbd = v);
$parcel$export(module.exports, "URL_PATH", () => $c97e36c8d40a3851$export$4c1fa0ac0eff2ac, (v) => $c97e36c8d40a3851$export$4c1fa0ac0eff2ac = v);
$parcel$export(module.exports, "URL_PATH_PARAMETER_KEY", () => $c97e36c8d40a3851$export$5bee9450fe31dde1, (v) => $c97e36c8d40a3851$export$5bee9450fe31dde1 = v);
$parcel$export(module.exports, "URL_PATH_PARAMETER_KEY_BASE", () => $c97e36c8d40a3851$export$d0b571fb4406d953, (v) => $c97e36c8d40a3851$export$d0b571fb4406d953 = v);
$parcel$export(module.exports, "URL_PORT", () => $c97e36c8d40a3851$export$258b370e6c2b85d5, (v) => $c97e36c8d40a3851$export$258b370e6c2b85d5 = v);
$parcel$export(module.exports, "URL_QUERY", () => $c97e36c8d40a3851$export$dc5e5523da291a4b, (v) => $c97e36c8d40a3851$export$dc5e5523da291a4b = v);
$parcel$export(module.exports, "URL_SAME_ORIGIN", () => $c97e36c8d40a3851$export$fd5a8904ab5abfe0, (v) => $c97e36c8d40a3851$export$fd5a8904ab5abfe0 = v);
$parcel$export(module.exports, "URL_SCHEME", () => $c97e36c8d40a3851$export$1350d8937b0f26fb, (v) => $c97e36c8d40a3851$export$1350d8937b0f26fb = v);
$parcel$export(module.exports, "URL_TEMPLATE", () => $c97e36c8d40a3851$export$2a045f777fb349a8, (v) => $c97e36c8d40a3851$export$2a045f777fb349a8 = v);
$parcel$export(module.exports, "USER_AGENT_ORIGINAL", () => $c97e36c8d40a3851$export$8bb874585539a88f, (v) => $c97e36c8d40a3851$export$8bb874585539a88f = v);
$parcel$export(module.exports, "USER_EMAIL", () => $c97e36c8d40a3851$export$17d3a50785727199, (v) => $c97e36c8d40a3851$export$17d3a50785727199 = v);
$parcel$export(module.exports, "USER_FULL_NAME", () => $c97e36c8d40a3851$export$2931c570009689e, (v) => $c97e36c8d40a3851$export$2931c570009689e = v);
$parcel$export(module.exports, "USER_GEO_CITY", () => $c97e36c8d40a3851$export$199cbcedee735a43, (v) => $c97e36c8d40a3851$export$199cbcedee735a43 = v);
$parcel$export(module.exports, "USER_GEO_COUNTRY_CODE", () => $c97e36c8d40a3851$export$4ba5bf9d4e3ed862, (v) => $c97e36c8d40a3851$export$4ba5bf9d4e3ed862 = v);
$parcel$export(module.exports, "USER_GEO_REGION", () => $c97e36c8d40a3851$export$674c01ec2f0b89c3, (v) => $c97e36c8d40a3851$export$674c01ec2f0b89c3 = v);
$parcel$export(module.exports, "USER_GEO_SUBDIVISION", () => $c97e36c8d40a3851$export$bda1686739fd61c7, (v) => $c97e36c8d40a3851$export$bda1686739fd61c7 = v);
$parcel$export(module.exports, "USER_HASH", () => $c97e36c8d40a3851$export$8d804148f485d54c, (v) => $c97e36c8d40a3851$export$8d804148f485d54c = v);
$parcel$export(module.exports, "USER_ID", () => $c97e36c8d40a3851$export$212a8f1ea37518bd, (v) => $c97e36c8d40a3851$export$212a8f1ea37518bd = v);
$parcel$export(module.exports, "USER_IP_ADDRESS", () => $c97e36c8d40a3851$export$c9ac0fee28245883, (v) => $c97e36c8d40a3851$export$c9ac0fee28245883 = v);
$parcel$export(module.exports, "USER_NAME", () => $c97e36c8d40a3851$export$77078610759fe5f6, (v) => $c97e36c8d40a3851$export$77078610759fe5f6 = v);
$parcel$export(module.exports, "USER_ROLES", () => $c97e36c8d40a3851$export$7c6317deeec7a6c1, (v) => $c97e36c8d40a3851$export$7c6317deeec7a6c1 = v);
$parcel$export(module.exports, "VERCEL_BRANCH", () => $c97e36c8d40a3851$export$877ebf2e4ad81f03, (v) => $c97e36c8d40a3851$export$877ebf2e4ad81f03 = v);
$parcel$export(module.exports, "VERCEL_BUILD_ID", () => $c97e36c8d40a3851$export$70b2343945496e1f, (v) => $c97e36c8d40a3851$export$70b2343945496e1f = v);
$parcel$export(module.exports, "VERCEL_DEPLOYMENT_ID", () => $c97e36c8d40a3851$export$8415b56d2c6d2b1d, (v) => $c97e36c8d40a3851$export$8415b56d2c6d2b1d = v);
$parcel$export(module.exports, "VERCEL_DESTINATION", () => $c97e36c8d40a3851$export$cc81114a03caab18, (v) => $c97e36c8d40a3851$export$cc81114a03caab18 = v);
$parcel$export(module.exports, "VERCEL_EDGE_TYPE", () => $c97e36c8d40a3851$export$bc14eb892daceb23, (v) => $c97e36c8d40a3851$export$bc14eb892daceb23 = v);
$parcel$export(module.exports, "VERCEL_ENTRYPOINT", () => $c97e36c8d40a3851$export$3c973217450c3e9d, (v) => $c97e36c8d40a3851$export$3c973217450c3e9d = v);
$parcel$export(module.exports, "VERCEL_EXECUTION_REGION", () => $c97e36c8d40a3851$export$582c0b730ff1ddb9, (v) => $c97e36c8d40a3851$export$582c0b730ff1ddb9 = v);
$parcel$export(module.exports, "VERCEL_ID", () => $c97e36c8d40a3851$export$b3edfb545b65f1c5, (v) => $c97e36c8d40a3851$export$b3edfb545b65f1c5 = v);
$parcel$export(module.exports, "VERCEL_JA3_DIGEST", () => $c97e36c8d40a3851$export$2593317d8731841c, (v) => $c97e36c8d40a3851$export$2593317d8731841c = v);
$parcel$export(module.exports, "VERCEL_JA4_DIGEST", () => $c97e36c8d40a3851$export$8bb5bc1732aa41f, (v) => $c97e36c8d40a3851$export$8bb5bc1732aa41f = v);
$parcel$export(module.exports, "VERCEL_LOG_TYPE", () => $c97e36c8d40a3851$export$74a79c98b110b5b9, (v) => $c97e36c8d40a3851$export$74a79c98b110b5b9 = v);
$parcel$export(module.exports, "VERCEL_PATH", () => $c97e36c8d40a3851$export$26461b03281b4db4, (v) => $c97e36c8d40a3851$export$26461b03281b4db4 = v);
$parcel$export(module.exports, "VERCEL_PROJECT_ID", () => $c97e36c8d40a3851$export$eaea590d6d3dd93c, (v) => $c97e36c8d40a3851$export$eaea590d6d3dd93c = v);
$parcel$export(module.exports, "VERCEL_PROJECT_NAME", () => $c97e36c8d40a3851$export$af45365f70099379, (v) => $c97e36c8d40a3851$export$af45365f70099379 = v);
$parcel$export(module.exports, "VERCEL_PROXY_CACHE_ID", () => $c97e36c8d40a3851$export$a49e732d34d5ba9b, (v) => $c97e36c8d40a3851$export$a49e732d34d5ba9b = v);
$parcel$export(module.exports, "VERCEL_PROXY_CLIENT_IP", () => $c97e36c8d40a3851$export$7c147fe246bc8bd3, (v) => $c97e36c8d40a3851$export$7c147fe246bc8bd3 = v);
$parcel$export(module.exports, "VERCEL_PROXY_HOST", () => $c97e36c8d40a3851$export$e5111b6070e1ee9e, (v) => $c97e36c8d40a3851$export$e5111b6070e1ee9e = v);
$parcel$export(module.exports, "VERCEL_PROXY_LAMBDA_REGION", () => $c97e36c8d40a3851$export$591cbfd403f8c8d, (v) => $c97e36c8d40a3851$export$591cbfd403f8c8d = v);
$parcel$export(module.exports, "VERCEL_PROXY_METHOD", () => $c97e36c8d40a3851$export$b1388db955bbb885, (v) => $c97e36c8d40a3851$export$b1388db955bbb885 = v);
$parcel$export(module.exports, "VERCEL_PROXY_PATH", () => $c97e36c8d40a3851$export$e898d0e9e211abd9, (v) => $c97e36c8d40a3851$export$e898d0e9e211abd9 = v);
$parcel$export(module.exports, "VERCEL_PROXY_PATH_TYPE", () => $c97e36c8d40a3851$export$ab6fee0e8a6ee069, (v) => $c97e36c8d40a3851$export$ab6fee0e8a6ee069 = v);
$parcel$export(module.exports, "VERCEL_PROXY_PATH_TYPE_VARIANT", () => $c97e36c8d40a3851$export$9786ad94c199ffbb, (v) => $c97e36c8d40a3851$export$9786ad94c199ffbb = v);
$parcel$export(module.exports, "VERCEL_PROXY_REFERER", () => $c97e36c8d40a3851$export$269890524eed693b, (v) => $c97e36c8d40a3851$export$269890524eed693b = v);
$parcel$export(module.exports, "VERCEL_PROXY_REGION", () => $c97e36c8d40a3851$export$2ec623a8212d6b64, (v) => $c97e36c8d40a3851$export$2ec623a8212d6b64 = v);
$parcel$export(module.exports, "VERCEL_PROXY_RESPONSE_BYTE_SIZE", () => $c97e36c8d40a3851$export$30e7673b01ff994e, (v) => $c97e36c8d40a3851$export$30e7673b01ff994e = v);
$parcel$export(module.exports, "VERCEL_PROXY_SCHEME", () => $c97e36c8d40a3851$export$9ea93477840812bf, (v) => $c97e36c8d40a3851$export$9ea93477840812bf = v);
$parcel$export(module.exports, "VERCEL_PROXY_STATUS_CODE", () => $c97e36c8d40a3851$export$a6da0c365670c430, (v) => $c97e36c8d40a3851$export$a6da0c365670c430 = v);
$parcel$export(module.exports, "VERCEL_PROXY_TIMESTAMP", () => $c97e36c8d40a3851$export$7986b22da43f2885, (v) => $c97e36c8d40a3851$export$7986b22da43f2885 = v);
$parcel$export(module.exports, "VERCEL_PROXY_USER_AGENT", () => $c97e36c8d40a3851$export$a9f943c7ceb3b42f, (v) => $c97e36c8d40a3851$export$a9f943c7ceb3b42f = v);
$parcel$export(module.exports, "VERCEL_PROXY_VERCEL_CACHE", () => $c97e36c8d40a3851$export$dfe49501efcdffce, (v) => $c97e36c8d40a3851$export$dfe49501efcdffce = v);
$parcel$export(module.exports, "VERCEL_PROXY_VERCEL_ID", () => $c97e36c8d40a3851$export$be465f50c92eb01d, (v) => $c97e36c8d40a3851$export$be465f50c92eb01d = v);
$parcel$export(module.exports, "VERCEL_PROXY_WAF_ACTION", () => $c97e36c8d40a3851$export$c138d1796bb34999, (v) => $c97e36c8d40a3851$export$c138d1796bb34999 = v);
$parcel$export(module.exports, "VERCEL_PROXY_WAF_RULE_ID", () => $c97e36c8d40a3851$export$85a0016690a0ccf2, (v) => $c97e36c8d40a3851$export$85a0016690a0ccf2 = v);
$parcel$export(module.exports, "VERCEL_REQUEST_ID", () => $c97e36c8d40a3851$export$883acab36ede4bfa, (v) => $c97e36c8d40a3851$export$883acab36ede4bfa = v);
$parcel$export(module.exports, "VERCEL_SOURCE", () => $c97e36c8d40a3851$export$9cfc88d203f9cdf1, (v) => $c97e36c8d40a3851$export$9cfc88d203f9cdf1 = v);
$parcel$export(module.exports, "VERCEL_STATUS_CODE", () => $c97e36c8d40a3851$export$b3c6c599110d7bab, (v) => $c97e36c8d40a3851$export$b3c6c599110d7bab = v);
$parcel$export(module.exports, "_AWS_KINESIS_STREAM_NAME", () => $c97e36c8d40a3851$export$247839c65766758, (v) => $c97e36c8d40a3851$export$247839c65766758 = v);
$parcel$export(module.exports, "_AWS_REQUEST_ID", () => $c97e36c8d40a3851$export$f4d52b02df927d54, (v) => $c97e36c8d40a3851$export$f4d52b02df927d54 = v);
$parcel$export(module.exports, "_HTTP_REQUEST_METHOD", () => $c97e36c8d40a3851$export$df30ee8c5b5f1989, (v) => $c97e36c8d40a3851$export$df30ee8c5b5f1989 = v);
$parcel$export(module.exports, "_SENTRY_SEGMENT_ID", () => $c97e36c8d40a3851$export$268a117c860fca6d, (v) => $c97e36c8d40a3851$export$268a117c860fca6d = v);
var $c97e36c8d40a3851$export$b60c5e9f9b7b58bd;
var $c97e36c8d40a3851$export$cc06afd6de7f2c10;
var $c97e36c8d40a3851$export$ced6746028fe2cc;
var $c97e36c8d40a3851$export$e6f4aa4f4fcb6da8;
var $c97e36c8d40a3851$export$f02d892201cd8d36;
var $c97e36c8d40a3851$export$f277a7ef9e273960;
var $c97e36c8d40a3851$export$1a8c212c3becaa80;
var $c97e36c8d40a3851$export$721b137086c68a47;
var $c97e36c8d40a3851$export$6afde2bb69d9aa86;
var $c97e36c8d40a3851$export$eadb4b562c974031;
var $c97e36c8d40a3851$export$22a90f0ac1eee843;
var $c97e36c8d40a3851$export$a727f215a0be1dad;
var $c97e36c8d40a3851$export$536bc61b34d995e5;
var $c97e36c8d40a3851$export$c43ea6115b380e62;
var $c97e36c8d40a3851$export$d2a16e26bada7cf1;
var $c97e36c8d40a3851$export$604eb1bd2278163b;
var $c97e36c8d40a3851$export$2f8568696c5aa352;
var $c97e36c8d40a3851$export$ccc8efd7dd31d3a9;
var $c97e36c8d40a3851$export$e176bf5dc45e40df;
var $c97e36c8d40a3851$export$c4ea01fd53f64e16;
var $c97e36c8d40a3851$export$bb5e6f2f31a15da9;
var $c97e36c8d40a3851$export$1762c11b666b026a;
var $c97e36c8d40a3851$export$14ddd4b729910100;
var $c97e36c8d40a3851$export$5311d7c8e1f8eabb;
var $c97e36c8d40a3851$export$2b748b9eca00828b;
var $c97e36c8d40a3851$export$5af25308c11addea;
var $c97e36c8d40a3851$export$28f78b3b1663cb92;
var $c97e36c8d40a3851$export$a1d3f09f0f1f066f;
var $c97e36c8d40a3851$export$322bd4ea9f163663;
var $c97e36c8d40a3851$export$95711b9e669edad8;
var $c97e36c8d40a3851$export$5924d7d72384626a;
var $c97e36c8d40a3851$export$db3b1b877a4ce4db;
var $c97e36c8d40a3851$export$a434a3e8afec2879;
var $c97e36c8d40a3851$export$fe00bb20636d42af;
var $c97e36c8d40a3851$export$712aa698b7ee271e;
var $c97e36c8d40a3851$export$1fac638b11ec16d9;
var $c97e36c8d40a3851$export$d132016ea64058e3;
var $c97e36c8d40a3851$export$53f2f47ec3b2f9ed;
var $c97e36c8d40a3851$export$9f80c4b11053cef1;
var $c97e36c8d40a3851$export$5f7a08466d84e877;
var $c97e36c8d40a3851$export$2cea7f14750b8c19;
var $c97e36c8d40a3851$export$34c59270f032a6c6;
var $c97e36c8d40a3851$export$5b6c28c7dca07ad7;
var $c97e36c8d40a3851$export$1dc8ae58b58d6c50;
var $c97e36c8d40a3851$export$ba267414e3c0d822;
var $c97e36c8d40a3851$export$71b176005902b99e;
var $c97e36c8d40a3851$export$5c5b5a3c245a0079;
var $c97e36c8d40a3851$export$8ee1df3c6367a60;
var $c97e36c8d40a3851$export$e8c7802ae95beccf;
var $c97e36c8d40a3851$export$bb237734da4d464;
var $c97e36c8d40a3851$export$cdaaf6d1fdcba0b6;
var $c97e36c8d40a3851$export$36223ebd4a30e9f5;
var $c97e36c8d40a3851$export$8feaa177bb7941e2;
var $c97e36c8d40a3851$export$e1ca25240db91d68;
var $c97e36c8d40a3851$export$404a223fd1ada08b;
var $c97e36c8d40a3851$export$53362079310c68;
var $c97e36c8d40a3851$export$3efb5af0ac379f77;
var $c97e36c8d40a3851$export$2c10c1ca0612c46d;
var $c97e36c8d40a3851$export$bbb86ad4d6654da6;
var $c97e36c8d40a3851$export$ad6896f00a2b1076;
var $c97e36c8d40a3851$export$300f39d8506a273d;
var $c97e36c8d40a3851$export$ecaa0e7f4773ddc7;
var $c97e36c8d40a3851$export$74b78acb4c54c06b;
var $c97e36c8d40a3851$export$b15b2c133bc50e33;
var $c97e36c8d40a3851$export$5f1381d9ae1b1c95;
var $c97e36c8d40a3851$export$c170b7ff277132ea;
var $c97e36c8d40a3851$export$9459a5df93695e45;
var $c97e36c8d40a3851$export$a7902bd57492ebe8;
var $c97e36c8d40a3851$export$d2ace0da59da09b7;
var $c97e36c8d40a3851$export$c15dd8d2461e0aeb;
var $c97e36c8d40a3851$export$5405b0a98e00e538;
var $c97e36c8d40a3851$export$bd393bbb84b309d3;
var $c97e36c8d40a3851$export$96f586f8837b86ae;
var $c97e36c8d40a3851$export$5d9f28f388f552d2;
var $c97e36c8d40a3851$export$b3d2f68e0e769504;
var $c97e36c8d40a3851$export$2c98412ed43013e8;
var $c97e36c8d40a3851$export$a7bd794d11c19f1b;
var $c97e36c8d40a3851$export$df4227832b83fdd0;
var $c97e36c8d40a3851$export$f131a6d8fbc0534f;
var $c97e36c8d40a3851$export$9bdc66d4a70e7e3a;
var $c97e36c8d40a3851$export$bfbbc3cbcaa90e98;
var $c97e36c8d40a3851$export$3565fa72459aa4d6;
var $c97e36c8d40a3851$export$bb67a834ae4bffdc;
var $c97e36c8d40a3851$export$4a06c859a283f06;
var $c97e36c8d40a3851$export$68324fac2038d0f2;
var $c97e36c8d40a3851$export$5e1bd62ffd2786fb;
var $c97e36c8d40a3851$export$bfdf2261058f56b;
var $c97e36c8d40a3851$export$23bf57842d9d53df;
var $c97e36c8d40a3851$export$bfbd7e060eeb4d35;
var $c97e36c8d40a3851$export$82eb6cccda27c3ff;
var $c97e36c8d40a3851$export$8ea68734d455808f;
var $c97e36c8d40a3851$export$40050e29324d44ee;
var $c97e36c8d40a3851$export$5cd7541006d9f467;
var $c97e36c8d40a3851$export$81c017edd95d692e;
var $c97e36c8d40a3851$export$120b3897a58cf903;
var $c97e36c8d40a3851$export$d4a9de43b4b1076c;
var $c97e36c8d40a3851$export$f37f4f9022f1ab17;
var $c97e36c8d40a3851$export$66ac18da14747cfb;
var $c97e36c8d40a3851$export$9e49b833525ca49d;
var $c97e36c8d40a3851$export$b084fea5b3097227;
var $c97e36c8d40a3851$export$e09cd8615652e8d0;
var $c97e36c8d40a3851$export$a43a60ec723a90ee;
var $c97e36c8d40a3851$export$34cc955357266287;
var $c97e36c8d40a3851$export$d9dd218693ea9bba;
var $c97e36c8d40a3851$export$c9649b7156282a2f;
var $c97e36c8d40a3851$export$daa8ce1f8adc553e;
var $c97e36c8d40a3851$export$cb93c7b05db202cf;
var $c97e36c8d40a3851$export$930f9bd3cc2e5b3d;
var $c97e36c8d40a3851$export$48c6d4c44afdc0b;
var $c97e36c8d40a3851$export$c78d41789fe4b1e4;
var $c97e36c8d40a3851$export$f462d9921f1f7332;
var $c97e36c8d40a3851$export$bc71f8df9a45e243;
var $c97e36c8d40a3851$export$ed840ec4a5f5d053;
var $c97e36c8d40a3851$export$c1a559a4f74a5e8e;
var $c97e36c8d40a3851$export$d1c007424092e3f5;
var $c97e36c8d40a3851$export$9ebb466ce954c49c;
var $c97e36c8d40a3851$export$e9aafc7348984403;
var $c97e36c8d40a3851$export$faaa46964f075237;
var $c97e36c8d40a3851$export$d28c4b3cc4431a87;
var $c97e36c8d40a3851$export$734b017b330c8fe6;
var $c97e36c8d40a3851$export$683ebdc48ba3758d;
var $c97e36c8d40a3851$export$be0263971250ef44;
var $c97e36c8d40a3851$export$36a0cbc35c405232;
var $c97e36c8d40a3851$export$469f7765ba335497;
var $c97e36c8d40a3851$export$fe6fe2b7af051610;
var $c97e36c8d40a3851$export$8345821877c4dfad;
var $c97e36c8d40a3851$export$f6c188a7e02335cf;
var $c97e36c8d40a3851$export$aaf709a8971e825f;
var $c97e36c8d40a3851$export$def01b82f8c092f7;
var $c97e36c8d40a3851$export$23d4264c606a73a6;
var $c97e36c8d40a3851$export$af9ece53bb92f66b;
var $c97e36c8d40a3851$export$25421625a565b69;
var $c97e36c8d40a3851$export$ab0c90d873e69ccb;
var $c97e36c8d40a3851$export$538c05cc8cb2a2bb;
var $c97e36c8d40a3851$export$f86df4de196e1a7c;
var $c97e36c8d40a3851$export$51e8aa8c0d65e7b8;
var $c97e36c8d40a3851$export$99023486ecc470bd;
var $c97e36c8d40a3851$export$2f6c85eaf382e81;
var $c97e36c8d40a3851$export$1158d57c0aed42be;
var $c97e36c8d40a3851$export$d85c4f947ab776e3;
var $c97e36c8d40a3851$export$813ef8386d874918;
var $c97e36c8d40a3851$export$7c2f74ff9251f64;
var $c97e36c8d40a3851$export$993f84dab107b880;
var $c97e36c8d40a3851$export$7b9c2315e94d8d2f;
var $c97e36c8d40a3851$export$f01e5cd42b9ec146;
var $c97e36c8d40a3851$export$987f6b4367434b55;
var $c97e36c8d40a3851$export$d9d145585d5022bb;
var $c97e36c8d40a3851$export$44ffba16bd48dac6;
var $c97e36c8d40a3851$export$3134892c5d2e251a;
var $c97e36c8d40a3851$export$8495028d10296058;
var $c97e36c8d40a3851$export$d6d0e4fcf46d490c;
var $c97e36c8d40a3851$export$658dced473c19301;
var $c97e36c8d40a3851$export$97b0f9c3fbe64076;
var $c97e36c8d40a3851$export$cf2c95ed5efbe9eb;
var $c97e36c8d40a3851$export$880007904f61a388;
var $c97e36c8d40a3851$export$3e903b72d4d9e07d;
var $c97e36c8d40a3851$export$34da07180e0e56af;
var $c97e36c8d40a3851$export$c49aafdaeb061953;
var $c97e36c8d40a3851$export$ceb762c61de2f17f;
var $c97e36c8d40a3851$export$a5f54ccfb28c0caf;
var $c97e36c8d40a3851$export$1c86a56857b024db;
var $c97e36c8d40a3851$export$7598f3464be47440;
var $c97e36c8d40a3851$export$b673289c971fc0ae;
var $c97e36c8d40a3851$export$98b23f3e6f0c2a6f;
var $c97e36c8d40a3851$export$6ddeaf0498614ebb;
var $c97e36c8d40a3851$export$97b78f78d64a7232;
var $c97e36c8d40a3851$export$5147715be870fff7;
var $c97e36c8d40a3851$export$5276bb46e6096fba;
var $c97e36c8d40a3851$export$cbcbc1f67a937cf3;
var $c97e36c8d40a3851$export$226a2381b8f0cf78;
var $c97e36c8d40a3851$export$fd35512cae286064;
var $c97e36c8d40a3851$export$de9bbf95ab1d81e;
var $c97e36c8d40a3851$export$47fb20e8d18d7d15;
var $c97e36c8d40a3851$export$9db7964e4b8cb849;
var $c97e36c8d40a3851$export$7139adf9d3bace41;
var $c97e36c8d40a3851$export$8ac3d09060e7f25d;
var $c97e36c8d40a3851$export$dad0e4778ea23971;
var $c97e36c8d40a3851$export$c14d903ccf9385a8;
var $c97e36c8d40a3851$export$934cded0041affd7;
var $c97e36c8d40a3851$export$6386da1dcba88c9d;
var $c97e36c8d40a3851$export$a3371797e606e2;
var $c97e36c8d40a3851$export$a5bbef0af83b23e5;
var $c97e36c8d40a3851$export$91ed1f55874222a6;
var $c97e36c8d40a3851$export$23de81068d2aed1b;
var $c97e36c8d40a3851$export$d738320e1fba9e9d;
var $c97e36c8d40a3851$export$2eacdea75497e8a5;
var $c97e36c8d40a3851$export$2bc3ea101f86c1d2;
var $c97e36c8d40a3851$export$c54e27e8d90ee081;
var $c97e36c8d40a3851$export$4943adcec371c2a6;
var $c97e36c8d40a3851$export$f000a5900d0480c2;
var $c97e36c8d40a3851$export$8f5234893868273b;
var $c97e36c8d40a3851$export$1a35518f6e81e8c7;
var $c97e36c8d40a3851$export$a2d90911eaae60fc;
var $c97e36c8d40a3851$export$3c22ff8b64b8f565;
var $c97e36c8d40a3851$export$b8019c0e2a5b5f0f;
var $c97e36c8d40a3851$export$8c11477e471467c8;
var $c97e36c8d40a3851$export$92a96f6363488aee;
var $c97e36c8d40a3851$export$f91beb6088f9ded9;
var $c97e36c8d40a3851$export$78bc7224576bf289;
var $c97e36c8d40a3851$export$a8027e0ea0d93ca;
var $c97e36c8d40a3851$export$5e59d3aea52e5037;
var $c97e36c8d40a3851$export$47e408be0da7933f;
var $c97e36c8d40a3851$export$d5772b934ca13e57;
var $c97e36c8d40a3851$export$36e47f6a5777561d;
var $c97e36c8d40a3851$export$e768cbc99cd68acf;
var $c97e36c8d40a3851$export$dfcc6c69df1343f2;
var $c97e36c8d40a3851$export$69b0a5d9226b5211;
var $c97e36c8d40a3851$export$da010a4f4fc971ae;
var $c97e36c8d40a3851$export$5d515b35be0601a0;
var $c97e36c8d40a3851$export$3e1b1037a315c5ca;
var $c97e36c8d40a3851$export$847fdd494825f0fb;
var $c97e36c8d40a3851$export$a9d76f26c6c730a9;
var $c97e36c8d40a3851$export$de03f86d1c9866ca;
var $c97e36c8d40a3851$export$65798ecab7eef8c;
var $c97e36c8d40a3851$export$22aa61f48b9c79a0;
var $c97e36c8d40a3851$export$69f5fb98f5aed812;
var $c97e36c8d40a3851$export$bdea5d1006fd280a;
var $c97e36c8d40a3851$export$f63a7230c5b1d609;
var $c97e36c8d40a3851$export$6f25e59b05bb8e17;
var $c97e36c8d40a3851$export$a56ad13c4afc7421;
var $c97e36c8d40a3851$export$d9ce89ce8912bf12;
var $c97e36c8d40a3851$export$17094e5f380e4162;
var $c97e36c8d40a3851$export$28a0ffdf747973a0;
var $c97e36c8d40a3851$export$5480ae1ba5d50bb9;
var $c97e36c8d40a3851$export$edc72ee4a17f5152;
var $c97e36c8d40a3851$export$19e4df138d354f8b;
var $c97e36c8d40a3851$export$92b0d20fa482b4b2;
var $c97e36c8d40a3851$export$3f638a793d61933f;
var $c97e36c8d40a3851$export$3f511731cc3687d4;
var $c97e36c8d40a3851$export$692b08741d6b6265;
var $c97e36c8d40a3851$export$cf67f8cb2324428e;
var $c97e36c8d40a3851$export$9d4197c1ffc5f359;
var $c97e36c8d40a3851$export$509634fbff540e75;
var $c97e36c8d40a3851$export$ccbc4fdff4b5eff5;
var $c97e36c8d40a3851$export$e0cb371ca548b1d6;
var $c97e36c8d40a3851$export$3c39026d09026bc2;
var $c97e36c8d40a3851$export$bf9e8248cb72cf00;
var $c97e36c8d40a3851$export$1054f22a72121d0f;
var $c97e36c8d40a3851$export$723b8a59dad2e467;
var $c97e36c8d40a3851$export$160081ff141bac8e;
var $c97e36c8d40a3851$export$194f62c84d27310;
var $c97e36c8d40a3851$export$7ed866d57b018d09;
var $c97e36c8d40a3851$export$d50bae4562e03e5;
var $c97e36c8d40a3851$export$649ea67a18fe8e8b;
var $c97e36c8d40a3851$export$136a5c1b43caaccd;
var $c97e36c8d40a3851$export$e33a28ea554b6ddc;
var $c97e36c8d40a3851$export$acbe2d25ac76ea64;
var $c97e36c8d40a3851$export$793c13e17d7e5e2b;
var $c97e36c8d40a3851$export$a5617e33b89fd956;
var $c97e36c8d40a3851$export$b51f82164fa31e07;
var $c97e36c8d40a3851$export$f2ef55183c04d202;
var $c97e36c8d40a3851$export$7c98fc0c48a16b1c;
var $c97e36c8d40a3851$export$f0511e328234ae83;
var $c97e36c8d40a3851$export$be46596bc6608f3b;
var $c97e36c8d40a3851$export$f215947b3d76a6b7;
var $c97e36c8d40a3851$export$89bbc91416db6670;
var $c97e36c8d40a3851$export$b4b5eff8a8712c89;
var $c97e36c8d40a3851$export$f455969a57ab8a03;
var $c97e36c8d40a3851$export$13f2f8f42af49cec;
var $c97e36c8d40a3851$export$cd357afe2ffdd2c3;
var $c97e36c8d40a3851$export$d9ca2a279a11be5e;
var $c97e36c8d40a3851$export$bbd59a8c7efad4c9;
var $c97e36c8d40a3851$export$8413282a17f1cda5;
var $c97e36c8d40a3851$export$30d19ddc7705e7e8;
var $c97e36c8d40a3851$export$64a4f09e2444b3d;
var $c97e36c8d40a3851$export$645b039fe163809e;
var $c97e36c8d40a3851$export$b23ef8b8ffa607e1;
var $c97e36c8d40a3851$export$8bf64516740c1369;
var $c97e36c8d40a3851$export$9a0dc8e612f3e10b;
var $c97e36c8d40a3851$export$abe90fedb3dddda2;
var $c97e36c8d40a3851$export$4a19da9c85ed2ade;
var $c97e36c8d40a3851$export$5e091479f094bdbc;
var $c97e36c8d40a3851$export$d70909b5aa96a79a;
var $c97e36c8d40a3851$export$651d142a8017d83d;
var $c97e36c8d40a3851$export$44382a010a9f7fcf;
var $c97e36c8d40a3851$export$807abfdc6b7b9338;
var $c97e36c8d40a3851$export$31881d07f2569218;
var $c97e36c8d40a3851$export$e5bbf306deb709a6;
var $c97e36c8d40a3851$export$aa8721167c5c8d2d;
var $c97e36c8d40a3851$export$757b93e5b3adc7cb;
var $c97e36c8d40a3851$export$f869eaa92db1dc9b;
var $c97e36c8d40a3851$export$5d1d761e41c32d9e;
var $c97e36c8d40a3851$export$8aec72d9491f9399;
var $c97e36c8d40a3851$export$5562635d2be2ab25;
var $c97e36c8d40a3851$export$2dc31837ce6f7a3d;
var $c97e36c8d40a3851$export$b561df15f64d32e3;
var $c97e36c8d40a3851$export$181f78b28f2ffa57;
var $c97e36c8d40a3851$export$6c97c77b89571c75;
var $c97e36c8d40a3851$export$51e431eaf1f9bf58;
var $c97e36c8d40a3851$export$71429c7ef7cb7063;
var $c97e36c8d40a3851$export$99905d7583a6e8ac;
var $c97e36c8d40a3851$export$b6c4be74fd0c06bd;
var $c97e36c8d40a3851$export$fd23e5b8d261a89;
var $c97e36c8d40a3851$export$25fabc9b3d1dd567;
var $c97e36c8d40a3851$export$41507f7b07dad151;
var $c97e36c8d40a3851$export$1352f3699c35dd73;
var $c97e36c8d40a3851$export$fd6c9d5c74d943ac;
var $c97e36c8d40a3851$export$c29634e3cf41e479;
var $c97e36c8d40a3851$export$e6a60882cce7a085;
var $c97e36c8d40a3851$export$6773c9098ba5e194;
var $c97e36c8d40a3851$export$6ee6b62f50047686;
var $c97e36c8d40a3851$export$efac052bb3661242;
var $c97e36c8d40a3851$export$7ccd63b9ca955862;
var $c97e36c8d40a3851$export$50921df5a58cb3ef;
var $c97e36c8d40a3851$export$8e48efc7acb57a97;
var $c97e36c8d40a3851$export$cea9121727113f77;
var $c97e36c8d40a3851$export$bed35ff7f9af3aaa;
var $c97e36c8d40a3851$export$6b729e898b9067ce;
var $c97e36c8d40a3851$export$984fbab9b52f7e24;
var $c97e36c8d40a3851$export$9ea17906a87ada6f;
var $c97e36c8d40a3851$export$394b443aaff3ef92;
var $c97e36c8d40a3851$export$6ddc374adbc06720;
var $c97e36c8d40a3851$export$ab8c7ebc9add56b2;
var $c97e36c8d40a3851$export$40ecc5bcd633d1ee;
var $c97e36c8d40a3851$export$86a8df7fff52fc69;
var $c97e36c8d40a3851$export$cf2115d46768f4c5;
var $c97e36c8d40a3851$export$3d7e036e195764db;
var $c97e36c8d40a3851$export$60c1d11221608cee;
var $c97e36c8d40a3851$export$bc3cef164abbc42c;
var $c97e36c8d40a3851$export$43f9afb62cd79dec;
var $c97e36c8d40a3851$export$a5ab4ffc4765f75f;
var $c97e36c8d40a3851$export$ccf46db9ab1743ec;
var $c97e36c8d40a3851$export$76c1c247342d776;
var $c97e36c8d40a3851$export$92f5944f0b02c9fb;
var $c97e36c8d40a3851$export$867eeefcb1c95b27;
var $c97e36c8d40a3851$export$5ada4697ae6aa17e;
var $c97e36c8d40a3851$export$427122300e8d54d0;
var $c97e36c8d40a3851$export$bcea8881375c352f;
var $c97e36c8d40a3851$export$b867715f9a0c04e9;
var $c97e36c8d40a3851$export$69878a39cbdbe097;
var $c97e36c8d40a3851$export$584c61a1b769552d;
var $c97e36c8d40a3851$export$8169ebcb0b0331dd;
var $c97e36c8d40a3851$export$2c9713b624877853;
var $c97e36c8d40a3851$export$45942692aeb454e0;
var $c97e36c8d40a3851$export$8e5efeaa031210cd;
var $c97e36c8d40a3851$export$35a62769ee05a05a;
var $c97e36c8d40a3851$export$8ea4f7e986ca4b06;
var $c97e36c8d40a3851$export$d2fd9ecaff0285a4;
var $c97e36c8d40a3851$export$a6c8e656a4f9bb67;
var $c97e36c8d40a3851$export$352a8075b163d53;
var $c97e36c8d40a3851$export$426d7b90ba5d79db;
var $c97e36c8d40a3851$export$f5a1ee40934d19ce;
var $c97e36c8d40a3851$export$1ba812a9756622ce;
var $c97e36c8d40a3851$export$351120039c36e03;
var $c97e36c8d40a3851$export$d42aa25ca09e17c4;
var $c97e36c8d40a3851$export$d268db29b88a4286;
var $c97e36c8d40a3851$export$c5deb6018f2d6251;
var $c97e36c8d40a3851$export$e06baa3034409453;
var $c97e36c8d40a3851$export$646fdb5910ce3931;
var $c97e36c8d40a3851$export$662e3d2d4361e29b;
var $c97e36c8d40a3851$export$1de3962f221ba441;
var $c97e36c8d40a3851$export$a4b3f0f5499c8738;
var $c97e36c8d40a3851$export$1aecdac6cecbdc5b;
var $c97e36c8d40a3851$export$2eb2ab35b317a103;
var $c97e36c8d40a3851$export$c7e14ea195ede241;
var $c97e36c8d40a3851$export$41ac034e7b9725a2;
var $c97e36c8d40a3851$export$9e521119d7751e37;
var $c97e36c8d40a3851$export$cbac8f541a64a150;
var $c97e36c8d40a3851$export$93dd08efa94c9dd4;
var $c97e36c8d40a3851$export$183e3523dac20bca;
var $c97e36c8d40a3851$export$3867ca1d8381d4e3;
var $c97e36c8d40a3851$export$11febcf9917c0057;
var $c97e36c8d40a3851$export$88ae1ee0c0a63398;
var $c97e36c8d40a3851$export$d5bd986d1f283f29;
var $c97e36c8d40a3851$export$fc4a2d238535d998;
var $c97e36c8d40a3851$export$57e53a60bf563f41;
var $c97e36c8d40a3851$export$ffdb1464deb0eedb;
var $c97e36c8d40a3851$export$b52670c950fd640;
var $c97e36c8d40a3851$export$c499fd8f1db3d18e;
var $c97e36c8d40a3851$export$b2ee2242301eff05;
var $c97e36c8d40a3851$export$2ebf9f7586f16841;
var $c97e36c8d40a3851$export$6e9ffd608b3e828b;
var $c97e36c8d40a3851$export$b960c5a73a722e6c;
var $c97e36c8d40a3851$export$a7a850351369c77e;
var $c97e36c8d40a3851$export$b18bca78f4736a94;
var $c97e36c8d40a3851$export$61a0059f562fb6c2;
var $c97e36c8d40a3851$export$7dc0d5aefb816d91;
var $c97e36c8d40a3851$export$58f6db56c841bef6;
var $c97e36c8d40a3851$export$97a3da679f509d5;
var $c97e36c8d40a3851$export$c387ec65fd1c2638;
var $c97e36c8d40a3851$export$4d9db82211f308a4;
var $c97e36c8d40a3851$export$ee4948a3be025123;
var $c97e36c8d40a3851$export$e0021eb2979cddaa;
var $c97e36c8d40a3851$export$7c0ac0c19a45beac;
var $c97e36c8d40a3851$export$6c32e9d84f534ee;
var $c97e36c8d40a3851$export$d1f9fbdb211dd29b;
var $c97e36c8d40a3851$export$45e7eea99a17d6e4;
var $c97e36c8d40a3851$export$20ea34e16c0aa64f;
var $c97e36c8d40a3851$export$8365b0f03557fae9;
var $c97e36c8d40a3851$export$49ebbb9621675650;
var $c97e36c8d40a3851$export$842be66a901f093;
var $c97e36c8d40a3851$export$a9f5a6cb28adccb1;
var $c97e36c8d40a3851$export$57b055d4bc586d67;
var $c97e36c8d40a3851$export$3ddfd660caa7bf7a;
var $c97e36c8d40a3851$export$fa7e1f5305153b3d;
var $c97e36c8d40a3851$export$5674ce9d013eb7bd;
var $c97e36c8d40a3851$export$6e8dc14cff6ccf72;
var $c97e36c8d40a3851$export$afd59480458e1b57;
var $c97e36c8d40a3851$export$48e61fb9bccccba9;
var $c97e36c8d40a3851$export$d3e674514dd3a3e1;
var $c97e36c8d40a3851$export$97ad02b50c60ef68;
var $c97e36c8d40a3851$export$61d053b1b63e82c4;
var $c97e36c8d40a3851$export$54256cce0d674dea;
var $c97e36c8d40a3851$export$8c01f0f407bcc5ca;
var $c97e36c8d40a3851$export$be3f46982f6c7160;
var $c97e36c8d40a3851$export$778e4213e2788579;
var $c97e36c8d40a3851$export$8b48ca3594d2b172;
var $c97e36c8d40a3851$export$8be180ec26319f9f;
var $c97e36c8d40a3851$export$60eccaddefa8fc1c;
var $c97e36c8d40a3851$export$c99ce4fe37484d84;
var $c97e36c8d40a3851$export$fdf432fcac7d8f37;
var $c97e36c8d40a3851$export$4c21cc9cdf2f5dbd;
var $c97e36c8d40a3851$export$dcc1eab7f3f31816;
var $c97e36c8d40a3851$export$dcb7f1379b2b8f86;
var $c97e36c8d40a3851$export$53416edeea4c2d74;
var $c97e36c8d40a3851$export$69f7e5d2b74c5c9e;
var $c97e36c8d40a3851$export$8e104aed582a26bc;
var $c97e36c8d40a3851$export$577047501949be9;
var $c97e36c8d40a3851$export$c4c45b599a2c15e;
var $c97e36c8d40a3851$export$361cb541700d648e;
var $c97e36c8d40a3851$export$974f160e11f25731;
var $c97e36c8d40a3851$export$7162f5c702b95903;
var $c97e36c8d40a3851$export$a034d066a9090500;
var $c97e36c8d40a3851$export$70938021e43e047c;
var $c97e36c8d40a3851$export$5f6ac460012a73bb;
var $c97e36c8d40a3851$export$d8e498c1c670bcbf;
var $c97e36c8d40a3851$export$cc1a78a24d947903;
var $c97e36c8d40a3851$export$d29b927e0bb0ffea;
var $c97e36c8d40a3851$export$b3999cacef245779;
var $c97e36c8d40a3851$export$ff168b5f9cf9dcf6;
var $c97e36c8d40a3851$export$2ab876a45bd6e64;
var $c97e36c8d40a3851$export$cb8027e4395c6c0e;
var $c97e36c8d40a3851$export$f5303d1bac3c2660;
var $c97e36c8d40a3851$export$6c463c5f3b00f64;
var $c97e36c8d40a3851$export$e25d553065457cab;
var $c97e36c8d40a3851$export$15d24c154ea8a56f;
var $c97e36c8d40a3851$export$e5065789a6c415d0;
var $c97e36c8d40a3851$export$62662c561d7c7835;
var $c97e36c8d40a3851$export$218f394557fb0a5a;
var $c97e36c8d40a3851$export$2a5ff6de5448ecdf;
var $c97e36c8d40a3851$export$9d23f3030ed2597e;
var $c97e36c8d40a3851$export$a26ff217a6124160;
var $c97e36c8d40a3851$export$c8072f5fcfdb5b77;
var $c97e36c8d40a3851$export$c4e4b74f1ccf3d96;
var $c97e36c8d40a3851$export$328519d02a26ac41;
var $c97e36c8d40a3851$export$d2061b291c43d045;
var $c97e36c8d40a3851$export$d1f04dfd3d695286;
var $c97e36c8d40a3851$export$234fbd86ea0f0bd8;
var $c97e36c8d40a3851$export$e795000978a75b12;
var $c97e36c8d40a3851$export$9f4683b4d1018ace;
var $c97e36c8d40a3851$export$e431b042fcdb1d63;
var $c97e36c8d40a3851$export$a453239171ac9a23;
var $c97e36c8d40a3851$export$3a7726a976c18d5f;
var $c97e36c8d40a3851$export$7eca7a6c06843b93;
var $c97e36c8d40a3851$export$f25c55f83e5b0672;
var $c97e36c8d40a3851$export$9562bfac4eb079cb;
var $c97e36c8d40a3851$export$c276d164ff91d2f7;
var $c97e36c8d40a3851$export$2f3e0574f1a99754;
var $c97e36c8d40a3851$export$15eecaab68167880;
var $c97e36c8d40a3851$export$513c47f6e194086a;
var $c97e36c8d40a3851$export$a3f464c4d5cd9096;
var $c97e36c8d40a3851$export$ed366a03a2330b03;
var $c97e36c8d40a3851$export$9b802c784f235e1d;
var $c97e36c8d40a3851$export$add0fc8b8c5726a4;
var $c97e36c8d40a3851$export$e7f32463f5bfd554;
var $c97e36c8d40a3851$export$f9346f394edf26a;
var $c97e36c8d40a3851$export$16b917774e73ef92;
var $c97e36c8d40a3851$export$15d2b60bf3b65454;
var $c97e36c8d40a3851$export$db55eca5af256142;
var $c97e36c8d40a3851$export$967c74f8b1f3d35;
var $c97e36c8d40a3851$export$7c33ae67962515d1;
var $c97e36c8d40a3851$export$9c69839b2d93489b;
var $c97e36c8d40a3851$export$be22d22d4b6cf5d8;
var $c97e36c8d40a3851$export$c529961b911626ac;
var $c97e36c8d40a3851$export$e39c4b15d2881f5;
var $c97e36c8d40a3851$export$a8ca145161313e7;
var $c97e36c8d40a3851$export$3c1204d03918d076;
var $c97e36c8d40a3851$export$eaac3f141165e288;
var $c97e36c8d40a3851$export$4c7e6934714150e6;
var $c97e36c8d40a3851$export$6f71f9711d666eb4;
var $c97e36c8d40a3851$export$2a3cd2bb71fb63a4;
var $c97e36c8d40a3851$export$55478a0b7d2ae98f;
var $c97e36c8d40a3851$export$bed10c4da9b8eb0a;
var $c97e36c8d40a3851$export$a82607b6424c06c8;
var $c97e36c8d40a3851$export$6b081f3484c7f4e5;
var $c97e36c8d40a3851$export$b7754d85fd39406c;
var $c97e36c8d40a3851$export$492856c046eb4728;
var $c97e36c8d40a3851$export$c1678a2059fbe906;
var $c97e36c8d40a3851$export$6d384a0bc1011c34;
var $c97e36c8d40a3851$export$1499a7dbfc01e7d4;
var $c97e36c8d40a3851$export$cfcbff40019f0ff1;
var $c97e36c8d40a3851$export$27157b5f68e583af;
var $c97e36c8d40a3851$export$54bf5ed61532925d;
var $c97e36c8d40a3851$export$60ed0786292ace08;
var $c97e36c8d40a3851$export$d770bfb8345e146;
var $c97e36c8d40a3851$export$bb73817f1290ad28;
var $c97e36c8d40a3851$export$f201c980f2b75802;
var $c97e36c8d40a3851$export$b40e970572afd0ee;
var $c97e36c8d40a3851$export$8850630a3d343488;
var $c97e36c8d40a3851$export$fd0a39a918d6516f;
var $c97e36c8d40a3851$export$e68ef41f8e0335bf;
var $c97e36c8d40a3851$export$5bff09650e762829;
var $c97e36c8d40a3851$export$21c1adce0e067f37;
var $c97e36c8d40a3851$export$fed6ce86f48c84bc;
var $c97e36c8d40a3851$export$500c2675137ac16e;
var $c97e36c8d40a3851$export$402c7728623fd8df;
var $c97e36c8d40a3851$export$15417259f4c0fe6b;
var $c97e36c8d40a3851$export$2b3b7f579a727f45;
var $c97e36c8d40a3851$export$514832a0b029734b;
var $c97e36c8d40a3851$export$b0522e6a14dec1a4;
var $c97e36c8d40a3851$export$659ea19f71a7ee0b;
var $c97e36c8d40a3851$export$1b61d972db315e73;
var $c97e36c8d40a3851$export$fb2970ee11a479ee;
var $c97e36c8d40a3851$export$920aceb2a8fad77e;
var $c97e36c8d40a3851$export$48f8f6fbc999d187;
var $c97e36c8d40a3851$export$eed590fa00a8223b;
var $c97e36c8d40a3851$export$f2e5bb5cd4a130da;
var $c97e36c8d40a3851$export$779ef03d633a9086;
var $c97e36c8d40a3851$export$d98b87c8d53d0dbc;
var $c97e36c8d40a3851$export$ca719aa57653a0a7;
var $c97e36c8d40a3851$export$74b19c5f48270c05;
var $c97e36c8d40a3851$export$c351affe7e8098cb;
var $c97e36c8d40a3851$export$be7cd6b3ae3ae765;
var $c97e36c8d40a3851$export$ec182524c4c57275;
var $c97e36c8d40a3851$export$9e45758246a85b07;
var $c97e36c8d40a3851$export$9fa5d5f0144954cb;
var $c97e36c8d40a3851$export$e66ba5bc4b978023;
var $c97e36c8d40a3851$export$2306e23cc611a36d;
var $c97e36c8d40a3851$export$144f8c1fe01428db;
var $c97e36c8d40a3851$export$f303b2744d52121c;
var $c97e36c8d40a3851$export$866b2dbc7bf18ce6;
var $c97e36c8d40a3851$export$b4c85774878b4841;
var $c97e36c8d40a3851$export$1c967a71bc9a3077;
var $c97e36c8d40a3851$export$5e3884a35a19eb90;
var $c97e36c8d40a3851$export$6e7ff99bb3259573;
var $c97e36c8d40a3851$export$7c932cba2d9e7a7;
var $c97e36c8d40a3851$export$94091942edce0667;
var $c97e36c8d40a3851$export$3671a8a524706a9d;
var $c97e36c8d40a3851$export$c288888dc82d233f;
var $c97e36c8d40a3851$export$8ff188536cebc35;
var $c97e36c8d40a3851$export$6407d78968c0eabe;
var $c97e36c8d40a3851$export$43e9fb9ec28d9743;
var $c97e36c8d40a3851$export$26f31d5c5c201739;
var $c97e36c8d40a3851$export$bff85124d2d35b93;
var $c97e36c8d40a3851$export$495c671ed5a6408c;
var $c97e36c8d40a3851$export$54b3d4d5548c35c3;
var $c97e36c8d40a3851$export$2954db6444fe1fa8;
var $c97e36c8d40a3851$export$15c1c974d16dd678;
var $c97e36c8d40a3851$export$9be2ae89a1eac217;
var $c97e36c8d40a3851$export$5c698591c0e586a2;
var $c97e36c8d40a3851$export$b711f2bb9c9a848a;
var $c97e36c8d40a3851$export$1d3a8501efd30213;
var $c97e36c8d40a3851$export$cebaf684ced5a2c9;
var $c97e36c8d40a3851$export$d4c658ecdcb7c78c;
var $c97e36c8d40a3851$export$b1b162b01baeb044;
var $c97e36c8d40a3851$export$8be2d593d7f88ed8;
var $c97e36c8d40a3851$export$dbd0a3528a97ccc0;
var $c97e36c8d40a3851$export$66581dc6d3d083d1;
var $c97e36c8d40a3851$export$e545f99e7abcc499;
var $c97e36c8d40a3851$export$7e1af5787f8c4aaa;
var $c97e36c8d40a3851$export$186c94c351c54768;
var $c97e36c8d40a3851$export$2e3fd8dfcb16fe0c;
var $c97e36c8d40a3851$export$7eeeceaa1dbd7cd5;
var $c97e36c8d40a3851$export$9d5bffdff936d554;
var $c97e36c8d40a3851$export$dc3a801c9a2c5b79;
var $c97e36c8d40a3851$export$27933a9557f87e98;
var $c97e36c8d40a3851$export$eefa737b40a0d535;
var $c97e36c8d40a3851$export$92740ffbcb02553b;
var $c97e36c8d40a3851$export$500e89753f9f1008;
var $c97e36c8d40a3851$export$d91a18e47fdddefd;
var $c97e36c8d40a3851$export$eccbe6f20884ea7f;
var $c97e36c8d40a3851$export$9e24f11d79141afb;
var $c97e36c8d40a3851$export$f0b96ad9586f8887;
var $c97e36c8d40a3851$export$8a92ed5d436a85c6;
var $c97e36c8d40a3851$export$edd59acdf7e86a71;
var $c97e36c8d40a3851$export$ae81a1ae71952d50;
var $c97e36c8d40a3851$export$6101470cd57eac1b;
var $c97e36c8d40a3851$export$452c0aee9673fe67;
var $c97e36c8d40a3851$export$773dddd1e8667756;
var $c97e36c8d40a3851$export$98815f8579a64a90;
var $c97e36c8d40a3851$export$7bc4e27428665019;
var $c97e36c8d40a3851$export$e7d7477fa9057ee2;
var $c97e36c8d40a3851$export$1f4267a3fc018448;
var $c97e36c8d40a3851$export$c171cae150389952;
var $c97e36c8d40a3851$export$d9bb35e957b22c72;
var $c97e36c8d40a3851$export$b3508a2c95f74e3d;
var $c97e36c8d40a3851$export$20bb272f4d21532d;
var $c97e36c8d40a3851$export$d7e64fbd0102ce90;
var $c97e36c8d40a3851$export$c17eae7e86dbba3c;
var $c97e36c8d40a3851$export$349603c0a9165744;
var $c97e36c8d40a3851$export$4dadf693741f0283;
var $c97e36c8d40a3851$export$6377864d12f7eeb3;
var $c97e36c8d40a3851$export$ba081af9585ed4;
var $c97e36c8d40a3851$export$7841dacb241485d0;
var $c97e36c8d40a3851$export$52c7044cf6301362;
var $c97e36c8d40a3851$export$56ea1c9e44590e20;
var $c97e36c8d40a3851$export$7626e389d05f4c36;
var $c97e36c8d40a3851$export$5e0a48187329b2e7;
var $c97e36c8d40a3851$export$c322b150d7667841;
var $c97e36c8d40a3851$export$4a4797d3c962f753;
var $c97e36c8d40a3851$export$767524d5e72e2645;
var $c97e36c8d40a3851$export$497354ca7b0ee666;
var $c97e36c8d40a3851$export$cbdc4ad11118116a;
var $c97e36c8d40a3851$export$5b890de778c4c2fe;
var $c97e36c8d40a3851$export$a78d9803b5e0a83e;
var $c97e36c8d40a3851$export$df1b536467b3992a;
var $c97e36c8d40a3851$export$73104a329e205998;
var $c97e36c8d40a3851$export$5740e3da55330b0a;
var $c97e36c8d40a3851$export$8dcc2d92ff6d65da;
var $c97e36c8d40a3851$export$e5f1321e53e24810;
var $c97e36c8d40a3851$export$56dd3098cbca7c8a;
var $c97e36c8d40a3851$export$aa7aff70e4380665;
var $c97e36c8d40a3851$export$dacb7d452aa6bcaf;
var $c97e36c8d40a3851$export$15dfc6c5e8f9baf6;
var $c97e36c8d40a3851$export$91ad03bba7909fb5;
var $c97e36c8d40a3851$export$86128e6c0ab71d64;
var $c97e36c8d40a3851$export$745b60c4819aec1d;
var $c97e36c8d40a3851$export$d2c893bfac1da9a1;
var $c97e36c8d40a3851$export$1c14ad02f9534b19;
var $c97e36c8d40a3851$export$db3cb63e0594d014;
var $c97e36c8d40a3851$export$a65c9a0eba2c222d;
var $c97e36c8d40a3851$export$68dbcca9c0e339ec;
var $c97e36c8d40a3851$export$d59b669d4bb3f006;
var $c97e36c8d40a3851$export$4d88d347aa9667fc;
var $c97e36c8d40a3851$export$9943ffdcaa4bc506;
var $c97e36c8d40a3851$export$d4f25b923533dbba;
var $c97e36c8d40a3851$export$35f3396a1cdeea45;
var $c97e36c8d40a3851$export$80e399da474bc98d;
var $c97e36c8d40a3851$export$e01809e2dbceac35;
var $c97e36c8d40a3851$export$41900d5c4e8a9c68;
var $c97e36c8d40a3851$export$362bb1cb0bb5ca03;
var $c97e36c8d40a3851$export$6803ac54f919d9cc;
var $c97e36c8d40a3851$export$72f5b47540331169;
var $c97e36c8d40a3851$export$6c61a8c9aa5305cb;
var $c97e36c8d40a3851$export$6b5244c457b68e65;
var $c97e36c8d40a3851$export$b7bd0c9a886f3414;
var $c97e36c8d40a3851$export$6b77f2bacac7c93d;
var $c97e36c8d40a3851$export$ddbc15c0e8e8a7ea;
var $c97e36c8d40a3851$export$feb4fe753df28a82;
var $c97e36c8d40a3851$export$d6267756132e2175;
var $c97e36c8d40a3851$export$570ac5a3fd7e6cc6;
var $c97e36c8d40a3851$export$5b9a0015e1c530ed;
var $c97e36c8d40a3851$export$8bbff71c84508218;
var $c97e36c8d40a3851$export$b55aa07a514a2430;
var $c97e36c8d40a3851$export$9927ad09f7c084dc;
var $c97e36c8d40a3851$export$52a07a35ff8ec6b6;
var $c97e36c8d40a3851$export$a10d277c42e6cae3;
var $c97e36c8d40a3851$export$cdc0ce5c66182801;
var $c97e36c8d40a3851$export$2504d4bd698dd962;
var $c97e36c8d40a3851$export$9dc86f3b876e96ef;
var $c97e36c8d40a3851$export$70ff7865f52549ae;
var $c97e36c8d40a3851$export$f77b53a42be6e6fd;
var $c97e36c8d40a3851$export$818eb7ab11414506;
var $c97e36c8d40a3851$export$829ef6b2e59d984d;
var $c97e36c8d40a3851$export$b30f4cb52c088a26;
var $c97e36c8d40a3851$export$335eace0ff1771cd;
var $c97e36c8d40a3851$export$374d88a2025416ac;
var $c97e36c8d40a3851$export$bb7a91303551eb37;
var $c97e36c8d40a3851$export$f132ea291a7db56b;
var $c97e36c8d40a3851$export$f0abd4170bbd2468;
var $c97e36c8d40a3851$export$50d00a157dc08581;
var $c97e36c8d40a3851$export$484576567a98833f;
var $c97e36c8d40a3851$export$ec9e491e475d0c97;
var $c97e36c8d40a3851$export$a86c59c10992220f;
var $c97e36c8d40a3851$export$e12f06597e992fde;
var $c97e36c8d40a3851$export$7ec54678ba28ea59;
var $c97e36c8d40a3851$export$433ba14c16717110;
var $c97e36c8d40a3851$export$309ee349b8a537f;
var $c97e36c8d40a3851$export$b87f371cbc396fcf;
var $c97e36c8d40a3851$export$60050fc49fe0e7e2;
var $c97e36c8d40a3851$export$348c8e2b37f276cd;
var $c97e36c8d40a3851$export$7f47e8a8b2d97cb2;
var $c97e36c8d40a3851$export$50d5adc4b543ce95;
var $c97e36c8d40a3851$export$9221f1d2c934d9f;
var $c97e36c8d40a3851$export$3a56578b3ae09a02;
var $c97e36c8d40a3851$export$e47b8dab9466c895;
var $c97e36c8d40a3851$export$4ca52f75cf4889c5;
var $c97e36c8d40a3851$export$7343d7d72195067f;
var $c97e36c8d40a3851$export$f334f32f8d4d8063;
var $c97e36c8d40a3851$export$c7bf2089e89a217c;
var $c97e36c8d40a3851$export$f514f97553a434b2;
var $c97e36c8d40a3851$export$61abde59b50deb8e;
var $c97e36c8d40a3851$export$5a5ce44f9fb51f93;
var $c97e36c8d40a3851$export$7044ea8d89b6f59d;
var $c97e36c8d40a3851$export$40eacf1a072c9dbd;
var $c97e36c8d40a3851$export$4c1fa0ac0eff2ac;
var $c97e36c8d40a3851$export$5bee9450fe31dde1;
var $c97e36c8d40a3851$export$d0b571fb4406d953;
var $c97e36c8d40a3851$export$258b370e6c2b85d5;
var $c97e36c8d40a3851$export$dc5e5523da291a4b;
var $c97e36c8d40a3851$export$fd5a8904ab5abfe0;
var $c97e36c8d40a3851$export$1350d8937b0f26fb;
var $c97e36c8d40a3851$export$2a045f777fb349a8;
var $c97e36c8d40a3851$export$8bb874585539a88f;
var $c97e36c8d40a3851$export$17d3a50785727199;
var $c97e36c8d40a3851$export$2931c570009689e;
var $c97e36c8d40a3851$export$199cbcedee735a43;
var $c97e36c8d40a3851$export$4ba5bf9d4e3ed862;
var $c97e36c8d40a3851$export$674c01ec2f0b89c3;
var $c97e36c8d40a3851$export$bda1686739fd61c7;
var $c97e36c8d40a3851$export$8d804148f485d54c;
var $c97e36c8d40a3851$export$212a8f1ea37518bd;
var $c97e36c8d40a3851$export$c9ac0fee28245883;
var $c97e36c8d40a3851$export$77078610759fe5f6;
var $c97e36c8d40a3851$export$7c6317deeec7a6c1;
var $c97e36c8d40a3851$export$877ebf2e4ad81f03;
var $c97e36c8d40a3851$export$70b2343945496e1f;
var $c97e36c8d40a3851$export$8415b56d2c6d2b1d;
var $c97e36c8d40a3851$export$cc81114a03caab18;
var $c97e36c8d40a3851$export$bc14eb892daceb23;
var $c97e36c8d40a3851$export$3c973217450c3e9d;
var $c97e36c8d40a3851$export$582c0b730ff1ddb9;
var $c97e36c8d40a3851$export$b3edfb545b65f1c5;
var $c97e36c8d40a3851$export$2593317d8731841c;
var $c97e36c8d40a3851$export$8bb5bc1732aa41f;
var $c97e36c8d40a3851$export$74a79c98b110b5b9;
var $c97e36c8d40a3851$export$26461b03281b4db4;
var $c97e36c8d40a3851$export$eaea590d6d3dd93c;
var $c97e36c8d40a3851$export$af45365f70099379;
var $c97e36c8d40a3851$export$a49e732d34d5ba9b;
var $c97e36c8d40a3851$export$7c147fe246bc8bd3;
var $c97e36c8d40a3851$export$e5111b6070e1ee9e;
var $c97e36c8d40a3851$export$591cbfd403f8c8d;
var $c97e36c8d40a3851$export$b1388db955bbb885;
var $c97e36c8d40a3851$export$e898d0e9e211abd9;
var $c97e36c8d40a3851$export$ab6fee0e8a6ee069;
var $c97e36c8d40a3851$export$9786ad94c199ffbb;
var $c97e36c8d40a3851$export$269890524eed693b;
var $c97e36c8d40a3851$export$2ec623a8212d6b64;
var $c97e36c8d40a3851$export$30e7673b01ff994e;
var $c97e36c8d40a3851$export$9ea93477840812bf;
var $c97e36c8d40a3851$export$a6da0c365670c430;
var $c97e36c8d40a3851$export$7986b22da43f2885;
var $c97e36c8d40a3851$export$a9f943c7ceb3b42f;
var $c97e36c8d40a3851$export$dfe49501efcdffce;
var $c97e36c8d40a3851$export$be465f50c92eb01d;
var $c97e36c8d40a3851$export$c138d1796bb34999;
var $c97e36c8d40a3851$export$85a0016690a0ccf2;
var $c97e36c8d40a3851$export$883acab36ede4bfa;
var $c97e36c8d40a3851$export$9cfc88d203f9cdf1;
var $c97e36c8d40a3851$export$b3c6c599110d7bab;
var $c97e36c8d40a3851$export$247839c65766758;
var $c97e36c8d40a3851$export$f4d52b02df927d54;
var $c97e36c8d40a3851$export$df30ee8c5b5f1989;
var $c97e36c8d40a3851$export$268a117c860fca6d;
"use strict";
const $c97e36c8d40a3851$var$AI_CITATIONS = "ai.citations", $c97e36c8d40a3851$var$AI_COMPLETION_TOKENS_USED = "ai.completion_tokens.used", $c97e36c8d40a3851$var$AI_DOCUMENTS = "ai.documents", $c97e36c8d40a3851$var$AI_FINISH_REASON = "ai.finish_reason", $c97e36c8d40a3851$var$AI_FREQUENCY_PENALTY = "ai.frequency_penalty", $c97e36c8d40a3851$var$AI_FUNCTION_CALL = "ai.function_call", $c97e36c8d40a3851$var$AI_GENERATION_ID = "ai.generation_id", $c97e36c8d40a3851$var$AI_INPUT_MESSAGES = "ai.input_messages", $c97e36c8d40a3851$var$AI_IS_SEARCH_REQUIRED = "ai.is_search_required", $c97e36c8d40a3851$var$AI_METADATA = "ai.metadata", $c97e36c8d40a3851$var$AI_MODEL_ID = "ai.model_id", $c97e36c8d40a3851$var$AI_MODEL_PROVIDER = "ai.model.provider", $c97e36c8d40a3851$var$AI_PIPELINE_NAME = "ai.pipeline.name", $c97e36c8d40a3851$var$AI_PREAMBLE = "ai.preamble", $c97e36c8d40a3851$var$AI_PRESENCE_PENALTY = "ai.presence_penalty", $c97e36c8d40a3851$var$AI_PROMPT_TOKENS_USED = "ai.prompt_tokens.used", $c97e36c8d40a3851$var$AI_RAW_PROMPTING = "ai.raw_prompting", $c97e36c8d40a3851$var$AI_RESPONSES = "ai.responses", $c97e36c8d40a3851$var$AI_RESPONSE_FORMAT = "ai.response_format", $c97e36c8d40a3851$var$AI_SEARCH_QUERIES = "ai.search_queries", $c97e36c8d40a3851$var$AI_SEARCH_RESULTS = "ai.search_results", $c97e36c8d40a3851$var$AI_SEED = "ai.seed", $c97e36c8d40a3851$var$AI_STREAMING = "ai.streaming", $c97e36c8d40a3851$var$AI_TAGS = "ai.tags", $c97e36c8d40a3851$var$AI_TEMPERATURE = "ai.temperature", $c97e36c8d40a3851$var$AI_TEXTS = "ai.texts", $c97e36c8d40a3851$var$AI_TOOLS = "ai.tools", $c97e36c8d40a3851$var$AI_TOOL_CALLS = "ai.tool_calls", $c97e36c8d40a3851$var$AI_TOP_K = "ai.top_k", $c97e36c8d40a3851$var$AI_TOP_P = "ai.top_p", $c97e36c8d40a3851$var$AI_TOTAL_COST = "ai.total_cost", $c97e36c8d40a3851$var$AI_TOTAL_TOKENS_USED = "ai.total_tokens.used", $c97e36c8d40a3851$var$AI_WARNINGS = "ai.warnings", $c97e36c8d40a3851$var$ANGULAR_VERSION = "angular.version", $c97e36c8d40a3851$var$APP_APP_BUILD = "app.app_build", $c97e36c8d40a3851$var$APP_APP_IDENTIFIER = "app.app_identifier", $c97e36c8d40a3851$var$APP_APP_NAME = "app.app_name", $c97e36c8d40a3851$var$APP_APP_START_TIME = "app.app_start_time", $c97e36c8d40a3851$var$APP_APP_VERSION = "app.app_version", $c97e36c8d40a3851$var$APP_BUILD = "app.build", $c97e36c8d40a3851$var$APP_IDENTIFIER = "app.identifier", $c97e36c8d40a3851$var$APP_IN_FOREGROUND = "app.in_foreground", $c97e36c8d40a3851$var$APP_NAME = "app.name", $c97e36c8d40a3851$var$APP_START_COLD = "app_start_cold", $c97e36c8d40a3851$var$APP_START_TIME = "app.start_time", $c97e36c8d40a3851$var$APP_START_TYPE = "app_start_type", $c97e36c8d40a3851$var$APP_START_WARM = "app_start_warm", $c97e36c8d40a3851$var$APP_VERSION = "app.version", $c97e36c8d40a3851$var$APP_VITALS_FRAMES_DELAY_VALUE = "app.vitals.frames.delay.value", $c97e36c8d40a3851$var$APP_VITALS_FRAMES_FROZEN_COUNT = "app.vitals.frames.frozen.count", $c97e36c8d40a3851$var$APP_VITALS_FRAMES_SLOW_COUNT = "app.vitals.frames.slow.count", $c97e36c8d40a3851$var$APP_VITALS_FRAMES_TOTAL_COUNT = "app.vitals.frames.total.count", $c97e36c8d40a3851$var$APP_VITALS_START_COLD_VALUE = "app.vitals.start.cold.value", $c97e36c8d40a3851$var$APP_VITALS_START_PREWARMED = "app.vitals.start.prewarmed", $c97e36c8d40a3851$var$APP_VITALS_START_REASON = "app.vitals.start.reason", $c97e36c8d40a3851$var$APP_VITALS_START_SCREEN = "app.vitals.start.screen", $c97e36c8d40a3851$var$APP_VITALS_START_TYPE = "app.vitals.start.type", $c97e36c8d40a3851$var$APP_VITALS_START_WARM_VALUE = "app.vitals.start.warm.value", $c97e36c8d40a3851$var$APP_VITALS_TTFD_VALUE = "app.vitals.ttfd.value", $c97e36c8d40a3851$var$APP_VITALS_TTID_VALUE = "app.vitals.ttid.value", $c97e36c8d40a3851$var$ART_GC_BLOCKING_COUNT = "art.gc.blocking_count", $c97e36c8d40a3851$var$ART_GC_BLOCKING_TIME = "art.gc.blocking_time", $c97e36c8d40a3851$var$ART_GC_PRE_OOME_COUNT = "art.gc.pre_oome_count", $c97e36c8d40a3851$var$ART_GC_TOTAL_COUNT = "art.gc.total_count", $c97e36c8d40a3851$var$ART_GC_TOTAL_TIME = "art.gc.total_time", $c97e36c8d40a3851$var$ART_GC_WAITING_TIME = "art.gc.waiting_time", $c97e36c8d40a3851$var$ART_MEMORY_FREE = "art.memory.free", $c97e36c8d40a3851$var$ART_MEMORY_FREE_UNTIL_GC = "art.memory.free_until_gc", $c97e36c8d40a3851$var$ART_MEMORY_FREE_UNTIL_OOME = "art.memory.free_until_oome", $c97e36c8d40a3851$var$ART_MEMORY_MAX = "art.memory.max", $c97e36c8d40a3851$var$ART_MEMORY_TOTAL = "art.memory.total", $c97e36c8d40a3851$var$AWS_CLOUDWATCH_LOGS_LOG_GROUP = "aws.cloudwatch.logs.log_group", $c97e36c8d40a3851$var$AWS_CLOUDWATCH_LOGS_LOG_STREAM = "aws.cloudwatch.logs.log_stream", $c97e36c8d40a3851$var$AWS_CLOUDWATCH_LOGS_URL = "aws.cloudwatch.logs.url", $c97e36c8d40a3851$var$AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS = "aws.dynamodb.attribute_definitions", $c97e36c8d40a3851$var$AWS_DYNAMODB_CONSISTENT_READ = "aws.dynamodb.consistent_read", $c97e36c8d40a3851$var$AWS_DYNAMODB_CONSUMED_CAPACITY = "aws.dynamodb.consumed_capacity", $c97e36c8d40a3851$var$AWS_DYNAMODB_COUNT = "aws.dynamodb.count", $c97e36c8d40a3851$var$AWS_DYNAMODB_EXCLUSIVE_START_TABLE = "aws.dynamodb.exclusive_start_table", $c97e36c8d40a3851$var$AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES = "aws.dynamodb.global_secondary_indexes", $c97e36c8d40a3851$var$AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES = "aws.dynamodb.global_secondary_index_updates", $c97e36c8d40a3851$var$AWS_DYNAMODB_INDEX_NAME = "aws.dynamodb.index_name", $c97e36c8d40a3851$var$AWS_DYNAMODB_ITEM_COLLECTION_METRICS = "aws.dynamodb.item_collection_metrics", $c97e36c8d40a3851$var$AWS_DYNAMODB_LIMIT = "aws.dynamodb.limit", $c97e36c8d40a3851$var$AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES = "aws.dynamodb.local_secondary_indexes", $c97e36c8d40a3851$var$AWS_DYNAMODB_PROJECTION = "aws.dynamodb.projection", $c97e36c8d40a3851$var$AWS_DYNAMODB_PROVISIONED_READ_CAPACITY = "aws.dynamodb.provisioned_read_capacity", $c97e36c8d40a3851$var$AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY = "aws.dynamodb.provisioned_write_capacity", $c97e36c8d40a3851$var$AWS_DYNAMODB_SCANNED_COUNT = "aws.dynamodb.scanned_count", $c97e36c8d40a3851$var$AWS_DYNAMODB_SCAN_FORWARD = "aws.dynamodb.scan_forward", $c97e36c8d40a3851$var$AWS_DYNAMODB_SEGMENT = "aws.dynamodb.segment", $c97e36c8d40a3851$var$AWS_DYNAMODB_SELECT = "aws.dynamodb.select", $c97e36c8d40a3851$var$AWS_DYNAMODB_TABLE_COUNT = "aws.dynamodb.table_count", $c97e36c8d40a3851$var$AWS_DYNAMODB_TABLE_NAMES = "aws.dynamodb.table_names", $c97e36c8d40a3851$var$AWS_DYNAMODB_TOTAL_SEGMENTS = "aws.dynamodb.total_segments", $c97e36c8d40a3851$var$AWS_EXTENDED_REQUEST_ID = "aws.extended_request_id", $c97e36c8d40a3851$var$AWS_KINESIS_STREAM_NAME = "aws.kinesis.stream_name", $c97e36c8d40a3851$var$_AWS_KINESIS_STREAM_NAME = "aws.kinesis.stream.name", $c97e36c8d40a3851$var$AWS_LAMBDA_AWS_REQUEST_ID = "aws.lambda.aws_request_id", $c97e36c8d40a3851$var$AWS_LAMBDA_EXECUTION_DURATION_IN_MILLIS = "aws.lambda.execution_duration_in_millis", $c97e36c8d40a3851$var$AWS_LAMBDA_FUNCTION_NAME = "aws.lambda.function_name", $c97e36c8d40a3851$var$AWS_LAMBDA_FUNCTION_VERSION = "aws.lambda.function_version", $c97e36c8d40a3851$var$AWS_LAMBDA_INVOKED_ARN = "aws.lambda.invoked_arn", $c97e36c8d40a3851$var$AWS_LAMBDA_INVOKED_FUNCTION_ARN = "aws.lambda.invoked_function_arn", $c97e36c8d40a3851$var$AWS_LAMBDA_REMAINING_TIME_IN_MILLIS = "aws.lambda.remaining_time_in_millis", $c97e36c8d40a3851$var$AWS_LOG_GROUP_NAMES = "aws.log.group.names", $c97e36c8d40a3851$var$AWS_LOG_STREAM_NAMES = "aws.log.stream.names", $c97e36c8d40a3851$var$AWS_REQUEST_EXTENDED_ID = "aws.request.extended_id", $c97e36c8d40a3851$var$AWS_REQUEST_ID = "aws.request_id", $c97e36c8d40a3851$var$_AWS_REQUEST_ID = "aws.request.id", $c97e36c8d40a3851$var$AWS_S3_BUCKET = "aws.s3.bucket", $c97e36c8d40a3851$var$AWS_SECRETSMANAGER_SECRET_ARN = "aws.secretsmanager.secret.arn", $c97e36c8d40a3851$var$AWS_SNS_TOPIC_ARN = "aws.sns.topic.arn", $c97e36c8d40a3851$var$AWS_STEP_FUNCTIONS_ACTIVITY_ARN = "aws.step_functions.activity.arn", $c97e36c8d40a3851$var$AWS_STEP_FUNCTIONS_STATE_MACHINE_ARN = "aws.step_functions.state_machine.arn", $c97e36c8d40a3851$var$BLOCKED_MAIN_THREAD = "blocked_main_thread", $c97e36c8d40a3851$var$BROWSER_NAME = "browser.name", $c97e36c8d40a3851$var$BROWSER_PERFORMANCE_NAVIGATION_ACTIVATION_START = "browser.performance.navigation.activation_start", $c97e36c8d40a3851$var$BROWSER_PERFORMANCE_TIME_ORIGIN = "browser.performance.time_origin", $c97e36c8d40a3851$var$BROWSER_REPORT_TYPE = "browser.report.type", $c97e36c8d40a3851$var$BROWSER_SCRIPT_INVOKER = "browser.script.invoker", $c97e36c8d40a3851$var$BROWSER_SCRIPT_INVOKER_TYPE = "browser.script.invoker_type", $c97e36c8d40a3851$var$BROWSER_SCRIPT_SOURCE_CHAR_POSITION = "browser.script.source_char_position", $c97e36c8d40a3851$var$BROWSER_VERSION = "browser.version", $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_CLS_REPORT_EVENT = "browser.web_vital.cls.report_event", $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_CLS_SOURCE_KEY = "browser.web_vital.cls.source.<key>", $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_CLS_SOURCE_KEY_BASE = "browser.web_vital.cls.source", $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_CLS_VALUE = "browser.web_vital.cls.value", $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_FCP_VALUE = "browser.web_vital.fcp.value", $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_FP_VALUE = "browser.web_vital.fp.value", $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_INP_VALUE = "browser.web_vital.inp.value", $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_LCP_ELEMENT = "browser.web_vital.lcp.element", $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_LCP_ID = "browser.web_vital.lcp.id", $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_LCP_LOAD_TIME = "browser.web_vital.lcp.load_time", $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_LCP_RENDER_TIME = "browser.web_vital.lcp.render_time", $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_LCP_REPORT_EVENT = "browser.web_vital.lcp.report_event", $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_LCP_SIZE = "browser.web_vital.lcp.size", $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_LCP_URL = "browser.web_vital.lcp.url", $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_LCP_VALUE = "browser.web_vital.lcp.value", $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_TTFB_REQUEST_TIME = "browser.web_vital.ttfb.request_time", $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_TTFB_VALUE = "browser.web_vital.ttfb.value", $c97e36c8d40a3851$var$CACHE_HIT = "cache.hit", $c97e36c8d40a3851$var$CACHE_ITEM_SIZE = "cache.item_size", $c97e36c8d40a3851$var$CACHE_KEY = "cache.key", $c97e36c8d40a3851$var$CACHE_OPERATION = "cache.operation", $c97e36c8d40a3851$var$CACHE_TTL = "cache.ttl", $c97e36c8d40a3851$var$CACHE_WRITE = "cache.write", $c97e36c8d40a3851$var$CHANNEL = "channel", $c97e36c8d40a3851$var$CLIENT_ADDRESS = "client.address", $c97e36c8d40a3851$var$CLIENT_PORT = "client.port", $c97e36c8d40a3851$var$CLOUDFLARE_D1_DURATION = "cloudflare.d1.duration", $c97e36c8d40a3851$var$CLOUDFLARE_D1_QUERY_TYPE = "cloudflare.d1.query_type", $c97e36c8d40a3851$var$CLOUDFLARE_D1_ROWS_READ = "cloudflare.d1.rows_read", $c97e36c8d40a3851$var$CLOUDFLARE_D1_ROWS_WRITTEN = "cloudflare.d1.rows_written", $c97e36c8d40a3851$var$CLOUDFLARE_DURABLE_OBJECT_QUERY_BINDINGS = "cloudflare.durable_object.query.bindings", $c97e36c8d40a3851$var$CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_READ = "cloudflare.durable_object.response.rows_read", $c97e36c8d40a3851$var$CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_WRITTEN = "cloudflare.durable_object.response.rows_written", $c97e36c8d40a3851$var$CLOUDFLARE_R2_BUCKET = "cloudflare.r2.bucket", $c97e36c8d40a3851$var$CLOUDFLARE_R2_OPERATION = "cloudflare.r2.operation", $c97e36c8d40a3851$var$CLOUDFLARE_R2_REQUEST_DELIMITER = "cloudflare.r2.request.delimiter", $c97e36c8d40a3851$var$CLOUDFLARE_R2_REQUEST_KEY = "cloudflare.r2.request.key", $c97e36c8d40a3851$var$CLOUDFLARE_R2_REQUEST_PART_NUMBER = "cloudflare.r2.request.part_number", $c97e36c8d40a3851$var$CLOUDFLARE_R2_REQUEST_PREFIX = "cloudflare.r2.request.prefix", $c97e36c8d40a3851$var$CLOUDFLARE_WORKFLOW_ATTEMPT = "cloudflare.workflow.attempt", $c97e36c8d40a3851$var$CLOUDFLARE_WORKFLOW_RETRIES_BACKOFF = "cloudflare.workflow.retries.backoff", $c97e36c8d40a3851$var$CLOUDFLARE_WORKFLOW_RETRIES_DELAY = "cloudflare.workflow.retries.delay", $c97e36c8d40a3851$var$CLOUDFLARE_WORKFLOW_RETRIES_LIMIT = "cloudflare.workflow.retries.limit", $c97e36c8d40a3851$var$CLOUDFLARE_WORKFLOW_TIMEOUT = "cloudflare.workflow.timeout", $c97e36c8d40a3851$var$CLOUD_ACCOUNT_ID = "cloud.account.id", $c97e36c8d40a3851$var$CLOUD_AVAILABILITY_ZONE = "cloud.availability_zone", $c97e36c8d40a3851$var$CLOUD_PLATFORM = "cloud.platform", $c97e36c8d40a3851$var$CLOUD_PROVIDER = "cloud.provider", $c97e36c8d40a3851$var$CLOUD_REGION = "cloud.region", $c97e36c8d40a3851$var$CLOUD_RESOURCE_ID = "cloud.resource_id", $c97e36c8d40a3851$var$CLS = "cls", $c97e36c8d40a3851$var$CLS_SOURCE_KEY = "cls.source.<key>", $c97e36c8d40a3851$var$CLS_SOURCE_KEY_BASE = "cls.source", $c97e36c8d40a3851$var$CODE_FILEPATH = "code.filepath", $c97e36c8d40a3851$var$CODE_FILE_PATH = "code.file.path", $c97e36c8d40a3851$var$CODE_FUNCTION = "code.function", $c97e36c8d40a3851$var$CODE_FUNCTION_NAME = "code.function.name", $c97e36c8d40a3851$var$CODE_LINENO = "code.lineno", $c97e36c8d40a3851$var$CODE_LINE_NUMBER = "code.line.number", $c97e36c8d40a3851$var$CODE_NAMESPACE = "code.namespace", $c97e36c8d40a3851$var$CONNECTIONTYPE = "connectionType", $c97e36c8d40a3851$var$CONNECTION_RTT = "connection.rtt", $c97e36c8d40a3851$var$CULTURE_CALENDAR = "culture.calendar", $c97e36c8d40a3851$var$CULTURE_DISPLAY_NAME = "culture.display_name", $c97e36c8d40a3851$var$CULTURE_IS_24_HOUR_FORMAT = "culture.is_24_hour_format", $c97e36c8d40a3851$var$CULTURE_LOCALE = "culture.locale", $c97e36c8d40a3851$var$CULTURE_TIMEZONE = "culture.timezone", $c97e36c8d40a3851$var$DB_COLLECTION_NAME = "db.collection.name", $c97e36c8d40a3851$var$DB_DRIVER_NAME = "db.driver.name", $c97e36c8d40a3851$var$DB_NAME = "db.name", $c97e36c8d40a3851$var$DB_NAMESPACE = "db.namespace", $c97e36c8d40a3851$var$DB_OPERATION = "db.operation", $c97e36c8d40a3851$var$DB_OPERATION_BATCH_SIZE = "db.operation.batch.size", $c97e36c8d40a3851$var$DB_OPERATION_NAME = "db.operation.name", $c97e36c8d40a3851$var$DB_QUERY_PARAMETER_KEY = "db.query.parameter.<key>", $c97e36c8d40a3851$var$DB_QUERY_PARAMETER_KEY_BASE = "db.query.parameter", $c97e36c8d40a3851$var$DB_QUERY_SUMMARY = "db.query.summary", $c97e36c8d40a3851$var$DB_QUERY_TEXT = "db.query.text", $c97e36c8d40a3851$var$DB_REDIS_CONNECTION = "db.redis.connection", $c97e36c8d40a3851$var$DB_REDIS_KEY = "db.redis.key", $c97e36c8d40a3851$var$DB_REDIS_PARAMETERS = "db.redis.parameters", $c97e36c8d40a3851$var$DB_RESPONSE_STATUS_CODE = "db.response.status_code", $c97e36c8d40a3851$var$DB_SQL_BINDINGS = "db.sql.bindings", $c97e36c8d40a3851$var$DB_STATEMENT = "db.statement", $c97e36c8d40a3851$var$DB_STORED_PROCEDURE_NAME = "db.stored_procedure.name", $c97e36c8d40a3851$var$DB_SYSTEM = "db.system", $c97e36c8d40a3851$var$DB_SYSTEM_NAME = "db.system.name", $c97e36c8d40a3851$var$DB_USER = "db.user", $c97e36c8d40a3851$var$DEVICEMEMORY = "deviceMemory", $c97e36c8d40a3851$var$DEVICE_ARCHS = "device.archs", $c97e36c8d40a3851$var$DEVICE_BATTERY_LEVEL = "device.battery_level", $c97e36c8d40a3851$var$DEVICE_BATTERY_TEMPERATURE = "device.battery_temperature", $c97e36c8d40a3851$var$DEVICE_BOOT_TIME = "device.boot_time", $c97e36c8d40a3851$var$DEVICE_BRAND = "device.brand", $c97e36c8d40a3851$var$DEVICE_CHARGING = "device.charging", $c97e36c8d40a3851$var$DEVICE_CHIPSET = "device.chipset", $c97e36c8d40a3851$var$DEVICE_CLASS = "device.class", $c97e36c8d40a3851$var$DEVICE_CONNECTION_TYPE = "device.connection_type", $c97e36c8d40a3851$var$DEVICE_CPU_DESCRIPTION = "device.cpu_description", $c97e36c8d40a3851$var$DEVICE_EXTERNAL_FREE_STORAGE = "device.external_free_storage", $c97e36c8d40a3851$var$DEVICE_EXTERNAL_STORAGE_SIZE = "device.external_storage_size", $c97e36c8d40a3851$var$DEVICE_FAMILY = "device.family", $c97e36c8d40a3851$var$DEVICE_FREE_MEMORY = "device.free_memory", $c97e36c8d40a3851$var$DEVICE_FREE_STORAGE = "device.free_storage", $c97e36c8d40a3851$var$DEVICE_ID = "device.id", $c97e36c8d40a3851$var$DEVICE_LOCALE = "device.locale", $c97e36c8d40a3851$var$DEVICE_LOW_MEMORY = "device.low_memory", $c97e36c8d40a3851$var$DEVICE_LOW_POWER_MODE = "device.low_power_mode", $c97e36c8d40a3851$var$DEVICE_MANUFACTURER = "device.manufacturer", $c97e36c8d40a3851$var$DEVICE_MEMORY_ESTIMATED_CAPACITY = "device.memory.estimated_capacity", $c97e36c8d40a3851$var$DEVICE_MEMORY_SIZE = "device.memory_size", $c97e36c8d40a3851$var$DEVICE_MODEL = "device.model", $c97e36c8d40a3851$var$DEVICE_MODEL_ID = "device.model_id", $c97e36c8d40a3851$var$DEVICE_NAME = "device.name", $c97e36c8d40a3851$var$DEVICE_ONLINE = "device.online", $c97e36c8d40a3851$var$DEVICE_ORIENTATION = "device.orientation", $c97e36c8d40a3851$var$DEVICE_PROCESSOR_COUNT = "device.processor_count", $c97e36c8d40a3851$var$DEVICE_PROCESSOR_FREQUENCY = "device.processor_frequency", $c97e36c8d40a3851$var$DEVICE_SCREEN_DENSITY = "device.screen_density", $c97e36c8d40a3851$var$DEVICE_SCREEN_DPI = "device.screen_dpi", $c97e36c8d40a3851$var$DEVICE_SCREEN_HEIGHT_PIXELS = "device.screen_height_pixels", $c97e36c8d40a3851$var$DEVICE_SCREEN_WIDTH_PIXELS = "device.screen_width_pixels", $c97e36c8d40a3851$var$DEVICE_SIMULATOR = "device.simulator", $c97e36c8d40a3851$var$DEVICE_STORAGE_SIZE = "device.storage_size", $c97e36c8d40a3851$var$DEVICE_THERMAL_STATE = "device.thermal_state", $c97e36c8d40a3851$var$DEVICE_TIMEZONE = "device.timezone", $c97e36c8d40a3851$var$DEVICE_USABLE_MEMORY = "device.usable_memory", $c97e36c8d40a3851$var$DIST = "dist", $c97e36c8d40a3851$var$EFFECTIVECONNECTIONTYPE = "effectiveConnectionType", $c97e36c8d40a3851$var$ENVIRONMENT = "environment", $c97e36c8d40a3851$var$ERROR_TYPE = "error.type", $c97e36c8d40a3851$var$EVENT_ID = "event.id", $c97e36c8d40a3851$var$EVENT_NAME = "event.name", $c97e36c8d40a3851$var$EXCEPTION_ESCAPED = "exception.escaped", $c97e36c8d40a3851$var$EXCEPTION_MESSAGE = "exception.message", $c97e36c8d40a3851$var$EXCEPTION_STACKTRACE = "exception.stacktrace", $c97e36c8d40a3851$var$EXCEPTION_TYPE = "exception.type", $c97e36c8d40a3851$var$FAAS_COLDSTART = "faas.coldstart", $c97e36c8d40a3851$var$FAAS_CRON = "faas.cron", $c97e36c8d40a3851$var$FAAS_DURATION_IN_MS = "faas.duration_in_ms", $c97e36c8d40a3851$var$FAAS_ENTRY_POINT = "faas.entry_point", $c97e36c8d40a3851$var$FAAS_EXECUTION = "faas.execution", $c97e36c8d40a3851$var$FAAS_ID = "faas.id", $c97e36c8d40a3851$var$FAAS_IDENTITY = "faas.identity", $c97e36c8d40a3851$var$FAAS_INVOCATION_ID = "faas.invocation_id", $c97e36c8d40a3851$var$FAAS_INVOKED_NAME = "faas.invoked_name", $c97e36c8d40a3851$var$FAAS_INVOKED_PROVIDER = "faas.invoked_provider", $c97e36c8d40a3851$var$FAAS_INVOKED_REGION = "faas.invoked_region", $c97e36c8d40a3851$var$FAAS_NAME = "faas.name", $c97e36c8d40a3851$var$FAAS_TIME = "faas.time", $c97e36c8d40a3851$var$FAAS_TRIGGER = "faas.trigger", $c97e36c8d40a3851$var$FAAS_VERSION = "faas.version", $c97e36c8d40a3851$var$FCP = "fcp", $c97e36c8d40a3851$var$FLAG_EVALUATION_KEY = "flag.evaluation.<key>", $c97e36c8d40a3851$var$FLAG_EVALUATION_KEY_BASE = "flag.evaluation", $c97e36c8d40a3851$var$FP = "fp", $c97e36c8d40a3851$var$FRAMES_DELAY = "frames.delay", $c97e36c8d40a3851$var$FRAMES_FROZEN = "frames.frozen", $c97e36c8d40a3851$var$FRAMES_FROZEN_RATE = "frames_frozen_rate", $c97e36c8d40a3851$var$FRAMES_SLOW = "frames.slow", $c97e36c8d40a3851$var$FRAMES_SLOW_RATE = "frames_slow_rate", $c97e36c8d40a3851$var$FRAMES_TOTAL = "frames.total", $c97e36c8d40a3851$var$FS_ERROR = "fs_error", $c97e36c8d40a3851$var$GCP_FUNCTION_CONTEXT_EVENT_ID = "gcp.function.context.event_id", $c97e36c8d40a3851$var$GCP_FUNCTION_CONTEXT_EVENT_TYPE = "gcp.function.context.event_type", $c97e36c8d40a3851$var$GCP_FUNCTION_CONTEXT_ID = "gcp.function.context.id", $c97e36c8d40a3851$var$GCP_FUNCTION_CONTEXT_RESOURCE = "gcp.function.context.resource", $c97e36c8d40a3851$var$GCP_FUNCTION_CONTEXT_SOURCE = "gcp.function.context.source", $c97e36c8d40a3851$var$GCP_FUNCTION_CONTEXT_SPECVERSION = "gcp.function.context.specversion", $c97e36c8d40a3851$var$GCP_FUNCTION_CONTEXT_TIME = "gcp.function.context.time", $c97e36c8d40a3851$var$GCP_FUNCTION_CONTEXT_TIMESTAMP = "gcp.function.context.timestamp", $c97e36c8d40a3851$var$GCP_FUNCTION_CONTEXT_TYPE = "gcp.function.context.type", $c97e36c8d40a3851$var$GCP_PROJECT_ID = "gcp.project.id", $c97e36c8d40a3851$var$GEN_AI_AGENT_NAME = "gen_ai.agent.name", $c97e36c8d40a3851$var$GEN_AI_CONTEXT_UTILIZATION = "gen_ai.context.utilization", $c97e36c8d40a3851$var$GEN_AI_CONTEXT_WINDOW_SIZE = "gen_ai.context.window_size", $c97e36c8d40a3851$var$GEN_AI_CONVERSATION_ID = "gen_ai.conversation.id", $c97e36c8d40a3851$var$GEN_AI_COST_CACHE_CREATION_INPUT_TOKENS = "gen_ai.cost.cache_creation.input_tokens", $c97e36c8d40a3851$var$GEN_AI_COST_CACHE_READ_INPUT_TOKENS = "gen_ai.cost.cache_read.input_tokens", $c97e36c8d40a3851$var$GEN_AI_COST_INPUT_TOKENS = "gen_ai.cost.input_tokens", $c97e36c8d40a3851$var$GEN_AI_COST_OUTPUT_TOKENS = "gen_ai.cost.output_tokens", $c97e36c8d40a3851$var$GEN_AI_COST_REASONING_OUTPUT_TOKENS = "gen_ai.cost.reasoning.output_tokens", $c97e36c8d40a3851$var$GEN_AI_COST_TOTAL_TOKENS = "gen_ai.cost.total_tokens", $c97e36c8d40a3851$var$GEN_AI_EMBEDDINGS_INPUT = "gen_ai.embeddings.input", $c97e36c8d40a3851$var$GEN_AI_FUNCTION_ID = "gen_ai.function_id", $c97e36c8d40a3851$var$GEN_AI_INPUT_MESSAGES = "gen_ai.input.messages", $c97e36c8d40a3851$var$GEN_AI_OPERATION_NAME = "gen_ai.operation.name", $c97e36c8d40a3851$var$GEN_AI_OPERATION_TYPE = "gen_ai.operation.type", $c97e36c8d40a3851$var$GEN_AI_OUTPUT_MESSAGES = "gen_ai.output.messages", $c97e36c8d40a3851$var$GEN_AI_PIPELINE_NAME = "gen_ai.pipeline.name", $c97e36c8d40a3851$var$GEN_AI_PROMPT = "gen_ai.prompt", $c97e36c8d40a3851$var$GEN_AI_PROMPT_NAME = "gen_ai.prompt.name", $c97e36c8d40a3851$var$GEN_AI_PROVIDER_NAME = "gen_ai.provider.name", $c97e36c8d40a3851$var$GEN_AI_REQUEST_AVAILABLE_TOOLS = "gen_ai.request.available_tools", $c97e36c8d40a3851$var$GEN_AI_REQUEST_FREQUENCY_PENALTY = "gen_ai.request.frequency_penalty", $c97e36c8d40a3851$var$GEN_AI_REQUEST_MAX_TOKENS = "gen_ai.request.max_tokens", $c97e36c8d40a3851$var$GEN_AI_REQUEST_MESSAGES = "gen_ai.request.messages", $c97e36c8d40a3851$var$GEN_AI_REQUEST_MODEL = "gen_ai.request.model", $c97e36c8d40a3851$var$GEN_AI_REQUEST_PRESENCE_PENALTY = "gen_ai.request.presence_penalty", $c97e36c8d40a3851$var$GEN_AI_REQUEST_REASONING_EFFORT = "gen_ai.request.reasoning_effort", $c97e36c8d40a3851$var$GEN_AI_REQUEST_SEED = "gen_ai.request.seed", $c97e36c8d40a3851$var$GEN_AI_REQUEST_STOP_SEQUENCES = "gen_ai.request.stop_sequences", $c97e36c8d40a3851$var$GEN_AI_REQUEST_TEMPERATURE = "gen_ai.request.temperature", $c97e36c8d40a3851$var$GEN_AI_REQUEST_TOP_K = "gen_ai.request.top_k", $c97e36c8d40a3851$var$GEN_AI_REQUEST_TOP_P = "gen_ai.request.top_p", $c97e36c8d40a3851$var$GEN_AI_RESPONSE_FINISH_REASONS = "gen_ai.response.finish_reasons", $c97e36c8d40a3851$var$GEN_AI_RESPONSE_ID = "gen_ai.response.id", $c97e36c8d40a3851$var$GEN_AI_RESPONSE_MODEL = "gen_ai.response.model", $c97e36c8d40a3851$var$GEN_AI_RESPONSE_STREAMING = "gen_ai.response.streaming", $c97e36c8d40a3851$var$GEN_AI_RESPONSE_TEXT = "gen_ai.response.text", $c97e36c8d40a3851$var$GEN_AI_RESPONSE_TIME_TO_FIRST_CHUNK = "gen_ai.response.time_to_first_chunk", $c97e36c8d40a3851$var$GEN_AI_RESPONSE_TIME_TO_FIRST_TOKEN = "gen_ai.response.time_to_first_token", $c97e36c8d40a3851$var$GEN_AI_RESPONSE_TOKENS_PER_SECOND = "gen_ai.response.tokens_per_second", $c97e36c8d40a3851$var$GEN_AI_RESPONSE_TOOL_CALLS = "gen_ai.response.tool_calls", $c97e36c8d40a3851$var$GEN_AI_SYSTEM = "gen_ai.system", $c97e36c8d40a3851$var$GEN_AI_SYSTEM_INSTRUCTIONS = "gen_ai.system_instructions", $c97e36c8d40a3851$var$GEN_AI_SYSTEM_MESSAGE = "gen_ai.system.message", $c97e36c8d40a3851$var$GEN_AI_TOOL_CALL_ARGUMENTS = "gen_ai.tool.call.arguments", $c97e36c8d40a3851$var$GEN_AI_TOOL_CALL_RESULT = "gen_ai.tool.call.result", $c97e36c8d40a3851$var$GEN_AI_TOOL_DEFINITIONS = "gen_ai.tool.definitions", $c97e36c8d40a3851$var$GEN_AI_TOOL_DESCRIPTION = "gen_ai.tool.description", $c97e36c8d40a3851$var$GEN_AI_TOOL_INPUT = "gen_ai.tool.input", $c97e36c8d40a3851$var$GEN_AI_TOOL_MESSAGE = "gen_ai.tool.message", $c97e36c8d40a3851$var$GEN_AI_TOOL_NAME = "gen_ai.tool.name", $c97e36c8d40a3851$var$GEN_AI_TOOL_OUTPUT = "gen_ai.tool.output", $c97e36c8d40a3851$var$GEN_AI_TOOL_TYPE = "gen_ai.tool.type", $c97e36c8d40a3851$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS = "gen_ai.usage.cache_creation.input_tokens", $c97e36c8d40a3851$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS = "gen_ai.usage.cache_read.input_tokens", $c97e36c8d40a3851$var$GEN_AI_USAGE_COMPLETION_TOKENS = "gen_ai.usage.completion_tokens", $c97e36c8d40a3851$var$GEN_AI_USAGE_INPUT_TOKENS = "gen_ai.usage.input_tokens", $c97e36c8d40a3851$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED = "gen_ai.usage.input_tokens.cached", $c97e36c8d40a3851$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE = "gen_ai.usage.input_tokens.cache_write", $c97e36c8d40a3851$var$GEN_AI_USAGE_OUTPUT_TOKENS = "gen_ai.usage.output_tokens", $c97e36c8d40a3851$var$GEN_AI_USAGE_OUTPUT_TOKENS_REASONING = "gen_ai.usage.output_tokens.reasoning", $c97e36c8d40a3851$var$GEN_AI_USAGE_PROMPT_TOKENS = "gen_ai.usage.prompt_tokens", $c97e36c8d40a3851$var$GEN_AI_USAGE_REASONING_OUTPUT_TOKENS = "gen_ai.usage.reasoning.output_tokens", $c97e36c8d40a3851$var$GEN_AI_USAGE_TOTAL_TOKENS = "gen_ai.usage.total_tokens", $c97e36c8d40a3851$var$GRAPHQL_DOCUMENT = "graphql.document", $c97e36c8d40a3851$var$GRAPHQL_OPERATION_NAME = "graphql.operation.name", $c97e36c8d40a3851$var$GRAPHQL_OPERATION_TYPE = "graphql.operation.type", $c97e36c8d40a3851$var$HARDWARECONCURRENCY = "hardwareConcurrency", $c97e36c8d40a3851$var$HTTP_CLIENT_IP = "http.client_ip", $c97e36c8d40a3851$var$HTTP_DECODED_RESPONSE_CONTENT_LENGTH = "http.decoded_response_content_length", $c97e36c8d40a3851$var$HTTP_FLAVOR = "http.flavor", $c97e36c8d40a3851$var$HTTP_FRAGMENT = "http.fragment", $c97e36c8d40a3851$var$HTTP_HOST = "http.host", $c97e36c8d40a3851$var$HTTP_METHOD = "http.method", $c97e36c8d40a3851$var$HTTP_QUERY = "http.query", $c97e36c8d40a3851$var$HTTP_REQUEST_BODY_DATA = "http.request.body.data", $c97e36c8d40a3851$var$HTTP_REQUEST_CONNECTION_END = "http.request.connection_end", $c97e36c8d40a3851$var$HTTP_REQUEST_CONNECT_START = "http.request.connect_start", $c97e36c8d40a3851$var$HTTP_REQUEST_DOMAIN_LOOKUP_END = "http.request.domain_lookup_end", $c97e36c8d40a3851$var$HTTP_REQUEST_DOMAIN_LOOKUP_START = "http.request.domain_lookup_start", $c97e36c8d40a3851$var$HTTP_REQUEST_FETCH_START = "http.request.fetch_start", $c97e36c8d40a3851$var$HTTP_REQUEST_HEADER_KEY = "http.request.header.<key>", $c97e36c8d40a3851$var$HTTP_REQUEST_HEADER_KEY_BASE = "http.request.header", $c97e36c8d40a3851$var$HTTP_REQUEST_METHOD = "http.request.method", $c97e36c8d40a3851$var$_HTTP_REQUEST_METHOD = "http.request_method", $c97e36c8d40a3851$var$HTTP_REQUEST_REDIRECT_END = "http.request.redirect_end", $c97e36c8d40a3851$var$HTTP_REQUEST_REDIRECT_START = "http.request.redirect_start", $c97e36c8d40a3851$var$HTTP_REQUEST_REQUEST_START = "http.request.request_start", $c97e36c8d40a3851$var$HTTP_REQUEST_RESEND_COUNT = "http.request.resend_count", $c97e36c8d40a3851$var$HTTP_REQUEST_RESPONSE_END = "http.request.response_end", $c97e36c8d40a3851$var$HTTP_REQUEST_RESPONSE_START = "http.request.response_start", $c97e36c8d40a3851$var$HTTP_REQUEST_SAME_ORIGIN = "http.request.same_origin", $c97e36c8d40a3851$var$HTTP_REQUEST_SECURE_CONNECTION_START = "http.request.secure_connection_start", $c97e36c8d40a3851$var$HTTP_REQUEST_TIME_TO_FIRST_BYTE = "http.request.time_to_first_byte", $c97e36c8d40a3851$var$HTTP_REQUEST_WORKER_START = "http.request.worker_start", $c97e36c8d40a3851$var$HTTP_RESPONSE_BODY_SIZE = "http.response.body.size", $c97e36c8d40a3851$var$HTTP_RESPONSE_CONTENT_LENGTH = "http.response_content_length", $c97e36c8d40a3851$var$HTTP_RESPONSE_HEADER_CONTENT_LENGTH = "http.response.header.content-length", $c97e36c8d40a3851$var$HTTP_RESPONSE_HEADER_KEY = "http.response.header.<key>", $c97e36c8d40a3851$var$HTTP_RESPONSE_HEADER_KEY_BASE = "http.response.header", $c97e36c8d40a3851$var$HTTP_RESPONSE_SIZE = "http.response.size", $c97e36c8d40a3851$var$HTTP_RESPONSE_STATUS_CODE = "http.response.status_code", $c97e36c8d40a3851$var$HTTP_RESPONSE_TRANSFER_SIZE = "http.response_transfer_size", $c97e36c8d40a3851$var$HTTP_ROUTE = "http.route", $c97e36c8d40a3851$var$HTTP_SCHEME = "http.scheme", $c97e36c8d40a3851$var$HTTP_SERVER_NAME = "http.server_name", $c97e36c8d40a3851$var$HTTP_SERVER_REQUEST_TIME_IN_QUEUE = "http.server.request.time_in_queue", $c97e36c8d40a3851$var$HTTP_STATUS_CODE = "http.status_code", $c97e36c8d40a3851$var$HTTP_TARGET = "http.target", $c97e36c8d40a3851$var$HTTP_URL = "http.url", $c97e36c8d40a3851$var$HTTP_USER_AGENT = "http.user_agent", $c97e36c8d40a3851$var$ID = "id", $c97e36c8d40a3851$var$INP = "inp", $c97e36c8d40a3851$var$JSONRPC_PROTOCOL_VERSION = "jsonrpc.protocol.version", $c97e36c8d40a3851$var$JSONRPC_REQUEST_ID = "jsonrpc.request.id", $c97e36c8d40a3851$var$JVM_GC_ACTION = "jvm.gc.action", $c97e36c8d40a3851$var$JVM_GC_NAME = "jvm.gc.name", $c97e36c8d40a3851$var$JVM_MEMORY_POOL_NAME = "jvm.memory.pool.name", $c97e36c8d40a3851$var$JVM_MEMORY_TYPE = "jvm.memory.type", $c97e36c8d40a3851$var$JVM_THREAD_DAEMON = "jvm.thread.daemon", $c97e36c8d40a3851$var$JVM_THREAD_STATE = "jvm.thread.state", $c97e36c8d40a3851$var$KOA_NAME = "koa.name", $c97e36c8d40a3851$var$KOA_TYPE = "koa.type", $c97e36c8d40a3851$var$LCP = "lcp", $c97e36c8d40a3851$var$LCP_ELEMENT = "lcp.element", $c97e36c8d40a3851$var$LCP_ID = "lcp.id", $c97e36c8d40a3851$var$LCP_LOADTIME = "lcp.loadTime", $c97e36c8d40a3851$var$LCP_RENDERTIME = "lcp.renderTime", $c97e36c8d40a3851$var$LCP_SIZE = "lcp.size", $c97e36c8d40a3851$var$LCP_URL = "lcp.url", $c97e36c8d40a3851$var$LOGGER_NAME = "logger.name", $c97e36c8d40a3851$var$MCP_CANCELLED_REASON = "mcp.cancelled.reason", $c97e36c8d40a3851$var$MCP_CANCELLED_REQUEST_ID = "mcp.cancelled.request_id", $c97e36c8d40a3851$var$MCP_CLIENT_NAME = "mcp.client.name", $c97e36c8d40a3851$var$MCP_CLIENT_TITLE = "mcp.client.title", $c97e36c8d40a3851$var$MCP_CLIENT_VERSION = "mcp.client.version", $c97e36c8d40a3851$var$MCP_LIFECYCLE_PHASE = "mcp.lifecycle.phase", $c97e36c8d40a3851$var$MCP_LOGGING_DATA_TYPE = "mcp.logging.data_type", $c97e36c8d40a3851$var$MCP_LOGGING_LEVEL = "mcp.logging.level", $c97e36c8d40a3851$var$MCP_LOGGING_LOGGER = "mcp.logging.logger", $c97e36c8d40a3851$var$MCP_LOGGING_MESSAGE = "mcp.logging.message", $c97e36c8d40a3851$var$MCP_METHOD_NAME = "mcp.method.name", $c97e36c8d40a3851$var$MCP_PROGRESS_CURRENT = "mcp.progress.current", $c97e36c8d40a3851$var$MCP_PROGRESS_MESSAGE = "mcp.progress.message", $c97e36c8d40a3851$var$MCP_PROGRESS_PERCENTAGE = "mcp.progress.percentage", $c97e36c8d40a3851$var$MCP_PROGRESS_TOKEN = "mcp.progress.token", $c97e36c8d40a3851$var$MCP_PROGRESS_TOTAL = "mcp.progress.total", $c97e36c8d40a3851$var$MCP_PROMPT_NAME = "mcp.prompt.name", $c97e36c8d40a3851$var$MCP_PROMPT_RESULT_DESCRIPTION = "mcp.prompt.result.description", $c97e36c8d40a3851$var$MCP_PROMPT_RESULT_MESSAGE_CONTENT = "mcp.prompt.result.message_content", $c97e36c8d40a3851$var$MCP_PROMPT_RESULT_MESSAGE_COUNT = "mcp.prompt.result.message_count", $c97e36c8d40a3851$var$MCP_PROMPT_RESULT_MESSAGE_ROLE = "mcp.prompt.result.message_role", $c97e36c8d40a3851$var$MCP_PROTOCOL_READY = "mcp.protocol.ready", $c97e36c8d40a3851$var$MCP_PROTOCOL_VERSION = "mcp.protocol.version", $c97e36c8d40a3851$var$MCP_REQUEST_ARGUMENT_KEY = "mcp.request.argument.<key>", $c97e36c8d40a3851$var$MCP_REQUEST_ARGUMENT_KEY_BASE = "mcp.request.argument", $c97e36c8d40a3851$var$MCP_REQUEST_ARGUMENT_NAME = "mcp.request.argument.name", $c97e36c8d40a3851$var$MCP_REQUEST_ARGUMENT_URI = "mcp.request.argument.uri", $c97e36c8d40a3851$var$MCP_REQUEST_ID = "mcp.request.id", $c97e36c8d40a3851$var$MCP_RESOURCE_PROTOCOL = "mcp.resource.protocol", $c97e36c8d40a3851$var$MCP_RESOURCE_URI = "mcp.resource.uri", $c97e36c8d40a3851$var$MCP_SERVER_NAME = "mcp.server.name", $c97e36c8d40a3851$var$MCP_SERVER_TITLE = "mcp.server.title", $c97e36c8d40a3851$var$MCP_SERVER_VERSION = "mcp.server.version", $c97e36c8d40a3851$var$MCP_SESSION_ID = "mcp.session.id", $c97e36c8d40a3851$var$MCP_TOOL_NAME = "mcp.tool.name", $c97e36c8d40a3851$var$MCP_TOOL_RESULT_CONTENT = "mcp.tool.result.content", $c97e36c8d40a3851$var$MCP_TOOL_RESULT_CONTENT_COUNT = "mcp.tool.result.content_count", $c97e36c8d40a3851$var$MCP_TOOL_RESULT_IS_ERROR = "mcp.tool.result.is_error", $c97e36c8d40a3851$var$MCP_TRANSPORT = "mcp.transport", $c97e36c8d40a3851$var$MDC_KEY = "mdc.<key>", $c97e36c8d40a3851$var$MDC_KEY_BASE = "mdc", $c97e36c8d40a3851$var$MESSAGING_BATCH_MESSAGE_COUNT = "messaging.batch.message_count", $c97e36c8d40a3851$var$MESSAGING_DESTINATION = "messaging.destination", $c97e36c8d40a3851$var$MESSAGING_DESTINATION_CONNECTION = "messaging.destination.connection", $c97e36c8d40a3851$var$MESSAGING_DESTINATION_NAME = "messaging.destination.name", $c97e36c8d40a3851$var$MESSAGING_MESSAGE_BODY_SIZE = "messaging.message.body.size", $c97e36c8d40a3851$var$MESSAGING_MESSAGE_CONVERSATION_ID = "messaging.message.conversation_id", $c97e36c8d40a3851$var$MESSAGING_MESSAGE_ENVELOPE_SIZE = "messaging.message.envelope.size", $c97e36c8d40a3851$var$MESSAGING_MESSAGE_ID = "messaging.message.id", $c97e36c8d40a3851$var$MESSAGING_MESSAGE_RECEIVE_LATENCY = "messaging.message.receive.latency", $c97e36c8d40a3851$var$MESSAGING_MESSAGE_RETRY_COUNT = "messaging.message.retry.count", $c97e36c8d40a3851$var$MESSAGING_OPERATION_NAME = "messaging.operation.name", $c97e36c8d40a3851$var$MESSAGING_OPERATION_TYPE = "messaging.operation.type", $c97e36c8d40a3851$var$MESSAGING_RABBITMQ_DESTINATION_ROUTING_KEY = "messaging.rabbitmq.destination.routing_key", $c97e36c8d40a3851$var$MESSAGING_SYSTEM = "messaging.system", $c97e36c8d40a3851$var$METHOD = "method", $c97e36c8d40a3851$var$MIDDLEWARE_NAME = "middleware.name", $c97e36c8d40a3851$var$NAVIGATION_ORIGIN = "navigation.origin", $c97e36c8d40a3851$var$NAVIGATION_ROUTE_ID = "navigation.route.id", $c97e36c8d40a3851$var$NAVIGATION_TYPE = "navigation.type", $c97e36c8d40a3851$var$NEL_ELAPSED_TIME = "nel.elapsed_time", $c97e36c8d40a3851$var$NEL_PHASE = "nel.phase", $c97e36c8d40a3851$var$NEL_REFERRER = "nel.referrer", $c97e36c8d40a3851$var$NEL_SAMPLING_FUNCTION = "nel.sampling_function", $c97e36c8d40a3851$var$NEL_TYPE = "nel.type", $c97e36c8d40a3851$var$NETWORK_CONNECTION_EFFECTIVE_TYPE = "network.connection.effective_type", $c97e36c8d40a3851$var$NETWORK_CONNECTION_RTT = "network.connection.rtt", $c97e36c8d40a3851$var$NETWORK_CONNECTION_TYPE = "network.connection.type", $c97e36c8d40a3851$var$NETWORK_LOCAL_ADDRESS = "network.local.address", $c97e36c8d40a3851$var$NETWORK_LOCAL_PORT = "network.local.port", $c97e36c8d40a3851$var$NETWORK_PEER_ADDRESS = "network.peer.address", $c97e36c8d40a3851$var$NETWORK_PEER_PORT = "network.peer.port", $c97e36c8d40a3851$var$NETWORK_PROTOCOL_NAME = "network.protocol.name", $c97e36c8d40a3851$var$NETWORK_PROTOCOL_VERSION = "network.protocol.version", $c97e36c8d40a3851$var$NETWORK_TRANSPORT = "network.transport", $c97e36c8d40a3851$var$NETWORK_TYPE = "network.type", $c97e36c8d40a3851$var$NET_HOST_IP = "net.host.ip", $c97e36c8d40a3851$var$NET_HOST_NAME = "net.host.name", $c97e36c8d40a3851$var$NET_HOST_PORT = "net.host.port", $c97e36c8d40a3851$var$NET_PEER_IP = "net.peer.ip", $c97e36c8d40a3851$var$NET_PEER_NAME = "net.peer.name", $c97e36c8d40a3851$var$NET_PEER_PORT = "net.peer.port", $c97e36c8d40a3851$var$NET_PROTOCOL_NAME = "net.protocol.name", $c97e36c8d40a3851$var$NET_PROTOCOL_VERSION = "net.protocol.version", $c97e36c8d40a3851$var$NET_SOCK_FAMILY = "net.sock.family", $c97e36c8d40a3851$var$NET_SOCK_HOST_ADDR = "net.sock.host.addr", $c97e36c8d40a3851$var$NET_SOCK_HOST_PORT = "net.sock.host.port", $c97e36c8d40a3851$var$NET_SOCK_PEER_ADDR = "net.sock.peer.addr", $c97e36c8d40a3851$var$NET_SOCK_PEER_NAME = "net.sock.peer.name", $c97e36c8d40a3851$var$NET_SOCK_PEER_PORT = "net.sock.peer.port", $c97e36c8d40a3851$var$NET_TRANSPORT = "net.transport", $c97e36c8d40a3851$var$OS_BUILD = "os.build", $c97e36c8d40a3851$var$OS_BUILD_ID = "os.build_id", $c97e36c8d40a3851$var$OS_DESCRIPTION = "os.description", $c97e36c8d40a3851$var$OS_KERNEL_VERSION = "os.kernel_version", $c97e36c8d40a3851$var$OS_NAME = "os.name", $c97e36c8d40a3851$var$OS_RAW_DESCRIPTION = "os.raw_description", $c97e36c8d40a3851$var$OS_ROOTED = "os.rooted", $c97e36c8d40a3851$var$OS_THEME = "os.theme", $c97e36c8d40a3851$var$OS_TYPE = "os.type", $c97e36c8d40a3851$var$OS_VERSION = "os.version", $c97e36c8d40a3851$var$OTEL_KIND = "otel.kind", $c97e36c8d40a3851$var$OTEL_SCOPE_NAME = "otel.scope.name", $c97e36c8d40a3851$var$OTEL_SCOPE_VERSION = "otel.scope.version", $c97e36c8d40a3851$var$OTEL_STATUS_CODE = "otel.status_code", $c97e36c8d40a3851$var$OTEL_STATUS_DESCRIPTION = "otel.status_description", $c97e36c8d40a3851$var$PARAMS_KEY = "params.<key>", $c97e36c8d40a3851$var$PARAMS_KEY_BASE = "params", $c97e36c8d40a3851$var$PERFORMANCE_ACTIVATIONSTART = "performance.activationStart", $c97e36c8d40a3851$var$PERFORMANCE_TIMEORIGIN = "performance.timeOrigin", $c97e36c8d40a3851$var$PREVIOUS_ROUTE = "previous_route", $c97e36c8d40a3851$var$PROCESS_COMMAND_ARGS = "process.command_args", $c97e36c8d40a3851$var$PROCESS_EXECUTABLE_NAME = "process.executable.name", $c97e36c8d40a3851$var$PROCESS_PID = "process.pid", $c97e36c8d40a3851$var$PROCESS_RUNTIME_DESCRIPTION = "process.runtime.description", $c97e36c8d40a3851$var$PROCESS_RUNTIME_ENGINE_NAME = "process.runtime.engine.name", $c97e36c8d40a3851$var$PROCESS_RUNTIME_ENGINE_VERSION = "process.runtime.engine.version", $c97e36c8d40a3851$var$PROCESS_RUNTIME_NAME = "process.runtime.name", $c97e36c8d40a3851$var$PROCESS_RUNTIME_VERSION = "process.runtime.version", $c97e36c8d40a3851$var$QUERY_KEY = "query.<key>", $c97e36c8d40a3851$var$QUERY_KEY_BASE = "query", $c97e36c8d40a3851$var$REACT_VERSION = "react.version", $c97e36c8d40a3851$var$RELEASE = "release", $c97e36c8d40a3851$var$REMIX_ACTION_FORM_DATA_KEY = "remix.action_form_data.<key>", $c97e36c8d40a3851$var$REMIX_ACTION_FORM_DATA_KEY_BASE = "remix.action_form_data", $c97e36c8d40a3851$var$REPLAY_ID = "replay_id", $c97e36c8d40a3851$var$RESOURCE_DEPLOYMENT_ENVIRONMENT = "resource.deployment.environment", $c97e36c8d40a3851$var$RESOURCE_DEPLOYMENT_ENVIRONMENT_NAME = "resource.deployment.environment.name", $c97e36c8d40a3851$var$RESOURCE_RENDER_BLOCKING_STATUS = "resource.render_blocking_status", $c97e36c8d40a3851$var$ROUTE = "route", $c97e36c8d40a3851$var$RPC_GRPC_STATUS_CODE = "rpc.grpc.status_code", $c97e36c8d40a3851$var$RPC_METHOD = "rpc.method", $c97e36c8d40a3851$var$RPC_RESPONSE_STATUS_CODE = "rpc.response.status_code", $c97e36c8d40a3851$var$RPC_SERVICE = "rpc.service", $c97e36c8d40a3851$var$RPC_SYSTEM = "rpc.system", $c97e36c8d40a3851$var$RPC_SYSTEM_NAME = "rpc.system.name", $c97e36c8d40a3851$var$RUNTIME_BUILD = "runtime.build", $c97e36c8d40a3851$var$RUNTIME_NAME = "runtime.name", $c97e36c8d40a3851$var$RUNTIME_RAW_DESCRIPTION = "runtime.raw_description", $c97e36c8d40a3851$var$RUNTIME_VERSION = "runtime.version", $c97e36c8d40a3851$var$SCORE_KEY = "score.<key>", $c97e36c8d40a3851$var$SCORE_KEY_BASE = "score", $c97e36c8d40a3851$var$SCORE_RATIO_KEY = "score.ratio.<key>", $c97e36c8d40a3851$var$SCORE_RATIO_KEY_BASE = "score.ratio", $c97e36c8d40a3851$var$SCORE_TOTAL = "score.total", $c97e36c8d40a3851$var$SCORE_WEIGHT_KEY = "score.weight.<key>", $c97e36c8d40a3851$var$SCORE_WEIGHT_KEY_BASE = "score.weight", $c97e36c8d40a3851$var$SENTRY_ACTION = "sentry.action", $c97e36c8d40a3851$var$SENTRY_BROWSER_NAME = "sentry.browser.name", $c97e36c8d40a3851$var$SENTRY_BROWSER_VERSION = "sentry.browser.version", $c97e36c8d40a3851$var$SENTRY_CANCELLATION_REASON = "sentry.cancellation_reason", $c97e36c8d40a3851$var$SENTRY_CATEGORY = "sentry.category", $c97e36c8d40a3851$var$SENTRY_CLIENT_SAMPLE_RATE = "sentry.client_sample_rate", $c97e36c8d40a3851$var$SENTRY_DESCRIPTION = "sentry.description", $c97e36c8d40a3851$var$SENTRY_DIST = "sentry.dist", $c97e36c8d40a3851$var$SENTRY_DOMAIN = "sentry.domain", $c97e36c8d40a3851$var$SENTRY_DSC_ENVIRONMENT = "sentry.dsc.environment", $c97e36c8d40a3851$var$SENTRY_DSC_PROJECT_ID = "sentry.dsc.project_id", $c97e36c8d40a3851$var$SENTRY_DSC_PUBLIC_KEY = "sentry.dsc.public_key", $c97e36c8d40a3851$var$SENTRY_DSC_RELEASE = "sentry.dsc.release", $c97e36c8d40a3851$var$SENTRY_DSC_SAMPLED = "sentry.dsc.sampled", $c97e36c8d40a3851$var$SENTRY_DSC_SAMPLE_RATE = "sentry.dsc.sample_rate", $c97e36c8d40a3851$var$SENTRY_DSC_TRACE_ID = "sentry.dsc.trace_id", $c97e36c8d40a3851$var$SENTRY_DSC_TRANSACTION = "sentry.dsc.transaction", $c97e36c8d40a3851$var$SENTRY_ENVIRONMENT = "sentry.environment", $c97e36c8d40a3851$var$SENTRY_EXCLUSIVE_TIME = "sentry.exclusive_time", $c97e36c8d40a3851$var$SENTRY_GRAPHQL_OPERATION = "sentry.graphql.operation", $c97e36c8d40a3851$var$SENTRY_GROUP = "sentry.group", $c97e36c8d40a3851$var$SENTRY_HTTP_PREFETCH = "sentry.http.prefetch", $c97e36c8d40a3851$var$SENTRY_IDLE_SPAN_FINISH_REASON = "sentry.idle_span_finish_reason", $c97e36c8d40a3851$var$SENTRY_IS_REMOTE = "sentry.is_remote", $c97e36c8d40a3851$var$SENTRY_KIND = "sentry.kind", $c97e36c8d40a3851$var$SENTRY_MAIN_THREAD = "sentry.main_thread", $c97e36c8d40a3851$var$SENTRY_MESSAGE_PARAMETER_KEY = "sentry.message.parameter.<key>", $c97e36c8d40a3851$var$SENTRY_MESSAGE_TEMPLATE = "sentry.message.template", $c97e36c8d40a3851$var$SENTRY_METRIC_SOURCE = "sentry.metric.source", $c97e36c8d40a3851$var$SENTRY_MOBILE = "sentry.mobile", $c97e36c8d40a3851$var$SENTRY_MODULE_KEY = "sentry.module.<key>", $c97e36c8d40a3851$var$SENTRY_MODULE_KEY_BASE = "sentry.module", $c97e36c8d40a3851$var$SENTRY_NEXTJS_SSR_FUNCTION_ROUTE = "sentry.nextjs.ssr.function.route", $c97e36c8d40a3851$var$SENTRY_NEXTJS_SSR_FUNCTION_TYPE = "sentry.nextjs.ssr.function.type", $c97e36c8d40a3851$var$SENTRY_NORMALIZED_DB_QUERY = "sentry.normalized_db_query", $c97e36c8d40a3851$var$SENTRY_NORMALIZED_DB_QUERY_HASH = "sentry.normalized_db_query.hash", $c97e36c8d40a3851$var$SENTRY_NORMALIZED_DESCRIPTION = "sentry.normalized_description", $c97e36c8d40a3851$var$SENTRY_OBSERVED_TIMESTAMP_NANOS = "sentry.observed_timestamp_nanos", $c97e36c8d40a3851$var$SENTRY_OP = "sentry.op", $c97e36c8d40a3851$var$SENTRY_ORIGIN = "sentry.origin", $c97e36c8d40a3851$var$SENTRY_PLATFORM = "sentry.platform", $c97e36c8d40a3851$var$SENTRY_PROFILER_ID = "sentry.profiler_id", $c97e36c8d40a3851$var$SENTRY_PROFILE_ID = "sentry.profile_id", $c97e36c8d40a3851$var$SENTRY_RELEASE = "sentry.release", $c97e36c8d40a3851$var$SENTRY_REPLAY_ID = "sentry.replay_id", $c97e36c8d40a3851$var$SENTRY_REPLAY_IS_BUFFERING = "sentry.replay_is_buffering", $c97e36c8d40a3851$var$SENTRY_REPORT_EVENT = "sentry.report_event", $c97e36c8d40a3851$var$SENTRY_SDK_INTEGRATIONS = "sentry.sdk.integrations", $c97e36c8d40a3851$var$SENTRY_SDK_NAME = "sentry.sdk.name", $c97e36c8d40a3851$var$SENTRY_SDK_VERSION = "sentry.sdk.version", $c97e36c8d40a3851$var$SENTRY_SEGMENT_ID = "sentry.segment.id", $c97e36c8d40a3851$var$_SENTRY_SEGMENT_ID = "sentry.segment_id", $c97e36c8d40a3851$var$SENTRY_SEGMENT_NAME = "sentry.segment.name", $c97e36c8d40a3851$var$SENTRY_SERVER_SAMPLE_RATE = "sentry.server_sample_rate", $c97e36c8d40a3851$var$SENTRY_SOURCE = "sentry.source", $c97e36c8d40a3851$var$SENTRY_SPAN_SOURCE = "sentry.span.source", $c97e36c8d40a3851$var$SENTRY_STATUS = "sentry.status", $c97e36c8d40a3851$var$SENTRY_STATUS_CODE = "sentry.status_code", $c97e36c8d40a3851$var$SENTRY_STATUS_MESSAGE = "sentry.status.message", $c97e36c8d40a3851$var$SENTRY_SVELTEKIT_NAVIGATION_FROM = "sentry.sveltekit.navigation.from", $c97e36c8d40a3851$var$SENTRY_SVELTEKIT_NAVIGATION_TO = "sentry.sveltekit.navigation.to", $c97e36c8d40a3851$var$SENTRY_SVELTEKIT_NAVIGATION_TYPE = "sentry.sveltekit.navigation.type", $c97e36c8d40a3851$var$SENTRY_THREAD_ID = "sentry.thread.id", $c97e36c8d40a3851$var$SENTRY_TIMESTAMP_SEQUENCE = "sentry.timestamp.sequence", $c97e36c8d40a3851$var$SENTRY_TRACE_LIFECYCLE = "sentry.trace_lifecycle", $c97e36c8d40a3851$var$SENTRY_TRACE_PARENT_SPAN_ID = "sentry.trace.parent_span_id", $c97e36c8d40a3851$var$SENTRY_TRACE_STATUS = "sentry.trace.status", $c97e36c8d40a3851$var$SENTRY_TRANSACTION = "sentry.transaction", $c97e36c8d40a3851$var$SENTRY_USER_EMAIL = "sentry.user.email", $c97e36c8d40a3851$var$SENTRY_USER_GEO_CITY = "sentry.user.geo.city", $c97e36c8d40a3851$var$SENTRY_USER_GEO_COUNTRY_CODE = "sentry.user.geo.country_code", $c97e36c8d40a3851$var$SENTRY_USER_GEO_REGION = "sentry.user.geo.region", $c97e36c8d40a3851$var$SENTRY_USER_GEO_SUBDIVISION = "sentry.user.geo.subdivision", $c97e36c8d40a3851$var$SENTRY_USER_ID = "sentry.user.id", $c97e36c8d40a3851$var$SENTRY_USER_IP = "sentry.user.ip", $c97e36c8d40a3851$var$SENTRY_USER_USERNAME = "sentry.user.username", $c97e36c8d40a3851$var$SERVER_ADDRESS = "server.address", $c97e36c8d40a3851$var$SERVER_NAME = "server_name", $c97e36c8d40a3851$var$SERVER_PORT = "server.port", $c97e36c8d40a3851$var$SERVICE_NAME = "service.name", $c97e36c8d40a3851$var$SERVICE_VERSION = "service.version", $c97e36c8d40a3851$var$SESSION_ID = "session.id", $c97e36c8d40a3851$var$STALL_PERCENTAGE = "stall_percentage", $c97e36c8d40a3851$var$STALL_TOTAL_TIME = "stall_total_time", $c97e36c8d40a3851$var$STATE_TYPE = "state.type", $c97e36c8d40a3851$var$THREAD_ID = "thread.id", $c97e36c8d40a3851$var$THREAD_NAME = "thread.name", $c97e36c8d40a3851$var$TIMBER_TAG = "timber.tag", $c97e36c8d40a3851$var$TIME_TO_FULL_DISPLAY = "time_to_full_display", $c97e36c8d40a3851$var$TIME_TO_INITIAL_DISPLAY = "time_to_initial_display", $c97e36c8d40a3851$var$TRANSACTION = "transaction", $c97e36c8d40a3851$var$TRPC_PROCEDURE_PATH = "trpc.procedure_path", $c97e36c8d40a3851$var$TRPC_PROCEDURE_TYPE = "trpc.procedure_type", $c97e36c8d40a3851$var$TTFB = "ttfb", $c97e36c8d40a3851$var$TTFB_REQUESTTIME = "ttfb.requestTime", $c97e36c8d40a3851$var$TYPE = "type", $c97e36c8d40a3851$var$UI_COMPONENT_NAME = "ui.component_name", $c97e36c8d40a3851$var$UI_CONTRIBUTES_TO_TTFD = "ui.contributes_to_ttfd", $c97e36c8d40a3851$var$UI_CONTRIBUTES_TO_TTID = "ui.contributes_to_ttid", $c97e36c8d40a3851$var$UI_ELEMENT_HEIGHT = "ui.element.height", $c97e36c8d40a3851$var$UI_ELEMENT_ID = "ui.element.id", $c97e36c8d40a3851$var$UI_ELEMENT_IDENTIFIER = "ui.element.identifier", $c97e36c8d40a3851$var$UI_ELEMENT_LOAD_TIME = "ui.element.load_time", $c97e36c8d40a3851$var$UI_ELEMENT_PAINT_TYPE = "ui.element.paint_type", $c97e36c8d40a3851$var$UI_ELEMENT_RENDER_TIME = "ui.element.render_time", $c97e36c8d40a3851$var$UI_ELEMENT_TYPE = "ui.element.type", $c97e36c8d40a3851$var$UI_ELEMENT_URL = "ui.element.url", $c97e36c8d40a3851$var$UI_ELEMENT_WIDTH = "ui.element.width", $c97e36c8d40a3851$var$URL = "url", $c97e36c8d40a3851$var$URL_DOMAIN = "url.domain", $c97e36c8d40a3851$var$URL_FRAGMENT = "url.fragment", $c97e36c8d40a3851$var$URL_FULL = "url.full", $c97e36c8d40a3851$var$URL_PATH = "url.path", $c97e36c8d40a3851$var$URL_PATH_PARAMETER_KEY = "url.path.parameter.<key>", $c97e36c8d40a3851$var$URL_PATH_PARAMETER_KEY_BASE = "url.path.parameter", $c97e36c8d40a3851$var$URL_PORT = "url.port", $c97e36c8d40a3851$var$URL_QUERY = "url.query", $c97e36c8d40a3851$var$URL_SAME_ORIGIN = "url.same_origin", $c97e36c8d40a3851$var$URL_SCHEME = "url.scheme", $c97e36c8d40a3851$var$URL_TEMPLATE = "url.template", $c97e36c8d40a3851$var$USER_AGENT_ORIGINAL = "user_agent.original", $c97e36c8d40a3851$var$USER_EMAIL = "user.email", $c97e36c8d40a3851$var$USER_FULL_NAME = "user.full_name", $c97e36c8d40a3851$var$USER_GEO_CITY = "user.geo.city", $c97e36c8d40a3851$var$USER_GEO_COUNTRY_CODE = "user.geo.country_code", $c97e36c8d40a3851$var$USER_GEO_REGION = "user.geo.region", $c97e36c8d40a3851$var$USER_GEO_SUBDIVISION = "user.geo.subdivision", $c97e36c8d40a3851$var$USER_HASH = "user.hash", $c97e36c8d40a3851$var$USER_ID = "user.id", $c97e36c8d40a3851$var$USER_IP_ADDRESS = "user.ip_address", $c97e36c8d40a3851$var$USER_NAME = "user.name", $c97e36c8d40a3851$var$USER_ROLES = "user.roles", $c97e36c8d40a3851$var$VERCEL_BRANCH = "vercel.branch", $c97e36c8d40a3851$var$VERCEL_BUILD_ID = "vercel.build_id", $c97e36c8d40a3851$var$VERCEL_DEPLOYMENT_ID = "vercel.deployment_id", $c97e36c8d40a3851$var$VERCEL_DESTINATION = "vercel.destination", $c97e36c8d40a3851$var$VERCEL_EDGE_TYPE = "vercel.edge_type", $c97e36c8d40a3851$var$VERCEL_ENTRYPOINT = "vercel.entrypoint", $c97e36c8d40a3851$var$VERCEL_EXECUTION_REGION = "vercel.execution_region", $c97e36c8d40a3851$var$VERCEL_ID = "vercel.id", $c97e36c8d40a3851$var$VERCEL_JA3_DIGEST = "vercel.ja3_digest", $c97e36c8d40a3851$var$VERCEL_JA4_DIGEST = "vercel.ja4_digest", $c97e36c8d40a3851$var$VERCEL_LOG_TYPE = "vercel.log_type", $c97e36c8d40a3851$var$VERCEL_PATH = "vercel.path", $c97e36c8d40a3851$var$VERCEL_PROJECT_ID = "vercel.project_id", $c97e36c8d40a3851$var$VERCEL_PROJECT_NAME = "vercel.project_name", $c97e36c8d40a3851$var$VERCEL_PROXY_CACHE_ID = "vercel.proxy.cache_id", $c97e36c8d40a3851$var$VERCEL_PROXY_CLIENT_IP = "vercel.proxy.client_ip", $c97e36c8d40a3851$var$VERCEL_PROXY_HOST = "vercel.proxy.host", $c97e36c8d40a3851$var$VERCEL_PROXY_LAMBDA_REGION = "vercel.proxy.lambda_region", $c97e36c8d40a3851$var$VERCEL_PROXY_METHOD = "vercel.proxy.method", $c97e36c8d40a3851$var$VERCEL_PROXY_PATH = "vercel.proxy.path", $c97e36c8d40a3851$var$VERCEL_PROXY_PATH_TYPE = "vercel.proxy.path_type", $c97e36c8d40a3851$var$VERCEL_PROXY_PATH_TYPE_VARIANT = "vercel.proxy.path_type_variant", $c97e36c8d40a3851$var$VERCEL_PROXY_REFERER = "vercel.proxy.referer", $c97e36c8d40a3851$var$VERCEL_PROXY_REGION = "vercel.proxy.region", $c97e36c8d40a3851$var$VERCEL_PROXY_RESPONSE_BYTE_SIZE = "vercel.proxy.response_byte_size", $c97e36c8d40a3851$var$VERCEL_PROXY_SCHEME = "vercel.proxy.scheme", $c97e36c8d40a3851$var$VERCEL_PROXY_STATUS_CODE = "vercel.proxy.status_code", $c97e36c8d40a3851$var$VERCEL_PROXY_TIMESTAMP = "vercel.proxy.timestamp", $c97e36c8d40a3851$var$VERCEL_PROXY_USER_AGENT = "vercel.proxy.user_agent", $c97e36c8d40a3851$var$VERCEL_PROXY_VERCEL_CACHE = "vercel.proxy.vercel_cache", $c97e36c8d40a3851$var$VERCEL_PROXY_VERCEL_ID = "vercel.proxy.vercel_id", $c97e36c8d40a3851$var$VERCEL_PROXY_WAF_ACTION = "vercel.proxy.waf_action", $c97e36c8d40a3851$var$VERCEL_PROXY_WAF_RULE_ID = "vercel.proxy.waf_rule_id", $c97e36c8d40a3851$var$VERCEL_REQUEST_ID = "vercel.request_id", $c97e36c8d40a3851$var$VERCEL_SOURCE = "vercel.source", $c97e36c8d40a3851$var$VERCEL_STATUS_CODE = "vercel.status_code", $c97e36c8d40a3851$var$ATTRIBUTE_TYPE = {
    "ai.citations": "string[]",
    "ai.completion_tokens.used": "integer",
    "ai.documents": "string[]",
    "ai.finish_reason": "string",
    "ai.frequency_penalty": "double",
    "ai.function_call": "string",
    "ai.generation_id": "string",
    "ai.input_messages": "string",
    "ai.is_search_required": "boolean",
    "ai.metadata": "string",
    "ai.model_id": "string",
    "ai.model.provider": "string",
    "ai.pipeline.name": "string",
    "ai.preamble": "string",
    "ai.presence_penalty": "double",
    "ai.prompt_tokens.used": "integer",
    "ai.raw_prompting": "boolean",
    "ai.responses": "string[]",
    "ai.response_format": "string",
    "ai.search_queries": "string[]",
    "ai.search_results": "string[]",
    "ai.seed": "string",
    "ai.streaming": "boolean",
    "ai.tags": "string",
    "ai.temperature": "double",
    "ai.texts": "string[]",
    "ai.tools": "string[]",
    "ai.tool_calls": "string[]",
    "ai.top_k": "integer",
    "ai.top_p": "double",
    "ai.total_cost": "double",
    "ai.total_tokens.used": "integer",
    "ai.warnings": "string[]",
    "angular.version": "string",
    "app.app_build": "string",
    "app.app_identifier": "string",
    "app.app_name": "string",
    "app.app_start_time": "string",
    "app.app_version": "string",
    "app.build": "string",
    "app.identifier": "string",
    "app.in_foreground": "boolean",
    "app.name": "string",
    app_start_cold: "double",
    "app.start_time": "string",
    app_start_type: "string",
    app_start_warm: "double",
    "app.version": "string",
    "app.vitals.frames.delay.value": "integer",
    "app.vitals.frames.frozen.count": "integer",
    "app.vitals.frames.slow.count": "integer",
    "app.vitals.frames.total.count": "integer",
    "app.vitals.start.cold.value": "double",
    "app.vitals.start.prewarmed": "boolean",
    "app.vitals.start.reason": "string",
    "app.vitals.start.screen": "string",
    "app.vitals.start.type": "string",
    "app.vitals.start.warm.value": "double",
    "app.vitals.ttfd.value": "double",
    "app.vitals.ttid.value": "double",
    "art.gc.blocking_count": "integer",
    "art.gc.blocking_time": "double",
    "art.gc.pre_oome_count": "integer",
    "art.gc.total_count": "integer",
    "art.gc.total_time": "double",
    "art.gc.waiting_time": "double",
    "art.memory.free": "integer",
    "art.memory.free_until_gc": "integer",
    "art.memory.free_until_oome": "integer",
    "art.memory.max": "integer",
    "art.memory.total": "integer",
    "aws.cloudwatch.logs.log_group": "string",
    "aws.cloudwatch.logs.log_stream": "string",
    "aws.cloudwatch.logs.url": "string",
    "aws.dynamodb.attribute_definitions": "string[]",
    "aws.dynamodb.consistent_read": "boolean",
    "aws.dynamodb.consumed_capacity": "string[]",
    "aws.dynamodb.count": "integer",
    "aws.dynamodb.exclusive_start_table": "string",
    "aws.dynamodb.global_secondary_indexes": "string[]",
    "aws.dynamodb.global_secondary_index_updates": "string[]",
    "aws.dynamodb.index_name": "string",
    "aws.dynamodb.item_collection_metrics": "string",
    "aws.dynamodb.limit": "integer",
    "aws.dynamodb.local_secondary_indexes": "string[]",
    "aws.dynamodb.projection": "string",
    "aws.dynamodb.provisioned_read_capacity": "double",
    "aws.dynamodb.provisioned_write_capacity": "double",
    "aws.dynamodb.scanned_count": "integer",
    "aws.dynamodb.scan_forward": "boolean",
    "aws.dynamodb.segment": "integer",
    "aws.dynamodb.select": "string",
    "aws.dynamodb.table_count": "integer",
    "aws.dynamodb.table_names": "string[]",
    "aws.dynamodb.total_segments": "integer",
    "aws.extended_request_id": "string",
    "aws.kinesis.stream_name": "string",
    "aws.kinesis.stream.name": "string",
    "aws.lambda.aws_request_id": "string",
    "aws.lambda.execution_duration_in_millis": "double",
    "aws.lambda.function_name": "string",
    "aws.lambda.function_version": "string",
    "aws.lambda.invoked_arn": "string",
    "aws.lambda.invoked_function_arn": "string",
    "aws.lambda.remaining_time_in_millis": "double",
    "aws.log.group.names": "string[]",
    "aws.log.stream.names": "string[]",
    "aws.request.extended_id": "string",
    "aws.request_id": "string",
    "aws.request.id": "string",
    "aws.s3.bucket": "string",
    "aws.secretsmanager.secret.arn": "string",
    "aws.sns.topic.arn": "string",
    "aws.step_functions.activity.arn": "string",
    "aws.step_functions.state_machine.arn": "string",
    blocked_main_thread: "boolean",
    "browser.name": "string",
    "browser.performance.navigation.activation_start": "double",
    "browser.performance.time_origin": "double",
    "browser.report.type": "string",
    "browser.script.invoker": "string",
    "browser.script.invoker_type": "string",
    "browser.script.source_char_position": "integer",
    "browser.version": "string",
    "browser.web_vital.cls.report_event": "string",
    "browser.web_vital.cls.source.<key>": "string",
    "browser.web_vital.cls.value": "double",
    "browser.web_vital.fcp.value": "double",
    "browser.web_vital.fp.value": "double",
    "browser.web_vital.inp.value": "double",
    "browser.web_vital.lcp.element": "string",
    "browser.web_vital.lcp.id": "string",
    "browser.web_vital.lcp.load_time": "integer",
    "browser.web_vital.lcp.render_time": "integer",
    "browser.web_vital.lcp.report_event": "string",
    "browser.web_vital.lcp.size": "integer",
    "browser.web_vital.lcp.url": "string",
    "browser.web_vital.lcp.value": "double",
    "browser.web_vital.ttfb.request_time": "double",
    "browser.web_vital.ttfb.value": "double",
    "cache.hit": "boolean",
    "cache.item_size": "integer",
    "cache.key": "string[]",
    "cache.operation": "string",
    "cache.ttl": "integer",
    "cache.write": "boolean",
    channel: "string",
    "client.address": "string",
    "client.port": "integer",
    "cloudflare.d1.duration": "integer",
    "cloudflare.d1.query_type": "string",
    "cloudflare.d1.rows_read": "integer",
    "cloudflare.d1.rows_written": "integer",
    "cloudflare.durable_object.query.bindings": "integer",
    "cloudflare.durable_object.response.rows_read": "integer",
    "cloudflare.durable_object.response.rows_written": "integer",
    "cloudflare.r2.bucket": "string",
    "cloudflare.r2.operation": "string",
    "cloudflare.r2.request.delimiter": "string",
    "cloudflare.r2.request.key": "string",
    "cloudflare.r2.request.part_number": "integer",
    "cloudflare.r2.request.prefix": "string",
    "cloudflare.workflow.attempt": "integer",
    "cloudflare.workflow.retries.backoff": "string",
    "cloudflare.workflow.retries.delay": "string",
    "cloudflare.workflow.retries.limit": "integer",
    "cloudflare.workflow.timeout": "string",
    "cloud.account.id": "string",
    "cloud.availability_zone": "string",
    "cloud.platform": "string",
    "cloud.provider": "string",
    "cloud.region": "string",
    "cloud.resource_id": "string",
    cls: "double",
    "cls.source.<key>": "string",
    "code.filepath": "string",
    "code.file.path": "string",
    "code.function": "string",
    "code.function.name": "string",
    "code.lineno": "integer",
    "code.line.number": "integer",
    "code.namespace": "string",
    connectionType: "string",
    "connection.rtt": "integer",
    "culture.calendar": "string",
    "culture.display_name": "string",
    "culture.is_24_hour_format": "boolean",
    "culture.locale": "string",
    "culture.timezone": "string",
    "db.collection.name": "string",
    "db.driver.name": "string",
    "db.name": "string",
    "db.namespace": "string",
    "db.operation": "string",
    "db.operation.batch.size": "integer",
    "db.operation.name": "string",
    "db.query.parameter.<key>": "string",
    "db.query.summary": "string",
    "db.query.text": "string",
    "db.redis.connection": "string",
    "db.redis.key": "string",
    "db.redis.parameters": "string[]",
    "db.response.status_code": "string",
    "db.sql.bindings": "string[]",
    "db.statement": "string",
    "db.stored_procedure.name": "string",
    "db.system": "string",
    "db.system.name": "string",
    "db.user": "string",
    deviceMemory: "string",
    "device.archs": "string[]",
    "device.battery_level": "double",
    "device.battery_temperature": "double",
    "device.boot_time": "string",
    "device.brand": "string",
    "device.charging": "boolean",
    "device.chipset": "string",
    "device.class": "string",
    "device.connection_type": "string",
    "device.cpu_description": "string",
    "device.external_free_storage": "integer",
    "device.external_storage_size": "integer",
    "device.family": "string",
    "device.free_memory": "integer",
    "device.free_storage": "integer",
    "device.id": "string",
    "device.locale": "string",
    "device.low_memory": "boolean",
    "device.low_power_mode": "boolean",
    "device.manufacturer": "string",
    "device.memory.estimated_capacity": "integer",
    "device.memory_size": "integer",
    "device.model": "string",
    "device.model_id": "string",
    "device.name": "string",
    "device.online": "boolean",
    "device.orientation": "string",
    "device.processor_count": "integer",
    "device.processor_frequency": "double",
    "device.screen_density": "double",
    "device.screen_dpi": "integer",
    "device.screen_height_pixels": "integer",
    "device.screen_width_pixels": "integer",
    "device.simulator": "boolean",
    "device.storage_size": "integer",
    "device.thermal_state": "string",
    "device.timezone": "string",
    "device.usable_memory": "integer",
    dist: "string",
    effectiveConnectionType: "string",
    environment: "string",
    "error.type": "string",
    "event.id": "integer",
    "event.name": "string",
    "exception.escaped": "boolean",
    "exception.message": "string",
    "exception.stacktrace": "string",
    "exception.type": "string",
    "faas.coldstart": "boolean",
    "faas.cron": "string",
    "faas.duration_in_ms": "integer",
    "faas.entry_point": "string",
    "faas.execution": "string",
    "faas.id": "string",
    "faas.identity": "string",
    "faas.invocation_id": "string",
    "faas.invoked_name": "string",
    "faas.invoked_provider": "string",
    "faas.invoked_region": "string",
    "faas.name": "string",
    "faas.time": "string",
    "faas.trigger": "string",
    "faas.version": "string",
    fcp: "double",
    "flag.evaluation.<key>": "boolean",
    fp: "double",
    "frames.delay": "integer",
    "frames.frozen": "integer",
    frames_frozen_rate: "double",
    "frames.slow": "integer",
    frames_slow_rate: "double",
    "frames.total": "integer",
    fs_error: "string",
    "gcp.function.context.event_id": "string",
    "gcp.function.context.event_type": "string",
    "gcp.function.context.id": "string",
    "gcp.function.context.resource": "string",
    "gcp.function.context.source": "string",
    "gcp.function.context.specversion": "string",
    "gcp.function.context.time": "string",
    "gcp.function.context.timestamp": "string",
    "gcp.function.context.type": "string",
    "gcp.project.id": "string",
    "gen_ai.agent.name": "string",
    "gen_ai.context.utilization": "double",
    "gen_ai.context.window_size": "integer",
    "gen_ai.conversation.id": "string",
    "gen_ai.cost.cache_creation.input_tokens": "double",
    "gen_ai.cost.cache_read.input_tokens": "double",
    "gen_ai.cost.input_tokens": "double",
    "gen_ai.cost.output_tokens": "double",
    "gen_ai.cost.reasoning.output_tokens": "double",
    "gen_ai.cost.total_tokens": "double",
    "gen_ai.embeddings.input": "string",
    "gen_ai.function_id": "string",
    "gen_ai.input.messages": "string",
    "gen_ai.operation.name": "string",
    "gen_ai.operation.type": "string",
    "gen_ai.output.messages": "string",
    "gen_ai.pipeline.name": "string",
    "gen_ai.prompt": "string",
    "gen_ai.prompt.name": "string",
    "gen_ai.provider.name": "string",
    "gen_ai.request.available_tools": "string",
    "gen_ai.request.frequency_penalty": "double",
    "gen_ai.request.max_tokens": "integer",
    "gen_ai.request.messages": "string",
    "gen_ai.request.model": "string",
    "gen_ai.request.presence_penalty": "double",
    "gen_ai.request.reasoning_effort": "string",
    "gen_ai.request.seed": "string",
    "gen_ai.request.stop_sequences": "string[]",
    "gen_ai.request.temperature": "double",
    "gen_ai.request.top_k": "integer",
    "gen_ai.request.top_p": "double",
    "gen_ai.response.finish_reasons": "string",
    "gen_ai.response.id": "string",
    "gen_ai.response.model": "string",
    "gen_ai.response.streaming": "boolean",
    "gen_ai.response.text": "string",
    "gen_ai.response.time_to_first_chunk": "double",
    "gen_ai.response.time_to_first_token": "double",
    "gen_ai.response.tokens_per_second": "double",
    "gen_ai.response.tool_calls": "string",
    "gen_ai.system": "string",
    "gen_ai.system_instructions": "string",
    "gen_ai.system.message": "string",
    "gen_ai.tool.call.arguments": "string",
    "gen_ai.tool.call.result": "string",
    "gen_ai.tool.definitions": "string",
    "gen_ai.tool.description": "string",
    "gen_ai.tool.input": "string",
    "gen_ai.tool.message": "string",
    "gen_ai.tool.name": "string",
    "gen_ai.tool.output": "string",
    "gen_ai.tool.type": "string",
    "gen_ai.usage.cache_creation.input_tokens": "integer",
    "gen_ai.usage.cache_read.input_tokens": "integer",
    "gen_ai.usage.completion_tokens": "integer",
    "gen_ai.usage.input_tokens": "integer",
    "gen_ai.usage.input_tokens.cached": "integer",
    "gen_ai.usage.input_tokens.cache_write": "integer",
    "gen_ai.usage.output_tokens": "integer",
    "gen_ai.usage.output_tokens.reasoning": "integer",
    "gen_ai.usage.prompt_tokens": "integer",
    "gen_ai.usage.reasoning.output_tokens": "integer",
    "gen_ai.usage.total_tokens": "integer",
    "graphql.document": "string",
    "graphql.operation.name": "string",
    "graphql.operation.type": "string",
    hardwareConcurrency: "string",
    "http.client_ip": "string",
    "http.decoded_response_content_length": "integer",
    "http.flavor": "string",
    "http.fragment": "string",
    "http.host": "string",
    "http.method": "string",
    "http.query": "string",
    "http.request.body.data": "string",
    "http.request.connection_end": "double",
    "http.request.connect_start": "double",
    "http.request.domain_lookup_end": "double",
    "http.request.domain_lookup_start": "double",
    "http.request.fetch_start": "double",
    "http.request.header.<key>": "string[]",
    "http.request.method": "string",
    "http.request_method": "string",
    "http.request.redirect_end": "double",
    "http.request.redirect_start": "double",
    "http.request.request_start": "double",
    "http.request.resend_count": "integer",
    "http.request.response_end": "double",
    "http.request.response_start": "double",
    "http.request.same_origin": "boolean",
    "http.request.secure_connection_start": "double",
    "http.request.time_to_first_byte": "double",
    "http.request.worker_start": "double",
    "http.response.body.size": "integer",
    "http.response_content_length": "integer",
    "http.response.header.content-length": "string",
    "http.response.header.<key>": "string[]",
    "http.response.size": "integer",
    "http.response.status_code": "integer",
    "http.response_transfer_size": "integer",
    "http.route": "string",
    "http.scheme": "string",
    "http.server_name": "string",
    "http.server.request.time_in_queue": "double",
    "http.status_code": "integer",
    "http.target": "string",
    "http.url": "string",
    "http.user_agent": "string",
    id: "string",
    inp: "double",
    "jsonrpc.protocol.version": "string",
    "jsonrpc.request.id": "string",
    "jvm.gc.action": "string",
    "jvm.gc.name": "string",
    "jvm.memory.pool.name": "string",
    "jvm.memory.type": "string",
    "jvm.thread.daemon": "boolean",
    "jvm.thread.state": "string",
    "koa.name": "string",
    "koa.type": "string",
    lcp: "double",
    "lcp.element": "string",
    "lcp.id": "string",
    "lcp.loadTime": "integer",
    "lcp.renderTime": "integer",
    "lcp.size": "integer",
    "lcp.url": "string",
    "logger.name": "string",
    "mcp.cancelled.reason": "string",
    "mcp.cancelled.request_id": "string",
    "mcp.client.name": "string",
    "mcp.client.title": "string",
    "mcp.client.version": "string",
    "mcp.lifecycle.phase": "string",
    "mcp.logging.data_type": "string",
    "mcp.logging.level": "string",
    "mcp.logging.logger": "string",
    "mcp.logging.message": "string",
    "mcp.method.name": "string",
    "mcp.progress.current": "integer",
    "mcp.progress.message": "string",
    "mcp.progress.percentage": "double",
    "mcp.progress.token": "string",
    "mcp.progress.total": "integer",
    "mcp.prompt.name": "string",
    "mcp.prompt.result.description": "string",
    "mcp.prompt.result.message_content": "string",
    "mcp.prompt.result.message_count": "integer",
    "mcp.prompt.result.message_role": "string",
    "mcp.protocol.ready": "integer",
    "mcp.protocol.version": "string",
    "mcp.request.argument.<key>": "string",
    "mcp.request.argument.name": "string",
    "mcp.request.argument.uri": "string",
    "mcp.request.id": "string",
    "mcp.resource.protocol": "string",
    "mcp.resource.uri": "string",
    "mcp.server.name": "string",
    "mcp.server.title": "string",
    "mcp.server.version": "string",
    "mcp.session.id": "string",
    "mcp.tool.name": "string",
    "mcp.tool.result.content": "string",
    "mcp.tool.result.content_count": "integer",
    "mcp.tool.result.is_error": "boolean",
    "mcp.transport": "string",
    "mdc.<key>": "string",
    "messaging.batch.message_count": "integer",
    "messaging.destination": "string",
    "messaging.destination.connection": "string",
    "messaging.destination.name": "string",
    "messaging.message.body.size": "integer",
    "messaging.message.conversation_id": "string",
    "messaging.message.envelope.size": "integer",
    "messaging.message.id": "string",
    "messaging.message.receive.latency": "integer",
    "messaging.message.retry.count": "integer",
    "messaging.operation.name": "string",
    "messaging.operation.type": "string",
    "messaging.rabbitmq.destination.routing_key": "string",
    "messaging.system": "string",
    method: "string",
    "middleware.name": "string",
    "navigation.origin": "string",
    "navigation.route.id": "string",
    "navigation.type": "string",
    "nel.elapsed_time": "integer",
    "nel.phase": "string",
    "nel.referrer": "string",
    "nel.sampling_function": "double",
    "nel.type": "string",
    "network.connection.effective_type": "string",
    "network.connection.rtt": "integer",
    "network.connection.type": "string",
    "network.local.address": "string",
    "network.local.port": "integer",
    "network.peer.address": "string",
    "network.peer.port": "integer",
    "network.protocol.name": "string",
    "network.protocol.version": "string",
    "network.transport": "string",
    "network.type": "string",
    "net.host.ip": "string",
    "net.host.name": "string",
    "net.host.port": "integer",
    "net.peer.ip": "string",
    "net.peer.name": "string",
    "net.peer.port": "integer",
    "net.protocol.name": "string",
    "net.protocol.version": "string",
    "net.sock.family": "string",
    "net.sock.host.addr": "string",
    "net.sock.host.port": "integer",
    "net.sock.peer.addr": "string",
    "net.sock.peer.name": "string",
    "net.sock.peer.port": "integer",
    "net.transport": "string",
    "os.build": "string",
    "os.build_id": "string",
    "os.description": "string",
    "os.kernel_version": "string",
    "os.name": "string",
    "os.raw_description": "string",
    "os.rooted": "boolean",
    "os.theme": "string",
    "os.type": "string",
    "os.version": "string",
    "otel.kind": "string",
    "otel.scope.name": "string",
    "otel.scope.version": "string",
    "otel.status_code": "string",
    "otel.status_description": "string",
    "params.<key>": "string",
    "performance.activationStart": "double",
    "performance.timeOrigin": "double",
    previous_route: "string",
    "process.command_args": "string[]",
    "process.executable.name": "string",
    "process.pid": "integer",
    "process.runtime.description": "string",
    "process.runtime.engine.name": "string",
    "process.runtime.engine.version": "string",
    "process.runtime.name": "string",
    "process.runtime.version": "string",
    "query.<key>": "string",
    "react.version": "string",
    release: "string",
    "remix.action_form_data.<key>": "string",
    replay_id: "string",
    "resource.deployment.environment": "string",
    "resource.deployment.environment.name": "string",
    "resource.render_blocking_status": "string",
    route: "string",
    "rpc.grpc.status_code": "integer",
    "rpc.method": "string",
    "rpc.response.status_code": "string",
    "rpc.service": "string",
    "rpc.system": "string",
    "rpc.system.name": "string",
    "runtime.build": "string",
    "runtime.name": "string",
    "runtime.raw_description": "string",
    "runtime.version": "string",
    "score.<key>": "double",
    "score.ratio.<key>": "double",
    "score.total": "double",
    "score.weight.<key>": "double",
    "sentry.action": "string",
    "sentry.browser.name": "string",
    "sentry.browser.version": "string",
    "sentry.cancellation_reason": "string",
    "sentry.category": "string",
    "sentry.client_sample_rate": "double",
    "sentry.description": "string",
    "sentry.dist": "string",
    "sentry.domain": "string",
    "sentry.dsc.environment": "string",
    "sentry.dsc.project_id": "string",
    "sentry.dsc.public_key": "string",
    "sentry.dsc.release": "string",
    "sentry.dsc.sampled": "boolean",
    "sentry.dsc.sample_rate": "string",
    "sentry.dsc.trace_id": "string",
    "sentry.dsc.transaction": "string",
    "sentry.environment": "string",
    "sentry.exclusive_time": "double",
    "sentry.graphql.operation": "string",
    "sentry.group": "string",
    "sentry.http.prefetch": "boolean",
    "sentry.idle_span_finish_reason": "string",
    "sentry.is_remote": "boolean",
    "sentry.kind": "string",
    "sentry.main_thread": "boolean",
    "sentry.message.parameter.<key>": "string",
    "sentry.message.template": "string",
    "sentry.metric.source": "string",
    "sentry.mobile": "boolean",
    "sentry.module.<key>": "string",
    "sentry.nextjs.ssr.function.route": "string",
    "sentry.nextjs.ssr.function.type": "string",
    "sentry.normalized_db_query": "string",
    "sentry.normalized_db_query.hash": "string",
    "sentry.normalized_description": "string",
    "sentry.observed_timestamp_nanos": "string",
    "sentry.op": "string",
    "sentry.origin": "string",
    "sentry.platform": "string",
    "sentry.profiler_id": "string",
    "sentry.profile_id": "string",
    "sentry.release": "string",
    "sentry.replay_id": "string",
    "sentry.replay_is_buffering": "boolean",
    "sentry.report_event": "string",
    "sentry.sdk.integrations": "string[]",
    "sentry.sdk.name": "string",
    "sentry.sdk.version": "string",
    "sentry.segment.id": "string",
    "sentry.segment_id": "string",
    "sentry.segment.name": "string",
    "sentry.server_sample_rate": "double",
    "sentry.source": "string",
    "sentry.span.source": "string",
    "sentry.status": "string",
    "sentry.status_code": "integer",
    "sentry.status.message": "string",
    "sentry.sveltekit.navigation.from": "string",
    "sentry.sveltekit.navigation.to": "string",
    "sentry.sveltekit.navigation.type": "string",
    "sentry.thread.id": "integer",
    "sentry.timestamp.sequence": "integer",
    "sentry.trace_lifecycle": "string",
    "sentry.trace.parent_span_id": "string",
    "sentry.trace.status": "string",
    "sentry.transaction": "string",
    "sentry.user.email": "string",
    "sentry.user.geo.city": "string",
    "sentry.user.geo.country_code": "string",
    "sentry.user.geo.region": "string",
    "sentry.user.geo.subdivision": "string",
    "sentry.user.id": "string",
    "sentry.user.ip": "string",
    "sentry.user.username": "string",
    "server.address": "string",
    server_name: "string",
    "server.port": "integer",
    "service.name": "string",
    "service.version": "string",
    "session.id": "string",
    stall_percentage: "double",
    stall_total_time: "double",
    "state.type": "string",
    "thread.id": "integer",
    "thread.name": "string",
    "timber.tag": "string",
    time_to_full_display: "double",
    time_to_initial_display: "double",
    transaction: "string",
    "trpc.procedure_path": "string",
    "trpc.procedure_type": "string",
    ttfb: "double",
    "ttfb.requestTime": "double",
    type: "string",
    "ui.component_name": "string",
    "ui.contributes_to_ttfd": "boolean",
    "ui.contributes_to_ttid": "boolean",
    "ui.element.height": "integer",
    "ui.element.id": "string",
    "ui.element.identifier": "string",
    "ui.element.load_time": "double",
    "ui.element.paint_type": "string",
    "ui.element.render_time": "double",
    "ui.element.type": "string",
    "ui.element.url": "string",
    "ui.element.width": "integer",
    url: "string",
    "url.domain": "string",
    "url.fragment": "string",
    "url.full": "string",
    "url.path": "string",
    "url.path.parameter.<key>": "string",
    "url.port": "integer",
    "url.query": "string",
    "url.same_origin": "boolean",
    "url.scheme": "string",
    "url.template": "string",
    "user_agent.original": "string",
    "user.email": "string",
    "user.full_name": "string",
    "user.geo.city": "string",
    "user.geo.country_code": "string",
    "user.geo.region": "string",
    "user.geo.subdivision": "string",
    "user.hash": "string",
    "user.id": "string",
    "user.ip_address": "string",
    "user.name": "string",
    "user.roles": "string[]",
    "vercel.branch": "string",
    "vercel.build_id": "string",
    "vercel.deployment_id": "string",
    "vercel.destination": "string",
    "vercel.edge_type": "string",
    "vercel.entrypoint": "string",
    "vercel.execution_region": "string",
    "vercel.id": "string",
    "vercel.ja3_digest": "string",
    "vercel.ja4_digest": "string",
    "vercel.log_type": "string",
    "vercel.path": "string",
    "vercel.project_id": "string",
    "vercel.project_name": "string",
    "vercel.proxy.cache_id": "string",
    "vercel.proxy.client_ip": "string",
    "vercel.proxy.host": "string",
    "vercel.proxy.lambda_region": "string",
    "vercel.proxy.method": "string",
    "vercel.proxy.path": "string",
    "vercel.proxy.path_type": "string",
    "vercel.proxy.path_type_variant": "string",
    "vercel.proxy.referer": "string",
    "vercel.proxy.region": "string",
    "vercel.proxy.response_byte_size": "integer",
    "vercel.proxy.scheme": "string",
    "vercel.proxy.status_code": "integer",
    "vercel.proxy.timestamp": "integer",
    "vercel.proxy.user_agent": "string[]",
    "vercel.proxy.vercel_cache": "string",
    "vercel.proxy.vercel_id": "string",
    "vercel.proxy.waf_action": "string",
    "vercel.proxy.waf_rule_id": "string",
    "vercel.request_id": "string",
    "vercel.source": "string",
    "vercel.status_code": "integer"
}, $c97e36c8d40a3851$var$ATTRIBUTE_METADATA = {
    "ai.citations": {
        brief: "References or sources cited by the AI model in its response.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Citation 1",
            "Citation 2"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.completion_tokens.used": {
        brief: "The number of tokens used to respond to the message.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 10,
        deprecation: {
            replacement: "gen_ai.usage.output_tokens"
        },
        aliases: [
            "gen_ai.usage.output_tokens",
            "gen_ai.usage.completion_tokens"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.documents": {
        brief: "Documents or content chunks used as context for the AI model.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "document1.txt",
            "document2.pdf"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.finish_reason": {
        brief: "The reason why the model stopped generating.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "COMPLETE",
        deprecation: {
            replacement: "gen_ai.response.finish_reasons"
        },
        aliases: [
            "gen_ai.response.finish_reasons"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.frequency_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. The higher the value, the stronger a penalty is applied to previously present tokens, proportional to how many times they have already appeared in the prompt or prior generation.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        deprecation: {
            replacement: "gen_ai.request.frequency_penalty"
        },
        aliases: [
            "gen_ai.request.frequency_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.function_call": {
        brief: "For an AI model call, the function that was called. This is deprecated for OpenAI, and replaced by tool_calls",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "function_name",
        deprecation: {
            replacement: "gen_ai.tool.name"
        },
        aliases: [
            "gen_ai.tool.name",
            "mcp.tool.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.generation_id": {
        brief: "Unique identifier for the completion.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gen_123abc",
        deprecation: {
            replacement: "gen_ai.response.id"
        },
        aliases: [
            "gen_ai.response.id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.input_messages": {
        brief: "The input messages sent to the model",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        deprecation: {
            replacement: "gen_ai.input.messages"
        },
        aliases: [
            "gen_ai.request.messages"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    65,
                    119
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.is_search_required": {
        brief: "Boolean indicating if the model needs to perform a search.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.metadata": {
        brief: "Extra metadata passed to an AI pipeline step.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"user_id": 123, "session_id": "abc123"}',
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    127
                ]
            }
        ]
    },
    "ai.model_id": {
        brief: "The vendor-specific ID of the model used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gpt-4",
        deprecation: {
            replacement: "gen_ai.response.model"
        },
        aliases: [
            "gen_ai.response.model"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.model.provider": {
        brief: "The provider of the model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "openai",
        deprecation: {
            replacement: "gen_ai.provider.name"
        },
        aliases: [
            "gen_ai.provider.name",
            "gen_ai.system"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    253
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.pipeline.name": {
        brief: "The name of the AI pipeline.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Autofix Pipeline",
        deprecation: {
            replacement: "gen_ai.pipeline.name"
        },
        aliases: [
            "gen_ai.pipeline.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    53,
                    76,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.preamble": {
        brief: "For an AI model call, the preamble parameter. Preambles are a part of the prompt used to adjust the model's overall behavior and conversation style.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "You are now a clown.",
        deprecation: {
            replacement: "gen_ai.system_instructions"
        },
        aliases: [
            "gen_ai.system_instructions"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.presence_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. Similar to frequency_penalty, except that this penalty is applied equally to all tokens that have already appeared, regardless of their exact frequencies.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        deprecation: {
            replacement: "gen_ai.request.presence_penalty"
        },
        aliases: [
            "gen_ai.request.presence_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.prompt_tokens.used": {
        brief: "The number of tokens used to process just the prompt.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 20,
        deprecation: {
            replacement: "gen_ai.usage.input_tokens"
        },
        aliases: [
            "gen_ai.usage.prompt_tokens",
            "gen_ai.usage.input_tokens"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.raw_prompting": {
        brief: "When enabled, the user\u2019s prompt will be sent to the model without any pre-processing.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.responses": {
        brief: "The response messages sent back by the AI model.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "hello",
            "world"
        ],
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    65,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.response_format": {
        brief: "For an AI model call, the format of the response",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "json_object",
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    127
                ]
            }
        ]
    },
    "ai.search_queries": {
        brief: "Queries used to search for relevant context or documents.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "climate change effects",
            "renewable energy"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.search_results": {
        brief: "Results returned from search queries for context.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "search_result_1, search_result_2"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.seed": {
        brief: "The seed, ideally models given the same seed and same other parameters will produce the exact same output.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        deprecation: {
            replacement: "gen_ai.request.seed"
        },
        aliases: [
            "gen_ai.request.seed"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.streaming": {
        brief: "Whether the request was streamed back.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        deprecation: {
            replacement: "gen_ai.response.streaming"
        },
        aliases: [
            "gen_ai.response.streaming"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    76,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.tags": {
        brief: "Tags that describe an AI pipeline step.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"executed_function": "add_integers"}',
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    127
                ]
            }
        ]
    },
    "ai.temperature": {
        brief: "For an AI model call, the temperature parameter. Temperature essentially means how random the output will be.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .1,
        deprecation: {
            replacement: "gen_ai.request.temperature"
        },
        aliases: [
            "gen_ai.request.temperature"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.texts": {
        brief: "Raw text inputs provided to the model.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Hello, how are you?",
            "What is the capital of France?"
        ],
        deprecation: {
            replacement: "gen_ai.input.messages"
        },
        aliases: [
            "gen_ai.input.messages"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.tools": {
        brief: "For an AI model call, the functions that are available",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "function_1",
            "function_2"
        ],
        deprecation: {
            replacement: "gen_ai.tool.definitions"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    65,
                    127
                ]
            }
        ]
    },
    "ai.tool_calls": {
        brief: "For an AI model call, the tool calls that were made.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "tool_call_1",
            "tool_call_2"
        ],
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    65
                ]
            }
        ]
    },
    "ai.top_k": {
        brief: "Limits the model to only consider the K most likely next tokens, where K is an integer (e.g., top_k=20 means only the 20 highest probability tokens are considered).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 35,
        deprecation: {
            replacement: "gen_ai.request.top_k"
        },
        aliases: [
            "gen_ai.request.top_k"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.top_p": {
        brief: "Limits the model to only consider tokens whose cumulative probability mass adds up to p, where p is a float between 0 and 1 (e.g., top_p=0.7 means only tokens that sum up to 70% of the probability mass are considered).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .7,
        deprecation: {
            replacement: "gen_ai.request.top_p"
        },
        aliases: [
            "gen_ai.request.top_p"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.total_cost": {
        brief: "The total cost for the tokens used.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        deprecation: {
            replacement: "gen_ai.cost.total_tokens"
        },
        aliases: [
            "gen_ai.cost.total_tokens"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    53
                ]
            }
        ]
    },
    "ai.total_tokens.used": {
        brief: "The total number of tokens used to process the prompt.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 30,
        deprecation: {
            replacement: "gen_ai.usage.total_tokens"
        },
        aliases: [
            "gen_ai.usage.total_tokens"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.warnings": {
        brief: "Warning messages generated during model execution.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Token limit exceeded"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "angular.version": {
        brief: "The version of the Angular framework",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "17.1.0",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    367
                ],
                description: "Added angular.version attribute"
            }
        ]
    },
    "app.app_build": {
        brief: "Internal build identifier, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1",
        deprecation: {
            replacement: "app.build",
            reason: "Deprecated in favor of app.build"
        },
        aliases: [
            "app.build"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_build in favor of app.build"
            }
        ]
    },
    "app.app_identifier": {
        brief: "Version-independent application identifier, often a dotted bundle ID.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "com.example.myapp",
        deprecation: {
            replacement: "app.identifier",
            reason: "Deprecated in favor of app.identifier"
        },
        aliases: [
            "app.identifier"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_identifier in favor of app.identifier"
            }
        ]
    },
    "app.app_name": {
        brief: "Human readable application name, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "My App",
        deprecation: {
            replacement: "app.name",
            reason: "Deprecated in favor of app.name"
        },
        aliases: [
            "app.name"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_name in favor of app.name"
            }
        ]
    },
    "app.app_start_time": {
        brief: "Formatted UTC timestamp when the user started the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2025-01-01T00:00:00.000Z",
        deprecation: {
            replacement: "app.start_time",
            reason: "Deprecated in favor of app.start_time"
        },
        aliases: [
            "app.start_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_start_time in favor of app.start_time"
            }
        ]
    },
    "app.app_version": {
        brief: "Human readable application version, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0.0",
        deprecation: {
            replacement: "app.version",
            reason: "Deprecated in favor of app.version"
        },
        aliases: [
            "app.version"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_version in favor of app.version"
            }
        ]
    },
    "app.build": {
        brief: "Internal build identifier, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1",
        aliases: [
            "app.app_build"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.build attribute"
            }
        ]
    },
    "app.identifier": {
        brief: "Version-independent application identifier, often a dotted bundle ID.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "com.example.myapp",
        aliases: [
            "app.app_identifier"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.identifier attribute"
            }
        ]
    },
    "app.in_foreground": {
        brief: "Whether the application is currently in the foreground.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.in_foreground attribute"
            }
        ]
    },
    "app.name": {
        brief: "Human readable application name, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "My App",
        aliases: [
            "app.app_name"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.name attribute"
            }
        ]
    },
    app_start_cold: {
        brief: "The duration of a cold app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.start.cold.value",
            reason: "Replaced by app.vitals.start.cold.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.start.cold.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    323
                ],
                description: "Added and deprecated in favor of app.vitals.start.cold.value"
            }
        ]
    },
    "app.start_time": {
        brief: "Formatted UTC timestamp when the user started the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2025-01-01T00:00:00.000Z",
        aliases: [
            "app.app_start_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.start_time attribute"
            }
        ]
    },
    app_start_type: {
        brief: "Mobile app start variant. Either cold or warm.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "cold",
        deprecation: {
            replacement: "app.vitals.start.type",
            reason: "Replaced by app.vitals.start.type to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.start.type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.start.type"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    app_start_warm: {
        brief: "The duration of a warm app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.start.warm.value",
            reason: "Replaced by app.vitals.start.warm.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.start.warm.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    323
                ],
                description: "Added and deprecated in favor of app.vitals.start.warm.value"
            }
        ]
    },
    "app.version": {
        brief: "Human readable application version, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0.0",
        aliases: [
            "app.app_version"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.version attribute"
            }
        ]
    },
    "app.vitals.frames.delay.value": {
        brief: "The sum of all delayed frame durations in seconds during the lifetime of the span. For more information see [frames delay](https://develop.sentry.dev/sdk/performance/frames-delay/).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5,
        aliases: [
            "frames.delay"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.delay.value to replace frames.delay"
            }
        ]
    },
    "app.vitals.frames.frozen.count": {
        brief: "The number of frozen frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        aliases: [
            "frames.frozen"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.frozen.count to replace frames.frozen"
            }
        ]
    },
    "app.vitals.frames.slow.count": {
        brief: "The number of slow frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        aliases: [
            "frames.slow"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.slow.count to replace frames.slow"
            }
        ]
    },
    "app.vitals.frames.total.count": {
        brief: "The number of total frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 60,
        aliases: [
            "frames.total"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.total.count to replace frames.total"
            }
        ]
    },
    "app.vitals.start.cold.value": {
        brief: "The duration of a cold app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "app_start_cold"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.start.cold.value attribute"
            }
        ]
    },
    "app.vitals.start.prewarmed": {
        brief: "Whether the app start was prewarmed.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    379
                ],
                description: "Added app.vitals.start.prewarmed attribute"
            }
        ]
    },
    "app.vitals.start.reason": {
        brief: "The reason that triggered the app start.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "push",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    353
                ],
                description: "Added app.vitals.start.reason attribute"
            }
        ]
    },
    "app.vitals.start.screen": {
        brief: "The screen that is rendered when the app start is complete. This is the screen the user first sees and can interact with after launch. The absence of this attribute on the app start span indicates a background app start where no UI was rendered.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MainActivity",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    353
                ],
                description: "Added app.vitals.start.screen attribute"
            }
        ]
    },
    "app.vitals.start.type": {
        brief: "The type of app start, for example `cold` or `warm`",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "cold",
        aliases: [
            "app_start_type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.start.type attribute"
            }
        ]
    },
    "app.vitals.start.warm.value": {
        brief: "The duration of a warm app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "app_start_warm"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.start.warm.value attribute"
            }
        ]
    },
    "app.vitals.ttfd.value": {
        brief: "The duration of time to full display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "time_to_full_display"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.ttfd.value attribute"
            }
        ]
    },
    "app.vitals.ttid.value": {
        brief: "The duration of time to initial display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "time_to_initial_display"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.ttid.value attribute"
            }
        ]
    },
    "art.gc.blocking_count": {
        brief: "Total number of blocking (stop-the-world) garbage collections performed by the Android Runtime",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.blocking_count attribute"
            }
        ]
    },
    "art.gc.blocking_time": {
        brief: "Total time spent in blocking (stop-the-world) garbage collections by the Android Runtime, in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 11.873,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.blocking_time attribute"
            }
        ]
    },
    "art.gc.pre_oome_count": {
        brief: "Total number of garbage collections triggered as a last resort before an OutOfMemoryError by the Android Runtime",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 0,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.pre_oome_count attribute"
            }
        ]
    },
    "art.gc.total_count": {
        brief: "Total number of garbage collections performed by the Android Runtime",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.total_count attribute"
            }
        ]
    },
    "art.gc.total_time": {
        brief: "Total time spent in garbage collection by the Android Runtime, in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 11.807,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.total_time attribute"
            }
        ]
    },
    "art.gc.waiting_time": {
        brief: "Total time threads spent waiting for garbage collection to complete in the Android Runtime, in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 8.054,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.waiting_time attribute"
            }
        ]
    },
    "art.memory.free": {
        brief: "Free memory available to the process as reported by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3181568,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.free attribute"
            }
        ]
    },
    "art.memory.free_until_gc": {
        brief: "Free memory available before a garbage collection would be triggered by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3181568,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.free_until_gc attribute"
            }
        ]
    },
    "art.memory.free_until_oome": {
        brief: "Free memory available before an OutOfMemoryError would be thrown by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 196083712,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.free_until_oome attribute"
            }
        ]
    },
    "art.memory.max": {
        brief: "Maximum memory the process is allowed to use as reported by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 201326592,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.max attribute"
            }
        ]
    },
    "art.memory.total": {
        brief: "Total memory currently allocated to the process by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 7774208,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.total attribute"
            }
        ]
    },
    "aws.cloudwatch.logs.log_group": {
        brief: "The name of the CloudWatch Logs log group",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/aws/lambda/my-function",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.cloudwatch.logs.log_group attribute"
            }
        ]
    },
    "aws.cloudwatch.logs.log_stream": {
        brief: "The name of the CloudWatch Logs log stream",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2024/01/01/[$LATEST]abcdef1234567890",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.cloudwatch.logs.log_stream attribute"
            }
        ]
    },
    "aws.cloudwatch.logs.url": {
        brief: "The URL to the CloudWatch Logs log group",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://console.aws.amazon.com/cloudwatch/home?region=us-east-1#logsV2:log-groups/log-group/my-log-group",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.cloudwatch.logs.url attribute"
            }
        ]
    },
    "aws.dynamodb.attribute_definitions": {
        brief: "The JSON-serialized value of each item in the `AttributeDefinitions` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "AttributeName": "string", "AttributeType": "string" }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.attribute_definitions attribute"
            }
        ]
    },
    "aws.dynamodb.consistent_read": {
        brief: "The value of the `ConsistentRead` request parameter.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.consistent_read attribute"
            }
        ]
    },
    "aws.dynamodb.consumed_capacity": {
        brief: "The JSON-serialized value of each item in the `ConsumedCapacity` response field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "CapacityUnits": number, "GlobalSecondaryIndexes": { "string" : { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number } }, "LocalSecondaryIndexes": { "string" : { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number } }, "ReadCapacityUnits": number, "Table": { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number }, "TableName": "string", "WriteCapacityUnits": number }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.consumed_capacity attribute"
            }
        ]
    },
    "aws.dynamodb.count": {
        brief: "The value of the `Count` response parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.count attribute"
            }
        ]
    },
    "aws.dynamodb.exclusive_start_table": {
        brief: "The value of the `ExclusiveStartTableName` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Users",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.exclusive_start_table attribute"
            }
        ]
    },
    "aws.dynamodb.global_secondary_indexes": {
        brief: "The JSON-serialized value of each item of the `GlobalSecondaryIndexes` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "IndexName": "string", "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" }, "ProvisionedThroughput": { "ReadCapacityUnits": number, "WriteCapacityUnits": number } }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.global_secondary_indexes attribute"
            }
        ]
    },
    "aws.dynamodb.global_secondary_index_updates": {
        brief: "The JSON-serialized value of each item in the `GlobalSecondaryIndexUpdates` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "Create": { "IndexName": "string", "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" }, "ProvisionedThroughput": { "ReadCapacityUnits": number, "WriteCapacityUnits": number } }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.global_secondary_index_updates attribute"
            }
        ]
    },
    "aws.dynamodb.index_name": {
        brief: "The value of the `IndexName` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "name_to_group",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.index_name attribute"
            }
        ]
    },
    "aws.dynamodb.item_collection_metrics": {
        brief: "The JSON-serialized value of the `ItemCollectionMetrics` response field.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '{ "string" : [ { "ItemCollectionKey": { "string" : { "B": blob, "BOOL": boolean, "BS": [ blob ], "L": [ "AttributeValue" ], "M": { "string" : "AttributeValue" }, "N": "string", "NS": [ "string" ], "NULL": boolean, "S": "string", "SS": [ "string" ] } }, "SizeEstimateRangeGB": [ number ] } ] }',
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.item_collection_metrics attribute"
            }
        ]
    },
    "aws.dynamodb.limit": {
        brief: "The value of the `Limit` request parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.limit attribute"
            }
        ]
    },
    "aws.dynamodb.local_secondary_indexes": {
        brief: "The JSON-serialized value of each item of the `LocalSecondaryIndexes` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "IndexArn": "string", "IndexName": "string", "IndexSizeBytes": number, "ItemCount": number, "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" } }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.local_secondary_indexes attribute"
            }
        ]
    },
    "aws.dynamodb.projection": {
        brief: "The value of the `ProjectionExpression` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Title, Price, Color",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.projection attribute"
            }
        ]
    },
    "aws.dynamodb.provisioned_read_capacity": {
        brief: "The value of the `ProvisionedThroughput.ReadCapacityUnits` request parameter.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.provisioned_read_capacity attribute"
            }
        ]
    },
    "aws.dynamodb.provisioned_write_capacity": {
        brief: "The value of the `ProvisionedThroughput.WriteCapacityUnits` request parameter.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.provisioned_write_capacity attribute"
            }
        ]
    },
    "aws.dynamodb.scanned_count": {
        brief: "The value of the `ScannedCount` response parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.scanned_count attribute"
            }
        ]
    },
    "aws.dynamodb.scan_forward": {
        brief: "The value of the `ScanIndexForward` request parameter.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.scan_forward attribute"
            }
        ]
    },
    "aws.dynamodb.segment": {
        brief: "The value of the `Segment` request parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.segment attribute"
            }
        ]
    },
    "aws.dynamodb.select": {
        brief: "The value of the `Select` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ALL_ATTRIBUTES",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.select attribute"
            }
        ]
    },
    "aws.dynamodb.table_count": {
        brief: "The number of items in the `TableNames` response parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 20,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.table_count attribute"
            }
        ]
    },
    "aws.dynamodb.table_names": {
        brief: "The keys in the `RequestItems` object field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "Users",
            "Cats"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.table_names attribute"
            }
        ]
    },
    "aws.dynamodb.total_segments": {
        brief: "The value of the `TotalSegments` request parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.total_segments attribute"
            }
        ]
    },
    "aws.extended_request_id": {
        brief: "The AWS extended request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "wzHcyEWfmOGDIE5QOhTAqFDoDWP3y8IUvpNINCwL9N4TEHbUw0/gZJ+VZTmCNCWR7fezEN3eCiQ=",
        aliases: [
            "aws.request.extended_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.extended_request_id attribute"
            }
        ]
    },
    "aws.kinesis.stream_name": {
        brief: "The name of the AWS Kinesis stream the request refers to.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "some-stream-name",
        aliases: [
            "aws.kinesis.stream.name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.kinesis.stream_name attribute"
            }
        ]
    },
    "aws.kinesis.stream.name": {
        brief: "The name of the AWS Kinesis stream the request refers to.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "some-stream-name",
        deprecation: {
            replacement: "aws.kinesis.stream_name",
            reason: "This attribute is being deprecated in favor of aws.kinesis.stream_name, which is the OTel-aligned replacement."
        },
        aliases: [
            "aws.kinesis.stream_name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.kinesis.stream.name attribute, deprecated in favor of aws.kinesis.stream_name"
            }
        ]
    },
    "aws.lambda.aws_request_id": {
        brief: "The AWS request ID as received by the Lambda function runtime",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "8476a536-e9f4-11e8-9739-2dfe598c3fcd",
        deprecation: {
            replacement: "faas.invocation_id",
            reason: "This attribute is being deprecated in favor of faas.invocation_id"
        },
        aliases: [
            "faas.invocation_id",
            "faas.execution"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    473
                ],
                description: "Added faas.execution as an alias"
            },
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ],
                description: "Deprecated aws.lambda.aws_request_id in favor of faas.invocation_id"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.aws_request_id attribute"
            }
        ]
    },
    "aws.lambda.execution_duration_in_millis": {
        brief: "The execution duration of the Lambda function invocation in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.execution_duration_in_millis attribute"
            }
        ]
    },
    "aws.lambda.function_name": {
        brief: "The name of the Lambda function",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-function",
        deprecation: {
            replacement: "faas.name",
            reason: "Use the OTel-aligned faas.name attribute instead"
        },
        aliases: [
            "faas.name"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ],
                description: "Deprecated aws.lambda.function_name in favor of faas.name"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.function_name attribute"
            }
        ]
    },
    "aws.lambda.function_version": {
        brief: "The version of the Lambda function",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "$LATEST",
        deprecation: {
            replacement: "faas.version",
            reason: "Use the OTel-aligned faas.version attribute instead"
        },
        aliases: [
            "faas.version"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ],
                description: "Deprecated aws.lambda.function_version in favor of faas.version"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.function_version attribute"
            }
        ]
    },
    "aws.lambda.invoked_arn": {
        brief: "The full ARN of the Lambda function that was invoked",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:lambda:us-east-1:123456789012:function:my-function",
        aliases: [
            "aws.lambda.invoked_function_arn"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ]
    },
    "aws.lambda.invoked_function_arn": {
        brief: "The full ARN of the Lambda function that was invoked",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "arn:aws:lambda:us-east-1:123456789012:function:my-function",
        deprecation: {
            replacement: "aws.lambda.invoked_arn",
            reason: "This attribute is being deprecated in favor of aws.lambda.invoked_arn"
        },
        aliases: [
            "aws.lambda.invoked_arn"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ],
                description: "Deprecated aws.lambda.invoked_function_arn in favor of aws.lambda.invoked_arn"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.invoked_function_arn attribute"
            }
        ]
    },
    "aws.lambda.remaining_time_in_millis": {
        brief: "The remaining time in milliseconds before the Lambda function times out",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5e3,
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.remaining_time_in_millis attribute"
            }
        ]
    },
    "aws.log.group.names": {
        brief: "The name(s) of the AWS log group(s) an application is writing to.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "/aws/lambda/my-function",
            "opentelemetry-service"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ]
    },
    "aws.log.stream.names": {
        brief: "The name(s) of the AWS log stream(s) an application is writing to.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "logs/main/10838bed-421f-43ef-870a-f43feacbbb5b"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ]
    },
    "aws.request.extended_id": {
        brief: "The AWS extended request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "wzHcyEWfmOGDIE5QOhTAqFDoDWP3y8IUvpNINCwL9N4TEHbUw0/gZJ+VZTmCNCWR7fezEN3eCiQ=",
        deprecation: {
            replacement: "aws.extended_request_id",
            reason: "This attribute is being deprecated in favor of aws.extended_request_id, which is the OTel-aligned replacement."
        },
        aliases: [
            "aws.extended_request_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.request.extended_id attribute, deprecated in favor of aws.extended_request_id"
            }
        ]
    },
    "aws.request_id": {
        brief: "The AWS request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "79b9da39-b7ae-508a-a6bc-864b2829c622",
        aliases: [
            "aws.request.id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.request_id attribute"
            }
        ]
    },
    "aws.request.id": {
        brief: "The AWS request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "79b9da39-b7ae-508a-a6bc-864b2829c622",
        deprecation: {
            replacement: "aws.request_id",
            reason: "This attribute is being deprecated in favor of aws.request_id, which is the OTel-aligned replacement."
        },
        aliases: [
            "aws.request_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.request.id attribute, deprecated in favor of aws.request_id"
            }
        ]
    },
    "aws.s3.bucket": {
        brief: "The S3 bucket name the request refers to.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ot-demo-test",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.s3.bucket attribute"
            }
        ]
    },
    "aws.secretsmanager.secret.arn": {
        brief: "The ARN of the Secret stored in Secrets Manager.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:secretsmanager:us-east-1:123456789012:secret:SecretName-6RandomCharacters",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.secretsmanager.secret.arn attribute"
            }
        ]
    },
    "aws.sns.topic.arn": {
        brief: "The ARN of the AWS SNS Topic. An Amazon SNS topic is a logical access point that acts as a communication channel.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:sns:us-east-1:123456789012:mystack-mytopic-NZJ5JSMVGFIE",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.sns.topic.arn attribute"
            }
        ]
    },
    "aws.step_functions.activity.arn": {
        brief: "The ARN of the AWS Step Functions Activity.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:states:us-east-1:123456789012:activity:get-greeting",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.step_functions.activity.arn attribute"
            }
        ]
    },
    "aws.step_functions.state_machine.arn": {
        brief: "The ARN of the AWS Step Functions State Machine.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:states:us-east-1:123456789012:stateMachine:myStateMachine:1",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.step_functions.state_machine.arn attribute"
            }
        ]
    },
    blocked_main_thread: {
        brief: "Whether the main thread was blocked by the span.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.name": {
        brief: "The name of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Chrome",
        aliases: [
            "sentry.browser.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127,
                    139
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.performance.navigation.activation_start": {
        brief: "The time between initiating a navigation to a page and the browser activating the page",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1.983,
        aliases: [
            "performance.activationStart"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added browser.performance.navigation.activation_start attribute"
            }
        ]
    },
    "browser.performance.time_origin": {
        brief: "The browser's performance.timeOrigin timestamp representing the time when the pageload was initiated",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1776185678886e-3,
        aliases: [
            "performance.timeOrigin"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added browser.performance.time_origin attribute attribute"
            }
        ]
    },
    "browser.report.type": {
        brief: "A browser report sent via reporting API..",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "network-error",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "browser.script.invoker": {
        brief: "How a script was called in the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Window.requestAnimationFrame",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.script.invoker_type": {
        brief: "Browser script entry point type.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "event-listener",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.script.source_char_position": {
        brief: "A number representing the script character position of the script.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 678,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.version": {
        brief: "The version of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "120.0.6099.130",
        aliases: [
            "sentry.browser.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    59,
                    127,
                    139
                ]
            }
        ]
    },
    "browser.web_vital.cls.report_event": {
        brief: "The event that caused the SDK to report CLS (pagehide or navigation)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "navigation",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    319
                ],
                description: "Added browser.web_vital.cls.report_event attribute"
            }
        ]
    },
    "browser.web_vital.cls.source.<key>": {
        brief: "The HTML elements or components responsible for the layout shift. <key> is a numeric index from 1 to N",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "body > div#app",
        aliases: [
            "cls.source.<key>"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    234
                ]
            }
        ]
    },
    "browser.web_vital.cls.value": {
        brief: "The value of the recorded Cumulative Layout Shift (CLS) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .2361,
        aliases: [
            "cls"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added browser.web_vital.cls.value attribute"
            }
        ]
    },
    "browser.web_vital.fcp.value": {
        brief: "The time it takes for the browser to render the first piece of meaningful content on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 547.6951,
        aliases: [
            "fcp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "browser.web_vital.fp.value": {
        brief: "The time in milliseconds it takes for the browser to render the first pixel on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 477.1926,
        aliases: [
            "fp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "browser.web_vital.inp.value": {
        brief: "The value of the recorded Interaction to Next Paint (INP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        aliases: [
            "inp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added browser.web_vital.inp.value attribute"
            }
        ]
    },
    "browser.web_vital.lcp.element": {
        brief: "The HTML element selector or component name for which LCP was reported",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "body > div#app > div#container > div",
        aliases: [
            "lcp.element"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.id": {
        brief: "The id of the dom element responsible for the largest contentful paint",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "#gero",
        aliases: [
            "lcp.id"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.load_time": {
        brief: "The time it took for the LCP element to be loaded",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1402,
        aliases: [
            "lcp.loadTime"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.render_time": {
        brief: "The time it took for the LCP element to be rendered",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1685,
        aliases: [
            "lcp.renderTime"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.report_event": {
        brief: "The event that caused the SDK to report LCP (pagehide or navigation)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "pagehide",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    319
                ],
                description: "Added browser.web_vital.lcp.report_event attribute"
            }
        ]
    },
    "browser.web_vital.lcp.size": {
        brief: "The size of the largest contentful paint element",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1024,
        aliases: [
            "lcp.size"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.url": {
        brief: "The url of the dom element responsible for the largest contentful paint",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com/static/img.png",
        aliases: [
            "lcp.url"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.value": {
        brief: "The value of the recorded Largest Contentful Paint (LCP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2500,
        aliases: [
            "lcp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added browser.web_vital.lcp.value attribute"
            }
        ]
    },
    "browser.web_vital.ttfb.request_time": {
        brief: "The time it takes for the server to process the initial request and send the first byte of a response to the user's browser",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1554.5814,
        aliases: [
            "ttfb.requestTime"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "browser.web_vital.ttfb.value": {
        brief: "The value of the recorded Time To First Byte (TTFB) web vital in Milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 194.3322,
        aliases: [
            "ttfb"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "cache.hit": {
        brief: "If the cache was hit during this span.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.item_size": {
        brief: "The size of the requested item in the cache. In bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 58,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.key": {
        brief: "The key of the cache accessed.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "my-cache-key",
            "my-other-cache-key"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.operation": {
        brief: "The operation being performed on the cache.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "get",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.ttl": {
        brief: "The ttl of the cache in seconds",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 120,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.write": {
        brief: "If the cache operation resulted in a write to the cache.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    channel: {
        brief: "The channel name that is being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "mail",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "client.address": {
        brief: "Client address - domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        aliases: [
            "http.client_ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    106,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "client.port": {
        brief: "Client port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 5432,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.d1.duration": {
        brief: "The duration of a Cloudflare D1 operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 543,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.d1.query_type": {
        brief: "The type of query executed in a Cloudflare D1 operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "run",
        deprecation: {
            replacement: "db.operation.name"
        },
        aliases: [
            "db.operation.name",
            "db.operation"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.d1.query_type attribute"
            }
        ]
    },
    "cloudflare.d1.rows_read": {
        brief: "The number of rows read in a Cloudflare D1 operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.d1.rows_written": {
        brief: "The number of rows written in a Cloudflare D1 operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.durable_object.query.bindings": {
        brief: "The number of bound parameters passed to the SQL exec call.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    435
                ],
                description: "Added cloudflare.durable_object.query.bindings attribute"
            }
        ]
    },
    "cloudflare.durable_object.response.rows_read": {
        brief: "The number of rows read by a Cloudflare Durable Object SQL operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12,
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    435
                ],
                description: "Added cloudflare.durable_object.response.rows_read attribute"
            }
        ]
    },
    "cloudflare.durable_object.response.rows_written": {
        brief: "The number of rows written by a Cloudflare Durable Object SQL operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    435
                ],
                description: "Added cloudflare.durable_object.response.rows_written attribute"
            }
        ]
    },
    "cloudflare.r2.bucket": {
        brief: "The name of the Cloudflare R2 bucket binding",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MY_BUCKET",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.bucket attribute"
            }
        ]
    },
    "cloudflare.r2.operation": {
        brief: "The R2 API operation being performed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GetObject",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.operation attribute"
            }
        ]
    },
    "cloudflare.r2.request.delimiter": {
        brief: "The delimiter used to group objects in an R2 list operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.delimiter attribute"
            }
        ]
    },
    "cloudflare.r2.request.key": {
        brief: "The object key used in the R2 operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-file.txt",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.key attribute"
            }
        ]
    },
    "cloudflare.r2.request.part_number": {
        brief: "The part number in a multipart upload operation",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.part_number attribute"
            }
        ]
    },
    "cloudflare.r2.request.prefix": {
        brief: "The prefix used to filter objects in an R2 list operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "images/",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.prefix attribute"
            }
        ]
    },
    "cloudflare.workflow.attempt": {
        brief: "The current attempt number for a Cloudflare Workflow step",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.attempt attribute"
            }
        ]
    },
    "cloudflare.workflow.retries.backoff": {
        brief: "The backoff strategy for Cloudflare Workflow step retries",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "exponential",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.retries.backoff attribute"
            }
        ]
    },
    "cloudflare.workflow.retries.delay": {
        brief: "The delay between Cloudflare Workflow step retries",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "5 seconds",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.retries.delay attribute"
            }
        ]
    },
    "cloudflare.workflow.retries.limit": {
        brief: "The maximum number of retries for a Cloudflare Workflow step",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.retries.limit attribute"
            }
        ]
    },
    "cloudflare.workflow.timeout": {
        brief: "The timeout duration for a Cloudflare Workflow step",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1 minute",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.timeout attribute"
            }
        ]
    },
    "cloud.account.id": {
        brief: "The cloud account ID the resource is assigned to",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "123456789012",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.account.id attribute"
            }
        ]
    },
    "cloud.availability_zone": {
        brief: "Cloud regions often have multiple, isolated locations known as zones to increase availability",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "us-east-1c",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.availability_zone attribute"
            }
        ]
    },
    "cloud.platform": {
        brief: "The cloud platform in use",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws_lambda",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.platform attribute"
            }
        ]
    },
    "cloud.provider": {
        brief: "Name of the cloud provider",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.provider attribute"
            }
        ]
    },
    "cloud.region": {
        brief: "The geographical region the resource is running",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "us-east-1",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.region attribute"
            }
        ]
    },
    "cloud.resource_id": {
        brief: "Cloud provider-specific native identifier of the monitored cloud resource",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:lambda:REGION:ACCOUNT_ID:function:my-function",
        aliases: [
            "faas.id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    475
                ],
                description: "Added faas.id as an alias"
            },
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ],
        additionalContext: [
            "This can be an identifier for a resource in AWS, GCP, or Azure. There may be some overlap in values found here with other attributes. For instance, an AWS lambda ARN may be found here as well as in `aws.lambda.invoked_arn`. OTEL recommends setting them alongside each other."
        ]
    },
    cls: {
        brief: "The value of the recorded Cumulative Layout Shift (CLS) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .2361,
        deprecation: {
            replacement: "browser.web_vital.cls.value",
            reason: "The CLS web vital is now recorded as a browser.web_vital.cls.value attribute."
        },
        aliases: [
            "browser.web_vital.cls.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "cls.source.<key>": {
        brief: "The HTML elements or components responsible for the layout shift. <key> is a numeric index from 1 to N",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "body > div#app",
        deprecation: {
            replacement: "browser.web_vital.cls.source.<key>",
            reason: "The CLS source is now recorded as a browser.web_vital.cls.source.<key> attribute."
        },
        aliases: [
            "browser.web_vital.cls.source.<key>"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    234
                ]
            }
        ]
    },
    "code.filepath": {
        brief: "The source code file name that identifies the code unit as uniquely as possible (preferably an absolute file path).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/app/myapplication/http/handler/server.py",
        deprecation: {
            replacement: "code.file.path"
        },
        aliases: [
            "code.file.path"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.file.path": {
        brief: "The source code file name that identifies the code unit as uniquely as possible (preferably an absolute file path).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/app/myapplication/http/handler/server.py",
        aliases: [
            "code.filepath"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "code.function": {
        brief: "The method or function name, or equivalent (usually rightmost part of the code unit's name).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "server_request",
        aliases: [
            "code.function.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.function.name": {
        brief: "The method or function fully-qualified name without arguments.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "server_request",
        aliases: [
            "code.function"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.lineno": {
        brief: "The line number in code.filepath best representing the operation. It SHOULD point within the code unit named in code.function",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 42,
        deprecation: {
            replacement: "code.line.number"
        },
        aliases: [
            "code.line.number"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.line.number": {
        brief: "The line number in code.filepath best representing the operation. It SHOULD point within the code unit named in code.function",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 42,
        aliases: [
            "code.lineno"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.namespace": {
        brief: "The 'namespace' within which code.function is defined. Usually the qualified class or module name, such that code.namespace + some separator + code.function form a unique identifier for the code unit.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http.handler",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    connectionType: {
        brief: "Specifies the type of the current connection (e.g. wifi, ethernet, cellular , etc).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "wifi",
        deprecation: {
            replacement: "network.connection.type",
            reason: "Old namespace-less attribute, to be replaced with network.connection.type for span-first future"
        },
        aliases: [
            "network.connection.type",
            "device.connection_type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "connection.rtt": {
        brief: "Specifies the estimated effective round-trip time of the current connection, in milliseconds.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        deprecation: {
            replacement: "network.connection.rtt",
            reason: "Old attribute name (no official namespace), to be replaced with network.connection.rtt for span-first future"
        },
        aliases: [
            "network.connection.rtt"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "culture.calendar": {
        brief: "The calendar system used by the culture.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GregorianCalendar",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.display_name": {
        brief: "Human readable name of the culture.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "English (United States)",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.is_24_hour_format": {
        brief: "Whether the culture uses 24-hour time format.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.locale": {
        brief: "The locale identifier following RFC 4646.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "en-US",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.timezone": {
        brief: "The timezone of the culture, as a geographic timezone identifier.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Europe/Vienna",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "db.collection.name": {
        brief: "The name of a collection (table, container) within the database.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "users",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    106,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.driver.name": {
        brief: "The name of the driver used for the database connection.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "psycopg2",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    297
                ],
                description: "Added db.driver.name attribute"
            }
        ]
    },
    "db.name": {
        brief: "The name of the database being accessed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "customers",
        deprecation: {
            replacement: "db.namespace"
        },
        aliases: [
            "db.namespace"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.namespace": {
        brief: "The name of the database being accessed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "customers",
        aliases: [
            "db.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.operation": {
        brief: "The name of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT",
        deprecation: {
            replacement: "db.operation.name"
        },
        aliases: [
            "db.operation.name",
            "cloudflare.d1.query_type"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    199
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.operation.batch.size": {
        brief: "The number of queries included in a batch operation. Operations are only considered batches when they contain two or more operations, and so db.operation.batch.size SHOULD never be 1.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 3,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    407
                ],
                description: "Added db.operation.batch.size attribute"
            }
        ]
    },
    "db.operation.name": {
        brief: "The name of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT",
        aliases: [
            "db.operation",
            "cloudflare.d1.query_type"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.query.parameter.<key>": {
        brief: "A query parameter used in db.query.text, with <key> being the parameter name, and the attribute value being a string representation of the parameter value.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "db.query.parameter.foo='123'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103,
                    127
                ]
            }
        ]
    },
    "db.query.summary": {
        brief: "A shortened representation of operation(s) in the full query. This attribute must be low-cardinality and should only contain the operation table names.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT users",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    208
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.query.text": {
        brief: "The database parameterized query being executed. Any parameter values (filters, insertion values, etc) should be replaced with parameter placeholders. If applicable, use `db.query.parameter.<key>` to add the parameter value.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT * FROM users WHERE id = $1",
        aliases: [
            "db.statement"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    208
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.redis.connection": {
        brief: "The redis connection name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-redis-instance",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.redis.key": {
        brief: "The key the Redis command is operating on.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user:2047:city",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    326
                ],
                description: "Added db.redis.key attribute"
            }
        ]
    },
    "db.redis.parameters": {
        brief: "The array of command parameters given to a redis command.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "test",
            "*"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "db.response.status_code": {
        brief: "Database response status code. The status code returned by the database. Usually it represents an error code, but may also represent partial success, warning, or differentiate between various types of successful outcomes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ORA-17002",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    462
                ],
                description: "Added db.response.status_code attribute"
            }
        ]
    },
    "db.sql.bindings": {
        brief: "The array of query bindings.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "1",
            "foo"
        ],
        deprecation: {
            replacement: "db.query.parameter.<key>",
            reason: "Instead of adding every binding in the db.sql.bindings attribute, add them as individual entires with db.query.parameter.<key>."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.statement": {
        brief: "The database statement being executed.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT * FROM users",
        deprecation: {
            replacement: "db.query.text"
        },
        aliases: [
            "db.query.text"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    199
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.stored_procedure.name": {
        brief: "The name of a stored procedure being called.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "GetUserById",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    398
                ]
            }
        ]
    },
    "db.system": {
        brief: "An identifier for the database management system (DBMS) product being used. See [OpenTelemetry docs](https://github.com/open-telemetry/semantic-conventions/blob/main/docs/database/database-spans.md#notes-and-well-known-identifiers-for-dbsystem) for a list of well-known identifiers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "postgresql",
        deprecation: {
            replacement: "db.system.name"
        },
        aliases: [
            "db.system.name"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    199,
                    224
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.system.name": {
        brief: "An identifier for the database management system (DBMS) product being used. See [OpenTelemetry docs](https://github.com/open-telemetry/semantic-conventions/blob/main/docs/database/database-spans.md#notes-and-well-known-identifiers-for-dbsystem) for a list of well-known identifiers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "postgresql",
        aliases: [
            "db.system"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.user": {
        brief: "The database user.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "fancy_user",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    deviceMemory: {
        brief: "The estimated total memory capacity of the device, only a rough estimation in gigabytes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "8 GB",
        deprecation: {
            replacement: "device.memory.estimated_capacity",
            reason: "Old namespace-less attribute, to be replaced with device.memory.estimated_capacity for span-first future"
        },
        aliases: [
            "device.memory.estimated_capacity"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    281
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "device.archs": {
        brief: "The CPU architectures of the device.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "arm64-v8a",
            "armeabi-v7a",
            "armeabi"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.archs attribute"
            }
        ]
    },
    "device.battery_level": {
        brief: "The battery level of the device as a percentage (0-100).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.battery_level attribute"
            }
        ]
    },
    "device.battery_temperature": {
        brief: "The battery temperature of the device in Celsius.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 25,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.battery_temperature attribute"
            }
        ]
    },
    "device.boot_time": {
        brief: "A formatted UTC timestamp when the system was booted.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2018-02-08T12:52:12Z",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.boot_time attribute"
            }
        ]
    },
    "device.brand": {
        brief: "The brand of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Apple",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116,
                    127
                ]
            }
        ]
    },
    "device.charging": {
        brief: "Whether the device was charging or not.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.charging attribute"
            }
        ]
    },
    "device.chipset": {
        brief: "The chipset of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Qualcomm SM8550",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.chipset attribute"
            }
        ]
    },
    "device.class": {
        brief: "The classification of the device. For example, `low`, `medium`, or `high`. Typically inferred by Relay - SDKs generally do not need to set this directly.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "medium",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.class attribute"
            }
        ]
    },
    "device.connection_type": {
        brief: "The internet connection type currently being used by the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "wifi",
        deprecation: {
            replacement: "network.connection.type",
            reason: "This attribute is being deprecated in favor of network.connection.type"
        },
        aliases: [
            "network.connection.type",
            "connectionType"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added and deprecated device.connection_type in favor of network.connection.type"
            }
        ]
    },
    "device.cpu_description": {
        brief: "A description of the CPU of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Intel(R) Core(TM)2 Quad CPU Q6600 @ 2.40GHz",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.cpu_description attribute"
            }
        ]
    },
    "device.external_free_storage": {
        brief: "External storage free size in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 67108864e3,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.external_free_storage attribute"
            }
        ]
    },
    "device.external_storage_size": {
        brief: "External storage total size in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 134217728e3,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.external_storage_size attribute"
            }
        ]
    },
    "device.family": {
        brief: "The family of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "iPhone",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116,
                    127
                ]
            }
        ]
    },
    "device.free_memory": {
        brief: "Free system memory in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2147483648,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.free_memory attribute"
            }
        ]
    },
    "device.free_storage": {
        brief: "Free device storage in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 107374182400,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.free_storage attribute"
            }
        ]
    },
    "device.id": {
        brief: "Unique device identifier.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.id attribute"
            }
        ]
    },
    "device.locale": {
        brief: "The locale of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "en-US",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.locale attribute"
            }
        ]
    },
    "device.low_memory": {
        brief: "Whether the device was low on memory.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.low_memory attribute"
            }
        ]
    },
    "device.low_power_mode": {
        brief: "Whether the device is in Low Power Mode.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    314
                ],
                description: "Added device.low_power_mode attribute"
            }
        ]
    },
    "device.manufacturer": {
        brief: "The manufacturer of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Google",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.manufacturer attribute"
            }
        ]
    },
    "device.memory.estimated_capacity": {
        brief: "The estimated total memory capacity of the device, only a rough estimation in gigabytes. Browsers report estimations in buckets of powers of 2, mostly capped at 8 GB",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 8,
        aliases: [
            "deviceMemory"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    281
                ],
                description: "Added attribute device.memory.estimated_capacity to be used instead of deviceMemory"
            }
        ]
    },
    "device.memory_size": {
        brief: "Total system memory available in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 17179869184,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.memory_size attribute"
            }
        ]
    },
    "device.model": {
        brief: "The model of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "iPhone 15 Pro Max",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116,
                    127
                ]
            }
        ]
    },
    "device.model_id": {
        brief: "An internal hardware revision to identify the device exactly.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "N861AP",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.model_id attribute"
            }
        ]
    },
    "device.name": {
        brief: "The name of the device. On mobile, this is the user-assigned device name. On servers and desktops, this is typically the hostname.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "localhost",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.name attribute"
            }
        ]
    },
    "device.online": {
        brief: "Whether the device was online or not.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.online attribute"
            }
        ]
    },
    "device.orientation": {
        brief: 'The orientation of the device, either "portrait" or "landscape".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "portrait",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.orientation attribute"
            }
        ]
    },
    "device.processor_count": {
        brief: 'Number of "logical processors".',
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 8,
        aliases: [
            "hardwareConcurrency"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added and deprecated attribute device.processor_count in favor of device.cpu.logical_core_count"
            }
        ]
    },
    "device.processor_frequency": {
        brief: "Processor frequency in MHz.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2400,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.processor_frequency attribute"
            }
        ]
    },
    "device.screen_density": {
        brief: "The screen density of the device.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2.625,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_density attribute"
            }
        ]
    },
    "device.screen_dpi": {
        brief: "The screen density in dots-per-inch (DPI) of the device.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 420,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_dpi attribute"
            }
        ]
    },
    "device.screen_height_pixels": {
        brief: "The height of the device screen in pixels.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2400,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_height_pixels attribute"
            }
        ]
    },
    "device.screen_width_pixels": {
        brief: "The width of the device screen in pixels.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1080,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_width_pixels attribute"
            }
        ]
    },
    "device.simulator": {
        brief: "Whether the device is a simulator or an actual device.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.simulator attribute"
            }
        ]
    },
    "device.storage_size": {
        brief: "Total device storage in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 274877906944,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.storage_size attribute"
            }
        ]
    },
    "device.thermal_state": {
        brief: "The thermal state of the device. Based on Apple's `ProcessInfo.ThermalState` enum: `nominal`, `fair`, `serious`, or `critical`.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "nominal",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.thermal_state attribute"
            }
        ]
    },
    "device.timezone": {
        brief: "The timezone of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Europe/Vienna",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.timezone attribute"
            }
        ]
    },
    "device.usable_memory": {
        brief: "Memory usable for the app in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2147483648,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.usable_memory attribute"
            }
        ]
    },
    dist: {
        brief: "The sentry dist.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0",
        deprecation: {
            replacement: "sentry.dist",
            reason: "This attribute is being deprecated in favor of sentry.dist."
        },
        aliases: [
            "sentry.dist"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    489
                ],
                description: "Added dist attribute"
            }
        ]
    },
    effectiveConnectionType: {
        brief: "Specifies the estimated effective type of the current connection (e.g. slow-2g, 2g, 3g, 4g).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "4g",
        deprecation: {
            replacement: "network.connection.effective_type",
            reason: "Old namespace-less attribute, to be replaced with network.connection.effective_type for span-first future"
        },
        aliases: [
            "network.connection.effective_type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    environment: {
        brief: "The sentry environment.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.environment"
        },
        aliases: [
            "sentry.environment"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "error.type": {
        brief: "Describes a class of error the operation ended with.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "timeout",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "event.id": {
        brief: "The unique identifier for this event (log record)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234567890,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    101
                ]
            }
        ]
    },
    "event.name": {
        brief: "The name that uniquely identifies this event (log record)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Process Payload",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    101,
                    127
                ]
            }
        ]
    },
    "exception.escaped": {
        brief: "SHOULD be set to true if the exception event is recorded at a point where it is known that the exception is escaping the scope of the span.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "exception.message": {
        brief: "The error message.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ENOENT: no such file or directory",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "exception.stacktrace": {
        brief: "A stacktrace as a string in the natural representation for the language runtime. The representation is to be determined and documented by each language SIG.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: `Exception in thread "main" java.lang.RuntimeException: Test exception
 at com.example.GenerateTrace.methodB(GenerateTrace.java:13)
 at com.example.GenerateTrace.methodA(GenerateTrace.java:9)
 at com.example.GenerateTrace.main(GenerateTrace.java:5)`,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "exception.type": {
        brief: "The type of the exception (its fully-qualified class name, if applicable). The dynamic type of the exception should be preferred over the static type in languages that support it.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "OSError",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.coldstart": {
        brief: "A boolean that is true if the serverless function is executed for the first time (aka cold-start).",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.cron": {
        brief: "A string containing the schedule period as Cron Expression.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "0/5 * * * ? *",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.duration_in_ms": {
        brief: "The duration a function took to run, in milliseconds.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 120,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403
                ]
            }
        ]
    },
    "faas.entry_point": {
        brief: "The code that's run when the cloud provider invokes your function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my_main_function",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403,
                    415
                ]
            }
        ]
    },
    "faas.execution": {
        brief: "The execution ID of the current function execution.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "af9d5aa4-a685-4c5f-a22b-444f80b3cc28",
        deprecation: {
            replacement: "faas.invocation_id",
            reason: "This attribute is being deprecated in favor of faas.invocation_id, which is the OTel-aligned replacement."
        },
        aliases: [
            "faas.invocation_id",
            "aws.lambda.aws_request_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    473
                ],
                description: "Added faas.execution attribute, deprecated in favor of faas.invocation_id"
            }
        ]
    },
    "faas.id": {
        brief: "The unique ID of the single function that this runtime instance executes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "arn:aws:lambda:REGION:ACCOUNT_ID:function:my-function",
        deprecation: {
            replacement: "cloud.resource_id",
            reason: "This attribute is being deprecated in favor of cloud.resource_id, which is the OTel-aligned replacement (renamed in OTel semantic conventions v1.19.0)."
        },
        aliases: [
            "cloud.resource_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    475
                ],
                description: "Added faas.id attribute, deprecated in favor of cloud.resource_id"
            }
        ]
    },
    "faas.identity": {
        brief: "The Service Account (GCP), IAM Execution Role (AWS), or Managed Identity (Azure) used by the serverless function when interacting with other cloud services",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "name@project.iam.gserviceaccount.com (GCP), arn:aws:iam::123456789012:role/role-name (AWS), 00000000-0000-0000-0000-000000000000 (Azure)",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403
                ]
            }
        ]
    },
    "faas.invocation_id": {
        brief: "The invocation ID of the current function invocation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "af9d5aa4-a685-4c5f-a22b-444f80b3cc28",
        aliases: [
            "aws.lambda.aws_request_id",
            "faas.execution"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    473
                ],
                description: "Added faas.execution as an alias"
            },
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ]
            }
        ]
    },
    "faas.invoked_name": {
        brief: "The name of the invoked function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "my-function",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    481
                ],
                description: "Added faas.invoked_name attribute"
            }
        ]
    },
    "faas.invoked_provider": {
        brief: "The cloud provider of the invoked function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    481
                ],
                description: "Added faas.invoked_provider attribute"
            }
        ]
    },
    "faas.invoked_region": {
        brief: "The cloud region of the invoked function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "eu-central-1",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    481
                ],
                description: "Added faas.invoked_region attribute"
            }
        ]
    },
    "faas.name": {
        brief: "The name of the serverless function",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "my_function",
        aliases: [
            "aws.lambda.function_name"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403,
                    415
                ]
            }
        ]
    },
    "faas.time": {
        brief: "A string containing the function invocation time in the ISO 8601 format expressed in UTC.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2020-01-23T13:47:06Z",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.trigger": {
        brief: "Type of the trigger which caused this function invocation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "timer",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.version": {
        brief: "The version of the function that was invoked",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "$LATEST",
        aliases: [
            "aws.lambda.function_version"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ]
            }
        ]
    },
    fcp: {
        brief: "The time it takes for the browser to render the first piece of meaningful content on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 547.6951,
        deprecation: {
            replacement: "browser.web_vital.fcp.value",
            reason: "This attribute is being deprecated in favor of browser.web_vital.fcp.value"
        },
        aliases: [
            "browser.web_vital.fcp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "flag.evaluation.<key>": {
        brief: "An instance of a feature flag evaluation. The value of this attribute is the boolean representing the evaluation result. The <key> suffix is the name of the feature flag.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "flag.evaluation.is_new_ui=true",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    fp: {
        brief: "The time it takes for the browser to render the first pixel on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 477.1926,
        deprecation: {
            replacement: "browser.web_vital.fp.value",
            reason: "This attribute is being deprecated in favor of browser.web_vital.fp.value"
        },
        aliases: [
            "browser.web_vital.fp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "frames.delay": {
        brief: "The sum of all delayed frame durations in seconds during the lifetime of the span. For more information see [frames delay](https://develop.sentry.dev/sdk/performance/frames-delay/).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5,
        deprecation: {
            replacement: "app.vitals.frames.delay.value",
            reason: "Replaced by app.vitals.frames.delay.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.delay.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.delay.value"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "frames.frozen": {
        brief: "The number of frozen frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        deprecation: {
            replacement: "app.vitals.frames.frozen.count",
            reason: "Replaced by app.vitals.frames.frozen.count to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.frozen.count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.frozen.count"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    frames_frozen_rate: {
        brief: "The rate of frozen frames, or `app_vitals.frames.frozen.count` divided by `app_vitals.frames.total.count`. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added frames_frozen_rate attribute"
            }
        ]
    },
    "frames.slow": {
        brief: "The number of slow frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        deprecation: {
            replacement: "app.vitals.frames.slow.count",
            reason: "Replaced by app.vitals.frames.slow.count to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.slow.count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.slow.count"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    frames_slow_rate: {
        brief: "The rate of slow frames, or `app_vitals.frames.slow.count` divided by `app_vitals.frames.total.count`. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added frames_slow_rate attribute"
            }
        ]
    },
    "frames.total": {
        brief: "The number of total frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 60,
        deprecation: {
            replacement: "app.vitals.frames.total.count",
            reason: "Replaced by app.vitals.frames.total.count to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.total.count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.total.count"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    fs_error: {
        brief: "The error message of a file system error.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "ENOENT: no such file or directory",
        deprecation: {
            replacement: "error.type",
            reason: "This attribute is not part of the OpenTelemetry specification and error.type fits much better."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "gcp.function.context.event_id": {
        brief: "The event ID from the legacy GCP Cloud Function context (1st gen)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.event_id attribute"
            }
        ]
    },
    "gcp.function.context.event_type": {
        brief: "The type of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "google.pubsub.topic.publish",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.event_type attribute"
            }
        ]
    },
    "gcp.function.context.id": {
        brief: "The unique event ID from the GCP CloudEvents context (2nd gen Cloud Functions)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.id attribute"
            }
        ]
    },
    "gcp.function.context.resource": {
        brief: "The resource that triggered the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "projects/my-project/topics/my-topic",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.resource attribute"
            }
        ]
    },
    "gcp.function.context.source": {
        brief: "The source of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "//pubsub.googleapis.com/projects/my-project/topics/my-topic",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.source attribute"
            }
        ]
    },
    "gcp.function.context.specversion": {
        brief: "The CloudEvents specification version of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.specversion attribute"
            }
        ]
    },
    "gcp.function.context.time": {
        brief: "The timestamp of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2024-01-01T00:00:00.000Z",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.time attribute"
            }
        ]
    },
    "gcp.function.context.timestamp": {
        brief: "The legacy timestamp of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2024-01-01T00:00:00.000Z",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.timestamp attribute"
            }
        ]
    },
    "gcp.function.context.type": {
        brief: "The type of the GCP Cloud Function event context",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "cloud_functions.context",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.type attribute"
            }
        ]
    },
    "gcp.project.id": {
        brief: "The ID of the project in GCP that this resource is associated with",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-project-123",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403
                ]
            }
        ]
    },
    "gen_ai.agent.name": {
        brief: "The name of the agent being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ResearchAssistant",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.context.utilization": {
        brief: "The fraction of the model context window utilized by this generation.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .75,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    315
                ],
                description: "Added gen_ai.context.utilization attribute"
            }
        ]
    },
    "gen_ai.context.window_size": {
        brief: "The maximum context window size supported by the model for this generation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 128e3,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    315
                ],
                description: "Added gen_ai.context.window_size attribute"
            }
        ]
    },
    "gen_ai.conversation.id": {
        brief: "The unique identifier for a conversation (session, thread), used to store and correlate messages within this conversation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "conv_5j66UpCpwteGg4YSxUnt7lPY",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    250
                ]
            }
        ]
    },
    "gen_ai.cost.cache_creation.input_tokens": {
        brief: "The cost of input tokens written to cache in USD.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        changelog: [
            {
                version: "0.16.0",
                description: "Added gen_ai.cost.cache_creation.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.cache_creation.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.cache_creation.input_tokens.",
            "This is a subset of gen_ai.cost.input_tokens, not an independent cost. Do not sum this with gen_ai.cost.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.cost.cache_read.input_tokens": {
        brief: "The cost of cached input tokens in USD.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        changelog: [
            {
                version: "0.16.0",
                description: "Added gen_ai.cost.cache_read.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.cache_read.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.cache_read.input_tokens.",
            "This is a subset of gen_ai.cost.input_tokens, not an independent cost. Do not sum this with gen_ai.cost.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.cost.input_tokens": {
        brief: "The total cost of all input tokens in USD (includes cached and cache creation tokens).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 123.45,
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.input_tokens.",
            "This is the total cost of all input tokens, including cached and cache creation tokens at their respective rates. For the cached portion, see gen_ai.cost.cache_read.input_tokens. For the cache creation portion, see gen_ai.cost.cache_creation.input_tokens."
        ]
    },
    "gen_ai.cost.output_tokens": {
        brief: "The total cost of all output tokens in USD (includes reasoning tokens).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 123.45,
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.output_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.output_tokens.",
            "This is the total cost of all output tokens, including reasoning tokens at their respective rate. For the reasoning portion, see gen_ai.cost.reasoning.output_tokens."
        ]
    },
    "gen_ai.cost.reasoning.output_tokens": {
        brief: "The cost of reasoning output tokens in USD.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        changelog: [
            {
                version: "0.16.0",
                description: "Added gen_ai.cost.reasoning.output_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.reasoning.output_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.reasoning.output_tokens.",
            "This is a subset of gen_ai.cost.output_tokens, not an independent cost. Do not sum this with gen_ai.cost.output_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.cost.total_tokens": {
        brief: "The total cost for the tokens used.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        aliases: [
            "ai.total_cost"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    126
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.total_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.total_tokens."
        ]
    },
    "gen_ai.embeddings.input": {
        brief: "The input to the embeddings model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "What's the weather in Paris?",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    195
                ]
            }
        ]
    },
    "gen_ai.function_id": {
        brief: "Framework-specific tracing label for the execution of a function or other unit of execution in a generative AI system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-awesome-function",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    308
                ],
                description: "Added gen_ai.function_id attribute"
            }
        ]
    },
    "gen_ai.input.messages": {
        brief: 'The messages passed to the model. It has to be a stringified version of an array of objects. The `role` attribute of each object must be `"user"`, `"assistant"`, `"tool"`, or `"system"`. For messages of the role `"tool"`, the `content` can be a string or an arbitrary object with information about the tool call. For other messages the `content` can be either a string or a list of objects in the format `{type: "text", text:"..."}`.',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"role": "user", "parts": [{"type": "text", "content": "Weather in Paris?"}]}, {"role": "assistant", "parts": [{"type": "tool_call", "id": "call_VSPygqKTWdrhaFErNvMV18Yl", "name": "get_weather", "arguments": {"location": "Paris"}}]}, {"role": "tool", "parts": [{"type": "tool_call_response", "id": "call_VSPygqKTWdrhaFErNvMV18Yl", "result": "rainy, 57\xB0F"}]}]',
        aliases: [
            "ai.texts"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.operation.name": {
        brief: "The name of the operation being performed. It has the following list of well-known values: 'chat', 'create_agent', 'embeddings', 'execute_tool', 'generate_content', 'invoke_agent', 'text_completion'. If one of them applies, then that value MUST be used. Otherwise a custom value MAY be used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "chat",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    225
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.operation.type": {
        brief: "The type of AI operation. Must be one of 'agent' (invoke_agent and create_agent spans), 'ai_client' (any LLM call), 'tool' (execute_tool spans), 'handoff' (handoff spans), 'other' (input and output processors, skill loading, guardrails etc.) . Added during ingestion based on span.op and gen_ai.operation.type. Used to filter and aggregate data in the UI",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "tool",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    257
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    113,
                    127
                ]
            }
        ]
    },
    "gen_ai.output.messages": {
        brief: "The model's response messages. It has to be a stringified version of an array of message objects, which can include text responses and tool calls.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"role": "assistant", "parts": [{"type": "text", "content": "The weather in Paris is currently rainy with a temperature of 57\xB0F."}], "finish_reason": "stop"}]',
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.pipeline.name": {
        brief: "Name of the AI pipeline or chain being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Autofix Pipeline",
        aliases: [
            "ai.pipeline.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    76,
                    127
                ]
            }
        ]
    },
    "gen_ai.prompt": {
        brief: "The input messages sent to the model",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        deprecation: {
            reason: "Deprecated from OTEL, use gen_ai.input.messages with the new format instead."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    74,
                    108,
                    119
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "gen_ai.prompt.name": {
        brief: "The name of the prompt that uniquely identifies it.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Prompt names may reveal user behavior patterns or sensitive operations"
        },
        isInOtel: !0,
        visibility: "public",
        example: "summarize_text",
        aliases: [
            "mcp.prompt.name"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Added gen_ai.prompt.name attribute"
            }
        ]
    },
    "gen_ai.provider.name": {
        brief: "The Generative AI provider as identified by the client or server instrumentation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "openai",
        aliases: [
            "ai.model.provider",
            "gen_ai.system"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    253
                ]
            }
        ]
    },
    "gen_ai.request.available_tools": {
        brief: "The available tools for the model. It has to be a stringified version of an array of objects.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"name": "get_weather", "description": "Get the weather for a given location"}, {"name": "get_news", "description": "Get the news for a given topic"}]',
        deprecation: {
            replacement: "gen_ai.tool.definitions"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    127
                ]
            }
        ]
    },
    "gen_ai.request.frequency_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. The higher the value, the stronger a penalty is applied to previously present tokens, proportional to how many times they have already appeared in the prompt or prior generation.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .5,
        aliases: [
            "ai.frequency_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.max_tokens": {
        brief: "The maximum number of tokens to generate in the response.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 2048,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62
                ]
            }
        ]
    },
    "gen_ai.request.messages": {
        brief: 'The messages passed to the model. It has to be a stringified version of an array of objects. The `role` attribute of each object must be `"user"`, `"assistant"`, `"tool"`, or `"system"`. For messages of the role `"tool"`, the `content` can be a string or an arbitrary object with information about the tool call. For other messages the `content` can be either a string or a list of objects in the format `{type: "text", text:"..."}`.',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "system", "content": "Generate a random number."}, {"role": "user", "content": [{"text": "Generate a random number between 0 and 10.", "type": "text"}]}, {"role": "tool", "content": {"toolCallId": "1", "toolName": "Weather", "output": "rainy"}}]',
        deprecation: {
            replacement: "gen_ai.input.messages"
        },
        aliases: [
            "ai.input_messages"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74,
                    108,
                    119,
                    122
                ]
            }
        ]
    },
    "gen_ai.request.model": {
        brief: "The model identifier being used for the request.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "gpt-4-turbo-preview",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.request.presence_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. Similar to frequency_penalty, except that this penalty is applied equally to all tokens that have already appeared, regardless of their exact frequencies.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .5,
        aliases: [
            "ai.presence_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.reasoning_effort": {
        brief: "Constrains the effort on reasoning for reasoning models. Supported values vary by provider.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "high",
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    334
                ],
                description: "Added gen_ai.request.reasoning_effort attribute"
            }
        ]
    },
    "gen_ai.request.seed": {
        brief: "The seed, ideally models given the same seed and same other parameters will produce the exact same output.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1234567890",
        aliases: [
            "ai.seed"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.request.stop_sequences": {
        brief: "List of sequences that the model will use to stop generating further tokens.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "forest",
            "lived"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added gen_ai.request.stop_sequences attribute"
            }
        ]
    },
    "gen_ai.request.temperature": {
        brief: "For an AI model call, the temperature parameter. Temperature essentially means how random the output will be.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .1,
        aliases: [
            "ai.temperature"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.top_k": {
        brief: "Limits the model to only consider the K most likely next tokens, where K is an integer (e.g., top_k=20 means only the 20 highest probability tokens are considered).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 35,
        aliases: [
            "ai.top_k"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.top_p": {
        brief: "Limits the model to only consider tokens whose cumulative probability mass adds up to p, where p is a float between 0 and 1 (e.g., top_p=0.7 means only tokens that sum up to 70% of the probability mass are considered).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .7,
        aliases: [
            "ai.top_p"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.response.finish_reasons": {
        brief: "The reason why the model stopped generating.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "COMPLETE",
        aliases: [
            "ai.finish_reason"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.response.id": {
        brief: "Unique identifier for the completion.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "gen_123abc",
        aliases: [
            "ai.generation_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.response.model": {
        brief: "The vendor-specific ID of the model used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "gpt-4",
        aliases: [
            "ai.model_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "gen_ai.response.streaming": {
        brief: "Whether or not the AI model call's response was streamed back asynchronously",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        aliases: [
            "ai.streaming"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    76
                ]
            }
        ]
    },
    "gen_ai.response.text": {
        brief: "The model's response text messages. It has to be a stringified version of an array of response text messages.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '["The weather in Paris is rainy and overcast, with temperatures around 57\xB0F", "The weather in London is sunny and warm, with temperatures around 65\xB0F"]',
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.response.time_to_first_chunk": {
        brief: "Time in seconds when the first response content chunk arrived in streaming responses.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .6853435,
        aliases: [
            "gen_ai.response.time_to_first_token"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.response.time_to_first_chunk attribute"
            }
        ]
    },
    "gen_ai.response.time_to_first_token": {
        brief: "Time in seconds when the first response content chunk arrived in streaming responses.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .6853435,
        deprecation: {
            replacement: "gen_ai.response.time_to_first_chunk"
        },
        aliases: [
            "gen_ai.response.time_to_first_chunk"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.response.time_to_first_chunk"
            },
            {
                version: "0.4.0",
                prs: [
                    227
                ]
            }
        ]
    },
    "gen_ai.response.tokens_per_second": {
        brief: "The total output tokens per seconds throughput",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12345.67,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    66
                ]
            }
        ]
    },
    "gen_ai.response.tool_calls": {
        brief: "The tool calls in the model's response. It has to be a stringified version of an array of objects.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"name": "get_weather", "arguments": {"location": "Paris"}}]',
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.system": {
        brief: "The provider of the model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "openai",
        deprecation: {
            replacement: "gen_ai.provider.name"
        },
        aliases: [
            "ai.model.provider",
            "gen_ai.provider.name"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    253
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.system_instructions": {
        brief: "The system instructions passed to the model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "You are a helpful assistant",
        aliases: [
            "ai.preamble"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.system.message": {
        brief: "The system instructions passed to the model.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "You are a helpful assistant",
        deprecation: {
            replacement: "gen_ai.system_instructions"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62
                ]
            }
        ]
    },
    "gen_ai.tool.call.arguments": {
        brief: "The arguments of the tool call. It has to be a stringified version of the arguments to the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '{"location": "Paris"}',
        aliases: [
            "gen_ai.tool.input"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.tool.call.result": {
        brief: "The result of the tool call. It has to be a stringified version of the result of the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "rainy, 57\xB0F",
        aliases: [
            "gen_ai.tool.output",
            "gen_ai.tool.message",
            "mcp.tool.result.content"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.tool.definitions": {
        brief: "The list of source system tool definitions available to the GenAI agent or model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"type": "function", "name": "get_current_weather", "description": "Get the current weather in a given location", "parameters": {"type": "object", "properties": {"location": {"type": "string", "description": "The city and state, e.g. San Francisco, CA"}, "unit": {"type": "string", "enum": ["celsius", "fahrenheit"]}}, "required": ["location", "unit"]}}]',
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.tool.description": {
        brief: "The description of the tool being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Searches the web for current information about a topic",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.tool.input": {
        brief: "The input of the tool being used. It has to be a stringified version of the input to the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"location": "Paris"}',
        deprecation: {
            replacement: "gen_ai.tool.call.arguments"
        },
        aliases: [
            "gen_ai.tool.call.arguments"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.tool.message": {
        brief: "The response from a tool or function call passed to the model.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rainy, 57\xB0F",
        deprecation: {
            replacement: "gen_ai.tool.call.result"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.output",
            "mcp.tool.result.content"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62
                ]
            }
        ]
    },
    "gen_ai.tool.name": {
        brief: "Name of the tool utilized by the agent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Flights",
        aliases: [
            "ai.function_call",
            "mcp.tool.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.tool.output": {
        brief: "The output of the tool being used. It has to be a stringified version of the output of the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rainy, 57\xB0F",
        deprecation: {
            replacement: "gen_ai.tool.call.result"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.message",
            "mcp.tool.result.content"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.tool.type": {
        brief: "The type of tool being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "function",
        deprecation: {
            reason: "The gen_ai.tool.type attribute is deprecated and should no longer be set."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.usage.cache_creation.input_tokens": {
        brief: "The number of tokens written to the cache when processing the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 100,
        aliases: [
            "gen_ai.usage.input_tokens.cache_write"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.usage.cache_creation.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.cache_read.input_tokens": {
        brief: "The number of cached tokens used to process the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 50,
        aliases: [
            "gen_ai.usage.input_tokens.cached"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.usage.cache_read.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.input_tokens, not an independent count. Do not sum this with gen_ai.usage.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.completion_tokens": {
        brief: "The number of tokens used in the GenAI response (completion).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        deprecation: {
            replacement: "gen_ai.usage.output_tokens"
        },
        aliases: [
            "ai.completion_tokens.used",
            "gen_ai.usage.output_tokens"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.input_tokens": {
        brief: "The number of tokens used to process the AI input (prompt) including cached input tokens.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        aliases: [
            "ai.prompt_tokens.used",
            "gen_ai.usage.prompt_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Update additional_context to reference gen_ai.usage.cache_read.input_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.5.0",
                prs: [
                    261
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This count includes cached input tokens. gen_ai.usage.cache_read.input_tokens is a subset of this value, not an independent count \u2014 do not sum them together."
        ]
    },
    "gen_ai.usage.input_tokens.cached": {
        brief: "The number of cached tokens used to process the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        deprecation: {
            replacement: "gen_ai.usage.cache_read.input_tokens"
        },
        aliases: [
            "gen_ai.usage.cache_read.input_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.usage.cache_read.input_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.input_tokens, not an independent count. Do not sum this with gen_ai.usage.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.input_tokens.cache_write": {
        brief: "The number of tokens written to the cache when processing the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        deprecation: {
            replacement: "gen_ai.usage.cache_creation.input_tokens"
        },
        aliases: [
            "gen_ai.usage.cache_creation.input_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.usage.cache_creation.input_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    217,
                    228
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.output_tokens": {
        brief: "The number of tokens used for creating the AI output (including reasoning tokens).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        aliases: [
            "ai.completion_tokens.used",
            "gen_ai.usage.completion_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Update additional_context to reference gen_ai.usage.reasoning.output_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.5.0",
                prs: [
                    261
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This count includes reasoning tokens. gen_ai.usage.reasoning.output_tokens is a subset of this value, not an independent count \u2014 do not sum them together."
        ]
    },
    "gen_ai.usage.output_tokens.reasoning": {
        brief: "The number of tokens used for reasoning to create the AI output.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 75,
        deprecation: {
            replacement: "gen_ai.usage.reasoning.output_tokens"
        },
        aliases: [
            "gen_ai.usage.reasoning.output_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.usage.reasoning.output_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.output_tokens, not an independent count. Do not sum this with gen_ai.usage.output_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.prompt_tokens": {
        brief: "The number of tokens used in the GenAI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 20,
        deprecation: {
            replacement: "gen_ai.usage.input_tokens"
        },
        aliases: [
            "ai.prompt_tokens.used",
            "gen_ai.usage.input_tokens"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.reasoning.output_tokens": {
        brief: "The number of tokens used for reasoning to create the AI output.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 75,
        aliases: [
            "gen_ai.usage.output_tokens.reasoning"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.usage.reasoning.output_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.output_tokens, not an independent count. Do not sum this with gen_ai.usage.output_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.total_tokens": {
        brief: "The total number of tokens used to process the prompt. (input tokens plus output todkens)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 20,
        aliases: [
            "ai.total_tokens.used"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is the sum of gen_ai.usage.input_tokens and gen_ai.usage.output_tokens. Do not sum this with either of them \u2014 they are already included."
        ]
    },
    "graphql.document": {
        brief: "The GraphQL document being executed.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "The document may contain sensitive information in arguments or variables. Instrumentation should redact sensitive information when possible."
        },
        isInOtel: !0,
        visibility: "public",
        example: "query findBookById { bookById(id: ?) { name } }",
        changelog: [
            {
                version: "0.7.0",
                description: "Adds the `graphql.document` attribute to track the GraphQL document being executed."
            }
        ]
    },
    "graphql.operation.name": {
        brief: "The name of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "findBookById",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "graphql.operation.type": {
        brief: "The type of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "query",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    hardwareConcurrency: {
        brief: "The number of logical CPU cores available.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "14",
        deprecation: {
            replacement: "device.processor_count",
            reason: "Old namespace-less attribute, to be replaced with device.processor_count for span-first future"
        },
        aliases: [
            "device.processor_count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    281,
                    300
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "http.client_ip": {
        brief: "Client address - domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "client.address"
        },
        aliases: [
            "client.address"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    106,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.decoded_response_content_length": {
        brief: "The decoded body size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 456,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.flavor": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1.1",
        deprecation: {
            replacement: "network.protocol.version"
        },
        aliases: [
            "network.protocol.version",
            "net.protocol.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.fragment": {
        brief: "The fragments present in the URI. Note that this contains the leading # character, while the `url.fragment` attribute does not.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "#details",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "http.host": {
        brief: "The domain name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            reason: "Deprecated, use one of `server.address` or `client.address`, depending on the usage"
        },
        aliases: [
            "server.address",
            "client.address",
            "http.server_name",
            "net.host.name",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.method": {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "GET",
        deprecation: {
            replacement: "http.request.method"
        },
        aliases: [
            "http.request.method",
            "http.request_method",
            "method"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.query": {
        brief: "The query string present in the URL. Note that this contains the leading ? character, while the `url.query` attribute does not.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Query string values can contain sensitive information. Clients should attempt to scrub parameters that might contain sensitive information."
        },
        isInOtel: !1,
        visibility: "public",
        example: "?foo=bar&bar=baz",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.body.data": {
        brief: "HTTP request body data. Can be given as string or structural data of any format.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    336
                ],
                description: "Added http.request.body.data attribute"
            }
        ]
    },
    "http.request.connection_end": {
        brief: "The UNIX timestamp representing the time immediately after the browser finishes establishing the connection to the server to retrieve the resource. The timestamp value includes the time interval to establish the transport connection, as well as other time intervals such as TLS handshake and SOCKS authentication.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955515e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.connect_start": {
        brief: "The UNIX timestamp representing the time immediately before the user agent starts establishing the connection to the server to retrieve the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555111e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.domain_lookup_end": {
        brief: "The UNIX timestamp representing the time immediately after the browser finishes the domain-name lookup for the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555201e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.domain_lookup_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts the domain name lookup for the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555322e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.fetch_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts to fetch the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555389e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.header.<key>": {
        brief: "HTTP request headers, <key> being the normalized HTTP Header name (lowercase), the value being the header values.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "http.request.header.custom-header=['foo', 'bar']",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    201,
                    204
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "http.request.method": {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "GET",
        aliases: [
            "method",
            "http.method",
            "http.request_method"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request_method": {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET",
        deprecation: {
            replacement: "http.request.method"
        },
        aliases: [
            "method",
            "http.method",
            "http.request.method"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    343
                ],
                description: "Added http.request_method attribute"
            }
        ]
    },
    "http.request.redirect_end": {
        brief: "The UNIX timestamp representing the timestamp immediately after receiving the last byte of the response of the last redirect",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829558502e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    130,
                    134
                ]
            }
        ]
    },
    "http.request.redirect_start": {
        brief: "The UNIX timestamp representing the start time of the fetch which that initiates the redirect.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555495e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.request_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts requesting the resource from the server, cache, or local resource. If the transport connection fails and the browser retires the request, the value returned will be the start of the retry request.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955551e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.resend_count": {
        brief: "The ordinal number of request resending attempt (for any reason, including redirects).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.response_end": {
        brief: "The UNIX timestamp representing the time immediately after the browser receives the last byte of the resource or immediately before the transport connection is closed, whichever comes first.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955589e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.response_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts requesting the resource from the server, cache, or local resource. If the transport connection fails and the browser retires the request, the value returned will be the start of the retry request.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 17328295557e-1,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.same_origin": {
        brief: "Indicates that a URL has the same origin as the current page's origin in the browser.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        aliases: [
            "url.same_origin"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    456
                ],
                description: "Added http.request.same_origin attribute"
            }
        ]
    },
    "http.request.secure_connection_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts the handshake process to secure the current connection. If a secure connection is not used, the property returns zero.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955573e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.time_to_first_byte": {
        brief: "The time in seconds from the browser's timeorigin to when the first byte of the request's response was received. See https://web.dev/articles/ttfb#measure-resource-requests",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1.032,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    131
                ]
            }
        ]
    },
    "http.request.worker_start": {
        brief: "The UNIX timestamp representing the timestamp immediately before dispatching the FetchEvent if a Service Worker thread is already running, or immediately before starting the Service Worker thread if it is not already running.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955368e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    130,
                    134
                ]
            }
        ]
    },
    "http.response.body.size": {
        brief: "The encoded body size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 123,
        aliases: [
            "http.response_content_length",
            "http.response.header.content-length"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    106
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response_content_length": {
        brief: "The encoded body size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 123,
        deprecation: {
            replacement: "http.response.body.size"
        },
        aliases: [
            "http.response.body.size",
            "http.response.header.content-length"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    106
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response.header.content-length": {
        brief: "The size of the message body sent to the recipient (in bytes)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http.response.header.custom-header=['foo', 'bar']",
        aliases: [
            "http.response_content_length",
            "http.response.body.size"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response.header.<key>": {
        brief: "HTTP response headers, <key> being the normalized HTTP Header name (lowercase), the value being the header values.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "http.response.header.custom-header=['foo', 'bar']",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    201,
                    204
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "http.response.size": {
        brief: "The transfer size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 456,
        aliases: [
            "http.response_transfer_size"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response.status_code": {
        brief: "The status code of the HTTP response.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 404,
        aliases: [
            "http.status_code"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response_transfer_size": {
        brief: "The transfer size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 456,
        deprecation: {
            replacement: "http.response.size"
        },
        aliases: [
            "http.response.size"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.route": {
        brief: "The matched route, that is, the path template in the format used by the respective server framework.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/users/:id",
        aliases: [
            "url.template"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.scheme": {
        brief: "The URI scheme component identifying the used protocol.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https",
        deprecation: {
            replacement: "url.scheme"
        },
        aliases: [
            "url.scheme"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.server_name": {
        brief: "The server domain name",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address"
        },
        aliases: [
            "server.address",
            "net.host.name",
            "http.host",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.server.request.time_in_queue": {
        brief: "The time in milliseconds the request spent in the server queue before processing began. Measured from the X-Request-Start header set by reverse proxies (e.g., Nginx, HAProxy, Heroku) to when the application started handling the request.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    267
                ]
            }
        ]
    },
    "http.status_code": {
        brief: "The status code of the HTTP response.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 404,
        deprecation: {
            replacement: "http.response.status_code"
        },
        aliases: [
            "http.response.status_code"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.target": {
        brief: "The pathname and query string of the URL.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/test?foo=bar#buzz",
        deprecation: {
            replacement: "url.path",
            reason: "This attribute is being deprecated in favor of url.path and url.query"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.url": {
        brief: "The URL of the resource that was fetched.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https://example.com/test?foo=bar#buzz",
        deprecation: {
            replacement: "url.full"
        },
        aliases: [
            "url.full",
            "url"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.user_agent": {
        brief: "Value of the HTTP User-Agent header sent by the client.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Mozilla/5.0 (iPhone; CPU iPhone OS 14_7_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.2 Mobile/15E148 Safari/604.1",
        deprecation: {
            replacement: "user_agent.original"
        },
        aliases: [
            "user_agent.original"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    id: {
        brief: "A unique identifier for the span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "f47ac10b58cc4372a5670e02b2c3d479",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    inp: {
        brief: "The value of the recorded Interaction to Next Paint (INP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        deprecation: {
            replacement: "browser.web_vital.inp.value",
            reason: "The INP web vital is now recorded as a browser.web_vital.inp.value attribute."
        },
        aliases: [
            "browser.web_vital.inp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "jsonrpc.protocol.version": {
        brief: "The version of the JSON-RPC protocol used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2.0",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Added jsonrpc.protocol.version attribute"
            }
        ]
    },
    "jsonrpc.request.id": {
        brief: "The JSON-RPC request identifier. Unique within the session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1",
        aliases: [
            "mcp.request.id"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Added jsonrpc.request.id attribute"
            }
        ]
    },
    "jvm.gc.action": {
        brief: "Name of the garbage collector action.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "end of minor GC",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.gc.name": {
        brief: "Name of the garbage collector.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "G1 Young Generation",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.memory.pool.name": {
        brief: "Name of the memory pool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "G1 Old Gen",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.memory.type": {
        brief: "Name of the memory pool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "G1 Old Gen",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.thread.daemon": {
        brief: "Whether the thread is daemon or not.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.thread.state": {
        brief: "State of the thread.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "blocked",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "koa.name": {
        brief: "The name of the Koa middleware or matched route that handled the request.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        deprecation: {
            reason: "No single replacement. SDKs should use http.route for router layers and code.function.name for middleware layers instead."
        },
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    490
                ],
                description: "Added koa.name attribute as deprecated"
            }
        ]
    },
    "koa.type": {
        brief: "The type of the Koa layer that handled the request.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "router",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    471
                ],
                description: "Added koa.type attribute"
            }
        ]
    },
    lcp: {
        brief: "The value of the recorded Largest Contentful Paint (LCP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2500,
        deprecation: {
            replacement: "browser.web_vital.lcp.value",
            reason: "The LCP web vital is now recorded as a browser.web_vital.lcp.value attribute."
        },
        aliases: [
            "browser.web_vital.lcp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "lcp.element": {
        brief: "The dom element responsible for the largest contentful paint.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "img",
        deprecation: {
            replacement: "browser.web_vital.lcp.element",
            reason: "The LCP element is now recorded as a browser.web_vital.lcp.element attribute."
        },
        aliases: [
            "browser.web_vital.lcp.element"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "lcp.id": {
        brief: "The id of the dom element responsible for the largest contentful paint.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "#hero",
        deprecation: {
            replacement: "browser.web_vital.lcp.id",
            reason: "The LCP id is now recorded as a browser.web_vital.lcp.id attribute."
        },
        aliases: [
            "browser.web_vital.lcp.id"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "lcp.loadTime": {
        brief: "The time it took for the LCP element to be loaded",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1402,
        deprecation: {
            replacement: "browser.web_vital.lcp.load_time",
            reason: "The LCP load time is now recorded as a browser.web_vital.lcp.load_time attribute."
        },
        aliases: [
            "browser.web_vital.lcp.load_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "lcp.renderTime": {
        brief: "The time it took for the LCP element to be rendered",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1685,
        deprecation: {
            replacement: "browser.web_vital.lcp.render_time",
            reason: "The LCP render time is now recorded as a browser.web_vital.lcp.render_time attribute."
        },
        aliases: [
            "browser.web_vital.lcp.render_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "lcp.size": {
        brief: "The size of the largest contentful paint element.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234,
        deprecation: {
            replacement: "browser.web_vital.lcp.size",
            reason: "The LCP size is now recorded as a browser.web_vital.lcp.size attribute."
        },
        aliases: [
            "browser.web_vital.lcp.size"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "lcp.url": {
        brief: "The url of the dom element responsible for the largest contentful paint.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com",
        deprecation: {
            replacement: "browser.web_vital.lcp.url",
            reason: "The LCP url is now recorded as a browser.web_vital.lcp.url attribute."
        },
        aliases: [
            "browser.web_vital.lcp.url"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "logger.name": {
        brief: "The name of the logger that generated this event.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "myLogger",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "mcp.cancelled.reason": {
        brief: "Reason for the cancellation of an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Cancellation reasons may contain user-specific or sensitive information"
        },
        isInOtel: !1,
        visibility: "public",
        example: "User cancelled the request",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.cancelled.request_id": {
        brief: "Request ID of the cancelled MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.client.name": {
        brief: "Name of the MCP client application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "claude-desktop",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.client.title": {
        brief: "Display title of the MCP client application.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Client titles may reveal user-specific application configurations or custom setups"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Claude Desktop",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.client.version": {
        brief: "Version of the MCP client application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0.0",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.lifecycle.phase": {
        brief: "Lifecycle phase indicator for MCP operations.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "initialization_complete",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.data_type": {
        brief: "Data type of the logged message content.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "string",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.level": {
        brief: "Log level for MCP logging operations.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "info",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.logger": {
        brief: "Logger name for MCP logging operations.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Logger names may be user-defined and could contain sensitive information"
        },
        isInOtel: !1,
        visibility: "public",
        example: "mcp_server",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.message": {
        brief: "Log message content from MCP logging operations.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Log messages can contain user data"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Tool execution completed successfully",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.method.name": {
        brief: "The name of the MCP request or notification method being called.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "tools/call",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.current": {
        brief: "Current progress value of an MCP operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.message": {
        brief: "Progress message describing the current state of an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Progress messages may contain user-specific or sensitive information"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Processing 50 of 100 items",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.percentage": {
        brief: "Calculated progress percentage of an MCP operation. Computed from current/total * 100.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.token": {
        brief: "Token for tracking progress of an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "progress-token-123",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.total": {
        brief: "Total progress target value of an MCP operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.name": {
        brief: "Name of the MCP prompt template being used.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Prompt names may reveal user behavior patterns or sensitive operations"
        },
        isInOtel: !1,
        visibility: "public",
        example: "summarize",
        deprecation: {
            replacement: "gen_ai.prompt.name",
            reason: "OTel uses gen_ai.prompt.name for MCP prompt names"
        },
        aliases: [
            "gen_ai.prompt.name"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of gen_ai.prompt.name"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.description": {
        brief: "Description of the prompt result.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "A summary of the requested information",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.message_content": {
        brief: "Content of the message in the prompt result. Used for single message results only.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Please provide a summary of the document",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.message_count": {
        brief: "Number of messages in the prompt result.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.message_role": {
        brief: "Role of the message in the prompt result. Used for single message results only.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.protocol.ready": {
        brief: "Protocol readiness indicator for MCP session. Non-zero value indicates the protocol is ready.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.protocol.version": {
        brief: "MCP protocol version used in the session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2024-11-05",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.request.argument.<key>": {
        brief: "MCP request argument with dynamic key suffix. The <key> is replaced with the actual argument name. The value is a JSON-stringified representation of the argument value.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Arguments contain user input"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "mcp.request.argument.query='weather in Paris'",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    176
                ]
            }
        ]
    },
    "mcp.request.argument.name": {
        brief: "Name argument from prompts/get MCP request.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Prompt names can contain user input"
        },
        isInOtel: !1,
        visibility: "public",
        example: "summarize",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.request.argument.uri": {
        brief: "URI argument from resources/read MCP request.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "URIs can contain user file paths"
        },
        isInOtel: !1,
        visibility: "public",
        example: "file:///path/to/resource",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.request.id": {
        brief: "JSON-RPC request identifier for the MCP request. Unique within the MCP session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1",
        deprecation: {
            replacement: "jsonrpc.request.id",
            reason: "OTel models MCP as JSON-RPC, uses jsonrpc.request.id"
        },
        aliases: [
            "jsonrpc.request.id"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of jsonrpc.request.id"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.resource.protocol": {
        brief: "Protocol of the resource URI being accessed, extracted from the URI.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "file",
        deprecation: {
            replacement: "network.protocol.name",
            reason: "OTel uses the generic network.protocol.name attribute"
        },
        aliases: [
            "network.protocol.name",
            "net.protocol.name"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of network.protocol.name"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.resource.uri": {
        brief: "The resource URI being accessed in an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "URIs can contain sensitive file paths"
        },
        isInOtel: !0,
        visibility: "public",
        example: "file:///path/to/file.txt",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.server.name": {
        brief: "Name of the MCP server application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sentry-mcp-server",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.server.title": {
        brief: "Display title of the MCP server application.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Server titles may reveal user-specific application configurations or custom setups"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Sentry MCP Server",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.server.version": {
        brief: "Version of the MCP server application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "0.1.0",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.session.id": {
        brief: "Identifier for the MCP session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "550e8400-e29b-41d4-a716-446655440000",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.tool.name": {
        brief: "Name of the MCP tool being called.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "calculator",
        deprecation: {
            replacement: "gen_ai.tool.name",
            reason: "OTel uses gen_ai.tool.name for MCP tool names"
        },
        aliases: [
            "gen_ai.tool.name",
            "ai.function_call"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of gen_ai.tool.name"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.tool.result.content": {
        brief: "The content of the tool result.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Tool results can contain user data"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"output": "rainy", "toolCallId": "1"}',
        deprecation: {
            replacement: "gen_ai.tool.call.result",
            reason: "OTel uses gen_ai.tool.call.result for MCP tool results"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.message",
            "gen_ai.tool.output"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of gen_ai.tool.call.result"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    164
                ]
            }
        ]
    },
    "mcp.tool.result.content_count": {
        brief: "Number of content items in the tool result.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.tool.result.is_error": {
        brief: "Whether a tool execution resulted in an error.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        deprecation: {
            replacement: "error.type",
            reason: "OTel uses error.type set to 'tool_error' when isError is true. Cannot be automatically backfilled due to type mismatch (boolean vs string)."
        },
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of error.type"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.transport": {
        brief: "Transport method used for MCP communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stdio",
        deprecation: {
            replacement: "network.transport",
            reason: "OTel uses the generic network.transport attribute"
        },
        aliases: [
            "network.transport",
            "net.transport"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of network.transport"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mdc.<key>": {
        brief: "Attributes from the Mapped Diagnostic Context (MDC) present at the moment the log record was created. The MDC is supported by all the most popular logging solutions in the Java ecosystem, and it's usually implemented as a thread-local map that stores context for e.g. a specific request.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "mdc.some_key='some_value'",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    176
                ]
            }
        ]
    },
    "messaging.batch.message_count": {
        brief: "The number of messages sent, received, or processed in the scope of the batching operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    341
                ],
                description: "Added messaging.batch.message_count attribute"
            }
        ]
    },
    "messaging.destination": {
        brief: "The message destination name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "BestTopic",
        deprecation: {
            replacement: "messaging.destination.name",
            reason: "This attribute is being deprecated in favor of messaging.destination.name, which is the OTel-aligned replacement."
        },
        aliases: [
            "messaging.destination.name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added messaging.destination attribute, deprecated in favor of messaging.destination.name"
            }
        ]
    },
    "messaging.destination.connection": {
        brief: "The message destination connection.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "BestTopic",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.destination.name": {
        brief: "The message destination name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "BestTopic",
        aliases: [
            "messaging.destination"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added messaging.destination as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.body.size": {
        brief: "The size of the message body in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 839,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.conversation_id": {
        brief: 'The conversation ID identifying the conversation to which the message belongs, represented as a string. Sometimes called "Correlation ID".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "MyConversationId",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    468
                ],
                description: "Added messaging.message.conversation_id attribute"
            }
        ]
    },
    "messaging.message.envelope.size": {
        brief: "The size of the message body and metadata in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1045,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.id": {
        brief: "A value used by the messaging system as an identifier for the message, represented as a string.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "f47ac10b58cc4372a5670e02b2c3d479",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.receive.latency": {
        brief: "The latency between when the message was published and received.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732847252,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.retry.count": {
        brief: "The amount of attempts to send the message.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.operation.name": {
        brief: "The name of the messaging operation being performed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "send",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added messaging.operation.name attribute"
            }
        ]
    },
    "messaging.operation.type": {
        brief: "A string identifying the type of the messaging operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "create",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    51,
                    127
                ]
            }
        ]
    },
    "messaging.rabbitmq.destination.routing_key": {
        brief: "RabbitMQ message routing key.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "myKey",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    468
                ],
                description: "Added messaging.rabbitmq.destination.routing_key attribute"
            }
        ]
    },
    "messaging.system": {
        brief: "The messaging system as identified by the client instrumentation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "activemq",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    method: {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET",
        deprecation: {
            replacement: "http.request.method"
        },
        aliases: [
            "http.request.method",
            "http.request_method",
            "http.method"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "middleware.name": {
        brief: "The name of the middleware.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "AuthenticationMiddleware",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    336
                ],
                description: "Added middleware.name attribute"
            }
        ]
    },
    "navigation.origin": {
        brief: "The origin of the navigation (usually client side router navigations). Should preferrably parameterized template (like url.template) or a URL path otherwise.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        aliases: [
            "sentry.sveltekit.navigation.from"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added navigation.origin attribute"
            }
        ]
    },
    "navigation.route.id": {
        brief: "The identifier of the matched client-side route, as assigned by the routing framework (e.g., vue-router name, react-router id).",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "AboutView",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    468
                ],
                description: "Added navigation.route.id attribute"
            }
        ]
    },
    "navigation.type": {
        brief: "The type of navigation done by a client-side router.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "router.push",
        aliases: [
            "sentry.sveltekit.navigation.type"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added new deprecated alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "nel.elapsed_time": {
        brief: "The elapsed number of milliseconds between the start of the resource fetch and when it was completed or aborted by the user agent.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    68
                ]
            }
        ]
    },
    "nel.phase": {
        brief: 'If request failed, the phase of its network error. If request succeeded, "application".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "application",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "nel.referrer": {
        brief: "request's referrer, as determined by the referrer policy associated with its client.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com/foo?bar=baz",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "nel.sampling_function": {
        brief: "The sampling function used to determine if the request should be sampled.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    68
                ]
            }
        ]
    },
    "nel.type": {
        brief: 'If request failed, the type of its network error. If request succeeded, "ok".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "dns.unreachable",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "network.connection.effective_type": {
        brief: "Specifies the effective type of the current connection (e.g. slow-2g, 2g, 3g, 4g).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "4g",
        aliases: [
            "effectiveConnectionType"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added attribute network.connection.effective_type to be used instead of effectiveConnectionType"
            }
        ]
    },
    "network.connection.rtt": {
        brief: "Specifies the estimated effective round-trip time of the current connection, in milliseconds.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        aliases: [
            "connection.rtt"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added attribute network.connection.rtt to be used instead of connection.rtt"
            }
        ]
    },
    "network.connection.type": {
        brief: "Specifies the type of the current connection (e.g. wifi, ethernet, cellular , etc).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "wifi",
        aliases: [
            "device.connection_type",
            "connectionType"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added attribute network.connection.type to be used instead of connectionType"
            }
        ]
    },
    "network.local.address": {
        brief: "Local address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "10.1.2.80",
        aliases: [
            "net.host.ip",
            "net.sock.host.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.local.port": {
        brief: "Local port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 65400,
        aliases: [
            "net.sock.host.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.peer.address": {
        brief: "Peer address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "10.1.2.80",
        aliases: [
            "net.peer.ip",
            "net.sock.peer.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.peer.port": {
        brief: "Peer port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 65400,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.protocol.name": {
        brief: "OSI application layer or non-OSI equivalent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http",
        aliases: [
            "net.protocol.name",
            "mcp.resource.protocol"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.protocol.version": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1.1",
        aliases: [
            "http.flavor",
            "net.protocol.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.transport": {
        brief: "OSI transport layer or inter-process communication method.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "tcp",
        aliases: [
            "net.transport",
            "mcp.transport"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.type": {
        brief: "OSI network layer or non-OSI equivalent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ipv4",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.host.ip": {
        brief: "Local address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "192.168.0.1",
        deprecation: {
            replacement: "network.local.address"
        },
        aliases: [
            "network.local.address",
            "net.sock.host.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.host.name": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address"
        },
        aliases: [
            "server.address",
            "http.server_name",
            "http.host",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.host.port": {
        brief: "Server port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        deprecation: {
            replacement: "server.port"
        },
        aliases: [
            "server.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.peer.ip": {
        brief: "Peer address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "192.168.0.1",
        deprecation: {
            replacement: "network.peer.address"
        },
        aliases: [
            "network.peer.address",
            "net.sock.peer.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.peer.name": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            reason: "Deprecated, use server.address on client spans and client.address on server spans."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.peer.port": {
        brief: "Peer port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        deprecation: {
            replacement: "server.port",
            reason: "Deprecated, use server.port on client spans and client.port on server spans."
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.protocol.name": {
        brief: "OSI application layer or non-OSI equivalent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http",
        deprecation: {
            replacement: "network.protocol.name"
        },
        aliases: [
            "network.protocol.name",
            "mcp.resource.protocol"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.protocol.version": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1.1",
        deprecation: {
            replacement: "network.protocol.version"
        },
        aliases: [
            "network.protocol.version",
            "http.flavor"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.family": {
        brief: "OSI transport and network layer",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "inet",
        deprecation: {
            replacement: "network.transport",
            reason: "Deprecated, use network.transport and network.type."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.host.addr": {
        brief: "Local address of the network connection mapping to Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/var/my.sock",
        deprecation: {
            replacement: "network.local.address"
        },
        aliases: [
            "network.local.address",
            "net.host.ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.host.port": {
        brief: "Local port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 8080,
        deprecation: {
            replacement: "network.local.port"
        },
        aliases: [
            "network.local.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.peer.addr": {
        brief: "Peer address of the network connection - IP address",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "192.168.0.1",
        deprecation: {
            replacement: "network.peer.address"
        },
        aliases: [
            "network.peer.address",
            "net.peer.ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.peer.name": {
        brief: "Peer address of the network connection - Unix domain socket name",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/var/my.sock",
        deprecation: {
            reason: "Deprecated from OTEL, no replacement at this time"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    119,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.peer.port": {
        brief: "Peer port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 8080,
        deprecation: {
            replacement: "network.peer.port"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.transport": {
        brief: "OSI transport layer or inter-process communication method.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "tcp",
        deprecation: {
            replacement: "network.transport"
        },
        aliases: [
            "network.transport",
            "mcp.transport"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.build": {
        brief: "The build ID of the operating system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        deprecation: {
            replacement: "os.build_id"
        },
        aliases: [
            "os.build_id"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.build attribute, deprecated in favor of os.build_id"
            }
        ]
    },
    "os.build_id": {
        brief: "The build ID of the operating system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1234567890",
        aliases: [
            "os.build"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.build as alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.description": {
        brief: "Human readable (not intended to be parsed) OS version information, like e.g. reported by ver or lsb_release -a commands.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Ubuntu 18.04.1 LTS",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.kernel_version": {
        brief: "An independent kernel version string. Typically the entire output of the `uname` syscall.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "20.2.0",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.kernel_version attribute"
            }
        ]
    },
    "os.name": {
        brief: "Human readable operating system name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Ubuntu",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.raw_description": {
        brief: "An unprocessed description string obtained by the operating system. For some well-known runtimes, Sentry will attempt to parse `name` and `version` from this string, if they are not explicitly given.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Ubuntu 22.04.4 LTS (Jammy Jellyfish)",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.raw_description attribute"
            }
        ]
    },
    "os.rooted": {
        brief: "Whether the operating system has been jailbroken or rooted.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.rooted attribute"
            }
        ]
    },
    "os.theme": {
        brief: "Whether the OS runs in dark mode or light mode.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "dark",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.theme attribute"
            }
        ]
    },
    "os.type": {
        brief: "The operating system type.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "linux",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.version": {
        brief: "The version of the operating system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "18.04.2",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.kind": {
        brief: "The span kind (https://opentelemetry.io/docs/concepts/signals/traces/#span-kind). Deprecated, use `sentry.kind` instead.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SERVER",
        deprecation: {
            replacement: "sentry.kind",
            reason: "Deprecated in favor of sentry.kind"
        },
        aliases: [
            "sentry.kind"
        ],
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    440
                ],
                description: "Added otel.kind attribute"
            }
        ]
    },
    "otel.scope.name": {
        brief: "The name of the instrumentation scope - (InstrumentationScope.Name in OTLP).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "io.opentelemetry.contrib.mongodb",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.scope.version": {
        brief: "The version of the instrumentation scope - (InstrumentationScope.Version in OTLP).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2.4.5",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.status_code": {
        brief: "Name of the code, either \u201COK\u201D or \u201CERROR\u201D. MUST NOT be set if the status code is UNSET.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "OK",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.status_description": {
        brief: "Description of the Status if it has a value, otherwise not set.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "resource not found",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "params.<key>": {
        brief: "Decoded parameters extracted from a URL path. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "params.id='123'",
        aliases: [
            "url.path.parameter.<key>"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "performance.activationStart": {
        brief: "The time between initiating a navigation to a page and the browser activating the page",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1.983,
        deprecation: {
            replacement: "browser.performance.navigation.activation_start",
            reason: "The activationStart is now recorded as the browser.performance.navigation.activation_start attribute."
        },
        aliases: [
            "browser.performance.navigation.activation_start"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added performance.activationStart attribute"
            }
        ]
    },
    "performance.timeOrigin": {
        brief: "The browser's performance.timeOrigin timestamp representing the time when the pageload was initiated",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1776185678886e-3,
        deprecation: {
            replacement: "browser.performance.time_origin",
            reason: "The timeOrigin is now recorded as the browser.performance.time_origin attribute."
        },
        aliases: [
            "browser.performance.time_origin"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added performance.timeOrigin attribute"
            }
        ]
    },
    previous_route: {
        brief: "Also used by mobile SDKs to indicate the previous route in the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "HomeScreen",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.command_args": {
        brief: "All the command arguments (including the command/executable itself) as received by the process.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "cmd/otecol",
            "--config=config.yaml"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    327
                ],
                description: "Added process.command_args attribute"
            }
        ]
    },
    "process.executable.name": {
        brief: "The name of the executable that started the process.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "getsentry",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.pid": {
        brief: "The process ID of the running process.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 12345,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.description": {
        brief: "An additional description about the runtime of the process, for example a specific vendor customization of the runtime environment. Equivalent to `raw_description` in the Sentry runtime context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Eclipse OpenJ9 VM openj9-0.21.0",
        aliases: [
            "runtime.raw_description"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.engine.name": {
        brief: "The name of the runtime engine.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "v8",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.engine.version": {
        brief: "The version of the runtime engine.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "12.9.202.13-rusty",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.name": {
        brief: "The name of the runtime. Equivalent to `name` in the Sentry runtime context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "node",
        aliases: [
            "runtime.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.version": {
        brief: "The version of the runtime of this process, as returned by the runtime without modification. Equivalent to `version` in the Sentry runtime context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "18.04.2",
        aliases: [
            "runtime.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "query.<key>": {
        brief: "An item in a query string. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "query.id='123'",
        deprecation: {
            replacement: "url.query",
            reason: "Instead of sending items individually in query.<key>, they should be sent all together with url.query."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "react.version": {
        brief: "The version of the React framework",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "18.2.0",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    368
                ],
                description: "Added react.version attribute"
            }
        ]
    },
    release: {
        brief: "The sentry release.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.release"
        },
        aliases: [
            "sentry.release"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "remix.action_form_data.<key>": {
        brief: "Remix form data, <key> being the form data key, the value being the form data value.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "http.response.header.text='test'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    replay_id: {
        brief: "The id of the sentry replay.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        deprecation: {
            replacement: "sentry.replay_id"
        },
        aliases: [
            "sentry.replay_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "resource.deployment.environment": {
        brief: "The software deployment environment name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.environment"
        },
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    266
                ]
            }
        ]
    },
    "resource.deployment.environment.name": {
        brief: "The software deployment environment name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.environment"
        },
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    196
                ]
            }
        ]
    },
    "resource.render_blocking_status": {
        brief: "The render blocking status of the resource.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "non-blocking",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    route: {
        brief: "The matched route, that is, the path template in the format used by the respective server framework. Also used by mobile SDKs to indicate the current route in the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "App\\Controller::indexAction",
        deprecation: {
            replacement: "http.route"
        },
        aliases: [
            "http.route"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "rpc.grpc.status_code": {
        brief: "The numeric status code of the gRPC request.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "rpc.method": {
        brief: "The fully-qualified logical name of the method from the RPC interface perspective.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "com.example.ExampleService/exampleMethod",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    351
                ],
                description: "Added rpc.method attribute"
            }
        ]
    },
    "rpc.response.status_code": {
        brief: "Status code of the RPC returned by the RPC server or generated by the client.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "DEADLINE_EXCEEDED",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    352
                ],
                description: "Added rpc.response.status_code attribute"
            }
        ]
    },
    "rpc.service": {
        brief: "The full (logical) name of the service being called, including its package name, if applicable.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "myService.BestService",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "rpc.system": {
        brief: "A string identifying the remoting system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws-api",
        deprecation: {
            replacement: "rpc.system.name",
            reason: "This attribute is being deprecated in favor of rpc.system.name, which is the OTel-aligned replacement."
        },
        aliases: [
            "rpc.system.name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added rpc.system attribute, deprecated in favor of rpc.system.name"
            }
        ]
    },
    "rpc.system.name": {
        brief: "A string identifying the remoting system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws-api",
        aliases: [
            "rpc.system"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added rpc.system.name attribute"
            }
        ]
    },
    "runtime.build": {
        brief: "The application build string, when it is separate from the version.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stable",
        deprecation: {
            reason: "The runtime.* namespace is deprecated in favor of process.runtime.*. No direct OTel equivalent exists for this attribute."
        },
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.build attribute"
            }
        ]
    },
    "runtime.name": {
        brief: "The name of the runtime. For example node, CPython, or rustc.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "node",
        deprecation: {
            replacement: "process.runtime.name",
            reason: "Prefer OTel-aligned process.runtime.name"
        },
        aliases: [
            "process.runtime.name"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.name attribute in favor of process.runtime.name"
            }
        ]
    },
    "runtime.raw_description": {
        brief: "Unprocessed description string as obtained from the runtime. Used to extract name and version for well-known runtimes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Eclipse OpenJ9 VM openj9-0.21.0",
        deprecation: {
            replacement: "process.runtime.description",
            reason: "Prefer OTel-aligned process.runtime.description"
        },
        aliases: [
            "process.runtime.description"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.raw_description attribute in favor of process.runtime.description"
            }
        ]
    },
    "runtime.version": {
        brief: "The version of the runtime.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "18.04.2",
        deprecation: {
            replacement: "process.runtime.version",
            reason: "Prefer OTel-aligned process.runtime.version"
        },
        aliases: [
            "process.runtime.version"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.version attribute in favor of process.runtime.version"
            }
        ]
    },
    "score.<key>": {
        brief: "The weighted performance score for a web vital. This is defined as `score.weight.<key>` * `score.ratio.<key>`.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "score.cls=0.1723",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.<key> attribute"
            }
        ]
    },
    "score.ratio.<key>": {
        brief: "The score for a web vital, normalized to a number between 0 and 1.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "score.ratio.inp=0.7748",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.ratio.<key> attribute"
            }
        ]
    },
    "score.total": {
        brief: "The total performance score of a span. This is the sum of individual weighted web vital scores (see `score.<key>`).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.total attribute"
            }
        ]
    },
    "score.weight.<key>": {
        brief: "The relative weight of a web vital in a span's performance score.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "score.weight.fcp=0.25",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.weight.<key> attribute"
            }
        ]
    },
    "sentry.action": {
        brief: "Used as a generic attribute representing the action depending on the type of span. For instance, this is the database query operation for DB spans, and the request method for HTTP spans.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.browser.name": {
        brief: "The name of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Chrome",
        deprecation: {
            replacement: "browser.name"
        },
        aliases: [
            "browser.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    139
                ]
            }
        ]
    },
    "sentry.browser.version": {
        brief: "The version of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "120.0.6099.130",
        deprecation: {
            replacement: "browser.version"
        },
        aliases: [
            "browser.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    139
                ]
            }
        ]
    },
    "sentry.cancellation_reason": {
        brief: "The reason why a span ended early.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "document.hidden",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.category": {
        brief: "The high-level category of a span, derived from the span operation or span attributes. This categorizes spans by their general purpose (e.g., database, HTTP, UI). Known values include: 'ai', 'ai.pipeline', 'app', 'browser', 'cache', 'console', 'db', 'event', 'file', 'function.aws', 'function.azure', 'function.gcp', 'function.nextjs', 'function.remix', 'graphql', 'grpc', 'http', 'measure', 'middleware', 'navigation', 'pageload', 'queue', 'resource', 'rpc', 'serialize', 'subprocess', 'template', 'topic', 'ui', 'ui.angular', 'ui.ember', 'ui.react', 'ui.svelte', 'ui.vue', 'view', 'websocket'.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "db",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    218
                ]
            }
        ]
    },
    "sentry.client_sample_rate": {
        brief: "Rate at which a span was sampled in the SDK.",
        type: "double",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    102
                ]
            }
        ]
    },
    "sentry.description": {
        brief: "The human-readable description of a span.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "index view query",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    135
                ]
            }
        ]
    },
    "sentry.dist": {
        brief: "The sentry dist.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0",
        aliases: [
            "dist"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    489
                ],
                description: "Added dist as an alias"
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.domain": {
        brief: "Used as a generic attribute representing the domain depending on the type of span. For instance, this is the collection/table name for database spans, and the server address for HTTP spans.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "example.com",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.dsc.environment": {
        brief: "The environment from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "prod",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.project_id": {
        brief: "The ID of the project where the trace originated (i.e. the project of the SDK that started the trace). Propagated through the dynamic sampling context and set by Relay during ingestion.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "12345",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    358
                ],
                description: "Add sentry.dsc.project_id as an attribute"
            }
        ]
    },
    "sentry.dsc.public_key": {
        brief: "The public key from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "c51734c603c4430eb57cb0a5728a479d",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.release": {
        brief: "The release identifier from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "frontend@e8211be71b214afab5b85de4b4c54be3714952bb",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.sampled": {
        brief: "Whether the event was sampled according to the dynamic sampling context.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: !0,
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.sample_rate": {
        brief: "The sample rate from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "1.0",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.trace_id": {
        brief: "The trace ID from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "047372980460430cbc78d9779df33a46",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.transaction": {
        brief: "The transaction name from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "/issues/errors-outages/",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.environment": {
        brief: "The sentry environment.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "production",
        aliases: [
            "environment"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.exclusive_time": {
        brief: "The exclusive time duration of the span in milliseconds.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    160
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.graphql.operation": {
        brief: "Indicates the type of graphql operation, emitted by the Javascript SDK.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "getUserById",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.group": {
        brief: "Stores the hash of `sentry.normalized_description`. This is primarily used for grouping spans in the product end.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.http.prefetch": {
        brief: "If an http request was a prefetch request.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.idle_span_finish_reason": {
        brief: "The reason why an idle span ended early.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "idleTimeout",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.is_remote": {
        brief: "Indicates whether a span's parent is remote.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.kind": {
        brief: "Used to clarify the relationship between parents and children, or to distinguish between spans, e.g. a `server` and `client` span with the same name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "server",
        aliases: [
            "otel.kind"
        ],
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.main_thread": {
        brief: "Whether the span or event occurred on the main thread. Computed by Relay and should not be set by SDKs.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    "sentry.message.parameter.<key>": {
        brief: "A parameter used in the message template. <key> can either be the number that represent the parameter's position in the template string (sentry.message.parameter.0, sentry.message.parameter.1, etc) or the parameter's name (sentry.message.parameter.item_id, sentry.message.parameter.user_id, etc)",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sentry.message.parameter.0='123'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116
                ]
            }
        ]
    },
    "sentry.message.template": {
        brief: "The parameterized template string.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Hello, {name}!",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116
                ]
            }
        ]
    },
    "sentry.metric.source": {
        brief: "The provenance of a metric.  For example, this can be set to indicate if a metric was generated by Relay from a span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "span",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    476
                ],
                description: "Added sentry.metric.source attribute"
            }
        ]
    },
    "sentry.mobile": {
        brief: "Whether the application is using a mobile SDK. Computed by Relay and should not be set by SDKs.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    "sentry.module.<key>": {
        brief: "A module that was loaded in the process. The key is the name of the module.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "sentry.module.brianium/paratest='v7.7.0'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "sentry.nextjs.ssr.function.route": {
        brief: "A parameterized route for a function in Next.js that contributes to Server-Side Rendering. Should be present on spans that track such functions when the file location of the function is known.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/posts/[id]/layout",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    54,
                    106
                ]
            }
        ]
    },
    "sentry.nextjs.ssr.function.type": {
        brief: "A descriptor for a for a function in Next.js that contributes to Server-Side Rendering. Should be present on spans that track such functions.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "generateMetadata",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    54,
                    106
                ]
            }
        ]
    },
    "sentry.normalized_db_query": {
        brief: "The normalized version of `db.query.text`.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT .. FROM sentry_project WHERE (project_id = %s)",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    194
                ]
            }
        ]
    },
    "sentry.normalized_db_query.hash": {
        brief: "The hash of `sentry.normalized_db_query`.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    200
                ]
            }
        ]
    },
    "sentry.normalized_description": {
        brief: "Used as a generic attribute representing the normalized `sentry.description`. This refers to the legacy use case of `sentry.description` where it holds relevant data depending on the type of span (e.g. database query, resource url, http request description, etc).",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT .. FROM sentry_project WHERE (project_id = %s)",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.observed_timestamp_nanos": {
        brief: "The timestamp at which an envelope was received by Relay, in nanoseconds.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1544712660300000000",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    174
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    137
                ]
            }
        ]
    },
    "sentry.op": {
        brief: "The operation of a span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "http.client",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.origin": {
        brief: "The origin of the instrumentation (e.g. span, log, etc.)",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "auto.http.otel.fastify",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.platform": {
        brief: "The sdk platform that generated the event.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "php",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.profiler_id": {
        brief: "The id of the currently running profiler (continuous profiling)",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "18779b64dd35d1a538e7ce2dd2d3fad3",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    242
                ]
            }
        ]
    },
    "sentry.profile_id": {
        brief: "The ID of the Sentry profile the span is associated with. This is only meaningful for transaction-based profiling.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    344
                ],
                description: "Added sentry.profile_id attribute"
            }
        ]
    },
    "sentry.release": {
        brief: "The sentry release.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "7.0.0",
        aliases: [
            "service.version",
            "release"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.replay_id": {
        brief: "The id of the sentry replay.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        aliases: [
            "replay_id"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.replay_is_buffering": {
        brief: "A sentinel attribute on log events indicating whether the current Session Replay is being buffered (onErrorSampleRate).",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.report_event": {
        brief: "(Deprecated) The event that caused the SDK to report CLS or LCP (pagehide or navigation)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "pagehide",
        deprecation: {
            reason: "The report event is now recorded as a browser.web_vital.lcp.report_event or browser.web_vital.cls.report_event attribute. No backfill required."
        },
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    320
                ],
                description: "Added sentry.report_event attribute"
            }
        ]
    },
    "sentry.sdk.integrations": {
        brief: "A list of names identifying enabled integrations. The list shouldhave all enabled integrations, including default integrations. Defaultintegrations are included because different SDK releases may contain differentdefault integrations.",
        type: "string[]",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "InboundFilters",
            "FunctionToString",
            "BrowserApiErrors",
            "Breadcrumbs"
        ],
        changelog: [
            {
                version: "0.0.0",
                prs: [
                    42
                ]
            }
        ]
    },
    "sentry.sdk.name": {
        brief: "The sentry sdk name.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "@sentry/react",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.sdk.version": {
        brief: "The sentry sdk version.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "7.0.0",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.segment.id": {
        brief: "The segment ID of a span",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "051581bf3cb55c13",
        aliases: [
            "sentry.segment_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    107,
                    124
                ]
            }
        ]
    },
    "sentry.segment_id": {
        brief: "The segment ID of a span",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "051581bf3cb55c13",
        deprecation: {
            replacement: "sentry.segment.id"
        },
        aliases: [
            "sentry.segment.id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    124
                ]
            }
        ]
    },
    "sentry.segment.name": {
        brief: "The segment name of a span",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET /user",
        aliases: [
            "sentry.transaction",
            "transaction"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    345
                ],
                description: "Added sentry.transaction and transaction aliases"
            },
            {
                version: "0.1.0",
                prs: [
                    104
                ]
            }
        ]
    },
    "sentry.server_sample_rate": {
        brief: "Rate at which a span was sampled in Relay.",
        type: "double",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    102
                ]
            }
        ]
    },
    "sentry.source": {
        brief: "The source of a span, also referred to as transaction source. Known values are:  `'custom'`, `'url'`, `'route'`, `'component'`, `'view'`, `'task'`. '`source`' describes a parametrized route, while `'url'` describes the full URL, potentially containing identifiers.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "route",
        deprecation: {
            replacement: "sentry.span.source",
            reason: "This attribute is being deprecated in favor of sentry.span.source"
        },
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    "sentry.span.source": {
        brief: "The source of a span, also referred to as transaction source. Known values are:  `'custom'`, `'url'`, `'route'`, `'component'`, `'view'`, `'task'`. '`source`' describes a parametrized route, while `'url'` describes the full URL, potentially containing identifiers.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "route",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    214
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.status": {
        brief: `The span's status (either "ok" or "error"). Older SDKs may set this to a more specific error, but this behaviour is deprecated.`,
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "ok",
        changelog: [
            {
                version: "0.14.0",
                prs: [
                    453
                ]
            }
        ]
    },
    "sentry.status_code": {
        brief: "The HTTP status code used in Sentry Insights. Typically set by Sentry during ingestion, rather than by clients.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    223,
                    228
                ]
            }
        ]
    },
    "sentry.status.message": {
        brief: "The from OTLP extracted status message.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "foobar",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.sveltekit.navigation.from": {
        brief: "the navigation origin (sveltekit router)",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/home",
        deprecation: {
            replacement: "navigation.origin",
            reason: "Use the more generic attribute instead"
        },
        aliases: [
            "navigation.origin"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added sentry.sveltekit.navigation.from attribute"
            }
        ]
    },
    "sentry.sveltekit.navigation.to": {
        brief: "the navigation destination",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        deprecation: {
            reason: "the navigation destination is already covered by url.* attributes"
        },
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added sentry.sveltekit.navigation.to attribute"
            }
        ]
    },
    "sentry.sveltekit.navigation.type": {
        brief: "The type of navigation event emitted from the sveltekit client router",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "link",
        deprecation: {
            replacement: "navigation.type",
            reason: "Use the more generic attribute instead"
        },
        aliases: [
            "navigation.type"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added sentry.sveltekit.navigation.type attribute"
            }
        ]
    },
    "sentry.thread.id": {
        brief: "Current \u201Cmanaged\u201D thread ID.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 56,
        deprecation: {
            replacement: "thread.id",
            reason: "This attribute is being deprecated in favor of the OTel-standard thread.id"
        },
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    451
                ]
            }
        ]
    },
    "sentry.timestamp.sequence": {
        brief: "A sequencing counter for deterministic ordering of logs or metrics when timestamps share the same integer millisecond. Starts at 0 on SDK initialization, increments by 1 for each captured item, and resets to 0 when the integer millisecond of the current item differs from the previous one.",
        type: "integer",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: 0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    262
                ]
            }
        ]
    },
    "sentry.trace_lifecycle": {
        brief: "Indicates the chosen trace lifecycle mode of the SDK (stream or static)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stream",
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    442
                ],
                description: "Added sentry.trace_lifecycle attribute"
            }
        ]
    },
    "sentry.trace.parent_span_id": {
        brief: "The span id of the span that was active when the log was collected. This should not be set if there was no active span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "b0e6f15b45c36b12",
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    287
                ],
                description: "Deprecate `sentry.trace.parent_span_id`"
            },
            {
                version: "0.1.0",
                prs: [
                    116
                ]
            }
        ]
    },
    "sentry.trace.status": {
        brief: `The segment's status (either "ok" or "error"). Older SDKs may set this to a more specific error, but this behaviour is deprecated.`,
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "ok",
        changelog: [
            {
                version: "0.14.0",
                prs: [
                    453
                ]
            }
        ]
    },
    "sentry.transaction": {
        brief: "The sentry transaction (segment name).",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET /",
        deprecation: {
            replacement: "sentry.segment.name",
            reason: "This attribute is being deprecated in favor of sentry.segment.name"
        },
        aliases: [
            "sentry.segment.name",
            "transaction"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    345
                ],
                description: "Deprecated sentry.transaction in favor of sentry.segment.name"
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.user.email": {
        brief: "User email address.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.email"
        },
        aliases: [
            "user.email"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.city": {
        brief: "Human readable city name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.city"
        },
        aliases: [
            "user.geo.city"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.country_code": {
        brief: "Two-letter country code (ISO 3166-1 alpha-2).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.country_code"
        },
        aliases: [
            "user.geo.country_code"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.region": {
        brief: "Human readable region name or code.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.region"
        },
        aliases: [
            "user.geo.region"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.subdivision": {
        brief: "Human readable subdivision name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.subdivision"
        },
        aliases: [
            "user.geo.subdivision"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.id": {
        brief: "Unique identifier of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.id"
        },
        aliases: [
            "user.id"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.ip": {
        brief: "The IP address of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.ip_address"
        },
        aliases: [
            "user.ip_address"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.username": {
        brief: "Short name or login/username of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.name"
        },
        aliases: [
            "user.name"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "server.address": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        aliases: [
            "http.server_name",
            "net.host.name",
            "http.host",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    server_name: {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            reason: "This attribute is being deprecated in favor of server.address, which is the OTel-aligned replacement."
        },
        aliases: [
            "server.address",
            "http.server_name",
            "net.host.name",
            "http.host"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    477
                ],
                description: "Added server_name attribute, deprecated in favor of server.address"
            }
        ]
    },
    "server.port": {
        brief: "Server port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        aliases: [
            "net.host.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "service.name": {
        brief: "Logical name of the service.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "omegastar",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "service.version": {
        brief: "The version string of the service API or implementation. The format is not defined by these conventions.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "5.0.0",
        aliases: [
            "sentry.release"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "session.id": {
        brief: "A unique id identifying the active session at the time of setting this attribute",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "00112233-4455-6677-8899-aabbccddeeff",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    412
                ],
                description: "Added session.id attribute"
            }
        ]
    },
    stall_percentage: {
        brief: "The fraction of time the app was stalled. Only applies to React Native. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added stall_percentage attribute"
            }
        ]
    },
    stall_total_time: {
        brief: "The combined duration of all stalls in milliseconds. Only applies to React Native. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added stall_total_time attribute"
            }
        ]
    },
    "state.type": {
        brief: "The type of state management library",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "redux",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    365
                ],
                description: "Added state.type attribute"
            }
        ]
    },
    "thread.id": {
        brief: "Current \u201Cmanaged\u201D thread ID.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 56,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "thread.name": {
        brief: "Current thread name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "main",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "timber.tag": {
        brief: "The log tag provided by the timber logging framework.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MyTag",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    183
                ]
            }
        ]
    },
    time_to_full_display: {
        brief: "The duration of time to full display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.ttfd.value",
            reason: "Replaced by app.vitals.ttfd.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.ttfd.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added and deprecated in favor of app.vitals.ttfd.value"
            }
        ]
    },
    time_to_initial_display: {
        brief: "The duration of time to initial display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.ttid.value",
            reason: "Replaced by app.vitals.ttid.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.ttid.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added and deprecated in favor of app.vitals.ttid.value"
            }
        ]
    },
    transaction: {
        brief: "The sentry transaction (segment name).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET /",
        deprecation: {
            replacement: "sentry.segment.name"
        },
        aliases: [
            "sentry.segment.name",
            "sentry.transaction"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    345
                ],
                description: "Updated transaction deprecation replacement to sentry.segment.name"
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "trpc.procedure_path": {
        brief: "The path of the tRPC procedure being called",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user.getById",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    370
                ],
                description: "Added trpc.procedure_path attribute"
            }
        ]
    },
    "trpc.procedure_type": {
        brief: "The type of the tRPC procedure",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "query",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    370
                ],
                description: "Added trpc.procedure_type attribute"
            }
        ]
    },
    ttfb: {
        brief: "The value of the recorded Time To First Byte (TTFB) web vital in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 194,
        deprecation: {
            replacement: "browser.web_vital.ttfb.value",
            reason: "This attribute is being deprecated in favor of browser.web_vital.ttfb.value"
        },
        aliases: [
            "browser.web_vital.ttfb.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "ttfb.requestTime": {
        brief: "The time it takes for the server to process the initial request and send the first byte of a response to the user's browser",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1554.5814,
        deprecation: {
            replacement: "browser.web_vital.ttfb.request_time",
            reason: "This attribute is being deprecated in favor of browser.web_vital.ttfb.request_time"
        },
        aliases: [
            "browser.web_vital.ttfb.request_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    type: {
        brief: "More granular type of the operation happening.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "fetch",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.component_name": {
        brief: "The name of the associated component.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "HomeButton",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.contributes_to_ttfd": {
        brief: "Whether the span execution contributed to the TTFD (time to fully drawn) metric.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.contributes_to_ttid": {
        brief: "Whether the span execution contributed to the TTID (time to initial display) metric.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.element.height": {
        brief: "The height of the UI element (for Html in pixels)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 256,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.height attribute"
            }
        ]
    },
    "ui.element.id": {
        brief: "The id of the UI element",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "btn-login",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.id attribute"
            }
        ]
    },
    "ui.element.identifier": {
        brief: "The identifier used to measure the UI element timing",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "heroImage",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.identifier attribute"
            }
        ]
    },
    "ui.element.load_time": {
        brief: "The loading time of a UI element (from time origin to finished loading)",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 998.2234,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.load_time attribute"
            }
        ]
    },
    "ui.element.paint_type": {
        brief: "The type of element paint. Can either be 'image-paint' or 'text-paint'",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "image-paint",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.paint_type attribute"
            }
        ]
    },
    "ui.element.render_time": {
        brief: "The rendering time of the UI element (from time origin to finished rendering)",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1023.1124,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.render_time attribute"
            }
        ]
    },
    "ui.element.type": {
        brief: "type of the UI element",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "img",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.type attribute"
            }
        ]
    },
    "ui.element.url": {
        brief: "The URL of the UI element (e.g. an img src)",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://assets.myapp.com/hero.png",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.url attribute"
            }
        ]
    },
    "ui.element.width": {
        brief: "The width of the UI element (for HTML in pixels)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 512,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.width attribute"
            }
        ]
    },
    url: {
        brief: "The URL of the resource that was fetched.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com/test?foo=bar#buzz",
        deprecation: {
            replacement: "url.full"
        },
        aliases: [
            "url.full",
            "http.url"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.domain": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.fragment": {
        brief: "The fragments present in the URI. Note that this does not contain the leading # character, while the `http.fragment` attribute does.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "details",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "url.full": {
        brief: "The URL of the resource that was fetched.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https://example.com/test?foo=bar#buzz",
        aliases: [
            "http.url",
            "url"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.path": {
        brief: "The URI path component.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/foo",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "url.path.parameter.<key>": {
        brief: "Decoded parameters extracted from a URL path. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "url.path.parameter.id='123'",
        aliases: [
            "params.<key>"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "url.port": {
        brief: "Server port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.query": {
        brief: "The query string present in the URL. Note that this does not contain the leading ? character, while the `http.query` attribute does.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Query string values can contain sensitive information. Clients should attempt to scrub parameters that might contain sensitive information."
        },
        isInOtel: !0,
        visibility: "public",
        example: "foo=bar&bar=baz",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "url.same_origin": {
        brief: "Indicates that a URL has the same origin as the current page's origin in the browser.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        deprecation: {
            replacement: "http.request.same_origin",
            reason: "This attribute is being deprecated in favor of http.request.same_origin."
        },
        aliases: [
            "http.request.same_origin"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    456
                ],
                description: "Added url.same_origin attribute, deprecated in favor of http.request.same_origin"
            }
        ]
    },
    "url.scheme": {
        brief: "The URI scheme component identifying the used protocol.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https",
        aliases: [
            "http.scheme"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.template": {
        brief: "The low-cardinality template of an absolute path reference.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/users/:id",
        aliases: [
            "http.route"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "user_agent.original": {
        brief: "Value of the HTTP User-Agent header sent by the client.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Mozilla/5.0 (iPhone; CPU iPhone OS 14_7_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.2 Mobile/15E148 Safari/604.1",
        aliases: [
            "http.user_agent"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "user.email": {
        brief: "User email address.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "test@example.com",
        aliases: [
            "sentry.user.email"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.full_name": {
        brief: "User's full name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "John Smith",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.city": {
        brief: "Human readable city name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Toronto",
        aliases: [
            "sentry.user.geo.city"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.country_code": {
        brief: "Two-letter country code (ISO 3166-1 alpha-2).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "CA",
        aliases: [
            "sentry.user.geo.country_code"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.region": {
        brief: "Human readable region name or code.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Canada",
        aliases: [
            "sentry.user.geo.region"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.subdivision": {
        brief: "Human readable subdivision name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Ontario",
        aliases: [
            "sentry.user.geo.subdivision"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.hash": {
        brief: "Unique user hash to correlate information for a user in anonymized form.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "8ae4c2993e0f4f3b8b2d1b1f3b5e8f4d",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.id": {
        brief: "Unique identifier of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "S-1-5-21-202424912787-2692429404-2351956786-1000",
        aliases: [
            "sentry.user.id"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.ip_address": {
        brief: "The IP address of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "192.168.1.1",
        aliases: [
            "sentry.user.ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    75
                ]
            }
        ]
    },
    "user.name": {
        brief: "Short name or login/username of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "j.smith",
        aliases: [
            "sentry.user.username"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.roles": {
        brief: "Array of user roles at the time of the event.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "admin",
            "editor"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "vercel.branch": {
        brief: "Git branch name for Vercel project",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "main",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.build_id": {
        brief: "Identifier for the Vercel build (only present on build logs)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "bld_cotnkcr76",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.deployment_id": {
        brief: "Identifier for the Vercel deployment",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "dpl_233NRGRjVZX1caZrXWtz5g1TAksD",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.destination": {
        brief: "Origin of the external content in Vercel (only on external logs)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://vitals.vercel-insights.com/v1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.edge_type": {
        brief: "Type of edge runtime in Vercel",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "edge-function",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.entrypoint": {
        brief: "Entrypoint for the request in Vercel",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "api/index.js",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.execution_region": {
        brief: "Region where the request is executed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.id": {
        brief: "Unique identifier for the log entry in Vercel",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1573817187330377061717300000",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.ja3_digest": {
        brief: "JA3 fingerprint digest of Vercel request",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "769,47-53-5-10-49161-49162-49171-49172-50-56-19-4,0-10-11,23-24-25,0",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.ja4_digest": {
        brief: "JA4 fingerprint digest",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "t13d1516h2_8daaf6152771_02713d6af862",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.log_type": {
        brief: "Vercel log output type",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stdout",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.path": {
        brief: "Function or dynamic path of the request in Vercel.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/dynamic/[route].json",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    349
                ],
                description: "Added vercel.path attribute"
            }
        ]
    },
    "vercel.project_id": {
        brief: "Identifier for the Vercel project",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gdufoJxB6b9b1fEqr1jUtFkyavUU",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.project_name": {
        brief: "Name of the Vercel project",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-app",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.cache_id": {
        brief: "Original request ID when request is served from cache",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "pdx1::v8g4b-1744143786684-93dafbc0f70d",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.client_ip": {
        brief: "Client IP address",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "120.75.16.101",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.host": {
        brief: "Hostname of the request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "test.vercel.app",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.lambda_region": {
        brief: "Region where lambda function executed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.method": {
        brief: "HTTP method of the request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.path": {
        brief: "Request path with query parameters",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/dynamic/some-value.json?route=some-value",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.path_type": {
        brief: "How the request was served based on its path and project configuration",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "func",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.path_type_variant": {
        brief: "Variant of the path type",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "api",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.referer": {
        brief: "Referer of the request",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "*.vercel.app",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.region": {
        brief: "Region where the request is processed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.response_byte_size": {
        brief: "Size of the response in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1024,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.scheme": {
        brief: "Protocol of the request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.status_code": {
        brief: "HTTP status code of the proxy request",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.timestamp": {
        brief: "Unix timestamp when the proxy request was made",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1573817250172,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.user_agent": {
        brief: "User agent strings of the request",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Mozilla/5.0..."
        ],
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.vercel_cache": {
        brief: "Cache status sent to the browser",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "REVALIDATED",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.vercel_id": {
        brief: "Vercel-specific identifier",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1::abc123",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.waf_action": {
        brief: "Action taken by firewall rules",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "deny",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.waf_rule_id": {
        brief: "ID of the firewall rule that matched",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rule_gAHz8jtSB1Gy",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.request_id": {
        brief: "Identifier of the Vercel request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "643af4e3-975a-4cc7-9e7a-1eda11539d90",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.source": {
        brief: "Origin of the Vercel log (build, edge, lambda, static, external, or firewall)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "build",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.status_code": {
        brief: "HTTP status code of the request (-1 means no response returned and the lambda crashed)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    }
};
$c97e36c8d40a3851$export$b60c5e9f9b7b58bd = $c97e36c8d40a3851$var$AI_CITATIONS, $c97e36c8d40a3851$export$cc06afd6de7f2c10 = $c97e36c8d40a3851$var$AI_COMPLETION_TOKENS_USED, $c97e36c8d40a3851$export$ced6746028fe2cc = $c97e36c8d40a3851$var$AI_DOCUMENTS, $c97e36c8d40a3851$export$e6f4aa4f4fcb6da8 = $c97e36c8d40a3851$var$AI_FINISH_REASON, $c97e36c8d40a3851$export$f02d892201cd8d36 = $c97e36c8d40a3851$var$AI_FREQUENCY_PENALTY, $c97e36c8d40a3851$export$f277a7ef9e273960 = $c97e36c8d40a3851$var$AI_FUNCTION_CALL, $c97e36c8d40a3851$export$1a8c212c3becaa80 = $c97e36c8d40a3851$var$AI_GENERATION_ID, $c97e36c8d40a3851$export$721b137086c68a47 = $c97e36c8d40a3851$var$AI_INPUT_MESSAGES, $c97e36c8d40a3851$export$6afde2bb69d9aa86 = $c97e36c8d40a3851$var$AI_IS_SEARCH_REQUIRED, $c97e36c8d40a3851$export$eadb4b562c974031 = $c97e36c8d40a3851$var$AI_METADATA, $c97e36c8d40a3851$export$22a90f0ac1eee843 = $c97e36c8d40a3851$var$AI_MODEL_ID, $c97e36c8d40a3851$export$a727f215a0be1dad = $c97e36c8d40a3851$var$AI_MODEL_PROVIDER, $c97e36c8d40a3851$export$536bc61b34d995e5 = $c97e36c8d40a3851$var$AI_PIPELINE_NAME, $c97e36c8d40a3851$export$c43ea6115b380e62 = $c97e36c8d40a3851$var$AI_PREAMBLE, $c97e36c8d40a3851$export$d2a16e26bada7cf1 = $c97e36c8d40a3851$var$AI_PRESENCE_PENALTY, $c97e36c8d40a3851$export$604eb1bd2278163b = $c97e36c8d40a3851$var$AI_PROMPT_TOKENS_USED, $c97e36c8d40a3851$export$2f8568696c5aa352 = $c97e36c8d40a3851$var$AI_RAW_PROMPTING, $c97e36c8d40a3851$export$ccc8efd7dd31d3a9 = $c97e36c8d40a3851$var$AI_RESPONSES, $c97e36c8d40a3851$export$e176bf5dc45e40df = $c97e36c8d40a3851$var$AI_RESPONSE_FORMAT, $c97e36c8d40a3851$export$c4ea01fd53f64e16 = $c97e36c8d40a3851$var$AI_SEARCH_QUERIES, $c97e36c8d40a3851$export$bb5e6f2f31a15da9 = $c97e36c8d40a3851$var$AI_SEARCH_RESULTS, $c97e36c8d40a3851$export$1762c11b666b026a = $c97e36c8d40a3851$var$AI_SEED, $c97e36c8d40a3851$export$14ddd4b729910100 = $c97e36c8d40a3851$var$AI_STREAMING, $c97e36c8d40a3851$export$5311d7c8e1f8eabb = $c97e36c8d40a3851$var$AI_TAGS, $c97e36c8d40a3851$export$2b748b9eca00828b = $c97e36c8d40a3851$var$AI_TEMPERATURE, $c97e36c8d40a3851$export$5af25308c11addea = $c97e36c8d40a3851$var$AI_TEXTS, $c97e36c8d40a3851$export$28f78b3b1663cb92 = $c97e36c8d40a3851$var$AI_TOOLS, $c97e36c8d40a3851$export$a1d3f09f0f1f066f = $c97e36c8d40a3851$var$AI_TOOL_CALLS, $c97e36c8d40a3851$export$322bd4ea9f163663 = $c97e36c8d40a3851$var$AI_TOP_K, $c97e36c8d40a3851$export$95711b9e669edad8 = $c97e36c8d40a3851$var$AI_TOP_P, $c97e36c8d40a3851$export$5924d7d72384626a = $c97e36c8d40a3851$var$AI_TOTAL_COST, $c97e36c8d40a3851$export$db3b1b877a4ce4db = $c97e36c8d40a3851$var$AI_TOTAL_TOKENS_USED, $c97e36c8d40a3851$export$a434a3e8afec2879 = $c97e36c8d40a3851$var$AI_WARNINGS, $c97e36c8d40a3851$export$fe00bb20636d42af = $c97e36c8d40a3851$var$ANGULAR_VERSION, $c97e36c8d40a3851$export$712aa698b7ee271e = $c97e36c8d40a3851$var$APP_APP_BUILD, $c97e36c8d40a3851$export$1fac638b11ec16d9 = $c97e36c8d40a3851$var$APP_APP_IDENTIFIER, $c97e36c8d40a3851$export$d132016ea64058e3 = $c97e36c8d40a3851$var$APP_APP_NAME, $c97e36c8d40a3851$export$53f2f47ec3b2f9ed = $c97e36c8d40a3851$var$APP_APP_START_TIME, $c97e36c8d40a3851$export$9f80c4b11053cef1 = $c97e36c8d40a3851$var$APP_APP_VERSION, $c97e36c8d40a3851$export$5f7a08466d84e877 = $c97e36c8d40a3851$var$APP_BUILD, $c97e36c8d40a3851$export$2cea7f14750b8c19 = $c97e36c8d40a3851$var$APP_IDENTIFIER, $c97e36c8d40a3851$export$34c59270f032a6c6 = $c97e36c8d40a3851$var$APP_IN_FOREGROUND, $c97e36c8d40a3851$export$5b6c28c7dca07ad7 = $c97e36c8d40a3851$var$APP_NAME, $c97e36c8d40a3851$export$1dc8ae58b58d6c50 = $c97e36c8d40a3851$var$APP_START_COLD, $c97e36c8d40a3851$export$ba267414e3c0d822 = $c97e36c8d40a3851$var$APP_START_TIME, $c97e36c8d40a3851$export$71b176005902b99e = $c97e36c8d40a3851$var$APP_START_TYPE, $c97e36c8d40a3851$export$5c5b5a3c245a0079 = $c97e36c8d40a3851$var$APP_START_WARM, $c97e36c8d40a3851$export$8ee1df3c6367a60 = $c97e36c8d40a3851$var$APP_VERSION, $c97e36c8d40a3851$export$e8c7802ae95beccf = $c97e36c8d40a3851$var$APP_VITALS_FRAMES_DELAY_VALUE, $c97e36c8d40a3851$export$bb237734da4d464 = $c97e36c8d40a3851$var$APP_VITALS_FRAMES_FROZEN_COUNT, $c97e36c8d40a3851$export$cdaaf6d1fdcba0b6 = $c97e36c8d40a3851$var$APP_VITALS_FRAMES_SLOW_COUNT, $c97e36c8d40a3851$export$36223ebd4a30e9f5 = $c97e36c8d40a3851$var$APP_VITALS_FRAMES_TOTAL_COUNT, $c97e36c8d40a3851$export$8feaa177bb7941e2 = $c97e36c8d40a3851$var$APP_VITALS_START_COLD_VALUE, $c97e36c8d40a3851$export$e1ca25240db91d68 = $c97e36c8d40a3851$var$APP_VITALS_START_PREWARMED, $c97e36c8d40a3851$export$404a223fd1ada08b = $c97e36c8d40a3851$var$APP_VITALS_START_REASON, $c97e36c8d40a3851$export$53362079310c68 = $c97e36c8d40a3851$var$APP_VITALS_START_SCREEN, $c97e36c8d40a3851$export$3efb5af0ac379f77 = $c97e36c8d40a3851$var$APP_VITALS_START_TYPE, $c97e36c8d40a3851$export$2c10c1ca0612c46d = $c97e36c8d40a3851$var$APP_VITALS_START_WARM_VALUE, $c97e36c8d40a3851$export$bbb86ad4d6654da6 = $c97e36c8d40a3851$var$APP_VITALS_TTFD_VALUE, $c97e36c8d40a3851$export$ad6896f00a2b1076 = $c97e36c8d40a3851$var$APP_VITALS_TTID_VALUE, $c97e36c8d40a3851$export$300f39d8506a273d = $c97e36c8d40a3851$var$ART_GC_BLOCKING_COUNT, $c97e36c8d40a3851$export$ecaa0e7f4773ddc7 = $c97e36c8d40a3851$var$ART_GC_BLOCKING_TIME, $c97e36c8d40a3851$export$74b78acb4c54c06b = $c97e36c8d40a3851$var$ART_GC_PRE_OOME_COUNT, $c97e36c8d40a3851$export$b15b2c133bc50e33 = $c97e36c8d40a3851$var$ART_GC_TOTAL_COUNT, $c97e36c8d40a3851$export$5f1381d9ae1b1c95 = $c97e36c8d40a3851$var$ART_GC_TOTAL_TIME, $c97e36c8d40a3851$export$c170b7ff277132ea = $c97e36c8d40a3851$var$ART_GC_WAITING_TIME, $c97e36c8d40a3851$export$9459a5df93695e45 = $c97e36c8d40a3851$var$ART_MEMORY_FREE, $c97e36c8d40a3851$export$a7902bd57492ebe8 = $c97e36c8d40a3851$var$ART_MEMORY_FREE_UNTIL_GC, $c97e36c8d40a3851$export$d2ace0da59da09b7 = $c97e36c8d40a3851$var$ART_MEMORY_FREE_UNTIL_OOME, $c97e36c8d40a3851$export$c15dd8d2461e0aeb = $c97e36c8d40a3851$var$ART_MEMORY_MAX, $c97e36c8d40a3851$export$5405b0a98e00e538 = $c97e36c8d40a3851$var$ART_MEMORY_TOTAL, $c97e36c8d40a3851$export$bd393bbb84b309d3 = $c97e36c8d40a3851$var$ATTRIBUTE_METADATA, $c97e36c8d40a3851$export$96f586f8837b86ae = $c97e36c8d40a3851$var$ATTRIBUTE_TYPE, $c97e36c8d40a3851$export$5d9f28f388f552d2 = $c97e36c8d40a3851$var$AWS_CLOUDWATCH_LOGS_LOG_GROUP, $c97e36c8d40a3851$export$b3d2f68e0e769504 = $c97e36c8d40a3851$var$AWS_CLOUDWATCH_LOGS_LOG_STREAM, $c97e36c8d40a3851$export$2c98412ed43013e8 = $c97e36c8d40a3851$var$AWS_CLOUDWATCH_LOGS_URL, $c97e36c8d40a3851$export$a7bd794d11c19f1b = $c97e36c8d40a3851$var$AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS, $c97e36c8d40a3851$export$df4227832b83fdd0 = $c97e36c8d40a3851$var$AWS_DYNAMODB_CONSISTENT_READ, $c97e36c8d40a3851$export$f131a6d8fbc0534f = $c97e36c8d40a3851$var$AWS_DYNAMODB_CONSUMED_CAPACITY, $c97e36c8d40a3851$export$9bdc66d4a70e7e3a = $c97e36c8d40a3851$var$AWS_DYNAMODB_COUNT, $c97e36c8d40a3851$export$bfbbc3cbcaa90e98 = $c97e36c8d40a3851$var$AWS_DYNAMODB_EXCLUSIVE_START_TABLE, $c97e36c8d40a3851$export$3565fa72459aa4d6 = $c97e36c8d40a3851$var$AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES, $c97e36c8d40a3851$export$bb67a834ae4bffdc = $c97e36c8d40a3851$var$AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES, $c97e36c8d40a3851$export$4a06c859a283f06 = $c97e36c8d40a3851$var$AWS_DYNAMODB_INDEX_NAME, $c97e36c8d40a3851$export$68324fac2038d0f2 = $c97e36c8d40a3851$var$AWS_DYNAMODB_ITEM_COLLECTION_METRICS, $c97e36c8d40a3851$export$5e1bd62ffd2786fb = $c97e36c8d40a3851$var$AWS_DYNAMODB_LIMIT, $c97e36c8d40a3851$export$bfdf2261058f56b = $c97e36c8d40a3851$var$AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES, $c97e36c8d40a3851$export$23bf57842d9d53df = $c97e36c8d40a3851$var$AWS_DYNAMODB_PROJECTION, $c97e36c8d40a3851$export$bfbd7e060eeb4d35 = $c97e36c8d40a3851$var$AWS_DYNAMODB_PROVISIONED_READ_CAPACITY, $c97e36c8d40a3851$export$82eb6cccda27c3ff = $c97e36c8d40a3851$var$AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY, $c97e36c8d40a3851$export$8ea68734d455808f = $c97e36c8d40a3851$var$AWS_DYNAMODB_SCANNED_COUNT, $c97e36c8d40a3851$export$40050e29324d44ee = $c97e36c8d40a3851$var$AWS_DYNAMODB_SCAN_FORWARD, $c97e36c8d40a3851$export$5cd7541006d9f467 = $c97e36c8d40a3851$var$AWS_DYNAMODB_SEGMENT, $c97e36c8d40a3851$export$81c017edd95d692e = $c97e36c8d40a3851$var$AWS_DYNAMODB_SELECT, $c97e36c8d40a3851$export$120b3897a58cf903 = $c97e36c8d40a3851$var$AWS_DYNAMODB_TABLE_COUNT, $c97e36c8d40a3851$export$d4a9de43b4b1076c = $c97e36c8d40a3851$var$AWS_DYNAMODB_TABLE_NAMES, $c97e36c8d40a3851$export$f37f4f9022f1ab17 = $c97e36c8d40a3851$var$AWS_DYNAMODB_TOTAL_SEGMENTS, $c97e36c8d40a3851$export$66ac18da14747cfb = $c97e36c8d40a3851$var$AWS_EXTENDED_REQUEST_ID, $c97e36c8d40a3851$export$9e49b833525ca49d = $c97e36c8d40a3851$var$AWS_KINESIS_STREAM_NAME, $c97e36c8d40a3851$export$b084fea5b3097227 = $c97e36c8d40a3851$var$AWS_LAMBDA_AWS_REQUEST_ID, $c97e36c8d40a3851$export$e09cd8615652e8d0 = $c97e36c8d40a3851$var$AWS_LAMBDA_EXECUTION_DURATION_IN_MILLIS, $c97e36c8d40a3851$export$a43a60ec723a90ee = $c97e36c8d40a3851$var$AWS_LAMBDA_FUNCTION_NAME, $c97e36c8d40a3851$export$34cc955357266287 = $c97e36c8d40a3851$var$AWS_LAMBDA_FUNCTION_VERSION, $c97e36c8d40a3851$export$d9dd218693ea9bba = $c97e36c8d40a3851$var$AWS_LAMBDA_INVOKED_ARN, $c97e36c8d40a3851$export$c9649b7156282a2f = $c97e36c8d40a3851$var$AWS_LAMBDA_INVOKED_FUNCTION_ARN, $c97e36c8d40a3851$export$daa8ce1f8adc553e = $c97e36c8d40a3851$var$AWS_LAMBDA_REMAINING_TIME_IN_MILLIS, $c97e36c8d40a3851$export$cb93c7b05db202cf = $c97e36c8d40a3851$var$AWS_LOG_GROUP_NAMES, $c97e36c8d40a3851$export$930f9bd3cc2e5b3d = $c97e36c8d40a3851$var$AWS_LOG_STREAM_NAMES, $c97e36c8d40a3851$export$48c6d4c44afdc0b = $c97e36c8d40a3851$var$AWS_REQUEST_EXTENDED_ID, $c97e36c8d40a3851$export$c78d41789fe4b1e4 = $c97e36c8d40a3851$var$AWS_REQUEST_ID, $c97e36c8d40a3851$export$f462d9921f1f7332 = $c97e36c8d40a3851$var$AWS_S3_BUCKET, $c97e36c8d40a3851$export$bc71f8df9a45e243 = $c97e36c8d40a3851$var$AWS_SECRETSMANAGER_SECRET_ARN, $c97e36c8d40a3851$export$ed840ec4a5f5d053 = $c97e36c8d40a3851$var$AWS_SNS_TOPIC_ARN, $c97e36c8d40a3851$export$c1a559a4f74a5e8e = $c97e36c8d40a3851$var$AWS_STEP_FUNCTIONS_ACTIVITY_ARN, $c97e36c8d40a3851$export$d1c007424092e3f5 = $c97e36c8d40a3851$var$AWS_STEP_FUNCTIONS_STATE_MACHINE_ARN, $c97e36c8d40a3851$export$9ebb466ce954c49c = $c97e36c8d40a3851$var$BLOCKED_MAIN_THREAD, $c97e36c8d40a3851$export$e9aafc7348984403 = $c97e36c8d40a3851$var$BROWSER_NAME, $c97e36c8d40a3851$export$faaa46964f075237 = $c97e36c8d40a3851$var$BROWSER_PERFORMANCE_NAVIGATION_ACTIVATION_START, $c97e36c8d40a3851$export$d28c4b3cc4431a87 = $c97e36c8d40a3851$var$BROWSER_PERFORMANCE_TIME_ORIGIN, $c97e36c8d40a3851$export$734b017b330c8fe6 = $c97e36c8d40a3851$var$BROWSER_REPORT_TYPE, $c97e36c8d40a3851$export$683ebdc48ba3758d = $c97e36c8d40a3851$var$BROWSER_SCRIPT_INVOKER, $c97e36c8d40a3851$export$be0263971250ef44 = $c97e36c8d40a3851$var$BROWSER_SCRIPT_INVOKER_TYPE, $c97e36c8d40a3851$export$36a0cbc35c405232 = $c97e36c8d40a3851$var$BROWSER_SCRIPT_SOURCE_CHAR_POSITION, $c97e36c8d40a3851$export$469f7765ba335497 = $c97e36c8d40a3851$var$BROWSER_VERSION, $c97e36c8d40a3851$export$fe6fe2b7af051610 = $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_CLS_REPORT_EVENT, $c97e36c8d40a3851$export$8345821877c4dfad = $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_CLS_SOURCE_KEY, $c97e36c8d40a3851$export$f6c188a7e02335cf = $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_CLS_SOURCE_KEY_BASE, $c97e36c8d40a3851$export$aaf709a8971e825f = $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_CLS_VALUE, $c97e36c8d40a3851$export$def01b82f8c092f7 = $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_FCP_VALUE, $c97e36c8d40a3851$export$23d4264c606a73a6 = $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_FP_VALUE, $c97e36c8d40a3851$export$af9ece53bb92f66b = $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_INP_VALUE, $c97e36c8d40a3851$export$25421625a565b69 = $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_LCP_ELEMENT, $c97e36c8d40a3851$export$ab0c90d873e69ccb = $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_LCP_ID, $c97e36c8d40a3851$export$538c05cc8cb2a2bb = $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_LCP_LOAD_TIME, $c97e36c8d40a3851$export$f86df4de196e1a7c = $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_LCP_RENDER_TIME, $c97e36c8d40a3851$export$51e8aa8c0d65e7b8 = $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_LCP_REPORT_EVENT, $c97e36c8d40a3851$export$99023486ecc470bd = $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_LCP_SIZE, $c97e36c8d40a3851$export$2f6c85eaf382e81 = $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_LCP_URL, $c97e36c8d40a3851$export$1158d57c0aed42be = $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_LCP_VALUE, $c97e36c8d40a3851$export$d85c4f947ab776e3 = $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_TTFB_REQUEST_TIME, $c97e36c8d40a3851$export$813ef8386d874918 = $c97e36c8d40a3851$var$BROWSER_WEB_VITAL_TTFB_VALUE, $c97e36c8d40a3851$export$7c2f74ff9251f64 = $c97e36c8d40a3851$var$CACHE_HIT, $c97e36c8d40a3851$export$993f84dab107b880 = $c97e36c8d40a3851$var$CACHE_ITEM_SIZE, $c97e36c8d40a3851$export$7b9c2315e94d8d2f = $c97e36c8d40a3851$var$CACHE_KEY, $c97e36c8d40a3851$export$f01e5cd42b9ec146 = $c97e36c8d40a3851$var$CACHE_OPERATION, $c97e36c8d40a3851$export$987f6b4367434b55 = $c97e36c8d40a3851$var$CACHE_TTL, $c97e36c8d40a3851$export$d9d145585d5022bb = $c97e36c8d40a3851$var$CACHE_WRITE, $c97e36c8d40a3851$export$44ffba16bd48dac6 = $c97e36c8d40a3851$var$CHANNEL, $c97e36c8d40a3851$export$3134892c5d2e251a = $c97e36c8d40a3851$var$CLIENT_ADDRESS, $c97e36c8d40a3851$export$8495028d10296058 = $c97e36c8d40a3851$var$CLIENT_PORT, $c97e36c8d40a3851$export$d6d0e4fcf46d490c = $c97e36c8d40a3851$var$CLOUDFLARE_D1_DURATION, $c97e36c8d40a3851$export$658dced473c19301 = $c97e36c8d40a3851$var$CLOUDFLARE_D1_QUERY_TYPE, $c97e36c8d40a3851$export$97b0f9c3fbe64076 = $c97e36c8d40a3851$var$CLOUDFLARE_D1_ROWS_READ, $c97e36c8d40a3851$export$cf2c95ed5efbe9eb = $c97e36c8d40a3851$var$CLOUDFLARE_D1_ROWS_WRITTEN, $c97e36c8d40a3851$export$880007904f61a388 = $c97e36c8d40a3851$var$CLOUDFLARE_DURABLE_OBJECT_QUERY_BINDINGS, $c97e36c8d40a3851$export$3e903b72d4d9e07d = $c97e36c8d40a3851$var$CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_READ, $c97e36c8d40a3851$export$34da07180e0e56af = $c97e36c8d40a3851$var$CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_WRITTEN, $c97e36c8d40a3851$export$c49aafdaeb061953 = $c97e36c8d40a3851$var$CLOUDFLARE_R2_BUCKET, $c97e36c8d40a3851$export$ceb762c61de2f17f = $c97e36c8d40a3851$var$CLOUDFLARE_R2_OPERATION, $c97e36c8d40a3851$export$a5f54ccfb28c0caf = $c97e36c8d40a3851$var$CLOUDFLARE_R2_REQUEST_DELIMITER, $c97e36c8d40a3851$export$1c86a56857b024db = $c97e36c8d40a3851$var$CLOUDFLARE_R2_REQUEST_KEY, $c97e36c8d40a3851$export$7598f3464be47440 = $c97e36c8d40a3851$var$CLOUDFLARE_R2_REQUEST_PART_NUMBER, $c97e36c8d40a3851$export$b673289c971fc0ae = $c97e36c8d40a3851$var$CLOUDFLARE_R2_REQUEST_PREFIX, $c97e36c8d40a3851$export$98b23f3e6f0c2a6f = $c97e36c8d40a3851$var$CLOUDFLARE_WORKFLOW_ATTEMPT, $c97e36c8d40a3851$export$6ddeaf0498614ebb = $c97e36c8d40a3851$var$CLOUDFLARE_WORKFLOW_RETRIES_BACKOFF, $c97e36c8d40a3851$export$97b78f78d64a7232 = $c97e36c8d40a3851$var$CLOUDFLARE_WORKFLOW_RETRIES_DELAY, $c97e36c8d40a3851$export$5147715be870fff7 = $c97e36c8d40a3851$var$CLOUDFLARE_WORKFLOW_RETRIES_LIMIT, $c97e36c8d40a3851$export$5276bb46e6096fba = $c97e36c8d40a3851$var$CLOUDFLARE_WORKFLOW_TIMEOUT, $c97e36c8d40a3851$export$cbcbc1f67a937cf3 = $c97e36c8d40a3851$var$CLOUD_ACCOUNT_ID, $c97e36c8d40a3851$export$226a2381b8f0cf78 = $c97e36c8d40a3851$var$CLOUD_AVAILABILITY_ZONE, $c97e36c8d40a3851$export$fd35512cae286064 = $c97e36c8d40a3851$var$CLOUD_PLATFORM, $c97e36c8d40a3851$export$de9bbf95ab1d81e = $c97e36c8d40a3851$var$CLOUD_PROVIDER, $c97e36c8d40a3851$export$47fb20e8d18d7d15 = $c97e36c8d40a3851$var$CLOUD_REGION, $c97e36c8d40a3851$export$9db7964e4b8cb849 = $c97e36c8d40a3851$var$CLOUD_RESOURCE_ID, $c97e36c8d40a3851$export$7139adf9d3bace41 = "cls", $c97e36c8d40a3851$export$8ac3d09060e7f25d = $c97e36c8d40a3851$var$CLS_SOURCE_KEY, $c97e36c8d40a3851$export$dad0e4778ea23971 = $c97e36c8d40a3851$var$CLS_SOURCE_KEY_BASE, $c97e36c8d40a3851$export$c14d903ccf9385a8 = $c97e36c8d40a3851$var$CODE_FILEPATH, $c97e36c8d40a3851$export$934cded0041affd7 = $c97e36c8d40a3851$var$CODE_FILE_PATH, $c97e36c8d40a3851$export$6386da1dcba88c9d = $c97e36c8d40a3851$var$CODE_FUNCTION, $c97e36c8d40a3851$export$a3371797e606e2 = $c97e36c8d40a3851$var$CODE_FUNCTION_NAME, $c97e36c8d40a3851$export$a5bbef0af83b23e5 = $c97e36c8d40a3851$var$CODE_LINENO, $c97e36c8d40a3851$export$91ed1f55874222a6 = $c97e36c8d40a3851$var$CODE_LINE_NUMBER, $c97e36c8d40a3851$export$23de81068d2aed1b = $c97e36c8d40a3851$var$CODE_NAMESPACE, $c97e36c8d40a3851$export$d738320e1fba9e9d = $c97e36c8d40a3851$var$CONNECTIONTYPE, $c97e36c8d40a3851$export$2eacdea75497e8a5 = $c97e36c8d40a3851$var$CONNECTION_RTT, $c97e36c8d40a3851$export$2bc3ea101f86c1d2 = $c97e36c8d40a3851$var$CULTURE_CALENDAR, $c97e36c8d40a3851$export$c54e27e8d90ee081 = $c97e36c8d40a3851$var$CULTURE_DISPLAY_NAME, $c97e36c8d40a3851$export$4943adcec371c2a6 = $c97e36c8d40a3851$var$CULTURE_IS_24_HOUR_FORMAT, $c97e36c8d40a3851$export$f000a5900d0480c2 = $c97e36c8d40a3851$var$CULTURE_LOCALE, $c97e36c8d40a3851$export$8f5234893868273b = $c97e36c8d40a3851$var$CULTURE_TIMEZONE, $c97e36c8d40a3851$export$1a35518f6e81e8c7 = $c97e36c8d40a3851$var$DB_COLLECTION_NAME, $c97e36c8d40a3851$export$a2d90911eaae60fc = $c97e36c8d40a3851$var$DB_DRIVER_NAME, $c97e36c8d40a3851$export$3c22ff8b64b8f565 = $c97e36c8d40a3851$var$DB_NAME, $c97e36c8d40a3851$export$b8019c0e2a5b5f0f = $c97e36c8d40a3851$var$DB_NAMESPACE, $c97e36c8d40a3851$export$8c11477e471467c8 = $c97e36c8d40a3851$var$DB_OPERATION, $c97e36c8d40a3851$export$92a96f6363488aee = $c97e36c8d40a3851$var$DB_OPERATION_BATCH_SIZE, $c97e36c8d40a3851$export$f91beb6088f9ded9 = $c97e36c8d40a3851$var$DB_OPERATION_NAME, $c97e36c8d40a3851$export$78bc7224576bf289 = $c97e36c8d40a3851$var$DB_QUERY_PARAMETER_KEY, $c97e36c8d40a3851$export$a8027e0ea0d93ca = $c97e36c8d40a3851$var$DB_QUERY_PARAMETER_KEY_BASE, $c97e36c8d40a3851$export$5e59d3aea52e5037 = $c97e36c8d40a3851$var$DB_QUERY_SUMMARY, $c97e36c8d40a3851$export$47e408be0da7933f = $c97e36c8d40a3851$var$DB_QUERY_TEXT, $c97e36c8d40a3851$export$d5772b934ca13e57 = $c97e36c8d40a3851$var$DB_REDIS_CONNECTION, $c97e36c8d40a3851$export$36e47f6a5777561d = $c97e36c8d40a3851$var$DB_REDIS_KEY, $c97e36c8d40a3851$export$e768cbc99cd68acf = $c97e36c8d40a3851$var$DB_REDIS_PARAMETERS, $c97e36c8d40a3851$export$dfcc6c69df1343f2 = $c97e36c8d40a3851$var$DB_RESPONSE_STATUS_CODE, $c97e36c8d40a3851$export$69b0a5d9226b5211 = $c97e36c8d40a3851$var$DB_SQL_BINDINGS, $c97e36c8d40a3851$export$da010a4f4fc971ae = $c97e36c8d40a3851$var$DB_STATEMENT, $c97e36c8d40a3851$export$5d515b35be0601a0 = $c97e36c8d40a3851$var$DB_STORED_PROCEDURE_NAME, $c97e36c8d40a3851$export$3e1b1037a315c5ca = $c97e36c8d40a3851$var$DB_SYSTEM, $c97e36c8d40a3851$export$847fdd494825f0fb = $c97e36c8d40a3851$var$DB_SYSTEM_NAME, $c97e36c8d40a3851$export$a9d76f26c6c730a9 = $c97e36c8d40a3851$var$DB_USER, $c97e36c8d40a3851$export$de03f86d1c9866ca = $c97e36c8d40a3851$var$DEVICEMEMORY, $c97e36c8d40a3851$export$65798ecab7eef8c = $c97e36c8d40a3851$var$DEVICE_ARCHS, $c97e36c8d40a3851$export$22aa61f48b9c79a0 = $c97e36c8d40a3851$var$DEVICE_BATTERY_LEVEL, $c97e36c8d40a3851$export$69f5fb98f5aed812 = $c97e36c8d40a3851$var$DEVICE_BATTERY_TEMPERATURE, $c97e36c8d40a3851$export$bdea5d1006fd280a = $c97e36c8d40a3851$var$DEVICE_BOOT_TIME, $c97e36c8d40a3851$export$f63a7230c5b1d609 = $c97e36c8d40a3851$var$DEVICE_BRAND, $c97e36c8d40a3851$export$6f25e59b05bb8e17 = $c97e36c8d40a3851$var$DEVICE_CHARGING, $c97e36c8d40a3851$export$a56ad13c4afc7421 = $c97e36c8d40a3851$var$DEVICE_CHIPSET, $c97e36c8d40a3851$export$d9ce89ce8912bf12 = $c97e36c8d40a3851$var$DEVICE_CLASS, $c97e36c8d40a3851$export$17094e5f380e4162 = $c97e36c8d40a3851$var$DEVICE_CONNECTION_TYPE, $c97e36c8d40a3851$export$28a0ffdf747973a0 = $c97e36c8d40a3851$var$DEVICE_CPU_DESCRIPTION, $c97e36c8d40a3851$export$5480ae1ba5d50bb9 = $c97e36c8d40a3851$var$DEVICE_EXTERNAL_FREE_STORAGE, $c97e36c8d40a3851$export$edc72ee4a17f5152 = $c97e36c8d40a3851$var$DEVICE_EXTERNAL_STORAGE_SIZE, $c97e36c8d40a3851$export$19e4df138d354f8b = $c97e36c8d40a3851$var$DEVICE_FAMILY, $c97e36c8d40a3851$export$92b0d20fa482b4b2 = $c97e36c8d40a3851$var$DEVICE_FREE_MEMORY, $c97e36c8d40a3851$export$3f638a793d61933f = $c97e36c8d40a3851$var$DEVICE_FREE_STORAGE, $c97e36c8d40a3851$export$3f511731cc3687d4 = $c97e36c8d40a3851$var$DEVICE_ID, $c97e36c8d40a3851$export$692b08741d6b6265 = $c97e36c8d40a3851$var$DEVICE_LOCALE, $c97e36c8d40a3851$export$cf67f8cb2324428e = $c97e36c8d40a3851$var$DEVICE_LOW_MEMORY, $c97e36c8d40a3851$export$9d4197c1ffc5f359 = $c97e36c8d40a3851$var$DEVICE_LOW_POWER_MODE, $c97e36c8d40a3851$export$509634fbff540e75 = $c97e36c8d40a3851$var$DEVICE_MANUFACTURER, $c97e36c8d40a3851$export$ccbc4fdff4b5eff5 = $c97e36c8d40a3851$var$DEVICE_MEMORY_ESTIMATED_CAPACITY, $c97e36c8d40a3851$export$e0cb371ca548b1d6 = $c97e36c8d40a3851$var$DEVICE_MEMORY_SIZE, $c97e36c8d40a3851$export$3c39026d09026bc2 = $c97e36c8d40a3851$var$DEVICE_MODEL, $c97e36c8d40a3851$export$bf9e8248cb72cf00 = $c97e36c8d40a3851$var$DEVICE_MODEL_ID, $c97e36c8d40a3851$export$1054f22a72121d0f = $c97e36c8d40a3851$var$DEVICE_NAME, $c97e36c8d40a3851$export$723b8a59dad2e467 = $c97e36c8d40a3851$var$DEVICE_ONLINE, $c97e36c8d40a3851$export$160081ff141bac8e = $c97e36c8d40a3851$var$DEVICE_ORIENTATION, $c97e36c8d40a3851$export$194f62c84d27310 = $c97e36c8d40a3851$var$DEVICE_PROCESSOR_COUNT, $c97e36c8d40a3851$export$7ed866d57b018d09 = $c97e36c8d40a3851$var$DEVICE_PROCESSOR_FREQUENCY, $c97e36c8d40a3851$export$d50bae4562e03e5 = $c97e36c8d40a3851$var$DEVICE_SCREEN_DENSITY, $c97e36c8d40a3851$export$649ea67a18fe8e8b = $c97e36c8d40a3851$var$DEVICE_SCREEN_DPI, $c97e36c8d40a3851$export$136a5c1b43caaccd = $c97e36c8d40a3851$var$DEVICE_SCREEN_HEIGHT_PIXELS, $c97e36c8d40a3851$export$e33a28ea554b6ddc = $c97e36c8d40a3851$var$DEVICE_SCREEN_WIDTH_PIXELS, $c97e36c8d40a3851$export$acbe2d25ac76ea64 = $c97e36c8d40a3851$var$DEVICE_SIMULATOR, $c97e36c8d40a3851$export$793c13e17d7e5e2b = $c97e36c8d40a3851$var$DEVICE_STORAGE_SIZE, $c97e36c8d40a3851$export$a5617e33b89fd956 = $c97e36c8d40a3851$var$DEVICE_THERMAL_STATE, $c97e36c8d40a3851$export$b51f82164fa31e07 = $c97e36c8d40a3851$var$DEVICE_TIMEZONE, $c97e36c8d40a3851$export$f2ef55183c04d202 = $c97e36c8d40a3851$var$DEVICE_USABLE_MEMORY, $c97e36c8d40a3851$export$7c98fc0c48a16b1c = $c97e36c8d40a3851$var$DIST, $c97e36c8d40a3851$export$f0511e328234ae83 = $c97e36c8d40a3851$var$EFFECTIVECONNECTIONTYPE, $c97e36c8d40a3851$export$be46596bc6608f3b = $c97e36c8d40a3851$var$ENVIRONMENT, $c97e36c8d40a3851$export$f215947b3d76a6b7 = $c97e36c8d40a3851$var$ERROR_TYPE, $c97e36c8d40a3851$export$89bbc91416db6670 = $c97e36c8d40a3851$var$EVENT_ID, $c97e36c8d40a3851$export$b4b5eff8a8712c89 = $c97e36c8d40a3851$var$EVENT_NAME, $c97e36c8d40a3851$export$f455969a57ab8a03 = $c97e36c8d40a3851$var$EXCEPTION_ESCAPED, $c97e36c8d40a3851$export$13f2f8f42af49cec = $c97e36c8d40a3851$var$EXCEPTION_MESSAGE, $c97e36c8d40a3851$export$cd357afe2ffdd2c3 = $c97e36c8d40a3851$var$EXCEPTION_STACKTRACE, $c97e36c8d40a3851$export$d9ca2a279a11be5e = $c97e36c8d40a3851$var$EXCEPTION_TYPE, $c97e36c8d40a3851$export$bbd59a8c7efad4c9 = $c97e36c8d40a3851$var$FAAS_COLDSTART, $c97e36c8d40a3851$export$8413282a17f1cda5 = $c97e36c8d40a3851$var$FAAS_CRON, $c97e36c8d40a3851$export$30d19ddc7705e7e8 = $c97e36c8d40a3851$var$FAAS_DURATION_IN_MS, $c97e36c8d40a3851$export$64a4f09e2444b3d = $c97e36c8d40a3851$var$FAAS_ENTRY_POINT, $c97e36c8d40a3851$export$645b039fe163809e = $c97e36c8d40a3851$var$FAAS_EXECUTION, $c97e36c8d40a3851$export$b23ef8b8ffa607e1 = $c97e36c8d40a3851$var$FAAS_ID, $c97e36c8d40a3851$export$8bf64516740c1369 = $c97e36c8d40a3851$var$FAAS_IDENTITY, $c97e36c8d40a3851$export$9a0dc8e612f3e10b = $c97e36c8d40a3851$var$FAAS_INVOCATION_ID, $c97e36c8d40a3851$export$abe90fedb3dddda2 = $c97e36c8d40a3851$var$FAAS_INVOKED_NAME, $c97e36c8d40a3851$export$4a19da9c85ed2ade = $c97e36c8d40a3851$var$FAAS_INVOKED_PROVIDER, $c97e36c8d40a3851$export$5e091479f094bdbc = $c97e36c8d40a3851$var$FAAS_INVOKED_REGION, $c97e36c8d40a3851$export$d70909b5aa96a79a = $c97e36c8d40a3851$var$FAAS_NAME, $c97e36c8d40a3851$export$651d142a8017d83d = $c97e36c8d40a3851$var$FAAS_TIME, $c97e36c8d40a3851$export$44382a010a9f7fcf = $c97e36c8d40a3851$var$FAAS_TRIGGER, $c97e36c8d40a3851$export$807abfdc6b7b9338 = $c97e36c8d40a3851$var$FAAS_VERSION, $c97e36c8d40a3851$export$31881d07f2569218 = "fcp", $c97e36c8d40a3851$export$e5bbf306deb709a6 = $c97e36c8d40a3851$var$FLAG_EVALUATION_KEY, $c97e36c8d40a3851$export$aa8721167c5c8d2d = $c97e36c8d40a3851$var$FLAG_EVALUATION_KEY_BASE, $c97e36c8d40a3851$export$757b93e5b3adc7cb = "fp", $c97e36c8d40a3851$export$f869eaa92db1dc9b = $c97e36c8d40a3851$var$FRAMES_DELAY, $c97e36c8d40a3851$export$5d1d761e41c32d9e = $c97e36c8d40a3851$var$FRAMES_FROZEN, $c97e36c8d40a3851$export$8aec72d9491f9399 = $c97e36c8d40a3851$var$FRAMES_FROZEN_RATE, $c97e36c8d40a3851$export$5562635d2be2ab25 = $c97e36c8d40a3851$var$FRAMES_SLOW, $c97e36c8d40a3851$export$2dc31837ce6f7a3d = $c97e36c8d40a3851$var$FRAMES_SLOW_RATE, $c97e36c8d40a3851$export$b561df15f64d32e3 = $c97e36c8d40a3851$var$FRAMES_TOTAL, $c97e36c8d40a3851$export$181f78b28f2ffa57 = $c97e36c8d40a3851$var$FS_ERROR, $c97e36c8d40a3851$export$6c97c77b89571c75 = $c97e36c8d40a3851$var$GCP_FUNCTION_CONTEXT_EVENT_ID, $c97e36c8d40a3851$export$51e431eaf1f9bf58 = $c97e36c8d40a3851$var$GCP_FUNCTION_CONTEXT_EVENT_TYPE, $c97e36c8d40a3851$export$71429c7ef7cb7063 = $c97e36c8d40a3851$var$GCP_FUNCTION_CONTEXT_ID, $c97e36c8d40a3851$export$99905d7583a6e8ac = $c97e36c8d40a3851$var$GCP_FUNCTION_CONTEXT_RESOURCE, $c97e36c8d40a3851$export$b6c4be74fd0c06bd = $c97e36c8d40a3851$var$GCP_FUNCTION_CONTEXT_SOURCE, $c97e36c8d40a3851$export$fd23e5b8d261a89 = $c97e36c8d40a3851$var$GCP_FUNCTION_CONTEXT_SPECVERSION, $c97e36c8d40a3851$export$25fabc9b3d1dd567 = $c97e36c8d40a3851$var$GCP_FUNCTION_CONTEXT_TIME, $c97e36c8d40a3851$export$41507f7b07dad151 = $c97e36c8d40a3851$var$GCP_FUNCTION_CONTEXT_TIMESTAMP, $c97e36c8d40a3851$export$1352f3699c35dd73 = $c97e36c8d40a3851$var$GCP_FUNCTION_CONTEXT_TYPE, $c97e36c8d40a3851$export$fd6c9d5c74d943ac = $c97e36c8d40a3851$var$GCP_PROJECT_ID, $c97e36c8d40a3851$export$c29634e3cf41e479 = $c97e36c8d40a3851$var$GEN_AI_AGENT_NAME, $c97e36c8d40a3851$export$e6a60882cce7a085 = $c97e36c8d40a3851$var$GEN_AI_CONTEXT_UTILIZATION, $c97e36c8d40a3851$export$6773c9098ba5e194 = $c97e36c8d40a3851$var$GEN_AI_CONTEXT_WINDOW_SIZE, $c97e36c8d40a3851$export$6ee6b62f50047686 = $c97e36c8d40a3851$var$GEN_AI_CONVERSATION_ID, $c97e36c8d40a3851$export$efac052bb3661242 = $c97e36c8d40a3851$var$GEN_AI_COST_CACHE_CREATION_INPUT_TOKENS, $c97e36c8d40a3851$export$7ccd63b9ca955862 = $c97e36c8d40a3851$var$GEN_AI_COST_CACHE_READ_INPUT_TOKENS, $c97e36c8d40a3851$export$50921df5a58cb3ef = $c97e36c8d40a3851$var$GEN_AI_COST_INPUT_TOKENS, $c97e36c8d40a3851$export$8e48efc7acb57a97 = $c97e36c8d40a3851$var$GEN_AI_COST_OUTPUT_TOKENS, $c97e36c8d40a3851$export$cea9121727113f77 = $c97e36c8d40a3851$var$GEN_AI_COST_REASONING_OUTPUT_TOKENS, $c97e36c8d40a3851$export$bed35ff7f9af3aaa = $c97e36c8d40a3851$var$GEN_AI_COST_TOTAL_TOKENS, $c97e36c8d40a3851$export$6b729e898b9067ce = $c97e36c8d40a3851$var$GEN_AI_EMBEDDINGS_INPUT, $c97e36c8d40a3851$export$984fbab9b52f7e24 = $c97e36c8d40a3851$var$GEN_AI_FUNCTION_ID, $c97e36c8d40a3851$export$9ea17906a87ada6f = $c97e36c8d40a3851$var$GEN_AI_INPUT_MESSAGES, $c97e36c8d40a3851$export$394b443aaff3ef92 = $c97e36c8d40a3851$var$GEN_AI_OPERATION_NAME, $c97e36c8d40a3851$export$6ddc374adbc06720 = $c97e36c8d40a3851$var$GEN_AI_OPERATION_TYPE, $c97e36c8d40a3851$export$ab8c7ebc9add56b2 = $c97e36c8d40a3851$var$GEN_AI_OUTPUT_MESSAGES, $c97e36c8d40a3851$export$40ecc5bcd633d1ee = $c97e36c8d40a3851$var$GEN_AI_PIPELINE_NAME, $c97e36c8d40a3851$export$86a8df7fff52fc69 = $c97e36c8d40a3851$var$GEN_AI_PROMPT, $c97e36c8d40a3851$export$cf2115d46768f4c5 = $c97e36c8d40a3851$var$GEN_AI_PROMPT_NAME, $c97e36c8d40a3851$export$3d7e036e195764db = $c97e36c8d40a3851$var$GEN_AI_PROVIDER_NAME, $c97e36c8d40a3851$export$60c1d11221608cee = $c97e36c8d40a3851$var$GEN_AI_REQUEST_AVAILABLE_TOOLS, $c97e36c8d40a3851$export$bc3cef164abbc42c = $c97e36c8d40a3851$var$GEN_AI_REQUEST_FREQUENCY_PENALTY, $c97e36c8d40a3851$export$43f9afb62cd79dec = $c97e36c8d40a3851$var$GEN_AI_REQUEST_MAX_TOKENS, $c97e36c8d40a3851$export$a5ab4ffc4765f75f = $c97e36c8d40a3851$var$GEN_AI_REQUEST_MESSAGES, $c97e36c8d40a3851$export$ccf46db9ab1743ec = $c97e36c8d40a3851$var$GEN_AI_REQUEST_MODEL, $c97e36c8d40a3851$export$76c1c247342d776 = $c97e36c8d40a3851$var$GEN_AI_REQUEST_PRESENCE_PENALTY, $c97e36c8d40a3851$export$92f5944f0b02c9fb = $c97e36c8d40a3851$var$GEN_AI_REQUEST_REASONING_EFFORT, $c97e36c8d40a3851$export$867eeefcb1c95b27 = $c97e36c8d40a3851$var$GEN_AI_REQUEST_SEED, $c97e36c8d40a3851$export$5ada4697ae6aa17e = $c97e36c8d40a3851$var$GEN_AI_REQUEST_STOP_SEQUENCES, $c97e36c8d40a3851$export$427122300e8d54d0 = $c97e36c8d40a3851$var$GEN_AI_REQUEST_TEMPERATURE, $c97e36c8d40a3851$export$bcea8881375c352f = $c97e36c8d40a3851$var$GEN_AI_REQUEST_TOP_K, $c97e36c8d40a3851$export$b867715f9a0c04e9 = $c97e36c8d40a3851$var$GEN_AI_REQUEST_TOP_P, $c97e36c8d40a3851$export$69878a39cbdbe097 = $c97e36c8d40a3851$var$GEN_AI_RESPONSE_FINISH_REASONS, $c97e36c8d40a3851$export$584c61a1b769552d = $c97e36c8d40a3851$var$GEN_AI_RESPONSE_ID, $c97e36c8d40a3851$export$8169ebcb0b0331dd = $c97e36c8d40a3851$var$GEN_AI_RESPONSE_MODEL, $c97e36c8d40a3851$export$2c9713b624877853 = $c97e36c8d40a3851$var$GEN_AI_RESPONSE_STREAMING, $c97e36c8d40a3851$export$45942692aeb454e0 = $c97e36c8d40a3851$var$GEN_AI_RESPONSE_TEXT, $c97e36c8d40a3851$export$8e5efeaa031210cd = $c97e36c8d40a3851$var$GEN_AI_RESPONSE_TIME_TO_FIRST_CHUNK, $c97e36c8d40a3851$export$35a62769ee05a05a = $c97e36c8d40a3851$var$GEN_AI_RESPONSE_TIME_TO_FIRST_TOKEN, $c97e36c8d40a3851$export$8ea4f7e986ca4b06 = $c97e36c8d40a3851$var$GEN_AI_RESPONSE_TOKENS_PER_SECOND, $c97e36c8d40a3851$export$d2fd9ecaff0285a4 = $c97e36c8d40a3851$var$GEN_AI_RESPONSE_TOOL_CALLS, $c97e36c8d40a3851$export$a6c8e656a4f9bb67 = $c97e36c8d40a3851$var$GEN_AI_SYSTEM, $c97e36c8d40a3851$export$352a8075b163d53 = $c97e36c8d40a3851$var$GEN_AI_SYSTEM_INSTRUCTIONS, $c97e36c8d40a3851$export$426d7b90ba5d79db = $c97e36c8d40a3851$var$GEN_AI_SYSTEM_MESSAGE, $c97e36c8d40a3851$export$f5a1ee40934d19ce = $c97e36c8d40a3851$var$GEN_AI_TOOL_CALL_ARGUMENTS, $c97e36c8d40a3851$export$1ba812a9756622ce = $c97e36c8d40a3851$var$GEN_AI_TOOL_CALL_RESULT, $c97e36c8d40a3851$export$351120039c36e03 = $c97e36c8d40a3851$var$GEN_AI_TOOL_DEFINITIONS, $c97e36c8d40a3851$export$d42aa25ca09e17c4 = $c97e36c8d40a3851$var$GEN_AI_TOOL_DESCRIPTION, $c97e36c8d40a3851$export$d268db29b88a4286 = $c97e36c8d40a3851$var$GEN_AI_TOOL_INPUT, $c97e36c8d40a3851$export$c5deb6018f2d6251 = $c97e36c8d40a3851$var$GEN_AI_TOOL_MESSAGE, $c97e36c8d40a3851$export$e06baa3034409453 = $c97e36c8d40a3851$var$GEN_AI_TOOL_NAME, $c97e36c8d40a3851$export$646fdb5910ce3931 = $c97e36c8d40a3851$var$GEN_AI_TOOL_OUTPUT, $c97e36c8d40a3851$export$662e3d2d4361e29b = $c97e36c8d40a3851$var$GEN_AI_TOOL_TYPE, $c97e36c8d40a3851$export$1de3962f221ba441 = $c97e36c8d40a3851$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS, $c97e36c8d40a3851$export$a4b3f0f5499c8738 = $c97e36c8d40a3851$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS, $c97e36c8d40a3851$export$1aecdac6cecbdc5b = $c97e36c8d40a3851$var$GEN_AI_USAGE_COMPLETION_TOKENS, $c97e36c8d40a3851$export$2eb2ab35b317a103 = $c97e36c8d40a3851$var$GEN_AI_USAGE_INPUT_TOKENS, $c97e36c8d40a3851$export$c7e14ea195ede241 = $c97e36c8d40a3851$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED, $c97e36c8d40a3851$export$41ac034e7b9725a2 = $c97e36c8d40a3851$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE, $c97e36c8d40a3851$export$9e521119d7751e37 = $c97e36c8d40a3851$var$GEN_AI_USAGE_OUTPUT_TOKENS, $c97e36c8d40a3851$export$cbac8f541a64a150 = $c97e36c8d40a3851$var$GEN_AI_USAGE_OUTPUT_TOKENS_REASONING, $c97e36c8d40a3851$export$93dd08efa94c9dd4 = $c97e36c8d40a3851$var$GEN_AI_USAGE_PROMPT_TOKENS, $c97e36c8d40a3851$export$183e3523dac20bca = $c97e36c8d40a3851$var$GEN_AI_USAGE_REASONING_OUTPUT_TOKENS, $c97e36c8d40a3851$export$3867ca1d8381d4e3 = $c97e36c8d40a3851$var$GEN_AI_USAGE_TOTAL_TOKENS, $c97e36c8d40a3851$export$11febcf9917c0057 = $c97e36c8d40a3851$var$GRAPHQL_DOCUMENT, $c97e36c8d40a3851$export$88ae1ee0c0a63398 = $c97e36c8d40a3851$var$GRAPHQL_OPERATION_NAME, $c97e36c8d40a3851$export$d5bd986d1f283f29 = $c97e36c8d40a3851$var$GRAPHQL_OPERATION_TYPE, $c97e36c8d40a3851$export$fc4a2d238535d998 = $c97e36c8d40a3851$var$HARDWARECONCURRENCY, $c97e36c8d40a3851$export$57e53a60bf563f41 = $c97e36c8d40a3851$var$HTTP_CLIENT_IP, $c97e36c8d40a3851$export$ffdb1464deb0eedb = $c97e36c8d40a3851$var$HTTP_DECODED_RESPONSE_CONTENT_LENGTH, $c97e36c8d40a3851$export$b52670c950fd640 = $c97e36c8d40a3851$var$HTTP_FLAVOR, $c97e36c8d40a3851$export$c499fd8f1db3d18e = $c97e36c8d40a3851$var$HTTP_FRAGMENT, $c97e36c8d40a3851$export$b2ee2242301eff05 = $c97e36c8d40a3851$var$HTTP_HOST, $c97e36c8d40a3851$export$2ebf9f7586f16841 = $c97e36c8d40a3851$var$HTTP_METHOD, $c97e36c8d40a3851$export$6e9ffd608b3e828b = $c97e36c8d40a3851$var$HTTP_QUERY, $c97e36c8d40a3851$export$b960c5a73a722e6c = $c97e36c8d40a3851$var$HTTP_REQUEST_BODY_DATA, $c97e36c8d40a3851$export$a7a850351369c77e = $c97e36c8d40a3851$var$HTTP_REQUEST_CONNECTION_END, $c97e36c8d40a3851$export$b18bca78f4736a94 = $c97e36c8d40a3851$var$HTTP_REQUEST_CONNECT_START, $c97e36c8d40a3851$export$61a0059f562fb6c2 = $c97e36c8d40a3851$var$HTTP_REQUEST_DOMAIN_LOOKUP_END, $c97e36c8d40a3851$export$7dc0d5aefb816d91 = $c97e36c8d40a3851$var$HTTP_REQUEST_DOMAIN_LOOKUP_START, $c97e36c8d40a3851$export$58f6db56c841bef6 = $c97e36c8d40a3851$var$HTTP_REQUEST_FETCH_START, $c97e36c8d40a3851$export$97a3da679f509d5 = $c97e36c8d40a3851$var$HTTP_REQUEST_HEADER_KEY, $c97e36c8d40a3851$export$c387ec65fd1c2638 = $c97e36c8d40a3851$var$HTTP_REQUEST_HEADER_KEY_BASE, $c97e36c8d40a3851$export$4d9db82211f308a4 = $c97e36c8d40a3851$var$HTTP_REQUEST_METHOD, $c97e36c8d40a3851$export$ee4948a3be025123 = $c97e36c8d40a3851$var$HTTP_REQUEST_REDIRECT_END, $c97e36c8d40a3851$export$e0021eb2979cddaa = $c97e36c8d40a3851$var$HTTP_REQUEST_REDIRECT_START, $c97e36c8d40a3851$export$7c0ac0c19a45beac = $c97e36c8d40a3851$var$HTTP_REQUEST_REQUEST_START, $c97e36c8d40a3851$export$6c32e9d84f534ee = $c97e36c8d40a3851$var$HTTP_REQUEST_RESEND_COUNT, $c97e36c8d40a3851$export$d1f9fbdb211dd29b = $c97e36c8d40a3851$var$HTTP_REQUEST_RESPONSE_END, $c97e36c8d40a3851$export$45e7eea99a17d6e4 = $c97e36c8d40a3851$var$HTTP_REQUEST_RESPONSE_START, $c97e36c8d40a3851$export$20ea34e16c0aa64f = $c97e36c8d40a3851$var$HTTP_REQUEST_SAME_ORIGIN, $c97e36c8d40a3851$export$8365b0f03557fae9 = $c97e36c8d40a3851$var$HTTP_REQUEST_SECURE_CONNECTION_START, $c97e36c8d40a3851$export$49ebbb9621675650 = $c97e36c8d40a3851$var$HTTP_REQUEST_TIME_TO_FIRST_BYTE, $c97e36c8d40a3851$export$842be66a901f093 = $c97e36c8d40a3851$var$HTTP_REQUEST_WORKER_START, $c97e36c8d40a3851$export$a9f5a6cb28adccb1 = $c97e36c8d40a3851$var$HTTP_RESPONSE_BODY_SIZE, $c97e36c8d40a3851$export$57b055d4bc586d67 = $c97e36c8d40a3851$var$HTTP_RESPONSE_CONTENT_LENGTH, $c97e36c8d40a3851$export$3ddfd660caa7bf7a = $c97e36c8d40a3851$var$HTTP_RESPONSE_HEADER_CONTENT_LENGTH, $c97e36c8d40a3851$export$fa7e1f5305153b3d = $c97e36c8d40a3851$var$HTTP_RESPONSE_HEADER_KEY, $c97e36c8d40a3851$export$5674ce9d013eb7bd = $c97e36c8d40a3851$var$HTTP_RESPONSE_HEADER_KEY_BASE, $c97e36c8d40a3851$export$6e8dc14cff6ccf72 = $c97e36c8d40a3851$var$HTTP_RESPONSE_SIZE, $c97e36c8d40a3851$export$afd59480458e1b57 = $c97e36c8d40a3851$var$HTTP_RESPONSE_STATUS_CODE, $c97e36c8d40a3851$export$48e61fb9bccccba9 = $c97e36c8d40a3851$var$HTTP_RESPONSE_TRANSFER_SIZE, $c97e36c8d40a3851$export$d3e674514dd3a3e1 = $c97e36c8d40a3851$var$HTTP_ROUTE, $c97e36c8d40a3851$export$97ad02b50c60ef68 = $c97e36c8d40a3851$var$HTTP_SCHEME, $c97e36c8d40a3851$export$61d053b1b63e82c4 = $c97e36c8d40a3851$var$HTTP_SERVER_NAME, $c97e36c8d40a3851$export$54256cce0d674dea = $c97e36c8d40a3851$var$HTTP_SERVER_REQUEST_TIME_IN_QUEUE, $c97e36c8d40a3851$export$8c01f0f407bcc5ca = $c97e36c8d40a3851$var$HTTP_STATUS_CODE, $c97e36c8d40a3851$export$be3f46982f6c7160 = $c97e36c8d40a3851$var$HTTP_TARGET, $c97e36c8d40a3851$export$778e4213e2788579 = $c97e36c8d40a3851$var$HTTP_URL, $c97e36c8d40a3851$export$8b48ca3594d2b172 = $c97e36c8d40a3851$var$HTTP_USER_AGENT, $c97e36c8d40a3851$export$8be180ec26319f9f = "id", $c97e36c8d40a3851$export$60eccaddefa8fc1c = "inp", $c97e36c8d40a3851$export$c99ce4fe37484d84 = $c97e36c8d40a3851$var$JSONRPC_PROTOCOL_VERSION, $c97e36c8d40a3851$export$fdf432fcac7d8f37 = $c97e36c8d40a3851$var$JSONRPC_REQUEST_ID, $c97e36c8d40a3851$export$4c21cc9cdf2f5dbd = $c97e36c8d40a3851$var$JVM_GC_ACTION, $c97e36c8d40a3851$export$dcc1eab7f3f31816 = $c97e36c8d40a3851$var$JVM_GC_NAME, $c97e36c8d40a3851$export$dcb7f1379b2b8f86 = $c97e36c8d40a3851$var$JVM_MEMORY_POOL_NAME, $c97e36c8d40a3851$export$53416edeea4c2d74 = $c97e36c8d40a3851$var$JVM_MEMORY_TYPE, $c97e36c8d40a3851$export$69f7e5d2b74c5c9e = $c97e36c8d40a3851$var$JVM_THREAD_DAEMON, $c97e36c8d40a3851$export$8e104aed582a26bc = $c97e36c8d40a3851$var$JVM_THREAD_STATE, $c97e36c8d40a3851$export$577047501949be9 = $c97e36c8d40a3851$var$KOA_NAME, $c97e36c8d40a3851$export$c4c45b599a2c15e = $c97e36c8d40a3851$var$KOA_TYPE, $c97e36c8d40a3851$export$361cb541700d648e = "lcp", $c97e36c8d40a3851$export$974f160e11f25731 = $c97e36c8d40a3851$var$LCP_ELEMENT, $c97e36c8d40a3851$export$7162f5c702b95903 = $c97e36c8d40a3851$var$LCP_ID, $c97e36c8d40a3851$export$a034d066a9090500 = $c97e36c8d40a3851$var$LCP_LOADTIME, $c97e36c8d40a3851$export$70938021e43e047c = $c97e36c8d40a3851$var$LCP_RENDERTIME, $c97e36c8d40a3851$export$5f6ac460012a73bb = $c97e36c8d40a3851$var$LCP_SIZE, $c97e36c8d40a3851$export$d8e498c1c670bcbf = $c97e36c8d40a3851$var$LCP_URL, $c97e36c8d40a3851$export$cc1a78a24d947903 = $c97e36c8d40a3851$var$LOGGER_NAME, $c97e36c8d40a3851$export$d29b927e0bb0ffea = $c97e36c8d40a3851$var$MCP_CANCELLED_REASON, $c97e36c8d40a3851$export$b3999cacef245779 = $c97e36c8d40a3851$var$MCP_CANCELLED_REQUEST_ID, $c97e36c8d40a3851$export$ff168b5f9cf9dcf6 = $c97e36c8d40a3851$var$MCP_CLIENT_NAME, $c97e36c8d40a3851$export$2ab876a45bd6e64 = $c97e36c8d40a3851$var$MCP_CLIENT_TITLE, $c97e36c8d40a3851$export$cb8027e4395c6c0e = $c97e36c8d40a3851$var$MCP_CLIENT_VERSION, $c97e36c8d40a3851$export$f5303d1bac3c2660 = $c97e36c8d40a3851$var$MCP_LIFECYCLE_PHASE, $c97e36c8d40a3851$export$6c463c5f3b00f64 = $c97e36c8d40a3851$var$MCP_LOGGING_DATA_TYPE, $c97e36c8d40a3851$export$e25d553065457cab = $c97e36c8d40a3851$var$MCP_LOGGING_LEVEL, $c97e36c8d40a3851$export$15d24c154ea8a56f = $c97e36c8d40a3851$var$MCP_LOGGING_LOGGER, $c97e36c8d40a3851$export$e5065789a6c415d0 = $c97e36c8d40a3851$var$MCP_LOGGING_MESSAGE, $c97e36c8d40a3851$export$62662c561d7c7835 = $c97e36c8d40a3851$var$MCP_METHOD_NAME, $c97e36c8d40a3851$export$218f394557fb0a5a = $c97e36c8d40a3851$var$MCP_PROGRESS_CURRENT, $c97e36c8d40a3851$export$2a5ff6de5448ecdf = $c97e36c8d40a3851$var$MCP_PROGRESS_MESSAGE, $c97e36c8d40a3851$export$9d23f3030ed2597e = $c97e36c8d40a3851$var$MCP_PROGRESS_PERCENTAGE, $c97e36c8d40a3851$export$a26ff217a6124160 = $c97e36c8d40a3851$var$MCP_PROGRESS_TOKEN, $c97e36c8d40a3851$export$c8072f5fcfdb5b77 = $c97e36c8d40a3851$var$MCP_PROGRESS_TOTAL, $c97e36c8d40a3851$export$c4e4b74f1ccf3d96 = $c97e36c8d40a3851$var$MCP_PROMPT_NAME, $c97e36c8d40a3851$export$328519d02a26ac41 = $c97e36c8d40a3851$var$MCP_PROMPT_RESULT_DESCRIPTION, $c97e36c8d40a3851$export$d2061b291c43d045 = $c97e36c8d40a3851$var$MCP_PROMPT_RESULT_MESSAGE_CONTENT, $c97e36c8d40a3851$export$d1f04dfd3d695286 = $c97e36c8d40a3851$var$MCP_PROMPT_RESULT_MESSAGE_COUNT, $c97e36c8d40a3851$export$234fbd86ea0f0bd8 = $c97e36c8d40a3851$var$MCP_PROMPT_RESULT_MESSAGE_ROLE, $c97e36c8d40a3851$export$e795000978a75b12 = $c97e36c8d40a3851$var$MCP_PROTOCOL_READY, $c97e36c8d40a3851$export$9f4683b4d1018ace = $c97e36c8d40a3851$var$MCP_PROTOCOL_VERSION, $c97e36c8d40a3851$export$e431b042fcdb1d63 = $c97e36c8d40a3851$var$MCP_REQUEST_ARGUMENT_KEY, $c97e36c8d40a3851$export$a453239171ac9a23 = $c97e36c8d40a3851$var$MCP_REQUEST_ARGUMENT_KEY_BASE, $c97e36c8d40a3851$export$3a7726a976c18d5f = $c97e36c8d40a3851$var$MCP_REQUEST_ARGUMENT_NAME, $c97e36c8d40a3851$export$7eca7a6c06843b93 = $c97e36c8d40a3851$var$MCP_REQUEST_ARGUMENT_URI, $c97e36c8d40a3851$export$f25c55f83e5b0672 = $c97e36c8d40a3851$var$MCP_REQUEST_ID, $c97e36c8d40a3851$export$9562bfac4eb079cb = $c97e36c8d40a3851$var$MCP_RESOURCE_PROTOCOL, $c97e36c8d40a3851$export$c276d164ff91d2f7 = $c97e36c8d40a3851$var$MCP_RESOURCE_URI, $c97e36c8d40a3851$export$2f3e0574f1a99754 = $c97e36c8d40a3851$var$MCP_SERVER_NAME, $c97e36c8d40a3851$export$15eecaab68167880 = $c97e36c8d40a3851$var$MCP_SERVER_TITLE, $c97e36c8d40a3851$export$513c47f6e194086a = $c97e36c8d40a3851$var$MCP_SERVER_VERSION, $c97e36c8d40a3851$export$a3f464c4d5cd9096 = $c97e36c8d40a3851$var$MCP_SESSION_ID, $c97e36c8d40a3851$export$ed366a03a2330b03 = $c97e36c8d40a3851$var$MCP_TOOL_NAME, $c97e36c8d40a3851$export$9b802c784f235e1d = $c97e36c8d40a3851$var$MCP_TOOL_RESULT_CONTENT, $c97e36c8d40a3851$export$add0fc8b8c5726a4 = $c97e36c8d40a3851$var$MCP_TOOL_RESULT_CONTENT_COUNT, $c97e36c8d40a3851$export$e7f32463f5bfd554 = $c97e36c8d40a3851$var$MCP_TOOL_RESULT_IS_ERROR, $c97e36c8d40a3851$export$f9346f394edf26a = $c97e36c8d40a3851$var$MCP_TRANSPORT, $c97e36c8d40a3851$export$16b917774e73ef92 = $c97e36c8d40a3851$var$MDC_KEY, $c97e36c8d40a3851$export$15d2b60bf3b65454 = "mdc", $c97e36c8d40a3851$export$db55eca5af256142 = $c97e36c8d40a3851$var$MESSAGING_BATCH_MESSAGE_COUNT, $c97e36c8d40a3851$export$967c74f8b1f3d35 = $c97e36c8d40a3851$var$MESSAGING_DESTINATION, $c97e36c8d40a3851$export$7c33ae67962515d1 = $c97e36c8d40a3851$var$MESSAGING_DESTINATION_CONNECTION, $c97e36c8d40a3851$export$9c69839b2d93489b = $c97e36c8d40a3851$var$MESSAGING_DESTINATION_NAME, $c97e36c8d40a3851$export$be22d22d4b6cf5d8 = $c97e36c8d40a3851$var$MESSAGING_MESSAGE_BODY_SIZE, $c97e36c8d40a3851$export$c529961b911626ac = $c97e36c8d40a3851$var$MESSAGING_MESSAGE_CONVERSATION_ID, $c97e36c8d40a3851$export$e39c4b15d2881f5 = $c97e36c8d40a3851$var$MESSAGING_MESSAGE_ENVELOPE_SIZE, $c97e36c8d40a3851$export$a8ca145161313e7 = $c97e36c8d40a3851$var$MESSAGING_MESSAGE_ID, $c97e36c8d40a3851$export$3c1204d03918d076 = $c97e36c8d40a3851$var$MESSAGING_MESSAGE_RECEIVE_LATENCY, $c97e36c8d40a3851$export$eaac3f141165e288 = $c97e36c8d40a3851$var$MESSAGING_MESSAGE_RETRY_COUNT, $c97e36c8d40a3851$export$4c7e6934714150e6 = $c97e36c8d40a3851$var$MESSAGING_OPERATION_NAME, $c97e36c8d40a3851$export$6f71f9711d666eb4 = $c97e36c8d40a3851$var$MESSAGING_OPERATION_TYPE, $c97e36c8d40a3851$export$2a3cd2bb71fb63a4 = $c97e36c8d40a3851$var$MESSAGING_RABBITMQ_DESTINATION_ROUTING_KEY, $c97e36c8d40a3851$export$55478a0b7d2ae98f = $c97e36c8d40a3851$var$MESSAGING_SYSTEM, $c97e36c8d40a3851$export$bed10c4da9b8eb0a = $c97e36c8d40a3851$var$METHOD, $c97e36c8d40a3851$export$a82607b6424c06c8 = $c97e36c8d40a3851$var$MIDDLEWARE_NAME, $c97e36c8d40a3851$export$6b081f3484c7f4e5 = $c97e36c8d40a3851$var$NAVIGATION_ORIGIN, $c97e36c8d40a3851$export$b7754d85fd39406c = $c97e36c8d40a3851$var$NAVIGATION_ROUTE_ID, $c97e36c8d40a3851$export$492856c046eb4728 = $c97e36c8d40a3851$var$NAVIGATION_TYPE, $c97e36c8d40a3851$export$c1678a2059fbe906 = $c97e36c8d40a3851$var$NEL_ELAPSED_TIME, $c97e36c8d40a3851$export$6d384a0bc1011c34 = $c97e36c8d40a3851$var$NEL_PHASE, $c97e36c8d40a3851$export$1499a7dbfc01e7d4 = $c97e36c8d40a3851$var$NEL_REFERRER, $c97e36c8d40a3851$export$cfcbff40019f0ff1 = $c97e36c8d40a3851$var$NEL_SAMPLING_FUNCTION, $c97e36c8d40a3851$export$27157b5f68e583af = $c97e36c8d40a3851$var$NEL_TYPE, $c97e36c8d40a3851$export$54bf5ed61532925d = $c97e36c8d40a3851$var$NETWORK_CONNECTION_EFFECTIVE_TYPE, $c97e36c8d40a3851$export$60ed0786292ace08 = $c97e36c8d40a3851$var$NETWORK_CONNECTION_RTT, $c97e36c8d40a3851$export$d770bfb8345e146 = $c97e36c8d40a3851$var$NETWORK_CONNECTION_TYPE, $c97e36c8d40a3851$export$bb73817f1290ad28 = $c97e36c8d40a3851$var$NETWORK_LOCAL_ADDRESS, $c97e36c8d40a3851$export$f201c980f2b75802 = $c97e36c8d40a3851$var$NETWORK_LOCAL_PORT, $c97e36c8d40a3851$export$b40e970572afd0ee = $c97e36c8d40a3851$var$NETWORK_PEER_ADDRESS, $c97e36c8d40a3851$export$8850630a3d343488 = $c97e36c8d40a3851$var$NETWORK_PEER_PORT, $c97e36c8d40a3851$export$fd0a39a918d6516f = $c97e36c8d40a3851$var$NETWORK_PROTOCOL_NAME, $c97e36c8d40a3851$export$e68ef41f8e0335bf = $c97e36c8d40a3851$var$NETWORK_PROTOCOL_VERSION, $c97e36c8d40a3851$export$5bff09650e762829 = $c97e36c8d40a3851$var$NETWORK_TRANSPORT, $c97e36c8d40a3851$export$21c1adce0e067f37 = $c97e36c8d40a3851$var$NETWORK_TYPE, $c97e36c8d40a3851$export$fed6ce86f48c84bc = $c97e36c8d40a3851$var$NET_HOST_IP, $c97e36c8d40a3851$export$500c2675137ac16e = $c97e36c8d40a3851$var$NET_HOST_NAME, $c97e36c8d40a3851$export$402c7728623fd8df = $c97e36c8d40a3851$var$NET_HOST_PORT, $c97e36c8d40a3851$export$15417259f4c0fe6b = $c97e36c8d40a3851$var$NET_PEER_IP, $c97e36c8d40a3851$export$2b3b7f579a727f45 = $c97e36c8d40a3851$var$NET_PEER_NAME, $c97e36c8d40a3851$export$514832a0b029734b = $c97e36c8d40a3851$var$NET_PEER_PORT, $c97e36c8d40a3851$export$b0522e6a14dec1a4 = $c97e36c8d40a3851$var$NET_PROTOCOL_NAME, $c97e36c8d40a3851$export$659ea19f71a7ee0b = $c97e36c8d40a3851$var$NET_PROTOCOL_VERSION, $c97e36c8d40a3851$export$1b61d972db315e73 = $c97e36c8d40a3851$var$NET_SOCK_FAMILY, $c97e36c8d40a3851$export$fb2970ee11a479ee = $c97e36c8d40a3851$var$NET_SOCK_HOST_ADDR, $c97e36c8d40a3851$export$920aceb2a8fad77e = $c97e36c8d40a3851$var$NET_SOCK_HOST_PORT, $c97e36c8d40a3851$export$48f8f6fbc999d187 = $c97e36c8d40a3851$var$NET_SOCK_PEER_ADDR, $c97e36c8d40a3851$export$eed590fa00a8223b = $c97e36c8d40a3851$var$NET_SOCK_PEER_NAME, $c97e36c8d40a3851$export$f2e5bb5cd4a130da = $c97e36c8d40a3851$var$NET_SOCK_PEER_PORT, $c97e36c8d40a3851$export$779ef03d633a9086 = $c97e36c8d40a3851$var$NET_TRANSPORT, $c97e36c8d40a3851$export$d98b87c8d53d0dbc = $c97e36c8d40a3851$var$OS_BUILD, $c97e36c8d40a3851$export$ca719aa57653a0a7 = $c97e36c8d40a3851$var$OS_BUILD_ID, $c97e36c8d40a3851$export$74b19c5f48270c05 = $c97e36c8d40a3851$var$OS_DESCRIPTION, $c97e36c8d40a3851$export$c351affe7e8098cb = $c97e36c8d40a3851$var$OS_KERNEL_VERSION, $c97e36c8d40a3851$export$be7cd6b3ae3ae765 = $c97e36c8d40a3851$var$OS_NAME, $c97e36c8d40a3851$export$ec182524c4c57275 = $c97e36c8d40a3851$var$OS_RAW_DESCRIPTION, $c97e36c8d40a3851$export$9e45758246a85b07 = $c97e36c8d40a3851$var$OS_ROOTED, $c97e36c8d40a3851$export$9fa5d5f0144954cb = $c97e36c8d40a3851$var$OS_THEME, $c97e36c8d40a3851$export$e66ba5bc4b978023 = $c97e36c8d40a3851$var$OS_TYPE, $c97e36c8d40a3851$export$2306e23cc611a36d = $c97e36c8d40a3851$var$OS_VERSION, $c97e36c8d40a3851$export$144f8c1fe01428db = $c97e36c8d40a3851$var$OTEL_KIND, $c97e36c8d40a3851$export$f303b2744d52121c = $c97e36c8d40a3851$var$OTEL_SCOPE_NAME, $c97e36c8d40a3851$export$866b2dbc7bf18ce6 = $c97e36c8d40a3851$var$OTEL_SCOPE_VERSION, $c97e36c8d40a3851$export$b4c85774878b4841 = $c97e36c8d40a3851$var$OTEL_STATUS_CODE, $c97e36c8d40a3851$export$1c967a71bc9a3077 = $c97e36c8d40a3851$var$OTEL_STATUS_DESCRIPTION, $c97e36c8d40a3851$export$5e3884a35a19eb90 = $c97e36c8d40a3851$var$PARAMS_KEY, $c97e36c8d40a3851$export$6e7ff99bb3259573 = $c97e36c8d40a3851$var$PARAMS_KEY_BASE, $c97e36c8d40a3851$export$7c932cba2d9e7a7 = $c97e36c8d40a3851$var$PERFORMANCE_ACTIVATIONSTART, $c97e36c8d40a3851$export$94091942edce0667 = $c97e36c8d40a3851$var$PERFORMANCE_TIMEORIGIN, $c97e36c8d40a3851$export$3671a8a524706a9d = $c97e36c8d40a3851$var$PREVIOUS_ROUTE, $c97e36c8d40a3851$export$c288888dc82d233f = $c97e36c8d40a3851$var$PROCESS_COMMAND_ARGS, $c97e36c8d40a3851$export$8ff188536cebc35 = $c97e36c8d40a3851$var$PROCESS_EXECUTABLE_NAME, $c97e36c8d40a3851$export$6407d78968c0eabe = $c97e36c8d40a3851$var$PROCESS_PID, $c97e36c8d40a3851$export$43e9fb9ec28d9743 = $c97e36c8d40a3851$var$PROCESS_RUNTIME_DESCRIPTION, $c97e36c8d40a3851$export$26f31d5c5c201739 = $c97e36c8d40a3851$var$PROCESS_RUNTIME_ENGINE_NAME, $c97e36c8d40a3851$export$bff85124d2d35b93 = $c97e36c8d40a3851$var$PROCESS_RUNTIME_ENGINE_VERSION, $c97e36c8d40a3851$export$495c671ed5a6408c = $c97e36c8d40a3851$var$PROCESS_RUNTIME_NAME, $c97e36c8d40a3851$export$54b3d4d5548c35c3 = $c97e36c8d40a3851$var$PROCESS_RUNTIME_VERSION, $c97e36c8d40a3851$export$2954db6444fe1fa8 = $c97e36c8d40a3851$var$QUERY_KEY, $c97e36c8d40a3851$export$15c1c974d16dd678 = $c97e36c8d40a3851$var$QUERY_KEY_BASE, $c97e36c8d40a3851$export$9be2ae89a1eac217 = $c97e36c8d40a3851$var$REACT_VERSION, $c97e36c8d40a3851$export$5c698591c0e586a2 = $c97e36c8d40a3851$var$RELEASE, $c97e36c8d40a3851$export$b711f2bb9c9a848a = $c97e36c8d40a3851$var$REMIX_ACTION_FORM_DATA_KEY, $c97e36c8d40a3851$export$1d3a8501efd30213 = $c97e36c8d40a3851$var$REMIX_ACTION_FORM_DATA_KEY_BASE, $c97e36c8d40a3851$export$cebaf684ced5a2c9 = $c97e36c8d40a3851$var$REPLAY_ID, $c97e36c8d40a3851$export$d4c658ecdcb7c78c = $c97e36c8d40a3851$var$RESOURCE_DEPLOYMENT_ENVIRONMENT, $c97e36c8d40a3851$export$b1b162b01baeb044 = $c97e36c8d40a3851$var$RESOURCE_DEPLOYMENT_ENVIRONMENT_NAME, $c97e36c8d40a3851$export$8be2d593d7f88ed8 = $c97e36c8d40a3851$var$RESOURCE_RENDER_BLOCKING_STATUS, $c97e36c8d40a3851$export$dbd0a3528a97ccc0 = $c97e36c8d40a3851$var$ROUTE, $c97e36c8d40a3851$export$66581dc6d3d083d1 = $c97e36c8d40a3851$var$RPC_GRPC_STATUS_CODE, $c97e36c8d40a3851$export$e545f99e7abcc499 = $c97e36c8d40a3851$var$RPC_METHOD, $c97e36c8d40a3851$export$7e1af5787f8c4aaa = $c97e36c8d40a3851$var$RPC_RESPONSE_STATUS_CODE, $c97e36c8d40a3851$export$186c94c351c54768 = $c97e36c8d40a3851$var$RPC_SERVICE, $c97e36c8d40a3851$export$2e3fd8dfcb16fe0c = $c97e36c8d40a3851$var$RPC_SYSTEM, $c97e36c8d40a3851$export$7eeeceaa1dbd7cd5 = $c97e36c8d40a3851$var$RPC_SYSTEM_NAME, $c97e36c8d40a3851$export$9d5bffdff936d554 = $c97e36c8d40a3851$var$RUNTIME_BUILD, $c97e36c8d40a3851$export$dc3a801c9a2c5b79 = $c97e36c8d40a3851$var$RUNTIME_NAME, $c97e36c8d40a3851$export$27933a9557f87e98 = $c97e36c8d40a3851$var$RUNTIME_RAW_DESCRIPTION, $c97e36c8d40a3851$export$eefa737b40a0d535 = $c97e36c8d40a3851$var$RUNTIME_VERSION, $c97e36c8d40a3851$export$92740ffbcb02553b = $c97e36c8d40a3851$var$SCORE_KEY, $c97e36c8d40a3851$export$500e89753f9f1008 = $c97e36c8d40a3851$var$SCORE_KEY_BASE, $c97e36c8d40a3851$export$d91a18e47fdddefd = $c97e36c8d40a3851$var$SCORE_RATIO_KEY, $c97e36c8d40a3851$export$eccbe6f20884ea7f = $c97e36c8d40a3851$var$SCORE_RATIO_KEY_BASE, $c97e36c8d40a3851$export$9e24f11d79141afb = $c97e36c8d40a3851$var$SCORE_TOTAL, $c97e36c8d40a3851$export$f0b96ad9586f8887 = $c97e36c8d40a3851$var$SCORE_WEIGHT_KEY, $c97e36c8d40a3851$export$8a92ed5d436a85c6 = $c97e36c8d40a3851$var$SCORE_WEIGHT_KEY_BASE, $c97e36c8d40a3851$export$edd59acdf7e86a71 = $c97e36c8d40a3851$var$SENTRY_ACTION, $c97e36c8d40a3851$export$ae81a1ae71952d50 = $c97e36c8d40a3851$var$SENTRY_BROWSER_NAME, $c97e36c8d40a3851$export$6101470cd57eac1b = $c97e36c8d40a3851$var$SENTRY_BROWSER_VERSION, $c97e36c8d40a3851$export$452c0aee9673fe67 = $c97e36c8d40a3851$var$SENTRY_CANCELLATION_REASON, $c97e36c8d40a3851$export$773dddd1e8667756 = $c97e36c8d40a3851$var$SENTRY_CATEGORY, $c97e36c8d40a3851$export$98815f8579a64a90 = $c97e36c8d40a3851$var$SENTRY_CLIENT_SAMPLE_RATE, $c97e36c8d40a3851$export$7bc4e27428665019 = $c97e36c8d40a3851$var$SENTRY_DESCRIPTION, $c97e36c8d40a3851$export$e7d7477fa9057ee2 = $c97e36c8d40a3851$var$SENTRY_DIST, $c97e36c8d40a3851$export$1f4267a3fc018448 = $c97e36c8d40a3851$var$SENTRY_DOMAIN, $c97e36c8d40a3851$export$c171cae150389952 = $c97e36c8d40a3851$var$SENTRY_DSC_ENVIRONMENT, $c97e36c8d40a3851$export$d9bb35e957b22c72 = $c97e36c8d40a3851$var$SENTRY_DSC_PROJECT_ID, $c97e36c8d40a3851$export$b3508a2c95f74e3d = $c97e36c8d40a3851$var$SENTRY_DSC_PUBLIC_KEY, $c97e36c8d40a3851$export$20bb272f4d21532d = $c97e36c8d40a3851$var$SENTRY_DSC_RELEASE, $c97e36c8d40a3851$export$d7e64fbd0102ce90 = $c97e36c8d40a3851$var$SENTRY_DSC_SAMPLED, $c97e36c8d40a3851$export$c17eae7e86dbba3c = $c97e36c8d40a3851$var$SENTRY_DSC_SAMPLE_RATE, $c97e36c8d40a3851$export$349603c0a9165744 = $c97e36c8d40a3851$var$SENTRY_DSC_TRACE_ID, $c97e36c8d40a3851$export$4dadf693741f0283 = $c97e36c8d40a3851$var$SENTRY_DSC_TRANSACTION, $c97e36c8d40a3851$export$6377864d12f7eeb3 = $c97e36c8d40a3851$var$SENTRY_ENVIRONMENT, $c97e36c8d40a3851$export$ba081af9585ed4 = $c97e36c8d40a3851$var$SENTRY_EXCLUSIVE_TIME, $c97e36c8d40a3851$export$7841dacb241485d0 = $c97e36c8d40a3851$var$SENTRY_GRAPHQL_OPERATION, $c97e36c8d40a3851$export$52c7044cf6301362 = $c97e36c8d40a3851$var$SENTRY_GROUP, $c97e36c8d40a3851$export$56ea1c9e44590e20 = $c97e36c8d40a3851$var$SENTRY_HTTP_PREFETCH, $c97e36c8d40a3851$export$7626e389d05f4c36 = $c97e36c8d40a3851$var$SENTRY_IDLE_SPAN_FINISH_REASON, $c97e36c8d40a3851$export$5e0a48187329b2e7 = $c97e36c8d40a3851$var$SENTRY_IS_REMOTE, $c97e36c8d40a3851$export$c322b150d7667841 = $c97e36c8d40a3851$var$SENTRY_KIND, $c97e36c8d40a3851$export$4a4797d3c962f753 = $c97e36c8d40a3851$var$SENTRY_MAIN_THREAD, $c97e36c8d40a3851$export$767524d5e72e2645 = $c97e36c8d40a3851$var$SENTRY_MESSAGE_PARAMETER_KEY, $c97e36c8d40a3851$export$497354ca7b0ee666 = $c97e36c8d40a3851$var$SENTRY_MESSAGE_TEMPLATE, $c97e36c8d40a3851$export$cbdc4ad11118116a = $c97e36c8d40a3851$var$SENTRY_METRIC_SOURCE, $c97e36c8d40a3851$export$5b890de778c4c2fe = $c97e36c8d40a3851$var$SENTRY_MOBILE, $c97e36c8d40a3851$export$a78d9803b5e0a83e = $c97e36c8d40a3851$var$SENTRY_MODULE_KEY, $c97e36c8d40a3851$export$df1b536467b3992a = $c97e36c8d40a3851$var$SENTRY_MODULE_KEY_BASE, $c97e36c8d40a3851$export$73104a329e205998 = $c97e36c8d40a3851$var$SENTRY_NEXTJS_SSR_FUNCTION_ROUTE, $c97e36c8d40a3851$export$5740e3da55330b0a = $c97e36c8d40a3851$var$SENTRY_NEXTJS_SSR_FUNCTION_TYPE, $c97e36c8d40a3851$export$8dcc2d92ff6d65da = $c97e36c8d40a3851$var$SENTRY_NORMALIZED_DB_QUERY, $c97e36c8d40a3851$export$e5f1321e53e24810 = $c97e36c8d40a3851$var$SENTRY_NORMALIZED_DB_QUERY_HASH, $c97e36c8d40a3851$export$56dd3098cbca7c8a = $c97e36c8d40a3851$var$SENTRY_NORMALIZED_DESCRIPTION, $c97e36c8d40a3851$export$aa7aff70e4380665 = $c97e36c8d40a3851$var$SENTRY_OBSERVED_TIMESTAMP_NANOS, $c97e36c8d40a3851$export$dacb7d452aa6bcaf = $c97e36c8d40a3851$var$SENTRY_OP, $c97e36c8d40a3851$export$15dfc6c5e8f9baf6 = $c97e36c8d40a3851$var$SENTRY_ORIGIN, $c97e36c8d40a3851$export$91ad03bba7909fb5 = $c97e36c8d40a3851$var$SENTRY_PLATFORM, $c97e36c8d40a3851$export$86128e6c0ab71d64 = $c97e36c8d40a3851$var$SENTRY_PROFILER_ID, $c97e36c8d40a3851$export$745b60c4819aec1d = $c97e36c8d40a3851$var$SENTRY_PROFILE_ID, $c97e36c8d40a3851$export$d2c893bfac1da9a1 = $c97e36c8d40a3851$var$SENTRY_RELEASE, $c97e36c8d40a3851$export$1c14ad02f9534b19 = $c97e36c8d40a3851$var$SENTRY_REPLAY_ID, $c97e36c8d40a3851$export$db3cb63e0594d014 = $c97e36c8d40a3851$var$SENTRY_REPLAY_IS_BUFFERING, $c97e36c8d40a3851$export$a65c9a0eba2c222d = $c97e36c8d40a3851$var$SENTRY_REPORT_EVENT, $c97e36c8d40a3851$export$68dbcca9c0e339ec = $c97e36c8d40a3851$var$SENTRY_SDK_INTEGRATIONS, $c97e36c8d40a3851$export$d59b669d4bb3f006 = $c97e36c8d40a3851$var$SENTRY_SDK_NAME, $c97e36c8d40a3851$export$4d88d347aa9667fc = $c97e36c8d40a3851$var$SENTRY_SDK_VERSION, $c97e36c8d40a3851$export$9943ffdcaa4bc506 = $c97e36c8d40a3851$var$SENTRY_SEGMENT_ID, $c97e36c8d40a3851$export$d4f25b923533dbba = $c97e36c8d40a3851$var$SENTRY_SEGMENT_NAME, $c97e36c8d40a3851$export$35f3396a1cdeea45 = $c97e36c8d40a3851$var$SENTRY_SERVER_SAMPLE_RATE, $c97e36c8d40a3851$export$80e399da474bc98d = $c97e36c8d40a3851$var$SENTRY_SOURCE, $c97e36c8d40a3851$export$e01809e2dbceac35 = $c97e36c8d40a3851$var$SENTRY_SPAN_SOURCE, $c97e36c8d40a3851$export$41900d5c4e8a9c68 = $c97e36c8d40a3851$var$SENTRY_STATUS, $c97e36c8d40a3851$export$362bb1cb0bb5ca03 = $c97e36c8d40a3851$var$SENTRY_STATUS_CODE, $c97e36c8d40a3851$export$6803ac54f919d9cc = $c97e36c8d40a3851$var$SENTRY_STATUS_MESSAGE, $c97e36c8d40a3851$export$72f5b47540331169 = $c97e36c8d40a3851$var$SENTRY_SVELTEKIT_NAVIGATION_FROM, $c97e36c8d40a3851$export$6c61a8c9aa5305cb = $c97e36c8d40a3851$var$SENTRY_SVELTEKIT_NAVIGATION_TO, $c97e36c8d40a3851$export$6b5244c457b68e65 = $c97e36c8d40a3851$var$SENTRY_SVELTEKIT_NAVIGATION_TYPE, $c97e36c8d40a3851$export$b7bd0c9a886f3414 = $c97e36c8d40a3851$var$SENTRY_THREAD_ID, $c97e36c8d40a3851$export$6b77f2bacac7c93d = $c97e36c8d40a3851$var$SENTRY_TIMESTAMP_SEQUENCE, $c97e36c8d40a3851$export$ddbc15c0e8e8a7ea = $c97e36c8d40a3851$var$SENTRY_TRACE_LIFECYCLE, $c97e36c8d40a3851$export$feb4fe753df28a82 = $c97e36c8d40a3851$var$SENTRY_TRACE_PARENT_SPAN_ID, $c97e36c8d40a3851$export$d6267756132e2175 = $c97e36c8d40a3851$var$SENTRY_TRACE_STATUS, $c97e36c8d40a3851$export$570ac5a3fd7e6cc6 = $c97e36c8d40a3851$var$SENTRY_TRANSACTION, $c97e36c8d40a3851$export$5b9a0015e1c530ed = $c97e36c8d40a3851$var$SENTRY_USER_EMAIL, $c97e36c8d40a3851$export$8bbff71c84508218 = $c97e36c8d40a3851$var$SENTRY_USER_GEO_CITY, $c97e36c8d40a3851$export$b55aa07a514a2430 = $c97e36c8d40a3851$var$SENTRY_USER_GEO_COUNTRY_CODE, $c97e36c8d40a3851$export$9927ad09f7c084dc = $c97e36c8d40a3851$var$SENTRY_USER_GEO_REGION, $c97e36c8d40a3851$export$52a07a35ff8ec6b6 = $c97e36c8d40a3851$var$SENTRY_USER_GEO_SUBDIVISION, $c97e36c8d40a3851$export$a10d277c42e6cae3 = $c97e36c8d40a3851$var$SENTRY_USER_ID, $c97e36c8d40a3851$export$cdc0ce5c66182801 = $c97e36c8d40a3851$var$SENTRY_USER_IP, $c97e36c8d40a3851$export$2504d4bd698dd962 = $c97e36c8d40a3851$var$SENTRY_USER_USERNAME, $c97e36c8d40a3851$export$9dc86f3b876e96ef = $c97e36c8d40a3851$var$SERVER_ADDRESS, $c97e36c8d40a3851$export$70ff7865f52549ae = $c97e36c8d40a3851$var$SERVER_NAME, $c97e36c8d40a3851$export$f77b53a42be6e6fd = $c97e36c8d40a3851$var$SERVER_PORT, $c97e36c8d40a3851$export$818eb7ab11414506 = $c97e36c8d40a3851$var$SERVICE_NAME, $c97e36c8d40a3851$export$829ef6b2e59d984d = $c97e36c8d40a3851$var$SERVICE_VERSION, $c97e36c8d40a3851$export$b30f4cb52c088a26 = $c97e36c8d40a3851$var$SESSION_ID, $c97e36c8d40a3851$export$335eace0ff1771cd = $c97e36c8d40a3851$var$STALL_PERCENTAGE, $c97e36c8d40a3851$export$374d88a2025416ac = $c97e36c8d40a3851$var$STALL_TOTAL_TIME, $c97e36c8d40a3851$export$bb7a91303551eb37 = $c97e36c8d40a3851$var$STATE_TYPE, $c97e36c8d40a3851$export$f132ea291a7db56b = $c97e36c8d40a3851$var$THREAD_ID, $c97e36c8d40a3851$export$f0abd4170bbd2468 = $c97e36c8d40a3851$var$THREAD_NAME, $c97e36c8d40a3851$export$50d00a157dc08581 = $c97e36c8d40a3851$var$TIMBER_TAG, $c97e36c8d40a3851$export$484576567a98833f = $c97e36c8d40a3851$var$TIME_TO_FULL_DISPLAY, $c97e36c8d40a3851$export$ec9e491e475d0c97 = $c97e36c8d40a3851$var$TIME_TO_INITIAL_DISPLAY, $c97e36c8d40a3851$export$a86c59c10992220f = $c97e36c8d40a3851$var$TRANSACTION, $c97e36c8d40a3851$export$e12f06597e992fde = $c97e36c8d40a3851$var$TRPC_PROCEDURE_PATH, $c97e36c8d40a3851$export$7ec54678ba28ea59 = $c97e36c8d40a3851$var$TRPC_PROCEDURE_TYPE, $c97e36c8d40a3851$export$433ba14c16717110 = $c97e36c8d40a3851$var$TTFB, $c97e36c8d40a3851$export$309ee349b8a537f = $c97e36c8d40a3851$var$TTFB_REQUESTTIME, $c97e36c8d40a3851$export$b87f371cbc396fcf = $c97e36c8d40a3851$var$TYPE, $c97e36c8d40a3851$export$60050fc49fe0e7e2 = $c97e36c8d40a3851$var$UI_COMPONENT_NAME, $c97e36c8d40a3851$export$348c8e2b37f276cd = $c97e36c8d40a3851$var$UI_CONTRIBUTES_TO_TTFD, $c97e36c8d40a3851$export$7f47e8a8b2d97cb2 = $c97e36c8d40a3851$var$UI_CONTRIBUTES_TO_TTID, $c97e36c8d40a3851$export$50d5adc4b543ce95 = $c97e36c8d40a3851$var$UI_ELEMENT_HEIGHT, $c97e36c8d40a3851$export$9221f1d2c934d9f = $c97e36c8d40a3851$var$UI_ELEMENT_ID, $c97e36c8d40a3851$export$3a56578b3ae09a02 = $c97e36c8d40a3851$var$UI_ELEMENT_IDENTIFIER, $c97e36c8d40a3851$export$e47b8dab9466c895 = $c97e36c8d40a3851$var$UI_ELEMENT_LOAD_TIME, $c97e36c8d40a3851$export$4ca52f75cf4889c5 = $c97e36c8d40a3851$var$UI_ELEMENT_PAINT_TYPE, $c97e36c8d40a3851$export$7343d7d72195067f = $c97e36c8d40a3851$var$UI_ELEMENT_RENDER_TIME, $c97e36c8d40a3851$export$f334f32f8d4d8063 = $c97e36c8d40a3851$var$UI_ELEMENT_TYPE, $c97e36c8d40a3851$export$c7bf2089e89a217c = $c97e36c8d40a3851$var$UI_ELEMENT_URL, $c97e36c8d40a3851$export$f514f97553a434b2 = $c97e36c8d40a3851$var$UI_ELEMENT_WIDTH, $c97e36c8d40a3851$export$61abde59b50deb8e = "url", $c97e36c8d40a3851$export$5a5ce44f9fb51f93 = $c97e36c8d40a3851$var$URL_DOMAIN, $c97e36c8d40a3851$export$7044ea8d89b6f59d = $c97e36c8d40a3851$var$URL_FRAGMENT, $c97e36c8d40a3851$export$40eacf1a072c9dbd = $c97e36c8d40a3851$var$URL_FULL, $c97e36c8d40a3851$export$4c1fa0ac0eff2ac = $c97e36c8d40a3851$var$URL_PATH, $c97e36c8d40a3851$export$5bee9450fe31dde1 = $c97e36c8d40a3851$var$URL_PATH_PARAMETER_KEY, $c97e36c8d40a3851$export$d0b571fb4406d953 = $c97e36c8d40a3851$var$URL_PATH_PARAMETER_KEY_BASE, $c97e36c8d40a3851$export$258b370e6c2b85d5 = $c97e36c8d40a3851$var$URL_PORT, $c97e36c8d40a3851$export$dc5e5523da291a4b = $c97e36c8d40a3851$var$URL_QUERY, $c97e36c8d40a3851$export$fd5a8904ab5abfe0 = $c97e36c8d40a3851$var$URL_SAME_ORIGIN, $c97e36c8d40a3851$export$1350d8937b0f26fb = $c97e36c8d40a3851$var$URL_SCHEME, $c97e36c8d40a3851$export$2a045f777fb349a8 = $c97e36c8d40a3851$var$URL_TEMPLATE, $c97e36c8d40a3851$export$8bb874585539a88f = $c97e36c8d40a3851$var$USER_AGENT_ORIGINAL, $c97e36c8d40a3851$export$17d3a50785727199 = $c97e36c8d40a3851$var$USER_EMAIL, $c97e36c8d40a3851$export$2931c570009689e = $c97e36c8d40a3851$var$USER_FULL_NAME, $c97e36c8d40a3851$export$199cbcedee735a43 = $c97e36c8d40a3851$var$USER_GEO_CITY, $c97e36c8d40a3851$export$4ba5bf9d4e3ed862 = $c97e36c8d40a3851$var$USER_GEO_COUNTRY_CODE, $c97e36c8d40a3851$export$674c01ec2f0b89c3 = $c97e36c8d40a3851$var$USER_GEO_REGION, $c97e36c8d40a3851$export$bda1686739fd61c7 = $c97e36c8d40a3851$var$USER_GEO_SUBDIVISION, $c97e36c8d40a3851$export$8d804148f485d54c = $c97e36c8d40a3851$var$USER_HASH, $c97e36c8d40a3851$export$212a8f1ea37518bd = $c97e36c8d40a3851$var$USER_ID, $c97e36c8d40a3851$export$c9ac0fee28245883 = $c97e36c8d40a3851$var$USER_IP_ADDRESS, $c97e36c8d40a3851$export$77078610759fe5f6 = $c97e36c8d40a3851$var$USER_NAME, $c97e36c8d40a3851$export$7c6317deeec7a6c1 = $c97e36c8d40a3851$var$USER_ROLES, $c97e36c8d40a3851$export$877ebf2e4ad81f03 = $c97e36c8d40a3851$var$VERCEL_BRANCH, $c97e36c8d40a3851$export$70b2343945496e1f = $c97e36c8d40a3851$var$VERCEL_BUILD_ID, $c97e36c8d40a3851$export$8415b56d2c6d2b1d = $c97e36c8d40a3851$var$VERCEL_DEPLOYMENT_ID, $c97e36c8d40a3851$export$cc81114a03caab18 = $c97e36c8d40a3851$var$VERCEL_DESTINATION, $c97e36c8d40a3851$export$bc14eb892daceb23 = $c97e36c8d40a3851$var$VERCEL_EDGE_TYPE, $c97e36c8d40a3851$export$3c973217450c3e9d = $c97e36c8d40a3851$var$VERCEL_ENTRYPOINT, $c97e36c8d40a3851$export$582c0b730ff1ddb9 = $c97e36c8d40a3851$var$VERCEL_EXECUTION_REGION, $c97e36c8d40a3851$export$b3edfb545b65f1c5 = $c97e36c8d40a3851$var$VERCEL_ID, $c97e36c8d40a3851$export$2593317d8731841c = $c97e36c8d40a3851$var$VERCEL_JA3_DIGEST, $c97e36c8d40a3851$export$8bb5bc1732aa41f = $c97e36c8d40a3851$var$VERCEL_JA4_DIGEST, $c97e36c8d40a3851$export$74a79c98b110b5b9 = $c97e36c8d40a3851$var$VERCEL_LOG_TYPE, $c97e36c8d40a3851$export$26461b03281b4db4 = $c97e36c8d40a3851$var$VERCEL_PATH, $c97e36c8d40a3851$export$eaea590d6d3dd93c = $c97e36c8d40a3851$var$VERCEL_PROJECT_ID, $c97e36c8d40a3851$export$af45365f70099379 = $c97e36c8d40a3851$var$VERCEL_PROJECT_NAME, $c97e36c8d40a3851$export$a49e732d34d5ba9b = $c97e36c8d40a3851$var$VERCEL_PROXY_CACHE_ID, $c97e36c8d40a3851$export$7c147fe246bc8bd3 = $c97e36c8d40a3851$var$VERCEL_PROXY_CLIENT_IP, $c97e36c8d40a3851$export$e5111b6070e1ee9e = $c97e36c8d40a3851$var$VERCEL_PROXY_HOST, $c97e36c8d40a3851$export$591cbfd403f8c8d = $c97e36c8d40a3851$var$VERCEL_PROXY_LAMBDA_REGION, $c97e36c8d40a3851$export$b1388db955bbb885 = $c97e36c8d40a3851$var$VERCEL_PROXY_METHOD, $c97e36c8d40a3851$export$e898d0e9e211abd9 = $c97e36c8d40a3851$var$VERCEL_PROXY_PATH, $c97e36c8d40a3851$export$ab6fee0e8a6ee069 = $c97e36c8d40a3851$var$VERCEL_PROXY_PATH_TYPE, $c97e36c8d40a3851$export$9786ad94c199ffbb = $c97e36c8d40a3851$var$VERCEL_PROXY_PATH_TYPE_VARIANT, $c97e36c8d40a3851$export$269890524eed693b = $c97e36c8d40a3851$var$VERCEL_PROXY_REFERER, $c97e36c8d40a3851$export$2ec623a8212d6b64 = $c97e36c8d40a3851$var$VERCEL_PROXY_REGION, $c97e36c8d40a3851$export$30e7673b01ff994e = $c97e36c8d40a3851$var$VERCEL_PROXY_RESPONSE_BYTE_SIZE, $c97e36c8d40a3851$export$9ea93477840812bf = $c97e36c8d40a3851$var$VERCEL_PROXY_SCHEME, $c97e36c8d40a3851$export$a6da0c365670c430 = $c97e36c8d40a3851$var$VERCEL_PROXY_STATUS_CODE, $c97e36c8d40a3851$export$7986b22da43f2885 = $c97e36c8d40a3851$var$VERCEL_PROXY_TIMESTAMP, $c97e36c8d40a3851$export$a9f943c7ceb3b42f = $c97e36c8d40a3851$var$VERCEL_PROXY_USER_AGENT, $c97e36c8d40a3851$export$dfe49501efcdffce = $c97e36c8d40a3851$var$VERCEL_PROXY_VERCEL_CACHE, $c97e36c8d40a3851$export$be465f50c92eb01d = $c97e36c8d40a3851$var$VERCEL_PROXY_VERCEL_ID, $c97e36c8d40a3851$export$c138d1796bb34999 = $c97e36c8d40a3851$var$VERCEL_PROXY_WAF_ACTION, $c97e36c8d40a3851$export$85a0016690a0ccf2 = $c97e36c8d40a3851$var$VERCEL_PROXY_WAF_RULE_ID, $c97e36c8d40a3851$export$883acab36ede4bfa = $c97e36c8d40a3851$var$VERCEL_REQUEST_ID, $c97e36c8d40a3851$export$9cfc88d203f9cdf1 = $c97e36c8d40a3851$var$VERCEL_SOURCE, $c97e36c8d40a3851$export$b3c6c599110d7bab = $c97e36c8d40a3851$var$VERCEL_STATUS_CODE, $c97e36c8d40a3851$export$247839c65766758 = $c97e36c8d40a3851$var$_AWS_KINESIS_STREAM_NAME, $c97e36c8d40a3851$export$f4d52b02df927d54 = $c97e36c8d40a3851$var$_AWS_REQUEST_ID, $c97e36c8d40a3851$export$df30ee8c5b5f1989 = $c97e36c8d40a3851$var$_HTTP_REQUEST_METHOD, $c97e36c8d40a3851$export$268a117c860fca6d = $c97e36c8d40a3851$var$_SENTRY_SEGMENT_ID; //# sourceMappingURL=attributes.cjs.map

});



parcelRegister("i98W3", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8DrvK = parcelRequire("8DrvK");

var $9Yejo = parcelRequire("9Yejo");

var $iS3Yk = parcelRequire("iS3Yk");

var $d7AD6 = parcelRequire("d7AD6");

var $1UPRv = parcelRequire("1UPRv");

var $eMfEg = parcelRequire("eMfEg");

var $8iRTV = parcelRequire("8iRTV");

var $1JmGh = parcelRequire("1JmGh");

var $cXaTJ = parcelRequire("cXaTJ");

var $1MCl5 = parcelRequire("1MCl5");

var $YfOkS = parcelRequire("YfOkS");
function $d35fffa076e956be$var$captureException(exception, hint) {
    return $8DrvK.getCurrentScope().captureException(exception, $1JmGh.parseEventHintOrCaptureContext(hint));
}
function $d35fffa076e956be$var$captureMessage(message, captureContext) {
    const level = typeof captureContext === "string" ? captureContext : void 0;
    const hint = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : void 0;
    return $8DrvK.getCurrentScope().captureMessage(message, level, hint);
}
function $d35fffa076e956be$var$captureEvent(event, hint) {
    return $8DrvK.getCurrentScope().captureEvent(event, hint);
}
function $d35fffa076e956be$var$setContext(name, context) {
    $8DrvK.getIsolationScope().setContext(name, context);
}
function $d35fffa076e956be$var$setExtras(extras) {
    $8DrvK.getIsolationScope().setExtras(extras);
}
function $d35fffa076e956be$var$setExtra(key, extra) {
    $8DrvK.getIsolationScope().setExtra(key, extra);
}
function $d35fffa076e956be$var$setTags(tags) {
    $8DrvK.getIsolationScope().setTags(tags);
}
function $d35fffa076e956be$var$setTag(key, value) {
    $8DrvK.getIsolationScope().setTag(key, value);
}
function $d35fffa076e956be$var$setAttributes(attributes) {
    $8DrvK.getIsolationScope().setAttributes(attributes);
}
function $d35fffa076e956be$var$setAttribute(key, value) {
    $8DrvK.getIsolationScope().setAttribute(key, value);
}
function $d35fffa076e956be$var$setUser(user) {
    $8DrvK.getIsolationScope().setUser(user);
}
function $d35fffa076e956be$var$setConversationId(conversationId) {
    $8DrvK.getIsolationScope().setConversationId(conversationId);
}
function $d35fffa076e956be$var$lastEventId() {
    return $8DrvK.getIsolationScope().lastEventId();
}
function $d35fffa076e956be$var$captureCheckIn(checkIn, upsertMonitorConfig) {
    const scope = $8DrvK.getCurrentScope();
    const client = $8DrvK.getClient();
    if (!client) $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return $8iRTV.uuid4();
}
function $d35fffa076e956be$var$withMonitor(monitorSlug, callback, upsertMonitorConfig) {
    function runCallback() {
        const checkInId = $d35fffa076e956be$var$captureCheckIn({
            monitorSlug: monitorSlug,
            status: "in_progress"
        }, upsertMonitorConfig);
        const now = $1MCl5.timestampInSeconds();
        function finishCheckIn(status) {
            $d35fffa076e956be$var$captureCheckIn({
                monitorSlug: monitorSlug,
                status: status,
                checkInId: checkInId,
                duration: $1MCl5.timestampInSeconds() - now
            });
        }
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn("error");
            throw e;
        }
        if ($eMfEg.isThenable(maybePromiseResult)) return maybePromiseResult.then((r)=>{
            finishCheckIn("ok");
            return r;
        }, (e)=>{
            finishCheckIn("error");
            throw e;
        });
        finishCheckIn("ok");
        return maybePromiseResult;
    }
    return $8DrvK.withIsolationScope(()=>upsertMonitorConfig?.isolateTrace ? $d7AD6.startNewTrace(runCallback) : runCallback());
}
async function $d35fffa076e956be$var$flush(timeout) {
    const client = $8DrvK.getClient();
    if (client) return client.flush(timeout);
    $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
async function $d35fffa076e956be$var$close(timeout) {
    const client = $8DrvK.getClient();
    if (client) return client.close(timeout);
    $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
function $d35fffa076e956be$var$isInitialized() {
    return !!$8DrvK.getClient();
}
function $d35fffa076e956be$var$isEnabled() {
    const client = $8DrvK.getClient();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
function $d35fffa076e956be$var$addEventProcessor(callback) {
    $8DrvK.getIsolationScope().addEventProcessor(callback);
}
function $d35fffa076e956be$var$startSession(context) {
    const isolationScope = $8DrvK.getIsolationScope();
    const { user: user } = $cXaTJ.getCombinedScopeData(isolationScope, $8DrvK.getCurrentScope());
    const { userAgent: userAgent } = $YfOkS.GLOBAL_OBJ.navigator || {};
    const session$1 = $iS3Yk.makeSession({
        user: user,
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === "ok") $iS3Yk.updateSession(currentSession, {
        status: "exited"
    });
    $d35fffa076e956be$var$endSession();
    isolationScope.setSession(session$1);
    return session$1;
}
function $d35fffa076e956be$var$endSession() {
    const isolationScope = $8DrvK.getIsolationScope();
    const currentScope = $8DrvK.getCurrentScope();
    const session$1 = currentScope.getSession() || isolationScope.getSession();
    if (session$1) $iS3Yk.closeSession(session$1);
    $d35fffa076e956be$var$_sendSessionUpdate();
    isolationScope.setSession();
}
function $d35fffa076e956be$var$_sendSessionUpdate() {
    const isolationScope = $8DrvK.getIsolationScope();
    const client = $8DrvK.getClient();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
function $d35fffa076e956be$var$captureSession(end = false) {
    if (end) {
        $d35fffa076e956be$var$endSession();
        return;
    }
    $d35fffa076e956be$var$_sendSessionUpdate();
}
module.exports.addEventProcessor = $d35fffa076e956be$var$addEventProcessor;
module.exports.captureCheckIn = $d35fffa076e956be$var$captureCheckIn;
module.exports.captureEvent = $d35fffa076e956be$var$captureEvent;
module.exports.captureException = $d35fffa076e956be$var$captureException;
module.exports.captureMessage = $d35fffa076e956be$var$captureMessage;
module.exports.captureSession = $d35fffa076e956be$var$captureSession;
module.exports.close = $d35fffa076e956be$var$close;
module.exports.endSession = $d35fffa076e956be$var$endSession;
module.exports.flush = $d35fffa076e956be$var$flush;
module.exports.isEnabled = $d35fffa076e956be$var$isEnabled;
module.exports.isInitialized = $d35fffa076e956be$var$isInitialized;
module.exports.lastEventId = $d35fffa076e956be$var$lastEventId;
module.exports.setAttribute = $d35fffa076e956be$var$setAttribute;
module.exports.setAttributes = $d35fffa076e956be$var$setAttributes;
module.exports.setContext = $d35fffa076e956be$var$setContext;
module.exports.setConversationId = $d35fffa076e956be$var$setConversationId;
module.exports.setExtra = $d35fffa076e956be$var$setExtra;
module.exports.setExtras = $d35fffa076e956be$var$setExtras;
module.exports.setTag = $d35fffa076e956be$var$setTag;
module.exports.setTags = $d35fffa076e956be$var$setTags;
module.exports.setUser = $d35fffa076e956be$var$setUser;
module.exports.startSession = $d35fffa076e956be$var$startSession;
module.exports.withMonitor = $d35fffa076e956be$var$withMonitor;

});
parcelRegister("1JmGh", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jf5XH = parcelRequire("jf5XH");

var $jukkv = parcelRequire("jukkv");

var $htzrJ = parcelRequire("htzrJ");

var $fmNiC = parcelRequire("fmNiC");

var $8iRTV = parcelRequire("8iRTV");

var $aaVDI = parcelRequire("aaVDI");

var $cXaTJ = parcelRequire("cXaTJ");

var $erV30 = parcelRequire("erV30");

var $kzgET = parcelRequire("kzgET");

var $1MCl5 = parcelRequire("1MCl5");
function $142b965b7ff37e7b$var$prepareEvent(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || $8iRTV.uuid4(),
        timestamp: event.timestamp || $1MCl5.dateTimestampInSeconds()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $142b965b7ff37e7b$var$applyClientOptions(prepared, options);
    $142b965b7ff37e7b$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit("applyFrameMetadata", event);
    if (event.type === void 0) $142b965b7ff37e7b$var$applyDebugIds(prepared, options.stackParser);
    const finalScope = $142b965b7ff37e7b$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) $8iRTV.addExceptionMechanism(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    const data = $cXaTJ.getCombinedScopeData(isolationScope, finalScope);
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    $cXaTJ.applyScopeDataToEvent(prepared, data);
    const eventProcessors$1 = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const isInternalException = hint.data && hint.data.__sentry__ === true;
    const result = isInternalException ? $kzgET.resolvedSyncPromise(prepared) : $jukkv.notifyEventProcessors(eventProcessors$1, prepared, hint);
    return result.then((evt)=>{
        if (evt) $142b965b7ff37e7b$var$applyDebugMeta(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $142b965b7ff37e7b$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
function $142b965b7ff37e7b$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength } = options;
    event.environment = event.environment || environment || $jf5XH.DEFAULT_ENVIRONMENT;
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url && maxValueLength) request.url = $erV30.truncate(request.url, maxValueLength);
    if (maxValueLength) event.exception?.values?.forEach((exception)=>{
        if (exception.value) exception.value = $erV30.truncate(exception.value, maxValueLength);
    });
}
function $142b965b7ff37e7b$var$applyDebugIds(event, stackParser) {
    const filenameDebugIdMap = $fmNiC.getFilenameToDebugIdMap(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
function $142b965b7ff37e7b$var$applyDebugMeta(event) {
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: debug_id
        });
    });
}
function $142b965b7ff37e7b$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
function $142b965b7ff37e7b$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: $aaVDI.normalize(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: $aaVDI.normalize(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: $aaVDI.normalize(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: $aaVDI.normalize(event.extra, depth, maxBreadth)
        }
    };
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        if (event.contexts.trace.data) normalized.contexts.trace.data = $aaVDI.normalize(event.contexts.trace.data, depth, maxBreadth);
    }
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: $aaVDI.normalize(span.data, depth, maxBreadth)
            }
        };
    });
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = $aaVDI.normalize(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $142b965b7ff37e7b$var$getFinalScope(scope$1, captureContext) {
    if (!captureContext) return scope$1;
    const finalScope = scope$1 ? scope$1.clone() : new $htzrJ.Scope();
    finalScope.update(captureContext);
    return finalScope;
}
function $142b965b7ff37e7b$var$parseEventHintOrCaptureContext(hint) {
    if (!hint) return void 0;
    if ($142b965b7ff37e7b$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($142b965b7ff37e7b$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $142b965b7ff37e7b$var$hintIsScopeOrFunction(hint) {
    return hint instanceof $htzrJ.Scope || typeof hint === "function";
}
const $142b965b7ff37e7b$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "propagationContext"
];
function $142b965b7ff37e7b$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$142b965b7ff37e7b$var$captureContextKeys.includes(key));
}
module.exports.applyClientOptions = $142b965b7ff37e7b$var$applyClientOptions;
module.exports.applyDebugIds = $142b965b7ff37e7b$var$applyDebugIds;
module.exports.applyDebugMeta = $142b965b7ff37e7b$var$applyDebugMeta;
module.exports.parseEventHintOrCaptureContext = $142b965b7ff37e7b$var$parseEventHintOrCaptureContext;
module.exports.prepareEvent = $142b965b7ff37e7b$var$prepareEvent;

});
parcelRegister("jukkv", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9Yejo = parcelRequire("9Yejo");

var $1UPRv = parcelRequire("1UPRv");

var $eMfEg = parcelRequire("eMfEg");

var $kzgET = parcelRequire("kzgET");
function $e30096bc3d787423$var$notifyEventProcessors(processors, event, hint, index = 0) {
    try {
        const result = $e30096bc3d787423$var$_notifyEventProcessors(event, hint, processors, index);
        return $eMfEg.isThenable(result) ? result : $kzgET.resolvedSyncPromise(result);
    } catch (error) {
        return $kzgET.rejectedSyncPromise(error);
    }
}
function $e30096bc3d787423$var$_notifyEventProcessors(event, hint, processors, index) {
    const processor = processors[index];
    if (!event || !processor) return event;
    const result = processor({
        ...event
    }, hint);
    $9Yejo.DEBUG_BUILD && result === null && $1UPRv.debug.log(`Event processor "${processor.id || "?"}" dropped event`);
    if ($eMfEg.isThenable(result)) return result.then((final)=>$e30096bc3d787423$var$_notifyEventProcessors(final, hint, processors, index + 1));
    return $e30096bc3d787423$var$_notifyEventProcessors(result, hint, processors, index + 1);
}
module.exports.notifyEventProcessors = $e30096bc3d787423$var$notifyEventProcessors;

});
parcelRegister("kzgET", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eMfEg = parcelRequire("eMfEg");
const $ef93ff9047fbb743$var$STATE_PENDING = 0;
const $ef93ff9047fbb743$var$STATE_RESOLVED = 1;
const $ef93ff9047fbb743$var$STATE_REJECTED = 2;
function $ef93ff9047fbb743$var$resolvedSyncPromise(value) {
    return new $ef93ff9047fbb743$var$SyncPromise((resolve)=>{
        resolve(value);
    });
}
function $ef93ff9047fbb743$var$rejectedSyncPromise(reason) {
    return new $ef93ff9047fbb743$var$SyncPromise((_, reject)=>{
        reject(reason);
    });
}
class $ef93ff9047fbb743$var$SyncPromise {
    constructor(executor){
        this._state = $ef93ff9047fbb743$var$STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $ef93ff9047fbb743$var$SyncPromise((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $ef93ff9047fbb743$var$SyncPromise((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $ef93ff9047fbb743$var$STATE_PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $ef93ff9047fbb743$var$STATE_RESOLVED) handler[1](this._value);
            if (this._state === $ef93ff9047fbb743$var$STATE_REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $ef93ff9047fbb743$var$STATE_PENDING) return;
            if ($eMfEg.isThenable(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($ef93ff9047fbb743$var$STATE_RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($ef93ff9047fbb743$var$STATE_REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}
module.exports.SyncPromise = $ef93ff9047fbb743$var$SyncPromise;
module.exports.rejectedSyncPromise = $ef93ff9047fbb743$var$rejectedSyncPromise;
module.exports.resolvedSyncPromise = $ef93ff9047fbb743$var$resolvedSyncPromise;

});


parcelRegister("fmNiC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $82RPZ = parcelRequire("82RPZ");

var $YfOkS = parcelRequire("YfOkS");
let $b2ff26ea3cb94c47$var$parsedStackResults;
let $b2ff26ea3cb94c47$var$lastSentryKeysCount;
let $b2ff26ea3cb94c47$var$lastNativeKeysCount;
let $b2ff26ea3cb94c47$var$cachedFilenameDebugIds;
function $b2ff26ea3cb94c47$var$getFilenameToDebugIdMap(stackParser) {
    const sentryDebugIdMap = $YfOkS.GLOBAL_OBJ._sentryDebugIds;
    const nativeDebugIdMap = $YfOkS.GLOBAL_OBJ._debugIds;
    if (!sentryDebugIdMap && !nativeDebugIdMap) return {};
    const sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
    const nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
    if ($b2ff26ea3cb94c47$var$cachedFilenameDebugIds && sentryDebugIdKeys.length === $b2ff26ea3cb94c47$var$lastSentryKeysCount && nativeDebugIdKeys.length === $b2ff26ea3cb94c47$var$lastNativeKeysCount) return $b2ff26ea3cb94c47$var$cachedFilenameDebugIds;
    $b2ff26ea3cb94c47$var$lastSentryKeysCount = sentryDebugIdKeys.length;
    $b2ff26ea3cb94c47$var$lastNativeKeysCount = nativeDebugIdKeys.length;
    $b2ff26ea3cb94c47$var$cachedFilenameDebugIds = {};
    if (!$b2ff26ea3cb94c47$var$parsedStackResults) $b2ff26ea3cb94c47$var$parsedStackResults = {};
    const processDebugIds = (debugIdKeys, debugIdMap)=>{
        for (const key of debugIdKeys){
            const debugId = debugIdMap[key];
            const result = $b2ff26ea3cb94c47$var$parsedStackResults?.[key];
            if (result && $b2ff26ea3cb94c47$var$cachedFilenameDebugIds && debugId) {
                $b2ff26ea3cb94c47$var$cachedFilenameDebugIds[result[0]] = debugId;
                if ($b2ff26ea3cb94c47$var$parsedStackResults) $b2ff26ea3cb94c47$var$parsedStackResults[key] = [
                    result[0],
                    debugId
                ];
            } else if (debugId) {
                const parsedStack = stackParser(key);
                for(let i = parsedStack.length - 1; i >= 0; i--){
                    const stackFrame = parsedStack[i];
                    const filename = stackFrame?.filename;
                    if (filename && $b2ff26ea3cb94c47$var$cachedFilenameDebugIds && $b2ff26ea3cb94c47$var$parsedStackResults) {
                        $b2ff26ea3cb94c47$var$cachedFilenameDebugIds[filename] = debugId;
                        $b2ff26ea3cb94c47$var$parsedStackResults[key] = [
                            filename,
                            debugId
                        ];
                        break;
                    }
                }
            }
        }
    };
    if (sentryDebugIdMap) processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
    if (nativeDebugIdMap) processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
    return $b2ff26ea3cb94c47$var$cachedFilenameDebugIds;
}
function $b2ff26ea3cb94c47$var$getDebugImagesForResources(stackParser, resource_paths) {
    const filenameDebugIdMap = $b2ff26ea3cb94c47$var$getFilenameToDebugIdMap(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths){
        const normalizedPath = $82RPZ.normalizeStackTracePath(path);
        if (normalizedPath && filenameDebugIdMap[normalizedPath]) images.push({
            type: "sourcemap",
            code_file: path,
            debug_id: filenameDebugIdMap[normalizedPath]
        });
    }
    return images;
}
module.exports.getDebugImagesForResources = $b2ff26ea3cb94c47$var$getDebugImagesForResources;
module.exports.getFilenameToDebugIdMap = $b2ff26ea3cb94c47$var$getFilenameToDebugIdMap;

});



parcelRegister("4bnGa", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6FBPf = parcelRequire("6FBPf");

var $b3Isg = parcelRequire("b3Isg");

var $5wKGb = parcelRequire("5wKGb");

var $1xFq0 = parcelRequire("1xFq0");
function $30ba8eb58c492ae9$var$waitForTracingChannelBinding(callback, retries = 1) {
    const binding = $1xFq0.getAsyncContextStrategy($6FBPf.getMainCarrier()).getTracingChannelBinding?.();
    if (binding) {
        callback();
        return;
    }
    if (!retries) return;
    $5wKGb.safeUnref(setTimeout(()=>{
        $30ba8eb58c492ae9$var$waitForTracingChannelBinding(callback, retries - 1);
    }, 1));
}
function $30ba8eb58c492ae9$var$_INTERNAL_createTracingChannelBinding(asyncLocalStorage, getScopes) {
    return {
        asyncLocalStorage: asyncLocalStorage,
        getStoreWithActiveSpan: (span)=>{
            const { scope: scope, isolationScope: isolationScope } = getScopes();
            const activeScope = scope.clone();
            $b3Isg._setSpanForScope(activeScope, span);
            return {
                scope: activeScope,
                isolationScope: isolationScope
            };
        }
    };
}
module.exports._INTERNAL_createTracingChannelBinding = $30ba8eb58c492ae9$var$_INTERNAL_createTracingChannelBinding;
module.exports.waitForTracingChannelBinding = $30ba8eb58c492ae9$var$waitForTracingChannelBinding;

});
parcelRegister("5wKGb", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $40642678f51eaddf$var$safeUnref(timer) {
    if (typeof timer === "object" && typeof timer.unref === "function") timer.unref();
    return timer;
}
module.exports.safeUnref = $40642678f51eaddf$var$safeUnref;

});


parcelRegister("bsUcA", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dXYuT = parcelRequire("dXYuT");
const $858de7ccf1222da4$var$SENTRY_API_VERSION = "7";
function $858de7ccf1222da4$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
function $858de7ccf1222da4$var$_getIngestEndpoint(dsn) {
    return `${$858de7ccf1222da4$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
function $858de7ccf1222da4$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $858de7ccf1222da4$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
function $858de7ccf1222da4$var$getEnvelopeEndpointWithUrlEncodedAuth(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$858de7ccf1222da4$var$_getIngestEndpoint(dsn)}?${$858de7ccf1222da4$var$_encodedAuth(dsn, sdkInfo)}`;
}
function $858de7ccf1222da4$var$getReportDialogEndpoint(dsnLike, dialogOptions) {
    const dsn$1 = $dXYuT.makeDsn(dsnLike);
    if (!dsn$1) return "";
    const endpoint = `${$858de7ccf1222da4$var$getBaseApiEndpoint(dsn$1)}embed/error-page/`;
    let encodedOptions = `dsn=${$dXYuT.dsnToString(dsn$1)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}
module.exports.SENTRY_API_VERSION = $858de7ccf1222da4$var$SENTRY_API_VERSION;
module.exports.getEnvelopeEndpointWithUrlEncodedAuth = $858de7ccf1222da4$var$getEnvelopeEndpointWithUrlEncodedAuth;
module.exports.getReportDialogEndpoint = $858de7ccf1222da4$var$getReportDialogEndpoint;

});

parcelRegister("3XVPB", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bsUcA = parcelRequire("bsUcA");

var $jf5XH = parcelRequire("jf5XH");

var $8DrvK = parcelRequire("8DrvK");

var $9Yejo = parcelRequire("9Yejo");

var $aRHOP = parcelRequire("aRHOP");

var $k2EST = parcelRequire("k2EST");

var $44TbO = parcelRequire("44TbO");

var $dpToc = parcelRequire("dpToc");

var $iS3Yk = parcelRequire("iS3Yk");

var $boK9h = parcelRequire("boK9h");

var $5ob0u = parcelRequire("5ob0u");

var $jp1pQ = parcelRequire("jp1pQ");

var $dXGj2 = parcelRequire("dXGj2");

var $gFX5W = parcelRequire("gFX5W");

var $1UPRv = parcelRequire("1UPRv");

var $dXYuT = parcelRequire("dXYuT");

var $5gI17 = parcelRequire("5gI17");

var $86e6R = parcelRequire("86e6R");

var $eMfEg = parcelRequire("eMfEg");

var $abhMj = parcelRequire("abhMj");

var $8iRTV = parcelRequire("8iRTV");

var $ljBvc = parcelRequire("ljBvc");

var $1JmGh = parcelRequire("1JmGh");

var $75YtR = parcelRequire("75YtR");

var $8odom = parcelRequire("8odom");

var $2aQlx = parcelRequire("2aQlx");

var $eXvrd = parcelRequire("eXvrd");

var $5wKGb = parcelRequire("5wKGb");

var $dTiHO = parcelRequire("dTiHO");

var $csycH = parcelRequire("csycH");
const $2e33bde214a8b335$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $2e33bde214a8b335$var$MISSING_RELEASE_FOR_SESSION_ERROR = "Discarded session because of missing or non-string release";
const $2e33bde214a8b335$var$INTERNAL_ERROR_SYMBOL = /* @__PURE__ */ Symbol.for("SentryInternalError");
const $2e33bde214a8b335$var$DO_NOT_SEND_EVENT_SYMBOL = /* @__PURE__ */ Symbol.for("SentryDoNotSendEventError");
const $2e33bde214a8b335$var$DEFAULT_FLUSH_INTERVAL = 5e3;
function $2e33bde214a8b335$var$_makeInternalError(message) {
    return {
        message: message,
        [$2e33bde214a8b335$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $2e33bde214a8b335$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$2e33bde214a8b335$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $2e33bde214a8b335$var$_isInternalError(error) {
    return $eMfEg.isObjectLike(error) && $2e33bde214a8b335$var$INTERNAL_ERROR_SYMBOL in error;
}
function $2e33bde214a8b335$var$_isDoNotSendEventError(error) {
    return $eMfEg.isObjectLike(error) && $2e33bde214a8b335$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
function $2e33bde214a8b335$var$setupWeightBasedFlushing(client, afterCaptureHook, flushHook, estimateSizeFn, flushFn) {
    let weight = 0;
    let flushTimeout;
    let isTimerActive = false;
    client.on(flushHook, ()=>{
        weight = 0;
        clearTimeout(flushTimeout);
        isTimerActive = false;
    });
    client.on(afterCaptureHook, (item)=>{
        weight += estimateSizeFn(item);
        if (weight >= 8e5) flushFn(client);
        else if (!isTimerActive) {
            const flushInterval = client.getOptions()._flushInterval ?? $2e33bde214a8b335$var$DEFAULT_FLUSH_INTERVAL;
            if (flushInterval > 0) {
                isTimerActive = true;
                flushTimeout = $5wKGb.safeUnref(setTimeout(()=>{
                    flushFn(client);
                }, flushInterval));
            }
        }
    });
    client.on("flush", ()=>{
        flushFn(client);
    });
}
class $2e33bde214a8b335$var$Client {
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        this._promiseBuffer = $75YtR.makePromiseBuffer(options.transportOptions?.bufferSize ?? $dXGj2.DEFAULT_TRANSPORT_BUFFER_SIZE);
        this._dataCollection = $csycH.resolveDataCollectionOptions(options);
        if (options.dsn) this._dsn = $dXYuT.makeDsn(options.dsn);
        else $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = $bsUcA.getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : void 0);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
        this._options.enableLogs = this._options.enableLogs ?? this._options._experiments?.enableLogs ?? true;
        if (this._options.enableLogs) $2e33bde214a8b335$var$setupWeightBasedFlushing(this, "afterCaptureLog", "flushLogs", $2e33bde214a8b335$var$estimateLogSizeInBytes, $44TbO._INTERNAL_flushLogsBuffer);
        const enableMetrics = this._options.enableMetrics ?? this._options._experiments?.enableMetrics ?? true;
        if (enableMetrics) $2e33bde214a8b335$var$setupWeightBasedFlushing(this, "afterCaptureMetric", "flushMetrics", $2e33bde214a8b335$var$estimateMetricSizeInBytes, $dpToc._INTERNAL_flushMetricsBuffer);
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = $8iRTV.uuid4();
        if ($8iRTV.checkOrSetAlreadyCaught(exception)) {
            $9Yejo.DEBUG_BUILD && $1UPRv.debug.log($2e33bde214a8b335$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(()=>this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)).then((res)=>res), "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: $8iRTV.uuid4(),
            ...hint
        };
        const eventMessage = $eMfEg.isParameterizedString(message) ? message : String(message);
        const isMessage = $eMfEg.isPrimitive(message);
        const promisedEvent = isMessage ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(()=>promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)), isMessage ? "unknown" : "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = $8iRTV.uuid4();
        if (hint?.originalException && $8iRTV.checkOrSetAlreadyCaught(hint.originalException)) {
            $9Yejo.DEBUG_BUILD && $1UPRv.debug.log($2e33bde214a8b335$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        const dataCategory = $2e33bde214a8b335$var$getDataCategoryByType(event.type);
        this._process(()=>this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope), dataCategory);
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session$1) {
        this.sendSession(session$1);
        $iS3Yk.updateSession(session$1, {
            init: false
        });
    }
    /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the resolved data collection configuration.
   */ getDataCollectionOptions() {
        return this._dataCollection;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async flush(timeout) {
        const transport = this._transport;
        this.emit("flush");
        if (!transport) return true;
        const clientFinished = await this._isClientDoneProcessing(timeout);
        const transportFlushed = await transport.flush(timeout);
        return clientFinished && transportFlushed;
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async close(timeout) {
        const result = await this.flush(timeout);
        this.getOptions().enabled = false;
        this.emit("close");
        return result;
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith("Spotlight"))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the names of all installed integrations.
   */ getIntegrationNames() {
        return Object.keys(this._integrations);
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration$1) {
        const isAlreadyInstalled = this._integrations[integration$1.name];
        if (!isAlreadyInstalled && integration$1.beforeSetup) integration$1.beforeSetup(this);
        $k2EST.setupIntegration(this, integration$1, this._integrations);
        if (!isAlreadyInstalled) $k2EST.afterSetupIntegrations(this, [
            integration$1
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        const genAiSpanItem = $jp1pQ.extractGenAiSpansFromEvent(event, this);
        let env = $aRHOP.createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = $5gI17.addItemToEnvelope(env, $5gI17.createAttachmentEnvelopeItem(attachment));
        if (genAiSpanItem) env = $5gI17.addItemToEnvelope(env, genAiSpanItem);
        this.sendEnvelope(env).then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse));
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        const { release: clientReleaseOption, environment: clientEnvironmentOption = $jf5XH.DEFAULT_ENVIRONMENT } = this._options;
        if ("aggregates" in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn($2e33bde214a8b335$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn($2e33bde214a8b335$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit("beforeSendSession", session);
        const env = $aRHOP.createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            const key = `${reason}:${category}`;
            $9Yejo.DEBUG_BUILD && $1UPRv.debug.log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hookCallbacks = this._hooks[hook] = this._hooks[hook] || /* @__PURE__ */ new Set();
        const uniqueCallback = (...args)=>callback(...args);
        hookCallbacks.add(uniqueCallback);
        return ()=>{
            hookCallbacks.delete(uniqueCallback);
        };
    }
    /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) try {
            return await this._transport.send(envelope);
        } catch (reason) {
            $9Yejo.DEBUG_BUILD && $1UPRv.debug.error("Error while sending envelope:", reason);
            return {};
        }
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.error("Transport disabled");
        return {};
    }
    /**
   * Register a cleanup function to be called when the client is disposed.
   * This is useful for integrations that need to clean up global state.
   *
   * NOTE: This is a no-op in the base `Client` class. Subclasses like `ServerRuntimeClient`
   * override this method to actually register and execute cleanup callbacks.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    registerCleanup(callback) {}
    /**
   * Disposes of the client and releases all resources.
   *
   * Subclasses should override this method to clean up their own resources, including invoking
   * any callbacks registered via {@link Client.registerCleanup}. The base implementation is a
   * no-op and does NOT execute registered cleanup callbacks.
   *
   * After calling dispose(), the client should not be used anymore.
   */ dispose() {}
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = $k2EST.setupIntegrations(this, integrations);
        $k2EST.afterSetupIntegrations(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session$1, event) {
        let crashed = event.level === "fatal";
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            crashed = false;
            for (const ex of exceptions)if (ex.mechanism?.handled === false) {
                crashed = true;
                break;
            }
        }
        const sessionNonTerminal = session$1.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session$1.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            $iS3Yk.updateSession(session$1, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session$1.errors || Number(errored || crashed)
            });
            this.captureSession(session$1);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ async _isClientDoneProcessing(timeout) {
        let ticked = 0;
        while(!timeout || ticked < timeout){
            await new Promise((resolve)=>setTimeout(resolve, 1));
            if (!this._numProcessing) return true;
            ticked++;
        }
        return false;
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== void 0;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = this.getIntegrationNames();
        if (!hint.integrations && integrations.length) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return $1JmGh.prepareEvent(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit("postprocessEvent", evt, hint);
            evt.contexts = {
                trace: {
                    ...evt.contexts?.trace,
                    ...$8DrvK.getTraceContextFromScope(currentScope)
                },
                ...evt.contexts
            };
            const dynamicSamplingContext$1 = $boK9h.getDynamicSamplingContextFromScope(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext$1,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = $8DrvK.getCurrentScope(), isolationScope = $8DrvK.getIsolationScope()) {
        if ($9Yejo.DEBUG_BUILD && $2e33bde214a8b335$var$isErrorEvent(event)) $1UPRv.debug.log(`Captured error event \`${$86e6R.getPossibleEventMessages(event)[0] || "<unknown>"}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if ($9Yejo.DEBUG_BUILD) {
                if ($2e33bde214a8b335$var$_isDoNotSendEventError(reason)) $1UPRv.debug.log(reason.message);
                else if ($2e33bde214a8b335$var$_isInternalError(reason)) $1UPRv.debug.warn(reason.message);
                else $1UPRv.debug.warn(reason);
            }
            return void 0;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $2e33bde214a8b335$var$isTransactionEvent(event);
        const isError = $2e33bde214a8b335$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        const parsedSampleRate = typeof sampleRate === "undefined" ? void 0 : $ljBvc.parseSampleRate(sampleRate);
        const dataCategory = $2e33bde214a8b335$var$getDataCategoryByType(event.type);
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory);
                throw $2e33bde214a8b335$var$_makeDoNotSendEventError("An event processor returned `null`, will not send event.");
            }
            const isInternalException = hint.data?.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $2e33bde214a8b335$var$processBeforeSend(this, options, prepared, hint);
            return $2e33bde214a8b335$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw $2e33bde214a8b335$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isError && typeof parsedSampleRate === "number" && $8odom.safeMathRandom() > parsedSampleRate) {
                this.recordDroppedEvent("sample_rate", "error");
                throw $2e33bde214a8b335$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`);
            }
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($2e33bde214a8b335$var$_isDoNotSendEventError(reason) || $2e33bde214a8b335$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                mechanism: {
                    handled: false,
                    type: "internal"
                },
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $2e33bde214a8b335$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(taskProducer, dataCategory) {
        this._numProcessing++;
        this._promiseBuffer.add(taskProducer).then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            if (reason === $75YtR.SENTRY_BUFFER_FULL_ERROR) this.recordDroppedEvent("queue_overflow", dataCategory);
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.log("Flushing outcomes...");
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            $9Yejo.DEBUG_BUILD && $1UPRv.debug.log("No outcomes to send");
            return;
        }
        if (!this._dsn) {
            $9Yejo.DEBUG_BUILD && $1UPRv.debug.log("No dsn provided, will not send outcomes");
            return;
        }
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.log("Sending outcomes:", outcomes);
        const envelope = $gFX5W.createClientReportEnvelope(outcomes, this._options.tunnel && $dXYuT.dsnToString(this._dsn));
        this.sendEnvelope(envelope);
    }
}
function $2e33bde214a8b335$var$getDataCategoryByType(type) {
    return type === "replay_event" ? "replay" : type || "error";
}
function $2e33bde214a8b335$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ($eMfEg.isThenable(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!$eMfEg.isPlainObject(event) && event !== null) throw $2e33bde214a8b335$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $2e33bde214a8b335$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!$eMfEg.isPlainObject(beforeSendResult) && beforeSendResult !== null) throw $2e33bde214a8b335$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
function $2e33bde214a8b335$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, ignoreSpans: ignoreSpans } = options;
    const beforeSendSpan$1 = !$5ob0u.isStreamedBeforeSendSpanCallback(options.beforeSendSpan) && options.beforeSendSpan;
    let processedEvent = event;
    if ($2e33bde214a8b335$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($2e33bde214a8b335$var$isTransactionEvent(processedEvent)) {
        if (beforeSendSpan$1 || ignoreSpans) {
            const rootSpanJson = $dTiHO.convertTransactionEventToSpanJson(processedEvent);
            if (ignoreSpans?.length && $2aQlx.shouldIgnoreSpan({
                description: rootSpanJson.description,
                op: rootSpanJson.op,
                attributes: rootSpanJson.data
            }, ignoreSpans)) return null;
            if (beforeSendSpan$1) {
                const processedRootSpanJson = beforeSendSpan$1(rootSpanJson);
                if (!processedRootSpanJson) $eXvrd.showSpanDropWarning();
                else processedEvent = $abhMj.merge(event, $dTiHO.convertSpanJsonToTransactionEvent(processedRootSpanJson));
            }
            if (processedEvent.spans) {
                const processedSpans = [];
                const initialSpans = processedEvent.spans;
                for (const span of initialSpans){
                    if (ignoreSpans?.length && $2aQlx.shouldIgnoreSpan({
                        description: span.description,
                        op: span.op,
                        attributes: span.data
                    }, ignoreSpans)) {
                        $2aQlx.reparentChildSpans(initialSpans, span);
                        continue;
                    }
                    if (beforeSendSpan$1) {
                        const processedSpan = beforeSendSpan$1(span);
                        if (!processedSpan) {
                            $eXvrd.showSpanDropWarning();
                            processedSpans.push(span);
                        } else processedSpans.push(processedSpan);
                    } else processedSpans.push(span);
                }
                const droppedSpans = processedEvent.spans.length - processedSpans.length;
                if (droppedSpans) client.recordDroppedEvent("before_send", "span", droppedSpans);
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $2e33bde214a8b335$var$isErrorEvent(event) {
    return event.type === void 0;
}
function $2e33bde214a8b335$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
function $2e33bde214a8b335$var$estimateMetricSizeInBytes(metric) {
    let weight = 0;
    if (metric.name) weight += metric.name.length * 2;
    weight += 8;
    return weight + $2e33bde214a8b335$var$estimateAttributesSizeInBytes(metric.attributes);
}
function $2e33bde214a8b335$var$estimateLogSizeInBytes(log) {
    let weight = 0;
    if (log.message) weight += log.message.length * 2;
    return weight + $2e33bde214a8b335$var$estimateAttributesSizeInBytes(log.attributes);
}
function $2e33bde214a8b335$var$estimateAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    Object.values(attributes).forEach((value)=>{
        if (Array.isArray(value)) weight += value.length * $2e33bde214a8b335$var$estimatePrimitiveSizeInBytes(value[0]);
        else if ($eMfEg.isPrimitive(value)) weight += $2e33bde214a8b335$var$estimatePrimitiveSizeInBytes(value);
        else weight += 100;
    });
    return weight;
}
function $2e33bde214a8b335$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "number") return 8;
    else if (typeof value === "boolean") return 4;
    return 0;
}
module.exports.Client = $2e33bde214a8b335$var$Client;

});
parcelRegister("k2EST", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8DrvK = parcelRequire("8DrvK");

var $9Yejo = parcelRequire("9Yejo");

var $1UPRv = parcelRequire("1UPRv");
const $e973b558fb70b88f$var$installedIntegrations = [];
function $e973b558fb70b88f$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
function $e973b558fb70b88f$var$getIntegrationsToSetup(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $e973b558fb70b88f$var$filterDuplicates(integrations);
}
function $e973b558fb70b88f$var$setupIntegrations(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        if (integration?.beforeSetup) integration.beforeSetup(client);
    });
    integrations.forEach((integration)=>{
        if (integration) $e973b558fb70b88f$var$setupIntegration(client, integration, integrationIndex);
    });
    return integrationIndex;
}
function $e973b558fb70b88f$var$afterSetupIntegrations(client, integrations) {
    for (const integration of integrations)if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
function $e973b558fb70b88f$var$setupIntegration(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    if (!$e973b558fb70b88f$var$installedIntegrations.includes(integration.name) && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $e973b558fb70b88f$var$installedIntegrations.push(integration.name);
    }
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    [
        "processSpan",
        "processSegmentSpan"
    ].forEach((hook)=>{
        const callback = integration[hook];
        if (typeof callback === "function") client.on(hook, (span)=>callback.call(integration, span, client));
    });
    $9Yejo.DEBUG_BUILD && $1UPRv.debug.log(`Integration installed: ${integration.name}`);
}
function $e973b558fb70b88f$var$addIntegration(integration) {
    const client = $8DrvK.getClient();
    if (!client) {
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
function $e973b558fb70b88f$var$defineIntegration(fn) {
    return fn;
}
function $e973b558fb70b88f$var$extendIntegration(integration, extendedIntegration) {
    const wrappedIntegration = {
        ...integration,
        ...extendedIntegration
    };
    for(const key in extendedIntegration){
        const baseValue = integration[key];
        const extendedValue = extendedIntegration[key];
        if (typeof baseValue === "function" && typeof extendedValue === "function") {
            const wrappedFunction = new Proxy(baseValue, {
                apply: (target, thisArg, args)=>{
                    Reflect.apply(target, thisArg, args);
                    return Reflect.apply(extendedValue, thisArg, args);
                }
            });
            wrappedIntegration[key] = wrappedFunction;
        }
    }
    return wrappedIntegration;
}
module.exports.addIntegration = $e973b558fb70b88f$var$addIntegration;
module.exports.afterSetupIntegrations = $e973b558fb70b88f$var$afterSetupIntegrations;
module.exports.defineIntegration = $e973b558fb70b88f$var$defineIntegration;
module.exports.extendIntegration = $e973b558fb70b88f$var$extendIntegration;
module.exports.getIntegrationsToSetup = $e973b558fb70b88f$var$getIntegrationsToSetup;
module.exports.installedIntegrations = $e973b558fb70b88f$var$installedIntegrations;
module.exports.setupIntegration = $e973b558fb70b88f$var$setupIntegration;
module.exports.setupIntegrations = $e973b558fb70b88f$var$setupIntegrations;

});

parcelRegister("44TbO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9eCUH = parcelRequire("9eCUH");

var $6FBPf = parcelRequire("6FBPf");

var $8DrvK = parcelRequire("8DrvK");

var $9Yejo = parcelRequire("9Yejo");

var $1UPRv = parcelRequire("1UPRv");

var $eMfEg = parcelRequire("eMfEg");

var $cXaTJ = parcelRequire("cXaTJ");

var $b3Isg = parcelRequire("b3Isg");

var $1MCl5 = parcelRequire("1MCl5");

var $3okXi = parcelRequire("3okXi");

var $7Odr4 = parcelRequire("7Odr4");

var $dvpW2 = parcelRequire("dvpW2");

var $jMEtX = parcelRequire("jMEtX");
const $2f82589c8e3d3880$var$MAX_LOG_BUFFER_SIZE = 100;
function $2f82589c8e3d3880$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
function $2f82589c8e3d3880$var$_INTERNAL_captureSerializedLog(client, serializedLog) {
    const bufferMap = $2f82589c8e3d3880$var$_getBufferMap();
    const logBuffer = $2f82589c8e3d3880$var$_INTERNAL_getLogBuffer(client);
    if (logBuffer === void 0) bufferMap.set(client, [
        serializedLog
    ]);
    else if (logBuffer.length >= $2f82589c8e3d3880$var$MAX_LOG_BUFFER_SIZE) {
        $2f82589c8e3d3880$var$_INTERNAL_flushLogsBuffer(client, logBuffer);
        bufferMap.set(client, [
            serializedLog
        ]);
    } else bufferMap.set(client, [
        ...logBuffer,
        serializedLog
    ]);
}
function $2f82589c8e3d3880$var$_INTERNAL_captureLog(beforeLog, currentScope = $8DrvK.getCurrentScope(), captureSerializedLog = $2f82589c8e3d3880$var$_INTERNAL_captureSerializedLog) {
    const client = currentScope?.getClient() ?? $8DrvK.getClient();
    if (!client) {
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn("No client available to capture log.");
        return;
    }
    const { release: release, environment: environment, enableLogs: enableLogs = true, beforeSendLog: beforeSendLog } = client.getOptions();
    if (!enableLogs) {
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn("logging option not enabled, log will not be captured.");
        return;
    }
    const [, traceContext] = $7Odr4._getTraceInfoFromScope(client, currentScope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    const { user: { id: id, email: email, username: username }, attributes: scopeAttributes = {} } = $cXaTJ.getCombinedScopeData($8DrvK.getIsolationScope(), currentScope);
    $2f82589c8e3d3880$var$setLogAttribute(processedLogAttributes, "user.id", id, false);
    $2f82589c8e3d3880$var$setLogAttribute(processedLogAttributes, "user.email", email, false);
    $2f82589c8e3d3880$var$setLogAttribute(processedLogAttributes, "user.name", username, false);
    $2f82589c8e3d3880$var$setLogAttribute(processedLogAttributes, "sentry.release", release);
    $2f82589c8e3d3880$var$setLogAttribute(processedLogAttributes, "sentry.environment", environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $2f82589c8e3d3880$var$setLogAttribute(processedLogAttributes, "sentry.sdk.name", name);
    $2f82589c8e3d3880$var$setLogAttribute(processedLogAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId(true);
    $2f82589c8e3d3880$var$setLogAttribute(processedLogAttributes, "sentry.replay_id", replayId);
    if (replayId && replay?.getRecordingMode() === "buffer") $2f82589c8e3d3880$var$setLogAttribute(processedLogAttributes, "sentry._internal.replay_is_buffering", true);
    const beforeLogMessage = beforeLog.message;
    if ($eMfEg.isParameterizedString(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        if (__sentry_template_values__?.length) processedLogAttributes["sentry.message.template"] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = $b3Isg._getSpanForScope(currentScope);
    $2f82589c8e3d3880$var$setLogAttribute(processedLogAttributes, "sentry.trace.parent_span_id", span?.spanContext().spanId);
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit("beforeCaptureLog", processedLog);
    const log = beforeSendLog ? $1UPRv.consoleSandbox(()=>beforeSendLog(processedLog)) : processedLog;
    if (!log) {
        client.recordDroppedEvent("before_send", "log_item", 1);
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn("beforeSendLog returned null, log will not be captured.");
        return;
    }
    const { level: level, message: message, attributes: logAttributes = {}, severityNumber: severityNumber } = log;
    const timestamp = $1MCl5.timestampInSeconds();
    const sequenceAttr = $3okXi.getSequenceAttribute(timestamp);
    const serializedLog = {
        timestamp: timestamp,
        level: level,
        body: $2f82589c8e3d3880$var$_removeLoneSurrogates(String(message)),
        trace_id: traceContext?.trace_id,
        severity_number: severityNumber ?? $dvpW2.SEVERITY_TEXT_TO_SEVERITY_NUMBER[level],
        attributes: $2f82589c8e3d3880$var$sanitizeLogAttributes({
            ...$9eCUH.serializeAttributes(scopeAttributes),
            ...$9eCUH.serializeAttributes(logAttributes, true),
            [sequenceAttr.key]: sequenceAttr.value
        })
    };
    captureSerializedLog(client, serializedLog);
    client.emit("afterCaptureLog", log);
}
function $2f82589c8e3d3880$var$_INTERNAL_flushLogsBuffer(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $2f82589c8e3d3880$var$_INTERNAL_getLogBuffer(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope$1 = $jMEtX.createLogEnvelope(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $2f82589c8e3d3880$var$_getBufferMap().set(client, []);
    client.emit("flushLogs");
    client.sendEnvelope(envelope$1);
}
function $2f82589c8e3d3880$var$_INTERNAL_getLogBuffer(client) {
    return $2f82589c8e3d3880$var$_getBufferMap().get(client);
}
function $2f82589c8e3d3880$var$_getBufferMap() {
    return $6FBPf.getGlobalSingleton("clientToLogBufferMap", ()=>/* @__PURE__ */ new WeakMap());
}
function $2f82589c8e3d3880$var$sanitizeLogAttributes(attributes) {
    const sanitized = {};
    for (const [key, attr] of Object.entries(attributes)){
        const sanitizedKey = $2f82589c8e3d3880$var$_removeLoneSurrogates(key);
        if (attr.type === "string") sanitized[sanitizedKey] = {
            ...attr,
            value: $2f82589c8e3d3880$var$_removeLoneSurrogates(attr.value)
        };
        else sanitized[sanitizedKey] = attr;
    }
    return sanitized;
}
function $2f82589c8e3d3880$var$_removeLoneSurrogates(str) {
    const strObj = Object(str);
    const isWellFormed = strObj["isWellFormed"];
    const toWellFormed = strObj["toWellFormed"];
    if (typeof isWellFormed === "function" && typeof toWellFormed === "function") return isWellFormed.call(str) ? str : toWellFormed.call(str);
    return str;
}
module.exports._INTERNAL_captureLog = $2f82589c8e3d3880$var$_INTERNAL_captureLog;
module.exports._INTERNAL_captureSerializedLog = $2f82589c8e3d3880$var$_INTERNAL_captureSerializedLog;
module.exports._INTERNAL_flushLogsBuffer = $2f82589c8e3d3880$var$_INTERNAL_flushLogsBuffer;
module.exports._INTERNAL_getLogBuffer = $2f82589c8e3d3880$var$_INTERNAL_getLogBuffer;
module.exports._removeLoneSurrogates = $2f82589c8e3d3880$var$_removeLoneSurrogates;

});
parcelRegister("3okXi", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $2783de4494585b07$var$SEQUENCE_ATTR_KEY = "sentry.timestamp.sequence";
let $2783de4494585b07$var$_sequenceNumber = 0;
let $2783de4494585b07$var$_previousTimestampMs;
function $2783de4494585b07$var$getSequenceAttribute(timestampInSeconds) {
    const nowMs = Math.floor(timestampInSeconds * 1e3);
    if ($2783de4494585b07$var$_previousTimestampMs !== void 0 && nowMs !== $2783de4494585b07$var$_previousTimestampMs) $2783de4494585b07$var$_sequenceNumber = 0;
    const value = $2783de4494585b07$var$_sequenceNumber;
    $2783de4494585b07$var$_sequenceNumber++;
    $2783de4494585b07$var$_previousTimestampMs = nowMs;
    return {
        key: $2783de4494585b07$var$SEQUENCE_ATTR_KEY,
        value: {
            value: value,
            type: "integer"
        }
    };
}
module.exports.getSequenceAttribute = $2783de4494585b07$var$getSequenceAttribute;

});

parcelRegister("7Odr4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8DrvK = parcelRequire("8DrvK");

var $boK9h = parcelRequire("boK9h");

var $eXvrd = parcelRequire("eXvrd");
function $5af79ff39ec053dc$var$_getTraceInfoFromScope(client, scope) {
    if (!scope) return [
        void 0,
        void 0
    ];
    return $8DrvK.withScope(scope, ()=>{
        const span = $eXvrd.getActiveSpan();
        const traceContext = span ? $eXvrd.spanToTraceContext(span) : $8DrvK.getTraceContextFromScope(scope);
        const dynamicSamplingContext$1 = span ? $boK9h.getDynamicSamplingContextFromSpan(span) : $boK9h.getDynamicSamplingContextFromScope(client, scope);
        return [
            dynamicSamplingContext$1,
            traceContext
        ];
    });
}
module.exports._getTraceInfoFromScope = $5af79ff39ec053dc$var$_getTraceInfoFromScope;

});

parcelRegister("dvpW2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $9d5249cbe6b8afef$var$SEVERITY_TEXT_TO_SEVERITY_NUMBER = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};
module.exports.SEVERITY_TEXT_TO_SEVERITY_NUMBER = $9d5249cbe6b8afef$var$SEVERITY_TEXT_TO_SEVERITY_NUMBER;

});

parcelRegister("jMEtX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dXYuT = parcelRequire("dXYuT");

var $5gI17 = parcelRequire("5gI17");

var $aFZw5 = parcelRequire("aFZw5");
function $e671e6f1e2a12b3d$var$createLogContainerEnvelopeItem(items, inferUserData) {
    const inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "log",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.log+json"
        },
        {
            version: 2,
            ...$aFZw5.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: items
        }
    ];
}
function $e671e6f1e2a12b3d$var$createLogEnvelope(logs, metadata, tunnel, dsn$1, inferUserData) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $dXYuT.dsnToString(dsn$1);
    return $5gI17.createEnvelope(headers, [
        $e671e6f1e2a12b3d$var$createLogContainerEnvelopeItem(logs, inferUserData)
    ]);
}
module.exports.createLogContainerEnvelopeItem = $e671e6f1e2a12b3d$var$createLogContainerEnvelopeItem;
module.exports.createLogEnvelope = $e671e6f1e2a12b3d$var$createLogEnvelope;

});
parcelRegister("aFZw5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $a82j2 = parcelRequire("a82j2");

var $YfOkS = parcelRequire("YfOkS");
function $7c5d739eed8a61de$var$isBrowser() {
    return typeof window !== "undefined" && (!$a82j2.isNodeEnv() || $7c5d739eed8a61de$var$isElectronNodeRenderer());
}
function $7c5d739eed8a61de$var$isElectronNodeRenderer() {
    const process = $YfOkS.GLOBAL_OBJ.process;
    return process?.type === "renderer";
}
module.exports.isBrowser = $7c5d739eed8a61de$var$isBrowser;

});
parcelRegister("a82j2", function(module, exports) {
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8zi2C = parcelRequire("8zi2C");
function isNodeEnv() {
    return !$8zi2C.isBrowserBundle() && Object.prototype.toString.call(0) === "[object process]";
}
function dynamicRequire(mod, request) {
    return mod.require(request);
}
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch  {}
    if (!mod) try {
        const { cwd } = dynamicRequire(existingModule, "process");
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch  {}
    return mod;
}
exports.isNodeEnv = isNodeEnv;
exports.loadModule = loadModule;

});
parcelRegister("8zi2C", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $63cf963f4fd0422a$var$isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
function $63cf963f4fd0422a$var$getSDKSource() {
    /*! __SENTRY_SDK_SOURCE__ */ return "npm";
}
module.exports.getSDKSource = $63cf963f4fd0422a$var$getSDKSource;
module.exports.isBrowserBundle = $63cf963f4fd0422a$var$isBrowserBundle;

});





parcelRegister("dpToc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9eCUH = parcelRequire("9eCUH");

var $6FBPf = parcelRequire("6FBPf");

var $8DrvK = parcelRequire("8DrvK");

var $9Yejo = parcelRequire("9Yejo");

var $1UPRv = parcelRequire("1UPRv");

var $cXaTJ = parcelRequire("cXaTJ");

var $b3Isg = parcelRequire("b3Isg");

var $1MCl5 = parcelRequire("1MCl5");

var $3okXi = parcelRequire("3okXi");

var $7Odr4 = parcelRequire("7Odr4");

var $lOg8I = parcelRequire("lOg8I");
const $9c489350b0ad505c$var$MAX_METRIC_BUFFER_SIZE = 1e3;
function $9c489350b0ad505c$var$setMetricAttribute(metricAttributes, key, value, setEvenIfPresent = true) {
    if (value && (setEvenIfPresent || !(key in metricAttributes))) metricAttributes[key] = value;
}
function $9c489350b0ad505c$var$_INTERNAL_captureSerializedMetric(client, serializedMetric) {
    const bufferMap = $9c489350b0ad505c$var$_getBufferMap();
    const metricBuffer = $9c489350b0ad505c$var$_INTERNAL_getMetricBuffer(client);
    if (metricBuffer === void 0) bufferMap.set(client, [
        serializedMetric
    ]);
    else if (metricBuffer.length >= $9c489350b0ad505c$var$MAX_METRIC_BUFFER_SIZE) {
        $9c489350b0ad505c$var$_INTERNAL_flushMetricsBuffer(client, metricBuffer);
        bufferMap.set(client, [
            serializedMetric
        ]);
    } else bufferMap.set(client, [
        ...metricBuffer,
        serializedMetric
    ]);
}
function $9c489350b0ad505c$var$_enrichMetricAttributes(beforeMetric, client, user) {
    const { release: release, environment: environment } = client.getOptions();
    const processedMetricAttributes = {
        ...beforeMetric.attributes
    };
    $9c489350b0ad505c$var$setMetricAttribute(processedMetricAttributes, "user.id", user.id, false);
    $9c489350b0ad505c$var$setMetricAttribute(processedMetricAttributes, "user.email", user.email, false);
    $9c489350b0ad505c$var$setMetricAttribute(processedMetricAttributes, "user.name", user.username, false);
    $9c489350b0ad505c$var$setMetricAttribute(processedMetricAttributes, "sentry.release", release);
    $9c489350b0ad505c$var$setMetricAttribute(processedMetricAttributes, "sentry.environment", environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $9c489350b0ad505c$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.name", name);
    $9c489350b0ad505c$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId(true);
    $9c489350b0ad505c$var$setMetricAttribute(processedMetricAttributes, "sentry.replay_id", replayId);
    if (replayId && replay?.getRecordingMode() === "buffer") $9c489350b0ad505c$var$setMetricAttribute(processedMetricAttributes, "sentry._internal.replay_is_buffering", true);
    return {
        ...beforeMetric,
        attributes: processedMetricAttributes
    };
}
function $9c489350b0ad505c$var$_buildSerializedMetric(metric, client, currentScope, scopeAttributes) {
    const [, traceContext] = $7Odr4._getTraceInfoFromScope(client, currentScope);
    const span = $b3Isg._getSpanForScope(currentScope);
    const traceId = span ? span.spanContext().traceId : traceContext?.trace_id;
    const spanId = span ? span.spanContext().spanId : void 0;
    const timestamp = $1MCl5.timestampInSeconds();
    const sequenceAttr = $3okXi.getSequenceAttribute(timestamp);
    return {
        timestamp: timestamp,
        trace_id: traceId ?? "",
        span_id: spanId,
        name: metric.name,
        type: metric.type,
        unit: metric.unit,
        value: metric.value,
        attributes: {
            ...$9eCUH.serializeAttributes(scopeAttributes),
            ...$9eCUH.serializeAttributes(metric.attributes, "skip-undefined"),
            [sequenceAttr.key]: sequenceAttr.value
        }
    };
}
function $9c489350b0ad505c$var$_INTERNAL_captureMetric(beforeMetric, options) {
    const currentScope = options?.scope ?? $8DrvK.getCurrentScope();
    const captureSerializedMetric = options?.captureSerializedMetric ?? $9c489350b0ad505c$var$_INTERNAL_captureSerializedMetric;
    const client = currentScope?.getClient() ?? $8DrvK.getClient();
    if (!client) {
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn("No client available to capture metric.");
        return;
    }
    const { _experiments: _experiments, enableMetrics: enableMetrics, beforeSendMetric: beforeSendMetric } = client.getOptions();
    const metricsEnabled = enableMetrics ?? _experiments?.enableMetrics ?? true;
    if (!metricsEnabled) {
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn("metrics option not enabled, metric will not be captured.");
        return;
    }
    const { user: user, attributes: scopeAttributes } = $cXaTJ.getCombinedScopeData($8DrvK.getIsolationScope(), currentScope);
    const enrichedMetric = $9c489350b0ad505c$var$_enrichMetricAttributes(beforeMetric, client, user);
    client.emit("processMetric", enrichedMetric);
    const beforeSendCallback = beforeSendMetric || _experiments?.beforeSendMetric;
    const processedMetric = beforeSendCallback ? beforeSendCallback(enrichedMetric) : enrichedMetric;
    if (!processedMetric) {
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.log("`beforeSendMetric` returned `null`, will not send metric.");
        return;
    }
    const serializedMetric = $9c489350b0ad505c$var$_buildSerializedMetric(processedMetric, client, currentScope, scopeAttributes);
    $9Yejo.DEBUG_BUILD && $1UPRv.debug.log("[Metric]", serializedMetric);
    captureSerializedMetric(client, serializedMetric);
    client.emit("afterCaptureMetric", processedMetric);
}
function $9c489350b0ad505c$var$_INTERNAL_flushMetricsBuffer(client, maybeMetricBuffer) {
    const metricBuffer = maybeMetricBuffer ?? $9c489350b0ad505c$var$_INTERNAL_getMetricBuffer(client) ?? [];
    if (metricBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope$1 = $lOg8I.createMetricEnvelope(metricBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $9c489350b0ad505c$var$_getBufferMap().set(client, []);
    client.emit("flushMetrics");
    client.sendEnvelope(envelope$1);
}
function $9c489350b0ad505c$var$_INTERNAL_getMetricBuffer(client) {
    return $9c489350b0ad505c$var$_getBufferMap().get(client);
}
function $9c489350b0ad505c$var$_getBufferMap() {
    return $6FBPf.getGlobalSingleton("clientToMetricBufferMap", ()=>/* @__PURE__ */ new WeakMap());
}
module.exports._INTERNAL_captureMetric = $9c489350b0ad505c$var$_INTERNAL_captureMetric;
module.exports._INTERNAL_captureSerializedMetric = $9c489350b0ad505c$var$_INTERNAL_captureSerializedMetric;
module.exports._INTERNAL_flushMetricsBuffer = $9c489350b0ad505c$var$_INTERNAL_flushMetricsBuffer;
module.exports._INTERNAL_getMetricBuffer = $9c489350b0ad505c$var$_INTERNAL_getMetricBuffer;

});
parcelRegister("lOg8I", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dXYuT = parcelRequire("dXYuT");

var $5gI17 = parcelRequire("5gI17");

var $aFZw5 = parcelRequire("aFZw5");
function $fe0ac976c4058b06$var$createMetricContainerEnvelopeItem(items, inferUserData) {
    const inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "trace_metric",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.trace-metric+json"
        },
        {
            version: 2,
            ...$aFZw5.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: items
        }
    ];
}
function $fe0ac976c4058b06$var$createMetricEnvelope(metrics, metadata, tunnel, dsn$1, inferUserData) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $dXYuT.dsnToString(dsn$1);
    return $5gI17.createEnvelope(headers, [
        $fe0ac976c4058b06$var$createMetricContainerEnvelopeItem(metrics, inferUserData)
    ]);
}
module.exports.createMetricContainerEnvelopeItem = $fe0ac976c4058b06$var$createMetricContainerEnvelopeItem;
module.exports.createMetricEnvelope = $fe0ac976c4058b06$var$createMetricEnvelope;

});


parcelRegister("jp1pQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $aFZw5 = parcelRequire("aFZw5");

var $cGnx0 = parcelRequire("cGnx0");

var $2WGsB = parcelRequire("2WGsB");
function $e20173496cdc349d$var$extractGenAiSpansFromEvent(event, client) {
    if (event.type !== "transaction" || !event.spans?.length || !event.sdkProcessingMetadata?.hasGenAiSpans || client.getOptions().streamGenAiSpans === false || $cGnx0.hasSpanStreamingEnabled(client)) return void 0;
    const genAiSpans = [];
    const remainingSpans = [];
    for (const span of event.spans)if (span.op?.startsWith("gen_ai.")) genAiSpans.push($2WGsB.spanJsonToSerializedStreamedSpan(span));
    else remainingSpans.push(span);
    if (genAiSpans.length === 0) return void 0;
    event.spans = remainingSpans;
    const inferSetting = client.getDataCollectionOptions().userInfo ? "auto" : "never";
    return [
        {
            type: "span",
            item_count: genAiSpans.length,
            content_type: "application/vnd.sentry.items.span.v2+json"
        },
        {
            version: 2,
            ...$aFZw5.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: genAiSpans
        }
    ];
}
module.exports.extractGenAiSpansFromEvent = $e20173496cdc349d$var$extractGenAiSpansFromEvent;

});
parcelRegister("2WGsB", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eXvrd = parcelRequire("eXvrd");
function $2251ef4a35c7a9fc$var$spanJsonToSerializedStreamedSpan(span) {
    const streamedSpan = {
        trace_id: span.trace_id,
        span_id: span.span_id,
        parent_span_id: span.parent_span_id,
        name: span.description || "",
        start_timestamp: span.start_timestamp,
        end_timestamp: span.timestamp || span.start_timestamp,
        status: !span.status || span.status === "ok" || span.status === "cancelled" ? "ok" : "error",
        is_segment: false,
        attributes: {
            ...span.data
        },
        links: span.links
    };
    return $eXvrd.streamedSpanJsonToSerializedSpan(streamedSpan);
}
module.exports.spanJsonToSerializedStreamedSpan = $2251ef4a35c7a9fc$var$spanJsonToSerializedStreamedSpan;

});


parcelRegister("dXGj2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9Yejo = parcelRequire("9Yejo");

var $1UPRv = parcelRequire("1UPRv");

var $5gI17 = parcelRequire("5gI17");

var $75YtR = parcelRequire("75YtR");

var $iMxjn = parcelRequire("iMxjn");
const $a2a19a21476ae0f3$var$DEFAULT_TRANSPORT_BUFFER_SIZE = 64;
function $a2a19a21476ae0f3$var$createTransport(options, makeRequest, buffer = $75YtR.makePromiseBuffer(options.bufferSize || $a2a19a21476ae0f3$var$DEFAULT_TRANSPORT_BUFFER_SIZE)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope$1) {
        const filteredEnvelopeItems = [];
        $5gI17.forEachEnvelopeItem(envelope$1, (item, type)=>{
            const dataCategory = $5gI17.envelopeItemTypeToDataCategory(type);
            if ($iMxjn.isRateLimited(rateLimits, dataCategory)) options.recordDroppedEvent("ratelimit_backoff", dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        if (filteredEnvelopeItems.length === 0) return Promise.resolve({});
        const filteredEnvelope = $5gI17.createEnvelope(envelope$1[0], filteredEnvelopeItems);
        const recordEnvelopeLoss = (reason)=>{
            if ($5gI17.envelopeContainsItemType(filteredEnvelope, [
                "client_report"
            ])) {
                $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn(`Dropping client report. Will not send outcomes (reason: ${reason}).`);
                return;
            }
            $5gI17.forEachEnvelopeItem(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, $5gI17.envelopeItemTypeToDataCategory(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: $5gI17.serializeEnvelope(filteredEnvelope)
            }).then((response)=>{
                if (response.statusCode === 413) {
                    $9Yejo.DEBUG_BUILD && $1UPRv.debug.error("Sentry responded with status code 413. Envelope was discarded due to exceeding size limits.");
                    recordEnvelopeLoss("send_error");
                    return response;
                }
                if ($9Yejo.DEBUG_BUILD && response.statusCode !== void 0 && (response.statusCode < 200 || response.statusCode >= 300)) $1UPRv.debug.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = $iMxjn.updateRateLimits(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                $9Yejo.DEBUG_BUILD && $1UPRv.debug.error("Encountered error running transport request:", error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === $75YtR.SENTRY_BUFFER_FULL_ERROR) {
                $9Yejo.DEBUG_BUILD && $1UPRv.debug.error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return Promise.resolve({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}
module.exports.DEFAULT_TRANSPORT_BUFFER_SIZE = $a2a19a21476ae0f3$var$DEFAULT_TRANSPORT_BUFFER_SIZE;
module.exports.createTransport = $a2a19a21476ae0f3$var$createTransport;

});
parcelRegister("75YtR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kzgET = parcelRequire("kzgET");

var $5wKGb = parcelRequire("5wKGb");
const $015549f8bb62e369$var$SENTRY_BUFFER_FULL_ERROR = /* @__PURE__ */ Symbol.for("SentryBufferFullError");
function $015549f8bb62e369$var$makePromiseBuffer(limit = 100) {
    const buffer = /* @__PURE__ */ new Set();
    function isReady() {
        return buffer.size < limit;
    }
    function remove(task) {
        buffer.delete(task);
    }
    function add(taskProducer) {
        if (!isReady()) return $kzgET.rejectedSyncPromise($015549f8bb62e369$var$SENTRY_BUFFER_FULL_ERROR);
        const task = taskProducer();
        buffer.add(task);
        task.then(()=>remove(task), ()=>remove(task));
        return task;
    }
    function drain(timeout) {
        if (!buffer.size) return $kzgET.resolvedSyncPromise(true);
        const drainPromise = Promise.allSettled(Array.from(buffer)).then(()=>true);
        if (!timeout) return drainPromise;
        const promises = [
            drainPromise,
            new Promise((resolve)=>$5wKGb.safeUnref(setTimeout(()=>resolve(false), timeout)))
        ];
        return Promise.race(promises);
    }
    return {
        get $ () {
            return Array.from(buffer);
        },
        add: add,
        drain: drain
    };
}
module.exports.SENTRY_BUFFER_FULL_ERROR = $015549f8bb62e369$var$SENTRY_BUFFER_FULL_ERROR;
module.exports.makePromiseBuffer = $015549f8bb62e369$var$makePromiseBuffer;

});

parcelRegister("iMxjn", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8odom = parcelRequire("8odom");
const $dac68ca6f949a3f6$var$DEFAULT_RETRY_AFTER = 60000;
function $dac68ca6f949a3f6$var$parseRetryAfterHeader(header, now = $8odom.safeDateNow()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1e3;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $dac68ca6f949a3f6$var$DEFAULT_RETRY_AFTER;
}
function $dac68ca6f949a3f6$var$disabledUntil(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
function $dac68ca6f949a3f6$var$isRateLimited(limits, dataCategory, now = $8odom.safeDateNow()) {
    return $dac68ca6f949a3f6$var$disabledUntil(limits, dataCategory) > now;
}
function $dac68ca6f949a3f6$var$updateRateLimits(limits, { statusCode: statusCode, headers: headers }, now = $8odom.safeDateNow()) {
    const updatedRateLimits = {
        ...limits
    };
    const rateLimitHeader = headers?.["x-sentry-rate-limits"];
    const retryAfterHeader = headers?.["retry-after"];
    if (rateLimitHeader) for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1e3;
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $dac68ca6f949a3f6$var$parseRetryAfterHeader(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}
module.exports.DEFAULT_RETRY_AFTER = $dac68ca6f949a3f6$var$DEFAULT_RETRY_AFTER;
module.exports.disabledUntil = $dac68ca6f949a3f6$var$disabledUntil;
module.exports.isRateLimited = $dac68ca6f949a3f6$var$isRateLimited;
module.exports.parseRetryAfterHeader = $dac68ca6f949a3f6$var$parseRetryAfterHeader;
module.exports.updateRateLimits = $dac68ca6f949a3f6$var$updateRateLimits;

});


parcelRegister("gFX5W", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5gI17 = parcelRequire("5gI17");

var $1MCl5 = parcelRequire("1MCl5");
function $c23e50b309a74993$var$createClientReportEnvelope(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || $1MCl5.dateTimestampInSeconds(),
            discarded_events: discarded_events
        }
    ];
    return $5gI17.createEnvelope(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}
module.exports.createClientReportEnvelope = $c23e50b309a74993$var$createClientReportEnvelope;

});

parcelRegister("86e6R", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $5e59d422630c6dfe$var$getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch  {}
    return possibleMessages;
}
module.exports.getPossibleEventMessages = $5e59d422630c6dfe$var$getPossibleEventMessages;

});

parcelRegister("dTiHO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dknph = parcelRequire("dknph");
function $a1ceebf867ff3a7b$var$convertTransactionEventToSpanJson(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? "",
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? "",
        origin: origin,
        profile_id: data?.[$dknph.SEMANTIC_ATTRIBUTE_PROFILE_ID],
        exclusive_time: data?.[$dknph.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
        measurements: event.measurements,
        is_segment: true
    };
}
function $a1ceebf867ff3a7b$var$convertSpanJsonToTransactionEvent(span) {
    return {
        type: "transaction",
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [$dknph.SEMANTIC_ATTRIBUTE_PROFILE_ID]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [$dknph.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}
module.exports.convertSpanJsonToTransactionEvent = $a1ceebf867ff3a7b$var$convertSpanJsonToTransactionEvent;
module.exports.convertTransactionEventToSpanJson = $a1ceebf867ff3a7b$var$convertTransactionEventToSpanJson;

});

parcelRegister("csycH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $fpUGo = parcelRequire("fpUGo");
const $9122a1ba9bce9153$var$DEFAULTS = {
    userInfo: true,
    cookies: true,
    httpHeaders: {
        request: true,
        response: true
    },
    httpBodies: [
        "incomingRequest",
        "outgoingRequest",
        "incomingResponse",
        "outgoingResponse"
    ],
    urlQueryParams: true,
    graphQL: {
        document: true,
        variables: true
    },
    genAI: {
        inputs: true,
        outputs: true
    },
    databaseQueryData: true,
    stackFrameVariables: true,
    frameContextLines: 5
};
function $9122a1ba9bce9153$var$resolveDataCollectionOptions(options) {
    const base = options.dataCollection != null ? $9122a1ba9bce9153$var$DEFAULTS : $fpUGo.defaultPiiToCollectionOptions(options.sendDefaultPii);
    const dc = options.dataCollection ?? {};
    return {
        userInfo: dc.userInfo ?? base.userInfo,
        cookies: dc.cookies ?? base.cookies,
        httpHeaders: {
            request: dc.httpHeaders?.request ?? base.httpHeaders.request,
            response: dc.httpHeaders?.response ?? base.httpHeaders.response
        },
        httpBodies: dc.httpBodies ?? base.httpBodies,
        // oxlint-disable-next-line typescript/no-deprecated
        urlQueryParams: dc.urlQueryParams ?? dc.queryParams ?? base.urlQueryParams,
        graphQL: {
            document: dc.graphQL?.document ?? base.graphQL.document,
            variables: dc.graphQL?.variables ?? base.graphQL.variables
        },
        genAI: {
            inputs: dc.genAI?.inputs ?? base.genAI.inputs,
            outputs: dc.genAI?.outputs ?? base.genAI.outputs
        },
        databaseQueryData: dc.databaseQueryData ?? base.databaseQueryData,
        stackFrameVariables: dc.stackFrameVariables ?? base.stackFrameVariables,
        frameContextLines: dc.frameContextLines ?? base.frameContextLines
    };
}
module.exports.resolveDataCollectionOptions = $9122a1ba9bce9153$var$resolveDataCollectionOptions;

});
parcelRegister("fpUGo", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8u8UM = parcelRequire("8u8UM");
function $b39528d76dc942b6$var$defaultPiiToCollectionOptions(sendDefaultPii) {
    return sendDefaultPii === true ? {
        userInfo: true,
        cookies: true,
        httpHeaders: {
            request: true,
            response: true
        },
        httpBodies: [
            "incomingRequest",
            "outgoingRequest",
            "incomingResponse",
            "outgoingResponse"
        ],
        urlQueryParams: true,
        graphQL: {
            document: true,
            variables: true
        },
        genAI: {
            inputs: true,
            outputs: true
        },
        databaseQueryData: true,
        stackFrameVariables: true,
        frameContextLines: 7
    } : {
        userInfo: false,
        cookies: {
            deny: $8u8UM.PII_HEADER_SNIPPETS
        },
        httpHeaders: {
            request: {
                deny: $8u8UM.PII_HEADER_SNIPPETS
            },
            response: {
                deny: $8u8UM.PII_HEADER_SNIPPETS
            }
        },
        httpBodies: [],
        urlQueryParams: {
            deny: $8u8UM.PII_HEADER_SNIPPETS
        },
        // The GraphQL document has literal values redacted at collection time, so it was historically
        // always attached regardless of `sendDefaultPii`; keep it on to preserve that behavior.
        graphQL: {
            document: true,
            variables: true
        },
        genAI: {
            inputs: false,
            outputs: false
        },
        // Database query values were only sent with `sendDefaultPii: true` (e.g. Supabase gated on it),
        // so map the legacy "off" state to `false`.
        databaseQueryData: false,
        stackFrameVariables: true,
        frameContextLines: 7
    };
}
module.exports.defaultPiiToCollectionOptions = $b39528d76dc942b6$var$defaultPiiToCollectionOptions;

});
parcelRegister("8u8UM", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $62d80a5fb62e2a61$var$FILTERED_VALUE = "[Filtered]";
const $62d80a5fb62e2a61$var$PII_HEADER_SNIPPETS = [
    "forwarded",
    "-ip",
    "remote-",
    "via",
    "-user"
];
const $62d80a5fb62e2a61$var$SENSITIVE_KEY_SNIPPETS = [
    "auth",
    "token",
    "secret",
    "session",
    // for the user_session cookie
    "password",
    "passwd",
    "pwd",
    "key",
    "jwt",
    "bearer",
    "sso",
    "saml",
    "csrf",
    "xsrf",
    "credentials",
    "sid",
    "identity",
    // Always treat cookie headers as sensitive in case individual key-value cookie pairs cannot properly be extracted
    "set-cookie",
    "cookie"
];
const $62d80a5fb62e2a61$var$SENSITIVE_COOKIE_NAME_SNIPPETS = [
    // Express / Connect default session cookie
    ".sid",
    // Opaque session ids (PHPSESSID, ASPSESSIONID*, BIGipServer*, *sessid*, …)
    "sessid",
    // Laravel etc. "remember me" tokens
    "remember",
    // OIDC / OAuth auxiliary (`oauth*` covered by header snippet `auth`)
    "oidc",
    "pkce",
    "nonce",
    // RFC 6265bis high-security cookie name prefixes
    "__secure-",
    "__host-",
    // Load balancer / CDN sticky-session cookies (opaque routing tokens)
    "awsalb",
    "awselb",
    "akamai",
    // BaaS / IdP session cookies (names often omit "session")
    "__stripe",
    "cognito",
    "firebase",
    "supabase",
    "sb-",
    // Step-up / MFA cookies
    "mfa",
    "2fa"
];
module.exports.FILTERED_VALUE = $62d80a5fb62e2a61$var$FILTERED_VALUE;
module.exports.PII_HEADER_SNIPPETS = $62d80a5fb62e2a61$var$PII_HEADER_SNIPPETS;
module.exports.SENSITIVE_COOKIE_NAME_SNIPPETS = $62d80a5fb62e2a61$var$SENSITIVE_COOKIE_NAME_SNIPPETS;
module.exports.SENSITIVE_KEY_SNIPPETS = $62d80a5fb62e2a61$var$SENSITIVE_KEY_SNIPPETS;

});




parcelRegister("bzcaU", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8DrvK = parcelRequire("8DrvK");

var $9Yejo = parcelRequire("9Yejo");

var $1UPRv = parcelRequire("1UPRv");
function $86bc68472484e415$var$initAndBind(clientClass, options) {
    if (options.debug === true) {
        if ($9Yejo.DEBUG_BUILD) $1UPRv.debug.enable();
        else $1UPRv.consoleSandbox(()=>{
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = $8DrvK.getCurrentScope();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $86bc68472484e415$var$setCurrentClient(client);
    client.init();
    return client;
}
function $86bc68472484e415$var$setCurrentClient(client) {
    $8DrvK.getCurrentScope().setClient(client);
}
module.exports.initAndBind = $86bc68472484e415$var$initAndBind;
module.exports.setCurrentClient = $86bc68472484e415$var$setCurrentClient;

});

parcelRegister("io2GI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9Yejo = parcelRequire("9Yejo");

var $1UPRv = parcelRequire("1UPRv");

var $5gI17 = parcelRequire("5gI17");

var $8odom = parcelRequire("8odom");

var $iMxjn = parcelRequire("iMxjn");

var $5wKGb = parcelRequire("5wKGb");
const $d62c8daac63d622a$var$MIN_DELAY = 100;
const $d62c8daac63d622a$var$START_DELAY = 5e3;
const $d62c8daac63d622a$var$MAX_DELAY = 36e5;
function $d62c8daac63d622a$var$makeOfflineTransport(createTransport) {
    function log(...args) {
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.log("[Offline]:", ...args);
    }
    return (options)=>{
        const transport = createTransport(options);
        if (!options.createStore) throw new Error("No `createStore` function was provided");
        const store = options.createStore(options);
        let retryDelay = $d62c8daac63d622a$var$START_DELAY;
        let flushTimer;
        function shouldQueue(env, error, retryDelay2) {
            if ($5gI17.envelopeContainsItemType(env, [
                "client_report"
            ])) return false;
            if (options.shouldStore) return options.shouldStore(env, error, retryDelay2);
            return true;
        }
        function flushIn(delay) {
            if (flushTimer) clearTimeout(flushTimer);
            flushTimer = $5wKGb.safeUnref(setTimeout(async ()=>{
                flushTimer = void 0;
                const found = await store.shift();
                if (found) {
                    log("Attempting to send previously queued event");
                    found[0].sent_at = new Date($8odom.safeDateNow()).toISOString();
                    send(found, true).catch((e)=>{
                        log("Failed to retry sending", e);
                    });
                }
            }, delay));
        }
        function flushWithBackOff() {
            if (flushTimer) return;
            flushIn(retryDelay);
            retryDelay = Math.min(retryDelay * 2, $d62c8daac63d622a$var$MAX_DELAY);
        }
        async function send(envelope$1, isRetry = false) {
            if (!isRetry && $5gI17.envelopeContainsItemType(envelope$1, [
                "replay_event",
                "replay_recording"
            ])) {
                await store.push(envelope$1);
                flushIn($d62c8daac63d622a$var$MIN_DELAY);
                return {};
            }
            try {
                if (options.shouldSend && await options.shouldSend(envelope$1) === false) throw new Error("Envelope not sent because `shouldSend` callback returned false");
                const result = await transport.send(envelope$1);
                let delay = $d62c8daac63d622a$var$MIN_DELAY;
                if (result) {
                    if (result.headers?.["retry-after"]) delay = $iMxjn.parseRetryAfterHeader(result.headers["retry-after"]);
                    else if (result.headers?.["x-sentry-rate-limits"]) delay = 6e4;
                    else if ((result.statusCode || 0) >= 400) return result;
                }
                flushIn(delay);
                retryDelay = $d62c8daac63d622a$var$START_DELAY;
                return result;
            } catch (e) {
                if (await shouldQueue(envelope$1, e, retryDelay)) {
                    if (isRetry) await store.unshift(envelope$1);
                    else await store.push(envelope$1);
                    flushWithBackOff();
                    log("Error sending. Event queued.", e);
                    return {};
                } else throw e;
            }
        }
        if (options.flushAtStartup) flushWithBackOff();
        return {
            send: send,
            flush: (timeout)=>{
                if (timeout === void 0) {
                    retryDelay = $d62c8daac63d622a$var$START_DELAY;
                    flushIn($d62c8daac63d622a$var$MIN_DELAY);
                }
                return transport.flush(timeout);
            }
        };
    };
}
module.exports.MIN_DELAY = $d62c8daac63d622a$var$MIN_DELAY;
module.exports.START_DELAY = $d62c8daac63d622a$var$START_DELAY;
module.exports.makeOfflineTransport = $d62c8daac63d622a$var$makeOfflineTransport;

});

parcelRegister("02PaP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bsUcA = parcelRequire("bsUcA");

var $dXYuT = parcelRequire("dXYuT");

var $5gI17 = parcelRequire("5gI17");
const $0087e211b4f30b54$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY = "MULTIPLEXED_TRANSPORT_EXTRA_KEY";
function $0087e211b4f30b54$var$eventFromEnvelope(env, types) {
    let event;
    $5gI17.forEachEnvelopeItem(env, (item, type)=>{
        if (types.includes(type)) event = Array.isArray(item) ? item[1] : void 0;
        return !!event;
    });
    return event;
}
function $0087e211b4f30b54$var$makeOverrideReleaseTransport(createTransport, release) {
    return (options)=>{
        const transport = createTransport(options);
        return {
            ...transport,
            send: async (envelope)=>{
                const event = $0087e211b4f30b54$var$eventFromEnvelope(envelope, [
                    "event",
                    "transaction",
                    "profile",
                    "replay_event"
                ]);
                if (event) event.release = release;
                return transport.send(envelope);
            }
        };
    };
}
function $0087e211b4f30b54$var$overrideDsn(envelope$1, dsn) {
    return $5gI17.createEnvelope(dsn ? {
        ...envelope$1[0],
        dsn: dsn
    } : envelope$1[0], envelope$1[1]);
}
function $0087e211b4f30b54$var$makeMultiplexedTransport(createTransport, matcher) {
    return (options)=>{
        const fallbackTransport = createTransport(options);
        const otherTransports = /* @__PURE__ */ new Map();
        const actualMatcher = matcher || ((args)=>{
            const event = args.getEvent();
            if (event?.extra?.[$0087e211b4f30b54$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY] && Array.isArray(event.extra[$0087e211b4f30b54$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY])) return event.extra[$0087e211b4f30b54$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY];
            return [];
        });
        function getTransport(dsn$1, release) {
            const key = release ? `${dsn$1}:${release}` : dsn$1;
            let transport = otherTransports.get(key);
            if (!transport) {
                const validatedDsn = $dXYuT.dsnFromString(dsn$1);
                if (!validatedDsn) return void 0;
                const url = $bsUcA.getEnvelopeEndpointWithUrlEncodedAuth(validatedDsn, options.tunnel);
                transport = release ? $0087e211b4f30b54$var$makeOverrideReleaseTransport(createTransport, release)({
                    ...options,
                    url: url
                }) : createTransport({
                    ...options,
                    url: url
                });
                otherTransports.set(key, transport);
            }
            return [
                dsn$1,
                transport
            ];
        }
        async function send(envelope) {
            function getEvent(types) {
                const eventTypes = types?.length ? types : [
                    "event"
                ];
                return $0087e211b4f30b54$var$eventFromEnvelope(envelope, eventTypes);
            }
            const transports = actualMatcher({
                envelope: envelope,
                getEvent: getEvent
            }).map((result)=>{
                if (typeof result === "string") return getTransport(result, void 0);
                else return getTransport(result.dsn, result.release);
            }).filter((t)=>!!t);
            const transportsWithFallback = transports.length ? transports : [
                [
                    "",
                    fallbackTransport
                ]
            ];
            const results = await Promise.all(transportsWithFallback.map(([dsn, transport])=>transport.send($0087e211b4f30b54$var$overrideDsn(envelope, dsn))));
            return results[0];
        }
        async function flush(timeout) {
            const allTransports = [
                ...otherTransports.values(),
                fallbackTransport
            ];
            const results = await Promise.all(allTransports.map((transport)=>transport.flush(timeout)));
            return results.every((r)=>r);
        }
        return {
            send: send,
            flush: flush
        };
    };
}
module.exports.MULTIPLEXED_TRANSPORT_EXTRA_KEY = $0087e211b4f30b54$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY;
module.exports.eventFromEnvelope = $0087e211b4f30b54$var$eventFromEnvelope;
module.exports.makeMultiplexedTransport = $0087e211b4f30b54$var$makeMultiplexedTransport;

});

parcelRegister("71viH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9Yejo = parcelRequire("9Yejo");

var $1UPRv = parcelRequire("1UPRv");
const $51d0e80ab7f8dc6c$var$SKIPPED_AI_PROVIDERS = /* @__PURE__ */ new Set();
function $51d0e80ab7f8dc6c$var$_INTERNAL_skipAiProviderWrapping(modules) {
    modules.forEach((module)=>{
        $51d0e80ab7f8dc6c$var$SKIPPED_AI_PROVIDERS.add(module);
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.log(`AI provider "${module}" wrapping will be skipped`);
    });
}
function $51d0e80ab7f8dc6c$var$_INTERNAL_shouldSkipAiProviderWrapping(module) {
    return $51d0e80ab7f8dc6c$var$SKIPPED_AI_PROVIDERS.has(module);
}
function $51d0e80ab7f8dc6c$var$_INTERNAL_clearAiProviderSkips() {
    $51d0e80ab7f8dc6c$var$SKIPPED_AI_PROVIDERS.clear();
    $9Yejo.DEBUG_BUILD && $1UPRv.debug.log("Cleared AI provider skip registrations");
}
module.exports._INTERNAL_clearAiProviderSkips = $51d0e80ab7f8dc6c$var$_INTERNAL_clearAiProviderSkips;
module.exports._INTERNAL_shouldSkipAiProviderWrapping = $51d0e80ab7f8dc6c$var$_INTERNAL_shouldSkipAiProviderWrapping;
module.exports._INTERNAL_skipAiProviderWrapping = $51d0e80ab7f8dc6c$var$_INTERNAL_skipAiProviderWrapping;

});

parcelRegister("cI72D", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8u8UM = parcelRequire("8u8UM");
function $940f0e63eb44cddf$var$isSensitiveKey(lower, denySnippets) {
    return denySnippets.some((snippet)=>lower.includes(snippet));
}
function $940f0e63eb44cddf$var$filterKeyValueData(data, behavior, additionalDenyTerms) {
    if (behavior === false) return {};
    const denySnippets = additionalDenyTerms != null ? [
        ...$8u8UM.SENSITIVE_KEY_SNIPPETS,
        ...additionalDenyTerms
    ] : $8u8UM.SENSITIVE_KEY_SNIPPETS;
    const result = {};
    if (behavior === true) {
        for (const key of Object.keys(data))result[key] = $940f0e63eb44cddf$var$isSensitiveKey(key.toLowerCase(), denySnippets) ? $8u8UM.FILTERED_VALUE : data[key];
        return result;
    }
    if ("deny" in behavior) {
        const lowerTerms2 = behavior.deny.map((t)=>t.toLowerCase());
        for (const key of Object.keys(data)){
            const lower = key.toLowerCase();
            const isDenied = $940f0e63eb44cddf$var$isSensitiveKey(lower, denySnippets) || lowerTerms2.some((term)=>lower.includes(term));
            result[key] = isDenied ? $8u8UM.FILTERED_VALUE : data[key];
        }
        return result;
    }
    const lowerTerms = behavior.allow.map((t)=>t.toLowerCase());
    for (const key of Object.keys(data)){
        const lower = key.toLowerCase();
        if ($940f0e63eb44cddf$var$isSensitiveKey(lower, denySnippets)) result[key] = $8u8UM.FILTERED_VALUE;
        else {
            const isAllowed = lowerTerms.some((term)=>lower.includes(term));
            result[key] = isAllowed ? data[key] : $8u8UM.FILTERED_VALUE;
        }
    }
    return result;
}
module.exports.filterKeyValueData = $940f0e63eb44cddf$var$filterKeyValueData;

});

parcelRegister("c8o8z", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dylZw = parcelRequire("dylZw");

var $8u8UM = parcelRequire("8u8UM");

var $cI72D = parcelRequire("cI72D");
function $8d58f4868b395fd7$var$filterCookies(cookieString, behavior) {
    if (behavior === false) return {};
    try {
        const parsed = $dylZw.parseCookie(cookieString);
        if (Object.keys(parsed).length === 0) return {};
        return $cI72D.filterKeyValueData(parsed, behavior, $8u8UM.SENSITIVE_COOKIE_NAME_SNIPPETS);
    } catch  {
        return $8u8UM.FILTERED_VALUE;
    }
}
module.exports.filterCookies = $8d58f4868b395fd7$var$filterCookies;

});
parcelRegister("dylZw", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $9ddf82555e1f3a15$var$parseCookie(str) {
    const obj = {};
    let index = 0;
    while(index < str.length){
        const eqIdx = str.indexOf("=", index);
        if (eqIdx === -1) break;
        let endIdx = str.indexOf(";", index);
        if (endIdx === -1) endIdx = str.length;
        else if (endIdx < eqIdx) {
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const key = str.slice(index, eqIdx).trim();
        if (void 0 === obj[key]) {
            let val = str.slice(eqIdx + 1, endIdx).trim();
            if (val.charCodeAt(0) === 34) val = val.slice(1, -1);
            try {
                obj[key] = val.indexOf("%") !== -1 ? decodeURIComponent(val) : val;
            } catch  {
                obj[key] = val;
            }
        }
        index = endIdx + 1;
    }
    return obj;
}
module.exports.parseCookie = $9ddf82555e1f3a15$var$parseCookie;

});


parcelRegister("9EfhF", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8u8UM = parcelRequire("8u8UM");

var $cI72D = parcelRequire("cI72D");
function $7063b4909bf1a772$var$filterQueryParams(queryString, behavior) {
    if (behavior === false) return {};
    try {
        const params = new URLSearchParams(queryString);
        const parsed = {};
        params.forEach((value, key)=>{
            parsed[key] = value;
        });
        if (Object.keys(parsed).length === 0) return {};
        return $cI72D.filterKeyValueData(parsed, behavior);
    } catch  {
        return $8u8UM.FILTERED_VALUE;
    }
}
module.exports.filterQueryParams = $7063b4909bf1a772$var$filterQueryParams;

});

parcelRegister("cu5Ya", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $916ceac5a32a43c6$var$FALSY_ENV_VALUES = /* @__PURE__ */ new Set([
    "false",
    "f",
    "n",
    "no",
    "off",
    "0"
]);
const $916ceac5a32a43c6$var$TRUTHY_ENV_VALUES = /* @__PURE__ */ new Set([
    "true",
    "t",
    "y",
    "yes",
    "on",
    "1"
]);
function $916ceac5a32a43c6$var$envToBool(value, options) {
    const normalized = String(value).toLowerCase();
    if ($916ceac5a32a43c6$var$FALSY_ENV_VALUES.has(normalized)) return false;
    if ($916ceac5a32a43c6$var$TRUTHY_ENV_VALUES.has(normalized)) return true;
    return options?.strict ? null : Boolean(value);
}
module.exports.FALSY_ENV_VALUES = $916ceac5a32a43c6$var$FALSY_ENV_VALUES;
module.exports.TRUTHY_ENV_VALUES = $916ceac5a32a43c6$var$TRUTHY_ENV_VALUES;
module.exports.envToBool = $916ceac5a32a43c6$var$envToBool;

});

parcelRegister("jTC4y", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dXYuT = parcelRequire("dXYuT");

var $5gI17 = parcelRequire("5gI17");

var $8odom = parcelRequire("8odom");
function $e7c0afcbfc060784$var$createCheckInEnvelope(checkIn, dynamicSamplingContext, metadata, tunnel, dsn$1) {
    const headers = {
        sent_at: new Date($8odom.safeDateNow()).toISOString()
    };
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $dXYuT.dsnToString(dsn$1);
    if (dynamicSamplingContext) headers.trace = dynamicSamplingContext;
    const item = $e7c0afcbfc060784$var$createCheckInEnvelopeItem(checkIn);
    return $5gI17.createEnvelope(headers, [
        item
    ]);
}
function $e7c0afcbfc060784$var$createCheckInEnvelopeItem(checkIn) {
    const checkInHeaders = {
        type: "check_in"
    };
    return [
        checkInHeaders,
        checkIn
    ];
}
module.exports.createCheckInEnvelope = $e7c0afcbfc060784$var$createCheckInEnvelope;

});

parcelRegister("9ZOjK", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9NHnC = parcelRequire("9NHnC");
function $7470d7917a3b24c8$var$isSentryRequestUrl(url, client) {
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    return $7470d7917a3b24c8$var$checkDsn(url, dsn) || $7470d7917a3b24c8$var$checkTunnel(url, tunnel);
}
function $7470d7917a3b24c8$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $7470d7917a3b24c8$var$removeTrailingSlash(url) === $7470d7917a3b24c8$var$removeTrailingSlash(tunnel);
}
function $7470d7917a3b24c8$var$checkDsn(url$1, dsn) {
    const urlParts = $9NHnC.parseStringToURLObject(url$1);
    if (!urlParts || $9NHnC.isURLObjectRelative(urlParts)) return false;
    if (!dsn) return false;
    return $7470d7917a3b24c8$var$hostnameMatchesDsnHost(urlParts.hostname, dsn.host) && /(^|&|\?)sentry_key=/.test(urlParts.search);
}
function $7470d7917a3b24c8$var$hostnameMatchesDsnHost(hostname, dsnHost) {
    return hostname === dsnHost || dsnHost.length > 0 && hostname.endsWith(`.${dsnHost}`);
}
function $7470d7917a3b24c8$var$removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}
module.exports.isSentryRequestUrl = $7470d7917a3b24c8$var$isSentryRequestUrl;

});
parcelRegister("9NHnC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iuxoj = parcelRequire("iuxoj");

var $dknph = parcelRequire("dknph");
const $722a57020c6dc482$var$DEFAULT_BASE_URL = "thismessage:/";
function $722a57020c6dc482$var$isURLObjectRelative(url) {
    return "isRelative" in url;
}
function $722a57020c6dc482$var$parseStringToURLObject(url, urlBase) {
    const isRelative = url.indexOf("://") <= 0 && url.indexOf("//") !== 0;
    const base = urlBase ?? (isRelative ? $722a57020c6dc482$var$DEFAULT_BASE_URL : void 0);
    try {
        if ("canParse" in URL && !URL.canParse(url, base)) return void 0;
        const fullUrlObject = new URL(url, base);
        if (isRelative) return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {}
    return void 0;
}
function $722a57020c6dc482$var$getSanitizedUrlStringFromUrlObject(url) {
    if ($722a57020c6dc482$var$isURLObjectRelative(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = "";
    newUrl.hash = "";
    if ([
        "80",
        "443"
    ].includes(newUrl.port)) newUrl.port = "";
    if (newUrl.password) newUrl.password = "%filtered%";
    if (newUrl.username) newUrl.username = "%filtered%";
    return newUrl.toString();
}
function $722a57020c6dc482$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? "GET";
    const route = routeName ? routeName : urlObject ? kind === "client" ? $722a57020c6dc482$var$getSanitizedUrlStringFromUrlObject(urlObject) : urlObject.pathname : "/";
    return `${method} ${route}`;
}
function $722a57020c6dc482$var$getHttpSpanDetailsFromUrlObject(urlObject, kind, spanOrigin, request, routeName) {
    const attributes$1 = {
        [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanOrigin,
        [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "url"
    };
    if (routeName) {
        attributes$1[kind === "server" ? "http.route" : "url.template"] = routeName;
        attributes$1[$dknph.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "route";
    }
    if (request?.method) attributes$1[$dknph.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes$1["url.query"] = urlObject.search;
        if (urlObject.hash) attributes$1["url.fragment"] = urlObject.hash;
        if (urlObject.pathname) {
            attributes$1["url.path"] = urlObject.pathname;
            if (urlObject.pathname === "/") attributes$1[$dknph.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "route";
        }
        if (!$722a57020c6dc482$var$isURLObjectRelative(urlObject)) {
            attributes$1[$iuxoj.URL_FULL] = urlObject.href;
            if (urlObject.port) attributes$1["url.port"] = urlObject.port;
            if (urlObject.protocol) attributes$1["url.scheme"] = urlObject.protocol;
            if (urlObject.hostname) attributes$1[kind === "server" ? "server.address" : "url.domain"] = urlObject.hostname;
        }
    }
    return [
        $722a57020c6dc482$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes$1
    ];
}
function $722a57020c6dc482$var$parseUrl(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
function $722a57020c6dc482$var$stripUrlQueryAndFragment(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
function $722a57020c6dc482$var$getSanitizedUrlString(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}
function $722a57020c6dc482$var$stripDataUrlContent(url, includeDataPrefix = true) {
    if (url.startsWith("data:")) {
        const match = url.match(/^data:([^;,]+)/);
        const mimeType = match ? match[1] : "text/plain";
        const isBase64 = url.includes(";base64,");
        const dataStart = url.indexOf(",");
        let dataPrefix = "";
        if (includeDataPrefix && dataStart !== -1) {
            const data = url.slice(dataStart + 1);
            dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
        }
        return `data:${mimeType}${isBase64 ? ",base64" : ""}${dataPrefix ? `,${dataPrefix}` : ""}`;
    }
    return url;
}
module.exports.getHttpSpanDetailsFromUrlObject = $722a57020c6dc482$var$getHttpSpanDetailsFromUrlObject;
module.exports.getSanitizedUrlString = $722a57020c6dc482$var$getSanitizedUrlString;
module.exports.getSanitizedUrlStringFromUrlObject = $722a57020c6dc482$var$getSanitizedUrlStringFromUrlObject;
module.exports.isURLObjectRelative = $722a57020c6dc482$var$isURLObjectRelative;
module.exports.parseStringToURLObject = $722a57020c6dc482$var$parseStringToURLObject;
module.exports.parseUrl = $722a57020c6dc482$var$parseUrl;
module.exports.stripDataUrlContent = $722a57020c6dc482$var$stripDataUrlContent;
module.exports.stripUrlQueryAndFragment = $722a57020c6dc482$var$stripUrlQueryAndFragment;

});


parcelRegister("lNccF", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $fdd7a3e541f056d1$var$parameterize(strings, ...values) {
    const formatted = new String(String.raw(strings, ...values));
    formatted.__sentry_template_string__ = strings.join("\0").replace(/%/g, "%%").replace(/\0/g, "%s");
    formatted.__sentry_template_values__ = values;
    return formatted;
}
const $fdd7a3e541f056d1$var$fmt = $fdd7a3e541f056d1$var$parameterize;
module.exports.fmt = $fdd7a3e541f056d1$var$fmt;
module.exports.parameterize = $fdd7a3e541f056d1$var$parameterize;

});

parcelRegister("dQEGN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bsUcA = parcelRequire("bsUcA");

var $1UPRv = parcelRequire("1UPRv");

var $dXYuT = parcelRequire("dXYuT");

var $5gI17 = parcelRequire("5gI17");
async function $a14fb1bf4c607eea$var$handleTunnelRequest(options) {
    const { request: request, allowedDsns: allowedDsns } = options;
    if (allowedDsns.length === 0) return new Response("Tunnel not configured", {
        status: 500
    });
    const body = new Uint8Array(await request.arrayBuffer());
    let envelopeHeader;
    try {
        [envelopeHeader] = $5gI17.parseEnvelope(body);
    } catch  {
        return new Response("Invalid envelope", {
            status: 400
        });
    }
    if (!envelopeHeader) return new Response("Invalid envelope: missing header", {
        status: 400
    });
    const dsn$1 = envelopeHeader.dsn;
    if (!dsn$1) return new Response("Invalid envelope: missing DSN", {
        status: 400
    });
    const isAllowed = allowedDsns.some((allowed)=>allowed === dsn$1);
    if (!isAllowed) {
        $1UPRv.debug.warn(`Sentry tunnel: rejected request with unauthorized DSN (${dsn$1})`);
        return new Response("DSN not allowed", {
            status: 403
        });
    }
    const dsnComponents = $dXYuT.makeDsn(dsn$1);
    if (!dsnComponents) {
        $1UPRv.debug.warn(`Could not extract DSN Components from: ${dsn$1}`);
        return new Response("Invalid DSN", {
            status: 403
        });
    }
    const sentryIngestUrl = $bsUcA.getEnvelopeEndpointWithUrlEncodedAuth(dsnComponents);
    try {
        return await fetch(sentryIngestUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-sentry-envelope"
            },
            body: body
        });
    } catch (error) {
        $1UPRv.debug.error("Sentry tunnel: failed to forward envelope", error);
        return new Response("Failed to forward envelope to Sentry", {
            status: 500
        });
    }
}
module.exports.handleTunnelRequest = $a14fb1bf4c607eea$var$handleTunnelRequest;

});

parcelRegister("ixEJH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $d7fae8681280dbaf$var$addAutoIpAddressToUser(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === void 0) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: "{{auto}}"
    };
}
function $d7fae8681280dbaf$var$addAutoIpAddressToSession(session) {
    if ("aggregates" in session) {
        if (session.attrs?.["ip_address"] === void 0) session.attrs = {
            ...session.attrs,
            ip_address: "{{auto}}"
        };
    } else if (session.ipAddress === void 0) session.ipAddress = "{{auto}}";
}
module.exports.addAutoIpAddressToSession = $d7fae8681280dbaf$var$addAutoIpAddressToSession;
module.exports.addAutoIpAddressToUser = $d7fae8681280dbaf$var$addAutoIpAddressToUser;

});

parcelRegister("hhWrw", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $88W3d = parcelRequire("88W3d");
function $c9615bc4c91569ad$var$applySdkMetadata(options, name, names = [
    name
], source = "npm") {
    const sdk = (options._metadata = options._metadata || {}).sdk = options._metadata.sdk || {};
    if (!sdk.name) {
        sdk.name = `sentry.javascript.${name}`;
        sdk.packages = names.map((name2)=>({
                name: `${source}:@sentry/${name2}`,
                version: $88W3d.SDK_VERSION
            }));
        sdk.version = $88W3d.SDK_VERSION;
    }
}
module.exports.applySdkMetadata = $c9615bc4c91569ad$var$applySdkMetadata;

});

parcelRegister("ft8tx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1xFq0 = parcelRequire("1xFq0");

var $6FBPf = parcelRequire("6FBPf");

var $8DrvK = parcelRequire("8DrvK");

var $i98W3 = parcelRequire("i98W3");

var $1UPRv = parcelRequire("1UPRv");

var $eXvrd = parcelRequire("eXvrd");

var $13jPF = parcelRequire("13jPF");

var $kJznu = parcelRequire("kJznu");

var $boK9h = parcelRequire("boK9h");

var $lJcxl = parcelRequire("lJcxl");

var $jrPYE = parcelRequire("jrPYE");
function $b4302378fb26ea26$var$getTraceData(options = {}) {
    const client = options.client || $8DrvK.getClient();
    if (!$i98W3.isEnabled() || !client) return {};
    const carrier$1 = $6FBPf.getMainCarrier();
    const acs = $1xFq0.getAsyncContextStrategy(carrier$1);
    if (acs.getTraceData) return acs.getTraceData(options);
    const scope = options.scope || $8DrvK.getCurrentScope();
    const span = options.span || $eXvrd.getActiveSpan();
    const isTwpPlaceholder = $kJznu.spanIsNonRecordingSpan(span) && !$13jPF.hasSpansEnabled(client.getOptions());
    if (!span && $8DrvK.hasExternalPropagationContext()) return {};
    const sentryTrace = span && !isTwpPlaceholder ? $eXvrd.spanToTraceHeader(span) : $b4302378fb26ea26$var$scopeToTraceHeader(scope);
    const dsc = span ? $boK9h.getDynamicSamplingContextFromSpan(span) : $boK9h.getDynamicSamplingContextFromScope(client, scope);
    const baggage$1 = $lJcxl.dynamicSamplingContextToSentryBaggageHeader(dsc);
    const isValidSentryTraceHeader = $jrPYE.TRACEPARENT_REGEXP.test(sentryTrace);
    if (!isValidSentryTraceHeader) {
        $1UPRv.debug.warn("Invalid sentry-trace data. Cannot generate trace data");
        return {};
    }
    const traceData = {
        "sentry-trace": sentryTrace,
        baggage: baggage$1
    };
    if (options.propagateTraceparent) traceData.traceparent = span && !isTwpPlaceholder ? $eXvrd.spanToTraceparentHeader(span) : $b4302378fb26ea26$var$scopeToTraceparentHeader(scope);
    return traceData;
}
function $b4302378fb26ea26$var$scopeToTraceHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return $jrPYE.generateSentryTraceHeader(traceId, propagationSpanId, sampled);
}
function $b4302378fb26ea26$var$scopeToTraceparentHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return $jrPYE.generateTraceparentHeader(traceId, propagationSpanId, sampled);
}
module.exports.getTraceData = $b4302378fb26ea26$var$getTraceData;

});

parcelRegister("jCSeW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9Yejo = parcelRequire("9Yejo");

var $1UPRv = parcelRequire("1UPRv");

var $erV30 = parcelRequire("erV30");
const $e49ba3dd48a7da94$var$NOT_PROPAGATED_MESSAGE = "[Tracing] Not injecting trace data for url because it does not match tracePropagationTargets:";
function $e49ba3dd48a7da94$var$shouldPropagateTraceForUrl(url, tracePropagationTargets, decisionMap) {
    if (typeof url !== "string" || !tracePropagationTargets) return true;
    const cachedDecision = decisionMap?.get(url);
    if (cachedDecision !== void 0) {
        $9Yejo.DEBUG_BUILD && !cachedDecision && $1UPRv.debug.log($e49ba3dd48a7da94$var$NOT_PROPAGATED_MESSAGE, url);
        return cachedDecision;
    }
    const decision = $erV30.stringMatchesSomePattern(url, tracePropagationTargets);
    decisionMap?.set(url, decision);
    $9Yejo.DEBUG_BUILD && !decision && $1UPRv.debug.log($e49ba3dd48a7da94$var$NOT_PROPAGATED_MESSAGE, url);
    return decision;
}
module.exports.shouldPropagateTraceForUrl = $e49ba3dd48a7da94$var$shouldPropagateTraceForUrl;

});

parcelRegister("3mhH9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ft8tx = parcelRequire("ft8tx");
function $272127077f1dfbff$var$getTraceMetaTags(traceData$1) {
    return Object.entries(traceData$1 || $ft8tx.getTraceData()).map(([key, value])=>`<meta name="${key}" content="${value}"/>`).join("");
}
module.exports.getTraceMetaTags = $272127077f1dfbff$var$getTraceMetaTags;

});

parcelRegister("h1aOQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $c63aec18b21e166d$var$uniq(input) {
    return Array.from(new Set(input));
}
module.exports.uniq = $c63aec18b21e166d$var$uniq;

});

parcelRegister("fTqrd", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9Yejo = parcelRequire("9Yejo");

var $1UPRv = parcelRequire("1UPRv");

var $fpUGo = parcelRequire("fpUGo");

var $8u8UM = parcelRequire("8u8UM");

var $cI72D = parcelRequire("cI72D");

var $5wKGb = parcelRequire("5wKGb");
const $b920801e91675edf$var$MAX_BODY_BYTE_LENGTH = 1048576;
const $b920801e91675edf$var$TEXT_CONTENT_TYPES = [
    "text/",
    "application/json",
    "application/x-www-form-urlencoded",
    "application/xml",
    "application/graphql"
];
function $b920801e91675edf$var$getMaxBodyByteLength(maxRequestBodySize) {
    if (maxRequestBodySize === "small") return 1e3;
    if (maxRequestBodySize === "medium") return 1e4;
    return $b920801e91675edf$var$MAX_BODY_BYTE_LENGTH;
}
function $b920801e91675edf$var$winterCGHeadersToDict(winterCGHeaders) {
    const headers = {};
    try {
        winterCGHeaders.forEach((value, key)=>{
            if (typeof value === "string") headers[key] = value;
        });
    } catch  {}
    return headers;
}
function $b920801e91675edf$var$headersToDict(reqHeaders) {
    const headers = /* @__PURE__ */ Object.create(null);
    try {
        Object.entries(reqHeaders).forEach(([key, value])=>{
            if (typeof value === "string") headers[key] = value;
            else if (typeof value === "number") headers[key] = String(value);
        });
    } catch  {}
    return headers;
}
function $b920801e91675edf$var$winterCGRequestToRequestData(req) {
    const headers = $b920801e91675edf$var$winterCGHeadersToDict(req.headers);
    return {
        method: req.method,
        url: req.url,
        query_string: $b920801e91675edf$var$extractQueryParamsFromUrl(req.url),
        headers: headers
    };
}
function $b920801e91675edf$var$isTextualContentType(contentType) {
    if (!contentType) return false;
    const lowerContentType = contentType.toLowerCase();
    return $b920801e91675edf$var$TEXT_CONTENT_TYPES.some((type)=>lowerContentType.includes(type));
}
async function $b920801e91675edf$var$captureBodyFromWinterCGRequest(request, isolationScope, maxRequestBodySize) {
    try {
        const contentType = request.headers.get("content-type");
        if (!$b920801e91675edf$var$isTextualContentType(contentType)) {
            $9Yejo.DEBUG_BUILD && $1UPRv.debug.log("Skipping body capture for non-textual content type:", contentType);
            return;
        }
        if (!request.body) return;
        const contentLength = request.headers.get("content-length");
        const maxBodySize = $b920801e91675edf$var$getMaxBodyByteLength(maxRequestBodySize);
        if (contentLength) {
            const length = parseInt(contentLength, 10);
            if (!isNaN(length) && length > $b920801e91675edf$var$MAX_BODY_BYTE_LENGTH) {
                $9Yejo.DEBUG_BUILD && $1UPRv.debug.log("Skipping body capture: body too large", length);
                return;
            }
        }
        const clonedRequest = request.clone();
        const bodyPromise = clonedRequest.text();
        const timeoutPromise = new Promise((resolve)=>{
            $5wKGb.safeUnref(setTimeout(()=>resolve(null), 2e3));
        });
        const body = await Promise.race([
            bodyPromise,
            timeoutPromise
        ]);
        if (body === null) {
            $9Yejo.DEBUG_BUILD && $1UPRv.debug.log("Timeout reading request body");
            return;
        }
        if (!body) return;
        const encoder = new TextEncoder();
        const bytes = encoder.encode(body);
        const bodyByteLength = bytes.length;
        let truncatedBody;
        if (bodyByteLength > maxBodySize) {
            const decoder = new TextDecoder();
            truncatedBody = `${decoder.decode(bytes.slice(0, maxBodySize - 3))}...`;
        } else truncatedBody = body;
        isolationScope.setSDKProcessingMetadata({
            normalizedRequest: {
                data: truncatedBody
            }
        });
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.log("Captured request body:", bodyByteLength, "bytes");
    } catch (error) {
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.error("Error capturing request body:", error);
    }
}
function $b920801e91675edf$var$httpRequestToRequestData(request) {
    const headers = request.headers || {};
    const forwardedHost = typeof headers["x-forwarded-host"] === "string" ? headers["x-forwarded-host"] : void 0;
    const host = forwardedHost || (typeof headers.host === "string" ? headers.host : void 0);
    const forwardedProto = typeof headers["x-forwarded-proto"] === "string" ? headers["x-forwarded-proto"] : void 0;
    const protocol = forwardedProto || request.protocol || (request.socket?.encrypted ? "https" : "http");
    const url = request.url || "";
    const absoluteUrl = $b920801e91675edf$var$getAbsoluteUrl({
        url: url,
        host: host,
        protocol: protocol
    });
    const data = request.body || void 0;
    const cookies = request.cookies;
    return {
        url: absoluteUrl,
        method: request.method,
        query_string: $b920801e91675edf$var$extractQueryParamsFromUrl(url),
        headers: $b920801e91675edf$var$headersToDict(headers),
        cookies: cookies,
        data: data
    };
}
function $b920801e91675edf$var$getAbsoluteUrl({ url: url, protocol: protocol, host: host }) {
    if (url?.startsWith("http")) return url;
    if (url && host) return `${protocol}://${host}${url}`;
    return void 0;
}
function $b920801e91675edf$var$httpHeadersToSpanAttributes(headers, dataCollection = false, lifecycle = "request") {
    const resolvedDataCollection = typeof dataCollection === "boolean" ? $fpUGo.defaultPiiToCollectionOptions(dataCollection) : dataCollection;
    const headerBehavior = lifecycle === "request" ? resolvedDataCollection.httpHeaders.request : resolvedDataCollection.httpHeaders.response;
    const cookieBehavior = resolvedDataCollection.cookies;
    const prefix = `http.${lifecycle}.header.`;
    const spanAttributes = {};
    try {
        const regularHeaders = {};
        for (const [key, value] of Object.entries(headers)){
            if (value == null) continue;
            const lowerKey = key.toLowerCase();
            const isCookieHeader = lowerKey === "cookie" || lowerKey === "set-cookie";
            if (isCookieHeader) {
                if (cookieBehavior === false) continue;
                if (typeof value === "string" && value !== "") {
                    const parsed = $b920801e91675edf$var$parseCookieHeader(value, lowerKey === "set-cookie");
                    const filtered = $cI72D.filterKeyValueData(parsed, cookieBehavior, $8u8UM.SENSITIVE_COOKIE_NAME_SNIPPETS);
                    for (const [cookieKey, cookieValue] of Object.entries(filtered))spanAttributes[`${prefix}${$b920801e91675edf$var$normalizeAttributeKey(lowerKey)}.${$b920801e91675edf$var$normalizeAttributeKey(cookieKey)}`] = cookieValue;
                } else spanAttributes[`${prefix}${$b920801e91675edf$var$normalizeAttributeKey(lowerKey)}`] = $8u8UM.FILTERED_VALUE;
            } else {
                if (headerBehavior === false) continue;
                if (Array.isArray(value)) regularHeaders[lowerKey] = value.map((v)=>v != null ? String(v) : v).join(";");
                else if (typeof value === "string") regularHeaders[lowerKey] = value;
            }
        }
        if (headerBehavior !== false) {
            const filtered = $cI72D.filterKeyValueData(regularHeaders, headerBehavior);
            for (const [headerKey, headerValue] of Object.entries(filtered))spanAttributes[`${prefix}${$b920801e91675edf$var$normalizeAttributeKey(headerKey)}`] = headerValue;
        }
    } catch  {}
    return spanAttributes;
}
function $b920801e91675edf$var$normalizeAttributeKey(key) {
    return key.replace(/-/g, "_");
}
function $b920801e91675edf$var$parseCookieHeader(value, isSetCookie) {
    const semicolonIndex = value.indexOf(";");
    const cookieString = isSetCookie && semicolonIndex !== -1 ? value.substring(0, semicolonIndex) : value;
    const cookies = isSetCookie ? [
        cookieString
    ] : cookieString.split("; ");
    const result = {};
    for (const cookie of cookies){
        const equalSignIndex = cookie.indexOf("=");
        const cookieKey = (equalSignIndex !== -1 ? cookie.substring(0, equalSignIndex) : cookie).toLowerCase();
        const cookieValue = equalSignIndex !== -1 ? cookie.substring(equalSignIndex + 1) : "";
        result[cookieKey] = cookieValue;
    }
    return result;
}
function $b920801e91675edf$var$extractQueryParamsFromUrl(url) {
    if (!url) return;
    try {
        const queryParams = new URL(url, "http://s.io").search.slice(1);
        return queryParams.length ? queryParams : void 0;
    } catch  {
        return void 0;
    }
}
module.exports.MAX_BODY_BYTE_LENGTH = $b920801e91675edf$var$MAX_BODY_BYTE_LENGTH;
module.exports.captureBodyFromWinterCGRequest = $b920801e91675edf$var$captureBodyFromWinterCGRequest;
module.exports.extractQueryParamsFromUrl = $b920801e91675edf$var$extractQueryParamsFromUrl;
module.exports.getMaxBodyByteLength = $b920801e91675edf$var$getMaxBodyByteLength;
module.exports.headersToDict = $b920801e91675edf$var$headersToDict;
module.exports.httpHeadersToSpanAttributes = $b920801e91675edf$var$httpHeadersToSpanAttributes;
module.exports.httpRequestToRequestData = $b920801e91675edf$var$httpRequestToRequestData;
module.exports.winterCGHeadersToDict = $b920801e91675edf$var$winterCGHeadersToDict;
module.exports.winterCGRequestToRequestData = $b920801e91675edf$var$winterCGRequestToRequestData;

});

parcelRegister("667w2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $470922190ed6da57$var$SPAN_KIND = {
    INTERNAL: 0,
    SERVER: 1,
    CLIENT: 2,
    PRODUCER: 3,
    CONSUMER: 4
};
const $470922190ed6da57$var$SPAN_KIND_NAME = {
    [$470922190ed6da57$var$SPAN_KIND.INTERNAL]: "INTERNAL",
    [$470922190ed6da57$var$SPAN_KIND.SERVER]: "SERVER",
    [$470922190ed6da57$var$SPAN_KIND.CLIENT]: "CLIENT",
    [$470922190ed6da57$var$SPAN_KIND.PRODUCER]: "PRODUCER",
    [$470922190ed6da57$var$SPAN_KIND.CONSUMER]: "CONSUMER"
};
function $470922190ed6da57$var$spanKindToName(kind) {
    return $470922190ed6da57$var$SPAN_KIND_NAME[kind];
}
module.exports.SPAN_KIND = $470922190ed6da57$var$SPAN_KIND;
module.exports.spanKindToName = $470922190ed6da57$var$spanKindToName;

});

parcelRegister("85QQN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8DrvK = parcelRequire("8DrvK");

var $1UPRv = parcelRequire("1UPRv");

var $1MCl5 = parcelRequire("1MCl5");
const $5e47c9608e0128eb$var$DEFAULT_BREADCRUMBS = 100;
function $5e47c9608e0128eb$var$addBreadcrumb(breadcrumb, hint) {
    const client = $8DrvK.getClient();
    const isolationScope = $8DrvK.getIsolationScope();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $5e47c9608e0128eb$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = $1MCl5.dateTimestampInSeconds();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? $1UPRv.consoleSandbox(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}
module.exports.addBreadcrumb = $5e47c9608e0128eb$var$addBreadcrumb;

});

parcelRegister("kSd27", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8DrvK = parcelRequire("8DrvK");

var $k2EST = parcelRequire("k2EST");

var $kzIHY = parcelRequire("kzIHY");
const $f322f5e363d16def$var$INTEGRATION_NAME = "FunctionToString";
const $f322f5e363d16def$var$SETUP_CLIENTS = /* @__PURE__ */ new WeakMap();
const $f322f5e363d16def$var$_functionToStringIntegration = ()=>{
    return {
        name: $f322f5e363d16def$var$INTEGRATION_NAME,
        setupOnce () {
            const originalFunctionToString = Function.prototype.toString;
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = $kzIHY.getOriginalFunction(this);
                    let unwrappedFunction;
                    try {
                        if ($f322f5e363d16def$var$SETUP_CLIENTS.has($8DrvK.getClient()) && originalFunction !== void 0) unwrappedFunction = originalFunction;
                    } catch  {}
                    return originalFunctionToString.apply(unwrappedFunction ?? this, args);
                };
            } catch  {}
        },
        setup (client) {
            $f322f5e363d16def$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
const $f322f5e363d16def$var$functionToStringIntegration = $k2EST.defineIntegration($f322f5e363d16def$var$_functionToStringIntegration);
module.exports.functionToStringIntegration = $f322f5e363d16def$var$functionToStringIntegration;

});

parcelRegister("3HHYv", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9Yejo = parcelRequire("9Yejo");

var $k2EST = parcelRequire("k2EST");

var $1UPRv = parcelRequire("1UPRv");

var $86e6R = parcelRequire("86e6R");

var $8iRTV = parcelRequire("8iRTV");

var $erV30 = parcelRequire("erV30");
const $2b277fc64f9ebfb6$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    // The browser logs this when a ResizeObserver handler takes a bit longer. Usually this is not an actual issue though. It indicates slowness.
    /^Cannot redefine property: googletag$/,
    // This is thrown when google tag manager is used in combination with an ad blocker
    /^Can't find variable: gmo$/,
    // Error from Google Search App https://issuetracker.google.com/issues/396043331
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    // Random error that happens but not actionable or noticeable to end-users.
    /can't redefine non-configurable property "solana"/,
    // Probably a browser extension or custom browser (Brave) throwing this error
    /vv\(\)\.getRestrictions is not a function/,
    // Error thrown by GTM, seemingly not affecting end-users
    /Can't find variable: _AutofillCallbackHandler/,
    // Unactionable error in instagram webview https://developers.facebook.com/community/threads/320013549791141/
    /Object Not Found Matching Id:\d+, MethodName:simulateEvent/,
    // unactionable error from CEFSharp, a .NET library that embeds chromium in .NET apps
    /^Java exception was raised during method invocation$/
];
const $2b277fc64f9ebfb6$var$INTEGRATION_NAME = "EventFilters";
const $2b277fc64f9ebfb6$var$eventFiltersIntegration = $k2EST.defineIntegration((options = {})=>{
    let mergedOptions;
    return {
        name: $2b277fc64f9ebfb6$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $2b277fc64f9ebfb6$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $2b277fc64f9ebfb6$var$_mergeOptions(options, clientOptions);
            }
            return $2b277fc64f9ebfb6$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
const $2b277fc64f9ebfb6$var$inboundFiltersIntegration = $k2EST.defineIntegration((options = {})=>{
    return {
        ...$2b277fc64f9ebfb6$var$eventFiltersIntegration(options),
        name: "InboundFilters"
    };
});
function $2b277fc64f9ebfb6$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $2b277fc64f9ebfb6$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $2b277fc64f9ebfb6$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        if ($2b277fc64f9ebfb6$var$_isIgnoredError(event, options.ignoreErrors)) {
            $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn(`Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${$8iRTV.getEventDescription(event)}`);
            return true;
        }
        if ($2b277fc64f9ebfb6$var$_isUselessError(event)) {
            $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn(`Event dropped due to not having an error message, error type or stacktrace.
Event: ${$8iRTV.getEventDescription(event)}`);
            return true;
        }
        if ($2b277fc64f9ebfb6$var$_isDeniedUrl(event, options.denyUrls)) {
            $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn(`Event dropped due to being matched by \`denyUrls\` option.
Event: ${$8iRTV.getEventDescription(event)}.
Url: ${$2b277fc64f9ebfb6$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$2b277fc64f9ebfb6$var$_isAllowedUrl(event, options.allowUrls)) {
            $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn(`Event dropped due to not being matched by \`allowUrls\` option.
Event: ${$8iRTV.getEventDescription(event)}.
Url: ${$2b277fc64f9ebfb6$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === "transaction") {
        if ($2b277fc64f9ebfb6$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn(`Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${$8iRTV.getEventDescription(event)}`);
            return true;
        }
    }
    return false;
}
function $2b277fc64f9ebfb6$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return $86e6R.getPossibleEventMessages(event).some((message)=>$erV30.stringMatchesSomePattern(message, ignoreErrors));
}
function $2b277fc64f9ebfb6$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? $erV30.stringMatchesSomePattern(name, ignoreTransactions) : false;
}
function $2b277fc64f9ebfb6$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $2b277fc64f9ebfb6$var$_getEventFilterUrl(event);
    return !url ? false : $erV30.stringMatchesSomePattern(url, denyUrls);
}
function $2b277fc64f9ebfb6$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $2b277fc64f9ebfb6$var$_getEventFilterUrl(event);
    return !url ? true : $erV30.stringMatchesSomePattern(url, allowUrls);
}
function $2b277fc64f9ebfb6$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $2b277fc64f9ebfb6$var$_getEventFilterUrl(event) {
    try {
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === void 0 && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $2b277fc64f9ebfb6$var$_getLastValidUrl(frames) : null;
    } catch  {
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.error(`Cannot extract url for event ${$8iRTV.getEventDescription(event)}`);
        return null;
    }
}
function $2b277fc64f9ebfb6$var$_isUselessError(event) {
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== "Error" || value.value));
}
module.exports.eventFiltersIntegration = $2b277fc64f9ebfb6$var$eventFiltersIntegration;
module.exports.inboundFiltersIntegration = $2b277fc64f9ebfb6$var$inboundFiltersIntegration;

});

parcelRegister("7RlKL", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k2EST = parcelRequire("k2EST");

var $iThCW = parcelRequire("iThCW");

var $2TyT2 = parcelRequire("2TyT2");
const $5b8e5b653111bb74$var$DEFAULT_KEY = "cause";
const $5b8e5b653111bb74$var$DEFAULT_LIMIT = 5;
const $5b8e5b653111bb74$var$INTEGRATION_NAME = "LinkedErrors";
const $5b8e5b653111bb74$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $5b8e5b653111bb74$var$DEFAULT_LIMIT;
    const key = options.key || $5b8e5b653111bb74$var$DEFAULT_KEY;
    return {
        name: $5b8e5b653111bb74$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options2 = client.getOptions();
            $iThCW.applyAggregateErrorsToEvent($2TyT2.exceptionFromError, options2.stackParser, key, limit, event, hint);
        }
    };
};
const $5b8e5b653111bb74$var$linkedErrorsIntegration = $k2EST.defineIntegration($5b8e5b653111bb74$var$_linkedErrorsIntegration);
module.exports.linkedErrorsIntegration = $5b8e5b653111bb74$var$linkedErrorsIntegration;

});
parcelRegister("iThCW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eMfEg = parcelRequire("eMfEg");
function $dc0b096ddd5442e9$var$applyAggregateErrorsToEvent(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !$eMfEg.isError(hint.originalException)) return;
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : void 0;
    if (originalException) event.exception.values = $dc0b096ddd5442e9$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $dc0b096ddd5442e9$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    if ($eMfEg.isError(error[key])) {
        $dc0b096ddd5442e9$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $dc0b096ddd5442e9$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $dc0b096ddd5442e9$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    if ($dc0b096ddd5442e9$var$isExceptionGroup(error)) error.errors.forEach((childError, i)=>{
        if ($eMfEg.isError(childError)) {
            $dc0b096ddd5442e9$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $dc0b096ddd5442e9$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $dc0b096ddd5442e9$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $dc0b096ddd5442e9$var$isExceptionGroup(error) {
    return Array.isArray(error.errors);
}
function $dc0b096ddd5442e9$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error) {
    exception.mechanism = {
        handled: true,
        type: "auto.core.linked_errors",
        ...$dc0b096ddd5442e9$var$isExceptionGroup(error) && {
            is_exception_group: true
        },
        ...exception.mechanism,
        exception_id: exceptionId
    };
}
function $dc0b096ddd5442e9$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    exception.mechanism = {
        handled: true,
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
module.exports.applyAggregateErrorsToEvent = $dc0b096ddd5442e9$var$applyAggregateErrorsToEvent;

});

parcelRegister("2TyT2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eMfEg = parcelRequire("eMfEg");

var $8iRTV = parcelRequire("8iRTV");

var $aaVDI = parcelRequire("aaVDI");

var $kzIHY = parcelRequire("kzIHY");
function $21bbc79457e088ac$var$parseStackFrames(stackParser, error) {
    return stackParser(error.stack || "", 1);
}
function $21bbc79457e088ac$var$hasSentryFetchUrlHost(error) {
    return $eMfEg.isError(error) && "__sentry_fetch_url_host__" in error && typeof error.__sentry_fetch_url_host__ === "string";
}
function $21bbc79457e088ac$var$_enhanceErrorWithSentryInfo(error) {
    if ($21bbc79457e088ac$var$hasSentryFetchUrlHost(error)) return `${error.message} (${error.__sentry_fetch_url_host__})`;
    return error.message;
}
function $21bbc79457e088ac$var$exceptionFromError(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: $21bbc79457e088ac$var$_enhanceErrorWithSentryInfo(error)
    };
    const frames = $21bbc79457e088ac$var$parseStackFrames(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function $21bbc79457e088ac$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if ($eMfEg.isError(value)) return value;
    }
    return void 0;
}
function $21bbc79457e088ac$var$getMessageForObject(exception) {
    if ("name" in exception && typeof exception.name === "string") {
        let message = `'${exception.name}' captured as exception`;
        if ("message" in exception && typeof exception.message === "string") message += ` with message '${exception.message}'`;
        return message;
    } else if ("message" in exception && typeof exception.message === "string") return exception.message;
    const keys = $kzIHY.extractExceptionKeysForMessage(exception);
    if ($eMfEg.isErrorEvent(exception)) return `Event \`ErrorEvent\` captured as exception with message \`${exception.message}\``;
    const className = $21bbc79457e088ac$var$getObjectClassName(exception);
    return `${className && className !== "Object" ? `'${className}'` : "Object"} captured as exception with keys: ${keys}`;
}
function $21bbc79457e088ac$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch  {}
}
function $21bbc79457e088ac$var$getException(client, mechanism, exception, hint) {
    if ($eMfEg.isError(exception)) return [
        exception,
        void 0
    ];
    mechanism.synthetic = true;
    if ($eMfEg.isPlainObject(exception)) {
        const normalizeDepth = client?.getOptions().normalizeDepth;
        const extras = {
            ["__serialized__"]: $aaVDI.normalizeToSize(exception, normalizeDepth)
        };
        const errorFromProp = $21bbc79457e088ac$var$getErrorPropertyFromObject(exception);
        if (errorFromProp) return [
            errorFromProp,
            extras
        ];
        const message = $21bbc79457e088ac$var$getMessageForObject(exception);
        const ex2 = hint?.syntheticException || new Error(message);
        ex2.message = message;
        return [
            ex2,
            extras
        ];
    }
    const ex = hint?.syntheticException || new Error(exception);
    ex.message = `${exception}`;
    return [
        ex,
        void 0
    ];
}
function $21bbc79457e088ac$var$eventFromUnknownInput(client, stackParser, exception, hint) {
    const providedMechanism = hint?.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: "generic"
    };
    const [ex, extras] = $21bbc79457e088ac$var$getException(client, mechanism, exception, hint);
    const event = {
        exception: {
            values: [
                $21bbc79457e088ac$var$exceptionFromError(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    $8iRTV.addExceptionTypeValue(event, void 0, void 0);
    $8iRTV.addExceptionMechanism(event, mechanism);
    return {
        ...event,
        event_id: hint?.event_id
    };
}
function $21bbc79457e088ac$var$eventFromMessage(stackParser, message, level = "info", hint, attachStacktrace) {
    const event = {
        event_id: hint?.event_id,
        level: level
    };
    if (attachStacktrace && hint?.syntheticException) {
        const frames = $21bbc79457e088ac$var$parseStackFrames(stackParser, hint.syntheticException);
        if (frames.length) {
            event.exception = {
                values: [
                    {
                        value: message,
                        stacktrace: {
                            frames: frames
                        }
                    }
                ]
            };
            $8iRTV.addExceptionMechanism(event, {
                synthetic: true
            });
        }
    }
    if ($eMfEg.isParameterizedString(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
module.exports._enhanceErrorWithSentryInfo = $21bbc79457e088ac$var$_enhanceErrorWithSentryInfo;
module.exports.eventFromMessage = $21bbc79457e088ac$var$eventFromMessage;
module.exports.eventFromUnknownInput = $21bbc79457e088ac$var$eventFromUnknownInput;
module.exports.exceptionFromError = $21bbc79457e088ac$var$exceptionFromError;
module.exports.parseStackFrames = $21bbc79457e088ac$var$parseStackFrames;

});


parcelRegister("wImw7", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k2EST = parcelRequire("k2EST");

var $lw8Ay = parcelRequire("lw8Ay");

var $5gI17 = parcelRequire("5gI17");
const $062566ad9925c48d$var$moduleMetadataIntegration = $k2EST.defineIntegration(()=>{
    return {
        name: "ModuleMetadata",
        setup (client) {
            client.on("beforeEnvelope", (envelope$1)=>{
                $5gI17.forEachEnvelopeItem(envelope$1, (item, type)=>{
                    if (type === "event") {
                        const event = Array.isArray(item) ? item[1] : void 0;
                        if (event) {
                            $lw8Ay.stripMetadataFromStackFrames(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on("applyFrameMetadata", (event)=>{
                if (event.type) return;
                const stackParser = client.getOptions().stackParser;
                $lw8Ay.addMetadataToStackFrames(stackParser, event);
            });
        }
    };
});
module.exports.moduleMetadataIntegration = $062566ad9925c48d$var$moduleMetadataIntegration;

});
parcelRegister("lw8Ay", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $YfOkS = parcelRequire("YfOkS");
const $faa33fa448c1e778$var$filenameMetadataMap = /* @__PURE__ */ new Map();
const $faa33fa448c1e778$var$parsedStacks = /* @__PURE__ */ new Set();
function $faa33fa448c1e778$var$getFilenameToMetadataMap(parser) {
    if (!$YfOkS.GLOBAL_OBJ._sentryModuleMetadata) return {};
    const filenameMap = {};
    for (const stack of Object.keys($YfOkS.GLOBAL_OBJ._sentryModuleMetadata)){
        const metadata = $YfOkS.GLOBAL_OBJ._sentryModuleMetadata[stack];
        const frames = parser(stack);
        for (const frame of frames.reverse())if (frame.filename) {
            filenameMap[frame.filename] = metadata;
            break;
        }
    }
    return filenameMap;
}
function $faa33fa448c1e778$var$ensureMetadataStacksAreParsed(parser) {
    if (!$YfOkS.GLOBAL_OBJ._sentryModuleMetadata) return;
    for (const stack of Object.keys($YfOkS.GLOBAL_OBJ._sentryModuleMetadata)){
        const metadata = $YfOkS.GLOBAL_OBJ._sentryModuleMetadata[stack];
        if ($faa33fa448c1e778$var$parsedStacks.has(stack)) continue;
        $faa33fa448c1e778$var$parsedStacks.add(stack);
        const frames = parser(stack);
        for (const frame of frames.reverse())if (frame.filename) {
            $faa33fa448c1e778$var$filenameMetadataMap.set(frame.filename, metadata);
            break;
        }
    }
}
function $faa33fa448c1e778$var$getMetadataForUrl(parser, filename) {
    $faa33fa448c1e778$var$ensureMetadataStacksAreParsed(parser);
    return $faa33fa448c1e778$var$filenameMetadataMap.get(filename);
}
function $faa33fa448c1e778$var$addMetadataToStackFrames(parser, event) {
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (!frame.filename || frame.module_metadata) return;
            const metadata = $faa33fa448c1e778$var$getMetadataForUrl(parser, frame.filename);
            if (metadata) frame.module_metadata = metadata;
        });
    });
}
function $faa33fa448c1e778$var$stripMetadataFromStackFrames(event) {
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            delete frame.module_metadata;
        });
    });
}
module.exports.addMetadataToStackFrames = $faa33fa448c1e778$var$addMetadataToStackFrames;
module.exports.getFilenameToMetadataMap = $faa33fa448c1e778$var$getFilenameToMetadataMap;
module.exports.getMetadataForUrl = $faa33fa448c1e778$var$getMetadataForUrl;
module.exports.stripMetadataFromStackFrames = $faa33fa448c1e778$var$stripMetadataFromStackFrames;

});


parcelRegister("dToAN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8DrvK = parcelRequire("8DrvK");

var $k2EST = parcelRequire("k2EST");

var $dknph = parcelRequire("dknph");

var $dylZw = parcelRequire("dylZw");

var $fTqrd = parcelRequire("fTqrd");

var $faQaz = parcelRequire("faQaz");

var $3rSi0 = parcelRequire("3rSi0");

var $iuxoj = parcelRequire("iuxoj");
const $029c2f6f78c0721f$var$INTEGRATION_NAME = "RequestData";
const $029c2f6f78c0721f$var$_requestDataIntegration = (options = {})=>{
    function resolveIncludeAndDataCollection(client) {
        const dc = client.getDataCollectionOptions();
        const dataCollection = {
            ...dc,
            ...options.include?.cookies === true && dc.cookies === false && {
                cookies: true
            },
            ...options.include?.headers === true && dc.httpHeaders.request === false && {
                httpHeaders: {
                    ...dc.httpHeaders,
                    request: true
                }
            }
        };
        return {
            dataCollection: dataCollection,
            include: {
                cookies: dataCollection.cookies !== false,
                // Always attach body data that's already on the scope — dataCollection.httpBodies gates write-time, not read-time
                data: true,
                headers: dataCollection.httpHeaders.request !== false,
                ip: dataCollection.userInfo,
                query_string: dataCollection.urlQueryParams !== false,
                // No dataCollection equivalent — URL is always included
                url: true,
                ...options.include
            }
        };
    }
    return {
        name: $029c2f6f78c0721f$var$INTEGRATION_NAME,
        processEvent (event, _hint, client) {
            const { sdkProcessingMetadata: sdkProcessingMetadata = {} } = event;
            const { normalizedRequest: normalizedRequest, ipAddress: ipAddress } = sdkProcessingMetadata;
            const { include: include } = resolveIncludeAndDataCollection(client);
            if (normalizedRequest) $029c2f6f78c0721f$var$addNormalizedRequestDataToEvent(event, normalizedRequest, {
                ipAddress: ipAddress
            }, include);
            return event;
        },
        processSegmentSpan (span, client) {
            const { sdkProcessingMetadata: sdkProcessingMetadata = {} } = $8DrvK.getIsolationScope().getScopeData();
            const { normalizedRequest: normalizedRequest, ipAddress: ipAddress } = sdkProcessingMetadata;
            if (!normalizedRequest) return;
            const { include: include, dataCollection: dataCollection } = resolveIncludeAndDataCollection(client);
            $029c2f6f78c0721f$var$addNormalizedRequestDataToSpan(span, normalizedRequest, ipAddress, include, dataCollection);
        }
    };
};
const $029c2f6f78c0721f$var$requestDataIntegration = $k2EST.defineIntegration($029c2f6f78c0721f$var$_requestDataIntegration);
function $029c2f6f78c0721f$var$addNormalizedRequestDataToEvent(event, req, additionalData, include) {
    event.request = {
        ...event.request,
        ...$029c2f6f78c0721f$var$extractNormalizedRequestData(req, include)
    };
    if (include.ip) {
        const ip = req.headers && $faQaz.getClientIPAddress(req.headers) || additionalData.ipAddress;
        if (ip) event.user = {
            ...event.user,
            ip_address: ip
        };
    }
}
function $029c2f6f78c0721f$var$addNormalizedRequestDataToSpan(span, normalizedRequest, ipAddress, include, dataCollection) {
    const requestData = $029c2f6f78c0721f$var$extractNormalizedRequestData(normalizedRequest, include);
    const attributes$1 = {};
    if (requestData.url) attributes$1[$iuxoj.URL_FULL] = requestData.url;
    if (requestData.method) attributes$1["http.request.method"] = requestData.method;
    if (requestData.query_string) attributes$1[$iuxoj.URL_QUERY] = $029c2f6f78c0721f$var$normalizeQueryString(requestData.query_string);
    $3rSi0.safeSetSpanJSONAttributes(span, attributes$1);
    if (requestData.cookies && Object.keys(requestData.cookies).length > 0) {
        const cookieString = Object.entries(requestData.cookies).map(([name, value])=>`${name}=${value}`).join("; ");
        const cookieAttributes = $fTqrd.httpHeadersToSpanAttributes({
            cookie: cookieString
        }, dataCollection, "request");
        $3rSi0.safeSetSpanJSONAttributes(span, cookieAttributes);
    }
    if (requestData.headers) {
        const headerAttributes = $fTqrd.httpHeadersToSpanAttributes(requestData.headers, dataCollection, "request");
        $3rSi0.safeSetSpanJSONAttributes(span, headerAttributes);
    }
    if (requestData.data != null) {
        const serialized = typeof requestData.data === "string" ? requestData.data : JSON.stringify(requestData.data);
        if (serialized) $3rSi0.safeSetSpanJSONAttributes(span, {
            "http.request.body.data": serialized
        });
    }
    if (include.ip) {
        const ip = normalizedRequest.headers && $faQaz.getClientIPAddress(normalizedRequest.headers) || ipAddress || void 0;
        if (ip) $3rSi0.safeSetSpanJSONAttributes(span, {
            [$dknph.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS]: ip
        });
    }
}
function $029c2f6f78c0721f$var$extractNormalizedRequestData(normalizedRequest, include) {
    const requestData = {};
    const headers = {
        ...normalizedRequest.headers
    };
    if (include.headers) {
        requestData.headers = headers;
        if (!include.cookies) delete headers.cookie;
        if (!include.ip) {
            const ipHeaderNamesLower = new Set($faQaz.ipHeaderNames.map((name)=>name.toLowerCase()));
            for (const key of Object.keys(headers))if (ipHeaderNamesLower.has(key.toLowerCase())) delete headers[key];
        }
    }
    requestData.method = normalizedRequest.method;
    if (include.url) requestData.url = normalizedRequest.url;
    if (include.cookies) {
        const cookies = normalizedRequest.cookies || (headers?.cookie ? $dylZw.parseCookie(headers.cookie) : void 0);
        requestData.cookies = cookies || {};
    }
    if (include.query_string) requestData.query_string = normalizedRequest.query_string;
    if (include.data) requestData.data = normalizedRequest.data;
    return requestData;
}
function $029c2f6f78c0721f$var$normalizeQueryString(queryString) {
    if (typeof queryString === "string") return queryString || void 0;
    const pairs = Array.isArray(queryString) ? queryString : Object.entries(queryString);
    const result = pairs.map(([key, value])=>`${key}=${value}`).join("&");
    return result || void 0;
}
module.exports.requestDataIntegration = $029c2f6f78c0721f$var$requestDataIntegration;

});
parcelRegister("faQaz", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $b0c041f8bc6f5431$var$ipHeaderNames = [
    "X-Client-IP",
    "X-Forwarded-For",
    "Fly-Client-IP",
    "CF-Connecting-IP",
    "Fastly-Client-Ip",
    "True-Client-Ip",
    "X-Real-IP",
    "X-Cluster-Client-IP",
    "X-Forwarded",
    "Forwarded-For",
    "Forwarded",
    "X-Vercel-Forwarded-For"
];
function $b0c041f8bc6f5431$var$getClientIPAddress(headers) {
    const lowerCaseHeaders = {};
    for (const key of Object.keys(headers))lowerCaseHeaders[key.toLowerCase()] = headers[key];
    const headerValues = $b0c041f8bc6f5431$var$ipHeaderNames.map((headerName)=>{
        const rawValue = lowerCaseHeaders[headerName.toLowerCase()];
        const value = Array.isArray(rawValue) ? rawValue.join(";") : rawValue;
        if (headerName === "Forwarded") return $b0c041f8bc6f5431$var$parseForwardedHeader(value);
        return value?.split(",").map((v)=>v.trim());
    });
    const flattenedHeaderValues = headerValues.reduce((acc, val)=>{
        if (!val) return acc;
        return acc.concat(val);
    }, []);
    const ipAddress = flattenedHeaderValues.find((ip)=>ip !== null && $b0c041f8bc6f5431$var$isIP(ip));
    return ipAddress || null;
}
function $b0c041f8bc6f5431$var$parseForwardedHeader(value) {
    if (!value) return null;
    for (const part of value.split(";")){
        if (part.startsWith("for=")) return part.slice(4);
    }
    return null;
}
function $b0c041f8bc6f5431$var$isIP(str) {
    const regex = /(?:^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$)|(?:^(?:(?:[a-fA-F\d]{1,4}:){7}(?:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){6}(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){5}(?::(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,2}|:)|(?:[a-fA-F\d]{1,4}:){4}(?:(?::[a-fA-F\d]{1,4}){0,1}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,3}|:)|(?:[a-fA-F\d]{1,4}:){3}(?:(?::[a-fA-F\d]{1,4}){0,2}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,4}|:)|(?:[a-fA-F\d]{1,4}:){2}(?:(?::[a-fA-F\d]{1,4}){0,3}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,5}|:)|(?:[a-fA-F\d]{1,4}:){1}(?:(?::[a-fA-F\d]{1,4}){0,4}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,6}|:)|(?::(?:(?::[a-fA-F\d]{1,4}){0,5}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,7}|:)))(?:%[0-9a-zA-Z]{1,})?$)/;
    return regex.test(str);
}
module.exports.getClientIPAddress = $b0c041f8bc6f5431$var$getClientIPAddress;
module.exports.ipHeaderNames = $b0c041f8bc6f5431$var$ipHeaderNames;

});


parcelRegister("fF0Ei", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8DrvK = parcelRequire("8DrvK");

var $i98W3 = parcelRequire("i98W3");

var $hvU0C = parcelRequire("hvU0C");

var $k2EST = parcelRequire("k2EST");

var $1UPRv = parcelRequire("1UPRv");

var $8iRTV = parcelRequire("8iRTV");

var $1Vg0b = parcelRequire("1Vg0b");

var $erV30 = parcelRequire("erV30");

var $YfOkS = parcelRequire("YfOkS");
const $b66b3038a39b9eb4$var$INTEGRATION_NAME = "CaptureConsole";
const $b66b3038a39b9eb4$var$_captureConsoleIntegration = (options = {})=>{
    const levels = options.levels || $1UPRv.CONSOLE_LEVELS;
    const handled = options.handled ?? true;
    return {
        name: $b66b3038a39b9eb4$var$INTEGRATION_NAME,
        setup (client) {
            if (!("console" in $YfOkS.GLOBAL_OBJ)) return;
            $hvU0C.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($8DrvK.getClient() !== client || !levels.includes(level)) return;
                $b66b3038a39b9eb4$var$consoleHandler(args, level, handled);
            });
        }
    };
};
const $b66b3038a39b9eb4$var$captureConsoleIntegration = $k2EST.defineIntegration($b66b3038a39b9eb4$var$_captureConsoleIntegration);
function $b66b3038a39b9eb4$var$consoleHandler(args, level, handled) {
    const severityLevel = $1Vg0b.severityLevelFromString(level);
    const syntheticException = new Error();
    const captureContext = {
        level: $1Vg0b.severityLevelFromString(level),
        extra: {
            arguments: args
        }
    };
    $8DrvK.withScope((scope)=>{
        scope.addEventProcessor((event)=>{
            event.logger = "console";
            $8iRTV.addExceptionMechanism(event, {
                handled: handled,
                type: "auto.core.capture_console"
            });
            return event;
        });
        if (level === "assert") {
            if (!args[0]) {
                const message2 = `Assertion failed: ${$erV30.safeJoin(args.slice(1), " ") || "console.assert"}`;
                scope.setExtra("arguments", args.slice(1));
                scope.captureMessage(message2, severityLevel, {
                    captureContext: captureContext,
                    syntheticException: syntheticException
                });
            }
            return;
        }
        const error = args.find((arg)=>arg instanceof Error);
        if (error) {
            $i98W3.captureException(error, captureContext);
            return;
        }
        const message = $erV30.safeJoin(args, " ");
        scope.captureMessage(message, severityLevel, {
            captureContext: captureContext,
            syntheticException: syntheticException
        });
    });
}
module.exports.captureConsoleIntegration = $b66b3038a39b9eb4$var$captureConsoleIntegration;

});
parcelRegister("hvU0C", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9Yejo = parcelRequire("9Yejo");

var $1UPRv = parcelRequire("1UPRv");

var $kzIHY = parcelRequire("kzIHY");

var $erV30 = parcelRequire("erV30");

var $YfOkS = parcelRequire("YfOkS");

var $1aID7 = parcelRequire("1aID7");
const $cc00c71f587a7f33$var$_filter = /* @__PURE__ */ new Set([]);
function $cc00c71f587a7f33$var$addConsoleInstrumentationHandler(handler) {
    const type = "console";
    const removeHandler = $1aID7.addHandler(type, handler);
    $1aID7.maybeInstrument(type, $cc00c71f587a7f33$var$instrumentConsole);
    return removeHandler;
}
function $cc00c71f587a7f33$var$addConsoleInstrumentationFilter(filter) {
    for (const f of filter)$cc00c71f587a7f33$var$_filter.add(f);
    return ()=>{
        for (const f of filter)$cc00c71f587a7f33$var$_filter.delete(f);
    };
}
const $cc00c71f587a7f33$var$instrumentedLevels = /* @__PURE__ */ new Set();
function $cc00c71f587a7f33$var$instrumentConsole() {
    if (!("console" in $YfOkS.GLOBAL_OBJ)) return;
    $1UPRv.CONSOLE_LEVELS.forEach(function(level) {
        if ($cc00c71f587a7f33$var$instrumentedLevels.has(level) || !(level in $YfOkS.GLOBAL_OBJ.console)) return;
        $cc00c71f587a7f33$var$instrumentedLevels.add(level);
        $kzIHY.fill($YfOkS.GLOBAL_OBJ.console, level, function(originalConsoleMethod) {
            $1UPRv.originalConsoleMethods[level] = originalConsoleMethod;
            return function(...args) {
                const firstArg = args[0];
                const log = $1UPRv.originalConsoleMethods[level];
                const isFiltered = $cc00c71f587a7f33$var$_filter.size && typeof firstArg === "string" && $erV30.stringMatchesSomePattern(firstArg, $cc00c71f587a7f33$var$_filter);
                if (!isFiltered) $1aID7.triggerHandlers("console", {
                    args: args,
                    level: level
                });
                if (!isFiltered || $9Yejo.DEBUG_BUILD && $1UPRv.debug.isEnabled()) log?.apply($YfOkS.GLOBAL_OBJ.console, args);
            };
        });
    });
}
module.exports.addConsoleInstrumentationFilter = $cc00c71f587a7f33$var$addConsoleInstrumentationFilter;
module.exports.addConsoleInstrumentationHandler = $cc00c71f587a7f33$var$addConsoleInstrumentationHandler;
module.exports.instrumentConsole = $cc00c71f587a7f33$var$instrumentConsole;

});

parcelRegister("1Vg0b", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $166786fd5085a28f$var$severityLevelFromString(level) {
    return level === "warn" ? "warning" : [
        "fatal",
        "error",
        "warning",
        "log",
        "info",
        "debug"
    ].includes(level) ? level : "log";
}
module.exports.severityLevelFromString = $166786fd5085a28f$var$severityLevelFromString;

});


parcelRegister("aKXLl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9Yejo = parcelRequire("9Yejo");

var $k2EST = parcelRequire("k2EST");

var $1UPRv = parcelRequire("1UPRv");

var $82RPZ = parcelRequire("82RPZ");
const $7d4c8ee5452370d9$var$INTEGRATION_NAME = "Dedupe";
const $7d4c8ee5452370d9$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $7d4c8ee5452370d9$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            if (currentEvent.type) return currentEvent;
            try {
                if ($7d4c8ee5452370d9$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch  {}
            return previousEvent = currentEvent;
        }
    };
};
const $7d4c8ee5452370d9$var$dedupeIntegration = $k2EST.defineIntegration($7d4c8ee5452370d9$var$_dedupeIntegration);
function $7d4c8ee5452370d9$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($7d4c8ee5452370d9$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($7d4c8ee5452370d9$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $7d4c8ee5452370d9$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    if (!currentMessage && !previousMessage) return false;
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$7d4c8ee5452370d9$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$7d4c8ee5452370d9$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $7d4c8ee5452370d9$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $7d4c8ee5452370d9$var$_getExceptionFromEvent(previousEvent);
    const currentException = $7d4c8ee5452370d9$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$7d4c8ee5452370d9$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$7d4c8ee5452370d9$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $7d4c8ee5452370d9$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $82RPZ.getFramesFromEvent(currentEvent);
    let previousFrames = $82RPZ.getFramesFromEvent(previousEvent);
    if (!currentFrames && !previousFrames) return true;
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    if (previousFrames.length !== currentFrames.length) return false;
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $7d4c8ee5452370d9$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    if (!currentFingerprint && !previousFingerprint) return true;
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch  {
        return false;
    }
}
function $7d4c8ee5452370d9$var$_getExceptionFromEvent(event) {
    return event.exception?.values?.[0];
}
module.exports._shouldDropEvent = $7d4c8ee5452370d9$var$_shouldDropEvent;
module.exports.dedupeIntegration = $7d4c8ee5452370d9$var$dedupeIntegration;

});

parcelRegister("6qA6p", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9Yejo = parcelRequire("9Yejo");

var $k2EST = parcelRequire("k2EST");

var $1UPRv = parcelRequire("1UPRv");

var $eMfEg = parcelRequire("eMfEg");

var $aaVDI = parcelRequire("aaVDI");

var $l8ak2 = parcelRequire("l8ak2");

var $erV30 = parcelRequire("erV30");
const $4ae12cf39d5a5b31$var$INTEGRATION_NAME = "ExtraErrorData";
const $4ae12cf39d5a5b31$var$_extraErrorDataIntegration = (options = {})=>{
    const { depth: depth = 3, captureErrorCause: captureErrorCause = true } = options;
    return {
        name: $4ae12cf39d5a5b31$var$INTEGRATION_NAME,
        processEvent (event, hint, client) {
            const { maxValueLength: maxValueLength } = client.getOptions();
            return $4ae12cf39d5a5b31$var$_enhanceEventWithErrorData(event, hint, depth, captureErrorCause, maxValueLength);
        }
    };
};
const $4ae12cf39d5a5b31$var$extraErrorDataIntegration = $k2EST.defineIntegration($4ae12cf39d5a5b31$var$_extraErrorDataIntegration);
function $4ae12cf39d5a5b31$var$_enhanceEventWithErrorData(event, hint = {}, depth, captureErrorCause, maxValueLength) {
    if (!hint.originalException || !$eMfEg.isError(hint.originalException)) return event;
    const exceptionName = hint.originalException.name || hint.originalException.constructor.name;
    const errorData = $4ae12cf39d5a5b31$var$_extractErrorData(hint.originalException, captureErrorCause, maxValueLength);
    if (errorData) {
        const contexts = {
            ...event.contexts
        };
        const normalizedErrorData = $aaVDI.normalize(errorData, depth);
        if ($eMfEg.isPlainObject(normalizedErrorData)) {
            $l8ak2.setSkipNormalizationHint(normalizedErrorData);
            contexts[exceptionName] = normalizedErrorData;
        }
        return {
            ...event,
            contexts: contexts
        };
    }
    return event;
}
function $4ae12cf39d5a5b31$var$_extractErrorData(error, captureErrorCause, maxValueLength) {
    try {
        const nativeKeys = [
            "name",
            "message",
            "stack",
            "line",
            "column",
            "fileName",
            "lineNumber",
            "columnNumber",
            "toJSON"
        ];
        const extraErrorInfo = {};
        for (const key of Object.keys(error)){
            if (nativeKeys.indexOf(key) !== -1) continue;
            const value = error[key];
            extraErrorInfo[key] = $eMfEg.isError(value) || typeof value === "string" ? maxValueLength ? $erV30.truncate(`${value}`, maxValueLength) : `${value}` : value;
        }
        if (captureErrorCause && error.cause !== void 0) {
            if ($eMfEg.isError(error.cause)) {
                const errorName = error.cause.name || error.cause.constructor.name;
                extraErrorInfo.cause = {
                    [errorName]: $4ae12cf39d5a5b31$var$_extractErrorData(error.cause, false, maxValueLength)
                };
            } else extraErrorInfo.cause = error.cause;
        }
        if (typeof error.toJSON === "function") {
            const serializedError = error.toJSON();
            for (const key of Object.keys(serializedError)){
                const value = serializedError[key];
                extraErrorInfo[key] = $eMfEg.isError(value) ? value.toString() : value;
            }
        }
        return extraErrorInfo;
    } catch (oO) {
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.error("Unable to extract extra data from the Error object:", oO);
    }
    return null;
}
module.exports.extraErrorDataIntegration = $4ae12cf39d5a5b31$var$extraErrorDataIntegration;

});

parcelRegister("cNTun", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k2EST = parcelRequire("k2EST");

var $8We3n = parcelRequire("8We3n");

var $YfOkS = parcelRequire("YfOkS");
const $0267d3027e783a37$var$INTEGRATION_NAME = "RewriteFrames";
const $0267d3027e783a37$var$rewriteFramesIntegration = $k2EST.defineIntegration((options = {})=>{
    const root = options.root;
    const prefix = options.prefix || "app:///";
    const isBrowser = "window" in $YfOkS.GLOBAL_OBJ && !!$YfOkS.GLOBAL_OBJ.window;
    const iteratee = options.iteratee || $0267d3027e783a37$var$generateIteratee({
        isBrowser: isBrowser,
        root: root,
        prefix: prefix
    });
    function _processExceptionsEvent(event) {
        try {
            return {
                ...event,
                exception: {
                    ...event.exception,
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map((value)=>({
                            ...value,
                            ...value.stacktrace && {
                                stacktrace: _processStacktrace(value.stacktrace)
                            }
                        }))
                }
            };
        } catch  {
            return event;
        }
    }
    function _processStacktrace(stacktrace) {
        return {
            ...stacktrace,
            frames: stacktrace?.frames?.map((f)=>iteratee(f))
        };
    }
    return {
        name: $0267d3027e783a37$var$INTEGRATION_NAME,
        processEvent (originalEvent) {
            let processedEvent = originalEvent;
            if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) processedEvent = _processExceptionsEvent(processedEvent);
            return processedEvent;
        }
    };
});
function $0267d3027e783a37$var$generateIteratee({ isBrowser: isBrowser, root: root, prefix: prefix }) {
    return (frame)=>{
        if (!frame.filename) return frame;
        const isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) || // or the presence of a backslash without a forward slash (which are not allowed on Windows)
        frame.filename.includes("\\") && !frame.filename.includes("/");
        const startsWithSlash = /^\//.test(frame.filename);
        if (isBrowser) {
            if (root) {
                const oldFilename = frame.filename;
                if (oldFilename.indexOf(root) === 0) frame.filename = oldFilename.replace(root, prefix);
            }
        } else if (isWindowsFrame || startsWithSlash) {
            const filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, "").replace(/\\/g, "/") : frame.filename;
            const base = root ? $8We3n.relative(root, filename) : $8We3n.basename(filename);
            frame.filename = `${prefix}${base}`;
        }
        return frame;
    };
}
module.exports.generateIteratee = $0267d3027e783a37$var$generateIteratee;
module.exports.rewriteFramesIntegration = $0267d3027e783a37$var$rewriteFramesIntegration;

});
parcelRegister("8We3n", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $681ea43f086c5248$var$normalizeArray(parts, allowAboveRoot) {
    let up = 0;
    for(let i = parts.length - 1; i >= 0; i--){
        const last = parts[i];
        if (last === ".") parts.splice(i, 1);
        else if (last === "..") {
            parts.splice(i, 1);
            up++;
        } else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    if (allowAboveRoot) for(; up--; up)parts.unshift("..");
    return parts;
}
const $681ea43f086c5248$var$splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
function $681ea43f086c5248$var$splitPath(filename) {
    const truncated = filename.length > 1024 ? `<truncated>${filename.slice(-1024)}` : filename;
    const parts = $681ea43f086c5248$var$splitPathRe.exec(truncated);
    return parts ? parts.slice(1) : [];
}
function $681ea43f086c5248$var$resolve(...args) {
    let resolvedPath = "";
    let resolvedAbsolute = false;
    for(let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        const path = i >= 0 ? args[i] : "/";
        if (!path) continue;
        resolvedPath = `${path}/${resolvedPath}`;
        resolvedAbsolute = path.charAt(0) === "/";
    }
    resolvedPath = $681ea43f086c5248$var$normalizeArray(resolvedPath.split("/").filter((p)=>!!p), !resolvedAbsolute).join("/");
    return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
}
function $681ea43f086c5248$var$trim(arr) {
    let start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== "") break;
    }
    let end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== "") break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
function $681ea43f086c5248$var$relative(from, to) {
    from = $681ea43f086c5248$var$resolve(from).slice(1);
    to = $681ea43f086c5248$var$resolve(to).slice(1);
    const fromParts = $681ea43f086c5248$var$trim(from.split("/"));
    const toParts = $681ea43f086c5248$var$trim(to.split("/"));
    const length = Math.min(fromParts.length, toParts.length);
    let samePartsLength = length;
    for(let i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    let outputParts = [];
    for(let i = samePartsLength; i < fromParts.length; i++)outputParts.push("..");
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join("/");
}
function $681ea43f086c5248$var$normalizePath(path) {
    const isPathAbsolute = $681ea43f086c5248$var$isAbsolute(path);
    const trailingSlash = path.slice(-1) === "/";
    let normalizedPath = $681ea43f086c5248$var$normalizeArray(path.split("/").filter((p)=>!!p), !isPathAbsolute).join("/");
    if (!normalizedPath && !isPathAbsolute) normalizedPath = ".";
    if (normalizedPath && trailingSlash) normalizedPath += "/";
    return (isPathAbsolute ? "/" : "") + normalizedPath;
}
function $681ea43f086c5248$var$isAbsolute(path) {
    return path.charAt(0) === "/";
}
function $681ea43f086c5248$var$join(...args) {
    return $681ea43f086c5248$var$normalizePath(args.join("/"));
}
function $681ea43f086c5248$var$dirname(path) {
    const result = $681ea43f086c5248$var$splitPath(path);
    const root = result[0] || "";
    let dir = result[1];
    if (!root && !dir) return ".";
    if (dir) dir = dir.slice(0, dir.length - 1);
    return root + dir;
}
function $681ea43f086c5248$var$basename(path, ext) {
    let f = $681ea43f086c5248$var$splitPath(path)[2] || "";
    if (ext && f.slice(ext.length * -1) === ext) f = f.slice(0, f.length - ext.length);
    return f;
}
module.exports.basename = $681ea43f086c5248$var$basename;
module.exports.dirname = $681ea43f086c5248$var$dirname;
module.exports.isAbsolute = $681ea43f086c5248$var$isAbsolute;
module.exports.join = $681ea43f086c5248$var$join;
module.exports.normalizePath = $681ea43f086c5248$var$normalizePath;
module.exports.relative = $681ea43f086c5248$var$relative;
module.exports.resolve = $681ea43f086c5248$var$resolve;

});


parcelRegister("2cJCG", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $85QQN = parcelRequire("85QQN");

var $8DrvK = parcelRequire("8DrvK");

var $9Yejo = parcelRequire("9Yejo");

var $i98W3 = parcelRequire("i98W3");

var $k2EST = parcelRequire("k2EST");

var $dknph = parcelRequire("dknph");

var $1UPRv = parcelRequire("1UPRv");

var $8iRTV = parcelRequire("8iRTV");

var $eMfEg = parcelRequire("eMfEg");

var $3su1E = parcelRequire("3su1E");

var $d7AD6 = parcelRequire("d7AD6");
const $19b0178a05c09b4f$var$AUTH_OPERATIONS_TO_INSTRUMENT = [
    "reauthenticate",
    "signInAnonymously",
    "signInWithOAuth",
    "signInWithIdToken",
    "signInWithOtp",
    "signInWithPassword",
    "signInWithSSO",
    "signOut",
    "signUp",
    "verifyOtp"
];
const $19b0178a05c09b4f$var$AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT = [
    "createUser",
    "deleteUser",
    "listUsers",
    "getUserById",
    "updateUserById",
    "inviteUserByEmail"
];
const $19b0178a05c09b4f$var$FILTER_MAPPINGS = {
    eq: "eq",
    neq: "neq",
    gt: "gt",
    gte: "gte",
    lt: "lt",
    lte: "lte",
    like: "like",
    "like(all)": "likeAllOf",
    "like(any)": "likeAnyOf",
    ilike: "ilike",
    "ilike(all)": "ilikeAllOf",
    "ilike(any)": "ilikeAnyOf",
    is: "is",
    in: "in",
    cs: "contains",
    cd: "containedBy",
    sr: "rangeGt",
    nxl: "rangeGte",
    sl: "rangeLt",
    nxr: "rangeLte",
    adj: "rangeAdjacent",
    ov: "overlaps",
    fts: "",
    plfts: "plain",
    phfts: "phrase",
    wfts: "websearch",
    not: "not"
};
const $19b0178a05c09b4f$var$DB_OPERATIONS_TO_INSTRUMENT = [
    "select",
    "insert",
    "upsert",
    "update",
    "delete"
];
function $19b0178a05c09b4f$var$markAsInstrumented(fn) {
    try {
        fn.__SENTRY_INSTRUMENTED__ = true;
    } catch  {}
}
function $19b0178a05c09b4f$var$isInstrumented(fn) {
    try {
        return fn.__SENTRY_INSTRUMENTED__;
    } catch  {
        return false;
    }
}
function $19b0178a05c09b4f$var$getMutationBodyPayloadForTelemetry(rawBody, plainBody) {
    if (Object.keys(plainBody).length > 0) return plainBody;
    if (Array.isArray(rawBody) && rawBody.length > 0) return rawBody;
    return void 0;
}
function $19b0178a05c09b4f$var$hasMutationBodyForDescription(rawBody, plainBody) {
    return $19b0178a05c09b4f$var$getMutationBodyPayloadForTelemetry(rawBody, plainBody) !== void 0;
}
function $19b0178a05c09b4f$var$getHeader(headers, name) {
    if (!headers) return void 0;
    if (typeof headers.get === "function") return headers.get(name) ?? void 0;
    const plainHeaders = headers;
    const lowerCaseName = name.toLowerCase();
    const key = Object.keys(plainHeaders).find((headerName)=>headerName.toLowerCase() === lowerCaseName);
    return key !== void 0 ? plainHeaders[key] : void 0;
}
function $19b0178a05c09b4f$var$extractOperation(method, headers = {}) {
    switch(method){
        case "GET":
            return "select";
        case "POST":
            if ($19b0178a05c09b4f$var$getHeader(headers, "Prefer")?.includes("resolution=")) return "upsert";
            else return "insert";
        case "PATCH":
            return "update";
        case "DELETE":
            return "delete";
        default:
            return "<unknown-op>";
    }
}
function $19b0178a05c09b4f$var$translateFiltersIntoMethods(key, query) {
    if (query === "" || query === "*") return "select(*)";
    if (key === "select") return `select(${query})`;
    if (key === "or" || key.endsWith(".or")) return `${key}${query}`;
    const [filter, ...value] = query.split(".");
    let method;
    if (filter?.startsWith("fts")) method = "textSearch";
    else if (filter?.startsWith("plfts")) method = "textSearch[plain]";
    else if (filter?.startsWith("phfts")) method = "textSearch[phrase]";
    else if (filter?.startsWith("wfts")) method = "textSearch[websearch]";
    else method = filter && $19b0178a05c09b4f$var$FILTER_MAPPINGS[filter] || "filter";
    return `${method}(${key}, ${value.join(".")})`;
}
function $19b0178a05c09b4f$var$instrumentAuthOperation(operation, isAdmin = false) {
    return new Proxy(operation, {
        apply (target, thisArg, argumentsList) {
            return $d7AD6.startSpan({
                name: `auth ${isAdmin ? "(admin) " : ""}${operation.name}`,
                attributes: {
                    [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.db.supabase",
                    [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "db",
                    "db.system": "postgresql",
                    "db.operation": `auth.${isAdmin ? "admin." : ""}${operation.name}`
                }
            }, (span)=>{
                return Reflect.apply(target, thisArg, argumentsList).then((res)=>{
                    if ($eMfEg.isObjectLike(res) && "error" in res && res.error) {
                        span.setStatus({
                            code: $3su1E.SPAN_STATUS_ERROR
                        });
                        $i98W3.captureException(res.error, {
                            mechanism: {
                                handled: false,
                                type: "auto.db.supabase.auth"
                            }
                        });
                    } else span.setStatus({
                        code: $3su1E.SPAN_STATUS_OK
                    });
                    span.end();
                    return res;
                }).catch((err)=>{
                    span.setStatus({
                        code: $3su1E.SPAN_STATUS_ERROR
                    });
                    span.end();
                    $i98W3.captureException(err, {
                        mechanism: {
                            handled: false,
                            type: "auto.db.supabase.auth"
                        }
                    });
                    throw err;
                }).then(...argumentsList);
            });
        }
    });
}
function $19b0178a05c09b4f$var$instrumentSupabaseAuthClient(supabaseClientInstance) {
    const auth = supabaseClientInstance.auth;
    if (!auth || $19b0178a05c09b4f$var$isInstrumented(supabaseClientInstance.auth)) return;
    for (const operation of $19b0178a05c09b4f$var$AUTH_OPERATIONS_TO_INSTRUMENT){
        const authOperation = auth[operation];
        if (!authOperation) continue;
        if (typeof supabaseClientInstance.auth[operation] === "function") supabaseClientInstance.auth[operation] = $19b0178a05c09b4f$var$instrumentAuthOperation(authOperation);
    }
    for (const operation of $19b0178a05c09b4f$var$AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT){
        const authOperation = auth.admin[operation];
        if (!authOperation) continue;
        if (typeof supabaseClientInstance.auth.admin[operation] === "function") supabaseClientInstance.auth.admin[operation] = $19b0178a05c09b4f$var$instrumentAuthOperation(authOperation, true);
    }
    $19b0178a05c09b4f$var$markAsInstrumented(supabaseClientInstance.auth);
}
function $19b0178a05c09b4f$var$instrumentSupabaseClientConstructor(SupabaseClient, _options) {
    if ($19b0178a05c09b4f$var$isInstrumented(SupabaseClient.prototype.from)) return;
    SupabaseClient.prototype.from = new Proxy(SupabaseClient.prototype.from, {
        apply (target, thisArg, argumentsList) {
            const rv = Reflect.apply(target, thisArg, argumentsList);
            const PostgRESTQueryBuilder = rv.constructor;
            $19b0178a05c09b4f$var$instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder, _options);
            return rv;
        }
    });
    $19b0178a05c09b4f$var$markAsInstrumented(SupabaseClient.prototype.from);
}
function $19b0178a05c09b4f$var$instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder, _options) {
    if ($19b0178a05c09b4f$var$isInstrumented(PostgRESTFilterBuilder.prototype.then)) return;
    PostgRESTFilterBuilder.prototype.then = new Proxy(PostgRESTFilterBuilder.prototype.then, {
        apply (target, thisArg, argumentsList) {
            const operations = $19b0178a05c09b4f$var$DB_OPERATIONS_TO_INSTRUMENT;
            const typedThis = thisArg;
            const operation = $19b0178a05c09b4f$var$extractOperation(typedThis.method, typedThis.headers);
            if (!operations.includes(operation)) return Reflect.apply(target, thisArg, argumentsList);
            if (!typedThis?.url?.pathname || typeof typedThis.url.pathname !== "string") return Reflect.apply(target, thisArg, argumentsList);
            const pathParts = typedThis.url.pathname.split("/");
            const table = pathParts.length > 0 ? pathParts[pathParts.length - 1] : "";
            const queryItems = [];
            for (const [key, value] of typedThis.url.searchParams.entries())queryItems.push($19b0178a05c09b4f$var$translateFiltersIntoMethods(key, value));
            const body = /* @__PURE__ */ Object.create(null);
            if ($eMfEg.isPlainObject(typedThis.body)) for (const [key, value] of Object.entries(typedThis.body))body[key] = value;
            const client = $8DrvK.getClient();
            const shouldSendData = _options.sendOperationData ?? client?.getDataCollectionOptions().databaseQueryData === true;
            const bodyPayload = $19b0178a05c09b4f$var$getMutationBodyPayloadForTelemetry(typedThis.body, body);
            const mutationPart = operation === "select" ? "" : `${operation}${$19b0178a05c09b4f$var$hasMutationBodyForDescription(typedThis.body, body) ? "(...) " : ""}`;
            const queryPart = shouldSendData ? queryItems.join(" ") : queryItems.length > 0 ? "[redacted]" : "";
            const descriptionMiddle = [
                mutationPart.trimEnd(),
                queryPart
            ].filter(Boolean).join(" ");
            const description = descriptionMiddle ? `${descriptionMiddle} from(${table})` : `from(${table})`;
            const attributes = {
                "db.table": table,
                "db.schema": typedThis.schema,
                "db.url": typedThis.url.origin,
                "db.sdk": $19b0178a05c09b4f$var$getHeader(typedThis.headers, "X-Client-Info"),
                "db.system": "postgresql",
                "db.operation": operation,
                [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.db.supabase",
                [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "db"
            };
            if (queryItems.length && shouldSendData) attributes["db.query"] = queryItems;
            if (bodyPayload !== void 0 && shouldSendData) attributes["db.body"] = bodyPayload;
            return $d7AD6.startSpan({
                name: description,
                attributes: attributes
            }, (span)=>{
                return Reflect.apply(target, thisArg, []).then((res)=>{
                    if (span) {
                        if (res && typeof res === "object" && "status" in res) $3su1E.setHttpStatus(span, res.status || 500);
                        span.end();
                    }
                    if (res?.error) {
                        const err = new Error(res.error.message);
                        if (res.error.code) err.code = res.error.code;
                        if (res.error.details) err.details = res.error.details;
                        const supabaseContext = {};
                        if (queryItems.length && shouldSendData) supabaseContext.query = queryItems;
                        if (bodyPayload !== void 0 && shouldSendData) supabaseContext.body = bodyPayload;
                        $i98W3.captureException(err, (scope)=>{
                            scope.addEventProcessor((e)=>{
                                $8iRTV.addExceptionMechanism(e, {
                                    handled: false,
                                    type: "auto.db.supabase.postgres"
                                });
                                return e;
                            });
                            scope.setContext("supabase", supabaseContext);
                            return scope;
                        });
                    }
                    const breadcrumb = {
                        type: "supabase",
                        category: `db.${operation}`,
                        message: description
                    };
                    const data = {};
                    if (queryItems.length && shouldSendData) data.query = queryItems;
                    if (bodyPayload !== void 0 && shouldSendData) data.body = bodyPayload;
                    if (Object.keys(data).length) breadcrumb.data = data;
                    $85QQN.addBreadcrumb(breadcrumb);
                    return res;
                }, (err)=>{
                    if (span) {
                        $3su1E.setHttpStatus(span, 500);
                        span.end();
                    }
                    throw err;
                }).then(...argumentsList);
            });
        }
    });
    $19b0178a05c09b4f$var$markAsInstrumented(PostgRESTFilterBuilder.prototype.then);
}
function $19b0178a05c09b4f$var$instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder, _options) {
    for (const operation of $19b0178a05c09b4f$var$DB_OPERATIONS_TO_INSTRUMENT){
        if ($19b0178a05c09b4f$var$isInstrumented(PostgRESTQueryBuilder.prototype[operation])) continue;
        PostgRESTQueryBuilder.prototype[operation] = new Proxy(PostgRESTQueryBuilder.prototype[operation], {
            apply (target, thisArg, argumentsList) {
                const rv = Reflect.apply(target, thisArg, argumentsList);
                const PostgRESTFilterBuilder = rv.constructor;
                $9Yejo.DEBUG_BUILD && $1UPRv.debug.log(`Instrumenting ${operation} operation's PostgRESTFilterBuilder`);
                $19b0178a05c09b4f$var$instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder, _options);
                return rv;
            }
        });
        $19b0178a05c09b4f$var$markAsInstrumented(PostgRESTQueryBuilder.prototype[operation]);
    }
}
const $19b0178a05c09b4f$var$instrumentSupabaseClient = (supabaseClient, options = {})=>{
    if (!supabaseClient) {
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn("Supabase integration was not installed because no Supabase client was provided.");
        return;
    }
    const SupabaseClientConstructor = supabaseClient.constructor === Function ? supabaseClient : supabaseClient.constructor;
    $19b0178a05c09b4f$var$instrumentSupabaseClientConstructor(SupabaseClientConstructor, options);
    $19b0178a05c09b4f$var$instrumentSupabaseAuthClient(supabaseClient);
};
const $19b0178a05c09b4f$var$INTEGRATION_NAME = "Supabase";
const $19b0178a05c09b4f$var$_supabaseIntegration = (supabaseClient, options)=>{
    return {
        setupOnce () {
            $19b0178a05c09b4f$var$instrumentSupabaseClient(supabaseClient, options);
        },
        name: $19b0178a05c09b4f$var$INTEGRATION_NAME
    };
};
const $19b0178a05c09b4f$var$supabaseIntegration = $k2EST.defineIntegration((options)=>{
    return $19b0178a05c09b4f$var$_supabaseIntegration(options.supabaseClient, {
        sendOperationData: options.sendOperationData
    });
});
module.exports.DB_OPERATIONS_TO_INSTRUMENT = $19b0178a05c09b4f$var$DB_OPERATIONS_TO_INSTRUMENT;
module.exports.FILTER_MAPPINGS = $19b0178a05c09b4f$var$FILTER_MAPPINGS;
module.exports.extractOperation = $19b0178a05c09b4f$var$extractOperation;
module.exports.getHeader = $19b0178a05c09b4f$var$getHeader;
module.exports.instrumentSupabaseClient = $19b0178a05c09b4f$var$instrumentSupabaseClient;
module.exports.supabaseIntegration = $19b0178a05c09b4f$var$supabaseIntegration;
module.exports.translateFiltersIntoMethods = $19b0178a05c09b4f$var$translateFiltersIntoMethods;

});

parcelRegister("hPYiy", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k2EST = parcelRequire("k2EST");

var $eMfEg = parcelRequire("eMfEg");

var $erV30 = parcelRequire("erV30");
const $cfc5f914a1ee6deb$var$DEFAULT_LIMIT = 10;
const $cfc5f914a1ee6deb$var$INTEGRATION_NAME = "ZodErrors";
function $cfc5f914a1ee6deb$var$originalExceptionIsZodError(originalException) {
    return $eMfEg.isError(originalException) && originalException.name === "ZodError" && Array.isArray(originalException.issues);
}
function $cfc5f914a1ee6deb$var$flattenIssue(issue) {
    return {
        ...issue,
        path: "path" in issue && Array.isArray(issue.path) ? issue.path.join(".") : void 0,
        keys: "keys" in issue ? JSON.stringify(issue.keys) : void 0,
        unionErrors: "unionErrors" in issue ? JSON.stringify(issue.unionErrors) : void 0
    };
}
function $cfc5f914a1ee6deb$var$flattenIssuePath(path) {
    return path.map((p)=>{
        if (typeof p === "number") return "<array>";
        else return p;
    }).join(".");
}
function $cfc5f914a1ee6deb$var$formatIssueMessage(zodError) {
    const errorKeyMap = /* @__PURE__ */ new Set();
    for (const iss of zodError.issues){
        const issuePath = $cfc5f914a1ee6deb$var$flattenIssuePath(iss.path);
        if (issuePath.length > 0) errorKeyMap.add(issuePath);
    }
    const errorKeys = Array.from(errorKeyMap);
    if (errorKeys.length === 0) {
        let rootExpectedType = "variable";
        if (zodError.issues.length > 0) {
            const iss = zodError.issues[0];
            if (iss !== void 0 && "expected" in iss && typeof iss.expected === "string") rootExpectedType = iss.expected;
        }
        return `Failed to validate ${rootExpectedType}`;
    }
    return `Failed to validate keys: ${$erV30.truncate(errorKeys.join(", "), 100)}`;
}
function $cfc5f914a1ee6deb$var$applyZodErrorsToEvent(limit, saveZodIssuesAsAttachment = false, event, hint) {
    if (!event.exception?.values || !hint.originalException || !$cfc5f914a1ee6deb$var$originalExceptionIsZodError(hint.originalException) || hint.originalException.issues.length === 0) return event;
    try {
        const issuesToFlatten = saveZodIssuesAsAttachment ? hint.originalException.issues : hint.originalException.issues.slice(0, limit);
        const flattenedIssues = issuesToFlatten.map($cfc5f914a1ee6deb$var$flattenIssue);
        if (saveZodIssuesAsAttachment) {
            if (!Array.isArray(hint.attachments)) hint.attachments = [];
            hint.attachments.push({
                filename: "zod_issues.json",
                data: JSON.stringify({
                    issues: flattenedIssues
                })
            });
        }
        return {
            ...event,
            exception: {
                ...event.exception,
                values: [
                    {
                        ...event.exception.values[0],
                        value: $cfc5f914a1ee6deb$var$formatIssueMessage(hint.originalException)
                    },
                    ...event.exception.values.slice(1)
                ]
            },
            extra: {
                ...event.extra,
                "zoderror.issues": flattenedIssues.slice(0, limit)
            }
        };
    } catch (e) {
        return {
            ...event,
            extra: {
                ...event.extra,
                "zoderrors sentry integration parse error": {
                    message: "an exception was thrown while processing ZodError within applyZodErrorsToEvent()",
                    error: e instanceof Error ? `${e.name}: ${e.message}
${e.stack}` : "unknown"
                }
            }
        };
    }
}
const $cfc5f914a1ee6deb$var$_zodErrorsIntegration = (options = {})=>{
    const limit = options.limit ?? $cfc5f914a1ee6deb$var$DEFAULT_LIMIT;
    return {
        name: $cfc5f914a1ee6deb$var$INTEGRATION_NAME,
        processEvent (originalEvent, hint) {
            const processedEvent = $cfc5f914a1ee6deb$var$applyZodErrorsToEvent(limit, options.saveZodIssuesAsAttachment, originalEvent, hint);
            return processedEvent;
        }
    };
};
const $cfc5f914a1ee6deb$var$zodErrorsIntegration = $k2EST.defineIntegration($cfc5f914a1ee6deb$var$_zodErrorsIntegration);
module.exports.applyZodErrorsToEvent = $cfc5f914a1ee6deb$var$applyZodErrorsToEvent;
module.exports.flattenIssue = $cfc5f914a1ee6deb$var$flattenIssue;
module.exports.flattenIssuePath = $cfc5f914a1ee6deb$var$flattenIssuePath;
module.exports.formatIssueMessage = $cfc5f914a1ee6deb$var$formatIssueMessage;
module.exports.zodErrorsIntegration = $cfc5f914a1ee6deb$var$zodErrorsIntegration;

});

parcelRegister("fmpEn", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k2EST = parcelRequire("k2EST");

var $lw8Ay = parcelRequire("lw8Ay");

var $5gI17 = parcelRequire("5gI17");

var $82RPZ = parcelRequire("82RPZ");

var $YfOkS = parcelRequire("YfOkS");
const $b2ecceb2a541e348$var$thirdPartyErrorFilterIntegration = $k2EST.defineIntegration((options)=>{
    return {
        name: "ThirdPartyErrorsFilter",
        setup (client) {
            client.on("beforeEnvelope", (envelope$1)=>{
                $5gI17.forEachEnvelopeItem(envelope$1, (item, type)=>{
                    if (type === "event") {
                        const event = Array.isArray(item) ? item[1] : void 0;
                        if (event) {
                            $lw8Ay.stripMetadataFromStackFrames(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on("applyFrameMetadata", (event)=>{
                if (event.type) return;
                const stackParser = client.getOptions().stackParser;
                $lw8Ay.addMetadataToStackFrames(stackParser, event);
            });
        },
        preprocessEvent (event) {
            if (options.ignoreSentryInternalFrames && ($YfOkS.GLOBAL_OBJ._sentryWrappedDepth ?? 0) > 0) event.sdkProcessingMetadata = {
                ...event.sdkProcessingMetadata,
                insideSentryWrapped: true
            };
        },
        processEvent (event) {
            const insideSentryWrapped = options.ignoreSentryInternalFrames ? event.sdkProcessingMetadata?.insideSentryWrapped === true && event.exception?.values?.length === 1 : false;
            const frameKeys = $b2ecceb2a541e348$var$getBundleKeysForAllFramesWithFilenames(event, options.ignoreSentryInternalFrames, insideSentryWrapped);
            if (frameKeys) {
                const arrayMethod = options.behaviour === "drop-error-if-contains-third-party-frames" || options.behaviour === "apply-tag-if-contains-third-party-frames" ? "some" : "every";
                const behaviourApplies = frameKeys[arrayMethod]((keys)=>!keys.some((key)=>options.filterKeys.includes(key)));
                if (behaviourApplies) {
                    const shouldDrop = options.behaviour === "drop-error-if-contains-third-party-frames" || options.behaviour === "drop-error-if-exclusively-contains-third-party-frames";
                    if (shouldDrop) return null;
                    else event.tags = {
                        ...event.tags,
                        third_party_code: true
                    };
                }
            }
            return event;
        }
    };
});
function $b2ecceb2a541e348$var$isSentryInternalFrame(frame, frameIndex, insideSentryWrapped) {
    if (frameIndex !== 0) return false;
    if (insideSentryWrapped && $b2ecceb2a541e348$var$isLikelyMinifiedSentryWrappedFrame(frame)) return true;
    if (frame.function === "sentryWrapped") return true;
    if (!frame.context_line || !frame.filename) return false;
    if (!frame.filename.includes("sentry") || !frame.filename.includes("helpers") || // Filename would look something like this: 'node_modules/@sentry/browser/build/npm/esm/helpers.js'
    !frame.context_line.includes($b2ecceb2a541e348$var$SENTRY_INTERNAL_FN_APPLY)) return false;
    if (frame.pre_context) {
        const len = frame.pre_context.length;
        for(let i = 0; i < len; i++){
            if (frame.pre_context[i]?.includes($b2ecceb2a541e348$var$SENTRY_INTERNAL_COMMENT)) return true;
        }
    }
    return false;
}
function $b2ecceb2a541e348$var$getBundleKeysForAllFramesWithFilenames(event, ignoreSentryInternalFrames, insideSentryWrapped) {
    const frames = $82RPZ.getFramesFromEvent(event);
    if (!frames) return void 0;
    return frames.filter((frame, index)=>{
        if (!frame.filename) return false;
        if (frame.lineno == null && frame.colno == null && frame.instruction_addr == null) return false;
        return !ignoreSentryInternalFrames || !$b2ecceb2a541e348$var$isSentryInternalFrame(frame, index, !!insideSentryWrapped);
    }).map((frame)=>{
        if (!frame.module_metadata) return [];
        return Object.keys(frame.module_metadata).filter((key)=>key.startsWith($b2ecceb2a541e348$var$BUNDLER_PLUGIN_APP_KEY_PREFIX)).map((key)=>key.slice($b2ecceb2a541e348$var$BUNDLER_PLUGIN_APP_KEY_PREFIX.length));
    });
}
function $b2ecceb2a541e348$var$isLikelyMinifiedSentryWrappedFrame(frame) {
    return !frame.context_line && !frame.pre_context && !!frame.function && frame.function.length <= 2;
}
const $b2ecceb2a541e348$var$BUNDLER_PLUGIN_APP_KEY_PREFIX = "_sentryBundlerPluginAppKey:";
const $b2ecceb2a541e348$var$SENTRY_INTERNAL_COMMENT = "Attempt to invoke user-land function";
const $b2ecceb2a541e348$var$SENTRY_INTERNAL_FN_APPLY = "fn.apply(this, wrappedArguments)";
module.exports.thirdPartyErrorFilterIntegration = $b2ecceb2a541e348$var$thirdPartyErrorFilterIntegration;

});

parcelRegister("lUkJd", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $85QQN = parcelRequire("85QQN");

var $8DrvK = parcelRequire("8DrvK");

var $hvU0C = parcelRequire("hvU0C");

var $k2EST = parcelRequire("k2EST");

var $1UPRv = parcelRequire("1UPRv");

var $1Vg0b = parcelRequire("1Vg0b");

var $erV30 = parcelRequire("erV30");

var $YfOkS = parcelRequire("YfOkS");
const $ff2ee82a65545913$var$INTEGRATION_NAME = "Console";
const $ff2ee82a65545913$var$consoleIntegration = $k2EST.defineIntegration((options = {})=>{
    const levels = new Set(options.levels || $1UPRv.CONSOLE_LEVELS);
    return {
        name: $ff2ee82a65545913$var$INTEGRATION_NAME,
        setup (client) {
            const unsubscribe = $hvU0C.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($8DrvK.getClient() !== client || !levels.has(level)) return;
                $ff2ee82a65545913$var$addConsoleBreadcrumb(level, args);
            });
            client.registerCleanup(unsubscribe);
            if (options.filter) {
                const unsubscribe2 = $hvU0C.addConsoleInstrumentationFilter(options.filter);
                client.registerCleanup(unsubscribe2);
            }
        }
    };
});
function $ff2ee82a65545913$var$addConsoleBreadcrumb(level, args) {
    const breadcrumb = {
        category: "console",
        data: {
            arguments: args,
            logger: "console"
        },
        level: $1Vg0b.severityLevelFromString(level),
        message: $ff2ee82a65545913$var$formatConsoleArgs(args)
    };
    if (level === "assert") {
        if (args[0] === false) {
            const assertionArgs = args.slice(1);
            breadcrumb.message = assertionArgs.length > 0 ? `Assertion failed: ${$ff2ee82a65545913$var$formatConsoleArgs(assertionArgs)}` : "Assertion failed";
            breadcrumb.data.arguments = assertionArgs;
        } else return;
    }
    $85QQN.addBreadcrumb(breadcrumb, {
        input: args,
        level: level
    });
}
function $ff2ee82a65545913$var$formatConsoleArgs(values) {
    return "util" in $YfOkS.GLOBAL_OBJ && typeof $YfOkS.GLOBAL_OBJ.util.format === "function" ? $YfOkS.GLOBAL_OBJ.util.format(...values) : $erV30.safeJoin(values, " ");
}
module.exports.addConsoleBreadcrumb = $ff2ee82a65545913$var$addConsoleBreadcrumb;
module.exports.consoleIntegration = $ff2ee82a65545913$var$consoleIntegration;

});

parcelRegister("jTUhJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k2EST = parcelRequire("k2EST");

var $3q75X = parcelRequire("3q75X");
const $e7ced06667232f57$var$featureFlagsIntegration = $k2EST.defineIntegration(()=>{
    return {
        name: "FeatureFlags",
        processEvent (event, _hint, _client) {
            return $3q75X._INTERNAL_copyFlagsFromScopeToEvent(event);
        },
        addFeatureFlag (name, value) {
            $3q75X._INTERNAL_insertFlagToScope(name, value);
            $3q75X._INTERNAL_addFeatureFlagToActiveSpan(name, value);
        }
    };
});
module.exports.featureFlagsIntegration = $e7ced06667232f57$var$featureFlagsIntegration;

});
parcelRegister("3q75X", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8DrvK = parcelRequire("8DrvK");

var $9Yejo = parcelRequire("9Yejo");

var $1UPRv = parcelRequire("1UPRv");

var $eXvrd = parcelRequire("eXvrd");
const $27d94dbc6b4779bb$var$_INTERNAL_FLAG_BUFFER_SIZE = 100;
const $27d94dbc6b4779bb$var$_INTERNAL_MAX_FLAGS_PER_SPAN = 10;
const $27d94dbc6b4779bb$var$SPAN_FLAG_ATTRIBUTE_PREFIX = "flag.evaluation.";
function $27d94dbc6b4779bb$var$_INTERNAL_copyFlagsFromScopeToEvent(event) {
    if (event.type) return event;
    const scope = $8DrvK.getCurrentScope();
    const flagContext = scope.getScopeData().contexts.flags;
    const flagBuffer = flagContext ? flagContext.values : [];
    if (!flagBuffer.length) return event;
    if (event.contexts === void 0) event.contexts = {};
    event.contexts.flags = {
        values: [
            ...flagBuffer
        ]
    };
    return event;
}
function $27d94dbc6b4779bb$var$_INTERNAL_insertFlagToScope(name, value, maxSize = $27d94dbc6b4779bb$var$_INTERNAL_FLAG_BUFFER_SIZE) {
    const scopeContexts = $8DrvK.getCurrentScope().getScopeData().contexts;
    if (!scopeContexts.flags) scopeContexts.flags = {
        values: []
    };
    const flags = scopeContexts.flags.values;
    $27d94dbc6b4779bb$var$_INTERNAL_insertToFlagBuffer(flags, name, value, maxSize);
}
function $27d94dbc6b4779bb$var$_INTERNAL_insertToFlagBuffer(flags, name, value, maxSize) {
    if (typeof value !== "boolean") return;
    if (flags.length > maxSize) {
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.error(`[Feature Flags] insertToFlagBuffer called on a buffer larger than maxSize=${maxSize}`);
        return;
    }
    const index = flags.findIndex((f)=>f.flag === name);
    if (index !== -1) flags.splice(index, 1);
    if (flags.length === maxSize) flags.shift();
    flags.push({
        flag: name,
        result: value
    });
}
function $27d94dbc6b4779bb$var$_INTERNAL_addFeatureFlagToActiveSpan(name, value, maxFlagsPerSpan = $27d94dbc6b4779bb$var$_INTERNAL_MAX_FLAGS_PER_SPAN) {
    if (typeof value !== "boolean") return;
    const span = $eXvrd.getActiveSpan();
    if (!span) return;
    const attributes = $eXvrd.spanToJSON(span).data;
    if (`${$27d94dbc6b4779bb$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}` in attributes) {
        span.setAttribute(`${$27d94dbc6b4779bb$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
        return;
    }
    const numOfAddedFlags = Object.keys(attributes).filter((key)=>key.startsWith($27d94dbc6b4779bb$var$SPAN_FLAG_ATTRIBUTE_PREFIX)).length;
    if (numOfAddedFlags < maxFlagsPerSpan) span.setAttribute(`${$27d94dbc6b4779bb$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
}
module.exports._INTERNAL_FLAG_BUFFER_SIZE = $27d94dbc6b4779bb$var$_INTERNAL_FLAG_BUFFER_SIZE;
module.exports._INTERNAL_MAX_FLAGS_PER_SPAN = $27d94dbc6b4779bb$var$_INTERNAL_MAX_FLAGS_PER_SPAN;
module.exports._INTERNAL_addFeatureFlagToActiveSpan = $27d94dbc6b4779bb$var$_INTERNAL_addFeatureFlagToActiveSpan;
module.exports._INTERNAL_copyFlagsFromScopeToEvent = $27d94dbc6b4779bb$var$_INTERNAL_copyFlagsFromScopeToEvent;
module.exports._INTERNAL_insertFlagToScope = $27d94dbc6b4779bb$var$_INTERNAL_insertFlagToScope;
module.exports._INTERNAL_insertToFlagBuffer = $27d94dbc6b4779bb$var$_INTERNAL_insertToFlagBuffer;

});


parcelRegister("4XFa2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k2EST = parcelRequire("k2EST");

var $3q75X = parcelRequire("3q75X");

var $kzIHY = parcelRequire("kzIHY");
const $39cc99d23218208f$var$growthbookIntegration = $k2EST.defineIntegration(({ growthbookClass: growthbookClass })=>{
    return {
        name: "GrowthBook",
        setupOnce () {
            const proto = growthbookClass.prototype;
            if (typeof proto.isOn === "function") $kzIHY.fill(proto, "isOn", $39cc99d23218208f$var$_wrapAndCaptureBooleanResult);
            if (typeof proto.getFeatureValue === "function") $kzIHY.fill(proto, "getFeatureValue", $39cc99d23218208f$var$_wrapAndCaptureBooleanResult);
        },
        processEvent (event, _hint, _client) {
            return $3q75X._INTERNAL_copyFlagsFromScopeToEvent(event);
        }
    };
});
function $39cc99d23218208f$var$_wrapAndCaptureBooleanResult(original) {
    return function(...args) {
        const flagName = args[0];
        const result = original.apply(this, args);
        if (typeof flagName === "string" && typeof result === "boolean") {
            $3q75X._INTERNAL_insertFlagToScope(flagName, result);
            $3q75X._INTERNAL_addFeatureFlagToActiveSpan(flagName, result);
        }
        return result;
    };
}
module.exports.growthbookIntegration = $39cc99d23218208f$var$growthbookIntegration;

});

parcelRegister("iMpUn", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8DrvK = parcelRequire("8DrvK");

var $k2EST = parcelRequire("k2EST");

var $dknph = parcelRequire("dknph");

var $eXvrd = parcelRequire("eXvrd");
const $dac0ce88cc3036a0$var$INTEGRATION_NAME = "ConversationId";
const $dac0ce88cc3036a0$var$_conversationIdIntegration = ()=>{
    return {
        name: $dac0ce88cc3036a0$var$INTEGRATION_NAME,
        setup (client) {
            client.on("spanStart", (span)=>{
                const scopeData = $8DrvK.getCurrentScope().getScopeData();
                const isolationScopeData = $8DrvK.getIsolationScope().getScopeData();
                const conversationId = scopeData.conversationId || isolationScopeData.conversationId;
                if (conversationId) {
                    const { op: op, data: attributes, description: name } = $eXvrd.spanToJSON(span);
                    if (!op?.startsWith("gen_ai.") && !attributes["ai.operationId"] && !name?.startsWith("ai.")) return;
                    span.setAttribute($dknph.GEN_AI_CONVERSATION_ID_ATTRIBUTE, conversationId);
                }
            });
        }
    };
};
const $dac0ce88cc3036a0$var$conversationIdIntegration = $k2EST.defineIntegration($dac0ce88cc3036a0$var$_conversationIdIntegration);
module.exports.conversationIdIntegration = $dac0ce88cc3036a0$var$conversationIdIntegration;

});

parcelRegister("igLrB", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8DrvK = parcelRequire("8DrvK");

var $9Yejo = parcelRequire("9Yejo");

var $1UPRv = parcelRequire("1UPRv");
function $d4ce860c935ab86f$var$isProfilingIntegrationWithProfiler(integration) {
    return !!integration && typeof integration["_profiler"] !== "undefined" && typeof integration["_profiler"]["start"] === "function" && typeof integration["_profiler"]["stop"] === "function";
}
function $d4ce860c935ab86f$var$startProfiler() {
    const client = $8DrvK.getClient();
    if (!client) {
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn("No Sentry client available, profiling is not started");
        return;
    }
    const integration = client.getIntegrationByName("ProfilingIntegration");
    if (!integration) {
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn("ProfilingIntegration is not available");
        return;
    }
    if (!$d4ce860c935ab86f$var$isProfilingIntegrationWithProfiler(integration)) {
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn("Profiler is not available on profiling integration.");
        return;
    }
    integration._profiler.start();
}
function $d4ce860c935ab86f$var$stopProfiler() {
    const client = $8DrvK.getClient();
    if (!client) {
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn("No Sentry client available, profiling is not started");
        return;
    }
    const integration = client.getIntegrationByName("ProfilingIntegration");
    if (!integration) {
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn("ProfilingIntegration is not available");
        return;
    }
    if (!$d4ce860c935ab86f$var$isProfilingIntegrationWithProfiler(integration)) {
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn("Profiler is not available on profiling integration.");
        return;
    }
    integration._profiler.stop();
}
const $d4ce860c935ab86f$var$profiler = {
    startProfiler: $d4ce860c935ab86f$var$startProfiler,
    stopProfiler: $d4ce860c935ab86f$var$stopProfiler
};
module.exports.profiler = $d4ce860c935ab86f$var$profiler;

});

parcelRegister("eVEl3", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iuxoj = parcelRequire("iuxoj");

var $8DrvK = parcelRequire("8DrvK");

var $dknph = parcelRequire("dknph");

var $eXvrd = parcelRequire("eXvrd");

var $3su1E = parcelRequire("3su1E");

var $eMfEg = parcelRequire("eMfEg");

var $13jPF = parcelRequire("13jPF");

var $kJznu = parcelRequire("kJznu");

var $lJcxl = parcelRequire("lJcxl");

var $cGnx0 = parcelRequire("cGnx0");

var $d7AD6 = parcelRequire("d7AD6");

var $ft8tx = parcelRequire("ft8tx");

var $9NHnC = parcelRequire("9NHnC");
function $ade5adf6ad9bc7f3$var$instrumentFetchRequest(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOriginOrOptions) {
    if (!handlerData.fetchData) return void 0;
    const { method: method, url: url } = handlerData.fetchData;
    const shouldCreateSpanResult = $13jPF.hasSpansEnabled() && shouldCreateSpan(url);
    if (handlerData.endTimestamp) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span2 = spans[spanId];
        if (span2) {
            if (shouldCreateSpanResult) {
                $ade5adf6ad9bc7f3$var$endSpan(span2, handlerData);
                $ade5adf6ad9bc7f3$var$_callOnRequestSpanEnd(span2, handlerData, spanOriginOrOptions);
            }
            delete spans[spanId];
        }
        return void 0;
    }
    const { spanOrigin: spanOrigin = "auto.http.browser", propagateTraceparent: propagateTraceparent = false } = typeof spanOriginOrOptions === "object" ? spanOriginOrOptions : {
        spanOrigin: spanOriginOrOptions
    };
    const client = $8DrvK.getClient();
    const hasParent = !!$eXvrd.getActiveSpan();
    const shouldEmitSpan = hasParent || !!client && $cGnx0.hasSpanStreamingEnabled(client);
    const span = shouldCreateSpanResult && shouldEmitSpan ? $d7AD6.startInactiveSpan($ade5adf6ad9bc7f3$var$getSpanStartOptions(url, method, spanOrigin)) : new $kJznu.SentryNonRecordingSpan();
    const spanForTraceHeaders = $d7AD6.spanIsIgnored(span) && hasParent ? void 0 : span;
    if (shouldCreateSpanResult && !shouldEmitSpan) client?.recordDroppedEvent("no_parent_span", "span");
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url)) {
        const request = handlerData.args[0];
        const options = {
            ...handlerData.args[1] || {}
        };
        const headers = $ade5adf6ad9bc7f3$var$_INTERNAL_getTracingHeadersForFetchRequest(request, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        $13jPF.hasSpansEnabled() && shouldEmitSpan ? spanForTraceHeaders : void 0, propagateTraceparent);
        if (headers) {
            handlerData.args[1] = options;
            options.headers = headers;
        }
    }
    if (client) {
        const fetchHint = {
            input: handlerData.args,
            response: handlerData.response,
            startTimestamp: handlerData.startTimestamp,
            endTimestamp: handlerData.endTimestamp
        };
        client.emit("beforeOutgoingRequestSpan", span, fetchHint);
    }
    return span;
}
function $ade5adf6ad9bc7f3$var$_callOnRequestSpanEnd(span, handlerData, spanOriginOrOptions) {
    const onRequestSpanEnd = typeof spanOriginOrOptions === "object" && spanOriginOrOptions !== null ? spanOriginOrOptions.onRequestSpanEnd : void 0;
    onRequestSpanEnd?.(span, {
        headers: handlerData.response?.headers,
        error: handlerData.error
    });
}
function $ade5adf6ad9bc7f3$var$_INTERNAL_getTracingHeadersForFetchRequest(request, fetchOptionsObj, span, propagateTraceparent) {
    const traceHeaders = $ft8tx.getTraceData({
        span: span,
        propagateTraceparent: propagateTraceparent
    });
    const sentryTrace = traceHeaders["sentry-trace"];
    const baggage = traceHeaders.baggage;
    const traceparent = traceHeaders.traceparent;
    if (!sentryTrace) return void 0;
    const originalHeaders = fetchOptionsObj.headers || ($eMfEg.isRequest(request) ? request.headers : void 0);
    if (!originalHeaders) return {
        "sentry-trace": sentryTrace,
        ...baggage && {
            baggage: baggage
        },
        ...traceparent && {
            traceparent: traceparent
        }
    };
    else if ($ade5adf6ad9bc7f3$var$isHeaders(originalHeaders)) {
        const newHeaders = new Headers(originalHeaders);
        if (!newHeaders.get("sentry-trace")) newHeaders.set("sentry-trace", sentryTrace);
        if (propagateTraceparent && traceparent && !newHeaders.get("traceparent")) newHeaders.set("traceparent", traceparent);
        if (baggage) {
            const prevBaggageHeader = newHeaders.get("baggage");
            if (!prevBaggageHeader) newHeaders.set("baggage", baggage);
            else if (!$ade5adf6ad9bc7f3$var$baggageHeaderHasSentryBaggageValues(prevBaggageHeader)) newHeaders.set("baggage", `${prevBaggageHeader},${baggage}`);
        }
        return newHeaders;
    } else if ($ade5adf6ad9bc7f3$var$isHeadersInitTupleArray(originalHeaders)) {
        const newHeaders = [
            ...originalHeaders
        ];
        if (!newHeaders.find((header)=>header[0] === "sentry-trace")) newHeaders.push([
            "sentry-trace",
            sentryTrace
        ]);
        if (propagateTraceparent && traceparent && !newHeaders.find((header)=>header[0] === "traceparent")) newHeaders.push([
            "traceparent",
            traceparent
        ]);
        const prevBaggageHeaderWithSentryValues = originalHeaders.find((header)=>header[0] === "baggage" && typeof header[1] === "string" && $ade5adf6ad9bc7f3$var$baggageHeaderHasSentryBaggageValues(header[1]));
        if (baggage && !prevBaggageHeaderWithSentryValues) newHeaders.push([
            "baggage",
            baggage
        ]);
        return newHeaders;
    } else {
        const existingSentryTraceHeader = "sentry-trace" in originalHeaders ? originalHeaders["sentry-trace"] : void 0;
        const existingTraceparentHeader = "traceparent" in originalHeaders ? originalHeaders.traceparent : void 0;
        const existingBaggageHeader = "baggage" in originalHeaders ? originalHeaders.baggage : void 0;
        const newBaggageHeaders = existingBaggageHeader ? Array.isArray(existingBaggageHeader) ? [
            ...existingBaggageHeader
        ] : [
            existingBaggageHeader
        ] : [];
        const prevBaggageHeaderWithSentryValues = existingBaggageHeader && (Array.isArray(existingBaggageHeader) ? existingBaggageHeader.find((headerItem)=>$ade5adf6ad9bc7f3$var$baggageHeaderHasSentryBaggageValues(headerItem)) : $ade5adf6ad9bc7f3$var$baggageHeaderHasSentryBaggageValues(existingBaggageHeader));
        if (baggage && !prevBaggageHeaderWithSentryValues) newBaggageHeaders.push(baggage);
        const newHeaders = Object.assign({}, originalHeaders, {
            "sentry-trace": existingSentryTraceHeader ?? sentryTrace,
            ...newBaggageHeaders.length > 0 && {
                baggage: newBaggageHeaders.join(",")
            }
        });
        if (propagateTraceparent && traceparent && !existingTraceparentHeader) newHeaders.traceparent = traceparent;
        return newHeaders;
    }
}
function $ade5adf6ad9bc7f3$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        $3su1E.setHttpStatus(span, handlerData.response.status);
        const contentLength = handlerData.response?.headers?.get("content-length");
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: $3su1E.SPAN_STATUS_ERROR,
        message: "internal_error"
    });
    span.end();
}
function $ade5adf6ad9bc7f3$var$baggageHeaderHasSentryBaggageValues(baggageHeader) {
    if (typeof baggageHeader !== "string") return false;
    return baggageHeader.split(",").some((baggageEntry)=>baggageEntry.trim().startsWith($lJcxl.SENTRY_BAGGAGE_KEY_PREFIX));
}
function $ade5adf6ad9bc7f3$var$isHeaders(headers) {
    return typeof Headers !== "undefined" && $eMfEg.isInstanceOf(headers, Headers);
}
function $ade5adf6ad9bc7f3$var$isHeadersInitTupleArray(headers) {
    if (!Array.isArray(headers)) return false;
    return headers.every((item)=>Array.isArray(item) && item.length === 2 && typeof item[0] === "string");
}
function $ade5adf6ad9bc7f3$var$getSpanStartOptions(url$1, method, spanOrigin) {
    if (url$1.startsWith("data:")) {
        const sanitizedUrl2 = $9NHnC.stripDataUrlContent(url$1);
        return {
            name: `${method} ${sanitizedUrl2}`,
            attributes: $ade5adf6ad9bc7f3$var$getFetchSpanAttributes(url$1, void 0, method, spanOrigin)
        };
    }
    const parsedUrl = $9NHnC.parseStringToURLObject(url$1);
    const sanitizedUrl = parsedUrl ? $9NHnC.getSanitizedUrlStringFromUrlObject(parsedUrl) : url$1;
    return {
        name: `${method} ${sanitizedUrl}`,
        attributes: $ade5adf6ad9bc7f3$var$getFetchSpanAttributes(url$1, parsedUrl, method, spanOrigin)
    };
}
function $ade5adf6ad9bc7f3$var$getFetchSpanAttributes(url$1, parsedUrl, method, spanOrigin) {
    const attributes$1 = {
        url: $9NHnC.stripDataUrlContent(url$1),
        type: "fetch",
        "http.method": method,
        [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanOrigin,
        [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "http.client"
    };
    if (parsedUrl) {
        if (!$9NHnC.isURLObjectRelative(parsedUrl)) {
            attributes$1[$iuxoj.HTTP_URL] = $9NHnC.stripDataUrlContent(parsedUrl.href);
            attributes$1[$iuxoj.URL_FULL] = $9NHnC.stripDataUrlContent(parsedUrl.href);
            attributes$1["server.address"] = parsedUrl.host;
        }
        if (parsedUrl.search) attributes$1["http.query"] = parsedUrl.search;
        if (parsedUrl.hash) attributes$1["http.fragment"] = parsedUrl.hash;
    }
    return attributes$1;
}
module.exports._INTERNAL_getTracingHeadersForFetchRequest = $ade5adf6ad9bc7f3$var$_INTERNAL_getTracingHeadersForFetchRequest;
module.exports._callOnRequestSpanEnd = $ade5adf6ad9bc7f3$var$_callOnRequestSpanEnd;
module.exports.instrumentFetchRequest = $ade5adf6ad9bc7f3$var$instrumentFetchRequest;

});

parcelRegister("3uYc3", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8DrvK = parcelRequire("8DrvK");
function $28c2dd9535ef5d65$var$captureFeedback(params, hint = {}, scope = $8DrvK.getCurrentScope()) {
    const { message: message, name: name, email: email, url: url, source: source, associatedEventId: associatedEventId, tags: tags } = params;
    const feedbackEvent = {
        contexts: {
            feedback: {
                contact_email: email,
                name: name,
                message: message,
                url: url,
                source: source,
                associated_event_id: associatedEventId
            }
        },
        type: "feedback",
        level: "info",
        tags: tags
    };
    const client = scope?.getClient() || $8DrvK.getClient();
    if (client) client.emit("beforeSendFeedback", feedbackEvent, hint);
    const eventId = scope.captureEvent(feedbackEvent, hint);
    return eventId;
}
module.exports.captureFeedback = $28c2dd9535ef5d65$var$captureFeedback;

});

parcelRegister("bmhFg", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $44TbO = parcelRequire("44TbO");

var $lNccF = parcelRequire("lNccF");
function $844f739e614f36aa$var$captureLog(level, message, attributes, scope, severityNumber) {
    $44TbO._INTERNAL_captureLog({
        level: level,
        message: message,
        attributes: attributes,
        severityNumber: severityNumber
    }, scope);
}
function $844f739e614f36aa$var$trace(message, attributes, { scope: scope } = {}) {
    $844f739e614f36aa$var$captureLog("trace", message, attributes, scope);
}
function $844f739e614f36aa$var$debug(message, attributes, { scope: scope } = {}) {
    $844f739e614f36aa$var$captureLog("debug", message, attributes, scope);
}
function $844f739e614f36aa$var$info(message, attributes, { scope: scope } = {}) {
    $844f739e614f36aa$var$captureLog("info", message, attributes, scope);
}
function $844f739e614f36aa$var$warn(message, attributes, { scope: scope } = {}) {
    $844f739e614f36aa$var$captureLog("warn", message, attributes, scope);
}
function $844f739e614f36aa$var$error(message, attributes, { scope: scope } = {}) {
    $844f739e614f36aa$var$captureLog("error", message, attributes, scope);
}
function $844f739e614f36aa$var$fatal(message, attributes, { scope: scope } = {}) {
    $844f739e614f36aa$var$captureLog("fatal", message, attributes, scope);
}
module.exports.fmt = $lNccF.fmt;
module.exports.debug = $844f739e614f36aa$var$debug;
module.exports.error = $844f739e614f36aa$var$error;
module.exports.fatal = $844f739e614f36aa$var$fatal;
module.exports.info = $844f739e614f36aa$var$info;
module.exports.trace = $844f739e614f36aa$var$trace;
module.exports.warn = $844f739e614f36aa$var$warn;

});

parcelRegister("dKoIL", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8DrvK = parcelRequire("8DrvK");

var $9Yejo = parcelRequire("9Yejo");

var $hvU0C = parcelRequire("hvU0C");

var $k2EST = parcelRequire("k2EST");

var $dknph = parcelRequire("dknph");

var $1UPRv = parcelRequire("1UPRv");

var $eMfEg = parcelRequire("eMfEg");

var $aaVDI = parcelRequire("aaVDI");

var $44TbO = parcelRequire("44TbO");

var $jM7sD = parcelRequire("jM7sD");
const $a022bf5334fcd511$var$INTEGRATION_NAME = "ConsoleLogs";
const $a022bf5334fcd511$var$DEFAULT_ATTRIBUTES = {
    [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.log.console"
};
const $a022bf5334fcd511$var$_consoleLoggingIntegration = (options = {})=>{
    const levels = options.levels || $1UPRv.CONSOLE_LEVELS;
    return {
        name: $a022bf5334fcd511$var$INTEGRATION_NAME,
        setup (client) {
            const { enableLogs: enableLogs, normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = client.getOptions();
            if (!enableLogs) {
                $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn("`enableLogs` is not enabled, ConsoleLogs integration disabled");
                return;
            }
            const unsubscribe = $hvU0C.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($8DrvK.getClient() !== client || !levels.includes(level)) return;
                const firstArg = args[0];
                const followingArgs = args.slice(1);
                if (level === "assert") {
                    if (!firstArg) {
                        const assertionMessage = followingArgs.length > 0 ? `Assertion failed: ${$jM7sD.formatConsoleArgs(followingArgs, normalizeDepth, normalizeMaxBreadth)}` : "Assertion failed";
                        $44TbO._INTERNAL_captureLog({
                            level: "error",
                            message: assertionMessage,
                            attributes: $a022bf5334fcd511$var$DEFAULT_ATTRIBUTES
                        });
                    }
                    return;
                }
                const isLevelLog = level === "log";
                const attributes = {
                    ...$a022bf5334fcd511$var$DEFAULT_ATTRIBUTES
                };
                if ($eMfEg.isPlainObject(firstArg)) {
                    Object.assign(attributes, $aaVDI.normalize(firstArg, normalizeDepth, normalizeMaxBreadth));
                    const remainingArgsStartIndex = typeof args[1] === "string" ? 2 : 1;
                    const remainingArgs = args.slice(remainingArgsStartIndex);
                    remainingArgs.forEach((arg, index)=>{
                        attributes[`sentry.message.parameter.${index}`] = $aaVDI.normalize(arg, normalizeDepth, normalizeMaxBreadth);
                    });
                } else {
                    const shouldGenerateTemplate = followingArgs.length > 0 && typeof firstArg === "string" && !$jM7sD.hasConsoleSubstitutions(firstArg);
                    if (shouldGenerateTemplate) {
                        const templateAttrs = $jM7sD.createConsoleTemplateAttributes(firstArg, followingArgs);
                        for (const [key, value] of Object.entries(templateAttrs))attributes[key] = key.startsWith("sentry.message.parameter.") ? $aaVDI.normalize(value, normalizeDepth, normalizeMaxBreadth) : value;
                    }
                }
                $44TbO._INTERNAL_captureLog({
                    level: isLevelLog ? "info" : level,
                    message: $jM7sD.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth),
                    severityNumber: isLevelLog ? 10 : void 0,
                    attributes: attributes
                });
            });
            client.registerCleanup(unsubscribe);
        }
    };
};
const $a022bf5334fcd511$var$consoleLoggingIntegration = $k2EST.defineIntegration($a022bf5334fcd511$var$_consoleLoggingIntegration);
module.exports.consoleLoggingIntegration = $a022bf5334fcd511$var$consoleLoggingIntegration;

});
parcelRegister("jM7sD", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eMfEg = parcelRequire("eMfEg");

var $aaVDI = parcelRequire("aaVDI");

var $YfOkS = parcelRequire("YfOkS");
function $e658499603cf4e12$var$formatConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
    return "util" in $YfOkS.GLOBAL_OBJ && typeof $YfOkS.GLOBAL_OBJ.util.format === "function" ? $YfOkS.GLOBAL_OBJ.util.format(...values) : $e658499603cf4e12$var$safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth);
}
function $e658499603cf4e12$var$safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
    return values.map((value)=>$eMfEg.isPrimitive(value) ? String(value) : JSON.stringify($aaVDI.normalize(value, normalizeDepth, normalizeMaxBreadth))).join(" ");
}
function $e658499603cf4e12$var$hasConsoleSubstitutions(str) {
    return /%[sdifocO]/.test(str);
}
function $e658499603cf4e12$var$createConsoleTemplateAttributes(firstArg, followingArgs) {
    const attributes = {};
    const template = new Array(followingArgs.length).fill("{}").join(" ");
    attributes["sentry.message.template"] = `${firstArg} ${template}`;
    followingArgs.forEach((arg, index)=>{
        attributes[`sentry.message.parameter.${index}`] = arg;
    });
    return attributes;
}
module.exports.createConsoleTemplateAttributes = $e658499603cf4e12$var$createConsoleTemplateAttributes;
module.exports.formatConsoleArgs = $e658499603cf4e12$var$formatConsoleArgs;
module.exports.hasConsoleSubstitutions = $e658499603cf4e12$var$hasConsoleSubstitutions;
module.exports.safeJoinConsoleArgs = $e658499603cf4e12$var$safeJoinConsoleArgs;

});


parcelRegister("9ysLw", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dpToc = parcelRequire("dpToc");
function $6f4d9a3db1ec65bc$var$captureMetric(type, name, value, options) {
    $dpToc._INTERNAL_captureMetric({
        type: type,
        name: name,
        value: value,
        unit: options?.unit,
        attributes: options?.attributes
    }, {
        scope: options?.scope
    });
}
function $6f4d9a3db1ec65bc$var$count(name, value = 1, options) {
    $6f4d9a3db1ec65bc$var$captureMetric("counter", name, value, options);
}
function $6f4d9a3db1ec65bc$var$gauge(name, value, options) {
    $6f4d9a3db1ec65bc$var$captureMetric("gauge", name, value, options);
}
function $6f4d9a3db1ec65bc$var$distribution(name, value, options) {
    $6f4d9a3db1ec65bc$var$captureMetric("distribution", name, value, options);
}
module.exports.count = $6f4d9a3db1ec65bc$var$count;
module.exports.distribution = $6f4d9a3db1ec65bc$var$distribution;
module.exports.gauge = $6f4d9a3db1ec65bc$var$gauge;

});

parcelRegister("5A7F2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8DrvK = parcelRequire("8DrvK");

var $44TbO = parcelRequire("44TbO");

var $jM7sD = parcelRequire("jM7sD");

var $eMfEg = parcelRequire("eMfEg");

var $aaVDI = parcelRequire("aaVDI");
const $410641db7985ef90$var$DEFAULT_CAPTURED_LEVELS = [
    "trace",
    "debug",
    "info",
    "warn",
    "error",
    "fatal"
];
function $410641db7985ef90$var$createConsolaReporter(options = {}) {
    const levels = new Set(options.levels ?? $410641db7985ef90$var$DEFAULT_CAPTURED_LEVELS);
    const providedClient = options.client;
    return {
        log (logObj) {
            const { type: type, level: level, message: consolaMessage, args: args, tag: tag, date: _date, ...rest } = logObj;
            const client = providedClient || $8DrvK.getClient();
            if (!client) return;
            const logSeverityLevel = $410641db7985ef90$var$getLogSeverityLevel(type, level);
            if (!levels.has(logSeverityLevel)) return;
            const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = client.getOptions();
            const attributes = {};
            for (const [key, value] of Object.entries(rest))attributes[key] = $aaVDI.normalize(value, normalizeDepth, normalizeMaxBreadth);
            attributes["sentry.origin"] = "auto.log.consola";
            if (tag) attributes["consola.tag"] = tag;
            if (type) attributes["consola.type"] = type;
            if (level != null && typeof level === "number") attributes["consola.level"] = level;
            const extractionResult = $410641db7985ef90$var$processExtractedAttributes($410641db7985ef90$var$defaultExtractAttributes(args, normalizeDepth, normalizeMaxBreadth), normalizeDepth, normalizeMaxBreadth);
            if (extractionResult?.attributes) Object.assign(attributes, extractionResult.attributes);
            $44TbO._INTERNAL_captureLog({
                level: logSeverityLevel,
                message: extractionResult?.message || consolaMessage || args && $jM7sD.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth) || "",
                attributes: attributes
            });
        }
    };
}
const $410641db7985ef90$var$CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP = {
    // Consola built-in types
    silent: "trace",
    fatal: "fatal",
    error: "error",
    warn: "warn",
    log: "info",
    info: "info",
    success: "info",
    fail: "error",
    ready: "info",
    start: "info",
    box: "info",
    debug: "debug",
    trace: "trace",
    verbose: "debug",
    // Custom types that might exist
    critical: "fatal",
    notice: "info"
};
const $410641db7985ef90$var$CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP = {
    0: "fatal",
    // Fatal and Error
    1: "warn",
    // Warnings
    2: "info",
    // Normal logs
    3: "info",
    // Informational logs, success, fail, ready, start, ...
    4: "debug",
    // Debug logs
    5: "trace"
};
function $410641db7985ef90$var$getLogSeverityLevel(type, level) {
    if (type === "verbose") return "debug";
    if (type === "silent") return "trace";
    if (type) {
        const mappedLevel = $410641db7985ef90$var$CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP[type];
        if (mappedLevel) return mappedLevel;
    }
    if (typeof level === "number") {
        const mappedLevel = $410641db7985ef90$var$CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP[level];
        if (mappedLevel) return mappedLevel;
    }
    return "info";
}
function $410641db7985ef90$var$defaultExtractAttributes(args, normalizeDepth, normalizeMaxBreadth) {
    if (!args?.length) return {
        message: ""
    };
    const message = $jM7sD.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth);
    const firstArg = args[0];
    if ($eMfEg.isPlainObject(firstArg)) {
        const remainingArgsStartIndex = typeof args[1] === "string" ? 2 : 1;
        const remainingArgs = args.slice(remainingArgsStartIndex);
        return {
            message: message,
            // Object content from first arg is added as attributes
            attributes: firstArg,
            // Add remaining args as message parameters
            messageParameters: remainingArgs
        };
    } else {
        const followingArgs = args.slice(1);
        const shouldAddTemplateAttr = followingArgs.length > 0 && typeof firstArg === "string" && !$jM7sD.hasConsoleSubstitutions(firstArg);
        return {
            message: message,
            messageTemplate: shouldAddTemplateAttr ? firstArg : void 0,
            messageParameters: shouldAddTemplateAttr ? followingArgs : void 0
        };
    }
}
function $410641db7985ef90$var$processExtractedAttributes(extractionResult, normalizeDepth, normalizeMaxBreadth) {
    const { message: message, attributes: attributes, messageTemplate: messageTemplate, messageParameters: messageParameters } = extractionResult;
    const messageParamAttributes = {};
    if (messageTemplate && messageParameters) {
        const templateAttrs = $jM7sD.createConsoleTemplateAttributes(messageTemplate, messageParameters);
        for (const [key, value] of Object.entries(templateAttrs))messageParamAttributes[key] = key.startsWith("sentry.message.parameter.") ? $aaVDI.normalize(value, normalizeDepth, normalizeMaxBreadth) : value;
    } else if (messageParameters && messageParameters.length > 0) messageParameters.forEach((arg, index)=>{
        messageParamAttributes[`sentry.message.parameter.${index}`] = $aaVDI.normalize(arg, normalizeDepth, normalizeMaxBreadth);
    });
    return {
        message: message,
        attributes: {
            ...$aaVDI.normalize(attributes, normalizeDepth, normalizeMaxBreadth),
            ...messageParamAttributes
        }
    };
}
module.exports.createConsolaReporter = $410641db7985ef90$var$createConsolaReporter;

});

parcelRegister("aIgLw", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8DrvK = parcelRequire("8DrvK");

var $dknph = parcelRequire("dknph");

var $4htth = parcelRequire("4htth");

var $71viH = parcelRequire("71viH");

var $eXvrd = parcelRequire("eXvrd");

var $4GqxV = parcelRequire("4GqxV");

var $9QwBg = parcelRequire("9QwBg");

var $6WjYJ = parcelRequire("6WjYJ");

var $cGnx0 = parcelRequire("cGnx0");

var $9dzpp = parcelRequire("9dzpp");

var $7Pjqz = parcelRequire("7Pjqz");
function $7ccb04b85df69c08$var$onVercelAiSpanStart(span) {
    const { data: attributes, description: name } = $eXvrd.spanToJSON(span);
    if (!name) return;
    if (attributes[$7Pjqz.AI_TOOL_CALL_NAME_ATTRIBUTE] && attributes[$7Pjqz.AI_TOOL_CALL_ID_ATTRIBUTE] && name === "ai.toolCall") {
        $7ccb04b85df69c08$var$processToolCallSpan(span, attributes);
        return;
    }
    if (!attributes[$7Pjqz.AI_OPERATION_ID_ATTRIBUTE] && !name.startsWith("ai.")) return;
    if ($6WjYJ.SPAN_TO_OPERATION_NAME.get(name) === "generate_content") $71viH._INTERNAL_skipAiProviderWrapping([
        $4GqxV.WORKERS_AI_INTEGRATION_NAME
    ]);
    const client = $8DrvK.getClient();
    const integration = client?.getIntegrationByName("VercelAI");
    const enableTruncation = $4htth.shouldEnableTruncation(integration?.options?.enableTruncation);
    $7ccb04b85df69c08$var$processGenerateSpan(span, name, attributes, enableTruncation);
}
function $7ccb04b85df69c08$var$vercelAiEventProcessor(event) {
    if (event.type === "transaction" && event.spans) {
        const tokenAccumulator = /* @__PURE__ */ new Map();
        for (const span of event.spans){
            $7ccb04b85df69c08$var$processEndedVercelAiSpan(span);
            $9dzpp.accumulateTokensForParent(span, tokenAccumulator);
        }
        $9dzpp.applyToolDescriptionsAndTokens(event.spans, tokenAccumulator);
        const trace = event.contexts?.trace;
        if (trace?.op === "gen_ai.invoke_agent") $9dzpp.applyAccumulatedTokens(trace, tokenAccumulator);
    }
    return event;
}
function $7ccb04b85df69c08$var$normalizeFinishReason(finishReason) {
    if (typeof finishReason !== "string") return "stop";
    switch(finishReason){
        case "tool-calls":
            return "tool_call";
        case "stop":
        case "length":
        case "content_filter":
        case "error":
            return finishReason;
        default:
            return finishReason;
    }
}
function $7ccb04b85df69c08$var$buildOutputMessages(attributes) {
    const responseText = attributes[$7Pjqz.AI_RESPONSE_TEXT_ATTRIBUTE];
    const responseToolCalls = attributes[$7Pjqz.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE];
    const finishReason = attributes[$7Pjqz.AI_RESPONSE_FINISH_REASON_ATTRIBUTE];
    if (responseText == null && responseToolCalls == null) return;
    const parts = [];
    if (typeof responseText === "string" && responseText.length > 0) parts.push({
        type: "text",
        content: responseText
    });
    if (responseToolCalls != null) try {
        const toolCalls = typeof responseToolCalls === "string" ? JSON.parse(responseToolCalls) : responseToolCalls;
        if (Array.isArray(toolCalls)) {
            for (const toolCall of toolCalls){
                const args = toolCall.input ?? toolCall.args;
                parts.push({
                    type: "tool_call",
                    id: toolCall.toolCallId,
                    name: toolCall.toolName,
                    // Handle undefined args: JSON.stringify(undefined) returns undefined, not a string,
                    // which would cause the property to be omitted from the final JSON output
                    arguments: typeof args === "string" ? args : JSON.stringify(args ?? {})
                });
            }
            delete attributes[$7Pjqz.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE];
        }
    } catch  {}
    if (parts.length > 0) {
        const outputMessage = {
            role: "assistant",
            parts: parts,
            finish_reason: $7ccb04b85df69c08$var$normalizeFinishReason(finishReason)
        };
        attributes[$9QwBg.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE] = JSON.stringify([
            outputMessage
        ]);
        delete attributes[$7Pjqz.AI_RESPONSE_TEXT_ATTRIBUTE];
    }
}
function $7ccb04b85df69c08$var$processVercelAiSpanAttributes(attributes) {
    $7ccb04b85df69c08$var$renameAttributeKey(attributes, $7Pjqz.AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE, $9QwBg.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE);
    $7ccb04b85df69c08$var$renameAttributeKey(attributes, $7Pjqz.AI_USAGE_PROMPT_TOKENS_ATTRIBUTE, $9QwBg.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $7ccb04b85df69c08$var$renameAttributeKey(attributes, $7Pjqz.AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE, $9QwBg.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE);
    $7ccb04b85df69c08$var$renameAttributeKey(attributes, "ai.usage.inputTokens", $9QwBg.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $7ccb04b85df69c08$var$renameAttributeKey(attributes, "ai.usage.outputTokens", $9QwBg.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE);
    $7ccb04b85df69c08$var$renameAttributeKey(attributes, $7Pjqz.AI_USAGE_TOKENS_ATTRIBUTE, $9QwBg.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $7ccb04b85df69c08$var$renameAttributeKey(attributes, "ai.response.avgOutputTokensPerSecond", "ai.response.avgCompletionTokensPerSecond");
    const inputTokensAreCacheInclusive = Object.keys(attributes).some((key)=>key.startsWith($7Pjqz.AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX));
    if (!inputTokensAreCacheInclusive && typeof attributes[$9QwBg.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] === "number" && typeof attributes[$9QwBg.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE] === "number") attributes[$9QwBg.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = attributes[$9QwBg.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] + attributes[$9QwBg.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE];
    if (typeof attributes[$9QwBg.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] === "number") {
        const outputTokens = typeof attributes[$9QwBg.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] === "number" ? attributes[$9QwBg.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] : 0;
        attributes[$9QwBg.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = outputTokens + attributes[$9QwBg.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE];
    }
    if (attributes[$7Pjqz.AI_PROMPT_TOOLS_ATTRIBUTE] && Array.isArray(attributes[$7Pjqz.AI_PROMPT_TOOLS_ATTRIBUTE])) attributes[$7Pjqz.AI_PROMPT_TOOLS_ATTRIBUTE] = $9dzpp.convertAvailableToolsToJsonString(attributes[$7Pjqz.AI_PROMPT_TOOLS_ATTRIBUTE]);
    if (attributes[$7Pjqz.OPERATION_NAME_ATTRIBUTE]) {
        const rawOperationName = attributes[$7Pjqz.AI_OPERATION_ID_ATTRIBUTE] ? attributes[$7Pjqz.AI_OPERATION_ID_ATTRIBUTE] : attributes[$7Pjqz.OPERATION_NAME_ATTRIBUTE];
        const operationName = $6WjYJ.SPAN_TO_OPERATION_NAME.get(rawOperationName) ?? rawOperationName;
        attributes[$9QwBg.GEN_AI_OPERATION_NAME_ATTRIBUTE] = operationName;
        delete attributes[$7Pjqz.OPERATION_NAME_ATTRIBUTE];
    }
    $7ccb04b85df69c08$var$renameAttributeKey(attributes, $7Pjqz.AI_PROMPT_MESSAGES_ATTRIBUTE, $9QwBg.GEN_AI_INPUT_MESSAGES_ATTRIBUTE);
    $7ccb04b85df69c08$var$buildOutputMessages(attributes);
    $7ccb04b85df69c08$var$renameAttributeKey(attributes, $7Pjqz.AI_RESPONSE_OBJECT_ATTRIBUTE, "gen_ai.response.object");
    $7ccb04b85df69c08$var$renameAttributeKey(attributes, $7Pjqz.AI_PROMPT_TOOLS_ATTRIBUTE, "gen_ai.request.available_tools");
    $7ccb04b85df69c08$var$renameAttributeKey(attributes, $7Pjqz.AI_TOOL_CALL_ARGS_ATTRIBUTE, $9QwBg.GEN_AI_TOOL_INPUT_ATTRIBUTE);
    $7ccb04b85df69c08$var$renameAttributeKey(attributes, $7Pjqz.AI_TOOL_CALL_RESULT_ATTRIBUTE, $9QwBg.GEN_AI_TOOL_OUTPUT_ATTRIBUTE);
    $7ccb04b85df69c08$var$renameAttributeKey(attributes, $7Pjqz.AI_SCHEMA_ATTRIBUTE, "gen_ai.request.schema");
    $7ccb04b85df69c08$var$renameAttributeKey(attributes, $7Pjqz.AI_MODEL_ID_ATTRIBUTE, $9QwBg.GEN_AI_REQUEST_MODEL_ATTRIBUTE);
    if (Array.isArray(attributes[$7Pjqz.AI_VALUES_ATTRIBUTE])) {
        const parsed = attributes[$7Pjqz.AI_VALUES_ATTRIBUTE].map((v)=>{
            try {
                return JSON.parse(v);
            } catch  {
                return v;
            }
        });
        attributes[$9QwBg.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE] = parsed.length === 1 ? parsed[0] : JSON.stringify(parsed);
    }
    $7ccb04b85df69c08$var$addProviderMetadataToAttributes(attributes);
    for (const key of Object.keys(attributes)){
        if (Array.isArray(attributes[key])) attributes[key] = JSON.stringify(attributes[key]);
        if (key.startsWith("ai.")) $7ccb04b85df69c08$var$renameAttributeKey(attributes, key, `vercel.${key}`);
    }
}
function $7ccb04b85df69c08$var$processEndedVercelAiSpan(span) {
    const { data: attributes, origin: origin } = span;
    if (origin !== "auto.vercelai.otel") return;
    if (span.status && span.status !== "ok") span.status = "internal_error";
    $7ccb04b85df69c08$var$processVercelAiSpanAttributes(attributes);
}
function $7ccb04b85df69c08$var$processVercelAiStreamedSpan(span) {
    const attributes = span.attributes;
    if (attributes?.[$dknph.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN] !== "auto.vercelai.otel") return;
    $7ccb04b85df69c08$var$processVercelAiSpanAttributes(attributes);
    if (attributes[$dknph.SEMANTIC_ATTRIBUTE_SENTRY_OP] === "gen_ai.execute_tool" && span.parent_span_id) {
        const descriptions = $6WjYJ.toolDescriptionMap.get(span.parent_span_id);
        if (descriptions) {
            const toolName = attributes[$9QwBg.GEN_AI_TOOL_NAME_ATTRIBUTE];
            if (typeof toolName === "string") {
                const desc = descriptions.get(toolName);
                if (desc) attributes[$9QwBg.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = desc;
            }
        }
    }
    $6WjYJ.toolDescriptionMap.delete(span.span_id);
}
function $7ccb04b85df69c08$var$renameAttributeKey(attributes, oldKey, newKey) {
    if (attributes[oldKey] != null) {
        attributes[newKey] = attributes[oldKey];
        delete attributes[oldKey];
    }
}
function $7ccb04b85df69c08$var$processToolCallSpan(span, attributes) {
    span.setAttribute($dknph.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, "auto.vercelai.otel");
    span.setAttribute($dknph.SEMANTIC_ATTRIBUTE_SENTRY_OP, "gen_ai.execute_tool");
    span.setAttribute($9QwBg.GEN_AI_OPERATION_NAME_ATTRIBUTE, "execute_tool");
    $7ccb04b85df69c08$var$renameAttributeKey(attributes, $7Pjqz.AI_TOOL_CALL_NAME_ATTRIBUTE, $9QwBg.GEN_AI_TOOL_NAME_ATTRIBUTE);
    $7ccb04b85df69c08$var$renameAttributeKey(attributes, $7Pjqz.AI_TOOL_CALL_ID_ATTRIBUTE, $9QwBg.GEN_AI_TOOL_CALL_ID_ATTRIBUTE);
    const toolCallId = attributes[$9QwBg.GEN_AI_TOOL_CALL_ID_ATTRIBUTE];
    if (typeof toolCallId === "string") $6WjYJ.toolCallSpanContextMap.set(toolCallId, span.spanContext());
    if (!attributes[$9QwBg.GEN_AI_TOOL_TYPE_ATTRIBUTE]) span.setAttribute($9QwBg.GEN_AI_TOOL_TYPE_ATTRIBUTE, "function");
    const toolName = attributes[$9QwBg.GEN_AI_TOOL_NAME_ATTRIBUTE];
    if (toolName) span.updateName(`execute_tool ${toolName}`);
}
function $7ccb04b85df69c08$var$processGenerateSpan(span, name, attributes, enableTruncation) {
    span.setAttribute($dknph.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, "auto.vercelai.otel");
    const nameWthoutAi = name.replace("ai.", "");
    span.setAttribute("ai.pipeline.name", nameWthoutAi);
    span.updateName(nameWthoutAi);
    const functionId = attributes[$7Pjqz.AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE];
    if (functionId && typeof functionId === "string") span.setAttribute("gen_ai.function_id", functionId);
    $9dzpp.requestMessagesFromPrompt(span, attributes, enableTruncation);
    if (attributes[$7Pjqz.AI_MODEL_ID_ATTRIBUTE] && !attributes[$9QwBg.GEN_AI_RESPONSE_MODEL_ATTRIBUTE]) span.setAttribute($9QwBg.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, attributes[$7Pjqz.AI_MODEL_ID_ATTRIBUTE]);
    span.setAttribute("ai.streaming", name.includes("stream"));
    const operationName = $6WjYJ.SPAN_TO_OPERATION_NAME.get(name);
    if (operationName) span.setAttribute($dknph.SEMANTIC_ATTRIBUTE_SENTRY_OP, `gen_ai.${operationName}`);
    else if (name.startsWith("ai.stream")) span.setAttribute($dknph.SEMANTIC_ATTRIBUTE_SENTRY_OP, "ai.run");
    if (operationName === "invoke_agent") {
        if (functionId && typeof functionId === "string") span.updateName(`invoke_agent ${functionId}`);
        else span.updateName("invoke_agent");
        return;
    }
    const modelId = attributes[$7Pjqz.AI_MODEL_ID_ATTRIBUTE];
    if (modelId && operationName) span.updateName(`${operationName} ${modelId}`);
    const client = $8DrvK.getClient();
    if (client && $cGnx0.hasSpanStreamingEnabled(client) && attributes[$7Pjqz.AI_PROMPT_TOOLS_ATTRIBUTE] && Array.isArray(attributes[$7Pjqz.AI_PROMPT_TOOLS_ATTRIBUTE])) {
        const descriptions = /* @__PURE__ */ new Map();
        for (const toolStr of attributes[$7Pjqz.AI_PROMPT_TOOLS_ATTRIBUTE])try {
            const parsed = typeof toolStr === "string" ? JSON.parse(toolStr) : toolStr;
            if (parsed?.name && parsed?.description) descriptions.set(parsed.name, parsed.description);
        } catch  {}
        if (descriptions.size > 0) {
            const parentSpanId = $eXvrd.spanToJSON(span).parent_span_id;
            if (parentSpanId) $6WjYJ.toolDescriptionMap.set(parentSpanId, descriptions);
        }
    }
}
function $7ccb04b85df69c08$var$addVercelAiProcessors(client) {
    client.on("spanStart", $7ccb04b85df69c08$var$onVercelAiSpanStart);
    client.addEventProcessor(Object.assign($7ccb04b85df69c08$var$vercelAiEventProcessor, {
        id: "VercelAiEventProcessor"
    }));
    client.on("processSpan", (span)=>{
        $7ccb04b85df69c08$var$processVercelAiStreamedSpan(span);
    });
}
function $7ccb04b85df69c08$var$getProviderMetadataAttributes(providerMetadata) {
    const attributes = {};
    if (!providerMetadata || typeof providerMetadata !== "object") return attributes;
    const metadata = providerMetadata;
    const openaiMetadata = metadata.openai ?? metadata.azure;
    if (openaiMetadata) {
        $7ccb04b85df69c08$var$setAttributeIfDefined(attributes, $9QwBg.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, openaiMetadata.cachedPromptTokens);
        $7ccb04b85df69c08$var$setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.reasoning", openaiMetadata.reasoningTokens);
        $7ccb04b85df69c08$var$setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.prediction_accepted", openaiMetadata.acceptedPredictionTokens);
        $7ccb04b85df69c08$var$setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.prediction_rejected", openaiMetadata.rejectedPredictionTokens);
        $7ccb04b85df69c08$var$setAttributeIfDefined(attributes, $9QwBg.GEN_AI_CONVERSATION_ID_ATTRIBUTE, openaiMetadata.responseId);
    }
    if (metadata.anthropic) {
        const cachedInputTokens = metadata.anthropic.usage?.cache_read_input_tokens ?? metadata.anthropic.cacheReadInputTokens;
        $7ccb04b85df69c08$var$setAttributeIfDefined(attributes, $9QwBg.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, cachedInputTokens);
        const cacheWriteInputTokens = metadata.anthropic.usage?.cache_creation_input_tokens ?? metadata.anthropic.cacheCreationInputTokens;
        $7ccb04b85df69c08$var$setAttributeIfDefined(attributes, $9QwBg.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE, cacheWriteInputTokens);
    }
    if (metadata.bedrock?.usage) {
        $7ccb04b85df69c08$var$setAttributeIfDefined(attributes, $9QwBg.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, metadata.bedrock.usage.cacheReadInputTokens);
        $7ccb04b85df69c08$var$setAttributeIfDefined(attributes, $9QwBg.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE, metadata.bedrock.usage.cacheWriteInputTokens);
    }
    if (metadata.deepseek) {
        $7ccb04b85df69c08$var$setAttributeIfDefined(attributes, $9QwBg.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, metadata.deepseek.promptCacheHitTokens);
        $7ccb04b85df69c08$var$setAttributeIfDefined(attributes, "gen_ai.usage.input_tokens.cache_miss", metadata.deepseek.promptCacheMissTokens);
    }
    return attributes;
}
function $7ccb04b85df69c08$var$addProviderMetadataToAttributes(attributes) {
    const providerMetadata = attributes[$7Pjqz.AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE];
    if (!providerMetadata) return;
    try {
        const derived = $7ccb04b85df69c08$var$getProviderMetadataAttributes(JSON.parse(providerMetadata));
        for (const [key, value] of Object.entries(derived)){
            if (key === $9QwBg.GEN_AI_CONVERSATION_ID_ATTRIBUTE && attributes[key]) continue;
            attributes[key] = value;
        }
    } catch  {}
}
function $7ccb04b85df69c08$var$setAttributeIfDefined(attributes, key, value) {
    if (value != null) attributes[key] = value;
}
module.exports.addVercelAiProcessors = $7ccb04b85df69c08$var$addVercelAiProcessors;
module.exports.getProviderMetadataAttributes = $7ccb04b85df69c08$var$getProviderMetadataAttributes;
module.exports.processVercelAiSpanAttributes = $7ccb04b85df69c08$var$processVercelAiSpanAttributes;

});
parcelRegister("4htth", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8DrvK = parcelRequire("8DrvK");

var $cGnx0 = parcelRequire("cGnx0");

var $eMfEg = parcelRequire("eMfEg");

var $9QwBg = parcelRequire("9QwBg");

var $2wYdH = parcelRequire("2wYdH");
function $31df9c51c887fe86$var$resolveAIRecordingOptions(options) {
    const genAI = $8DrvK.getClient()?.getDataCollectionOptions().genAI;
    return {
        ...options,
        recordInputs: options?.recordInputs ?? genAI?.inputs ?? false,
        recordOutputs: options?.recordOutputs ?? genAI?.outputs ?? false
    };
}
function $31df9c51c887fe86$var$shouldEnableTruncation(enableTruncation) {
    if (enableTruncation !== void 0) return enableTruncation;
    const client = $8DrvK.getClient();
    if (!client) return true;
    return !$cGnx0.hasSpanStreamingEnabled(client) && client.getOptions().streamGenAiSpans === false;
}
function $31df9c51c887fe86$var$buildMethodPath(currentPath, prop) {
    return currentPath ? `${currentPath}.${prop}` : prop;
}
function $31df9c51c887fe86$var$setTokenUsageAttributes(span, promptTokens, completionTokens, cachedInputTokens, cachedOutputTokens) {
    if (promptTokens !== void 0) span.setAttributes({
        [$9QwBg.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE]: promptTokens
    });
    if (completionTokens !== void 0) span.setAttributes({
        [$9QwBg.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE]: completionTokens
    });
    if (promptTokens !== void 0 || completionTokens !== void 0 || cachedInputTokens !== void 0 || cachedOutputTokens !== void 0) {
        const totalTokens = (promptTokens ?? 0) + (completionTokens ?? 0) + (cachedInputTokens ?? 0) + (cachedOutputTokens ?? 0);
        span.setAttributes({
            [$9QwBg.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE]: totalTokens
        });
    }
}
function $31df9c51c887fe86$var$endStreamSpan(span, state, recordOutputs) {
    if (!span.isRecording()) return;
    const attrs = {
        [$9QwBg.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE]: true
    };
    if (state.responseId) attrs[$9QwBg.GEN_AI_RESPONSE_ID_ATTRIBUTE] = state.responseId;
    if (state.responseModel) attrs[$9QwBg.GEN_AI_RESPONSE_MODEL_ATTRIBUTE] = state.responseModel;
    if (state.promptTokens !== void 0) attrs[$9QwBg.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = state.promptTokens;
    if (state.completionTokens !== void 0) attrs[$9QwBg.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = state.completionTokens;
    if (state.totalTokens !== void 0) attrs[$9QwBg.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = state.totalTokens;
    else if (state.promptTokens !== void 0 || state.completionTokens !== void 0 || state.cacheCreationInputTokens !== void 0 || state.cacheReadInputTokens !== void 0) attrs[$9QwBg.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = (state.promptTokens ?? 0) + (state.completionTokens ?? 0) + (state.cacheCreationInputTokens ?? 0) + (state.cacheReadInputTokens ?? 0);
    if (state.finishReasons.length) attrs[$9QwBg.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify(state.finishReasons);
    if (recordOutputs && state.responseTexts.length) attrs[$9QwBg.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = state.responseTexts.join("");
    if (recordOutputs && state.toolCalls.length) attrs[$9QwBg.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(state.toolCalls);
    span.setAttributes(attrs);
    span.end();
}
function $31df9c51c887fe86$var$getTruncatedJsonString(value) {
    if (typeof value === "string") return $2wYdH.truncateGenAiStringInput(value);
    try {
        return JSON.stringify(Array.isArray(value) ? $2wYdH.truncateGenAiMessages(value) : value);
    } catch  {
        return "[unserializable]";
    }
}
function $31df9c51c887fe86$var$extractSystemInstructions(messages) {
    if (!Array.isArray(messages)) return {
        systemInstructions: void 0,
        filteredMessages: messages
    };
    const systemMessageIndex = messages.findIndex((msg)=>msg && typeof msg === "object" && "role" in msg && msg.role === "system");
    if (systemMessageIndex === -1) return {
        systemInstructions: void 0,
        filteredMessages: messages
    };
    const systemMessage = messages[systemMessageIndex];
    const systemContent = typeof systemMessage.content === "string" ? systemMessage.content : systemMessage.content !== void 0 ? JSON.stringify(systemMessage.content) : void 0;
    if (!systemContent) return {
        systemInstructions: void 0,
        filteredMessages: messages
    };
    const systemInstructions = JSON.stringify([
        {
            type: "text",
            content: systemContent
        }
    ]);
    const filteredMessages = [
        ...messages.slice(0, systemMessageIndex),
        ...messages.slice(systemMessageIndex + 1)
    ];
    return {
        systemInstructions: systemInstructions,
        filteredMessages: filteredMessages
    };
}
async function $31df9c51c887fe86$var$createWithResponseWrapper(originalWithResponse, instrumentedPromise) {
    const [instrumentedResult, originalWrapper] = await Promise.all([
        instrumentedPromise,
        originalWithResponse
    ]);
    if (originalWrapper && typeof originalWrapper === "object" && "data" in originalWrapper) return {
        ...originalWrapper,
        data: instrumentedResult
    };
    return instrumentedResult;
}
function $31df9c51c887fe86$var$wrapPromiseWithMethods(originalPromiseLike, instrumentedPromise) {
    if (!$eMfEg.isThenable(originalPromiseLike)) return instrumentedPromise;
    return new Proxy(originalPromiseLike, {
        get (target, prop) {
            const useInstrumentedPromise = prop in Promise.prototype || prop === Symbol.toStringTag;
            const source = useInstrumentedPromise ? instrumentedPromise : target;
            const value = Reflect.get(source, prop);
            if (prop === "withResponse" && typeof value === "function") return function wrappedWithResponse() {
                const originalWithResponse = value.call(target);
                return $31df9c51c887fe86$var$createWithResponseWrapper(originalWithResponse, instrumentedPromise);
            };
            return typeof value === "function" ? value.bind(source) : value;
        }
    });
}
module.exports.buildMethodPath = $31df9c51c887fe86$var$buildMethodPath;
module.exports.endStreamSpan = $31df9c51c887fe86$var$endStreamSpan;
module.exports.extractSystemInstructions = $31df9c51c887fe86$var$extractSystemInstructions;
module.exports.getTruncatedJsonString = $31df9c51c887fe86$var$getTruncatedJsonString;
module.exports.resolveAIRecordingOptions = $31df9c51c887fe86$var$resolveAIRecordingOptions;
module.exports.setTokenUsageAttributes = $31df9c51c887fe86$var$setTokenUsageAttributes;
module.exports.shouldEnableTruncation = $31df9c51c887fe86$var$shouldEnableTruncation;
module.exports.wrapPromiseWithMethods = $31df9c51c887fe86$var$wrapPromiseWithMethods;

});
parcelRegister("9QwBg", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $72b24213621b91b4$var$GEN_AI_PROMPT_ATTRIBUTE = "gen_ai.prompt";
const $72b24213621b91b4$var$GEN_AI_SYSTEM_ATTRIBUTE = "gen_ai.system";
const $72b24213621b91b4$var$GEN_AI_REQUEST_MODEL_ATTRIBUTE = "gen_ai.request.model";
const $72b24213621b91b4$var$GEN_AI_REQUEST_STREAM_ATTRIBUTE = "gen_ai.request.stream";
const $72b24213621b91b4$var$GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE = "gen_ai.request.temperature";
const $72b24213621b91b4$var$GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE = "gen_ai.request.max_tokens";
const $72b24213621b91b4$var$GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE = "gen_ai.request.frequency_penalty";
const $72b24213621b91b4$var$GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE = "gen_ai.request.presence_penalty";
const $72b24213621b91b4$var$GEN_AI_REQUEST_TOP_P_ATTRIBUTE = "gen_ai.request.top_p";
const $72b24213621b91b4$var$GEN_AI_REQUEST_TOP_K_ATTRIBUTE = "gen_ai.request.top_k";
const $72b24213621b91b4$var$GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE = "gen_ai.request.encoding_format";
const $72b24213621b91b4$var$GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE = "gen_ai.request.dimensions";
const $72b24213621b91b4$var$GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE = "gen_ai.response.finish_reasons";
const $72b24213621b91b4$var$GEN_AI_RESPONSE_MODEL_ATTRIBUTE = "gen_ai.response.model";
const $72b24213621b91b4$var$GEN_AI_RESPONSE_ID_ATTRIBUTE = "gen_ai.response.id";
const $72b24213621b91b4$var$GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE = "gen_ai.response.stop_reason";
const $72b24213621b91b4$var$GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.input_tokens";
const $72b24213621b91b4$var$GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.output_tokens";
const $72b24213621b91b4$var$GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE = "gen_ai.usage.total_tokens";
const $72b24213621b91b4$var$GEN_AI_OPERATION_NAME_ATTRIBUTE = "gen_ai.operation.name";
const $72b24213621b91b4$var$GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = "sentry.sdk_meta.gen_ai.input.messages.original_length";
const $72b24213621b91b4$var$GEN_AI_INPUT_MESSAGES_ATTRIBUTE = "gen_ai.input.messages";
const $72b24213621b91b4$var$GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE = "gen_ai.output.messages";
const $72b24213621b91b4$var$GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = "gen_ai.system_instructions";
const $72b24213621b91b4$var$GEN_AI_RESPONSE_TEXT_ATTRIBUTE = "gen_ai.response.text";
const $72b24213621b91b4$var$GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE = "gen_ai.request.available_tools";
const $72b24213621b91b4$var$GEN_AI_RESPONSE_STREAMING_ATTRIBUTE = "gen_ai.response.streaming";
const $72b24213621b91b4$var$GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = "gen_ai.response.tool_calls";
const $72b24213621b91b4$var$GEN_AI_AGENT_NAME_ATTRIBUTE = "gen_ai.agent.name";
const $72b24213621b91b4$var$GEN_AI_PIPELINE_NAME_ATTRIBUTE = "gen_ai.pipeline.name";
const $72b24213621b91b4$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE = "gen_ai.conversation.id";
const $72b24213621b91b4$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.cache_creation_input_tokens";
const $72b24213621b91b4$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.cache_read_input_tokens";
const $72b24213621b91b4$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE = "gen_ai.usage.input_tokens.cache_write";
const $72b24213621b91b4$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE = "gen_ai.usage.input_tokens.cached";
const $72b24213621b91b4$var$GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE = "gen_ai.invoke_agent";
const $72b24213621b91b4$var$GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE = "gen_ai.embeddings.input";
const $72b24213621b91b4$var$GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE = "gen_ai.embeddings";
const $72b24213621b91b4$var$GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE = "gen_ai.execute_tool";
const $72b24213621b91b4$var$GEN_AI_TOOL_NAME_ATTRIBUTE = "gen_ai.tool.name";
const $72b24213621b91b4$var$GEN_AI_TOOL_CALL_ID_ATTRIBUTE = "gen_ai.tool.call.id";
const $72b24213621b91b4$var$GEN_AI_TOOL_TYPE_ATTRIBUTE = "gen_ai.tool.type";
const $72b24213621b91b4$var$GEN_AI_TOOL_INPUT_ATTRIBUTE = "gen_ai.tool.input";
const $72b24213621b91b4$var$GEN_AI_TOOL_OUTPUT_ATTRIBUTE = "gen_ai.tool.output";
const $72b24213621b91b4$var$GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE = "gen_ai.tool.description";
module.exports.GEN_AI_AGENT_NAME_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_AGENT_NAME_ATTRIBUTE;
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE;
module.exports.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_INPUT_MESSAGES_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_INPUT_MESSAGES_ATTRIBUTE;
module.exports.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE;
module.exports.GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_OPERATION_NAME_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_OPERATION_NAME_ATTRIBUTE;
module.exports.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE;
module.exports.GEN_AI_PIPELINE_NAME_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_PIPELINE_NAME_ATTRIBUTE;
module.exports.GEN_AI_PROMPT_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_PROMPT_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_MODEL_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_REQUEST_MODEL_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_STREAM_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_REQUEST_STREAM_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TOP_K_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_REQUEST_TOP_K_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TOP_P_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_REQUEST_TOP_P_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_ID_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_RESPONSE_ID_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_MODEL_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_RESPONSE_MODEL_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_RESPONSE_STREAMING_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_TEXT_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_RESPONSE_TEXT_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_SYSTEM_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE;
module.exports.GEN_AI_TOOL_CALL_ID_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_TOOL_CALL_ID_ATTRIBUTE;
module.exports.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE;
module.exports.GEN_AI_TOOL_INPUT_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_TOOL_INPUT_ATTRIBUTE;
module.exports.GEN_AI_TOOL_NAME_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_TOOL_NAME_ATTRIBUTE;
module.exports.GEN_AI_TOOL_OUTPUT_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_TOOL_OUTPUT_ATTRIBUTE;
module.exports.GEN_AI_TOOL_TYPE_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_TOOL_TYPE_ATTRIBUTE;
module.exports.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE;
module.exports.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE = $72b24213621b91b4$var$GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE;

});

parcelRegister("2wYdH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2dZgI = parcelRequire("2dZgI");
const $1d7d48605e8742a1$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT = 2e4;
const $1d7d48605e8742a1$var$utf8Bytes = (text)=>{
    return new TextEncoder().encode(text).length;
};
const $1d7d48605e8742a1$var$jsonBytes = (value)=>{
    return $1d7d48605e8742a1$var$utf8Bytes(JSON.stringify(value));
};
function $1d7d48605e8742a1$var$truncateTextByBytes(text, maxBytes) {
    if ($1d7d48605e8742a1$var$utf8Bytes(text) <= maxBytes) return text;
    let low = 0;
    let high = text.length;
    let bestFit = "";
    while(low <= high){
        const mid = Math.floor((low + high) / 2);
        const candidate = text.slice(0, mid);
        const byteSize = $1d7d48605e8742a1$var$utf8Bytes(candidate);
        if (byteSize <= maxBytes) {
            bestFit = candidate;
            low = mid + 1;
        } else high = mid - 1;
    }
    return bestFit;
}
function $1d7d48605e8742a1$var$getItemText(item) {
    if (typeof item === "string") return item;
    if ("text" in item && typeof item.text === "string") return item.text;
    return "";
}
function $1d7d48605e8742a1$var$withItemText(item, text) {
    if (typeof item === "string") return text;
    return {
        ...item,
        text: text
    };
}
function $1d7d48605e8742a1$var$isContentMessage(message) {
    return message !== null && typeof message === "object" && "content" in message && typeof message.content === "string";
}
function $1d7d48605e8742a1$var$isContentArrayMessage(message) {
    return message !== null && typeof message === "object" && "content" in message && Array.isArray(message.content);
}
function $1d7d48605e8742a1$var$isPartsMessage(message) {
    return message !== null && typeof message === "object" && "parts" in message && Array.isArray(message.parts) && message.parts.length > 0;
}
function $1d7d48605e8742a1$var$truncateContentMessage(message, maxBytes) {
    const emptyMessage = {
        ...message,
        content: ""
    };
    const overhead = $1d7d48605e8742a1$var$jsonBytes(emptyMessage);
    const availableForContent = maxBytes - overhead;
    if (availableForContent <= 0) return [];
    const truncatedContent = $1d7d48605e8742a1$var$truncateTextByBytes(message.content, availableForContent);
    return [
        {
            ...message,
            content: truncatedContent
        }
    ];
}
function $1d7d48605e8742a1$var$getArrayItems(message) {
    if ("parts" in message && Array.isArray(message.parts)) return {
        key: "parts",
        items: message.parts
    };
    if ("content" in message && Array.isArray(message.content)) return {
        key: "content",
        items: message.content
    };
    return {
        key: null,
        items: []
    };
}
function $1d7d48605e8742a1$var$truncateArrayMessage(message, maxBytes) {
    const { key: key, items: items } = $1d7d48605e8742a1$var$getArrayItems(message);
    if (key === null || items.length === 0) return [];
    const emptyItems = items.map((item)=>$1d7d48605e8742a1$var$withItemText(item, ""));
    const overhead = $1d7d48605e8742a1$var$jsonBytes({
        ...message,
        [key]: emptyItems
    });
    let remainingBytes = maxBytes - overhead;
    if (remainingBytes <= 0) return [];
    const includedItems = [];
    for (const item of items){
        const text = $1d7d48605e8742a1$var$getItemText(item);
        const textSize = $1d7d48605e8742a1$var$utf8Bytes(text);
        if (textSize <= remainingBytes) {
            includedItems.push(item);
            remainingBytes -= textSize;
        } else if (includedItems.length === 0) {
            const truncated = $1d7d48605e8742a1$var$truncateTextByBytes(text, remainingBytes);
            if (truncated) includedItems.push($1d7d48605e8742a1$var$withItemText(item, truncated));
            break;
        } else break;
    }
    if (includedItems.length <= 0) return [];
    else return [
        {
            ...message,
            [key]: includedItems
        }
    ];
}
function $1d7d48605e8742a1$var$truncateSingleMessage(message, maxBytes) {
    if (!message) return [];
    if (typeof message === "string") {
        const truncated = $1d7d48605e8742a1$var$truncateTextByBytes(message, maxBytes);
        return truncated ? [
            truncated
        ] : [];
    }
    if (typeof message !== "object") return [];
    if ($1d7d48605e8742a1$var$isContentMessage(message)) return $1d7d48605e8742a1$var$truncateContentMessage(message, maxBytes);
    if ($1d7d48605e8742a1$var$isContentArrayMessage(message) || $1d7d48605e8742a1$var$isPartsMessage(message)) return $1d7d48605e8742a1$var$truncateArrayMessage(message, maxBytes);
    return [];
}
function $1d7d48605e8742a1$var$stripInlineMediaFromMessages(messages) {
    const stripped = messages.map((message)=>{
        let newMessage = void 0;
        if (!!message && typeof message === "object") {
            if ($1d7d48605e8742a1$var$isContentArrayMessage(message)) newMessage = {
                ...message,
                content: $1d7d48605e8742a1$var$stripInlineMediaFromMessages(message.content)
            };
            else if ("content" in message && $2dZgI.isContentMedia(message.content)) newMessage = {
                ...message,
                content: $2dZgI.stripInlineMediaFromSingleMessage(message.content)
            };
            if ($1d7d48605e8742a1$var$isPartsMessage(message)) newMessage = {
                // might have to strip content AND parts
                ...newMessage ?? message,
                parts: $1d7d48605e8742a1$var$stripInlineMediaFromMessages(message.parts)
            };
            if ($2dZgI.isContentMedia(newMessage)) newMessage = $2dZgI.stripInlineMediaFromSingleMessage(newMessage);
            else if ($2dZgI.isContentMedia(message)) newMessage = $2dZgI.stripInlineMediaFromSingleMessage(message);
        }
        return newMessage ?? message;
    });
    return stripped;
}
function $1d7d48605e8742a1$var$truncateMessagesByBytes(messages, maxBytes) {
    if (!Array.isArray(messages) || messages.length === 0) return messages;
    const effectiveMaxBytes = maxBytes - 2;
    const lastMessage = messages[messages.length - 1];
    const stripped = $1d7d48605e8742a1$var$stripInlineMediaFromMessages([
        lastMessage
    ]);
    const strippedMessage = stripped[0];
    const messageBytes = $1d7d48605e8742a1$var$jsonBytes(strippedMessage);
    if (messageBytes <= effectiveMaxBytes) return stripped;
    return $1d7d48605e8742a1$var$truncateSingleMessage(strippedMessage, effectiveMaxBytes);
}
function $1d7d48605e8742a1$var$truncateGenAiMessages(messages) {
    return $1d7d48605e8742a1$var$truncateMessagesByBytes(messages, $1d7d48605e8742a1$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
}
function $1d7d48605e8742a1$var$truncateGenAiStringInput(input) {
    return $1d7d48605e8742a1$var$truncateTextByBytes(input, $1d7d48605e8742a1$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
}
module.exports.DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT = $1d7d48605e8742a1$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT;
module.exports.truncateGenAiMessages = $1d7d48605e8742a1$var$truncateGenAiMessages;
module.exports.truncateGenAiStringInput = $1d7d48605e8742a1$var$truncateGenAiStringInput;

});
parcelRegister("2dZgI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $19ec5253ca5446b6$var$isContentMedia(part) {
    if (!part || typeof part !== "object") return false;
    return $19ec5253ca5446b6$var$isContentMediaSource(part) || $19ec5253ca5446b6$var$hasInlineData(part) || $19ec5253ca5446b6$var$hasImageUrl(part) || $19ec5253ca5446b6$var$hasInputAudio(part) || $19ec5253ca5446b6$var$hasFileData(part) || $19ec5253ca5446b6$var$hasMediaTypeData(part) || $19ec5253ca5446b6$var$hasVercelFileData(part) || $19ec5253ca5446b6$var$hasVercelImageData(part) || $19ec5253ca5446b6$var$hasBlobOrBase64Type(part) || $19ec5253ca5446b6$var$hasB64Json(part) || $19ec5253ca5446b6$var$hasImageGenerationResult(part) || $19ec5253ca5446b6$var$hasDataUri(part);
}
function $19ec5253ca5446b6$var$hasImageUrl(part) {
    if (!("image_url" in part)) return false;
    if (typeof part.image_url === "string") return part.image_url.startsWith("data:");
    return $19ec5253ca5446b6$var$hasNestedImageUrl(part);
}
function $19ec5253ca5446b6$var$hasNestedImageUrl(part) {
    return "image_url" in part && !!part.image_url && typeof part.image_url === "object" && "url" in part.image_url && typeof part.image_url.url === "string" && part.image_url.url.startsWith("data:");
}
function $19ec5253ca5446b6$var$isContentMediaSource(part) {
    return "type" in part && typeof part.type === "string" && "source" in part && $19ec5253ca5446b6$var$isContentMedia(part.source);
}
function $19ec5253ca5446b6$var$hasInlineData(part) {
    return "inlineData" in part && !!part.inlineData && typeof part.inlineData === "object" && "data" in part.inlineData && typeof part.inlineData.data === "string";
}
function $19ec5253ca5446b6$var$hasInputAudio(part) {
    return "type" in part && part.type === "input_audio" && "input_audio" in part && !!part.input_audio && typeof part.input_audio === "object" && "data" in part.input_audio && typeof part.input_audio.data === "string";
}
function $19ec5253ca5446b6$var$hasFileData(part) {
    return "type" in part && part.type === "file" && "file" in part && !!part.file && typeof part.file === "object" && "file_data" in part.file && typeof part.file.file_data === "string";
}
function $19ec5253ca5446b6$var$hasMediaTypeData(part) {
    return "media_type" in part && typeof part.media_type === "string" && "data" in part;
}
function $19ec5253ca5446b6$var$hasVercelFileData(part) {
    return "type" in part && part.type === "file" && "mediaType" in part && typeof part.mediaType === "string" && "data" in part && typeof part.data === "string" && // Only strip base64/binary data, not HTTP/HTTPS URLs which should be preserved as references
    !part.data.startsWith("http://") && !part.data.startsWith("https://");
}
function $19ec5253ca5446b6$var$hasVercelImageData(part) {
    return "type" in part && part.type === "image" && "image" in part && typeof part.image === "string" && // Only strip base64/data URIs, not HTTP/HTTPS URLs which should be preserved as references
    !part.image.startsWith("http://") && !part.image.startsWith("https://");
}
function $19ec5253ca5446b6$var$hasBlobOrBase64Type(part) {
    return "type" in part && (part.type === "blob" || part.type === "base64");
}
function $19ec5253ca5446b6$var$hasB64Json(part) {
    return "b64_json" in part;
}
function $19ec5253ca5446b6$var$hasImageGenerationResult(part) {
    return "type" in part && "result" in part && part.type === "image_generation";
}
function $19ec5253ca5446b6$var$hasDataUri(part) {
    return "uri" in part && typeof part.uri === "string" && part.uri.startsWith("data:");
}
const $19ec5253ca5446b6$var$REMOVED_STRING = "[Blob substitute]";
const $19ec5253ca5446b6$var$MEDIA_FIELDS = [
    "image_url",
    "data",
    "content",
    "b64_json",
    "result",
    "uri",
    "image"
];
function $19ec5253ca5446b6$var$stripInlineMediaFromSingleMessage(part) {
    const strip = {
        ...part
    };
    if ($19ec5253ca5446b6$var$isContentMedia(strip.source)) strip.source = $19ec5253ca5446b6$var$stripInlineMediaFromSingleMessage(strip.source);
    if ($19ec5253ca5446b6$var$hasInlineData(part)) strip.inlineData = {
        ...part.inlineData,
        data: $19ec5253ca5446b6$var$REMOVED_STRING
    };
    if ($19ec5253ca5446b6$var$hasNestedImageUrl(part)) strip.image_url = {
        ...part.image_url,
        url: $19ec5253ca5446b6$var$REMOVED_STRING
    };
    if ($19ec5253ca5446b6$var$hasInputAudio(part)) strip.input_audio = {
        ...part.input_audio,
        data: $19ec5253ca5446b6$var$REMOVED_STRING
    };
    if ($19ec5253ca5446b6$var$hasFileData(part)) strip.file = {
        ...part.file,
        file_data: $19ec5253ca5446b6$var$REMOVED_STRING
    };
    for (const field of $19ec5253ca5446b6$var$MEDIA_FIELDS)if (typeof strip[field] === "string") strip[field] = $19ec5253ca5446b6$var$REMOVED_STRING;
    return strip;
}
module.exports.isContentMedia = $19ec5253ca5446b6$var$isContentMedia;
module.exports.stripInlineMediaFromSingleMessage = $19ec5253ca5446b6$var$stripInlineMediaFromSingleMessage;

});



parcelRegister("4GqxV", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $368fad336848eed1$var$WORKERS_AI_PROVIDER_NAME = "cloudflare.workers_ai";
const $368fad336848eed1$var$WORKERS_AI_ORIGIN = "auto.ai.cloudflare.workers_ai";
const $368fad336848eed1$var$WORKERS_AI_INTEGRATION_NAME = "WorkersAI";
module.exports.WORKERS_AI_INTEGRATION_NAME = $368fad336848eed1$var$WORKERS_AI_INTEGRATION_NAME;
module.exports.WORKERS_AI_ORIGIN = $368fad336848eed1$var$WORKERS_AI_ORIGIN;
module.exports.WORKERS_AI_PROVIDER_NAME = $368fad336848eed1$var$WORKERS_AI_PROVIDER_NAME;

});

parcelRegister("6WjYJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $50d7a82fc002237b$var$toolCallSpanContextMap = /* @__PURE__ */ new Map();
const $50d7a82fc002237b$var$toolDescriptionMap = /* @__PURE__ */ new Map();
const $50d7a82fc002237b$var$SPAN_TO_OPERATION_NAME = /* @__PURE__ */ new Map([
    [
        "ai.generateText",
        "invoke_agent"
    ],
    [
        "ai.streamText",
        "invoke_agent"
    ],
    [
        "ai.generateObject",
        "invoke_agent"
    ],
    [
        "ai.streamObject",
        "invoke_agent"
    ],
    [
        "ai.generateText.doGenerate",
        "generate_content"
    ],
    [
        "ai.streamText.doStream",
        "generate_content"
    ],
    [
        "ai.generateObject.doGenerate",
        "generate_content"
    ],
    [
        "ai.streamObject.doStream",
        "generate_content"
    ],
    [
        "ai.embed.doEmbed",
        "embeddings"
    ],
    [
        "ai.embedMany.doEmbed",
        "embeddings"
    ],
    [
        "ai.rerank.doRerank",
        "rerank"
    ],
    [
        "ai.toolCall",
        "execute_tool"
    ]
]);
module.exports.SPAN_TO_OPERATION_NAME = $50d7a82fc002237b$var$SPAN_TO_OPERATION_NAME;
module.exports.toolCallSpanContextMap = $50d7a82fc002237b$var$toolCallSpanContextMap;
module.exports.toolDescriptionMap = $50d7a82fc002237b$var$toolDescriptionMap;

});

parcelRegister("9dzpp", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9QwBg = parcelRequire("9QwBg");

var $4htth = parcelRequire("4htth");

var $erV30 = parcelRequire("erV30");

var $6WjYJ = parcelRequire("6WjYJ");

var $7Pjqz = parcelRequire("7Pjqz");
function $6b60cb6c88415cb7$var$accumulateTokensForParent(span, tokenAccumulator) {
    const parentSpanId = span.parent_span_id;
    if (!parentSpanId) return;
    const inputTokens = span.data[$9QwBg.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE];
    const outputTokens = span.data[$9QwBg.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE];
    if (typeof inputTokens === "number" || typeof outputTokens === "number") {
        const existing = tokenAccumulator.get(parentSpanId) || {
            inputTokens: 0,
            outputTokens: 0
        };
        if (typeof inputTokens === "number") existing.inputTokens += inputTokens;
        if (typeof outputTokens === "number") existing.outputTokens += outputTokens;
        tokenAccumulator.set(parentSpanId, existing);
    }
}
function $6b60cb6c88415cb7$var$applyAccumulatedTokens(spanOrTrace, tokenAccumulator) {
    const accumulated = tokenAccumulator.get(spanOrTrace.span_id);
    if (!accumulated || !spanOrTrace.data) return;
    if (accumulated.inputTokens > 0) spanOrTrace.data[$9QwBg.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = accumulated.inputTokens;
    if (accumulated.outputTokens > 0) spanOrTrace.data[$9QwBg.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = accumulated.outputTokens;
    if (accumulated.inputTokens > 0 || accumulated.outputTokens > 0) spanOrTrace.data["gen_ai.usage.total_tokens"] = accumulated.inputTokens + accumulated.outputTokens;
}
function $6b60cb6c88415cb7$var$buildToolDescriptionMap(spans) {
    const toolDescriptions = /* @__PURE__ */ new Map();
    for (const span of spans){
        const availableTools = span.data[$9QwBg.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE];
        if (typeof availableTools !== "string") continue;
        try {
            const tools = JSON.parse(availableTools);
            for (const tool of tools)if (tool.name && tool.description && !toolDescriptions.has(tool.name)) toolDescriptions.set(tool.name, tool.description);
        } catch  {}
    }
    return toolDescriptions;
}
function $6b60cb6c88415cb7$var$applyToolDescriptionsAndTokens(spans, tokenAccumulator) {
    const toolDescriptions = $6b60cb6c88415cb7$var$buildToolDescriptionMap(spans);
    for (const span of spans){
        if (span.op === "gen_ai.execute_tool") {
            const toolName = span.data[$9QwBg.GEN_AI_TOOL_NAME_ATTRIBUTE];
            if (typeof toolName === "string") {
                const description = toolDescriptions.get(toolName);
                if (description) span.data[$9QwBg.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = description;
            }
        }
        if (span.op === "gen_ai.invoke_agent") $6b60cb6c88415cb7$var$applyAccumulatedTokens(span, tokenAccumulator);
    }
}
function $6b60cb6c88415cb7$var$_INTERNAL_getSpanContextForToolCallId(toolCallId) {
    return $6WjYJ.toolCallSpanContextMap.get(toolCallId);
}
function $6b60cb6c88415cb7$var$_INTERNAL_cleanupToolCallSpanContext(toolCallId) {
    $6WjYJ.toolCallSpanContextMap.delete(toolCallId);
}
function $6b60cb6c88415cb7$var$convertAvailableToolsToJsonString(tools) {
    const toolObjects = tools.map((tool)=>{
        if (typeof tool === "string") try {
            return JSON.parse(tool);
        } catch  {
            return tool;
        }
        return tool;
    });
    return JSON.stringify(toolObjects);
}
function $6b60cb6c88415cb7$var$filterMessagesArray(input) {
    return input.filter((m)=>!!m && typeof m === "object" && "role" in m && "content" in m);
}
function $6b60cb6c88415cb7$var$convertUserInputToMessagesFormat(userInput) {
    try {
        const p = JSON.parse(userInput);
        if (!!p && typeof p === "object") {
            let { messages: messages } = p;
            const { prompt: prompt, system: system } = p;
            const result = [];
            if (typeof system === "string") result.push({
                role: "system",
                content: system
            });
            if (typeof messages === "string") try {
                messages = JSON.parse(messages);
            } catch  {}
            if (Array.isArray(messages)) {
                result.push(...$6b60cb6c88415cb7$var$filterMessagesArray(messages));
                return result;
            }
            if (Array.isArray(prompt)) {
                result.push(...$6b60cb6c88415cb7$var$filterMessagesArray(prompt));
                return result;
            }
            if (typeof prompt === "string") result.push({
                role: "user",
                content: prompt
            });
            if (result.length > 0) return result;
        }
    } catch  {}
    return [];
}
function $6b60cb6c88415cb7$var$requestMessagesFromPrompt(span, attributes, enableTruncation) {
    if (typeof attributes[$7Pjqz.AI_PROMPT_ATTRIBUTE] === "string" && !attributes[$9QwBg.GEN_AI_INPUT_MESSAGES_ATTRIBUTE] && !attributes[$7Pjqz.AI_PROMPT_MESSAGES_ATTRIBUTE]) {
        const userInput = attributes[$7Pjqz.AI_PROMPT_ATTRIBUTE];
        const messages = $6b60cb6c88415cb7$var$convertUserInputToMessagesFormat(userInput);
        if (messages.length) {
            const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $4htth.extractSystemInstructions(messages);
            if (systemInstructions) span.setAttribute($9QwBg.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
            const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
            const messagesJson = enableTruncation ? $4htth.getTruncatedJsonString(filteredMessages) : $erV30.stringify(filteredMessages);
            span.setAttributes({
                [$7Pjqz.AI_PROMPT_ATTRIBUTE]: messagesJson,
                [$9QwBg.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: messagesJson,
                [$9QwBg.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
            });
        }
    } else if (typeof attributes[$7Pjqz.AI_PROMPT_MESSAGES_ATTRIBUTE] === "string") {
        const originalMessagesJson = attributes[$7Pjqz.AI_PROMPT_MESSAGES_ATTRIBUTE];
        try {
            const messages = JSON.parse(originalMessagesJson);
            if (Array.isArray(messages)) {
                const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $4htth.extractSystemInstructions(messages);
                if (systemInstructions) span.setAttribute($9QwBg.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
                const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
                const messagesJson = !enableTruncation && filteredMessages === messages ? originalMessagesJson : enableTruncation ? $4htth.getTruncatedJsonString(filteredMessages) : $erV30.stringify(filteredMessages);
                span.setAttributes({
                    [$7Pjqz.AI_PROMPT_MESSAGES_ATTRIBUTE]: messagesJson,
                    [$9QwBg.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: messagesJson,
                    [$9QwBg.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
                });
            }
        } catch  {}
    }
}
module.exports._INTERNAL_cleanupToolCallSpanContext = $6b60cb6c88415cb7$var$_INTERNAL_cleanupToolCallSpanContext;
module.exports._INTERNAL_getSpanContextForToolCallId = $6b60cb6c88415cb7$var$_INTERNAL_getSpanContextForToolCallId;
module.exports.accumulateTokensForParent = $6b60cb6c88415cb7$var$accumulateTokensForParent;
module.exports.applyAccumulatedTokens = $6b60cb6c88415cb7$var$applyAccumulatedTokens;
module.exports.applyToolDescriptionsAndTokens = $6b60cb6c88415cb7$var$applyToolDescriptionsAndTokens;
module.exports.convertAvailableToolsToJsonString = $6b60cb6c88415cb7$var$convertAvailableToolsToJsonString;
module.exports.convertUserInputToMessagesFormat = $6b60cb6c88415cb7$var$convertUserInputToMessagesFormat;
module.exports.requestMessagesFromPrompt = $6b60cb6c88415cb7$var$requestMessagesFromPrompt;

});
parcelRegister("7Pjqz", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $5b2c5dbef749ddfc$var$OPERATION_NAME_ATTRIBUTE = "operation.name";
const $5b2c5dbef749ddfc$var$AI_OPERATION_ID_ATTRIBUTE = "ai.operationId";
const $5b2c5dbef749ddfc$var$AI_PROMPT_ATTRIBUTE = "ai.prompt";
const $5b2c5dbef749ddfc$var$AI_SCHEMA_ATTRIBUTE = "ai.schema";
const $5b2c5dbef749ddfc$var$AI_RESPONSE_OBJECT_ATTRIBUTE = "ai.response.object";
const $5b2c5dbef749ddfc$var$AI_VALUES_ATTRIBUTE = "ai.values";
const $5b2c5dbef749ddfc$var$AI_RESPONSE_TEXT_ATTRIBUTE = "ai.response.text";
const $5b2c5dbef749ddfc$var$AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = "ai.response.toolCalls";
const $5b2c5dbef749ddfc$var$AI_RESPONSE_FINISH_REASON_ATTRIBUTE = "ai.response.finishReason";
const $5b2c5dbef749ddfc$var$AI_PROMPT_MESSAGES_ATTRIBUTE = "ai.prompt.messages";
const $5b2c5dbef749ddfc$var$AI_PROMPT_TOOLS_ATTRIBUTE = "ai.prompt.tools";
const $5b2c5dbef749ddfc$var$AI_MODEL_ID_ATTRIBUTE = "ai.model.id";
const $5b2c5dbef749ddfc$var$AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE = "ai.response.providerMetadata";
const $5b2c5dbef749ddfc$var$AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE = "ai.usage.cachedInputTokens";
const $5b2c5dbef749ddfc$var$AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX = "ai.usage.inputTokenDetails.";
const $5b2c5dbef749ddfc$var$AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE = "ai.telemetry.functionId";
const $5b2c5dbef749ddfc$var$AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE = "ai.usage.completionTokens";
const $5b2c5dbef749ddfc$var$AI_USAGE_PROMPT_TOKENS_ATTRIBUTE = "ai.usage.promptTokens";
const $5b2c5dbef749ddfc$var$AI_USAGE_TOKENS_ATTRIBUTE = "ai.usage.tokens";
const $5b2c5dbef749ddfc$var$AI_TOOL_CALL_NAME_ATTRIBUTE = "ai.toolCall.name";
const $5b2c5dbef749ddfc$var$AI_TOOL_CALL_ID_ATTRIBUTE = "ai.toolCall.id";
const $5b2c5dbef749ddfc$var$AI_TOOL_CALL_ARGS_ATTRIBUTE = "ai.toolCall.args";
const $5b2c5dbef749ddfc$var$AI_TOOL_CALL_RESULT_ATTRIBUTE = "ai.toolCall.result";
module.exports.AI_MODEL_ID_ATTRIBUTE = $5b2c5dbef749ddfc$var$AI_MODEL_ID_ATTRIBUTE;
module.exports.AI_OPERATION_ID_ATTRIBUTE = $5b2c5dbef749ddfc$var$AI_OPERATION_ID_ATTRIBUTE;
module.exports.AI_PROMPT_ATTRIBUTE = $5b2c5dbef749ddfc$var$AI_PROMPT_ATTRIBUTE;
module.exports.AI_PROMPT_MESSAGES_ATTRIBUTE = $5b2c5dbef749ddfc$var$AI_PROMPT_MESSAGES_ATTRIBUTE;
module.exports.AI_PROMPT_TOOLS_ATTRIBUTE = $5b2c5dbef749ddfc$var$AI_PROMPT_TOOLS_ATTRIBUTE;
module.exports.AI_RESPONSE_FINISH_REASON_ATTRIBUTE = $5b2c5dbef749ddfc$var$AI_RESPONSE_FINISH_REASON_ATTRIBUTE;
module.exports.AI_RESPONSE_OBJECT_ATTRIBUTE = $5b2c5dbef749ddfc$var$AI_RESPONSE_OBJECT_ATTRIBUTE;
module.exports.AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE = $5b2c5dbef749ddfc$var$AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE;
module.exports.AI_RESPONSE_TEXT_ATTRIBUTE = $5b2c5dbef749ddfc$var$AI_RESPONSE_TEXT_ATTRIBUTE;
module.exports.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = $5b2c5dbef749ddfc$var$AI_RESPONSE_TOOL_CALLS_ATTRIBUTE;
module.exports.AI_SCHEMA_ATTRIBUTE = $5b2c5dbef749ddfc$var$AI_SCHEMA_ATTRIBUTE;
module.exports.AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE = $5b2c5dbef749ddfc$var$AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE;
module.exports.AI_TOOL_CALL_ARGS_ATTRIBUTE = $5b2c5dbef749ddfc$var$AI_TOOL_CALL_ARGS_ATTRIBUTE;
module.exports.AI_TOOL_CALL_ID_ATTRIBUTE = $5b2c5dbef749ddfc$var$AI_TOOL_CALL_ID_ATTRIBUTE;
module.exports.AI_TOOL_CALL_NAME_ATTRIBUTE = $5b2c5dbef749ddfc$var$AI_TOOL_CALL_NAME_ATTRIBUTE;
module.exports.AI_TOOL_CALL_RESULT_ATTRIBUTE = $5b2c5dbef749ddfc$var$AI_TOOL_CALL_RESULT_ATTRIBUTE;
module.exports.AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE = $5b2c5dbef749ddfc$var$AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE = $5b2c5dbef749ddfc$var$AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX = $5b2c5dbef749ddfc$var$AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX;
module.exports.AI_USAGE_PROMPT_TOKENS_ATTRIBUTE = $5b2c5dbef749ddfc$var$AI_USAGE_PROMPT_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_TOKENS_ATTRIBUTE = $5b2c5dbef749ddfc$var$AI_USAGE_TOKENS_ATTRIBUTE;
module.exports.AI_VALUES_ATTRIBUTE = $5b2c5dbef749ddfc$var$AI_VALUES_ATTRIBUTE;
module.exports.OPERATION_NAME_ATTRIBUTE = $5b2c5dbef749ddfc$var$OPERATION_NAME_ATTRIBUTE;

});



parcelRegister("fJO1p", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9Yejo = parcelRequire("9Yejo");

var $dknph = parcelRequire("dknph");

var $1UPRv = parcelRequire("1UPRv");

var $erV30 = parcelRequire("erV30");

var $3su1E = parcelRequire("3su1E");

var $d7AD6 = parcelRequire("d7AD6");

var $9QwBg = parcelRequire("9QwBg");

var $4htth = parcelRequire("4htth");

var $lQTuS = parcelRequire("lQTuS");

var $1tLsV = parcelRequire("1tLsV");

var $df0Nw = parcelRequire("df0Nw");
function $b751dc4431124774$var$extractAvailableTools(params) {
    const tools = Array.isArray(params.tools) ? params.tools : [];
    const hasWebSearchOptions = params.web_search_options && typeof params.web_search_options === "object";
    const webSearchOptions = hasWebSearchOptions ? [
        {
            type: "web_search_options",
            ...params.web_search_options
        }
    ] : [];
    const availableTools = [
        ...tools,
        ...webSearchOptions
    ];
    if (availableTools.length === 0) return void 0;
    try {
        return JSON.stringify(availableTools);
    } catch (error) {
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.error("Failed to serialize OpenAI tools:", error);
        return void 0;
    }
}
function $b751dc4431124774$var$extractRequestAttributes(args, operationName) {
    const attributes = {
        [$9QwBg.GEN_AI_SYSTEM_ATTRIBUTE]: "openai",
        [$9QwBg.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.openai"
    };
    if (args.length > 0 && typeof args[0] === "object" && args[0] !== null) {
        const params = args[0];
        const availableTools = $b751dc4431124774$var$extractAvailableTools(params);
        if (availableTools) attributes[$9QwBg.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = availableTools;
        Object.assign(attributes, $df0Nw.extractRequestParameters(params));
    } else attributes[$9QwBg.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = "unknown";
    return attributes;
}
function $b751dc4431124774$var$addRequestAttributes(span, params, operationName, enableTruncation) {
    if (operationName === "embeddings" && "input" in params) {
        const input = params.input;
        if (input == null) return;
        if (typeof input === "string" && input.length === 0) return;
        if (Array.isArray(input) && input.length === 0) return;
        span.setAttribute($9QwBg.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE, typeof input === "string" ? input : JSON.stringify(input));
        return;
    }
    const src = "input" in params ? params.input : "messages" in params ? params.messages : void 0;
    if (!src) return;
    if (Array.isArray(src) && src.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $4htth.extractSystemInstructions(src);
    if (systemInstructions) span.setAttribute($9QwBg.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
    span.setAttribute($9QwBg.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $4htth.getTruncatedJsonString(filteredMessages) : $erV30.stringify(filteredMessages));
    if (Array.isArray(filteredMessages)) span.setAttribute($9QwBg.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, filteredMessages.length);
    else span.setAttribute($9QwBg.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, 1);
}
function $b751dc4431124774$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    return function instrumentedCall(...args) {
        const operationName = instrumentedMethod.operation || "unknown";
        const requestAttributes = $b751dc4431124774$var$extractRequestAttributes(args, operationName);
        const model = requestAttributes[$9QwBg.GEN_AI_REQUEST_MODEL_ATTRIBUTE] || "unknown";
        const params = args[0];
        const isStreamRequested = params && typeof params === "object" && params.stream === true;
        const spanConfig = {
            name: `${operationName} ${model}`,
            op: `gen_ai.${operationName}`,
            attributes: requestAttributes
        };
        if (isStreamRequested) {
            let originalResult2;
            const instrumentedPromise2 = $d7AD6.startSpanManual(spanConfig, (span)=>{
                originalResult2 = originalMethod.apply(context, args);
                if (options.recordInputs && params) $b751dc4431124774$var$addRequestAttributes(span, params, operationName, $4htth.shouldEnableTruncation(options.enableTruncation));
                return (async ()=>{
                    try {
                        const result = await originalResult2;
                        return $1tLsV.instrumentStream(result, span, options.recordOutputs ?? false);
                    } catch (error) {
                        span.setStatus({
                            code: $3su1E.SPAN_STATUS_ERROR,
                            message: "internal_error"
                        });
                        span.end();
                        throw error;
                    }
                })();
            });
            return $4htth.wrapPromiseWithMethods(originalResult2, instrumentedPromise2);
        }
        let originalResult;
        const instrumentedPromise = $d7AD6.startSpan(spanConfig, (span)=>{
            originalResult = originalMethod.apply(context, args);
            if (options.recordInputs && params) $b751dc4431124774$var$addRequestAttributes(span, params, operationName, $4htth.shouldEnableTruncation(options.enableTruncation));
            return originalResult.then((result)=>{
                $df0Nw.addResponseAttributes(span, result, options.recordOutputs);
                return result;
            });
        });
        return $4htth.wrapPromiseWithMethods(originalResult, instrumentedPromise);
    };
}
function $b751dc4431124774$var$createDeepProxy(target, currentPath = "", options) {
    return new Proxy(target, {
        get (obj, prop) {
            const value = obj[prop];
            const methodPath = $4htth.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $lQTuS.OPENAI_METHOD_REGISTRY[methodPath];
            if (typeof value === "function" && instrumentedMethod) return $b751dc4431124774$var$instrumentMethod(value, methodPath, instrumentedMethod, obj, options);
            if (typeof value === "function") return value.bind(obj);
            if (value && typeof value === "object") return $b751dc4431124774$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
function $b751dc4431124774$var$instrumentOpenAiClient(client, options) {
    return $b751dc4431124774$var$createDeepProxy(client, "", $4htth.resolveAIRecordingOptions(options));
}
module.exports.addRequestAttributes = $b751dc4431124774$var$addRequestAttributes;
module.exports.extractRequestAttributes = $b751dc4431124774$var$extractRequestAttributes;
module.exports.instrumentOpenAiClient = $b751dc4431124774$var$instrumentOpenAiClient;

});
parcelRegister("lQTuS", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $fe8980d56ce486c6$var$OPENAI_INTEGRATION_NAME = "OpenAI";
const $fe8980d56ce486c6$var$OPENAI_METHOD_REGISTRY = {
    "responses.create": {
        operation: "chat"
    },
    "chat.completions.create": {
        operation: "chat"
    },
    "embeddings.create": {
        operation: "embeddings"
    },
    // Conversations API - for conversation state management
    // https://platform.openai.com/docs/guides/conversation-state
    "conversations.create": {
        operation: "chat"
    }
};
const $fe8980d56ce486c6$var$RESPONSES_TOOL_CALL_EVENT_TYPES = [
    "response.output_item.added",
    "response.function_call_arguments.delta",
    "response.function_call_arguments.done",
    "response.output_item.done"
];
const $fe8980d56ce486c6$var$RESPONSE_EVENT_TYPES = [
    "response.created",
    "response.in_progress",
    "response.failed",
    "response.completed",
    "response.incomplete",
    "response.queued",
    "response.output_text.delta",
    ...$fe8980d56ce486c6$var$RESPONSES_TOOL_CALL_EVENT_TYPES
];
module.exports.OPENAI_INTEGRATION_NAME = $fe8980d56ce486c6$var$OPENAI_INTEGRATION_NAME;
module.exports.OPENAI_METHOD_REGISTRY = $fe8980d56ce486c6$var$OPENAI_METHOD_REGISTRY;
module.exports.RESPONSES_TOOL_CALL_EVENT_TYPES = $fe8980d56ce486c6$var$RESPONSES_TOOL_CALL_EVENT_TYPES;
module.exports.RESPONSE_EVENT_TYPES = $fe8980d56ce486c6$var$RESPONSE_EVENT_TYPES;

});

parcelRegister("1tLsV", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $i98W3 = parcelRequire("i98W3");

var $3su1E = parcelRequire("3su1E");

var $4htth = parcelRequire("4htth");

var $lQTuS = parcelRequire("lQTuS");

var $df0Nw = parcelRequire("df0Nw");
function $113d518abb61fa05$var$processChatCompletionToolCalls(toolCalls, state) {
    for (const toolCall of toolCalls){
        const index = toolCall.index;
        if (index === void 0 || !toolCall.function) continue;
        if (!(index in state.chatCompletionToolCalls)) state.chatCompletionToolCalls[index] = {
            ...toolCall,
            function: {
                name: toolCall.function.name,
                arguments: toolCall.function.arguments || ""
            }
        };
        else {
            const existingToolCall = state.chatCompletionToolCalls[index];
            if (toolCall.function.arguments && existingToolCall?.function) existingToolCall.function.arguments += toolCall.function.arguments;
        }
    }
}
function $113d518abb61fa05$var$processChatCompletionChunk(chunk, state, recordOutputs) {
    state.responseId = chunk.id ?? state.responseId;
    state.responseModel = chunk.model ?? state.responseModel;
    if (chunk.usage) {
        state.promptTokens = chunk.usage.prompt_tokens;
        state.completionTokens = chunk.usage.completion_tokens;
        state.totalTokens = chunk.usage.total_tokens;
    }
    for (const choice of chunk.choices ?? []){
        if (recordOutputs) {
            if (choice.delta?.content) state.responseTexts.push(choice.delta.content);
            if (choice.delta?.tool_calls) $113d518abb61fa05$var$processChatCompletionToolCalls(choice.delta.tool_calls, state);
        }
        if (choice.finish_reason) state.finishReasons.push(choice.finish_reason);
    }
}
function $113d518abb61fa05$var$processResponsesApiEvent(streamEvent, state, recordOutputs, span) {
    if (!(streamEvent && typeof streamEvent === "object")) {
        state.eventTypes.push("unknown:non-object");
        return;
    }
    if (streamEvent instanceof Error) {
        span.setStatus({
            code: $3su1E.SPAN_STATUS_ERROR,
            message: "internal_error"
        });
        $i98W3.captureException(streamEvent, {
            mechanism: {
                handled: false,
                type: "auto.ai.openai.stream-response"
            }
        });
        return;
    }
    if (!("type" in streamEvent)) return;
    const event = streamEvent;
    if (!$lQTuS.RESPONSE_EVENT_TYPES.includes(event.type)) {
        state.eventTypes.push(event.type);
        return;
    }
    if (recordOutputs) {
        if (event.type === "response.output_item.done" && "item" in event) state.responsesApiToolCalls.push(event.item);
        if (event.type === "response.output_text.delta" && "delta" in event && event.delta) {
            state.responseTexts.push(event.delta);
            return;
        }
    }
    if ("response" in event) {
        const { response: response } = event;
        state.responseId = response.id ?? state.responseId;
        state.responseModel = response.model ?? state.responseModel;
        if (response.usage) {
            state.promptTokens = response.usage.input_tokens;
            state.completionTokens = response.usage.output_tokens;
            state.totalTokens = response.usage.total_tokens;
        }
        if (response.status) state.finishReasons.push(response.status);
        if (recordOutputs && response.output_text) state.responseTexts.push(response.output_text);
    }
}
async function* $113d518abb61fa05$var$instrumentStream(stream, span, recordOutputs) {
    const state = {
        eventTypes: [],
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: void 0,
        completionTokens: void 0,
        totalTokens: void 0,
        chatCompletionToolCalls: {},
        responsesApiToolCalls: []
    };
    try {
        for await (const event of stream){
            if ($df0Nw.isChatCompletionChunk(event)) $113d518abb61fa05$var$processChatCompletionChunk(event, state, recordOutputs);
            else if ($df0Nw.isResponsesApiStreamEvent(event)) $113d518abb61fa05$var$processResponsesApiEvent(event, state, recordOutputs, span);
            yield event;
        }
    } finally{
        const allToolCalls = [
            ...Object.values(state.chatCompletionToolCalls),
            ...state.responsesApiToolCalls
        ];
        $4htth.endStreamSpan(span, {
            ...state,
            toolCalls: allToolCalls
        }, recordOutputs);
    }
}
module.exports.instrumentStream = $113d518abb61fa05$var$instrumentStream;

});
parcelRegister("df0Nw", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9QwBg = parcelRequire("9QwBg");
function $9a3d4b7b5e219e04$var$isResponsesApiStreamEvent(event) {
    return event !== null && typeof event === "object" && "type" in event && typeof event.type === "string" && event.type.startsWith("response.");
}
function $9a3d4b7b5e219e04$var$isChatCompletionChunk(event) {
    return event !== null && typeof event === "object" && "object" in event && event.object === "chat.completion.chunk";
}
function $9a3d4b7b5e219e04$var$addResponseAttributes(span, result, recordOutputs) {
    if (!result || typeof result !== "object") return;
    const response = result;
    const attrs = {};
    if (typeof response.id === "string") attrs[$9QwBg.GEN_AI_RESPONSE_ID_ATTRIBUTE] = response.id;
    if (typeof response.model === "string") attrs[$9QwBg.GEN_AI_RESPONSE_MODEL_ATTRIBUTE] = response.model;
    if (response.object === "conversation" && typeof response.id === "string") attrs[$9QwBg.GEN_AI_CONVERSATION_ID_ATTRIBUTE] = response.id;
    if (response.usage && typeof response.usage === "object") {
        const usage = response.usage;
        const inputTokens = usage.prompt_tokens ?? usage.input_tokens;
        if (typeof inputTokens === "number") attrs[$9QwBg.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = inputTokens;
        const outputTokens = usage.completion_tokens ?? usage.output_tokens;
        if (typeof outputTokens === "number") attrs[$9QwBg.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = outputTokens;
        if (typeof usage.total_tokens === "number") attrs[$9QwBg.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = usage.total_tokens;
    }
    if (Array.isArray(response.choices)) {
        const choices = response.choices;
        const finishReasons = choices.map((choice)=>choice.finish_reason).filter((reason)=>typeof reason === "string");
        if (finishReasons.length > 0) attrs[$9QwBg.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify(finishReasons);
        if (recordOutputs) {
            const responseTexts = choices.map((choice)=>{
                const message = choice.message;
                return message?.content || "";
            });
            attrs[$9QwBg.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = JSON.stringify(responseTexts);
            const toolCalls = choices.map((choice)=>{
                const message = choice.message;
                return message?.tool_calls;
            }).filter((calls)=>Array.isArray(calls) && calls.length > 0).flat();
            if (toolCalls.length > 0) attrs[$9QwBg.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(toolCalls);
        }
    }
    if (typeof response.status === "string") {
        if (!attrs[$9QwBg.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE]) attrs[$9QwBg.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify([
            response.status
        ]);
    }
    if (recordOutputs) {
        if (typeof response.output_text === "string" && !attrs[$9QwBg.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]) attrs[$9QwBg.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = response.output_text;
        if (Array.isArray(response.output) && response.output.length > 0 && !attrs[$9QwBg.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]) {
            const functionCalls = response.output.filter((item)=>item?.type === "function_call");
            if (functionCalls.length > 0) attrs[$9QwBg.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(functionCalls);
        }
    }
    span.setAttributes(attrs);
}
function $9a3d4b7b5e219e04$var$extractConversationId(params) {
    if ("conversation" in params && typeof params.conversation === "string") return params.conversation;
    if ("previous_response_id" in params && typeof params.previous_response_id === "string") return params.previous_response_id;
    return void 0;
}
function $9a3d4b7b5e219e04$var$extractRequestParameters(params) {
    const attributes = {
        [$9QwBg.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: params.model ?? "unknown"
    };
    if ("temperature" in params) attributes[$9QwBg.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = params.temperature;
    if ("top_p" in params) attributes[$9QwBg.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = params.top_p;
    if ("frequency_penalty" in params) attributes[$9QwBg.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = params.frequency_penalty;
    if ("presence_penalty" in params) attributes[$9QwBg.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE] = params.presence_penalty;
    if ("stream" in params) attributes[$9QwBg.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = params.stream;
    if ("encoding_format" in params) attributes[$9QwBg.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE] = params.encoding_format;
    if ("dimensions" in params) attributes[$9QwBg.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE] = params.dimensions;
    const conversationId = $9a3d4b7b5e219e04$var$extractConversationId(params);
    if (conversationId) attributes[$9QwBg.GEN_AI_CONVERSATION_ID_ATTRIBUTE] = conversationId;
    return attributes;
}
module.exports.addResponseAttributes = $9a3d4b7b5e219e04$var$addResponseAttributes;
module.exports.extractRequestParameters = $9a3d4b7b5e219e04$var$extractRequestParameters;
module.exports.isChatCompletionChunk = $9a3d4b7b5e219e04$var$isChatCompletionChunk;
module.exports.isResponsesApiStreamEvent = $9a3d4b7b5e219e04$var$isResponsesApiStreamEvent;

});



parcelRegister("gS6wu", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dknph = parcelRequire("dknph");

var $3su1E = parcelRequire("3su1E");

var $d7AD6 = parcelRequire("d7AD6");

var $9QwBg = parcelRequire("9QwBg");

var $4htth = parcelRequire("4htth");

var $evMTG = parcelRequire("evMTG");

var $2Gnkt = parcelRequire("2Gnkt");

var $bWBLF = parcelRequire("bWBLF");
let $c486bfcea8b579bf$var$suppressDelegatedCreate = false;
const $c486bfcea8b579bf$var$INSTRUMENTED_METHODS = /* @__PURE__ */ new WeakSet();
function $c486bfcea8b579bf$var$extractRequestAttributes(args, methodPath, operationName) {
    const attributes = {
        [$9QwBg.GEN_AI_SYSTEM_ATTRIBUTE]: "anthropic",
        [$9QwBg.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.anthropic"
    };
    if (args.length > 0 && typeof args[0] === "object" && args[0] !== null) {
        const params = args[0];
        if (params.tools && Array.isArray(params.tools)) attributes[$9QwBg.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(params.tools);
        attributes[$9QwBg.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = params.model ?? "unknown";
        if ("temperature" in params) attributes[$9QwBg.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = params.temperature;
        if ("top_p" in params) attributes[$9QwBg.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = params.top_p;
        if ("stream" in params) attributes[$9QwBg.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = params.stream;
        if ("top_k" in params) attributes[$9QwBg.GEN_AI_REQUEST_TOP_K_ATTRIBUTE] = params.top_k;
        if ("frequency_penalty" in params) attributes[$9QwBg.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = params.frequency_penalty;
        if ("max_tokens" in params) attributes[$9QwBg.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE] = params.max_tokens;
    } else if (methodPath === "models.retrieve" || methodPath === "models.get") attributes[$9QwBg.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = args[0];
    else attributes[$9QwBg.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = "unknown";
    return attributes;
}
function $c486bfcea8b579bf$var$addPrivateRequestAttributes(span, params, enableTruncation) {
    const messages = $bWBLF.messagesFromParams(params);
    $bWBLF.setMessagesAttribute(span, messages, enableTruncation);
    if ("prompt" in params) span.setAttributes({
        [$9QwBg.GEN_AI_PROMPT_ATTRIBUTE]: JSON.stringify(params.prompt)
    });
}
function $c486bfcea8b579bf$var$addContentAttributes(span, response) {
    if ("content" in response) {
        if (Array.isArray(response.content)) {
            span.setAttributes({
                [$9QwBg.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: response.content.map((item)=>item.text).filter((text)=>!!text).join("")
            });
            const toolCalls = [];
            for (const item of response.content)if (item.type === "tool_use" || item.type === "server_tool_use") toolCalls.push(item);
            if (toolCalls.length > 0) span.setAttributes({
                [$9QwBg.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]: JSON.stringify(toolCalls)
            });
        }
    }
    if ("completion" in response) span.setAttributes({
        [$9QwBg.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: response.completion
    });
    if ("input_tokens" in response) span.setAttributes({
        [$9QwBg.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: JSON.stringify(response.input_tokens)
    });
}
function $c486bfcea8b579bf$var$addMetadataAttributes(span, response) {
    if ("id" in response && "model" in response) {
        span.setAttributes({
            [$9QwBg.GEN_AI_RESPONSE_ID_ATTRIBUTE]: response.id,
            [$9QwBg.GEN_AI_RESPONSE_MODEL_ATTRIBUTE]: response.model
        });
        if ("usage" in response && response.usage) $4htth.setTokenUsageAttributes(span, response.usage.input_tokens, response.usage.output_tokens, response.usage.cache_creation_input_tokens, response.usage.cache_read_input_tokens);
    }
}
function $c486bfcea8b579bf$var$addResponseAttributes(span, response, recordOutputs) {
    if (!response || typeof response !== "object") return;
    if ("type" in response && response.type === "error") {
        $bWBLF.handleResponseError(span, response);
        return;
    }
    if (recordOutputs) $c486bfcea8b579bf$var$addContentAttributes(span, response);
    $c486bfcea8b579bf$var$addMetadataAttributes(span, response);
}
function $c486bfcea8b579bf$var$handleStreamingError(error, span) {
    if (span.isRecording()) {
        span.setStatus({
            code: $3su1E.SPAN_STATUS_ERROR,
            message: "internal_error"
        });
        span.end();
    }
    throw error;
}
function $c486bfcea8b579bf$var$handleStreamingRequest(target, invocationThis, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod) {
    const model = requestAttributes[$9QwBg.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
    const spanConfig = {
        name: `${operationName} ${model}`,
        op: `gen_ai.${operationName}`,
        attributes: requestAttributes
    };
    if (isStreamRequested && !isStreamingMethod) {
        let originalResult;
        const instrumentedPromise = $d7AD6.startSpanManual(spanConfig, (span)=>{
            originalResult = target.apply(invocationThis, args);
            if (options.recordInputs && params) $c486bfcea8b579bf$var$addPrivateRequestAttributes(span, params, $4htth.shouldEnableTruncation(options.enableTruncation));
            return (async ()=>{
                try {
                    const result = await originalResult;
                    return $2Gnkt.instrumentAsyncIterableStream(result, span, options.recordOutputs ?? false);
                } catch (error) {
                    return $c486bfcea8b579bf$var$handleStreamingError(error, span);
                }
            })();
        });
        return $4htth.wrapPromiseWithMethods(originalResult, instrumentedPromise);
    } else return $d7AD6.startSpanManual(spanConfig, (span)=>{
        try {
            if (options.recordInputs && params) $c486bfcea8b579bf$var$addPrivateRequestAttributes(span, params, $4htth.shouldEnableTruncation(options.enableTruncation));
            $c486bfcea8b579bf$var$suppressDelegatedCreate = true;
            const messageStream = target.apply(invocationThis, args);
            $c486bfcea8b579bf$var$suppressDelegatedCreate = false;
            return $2Gnkt.instrumentMessageStream(messageStream, span, options.recordOutputs ?? false);
        } catch (error) {
            $c486bfcea8b579bf$var$suppressDelegatedCreate = false;
            return $c486bfcea8b579bf$var$handleStreamingError(error, span);
        }
    });
}
function $c486bfcea8b579bf$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    return new Proxy(originalMethod, {
        apply (target, thisArg, args) {
            const invocationThis = thisArg !== void 0 ? thisArg : context;
            const isStreamingMethod = instrumentedMethod.streaming === true;
            if (!isStreamingMethod && $c486bfcea8b579bf$var$suppressDelegatedCreate) return target.apply(invocationThis, args);
            const operationName = instrumentedMethod.operation || "unknown";
            const requestAttributes = $c486bfcea8b579bf$var$extractRequestAttributes(args, methodPath, operationName);
            const model = requestAttributes[$9QwBg.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
            const params = typeof args[0] === "object" ? args[0] : void 0;
            const isStreamRequested = Boolean(params?.stream);
            if (isStreamRequested || isStreamingMethod) return $c486bfcea8b579bf$var$handleStreamingRequest(target, invocationThis, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod);
            let originalResult;
            const instrumentedPromise = $d7AD6.startSpan({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, (span)=>{
                originalResult = target.apply(invocationThis, args);
                if (options.recordInputs && params) $c486bfcea8b579bf$var$addPrivateRequestAttributes(span, params, $4htth.shouldEnableTruncation(options.enableTruncation));
                return originalResult.then((result)=>{
                    $c486bfcea8b579bf$var$addResponseAttributes(span, result, options.recordOutputs);
                    return result;
                });
            });
            return $4htth.wrapPromiseWithMethods(originalResult, instrumentedPromise);
        }
    });
}
function $c486bfcea8b579bf$var$instrumentClientInPlace(client, options) {
    for (const methodPath of Object.keys($evMTG.ANTHROPIC_METHOD_REGISTRY)){
        const segments = methodPath.split(".");
        const methodName = segments.pop();
        let owner = client;
        for (const segment of segments)owner = owner?.[segment];
        if (!owner || typeof owner[methodName] !== "function") continue;
        const originalMethod = owner[methodName];
        if ($c486bfcea8b579bf$var$INSTRUMENTED_METHODS.has(originalMethod)) continue;
        const instrumented = $c486bfcea8b579bf$var$instrumentMethod(originalMethod, methodPath, $evMTG.ANTHROPIC_METHOD_REGISTRY[methodPath], owner, options);
        $c486bfcea8b579bf$var$INSTRUMENTED_METHODS.add(instrumented);
        owner[methodName] = instrumented;
    }
    return client;
}
function $c486bfcea8b579bf$var$instrumentAnthropicAiClient(anthropicAiClient, options) {
    return $c486bfcea8b579bf$var$instrumentClientInPlace(anthropicAiClient, $4htth.resolveAIRecordingOptions(options));
}
module.exports.addPrivateRequestAttributes = $c486bfcea8b579bf$var$addPrivateRequestAttributes;
module.exports.addResponseAttributes = $c486bfcea8b579bf$var$addResponseAttributes;
module.exports.extractRequestAttributes = $c486bfcea8b579bf$var$extractRequestAttributes;
module.exports.instrumentAnthropicAiClient = $c486bfcea8b579bf$var$instrumentAnthropicAiClient;

});
parcelRegister("evMTG", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $a909e3e170fe4144$var$ANTHROPIC_AI_INTEGRATION_NAME = "Anthropic_AI";
const $a909e3e170fe4144$var$ANTHROPIC_METHOD_REGISTRY = {
    "messages.create": {
        operation: "chat"
    },
    "messages.stream": {
        operation: "chat",
        streaming: true
    },
    "messages.countTokens": {
        operation: "chat"
    },
    "models.get": {
        operation: "models"
    },
    "completions.create": {
        operation: "chat"
    },
    "models.retrieve": {
        operation: "models"
    },
    "beta.messages.create": {
        operation: "chat"
    }
};
module.exports.ANTHROPIC_AI_INTEGRATION_NAME = $a909e3e170fe4144$var$ANTHROPIC_AI_INTEGRATION_NAME;
module.exports.ANTHROPIC_METHOD_REGISTRY = $a909e3e170fe4144$var$ANTHROPIC_METHOD_REGISTRY;

});

parcelRegister("2Gnkt", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $i98W3 = parcelRequire("i98W3");

var $3su1E = parcelRequire("3su1E");

var $4htth = parcelRequire("4htth");

var $bWBLF = parcelRequire("bWBLF");
function $1f4199b87aa2b2d8$var$isErrorEvent(event, span) {
    if ("type" in event && typeof event.type === "string") {
        if (event.type === "error") {
            span.setStatus({
                code: $3su1E.SPAN_STATUS_ERROR,
                message: $bWBLF.mapAnthropicErrorToStatusMessage(event.error?.type)
            });
            return true;
        }
    }
    return false;
}
function $1f4199b87aa2b2d8$var$handleMessageMetadata(event, state) {
    if (event.type === "message_delta") {
        if (event.usage && typeof event.usage.output_tokens === "number") state.completionTokens = event.usage.output_tokens;
        if (event.delta?.stop_reason) state.finishReasons.push(event.delta.stop_reason);
    }
    if (event.message) {
        const message = event.message;
        if (message.id) state.responseId = message.id;
        if (message.model) state.responseModel = message.model;
        if (message.usage) {
            if (typeof message.usage.input_tokens === "number") state.promptTokens = message.usage.input_tokens;
            if (typeof message.usage.cache_creation_input_tokens === "number") state.cacheCreationInputTokens = message.usage.cache_creation_input_tokens;
            if (typeof message.usage.cache_read_input_tokens === "number") state.cacheReadInputTokens = message.usage.cache_read_input_tokens;
        }
    }
}
function $1f4199b87aa2b2d8$var$handleContentBlockStart(event, state) {
    if (event.type !== "content_block_start" || typeof event.index !== "number" || !event.content_block) return;
    if (event.content_block.type === "tool_use" || event.content_block.type === "server_tool_use") state.activeToolBlocks[event.index] = {
        id: event.content_block.id,
        name: event.content_block.name,
        inputJsonParts: []
    };
}
function $1f4199b87aa2b2d8$var$handleContentBlockDelta(event, state, recordOutputs) {
    if (event.type !== "content_block_delta" || !event.delta) return;
    if (typeof event.index === "number" && "partial_json" in event.delta && typeof event.delta.partial_json === "string") {
        const active = state.activeToolBlocks[event.index];
        if (active) active.inputJsonParts.push(event.delta.partial_json);
    }
    if (recordOutputs && typeof event.delta.text === "string") state.responseTexts.push(event.delta.text);
}
function $1f4199b87aa2b2d8$var$handleContentBlockStop(event, state) {
    if (event.type !== "content_block_stop" || typeof event.index !== "number") return;
    const active = state.activeToolBlocks[event.index];
    if (!active) return;
    const raw = active.inputJsonParts.join("");
    let parsedInput;
    try {
        parsedInput = raw ? JSON.parse(raw) : {};
    } catch  {
        parsedInput = {
            __unparsed: raw
        };
    }
    state.toolCalls.push({
        type: "tool_use",
        id: active.id,
        name: active.name,
        input: parsedInput
    });
    delete state.activeToolBlocks[event.index];
}
function $1f4199b87aa2b2d8$var$processEvent(event, state, recordOutputs, span) {
    if (!(event && typeof event === "object")) return;
    const isError = $1f4199b87aa2b2d8$var$isErrorEvent(event, span);
    if (isError) return;
    $1f4199b87aa2b2d8$var$handleMessageMetadata(event, state);
    $1f4199b87aa2b2d8$var$handleContentBlockStart(event, state);
    $1f4199b87aa2b2d8$var$handleContentBlockDelta(event, state, recordOutputs);
    $1f4199b87aa2b2d8$var$handleContentBlockStop(event, state);
}
async function* $1f4199b87aa2b2d8$var$instrumentAsyncIterableStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: void 0,
        completionTokens: void 0,
        cacheCreationInputTokens: void 0,
        cacheReadInputTokens: void 0,
        toolCalls: [],
        activeToolBlocks: {}
    };
    try {
        for await (const event of stream){
            $1f4199b87aa2b2d8$var$processEvent(event, state, recordOutputs, span);
            yield event;
        }
    } finally{
        $4htth.endStreamSpan(span, state, recordOutputs);
    }
}
function $1f4199b87aa2b2d8$var$instrumentMessageStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: void 0,
        completionTokens: void 0,
        cacheCreationInputTokens: void 0,
        cacheReadInputTokens: void 0,
        toolCalls: [],
        activeToolBlocks: {}
    };
    stream.on("streamEvent", (event)=>{
        $1f4199b87aa2b2d8$var$processEvent(event, state, recordOutputs, span);
    });
    stream.on("message", ()=>{
        $4htth.endStreamSpan(span, state, recordOutputs);
    });
    stream.on("error", (error)=>{
        $i98W3.captureException(error, {
            mechanism: {
                handled: false,
                type: "auto.ai.anthropic.stream_error"
            }
        });
        if (span.isRecording()) {
            span.setStatus({
                code: $3su1E.SPAN_STATUS_ERROR,
                message: "internal_error"
            });
            span.end();
        }
    });
    return stream;
}
module.exports.instrumentAsyncIterableStream = $1f4199b87aa2b2d8$var$instrumentAsyncIterableStream;
module.exports.instrumentMessageStream = $1f4199b87aa2b2d8$var$instrumentMessageStream;

});
parcelRegister("bWBLF", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $i98W3 = parcelRequire("i98W3");

var $erV30 = parcelRequire("erV30");

var $3su1E = parcelRequire("3su1E");

var $9QwBg = parcelRequire("9QwBg");

var $4htth = parcelRequire("4htth");
function $8b22685decb717f7$var$setMessagesAttribute(span, messages, enableTruncation) {
    if (Array.isArray(messages) && messages.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $4htth.extractSystemInstructions(messages);
    if (systemInstructions) span.setAttributes({
        [$9QwBg.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE]: systemInstructions
    });
    const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 1;
    span.setAttributes({
        [$9QwBg.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $4htth.getTruncatedJsonString(filteredMessages) : $erV30.stringify(filteredMessages),
        [$9QwBg.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
    });
}
const $8b22685decb717f7$var$ANTHROPIC_ERROR_TYPE_TO_SPAN_STATUS = {
    invalid_request_error: "invalid_argument",
    authentication_error: "unauthenticated",
    permission_error: "permission_denied",
    not_found_error: "not_found",
    request_too_large: "failed_precondition",
    rate_limit_error: "resource_exhausted",
    api_error: "internal_error",
    overloaded_error: "unavailable"
};
function $8b22685decb717f7$var$mapAnthropicErrorToStatusMessage(errorType) {
    if (!errorType) return "internal_error";
    return $8b22685decb717f7$var$ANTHROPIC_ERROR_TYPE_TO_SPAN_STATUS[errorType] || "internal_error";
}
function $8b22685decb717f7$var$handleResponseError(span, response) {
    if (response.error) {
        span.setStatus({
            code: $3su1E.SPAN_STATUS_ERROR,
            message: $8b22685decb717f7$var$mapAnthropicErrorToStatusMessage(response.error.type)
        });
        $i98W3.captureException(response.error, {
            mechanism: {
                handled: false,
                type: "auto.ai.anthropic.anthropic_error"
            }
        });
    }
}
function $8b22685decb717f7$var$messagesFromParams(params) {
    const { system: system, messages: messages, input: input } = params;
    const systemMessages = typeof system === "string" ? [
        {
            role: "system",
            content: params.system
        }
    ] : [];
    const inputParamMessages = Array.isArray(input) ? input : input != null ? [
        input
    ] : void 0;
    const messagesParamMessages = Array.isArray(messages) ? messages : messages != null ? [
        messages
    ] : [];
    const userMessages = inputParamMessages ?? messagesParamMessages;
    return [
        ...systemMessages,
        ...userMessages
    ];
}
module.exports.handleResponseError = $8b22685decb717f7$var$handleResponseError;
module.exports.mapAnthropicErrorToStatusMessage = $8b22685decb717f7$var$mapAnthropicErrorToStatusMessage;
module.exports.messagesFromParams = $8b22685decb717f7$var$messagesFromParams;
module.exports.setMessagesAttribute = $8b22685decb717f7$var$setMessagesAttribute;

});



parcelRegister("faKNH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dknph = parcelRequire("dknph");

var $erV30 = parcelRequire("erV30");

var $3su1E = parcelRequire("3su1E");

var $d7AD6 = parcelRequire("d7AD6");

var $ciHXl = parcelRequire("ciHXl");

var $9QwBg = parcelRequire("9QwBg");

var $4htth = parcelRequire("4htth");

var $bfQBA = parcelRequire("bfQBA");

var $boXIs = parcelRequire("boXIs");

var $c3oQJ = parcelRequire("c3oQJ");
function $b0bc17d20feb2ef8$var$extractModel(params, context) {
    if ("model" in params && typeof params.model === "string") return params.model;
    if (context && typeof context === "object") {
        const contextObj = context;
        if ("model" in contextObj && typeof contextObj.model === "string") return contextObj.model;
        if ("modelVersion" in contextObj && typeof contextObj.modelVersion === "string") return contextObj.modelVersion;
    }
    return "unknown";
}
function $b0bc17d20feb2ef8$var$extractConfigAttributes(config) {
    const attributes = {};
    if ("temperature" in config && typeof config.temperature === "number") attributes[$9QwBg.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = config.temperature;
    if ("topP" in config && typeof config.topP === "number") attributes[$9QwBg.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = config.topP;
    if ("topK" in config && typeof config.topK === "number") attributes[$9QwBg.GEN_AI_REQUEST_TOP_K_ATTRIBUTE] = config.topK;
    if ("maxOutputTokens" in config && typeof config.maxOutputTokens === "number") attributes[$9QwBg.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE] = config.maxOutputTokens;
    if ("frequencyPenalty" in config && typeof config.frequencyPenalty === "number") attributes[$9QwBg.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = config.frequencyPenalty;
    if ("presencePenalty" in config && typeof config.presencePenalty === "number") attributes[$9QwBg.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE] = config.presencePenalty;
    return attributes;
}
function $b0bc17d20feb2ef8$var$extractRequestAttributes(operationName, params, context) {
    const attributes = {
        [$9QwBg.GEN_AI_SYSTEM_ATTRIBUTE]: $bfQBA.GOOGLE_GENAI_SYSTEM_NAME,
        [$9QwBg.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.google_genai"
    };
    if (params) {
        attributes[$9QwBg.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = $b0bc17d20feb2ef8$var$extractModel(params, context);
        if ("config" in params && typeof params.config === "object" && params.config) {
            const config = params.config;
            Object.assign(attributes, $b0bc17d20feb2ef8$var$extractConfigAttributes(config));
            if ("tools" in config && Array.isArray(config.tools)) {
                const functionDeclarations = config.tools.flatMap((tool)=>tool.functionDeclarations);
                attributes[$9QwBg.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(functionDeclarations);
            }
        }
    } else attributes[$9QwBg.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = $b0bc17d20feb2ef8$var$extractModel({}, context);
    return attributes;
}
function $b0bc17d20feb2ef8$var$addPrivateRequestAttributes(span, params, operationName, enableTruncation) {
    if (operationName === "embeddings") {
        const contents = params.contents;
        if (contents != null) span.setAttribute($9QwBg.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE, typeof contents === "string" ? contents : JSON.stringify(contents));
        return;
    }
    const messages = [];
    if ("config" in params && params.config && typeof params.config === "object" && "systemInstruction" in params.config && params.config.systemInstruction) messages.push(...$c3oQJ.contentUnionToMessages(params.config.systemInstruction, "system"));
    if ("history" in params) messages.push(...$c3oQJ.contentUnionToMessages(params.history, "user"));
    if ("contents" in params) messages.push(...$c3oQJ.contentUnionToMessages(params.contents, "user"));
    if ("message" in params) messages.push(...$c3oQJ.contentUnionToMessages(params.message, "user"));
    if (Array.isArray(messages) && messages.length) {
        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $4htth.extractSystemInstructions(messages);
        if (systemInstructions) span.setAttribute($9QwBg.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
        span.setAttributes({
            [$9QwBg.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength,
            [$9QwBg.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $4htth.getTruncatedJsonString(filteredMessages) : $erV30.stringify(filteredMessages)
        });
    }
}
function $b0bc17d20feb2ef8$var$addResponseAttributes(span, response, recordOutputs) {
    if (!response || typeof response !== "object") return;
    if (response.modelVersion) span.setAttribute($9QwBg.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, response.modelVersion);
    if (response.usageMetadata && typeof response.usageMetadata === "object") {
        const usage = response.usageMetadata;
        if (typeof usage.promptTokenCount === "number") span.setAttributes({
            [$9QwBg.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE]: usage.promptTokenCount
        });
        if (typeof usage.candidatesTokenCount === "number") span.setAttributes({
            [$9QwBg.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE]: usage.candidatesTokenCount
        });
        if (typeof usage.totalTokenCount === "number") span.setAttributes({
            [$9QwBg.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE]: usage.totalTokenCount
        });
    }
    if (recordOutputs && Array.isArray(response.candidates) && response.candidates.length > 0) {
        const responseTexts = response.candidates.map((candidate)=>{
            if (candidate.content?.parts && Array.isArray(candidate.content.parts)) return candidate.content.parts.map((part)=>typeof part.text === "string" ? part.text : "").filter((text)=>text.length > 0).join("");
            return "";
        }).filter((text)=>text.length > 0);
        if (responseTexts.length > 0) span.setAttributes({
            [$9QwBg.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: responseTexts.join("")
        });
    }
    if (recordOutputs && response.functionCalls) {
        const functionCalls = response.functionCalls;
        if (Array.isArray(functionCalls) && functionCalls.length > 0) span.setAttributes({
            [$9QwBg.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]: JSON.stringify(functionCalls)
        });
    }
}
function $b0bc17d20feb2ef8$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    const isEmbeddings = instrumentedMethod.operation === "embeddings";
    return new Proxy(originalMethod, {
        apply (target, _, args) {
            const operationName = instrumentedMethod.operation || "unknown";
            const params = args[0];
            const requestAttributes = $b0bc17d20feb2ef8$var$extractRequestAttributes(operationName, params, context);
            const model = requestAttributes[$9QwBg.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
            if (instrumentedMethod.streaming) return $d7AD6.startSpanManual({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, async (span)=>{
                try {
                    if (options.recordInputs && params) $b0bc17d20feb2ef8$var$addPrivateRequestAttributes(span, params, operationName, $4htth.shouldEnableTruncation(options.enableTruncation));
                    const stream = await target.apply(context, args);
                    return $boXIs.instrumentStream(stream, span, Boolean(options.recordOutputs));
                } catch (error) {
                    span.setStatus({
                        code: $3su1E.SPAN_STATUS_ERROR,
                        message: "internal_error"
                    });
                    span.end();
                    throw error;
                }
            });
            return $d7AD6.startSpan({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, (span)=>{
                if (options.recordInputs && params) $b0bc17d20feb2ef8$var$addPrivateRequestAttributes(span, params, operationName, $4htth.shouldEnableTruncation(options.enableTruncation));
                return $ciHXl.handleCallbackErrors(()=>target.apply(context, args), ()=>{}, ()=>{}, (result)=>{
                    if (!isEmbeddings) $b0bc17d20feb2ef8$var$addResponseAttributes(span, result, options.recordOutputs);
                });
            });
        }
    });
}
function $b0bc17d20feb2ef8$var$createDeepProxy(target, currentPath = "", options) {
    return new Proxy(target, {
        get: (t, prop, receiver)=>{
            const value = Reflect.get(t, prop, receiver);
            const methodPath = $4htth.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $bfQBA.GOOGLE_GENAI_METHOD_REGISTRY[methodPath];
            if (typeof value === "function" && instrumentedMethod) {
                const wrappedMethod = instrumentedMethod.operation ? $b0bc17d20feb2ef8$var$instrumentMethod(value, methodPath, instrumentedMethod, t, options) : value.bind(t);
                if (!instrumentedMethod.proxyResultPath) return wrappedMethod;
                return function(...args) {
                    const result = wrappedMethod(...args);
                    if (result && typeof result === "object") return $b0bc17d20feb2ef8$var$createDeepProxy(result, instrumentedMethod.proxyResultPath, options);
                    return result;
                };
            }
            if (typeof value === "function") return value.bind(t);
            if (value && typeof value === "object") return $b0bc17d20feb2ef8$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
function $b0bc17d20feb2ef8$var$instrumentGoogleGenAIClient(client, options) {
    return $b0bc17d20feb2ef8$var$createDeepProxy(client, "", $4htth.resolveAIRecordingOptions(options));
}
module.exports.addPrivateRequestAttributes = $b0bc17d20feb2ef8$var$addPrivateRequestAttributes;
module.exports.addResponseAttributes = $b0bc17d20feb2ef8$var$addResponseAttributes;
module.exports.extractModel = $b0bc17d20feb2ef8$var$extractModel;
module.exports.extractRequestAttributes = $b0bc17d20feb2ef8$var$extractRequestAttributes;
module.exports.instrumentGoogleGenAIClient = $b0bc17d20feb2ef8$var$instrumentGoogleGenAIClient;

});
parcelRegister("bfQBA", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $8319e6bf03942ee6$var$GOOGLE_GENAI_INTEGRATION_NAME = "Google_GenAI";
const $8319e6bf03942ee6$var$GOOGLE_GENAI_METHOD_REGISTRY = {
    "models.generateContent": {
        operation: "generate_content"
    },
    "models.generateContentStream": {
        operation: "generate_content",
        streaming: true
    },
    "models.embedContent": {
        operation: "embeddings"
    },
    "chats.create": {
        proxyResultPath: "chat"
    },
    "chat.sendMessage": {
        operation: "chat"
    },
    "chat.sendMessageStream": {
        operation: "chat",
        streaming: true
    }
};
const $8319e6bf03942ee6$var$GOOGLE_GENAI_SYSTEM_NAME = "google_genai";
module.exports.GOOGLE_GENAI_INTEGRATION_NAME = $8319e6bf03942ee6$var$GOOGLE_GENAI_INTEGRATION_NAME;
module.exports.GOOGLE_GENAI_METHOD_REGISTRY = $8319e6bf03942ee6$var$GOOGLE_GENAI_METHOD_REGISTRY;
module.exports.GOOGLE_GENAI_SYSTEM_NAME = $8319e6bf03942ee6$var$GOOGLE_GENAI_SYSTEM_NAME;

});

parcelRegister("boXIs", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $i98W3 = parcelRequire("i98W3");

var $3su1E = parcelRequire("3su1E");

var $4htth = parcelRequire("4htth");
function $84d041f2f3bbfa00$var$isErrorChunk(chunk, span) {
    const feedback = chunk?.promptFeedback;
    if (feedback?.blockReason) {
        const message = feedback.blockReasonMessage ?? feedback.blockReason;
        span.setStatus({
            code: $3su1E.SPAN_STATUS_ERROR,
            message: "internal_error"
        });
        $i98W3.captureException(`Content blocked: ${message}`, {
            mechanism: {
                handled: false,
                type: "auto.ai.google_genai"
            }
        });
        return true;
    }
    return false;
}
function $84d041f2f3bbfa00$var$handleResponseMetadata(chunk, state) {
    if (typeof chunk.responseId === "string") state.responseId = chunk.responseId;
    if (typeof chunk.modelVersion === "string") state.responseModel = chunk.modelVersion;
    const usage = chunk.usageMetadata;
    if (usage) {
        if (typeof usage.promptTokenCount === "number") state.promptTokens = usage.promptTokenCount;
        if (typeof usage.candidatesTokenCount === "number") state.completionTokens = usage.candidatesTokenCount;
        if (typeof usage.totalTokenCount === "number") state.totalTokens = usage.totalTokenCount;
    }
}
function $84d041f2f3bbfa00$var$handleCandidateContent(chunk, state, recordOutputs) {
    if (Array.isArray(chunk.functionCalls)) state.toolCalls.push(...chunk.functionCalls);
    for (const candidate of chunk.candidates ?? []){
        if (candidate?.finishReason && !state.finishReasons.includes(candidate.finishReason)) state.finishReasons.push(candidate.finishReason);
        for (const part of candidate?.content?.parts ?? []){
            if (recordOutputs && part.text) state.responseTexts.push(part.text);
            if (part.functionCall) state.toolCalls.push({
                type: "function",
                id: part.functionCall.id,
                name: part.functionCall.name,
                arguments: part.functionCall.args
            });
        }
    }
}
function $84d041f2f3bbfa00$var$processChunk(chunk, state, recordOutputs, span) {
    if (!chunk || $84d041f2f3bbfa00$var$isErrorChunk(chunk, span)) return;
    $84d041f2f3bbfa00$var$handleResponseMetadata(chunk, state);
    $84d041f2f3bbfa00$var$handleCandidateContent(chunk, state, recordOutputs);
}
async function* $84d041f2f3bbfa00$var$instrumentStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        toolCalls: []
    };
    try {
        for await (const chunk of stream){
            $84d041f2f3bbfa00$var$processChunk(chunk, state, recordOutputs, span);
            yield chunk;
        }
    } finally{
        $4htth.endStreamSpan(span, state, recordOutputs);
    }
}
module.exports.instrumentStream = $84d041f2f3bbfa00$var$instrumentStream;

});

parcelRegister("c3oQJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $8c690a7054a99189$var$contentUnionToMessages(content, role = "user") {
    if (typeof content === "string") return [
        {
            role: role,
            content: content
        }
    ];
    if (Array.isArray(content)) return content.flatMap((content2)=>$8c690a7054a99189$var$contentUnionToMessages(content2, role));
    if (typeof content !== "object" || !content) return [];
    if ("role" in content && typeof content.role === "string") return [
        content
    ];
    if ("parts" in content) return [
        {
            ...content,
            role: role
        }
    ];
    return [
        {
            role: role,
            content: content
        }
    ];
}
module.exports.contentUnionToMessages = $8c690a7054a99189$var$contentUnionToMessages;

});


parcelRegister("4PbDj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dknph = parcelRequire("dknph");

var $3su1E = parcelRequire("3su1E");

var $d7AD6 = parcelRequire("d7AD6");

var $9QwBg = parcelRequire("9QwBg");

var $4htth = parcelRequire("4htth");

var $jpH30 = parcelRequire("jpH30");

var $cFmVy = parcelRequire("cFmVy");
function $3834f2ee8d069123$var$createLangChainCallbackHandler(options = {}) {
    const { recordInputs: recordInputs, recordOutputs: recordOutputs } = $4htth.resolveAIRecordingOptions(options);
    const enableTruncation = $4htth.shouldEnableTruncation(options.enableTruncation);
    const spanMap = /* @__PURE__ */ new Map();
    const exitSpan = (runId)=>{
        const span = spanMap.get(runId);
        if (span?.isRecording()) {
            span.end();
            spanMap.delete(runId);
        }
    };
    const handler = {
        // Required LangChain BaseCallbackHandler properties
        lc_serializable: false,
        lc_namespace: [
            "langchain_core",
            "callbacks",
            "sentry"
        ],
        lc_secrets: void 0,
        lc_attributes: void 0,
        lc_aliases: void 0,
        lc_serializable_keys: void 0,
        lc_id: [
            "langchain_core",
            "callbacks",
            "sentry"
        ],
        lc_kwargs: {},
        name: "SentryCallbackHandler",
        // BaseCallbackHandlerInput boolean flags
        ignoreLLM: false,
        ignoreChain: false,
        ignoreAgent: false,
        ignoreRetriever: false,
        ignoreCustomEvent: false,
        raiseError: false,
        awaitHandlers: true,
        handleLLMStart (llm, prompts, runId, _parentRunId, _extraParams, tags, metadata, _runName) {
            const invocationParams = $cFmVy.getInvocationParams(tags);
            const attributes = $cFmVy.extractLLMRequestAttributes(llm, prompts, recordInputs, enableTruncation, invocationParams, metadata);
            const modelName = attributes[$9QwBg.GEN_AI_REQUEST_MODEL_ATTRIBUTE];
            const operationName = attributes[$9QwBg.GEN_AI_OPERATION_NAME_ATTRIBUTE];
            $d7AD6.startSpanManual({
                name: `${operationName} ${modelName}`,
                op: "gen_ai.chat",
                attributes: {
                    ...$cFmVy.getAgentNameFromMetadata(metadata),
                    ...attributes,
                    [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.chat"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Chat Model Start Handler
        handleChatModelStart (llm, messages, runId, _parentRunId, extraParams, tags, metadata, _runName) {
            const invocationParams = $cFmVy.getInvocationParams(tags);
            const attributes = $cFmVy.extractChatModelRequestAttributes(llm, messages, recordInputs, enableTruncation, invocationParams, metadata);
            const toolDefsJson = $cFmVy.extractToolDefinitions(extraParams);
            if (toolDefsJson) attributes[$9QwBg.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = toolDefsJson;
            const modelName = attributes[$9QwBg.GEN_AI_REQUEST_MODEL_ATTRIBUTE];
            const operationName = attributes[$9QwBg.GEN_AI_OPERATION_NAME_ATTRIBUTE];
            $d7AD6.startSpanManual({
                name: `${operationName} ${modelName}`,
                op: "gen_ai.chat",
                attributes: {
                    ...$cFmVy.getAgentNameFromMetadata(metadata),
                    ...attributes,
                    [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.chat"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // LLM End Handler - note: handleLLMEnd with capital LLM (used by both LLMs and chat models!)
        handleLLMEnd (output, runId, _parentRunId, _tags, _extraParams) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                const attributes = $cFmVy.extractLlmResponseAttributes(output, recordOutputs);
                if (attributes) span.setAttributes(attributes);
                exitSpan(runId);
            }
        },
        // LLM Error Handler - note: handleLLMError with capital LLM
        handleLLMError (_error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $3su1E.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                exitSpan(runId);
            }
        },
        // Chain Start Handler
        handleChainStart (chain, inputs, runId, _parentRunId, _tags, metadata, _runType, runName) {
            if (metadata?.__sentry_langgraph__) return;
            const chainName = runName || chain.name || "unknown_chain";
            const attributes = {
                [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.langchain",
                "langchain.chain.name": chainName
            };
            if (recordInputs) attributes["langchain.chain.inputs"] = JSON.stringify(inputs);
            $d7AD6.startSpanManual({
                name: `chain ${chainName}`,
                op: "gen_ai.invoke_agent",
                attributes: {
                    ...attributes,
                    [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.invoke_agent"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Chain End Handler
        handleChainEnd (outputs, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                if (recordOutputs) span.setAttributes({
                    "langchain.chain.outputs": JSON.stringify(outputs)
                });
                exitSpan(runId);
            }
        },
        // Chain Error Handler
        handleChainError (_error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $3su1E.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                exitSpan(runId);
            }
        },
        // Tool Start Handler
        handleToolStart (tool, input, runId, _parentRunId, _tags, metadata, runName) {
            if (metadata?.__sentry_langgraph__) return;
            const toolName = runName || tool.name || "unknown_tool";
            const attributes = {
                ...$cFmVy.getAgentNameFromMetadata(metadata),
                [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $jpH30.LANGCHAIN_ORIGIN,
                [$9QwBg.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "execute_tool",
                [$9QwBg.GEN_AI_TOOL_NAME_ATTRIBUTE]: toolName
            };
            if (recordInputs) attributes[$9QwBg.GEN_AI_TOOL_INPUT_ATTRIBUTE] = input;
            $d7AD6.startSpanManual({
                name: `execute_tool ${toolName}`,
                op: "gen_ai.execute_tool",
                attributes: {
                    ...attributes,
                    [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.execute_tool"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Tool End Handler
        handleToolEnd (output, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                if (recordOutputs) {
                    const outputObj = output;
                    const content = outputObj && typeof outputObj === "object" && "content" in outputObj ? outputObj.content : output;
                    span.setAttributes({
                        [$9QwBg.GEN_AI_TOOL_OUTPUT_ATTRIBUTE]: typeof content === "string" ? content : JSON.stringify(content)
                    });
                }
                exitSpan(runId);
            }
        },
        // Tool Error Handler
        handleToolError (_error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $3su1E.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                exitSpan(runId);
            }
        },
        // LangChain BaseCallbackHandler required methods
        copy () {
            return handler;
        },
        toJSON () {
            return {
                lc: 1,
                type: "not_implemented",
                id: handler.lc_id
            };
        },
        toJSONNotImplemented () {
            return {
                lc: 1,
                type: "not_implemented",
                id: handler.lc_id
            };
        }
    };
    return handler;
}
module.exports.createLangChainCallbackHandler = $3834f2ee8d069123$var$createLangChainCallbackHandler;

});
parcelRegister("jpH30", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $e221be784325608b$var$LANGCHAIN_INTEGRATION_NAME = "LangChain";
const $e221be784325608b$var$LANGCHAIN_ORIGIN = "auto.ai.langchain";
const $e221be784325608b$var$ROLE_MAP = {
    human: "user",
    ai: "assistant",
    assistant: "assistant",
    system: "system",
    function: "function",
    tool: "tool"
};
module.exports.LANGCHAIN_INTEGRATION_NAME = $e221be784325608b$var$LANGCHAIN_INTEGRATION_NAME;
module.exports.LANGCHAIN_ORIGIN = $e221be784325608b$var$LANGCHAIN_ORIGIN;
module.exports.ROLE_MAP = $e221be784325608b$var$ROLE_MAP;

});

parcelRegister("cFmVy", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dknph = parcelRequire("dknph");

var $erV30 = parcelRequire("erV30");

var $9QwBg = parcelRequire("9QwBg");

var $2dZgI = parcelRequire("2dZgI");

var $4htth = parcelRequire("4htth");

var $jpH30 = parcelRequire("jpH30");
const $02613615bf13ba44$var$setIfDefined = (target, key, value)=>{
    if (value != null) target[key] = value;
};
const $02613615bf13ba44$var$setNumberIfDefined = (target, key, value)=>{
    const n = Number(value);
    if (!Number.isNaN(n)) target[key] = n;
};
function $02613615bf13ba44$var$normalizeContent(v) {
    if (Array.isArray(v)) try {
        const stripped = v.map((part)=>part && typeof part === "object" && $2dZgI.isContentMedia(part) ? $2dZgI.stripInlineMediaFromSingleMessage(part) : part);
        return JSON.stringify(stripped);
    } catch  {
        return String(v);
    }
    return $erV30.stringify(v, String);
}
function $02613615bf13ba44$var$normalizeMessageRole(role) {
    const normalized = role.toLowerCase();
    return $jpH30.ROLE_MAP[normalized] ?? normalized;
}
function $02613615bf13ba44$var$normalizeRoleNameFromCtor(name) {
    if (name.includes("System")) return "system";
    if (name.includes("Human")) return "user";
    if (name.includes("AI") || name.includes("Assistant")) return "assistant";
    if (name.includes("Function")) return "function";
    if (name.includes("Tool")) return "tool";
    return "user";
}
function $02613615bf13ba44$var$getInvocationParams(tags) {
    if (!tags || Array.isArray(tags)) return void 0;
    return tags.invocation_params;
}
function $02613615bf13ba44$var$normalizeLangChainMessages(messages) {
    return messages.map((message)=>{
        const maybeGetType = message._getType;
        if (typeof maybeGetType === "function") {
            const messageType = maybeGetType.call(message);
            return {
                role: $02613615bf13ba44$var$normalizeMessageRole(messageType),
                content: $02613615bf13ba44$var$normalizeContent(message.content)
            };
        }
        if (message.lc === 1 && message.kwargs) {
            const id = message.id;
            const messageType = Array.isArray(id) && id.length > 0 ? id[id.length - 1] : "";
            const role = typeof messageType === "string" ? $02613615bf13ba44$var$normalizeRoleNameFromCtor(messageType) : "user";
            return {
                role: $02613615bf13ba44$var$normalizeMessageRole(role),
                content: $02613615bf13ba44$var$normalizeContent(message.kwargs?.content)
            };
        }
        if (message.type) {
            const role = String(message.type).toLowerCase();
            return {
                role: $02613615bf13ba44$var$normalizeMessageRole(role),
                content: $02613615bf13ba44$var$normalizeContent(message.content)
            };
        }
        if (message.role) return {
            role: $02613615bf13ba44$var$normalizeMessageRole(String(message.role)),
            content: $02613615bf13ba44$var$normalizeContent(message.content)
        };
        const ctor = message.constructor?.name;
        if (ctor && ctor !== "Object") return {
            role: $02613615bf13ba44$var$normalizeMessageRole($02613615bf13ba44$var$normalizeRoleNameFromCtor(ctor)),
            content: $02613615bf13ba44$var$normalizeContent(message.content)
        };
        return {
            role: "user",
            content: $02613615bf13ba44$var$normalizeContent(message.content)
        };
    });
}
function $02613615bf13ba44$var$extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata) {
    const attrs = {};
    const kwargs = "kwargs" in serialized ? serialized.kwargs : void 0;
    const temperature = invocationParams?.temperature ?? langSmithMetadata?.ls_temperature ?? kwargs?.temperature;
    $02613615bf13ba44$var$setNumberIfDefined(attrs, $9QwBg.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE, temperature);
    const maxTokens = invocationParams?.max_tokens ?? langSmithMetadata?.ls_max_tokens ?? kwargs?.max_tokens;
    $02613615bf13ba44$var$setNumberIfDefined(attrs, $9QwBg.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE, maxTokens);
    const topP = invocationParams?.top_p ?? kwargs?.top_p;
    $02613615bf13ba44$var$setNumberIfDefined(attrs, $9QwBg.GEN_AI_REQUEST_TOP_P_ATTRIBUTE, topP);
    const frequencyPenalty = invocationParams?.frequency_penalty;
    $02613615bf13ba44$var$setNumberIfDefined(attrs, $9QwBg.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE, frequencyPenalty);
    const presencePenalty = invocationParams?.presence_penalty;
    $02613615bf13ba44$var$setNumberIfDefined(attrs, $9QwBg.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE, presencePenalty);
    if (invocationParams && "stream" in invocationParams) $02613615bf13ba44$var$setIfDefined(attrs, $9QwBg.GEN_AI_REQUEST_STREAM_ATTRIBUTE, Boolean(invocationParams.stream));
    return attrs;
}
function $02613615bf13ba44$var$baseRequestAttributes(system, modelName, serialized, invocationParams, langSmithMetadata) {
    return {
        [$9QwBg.GEN_AI_SYSTEM_ATTRIBUTE]: $erV30.stringify(system ?? "langchain", String),
        [$9QwBg.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "chat",
        [$9QwBg.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: $erV30.stringify(modelName, String),
        [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $jpH30.LANGCHAIN_ORIGIN,
        ...$02613615bf13ba44$var$extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata)
    };
}
function $02613615bf13ba44$var$extractLLMRequestAttributes(llm, prompts, recordInputs, enableTruncation, invocationParams, langSmithMetadata) {
    const system = langSmithMetadata?.ls_provider;
    const modelName = invocationParams?.model ?? langSmithMetadata?.ls_model_name ?? "unknown";
    const attrs = $02613615bf13ba44$var$baseRequestAttributes(system, modelName, llm, invocationParams, langSmithMetadata);
    if (recordInputs && Array.isArray(prompts) && prompts.length > 0) {
        $02613615bf13ba44$var$setIfDefined(attrs, $9QwBg.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, prompts.length);
        const messages = prompts.map((p)=>({
                role: "user",
                content: p
            }));
        $02613615bf13ba44$var$setIfDefined(attrs, $9QwBg.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $4htth.getTruncatedJsonString(messages) : $erV30.stringify(messages));
    }
    return attrs;
}
function $02613615bf13ba44$var$extractChatModelRequestAttributes(llm, langChainMessages, recordInputs, enableTruncation, invocationParams, langSmithMetadata) {
    const system = langSmithMetadata?.ls_provider ?? llm.id?.[2];
    const modelName = invocationParams?.model ?? langSmithMetadata?.ls_model_name ?? "unknown";
    const attrs = $02613615bf13ba44$var$baseRequestAttributes(system, modelName, llm, invocationParams, langSmithMetadata);
    if (recordInputs && Array.isArray(langChainMessages) && langChainMessages.length > 0) {
        const normalized = $02613615bf13ba44$var$normalizeLangChainMessages(langChainMessages.flat());
        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $4htth.extractSystemInstructions(normalized);
        if (systemInstructions) $02613615bf13ba44$var$setIfDefined(attrs, $9QwBg.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
        $02613615bf13ba44$var$setIfDefined(attrs, $9QwBg.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, filteredLength);
        $02613615bf13ba44$var$setIfDefined(attrs, $9QwBg.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $4htth.getTruncatedJsonString(filteredMessages) : $erV30.stringify(filteredMessages));
    }
    return attrs;
}
function $02613615bf13ba44$var$addToolCallsAttributes(generations, attrs) {
    const toolCalls = [];
    const flatGenerations = generations.flat();
    for (const gen of flatGenerations){
        const msg = gen.message;
        const msgToolCalls = msg?.tool_calls;
        if (Array.isArray(msgToolCalls) && msgToolCalls.length > 0) toolCalls.push(...msgToolCalls);
        else {
            const content = gen.message?.content;
            if (Array.isArray(content)) for (const item of content){
                const t = item;
                if (t.type === "tool_use") toolCalls.push(t);
            }
        }
    }
    if (toolCalls.length > 0) $02613615bf13ba44$var$setIfDefined(attrs, $9QwBg.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, $erV30.stringify(toolCalls, String));
}
function $02613615bf13ba44$var$addTokenUsageAttributes(llmOutput, attrs) {
    if (!llmOutput) return;
    const tokenUsage = llmOutput.tokenUsage;
    const anthropicUsage = llmOutput.usage;
    if (tokenUsage) {
        $02613615bf13ba44$var$setNumberIfDefined(attrs, $9QwBg.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, tokenUsage.promptTokens);
        $02613615bf13ba44$var$setNumberIfDefined(attrs, $9QwBg.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, tokenUsage.completionTokens);
        $02613615bf13ba44$var$setNumberIfDefined(attrs, $9QwBg.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, tokenUsage.totalTokens);
    } else if (anthropicUsage) {
        $02613615bf13ba44$var$setNumberIfDefined(attrs, $9QwBg.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.input_tokens);
        $02613615bf13ba44$var$setNumberIfDefined(attrs, $9QwBg.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, anthropicUsage.output_tokens);
        const input = Number(anthropicUsage.input_tokens);
        const output = Number(anthropicUsage.output_tokens);
        const total = (Number.isNaN(input) ? 0 : input) + (Number.isNaN(output) ? 0 : output);
        if (total > 0) $02613615bf13ba44$var$setNumberIfDefined(attrs, $9QwBg.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, total);
        if (anthropicUsage.cache_creation_input_tokens !== void 0) $02613615bf13ba44$var$setNumberIfDefined(attrs, $9QwBg.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.cache_creation_input_tokens);
        if (anthropicUsage.cache_read_input_tokens !== void 0) $02613615bf13ba44$var$setNumberIfDefined(attrs, $9QwBg.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.cache_read_input_tokens);
    }
}
function $02613615bf13ba44$var$extractLlmResponseAttributes(llmResult, recordOutputs) {
    if (!llmResult) return;
    const attrs = {};
    if (Array.isArray(llmResult.generations)) {
        const finishReasons = llmResult.generations.flat().map((g)=>{
            if (g.generationInfo?.finish_reason) return g.generationInfo.finish_reason;
            if (g.generation_info?.finish_reason) return g.generation_info.finish_reason;
            return null;
        }).filter((r)=>typeof r === "string");
        if (finishReasons.length > 0) $02613615bf13ba44$var$setIfDefined(attrs, $9QwBg.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE, $erV30.stringify(finishReasons, String));
        $02613615bf13ba44$var$addToolCallsAttributes(llmResult.generations, attrs);
        if (recordOutputs) {
            const texts = llmResult.generations.flat().map((gen)=>gen.text ?? gen.message?.content).filter((t)=>typeof t === "string");
            if (texts.length > 0) $02613615bf13ba44$var$setIfDefined(attrs, $9QwBg.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, $erV30.stringify(texts, String));
        }
    }
    $02613615bf13ba44$var$addTokenUsageAttributes(llmResult.llmOutput, attrs);
    const llmOutput = llmResult.llmOutput;
    const firstGeneration = llmResult.generations?.[0]?.[0];
    const v1Message = firstGeneration?.message;
    const modelName = llmOutput?.model_name ?? llmOutput?.model ?? v1Message?.response_metadata?.model_name;
    if (modelName) $02613615bf13ba44$var$setIfDefined(attrs, $9QwBg.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, modelName);
    const responseId = llmOutput?.id ?? v1Message?.id;
    if (responseId) $02613615bf13ba44$var$setIfDefined(attrs, $9QwBg.GEN_AI_RESPONSE_ID_ATTRIBUTE, responseId);
    const stopReason = llmOutput?.stop_reason ?? v1Message?.response_metadata?.finish_reason;
    if (stopReason) $02613615bf13ba44$var$setIfDefined(attrs, $9QwBg.GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE, $erV30.stringify(stopReason, String));
    return attrs;
}
function $02613615bf13ba44$var$getAgentNameFromMetadata(metadata) {
    const attrs = {};
    const agentName = metadata?.lc_agent_name;
    if (typeof agentName === "string") attrs[$9QwBg.GEN_AI_AGENT_NAME_ATTRIBUTE] = agentName;
    return attrs;
}
function $02613615bf13ba44$var$extractToolDefinitions(extraParams) {
    const tools = extraParams?.invocation_params?.tools ?? extraParams?.options?.tools;
    if (!Array.isArray(tools) || tools.length === 0) return void 0;
    const toolDefs = tools.map((tool)=>{
        const fn = tool.function;
        return {
            type: "function",
            name: tool.name ?? fn?.name ?? "",
            description: tool.description ?? fn?.description
        };
    });
    return JSON.stringify(toolDefs);
}
function $02613615bf13ba44$var$isCallbackManager(value) {
    if (!value || typeof value !== "object") return false;
    const candidate = value;
    return typeof candidate.addHandler === "function" && typeof candidate.copy === "function";
}
function $02613615bf13ba44$var$isSentryHandler(handler) {
    return typeof handler === "object" && handler?.name === "SentryCallbackHandler";
}
function $02613615bf13ba44$var$containsSentryHandler(handlers) {
    return handlers.some($02613615bf13ba44$var$isSentryHandler);
}
function $02613615bf13ba44$var$_INTERNAL_mergeLangChainCallbackHandler(existing, sentryHandler) {
    if (!existing) return [
        sentryHandler
    ];
    if ($02613615bf13ba44$var$isCallbackManager(existing)) {
        if ($02613615bf13ba44$var$containsSentryHandler(existing.handlers ?? [])) return existing;
        const copied = existing.copy();
        copied.addHandler(sentryHandler, true);
        return copied;
    }
    const handlers = Array.isArray(existing) ? existing : [
        existing
    ];
    if ($02613615bf13ba44$var$containsSentryHandler(handlers)) return existing;
    return [
        ...handlers,
        sentryHandler
    ];
}
module.exports._INTERNAL_mergeLangChainCallbackHandler = $02613615bf13ba44$var$_INTERNAL_mergeLangChainCallbackHandler;
module.exports.extractChatModelRequestAttributes = $02613615bf13ba44$var$extractChatModelRequestAttributes;
module.exports.extractLLMRequestAttributes = $02613615bf13ba44$var$extractLLMRequestAttributes;
module.exports.extractLlmResponseAttributes = $02613615bf13ba44$var$extractLlmResponseAttributes;
module.exports.extractToolDefinitions = $02613615bf13ba44$var$extractToolDefinitions;
module.exports.getAgentNameFromMetadata = $02613615bf13ba44$var$getAgentNameFromMetadata;
module.exports.getInvocationParams = $02613615bf13ba44$var$getInvocationParams;
module.exports.normalizeLangChainMessages = $02613615bf13ba44$var$normalizeLangChainMessages;

});


parcelRegister("ebmb1", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dknph = parcelRequire("dknph");

var $d7AD6 = parcelRequire("d7AD6");

var $9QwBg = parcelRequire("9QwBg");

var $4htth = parcelRequire("4htth");

var $jpH30 = parcelRequire("jpH30");
function $a5334b97b1c9d12d$var$inferSystemFromInstance(instance) {
    const name = instance.constructor?.name ?? "";
    if (name.includes("OpenAI")) return "openai";
    if (name.includes("Google")) return "google_genai";
    if (name.includes("Mistral")) return "mistralai";
    if (name.includes("Vertex")) return "google_vertexai";
    if (name.includes("Bedrock")) return "aws_bedrock";
    if (name.includes("Ollama")) return "ollama";
    if (name.includes("Cloudflare")) return "cloudflare";
    if (name.includes("Cohere")) return "cohere";
    return "langchain";
}
function $a5334b97b1c9d12d$var$extractEmbeddingAttributes(instance) {
    const embeddingsInstance = instance ?? {};
    const attributes = {
        [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $jpH30.LANGCHAIN_ORIGIN,
        [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $9QwBg.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE,
        [$9QwBg.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "embeddings",
        [$9QwBg.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: embeddingsInstance.model ?? "unknown"
    };
    attributes[$9QwBg.GEN_AI_SYSTEM_ATTRIBUTE] = $a5334b97b1c9d12d$var$inferSystemFromInstance(embeddingsInstance);
    if ("dimensions" in embeddingsInstance) attributes[$9QwBg.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE] = embeddingsInstance.dimensions;
    if ("encodingFormat" in embeddingsInstance) attributes[$9QwBg.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE] = embeddingsInstance.encodingFormat;
    return attributes;
}
function $a5334b97b1c9d12d$var$_INTERNAL_getLangChainEmbeddingsSpanOptions(instance, input, options = {}) {
    const { recordInputs: recordInputs } = $4htth.resolveAIRecordingOptions(options);
    const attributes = $a5334b97b1c9d12d$var$extractEmbeddingAttributes(instance);
    const modelName = attributes[$9QwBg.GEN_AI_REQUEST_MODEL_ATTRIBUTE] || "unknown";
    if (recordInputs && input != null) attributes[$9QwBg.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE] = typeof input === "string" ? input : JSON.stringify(input);
    return {
        name: `embeddings ${modelName}`,
        op: $9QwBg.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE,
        attributes: attributes
    };
}
function $a5334b97b1c9d12d$var$instrumentEmbeddingMethod(originalMethod, options = {}) {
    return new Proxy(originalMethod, {
        apply (target, thisArg, args) {
            return $d7AD6.startSpan($a5334b97b1c9d12d$var$_INTERNAL_getLangChainEmbeddingsSpanOptions(thisArg, args[0], options), ()=>{
                return Reflect.apply(target, thisArg, args);
            });
        }
    });
}
function $a5334b97b1c9d12d$var$instrumentLangChainEmbeddings(instance, options) {
    const embeddingsInstance = instance;
    if (typeof embeddingsInstance.embedQuery === "function") embeddingsInstance.embedQuery = $a5334b97b1c9d12d$var$instrumentEmbeddingMethod(embeddingsInstance.embedQuery, options);
    if (typeof embeddingsInstance.embedDocuments === "function") embeddingsInstance.embedDocuments = $a5334b97b1c9d12d$var$instrumentEmbeddingMethod(embeddingsInstance.embedDocuments, options);
    return instance;
}
module.exports._INTERNAL_getLangChainEmbeddingsSpanOptions = $a5334b97b1c9d12d$var$_INTERNAL_getLangChainEmbeddingsSpanOptions;
module.exports.instrumentEmbeddingMethod = $a5334b97b1c9d12d$var$instrumentEmbeddingMethod;
module.exports.instrumentLangChainEmbeddings = $a5334b97b1c9d12d$var$instrumentLangChainEmbeddings;

});

parcelRegister("6ZCTz", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dknph = parcelRequire("dknph");

var $erV30 = parcelRequire("erV30");

var $3su1E = parcelRequire("3su1E");

var $d7AD6 = parcelRequire("d7AD6");

var $9QwBg = parcelRequire("9QwBg");

var $4htth = parcelRequire("4htth");

var $4PbDj = parcelRequire("4PbDj");

var $cFmVy = parcelRequire("cFmVy");

var $kYMFh = parcelRequire("kYMFh");

var $jEfDT = parcelRequire("jEfDT");
let $51769c625b116287$var$_insideCreateReactAgent = false;
const $51769c625b116287$var$SENTRY_PATCHED = "__sentry_patched__";
function $51769c625b116287$var$_INTERNAL_getLangGraphCreateAgentSpanOptions(agentName) {
    const attributes = {
        [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $kYMFh.LANGGRAPH_ORIGIN,
        [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.create_agent",
        [$9QwBg.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "create_agent"
    };
    if (agentName) attributes[$9QwBg.GEN_AI_AGENT_NAME_ATTRIBUTE] = agentName;
    return {
        op: "gen_ai.create_agent",
        name: agentName ? `create_agent ${agentName}` : "create_agent",
        attributes: attributes
    };
}
function $51769c625b116287$var$instrumentStateGraphCompile(originalCompile, options) {
    if (Object.prototype.hasOwnProperty.call(originalCompile, $51769c625b116287$var$SENTRY_PATCHED)) return originalCompile;
    const sentryHandler = $4PbDj.createLangChainCallbackHandler(options);
    const wrapped = new Proxy(originalCompile, {
        apply (target, thisArg, args) {
            if ($51769c625b116287$var$_insideCreateReactAgent) return Reflect.apply(target, thisArg, args);
            return $d7AD6.startSpan($51769c625b116287$var$_INTERNAL_getLangGraphCreateAgentSpanOptions(), (span)=>{
                try {
                    const compiledGraph = Reflect.apply(target, thisArg, args);
                    const compileOptions = args.length > 0 ? args[0] : {};
                    if (compileOptions?.name && typeof compileOptions.name === "string") {
                        span.setAttribute($9QwBg.GEN_AI_AGENT_NAME_ATTRIBUTE, compileOptions.name);
                        span.updateName(`create_agent ${compileOptions.name}`);
                    }
                    const originalInvoke = compiledGraph.invoke;
                    if (originalInvoke && typeof originalInvoke === "function") compiledGraph.invoke = $51769c625b116287$var$instrumentCompiledGraphInvoke(originalInvoke.bind(compiledGraph), compiledGraph, compileOptions, options, void 0, sentryHandler);
                    return compiledGraph;
                } catch (error) {
                    span.setStatus({
                        code: $3su1E.SPAN_STATUS_ERROR,
                        message: "internal_error"
                    });
                    throw error;
                }
            });
        }
    });
    Object.defineProperty(wrapped, $51769c625b116287$var$SENTRY_PATCHED, {
        value: true,
        enumerable: false
    });
    return wrapped;
}
function $51769c625b116287$var$instrumentCompiledGraphInvoke(originalInvoke, graphInstance, compileOptions, options, llm, sentryCallbackHandler) {
    return new Proxy(originalInvoke, {
        apply (target, thisArg, args) {
            const modelName = llm?.modelName ?? llm?.model;
            return $d7AD6.startSpan({
                op: "gen_ai.invoke_agent",
                name: "invoke_agent",
                attributes: {
                    [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $kYMFh.LANGGRAPH_ORIGIN,
                    [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $9QwBg.GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE,
                    [$9QwBg.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "invoke_agent"
                }
            }, async (span)=>{
                try {
                    const graphName = compileOptions?.name;
                    if (graphName && typeof graphName === "string") {
                        span.setAttribute($9QwBg.GEN_AI_PIPELINE_NAME_ATTRIBUTE, graphName);
                        span.setAttribute($9QwBg.GEN_AI_AGENT_NAME_ATTRIBUTE, graphName);
                        span.updateName(`invoke_agent ${graphName}`);
                    }
                    if (modelName) span.setAttribute($9QwBg.GEN_AI_REQUEST_MODEL_ATTRIBUTE, modelName);
                    const config = args.length > 1 ? args[1] : void 0;
                    const configurable = config?.configurable;
                    const threadId = configurable?.thread_id;
                    if (threadId && typeof threadId === "string") span.setAttribute($9QwBg.GEN_AI_CONVERSATION_ID_ATTRIBUTE, threadId);
                    if (sentryCallbackHandler) {
                        const invokeConfig = args[1] ?? {};
                        args[1] = invokeConfig;
                        const existingMetadata = invokeConfig.metadata ?? {};
                        invokeConfig.metadata = {
                            ...existingMetadata,
                            __sentry_langgraph__: true,
                            ...typeof graphName === "string" ? {
                                lc_agent_name: graphName
                            } : {}
                        };
                        invokeConfig.callbacks = $cFmVy._INTERNAL_mergeLangChainCallbackHandler(invokeConfig.callbacks, sentryCallbackHandler);
                    }
                    const tools = $jEfDT.extractToolsFromCompiledGraph(graphInstance);
                    if (tools) span.setAttribute($9QwBg.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE, JSON.stringify(tools));
                    const recordInputs = options.recordInputs;
                    const recordOutputs = options.recordOutputs;
                    const inputMessages = args.length > 0 ? args[0]?.messages ?? [] : [];
                    if (inputMessages && recordInputs) {
                        const normalizedMessages = $cFmVy.normalizeLangChainMessages(inputMessages);
                        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $4htth.extractSystemInstructions(normalizedMessages);
                        if (systemInstructions) span.setAttribute($9QwBg.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
                        const enableTruncation = $4htth.shouldEnableTruncation(options.enableTruncation);
                        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
                        span.setAttributes({
                            [$9QwBg.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $4htth.getTruncatedJsonString(filteredMessages) : $erV30.stringify(filteredMessages),
                            [$9QwBg.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
                        });
                    }
                    const result = await Reflect.apply(target, thisArg, args);
                    if (recordOutputs) $jEfDT.setResponseAttributes(span, inputMessages ?? null, result);
                    return result;
                } catch (error) {
                    span.setStatus({
                        code: $3su1E.SPAN_STATUS_ERROR,
                        message: "internal_error"
                    });
                    throw error;
                }
            });
        }
    });
}
function $51769c625b116287$var$instrumentCreateReactAgent(originalCreateReactAgent, options) {
    if (Object.prototype.hasOwnProperty.call(originalCreateReactAgent, $51769c625b116287$var$SENTRY_PATCHED)) return originalCreateReactAgent;
    const resolvedOptions = $4htth.resolveAIRecordingOptions(options);
    const sentryHandler = $4PbDj.createLangChainCallbackHandler(resolvedOptions);
    const wrapped = new Proxy(originalCreateReactAgent, {
        apply (target, thisArg, args) {
            const llm = $jEfDT.extractLLMFromParams(args);
            const agentName = $jEfDT.extractAgentNameFromParams(args);
            const params = args[0];
            if (params && Array.isArray(params.tools) && params.tools.length > 0) $jEfDT.wrapToolsWithSpans(params.tools, resolvedOptions, agentName ?? void 0);
            $51769c625b116287$var$_insideCreateReactAgent = true;
            let compiledGraph;
            try {
                compiledGraph = Reflect.apply(target, thisArg, args);
            } finally{
                $51769c625b116287$var$_insideCreateReactAgent = false;
            }
            const originalInvoke = compiledGraph.invoke;
            if (originalInvoke && typeof originalInvoke === "function") {
                const compileOptions = {};
                if (agentName) compileOptions.name = agentName;
                compiledGraph.invoke = $51769c625b116287$var$instrumentCompiledGraphInvoke(originalInvoke.bind(compiledGraph), compiledGraph, compileOptions, resolvedOptions, llm, sentryHandler);
            }
            return compiledGraph;
        }
    });
    Object.defineProperty(wrapped, $51769c625b116287$var$SENTRY_PATCHED, {
        value: true,
        enumerable: false
    });
    return wrapped;
}
function $51769c625b116287$var$instrumentStateGraph(stateGraph, options) {
    stateGraph.compile = $51769c625b116287$var$instrumentStateGraphCompile(stateGraph.compile, $4htth.resolveAIRecordingOptions(options));
    return stateGraph;
}
const $51769c625b116287$var$instrumentLangGraph = $51769c625b116287$var$instrumentStateGraph;
module.exports._INTERNAL_getLangGraphCreateAgentSpanOptions = $51769c625b116287$var$_INTERNAL_getLangGraphCreateAgentSpanOptions;
module.exports.instrumentCompiledGraphInvoke = $51769c625b116287$var$instrumentCompiledGraphInvoke;
module.exports.instrumentCreateReactAgent = $51769c625b116287$var$instrumentCreateReactAgent;
module.exports.instrumentLangGraph = $51769c625b116287$var$instrumentLangGraph;
module.exports.instrumentStateGraph = $51769c625b116287$var$instrumentStateGraph;
module.exports.instrumentStateGraphCompile = $51769c625b116287$var$instrumentStateGraphCompile;

});
parcelRegister("kYMFh", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $f45f290b8ff0fc4d$var$LANGGRAPH_INTEGRATION_NAME = "LangGraph";
const $f45f290b8ff0fc4d$var$LANGGRAPH_ORIGIN = "auto.ai.langgraph";
module.exports.LANGGRAPH_INTEGRATION_NAME = $f45f290b8ff0fc4d$var$LANGGRAPH_INTEGRATION_NAME;
module.exports.LANGGRAPH_ORIGIN = $f45f290b8ff0fc4d$var$LANGGRAPH_ORIGIN;

});

parcelRegister("jEfDT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dknph = parcelRequire("dknph");

var $3su1E = parcelRequire("3su1E");

var $d7AD6 = parcelRequire("d7AD6");

var $9QwBg = parcelRequire("9QwBg");

var $cFmVy = parcelRequire("cFmVy");

var $kYMFh = parcelRequire("kYMFh");
function $e4dde304daf21fe3$var$extractLLMFromParams(args) {
    const arg = args[0];
    if (typeof arg !== "object" || !arg || !("llm" in arg) || !arg.llm || typeof arg.llm !== "object") return null;
    const llm = arg.llm;
    if (typeof llm.modelName !== "string" && typeof llm.model !== "string") return null;
    return llm;
}
function $e4dde304daf21fe3$var$extractAgentNameFromParams(args) {
    const arg = args[0];
    if (typeof arg === "object" && !!arg && "name" in arg && typeof arg.name === "string") return arg.name;
    return null;
}
function $e4dde304daf21fe3$var$wrapToolsWithSpans(tools, options, agentName) {
    const SENTRY_WRAPPED = "__sentry_tool_wrapped__";
    for (const tool of tools){
        if (!tool || typeof tool !== "object") continue;
        const t = tool;
        const originalInvoke = t.invoke;
        if (typeof originalInvoke !== "function" || Object.prototype.hasOwnProperty.call(t, SENTRY_WRAPPED)) continue;
        const toolName = typeof t.name === "string" ? t.name : "unknown_tool";
        const toolDescription = typeof t.description === "string" ? t.description : void 0;
        const wrappedInvoke = new Proxy(originalInvoke, {
            apply (target, thisArg, args) {
                const spanAttributes = {
                    [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $kYMFh.LANGGRAPH_ORIGIN,
                    [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $9QwBg.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE,
                    [$9QwBg.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "execute_tool",
                    [$9QwBg.GEN_AI_TOOL_NAME_ATTRIBUTE]: toolName,
                    [$9QwBg.GEN_AI_TOOL_TYPE_ATTRIBUTE]: "function"
                };
                const callConfig = args[1];
                const callAgentName = callConfig?.metadata?.lc_agent_name ?? agentName;
                if (typeof callAgentName === "string") spanAttributes[$9QwBg.GEN_AI_AGENT_NAME_ATTRIBUTE] = callAgentName;
                if (toolDescription) spanAttributes[$9QwBg.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = toolDescription;
                const input = args[0];
                if (typeof input === "object" && !!input) {
                    if ("id" in input && typeof input.id === "string") spanAttributes[$9QwBg.GEN_AI_TOOL_CALL_ID_ATTRIBUTE] = input.id;
                    if (options.recordInputs) {
                        const toolArgs = "args" in input && typeof input.args === "object" ? input.args : input;
                        try {
                            spanAttributes[$9QwBg.GEN_AI_TOOL_INPUT_ATTRIBUTE] = JSON.stringify(toolArgs);
                        } catch  {}
                    }
                }
                return $d7AD6.startSpan({
                    op: $9QwBg.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE,
                    name: `execute_tool ${toolName}`,
                    attributes: spanAttributes
                }, async (span)=>{
                    try {
                        const result = await Reflect.apply(target, thisArg, args);
                        if (options.recordOutputs) try {
                            const resultObj = result;
                            const content = resultObj && typeof resultObj === "object" && "content" in resultObj ? resultObj.content : result;
                            span.setAttribute($9QwBg.GEN_AI_TOOL_OUTPUT_ATTRIBUTE, typeof content === "string" ? content : JSON.stringify(content));
                        } catch  {}
                        return result;
                    } catch (error) {
                        span.setStatus({
                            code: $3su1E.SPAN_STATUS_ERROR,
                            message: "internal_error"
                        });
                        throw error;
                    }
                });
            }
        });
        t.invoke = wrappedInvoke;
        Object.defineProperty(t, SENTRY_WRAPPED, {
            value: true,
            enumerable: false
        });
    }
    return tools;
}
function $e4dde304daf21fe3$var$extractToolCalls(messages) {
    if (!messages || messages.length === 0) return null;
    const toolCalls = [];
    for (const message of messages)if (message && typeof message === "object") {
        const msgToolCalls = message.tool_calls;
        if (msgToolCalls && Array.isArray(msgToolCalls)) toolCalls.push(...msgToolCalls);
    }
    return toolCalls.length > 0 ? toolCalls : null;
}
function $e4dde304daf21fe3$var$extractTokenUsageFromMessage(message) {
    const msg = message;
    let inputTokens = 0;
    let outputTokens = 0;
    let totalTokens = 0;
    if (msg.usage_metadata && typeof msg.usage_metadata === "object") {
        const usage = msg.usage_metadata;
        if (typeof usage.input_tokens === "number") inputTokens = usage.input_tokens;
        if (typeof usage.output_tokens === "number") outputTokens = usage.output_tokens;
        if (typeof usage.total_tokens === "number") totalTokens = usage.total_tokens;
        return {
            inputTokens: inputTokens,
            outputTokens: outputTokens,
            totalTokens: totalTokens
        };
    }
    if (msg.response_metadata && typeof msg.response_metadata === "object") {
        const metadata = msg.response_metadata;
        if (metadata.tokenUsage && typeof metadata.tokenUsage === "object") {
            const tokenUsage = metadata.tokenUsage;
            if (typeof tokenUsage.promptTokens === "number") inputTokens = tokenUsage.promptTokens;
            if (typeof tokenUsage.completionTokens === "number") outputTokens = tokenUsage.completionTokens;
            if (typeof tokenUsage.totalTokens === "number") totalTokens = tokenUsage.totalTokens;
        }
    }
    return {
        inputTokens: inputTokens,
        outputTokens: outputTokens,
        totalTokens: totalTokens
    };
}
function $e4dde304daf21fe3$var$extractModelMetadata(span, message) {
    const msg = message;
    if (msg.response_metadata && typeof msg.response_metadata === "object") {
        const metadata = msg.response_metadata;
        if (metadata.model_name && typeof metadata.model_name === "string") span.setAttribute($9QwBg.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, metadata.model_name);
        if (metadata.finish_reason && typeof metadata.finish_reason === "string") span.setAttribute($9QwBg.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE, [
            metadata.finish_reason
        ]);
    }
}
function $e4dde304daf21fe3$var$extractToolsFromCompiledGraph(compiledGraph) {
    if (!compiledGraph.builder?.nodes?.tools?.runnable?.tools) return null;
    const tools = compiledGraph.builder?.nodes?.tools?.runnable?.tools;
    if (!tools || !Array.isArray(tools) || tools.length === 0) return null;
    return tools.map((tool)=>({
            name: tool.lc_kwargs?.name,
            description: tool.lc_kwargs?.description,
            schema: tool.lc_kwargs?.schema
        }));
}
function $e4dde304daf21fe3$var$setResponseAttributes(span, inputMessages, result) {
    const resultObj = result;
    const outputMessages = resultObj?.messages;
    if (!outputMessages || !Array.isArray(outputMessages)) return;
    const inputCount = inputMessages?.length ?? 0;
    const newMessages = outputMessages.length > inputCount ? outputMessages.slice(inputCount) : [];
    if (newMessages.length === 0) return;
    const toolCalls = $e4dde304daf21fe3$var$extractToolCalls(newMessages);
    if (toolCalls) span.setAttribute($9QwBg.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, JSON.stringify(toolCalls));
    const normalizedNewMessages = $cFmVy.normalizeLangChainMessages(newMessages);
    span.setAttribute($9QwBg.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, JSON.stringify(normalizedNewMessages));
    let totalInputTokens = 0;
    let totalOutputTokens = 0;
    let totalTokens = 0;
    for (const message of newMessages){
        const tokens = $e4dde304daf21fe3$var$extractTokenUsageFromMessage(message);
        totalInputTokens += tokens.inputTokens;
        totalOutputTokens += tokens.outputTokens;
        totalTokens += tokens.totalTokens;
        $e4dde304daf21fe3$var$extractModelMetadata(span, message);
    }
    if (totalInputTokens > 0) span.setAttribute($9QwBg.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, totalInputTokens);
    if (totalOutputTokens > 0) span.setAttribute($9QwBg.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, totalOutputTokens);
    if (totalTokens > 0) span.setAttribute($9QwBg.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, totalTokens);
}
module.exports.extractAgentNameFromParams = $e4dde304daf21fe3$var$extractAgentNameFromParams;
module.exports.extractLLMFromParams = $e4dde304daf21fe3$var$extractLLMFromParams;
module.exports.extractModelMetadata = $e4dde304daf21fe3$var$extractModelMetadata;
module.exports.extractTokenUsageFromMessage = $e4dde304daf21fe3$var$extractTokenUsageFromMessage;
module.exports.extractToolCalls = $e4dde304daf21fe3$var$extractToolCalls;
module.exports.extractToolsFromCompiledGraph = $e4dde304daf21fe3$var$extractToolsFromCompiledGraph;
module.exports.setResponseAttributes = $e4dde304daf21fe3$var$setResponseAttributes;
module.exports.wrapToolsWithSpans = $e4dde304daf21fe3$var$wrapToolsWithSpans;

});


parcelRegister("g9OND", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eMfEg = parcelRequire("eMfEg");

var $3su1E = parcelRequire("3su1E");

var $d7AD6 = parcelRequire("d7AD6");

var $71viH = parcelRequire("71viH");

var $4htth = parcelRequire("4htth");

var $4GqxV = parcelRequire("4GqxV");

var $hN2RX = parcelRequire("hN2RX");

var $dxsDf = parcelRequire("dxsDf");
function $bc34e4574475874c$var$isReadableStream(value) {
    return $eMfEg.isObjectLike(value) && typeof value.pipeThrough === "function" && typeof value.getReader === "function";
}
function $bc34e4574475874c$var$instrumentRun(originalRun, context, options) {
    return function instrumentedRun(...args) {
        if ($71viH._INTERNAL_shouldSkipAiProviderWrapping($4GqxV.WORKERS_AI_INTEGRATION_NAME)) return originalRun.apply(context, args);
        const [model, inputs, runOptions] = args;
        const operationName = $dxsDf.getOperationName(inputs);
        const requestAttributes = $dxsDf.extractRequestAttributes(model, inputs, operationName);
        const modelName = typeof model === "string" ? model : "unknown";
        const isStreamRequested = !!inputs && typeof inputs === "object" && inputs.stream === true;
        const returnsRawResponse = !!runOptions && typeof runOptions === "object" && (runOptions.returnRawResponse === true || runOptions.websocket === true);
        const spanConfig = {
            name: `${operationName} ${modelName}`,
            op: `gen_ai.${operationName}`,
            attributes: requestAttributes
        };
        if (isStreamRequested && !returnsRawResponse) return $d7AD6.startSpanManual(spanConfig, (span)=>{
            const handleError = (error)=>{
                span.setStatus({
                    code: $3su1E.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                span.end();
                throw error;
            };
            let originalResult;
            try {
                originalResult = originalRun.apply(context, args);
            } catch (error) {
                return handleError(error);
            }
            if (options.recordInputs) $dxsDf.addRequestAttributes(span, inputs, operationName, $4htth.shouldEnableTruncation(options.enableTruncation));
            return originalResult.then((result)=>{
                if ($bc34e4574475874c$var$isReadableStream(result)) return $hN2RX.instrumentWorkersAiStream(result, span, options.recordOutputs);
                $dxsDf.addResponseAttributes(span, result, options.recordOutputs);
                span.end();
                return result;
            }, handleError);
        });
        return $d7AD6.startSpan(spanConfig, (span)=>{
            const originalResult = originalRun.apply(context, args);
            if (options.recordInputs) $dxsDf.addRequestAttributes(span, inputs, operationName, $4htth.shouldEnableTruncation(options.enableTruncation));
            return originalResult.then((result)=>{
                if (!returnsRawResponse) $dxsDf.addResponseAttributes(span, result, options.recordOutputs);
                return result;
            });
        });
    };
}
function $bc34e4574475874c$var$instrumentWorkersAiClient(client, options) {
    const resolvedOptions = $4htth.resolveAIRecordingOptions(options);
    const instrumented = new Proxy(client, {
        get (target, prop, receiver) {
            const value = Reflect.get(target, prop, receiver);
            if (prop === "run" && typeof value === "function") return $bc34e4574475874c$var$instrumentRun(value, target, resolvedOptions);
            return typeof value === "function" ? value.bind(target) : value;
        }
    });
    return instrumented;
}
module.exports.instrumentWorkersAiClient = $bc34e4574475874c$var$instrumentWorkersAiClient;

});
parcelRegister("hN2RX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3su1E = parcelRequire("3su1E");

var $4htth = parcelRequire("4htth");

var $dxsDf = parcelRequire("dxsDf");
function $cf393d0fd08a6429$var$accumulateStreamingToolCalls(toolCalls, accumulator) {
    for (const toolCall of toolCalls){
        const name = toolCall.function?.name ?? toolCall.name;
        const args = toolCall.function?.arguments ?? toolCall.arguments;
        if (name == null && args == null) continue;
        const index = toolCall.index ?? 0;
        const existing = accumulator[index];
        if (!existing) accumulator[index] = {
            index: index,
            id: toolCall.id,
            type: toolCall.type,
            function: {
                name: name,
                arguments: args ?? ""
            }
        };
        else if (existing.function) {
            if (name && !existing.function.name) existing.function.name = name;
            if (args) existing.function.arguments = `${existing.function.arguments ?? ""}${args}`;
        }
    }
}
function $cf393d0fd08a6429$var$processLine(line, state, recordOutputs, toolCallAccumulator) {
    const trimmed = line.trim();
    if (!trimmed.startsWith("data:")) return;
    const data = trimmed.slice(5).trim();
    if (!data || data === "[DONE]") return;
    let parsed;
    try {
        parsed = JSON.parse(data);
    } catch  {
        return;
    }
    if (parsed.usage) {
        if (typeof parsed.usage.prompt_tokens === "number") state.promptTokens = parsed.usage.prompt_tokens;
        if (typeof parsed.usage.completion_tokens === "number") state.completionTokens = parsed.usage.completion_tokens;
        if (typeof parsed.usage.total_tokens === "number") state.totalTokens = parsed.usage.total_tokens;
    }
    if (recordOutputs && typeof parsed.response === "string") state.responseTexts.push(parsed.response);
    if (recordOutputs && Array.isArray(parsed.tool_calls) && parsed.tool_calls.length > 0) state.toolCalls.push(...parsed.tool_calls);
    if (Array.isArray(parsed.choices)) for (const choice of parsed.choices){
        if (recordOutputs && typeof choice.delta?.content === "string" && choice.delta.content) state.responseTexts.push(choice.delta.content);
        if (recordOutputs && Array.isArray(choice.delta?.tool_calls)) $cf393d0fd08a6429$var$accumulateStreamingToolCalls(choice.delta.tool_calls, toolCallAccumulator);
        if (typeof choice.finish_reason === "string") state.finishReasons.push(choice.finish_reason);
    }
}
function $cf393d0fd08a6429$var$instrumentWorkersAiStream(stream, span, recordOutputs) {
    const reader = stream.getReader();
    const decoder = new TextDecoder();
    const state = {
        responseId: "",
        responseModel: "",
        finishReasons: [],
        responseTexts: [],
        toolCalls: [],
        promptTokens: void 0,
        completionTokens: void 0,
        totalTokens: void 0
    };
    const toolCallAccumulator = {};
    let buffer = "";
    let spanEnded = false;
    const finish = ()=>{
        if (spanEnded) return;
        spanEnded = true;
        if (recordOutputs) {
            const accumulatedToolCalls = Object.values(toolCallAccumulator);
            if (accumulatedToolCalls.length > 0) state.toolCalls.push(...accumulatedToolCalls);
            $dxsDf.setOutputMessagesAttribute(span, {
                responseText: state.responseTexts.join(""),
                toolCalls: state.toolCalls
            });
        }
        $4htth.endStreamSpan(span, state, recordOutputs);
    };
    const flushBuffer = (isDone)=>{
        const lines = buffer.split("\n");
        buffer = isDone ? "" : lines.pop() ?? "";
        for (const line of lines)$cf393d0fd08a6429$var$processLine(line, state, recordOutputs, toolCallAccumulator);
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await reader.read();
                if (done) {
                    buffer += decoder.decode();
                    flushBuffer(true);
                    finish();
                    controller.close();
                    return;
                }
                buffer += decoder.decode(value, {
                    stream: true
                });
                flushBuffer(false);
                controller.enqueue(value);
            } catch (error) {
                span.setStatus({
                    code: $3su1E.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                finish();
                controller.error(error);
            }
        },
        async cancel (reason) {
            finish();
            await reader.cancel(reason);
        }
    });
}
module.exports.instrumentWorkersAiStream = $cf393d0fd08a6429$var$instrumentWorkersAiStream;

});
parcelRegister("dxsDf", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iuxoj = parcelRequire("iuxoj");

var $dknph = parcelRequire("dknph");

var $9QwBg = parcelRequire("9QwBg");

var $4htth = parcelRequire("4htth");

var $erV30 = parcelRequire("erV30");

var $4GqxV = parcelRequire("4GqxV");
function $9db4912b04451a94$var$getOperationName(inputs) {
    if (inputs && typeof inputs === "object") {
        if ("messages" in inputs || "prompt" in inputs) return "chat";
        if ("text" in inputs) return "embeddings";
    }
    return "chat";
}
function $9db4912b04451a94$var$extractRequestAttributes(model, inputs, operationName) {
    const attributes$1 = {
        [$iuxoj.GEN_AI_PROVIDER_NAME]: $4GqxV.WORKERS_AI_PROVIDER_NAME,
        [$iuxoj.GEN_AI_OPERATION_NAME]: operationName,
        [$dknph.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $4GqxV.WORKERS_AI_ORIGIN,
        [$iuxoj.GEN_AI_REQUEST_MODEL]: typeof model === "string" ? model : "unknown"
    };
    if (inputs && typeof inputs === "object") {
        const params = inputs;
        if (typeof params.temperature === "number") attributes$1[$iuxoj.GEN_AI_REQUEST_TEMPERATURE] = params.temperature;
        if (typeof params.max_tokens === "number") attributes$1[$iuxoj.GEN_AI_REQUEST_MAX_TOKENS] = params.max_tokens;
        if (typeof params.top_p === "number") attributes$1[$iuxoj.GEN_AI_REQUEST_TOP_P] = params.top_p;
        if (typeof params.top_k === "number") attributes$1[$iuxoj.GEN_AI_REQUEST_TOP_K] = params.top_k;
        if (typeof params.frequency_penalty === "number") attributes$1[$iuxoj.GEN_AI_REQUEST_FREQUENCY_PENALTY] = params.frequency_penalty;
        if (typeof params.presence_penalty === "number") attributes$1[$iuxoj.GEN_AI_REQUEST_PRESENCE_PENALTY] = params.presence_penalty;
        if (params.stream === true) attributes$1[$9QwBg.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = true;
    }
    return attributes$1;
}
function $9db4912b04451a94$var$addRequestAttributes(span, inputs, operationName, enableTruncation) {
    if (!inputs || typeof inputs !== "object") return;
    const params = inputs;
    if (operationName === "embeddings") {
        const text = params.text;
        if (text == null || typeof text === "string" && text.length === 0 || Array.isArray(text) && text.length === 0) return;
        span.setAttribute($iuxoj.GEN_AI_EMBEDDINGS_INPUT, typeof text === "string" ? text : JSON.stringify(text));
        return;
    }
    const src = params.messages ?? params.prompt;
    if (src == null || Array.isArray(src) && src.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $4htth.extractSystemInstructions(src);
    if (systemInstructions) span.setAttribute($iuxoj.GEN_AI_SYSTEM_INSTRUCTIONS, systemInstructions);
    span.setAttribute($iuxoj.GEN_AI_INPUT_MESSAGES, enableTruncation ? $4htth.getTruncatedJsonString(filteredMessages) : $erV30.stringify(filteredMessages));
    span.setAttribute($9QwBg.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, Array.isArray(filteredMessages) ? filteredMessages.length : 1);
}
function $9db4912b04451a94$var$setOutputMessagesAttribute(span, { responseText: responseText, toolCalls: toolCalls }) {
    const parts = [];
    if (typeof responseText === "string" && responseText.length > 0) parts.push({
        type: "text",
        content: responseText
    });
    if (Array.isArray(toolCalls)) for (const toolCall of toolCalls){
        if (!toolCall || typeof toolCall !== "object") continue;
        const call = toolCall;
        const name = call.function?.name ?? call.name;
        const args = call.function?.arguments ?? call.arguments;
        parts.push({
            type: "tool_call",
            id: call.id,
            name: name,
            arguments: typeof args === "string" ? args : JSON.stringify(args ?? {})
        });
    }
    if (parts.length > 0) span.setAttribute($9QwBg.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE, JSON.stringify([
        {
            role: "assistant",
            parts: parts
        }
    ]));
}
function $9db4912b04451a94$var$addResponseAttributes(span, result, recordOutputs) {
    if (!result || typeof result !== "object" || // Raw `Response` objects (from `returnRawResponse`/`websocket`) cannot be introspected without consuming them.
    typeof Response !== "undefined" && result instanceof Response) return;
    const response = result;
    if (response.usage) $4htth.setTokenUsageAttributes(span, response.usage.prompt_tokens, response.usage.completion_tokens);
    if (recordOutputs) {
        let responseText;
        if (typeof response.response === "string") {
            responseText = response.response;
            span.setAttribute($9QwBg.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, response.response);
        } else if (response.response != null) {
            responseText = JSON.stringify(response.response);
            span.setAttribute($9QwBg.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, responseText);
        }
        const toolCalls = Array.isArray(response.tool_calls) && response.tool_calls.length > 0 ? response.tool_calls : void 0;
        if (toolCalls) span.setAttribute($9QwBg.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, JSON.stringify(toolCalls));
        $9db4912b04451a94$var$setOutputMessagesAttribute(span, {
            responseText: responseText,
            toolCalls: toolCalls
        });
    }
}
module.exports.addRequestAttributes = $9db4912b04451a94$var$addRequestAttributes;
module.exports.addResponseAttributes = $9db4912b04451a94$var$addResponseAttributes;
module.exports.extractRequestAttributes = $9db4912b04451a94$var$extractRequestAttributes;
module.exports.getOperationName = $9db4912b04451a94$var$getOperationName;
module.exports.setOutputMessagesAttribute = $9db4912b04451a94$var$setOutputMessagesAttribute;

});



parcelRegister("b5AAT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9Yejo = parcelRequire("9Yejo");

var $1UPRv = parcelRequire("1UPRv");

var $5wKGb = parcelRequire("5wKGb");

var $boK9h = parcelRequire("boK9h");

var $kOoLJ = parcelRequire("kOoLJ");

var $4OCL9 = parcelRequire("4OCL9");
const $812c8c2440f733cc$var$MAX_SPANS_PER_ENVELOPE = 1e3;
const $812c8c2440f733cc$var$MAX_TRACE_WEIGHT_IN_BYTES = 5e6;
class $812c8c2440f733cc$var$SpanBuffer {
    constructor(client, options){
        this._traceBuckets = /* @__PURE__ */ new Map();
        this._client = client;
        const { maxSpanLimit: maxSpanLimit, flushInterval: flushInterval, maxTraceWeightInBytes: maxTraceWeightInBytes } = options ?? {};
        this._maxSpanLimit = maxSpanLimit && maxSpanLimit > 0 && maxSpanLimit <= $812c8c2440f733cc$var$MAX_SPANS_PER_ENVELOPE ? maxSpanLimit : $812c8c2440f733cc$var$MAX_SPANS_PER_ENVELOPE;
        this._flushInterval = flushInterval && flushInterval > 0 ? flushInterval : 5e3;
        this._maxTraceWeight = maxTraceWeightInBytes && maxTraceWeightInBytes > 0 ? maxTraceWeightInBytes : $812c8c2440f733cc$var$MAX_TRACE_WEIGHT_IN_BYTES;
        this._client.on("flush", ()=>{
            this.drain();
        });
        this._client.on("close", ()=>{
            this._traceBuckets.forEach((bucket)=>{
                clearTimeout(bucket.timeout);
            });
            this._traceBuckets.clear();
        });
    }
    /**
   * Add a span to the buffer.
   */ add(spanJSON) {
        const traceId = spanJSON.trace_id;
        let bucket = this._traceBuckets.get(traceId);
        if (!bucket) {
            bucket = {
                spans: /* @__PURE__ */ new Set(),
                size: 0,
                timeout: $5wKGb.safeUnref(setTimeout(()=>{
                    this.flush(traceId);
                }, this._flushInterval))
            };
            this._traceBuckets.set(traceId, bucket);
        }
        bucket.spans.add(spanJSON);
        bucket.size += $4OCL9.estimateSerializedSpanSizeInBytes(spanJSON);
        if (bucket.spans.size >= this._maxSpanLimit || bucket.size >= this._maxTraceWeight) this.flush(traceId);
    }
    /**
   * Drain and flush all buffered traces.
   */ drain() {
        if (!this._traceBuckets.size) return;
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.log(`Flushing span tree map with ${this._traceBuckets.size} traces`);
        this._traceBuckets.forEach((_, traceId)=>{
            this.flush(traceId);
        });
    }
    /**
   * Flush spans of a specific trace.
   * In contrast to {@link SpanBuffer.drain}, this method does not flush all traces, but only the one with the given traceId.
   */ flush(traceId) {
        const bucket = this._traceBuckets.get(traceId);
        if (!bucket) return;
        if (!bucket.spans.size) {
            this._removeTrace(traceId);
            return;
        }
        const spans = Array.from(bucket.spans);
        const segmentSpan = spans[0]?._segmentSpan;
        if (!segmentSpan) {
            $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn("No segment span reference found on span JSON, cannot compute DSC");
            this._removeTrace(traceId);
            return;
        }
        const dsc = $boK9h.getDynamicSamplingContextFromSpan(segmentSpan);
        const cleanedSpans = spans.map((spanJSON)=>{
            const { _segmentSpan: _segmentSpan, ...cleanSpanJSON } = spanJSON;
            return cleanSpanJSON;
        });
        const envelope$1 = $kOoLJ.createStreamedSpanEnvelope(cleanedSpans, dsc, this._client);
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.log(`Sending span envelope for trace ${traceId} with ${cleanedSpans.length} spans`);
        this._client.sendEnvelope(envelope$1).then(null, (reason)=>{
            $9Yejo.DEBUG_BUILD && $1UPRv.debug.error("Error while sending streamed span envelope:", reason);
        });
        this._removeTrace(traceId);
    }
    _removeTrace(traceId) {
        const bucket = this._traceBuckets.get(traceId);
        if (bucket) clearTimeout(bucket.timeout);
        this._traceBuckets.delete(traceId);
    }
}
module.exports.SpanBuffer = $812c8c2440f733cc$var$SpanBuffer;

});
parcelRegister("kOoLJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dXYuT = parcelRequire("dXYuT");

var $5gI17 = parcelRequire("5gI17");

var $aFZw5 = parcelRequire("aFZw5");

var $8odom = parcelRequire("8odom");
function $f26bb0beda5a06d9$var$createStreamedSpanEnvelope(serializedSpans, dsc, client) {
    const options = client.getOptions();
    const dsn$1 = client.getDsn();
    const tunnel = options.tunnel;
    const sdk = $5gI17.getSdkMetadataForEnvelopeHeader(options._metadata);
    const headers = {
        sent_at: new Date($8odom.safeDateNow()).toISOString(),
        ...$f26bb0beda5a06d9$var$dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...sdk && {
            sdk: sdk
        },
        ...!!tunnel && dsn$1 && {
            dsn: $dXYuT.dsnToString(dsn$1)
        }
    };
    const inferSetting = client.getDataCollectionOptions().userInfo ? "auto" : "never";
    const spanContainer = [
        {
            type: "span",
            item_count: serializedSpans.length,
            content_type: "application/vnd.sentry.items.span.v2+json"
        },
        {
            version: 2,
            ...$aFZw5.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: serializedSpans
        }
    ];
    return $5gI17.createEnvelope(headers, [
        spanContainer
    ]);
}
function $f26bb0beda5a06d9$var$dscHasRequiredProps(dsc) {
    return !!dsc.trace_id && !!dsc.public_key;
}
module.exports.createStreamedSpanEnvelope = $f26bb0beda5a06d9$var$createStreamedSpanEnvelope;

});

parcelRegister("4OCL9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9eCUH = parcelRequire("9eCUH");
function $3819e5ca123ee762$var$estimateSerializedSpanSizeInBytes(span) {
    let weight = 156;
    weight += span.name.length * 2;
    weight += $9eCUH.estimateTypedAttributesSizeInBytes(span.attributes);
    if (span.links && span.links.length > 0) {
        const firstLink = span.links[0];
        const attributes$1 = firstLink?.attributes;
        const linkWeight = 100 + (attributes$1 ? $9eCUH.estimateTypedAttributesSizeInBytes(attributes$1) : 0);
        weight += linkWeight * span.links.length;
    }
    return weight;
}
module.exports.estimateSerializedSpanSizeInBytes = $3819e5ca123ee762$var$estimateSerializedSpanSizeInBytes;

});


parcelRegister("jOIOA", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9Yejo = parcelRequire("9Yejo");

var $k2EST = parcelRequire("k2EST");

var $5ob0u = parcelRequire("5ob0u");

var $3rSi0 = parcelRequire("3rSi0");

var $cGnx0 = parcelRequire("cGnx0");

var $b5AAT = parcelRequire("b5AAT");

var $1UPRv = parcelRequire("1UPRv");

var $eXvrd = parcelRequire("eXvrd");
const $e6d573207a904412$var$spanStreamingIntegration = $k2EST.defineIntegration(()=>{
    return {
        name: "SpanStreaming",
        setup (client) {
            const initialMessage = "SpanStreaming integration requires";
            const fallbackMsg = "Falling back to static trace lifecycle.";
            const clientOptions = client.getOptions();
            if (!$cGnx0.hasSpanStreamingEnabled(client)) {
                clientOptions.traceLifecycle = "static";
                $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn(`${initialMessage} \`traceLifecycle\` to be set to "stream"! ${fallbackMsg}`);
                return;
            }
            const beforeSendSpan$1 = clientOptions.beforeSendSpan;
            if (beforeSendSpan$1 && !$5ob0u.isStreamedBeforeSendSpanCallback(beforeSendSpan$1)) {
                clientOptions.traceLifecycle = "static";
                $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn(`${initialMessage} a beforeSendSpan callback using \`withStreamedSpan\`! ${fallbackMsg}`);
                return;
            }
            const buffer = new $b5AAT.SpanBuffer(client);
            client.on("afterSpanEnd", (span)=>{
                if (!$eXvrd.spanIsSampled(span)) return;
                buffer.add($3rSi0.captureSpan(span, client));
            });
        }
    };
});
module.exports.spanStreamingIntegration = $e6d573207a904412$var$spanStreamingIntegration;

});

parcelRegister("4q8ZE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $3380910b6344136f$var$getBreadcrumbLogLevelFromHttpStatusCode(statusCode) {
    if (statusCode === void 0) return void 0;
    else if (statusCode >= 400 && statusCode < 500) return "warning";
    else if (statusCode >= 500) return "error";
    else return void 0;
}
module.exports.getBreadcrumbLogLevelFromHttpStatusCode = $3380910b6344136f$var$getBreadcrumbLogLevelFromHttpStatusCode;

});

parcelRegister("hvGoi", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
class $cbf636d9c7ec3490$var$SentryError extends Error {
    constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.logLevel = logLevel;
    }
}
module.exports.SentryError = $cbf636d9c7ec3490$var$SentryError;

});

parcelRegister("ljke5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8DrvK = parcelRequire("8DrvK");

var $eMfEg = parcelRequire("eMfEg");

var $kzIHY = parcelRequire("kzIHY");

var $1HyJh = parcelRequire("1HyJh");

var $1MCl5 = parcelRequire("1MCl5");

var $YfOkS = parcelRequire("YfOkS");

var $1aID7 = parcelRequire("1aID7");
function $f83b0fce806147ad$var$addFetchInstrumentationHandler(handler, skipNativeFetchCheck) {
    const type = "fetch";
    const removeHandler = $1aID7.addHandler(type, handler);
    $1aID7.maybeInstrument(type, ()=>$f83b0fce806147ad$var$instrumentFetch(void 0, skipNativeFetchCheck));
    return removeHandler;
}
function $f83b0fce806147ad$var$addFetchEndInstrumentationHandler(handler) {
    const type = "fetch-body-resolved";
    const removeHandler = $1aID7.addHandler(type, handler);
    $1aID7.maybeInstrument(type, ()=>$f83b0fce806147ad$var$instrumentFetch($f83b0fce806147ad$var$streamHandler));
    return removeHandler;
}
function $f83b0fce806147ad$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !$1HyJh.supportsNativeFetch()) return;
    $kzIHY.fill($YfOkS.GLOBAL_OBJ, "fetch", function(originalFetch) {
        return function(...args) {
            const virtualError = new Error();
            const { method: method, url: url } = $f83b0fce806147ad$var$parseFetchArgs(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: $1MCl5.timestampInSeconds() * 1e3,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $f83b0fce806147ad$var$getHeadersFromFetchArgs(args)
            };
            if (!onFetchResolved) $1aID7.triggerHandlers("fetch", {
                ...handlerData
            });
            return originalFetch.apply($YfOkS.GLOBAL_OBJ, args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else $1aID7.triggerHandlers("fetch", {
                    ...handlerData,
                    endTimestamp: $1MCl5.timestampInSeconds() * 1e3,
                    response: response
                });
                return response;
            }, (error)=>{
                $1aID7.triggerHandlers("fetch", {
                    ...handlerData,
                    endTimestamp: $1MCl5.timestampInSeconds() * 1e3,
                    error: error
                });
                if ($eMfEg.isError(error) && error.stack === void 0) {
                    error.stack = virtualError.stack;
                    $kzIHY.addNonEnumerableProperty(error, "framesToPop", 1);
                }
                const client = $8DrvK.getClient();
                const enhanceOption = client?.getOptions().enhanceFetchErrorMessages ?? "always";
                const shouldEnhance = enhanceOption !== false;
                if (shouldEnhance && $eMfEg.isError(error) && error.name === "TypeError" && (error.message === "Failed to fetch" || error.message === "Load failed" || error.message === "NetworkError when attempting to fetch resource.")) try {
                    const url2 = new URL(handlerData.fetchData.url);
                    const hostname = url2.host;
                    if (enhanceOption === "always") error.message = `${error.message} (${hostname})`;
                    else $kzIHY.addNonEnumerableProperty(error, "__sentry_fetch_url_host__", hostname);
                } catch  {}
                throw error;
            });
        };
    });
}
async function $f83b0fce806147ad$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{});
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{});
                }, 5e3);
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch  {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{});
    }
}
function $f83b0fce806147ad$var$streamHandler(response) {
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    $f83b0fce806147ad$var$resolveResponse(clonedResponseForResolving, ()=>{
        $1aID7.triggerHandlers("fetch-body-resolved", {
            endTimestamp: $1MCl5.timestampInSeconds() * 1e3,
            response: response
        });
    });
}
function $f83b0fce806147ad$var$hasProp(obj, prop) {
    return $eMfEg.isObjectLike(obj) && !!obj[prop];
}
function $f83b0fce806147ad$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($f83b0fce806147ad$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
function $f83b0fce806147ad$var$parseFetchArgs(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [resource, options] = fetchArgs;
        return {
            url: $f83b0fce806147ad$var$getUrlFromResource(resource),
            method: $f83b0fce806147ad$var$hasProp(options, "method") ? String(options.method).toUpperCase() : // Request object as first argument
            $eMfEg.isRequest(resource) && $f83b0fce806147ad$var$hasProp(resource, "method") ? String(resource.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $f83b0fce806147ad$var$getUrlFromResource(arg),
        method: $f83b0fce806147ad$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
function $f83b0fce806147ad$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === "object" && optionsArgument !== null && "headers" in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ($eMfEg.isRequest(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {}
    return;
}
module.exports.addFetchEndInstrumentationHandler = $f83b0fce806147ad$var$addFetchEndInstrumentationHandler;
module.exports.addFetchInstrumentationHandler = $f83b0fce806147ad$var$addFetchInstrumentationHandler;
module.exports.parseFetchArgs = $f83b0fce806147ad$var$parseFetchArgs;

});
parcelRegister("1HyJh", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9Yejo = parcelRequire("9Yejo");

var $1UPRv = parcelRequire("1UPRv");

var $YfOkS = parcelRequire("YfOkS");
const $13d4bf1a3668e58f$var$WINDOW = $YfOkS.GLOBAL_OBJ;
function $13d4bf1a3668e58f$var$supportsErrorEvent() {
    try {
        new ErrorEvent("");
        return true;
    } catch  {
        return false;
    }
}
function $13d4bf1a3668e58f$var$supportsDOMError() {
    try {
        new DOMError("");
        return true;
    } catch  {
        return false;
    }
}
function $13d4bf1a3668e58f$var$supportsDOMException() {
    try {
        new DOMException("");
        return true;
    } catch  {
        return false;
    }
}
function $13d4bf1a3668e58f$var$supportsHistory() {
    return "history" in $13d4bf1a3668e58f$var$WINDOW && !!$13d4bf1a3668e58f$var$WINDOW.history;
}
const $13d4bf1a3668e58f$var$supportsFetch = $13d4bf1a3668e58f$var$_isFetchSupported;
function $13d4bf1a3668e58f$var$_isFetchSupported() {
    if (!("fetch" in $13d4bf1a3668e58f$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("data:,");
        new Response();
        return true;
    } catch  {
        return false;
    }
}
function $13d4bf1a3668e58f$var$isNativeFunction(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $13d4bf1a3668e58f$var$supportsNativeFetch() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$13d4bf1a3668e58f$var$_isFetchSupported()) return false;
    if ($13d4bf1a3668e58f$var$isNativeFunction($13d4bf1a3668e58f$var$WINDOW.fetch)) return true;
    let result = false;
    const doc = $13d4bf1a3668e58f$var$WINDOW.document;
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) result = $13d4bf1a3668e58f$var$isNativeFunction(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        $9Yejo.DEBUG_BUILD && $1UPRv.debug.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function $13d4bf1a3668e58f$var$supportsReportingObserver() {
    return "ReportingObserver" in $13d4bf1a3668e58f$var$WINDOW;
}
function $13d4bf1a3668e58f$var$supportsReferrerPolicy() {
    if (!$13d4bf1a3668e58f$var$_isFetchSupported()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch  {
        return false;
    }
}
module.exports.isNativeFunction = $13d4bf1a3668e58f$var$isNativeFunction;
module.exports.supportsDOMError = $13d4bf1a3668e58f$var$supportsDOMError;
module.exports.supportsDOMException = $13d4bf1a3668e58f$var$supportsDOMException;
module.exports.supportsErrorEvent = $13d4bf1a3668e58f$var$supportsErrorEvent;
module.exports.supportsFetch = $13d4bf1a3668e58f$var$supportsFetch;
module.exports.supportsHistory = $13d4bf1a3668e58f$var$supportsHistory;
module.exports.supportsNativeFetch = $13d4bf1a3668e58f$var$supportsNativeFetch;
module.exports.supportsReferrerPolicy = $13d4bf1a3668e58f$var$supportsReferrerPolicy;
module.exports.supportsReportingObserver = $13d4bf1a3668e58f$var$supportsReportingObserver;

});


parcelRegister("9leca", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $6cd1161f34405109$var$replaceExports(exports1, exportName, wrappedConstructor) {
    const original = exports1[exportName];
    if (typeof original !== "function") return;
    try {
        exports1[exportName] = wrappedConstructor;
    } catch  {
        Object.defineProperty(exports1, exportName, {
            value: wrappedConstructor,
            writable: true,
            configurable: true,
            enumerable: true
        });
    }
    if (exports1.default === original) try {
        exports1.default = wrappedConstructor;
    } catch  {
        Object.defineProperty(exports1, "default", {
            value: wrappedConstructor,
            writable: true,
            configurable: true,
            enumerable: true
        });
    }
}
module.exports.replaceExports = $6cd1161f34405109$var$replaceExports;

});

parcelRegister("gqrdu", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
class $bf542fb6a0ea33c2$var$LRUMap {
    constructor(_maxSize){
        this._maxSize = _maxSize;
        this._cache = /* @__PURE__ */ new Map();
    }
    /** Get the current size of the cache */ get size() {
        return this._cache.size;
    }
    /** Get an entry or undefined if it was not in the cache. Re-inserts to update the recently used order */ get(key) {
        const value = this._cache.get(key);
        if (value === void 0) return void 0;
        this._cache.delete(key);
        this._cache.set(key, value);
        return value;
    }
    /** Insert an entry and evict an older entry if we've reached maxSize */ set(key, value) {
        if (this._cache.size >= this._maxSize) {
            const nextKey = this._cache.keys().next().value;
            this._cache.delete(nextKey);
        }
        this._cache.set(key, value);
    }
    /** Remove an entry and return the entry if it was in the cache */ remove(key) {
        const value = this._cache.get(key);
        if (value) this._cache.delete(key);
        return value;
    }
    /** Clear all entries */ clear() {
        this._cache.clear();
    }
    /** Get all the keys */ keys() {
        return Array.from(this._cache.keys());
    }
    /** Get all the values */ values() {
        const values = [];
        this._cache.forEach((value)=>values.push(value));
        return values;
    }
}
module.exports.LRUMap = $bf542fb6a0ea33c2$var$LRUMap;

});

parcelRegister("jONpA", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $e6d903f84684d2d3$var$escapeStringForRegex(regexString) {
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
module.exports.escapeStringForRegex = $e6d903f84684d2d3$var$escapeStringForRegex;

});

parcelRegister("6J2LB", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eMfEg = parcelRequire("eMfEg");

var $YfOkS = parcelRequire("YfOkS");
const $4e59177db455f165$var$WINDOW = $YfOkS.GLOBAL_OBJ;
const $4e59177db455f165$var$DEFAULT_MAX_STRING_LENGTH = 80;
function $4e59177db455f165$var$htmlTreeAsString(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $4e59177db455f165$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $4e59177db455f165$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
function $4e59177db455f165$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return "";
    if ($4e59177db455f165$var$WINDOW.HTMLElement) {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && $eMfEg.isString(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
function $4e59177db455f165$var$getLocationHref() {
    try {
        return $4e59177db455f165$var$WINDOW.document.location.href;
    } catch  {
        return "";
    }
}
function $4e59177db455f165$var$getComponentName(elem, maxTraverseHeight = 5) {
    if (!$4e59177db455f165$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    for(let i = 0; i < maxTraverseHeight; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}
module.exports.getComponentName = $4e59177db455f165$var$getComponentName;
module.exports.getLocationHref = $4e59177db455f165$var$getLocationHref;
module.exports.htmlTreeAsString = $4e59177db455f165$var$htmlTreeAsString;

});



/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ /*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 'use strict';
let $584b81f9a9b8bf97$var$logDisabled_ = true;
let $584b81f9a9b8bf97$var$deprecationWarnings_ = true;
function $584b81f9a9b8bf97$export$e3c02be309be1f23(uastring, expr, pos) {
    const match = uastring.match(expr);
    return match && match.length >= pos && parseFloat(match[pos], 10);
}
function $584b81f9a9b8bf97$export$1f48841962b828b1(window1, eventNameToWrap, wrapper) {
    if (!window1.RTCPeerConnection) return;
    const proto = window1.RTCPeerConnection.prototype;
    const nativeAddEventListener = proto.addEventListener;
    proto.addEventListener = function(nativeEventName, cb) {
        if (nativeEventName !== eventNameToWrap) return nativeAddEventListener.apply(this, arguments);
        const wrappedCallback = (e)=>{
            const modifiedEvent = wrapper(e);
            if (modifiedEvent) {
                if (cb.handleEvent) cb.handleEvent(modifiedEvent);
                else cb(modifiedEvent);
            }
        };
        this._eventMap = this._eventMap || {};
        if (!this._eventMap[eventNameToWrap]) this._eventMap[eventNameToWrap] = new Map();
        this._eventMap[eventNameToWrap].set(cb, wrappedCallback);
        return nativeAddEventListener.apply(this, [
            nativeEventName,
            wrappedCallback
        ]);
    };
    const nativeRemoveEventListener = proto.removeEventListener;
    proto.removeEventListener = function(nativeEventName, cb) {
        if (nativeEventName !== eventNameToWrap || !this._eventMap || !this._eventMap[eventNameToWrap]) return nativeRemoveEventListener.apply(this, arguments);
        if (!this._eventMap[eventNameToWrap].has(cb)) return nativeRemoveEventListener.apply(this, arguments);
        const unwrappedCb = this._eventMap[eventNameToWrap].get(cb);
        this._eventMap[eventNameToWrap].delete(cb);
        if (this._eventMap[eventNameToWrap].size === 0) delete this._eventMap[eventNameToWrap];
        if (Object.keys(this._eventMap).length === 0) delete this._eventMap;
        return nativeRemoveEventListener.apply(this, [
            nativeEventName,
            unwrappedCb
        ]);
    };
    Object.defineProperty(proto, 'on' + eventNameToWrap, {
        get () {
            return this['_on' + eventNameToWrap];
        },
        set (cb) {
            if (this['_on' + eventNameToWrap]) {
                this.removeEventListener(eventNameToWrap, this['_on' + eventNameToWrap]);
                delete this['_on' + eventNameToWrap];
            }
            if (cb) this.addEventListener(eventNameToWrap, this['_on' + eventNameToWrap] = cb);
        },
        enumerable: true,
        configurable: true
    });
}
function $584b81f9a9b8bf97$export$afbfee8cc06fd3e4(bool) {
    if (typeof bool !== 'boolean') return new Error('Argument type: ' + typeof bool + '. Please use a boolean.');
    $584b81f9a9b8bf97$var$logDisabled_ = bool;
    return bool ? 'adapter.js logging disabled' : 'adapter.js logging enabled';
}
function $584b81f9a9b8bf97$export$51516be4b019e41e(bool) {
    if (typeof bool !== 'boolean') return new Error('Argument type: ' + typeof bool + '. Please use a boolean.');
    $584b81f9a9b8bf97$var$deprecationWarnings_ = !bool;
    return 'adapter.js deprecation warnings ' + (bool ? 'disabled' : 'enabled');
}
function $584b81f9a9b8bf97$export$bef1f36f5486a6a3() {
    if (typeof window === 'object') {
        if ($584b81f9a9b8bf97$var$logDisabled_) return;
        if (typeof console !== 'undefined' && typeof console.log === 'function') console.log.apply(console, arguments);
    }
}
function $584b81f9a9b8bf97$export$cdd73fc4100a6ef4(oldMethod, newMethod) {
    if (!$584b81f9a9b8bf97$var$deprecationWarnings_) return;
    console.warn(oldMethod + ' is deprecated, please use ' + newMethod + ' instead.');
}
function $584b81f9a9b8bf97$export$2d31490a0c05f094(window1) {
    // Returned result object.
    const result = {
        browser: null,
        version: null
    };
    // Fail early if it's not a browser
    if (typeof window1 === 'undefined' || !window1.navigator || !window1.navigator.userAgent) {
        result.browser = 'Not a browser.';
        return result;
    }
    const { navigator: navigator } = window1;
    if (navigator.mozGetUserMedia) {
        result.browser = 'firefox';
        result.version = parseInt($584b81f9a9b8bf97$export$e3c02be309be1f23(navigator.userAgent, /Firefox\/(\d+)\./, 1));
    } else if (navigator.webkitGetUserMedia || window1.isSecureContext === false && window1.webkitRTCPeerConnection) {
        // Chrome, Chromium, Webview, Opera.
        // Version matches Chrome/WebRTC version.
        // Chrome 74 removed webkitGetUserMedia on http as well so we need the
        // more complicated fallback to webkitRTCPeerConnection.
        result.browser = 'chrome';
        result.version = parseInt($584b81f9a9b8bf97$export$e3c02be309be1f23(navigator.userAgent, /Chrom(e|ium)\/(\d+)\./, 2));
    } else if (window1.RTCPeerConnection && navigator.userAgent.match(/AppleWebKit\/(\d+)\./)) {
        result.browser = 'safari';
        result.version = parseInt($584b81f9a9b8bf97$export$e3c02be309be1f23(navigator.userAgent, /AppleWebKit\/(\d+)\./, 1));
        result.supportsUnifiedPlan = window1.RTCRtpTransceiver && 'currentDirection' in window1.RTCRtpTransceiver.prototype;
        // Only for internal usage.
        result._safariVersion = $584b81f9a9b8bf97$export$e3c02be309be1f23(navigator.userAgent, /Version\/(\d+(\.?\d+))/, 1);
    } else {
        result.browser = 'Not a supported browser.';
        return result;
    }
    return result;
}
/**
 * Checks if something is an object.
 *
 * @param {*} val The something you want to check.
 * @return true if val is an object, false otherwise.
 */ function $584b81f9a9b8bf97$var$isObject(val) {
    return Object.prototype.toString.call(val) === '[object Object]';
}
function $584b81f9a9b8bf97$export$15384eac40dc88c8(data) {
    if (!$584b81f9a9b8bf97$var$isObject(data)) return data;
    return Object.keys(data).reduce(function(accumulator, key) {
        const isObj = $584b81f9a9b8bf97$var$isObject(data[key]);
        const value = isObj ? $584b81f9a9b8bf97$export$15384eac40dc88c8(data[key]) : data[key];
        const isEmptyObject = isObj && !Object.keys(value).length;
        if (value === undefined || isEmptyObject) return accumulator;
        return Object.assign(accumulator, {
            [key]: value
        });
    }, {});
}
function $584b81f9a9b8bf97$export$571b373e75babb58(stats, base, resultSet) {
    if (!base || resultSet.has(base.id)) return;
    resultSet.set(base.id, base);
    Object.keys(base).forEach((name)=>{
        if (name.endsWith('Id')) $584b81f9a9b8bf97$export$571b373e75babb58(stats, stats.get(base[name]), resultSet);
        else if (name.endsWith('Ids')) base[name].forEach((id)=>{
            $584b81f9a9b8bf97$export$571b373e75babb58(stats, stats.get(id), resultSet);
        });
    });
}
function $584b81f9a9b8bf97$export$93439ffc3f787d51(result, track, outbound) {
    const streamStatsType = outbound ? 'outbound-rtp' : 'inbound-rtp';
    const filteredResult = new Map();
    if (track === null) return filteredResult;
    const trackStats = [];
    result.forEach((value)=>{
        if (value.type === 'track' && value.trackIdentifier === track.id) trackStats.push(value);
    });
    trackStats.forEach((trackStat)=>{
        result.forEach((stats)=>{
            if (stats.type === streamStatsType && stats.trackId === trackStat.id) $584b81f9a9b8bf97$export$571b373e75babb58(result, stats, filteredResult);
        });
    });
    return filteredResult;
}


var $558eb894511c4db3$exports = {};

$parcel$export($558eb894511c4db3$exports, "shimMediaStream", () => $558eb894511c4db3$export$33ee24e7a300bcd1);
$parcel$export($558eb894511c4db3$exports, "shimOnTrack", () => $558eb894511c4db3$export$f358708f68ab068);
$parcel$export($558eb894511c4db3$exports, "shimGetSendersWithDtmf", () => $558eb894511c4db3$export$a41a030a2842f5d6);
$parcel$export($558eb894511c4db3$exports, "shimGetStats", () => $558eb894511c4db3$export$90608323826f0b17);
$parcel$export($558eb894511c4db3$exports, "shimSenderReceiverGetStats", () => $558eb894511c4db3$export$f2f0f2338114eb4b);
$parcel$export($558eb894511c4db3$exports, "shimAddTrackRemoveTrackWithNative", () => $558eb894511c4db3$export$30e3cdd46f8d5100);
$parcel$export($558eb894511c4db3$exports, "shimAddTrackRemoveTrack", () => $558eb894511c4db3$export$9588259fcf4ebc91);
$parcel$export($558eb894511c4db3$exports, "shimPeerConnection", () => $558eb894511c4db3$export$852a08dda9a55ea7);
$parcel$export($558eb894511c4db3$exports, "fixNegotiationNeeded", () => $558eb894511c4db3$export$341293bbeaae37cb);
$parcel$export($558eb894511c4db3$exports, "shimGetUserMedia", () => $bbd222a30988f5e1$export$1ed4910f4d37dc5e);
$parcel$export($558eb894511c4db3$exports, "shimGetDisplayMedia", () => $37b941bc77cf20ee$export$97270b87351d9c04);
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
'use strict';
const $bbd222a30988f5e1$var$logging = $584b81f9a9b8bf97$export$bef1f36f5486a6a3;
function $bbd222a30988f5e1$export$1ed4910f4d37dc5e(window, browserDetails) {
    const navigator = window && window.navigator;
    if (!navigator.mediaDevices) return;
    const constraintsToChrome_ = function(c) {
        if (typeof c !== 'object' || c.mandatory || c.optional) return c;
        const cc = {};
        Object.keys(c).forEach((key)=>{
            if (key === 'require' || key === 'advanced' || key === 'mediaSource') return;
            const r = typeof c[key] === 'object' ? c[key] : {
                ideal: c[key]
            };
            if (r.exact !== undefined && typeof r.exact === 'number') r.min = r.max = r.exact;
            const oldname_ = function(prefix, name) {
                if (prefix) return prefix + name.charAt(0).toUpperCase() + name.slice(1);
                return name === 'deviceId' ? 'sourceId' : name;
            };
            if (r.ideal !== undefined) {
                cc.optional = cc.optional || [];
                let oc = {};
                if (typeof r.ideal === 'number') {
                    oc[oldname_('min', key)] = r.ideal;
                    cc.optional.push(oc);
                    oc = {};
                    oc[oldname_('max', key)] = r.ideal;
                    cc.optional.push(oc);
                } else {
                    oc[oldname_('', key)] = r.ideal;
                    cc.optional.push(oc);
                }
            }
            if (r.exact !== undefined && typeof r.exact !== 'number') {
                cc.mandatory = cc.mandatory || {};
                cc.mandatory[oldname_('', key)] = r.exact;
            } else [
                'min',
                'max'
            ].forEach((mix)=>{
                if (r[mix] !== undefined) {
                    cc.mandatory = cc.mandatory || {};
                    cc.mandatory[oldname_(mix, key)] = r[mix];
                }
            });
        });
        if (c.advanced) cc.optional = (cc.optional || []).concat(c.advanced);
        return cc;
    };
    const shimConstraints_ = function(constraints, func) {
        if (browserDetails.version >= 61) return func(constraints);
        constraints = JSON.parse(JSON.stringify(constraints));
        if (constraints && typeof constraints.audio === 'object') {
            const remap = function(obj, a, b) {
                if (a in obj && !(b in obj)) {
                    obj[b] = obj[a];
                    delete obj[a];
                }
            };
            constraints = JSON.parse(JSON.stringify(constraints));
            remap(constraints.audio, 'autoGainControl', 'googAutoGainControl');
            remap(constraints.audio, 'noiseSuppression', 'googNoiseSuppression');
            constraints.audio = constraintsToChrome_(constraints.audio);
        }
        if (constraints && typeof constraints.video === 'object') {
            // Shim facingMode for mobile & surface pro.
            let face = constraints.video.facingMode;
            face = face && (typeof face === 'object' ? face : {
                ideal: face
            });
            const getSupportedFacingModeLies = browserDetails.version < 66;
            if (face && (face.exact === 'user' || face.exact === 'environment' || face.ideal === 'user' || face.ideal === 'environment') && !(navigator.mediaDevices.getSupportedConstraints && navigator.mediaDevices.getSupportedConstraints().facingMode && !getSupportedFacingModeLies)) {
                delete constraints.video.facingMode;
                let matches;
                if (face.exact === 'environment' || face.ideal === 'environment') matches = [
                    'back',
                    'rear'
                ];
                else if (face.exact === 'user' || face.ideal === 'user') matches = [
                    'front'
                ];
                if (matches) // Look for matches in label, or use last cam for back (typical).
                return navigator.mediaDevices.enumerateDevices().then((devices)=>{
                    devices = devices.filter((d)=>d.kind === 'videoinput');
                    let dev = devices.find((d)=>matches.some((match)=>d.label.toLowerCase().includes(match)));
                    if (!dev && devices.length && matches.includes('back')) dev = devices[devices.length - 1]; // more likely the back cam
                    if (dev) constraints.video.deviceId = face.exact ? {
                        exact: dev.deviceId
                    } : {
                        ideal: dev.deviceId
                    };
                    constraints.video = constraintsToChrome_(constraints.video);
                    $bbd222a30988f5e1$var$logging('chrome: ' + JSON.stringify(constraints));
                    return func(constraints);
                });
            }
            constraints.video = constraintsToChrome_(constraints.video);
        }
        $bbd222a30988f5e1$var$logging('chrome: ' + JSON.stringify(constraints));
        return func(constraints);
    };
    const shimError_ = function(e) {
        if (browserDetails.version >= 64) return e;
        return {
            name: ({
                PermissionDeniedError: 'NotAllowedError',
                PermissionDismissedError: 'NotAllowedError',
                InvalidStateError: 'NotAllowedError',
                DevicesNotFoundError: 'NotFoundError',
                ConstraintNotSatisfiedError: 'OverconstrainedError',
                TrackStartError: 'NotReadableError',
                MediaDeviceFailedDueToShutdown: 'NotAllowedError',
                MediaDeviceKillSwitchOn: 'NotAllowedError',
                TabCaptureError: 'AbortError',
                ScreenCaptureError: 'AbortError',
                DeviceCaptureError: 'AbortError'
            })[e.name] || e.name,
            message: e.message,
            constraint: e.constraint || e.constraintName,
            toString () {
                return this.name + (this.message && ': ') + this.message;
            }
        };
    };
    const getUserMedia_ = function(constraints, onSuccess, onError) {
        shimConstraints_(constraints, (c)=>{
            navigator.webkitGetUserMedia(c, onSuccess, (e)=>{
                if (onError) onError(shimError_(e));
            });
        });
    };
    navigator.getUserMedia = getUserMedia_.bind(navigator);
    // Even though Chrome 45 has navigator.mediaDevices and a getUserMedia
    // function which returns a Promise, it does not accept spec-style
    // constraints.
    if (navigator.mediaDevices.getUserMedia) {
        const origGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
        navigator.mediaDevices.getUserMedia = function(cs) {
            return shimConstraints_(cs, (c)=>origGetUserMedia(c).then((stream)=>{
                    if (c.audio && !stream.getAudioTracks().length || c.video && !stream.getVideoTracks().length) {
                        stream.getTracks().forEach((track)=>{
                            track.stop();
                        });
                        throw new DOMException('', 'NotFoundError');
                    }
                    return stream;
                }, (e)=>Promise.reject(shimError_(e))));
        };
    }
}


/*
 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 'use strict';
function $37b941bc77cf20ee$export$97270b87351d9c04(window, getSourceId) {
    if (window.navigator.mediaDevices && 'getDisplayMedia' in window.navigator.mediaDevices) return;
    if (!window.navigator.mediaDevices) return;
    // getSourceId is a function that returns a promise resolving with
    // the sourceId of the screen/window/tab to be shared.
    if (typeof getSourceId !== 'function') {
        console.error("shimGetDisplayMedia: getSourceId argument is not a function");
        return;
    }
    window.navigator.mediaDevices.getDisplayMedia = function getDisplayMedia(constraints) {
        return getSourceId(constraints).then((sourceId)=>{
            const widthSpecified = constraints.video && constraints.video.width;
            const heightSpecified = constraints.video && constraints.video.height;
            const frameRateSpecified = constraints.video && constraints.video.frameRate;
            constraints.video = {
                mandatory: {
                    chromeMediaSource: 'desktop',
                    chromeMediaSourceId: sourceId,
                    maxFrameRate: frameRateSpecified || 3
                }
            };
            if (widthSpecified) constraints.video.mandatory.maxWidth = widthSpecified;
            if (heightSpecified) constraints.video.mandatory.maxHeight = heightSpecified;
            return window.navigator.mediaDevices.getUserMedia(constraints);
        });
    };
}


'use strict';
function $558eb894511c4db3$export$33ee24e7a300bcd1(window) {
    window.MediaStream = window.MediaStream || window.webkitMediaStream;
}
function $558eb894511c4db3$export$f358708f68ab068(window) {
    if (typeof window === 'object' && window.RTCPeerConnection && !('ontrack' in window.RTCPeerConnection.prototype)) {
        Object.defineProperty(window.RTCPeerConnection.prototype, 'ontrack', {
            get () {
                return this._ontrack;
            },
            set (f) {
                if (this._ontrack) this.removeEventListener('track', this._ontrack);
                this.addEventListener('track', this._ontrack = f);
            },
            enumerable: true,
            configurable: true
        });
        const origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
        window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
            if (!this._ontrackpoly) {
                this._ontrackpoly = (e)=>{
                    // onaddstream does not fire when a track is added to an existing
                    // stream. But stream.onaddtrack is implemented so we use that.
                    e.stream.addEventListener('addtrack', (te)=>{
                        let receiver;
                        if (window.RTCPeerConnection.prototype.getReceivers) receiver = this.getReceivers().find((r)=>r.track && r.track.id === te.track.id);
                        else receiver = {
                            track: te.track
                        };
                        const event = new Event('track');
                        event.track = te.track;
                        event.receiver = receiver;
                        event.transceiver = {
                            receiver: receiver
                        };
                        event.streams = [
                            e.stream
                        ];
                        this.dispatchEvent(event);
                    });
                    e.stream.getTracks().forEach((track)=>{
                        let receiver;
                        if (window.RTCPeerConnection.prototype.getReceivers) receiver = this.getReceivers().find((r)=>r.track && r.track.id === track.id);
                        else receiver = {
                            track: track
                        };
                        const event = new Event('track');
                        event.track = track;
                        event.receiver = receiver;
                        event.transceiver = {
                            receiver: receiver
                        };
                        event.streams = [
                            e.stream
                        ];
                        this.dispatchEvent(event);
                    });
                };
                this.addEventListener('addstream', this._ontrackpoly);
            }
            return origSetRemoteDescription.apply(this, arguments);
        };
    } else // even if RTCRtpTransceiver is in window, it is only used and
    // emitted in unified-plan. Unfortunately this means we need
    // to unconditionally wrap the event.
    $584b81f9a9b8bf97$export$1f48841962b828b1(window, 'track', (e)=>{
        if (!e.transceiver) Object.defineProperty(e, 'transceiver', {
            value: {
                receiver: e.receiver
            }
        });
        return e;
    });
}
function $558eb894511c4db3$export$a41a030a2842f5d6(window) {
    // Overrides addTrack/removeTrack, depends on shimAddTrackRemoveTrack.
    if (typeof window === 'object' && window.RTCPeerConnection && !('getSenders' in window.RTCPeerConnection.prototype) && 'createDTMFSender' in window.RTCPeerConnection.prototype) {
        const shimSenderWithDtmf = function(pc, track) {
            return {
                track: track,
                get dtmf () {
                    if (this._dtmf === undefined) {
                        if (track.kind === 'audio') this._dtmf = pc.createDTMFSender(track);
                        else this._dtmf = null;
                    }
                    return this._dtmf;
                },
                _pc: pc
            };
        };
        // augment addTrack when getSenders is not available.
        if (!window.RTCPeerConnection.prototype.getSenders) {
            window.RTCPeerConnection.prototype.getSenders = function getSenders() {
                this._senders = this._senders || [];
                return this._senders.slice(); // return a copy of the internal state.
            };
            const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
            window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
                let sender = origAddTrack.apply(this, arguments);
                if (!sender) {
                    sender = shimSenderWithDtmf(this, track);
                    this._senders.push(sender);
                }
                return sender;
            };
            const origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
            window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
                origRemoveTrack.apply(this, arguments);
                const idx = this._senders.indexOf(sender);
                if (idx !== -1) this._senders.splice(idx, 1);
            };
        }
        const origAddStream = window.RTCPeerConnection.prototype.addStream;
        window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
            this._senders = this._senders || [];
            origAddStream.apply(this, [
                stream
            ]);
            stream.getTracks().forEach((track)=>{
                this._senders.push(shimSenderWithDtmf(this, track));
            });
        };
        const origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
        window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
            this._senders = this._senders || [];
            origRemoveStream.apply(this, [
                stream
            ]);
            stream.getTracks().forEach((track)=>{
                const sender = this._senders.find((s)=>s.track === track);
                if (sender) this._senders.splice(this._senders.indexOf(sender), 1);
            });
        };
    } else if (typeof window === 'object' && window.RTCPeerConnection && 'getSenders' in window.RTCPeerConnection.prototype && 'createDTMFSender' in window.RTCPeerConnection.prototype && window.RTCRtpSender && !('dtmf' in window.RTCRtpSender.prototype)) {
        const origGetSenders = window.RTCPeerConnection.prototype.getSenders;
        window.RTCPeerConnection.prototype.getSenders = function getSenders() {
            const senders = origGetSenders.apply(this, []);
            senders.forEach((sender)=>sender._pc = this);
            return senders;
        };
        Object.defineProperty(window.RTCRtpSender.prototype, 'dtmf', {
            get () {
                if (this._dtmf === undefined) {
                    if (this.track.kind === 'audio') this._dtmf = this._pc.createDTMFSender(this.track);
                    else this._dtmf = null;
                }
                return this._dtmf;
            }
        });
    }
}
function $558eb894511c4db3$export$90608323826f0b17(window) {
    if (!window.RTCPeerConnection) return;
    const origGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function getStats() {
        const [selector, onSucc, onErr] = arguments;
        // If selector is a function then we are in the old style stats so just
        // pass back the original getStats format to avoid breaking old users.
        if (arguments.length > 0 && typeof selector === 'function') return origGetStats.apply(this, arguments);
        // When spec-style getStats is supported, return those when called with
        // either no arguments or the selector argument is null.
        if (origGetStats.length === 0 && (arguments.length === 0 || typeof selector !== 'function')) return origGetStats.apply(this, []);
        const fixChromeStats_ = function(response) {
            const standardReport = {};
            const reports = response.result();
            reports.forEach((report)=>{
                const standardStats = {
                    id: report.id,
                    timestamp: report.timestamp,
                    type: {
                        localcandidate: 'local-candidate',
                        remotecandidate: 'remote-candidate'
                    }[report.type] || report.type
                };
                report.names().forEach((name)=>{
                    standardStats[name] = report.stat(name);
                });
                standardReport[standardStats.id] = standardStats;
            });
            return standardReport;
        };
        // shim getStats with maplike support
        const makeMapStats = function(stats) {
            return new Map(Object.keys(stats).map((key)=>[
                    key,
                    stats[key]
                ]));
        };
        if (arguments.length >= 2) {
            const successCallbackWrapper_ = function(response) {
                onSucc(makeMapStats(fixChromeStats_(response)));
            };
            return origGetStats.apply(this, [
                successCallbackWrapper_,
                selector
            ]);
        }
        // promise-support
        return new Promise((resolve, reject)=>{
            origGetStats.apply(this, [
                function(response) {
                    resolve(makeMapStats(fixChromeStats_(response)));
                },
                reject
            ]);
        }).then(onSucc, onErr);
    };
}
function $558eb894511c4db3$export$f2f0f2338114eb4b(window) {
    if (!(typeof window === 'object' && window.RTCPeerConnection && window.RTCRtpSender && window.RTCRtpReceiver)) return;
    // shim sender stats.
    if (!('getStats' in window.RTCRtpSender.prototype)) {
        const origGetSenders = window.RTCPeerConnection.prototype.getSenders;
        if (origGetSenders) window.RTCPeerConnection.prototype.getSenders = function getSenders() {
            const senders = origGetSenders.apply(this, []);
            senders.forEach((sender)=>sender._pc = this);
            return senders;
        };
        const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
        if (origAddTrack) window.RTCPeerConnection.prototype.addTrack = function addTrack() {
            const sender = origAddTrack.apply(this, arguments);
            sender._pc = this;
            return sender;
        };
        window.RTCRtpSender.prototype.getStats = function getStats() {
            const sender = this;
            return this._pc.getStats().then((result)=>/* Note: this will include stats of all senders that
         *   send a track with the same id as sender.track as
         *   it is not possible to identify the RTCRtpSender.
         */ $584b81f9a9b8bf97$export$93439ffc3f787d51(result, sender.track, true));
        };
    }
    // shim receiver stats.
    if (!('getStats' in window.RTCRtpReceiver.prototype)) {
        const origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;
        if (origGetReceivers) window.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
            const receivers = origGetReceivers.apply(this, []);
            receivers.forEach((receiver)=>receiver._pc = this);
            return receivers;
        };
        $584b81f9a9b8bf97$export$1f48841962b828b1(window, 'track', (e)=>{
            e.receiver._pc = e.srcElement;
            return e;
        });
        window.RTCRtpReceiver.prototype.getStats = function getStats() {
            const receiver = this;
            return this._pc.getStats().then((result)=>$584b81f9a9b8bf97$export$93439ffc3f787d51(result, receiver.track, false));
        };
    }
    if (!('getStats' in window.RTCRtpSender.prototype && 'getStats' in window.RTCRtpReceiver.prototype)) return;
    // shim RTCPeerConnection.getStats(track).
    const origGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function getStats() {
        if (arguments.length > 0 && arguments[0] instanceof window.MediaStreamTrack) {
            const track = arguments[0];
            let sender;
            let receiver;
            let err;
            this.getSenders().forEach((s)=>{
                if (s.track === track) {
                    if (sender) err = true;
                    else sender = s;
                }
            });
            this.getReceivers().forEach((r)=>{
                if (r.track === track) {
                    if (receiver) err = true;
                    else receiver = r;
                }
                return r.track === track;
            });
            if (err || sender && receiver) return Promise.reject(new DOMException('There are more than one sender or receiver for the track.', 'InvalidAccessError'));
            else if (sender) return sender.getStats();
            else if (receiver) return receiver.getStats();
            return Promise.reject(new DOMException('There is no sender or receiver for the track.', 'InvalidAccessError'));
        }
        return origGetStats.apply(this, arguments);
    };
}
function $558eb894511c4db3$export$30e3cdd46f8d5100(window) {
    // shim addTrack/removeTrack with native variants in order to make
    // the interactions with legacy getLocalStreams behave as in other browsers.
    // Keeps a mapping stream.id => [stream, rtpsenders...]
    window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        return Object.keys(this._shimmedLocalStreams).map((streamId)=>this._shimmedLocalStreams[streamId][0]);
    };
    const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
    window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
        if (!stream) return origAddTrack.apply(this, arguments);
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        const sender = origAddTrack.apply(this, arguments);
        if (!this._shimmedLocalStreams[stream.id]) this._shimmedLocalStreams[stream.id] = [
            stream,
            sender
        ];
        else if (this._shimmedLocalStreams[stream.id].indexOf(sender) === -1) this._shimmedLocalStreams[stream.id].push(sender);
        return sender;
    };
    const origAddStream = window.RTCPeerConnection.prototype.addStream;
    window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        stream.getTracks().forEach((track)=>{
            const alreadyExists = this.getSenders().find((s)=>s.track === track);
            if (alreadyExists) throw new DOMException('Track already exists.', 'InvalidAccessError');
        });
        const existingSenders = this.getSenders();
        origAddStream.apply(this, arguments);
        const newSenders = this.getSenders().filter((newSender)=>existingSenders.indexOf(newSender) === -1);
        this._shimmedLocalStreams[stream.id] = [
            stream
        ].concat(newSenders);
    };
    const origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
    window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        delete this._shimmedLocalStreams[stream.id];
        return origRemoveStream.apply(this, arguments);
    };
    const origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
    window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        if (sender) Object.keys(this._shimmedLocalStreams).forEach((streamId)=>{
            const idx = this._shimmedLocalStreams[streamId].indexOf(sender);
            if (idx !== -1) this._shimmedLocalStreams[streamId].splice(idx, 1);
            if (this._shimmedLocalStreams[streamId].length === 1) delete this._shimmedLocalStreams[streamId];
        });
        return origRemoveTrack.apply(this, arguments);
    };
}
function $558eb894511c4db3$export$9588259fcf4ebc91(window, browserDetails) {
    if (!window.RTCPeerConnection) return;
    // shim addTrack and removeTrack.
    if (window.RTCPeerConnection.prototype.addTrack && browserDetails.version >= 65) return $558eb894511c4db3$export$30e3cdd46f8d5100(window);
    // also shim pc.getLocalStreams when addTrack is shimmed
    // to return the original streams.
    const origGetLocalStreams = window.RTCPeerConnection.prototype.getLocalStreams;
    window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        const nativeStreams = origGetLocalStreams.apply(this);
        this._reverseStreams = this._reverseStreams || {};
        return nativeStreams.map((stream)=>this._reverseStreams[stream.id]);
    };
    const origAddStream = window.RTCPeerConnection.prototype.addStream;
    window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        stream.getTracks().forEach((track)=>{
            const alreadyExists = this.getSenders().find((s)=>s.track === track);
            if (alreadyExists) throw new DOMException('Track already exists.', 'InvalidAccessError');
        });
        // Add identity mapping for consistency with addTrack.
        // Unless this is being used with a stream from addTrack.
        if (!this._reverseStreams[stream.id]) {
            const newStream = new window.MediaStream(stream.getTracks());
            this._streams[stream.id] = newStream;
            this._reverseStreams[newStream.id] = stream;
            stream = newStream;
        }
        origAddStream.apply(this, [
            stream
        ]);
    };
    const origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
    window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        origRemoveStream.apply(this, [
            this._streams[stream.id] || stream
        ]);
        delete this._reverseStreams[this._streams[stream.id] ? this._streams[stream.id].id : stream.id];
        delete this._streams[stream.id];
    };
    window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
        if (this.signalingState === 'closed') throw new DOMException('The RTCPeerConnection\'s signalingState is \'closed\'.', 'InvalidStateError');
        const streams = [].slice.call(arguments, 1);
        if (streams.length !== 1 || !streams[0].getTracks().find((t)=>t === track)) // this is not fully correct but all we can manage without
        // [[associated MediaStreams]] internal slot.
        throw new DOMException("The adapter.js addTrack polyfill only supports a single  stream which is associated with the specified track.", 'NotSupportedError');
        const alreadyExists = this.getSenders().find((s)=>s.track === track);
        if (alreadyExists) throw new DOMException('Track already exists.', 'InvalidAccessError');
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        const oldStream = this._streams[stream.id];
        if (oldStream) {
            // this is using odd Chrome behaviour, use with caution:
            // https://bugs.chromium.org/p/webrtc/issues/detail?id=7815
            // Note: we rely on the high-level addTrack/dtmf shim to
            // create the sender with a dtmf sender.
            oldStream.addTrack(track);
            // Trigger ONN async.
            Promise.resolve().then(()=>{
                this.dispatchEvent(new Event('negotiationneeded'));
            });
        } else {
            const newStream = new window.MediaStream([
                track
            ]);
            this._streams[stream.id] = newStream;
            this._reverseStreams[newStream.id] = stream;
            this.addStream(newStream);
        }
        return this.getSenders().find((s)=>s.track === track);
    };
    // replace the internal stream id with the external one and
    // vice versa.
    function replaceInternalStreamId(pc, description) {
        let sdp = description.sdp;
        Object.keys(pc._reverseStreams || []).forEach((internalId)=>{
            const externalStream = pc._reverseStreams[internalId];
            const internalStream = pc._streams[externalStream.id];
            sdp = sdp.replace(new RegExp(internalStream.id, 'g'), externalStream.id);
        });
        return new RTCSessionDescription({
            type: description.type,
            sdp: sdp
        });
    }
    function replaceExternalStreamId(pc, description) {
        let sdp = description.sdp;
        Object.keys(pc._reverseStreams || []).forEach((internalId)=>{
            const externalStream = pc._reverseStreams[internalId];
            const internalStream = pc._streams[externalStream.id];
            sdp = sdp.replace(new RegExp(externalStream.id, 'g'), internalStream.id);
        });
        return new RTCSessionDescription({
            type: description.type,
            sdp: sdp
        });
    }
    [
        'createOffer',
        'createAnswer'
    ].forEach(function(method) {
        const nativeMethod = window.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                const args = arguments;
                const isLegacyCall = arguments.length && typeof arguments[0] === 'function';
                if (isLegacyCall) return nativeMethod.apply(this, [
                    (description)=>{
                        const desc = replaceInternalStreamId(this, description);
                        args[0].apply(null, [
                            desc
                        ]);
                    },
                    (err)=>{
                        if (args[1]) args[1].apply(null, err);
                    },
                    arguments[2]
                ]);
                return nativeMethod.apply(this, arguments).then((description)=>replaceInternalStreamId(this, description));
            }
        };
        window.RTCPeerConnection.prototype[method] = methodObj[method];
    });
    const origSetLocalDescription = window.RTCPeerConnection.prototype.setLocalDescription;
    window.RTCPeerConnection.prototype.setLocalDescription = function setLocalDescription() {
        if (!arguments.length || !arguments[0].type) return origSetLocalDescription.apply(this, arguments);
        arguments[0] = replaceExternalStreamId(this, arguments[0]);
        return origSetLocalDescription.apply(this, arguments);
    };
    // TODO: mangle getStats: https://w3c.github.io/webrtc-stats/#dom-rtcmediastreamstats-streamidentifier
    const origLocalDescription = Object.getOwnPropertyDescriptor(window.RTCPeerConnection.prototype, 'localDescription');
    Object.defineProperty(window.RTCPeerConnection.prototype, 'localDescription', {
        get () {
            const description = origLocalDescription.get.apply(this);
            if (description.type === '') return description;
            return replaceInternalStreamId(this, description);
        }
    });
    window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
        if (this.signalingState === 'closed') throw new DOMException('The RTCPeerConnection\'s signalingState is \'closed\'.', 'InvalidStateError');
        // We can not yet check for sender instanceof RTCRtpSender
        // since we shim RTPSender. So we check if sender._pc is set.
        if (!sender._pc) throw new DOMException("Argument 1 of RTCPeerConnection.removeTrack does not implement interface RTCRtpSender.", 'TypeError');
        const isLocal = sender._pc === this;
        if (!isLocal) throw new DOMException('Sender was not created by this connection.', 'InvalidAccessError');
        // Search for the native stream the senders track belongs to.
        this._streams = this._streams || {};
        let stream;
        Object.keys(this._streams).forEach((streamid)=>{
            const hasTrack = this._streams[streamid].getTracks().find((track)=>sender.track === track);
            if (hasTrack) stream = this._streams[streamid];
        });
        if (stream) {
            if (stream.getTracks().length === 1) // if this is the last track of the stream, remove the stream. This
            // takes care of any shimmed _senders.
            this.removeStream(this._reverseStreams[stream.id]);
            else // relying on the same odd chrome behaviour as above.
            stream.removeTrack(sender.track);
            this.dispatchEvent(new Event('negotiationneeded'));
        }
    };
}
function $558eb894511c4db3$export$852a08dda9a55ea7(window, browserDetails) {
    if (!window.RTCPeerConnection && window.webkitRTCPeerConnection) // very basic support for old versions.
    window.RTCPeerConnection = window.webkitRTCPeerConnection;
    if (!window.RTCPeerConnection) return;
    // shim implicit creation of RTCSessionDescription/RTCIceCandidate
    if (browserDetails.version < 53) [
        'setLocalDescription',
        'setRemoteDescription',
        'addIceCandidate'
    ].forEach(function(method) {
        const nativeMethod = window.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                arguments[0] = new (method === 'addIceCandidate' ? window.RTCIceCandidate : window.RTCSessionDescription)(arguments[0]);
                return nativeMethod.apply(this, arguments);
            }
        };
        window.RTCPeerConnection.prototype[method] = methodObj[method];
    });
}
function $558eb894511c4db3$export$341293bbeaae37cb(window, browserDetails) {
    $584b81f9a9b8bf97$export$1f48841962b828b1(window, 'negotiationneeded', (e)=>{
        const pc = e.target;
        if (browserDetails.version < 72 || pc.getConfiguration && pc.getConfiguration().sdpSemantics === 'plan-b') {
            if (pc.signalingState !== 'stable') return;
        }
        return e;
    });
}


var $c518d147eb169a8d$exports = {};

$parcel$export($c518d147eb169a8d$exports, "shimOnTrack", () => $c518d147eb169a8d$export$f358708f68ab068);
$parcel$export($c518d147eb169a8d$exports, "shimPeerConnection", () => $c518d147eb169a8d$export$852a08dda9a55ea7);
$parcel$export($c518d147eb169a8d$exports, "shimSenderGetStats", () => $c518d147eb169a8d$export$f0525502095c04ef);
$parcel$export($c518d147eb169a8d$exports, "shimReceiverGetStats", () => $c518d147eb169a8d$export$83d69126527b1171);
$parcel$export($c518d147eb169a8d$exports, "shimRemoveStream", () => $c518d147eb169a8d$export$825e523ef749bd8c);
$parcel$export($c518d147eb169a8d$exports, "shimRTCDataChannel", () => $c518d147eb169a8d$export$ff9cb3bc8990e8f7);
$parcel$export($c518d147eb169a8d$exports, "shimAddTransceiver", () => $c518d147eb169a8d$export$70c77533b6e9908d);
$parcel$export($c518d147eb169a8d$exports, "shimGetParameters", () => $c518d147eb169a8d$export$66238223c298fbaa);
$parcel$export($c518d147eb169a8d$exports, "shimCreateOffer", () => $c518d147eb169a8d$export$51beccf0e777b843);
$parcel$export($c518d147eb169a8d$exports, "shimCreateAnswer", () => $c518d147eb169a8d$export$df0b46e7cef08150);
$parcel$export($c518d147eb169a8d$exports, "shimGetUserMedia", () => $365b77720cb4f52a$export$1ed4910f4d37dc5e);
$parcel$export($c518d147eb169a8d$exports, "shimGetDisplayMedia", () => $cd853a759273f164$export$97270b87351d9c04);
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
'use strict';
function $365b77720cb4f52a$export$1ed4910f4d37dc5e(window, browserDetails) {
    const navigator = window && window.navigator;
    const MediaStreamTrack = window && window.MediaStreamTrack;
    navigator.getUserMedia = function(constraints, onSuccess, onError) {
        // Replace Firefox 44+'s deprecation warning with unprefixed version.
        $584b81f9a9b8bf97$export$cdd73fc4100a6ef4('navigator.getUserMedia', 'navigator.mediaDevices.getUserMedia');
        navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
    };
    if (!(browserDetails.version > 55 && 'autoGainControl' in navigator.mediaDevices.getSupportedConstraints())) {
        const remap = function(obj, a, b) {
            if (a in obj && !(b in obj)) {
                obj[b] = obj[a];
                delete obj[a];
            }
        };
        const nativeGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
        navigator.mediaDevices.getUserMedia = function(c) {
            if (typeof c === 'object' && typeof c.audio === 'object') {
                c = JSON.parse(JSON.stringify(c));
                remap(c.audio, 'autoGainControl', 'mozAutoGainControl');
                remap(c.audio, 'noiseSuppression', 'mozNoiseSuppression');
            }
            return nativeGetUserMedia(c);
        };
        if (MediaStreamTrack && MediaStreamTrack.prototype.getSettings) {
            const nativeGetSettings = MediaStreamTrack.prototype.getSettings;
            MediaStreamTrack.prototype.getSettings = function() {
                const obj = nativeGetSettings.apply(this, arguments);
                remap(obj, 'mozAutoGainControl', 'autoGainControl');
                remap(obj, 'mozNoiseSuppression', 'noiseSuppression');
                return obj;
            };
        }
        if (MediaStreamTrack && MediaStreamTrack.prototype.applyConstraints) {
            const nativeApplyConstraints = MediaStreamTrack.prototype.applyConstraints;
            MediaStreamTrack.prototype.applyConstraints = function(c) {
                if (this.kind === 'audio' && typeof c === 'object') {
                    c = JSON.parse(JSON.stringify(c));
                    remap(c, 'autoGainControl', 'mozAutoGainControl');
                    remap(c, 'noiseSuppression', 'mozNoiseSuppression');
                }
                return nativeApplyConstraints.apply(this, [
                    c
                ]);
            };
        }
    }
}


/*
 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 'use strict';
function $cd853a759273f164$export$97270b87351d9c04(window, preferredMediaSource) {
    if (window.navigator.mediaDevices && 'getDisplayMedia' in window.navigator.mediaDevices) return;
    if (!window.navigator.mediaDevices) return;
    window.navigator.mediaDevices.getDisplayMedia = function getDisplayMedia(constraints) {
        if (!(constraints && constraints.video)) {
            const err = new DOMException("getDisplayMedia without video constraints is undefined");
            err.name = 'NotFoundError';
            // from https://heycam.github.io/webidl/#idl-DOMException-error-names
            err.code = 8;
            return Promise.reject(err);
        }
        if (constraints.video === true) constraints.video = {
            mediaSource: preferredMediaSource
        };
        else constraints.video.mediaSource = preferredMediaSource;
        return window.navigator.mediaDevices.getUserMedia(constraints);
    };
}


'use strict';
function $c518d147eb169a8d$export$f358708f68ab068(window) {
    if (typeof window === 'object' && window.RTCTrackEvent && 'receiver' in window.RTCTrackEvent.prototype && !('transceiver' in window.RTCTrackEvent.prototype)) Object.defineProperty(window.RTCTrackEvent.prototype, 'transceiver', {
        get () {
            return {
                receiver: this.receiver
            };
        }
    });
}
function $c518d147eb169a8d$export$852a08dda9a55ea7(window, browserDetails) {
    if (typeof window !== 'object' || !(window.RTCPeerConnection || window.mozRTCPeerConnection)) return; // probably media.peerconnection.enabled=false in about:config
    if (!window.RTCPeerConnection && window.mozRTCPeerConnection) // very basic support for old versions.
    window.RTCPeerConnection = window.mozRTCPeerConnection;
    if (browserDetails.version < 53) // shim away need for obsolete RTCIceCandidate/RTCSessionDescription.
    [
        'setLocalDescription',
        'setRemoteDescription',
        'addIceCandidate'
    ].forEach(function(method) {
        const nativeMethod = window.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                arguments[0] = new (method === 'addIceCandidate' ? window.RTCIceCandidate : window.RTCSessionDescription)(arguments[0]);
                return nativeMethod.apply(this, arguments);
            }
        };
        window.RTCPeerConnection.prototype[method] = methodObj[method];
    });
    const modernStatsTypes = {
        inboundrtp: 'inbound-rtp',
        outboundrtp: 'outbound-rtp',
        candidatepair: 'candidate-pair',
        localcandidate: 'local-candidate',
        remotecandidate: 'remote-candidate'
    };
    const nativeGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function getStats() {
        const [selector, onSucc, onErr] = arguments;
        return nativeGetStats.apply(this, [
            selector || null
        ]).then((stats)=>{
            if (browserDetails.version < 53 && !onSucc) // Shim only promise getStats with spec-hyphens in type names
            // Leave callback version alone; misc old uses of forEach before Map
            try {
                stats.forEach((stat)=>{
                    stat.type = modernStatsTypes[stat.type] || stat.type;
                });
            } catch (e) {
                if (e.name !== 'TypeError') throw e;
                // Avoid TypeError: "type" is read-only, in old versions. 34-43ish
                stats.forEach((stat, i)=>{
                    stats.set(i, Object.assign({}, stat, {
                        type: modernStatsTypes[stat.type] || stat.type
                    }));
                });
            }
            return stats;
        }).then(onSucc, onErr);
    };
}
function $c518d147eb169a8d$export$f0525502095c04ef(window) {
    if (!(typeof window === 'object' && window.RTCPeerConnection && window.RTCRtpSender)) return;
    if (window.RTCRtpSender && 'getStats' in window.RTCRtpSender.prototype) return;
    const origGetSenders = window.RTCPeerConnection.prototype.getSenders;
    if (origGetSenders) window.RTCPeerConnection.prototype.getSenders = function getSenders() {
        const senders = origGetSenders.apply(this, []);
        senders.forEach((sender)=>sender._pc = this);
        return senders;
    };
    const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
    if (origAddTrack) window.RTCPeerConnection.prototype.addTrack = function addTrack() {
        const sender = origAddTrack.apply(this, arguments);
        sender._pc = this;
        return sender;
    };
    window.RTCRtpSender.prototype.getStats = function getStats() {
        return this.track ? this._pc.getStats(this.track) : Promise.resolve(new Map());
    };
}
function $c518d147eb169a8d$export$83d69126527b1171(window) {
    if (!(typeof window === 'object' && window.RTCPeerConnection && window.RTCRtpSender)) return;
    if (window.RTCRtpSender && 'getStats' in window.RTCRtpReceiver.prototype) return;
    const origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;
    if (origGetReceivers) window.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
        const receivers = origGetReceivers.apply(this, []);
        receivers.forEach((receiver)=>receiver._pc = this);
        return receivers;
    };
    $584b81f9a9b8bf97$export$1f48841962b828b1(window, 'track', (e)=>{
        e.receiver._pc = e.srcElement;
        return e;
    });
    window.RTCRtpReceiver.prototype.getStats = function getStats() {
        return this._pc.getStats(this.track);
    };
}
function $c518d147eb169a8d$export$825e523ef749bd8c(window) {
    if (!window.RTCPeerConnection || 'removeStream' in window.RTCPeerConnection.prototype) return;
    window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        $584b81f9a9b8bf97$export$cdd73fc4100a6ef4('removeStream', 'removeTrack');
        this.getSenders().forEach((sender)=>{
            if (sender.track && stream.getTracks().includes(sender.track)) this.removeTrack(sender);
        });
    };
}
function $c518d147eb169a8d$export$ff9cb3bc8990e8f7(window) {
    // rename DataChannel to RTCDataChannel (native fix in FF60):
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1173851
    if (window.DataChannel && !window.RTCDataChannel) window.RTCDataChannel = window.DataChannel;
}
function $c518d147eb169a8d$export$70c77533b6e9908d(window) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window === 'object' && window.RTCPeerConnection)) return;
    const origAddTransceiver = window.RTCPeerConnection.prototype.addTransceiver;
    if (origAddTransceiver) window.RTCPeerConnection.prototype.addTransceiver = function addTransceiver() {
        this.setParametersPromises = [];
        // WebIDL input coercion and validation
        let sendEncodings = arguments[1] && arguments[1].sendEncodings;
        if (sendEncodings === undefined) sendEncodings = [];
        sendEncodings = [
            ...sendEncodings
        ];
        const shouldPerformCheck = sendEncodings.length > 0;
        if (shouldPerformCheck) // If sendEncodings params are provided, validate grammar
        sendEncodings.forEach((encodingParam)=>{
            if ('rid' in encodingParam) {
                const ridRegex = /^[a-z0-9]{0,16}$/i;
                if (!ridRegex.test(encodingParam.rid)) throw new TypeError('Invalid RID value provided.');
            }
            if ('scaleResolutionDownBy' in encodingParam) {
                if (!(parseFloat(encodingParam.scaleResolutionDownBy) >= 1.0)) throw new RangeError('scale_resolution_down_by must be >= 1.0');
            }
            if ('maxFramerate' in encodingParam) {
                if (!(parseFloat(encodingParam.maxFramerate) >= 0)) throw new RangeError('max_framerate must be >= 0.0');
            }
        });
        const transceiver = origAddTransceiver.apply(this, arguments);
        if (shouldPerformCheck) {
            // Check if the init options were applied. If not we do this in an
            // asynchronous way and save the promise reference in a global object.
            // This is an ugly hack, but at the same time is way more robust than
            // checking the sender parameters before and after the createOffer
            // Also note that after the createoffer we are not 100% sure that
            // the params were asynchronously applied so we might miss the
            // opportunity to recreate offer.
            const { sender: sender } = transceiver;
            const params = sender.getParameters();
            if (!('encodings' in params) || // Avoid being fooled by patched getParameters() below.
            params.encodings.length === 1 && Object.keys(params.encodings[0]).length === 0) {
                params.encodings = sendEncodings;
                sender.sendEncodings = sendEncodings;
                this.setParametersPromises.push(sender.setParameters(params).then(()=>{
                    delete sender.sendEncodings;
                }).catch(()=>{
                    delete sender.sendEncodings;
                }));
            }
        }
        return transceiver;
    };
}
function $c518d147eb169a8d$export$66238223c298fbaa(window) {
    if (!(typeof window === 'object' && window.RTCRtpSender)) return;
    const origGetParameters = window.RTCRtpSender.prototype.getParameters;
    if (origGetParameters) window.RTCRtpSender.prototype.getParameters = function getParameters() {
        const params = origGetParameters.apply(this, arguments);
        if (!('encodings' in params)) params.encodings = [].concat(this.sendEncodings || [
            {}
        ]);
        return params;
    };
}
function $c518d147eb169a8d$export$51beccf0e777b843(window) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window === 'object' && window.RTCPeerConnection)) return;
    const origCreateOffer = window.RTCPeerConnection.prototype.createOffer;
    window.RTCPeerConnection.prototype.createOffer = function createOffer() {
        if (this.setParametersPromises && this.setParametersPromises.length) return Promise.all(this.setParametersPromises).then(()=>{
            return origCreateOffer.apply(this, arguments);
        }).finally(()=>{
            this.setParametersPromises = [];
        });
        return origCreateOffer.apply(this, arguments);
    };
}
function $c518d147eb169a8d$export$df0b46e7cef08150(window) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window === 'object' && window.RTCPeerConnection)) return;
    const origCreateAnswer = window.RTCPeerConnection.prototype.createAnswer;
    window.RTCPeerConnection.prototype.createAnswer = function createAnswer() {
        if (this.setParametersPromises && this.setParametersPromises.length) return Promise.all(this.setParametersPromises).then(()=>{
            return origCreateAnswer.apply(this, arguments);
        }).finally(()=>{
            this.setParametersPromises = [];
        });
        return origCreateAnswer.apply(this, arguments);
    };
}


var $9a20cef3f9b7f4b6$exports = {};

$parcel$export($9a20cef3f9b7f4b6$exports, "shimLocalStreamsAPI", () => $9a20cef3f9b7f4b6$export$8df41282f4fdcea2);
$parcel$export($9a20cef3f9b7f4b6$exports, "shimRemoteStreamsAPI", () => $9a20cef3f9b7f4b6$export$762aa4cbb4f2f857);
$parcel$export($9a20cef3f9b7f4b6$exports, "shimCallbacksAPI", () => $9a20cef3f9b7f4b6$export$da31df245debdd3);
$parcel$export($9a20cef3f9b7f4b6$exports, "shimGetUserMedia", () => $9a20cef3f9b7f4b6$export$1ed4910f4d37dc5e);
$parcel$export($9a20cef3f9b7f4b6$exports, "shimConstraints", () => $9a20cef3f9b7f4b6$export$494a01ac68ba81ac);
$parcel$export($9a20cef3f9b7f4b6$exports, "shimRTCIceServerUrls", () => $9a20cef3f9b7f4b6$export$671a8b47b41b6f41);
$parcel$export($9a20cef3f9b7f4b6$exports, "shimTrackEventTransceiver", () => $9a20cef3f9b7f4b6$export$85d53da088cb1b14);
$parcel$export($9a20cef3f9b7f4b6$exports, "shimCreateOfferLegacy", () => $9a20cef3f9b7f4b6$export$d444266503fdd2d4);
$parcel$export($9a20cef3f9b7f4b6$exports, "shimAudioContext", () => $9a20cef3f9b7f4b6$export$857cd739a7b795d2);
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ 
'use strict';
function $9a20cef3f9b7f4b6$export$8df41282f4fdcea2(window) {
    if (typeof window !== 'object' || !window.RTCPeerConnection) return;
    if (!('getLocalStreams' in window.RTCPeerConnection.prototype)) window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        if (!this._localStreams) this._localStreams = [];
        return this._localStreams;
    };
    if (!('addStream' in window.RTCPeerConnection.prototype)) {
        const _addTrack = window.RTCPeerConnection.prototype.addTrack;
        window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
            if (!this._localStreams) this._localStreams = [];
            if (!this._localStreams.includes(stream)) this._localStreams.push(stream);
            // Try to emulate Chrome's behaviour of adding in audio-video order.
            // Safari orders by track id.
            stream.getAudioTracks().forEach((track)=>_addTrack.call(this, track, stream));
            stream.getVideoTracks().forEach((track)=>_addTrack.call(this, track, stream));
        };
        window.RTCPeerConnection.prototype.addTrack = function addTrack(track, ...streams) {
            if (streams) streams.forEach((stream)=>{
                if (!this._localStreams) this._localStreams = [
                    stream
                ];
                else if (!this._localStreams.includes(stream)) this._localStreams.push(stream);
            });
            return _addTrack.apply(this, arguments);
        };
    }
    if (!('removeStream' in window.RTCPeerConnection.prototype)) window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        if (!this._localStreams) this._localStreams = [];
        const index = this._localStreams.indexOf(stream);
        if (index === -1) return;
        this._localStreams.splice(index, 1);
        const tracks = stream.getTracks();
        this.getSenders().forEach((sender)=>{
            if (tracks.includes(sender.track)) this.removeTrack(sender);
        });
    };
}
function $9a20cef3f9b7f4b6$export$762aa4cbb4f2f857(window) {
    if (typeof window !== 'object' || !window.RTCPeerConnection) return;
    if (!('getRemoteStreams' in window.RTCPeerConnection.prototype)) window.RTCPeerConnection.prototype.getRemoteStreams = function getRemoteStreams() {
        return this._remoteStreams ? this._remoteStreams : [];
    };
    if (!('onaddstream' in window.RTCPeerConnection.prototype)) {
        Object.defineProperty(window.RTCPeerConnection.prototype, 'onaddstream', {
            get () {
                return this._onaddstream;
            },
            set (f) {
                if (this._onaddstream) {
                    this.removeEventListener('addstream', this._onaddstream);
                    this.removeEventListener('track', this._onaddstreampoly);
                }
                this.addEventListener('addstream', this._onaddstream = f);
                this.addEventListener('track', this._onaddstreampoly = (e)=>{
                    e.streams.forEach((stream)=>{
                        if (!this._remoteStreams) this._remoteStreams = [];
                        if (this._remoteStreams.includes(stream)) return;
                        this._remoteStreams.push(stream);
                        const event = new Event('addstream');
                        event.stream = stream;
                        this.dispatchEvent(event);
                    });
                });
            }
        });
        const origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
        window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
            const pc = this;
            if (!this._onaddstreampoly) this.addEventListener('track', this._onaddstreampoly = function(e) {
                e.streams.forEach((stream)=>{
                    if (!pc._remoteStreams) pc._remoteStreams = [];
                    if (pc._remoteStreams.indexOf(stream) >= 0) return;
                    pc._remoteStreams.push(stream);
                    const event = new Event('addstream');
                    event.stream = stream;
                    pc.dispatchEvent(event);
                });
            });
            return origSetRemoteDescription.apply(pc, arguments);
        };
    }
}
function $9a20cef3f9b7f4b6$export$da31df245debdd3(window) {
    if (typeof window !== 'object' || !window.RTCPeerConnection) return;
    const prototype = window.RTCPeerConnection.prototype;
    const origCreateOffer = prototype.createOffer;
    const origCreateAnswer = prototype.createAnswer;
    const setLocalDescription = prototype.setLocalDescription;
    const setRemoteDescription = prototype.setRemoteDescription;
    const addIceCandidate = prototype.addIceCandidate;
    prototype.createOffer = function createOffer(successCallback, failureCallback) {
        const options = arguments.length >= 2 ? arguments[2] : arguments[0];
        const promise = origCreateOffer.apply(this, [
            options
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.createAnswer = function createAnswer(successCallback, failureCallback) {
        const options = arguments.length >= 2 ? arguments[2] : arguments[0];
        const promise = origCreateAnswer.apply(this, [
            options
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    let withCallback = function(description, successCallback, failureCallback) {
        const promise = setLocalDescription.apply(this, [
            description
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.setLocalDescription = withCallback;
    withCallback = function(description, successCallback, failureCallback) {
        const promise = setRemoteDescription.apply(this, [
            description
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.setRemoteDescription = withCallback;
    withCallback = function(candidate, successCallback, failureCallback) {
        const promise = addIceCandidate.apply(this, [
            candidate
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.addIceCandidate = withCallback;
}
function $9a20cef3f9b7f4b6$export$1ed4910f4d37dc5e(window) {
    const navigator = window && window.navigator;
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        // shim not needed in Safari 12.1
        const mediaDevices = navigator.mediaDevices;
        const _getUserMedia = mediaDevices.getUserMedia.bind(mediaDevices);
        navigator.mediaDevices.getUserMedia = (constraints)=>{
            return _getUserMedia($9a20cef3f9b7f4b6$export$494a01ac68ba81ac(constraints));
        };
    }
    if (!navigator.getUserMedia && navigator.mediaDevices && navigator.mediaDevices.getUserMedia) navigator.getUserMedia = (function getUserMedia(constraints, cb, errcb) {
        navigator.mediaDevices.getUserMedia(constraints).then(cb, errcb);
    }).bind(navigator);
}
function $9a20cef3f9b7f4b6$export$494a01ac68ba81ac(constraints) {
    if (constraints && constraints.video !== undefined) return Object.assign({}, constraints, {
        video: $584b81f9a9b8bf97$export$15384eac40dc88c8(constraints.video)
    });
    return constraints;
}
function $9a20cef3f9b7f4b6$export$671a8b47b41b6f41(window) {
    if (!window.RTCPeerConnection) return;
    // migrate from non-spec RTCIceServer.url to RTCIceServer.urls
    const OrigPeerConnection = window.RTCPeerConnection;
    window.RTCPeerConnection = function RTCPeerConnection(pcConfig, pcConstraints) {
        if (pcConfig && pcConfig.iceServers) {
            const newIceServers = [];
            for(let i = 0; i < pcConfig.iceServers.length; i++){
                let server = pcConfig.iceServers[i];
                if (server.urls === undefined && server.url) {
                    $584b81f9a9b8bf97$export$cdd73fc4100a6ef4('RTCIceServer.url', 'RTCIceServer.urls');
                    server = JSON.parse(JSON.stringify(server));
                    server.urls = server.url;
                    delete server.url;
                    newIceServers.push(server);
                } else newIceServers.push(pcConfig.iceServers[i]);
            }
            pcConfig.iceServers = newIceServers;
        }
        return new OrigPeerConnection(pcConfig, pcConstraints);
    };
    window.RTCPeerConnection.prototype = OrigPeerConnection.prototype;
    // wrap static methods. Currently just generateCertificate.
    if ('generateCertificate' in OrigPeerConnection) Object.defineProperty(window.RTCPeerConnection, 'generateCertificate', {
        get () {
            return OrigPeerConnection.generateCertificate;
        }
    });
}
function $9a20cef3f9b7f4b6$export$85d53da088cb1b14(window) {
    // Add event.transceiver member over deprecated event.receiver
    if (typeof window === 'object' && window.RTCTrackEvent && 'receiver' in window.RTCTrackEvent.prototype && !('transceiver' in window.RTCTrackEvent.prototype)) Object.defineProperty(window.RTCTrackEvent.prototype, 'transceiver', {
        get () {
            return {
                receiver: this.receiver
            };
        }
    });
}
function $9a20cef3f9b7f4b6$export$d444266503fdd2d4(window) {
    const origCreateOffer = window.RTCPeerConnection.prototype.createOffer;
    window.RTCPeerConnection.prototype.createOffer = function createOffer(offerOptions) {
        if (offerOptions) {
            if (typeof offerOptions.offerToReceiveAudio !== 'undefined') // support bit values
            offerOptions.offerToReceiveAudio = !!offerOptions.offerToReceiveAudio;
            const audioTransceiver = this.getTransceivers().find((transceiver)=>transceiver.receiver.track.kind === 'audio');
            if (offerOptions.offerToReceiveAudio === false && audioTransceiver) {
                if (audioTransceiver.direction === 'sendrecv') {
                    if (audioTransceiver.setDirection) audioTransceiver.setDirection('sendonly');
                    else audioTransceiver.direction = 'sendonly';
                } else if (audioTransceiver.direction === 'recvonly') {
                    if (audioTransceiver.setDirection) audioTransceiver.setDirection('inactive');
                    else audioTransceiver.direction = 'inactive';
                }
            } else if (offerOptions.offerToReceiveAudio === true && !audioTransceiver) this.addTransceiver('audio', {
                direction: 'recvonly'
            });
            if (typeof offerOptions.offerToReceiveVideo !== 'undefined') // support bit values
            offerOptions.offerToReceiveVideo = !!offerOptions.offerToReceiveVideo;
            const videoTransceiver = this.getTransceivers().find((transceiver)=>transceiver.receiver.track.kind === 'video');
            if (offerOptions.offerToReceiveVideo === false && videoTransceiver) {
                if (videoTransceiver.direction === 'sendrecv') {
                    if (videoTransceiver.setDirection) videoTransceiver.setDirection('sendonly');
                    else videoTransceiver.direction = 'sendonly';
                } else if (videoTransceiver.direction === 'recvonly') {
                    if (videoTransceiver.setDirection) videoTransceiver.setDirection('inactive');
                    else videoTransceiver.direction = 'inactive';
                }
            } else if (offerOptions.offerToReceiveVideo === true && !videoTransceiver) this.addTransceiver('video', {
                direction: 'recvonly'
            });
        }
        return origCreateOffer.apply(this, arguments);
    };
}
function $9a20cef3f9b7f4b6$export$857cd739a7b795d2(window) {
    if (typeof window !== 'object' || window.AudioContext) return;
    window.AudioContext = window.webkitAudioContext;
}


var $599d92f2f0dc2dee$exports = {};

$parcel$export($599d92f2f0dc2dee$exports, "shimRTCIceCandidate", () => $599d92f2f0dc2dee$export$cf133661e444ccfe);
$parcel$export($599d92f2f0dc2dee$exports, "shimRTCIceCandidateRelayProtocol", () => $599d92f2f0dc2dee$export$fdafb8d8280e29b5);
$parcel$export($599d92f2f0dc2dee$exports, "shimMaxMessageSize", () => $599d92f2f0dc2dee$export$a99147c78a56edc4);
$parcel$export($599d92f2f0dc2dee$exports, "shimSendThrowTypeError", () => $599d92f2f0dc2dee$export$d461c8d5c5db5da7);
$parcel$export($599d92f2f0dc2dee$exports, "shimConnectionState", () => $599d92f2f0dc2dee$export$63bb816cc75460);
$parcel$export($599d92f2f0dc2dee$exports, "removeExtmapAllowMixed", () => $599d92f2f0dc2dee$export$a57d114344295149);
$parcel$export($599d92f2f0dc2dee$exports, "shimAddIceCandidateNullOrEmpty", () => $599d92f2f0dc2dee$export$51d5e40b48c771c7);
$parcel$export($599d92f2f0dc2dee$exports, "shimParameterlessSetLocalDescription", () => $599d92f2f0dc2dee$export$7170d04e59f9d553);
/*
 *  Copyright (c) 2017 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ var $7522343ecaeeccb8$exports = {};
/* eslint-env node */ 'use strict';
// SDP helpers.
const $7522343ecaeeccb8$var$SDPUtils = {};
// Generate an alphanumeric identifier for cname or mids.
// TODO: use UUIDs instead? https://gist.github.com/jed/982883
$7522343ecaeeccb8$var$SDPUtils.generateIdentifier = function() {
    return Math.random().toString(36).substring(2, 12);
};
// The RTCP CNAME used by all peerconnections from the same JS.
$7522343ecaeeccb8$var$SDPUtils.localCName = $7522343ecaeeccb8$var$SDPUtils.generateIdentifier();
// Splits SDP into lines, dealing with both CRLF and LF.
$7522343ecaeeccb8$var$SDPUtils.splitLines = function(blob) {
    return blob.trim().split('\n').map((line)=>line.trim());
};
// Splits SDP into sessionpart and mediasections. Ensures CRLF.
$7522343ecaeeccb8$var$SDPUtils.splitSections = function(blob) {
    const parts = blob.split('\nm=');
    return parts.map((part, index)=>(index > 0 ? 'm=' + part : part).trim() + '\r\n');
};
// Returns the session description.
$7522343ecaeeccb8$var$SDPUtils.getDescription = function(blob) {
    const sections = $7522343ecaeeccb8$var$SDPUtils.splitSections(blob);
    return sections && sections[0];
};
// Returns the individual media sections.
$7522343ecaeeccb8$var$SDPUtils.getMediaSections = function(blob) {
    const sections = $7522343ecaeeccb8$var$SDPUtils.splitSections(blob);
    sections.shift();
    return sections;
};
// Returns lines that start with a certain prefix.
$7522343ecaeeccb8$var$SDPUtils.matchPrefix = function(blob, prefix) {
    return $7522343ecaeeccb8$var$SDPUtils.splitLines(blob).filter((line)=>line.indexOf(prefix) === 0);
};
// Parses an ICE candidate line. Sample input:
// candidate:702786350 2 udp 41819902 8.8.8.8 60769 typ relay raddr 8.8.8.8
// rport 55996"
// Input can be prefixed with a=.
$7522343ecaeeccb8$var$SDPUtils.parseCandidate = function(line) {
    let parts;
    // Parse both variants.
    if (line.indexOf('a=candidate:') === 0) parts = line.substring(12).split(' ');
    else parts = line.substring(10).split(' ');
    const candidate = {
        foundation: parts[0],
        component: {
            1: 'rtp',
            2: 'rtcp'
        }[parts[1]] || parts[1],
        protocol: parts[2].toLowerCase(),
        priority: parseInt(parts[3], 10),
        ip: parts[4],
        address: parts[4],
        port: parseInt(parts[5], 10),
        // skip parts[6] == 'typ'
        type: parts[7]
    };
    for(let i = 8; i < parts.length; i += 2)switch(parts[i]){
        case 'raddr':
            candidate.relatedAddress = parts[i + 1];
            break;
        case 'rport':
            candidate.relatedPort = parseInt(parts[i + 1], 10);
            break;
        case 'tcptype':
            candidate.tcpType = parts[i + 1];
            break;
        case 'ufrag':
            candidate.ufrag = parts[i + 1]; // for backward compatibility.
            candidate.usernameFragment = parts[i + 1];
            break;
        default:
            if (candidate[parts[i]] === undefined) candidate[parts[i]] = parts[i + 1];
            break;
    }
    return candidate;
};
// Translates a candidate object into SDP candidate attribute.
// This does not include the a= prefix!
$7522343ecaeeccb8$var$SDPUtils.writeCandidate = function(candidate) {
    const sdp = [];
    sdp.push(candidate.foundation);
    const component = candidate.component;
    if (component === 'rtp') sdp.push(1);
    else if (component === 'rtcp') sdp.push(2);
    else sdp.push(component);
    sdp.push(candidate.protocol.toUpperCase());
    sdp.push(candidate.priority);
    sdp.push(candidate.address || candidate.ip);
    sdp.push(candidate.port);
    const type = candidate.type;
    sdp.push('typ');
    sdp.push(type);
    if (type !== 'host' && candidate.relatedAddress && candidate.relatedPort !== undefined) {
        sdp.push('raddr');
        sdp.push(candidate.relatedAddress);
        sdp.push('rport');
        sdp.push(candidate.relatedPort);
    }
    if (candidate.tcpType && candidate.protocol.toLowerCase() === 'tcp') {
        sdp.push('tcptype');
        sdp.push(candidate.tcpType);
    }
    if (candidate.usernameFragment || candidate.ufrag) {
        sdp.push('ufrag');
        sdp.push(candidate.usernameFragment || candidate.ufrag);
    }
    return 'candidate:' + sdp.join(' ');
};
// Parses an ice-options line, returns an array of option tags.
// Sample input:
// a=ice-options:foo bar
$7522343ecaeeccb8$var$SDPUtils.parseIceOptions = function(line) {
    return line.substring(14).split(' ');
};
// Parses a rtpmap line, returns RTCRtpCoddecParameters. Sample input:
// a=rtpmap:111 opus/48000/2
$7522343ecaeeccb8$var$SDPUtils.parseRtpMap = function(line) {
    let parts = line.substring(9).split(' ');
    const parsed = {
        payloadType: parseInt(parts.shift(), 10)
    };
    parts = parts[0].split('/');
    parsed.name = parts[0];
    parsed.clockRate = parseInt(parts[1], 10); // was: clockrate
    parsed.channels = parts.length === 3 ? parseInt(parts[2], 10) : 1;
    // legacy alias, got renamed back to channels in ORTC.
    parsed.numChannels = parsed.channels;
    return parsed;
};
// Generates a rtpmap line from RTCRtpCodecCapability or
// RTCRtpCodecParameters.
$7522343ecaeeccb8$var$SDPUtils.writeRtpMap = function(codec) {
    let pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    const channels = codec.channels || codec.numChannels || 1;
    return 'a=rtpmap:' + pt + ' ' + codec.name + '/' + codec.clockRate + (channels !== 1 ? '/' + channels : '') + '\r\n';
};
// Parses a extmap line (headerextension from RFC 5285). Sample input:
// a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
// a=extmap:2/sendonly urn:ietf:params:rtp-hdrext:toffset
$7522343ecaeeccb8$var$SDPUtils.parseExtmap = function(line) {
    const parts = line.substring(9).split(' ');
    return {
        id: parseInt(parts[0], 10),
        direction: parts[0].indexOf('/') > 0 ? parts[0].split('/')[1] : 'sendrecv',
        uri: parts[1],
        attributes: parts.slice(2).join(' ')
    };
};
// Generates an extmap line from RTCRtpHeaderExtensionParameters or
// RTCRtpHeaderExtension.
$7522343ecaeeccb8$var$SDPUtils.writeExtmap = function(headerExtension) {
    return 'a=extmap:' + (headerExtension.id || headerExtension.preferredId) + (headerExtension.direction && headerExtension.direction !== 'sendrecv' ? '/' + headerExtension.direction : '') + ' ' + headerExtension.uri + (headerExtension.attributes ? ' ' + headerExtension.attributes : '') + '\r\n';
};
// Parses a fmtp line, returns dictionary. Sample input:
// a=fmtp:96 vbr=on;cng=on
// Also deals with vbr=on; cng=on
// Non-key-value such as telephone-events `0-15` get parsed as
// {`0-15`:undefined}
$7522343ecaeeccb8$var$SDPUtils.parseFmtp = function(line) {
    const parsed = {};
    let kv;
    const parts = line.substring(line.indexOf(' ') + 1).split(';');
    for(let j = 0; j < parts.length; j++){
        kv = parts[j].trim().split('=');
        parsed[kv[0].trim()] = kv[1];
    }
    return parsed;
};
// Generates a fmtp line from RTCRtpCodecCapability or RTCRtpCodecParameters.
$7522343ecaeeccb8$var$SDPUtils.writeFmtp = function(codec) {
    let line = '';
    let pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    if (codec.parameters && Object.keys(codec.parameters).length) {
        const params = [];
        Object.keys(codec.parameters).forEach((param)=>{
            if (codec.parameters[param] !== undefined) params.push(param + '=' + codec.parameters[param]);
            else params.push(param);
        });
        line += 'a=fmtp:' + pt + ' ' + params.join(';') + '\r\n';
    }
    return line;
};
// Parses a rtcp-fb line, returns RTCPRtcpFeedback object. Sample input:
// a=rtcp-fb:98 nack rpsi
$7522343ecaeeccb8$var$SDPUtils.parseRtcpFb = function(line) {
    const parts = line.substring(line.indexOf(' ') + 1).split(' ');
    return {
        type: parts.shift(),
        parameter: parts.join(' ')
    };
};
// Generate a=rtcp-fb lines from RTCRtpCodecCapability or RTCRtpCodecParameters.
$7522343ecaeeccb8$var$SDPUtils.writeRtcpFb = function(codec) {
    let lines = '';
    let pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    if (codec.rtcpFeedback && codec.rtcpFeedback.length) // FIXME: special handling for trr-int?
    codec.rtcpFeedback.forEach((fb)=>{
        lines += 'a=rtcp-fb:' + pt + ' ' + fb.type + (fb.parameter && fb.parameter.length ? ' ' + fb.parameter : '') + '\r\n';
    });
    return lines;
};
// Parses a RFC 5576 ssrc media attribute. Sample input:
// a=ssrc:3735928559 cname:something
$7522343ecaeeccb8$var$SDPUtils.parseSsrcMedia = function(line) {
    const sp = line.indexOf(' ');
    const parts = {
        ssrc: parseInt(line.substring(7, sp), 10)
    };
    const colon = line.indexOf(':', sp);
    if (colon > -1) {
        parts.attribute = line.substring(sp + 1, colon);
        parts.value = line.substring(colon + 1);
    } else parts.attribute = line.substring(sp + 1);
    return parts;
};
// Parse a ssrc-group line (see RFC 5576). Sample input:
// a=ssrc-group:semantics 12 34
$7522343ecaeeccb8$var$SDPUtils.parseSsrcGroup = function(line) {
    const parts = line.substring(13).split(' ');
    return {
        semantics: parts.shift(),
        ssrcs: parts.map((ssrc)=>parseInt(ssrc, 10))
    };
};
// Extracts the MID (RFC 5888) from a media section.
// Returns the MID or undefined if no mid line was found.
$7522343ecaeeccb8$var$SDPUtils.getMid = function(mediaSection) {
    const mid = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=mid:')[0];
    if (mid) return mid.substring(6);
};
// Parses a fingerprint line for DTLS-SRTP.
$7522343ecaeeccb8$var$SDPUtils.parseFingerprint = function(line) {
    const parts = line.substring(14).split(' ');
    return {
        algorithm: parts[0].toLowerCase(),
        value: parts[1].toUpperCase()
    };
};
// Extracts DTLS parameters from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the fingerprint line as input. See also getIceParameters.
$7522343ecaeeccb8$var$SDPUtils.getDtlsParameters = function(mediaSection, sessionpart) {
    const lines = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=fingerprint:');
    // Note: a=setup line is ignored since we use the 'auto' role in Edge.
    return {
        role: 'auto',
        fingerprints: lines.map($7522343ecaeeccb8$var$SDPUtils.parseFingerprint)
    };
};
// Serializes DTLS parameters to SDP.
$7522343ecaeeccb8$var$SDPUtils.writeDtlsParameters = function(params, setupType) {
    let sdp = 'a=setup:' + setupType + '\r\n';
    params.fingerprints.forEach((fp)=>{
        sdp += 'a=fingerprint:' + fp.algorithm + ' ' + fp.value + '\r\n';
    });
    return sdp;
};
// Parses a=crypto lines into
//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#dictionary-rtcsrtpsdesparameters-members
$7522343ecaeeccb8$var$SDPUtils.parseCryptoLine = function(line) {
    const parts = line.substring(9).split(' ');
    return {
        tag: parseInt(parts[0], 10),
        cryptoSuite: parts[1],
        keyParams: parts[2],
        sessionParams: parts.slice(3)
    };
};
$7522343ecaeeccb8$var$SDPUtils.writeCryptoLine = function(parameters) {
    return 'a=crypto:' + parameters.tag + ' ' + parameters.cryptoSuite + ' ' + (typeof parameters.keyParams === 'object' ? $7522343ecaeeccb8$var$SDPUtils.writeCryptoKeyParams(parameters.keyParams) : parameters.keyParams) + (parameters.sessionParams ? ' ' + parameters.sessionParams.join(' ') : '') + '\r\n';
};
// Parses the crypto key parameters into
//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#rtcsrtpkeyparam*
$7522343ecaeeccb8$var$SDPUtils.parseCryptoKeyParams = function(keyParams) {
    if (keyParams.indexOf('inline:') !== 0) return null;
    const parts = keyParams.substring(7).split('|');
    return {
        keyMethod: 'inline',
        keySalt: parts[0],
        lifeTime: parts[1],
        mkiValue: parts[2] ? parts[2].split(':')[0] : undefined,
        mkiLength: parts[2] ? parts[2].split(':')[1] : undefined
    };
};
$7522343ecaeeccb8$var$SDPUtils.writeCryptoKeyParams = function(keyParams) {
    return keyParams.keyMethod + ':' + keyParams.keySalt + (keyParams.lifeTime ? '|' + keyParams.lifeTime : '') + (keyParams.mkiValue && keyParams.mkiLength ? '|' + keyParams.mkiValue + ':' + keyParams.mkiLength : '');
};
// Extracts all SDES parameters.
$7522343ecaeeccb8$var$SDPUtils.getCryptoParameters = function(mediaSection, sessionpart) {
    const lines = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=crypto:');
    return lines.map($7522343ecaeeccb8$var$SDPUtils.parseCryptoLine);
};
// Parses ICE information from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the ice-ufrag and ice-pwd lines as input.
$7522343ecaeeccb8$var$SDPUtils.getIceParameters = function(mediaSection, sessionpart) {
    const ufrag = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=ice-ufrag:')[0];
    const pwd = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=ice-pwd:')[0];
    if (!(ufrag && pwd)) return null;
    return {
        usernameFragment: ufrag.substring(12),
        password: pwd.substring(10)
    };
};
// Serializes ICE parameters to SDP.
$7522343ecaeeccb8$var$SDPUtils.writeIceParameters = function(params) {
    let sdp = 'a=ice-ufrag:' + params.usernameFragment + '\r\n' + 'a=ice-pwd:' + params.password + '\r\n';
    if (params.iceLite) sdp += 'a=ice-lite\r\n';
    return sdp;
};
// Parses the SDP media section and returns RTCRtpParameters.
$7522343ecaeeccb8$var$SDPUtils.parseRtpParameters = function(mediaSection) {
    const description = {
        codecs: [],
        headerExtensions: [],
        fecMechanisms: [],
        rtcp: []
    };
    const lines = $7522343ecaeeccb8$var$SDPUtils.splitLines(mediaSection);
    const mline = lines[0].split(' ');
    description.profile = mline[2];
    for(let i = 3; i < mline.length; i++){
        const pt = mline[i];
        const rtpmapline = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=rtpmap:' + pt + ' ')[0];
        if (rtpmapline) {
            const codec = $7522343ecaeeccb8$var$SDPUtils.parseRtpMap(rtpmapline);
            const fmtps = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=fmtp:' + pt + ' ');
            // Only the first a=fmtp:<pt> is considered.
            codec.parameters = fmtps.length ? $7522343ecaeeccb8$var$SDPUtils.parseFmtp(fmtps[0]) : {};
            codec.rtcpFeedback = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=rtcp-fb:' + pt + ' ').map($7522343ecaeeccb8$var$SDPUtils.parseRtcpFb);
            description.codecs.push(codec);
            // parse FEC mechanisms from rtpmap lines.
            switch(codec.name.toUpperCase()){
                case 'RED':
                case 'ULPFEC':
                    description.fecMechanisms.push(codec.name.toUpperCase());
                    break;
                default:
                    break;
            }
        }
    }
    $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=extmap:').forEach((line)=>{
        description.headerExtensions.push($7522343ecaeeccb8$var$SDPUtils.parseExtmap(line));
    });
    const wildcardRtcpFb = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=rtcp-fb:* ').map($7522343ecaeeccb8$var$SDPUtils.parseRtcpFb);
    description.codecs.forEach((codec)=>{
        wildcardRtcpFb.forEach((fb)=>{
            const duplicate = codec.rtcpFeedback.find((existingFeedback)=>{
                return existingFeedback.type === fb.type && existingFeedback.parameter === fb.parameter;
            });
            if (!duplicate) codec.rtcpFeedback.push(fb);
        });
    });
    // FIXME: parse rtcp.
    return description;
};
// Generates parts of the SDP media section describing the capabilities /
// parameters.
$7522343ecaeeccb8$var$SDPUtils.writeRtpDescription = function(kind, caps) {
    let sdp = '';
    // Build the mline.
    sdp += 'm=' + kind + ' ';
    sdp += caps.codecs.length > 0 ? '9' : '0'; // reject if no codecs.
    sdp += ' ' + (caps.profile || 'UDP/TLS/RTP/SAVPF') + ' ';
    sdp += caps.codecs.map((codec)=>{
        if (codec.preferredPayloadType !== undefined) return codec.preferredPayloadType;
        return codec.payloadType;
    }).join(' ') + '\r\n';
    sdp += 'c=IN IP4 0.0.0.0\r\n';
    sdp += 'a=rtcp:9 IN IP4 0.0.0.0\r\n';
    // Add a=rtpmap lines for each codec. Also fmtp and rtcp-fb.
    caps.codecs.forEach((codec)=>{
        sdp += $7522343ecaeeccb8$var$SDPUtils.writeRtpMap(codec);
        sdp += $7522343ecaeeccb8$var$SDPUtils.writeFmtp(codec);
        sdp += $7522343ecaeeccb8$var$SDPUtils.writeRtcpFb(codec);
    });
    let maxptime = 0;
    caps.codecs.forEach((codec)=>{
        if (codec.maxptime > maxptime) maxptime = codec.maxptime;
    });
    if (maxptime > 0) sdp += 'a=maxptime:' + maxptime + '\r\n';
    if (caps.headerExtensions) caps.headerExtensions.forEach((extension)=>{
        sdp += $7522343ecaeeccb8$var$SDPUtils.writeExtmap(extension);
    });
    // FIXME: write fecMechanisms.
    return sdp;
};
// Parses the SDP media section and returns an array of
// RTCRtpEncodingParameters.
$7522343ecaeeccb8$var$SDPUtils.parseRtpEncodingParameters = function(mediaSection) {
    const encodingParameters = [];
    const description = $7522343ecaeeccb8$var$SDPUtils.parseRtpParameters(mediaSection);
    const hasRed = description.fecMechanisms.indexOf('RED') !== -1;
    const hasUlpfec = description.fecMechanisms.indexOf('ULPFEC') !== -1;
    // filter a=ssrc:... cname:, ignore PlanB-msid
    const ssrcs = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=ssrc:').map((line)=>$7522343ecaeeccb8$var$SDPUtils.parseSsrcMedia(line)).filter((parts)=>parts.attribute === 'cname');
    const primarySsrc = ssrcs.length > 0 && ssrcs[0].ssrc;
    let secondarySsrc;
    const flows = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=ssrc-group:FID').map((line)=>{
        const parts = line.substring(17).split(' ');
        return parts.map((part)=>parseInt(part, 10));
    });
    if (flows.length > 0 && flows[0].length > 1 && flows[0][0] === primarySsrc) secondarySsrc = flows[0][1];
    description.codecs.forEach((codec)=>{
        if (codec.name.toUpperCase() === 'RTX' && codec.parameters.apt) {
            let encParam = {
                ssrc: primarySsrc,
                codecPayloadType: parseInt(codec.parameters.apt, 10)
            };
            if (primarySsrc && secondarySsrc) encParam.rtx = {
                ssrc: secondarySsrc
            };
            encodingParameters.push(encParam);
            if (hasRed) {
                encParam = JSON.parse(JSON.stringify(encParam));
                encParam.fec = {
                    ssrc: primarySsrc,
                    mechanism: hasUlpfec ? 'red+ulpfec' : 'red'
                };
                encodingParameters.push(encParam);
            }
        }
    });
    if (encodingParameters.length === 0 && primarySsrc) encodingParameters.push({
        ssrc: primarySsrc
    });
    // we support both b=AS and b=TIAS but interpret AS as TIAS.
    let bandwidth = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'b=');
    if (bandwidth.length) {
        if (bandwidth[0].indexOf('b=TIAS:') === 0) bandwidth = parseInt(bandwidth[0].substring(7), 10);
        else if (bandwidth[0].indexOf('b=AS:') === 0) // use formula from JSEP to convert b=AS to TIAS value.
        bandwidth = parseInt(bandwidth[0].substring(5), 10) * 950 - 16000;
        else bandwidth = undefined;
        encodingParameters.forEach((params)=>{
            params.maxBitrate = bandwidth;
        });
    }
    return encodingParameters;
};
// parses http://draft.ortc.org/#rtcrtcpparameters*
$7522343ecaeeccb8$var$SDPUtils.parseRtcpParameters = function(mediaSection) {
    const rtcpParameters = {};
    // Gets the first SSRC. Note that with RTX there might be multiple
    // SSRCs.
    const remoteSsrc = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=ssrc:').map((line)=>$7522343ecaeeccb8$var$SDPUtils.parseSsrcMedia(line)).filter((obj)=>obj.attribute === 'cname')[0];
    if (remoteSsrc) {
        rtcpParameters.cname = remoteSsrc.value;
        rtcpParameters.ssrc = remoteSsrc.ssrc;
    }
    // Edge uses the compound attribute instead of reducedSize
    // compound is !reducedSize
    const rsize = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=rtcp-rsize');
    rtcpParameters.reducedSize = rsize.length > 0;
    rtcpParameters.compound = rsize.length === 0;
    // parses the rtcp-mux attrіbute.
    // Note that Edge does not support unmuxed RTCP.
    const mux = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=rtcp-mux');
    rtcpParameters.mux = mux.length > 0;
    return rtcpParameters;
};
$7522343ecaeeccb8$var$SDPUtils.writeRtcpParameters = function(rtcpParameters) {
    let sdp = '';
    if (rtcpParameters.reducedSize) sdp += 'a=rtcp-rsize\r\n';
    if (rtcpParameters.mux) sdp += 'a=rtcp-mux\r\n';
    if (rtcpParameters.ssrc !== undefined && rtcpParameters.cname) sdp += 'a=ssrc:' + rtcpParameters.ssrc + ' cname:' + rtcpParameters.cname + '\r\n';
    return sdp;
};
// parses either a=msid: or a=ssrc:... msid lines and returns
// the id of the MediaStream and MediaStreamTrack.
$7522343ecaeeccb8$var$SDPUtils.parseMsid = function(mediaSection) {
    let parts;
    const spec = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=msid:');
    if (spec.length === 1) {
        parts = spec[0].substring(7).split(' ');
        return {
            stream: parts[0],
            track: parts[1]
        };
    }
    const planB = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=ssrc:').map((line)=>$7522343ecaeeccb8$var$SDPUtils.parseSsrcMedia(line)).filter((msidParts)=>msidParts.attribute === 'msid');
    if (planB.length > 0) {
        parts = planB[0].value.split(' ');
        return {
            stream: parts[0],
            track: parts[1]
        };
    }
};
// SCTP
// parses draft-ietf-mmusic-sctp-sdp-26 first and falls back
// to draft-ietf-mmusic-sctp-sdp-05
$7522343ecaeeccb8$var$SDPUtils.parseSctpDescription = function(mediaSection) {
    const mline = $7522343ecaeeccb8$var$SDPUtils.parseMLine(mediaSection);
    const maxSizeLine = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=max-message-size:');
    let maxMessageSize;
    if (maxSizeLine.length > 0) maxMessageSize = parseInt(maxSizeLine[0].substring(19), 10);
    if (isNaN(maxMessageSize)) maxMessageSize = 65536;
    const sctpPort = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=sctp-port:');
    if (sctpPort.length > 0) return {
        port: parseInt(sctpPort[0].substring(12), 10),
        protocol: mline.fmt,
        maxMessageSize: maxMessageSize
    };
    const sctpMapLines = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=sctpmap:');
    if (sctpMapLines.length > 0) {
        const parts = sctpMapLines[0].substring(10).split(' ');
        return {
            port: parseInt(parts[0], 10),
            protocol: parts[1],
            maxMessageSize: maxMessageSize
        };
    }
};
// SCTP
// outputs the draft-ietf-mmusic-sctp-sdp-26 version that all browsers
// support by now receiving in this format, unless we originally parsed
// as the draft-ietf-mmusic-sctp-sdp-05 format (indicated by the m-line
// protocol of DTLS/SCTP -- without UDP/ or TCP/)
$7522343ecaeeccb8$var$SDPUtils.writeSctpDescription = function(media, sctp) {
    let output = [];
    if (media.protocol !== 'DTLS/SCTP') output = [
        'm=' + media.kind + ' 9 ' + media.protocol + ' ' + sctp.protocol + '\r\n',
        'c=IN IP4 0.0.0.0\r\n',
        'a=sctp-port:' + sctp.port + '\r\n'
    ];
    else output = [
        'm=' + media.kind + ' 9 ' + media.protocol + ' ' + sctp.port + '\r\n',
        'c=IN IP4 0.0.0.0\r\n',
        'a=sctpmap:' + sctp.port + ' ' + sctp.protocol + ' 65535\r\n'
    ];
    if (sctp.maxMessageSize !== undefined) output.push('a=max-message-size:' + sctp.maxMessageSize + '\r\n');
    return output.join('');
};
// Generate a session ID for SDP.
// https://tools.ietf.org/html/draft-ietf-rtcweb-jsep-20#section-5.2.1
// recommends using a cryptographically random +ve 64-bit value
// but right now this should be acceptable and within the right range
$7522343ecaeeccb8$var$SDPUtils.generateSessionId = function() {
    return Math.random().toString().substr(2, 22);
};
// Write boiler plate for start of SDP
// sessId argument is optional - if not supplied it will
// be generated randomly
// sessVersion is optional and defaults to 2
// sessUser is optional and defaults to 'thisisadapterortc'
$7522343ecaeeccb8$var$SDPUtils.writeSessionBoilerplate = function(sessId, sessVer, sessUser) {
    let sessionId;
    const version = sessVer !== undefined ? sessVer : 2;
    if (sessId) sessionId = sessId;
    else sessionId = $7522343ecaeeccb8$var$SDPUtils.generateSessionId();
    const user = sessUser || 'thisisadapterortc';
    // FIXME: sess-id should be an NTP timestamp.
    return "v=0\r\no=" + user + ' ' + sessionId + ' ' + version + ' IN IP4 127.0.0.1\r\n' + 's=-\r\n' + 't=0 0\r\n';
};
// Gets the direction from the mediaSection or the sessionpart.
$7522343ecaeeccb8$var$SDPUtils.getDirection = function(mediaSection, sessionpart) {
    // Look for sendrecv, sendonly, recvonly, inactive, default to sendrecv.
    const lines = $7522343ecaeeccb8$var$SDPUtils.splitLines(mediaSection);
    for(let i = 0; i < lines.length; i++)switch(lines[i]){
        case 'a=sendrecv':
        case 'a=sendonly':
        case 'a=recvonly':
        case 'a=inactive':
            return lines[i].substring(2);
        default:
    }
    if (sessionpart) return $7522343ecaeeccb8$var$SDPUtils.getDirection(sessionpart);
    return 'sendrecv';
};
$7522343ecaeeccb8$var$SDPUtils.getKind = function(mediaSection) {
    const lines = $7522343ecaeeccb8$var$SDPUtils.splitLines(mediaSection);
    const mline = lines[0].split(' ');
    return mline[0].substring(2);
};
$7522343ecaeeccb8$var$SDPUtils.isRejected = function(mediaSection) {
    return mediaSection.split(' ', 2)[1] === '0';
};
$7522343ecaeeccb8$var$SDPUtils.parseMLine = function(mediaSection) {
    const lines = $7522343ecaeeccb8$var$SDPUtils.splitLines(mediaSection);
    const parts = lines[0].substring(2).split(' ');
    return {
        kind: parts[0],
        port: parseInt(parts[1], 10),
        protocol: parts[2],
        fmt: parts.slice(3).join(' ')
    };
};
$7522343ecaeeccb8$var$SDPUtils.parseOLine = function(mediaSection) {
    const line = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'o=')[0];
    const parts = line.substring(2).split(' ');
    return {
        username: parts[0],
        sessionId: parts[1],
        sessionVersion: parseInt(parts[2], 10),
        netType: parts[3],
        addressType: parts[4],
        address: parts[5]
    };
};
// a very naive interpretation of a valid SDP.
$7522343ecaeeccb8$var$SDPUtils.isValidSDP = function(blob) {
    if (typeof blob !== 'string' || blob.length === 0) return false;
    const lines = $7522343ecaeeccb8$var$SDPUtils.splitLines(blob);
    for(let i = 0; i < lines.length; i++){
        if (lines[i].length < 2 || lines[i].charAt(1) !== '=') return false;
    // TODO: check the modifier a bit more.
    }
    return true;
};
$7522343ecaeeccb8$exports = $7522343ecaeeccb8$var$SDPUtils;



'use strict';
function $599d92f2f0dc2dee$export$cf133661e444ccfe(window) {
    // foundation is arbitrarily chosen as an indicator for full support for
    // https://w3c.github.io/webrtc-pc/#rtcicecandidate-interface
    if (!window.RTCIceCandidate || window.RTCIceCandidate && 'foundation' in window.RTCIceCandidate.prototype) return;
    const NativeRTCIceCandidate = window.RTCIceCandidate;
    window.RTCIceCandidate = function RTCIceCandidate(args) {
        // Remove the a= which shouldn't be part of the candidate string.
        if (typeof args === 'object' && args.candidate && args.candidate.indexOf('a=') === 0) {
            args = JSON.parse(JSON.stringify(args));
            args.candidate = args.candidate.substring(2);
        }
        if (args.candidate && args.candidate.length) {
            // Augment the native candidate with the parsed fields.
            const nativeCandidate = new NativeRTCIceCandidate(args);
            const parsedCandidate = (0, (/*@__PURE__*/$parcel$interopDefault($7522343ecaeeccb8$exports))).parseCandidate(args.candidate);
            for(const key in parsedCandidate)if (!(key in nativeCandidate)) Object.defineProperty(nativeCandidate, key, {
                value: parsedCandidate[key]
            });
            // Override serializer to not serialize the extra attributes.
            nativeCandidate.toJSON = function toJSON() {
                return {
                    candidate: nativeCandidate.candidate,
                    sdpMid: nativeCandidate.sdpMid,
                    sdpMLineIndex: nativeCandidate.sdpMLineIndex,
                    usernameFragment: nativeCandidate.usernameFragment
                };
            };
            return nativeCandidate;
        }
        return new NativeRTCIceCandidate(args);
    };
    window.RTCIceCandidate.prototype = NativeRTCIceCandidate.prototype;
    // Hook up the augmented candidate in onicecandidate and
    // addEventListener('icecandidate', ...)
    $584b81f9a9b8bf97$export$1f48841962b828b1(window, 'icecandidate', (e)=>{
        if (e.candidate) Object.defineProperty(e, 'candidate', {
            value: new window.RTCIceCandidate(e.candidate),
            writable: 'false'
        });
        return e;
    });
}
function $599d92f2f0dc2dee$export$fdafb8d8280e29b5(window) {
    if (!window.RTCIceCandidate || window.RTCIceCandidate && 'relayProtocol' in window.RTCIceCandidate.prototype) return;
    // Hook up the augmented candidate in onicecandidate and
    // addEventListener('icecandidate', ...)
    $584b81f9a9b8bf97$export$1f48841962b828b1(window, 'icecandidate', (e)=>{
        if (e.candidate) {
            const parsedCandidate = (0, (/*@__PURE__*/$parcel$interopDefault($7522343ecaeeccb8$exports))).parseCandidate(e.candidate.candidate);
            if (parsedCandidate.type === 'relay') // This is a libwebrtc-specific mapping of local type preference
            // to relayProtocol.
            e.candidate.relayProtocol = ({
                0: 'tls',
                1: 'tcp',
                2: 'udp'
            })[parsedCandidate.priority >> 24];
        }
        return e;
    });
}
function $599d92f2f0dc2dee$export$a99147c78a56edc4(window, browserDetails) {
    if (!window.RTCPeerConnection) return;
    if (!('sctp' in window.RTCPeerConnection.prototype)) Object.defineProperty(window.RTCPeerConnection.prototype, 'sctp', {
        get () {
            return typeof this._sctp === 'undefined' ? null : this._sctp;
        }
    });
    const sctpInDescription = function(description) {
        if (!description || !description.sdp) return false;
        const sections = (0, (/*@__PURE__*/$parcel$interopDefault($7522343ecaeeccb8$exports))).splitSections(description.sdp);
        sections.shift();
        return sections.some((mediaSection)=>{
            const mLine = (0, (/*@__PURE__*/$parcel$interopDefault($7522343ecaeeccb8$exports))).parseMLine(mediaSection);
            return mLine && mLine.kind === 'application' && mLine.protocol.indexOf('SCTP') !== -1;
        });
    };
    const getRemoteFirefoxVersion = function(description) {
        // TODO: Is there a better solution for detecting Firefox?
        const match = description.sdp.match(/mozilla...THIS_IS_SDPARTA-(\d+)/);
        if (match === null || match.length < 2) return -1;
        const version = parseInt(match[1], 10);
        // Test for NaN (yes, this is ugly)
        return version !== version ? -1 : version;
    };
    const getCanSendMaxMessageSize = function(remoteIsFirefox) {
        // Every implementation we know can send at least 64 KiB.
        // Note: Although Chrome is technically able to send up to 256 KiB, the
        //       data does not reach the other peer reliably.
        //       See: https://bugs.chromium.org/p/webrtc/issues/detail?id=8419
        let canSendMaxMessageSize = 65536;
        if (browserDetails.browser === 'firefox') {
            if (browserDetails.version < 57) {
                if (remoteIsFirefox === -1) // FF < 57 will send in 16 KiB chunks using the deprecated PPID
                // fragmentation.
                canSendMaxMessageSize = 16384;
                else // However, other FF (and RAWRTC) can reassemble PPID-fragmented
                // messages. Thus, supporting ~2 GiB when sending.
                canSendMaxMessageSize = 2147483637;
            } else if (browserDetails.version < 60) // Currently, all FF >= 57 will reset the remote maximum message size
            // to the default value when a data channel is created at a later
            // stage. :(
            // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
            canSendMaxMessageSize = browserDetails.version === 57 ? 65535 : 65536;
            else // FF >= 60 supports sending ~2 GiB
            canSendMaxMessageSize = 2147483637;
        }
        return canSendMaxMessageSize;
    };
    const getMaxMessageSize = function(description, remoteIsFirefox) {
        // Note: 65536 bytes is the default value from the SDP spec. Also,
        //       every implementation we know supports receiving 65536 bytes.
        let maxMessageSize = 65536;
        // FF 57 has a slightly incorrect default remote max message size, so
        // we need to adjust it here to avoid a failure when sending.
        // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1425697
        if (browserDetails.browser === 'firefox' && browserDetails.version === 57) maxMessageSize = 65535;
        const match = (0, (/*@__PURE__*/$parcel$interopDefault($7522343ecaeeccb8$exports))).matchPrefix(description.sdp, 'a=max-message-size:');
        if (match.length > 0) maxMessageSize = parseInt(match[0].substring(19), 10);
        else if (browserDetails.browser === 'firefox' && remoteIsFirefox !== -1) // If the maximum message size is not present in the remote SDP and
        // both local and remote are Firefox, the remote peer can receive
        // ~2 GiB.
        maxMessageSize = 2147483637;
        return maxMessageSize;
    };
    const origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
    window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
        this._sctp = null;
        // Chrome decided to not expose .sctp in plan-b mode.
        // As usual, adapter.js has to do an 'ugly worakaround'
        // to cover up the mess.
        if (browserDetails.browser === 'chrome' && browserDetails.version >= 76) {
            const { sdpSemantics: sdpSemantics } = this.getConfiguration();
            if (sdpSemantics === 'plan-b') Object.defineProperty(this, 'sctp', {
                get () {
                    return typeof this._sctp === 'undefined' ? null : this._sctp;
                },
                enumerable: true,
                configurable: true
            });
        }
        if (sctpInDescription(arguments[0])) {
            // Check if the remote is FF.
            const isFirefox = getRemoteFirefoxVersion(arguments[0]);
            // Get the maximum message size the local peer is capable of sending
            const canSendMMS = getCanSendMaxMessageSize(isFirefox);
            // Get the maximum message size of the remote peer.
            const remoteMMS = getMaxMessageSize(arguments[0], isFirefox);
            // Determine final maximum message size
            let maxMessageSize;
            if (canSendMMS === 0 && remoteMMS === 0) maxMessageSize = Number.POSITIVE_INFINITY;
            else if (canSendMMS === 0 || remoteMMS === 0) maxMessageSize = Math.max(canSendMMS, remoteMMS);
            else maxMessageSize = Math.min(canSendMMS, remoteMMS);
            // Create a dummy RTCSctpTransport object and the 'maxMessageSize'
            // attribute.
            const sctp = {};
            Object.defineProperty(sctp, 'maxMessageSize', {
                get () {
                    return maxMessageSize;
                }
            });
            this._sctp = sctp;
        }
        return origSetRemoteDescription.apply(this, arguments);
    };
}
function $599d92f2f0dc2dee$export$d461c8d5c5db5da7(window) {
    if (!(window.RTCPeerConnection && 'createDataChannel' in window.RTCPeerConnection.prototype)) return;
    // Note: Although Firefox >= 57 has a native implementation, the maximum
    //       message size can be reset for all data channels at a later stage.
    //       See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
    function wrapDcSend(dc, pc) {
        const origDataChannelSend = dc.send;
        dc.send = function send() {
            const data = arguments[0];
            const length = data.length || data.size || data.byteLength;
            if (dc.readyState === 'open' && pc.sctp && length > pc.sctp.maxMessageSize) throw new TypeError('Message too large (can send a maximum of ' + pc.sctp.maxMessageSize + ' bytes)');
            return origDataChannelSend.apply(dc, arguments);
        };
    }
    const origCreateDataChannel = window.RTCPeerConnection.prototype.createDataChannel;
    window.RTCPeerConnection.prototype.createDataChannel = function createDataChannel() {
        const dataChannel = origCreateDataChannel.apply(this, arguments);
        wrapDcSend(dataChannel, this);
        return dataChannel;
    };
    $584b81f9a9b8bf97$export$1f48841962b828b1(window, 'datachannel', (e)=>{
        wrapDcSend(e.channel, e.target);
        return e;
    });
}
function $599d92f2f0dc2dee$export$63bb816cc75460(window) {
    if (!window.RTCPeerConnection || 'connectionState' in window.RTCPeerConnection.prototype) return;
    const proto = window.RTCPeerConnection.prototype;
    Object.defineProperty(proto, 'connectionState', {
        get () {
            return ({
                completed: 'connected',
                checking: 'connecting'
            })[this.iceConnectionState] || this.iceConnectionState;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(proto, 'onconnectionstatechange', {
        get () {
            return this._onconnectionstatechange || null;
        },
        set (cb) {
            if (this._onconnectionstatechange) {
                this.removeEventListener('connectionstatechange', this._onconnectionstatechange);
                delete this._onconnectionstatechange;
            }
            if (cb) this.addEventListener('connectionstatechange', this._onconnectionstatechange = cb);
        },
        enumerable: true,
        configurable: true
    });
    [
        'setLocalDescription',
        'setRemoteDescription'
    ].forEach((method)=>{
        const origMethod = proto[method];
        proto[method] = function() {
            if (!this._connectionstatechangepoly) {
                this._connectionstatechangepoly = (e)=>{
                    const pc = e.target;
                    if (pc._lastConnectionState !== pc.connectionState) {
                        pc._lastConnectionState = pc.connectionState;
                        const newEvent = new Event('connectionstatechange', e);
                        pc.dispatchEvent(newEvent);
                    }
                    return e;
                };
                this.addEventListener('iceconnectionstatechange', this._connectionstatechangepoly);
            }
            return origMethod.apply(this, arguments);
        };
    });
}
function $599d92f2f0dc2dee$export$a57d114344295149(window, browserDetails) {
    /* remove a=extmap-allow-mixed for webrtc.org < M71 */ if (!window.RTCPeerConnection) return;
    if (browserDetails.browser === 'chrome' && browserDetails.version >= 71) return;
    if (browserDetails.browser === 'safari' && browserDetails._safariVersion >= 13.1) return;
    const nativeSRD = window.RTCPeerConnection.prototype.setRemoteDescription;
    window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription(desc) {
        if (desc && desc.sdp && desc.sdp.indexOf('\na=extmap-allow-mixed') !== -1) {
            const sdp = desc.sdp.split('\n').filter((line)=>{
                return line.trim() !== 'a=extmap-allow-mixed';
            }).join('\n');
            // Safari enforces read-only-ness of RTCSessionDescription fields.
            if (window.RTCSessionDescription && desc instanceof window.RTCSessionDescription) arguments[0] = new window.RTCSessionDescription({
                type: desc.type,
                sdp: sdp
            });
            else desc.sdp = sdp;
        }
        return nativeSRD.apply(this, arguments);
    };
}
function $599d92f2f0dc2dee$export$51d5e40b48c771c7(window, browserDetails) {
    // Support for addIceCandidate(null or undefined)
    // as well as addIceCandidate({candidate: "", ...})
    // https://bugs.chromium.org/p/chromium/issues/detail?id=978582
    // Note: must be called before other polyfills which change the signature.
    if (!(window.RTCPeerConnection && window.RTCPeerConnection.prototype)) return;
    const nativeAddIceCandidate = window.RTCPeerConnection.prototype.addIceCandidate;
    if (!nativeAddIceCandidate || nativeAddIceCandidate.length === 0) return;
    window.RTCPeerConnection.prototype.addIceCandidate = function addIceCandidate() {
        if (!arguments[0]) {
            if (arguments[1]) arguments[1].apply(null);
            return Promise.resolve();
        }
        // Firefox 68+ emits and processes {candidate: "", ...}, ignore
        // in older versions.
        // Native support for ignoring exists for Chrome M77+.
        // Safari ignores as well, exact version unknown but works in the same
        // version that also ignores addIceCandidate(null).
        if ((browserDetails.browser === 'chrome' && browserDetails.version < 78 || browserDetails.browser === 'firefox' && browserDetails.version < 68 || browserDetails.browser === 'safari') && arguments[0] && arguments[0].candidate === '') return Promise.resolve();
        return nativeAddIceCandidate.apply(this, arguments);
    };
}
function $599d92f2f0dc2dee$export$7170d04e59f9d553(window, browserDetails) {
    if (!(window.RTCPeerConnection && window.RTCPeerConnection.prototype)) return;
    const nativeSetLocalDescription = window.RTCPeerConnection.prototype.setLocalDescription;
    if (!nativeSetLocalDescription || nativeSetLocalDescription.length === 0) return;
    window.RTCPeerConnection.prototype.setLocalDescription = function setLocalDescription() {
        let desc = arguments[0] || {};
        if (typeof desc !== 'object' || desc.type && desc.sdp) return nativeSetLocalDescription.apply(this, arguments);
        // The remaining steps should technically happen when SLD comes off the
        // RTCPeerConnection's operations chain (not ahead of going on it), but
        // this is too difficult to shim. Instead, this shim only covers the
        // common case where the operations chain is empty. This is imperfect, but
        // should cover many cases. Rationale: Even if we can't reduce the glare
        // window to zero on imperfect implementations, there's value in tapping
        // into the perfect negotiation pattern that several browsers support.
        desc = {
            type: desc.type,
            sdp: desc.sdp
        };
        if (!desc.type) switch(this.signalingState){
            case 'stable':
            case 'have-local-offer':
            case 'have-remote-pranswer':
                desc.type = 'offer';
                break;
            default:
                desc.type = 'answer';
                break;
        }
        if (desc.sdp || desc.type !== 'offer' && desc.type !== 'answer') return nativeSetLocalDescription.apply(this, [
            desc
        ]);
        const func = desc.type === 'offer' ? this.createOffer : this.createAnswer;
        return func.apply(this).then((d)=>nativeSetLocalDescription.apply(this, [
                d
            ]));
    };
}



function $e095574c16a43495$export$e77bf46c04ac7d12({ window: window } = {}, options = {
    shimChrome: true,
    shimFirefox: true,
    shimSafari: true
}) {
    // Utils.
    const logging = $584b81f9a9b8bf97$export$bef1f36f5486a6a3;
    const browserDetails = $584b81f9a9b8bf97$export$2d31490a0c05f094(window);
    const adapter = {
        browserDetails: browserDetails,
        commonShim: $599d92f2f0dc2dee$exports,
        extractVersion: $584b81f9a9b8bf97$export$e3c02be309be1f23,
        disableLog: $584b81f9a9b8bf97$export$afbfee8cc06fd3e4,
        disableWarnings: $584b81f9a9b8bf97$export$51516be4b019e41e,
        sdp: // Expose sdp as a convenience. For production apps include directly.
        $7522343ecaeeccb8$exports
    };
    // Shim browser if found.
    switch(browserDetails.browser){
        case 'chrome':
            if (!$558eb894511c4db3$exports || !$558eb894511c4db3$exports.shimPeerConnection || !options.shimChrome) {
                logging('Chrome shim is not included in this adapter release.');
                return adapter;
            }
            if (browserDetails.version === null) {
                logging('Chrome shim can not determine version, not shimming.');
                return adapter;
            }
            logging('adapter.js shimming chrome.');
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $558eb894511c4db3$exports;
            // Must be called before shimPeerConnection.
            $599d92f2f0dc2dee$export$51d5e40b48c771c7(window, browserDetails);
            $599d92f2f0dc2dee$export$7170d04e59f9d553(window, browserDetails);
            $558eb894511c4db3$exports.shimGetUserMedia(window, browserDetails);
            $558eb894511c4db3$exports.shimMediaStream(window, browserDetails);
            $558eb894511c4db3$exports.shimPeerConnection(window, browserDetails);
            $558eb894511c4db3$exports.shimOnTrack(window, browserDetails);
            $558eb894511c4db3$exports.shimAddTrackRemoveTrack(window, browserDetails);
            $558eb894511c4db3$exports.shimGetSendersWithDtmf(window, browserDetails);
            $558eb894511c4db3$exports.shimGetStats(window, browserDetails);
            $558eb894511c4db3$exports.shimSenderReceiverGetStats(window, browserDetails);
            $558eb894511c4db3$exports.fixNegotiationNeeded(window, browserDetails);
            $599d92f2f0dc2dee$export$cf133661e444ccfe(window, browserDetails);
            $599d92f2f0dc2dee$export$fdafb8d8280e29b5(window, browserDetails);
            $599d92f2f0dc2dee$export$63bb816cc75460(window, browserDetails);
            $599d92f2f0dc2dee$export$a99147c78a56edc4(window, browserDetails);
            $599d92f2f0dc2dee$export$d461c8d5c5db5da7(window, browserDetails);
            $599d92f2f0dc2dee$export$a57d114344295149(window, browserDetails);
            break;
        case 'firefox':
            if (!$c518d147eb169a8d$exports || !$c518d147eb169a8d$exports.shimPeerConnection || !options.shimFirefox) {
                logging('Firefox shim is not included in this adapter release.');
                return adapter;
            }
            logging('adapter.js shimming firefox.');
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $c518d147eb169a8d$exports;
            // Must be called before shimPeerConnection.
            $599d92f2f0dc2dee$export$51d5e40b48c771c7(window, browserDetails);
            $599d92f2f0dc2dee$export$7170d04e59f9d553(window, browserDetails);
            $c518d147eb169a8d$exports.shimGetUserMedia(window, browserDetails);
            $c518d147eb169a8d$exports.shimPeerConnection(window, browserDetails);
            $c518d147eb169a8d$exports.shimOnTrack(window, browserDetails);
            $c518d147eb169a8d$exports.shimRemoveStream(window, browserDetails);
            $c518d147eb169a8d$exports.shimSenderGetStats(window, browserDetails);
            $c518d147eb169a8d$exports.shimReceiverGetStats(window, browserDetails);
            $c518d147eb169a8d$exports.shimRTCDataChannel(window, browserDetails);
            $c518d147eb169a8d$exports.shimAddTransceiver(window, browserDetails);
            $c518d147eb169a8d$exports.shimGetParameters(window, browserDetails);
            $c518d147eb169a8d$exports.shimCreateOffer(window, browserDetails);
            $c518d147eb169a8d$exports.shimCreateAnswer(window, browserDetails);
            $599d92f2f0dc2dee$export$cf133661e444ccfe(window, browserDetails);
            $599d92f2f0dc2dee$export$63bb816cc75460(window, browserDetails);
            $599d92f2f0dc2dee$export$a99147c78a56edc4(window, browserDetails);
            $599d92f2f0dc2dee$export$d461c8d5c5db5da7(window, browserDetails);
            break;
        case 'safari':
            if (!$9a20cef3f9b7f4b6$exports || !options.shimSafari) {
                logging('Safari shim is not included in this adapter release.');
                return adapter;
            }
            logging('adapter.js shimming safari.');
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $9a20cef3f9b7f4b6$exports;
            // Must be called before shimCallbackAPI.
            $599d92f2f0dc2dee$export$51d5e40b48c771c7(window, browserDetails);
            $599d92f2f0dc2dee$export$7170d04e59f9d553(window, browserDetails);
            $9a20cef3f9b7f4b6$exports.shimRTCIceServerUrls(window, browserDetails);
            $9a20cef3f9b7f4b6$exports.shimCreateOfferLegacy(window, browserDetails);
            $9a20cef3f9b7f4b6$exports.shimCallbacksAPI(window, browserDetails);
            $9a20cef3f9b7f4b6$exports.shimLocalStreamsAPI(window, browserDetails);
            $9a20cef3f9b7f4b6$exports.shimRemoteStreamsAPI(window, browserDetails);
            $9a20cef3f9b7f4b6$exports.shimTrackEventTransceiver(window, browserDetails);
            $9a20cef3f9b7f4b6$exports.shimGetUserMedia(window, browserDetails);
            $9a20cef3f9b7f4b6$exports.shimAudioContext(window, browserDetails);
            $599d92f2f0dc2dee$export$cf133661e444ccfe(window, browserDetails);
            $599d92f2f0dc2dee$export$fdafb8d8280e29b5(window, browserDetails);
            $599d92f2f0dc2dee$export$a99147c78a56edc4(window, browserDetails);
            $599d92f2f0dc2dee$export$d461c8d5c5db5da7(window, browserDetails);
            $599d92f2f0dc2dee$export$a57d114344295149(window, browserDetails);
            break;
        default:
            logging('Unsupported browser!');
            break;
    }
    return adapter;
}


'use strict';
const $09d981616173740d$var$adapter = (0, $e095574c16a43495$export$e77bf46c04ac7d12)({
    window: typeof window === 'undefined' ? undefined : window
});
var $09d981616173740d$export$2e2bcd8739ae039 = $09d981616173740d$var$adapter;


/**
 * Get the type of a JSON value.
 * Distinguishes between array, null and object.
 */ function $9b0297e2871b9bc0$export$664ede5272d59144(value) {
    let t = typeof value;
    if (t == "object") {
        if (Array.isArray(value)) return "array";
        if (value === null) return "null";
    }
    return t;
}
function $9b0297e2871b9bc0$export$98727920b98c3cdb(value) {
    return value !== null && typeof value == "object" && !Array.isArray(value);
}

/**
 * The symbol used as a key on message objects to store the message type.
 *
 * Note that this is an experimental feature - it is here to stay, but
 * implementation details may change without notice.
 */ const $851284a8a8af4698$export$87130b6dd9721cee = Symbol.for("protobuf-ts/message-type");


/**
 * Converts snake_case to lowerCamelCase.
 *
 * Should behave like protoc:
 * https://github.com/protocolbuffers/protobuf/blob/e8ae137c96444ea313485ed1118c5e43b2099cf1/src/google/protobuf/compiler/java/java_helpers.cc#L118
 */ function $ea8ab3bbbe8a3a0f$export$2bcb3d1403ab3e47(snakeCase) {
    let capNext = false;
    const sb = [];
    for(let i = 0; i < snakeCase.length; i++){
        let next = snakeCase.charAt(i);
        if (next == '_') capNext = true;
        else if (/\d/.test(next)) {
            sb.push(next);
            capNext = true;
        } else if (capNext) {
            sb.push(next.toUpperCase());
            capNext = false;
        } else if (i == 0) sb.push(next.toLowerCase());
        else sb.push(next);
    }
    return sb.join('');
}


var $30d9113c3699bf07$export$d40a369a25702af0;
(function(ScalarType) {
    // 0 is reserved for errors.
    // Order is weird for historical reasons.
    ScalarType[ScalarType["DOUBLE"] = 1] = "DOUBLE";
    ScalarType[ScalarType["FLOAT"] = 2] = "FLOAT";
    // Not ZigZag encoded.  Negative numbers take 10 bytes.  Use TYPE_SINT64 if
    // negative values are likely.
    ScalarType[ScalarType["INT64"] = 3] = "INT64";
    ScalarType[ScalarType["UINT64"] = 4] = "UINT64";
    // Not ZigZag encoded.  Negative numbers take 10 bytes.  Use TYPE_SINT32 if
    // negative values are likely.
    ScalarType[ScalarType["INT32"] = 5] = "INT32";
    ScalarType[ScalarType["FIXED64"] = 6] = "FIXED64";
    ScalarType[ScalarType["FIXED32"] = 7] = "FIXED32";
    ScalarType[ScalarType["BOOL"] = 8] = "BOOL";
    ScalarType[ScalarType["STRING"] = 9] = "STRING";
    // Tag-delimited aggregate.
    // Group type is deprecated and not supported in proto3. However, Proto3
    // implementations should still be able to parse the group wire format and
    // treat group fields as unknown fields.
    // TYPE_GROUP = 10,
    // TYPE_MESSAGE = 11,  // Length-delimited aggregate.
    // New in version 2.
    ScalarType[ScalarType["BYTES"] = 12] = "BYTES";
    ScalarType[ScalarType["UINT32"] = 13] = "UINT32";
    // TYPE_ENUM = 14,
    ScalarType[ScalarType["SFIXED32"] = 15] = "SFIXED32";
    ScalarType[ScalarType["SFIXED64"] = 16] = "SFIXED64";
    ScalarType[ScalarType["SINT32"] = 17] = "SINT32";
    ScalarType[ScalarType["SINT64"] = 18] = "SINT64";
})($30d9113c3699bf07$export$d40a369a25702af0 || ($30d9113c3699bf07$export$d40a369a25702af0 = {}));
var $30d9113c3699bf07$export$a3fb1069ae3b8bb4;
(function(LongType) {
    /**
     * Use JavaScript `bigint`.
     *
     * Field option `[jstype = JS_NORMAL]`.
     */ LongType[LongType["BIGINT"] = 0] = "BIGINT";
    /**
     * Use JavaScript `string`.
     *
     * Field option `[jstype = JS_STRING]`.
     */ LongType[LongType["STRING"] = 1] = "STRING";
    /**
     * Use JavaScript `number`.
     *
     * Large values will loose precision.
     *
     * Field option `[jstype = JS_NUMBER]`.
     */ LongType[LongType["NUMBER"] = 2] = "NUMBER";
})($30d9113c3699bf07$export$a3fb1069ae3b8bb4 || ($30d9113c3699bf07$export$a3fb1069ae3b8bb4 = {}));
var $30d9113c3699bf07$export$3c05d9da25cb7a9;
(function(RepeatType) {
    /**
     * The field is not repeated.
     */ RepeatType[RepeatType["NO"] = 0] = "NO";
    /**
     * The field is repeated and should be packed.
     * Invalid for `bytes` and `string`, they cannot be packed.
     */ RepeatType[RepeatType["PACKED"] = 1] = "PACKED";
    /**
     * The field is repeated but should not be packed.
     * The only valid repeat type for repeated `bytes` and `string`.
     */ RepeatType[RepeatType["UNPACKED"] = 2] = "UNPACKED";
})($30d9113c3699bf07$export$3c05d9da25cb7a9 || ($30d9113c3699bf07$export$3c05d9da25cb7a9 = {}));
function $30d9113c3699bf07$export$447fc6430fb31fd6(field) {
    var _a, _b, _c, _d;
    field.localName = (_a = field.localName) !== null && _a !== void 0 ? _a : (0, $ea8ab3bbbe8a3a0f$export$2bcb3d1403ab3e47)(field.name);
    field.jsonName = (_b = field.jsonName) !== null && _b !== void 0 ? _b : (0, $ea8ab3bbbe8a3a0f$export$2bcb3d1403ab3e47)(field.name);
    field.repeat = (_c = field.repeat) !== null && _c !== void 0 ? _c : $30d9113c3699bf07$export$3c05d9da25cb7a9.NO;
    field.opt = (_d = field.opt) !== null && _d !== void 0 ? _d : field.repeat ? false : field.oneof ? false : field.kind == "message";
    return field;
}
function $30d9113c3699bf07$export$9912926324fefcb(messageType, fieldName, extensionName, extensionType) {
    var _a;
    const options = (_a = messageType.fields.find((m, i)=>m.localName == fieldName || i == fieldName)) === null || _a === void 0 ? void 0 : _a.options;
    return options && options[extensionName] ? extensionType.fromJson(options[extensionName]) : undefined;
}
function $30d9113c3699bf07$export$d043a97b27c6a8b(messageType, fieldName, extensionName, extensionType) {
    var _a;
    const options = (_a = messageType.fields.find((m, i)=>m.localName == fieldName || i == fieldName)) === null || _a === void 0 ? void 0 : _a.options;
    if (!options) return undefined;
    const optionVal = options[extensionName];
    if (optionVal === undefined) return optionVal;
    return extensionType ? extensionType.fromJson(optionVal) : optionVal;
}
function $30d9113c3699bf07$export$ab424c63a2206e68(messageType, extensionName, extensionType) {
    const options = messageType.options;
    const optionVal = options[extensionName];
    if (optionVal === undefined) return optionVal;
    return extensionType ? extensionType.fromJson(optionVal) : optionVal;
}



/**
 * Is the given value a valid oneof group?
 *
 * We represent protobuf `oneof` as algebraic data types (ADT) in generated
 * code. But when working with messages of unknown type, the ADT does not
 * help us.
 *
 * This type guard checks if the given object adheres to the ADT rules, which
 * are as follows:
 *
 * 1) Must be an object.
 *
 * 2) Must have a "oneofKind" discriminator property.
 *
 * 3) If "oneofKind" is `undefined`, no member field is selected. The object
 * must not have any other properties.
 *
 * 4) If "oneofKind" is a `string`, the member field with this name is
 * selected.
 *
 * 5) If a member field is selected, the object must have a second property
 * with this name. The property must not be `undefined`.
 *
 * 6) No extra properties are allowed. The object has either one property
 * (no selection) or two properties (selection).
 *
 */ function $7ce9a86b3df91e1e$export$dcaa6868190faa1b(any) {
    if (typeof any != 'object' || any === null || !any.hasOwnProperty('oneofKind')) return false;
    switch(typeof any.oneofKind){
        case "string":
            if (any[any.oneofKind] === undefined) return false;
            return Object.keys(any).length == 2;
        case "undefined":
            return Object.keys(any).length == 1;
        default:
            return false;
    }
}
function $7ce9a86b3df91e1e$export$7a91ad8ad738cbfa(oneof, kind) {
    return oneof[kind];
}
function $7ce9a86b3df91e1e$export$429eba4cfebddb3f(oneof, kind, value) {
    if (oneof.oneofKind !== undefined) delete oneof[oneof.oneofKind];
    oneof.oneofKind = kind;
    if (value !== undefined) oneof[kind] = value;
}
function $7ce9a86b3df91e1e$export$b53620574aab7d1b(oneof, kind, value) {
    if (oneof.oneofKind !== undefined) delete oneof[oneof.oneofKind];
    oneof.oneofKind = kind;
    if (value !== undefined && kind !== undefined) oneof[kind] = value;
}
function $7ce9a86b3df91e1e$export$4e2f7a1f2c45f42a(oneof) {
    if (oneof.oneofKind !== undefined) delete oneof[oneof.oneofKind];
    oneof.oneofKind = undefined;
}
function $7ce9a86b3df91e1e$export$448d0647af41b287(oneof) {
    if (oneof.oneofKind === undefined) return undefined;
    return oneof[oneof.oneofKind];
}


class $06d2af0b6d81a0d7$export$909924fefdf89590 {
    constructor(info){
        var _a;
        this.fields = (_a = info.fields) !== null && _a !== void 0 ? _a : [];
    }
    prepare() {
        if (this.data) return;
        const req = [], known = [], oneofs = [];
        for (let field of this.fields){
            if (field.oneof) {
                if (!oneofs.includes(field.oneof)) {
                    oneofs.push(field.oneof);
                    req.push(field.oneof);
                    known.push(field.oneof);
                }
            } else {
                known.push(field.localName);
                switch(field.kind){
                    case "scalar":
                    case "enum":
                        if (!field.opt || field.repeat) req.push(field.localName);
                        break;
                    case "message":
                        if (field.repeat) req.push(field.localName);
                        break;
                    case "map":
                        req.push(field.localName);
                        break;
                }
            }
        }
        this.data = {
            req: req,
            known: known,
            oneofs: Object.values(oneofs)
        };
    }
    /**
     * Is the argument a valid message as specified by the
     * reflection information?
     *
     * Checks all field types recursively. The `depth`
     * specifies how deep into the structure the check will be.
     *
     * With a depth of 0, only the presence of fields
     * is checked.
     *
     * With a depth of 1 or more, the field types are checked.
     *
     * With a depth of 2 or more, the members of map, repeated
     * and message fields are checked.
     *
     * Message fields will be checked recursively with depth - 1.
     *
     * The number of map entries / repeated values being checked
     * is < depth.
     */ is(message, depth, allowExcessProperties = false) {
        if (depth < 0) return true;
        if (message === null || message === undefined || typeof message != 'object') return false;
        this.prepare();
        let keys = Object.keys(message), data = this.data;
        // if a required field is missing in arg, this cannot be a T
        if (keys.length < data.req.length || data.req.some((n)=>!keys.includes(n))) return false;
        if (!allowExcessProperties) {
            // if the arg contains a key we dont know, this is not a literal T
            if (keys.some((k)=>!data.known.includes(k))) return false;
        }
        // "With a depth of 0, only the presence and absence of fields is checked."
        // "With a depth of 1 or more, the field types are checked."
        if (depth < 1) return true;
        // check oneof group
        for (const name of data.oneofs){
            const group = message[name];
            if (!(0, $7ce9a86b3df91e1e$export$dcaa6868190faa1b)(group)) return false;
            if (group.oneofKind === undefined) continue;
            const field = this.fields.find((f)=>f.localName === group.oneofKind);
            if (!field) return false; // we found no field, but have a kind, something is wrong
            if (!this.field(group[group.oneofKind], field, allowExcessProperties, depth)) return false;
        }
        // check types
        for (const field of this.fields){
            if (field.oneof !== undefined) continue;
            if (!this.field(message[field.localName], field, allowExcessProperties, depth)) return false;
        }
        return true;
    }
    field(arg, field, allowExcessProperties, depth) {
        let repeated = field.repeat;
        switch(field.kind){
            case "scalar":
                if (arg === undefined) return field.opt;
                if (repeated) return this.scalars(arg, field.T, depth, field.L);
                return this.scalar(arg, field.T, field.L);
            case "enum":
                if (arg === undefined) return field.opt;
                if (repeated) return this.scalars(arg, (0, $30d9113c3699bf07$export$d40a369a25702af0).INT32, depth);
                return this.scalar(arg, (0, $30d9113c3699bf07$export$d40a369a25702af0).INT32);
            case "message":
                if (arg === undefined) return true;
                if (repeated) return this.messages(arg, field.T(), allowExcessProperties, depth);
                return this.message(arg, field.T(), allowExcessProperties, depth);
            case "map":
                if (typeof arg != 'object' || arg === null) return false;
                if (depth < 2) return true;
                if (!this.mapKeys(arg, field.K, depth)) return false;
                switch(field.V.kind){
                    case "scalar":
                        return this.scalars(Object.values(arg), field.V.T, depth, field.V.L);
                    case "enum":
                        return this.scalars(Object.values(arg), (0, $30d9113c3699bf07$export$d40a369a25702af0).INT32, depth);
                    case "message":
                        return this.messages(Object.values(arg), field.V.T(), allowExcessProperties, depth);
                }
                break;
        }
        return true;
    }
    message(arg, type, allowExcessProperties, depth) {
        if (allowExcessProperties) return type.isAssignable(arg, depth);
        return type.is(arg, depth);
    }
    messages(arg, type, allowExcessProperties, depth) {
        if (!Array.isArray(arg)) return false;
        if (depth < 2) return true;
        if (allowExcessProperties) {
            for(let i = 0; i < arg.length && i < depth; i++)if (!type.isAssignable(arg[i], depth - 1)) return false;
        } else {
            for(let i = 0; i < arg.length && i < depth; i++)if (!type.is(arg[i], depth - 1)) return false;
        }
        return true;
    }
    scalar(arg, type, longType) {
        let argType = typeof arg;
        switch(type){
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).UINT64:
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).FIXED64:
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).INT64:
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).SFIXED64:
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).SINT64:
                switch(longType){
                    case (0, $30d9113c3699bf07$export$a3fb1069ae3b8bb4).BIGINT:
                        return argType == "bigint";
                    case (0, $30d9113c3699bf07$export$a3fb1069ae3b8bb4).NUMBER:
                        return argType == "number" && !isNaN(arg);
                    default:
                        return argType == "string";
                }
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).BOOL:
                return argType == 'boolean';
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).STRING:
                return argType == 'string';
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).BYTES:
                return arg instanceof Uint8Array;
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).DOUBLE:
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).FLOAT:
                return argType == 'number' && !isNaN(arg);
            default:
                // case ScalarType.UINT32:
                // case ScalarType.FIXED32:
                // case ScalarType.INT32:
                // case ScalarType.SINT32:
                // case ScalarType.SFIXED32:
                return argType == 'number' && Number.isInteger(arg);
        }
    }
    scalars(arg, type, depth, longType) {
        if (!Array.isArray(arg)) return false;
        if (depth < 2) return true;
        if (Array.isArray(arg)) {
            for(let i = 0; i < arg.length && i < depth; i++)if (!this.scalar(arg[i], type, longType)) return false;
        }
        return true;
    }
    mapKeys(map, type, depth) {
        let keys = Object.keys(map);
        switch(type){
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).INT32:
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).FIXED32:
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).SFIXED32:
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).SINT32:
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).UINT32:
                return this.scalars(keys.slice(0, depth).map((k)=>parseInt(k)), type, depth);
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).BOOL:
                return this.scalars(keys.slice(0, depth).map((k)=>k == 'true' ? true : k == 'false' ? false : k), type, depth);
            default:
                return this.scalars(keys, type, depth, (0, $30d9113c3699bf07$export$a3fb1069ae3b8bb4).STRING);
        }
    }
}



// lookup table from base64 character to byte
let $14342a4c763bf8a3$var$encTable = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');
// lookup table from base64 character *code* to byte because lookup by number is fast
let $14342a4c763bf8a3$var$decTable = [];
for(let i = 0; i < $14342a4c763bf8a3$var$encTable.length; i++)$14342a4c763bf8a3$var$decTable[$14342a4c763bf8a3$var$encTable[i].charCodeAt(0)] = i;
// support base64url variants
$14342a4c763bf8a3$var$decTable["-".charCodeAt(0)] = $14342a4c763bf8a3$var$encTable.indexOf("+");
$14342a4c763bf8a3$var$decTable["_".charCodeAt(0)] = $14342a4c763bf8a3$var$encTable.indexOf("/");
function $14342a4c763bf8a3$export$afb15ede80c42aab(base64Str) {
    // estimate byte size, not accounting for inner padding and whitespace
    let es = base64Str.length * 3 / 4;
    // if (es % 3 !== 0)
    // throw new Error('invalid base64 string');
    if (base64Str[base64Str.length - 2] == '=') es -= 2;
    else if (base64Str[base64Str.length - 1] == '=') es -= 1;
    let bytes = new Uint8Array(es), bytePos = 0, groupPos = 0, b, p = 0 // previous byte
    ;
    for(let i = 0; i < base64Str.length; i++){
        b = $14342a4c763bf8a3$var$decTable[base64Str.charCodeAt(i)];
        if (b === undefined) // noinspection FallThroughInSwitchStatementJS
        switch(base64Str[i]){
            case '=':
                groupPos = 0; // reset state when padding found
            case '\n':
            case '\r':
            case '\t':
            case ' ':
                continue; // skip white-space, and padding
            default:
                throw Error(`invalid base64 string.`);
        }
        switch(groupPos){
            case 0:
                p = b;
                groupPos = 1;
                break;
            case 1:
                bytes[bytePos++] = p << 2 | (b & 48) >> 4;
                p = b;
                groupPos = 2;
                break;
            case 2:
                bytes[bytePos++] = (p & 15) << 4 | (b & 60) >> 2;
                p = b;
                groupPos = 3;
                break;
            case 3:
                bytes[bytePos++] = (p & 3) << 6 | b;
                groupPos = 0;
                break;
        }
    }
    if (groupPos == 1) throw Error(`invalid base64 string.`);
    return bytes.subarray(0, bytePos);
}
function $14342a4c763bf8a3$export$4e633de97d65d1c8(bytes) {
    let base64 = '', groupPos = 0, b, p = 0; // carry over from previous byte
    for(let i = 0; i < bytes.length; i++){
        b = bytes[i];
        switch(groupPos){
            case 0:
                base64 += $14342a4c763bf8a3$var$encTable[b >> 2];
                p = (b & 3) << 4;
                groupPos = 1;
                break;
            case 1:
                base64 += $14342a4c763bf8a3$var$encTable[p | b >> 4];
                p = (b & 15) << 2;
                groupPos = 2;
                break;
            case 2:
                base64 += $14342a4c763bf8a3$var$encTable[p | b >> 6];
                base64 += $14342a4c763bf8a3$var$encTable[b & 63];
                groupPos = 0;
                break;
        }
    }
    // padding required?
    if (groupPos) {
        base64 += $14342a4c763bf8a3$var$encTable[p];
        base64 += '=';
        if (groupPos == 1) base64 += '=';
    }
    return base64;
}



// Copyright 2008 Google Inc.  All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are
// met:
//
// * Redistributions of source code must retain the above copyright
// notice, this list of conditions and the following disclaimer.
// * Redistributions in binary form must reproduce the above
// copyright notice, this list of conditions and the following disclaimer
// in the documentation and/or other materials provided with the
// distribution.
// * Neither the name of Google Inc. nor the names of its
// contributors may be used to endorse or promote products derived from
// this software without specific prior written permission.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
// "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
// LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
// A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
// OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
// SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
// LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
// DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
// THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
//
// Code generated by the Protocol Buffer compiler is owned by the owner
// of the input file used when generating it.  This code is not
// standalone and requires a support library to be linked with it.  This
// support library is itself covered by the above license.
/**
 * Read a 64 bit varint as two JS numbers.
 *
 * Returns tuple:
 * [0]: low bits
 * [0]: high bits
 *
 * Copyright 2008 Google Inc.  All rights reserved.
 *
 * See https://github.com/protocolbuffers/protobuf/blob/8a71927d74a4ce34efe2d8769fda198f52d20d12/js/experimental/runtime/kernel/buffer_decoder.js#L175
 */ function $56fe0cf59e73311c$export$e5171d1968013adb() {
    let lowBits = 0;
    let highBits = 0;
    for(let shift = 0; shift < 28; shift += 7){
        let b = this.buf[this.pos++];
        lowBits |= (b & 0x7F) << shift;
        if ((b & 0x80) == 0) {
            this.assertBounds();
            return [
                lowBits,
                highBits
            ];
        }
    }
    let middleByte = this.buf[this.pos++];
    // last four bits of the first 32 bit number
    lowBits |= (middleByte & 0x0F) << 28;
    // 3 upper bits are part of the next 32 bit number
    highBits = (middleByte & 0x70) >> 4;
    if ((middleByte & 0x80) == 0) {
        this.assertBounds();
        return [
            lowBits,
            highBits
        ];
    }
    for(let shift = 3; shift <= 31; shift += 7){
        let b = this.buf[this.pos++];
        highBits |= (b & 0x7F) << shift;
        if ((b & 0x80) == 0) {
            this.assertBounds();
            return [
                lowBits,
                highBits
            ];
        }
    }
    throw new Error('invalid varint');
}
function $56fe0cf59e73311c$export$ff01ce396ff3d61f(lo, hi, bytes) {
    for(let i = 0; i < 28; i = i + 7){
        const shift = lo >>> i;
        const hasNext = !(shift >>> 7 == 0 && hi == 0);
        const byte = (hasNext ? shift | 0x80 : shift) & 0xFF;
        bytes.push(byte);
        if (!hasNext) return;
    }
    const splitBits = lo >>> 28 & 0x0F | (hi & 0x07) << 4;
    const hasMoreBits = !(hi >> 3 == 0);
    bytes.push((hasMoreBits ? splitBits | 0x80 : splitBits) & 0xFF);
    if (!hasMoreBits) return;
    for(let i = 3; i < 31; i = i + 7){
        const shift = hi >>> i;
        const hasNext = !(shift >>> 7 == 0);
        const byte = (hasNext ? shift | 0x80 : shift) & 0xFF;
        bytes.push(byte);
        if (!hasNext) return;
    }
    bytes.push(hi >>> 31 & 0x01);
}
// constants for binary math
const $56fe0cf59e73311c$var$TWO_PWR_32_DBL = 4294967296;
function $56fe0cf59e73311c$export$2696d481002c7488(dec) {
    // Check for minus sign.
    let minus = dec[0] == '-';
    if (minus) dec = dec.slice(1);
    // Work 6 decimal digits at a time, acting like we're converting base 1e6
    // digits to binary. This is safe to do with floating point math because
    // Number.isSafeInteger(ALL_32_BITS * 1e6) == true.
    const base = 1e6;
    let lowBits = 0;
    let highBits = 0;
    function add1e6digit(begin, end) {
        // Note: Number('') is 0.
        const digit1e6 = Number(dec.slice(begin, end));
        highBits *= base;
        lowBits = lowBits * base + digit1e6;
        // Carry bits from lowBits to highBits
        if (lowBits >= $56fe0cf59e73311c$var$TWO_PWR_32_DBL) {
            highBits = highBits + (lowBits / $56fe0cf59e73311c$var$TWO_PWR_32_DBL | 0);
            lowBits = lowBits % $56fe0cf59e73311c$var$TWO_PWR_32_DBL;
        }
    }
    add1e6digit(-24, -18);
    add1e6digit(-18, -12);
    add1e6digit(-12, -6);
    add1e6digit(-6);
    return [
        minus,
        lowBits,
        highBits
    ];
}
function $56fe0cf59e73311c$export$bd6d13315e46b1b7(bitsLow, bitsHigh) {
    // Skip the expensive conversion if the number is small enough to use the
    // built-in conversions.
    if (bitsHigh >>> 0 <= 0x1FFFFF) return '' + ($56fe0cf59e73311c$var$TWO_PWR_32_DBL * bitsHigh + (bitsLow >>> 0));
    // What this code is doing is essentially converting the input number from
    // base-2 to base-1e7, which allows us to represent the 64-bit range with
    // only 3 (very large) digits. Those digits are then trivial to convert to
    // a base-10 string.
    // The magic numbers used here are -
    // 2^24 = 16777216 = (1,6777216) in base-1e7.
    // 2^48 = 281474976710656 = (2,8147497,6710656) in base-1e7.
    // Split 32:32 representation into 16:24:24 representation so our
    // intermediate digits don't overflow.
    let low = bitsLow & 0xFFFFFF;
    let mid = (bitsLow >>> 24 | bitsHigh << 8) >>> 0 & 0xFFFFFF;
    let high = bitsHigh >> 16 & 0xFFFF;
    // Assemble our three base-1e7 digits, ignoring carries. The maximum
    // value in a digit at this step is representable as a 48-bit integer, which
    // can be stored in a 64-bit floating point number.
    let digitA = low + mid * 6777216 + high * 6710656;
    let digitB = mid + high * 8147497;
    let digitC = high * 2;
    // Apply carries from A to B and from B to C.
    let base = 10000000;
    if (digitA >= base) {
        digitB += Math.floor(digitA / base);
        digitA %= base;
    }
    if (digitB >= base) {
        digitC += Math.floor(digitB / base);
        digitB %= base;
    }
    // Convert base-1e7 digits to base-10, with optional leading zeroes.
    function decimalFrom1e7(digit1e7, needLeadingZeros) {
        let partial = digit1e7 ? String(digit1e7) : '';
        if (needLeadingZeros) return '0000000'.slice(partial.length) + partial;
        return partial;
    }
    return decimalFrom1e7(digitC, /*needLeadingZeros=*/ 0) + decimalFrom1e7(digitB, /*needLeadingZeros=*/ digitC) + // If the final 1e7 digit didn't need leading zeros, we would have
    // returned via the trivial code path at the top.
    decimalFrom1e7(digitA, /*needLeadingZeros=*/ 1);
}
function $56fe0cf59e73311c$export$77a3057e70db7f11(value, bytes) {
    if (value >= 0) {
        // write value as varint 32
        while(value > 0x7f){
            bytes.push(value & 0x7f | 0x80);
            value = value >>> 7;
        }
        bytes.push(value);
    } else {
        for(let i = 0; i < 9; i++){
            bytes.push(value & 127 | 128);
            value = value >> 7;
        }
        bytes.push(1);
    }
}
function $56fe0cf59e73311c$export$7138ea6223338e60() {
    let b = this.buf[this.pos++];
    let result = b & 0x7F;
    if ((b & 0x80) == 0) {
        this.assertBounds();
        return result;
    }
    b = this.buf[this.pos++];
    result |= (b & 0x7F) << 7;
    if ((b & 0x80) == 0) {
        this.assertBounds();
        return result;
    }
    b = this.buf[this.pos++];
    result |= (b & 0x7F) << 14;
    if ((b & 0x80) == 0) {
        this.assertBounds();
        return result;
    }
    b = this.buf[this.pos++];
    result |= (b & 0x7F) << 21;
    if ((b & 0x80) == 0) {
        this.assertBounds();
        return result;
    }
    // Extract only last 4 bits
    b = this.buf[this.pos++];
    result |= (b & 0x0F) << 28;
    for(let readBytes = 5; (b & 0x80) !== 0 && readBytes < 10; readBytes++)b = this.buf[this.pos++];
    if ((b & 0x80) != 0) throw new Error('invalid varint');
    this.assertBounds();
    // Result can have 32 bits, convert it to unsigned
    return result >>> 0;
}


let $675e5c20166be613$var$BI;
function $675e5c20166be613$export$e21a0a1962dae197() {
    const dv = new DataView(new ArrayBuffer(8));
    const ok = globalThis.BigInt !== undefined && typeof dv.getBigInt64 === "function" && typeof dv.getBigUint64 === "function" && typeof dv.setBigInt64 === "function" && typeof dv.setBigUint64 === "function";
    $675e5c20166be613$var$BI = ok ? {
        MIN: BigInt("-9223372036854775808"),
        MAX: BigInt("9223372036854775807"),
        UMIN: BigInt("0"),
        UMAX: BigInt("18446744073709551615"),
        C: BigInt,
        V: dv
    } : undefined;
}
$675e5c20166be613$export$e21a0a1962dae197();
function $675e5c20166be613$var$assertBi(bi) {
    if (!bi) throw new Error("BigInt unavailable, see https://github.com/timostamm/protobuf-ts/blob/v1.0.8/MANUAL.md#bigint-support");
}
// used to validate from(string) input (when bigint is unavailable)
const $675e5c20166be613$var$RE_DECIMAL_STR = /^-?[0-9]+$/;
// constants for binary math
const $675e5c20166be613$var$TWO_PWR_32_DBL = 0x100000000;
const $675e5c20166be613$var$HALF_2_PWR_32 = 0x080000000;
// base class for PbLong and PbULong provides shared code
class $675e5c20166be613$var$SharedPbLong {
    /**
     * Create a new instance with the given bits.
     */ constructor(lo, hi){
        this.lo = lo | 0;
        this.hi = hi | 0;
    }
    /**
     * Is this instance equal to 0?
     */ isZero() {
        return this.lo == 0 && this.hi == 0;
    }
    /**
     * Convert to a native number.
     */ toNumber() {
        let result = this.hi * $675e5c20166be613$var$TWO_PWR_32_DBL + (this.lo >>> 0);
        if (!Number.isSafeInteger(result)) throw new Error("cannot convert to safe number");
        return result;
    }
}
class $675e5c20166be613$export$2d16819998fb891c extends $675e5c20166be613$var$SharedPbLong {
    /**
     * Create instance from a `string`, `number` or `bigint`.
     */ static from(value) {
        if ($675e5c20166be613$var$BI) // noinspection FallThroughInSwitchStatementJS
        switch(typeof value){
            case "string":
                if (value == "0") return this.ZERO;
                if (value == "") throw new Error('string is no integer');
                value = $675e5c20166be613$var$BI.C(value);
            case "number":
                if (value === 0) return this.ZERO;
                value = $675e5c20166be613$var$BI.C(value);
            case "bigint":
                if (!value) return this.ZERO;
                if (value < $675e5c20166be613$var$BI.UMIN) throw new Error('signed value for ulong');
                if (value > $675e5c20166be613$var$BI.UMAX) throw new Error('ulong too large');
                $675e5c20166be613$var$BI.V.setBigUint64(0, value, true);
                return new $675e5c20166be613$export$2d16819998fb891c($675e5c20166be613$var$BI.V.getInt32(0, true), $675e5c20166be613$var$BI.V.getInt32(4, true));
        }
        else switch(typeof value){
            case "string":
                if (value == "0") return this.ZERO;
                value = value.trim();
                if (!$675e5c20166be613$var$RE_DECIMAL_STR.test(value)) throw new Error('string is no integer');
                let [minus, lo, hi] = (0, $56fe0cf59e73311c$export$2696d481002c7488)(value);
                if (minus) throw new Error('signed value for ulong');
                return new $675e5c20166be613$export$2d16819998fb891c(lo, hi);
            case "number":
                if (value == 0) return this.ZERO;
                if (!Number.isSafeInteger(value)) throw new Error('number is no integer');
                if (value < 0) throw new Error('signed value for ulong');
                return new $675e5c20166be613$export$2d16819998fb891c(value, value / $675e5c20166be613$var$TWO_PWR_32_DBL);
        }
        throw new Error('unknown value ' + typeof value);
    }
    /**
     * Convert to decimal string.
     */ toString() {
        return $675e5c20166be613$var$BI ? this.toBigInt().toString() : (0, $56fe0cf59e73311c$export$bd6d13315e46b1b7)(this.lo, this.hi);
    }
    /**
     * Convert to native bigint.
     */ toBigInt() {
        $675e5c20166be613$var$assertBi($675e5c20166be613$var$BI);
        $675e5c20166be613$var$BI.V.setInt32(0, this.lo, true);
        $675e5c20166be613$var$BI.V.setInt32(4, this.hi, true);
        return $675e5c20166be613$var$BI.V.getBigUint64(0, true);
    }
}
/**
 * ulong 0 singleton.
 */ $675e5c20166be613$export$2d16819998fb891c.ZERO = new $675e5c20166be613$export$2d16819998fb891c(0, 0);
class $675e5c20166be613$export$458c11e435f8bbac extends $675e5c20166be613$var$SharedPbLong {
    /**
     * Create instance from a `string`, `number` or `bigint`.
     */ static from(value) {
        if ($675e5c20166be613$var$BI) // noinspection FallThroughInSwitchStatementJS
        switch(typeof value){
            case "string":
                if (value == "0") return this.ZERO;
                if (value == "") throw new Error('string is no integer');
                value = $675e5c20166be613$var$BI.C(value);
            case "number":
                if (value === 0) return this.ZERO;
                value = $675e5c20166be613$var$BI.C(value);
            case "bigint":
                if (!value) return this.ZERO;
                if (value < $675e5c20166be613$var$BI.MIN) throw new Error('signed long too small');
                if (value > $675e5c20166be613$var$BI.MAX) throw new Error('signed long too large');
                $675e5c20166be613$var$BI.V.setBigInt64(0, value, true);
                return new $675e5c20166be613$export$458c11e435f8bbac($675e5c20166be613$var$BI.V.getInt32(0, true), $675e5c20166be613$var$BI.V.getInt32(4, true));
        }
        else switch(typeof value){
            case "string":
                if (value == "0") return this.ZERO;
                value = value.trim();
                if (!$675e5c20166be613$var$RE_DECIMAL_STR.test(value)) throw new Error('string is no integer');
                let [minus, lo, hi] = (0, $56fe0cf59e73311c$export$2696d481002c7488)(value);
                if (minus) {
                    if (hi > $675e5c20166be613$var$HALF_2_PWR_32 || hi == $675e5c20166be613$var$HALF_2_PWR_32 && lo != 0) throw new Error('signed long too small');
                } else if (hi >= $675e5c20166be613$var$HALF_2_PWR_32) throw new Error('signed long too large');
                let pbl = new $675e5c20166be613$export$458c11e435f8bbac(lo, hi);
                return minus ? pbl.negate() : pbl;
            case "number":
                if (value == 0) return this.ZERO;
                if (!Number.isSafeInteger(value)) throw new Error('number is no integer');
                return value > 0 ? new $675e5c20166be613$export$458c11e435f8bbac(value, value / $675e5c20166be613$var$TWO_PWR_32_DBL) : new $675e5c20166be613$export$458c11e435f8bbac(-value, -value / $675e5c20166be613$var$TWO_PWR_32_DBL).negate();
        }
        throw new Error('unknown value ' + typeof value);
    }
    /**
     * Do we have a minus sign?
     */ isNegative() {
        return (this.hi & $675e5c20166be613$var$HALF_2_PWR_32) !== 0;
    }
    /**
     * Negate two's complement.
     * Invert all the bits and add one to the result.
     */ negate() {
        let hi = ~this.hi, lo = this.lo;
        if (lo) lo = ~lo + 1;
        else hi += 1;
        return new $675e5c20166be613$export$458c11e435f8bbac(lo, hi);
    }
    /**
     * Convert to decimal string.
     */ toString() {
        if ($675e5c20166be613$var$BI) return this.toBigInt().toString();
        if (this.isNegative()) {
            let n = this.negate();
            return '-' + (0, $56fe0cf59e73311c$export$bd6d13315e46b1b7)(n.lo, n.hi);
        }
        return (0, $56fe0cf59e73311c$export$bd6d13315e46b1b7)(this.lo, this.hi);
    }
    /**
     * Convert to native bigint.
     */ toBigInt() {
        $675e5c20166be613$var$assertBi($675e5c20166be613$var$BI);
        $675e5c20166be613$var$BI.V.setInt32(0, this.lo, true);
        $675e5c20166be613$var$BI.V.setInt32(4, this.hi, true);
        return $675e5c20166be613$var$BI.V.getBigInt64(0, true);
    }
}
/**
 * long 0 singleton.
 */ $675e5c20166be613$export$458c11e435f8bbac.ZERO = new $675e5c20166be613$export$458c11e435f8bbac(0, 0);


/**
 * assert that condition is true or throw error (with message)
 */ function $4f68f1b9a9c8c878$export$a7a9523472993e97(condition, msg) {
    if (!condition) throw new Error(msg);
}
function $4f68f1b9a9c8c878$export$cbadc5a7223772a8(value, msg) {
    throw new Error(msg !== null && msg !== void 0 ? msg : 'Unexpected object: ' + value);
}
const $4f68f1b9a9c8c878$var$FLOAT32_MAX = 3.4028234663852886e+38, $4f68f1b9a9c8c878$var$FLOAT32_MIN = -340282346638528860000000000000000000000, $4f68f1b9a9c8c878$var$UINT32_MAX = 0xFFFFFFFF, $4f68f1b9a9c8c878$var$INT32_MAX = 0X7FFFFFFF, $4f68f1b9a9c8c878$var$INT32_MIN = -2147483648;
function $4f68f1b9a9c8c878$export$6ef88129b876fe31(arg) {
    if (typeof arg !== "number") throw new Error('invalid int 32: ' + typeof arg);
    if (!Number.isInteger(arg) || arg > $4f68f1b9a9c8c878$var$INT32_MAX || arg < $4f68f1b9a9c8c878$var$INT32_MIN) throw new Error('invalid int 32: ' + arg);
}
function $4f68f1b9a9c8c878$export$2e87d29058d6f62e(arg) {
    if (typeof arg !== "number") throw new Error('invalid uint 32: ' + typeof arg);
    if (!Number.isInteger(arg) || arg > $4f68f1b9a9c8c878$var$UINT32_MAX || arg < 0) throw new Error('invalid uint 32: ' + arg);
}
function $4f68f1b9a9c8c878$export$bc199b1875ae7ece(arg) {
    if (typeof arg !== "number") throw new Error('invalid float 32: ' + typeof arg);
    if (!Number.isFinite(arg)) return;
    if (arg > $4f68f1b9a9c8c878$var$FLOAT32_MAX || arg < $4f68f1b9a9c8c878$var$FLOAT32_MIN) throw new Error('invalid float 32: ' + arg);
}



function $81e6f6f0a094add0$export$dad3e19c395b0f8a(long, type) {
    switch(type){
        case (0, $30d9113c3699bf07$export$a3fb1069ae3b8bb4).BIGINT:
            return long.toBigInt();
        case (0, $30d9113c3699bf07$export$a3fb1069ae3b8bb4).NUMBER:
            return long.toNumber();
        default:
            // case undefined:
            // case LongType.STRING:
            return long.toString();
    }
}


class $542b30356d238d37$export$673b047513356c73 {
    constructor(info){
        this.info = info;
    }
    prepare() {
        var _a;
        if (this.fMap === undefined) {
            this.fMap = {};
            const fieldsInput = (_a = this.info.fields) !== null && _a !== void 0 ? _a : [];
            for (const field of fieldsInput){
                this.fMap[field.name] = field;
                this.fMap[field.jsonName] = field;
                this.fMap[field.localName] = field;
            }
        }
    }
    // Cannot parse JSON <type of jsonValue> for <type name>#<fieldName>.
    assert(condition, fieldName, jsonValue) {
        if (!condition) {
            let what = (0, $9b0297e2871b9bc0$export$664ede5272d59144)(jsonValue);
            if (what == "number" || what == "boolean") what = jsonValue.toString();
            throw new Error(`Cannot parse JSON ${what} for ${this.info.typeName}#${fieldName}`);
        }
    }
    /**
     * Reads a message from canonical JSON format into the target message.
     *
     * Repeated fields are appended. Map entries are added, overwriting
     * existing keys.
     *
     * If a message field is already present, it will be merged with the
     * new data.
     */ read(input, message, options) {
        this.prepare();
        const oneofsHandled = [];
        for (const [jsonKey, jsonValue] of Object.entries(input)){
            const field = this.fMap[jsonKey];
            if (!field) {
                if (!options.ignoreUnknownFields) throw new Error(`Found unknown field while reading ${this.info.typeName} from JSON format. JSON key: ${jsonKey}`);
                continue;
            }
            const localName = field.localName;
            // handle oneof ADT
            let target; // this will be the target for the field value, whether it is member of a oneof or not
            if (field.oneof) {
                if (jsonValue === null && (field.kind !== 'enum' || field.T()[0] !== 'google.protobuf.NullValue')) continue;
                // since json objects are unordered by specification, it is not possible to take the last of multiple oneofs
                if (oneofsHandled.includes(field.oneof)) throw new Error(`Multiple members of the oneof group "${field.oneof}" of ${this.info.typeName} are present in JSON.`);
                oneofsHandled.push(field.oneof);
                target = message[field.oneof] = {
                    oneofKind: localName
                };
            } else target = message;
            // we have handled oneof above. we just have read the value into `target`.
            if (field.kind == 'map') {
                if (jsonValue === null) continue;
                // check input
                this.assert((0, $9b0297e2871b9bc0$export$98727920b98c3cdb)(jsonValue), field.name, jsonValue);
                // our target to put map entries into
                const fieldObj = target[localName];
                // read entries
                for (const [jsonObjKey, jsonObjValue] of Object.entries(jsonValue)){
                    this.assert(jsonObjValue !== null, field.name + " map value", null);
                    // read value
                    let val;
                    switch(field.V.kind){
                        case "message":
                            val = field.V.T().internalJsonRead(jsonObjValue, options);
                            break;
                        case "enum":
                            val = this.enum(field.V.T(), jsonObjValue, field.name, options.ignoreUnknownFields);
                            if (val === false) continue;
                            break;
                        case "scalar":
                            val = this.scalar(jsonObjValue, field.V.T, field.V.L, field.name);
                            break;
                    }
                    this.assert(val !== undefined, field.name + " map value", jsonObjValue);
                    // read key
                    let key = jsonObjKey;
                    if (field.K == (0, $30d9113c3699bf07$export$d40a369a25702af0).BOOL) key = key == "true" ? true : key == "false" ? false : key;
                    key = this.scalar(key, field.K, (0, $30d9113c3699bf07$export$a3fb1069ae3b8bb4).STRING, field.name).toString();
                    fieldObj[key] = val;
                }
            } else if (field.repeat) {
                if (jsonValue === null) continue;
                // check input
                this.assert(Array.isArray(jsonValue), field.name, jsonValue);
                // our target to put array entries into
                const fieldArr = target[localName];
                // read array entries
                for (const jsonItem of jsonValue){
                    this.assert(jsonItem !== null, field.name, null);
                    let val;
                    switch(field.kind){
                        case "message":
                            val = field.T().internalJsonRead(jsonItem, options);
                            break;
                        case "enum":
                            val = this.enum(field.T(), jsonItem, field.name, options.ignoreUnknownFields);
                            if (val === false) continue;
                            break;
                        case "scalar":
                            val = this.scalar(jsonItem, field.T, field.L, field.name);
                            break;
                    }
                    this.assert(val !== undefined, field.name, jsonValue);
                    fieldArr.push(val);
                }
            } else switch(field.kind){
                case "message":
                    if (jsonValue === null && field.T().typeName != 'google.protobuf.Value') {
                        this.assert(field.oneof === undefined, field.name + " (oneof member)", null);
                        continue;
                    }
                    target[localName] = field.T().internalJsonRead(jsonValue, options, target[localName]);
                    break;
                case "enum":
                    if (jsonValue === null) continue;
                    let val = this.enum(field.T(), jsonValue, field.name, options.ignoreUnknownFields);
                    if (val === false) continue;
                    target[localName] = val;
                    break;
                case "scalar":
                    if (jsonValue === null) continue;
                    target[localName] = this.scalar(jsonValue, field.T, field.L, field.name);
                    break;
            }
        }
    }
    /**
     * Returns `false` for unrecognized string representations.
     *
     * google.protobuf.NullValue accepts only JSON `null` (or the old `"NULL_VALUE"`).
     */ enum(type, json, fieldName, ignoreUnknownFields) {
        if (type[0] == 'google.protobuf.NullValue') (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(json === null || json === "NULL_VALUE", `Unable to parse field ${this.info.typeName}#${fieldName}, enum ${type[0]} only accepts null.`);
        if (json === null) // we require 0 to be default value for all enums
        return 0;
        switch(typeof json){
            case "number":
                (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(Number.isInteger(json), `Unable to parse field ${this.info.typeName}#${fieldName}, enum can only be integral number, got ${json}.`);
                return json;
            case "string":
                let localEnumName = json;
                if (type[2] && json.substring(0, type[2].length) === type[2]) // lookup without the shared prefix
                localEnumName = json.substring(type[2].length);
                let enumNumber = type[1][localEnumName];
                if (typeof enumNumber === 'undefined' && ignoreUnknownFields) return false;
                (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(typeof enumNumber == "number", `Unable to parse field ${this.info.typeName}#${fieldName}, enum ${type[0]} has no value for "${json}".`);
                return enumNumber;
        }
        (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(false, `Unable to parse field ${this.info.typeName}#${fieldName}, cannot parse enum value from ${typeof json}".`);
    }
    scalar(json, type, longType, fieldName) {
        let e;
        try {
            switch(type){
                // float, double: JSON value will be a number or one of the special string values "NaN", "Infinity", and "-Infinity".
                // Either numbers or strings are accepted. Exponent notation is also accepted.
                case (0, $30d9113c3699bf07$export$d40a369a25702af0).DOUBLE:
                case (0, $30d9113c3699bf07$export$d40a369a25702af0).FLOAT:
                    if (json === null) return .0;
                    if (json === "NaN") return Number.NaN;
                    if (json === "Infinity") return Number.POSITIVE_INFINITY;
                    if (json === "-Infinity") return Number.NEGATIVE_INFINITY;
                    if (json === "") {
                        e = "empty string";
                        break;
                    }
                    if (typeof json == "string" && json.trim().length !== json.length) {
                        e = "extra whitespace";
                        break;
                    }
                    if (typeof json != "string" && typeof json != "number") break;
                    let float = Number(json);
                    if (Number.isNaN(float)) {
                        e = "not a number";
                        break;
                    }
                    if (!Number.isFinite(float)) {
                        // infinity and -infinity are handled by string representation above, so this is an error
                        e = "too large or small";
                        break;
                    }
                    if (type == (0, $30d9113c3699bf07$export$d40a369a25702af0).FLOAT) (0, $4f68f1b9a9c8c878$export$bc199b1875ae7ece)(float);
                    return float;
                // int32, fixed32, uint32: JSON value will be a decimal number. Either numbers or strings are accepted.
                case (0, $30d9113c3699bf07$export$d40a369a25702af0).INT32:
                case (0, $30d9113c3699bf07$export$d40a369a25702af0).FIXED32:
                case (0, $30d9113c3699bf07$export$d40a369a25702af0).SFIXED32:
                case (0, $30d9113c3699bf07$export$d40a369a25702af0).SINT32:
                case (0, $30d9113c3699bf07$export$d40a369a25702af0).UINT32:
                    if (json === null) return 0;
                    let int32;
                    if (typeof json == "number") int32 = json;
                    else if (json === "") e = "empty string";
                    else if (typeof json == "string") {
                        if (json.trim().length !== json.length) e = "extra whitespace";
                        else int32 = Number(json);
                    }
                    if (int32 === undefined) break;
                    if (type == (0, $30d9113c3699bf07$export$d40a369a25702af0).UINT32) (0, $4f68f1b9a9c8c878$export$2e87d29058d6f62e)(int32);
                    else (0, $4f68f1b9a9c8c878$export$6ef88129b876fe31)(int32);
                    return int32;
                // int64, fixed64, uint64: JSON value will be a decimal string. Either numbers or strings are accepted.
                case (0, $30d9113c3699bf07$export$d40a369a25702af0).INT64:
                case (0, $30d9113c3699bf07$export$d40a369a25702af0).SFIXED64:
                case (0, $30d9113c3699bf07$export$d40a369a25702af0).SINT64:
                    if (json === null) return (0, $81e6f6f0a094add0$export$dad3e19c395b0f8a)((0, $675e5c20166be613$export$458c11e435f8bbac).ZERO, longType);
                    if (typeof json != "number" && typeof json != "string") break;
                    return (0, $81e6f6f0a094add0$export$dad3e19c395b0f8a)((0, $675e5c20166be613$export$458c11e435f8bbac).from(json), longType);
                case (0, $30d9113c3699bf07$export$d40a369a25702af0).FIXED64:
                case (0, $30d9113c3699bf07$export$d40a369a25702af0).UINT64:
                    if (json === null) return (0, $81e6f6f0a094add0$export$dad3e19c395b0f8a)((0, $675e5c20166be613$export$2d16819998fb891c).ZERO, longType);
                    if (typeof json != "number" && typeof json != "string") break;
                    return (0, $81e6f6f0a094add0$export$dad3e19c395b0f8a)((0, $675e5c20166be613$export$2d16819998fb891c).from(json), longType);
                // bool:
                case (0, $30d9113c3699bf07$export$d40a369a25702af0).BOOL:
                    if (json === null) return false;
                    if (typeof json !== "boolean") break;
                    return json;
                // string:
                case (0, $30d9113c3699bf07$export$d40a369a25702af0).STRING:
                    if (json === null) return "";
                    if (typeof json !== "string") {
                        e = "extra whitespace";
                        break;
                    }
                    try {
                        encodeURIComponent(json);
                    } catch (e) {
                        e = "invalid UTF8";
                        break;
                    }
                    return json;
                // bytes: JSON value will be the data encoded as a string using standard base64 encoding with paddings.
                // Either standard or URL-safe base64 encoding with/without paddings are accepted.
                case (0, $30d9113c3699bf07$export$d40a369a25702af0).BYTES:
                    if (json === null || json === "") return new Uint8Array(0);
                    if (typeof json !== 'string') break;
                    return (0, $14342a4c763bf8a3$export$afb15ede80c42aab)(json);
            }
        } catch (error) {
            e = error.message;
        }
        this.assert(false, fieldName + (e ? " - " + e : ""), json);
    }
}






class $e291ba296f85b206$export$b2626b487dec7942 {
    constructor(info){
        var _a;
        this.fields = (_a = info.fields) !== null && _a !== void 0 ? _a : [];
    }
    /**
     * Converts the message to a JSON object, based on the field descriptors.
     */ write(message, options) {
        const json = {}, source = message;
        for (const field of this.fields){
            // field is not part of a oneof, simply write as is
            if (!field.oneof) {
                let jsonValue = this.field(field, source[field.localName], options);
                if (jsonValue !== undefined) json[options.useProtoFieldName ? field.name : field.jsonName] = jsonValue;
                continue;
            }
            // field is part of a oneof
            const group = source[field.oneof];
            if (group.oneofKind !== field.localName) continue; // not selected, skip
            const opt = field.kind == 'scalar' || field.kind == 'enum' ? Object.assign(Object.assign({}, options), {
                emitDefaultValues: true
            }) : options;
            let jsonValue = this.field(field, group[field.localName], opt);
            (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(jsonValue !== undefined);
            json[options.useProtoFieldName ? field.name : field.jsonName] = jsonValue;
        }
        return json;
    }
    field(field, value, options) {
        let jsonValue = undefined;
        if (field.kind == 'map') {
            (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(typeof value == "object" && value !== null);
            const jsonObj = {};
            switch(field.V.kind){
                case "scalar":
                    for (const [entryKey, entryValue] of Object.entries(value)){
                        const val = this.scalar(field.V.T, entryValue, field.name, false, true);
                        (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(val !== undefined);
                        jsonObj[entryKey.toString()] = val; // JSON standard allows only (double quoted) string as property key
                    }
                    break;
                case "message":
                    const messageType = field.V.T();
                    for (const [entryKey, entryValue] of Object.entries(value)){
                        const val = this.message(messageType, entryValue, field.name, options);
                        (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(val !== undefined);
                        jsonObj[entryKey.toString()] = val; // JSON standard allows only (double quoted) string as property key
                    }
                    break;
                case "enum":
                    const enumInfo = field.V.T();
                    for (const [entryKey, entryValue] of Object.entries(value)){
                        (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(entryValue === undefined || typeof entryValue == 'number');
                        const val = this.enum(enumInfo, entryValue, field.name, false, true, options.enumAsInteger);
                        (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(val !== undefined);
                        jsonObj[entryKey.toString()] = val; // JSON standard allows only (double quoted) string as property key
                    }
                    break;
            }
            if (options.emitDefaultValues || Object.keys(jsonObj).length > 0) jsonValue = jsonObj;
        } else if (field.repeat) {
            (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(Array.isArray(value));
            const jsonArr = [];
            switch(field.kind){
                case "scalar":
                    for(let i = 0; i < value.length; i++){
                        const val = this.scalar(field.T, value[i], field.name, field.opt, true);
                        (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(val !== undefined);
                        jsonArr.push(val);
                    }
                    break;
                case "enum":
                    const enumInfo = field.T();
                    for(let i = 0; i < value.length; i++){
                        (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(value[i] === undefined || typeof value[i] == 'number');
                        const val = this.enum(enumInfo, value[i], field.name, field.opt, true, options.enumAsInteger);
                        (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(val !== undefined);
                        jsonArr.push(val);
                    }
                    break;
                case "message":
                    const messageType = field.T();
                    for(let i = 0; i < value.length; i++){
                        const val = this.message(messageType, value[i], field.name, options);
                        (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(val !== undefined);
                        jsonArr.push(val);
                    }
                    break;
            }
            // add converted array to json output
            if (options.emitDefaultValues || jsonArr.length > 0 || options.emitDefaultValues) jsonValue = jsonArr;
        } else switch(field.kind){
            case "scalar":
                jsonValue = this.scalar(field.T, value, field.name, field.opt, options.emitDefaultValues);
                break;
            case "enum":
                jsonValue = this.enum(field.T(), value, field.name, field.opt, options.emitDefaultValues, options.enumAsInteger);
                break;
            case "message":
                jsonValue = this.message(field.T(), value, field.name, options);
                break;
        }
        return jsonValue;
    }
    /**
     * Returns `null` as the default for google.protobuf.NullValue.
     */ enum(type, value, fieldName, optional, emitDefaultValues, enumAsInteger) {
        if (type[0] == 'google.protobuf.NullValue') return !emitDefaultValues && !optional ? undefined : null;
        if (value === undefined) {
            (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(optional);
            return undefined;
        }
        if (value === 0 && !emitDefaultValues && !optional) // we require 0 to be default value for all enums
        return undefined;
        (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(typeof value == 'number');
        (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(Number.isInteger(value));
        if (enumAsInteger || !type[1].hasOwnProperty(value)) // if we don't now the enum value, just return the number
        return value;
        if (type[2]) // restore the dropped prefix
        return type[2] + type[1][value];
        return type[1][value];
    }
    message(type, value, fieldName, options) {
        if (value === undefined) return options.emitDefaultValues ? null : undefined;
        return type.internalJsonWrite(value, options);
    }
    scalar(type, value, fieldName, optional, emitDefaultValues) {
        if (value === undefined) {
            (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(optional);
            return undefined;
        }
        const ed = emitDefaultValues || optional;
        // noinspection FallThroughInSwitchStatementJS
        switch(type){
            // int32, fixed32, uint32: JSON value will be a decimal number. Either numbers or strings are accepted.
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).INT32:
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).SFIXED32:
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).SINT32:
                if (value === 0) return ed ? 0 : undefined;
                (0, $4f68f1b9a9c8c878$export$6ef88129b876fe31)(value);
                return value;
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).FIXED32:
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).UINT32:
                if (value === 0) return ed ? 0 : undefined;
                (0, $4f68f1b9a9c8c878$export$2e87d29058d6f62e)(value);
                return value;
            // float, double: JSON value will be a number or one of the special string values "NaN", "Infinity", and "-Infinity".
            // Either numbers or strings are accepted. Exponent notation is also accepted.
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).FLOAT:
                (0, $4f68f1b9a9c8c878$export$bc199b1875ae7ece)(value);
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).DOUBLE:
                if (value === 0) return ed ? 0 : undefined;
                (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(typeof value == 'number');
                if (Number.isNaN(value)) return 'NaN';
                if (value === Number.POSITIVE_INFINITY) return 'Infinity';
                if (value === Number.NEGATIVE_INFINITY) return '-Infinity';
                return value;
            // string:
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).STRING:
                if (value === "") return ed ? '' : undefined;
                (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(typeof value == 'string');
                return value;
            // bool:
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).BOOL:
                if (value === false) return ed ? false : undefined;
                (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(typeof value == 'boolean');
                return value;
            // JSON value will be a decimal string. Either numbers or strings are accepted.
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).UINT64:
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).FIXED64:
                (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(typeof value == 'number' || typeof value == 'string' || typeof value == 'bigint');
                let ulong = (0, $675e5c20166be613$export$2d16819998fb891c).from(value);
                if (ulong.isZero() && !ed) return undefined;
                return ulong.toString();
            // JSON value will be a decimal string. Either numbers or strings are accepted.
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).INT64:
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).SFIXED64:
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).SINT64:
                (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(typeof value == 'number' || typeof value == 'string' || typeof value == 'bigint');
                let long = (0, $675e5c20166be613$export$458c11e435f8bbac).from(value);
                if (long.isZero() && !ed) return undefined;
                return long.toString();
            // bytes: JSON value will be the data encoded as a string using standard base64 encoding with paddings.
            // Either standard or URL-safe base64 encoding with/without paddings are accepted.
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).BYTES:
                (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(value instanceof Uint8Array);
                if (!value.byteLength) return ed ? "" : undefined;
                return (0, $14342a4c763bf8a3$export$4e633de97d65d1c8)(value);
        }
    }
}


/**
 * This handler implements the default behaviour for unknown fields.
 * When reading data, unknown fields are stored on the message, in a
 * symbol property.
 * When writing data, the symbol property is queried and unknown fields
 * are serialized into the output again.
 */ var $f5d43270d4eddc89$export$2ef2fdbd18d3e030;
(function(UnknownFieldHandler) {
    /**
     * The symbol used to store unknown fields for a message.
     * The property must conform to `UnknownFieldContainer`.
     */ UnknownFieldHandler.symbol = Symbol.for("protobuf-ts/unknown");
    /**
     * Store an unknown field during binary read directly on the message.
     * This method is compatible with `BinaryReadOptions.readUnknownField`.
     */ UnknownFieldHandler.onRead = (typeName, message, fieldNo, wireType, data)=>{
        let container = is(message) ? message[UnknownFieldHandler.symbol] : message[UnknownFieldHandler.symbol] = [];
        container.push({
            no: fieldNo,
            wireType: wireType,
            data: data
        });
    };
    /**
     * Write unknown fields stored for the message to the writer.
     * This method is compatible with `BinaryWriteOptions.writeUnknownFields`.
     */ UnknownFieldHandler.onWrite = (typeName, message, writer)=>{
        for (let { no: no, wireType: wireType, data: data } of UnknownFieldHandler.list(message))writer.tag(no, wireType).raw(data);
    };
    /**
     * List unknown fields stored for the message.
     * Note that there may be multiples fields with the same number.
     */ UnknownFieldHandler.list = (message, fieldNo)=>{
        if (is(message)) {
            let all = message[UnknownFieldHandler.symbol];
            return fieldNo ? all.filter((uf)=>uf.no == fieldNo) : all;
        }
        return [];
    };
    /**
     * Returns the last unknown field by field number.
     */ UnknownFieldHandler.last = (message, fieldNo)=>UnknownFieldHandler.list(message, fieldNo).slice(-1)[0];
    const is = (message)=>message && Array.isArray(message[UnknownFieldHandler.symbol]);
})($f5d43270d4eddc89$export$2ef2fdbd18d3e030 || ($f5d43270d4eddc89$export$2ef2fdbd18d3e030 = {}));
function $f5d43270d4eddc89$export$f69cb2aab840e4e1(a, b) {
    return Object.assign(Object.assign({}, a), b);
}
var $f5d43270d4eddc89$export$e5d73eed61ade2af;
(function(WireType) {
    /**
     * Used for int32, int64, uint32, uint64, sint32, sint64, bool, enum
     */ WireType[WireType["Varint"] = 0] = "Varint";
    /**
     * Used for fixed64, sfixed64, double.
     * Always 8 bytes with little-endian byte order.
     */ WireType[WireType["Bit64"] = 1] = "Bit64";
    /**
     * Used for string, bytes, embedded messages, packed repeated fields
     *
     * Only repeated numeric types (types which use the varint, 32-bit,
     * or 64-bit wire types) can be packed. In proto3, such fields are
     * packed by default.
     */ WireType[WireType["LengthDelimited"] = 2] = "LengthDelimited";
    /**
     * Used for groups
     * @deprecated
     */ WireType[WireType["StartGroup"] = 3] = "StartGroup";
    /**
     * Used for groups
     * @deprecated
     */ WireType[WireType["EndGroup"] = 4] = "EndGroup";
    /**
     * Used for fixed32, sfixed32, float.
     * Always 4 bytes with little-endian byte order.
     */ WireType[WireType["Bit32"] = 5] = "Bit32";
})($f5d43270d4eddc89$export$e5d73eed61ade2af || ($f5d43270d4eddc89$export$e5d73eed61ade2af = {}));







function $2fd05501808339ea$export$7e70a6dbbc0779b1(type, longType = (0, $30d9113c3699bf07$export$a3fb1069ae3b8bb4).STRING) {
    switch(type){
        case (0, $30d9113c3699bf07$export$d40a369a25702af0).BOOL:
            return false;
        case (0, $30d9113c3699bf07$export$d40a369a25702af0).UINT64:
        case (0, $30d9113c3699bf07$export$d40a369a25702af0).FIXED64:
            return (0, $81e6f6f0a094add0$export$dad3e19c395b0f8a)((0, $675e5c20166be613$export$2d16819998fb891c).ZERO, longType);
        case (0, $30d9113c3699bf07$export$d40a369a25702af0).INT64:
        case (0, $30d9113c3699bf07$export$d40a369a25702af0).SFIXED64:
        case (0, $30d9113c3699bf07$export$d40a369a25702af0).SINT64:
            return (0, $81e6f6f0a094add0$export$dad3e19c395b0f8a)((0, $675e5c20166be613$export$458c11e435f8bbac).ZERO, longType);
        case (0, $30d9113c3699bf07$export$d40a369a25702af0).DOUBLE:
        case (0, $30d9113c3699bf07$export$d40a369a25702af0).FLOAT:
            return 0.0;
        case (0, $30d9113c3699bf07$export$d40a369a25702af0).BYTES:
            return new Uint8Array(0);
        case (0, $30d9113c3699bf07$export$d40a369a25702af0).STRING:
            return "";
        default:
            // case ScalarType.INT32:
            // case ScalarType.UINT32:
            // case ScalarType.SINT32:
            // case ScalarType.FIXED32:
            // case ScalarType.SFIXED32:
            return 0;
    }
}


class $f19e22002c942845$export$95f9a0270cc163dd {
    constructor(info){
        this.info = info;
    }
    prepare() {
        var _a;
        if (!this.fieldNoToField) {
            const fieldsInput = (_a = this.info.fields) !== null && _a !== void 0 ? _a : [];
            this.fieldNoToField = new Map(fieldsInput.map((field)=>[
                    field.no,
                    field
                ]));
        }
    }
    /**
     * Reads a message from binary format into the target message.
     *
     * Repeated fields are appended. Map entries are added, overwriting
     * existing keys.
     *
     * If a message field is already present, it will be merged with the
     * new data.
     */ read(reader, message, options, length) {
        this.prepare();
        const end = length === undefined ? reader.len : reader.pos + length;
        while(reader.pos < end){
            // read the tag and find the field
            const [fieldNo, wireType] = reader.tag(), field = this.fieldNoToField.get(fieldNo);
            if (!field) {
                let u = options.readUnknownField;
                if (u == "throw") throw new Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.info.typeName}`);
                let d = reader.skip(wireType);
                if (u !== false) (u === true ? (0, $f5d43270d4eddc89$export$2ef2fdbd18d3e030).onRead : u)(this.info.typeName, message, fieldNo, wireType, d);
                continue;
            }
            // target object for the field we are reading
            let target = message, repeated = field.repeat, localName = field.localName;
            // if field is member of oneof ADT, use ADT as target
            if (field.oneof) {
                target = target[field.oneof];
                // if other oneof member selected, set new ADT
                if (target.oneofKind !== localName) target = message[field.oneof] = {
                    oneofKind: localName
                };
            }
            // we have handled oneof above, we just have read the value into `target[localName]`
            switch(field.kind){
                case "scalar":
                case "enum":
                    let T = field.kind == "enum" ? (0, $30d9113c3699bf07$export$d40a369a25702af0).INT32 : field.T;
                    let L = field.kind == "scalar" ? field.L : undefined;
                    if (repeated) {
                        let arr = target[localName]; // safe to assume presence of array, oneof cannot contain repeated values
                        if (wireType == (0, $f5d43270d4eddc89$export$e5d73eed61ade2af).LengthDelimited && T != (0, $30d9113c3699bf07$export$d40a369a25702af0).STRING && T != (0, $30d9113c3699bf07$export$d40a369a25702af0).BYTES) {
                            let e = reader.uint32() + reader.pos;
                            while(reader.pos < e)arr.push(this.scalar(reader, T, L));
                        } else arr.push(this.scalar(reader, T, L));
                    } else target[localName] = this.scalar(reader, T, L);
                    break;
                case "message":
                    if (repeated) {
                        let arr = target[localName]; // safe to assume presence of array, oneof cannot contain repeated values
                        let msg = field.T().internalBinaryRead(reader, reader.uint32(), options);
                        arr.push(msg);
                    } else target[localName] = field.T().internalBinaryRead(reader, reader.uint32(), options, target[localName]);
                    break;
                case "map":
                    let [mapKey, mapVal] = this.mapEntry(field, reader, options);
                    // safe to assume presence of map object, oneof cannot contain repeated values
                    target[localName][mapKey] = mapVal;
                    break;
            }
        }
    }
    /**
     * Read a map field, expecting key field = 1, value field = 2
     */ mapEntry(field, reader, options) {
        let length = reader.uint32();
        let end = reader.pos + length;
        let key = undefined; // javascript only allows number or string for object properties
        let val = undefined;
        while(reader.pos < end){
            let [fieldNo, wireType] = reader.tag();
            switch(fieldNo){
                case 1:
                    if (field.K == (0, $30d9113c3699bf07$export$d40a369a25702af0).BOOL) key = reader.bool().toString();
                    else // long types are read as string, number types are okay as number
                    key = this.scalar(reader, field.K, (0, $30d9113c3699bf07$export$a3fb1069ae3b8bb4).STRING);
                    break;
                case 2:
                    switch(field.V.kind){
                        case "scalar":
                            val = this.scalar(reader, field.V.T, field.V.L);
                            break;
                        case "enum":
                            val = reader.int32();
                            break;
                        case "message":
                            val = field.V.T().internalBinaryRead(reader, reader.uint32(), options);
                            break;
                    }
                    break;
                default:
                    throw new Error(`Unknown field ${fieldNo} (wire type ${wireType}) in map entry for ${this.info.typeName}#${field.name}`);
            }
        }
        if (key === undefined) {
            let keyRaw = (0, $2fd05501808339ea$export$7e70a6dbbc0779b1)(field.K);
            key = field.K == (0, $30d9113c3699bf07$export$d40a369a25702af0).BOOL ? keyRaw.toString() : keyRaw;
        }
        if (val === undefined) switch(field.V.kind){
            case "scalar":
                val = (0, $2fd05501808339ea$export$7e70a6dbbc0779b1)(field.V.T, field.V.L);
                break;
            case "enum":
                val = 0;
                break;
            case "message":
                val = field.V.T().create();
                break;
        }
        return [
            key,
            val
        ];
    }
    scalar(reader, type, longType) {
        switch(type){
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).INT32:
                return reader.int32();
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).STRING:
                return reader.string();
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).BOOL:
                return reader.bool();
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).DOUBLE:
                return reader.double();
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).FLOAT:
                return reader.float();
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).INT64:
                return (0, $81e6f6f0a094add0$export$dad3e19c395b0f8a)(reader.int64(), longType);
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).UINT64:
                return (0, $81e6f6f0a094add0$export$dad3e19c395b0f8a)(reader.uint64(), longType);
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).FIXED64:
                return (0, $81e6f6f0a094add0$export$dad3e19c395b0f8a)(reader.fixed64(), longType);
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).FIXED32:
                return reader.fixed32();
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).BYTES:
                return reader.bytes();
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).UINT32:
                return reader.uint32();
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).SFIXED32:
                return reader.sfixed32();
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).SFIXED64:
                return (0, $81e6f6f0a094add0$export$dad3e19c395b0f8a)(reader.sfixed64(), longType);
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).SINT32:
                return reader.sint32();
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).SINT64:
                return (0, $81e6f6f0a094add0$export$dad3e19c395b0f8a)(reader.sint64(), longType);
        }
    }
}






class $c1e687ffefb5d08e$export$6d3debc51ae57d55 {
    constructor(info){
        this.info = info;
    }
    prepare() {
        if (!this.fields) {
            const fieldsInput = this.info.fields ? this.info.fields.concat() : [];
            this.fields = fieldsInput.sort((a, b)=>a.no - b.no);
        }
    }
    /**
     * Writes the message to binary format.
     */ write(message, writer, options) {
        this.prepare();
        for (const field of this.fields){
            let value, emitDefault, repeated = field.repeat, localName = field.localName;
            // handle oneof ADT
            if (field.oneof) {
                const group = message[field.oneof];
                if (group.oneofKind !== localName) continue; // if field is not selected, skip
                value = group[localName];
                emitDefault = true;
            } else {
                value = message[localName];
                emitDefault = false;
            }
            // we have handled oneof above. we just have to honor `emitDefault`.
            switch(field.kind){
                case "scalar":
                case "enum":
                    let T = field.kind == "enum" ? (0, $30d9113c3699bf07$export$d40a369a25702af0).INT32 : field.T;
                    if (repeated) {
                        (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(Array.isArray(value));
                        if (repeated == (0, $30d9113c3699bf07$export$3c05d9da25cb7a9).PACKED) this.packed(writer, T, field.no, value);
                        else for (const item of value)this.scalar(writer, T, field.no, item, true);
                    } else if (value === undefined) (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(field.opt);
                    else this.scalar(writer, T, field.no, value, emitDefault || field.opt);
                    break;
                case "message":
                    if (repeated) {
                        (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(Array.isArray(value));
                        for (const item of value)this.message(writer, options, field.T(), field.no, item);
                    } else this.message(writer, options, field.T(), field.no, value);
                    break;
                case "map":
                    (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(typeof value == 'object' && value !== null);
                    for (const [key, val] of Object.entries(value))this.mapEntry(writer, options, field, key, val);
                    break;
            }
        }
        let u = options.writeUnknownFields;
        if (u !== false) (u === true ? (0, $f5d43270d4eddc89$export$2ef2fdbd18d3e030).onWrite : u)(this.info.typeName, message, writer);
    }
    mapEntry(writer, options, field, key, value) {
        writer.tag(field.no, (0, $f5d43270d4eddc89$export$e5d73eed61ade2af).LengthDelimited);
        writer.fork();
        // javascript only allows number or string for object properties
        // we convert from our representation to the protobuf type
        let keyValue = key;
        switch(field.K){
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).INT32:
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).FIXED32:
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).UINT32:
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).SFIXED32:
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).SINT32:
                keyValue = Number.parseInt(key);
                break;
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).BOOL:
                (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(key == 'true' || key == 'false');
                keyValue = key == 'true';
                break;
        }
        // write key, expecting key field number = 1
        this.scalar(writer, field.K, 1, keyValue, true);
        // write value, expecting value field number = 2
        switch(field.V.kind){
            case 'scalar':
                this.scalar(writer, field.V.T, 2, value, true);
                break;
            case 'enum':
                this.scalar(writer, (0, $30d9113c3699bf07$export$d40a369a25702af0).INT32, 2, value, true);
                break;
            case 'message':
                this.message(writer, options, field.V.T(), 2, value);
                break;
        }
        writer.join();
    }
    message(writer, options, handler, fieldNo, value) {
        if (value === undefined) return;
        handler.internalBinaryWrite(value, writer.tag(fieldNo, (0, $f5d43270d4eddc89$export$e5d73eed61ade2af).LengthDelimited).fork(), options);
        writer.join();
    }
    /**
     * Write a single scalar value.
     */ scalar(writer, type, fieldNo, value, emitDefault) {
        let [wireType, method, isDefault] = this.scalarInfo(type, value);
        if (!isDefault || emitDefault) {
            writer.tag(fieldNo, wireType);
            writer[method](value);
        }
    }
    /**
     * Write an array of scalar values in packed format.
     */ packed(writer, type, fieldNo, value) {
        if (!value.length) return;
        (0, $4f68f1b9a9c8c878$export$a7a9523472993e97)(type !== (0, $30d9113c3699bf07$export$d40a369a25702af0).BYTES && type !== (0, $30d9113c3699bf07$export$d40a369a25702af0).STRING);
        // write tag
        writer.tag(fieldNo, (0, $f5d43270d4eddc89$export$e5d73eed61ade2af).LengthDelimited);
        // begin length-delimited
        writer.fork();
        // write values without tags
        let [, method] = this.scalarInfo(type);
        for(let i = 0; i < value.length; i++)writer[method](value[i]);
        // end length delimited
        writer.join();
    }
    /**
     * Get information for writing a scalar value.
     *
     * Returns tuple:
     * [0]: appropriate WireType
     * [1]: name of the appropriate method of IBinaryWriter
     * [2]: whether the given value is a default value
     *
     * If argument `value` is omitted, [2] is always false.
     */ scalarInfo(type, value) {
        let t = (0, $f5d43270d4eddc89$export$e5d73eed61ade2af).Varint;
        let m;
        let i = value === undefined;
        let d = value === 0;
        switch(type){
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).INT32:
                m = "int32";
                break;
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).STRING:
                d = i || !value.length;
                t = (0, $f5d43270d4eddc89$export$e5d73eed61ade2af).LengthDelimited;
                m = "string";
                break;
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).BOOL:
                d = value === false;
                m = "bool";
                break;
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).UINT32:
                m = "uint32";
                break;
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).DOUBLE:
                t = (0, $f5d43270d4eddc89$export$e5d73eed61ade2af).Bit64;
                m = "double";
                break;
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).FLOAT:
                t = (0, $f5d43270d4eddc89$export$e5d73eed61ade2af).Bit32;
                m = "float";
                break;
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).INT64:
                d = i || (0, $675e5c20166be613$export$458c11e435f8bbac).from(value).isZero();
                m = "int64";
                break;
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).UINT64:
                d = i || (0, $675e5c20166be613$export$2d16819998fb891c).from(value).isZero();
                m = "uint64";
                break;
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).FIXED64:
                d = i || (0, $675e5c20166be613$export$2d16819998fb891c).from(value).isZero();
                t = (0, $f5d43270d4eddc89$export$e5d73eed61ade2af).Bit64;
                m = "fixed64";
                break;
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).BYTES:
                d = i || !value.byteLength;
                t = (0, $f5d43270d4eddc89$export$e5d73eed61ade2af).LengthDelimited;
                m = "bytes";
                break;
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).FIXED32:
                t = (0, $f5d43270d4eddc89$export$e5d73eed61ade2af).Bit32;
                m = "fixed32";
                break;
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).SFIXED32:
                t = (0, $f5d43270d4eddc89$export$e5d73eed61ade2af).Bit32;
                m = "sfixed32";
                break;
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).SFIXED64:
                d = i || (0, $675e5c20166be613$export$458c11e435f8bbac).from(value).isZero();
                t = (0, $f5d43270d4eddc89$export$e5d73eed61ade2af).Bit64;
                m = "sfixed64";
                break;
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).SINT32:
                m = "sint32";
                break;
            case (0, $30d9113c3699bf07$export$d40a369a25702af0).SINT64:
                d = i || (0, $675e5c20166be613$export$458c11e435f8bbac).from(value).isZero();
                m = "sint64";
                break;
        }
        return [
            t,
            m,
            i || d
        ];
    }
}




function $0f7a96fc587b74f7$export$190e272bed773d84(type) {
    /**
     * This ternary can be removed in the next major version.
     * The `Object.create()` code path utilizes a new `messagePrototype`
     * property on the `IMessageType` which has this same `MESSAGE_TYPE`
     * non-enumerable property on it. Doing it this way means that we only
     * pay the cost of `Object.defineProperty()` once per `IMessageType`
     * class of once per "instance". The falsy code path is only provided
     * for backwards compatibility in cases where the runtime library is
     * updated without also updating the generated code.
     */ const msg = type.messagePrototype ? Object.create(type.messagePrototype) : Object.defineProperty({}, (0, $851284a8a8af4698$export$87130b6dd9721cee), {
        value: type
    });
    for (let field of type.fields){
        let name = field.localName;
        if (field.opt) continue;
        if (field.oneof) msg[field.oneof] = {
            oneofKind: undefined
        };
        else if (field.repeat) msg[name] = [];
        else switch(field.kind){
            case "scalar":
                msg[name] = (0, $2fd05501808339ea$export$7e70a6dbbc0779b1)(field.T, field.L);
                break;
            case "enum":
                // we require 0 to be default value for all enums
                msg[name] = 0;
                break;
            case "map":
                msg[name] = {};
                break;
        }
    }
    return msg;
}


/**
 * Copy partial data into the target message.
 *
 * If a singular scalar or enum field is present in the source, it
 * replaces the field in the target.
 *
 * If a singular message field is present in the source, it is merged
 * with the target field by calling mergePartial() of the responsible
 * message type.
 *
 * If a repeated field is present in the source, its values replace
 * all values in the target array, removing extraneous values.
 * Repeated message fields are copied, not merged.
 *
 * If a map field is present in the source, entries are added to the
 * target map, replacing entries with the same key. Entries that only
 * exist in the target remain. Entries with message values are copied,
 * not merged.
 *
 * Note that this function differs from protobuf merge semantics,
 * which appends repeated fields.
 */ function $e7e565fc412d5cb4$export$222be1b8ba523a3a(info, target, source) {
    let fieldValue, input = source, output; // where we want our field value to go
    for (let field of info.fields){
        let name = field.localName;
        if (field.oneof) {
            const group = input[field.oneof]; // this is the oneof`s group in the source
            if ((group === null || group === void 0 ? void 0 : group.oneofKind) == undefined) continue; // we skip this field, and all other members too
            fieldValue = group[name]; // our value comes from the the oneof group of the source
            output = target[field.oneof]; // and our output is the oneof group of the target
            output.oneofKind = group.oneofKind; // always update discriminator
            if (fieldValue == undefined) {
                delete output[name]; // remove any existing value
                continue; // skip further work on field
            }
        } else {
            fieldValue = input[name]; // we are using the source directly
            output = target; // we want our field value to go directly into the target
            if (fieldValue == undefined) continue; // skip further work on field, existing value is used as is
        }
        if (field.repeat) output[name].length = fieldValue.length; // resize target array to match source array
        // now we just work with `fieldValue` and `output` to merge the value
        switch(field.kind){
            case "scalar":
            case "enum":
                if (field.repeat) for(let i = 0; i < fieldValue.length; i++)output[name][i] = fieldValue[i]; // not a reference type
                else output[name] = fieldValue; // not a reference type
                break;
            case "message":
                let T = field.T();
                if (field.repeat) for(let i = 0; i < fieldValue.length; i++)output[name][i] = T.create(fieldValue[i]);
                else if (output[name] === undefined) output[name] = T.create(fieldValue); // nothing to merge with
                else T.mergePartial(output[name], fieldValue);
                break;
            case "map":
                // Map and repeated fields are simply overwritten, not appended or merged
                switch(field.V.kind){
                    case "scalar":
                    case "enum":
                        Object.assign(output[name], fieldValue); // elements are not reference types
                        break;
                    case "message":
                        let T1 = field.V.T();
                        for (let k of Object.keys(fieldValue))output[name][k] = T1.create(fieldValue[k]);
                        break;
                }
                break;
        }
    }
}



const $7cb6ab3f5117ad07$var$defaultsWrite = {
    emitDefaultValues: false,
    enumAsInteger: false,
    useProtoFieldName: false,
    prettySpaces: 0
}, $7cb6ab3f5117ad07$var$defaultsRead = {
    ignoreUnknownFields: false
};
function $7cb6ab3f5117ad07$export$e2108da0709719eb(options) {
    return options ? Object.assign(Object.assign({}, $7cb6ab3f5117ad07$var$defaultsRead), options) : $7cb6ab3f5117ad07$var$defaultsRead;
}
function $7cb6ab3f5117ad07$export$d0f2f49f029d6c38(options) {
    return options ? Object.assign(Object.assign({}, $7cb6ab3f5117ad07$var$defaultsWrite), options) : $7cb6ab3f5117ad07$var$defaultsWrite;
}
function $7cb6ab3f5117ad07$export$77bed8bb514232ab(a, b) {
    var _a, _b;
    let c = Object.assign(Object.assign({}, a), b);
    c.typeRegistry = [
        ...(_a = a === null || a === void 0 ? void 0 : a.typeRegistry) !== null && _a !== void 0 ? _a : [],
        ...(_b = b === null || b === void 0 ? void 0 : b.typeRegistry) !== null && _b !== void 0 ? _b : []
    ];
    return c;
}



function $95c56c1d1fa664c4$export$3c5f0d0c49971ab2(info, a, b) {
    if (a === b) return true;
    if (!a || !b) return false;
    for (let field of info.fields){
        let localName = field.localName;
        let val_a = field.oneof ? a[field.oneof][localName] : a[localName];
        let val_b = field.oneof ? b[field.oneof][localName] : b[localName];
        switch(field.kind){
            case "enum":
            case "scalar":
                let t = field.kind == "enum" ? (0, $30d9113c3699bf07$export$d40a369a25702af0).INT32 : field.T;
                if (!(field.repeat ? $95c56c1d1fa664c4$var$repeatedPrimitiveEq(t, val_a, val_b) : $95c56c1d1fa664c4$var$primitiveEq(t, val_a, val_b))) return false;
                break;
            case "map":
                if (!(field.V.kind == "message" ? $95c56c1d1fa664c4$var$repeatedMsgEq(field.V.T(), $95c56c1d1fa664c4$var$objectValues(val_a), $95c56c1d1fa664c4$var$objectValues(val_b)) : $95c56c1d1fa664c4$var$repeatedPrimitiveEq(field.V.kind == "enum" ? (0, $30d9113c3699bf07$export$d40a369a25702af0).INT32 : field.V.T, $95c56c1d1fa664c4$var$objectValues(val_a), $95c56c1d1fa664c4$var$objectValues(val_b)))) return false;
                break;
            case "message":
                let T = field.T();
                if (!(field.repeat ? $95c56c1d1fa664c4$var$repeatedMsgEq(T, val_a, val_b) : T.equals(val_a, val_b))) return false;
                break;
        }
    }
    return true;
}
const $95c56c1d1fa664c4$var$objectValues = Object.values;
function $95c56c1d1fa664c4$var$primitiveEq(type, a, b) {
    if (a === b) return true;
    if (type !== (0, $30d9113c3699bf07$export$d40a369a25702af0).BYTES) return false;
    let ba = a;
    let bb = b;
    if (ba.length !== bb.length) return false;
    for(let i = 0; i < ba.length; i++)if (ba[i] != bb[i]) return false;
    return true;
}
function $95c56c1d1fa664c4$var$repeatedPrimitiveEq(type, a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++)if (!$95c56c1d1fa664c4$var$primitiveEq(type, a[i], b[i])) return false;
    return true;
}
function $95c56c1d1fa664c4$var$repeatedMsgEq(type, a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++)if (!type.equals(a[i], b[i])) return false;
    return true;
}





const $bb0fb0c2378207ae$var$defaultsWrite = {
    writeUnknownFields: true,
    writerFactory: ()=>new $bb0fb0c2378207ae$export$b6da98667e5e554f()
};
function $bb0fb0c2378207ae$export$3d48eca60a8fb7e4(options) {
    return options ? Object.assign(Object.assign({}, $bb0fb0c2378207ae$var$defaultsWrite), options) : $bb0fb0c2378207ae$var$defaultsWrite;
}
class $bb0fb0c2378207ae$export$b6da98667e5e554f {
    constructor(textEncoder){
        /**
         * Previous fork states.
         */ this.stack = [];
        this.textEncoder = textEncoder !== null && textEncoder !== void 0 ? textEncoder : new TextEncoder();
        this.chunks = [];
        this.buf = [];
    }
    /**
     * Return all bytes written and reset this writer.
     */ finish() {
        this.chunks.push(new Uint8Array(this.buf)); // flush the buffer
        let len = 0;
        for(let i = 0; i < this.chunks.length; i++)len += this.chunks[i].length;
        let bytes = new Uint8Array(len);
        let offset = 0;
        for(let i = 0; i < this.chunks.length; i++){
            bytes.set(this.chunks[i], offset);
            offset += this.chunks[i].length;
        }
        this.chunks = [];
        return bytes;
    }
    /**
     * Start a new fork for length-delimited data like a message
     * or a packed repeated field.
     *
     * Must be joined later with `join()`.
     */ fork() {
        this.stack.push({
            chunks: this.chunks,
            buf: this.buf
        });
        this.chunks = [];
        this.buf = [];
        return this;
    }
    /**
     * Join the last fork. Write its length and bytes, then
     * return to the previous state.
     */ join() {
        // get chunk of fork
        let chunk = this.finish();
        // restore previous state
        let prev = this.stack.pop();
        if (!prev) throw new Error('invalid state, fork stack empty');
        this.chunks = prev.chunks;
        this.buf = prev.buf;
        // write length of chunk as varint
        this.uint32(chunk.byteLength);
        return this.raw(chunk);
    }
    /**
     * Writes a tag (field number and wire type).
     *
     * Equivalent to `uint32( (fieldNo << 3 | type) >>> 0 )`.
     *
     * Generated code should compute the tag ahead of time and call `uint32()`.
     */ tag(fieldNo, type) {
        return this.uint32((fieldNo << 3 | type) >>> 0);
    }
    /**
     * Write a chunk of raw bytes.
     */ raw(chunk) {
        if (this.buf.length) {
            this.chunks.push(new Uint8Array(this.buf));
            this.buf = [];
        }
        this.chunks.push(chunk);
        return this;
    }
    /**
     * Write a `uint32` value, an unsigned 32 bit varint.
     */ uint32(value) {
        (0, $4f68f1b9a9c8c878$export$2e87d29058d6f62e)(value);
        // write value as varint 32, inlined for speed
        while(value > 0x7f){
            this.buf.push(value & 0x7f | 0x80);
            value = value >>> 7;
        }
        this.buf.push(value);
        return this;
    }
    /**
     * Write a `int32` value, a signed 32 bit varint.
     */ int32(value) {
        (0, $4f68f1b9a9c8c878$export$6ef88129b876fe31)(value);
        (0, $56fe0cf59e73311c$export$77a3057e70db7f11)(value, this.buf);
        return this;
    }
    /**
     * Write a `bool` value, a variant.
     */ bool(value) {
        this.buf.push(value ? 1 : 0);
        return this;
    }
    /**
     * Write a `bytes` value, length-delimited arbitrary data.
     */ bytes(value) {
        this.uint32(value.byteLength); // write length of chunk as varint
        return this.raw(value);
    }
    /**
     * Write a `string` value, length-delimited data converted to UTF-8 text.
     */ string(value) {
        let chunk = this.textEncoder.encode(value);
        this.uint32(chunk.byteLength); // write length of chunk as varint
        return this.raw(chunk);
    }
    /**
     * Write a `float` value, 32-bit floating point number.
     */ float(value) {
        (0, $4f68f1b9a9c8c878$export$bc199b1875ae7ece)(value);
        let chunk = new Uint8Array(4);
        new DataView(chunk.buffer).setFloat32(0, value, true);
        return this.raw(chunk);
    }
    /**
     * Write a `double` value, a 64-bit floating point number.
     */ double(value) {
        let chunk = new Uint8Array(8);
        new DataView(chunk.buffer).setFloat64(0, value, true);
        return this.raw(chunk);
    }
    /**
     * Write a `fixed32` value, an unsigned, fixed-length 32-bit integer.
     */ fixed32(value) {
        (0, $4f68f1b9a9c8c878$export$2e87d29058d6f62e)(value);
        let chunk = new Uint8Array(4);
        new DataView(chunk.buffer).setUint32(0, value, true);
        return this.raw(chunk);
    }
    /**
     * Write a `sfixed32` value, a signed, fixed-length 32-bit integer.
     */ sfixed32(value) {
        (0, $4f68f1b9a9c8c878$export$6ef88129b876fe31)(value);
        let chunk = new Uint8Array(4);
        new DataView(chunk.buffer).setInt32(0, value, true);
        return this.raw(chunk);
    }
    /**
     * Write a `sint32` value, a signed, zigzag-encoded 32-bit varint.
     */ sint32(value) {
        (0, $4f68f1b9a9c8c878$export$6ef88129b876fe31)(value);
        // zigzag encode
        value = (value << 1 ^ value >> 31) >>> 0;
        (0, $56fe0cf59e73311c$export$77a3057e70db7f11)(value, this.buf);
        return this;
    }
    /**
     * Write a `fixed64` value, a signed, fixed-length 64-bit integer.
     */ sfixed64(value) {
        let chunk = new Uint8Array(8);
        let view = new DataView(chunk.buffer);
        let long = (0, $675e5c20166be613$export$458c11e435f8bbac).from(value);
        view.setInt32(0, long.lo, true);
        view.setInt32(4, long.hi, true);
        return this.raw(chunk);
    }
    /**
     * Write a `fixed64` value, an unsigned, fixed-length 64 bit integer.
     */ fixed64(value) {
        let chunk = new Uint8Array(8);
        let view = new DataView(chunk.buffer);
        let long = (0, $675e5c20166be613$export$2d16819998fb891c).from(value);
        view.setInt32(0, long.lo, true);
        view.setInt32(4, long.hi, true);
        return this.raw(chunk);
    }
    /**
     * Write a `int64` value, a signed 64-bit varint.
     */ int64(value) {
        let long = (0, $675e5c20166be613$export$458c11e435f8bbac).from(value);
        (0, $56fe0cf59e73311c$export$ff01ce396ff3d61f)(long.lo, long.hi, this.buf);
        return this;
    }
    /**
     * Write a `sint64` value, a signed, zig-zag-encoded 64-bit varint.
     */ sint64(value) {
        let long = (0, $675e5c20166be613$export$458c11e435f8bbac).from(value), // zigzag encode
        sign = long.hi >> 31, lo = long.lo << 1 ^ sign, hi = (long.hi << 1 | long.lo >>> 31) ^ sign;
        (0, $56fe0cf59e73311c$export$ff01ce396ff3d61f)(lo, hi, this.buf);
        return this;
    }
    /**
     * Write a `uint64` value, an unsigned 64-bit varint.
     */ uint64(value) {
        let long = (0, $675e5c20166be613$export$2d16819998fb891c).from(value);
        (0, $56fe0cf59e73311c$export$ff01ce396ff3d61f)(long.lo, long.hi, this.buf);
        return this;
    }
}





const $974eafbfdd597f55$var$defaultsRead = {
    readUnknownField: true,
    readerFactory: (bytes)=>new $974eafbfdd597f55$export$76c443c41c20b286(bytes)
};
function $974eafbfdd597f55$export$970bd8e9fb5f0092(options) {
    return options ? Object.assign(Object.assign({}, $974eafbfdd597f55$var$defaultsRead), options) : $974eafbfdd597f55$var$defaultsRead;
}
class $974eafbfdd597f55$export$76c443c41c20b286 {
    constructor(buf, textDecoder){
        this.varint64 = (0, $56fe0cf59e73311c$export$e5171d1968013adb); // dirty cast for `this`
        /**
         * Read a `uint32` field, an unsigned 32 bit varint.
         */ this.uint32 = (0, $56fe0cf59e73311c$export$7138ea6223338e60); // dirty cast for `this` and access to protected `buf`
        this.buf = buf;
        this.len = buf.length;
        this.pos = 0;
        this.view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
        this.textDecoder = textDecoder !== null && textDecoder !== void 0 ? textDecoder : new TextDecoder("utf-8", {
            fatal: true,
            ignoreBOM: true
        });
    }
    /**
     * Reads a tag - field number and wire type.
     */ tag() {
        let tag = this.uint32(), fieldNo = tag >>> 3, wireType = tag & 7;
        if (fieldNo <= 0 || wireType < 0 || wireType > 5) throw new Error("illegal tag: field no " + fieldNo + " wire type " + wireType);
        return [
            fieldNo,
            wireType
        ];
    }
    /**
     * Skip one element on the wire and return the skipped data.
     * Supports WireType.StartGroup since v2.0.0-alpha.23.
     */ skip(wireType) {
        let start = this.pos;
        // noinspection FallThroughInSwitchStatementJS
        switch(wireType){
            case (0, $f5d43270d4eddc89$export$e5d73eed61ade2af).Varint:
                while(this.buf[this.pos++] & 0x80);
                break;
            case (0, $f5d43270d4eddc89$export$e5d73eed61ade2af).Bit64:
                this.pos += 4;
            case (0, $f5d43270d4eddc89$export$e5d73eed61ade2af).Bit32:
                this.pos += 4;
                break;
            case (0, $f5d43270d4eddc89$export$e5d73eed61ade2af).LengthDelimited:
                let len = this.uint32();
                this.pos += len;
                break;
            case (0, $f5d43270d4eddc89$export$e5d73eed61ade2af).StartGroup:
                // From descriptor.proto: Group type is deprecated, not supported in proto3.
                // But we must still be able to parse and treat as unknown.
                let t;
                while((t = this.tag()[1]) !== (0, $f5d43270d4eddc89$export$e5d73eed61ade2af).EndGroup)this.skip(t);
                break;
            default:
                throw new Error("cant skip wire type " + wireType);
        }
        this.assertBounds();
        return this.buf.subarray(start, this.pos);
    }
    /**
     * Throws error if position in byte array is out of range.
     */ assertBounds() {
        if (this.pos > this.len) throw new RangeError("premature EOF");
    }
    /**
     * Read a `int32` field, a signed 32 bit varint.
     */ int32() {
        return this.uint32() | 0;
    }
    /**
     * Read a `sint32` field, a signed, zigzag-encoded 32-bit varint.
     */ sint32() {
        let zze = this.uint32();
        // decode zigzag
        return zze >>> 1 ^ -(zze & 1);
    }
    /**
     * Read a `int64` field, a signed 64-bit varint.
     */ int64() {
        return new (0, $675e5c20166be613$export$458c11e435f8bbac)(...this.varint64());
    }
    /**
     * Read a `uint64` field, an unsigned 64-bit varint.
     */ uint64() {
        return new (0, $675e5c20166be613$export$2d16819998fb891c)(...this.varint64());
    }
    /**
     * Read a `sint64` field, a signed, zig-zag-encoded 64-bit varint.
     */ sint64() {
        let [lo, hi] = this.varint64();
        // decode zig zag
        let s = -(lo & 1);
        lo = (lo >>> 1 | (hi & 1) << 31) ^ s;
        hi = hi >>> 1 ^ s;
        return new (0, $675e5c20166be613$export$458c11e435f8bbac)(lo, hi);
    }
    /**
     * Read a `bool` field, a variant.
     */ bool() {
        let [lo, hi] = this.varint64();
        return lo !== 0 || hi !== 0;
    }
    /**
     * Read a `fixed32` field, an unsigned, fixed-length 32-bit integer.
     */ fixed32() {
        return this.view.getUint32((this.pos += 4) - 4, true);
    }
    /**
     * Read a `sfixed32` field, a signed, fixed-length 32-bit integer.
     */ sfixed32() {
        return this.view.getInt32((this.pos += 4) - 4, true);
    }
    /**
     * Read a `fixed64` field, an unsigned, fixed-length 64 bit integer.
     */ fixed64() {
        return new (0, $675e5c20166be613$export$2d16819998fb891c)(this.sfixed32(), this.sfixed32());
    }
    /**
     * Read a `fixed64` field, a signed, fixed-length 64-bit integer.
     */ sfixed64() {
        return new (0, $675e5c20166be613$export$458c11e435f8bbac)(this.sfixed32(), this.sfixed32());
    }
    /**
     * Read a `float` field, 32-bit floating point number.
     */ float() {
        return this.view.getFloat32((this.pos += 4) - 4, true);
    }
    /**
     * Read a `double` field, a 64-bit floating point number.
     */ double() {
        return this.view.getFloat64((this.pos += 8) - 8, true);
    }
    /**
     * Read a `bytes` field, length-delimited arbitrary data.
     */ bytes() {
        let len = this.uint32();
        let start = this.pos;
        this.pos += len;
        this.assertBounds();
        return this.buf.subarray(start, start + len);
    }
    /**
     * Read a `string` field, length-delimited data converted to UTF-8 text.
     */ string() {
        return this.textDecoder.decode(this.bytes());
    }
}


const $20209612832397f7$var$baseDescriptors = Object.getOwnPropertyDescriptors(Object.getPrototypeOf({}));
const $20209612832397f7$var$messageTypeDescriptor = $20209612832397f7$var$baseDescriptors[0, $851284a8a8af4698$export$87130b6dd9721cee] = {};
class $20209612832397f7$export$80edbf15fa61a4db {
    constructor(name, fields, options){
        this.defaultCheckDepth = 16;
        this.typeName = name;
        this.fields = fields.map((0, $30d9113c3699bf07$export$447fc6430fb31fd6));
        this.options = options !== null && options !== void 0 ? options : {};
        $20209612832397f7$var$messageTypeDescriptor.value = this;
        this.messagePrototype = Object.create(null, $20209612832397f7$var$baseDescriptors);
        this.refTypeCheck = new (0, $06d2af0b6d81a0d7$export$909924fefdf89590)(this);
        this.refJsonReader = new (0, $542b30356d238d37$export$673b047513356c73)(this);
        this.refJsonWriter = new (0, $e291ba296f85b206$export$b2626b487dec7942)(this);
        this.refBinReader = new (0, $f19e22002c942845$export$95f9a0270cc163dd)(this);
        this.refBinWriter = new (0, $c1e687ffefb5d08e$export$6d3debc51ae57d55)(this);
    }
    create(value) {
        let message = (0, $0f7a96fc587b74f7$export$190e272bed773d84)(this);
        if (value !== undefined) (0, $e7e565fc412d5cb4$export$222be1b8ba523a3a)(this, message, value);
        return message;
    }
    /**
     * Clone the message.
     *
     * Unknown fields are discarded.
     */ clone(message) {
        let copy = this.create();
        (0, $e7e565fc412d5cb4$export$222be1b8ba523a3a)(this, copy, message);
        return copy;
    }
    /**
     * Determines whether two message of the same type have the same field values.
     * Checks for deep equality, traversing repeated fields, oneof groups, maps
     * and messages recursively.
     * Will also return true if both messages are `undefined`.
     */ equals(a, b) {
        return (0, $95c56c1d1fa664c4$export$3c5f0d0c49971ab2)(this, a, b);
    }
    /**
     * Is the given value assignable to our message type
     * and contains no [excess properties](https://www.typescriptlang.org/docs/handbook/interfaces.html#excess-property-checks)?
     */ is(arg, depth = this.defaultCheckDepth) {
        return this.refTypeCheck.is(arg, depth, false);
    }
    /**
     * Is the given value assignable to our message type,
     * regardless of [excess properties](https://www.typescriptlang.org/docs/handbook/interfaces.html#excess-property-checks)?
     */ isAssignable(arg, depth = this.defaultCheckDepth) {
        return this.refTypeCheck.is(arg, depth, true);
    }
    /**
     * Copy partial data into the target message.
     */ mergePartial(target, source) {
        (0, $e7e565fc412d5cb4$export$222be1b8ba523a3a)(this, target, source);
    }
    /**
     * Create a new message from binary format.
     */ fromBinary(data, options) {
        let opt = (0, $974eafbfdd597f55$export$970bd8e9fb5f0092)(options);
        return this.internalBinaryRead(opt.readerFactory(data), data.byteLength, opt);
    }
    /**
     * Read a new message from a JSON value.
     */ fromJson(json, options) {
        return this.internalJsonRead(json, (0, $7cb6ab3f5117ad07$export$e2108da0709719eb)(options));
    }
    /**
     * Read a new message from a JSON string.
     * This is equivalent to `T.fromJson(JSON.parse(json))`.
     */ fromJsonString(json, options) {
        let value = JSON.parse(json);
        return this.fromJson(value, options);
    }
    /**
     * Write the message to canonical JSON value.
     */ toJson(message, options) {
        return this.internalJsonWrite(message, (0, $7cb6ab3f5117ad07$export$d0f2f49f029d6c38)(options));
    }
    /**
     * Convert the message to canonical JSON string.
     * This is equivalent to `JSON.stringify(T.toJson(t))`
     */ toJsonString(message, options) {
        var _a;
        let value = this.toJson(message, options);
        return JSON.stringify(value, null, (_a = options === null || options === void 0 ? void 0 : options.prettySpaces) !== null && _a !== void 0 ? _a : 0);
    }
    /**
     * Write the message to binary format.
     */ toBinary(message, options) {
        let opt = (0, $bb0fb0c2378207ae$export$3d48eca60a8fb7e4)(options);
        return this.internalBinaryWrite(message, opt.writerFactory(), opt).finish();
    }
    /**
     * This is an internal method. If you just want to read a message from
     * JSON, use `fromJson()` or `fromJsonString()`.
     *
     * Reads JSON value and merges the fields into the target
     * according to protobuf rules. If the target is omitted,
     * a new instance is created first.
     */ internalJsonRead(json, options, target) {
        if (json !== null && typeof json == "object" && !Array.isArray(json)) {
            let message = target !== null && target !== void 0 ? target : this.create();
            this.refJsonReader.read(json, message, options);
            return message;
        }
        throw new Error(`Unable to parse message ${this.typeName} from JSON ${(0, $9b0297e2871b9bc0$export$664ede5272d59144)(json)}.`);
    }
    /**
     * This is an internal method. If you just want to write a message
     * to JSON, use `toJson()` or `toJsonString().
     *
     * Writes JSON value and returns it.
     */ internalJsonWrite(message, options) {
        return this.refJsonWriter.write(message, options);
    }
    /**
     * This is an internal method. If you just want to write a message
     * in binary format, use `toBinary()`.
     *
     * Serializes the message in binary format and appends it to the given
     * writer. Returns passed writer.
     */ internalBinaryWrite(message, writer, options) {
        this.refBinWriter.write(message, writer, options);
        return writer;
    }
    /**
     * This is an internal method. If you just want to read a message from
     * binary data, use `fromBinary()`.
     *
     * Reads data from binary format and merges the fields into
     * the target according to protobuf rules. If the target is
     * omitted, a new instance is created first.
     */ internalBinaryRead(reader, length, options, target) {
        let message = target !== null && target !== void 0 ? target : this.create();
        this.refBinReader.read(reader, message, options, length);
        return message;
    }
}


/**
 * An error that occurred while calling a RPC method.
 */ class $297ac12f7a07a328$export$5460eff990f31920 extends Error {
    constructor(message, code = 'UNKNOWN', meta){
        super(message);
        this.name = 'RpcError';
        // see https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#example
        Object.setPrototypeOf(this, new.target.prototype);
        this.code = code;
        this.meta = meta !== null && meta !== void 0 ? meta : {};
    }
    toString() {
        const l = [
            this.name + ': ' + this.message
        ];
        if (this.code) {
            l.push('');
            l.push('Code: ' + this.code);
        }
        if (this.serviceName && this.methodName) l.push('Method: ' + this.serviceName + '/' + this.methodName);
        let m = Object.entries(this.meta);
        if (m.length) {
            l.push('');
            l.push('Meta:');
            for (let [k, v] of m)l.push(`  ${k}: ${v}`);
        }
        return l.join('\n');
    }
}


function $8ab9239b4c4f2918$export$be413f38429b6a36(method, service) {
    var _a, _b, _c;
    let m = method;
    m.service = service;
    m.localName = (_a = m.localName) !== null && _a !== void 0 ? _a : (0, $ea8ab3bbbe8a3a0f$export$2bcb3d1403ab3e47)(m.name);
    // noinspection PointlessBooleanExpressionJS
    m.serverStreaming = !!m.serverStreaming;
    // noinspection PointlessBooleanExpressionJS
    m.clientStreaming = !!m.clientStreaming;
    m.options = (_b = m.options) !== null && _b !== void 0 ? _b : {};
    m.idempotency = (_c = m.idempotency) !== null && _c !== void 0 ? _c : undefined;
    return m;
}
function $8ab9239b4c4f2918$export$3ba9ba63a93d45c9(service, methodName, extensionName, extensionType) {
    var _a;
    const options = (_a = service.methods.find((m, i)=>m.localName === methodName || i === methodName)) === null || _a === void 0 ? void 0 : _a.options;
    return options && options[extensionName] ? extensionType.fromJson(options[extensionName]) : undefined;
}
function $8ab9239b4c4f2918$export$34893ad81be62fb5(service, methodName, extensionName, extensionType) {
    var _a;
    const options = (_a = service.methods.find((m, i)=>m.localName === methodName || i === methodName)) === null || _a === void 0 ? void 0 : _a.options;
    if (!options) return undefined;
    const optionVal = options[extensionName];
    if (optionVal === undefined) return optionVal;
    return extensionType ? extensionType.fromJson(optionVal) : optionVal;
}
function $8ab9239b4c4f2918$export$9145af61cab450c3(service, extensionName, extensionType) {
    const options = service.options;
    if (!options) return undefined;
    const optionVal = options[extensionName];
    if (optionVal === undefined) return optionVal;
    return extensionType ? extensionType.fromJson(optionVal) : optionVal;
}


class $deb1fa1d99288264$export$a2897b486520c8f3 {
    constructor(typeName, methods, options){
        this.typeName = typeName;
        this.methods = methods.map((i)=>(0, $8ab9239b4c4f2918$export$be413f38429b6a36)(i, this));
        this.options = options !== null && options !== void 0 ? options : {};
    }
}


function $5cf4629fd19c312e$export$762bd1dd98f14729(kind, transport, method, options, input) {
    var _a, _b, _c, _d;
    if (kind == "unary") {
        let tail = (mtd, inp, opt)=>transport.unary(mtd, inp, opt);
        for (const curr of ((_a = options.interceptors) !== null && _a !== void 0 ? _a : []).filter((i)=>i.interceptUnary).reverse()){
            const next = tail;
            tail = (mtd, inp, opt)=>curr.interceptUnary(next, mtd, inp, opt);
        }
        return tail(method, input, options);
    }
    if (kind == "serverStreaming") {
        let tail = (mtd, inp, opt)=>transport.serverStreaming(mtd, inp, opt);
        for (const curr of ((_b = options.interceptors) !== null && _b !== void 0 ? _b : []).filter((i)=>i.interceptServerStreaming).reverse()){
            const next = tail;
            tail = (mtd, inp, opt)=>curr.interceptServerStreaming(next, mtd, inp, opt);
        }
        return tail(method, input, options);
    }
    if (kind == "clientStreaming") {
        let tail = (mtd, opt)=>transport.clientStreaming(mtd, opt);
        for (const curr of ((_c = options.interceptors) !== null && _c !== void 0 ? _c : []).filter((i)=>i.interceptClientStreaming).reverse()){
            const next = tail;
            tail = (mtd, opt)=>curr.interceptClientStreaming(next, mtd, opt);
        }
        return tail(method, options);
    }
    if (kind == "duplex") {
        let tail = (mtd, opt)=>transport.duplex(mtd, opt);
        for (const curr of ((_d = options.interceptors) !== null && _d !== void 0 ? _d : []).filter((i)=>i.interceptDuplex).reverse()){
            const next = tail;
            tail = (mtd, opt)=>curr.interceptDuplex(next, mtd, opt);
        }
        return tail(method, options);
    }
    (0, $4f68f1b9a9c8c878$export$cbadc5a7223772a8)(kind);
}
function $5cf4629fd19c312e$export$21741207f7d5ea2f(transport, method, input, options) {
    return $5cf4629fd19c312e$export$762bd1dd98f14729("unary", transport, method, options, input);
}
function $5cf4629fd19c312e$export$38503fe713b3549b(transport, method, input, options) {
    return $5cf4629fd19c312e$export$762bd1dd98f14729("serverStreaming", transport, method, options, input);
}
function $5cf4629fd19c312e$export$dbee4bea47c4f905(transport, method, options) {
    return $5cf4629fd19c312e$export$762bd1dd98f14729("clientStreaming", transport, method, options);
}
function $5cf4629fd19c312e$export$ededfcb693ab96e1(transport, method, options) {
    return $5cf4629fd19c312e$export$762bd1dd98f14729("duplex", transport, method, options);
}


'use strict';
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const { iterator: $c319b2c832c2914a$var$iterator, toStringTag: $c319b2c832c2914a$var$toStringTag } = Symbol;
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
const $c319b2c832c2914a$var$isUnsafeObjectKey = (prop)=>typeof prop === 'string' && (prop === '__proto__' || prop === 'constructor' || prop === 'prototype');
/**
 * Determine whether an inherited object must be treated as a shared-prototype
 * boundary. Cross-realm Object.prototype objects cannot be distinguished
 * reliably from application-created null-prototype objects because their
 * properties are mutable, so all inherited terminal prototypes are excluded
 * as a fail-closed boundary. A null-prototype source still keeps its own
 * properties, as produced by mergeConfig and other safe materialization paths.
 *
 * @param {*} obj The object to inspect
 * @param {*} prototype The object's prototype
 * @param {boolean} source Whether obj is the original traversal source
 *
 * @returns {boolean} True when obj is a safe prototype traversal boundary
 */ const $c319b2c832c2914a$var$isPrototypeBoundary = (obj, prototype, source)=>obj === Object.prototype || !source && prototype === null;
/**
 * Determine whether an object can retain its identity through code paths that
 * add, replace, and remove config properties without bypassing unsafe-key
 * filtering. Immutable objects, unsafe-key-bearing objects, and objects with
 * accessor or restricted data properties must be materialized instead.
 *
 * @param {*} obj The object to inspect
 *
 * @returns {boolean} True when every own property is safe and fully mutable
 */ const $c319b2c832c2914a$var$isSafeAndFullyMutable = (obj)=>{
    if (!Object.isExtensible(obj)) return false;
    const props = Object.getOwnPropertyNames(obj);
    if (Object.getOwnPropertySymbols) props.push(...Object.getOwnPropertySymbols(obj));
    return props.every((prop)=>{
        if ($c319b2c832c2914a$var$isUnsafeObjectKey(prop)) return false;
        const descriptor = Object.getOwnPropertyDescriptor(obj, prop);
        return !!descriptor && descriptor.configurable && descriptor.writable === true;
    });
};
/**
 * Walk the prototype chain (excluding the source realm's Object.prototype)
 * looking for an own `prop`. This distinguishes genuine own/inherited members
 * — including class accessors and template prototypes — from members injected
 * via Object.prototype pollution (e.g. `Object.prototype.username = '...'`),
 * which live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ const $c319b2c832c2914a$var$hasOwnInPrototypeChain = (thing, prop)=>{
    let obj = thing;
    const seen = [];
    while(obj != null){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        const prototype = $c319b2c832c2914a$var$getPrototypeOf(obj);
        if ($c319b2c832c2914a$var$isPrototypeBoundary(obj, prototype, obj === thing)) return false;
        if ($c319b2c832c2914a$var$hasOwnProperty(obj, prop)) return true;
        obj = prototype;
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ const $c319b2c832c2914a$var$getSafeProp = (obj, prop)=>obj != null && $c319b2c832c2914a$var$hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
/**
 * Flatten an object and its application-defined prototype chain into a
 * null-prototype object. Members inherited only from the source realm's
 * Object.prototype are deliberately excluded, while class/template members
 * below that boundary are preserved.
 *
 * @param {*} thing The value to flatten
 *
 * @returns {*} A null-prototype copy, or the original value when it is already
 * structurally safe or is not an object
 */ const $c319b2c832c2914a$var$toSafeFlatObject = (thing)=>{
    if (thing == null || typeof thing !== 'object' && typeof thing !== 'function') return thing;
    const sourcePrototype = $c319b2c832c2914a$var$getPrototypeOf(thing);
    if (sourcePrototype === null && $c319b2c832c2914a$var$isSafeAndFullyMutable(thing)) return thing;
    const result = Object.create(null);
    const merged = Object.create(null);
    const seen = [];
    let current = thing;
    while(current != null){
        if (seen.indexOf(current) !== -1) break;
        seen.push(current);
        const prototype = current === thing ? sourcePrototype : $c319b2c832c2914a$var$getPrototypeOf(current);
        if ($c319b2c832c2914a$var$isPrototypeBoundary(current, prototype, current === thing)) break;
        const props = Object.getOwnPropertyNames(current);
        if (Object.getOwnPropertySymbols) props.push(...Object.getOwnPropertySymbols(current));
        for (const prop of props){
            if ($c319b2c832c2914a$var$isUnsafeObjectKey(prop)) continue;
            if (!$c319b2c832c2914a$var$hasOwnProperty(merged, prop)) {
                result[prop] = thing[prop];
                merged[prop] = true;
            }
        }
        current = prototype;
    }
    return result;
};
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if (!$c319b2c832c2914a$var$isObject(val)) return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || $c319b2c832c2914a$var$getPrototypeOf(prototype) === null) && // Treat safe own/inherited Symbol.toStringTag or Symbol.iterator members as
    // evidence the value is tagged/iterable, while ignoring members reachable
    // only through shared or terminal prototype boundaries.
    !$c319b2c832c2914a$var$hasOwnInPrototypeChain(val, $c319b2c832c2914a$var$toStringTag) && !$c319b2c832c2914a$var$hasOwnInPrototypeChain(val, $c319b2c832c2914a$var$iterator);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $c319b2c832c2914a$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$c319b2c832c2914a$var$isObject(val) || $c319b2c832c2914a$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $c319b2c832c2914a$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $c319b2c832c2914a$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest('FileList');
const $c319b2c832c2914a$var$isSet = $c319b2c832c2914a$var$kindOfTest('Set');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c319b2c832c2914a$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $c319b2c832c2914a$var$G = $c319b2c832c2914a$var$getGlobal();
const $c319b2c832c2914a$var$FormDataCtor = typeof $c319b2c832c2914a$var$G.FormData !== 'undefined' ? $c319b2c832c2914a$var$G.FormData : undefined;
const $c319b2c832c2914a$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($c319b2c832c2914a$var$FormDataCtor && thing instanceof $c319b2c832c2914a$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $c319b2c832c2914a$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$c319b2c832c2914a$var$isFunction(thing.append)) return false;
    const kind = $c319b2c832c2914a$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest('URLSearchParams');
const [$c319b2c832c2914a$var$isReadableStream, $c319b2c832c2914a$var$isRequest, $c319b2c832c2914a$var$isResponse, $c319b2c832c2914a$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($c319b2c832c2914a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($c319b2c832c2914a$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $c319b2c832c2914a$var$findKey(obj, key) {
    if ($c319b2c832c2914a$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === 'string' && $c319b2c832c2914a$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $c319b2c832c2914a$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($c319b2c832c2914a$var$isPlainObject(existing) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(existing, val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$c319b2c832c2914a$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $c319b2c832c2914a$var$isBuffer(source)) continue;
        $c319b2c832c2914a$var$forEach(source, assignValue);
        if (typeof source !== 'object' || $c319b2c832c2914a$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($c319b2c832c2914a$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$c319b2c832c2914a$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest('HTMLFormElement');
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
const { propertyIsEnumerable: $c319b2c832c2914a$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest('RegExp');
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[$c319b2c832c2914a$var$toStringTag] === 'FormData' && thing[$c319b2c832c2914a$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($c319b2c832c2914a$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                let target;
                if ($c319b2c832c2914a$var$isSet(source)) {
                    target = [];
                    for (const value of source){
                        const reducedValue = visit(value);
                        !$c319b2c832c2914a$var$isUndefined(reducedValue) && target.push(reducedValue);
                    }
                } else {
                    target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                    $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                        const reducedValue = visit(value);
                        !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                    });
                }
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $c319b2c832c2914a$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $c319b2c832c2914a$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $c319b2c832c2914a$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $c319b2c832c2914a$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $c319b2c832c2914a$var$isFunction($c319b2c832c2914a$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $c319b2c832c2914a$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($c319b2c832c2914a$var$_global) : $c319b2c832c2914a$var$_setImmediate;
// *********************
const $c319b2c832c2914a$var$isIterable = (thing)=>thing != null && $c319b2c832c2914a$var$isFunction(thing[$c319b2c832c2914a$var$iterator]);
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ const $c319b2c832c2914a$var$isSafeIterable = (thing)=>thing != null && $c319b2c832c2914a$var$hasOwnInPrototypeChain(thing, $c319b2c832c2914a$var$iterator) && $c319b2c832c2914a$var$isIterable(thing);
var $c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isEmptyObject: $c319b2c832c2914a$var$isEmptyObject,
    isReadableStream: $c319b2c832c2914a$var$isReadableStream,
    isRequest: $c319b2c832c2914a$var$isRequest,
    isResponse: $c319b2c832c2914a$var$isResponse,
    isHeaders: $c319b2c832c2914a$var$isHeaders,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isReactNativeBlob: $c319b2c832c2914a$var$isReactNativeBlob,
    isReactNative: $c319b2c832c2914a$var$isReactNative,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnInPrototypeChain: $c319b2c832c2914a$var$hasOwnInPrototypeChain,
    getSafeProp: $c319b2c832c2914a$var$getSafeProp,
    toSafeFlatObject: $c319b2c832c2914a$var$toSafeFlatObject,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable,
    setImmediate: $c319b2c832c2914a$var$_setImmediate,
    asap: $c319b2c832c2914a$var$asap,
    isIterable: $c319b2c832c2914a$var$isIterable,
    isSafeIterable: $c319b2c832c2914a$var$isSafeIterable
};









'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        const hasKey = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(parsed, key);
        if (!key || hasKey && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp($fc026bbf9ee156f1$var$ignoreDuplicateOf, key)) return;
        if (key === 'set-cookie') {
            if (hasKey) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = hasKey ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};



'use strict';
function $f8f5102fdfcbfec9$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $f8f5102fdfcbfec9$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $f8f5102fdfcbfec9$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $f8f5102fdfcbfec9$var$sanitizeValue(value, invalidChars) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value)) return value.map((item)=>$f8f5102fdfcbfec9$var$sanitizeValue(item, invalidChars));
    return $f8f5102fdfcbfec9$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $f8f5102fdfcbfec9$export$9e344cffce061a22 = (value)=>$f8f5102fdfcbfec9$var$sanitizeValue(value, $f8f5102fdfcbfec9$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $f8f5102fdfcbfec9$export$59dd66c2a12d8f62 = (value)=>$f8f5102fdfcbfec9$var$sanitizeValue(value, $f8f5102fdfcbfec9$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $f8f5102fdfcbfec9$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $f8f5102fdfcbfec9$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}


'use strict';
const $866cce54f6bdfb0c$var$$internals = Symbol('internals');
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : (0, $f8f5102fdfcbfec9$export$9e344cffce061a22)(String(value));
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$parameterNameRE = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function $866cce54f6bdfb0c$var$trimOWS(value) {
    let start = 0;
    let end = value.length;
    while(start < end){
        const code = value.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = value.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === value.length ? value : value.slice(start, end);
}
function $866cce54f6bdfb0c$var$decodeQuotedString(value) {
    const last = value.length - 1;
    if (last < 1 || value.charCodeAt(0) !== 0x22 || value.charCodeAt(last) !== 0x22) return value;
    let decoded = '';
    for(let i = 1; i < last; i++){
        const code = value.charCodeAt(i);
        if (code === 0x22) return value;
        if (code === 0x5c) {
            i += 1;
            if (i >= last) return value;
        }
        decoded += value[i];
    }
    return decoded;
}
function $866cce54f6bdfb0c$var$parseParameters(value) {
    const parameters = Object.create(null);
    const str = String(value);
    let start = 0;
    let quoted = false;
    let escaped = false;
    function parseParameter(end) {
        const part = $866cce54f6bdfb0c$var$trimOWS(str.slice(start, end));
        const equals = part.indexOf('=');
        if (equals < 1) return;
        const name = $866cce54f6bdfb0c$var$trimOWS(part.slice(0, equals));
        if (!$866cce54f6bdfb0c$var$parameterNameRE.test(name)) return;
        const normalizedName = name.toLowerCase();
        if (normalizedName === '__proto__' || normalizedName === 'constructor' || normalizedName === 'prototype') return;
        const parameterValue = $866cce54f6bdfb0c$var$trimOWS(part.slice(equals + 1));
        parameters[normalizedName] = $866cce54f6bdfb0c$var$decodeQuotedString(parameterValue);
    }
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        if (quoted) {
            if (escaped) escaped = false;
            else if (code === 0x5c) escaped = true;
            else if (code === 0x22) quoted = false;
        } else if (code === 0x22) quoted = true;
        else if (code === 0x2c || code === 0x3b) {
            parseParameter(i);
            start = i + 1;
        }
    }
    parseParameter(str.length);
    return parameters;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $fc026bbf9ee156f1$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(header) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSafeIterable(header)) {
            let obj = Object.create(null), dest, key;
            for (const entry of header){
                if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                key = entry[0];
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(obj, key)) {
                    dest = obj[key];
                    obj[key] = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(dest) ? [
                        ...dest,
                        entry[1]
                    ] : [
                        dest,
                        entry[1]
                    ];
                } else obj[key] = entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        const value = this.get('set-cookie');
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value : value == null || value === false ? [] : [
            value
        ];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static parseParameters(value) {
        return $866cce54f6bdfb0c$var$parseParameters(value);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;


'use strict';
const $4e2395edb77acf3a$export$6acd2efa8ac62a1b = '[REDACTED ****]';
function $4e2395edb77acf3a$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $4e2395edb77acf3a$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source) && $4e2395edb77acf3a$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $4e2395edb77acf3a$export$6acd2efa8ac62a1b : visit(value);
                if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
function $4e2395edb77acf3a$var$stringifySafely(value) {
    try {
        return String(value);
    } catch (err) {
        return '';
    }
}
function $4e2395edb77acf3a$var$aggregateErrorMessage(error) {
    const message = error.errors.map((entry)=>{
        try {
            return entry && entry.message ? $4e2395edb77acf3a$var$stringifySafely(entry.message) : $4e2395edb77acf3a$var$stringifySafely(entry);
        } catch (err) {
            return '';
        }
    }).filter(Boolean).join('; ');
    return message || error.name || 'AggregateError';
}
class $4e2395edb77acf3a$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        // `AggregateError` (thrown by Node on dual-stack/Happy-Eyeballs connection
        // failures) has an empty `message`; its detail lives in `errors[]`. Without
        // this, the wrapped error surfaces with a blank message (see #6721).
        let message = error.message;
        if (!message && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(error.errors) && error.errors.length) message = $4e2395edb77acf3a$var$aggregateErrorMessage(error);
        const axiosError = new $4e2395edb77acf3a$var$AxiosError(message, code || error.code, config, request, response);
        // Match native `Error` `cause` semantics: non-enumerable. The wrapped
        // error often carries circular internals (sockets, requests, agents), so
        // an enumerable `cause` makes structured loggers (pino/winston) and any
        // own-property walk throw "Converting circular structure to JSON".
        // Regression from #6982; see #7205. `__proto__: null` mirrors the
        // `message` descriptor below (prototype-pollution-safe descriptor).
        Object.defineProperty(axiosError, 'cause', {
            __proto__: null,
            value: error,
            writable: true,
            enumerable: false,
            configurable: true
        });
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(redactKeys) && redactKeys.length > 0 ? $4e2395edb77acf3a$var$redactConfig(config, redactKeys) : (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$4e2395edb77acf3a$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$4e2395edb77acf3a$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$4e2395edb77acf3a$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$4e2395edb77acf3a$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$4e2395edb77acf3a$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$4e2395edb77acf3a$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$4e2395edb77acf3a$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$4e2395edb77acf3a$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$4e2395edb77acf3a$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$4e2395edb77acf3a$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;


// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;



'use strict';
const $e6cbd383b18c9625$export$659081b45d03227d = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject((0, $c319b2c832c2914a$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4023ac50ad132196$export$2e2bcd8739ae039) || FormData)();
    const option = (name, fallback)=>{
        const value = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(options, name);
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(value) ? fallback : value;
    };
    const metaTokens = option('metaTokens', true);
    // eslint-disable-next-line no-use-before-define
    const visitor = option('visitor') || defaultVisitor;
    const dots = option('dots', false);
    const indexes = option('indexes', false);
    const _Blob = option('Blob') || typeof Blob !== 'undefined' && Blob;
    const maxDepth = option('maxDepth', $e6cbd383b18c9625$export$659081b45d03227d);
    const useBlob = _Blob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    const stack = [];
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isTypedArray(value)) {
            if (useBlob && typeof _Blob === 'function') return new _Blob([
                value
            ]);
            if ((0, $4023ac50ad132196$export$2e2bcd8739ae039) && (0, $4023ac50ad132196$export$2e2bcd8739ae039).isBufferAvailable()) return (0, $4023ac50ad132196$export$2e2bcd8739ae039).from(value);
            throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
        }
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReactNative(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? (value)=>encoder.call(this, value, $f66f8c7b4f247caf$var$encode) : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;


'use strict';
function $8df8fedf1c1e4428$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    url = url || '';
    const _options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    const _encode = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(_options, 'encode') || $8df8fedf1c1e4428$export$c564cdbbe6da493;
    const serializeFn = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(_options, 'serialize');
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
const $5de878cd737ef277$var$$internals = Symbol('internals');
// `handlers` is public and may be replaced with a nullish value by user code;
// `clear()` has always tolerated that. Treat it as an empty stack rather than
// dereferencing it.
function $5de878cd737ef277$var$countHandlers(handlers) {
    return handlers ? handlers.length : 0;
}
function $5de878cd737ef277$var$trimHandlers(handlers) {
    if (!handlers) return;
    while(handlers.length && handlers[handlers.length - 1] === null)handlers.pop();
}
function $5de878cd737ef277$var$syncHandlerEntries(manager, internals) {
    const handlers = manager.handlers;
    const length = $5de878cd737ef277$var$countHandlers(handlers);
    if (handlers !== internals.handlersRef) {
        internals.handlersRef = handlers;
        internals.handlerEntries.clear();
    } else if (length !== internals.handlersLength) {
        if (!length) internals.handlerEntries.clear();
        else internals.handlerEntries.forEach(function removeStaleEntry(entry, id) {
            if (handlers[entry.index] !== entry.handler) internals.handlerEntries.delete(id);
        });
    }
    internals.handlersLength = length;
}
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
        this[$5de878cd737ef277$var$$internals] = {
            handlersRef: this.handlers,
            handlersLength: this.handlers.length,
            handlerEntries: new Map(),
            iterationDepth: 0,
            nextId: 0
        };
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        const handler = {
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        };
        const internals = this[$5de878cd737ef277$var$$internals];
        if (this.handlers == null) this.handlers = [];
        $5de878cd737ef277$var$syncHandlerEntries(this, internals);
        const id = internals.nextId++;
        this.handlers.push(handler);
        internals.handlerEntries.set(id, {
            handler: handler,
            index: this.handlers.length - 1
        });
        internals.handlersLength = this.handlers.length;
        return id;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        const internals = this[$5de878cd737ef277$var$$internals];
        $5de878cd737ef277$var$syncHandlerEntries(this, internals);
        const entry = internals.handlerEntries.get(id);
        if (entry) {
            internals.handlerEntries.delete(id);
            // Ignore IDs invalidated by clear or direct replacement of handlers.
            if (this.handlers[entry.index] !== entry.handler) return;
            this.handlers[entry.index] = null;
            // Do not reuse an index while forEach is walking its length snapshot.
            if (!internals.iterationDepth) {
                $5de878cd737ef277$var$trimHandlers(this.handlers);
                internals.handlersLength = this.handlers.length;
            }
        }
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) {
            this.handlers = [];
            $5de878cd737ef277$var$syncHandlerEntries(this, this[$5de878cd737ef277$var$$internals]);
        }
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        const internals = this[$5de878cd737ef277$var$$internals];
        $5de878cd737ef277$var$syncHandlerEntries(this, internals);
        internals.iterationDepth++;
        try {
            (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
                if (h !== null) fn(h);
            });
        } finally{
            if (!--internals.iterationDepth) {
                $5de878cd737ef277$var$syncHandlerEntries(this, internals);
                $5de878cd737ef277$var$trimHandlers(this.handlers);
                internals.handlersLength = $5de878cd737ef277$var$countHandlers(this.handlers);
            }
        }
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;





'use strict';
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
};






'use strict';
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039);


'use strict';
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $6eeff4490c995137$export$2e2bcd8739ae039,
        FormData: $86d275a264afb13f$export$2e2bcd8739ae039,
        Blob: $59c79e94740631e4$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $565e85ead8bde60a$exports = {};

$parcel$export($565e85ead8bde60a$exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export($565e85ead8bde60a$exports, "navigator", () => $565e85ead8bde60a$export$ec7c8efa7f5790ae);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
$parcel$export($565e85ead8bde60a$exports, "origin", () => $565e85ead8bde60a$export$f710a83a91838a36);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $565e85ead8bde60a$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && (!$565e85ead8bde60a$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($565e85ead8bde60a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $565e85ead8bde60a$export$f710a83a91838a36 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$565e85ead8bde60a$exports,
    ...(0, $2f71637df772b183$export$2e2bcd8739ae039)
};


'use strict';
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(data, new (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).isNode && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}






'use strict';
const $5f8142930b3b943f$var$MAX_DEPTH = (0, $e6cbd383b18c9625$export$659081b45d03227d);
function $5f8142930b3b943f$var$throwIfDepthExceeded(index) {
    if (index > $5f8142930b3b943f$var$MAX_DEPTH) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('FormData field is too deeply nested (' + index + ' levels). Max depth: ' + $5f8142930b3b943f$var$MAX_DEPTH, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z] -> ['foo', 'x', 'y', 'z']
    // foo.x.y.z    -> ['foo', 'x', 'y', 'z']
    // A path is split on `.` and on `[...]` groups. A segment — whether written
    // in dot notation or captured inside brackets — may contain any character
    // except `.`, `[` and `]`, so a key like `user-name` or `user name` is kept
    // literal instead of being split (#5402). `.`, `[` and `]` keep their existing
    // meaning, e.g. `foo[bar.baz]` -> ['foo', 'bar', 'baz'] and `[]` is an array push.
    // Excluding `[` from the bracket group also makes the match fail fast at the
    // next `[`, so a malformed name cannot rescan to the end of the string from
    // every unmatched `[` — parsing stays linear in the length of the name.
    const path = [];
    const pattern = /[^.[\]]+|\[([^.[\]]*)]/g;
    let match;
    while((match = pattern.exec(name)) !== null){
        $5f8142930b3b943f$var$throwIfDepthExceeded(path.length);
        path.push(match[0] === '[]' ? '' : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        $5f8142930b3b943f$var$throwIfDepthExceeded(index);
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name) || !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;


'use strict';
const $2fec45dc063f0c4b$var$methodList = Object.freeze([
    'get',
    'delete',
    'head',
    'options',
    'post',
    'put',
    'patch',
    'purge',
    'link',
    'unlink',
    'query'
]);
var $2fec45dc063f0c4b$export$2e2bcd8739ae039 = $2fec45dc063f0c4b$var$methodList;


'use strict';
const $843bf0209bc94df8$var$own = (obj, key)=>obj != null && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $51466d41a76e5b4b$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $5f8142930b3b943f$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isStream(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFile(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $843bf0209bc94df8$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $f6f250f62cadb740$export$2e2bcd8739ae039)(data, formSerializer).toString();
                if ((isFileList = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $843bf0209bc94df8$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $843bf0209bc94df8$var$own(this, 'transitional') || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $843bf0209bc94df8$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isResponse(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $843bf0209bc94df8$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(e, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, $843bf0209bc94df8$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach((0, $2fec45dc063f0c4b$export$2e2bcd8739ae039), (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;



'use strict';
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $843bf0209bc94df8$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $9fd0919e266b4fda$var$CanceledError extends (0, $4e2395edb77acf3a$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;







'use strict';
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, response.config, response.request, response));
}





'use strict';
const $503871fd6eafbe9c$var$urlParserControlCharacters = /[\t\n\r]/g;
function $503871fd6eafbe9c$export$2e2bcd8739ae039(url) {
    if (typeof url !== 'string') return url;
    let start = 0;
    while(start < url.length && url.charCodeAt(start) <= 0x20)start++;
    return url.slice(start).replace($503871fd6eafbe9c$var$urlParserControlCharacters, '');
}


'use strict';
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Array<Function>}
 */ function $9b3ced92bc7bdc99$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    const flushWith = (...args)=>invoke(args);
    return [
        throttled,
        flush,
        flushWith
    ];
}
var $9b3ced92bc7bdc99$export$2e2bcd8739ae039 = $9b3ced92bc7bdc99$var$throttle;



const $1a6c80b567b74091$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $4a9d49cd0e6b8acc$export$2e2bcd8739ae039)(50, 250);
    return (0, $9b3ced92bc7bdc99$export$2e2bcd8739ae039)((e)=>{
        if (!e || !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(e.loaded)) return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = Math.max(0, total != null ? Math.min(rawLoaded, total) : rawLoaded);
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $1a6c80b567b74091$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $1a6c80b567b74091$export$5d35863c355a22a9 = (fn, scheduler = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap)=>(...args)=>scheduler(()=>fn(...args));






var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $bb8180acb278e187$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin), (0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) try {
                return decodeURIComponent(cookie.slice(eq + 1));
            } catch (e) {
                return cookie.slice(eq + 1);
            }
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};



'use strict';
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    if (!relativeURL) return baseURL;
    let end = baseURL.length;
    while(end > 0 && baseURL.charCodeAt(end - 1) === 47)end--;
    return baseURL.slice(0, end) + '/' + relativeURL.replace(/^\/+/, '');
}



'use strict';
const $598acbfafd2c63c5$var$malformedHttpProtocol = /^https?:(?!\/\/)/i;
// Redact the parts of a URL that can carry secrets before it is embedded in an
// error message. AxiosError.toJSON() serializes `message` verbatim and errors
// are commonly logged, while the opt-in `config.redact` model only cleans
// config keys — it cannot reach the message. Redact only the genuinely
// sensitive substrings — userinfo (credentials), query parameter values and
// fragment contents — with the same REDACTED marker the config redaction uses,
// while keeping the scheme, host, path and parameter names so the offending
// request stays accurately identifiable.
function $598acbfafd2c63c5$var$redactFragment(fragment) {
    if (!fragment) return fragment;
    return fragment.replace(/(^|&)([^=&]*=)?[^&]+/g, (match, separator, parameterName = '')=>{
        return `${separator}${parameterName}${0, $4e2395edb77acf3a$export$6acd2efa8ac62a1b}`;
    });
}
function $598acbfafd2c63c5$var$redactSensitiveURLParts(url) {
    const redactedURL = url.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${(0, $4e2395edb77acf3a$export$6acd2efa8ac62a1b)}@`);
    const fragmentIndex = redactedURL.indexOf('#');
    const urlWithoutFragment = fragmentIndex === -1 ? redactedURL : redactedURL.slice(0, fragmentIndex);
    const redactedURLWithoutFragment = urlWithoutFragment.replace(/([?&][^=&#]*=)[^&#]*/g, `$1${(0, $4e2395edb77acf3a$export$6acd2efa8ac62a1b)}`);
    if (fragmentIndex === -1) return redactedURLWithoutFragment;
    return `${redactedURLWithoutFragment}#${$598acbfafd2c63c5$var$redactFragment(redactedURL.slice(fragmentIndex + 1))}`;
}
function $598acbfafd2c63c5$var$assertValidHttpProtocolURL(url, config) {
    if (typeof url === 'string') {
        const normalizedURL = (0, $503871fd6eafbe9c$export$2e2bcd8739ae039)(url);
        if ($598acbfafd2c63c5$var$malformedHttpProtocol.test(normalizedURL)) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Invalid URL ${JSON.stringify($598acbfafd2c63c5$var$redactSensitiveURLParts(normalizedURL))}: missing "//" after protocol`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_INVALID_URL, config);
    }
}
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls, config) {
    $598acbfafd2c63c5$var$assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !(0, $8fa91c1a59edb5d9$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        $598acbfafd2c63c5$var$assertValidHttpProtocolURL(baseURL, config);
        return (0, $b63e12c1e0b9e0be$export$2e2bcd8739ae039)(baseURL, requestedURL);
    }
    return requestedURL;
}




'use strict';
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
const $f85fda54cd977b19$var$ownEnumerableKeys = (thing)=>{
    if (Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor) return Object.keys(thing).concat(Object.getOwnPropertySymbols(thing).filter((symbol)=>Object.getOwnPropertyDescriptor(thing, symbol).enumerable));
    return Object.keys(thing);
};
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(target) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    function getMergedTransitionalOption(prop) {
        const transitional2 = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config2, 'transitional') ? config2.transitional : undefined;
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(transitional2)) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(transitional2)) {
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(transitional2, prop)) return transitional2[prop];
            } else return undefined;
        }
        const transitional1 = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config1, 'transitional') ? config1.transitional : undefined;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(transitional1) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(transitional1, prop)) return transitional1[prop];
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutErrorMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), prop, true)
    };
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach($f85fda54cd977b19$var$ownEnumerableKeys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config2, 'validateStatus') && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(config2.validateStatus) && getMergedTransitionalOption('validateStatusUndefinedResolves') === false) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config1, 'validateStatus')) config.validateStatus = getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}



'use strict';
const $ff840e6c220d182f$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $ff840e6c220d182f$export$2e2bcd8739ae039(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders || {}).forEach(([key, val])=>{
        if ($ff840e6c220d182f$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}



/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $ab4625fac3104691$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $ab4625fac3104691$var$resolveConfig(config) {
    const newConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)((0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(baseURL, url, allowAbsoluteUrls, newConfig), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) {
        const username = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(auth, 'username') || '';
        const password = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(auth, 'password') || '';
        try {
            headers.set('Authorization', 'Basic ' + btoa(username + ':' + (password ? $ab4625fac3104691$var$encodeUTF8(password) : '')));
        } catch (e) {
            throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(e, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE, config);
        }
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data)) {
        const getHeaders = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(data, 'getHeaders');
        if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(getHeaders)) // Node.js FormData (like form-data package)
        (0, $ff840e6c220d182f$export$2e2bcd8739ae039)(headers, getHeaders.call(data), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $5eb63b558e1fb85a$export$2e2bcd8739ae039)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $65cc14c0704b5541$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $ab4625fac3104691$export$2e2bcd8739ae039 = $ab4625fac3104691$var$resolveConfig;



const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload, flushDownloadWithEvent;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend(event) {
            if (!request) return;
            // Status 0 means no response was received, which onerror and onabort normally
            // reject before this runs. Firefox 152 fires only readystatechange and loadend for
            // navigation-canceled requests (https://bugzilla.mozilla.org/show_bug.cgi?id=1505389),
            // leaving settle() to resolve them as an empty success. ECONNABORTED is the error
            // onabort raised on Firefox 151. Reads over file:, which some environments report as
            // status 0 on success, are excluded by the request URL's scheme after browser-style
            // preprocessing, by the page origin's scheme for relative URLs (which inherit it), or
            // by responseURL where implemented.
            if (request.status === 0 && ((0, $23607f53e4fda918$export$2e2bcd8739ae039)((0, $503871fd6eafbe9c$export$2e2bcd8739ae039)(_config.url)) || (0, $23607f53e4fda918$export$2e2bcd8739ae039)((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin)) !== 'file' && !(request.responseURL && request.responseURL.startsWith('file:'))) {
                reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request aborted', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
                done();
                // Clean up request
                request = null;
                return;
            }
            // When loadend is still dispatching, flushing with it gives progress
            // listeners a final delivery whose event has a live target. The legacy
            // ready-state fallback has no event, so replay its pending progress.
            // A throwing listener must not block settlement; rethrow asynchronously,
            // matching how listener errors surface on the throttle timer path.
            try {
                if (event) flushDownloadWithEvent && flushDownloadWithEvent(event);
                else flushDownload && flushDownload();
            } catch (err) {
                setTimeout(()=>{
                    throw err;
                });
            }
            // A final progress callback can cancel the request synchronously.
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request aborted', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(msg, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach((0, $f8f5102fdfcbfec9$export$c30c72bb7e677d54)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload, flushDownloadWithEvent] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $23607f53e4fda918$export$2e2bcd8739ae039)(_config.url);
        if (protocol && !(0, $bb8180acb278e187$export$2e2bcd8739ae039).protocols.includes(protocol)) {
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            done();
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $a052b9a6636aacdc$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039) ? err : new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>{
        if (aborted) return;
        if (signal.aborted) {
            onabort.call(signal);
            return;
        }
        signal.addEventListener('abort', onabort, {
            once: true
        });
    });
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(unsubscribe);
    return signal;
};
var $a052b9a6636aacdc$export$2e2bcd8739ae039 = $a052b9a6636aacdc$var$composeSignals;


const $c9465135abb26626$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c9465135abb26626$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c9465135abb26626$var$readStream(iterable))yield* $c9465135abb26626$export$71b051935044bd5d(chunk, chunkSize);
};
const $c9465135abb26626$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c9465135abb26626$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c9465135abb26626$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






/**
 * Estimate data: URL byte lengths *without* allocating large buffers.
 * - Fetch percent-decodes a base64 body before decoding it.
 * - Node's Buffer.from(body, 'base64') sizes its backing allocation from the
 *   raw body, including ignored characters and content after padding.
 * - Non-base64 data is percent-decoded and then encoded as UTF-8.
 */ const $da69a2069c6136ea$var$isHexDigit = (charCode)=>charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
const $da69a2069c6136ea$var$isPercentEncodedByte = (str, i, len)=>i + 2 < len && $da69a2069c6136ea$var$isHexDigit(str.charCodeAt(i + 1)) && $da69a2069c6136ea$var$isHexDigit(str.charCodeAt(i + 2));
const $da69a2069c6136ea$var$hexValue = (charCode)=>charCode <= 57 ? charCode - 48 : (charCode & 0xdf) - 55;
const $da69a2069c6136ea$var$isBase64Char = (charCode)=>charCode >= 65 && charCode <= 90 || // A-Z
    charCode >= 97 && charCode <= 122 || // a-z
    charCode >= 48 && charCode <= 57 || // 0-9
    charCode === 43 || // +
    charCode === 47 || // /
    charCode === 45 || // - (base64url)
    charCode === 95; // _ (base64url)
const $da69a2069c6136ea$var$isBase64Whitespace = (charCode)=>charCode === 9 || charCode === 10 || charCode === 12 || charCode === 13 || charCode === 32;
const $da69a2069c6136ea$var$base64Bytes = (significant)=>{
    const groups = Math.floor(significant / 4);
    const remainder = significant % 4;
    return groups * 3 + (remainder === 2 ? 1 : remainder === 3 ? 2 : 0);
};
// Buffer.byteLength(body, 'base64') uses the raw string length as an allocation
// upper bound even when Buffer.from later ignores characters or stops at '='.
const $da69a2069c6136ea$var$estimateBase64BufferAllocation = (body)=>{
    const len = body.length;
    let padding = 0;
    if (len > 0 && body.charCodeAt(len - 1) === 61 /* '=' */ ) {
        padding++;
        if (len > 1 && body.charCodeAt(len - 2) === 61 /* '=' */ ) padding++;
    }
    return Math.floor((len - padding) * 3 / 4);
};
const $da69a2069c6136ea$var$estimatePercentDecodedBase64Bytes = (body)=>{
    const len = body.length;
    let significant = 0;
    let padding = 0;
    let invalid = false;
    for(let i = 0; i < len; i++){
        let code = body.charCodeAt(i);
        if (code === 37 /* '%' */  && $da69a2069c6136ea$var$isPercentEncodedByte(body, i, len)) {
            code = $da69a2069c6136ea$var$hexValue(body.charCodeAt(i + 1)) * 16 + $da69a2069c6136ea$var$hexValue(body.charCodeAt(i + 2));
            i += 2;
        }
        if ($da69a2069c6136ea$var$isBase64Whitespace(code)) continue;
        if (code === 61 /* '=' */ ) {
            padding++;
            continue;
        }
        if (!$da69a2069c6136ea$var$isBase64Char(code) || padding > 0) {
            invalid = true;
            continue;
        }
        significant++;
    }
    // Fetch rejects malformed forgiving-base64 input. Returning the raw-size
    // allocation bound keeps that invalid input from becoming a pre-check bypass.
    if (invalid || padding > 2 || padding > 0 && (significant + padding) % 4 !== 0 || significant % 4 === 1) return $da69a2069c6136ea$var$estimateBase64BufferAllocation(body);
    return $da69a2069c6136ea$var$base64Bytes(significant);
};
const $da69a2069c6136ea$var$estimateDataURLBytes = (url, estimateBase64)=>{
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) return estimateBase64(body);
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && $da69a2069c6136ea$var$isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
};
function $da69a2069c6136ea$export$2e2bcd8739ae039(url) {
    // Fetch removes URL fragments before processing a data: URL.
    const fragmentIndex = typeof url === 'string' ? url.indexOf('#') : -1;
    return $da69a2069c6136ea$var$estimateDataURLBytes(fragmentIndex === -1 ? url : url.slice(0, fragmentIndex), $da69a2069c6136ea$var$estimatePercentDecodedBase64Bytes);
}
function $da69a2069c6136ea$export$1f39e64b554a246f(url) {
    return $da69a2069c6136ea$var$estimateDataURLBytes(url, $da69a2069c6136ea$var$estimateBase64BufferAllocation);
}


const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.20.0";



const $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE = 65536;
const $e52be20a9fc15e96$var$DEFAULT_REQUEST_OPTIONS = {
    cache: 'default',
    redirect: 'follow',
    referrer: 'about:client',
    referrerPolicy: '',
    mode: 'cors',
    integrity: '',
    keepalive: false,
    priority: 'auto',
    window: null
};
const { isFunction: $e52be20a9fc15e96$var$isFunction } = (0, $c319b2c832c2914a$export$2e2bcd8739ae039);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $e52be20a9fc15e96$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $e52be20a9fc15e96$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $e52be20a9fc15e96$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $e52be20a9fc15e96$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const $e52be20a9fc15e96$var$factory = (env)=>{
    const globalObject = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).global !== undefined && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).global !== null ? (0, $c319b2c832c2914a$export$2e2bcd8739ae039).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $e52be20a9fc15e96$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $e52be20a9fc15e96$var$isFunction(Request);
    const isResponseSupported = $e52be20a9fc15e96$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $e52be20a9fc15e96$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength, maxRedirects: maxRedirects } = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        const hasMaxContentLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $a052b9a6636aacdc$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        // AxiosError we raise while the request body is being streamed. Captured
        // by identity so the catch block can surface it directly, regardless of
        // how the runtime wraps the resulting fetch rejection (undici exposes it
        // as `err.cause`; some browsers drop the original error entirely).
        let pendingBodyError = null;
        const maxBodyLengthError = ()=>new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request body larger than maxBodyLength limit', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config, request);
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(configAuth, 'username') || '';
                const password = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(configAuth, 'password') || '';
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($e52be20a9fc15e96$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $bb8180acb278e187$export$2e2bcd8739ae039).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $e52be20a9fc15e96$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $e52be20a9fc15e96$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa($e52be20a9fc15e96$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $da69a2069c6136ea$export$2e2bcd8739ae039)(url);
                if (estimated > maxContentLength) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against known-size bodies before dispatch using
            // the body's *actual* size — never a caller-declared Content-Length,
            // which could under-report to slip an oversized body past the check.
            // Unknown-size streams return undefined here and are counted per-chunk
            // below as fetch consumes them.
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await getBodyLength(data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength)) {
                    requestContentLength = outboundLength;
                    if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                }
            }
            // A streamed body under maxBodyLength must be counted as fetch consumes
            // it; its size is never trusted from a caller-declared Content-Length.
            const mustEnforceStreamBody = hasMaxBodyLength && ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isStream(data));
            const trackRequestStream = (stream, onProgress, flush)=>(0, $c9465135abb26626$export$b0119225647bd83)(stream, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, (loadedBytes)=>{
                    if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                    onProgress && onProgress(loadedBytes);
                }, flush);
            if (supportsRequestStream && method !== 'get' && method !== 'head' && (onUploadProgress || mustEnforceStreamBody)) {
                requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
                // A declared length of 0 is only trusted to skip the wrap when we are
                // not enforcing a stream limit (which must not rely on that header).
                if (requestContentLength !== 0 || mustEnforceStreamBody) {
                    let _request = new Request(url, {
                        method: 'POST',
                        body: data,
                        duplex: 'half'
                    });
                    let contentTypeHeader;
                    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                    if (_request.body) {
                        const [onProgress, flush] = onUploadProgress && (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(requestContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onUploadProgress))) || [];
                        data = trackRequestStream(_request.body, onProgress, flush);
                    }
                }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== 'get' && method !== 'head') data = trackRequestStream(data);
            else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== 'get' && method !== 'head') throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Stream request bodies are not supported by the current fetch implementation', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config, request);
            if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132), false);
            const safeFetchOptions = fetchOptions == null ? fetchOptions : Object.assign(Object.create(null), fetchOptions);
            if (safeFetchOptions) {
                // These options are owned by Axios and are already reflected in the
                // resolved Request passed to fetch.
                delete safeFetchOptions.body;
                delete safeFetchOptions.headers;
                delete safeFetchOptions.method;
                delete safeFetchOptions.signal;
                delete safeFetchOptions.duplex;
                delete safeFetchOptions.credentials;
            }
            const resolvedOptions = Object.assign(Object.create(null), safeFetchOptions, {
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $f8f5102fdfcbfec9$export$c30c72bb7e677d54)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            });
            if (isRequestSupported) {
                (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach($e52be20a9fc15e96$var$DEFAULT_REQUEST_OPTIONS, (value, key)=>{
                    if (resolvedOptions[key] === undefined) resolvedOptions[key] = value;
                });
                if (resolvedOptions.signal === undefined) resolvedOptions.signal = null;
                if (resolvedOptions.body === undefined) resolvedOptions.body = null;
            }
            if (maxRedirects === 0) {
                resolvedOptions.redirect = 'manual';
                if (safeFetchOptions) safeFetchOptions.redirect = 'manual';
            }
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, safeFetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers);
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                const [onProgress, flush] = onDownloadProgress && (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(responseContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $c9465135abb26626$export$b0119225647bd83)(response.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                if (err !== canceledError) // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(canceledError, 'cause', {
                    __proto__: null,
                    value: err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw canceledError;
            }
            // Surface a maxBodyLength violation we raised while the request body was
            // being streamed. Matching by identity (rather than reading
            // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
            // and avoids both prototype-pollution reads and mis-attributing a foreign
            // AxiosError that merely happened to land in `err.cause`.
            if (pendingBodyError) {
                request && !pendingBodyError.request && (pendingBodyError.request = request);
                throw pendingBodyError;
            }
            // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
            // pre-checks, response size enforcement) without re-wrapping them.
            if (err instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)) {
                request && !err.request && (err.request = request);
                throw err;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
                const networkError = new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Network Error', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response);
                // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(networkError, 'cause', {
                    __proto__: null,
                    value: err.cause || err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw networkError;
            }
            throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $e52be20a9fc15e96$var$seedCache = new Map();
const $e52be20a9fc15e96$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $e52be20a9fc15e96$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $e52be20a9fc15e96$var$factory(env));
        map = target;
    }
    return target;
};
const $e52be20a9fc15e96$var$adapter = $e52be20a9fc15e96$export$3105c6651375d4fa();
var $e52be20a9fc15e96$export$2e2bcd8739ae039 = $e52be20a9fc15e96$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $4023ac50ad132196$export$2e2bcd8739ae039),
    xhr: (0, $79f0a48d5eb7919b$export$2e2bcd8739ae039),
    fetch: {
        get: $e52be20a9fc15e96$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $e8c8c7960873e9ee$var$getAdapter(adapters, config) {
    adapters = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($e8c8c7960873e9ee$var$renderReason).join('\n') : ' ' + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $e8c8c7960873e9ee$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $e8c8c7960873e9ee$var$knownAdapters
};



'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(_config) {
    // Interceptors may replace the merged config with an ordinary object. Flatten
    // it at the dispatch boundary so shared prototype members cannot become
    // request behavior, while preserving intentional template/class members.
    const config = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toSafeFlatObject(_config);
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from((0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(config, 'headers'));
    // Transform request data
    config.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $843bf0209bc94df8$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5a60afef8b0dd173$export$2e2bcd8739ae039)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}







'use strict';
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$85f59389941e7907$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object' || options === null) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('options must be an object', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};




'use strict';
const $a93486d2307f31c3$var$validators = (0, $85f59389941e7907$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)(),
            response: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) try {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                const dummyStack = dummy.stack;
                let stack = '';
                // slice off the Error: ... line
                if (typeof dummyStack === 'string') {
                    const firstNewlineIndex = dummyStack.indexOf('\n');
                    stack = firstNewlineIndex === -1 ? '' : dummyStack.slice(firstNewlineIndex + 1);
                }
                if (!err.stack) err.stack = stack;
                else if (stack) {
                    const firstNewlineIndex = stack.indexOf('\n');
                    const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                    const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                    if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                }
            } catch (e) {
            // Ignore failures from custom stack hooks or un-writable stack properties.
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            legacyInterceptorReqResOrdering: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            advertiseZstdAcceptEncoding: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            validateStatusUndefinedResolves: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $a93486d2307f31c3$var$validators.spelling('baseURL'),
            withXsrfToken: $a93486d2307f31c3$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(config, 'method') || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(this.defaults, 'method') || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach((0, $2fec45dc063f0c4b$export$2e2bcd8739ae039).concat('common'), (method)=>{
            delete headers[method];
        });
        config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled ? onFulfilled(newConfig) : newConfig;
            } catch (error) {
                if (!onRejected) {
                    promise = Promise.reject(error);
                    break;
                }
                try {
                    const rejectedResult = onRejected.call(this, error);
                    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isThenable(rejectedResult)) promise = Promise.resolve(rejectedResult).then(()=>(0, $9b8d10189805ccc0$export$2e2bcd8739ae039).call(this, newConfig));
                } catch (rejectedError) {
                    promise = Promise.reject(rejectedError);
                }
                break;
            }
        }
        if (!promise) try {
            promise = (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            promise = Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: config && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config, 'data') ? config.data : undefined
        }));
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $a93486d2307f31c3$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;






'use strict';
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    /**
   * @deprecated Use `ContentTooLarge` instead.
   */ PayloadTooLarge: 413,
    ContentTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    /**
   * @deprecated Use `UnprocessableContent` instead.
   */ UnprocessableEntity: 422,
    UnprocessableContent: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerReturnsAnUnknownError: 520,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    if ($f919374d785e9fb8$var$HttpStatusCode[value] === undefined) $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $a93486d2307f31c3$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)((0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, (0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $843bf0209bc94df8$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $a93486d2307f31c3$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $9fd0919e266b4fda$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $fb81495929d8a282$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.isCancel = (0, $5a60afef8b0dd173$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.VERSION = (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132);
$57966c7e0affc4cb$var$axios.toFormData = (0, $e6cbd383b18c9625$export$2e2bcd8739ae039);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $4e2395edb77acf3a$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $089369673aa7c1c3$export$2e2bcd8739ae039);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $9db8da59db12cd94$export$2e2bcd8739ae039);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $5f8142930b3b943f$export$2e2bcd8739ae039)((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $f919374d785e9fb8$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a, create: $b302555736d21bd7$export$185802fd694ee1f5 } = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039);


// Copyright 2018 Twitch Interactive, Inc.  All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License"). You may not
// use this file except in compliance with the License. A copy of the License is
// located at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
// CONDITIONS OF ANY KIND, either express or implied. See the License
// for the specific language governing permissions and limitations under
// the License.
/**
 * See https://twitchtv.github.io/twirp/docs/spec_v5.html#error-codes
 *
 * Names and descriptions from [twirp / errors.go](https://github.com/twitchtv/twirp/blob/b2ecb97cf02a9bb55d730920f6a1cb5243899093/errors.go)
 *
 * Copyright 2018 by Twitch Interactive, Inc.
 */ var $0b292aefa7b441d9$export$55bc18a3e61a4e3c;
(function(TwirpErrorCode) {
    /**
     * The operation was cancelled.
     */ TwirpErrorCode[TwirpErrorCode["cancelled"] = 0] = "cancelled";
    /**
     * An unknown error occurred. For example, this can be used when handling
     * errors raised by APIs that do not return any error information.
     */ TwirpErrorCode[TwirpErrorCode["unknown"] = 1] = "unknown";
    /**
     * The client specified an invalid argument. This indicates arguments that
     * are invalid regardless of the state of the system (i.e. a malformed
     * file name, required argument, number out of range, etc.).
     */ TwirpErrorCode[TwirpErrorCode["invalid_argument"] = 2] = "invalid_argument";
    /**
     * The client sent a message which could not be decoded. This may mean that
     * the message was encoded improperly or that the client and server have
     * incompatible message definitions.
     */ TwirpErrorCode[TwirpErrorCode["malformed"] = 3] = "malformed";
    /**
     * Operation expired before completion. For operations that change the state
     * of the system, this error may be returned even if the operation has
     * completed successfully (timeout).
     */ TwirpErrorCode[TwirpErrorCode["deadline_exceeded"] = 4] = "deadline_exceeded";
    /**
     * Some requested entity was not found.
     */ TwirpErrorCode[TwirpErrorCode["not_found"] = 5] = "not_found";
    /**
     * The requested URL path wasn't routable to a Twirp service and method.
     * This is returned by generated server code and should not be returned
     * by application code (use "not_found" or "unimplemented" instead).
     */ TwirpErrorCode[TwirpErrorCode["bad_route"] = 6] = "bad_route";
    /**
     * An attempt to create an entity failed because one already exists.
     */ TwirpErrorCode[TwirpErrorCode["already_exists"] = 7] = "already_exists";
    /**
     * The caller does not have permission to execute the specified operation.
     * It must not be used if the caller cannot be identified (use
     * "unauthenticated" instead).
     */ TwirpErrorCode[TwirpErrorCode["permission_denied"] = 8] = "permission_denied";
    /**
     * The request does not have valid authentication credentials for the
     * operation.
     */ TwirpErrorCode[TwirpErrorCode["unauthenticated"] = 9] = "unauthenticated";
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or
     * perhaps the entire file system is out of space.
     */ TwirpErrorCode[TwirpErrorCode["resource_exhausted"] = 10] = "resource_exhausted";
    /**
     * The operation was rejected because the system is not in a state
     * required for the operation's execution. For example, doing an rmdir
     * operation on a directory that is non-empty, or on a non-directory
     * object, or when having conflicting read-modify-write on the same
     * resource.
     */ TwirpErrorCode[TwirpErrorCode["failed_precondition"] = 11] = "failed_precondition";
    /**
     * The operation was aborted, typically due to a concurrency issue
     * like sequencer check failures, transaction aborts, etc.
     */ TwirpErrorCode[TwirpErrorCode["aborted"] = 12] = "aborted";
    /**
     * The operation was attempted past the valid range. For example, seeking
     * or reading past end of a paginated collection. Unlike
     * "invalid_argument", this error indicates a problem that may be fixed if
     * the system state changes (i.e. adding more items to the collection).
     * There is a fair bit of overlap between "failed_precondition" and
     * "out_of_range". We recommend using "out_of_range" (the more specific
     * error) when it applies so that callers who are iterating through a space
     * can easily look for an "out_of_range" error to detect when they are done.
     */ TwirpErrorCode[TwirpErrorCode["out_of_range"] = 13] = "out_of_range";
    /**
     * The operation is not implemented or not supported/enabled in this service.
     */ TwirpErrorCode[TwirpErrorCode["unimplemented"] = 14] = "unimplemented";
    /**
     * When some invariants expected by the underlying system have been broken.
     * In other words, something bad happened in the library or backend service.
     * Twirp specific issues like wire and serialization problems are also
     * reported as "internal" errors.
     */ TwirpErrorCode[TwirpErrorCode["internal"] = 15] = "internal";
    /**
     * The service is currently unavailable. This is most likely a transient
     * condition and may be corrected by retrying with a backoff.
     */ TwirpErrorCode[TwirpErrorCode["unavailable"] = 16] = "unavailable";
    /**
     * The operation resulted in unrecoverable data loss or corruption.
     */ TwirpErrorCode[TwirpErrorCode["dataloss"] = 17] = "dataloss";
})($0b292aefa7b441d9$export$55bc18a3e61a4e3c || ($0b292aefa7b441d9$export$55bc18a3e61a4e3c = {}));




function $165217fc3509c6bb$export$9c19195124c6a61a(headers, sendJson, meta) {
    // add meta as headers
    if (meta) for (let [k, v] of Object.entries(meta)){
        if (typeof v == "string") headers.append(k, v);
        else for (let i of v)headers.append(k, i);
    }
    // set standard headers (possibly overwriting meta)
    headers.set('Content-Type', sendJson ? "application/json" : "application/protobuf");
    headers.set('Accept', sendJson ? "application/json" : "application/protobuf, application/json");
    return headers;
}
function $165217fc3509c6bb$export$fdb50c8e6048be27(json) {
    if (!(0, $9b0297e2871b9bc0$export$98727920b98c3cdb)(json) || typeof json.code !== "string" || typeof json.msg !== "string") return new (0, $297ac12f7a07a328$export$5460eff990f31920)('cannot read twirp error response', (0, $0b292aefa7b441d9$export$55bc18a3e61a4e3c)[(0, $0b292aefa7b441d9$export$55bc18a3e61a4e3c).internal]);
    let meta = {};
    if ((0, $9b0297e2871b9bc0$export$98727920b98c3cdb)(json.meta)) {
        for (let [k, v] of Object.entries(json.meta))if (typeof v == "string") meta[k] = v;
    }
    return new (0, $297ac12f7a07a328$export$5460eff990f31920)(json.msg, json.code, meta);
}
function $165217fc3509c6bb$export$d00c7b480075de4e(headers) {
    let meta = {};
    headers.forEach((value, key)=>{
        if (key.toLowerCase() === 'content-type') return;
        if (key.toLowerCase() === 'content-length') return;
        if (meta.hasOwnProperty(key)) meta[key].push(value);
        else meta[key] = value;
    });
    return meta;
}


var $7c63507ffa2244e1$export$b3d0de17b6bbc646;
(function(DeferredState) {
    DeferredState[DeferredState["PENDING"] = 0] = "PENDING";
    DeferredState[DeferredState["REJECTED"] = 1] = "REJECTED";
    DeferredState[DeferredState["RESOLVED"] = 2] = "RESOLVED";
})($7c63507ffa2244e1$export$b3d0de17b6bbc646 || ($7c63507ffa2244e1$export$b3d0de17b6bbc646 = {}));
class $7c63507ffa2244e1$export$85f6557964517f1a {
    /**
     * @param preventUnhandledRejectionWarning - prevents the warning
     * "Unhandled Promise rejection" by adding a noop rejection handler.
     * Working with calls returned from the runtime-rpc package in an
     * async function usually means awaiting one call property after
     * the other. This means that the "status" is not being awaited when
     * an earlier await for the "headers" is rejected. This causes the
     * "unhandled promise reject" warning. A more correct behaviour for
     * calls might be to become aware whether at least one of the
     * promises is handled and swallow the rejection warning for the
     * others.
     */ constructor(preventUnhandledRejectionWarning = true){
        this._state = $7c63507ffa2244e1$export$b3d0de17b6bbc646.PENDING;
        this._promise = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
        });
        if (preventUnhandledRejectionWarning) this._promise.catch((_)=>{});
    }
    /**
     * Get the current state of the promise.
     */ get state() {
        return this._state;
    }
    /**
     * Get the deferred promise.
     */ get promise() {
        return this._promise;
    }
    /**
     * Resolve the promise. Throws if the promise is already resolved or rejected.
     */ resolve(value) {
        if (this.state !== $7c63507ffa2244e1$export$b3d0de17b6bbc646.PENDING) throw new Error(`cannot resolve ${$7c63507ffa2244e1$export$b3d0de17b6bbc646[this.state].toLowerCase()}`);
        this._resolve(value);
        this._state = $7c63507ffa2244e1$export$b3d0de17b6bbc646.RESOLVED;
    }
    /**
     * Reject the promise. Throws if the promise is already resolved or rejected.
     */ reject(reason) {
        if (this.state !== $7c63507ffa2244e1$export$b3d0de17b6bbc646.PENDING) throw new Error(`cannot reject ${$7c63507ffa2244e1$export$b3d0de17b6bbc646[this.state].toLowerCase()}`);
        this._reject(reason);
        this._state = $7c63507ffa2244e1$export$b3d0de17b6bbc646.REJECTED;
    }
    /**
     * Resolve the promise. Ignore if not pending.
     */ resolvePending(val) {
        if (this._state === $7c63507ffa2244e1$export$b3d0de17b6bbc646.PENDING) this.resolve(val);
    }
    /**
     * Reject the promise. Ignore if not pending.
     */ rejectPending(reason) {
        if (this._state === $7c63507ffa2244e1$export$b3d0de17b6bbc646.PENDING) this.reject(reason);
    }
}


function $2f9ef5474c1ad83a$export$7c5fc00899236162(defaults, options) {
    if (!options) return defaults;
    let o = {};
    $2f9ef5474c1ad83a$var$copy(defaults, o);
    $2f9ef5474c1ad83a$var$copy(options, o);
    for (let key of Object.keys(options)){
        let val = options[key];
        switch(key){
            case "jsonOptions":
                o.jsonOptions = (0, $7cb6ab3f5117ad07$export$77bed8bb514232ab)(defaults.jsonOptions, o.jsonOptions);
                break;
            case "binaryOptions":
                o.binaryOptions = (0, $f5d43270d4eddc89$export$f69cb2aab840e4e1)(defaults.binaryOptions, o.binaryOptions);
                break;
            case "meta":
                o.meta = {};
                $2f9ef5474c1ad83a$var$copy(defaults.meta, o.meta);
                $2f9ef5474c1ad83a$var$copy(options.meta, o.meta);
                break;
            case "interceptors":
                o.interceptors = defaults.interceptors ? defaults.interceptors.concat(val) : val.concat();
                break;
        }
    }
    return o;
}
function $2f9ef5474c1ad83a$var$copy(a, into) {
    if (!a) return;
    let c = into;
    for (let [k, v] of Object.entries(a)){
        if (v instanceof Date) c[k] = new Date(v.getTime());
        else if (Array.isArray(v)) c[k] = v.concat();
        else c[k] = v;
    }
}

var $da930d6dc5885469$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $da930d6dc5885469$export$9a440373637fd860 {
    constructor(method, requestHeaders, request, headers, response, status, trailers){
        this.method = method;
        this.requestHeaders = requestHeaders;
        this.request = request;
        this.headers = headers;
        this.response = response;
        this.status = status;
        this.trailers = trailers;
    }
    /**
     * If you are only interested in the final outcome of this call,
     * you can await it to receive a `FinishedUnaryCall`.
     */ then(onfulfilled, onrejected) {
        return this.promiseFinished().then((value)=>onfulfilled ? Promise.resolve(onfulfilled(value)) : value, (reason)=>onrejected ? Promise.resolve(onrejected(reason)) : Promise.reject(reason));
    }
    promiseFinished() {
        return $da930d6dc5885469$var$__awaiter(this, void 0, void 0, function*() {
            let [headers, response, status, trailers] = yield Promise.all([
                this.headers,
                this.response,
                this.status,
                this.trailers
            ]);
            return {
                method: this.method,
                requestHeaders: this.requestHeaders,
                request: this.request,
                headers: headers,
                response: response,
                status: status,
                trailers: trailers
            };
        });
    }
}




class $173a986e7ce6493c$export$7172f10038f2ec3f {
    constructor(options){
        this.defaultOptions = options;
    }
    mergeOptions(options) {
        return (0, $2f9ef5474c1ad83a$export$7c5fc00899236162)(this.defaultOptions, options);
    }
    unary(method, input, options) {
        var _a, _b, _c;
        let opt = options, url = this.makeUrl(method, opt), fetchInit = (_a = opt.fetchInit) !== null && _a !== void 0 ? _a : {}, requestBody = opt.sendJson ? method.I.toJsonString(input, opt.jsonOptions) : method.I.toBinary(input, opt.binaryOptions), defHeader = new (0, $7c63507ffa2244e1$export$85f6557964517f1a)(), defMessage = new (0, $7c63507ffa2244e1$export$85f6557964517f1a)(), defStatus = new (0, $7c63507ffa2244e1$export$85f6557964517f1a)(), defTrailer = new (0, $7c63507ffa2244e1$export$85f6557964517f1a)();
        globalThis.fetch(url, Object.assign(Object.assign({}, fetchInit), {
            method: 'POST',
            headers: (0, $165217fc3509c6bb$export$9c19195124c6a61a)(new globalThis.Headers(), !!opt.sendJson, opt.meta),
            body: requestBody,
            signal: (_b = options.abort) !== null && _b !== void 0 ? _b : null // node-fetch@3.0.0-beta.9 rejects `undefined`
        })).then((fetchResponse)=>{
            defHeader.resolve((0, $165217fc3509c6bb$export$d00c7b480075de4e)(fetchResponse.headers));
            // Cloudflare Workers throw when the type property of a fetch response
            // is accessed, so wrap access with try/catch. See:
            // * https://developers.cloudflare.com/workers/runtime-apis/response/#properties
            // * https://github.com/cloudflare/miniflare/blob/72f046e/packages/core/src/standards/http.ts#L646
            let responseType;
            try {
                responseType = fetchResponse.type;
            } catch (_a) {}
            switch(responseType){
                case "error":
                case "opaque":
                case "opaqueredirect":
                    // see https://developer.mozilla.org/en-US/docs/Web/API/Response/type
                    throw new (0, $297ac12f7a07a328$export$5460eff990f31920)(`fetch response type ${fetchResponse.type}`, (0, $0b292aefa7b441d9$export$55bc18a3e61a4e3c)[(0, $0b292aefa7b441d9$export$55bc18a3e61a4e3c).unknown]);
            }
            if (!fetchResponse.ok) return fetchResponse.json().then((value)=>{
                throw (0, $165217fc3509c6bb$export$fdb50c8e6048be27)(value);
            }, ()=>{
                throw new (0, $297ac12f7a07a328$export$5460eff990f31920)('received HTTP ' + fetchResponse.status + ', unable to read response body as json', (0, $0b292aefa7b441d9$export$55bc18a3e61a4e3c)[(0, $0b292aefa7b441d9$export$55bc18a3e61a4e3c).internal]);
            });
            if (opt.sendJson) return fetchResponse.json().then((value)=>method.O.fromJson(value, opt.jsonOptions), ()=>{
                throw new (0, $297ac12f7a07a328$export$5460eff990f31920)('unable to read response body as json', (0, $0b292aefa7b441d9$export$55bc18a3e61a4e3c)[(0, $0b292aefa7b441d9$export$55bc18a3e61a4e3c).dataloss]);
            });
            return fetchResponse.arrayBuffer().then((value)=>method.O.fromBinary(new Uint8Array(value), opt.binaryOptions), ()=>{
                throw new (0, $297ac12f7a07a328$export$5460eff990f31920)('unable to read response body', (0, $0b292aefa7b441d9$export$55bc18a3e61a4e3c)[(0, $0b292aefa7b441d9$export$55bc18a3e61a4e3c).dataloss]);
            });
        }, (reason)=>{
            // failed to fetch, aborted, wrong url or network problem
            if (reason instanceof Error && reason.name === 'AbortError') throw new (0, $297ac12f7a07a328$export$5460eff990f31920)(reason.message, (0, $0b292aefa7b441d9$export$55bc18a3e61a4e3c)[(0, $0b292aefa7b441d9$export$55bc18a3e61a4e3c).cancelled]);
            throw new (0, $297ac12f7a07a328$export$5460eff990f31920)(reason instanceof Error ? reason.message : reason);
        }).then((message)=>{
            defMessage.resolve(message);
            defStatus.resolve({
                code: 'OK',
                detail: ''
            });
            defTrailer.resolve({});
        }).catch((reason)=>{
            // RpcErrors are thrown by us, everything else is an internal error
            let error = reason instanceof (0, $297ac12f7a07a328$export$5460eff990f31920) ? reason : new (0, $297ac12f7a07a328$export$5460eff990f31920)(reason instanceof Error ? reason.message : reason, (0, $0b292aefa7b441d9$export$55bc18a3e61a4e3c)[(0, $0b292aefa7b441d9$export$55bc18a3e61a4e3c).internal]);
            error.methodName = method.name;
            error.serviceName = method.service.typeName;
            defHeader.rejectPending(error);
            defMessage.rejectPending(error);
            defStatus.rejectPending(error);
            defTrailer.rejectPending(error);
        });
        return new (0, $da930d6dc5885469$export$9a440373637fd860)(method, (_c = opt.meta) !== null && _c !== void 0 ? _c : {}, input, defHeader.promise, defMessage.promise, defStatus.promise, defTrailer.promise);
    }
    /**
     * Create an URI for a RPC call.
     *
     * Takes the `baseUrl` option and appends:
     * - slash "/"
     * - package name
     * - dot "."
     * - service name
     * - slash "/"
     * - method name
     *
     * If the service was declared without a package, the package name and dot
     * are omitted.
     *
     * The method name is CamelCased just as it would be in Go, unless the
     * option `useProtoMethodName` is `true`.
     */ makeUrl(method, options) {
        let base = options.baseUrl;
        if (base.endsWith('/')) base = base.substring(0, base.length - 1);
        let methodName = method.name;
        if (options.useProtoMethodName !== true) {
            methodName = (0, $ea8ab3bbbe8a3a0f$export$2bcb3d1403ab3e47)(methodName);
            methodName = methodName.substring(0, 1).toUpperCase() + methodName.substring(1);
        }
        return `${base}/${method.service.typeName}/${methodName}`;
    }
    clientStreaming(method /*, options: RpcOptions*/ ) {
        const e = new (0, $297ac12f7a07a328$export$5460eff990f31920)('Client streaming is not supported by Twirp', (0, $0b292aefa7b441d9$export$55bc18a3e61a4e3c)[(0, $0b292aefa7b441d9$export$55bc18a3e61a4e3c).unimplemented]);
        e.methodName = method.name;
        e.serviceName = method.service.typeName;
        throw e;
    }
    duplex(method /*, options: RpcOptions*/ ) {
        const e = new (0, $297ac12f7a07a328$export$5460eff990f31920)('Duplex streaming is not supported by Twirp', (0, $0b292aefa7b441d9$export$55bc18a3e61a4e3c)[(0, $0b292aefa7b441d9$export$55bc18a3e61a4e3c).unimplemented]);
        e.methodName = method.name;
        e.serviceName = method.service.typeName;
        throw e;
    }
    serverStreaming(method /*, input: I, options?: RpcOptions*/ ) {
        const e = new (0, $297ac12f7a07a328$export$5460eff990f31920)('Server streaming is not supported by Twirp', (0, $0b292aefa7b441d9$export$55bc18a3e61a4e3c)[(0, $0b292aefa7b441d9$export$55bc18a3e61a4e3c).unimplemented]);
        e.methodName = method.name;
        e.serviceName = method.service.typeName;
        throw e;
    }
}


var $1300170f237a6b56$exports = {};
"use strict";
Object.defineProperty($1300170f237a6b56$exports, "__esModule", {
    value: true
});
$1300170f237a6b56$exports.createLoggerSystem = $1300170f237a6b56$exports.LogLevelEnum = void 0;
var $c02a24cb3cbb4f38$exports = {};
"use strict";
Object.defineProperty($c02a24cb3cbb4f38$exports, "__esModule", {
    value: true
});
$c02a24cb3cbb4f38$exports.isReactNative = void 0;
/**
 * Checks whether we are using React Native
 */ const $c02a24cb3cbb4f38$var$isReactNative = ()=>{
    if (typeof navigator === "undefined") return false;
    return navigator.product?.toLowerCase() === "reactnative";
};
$c02a24cb3cbb4f38$exports.isReactNative = $c02a24cb3cbb4f38$var$isReactNative;


var $1300170f237a6b56$var$LogLevelEnum;
(function(LogLevelEnum) {
    LogLevelEnum[LogLevelEnum["trace"] = 0] = "trace";
    LogLevelEnum[LogLevelEnum["debug"] = 1] = "debug";
    LogLevelEnum[LogLevelEnum["info"] = 2] = "info";
    LogLevelEnum[LogLevelEnum["warn"] = 3] = "warn";
    LogLevelEnum[LogLevelEnum["error"] = 4] = "error";
})($1300170f237a6b56$var$LogLevelEnum || ($1300170f237a6b56$exports.LogLevelEnum = $1300170f237a6b56$var$LogLevelEnum = {}));
const $1300170f237a6b56$var$logToConsole = (logLevel, message, ...rest)=>{
    let logMethod;
    switch(logLevel){
        case "error":
            if ((0, $c02a24cb3cbb4f38$exports.isReactNative)()) {
                message = `ERROR: ${message}`;
                logMethod = console.info;
                break;
            }
            logMethod = console.error;
            break;
        case "warn":
            if ((0, $c02a24cb3cbb4f38$exports.isReactNative)()) {
                message = `WARN: ${message}`;
                logMethod = console.info;
                break;
            }
            logMethod = console.warn;
            break;
        case "info":
            logMethod = console.info;
            break;
        case "trace":
            logMethod = console.trace;
            break;
        default:
            logMethod = console.log;
            break;
    }
    logMethod(message, ...rest);
};
const $1300170f237a6b56$var$DEFAULT_LOG_LEVEL = "info";
const $1300170f237a6b56$var$DEFAULT_SINK = $1300170f237a6b56$var$logToConsole;
const $1300170f237a6b56$var$createLoggerSystem = ()=>{
    const sinkByScope = new Map([
        [
            "default",
            $1300170f237a6b56$var$DEFAULT_SINK
        ]
    ]);
    const logLevelByScope = new Map([
        [
            "default",
            $1300170f237a6b56$var$DEFAULT_LOG_LEVEL
        ]
    ]);
    const getLogger = (scope, options = {})=>{
        const tagString = (options.tags ?? []).filter(Boolean).join(",");
        const constructLogFunction = (logLevel)=>(message, ...data)=>{
                const scopedLogLevel = logLevelByScope.get(scope) ?? logLevelByScope.get("default");
                if ($1300170f237a6b56$var$LogLevelEnum[logLevel] >= $1300170f237a6b56$var$LogLevelEnum[scopedLogLevel]) {
                    const scopedSink = sinkByScope.get(scope) ?? sinkByScope.get("default");
                    scopedSink(logLevel, `[${scope}]${tagString.length ? `(${tagString})` : ""}: ${message}`, ...data);
                }
            };
        return {
            withExtraTags: (...extraTags)=>{
                return getLogger(scope, {
                    ...options,
                    tags: options.tags ? options.tags.concat(extraTags) : extraTags
                });
            },
            getLogLevel: ()=>{
                return logLevelByScope.get(scope) ?? logLevelByScope.get("default");
            },
            error: constructLogFunction("error"),
            trace: constructLogFunction("trace"),
            debug: constructLogFunction("debug"),
            info: constructLogFunction("info"),
            warn: constructLogFunction("warn")
        };
    };
    const configureLoggers = (optionsByScope)=>{
        for(const scope in optionsByScope){
            const options = optionsByScope[scope];
            if (options.sink) sinkByScope.set(scope, options.sink);
            else if (options.sink === null && scope !== "default") sinkByScope.delete(scope);
            if (options.level) logLevelByScope.set(scope, options.level);
            else if (options.level === null && scope !== "default") logLevelByScope.delete(scope);
        }
    };
    const restoreDefaults = ()=>{
        sinkByScope.clear();
        logLevelByScope.clear();
        sinkByScope.set("default", $1300170f237a6b56$var$DEFAULT_SINK);
        logLevelByScope.set("default", $1300170f237a6b56$var$DEFAULT_LOG_LEVEL);
    };
    return {
        getLogger: getLogger,
        configureLoggers: configureLoggers,
        restoreDefaults: restoreDefaults
    };
};
$1300170f237a6b56$exports.createLoggerSystem = $1300170f237a6b56$var$createLoggerSystem;


var $178bb82ca124d09b$export$b3a6900b22e4209;
var $178bb82ca124d09b$export$68d8715fc104d294;
var $178bb82ca124d09b$export$98e6a39c04603d36;
var $178bb82ca124d09b$export$ef804106d1571703;
var $178bb82ca124d09b$export$dfeb1045bffe1ff8;
var $178bb82ca124d09b$export$326874e595fb968b;
var $178bb82ca124d09b$export$705b3971a35c200;
var $178bb82ca124d09b$export$1ca60456d3287987;
var $178bb82ca124d09b$export$c61d0126da4c310f;
var $503e7b8ecd4140d2$export$98e6a39c04603d36;
var $503e7b8ecd4140d2$export$ef804106d1571703;
// For backward compatibility - alias will be removed in 3.0.0
var $503e7b8ecd4140d2$export$dfeb1045bffe1ff8;
var $503e7b8ecd4140d2$export$326874e595fb968b;
var $503e7b8ecd4140d2$export$705b3971a35c200;
var $503e7b8ecd4140d2$export$1ca60456d3287987;
var $503e7b8ecd4140d2$export$c61d0126da4c310f;
var $503e7b8ecd4140d2$var$toIntIfInt = function(v) {
    return String(Number(v)) === v ? Number(v) : v;
};
var $503e7b8ecd4140d2$var$attachProperties = function(match, location, names, rawName) {
    if (rawName && !names) location[rawName] = $503e7b8ecd4140d2$var$toIntIfInt(match[1]);
    else {
        for(var i = 0; i < names.length; i += 1)if (match[i + 1] != null) location[names[i]] = $503e7b8ecd4140d2$var$toIntIfInt(match[i + 1]);
    }
};
var $503e7b8ecd4140d2$var$parseReg = function(obj, location, content) {
    var needsBlank = obj.name && obj.names;
    if (obj.push && !location[obj.push]) location[obj.push] = [];
    else if (needsBlank && !location[obj.name]) location[obj.name] = {};
    var keyLocation = obj.push ? {} : needsBlank ? location[obj.name] : location; // otherwise, named location or root
    $503e7b8ecd4140d2$var$attachProperties(content.match(obj.reg), keyLocation, obj.names, obj.name);
    if (obj.push) location[obj.push].push(keyLocation);
};
var $71fab0475308d224$exports = {};
var $71fab0475308d224$var$grammar = $71fab0475308d224$exports = {
    v: [
        {
            name: 'version',
            reg: /^(\d*)$/
        }
    ],
    o: [
        {
            // o=- 20518 0 IN IP4 203.0.113.1
            // NB: sessionId will be a String in most cases because it is huge
            name: 'origin',
            reg: /^(\S*) (\d*) (\d*) (\S*) IP(\d) (\S*)/,
            names: [
                'username',
                'sessionId',
                'sessionVersion',
                'netType',
                'ipVer',
                'address'
            ],
            format: '%s %s %d %s IP%d %s'
        }
    ],
    // default parsing of these only (though some of these feel outdated)
    s: [
        {
            name: 'name'
        }
    ],
    i: [
        {
            name: 'description'
        }
    ],
    u: [
        {
            name: 'uri'
        }
    ],
    e: [
        {
            name: 'email'
        }
    ],
    p: [
        {
            name: 'phone'
        }
    ],
    z: [
        {
            name: 'timezones'
        }
    ],
    r: [
        {
            name: 'repeats'
        }
    ],
    // k: [{}], // outdated thing ignored
    t: [
        {
            // t=0 0
            name: 'timing',
            reg: /^(\d*) (\d*)/,
            names: [
                'start',
                'stop'
            ],
            format: '%d %d'
        }
    ],
    c: [
        {
            // c=IN IP4 10.47.197.26
            name: 'connection',
            reg: /^IN IP(\d) (\S*)/,
            names: [
                'version',
                'ip'
            ],
            format: 'IN IP%d %s'
        }
    ],
    b: [
        {
            // b=AS:4000
            push: 'bandwidth',
            reg: /^(TIAS|AS|CT|RR|RS):(\d*)/,
            names: [
                'type',
                'limit'
            ],
            format: '%s:%s'
        }
    ],
    m: [
        {
            // m=video 51744 RTP/AVP 126 97 98 34 31
            // NB: special - pushes to session
            // TODO: rtp/fmtp should be filtered by the payloads found here?
            reg: /^(\w*) (\d*) ([\w/]*)(?: (.*))?/,
            names: [
                'type',
                'port',
                'protocol',
                'payloads'
            ],
            format: '%s %d %s %s'
        }
    ],
    a: [
        {
            // a=rtpmap:110 opus/48000/2
            push: 'rtp',
            reg: /^rtpmap:(\d*) ([\w\-.]*)(?:\s*\/(\d*)(?:\s*\/(\S*))?)?/,
            names: [
                'payload',
                'codec',
                'rate',
                'encoding'
            ],
            format: function(o) {
                return o.encoding ? 'rtpmap:%d %s/%s/%s' : o.rate ? 'rtpmap:%d %s/%s' : 'rtpmap:%d %s';
            }
        },
        {
            // a=fmtp:108 profile-level-id=24;object=23;bitrate=64000
            // a=fmtp:111 minptime=10; useinbandfec=1
            push: 'fmtp',
            reg: /^fmtp:(\d*) ([\S| ]*)/,
            names: [
                'payload',
                'config'
            ],
            format: 'fmtp:%d %s'
        },
        {
            // a=control:streamid=0
            name: 'control',
            reg: /^control:(.*)/,
            format: 'control:%s'
        },
        {
            // a=rtcp:65179 IN IP4 193.84.77.194
            name: 'rtcp',
            reg: /^rtcp:(\d*)(?: (\S*) IP(\d) (\S*))?/,
            names: [
                'port',
                'netType',
                'ipVer',
                'address'
            ],
            format: function(o) {
                return o.address != null ? 'rtcp:%d %s IP%d %s' : 'rtcp:%d';
            }
        },
        {
            // a=rtcp-fb:98 trr-int 100
            push: 'rtcpFbTrrInt',
            reg: /^rtcp-fb:(\*|\d*) trr-int (\d*)/,
            names: [
                'payload',
                'value'
            ],
            format: 'rtcp-fb:%s trr-int %d'
        },
        {
            // a=rtcp-fb:98 nack rpsi
            push: 'rtcpFb',
            reg: /^rtcp-fb:(\*|\d*) ([\w-_]*)(?: ([\w-_]*))?/,
            names: [
                'payload',
                'type',
                'subtype'
            ],
            format: function(o) {
                return o.subtype != null ? 'rtcp-fb:%s %s %s' : 'rtcp-fb:%s %s';
            }
        },
        {
            // a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
            // a=extmap:1/recvonly URI-gps-string
            // a=extmap:3 urn:ietf:params:rtp-hdrext:encrypt urn:ietf:params:rtp-hdrext:smpte-tc 25@600/24
            push: 'ext',
            reg: /^extmap:(\d+)(?:\/(\w+))?(?: (urn:ietf:params:rtp-hdrext:encrypt))? (\S*)(?: (\S*))?/,
            names: [
                'value',
                'direction',
                'encrypt-uri',
                'uri',
                'config'
            ],
            format: function(o) {
                return 'extmap:%d' + (o.direction ? '/%s' : '%v') + (o['encrypt-uri'] ? ' %s' : '%v') + ' %s' + (o.config ? ' %s' : '');
            }
        },
        {
            // a=extmap-allow-mixed
            name: 'extmapAllowMixed',
            reg: /^(extmap-allow-mixed)/
        },
        {
            // a=crypto:1 AES_CM_128_HMAC_SHA1_80 inline:PS1uQCVeeCFCanVmcjkpPywjNWhcYD0mXXtxaVBR|2^20|1:32
            push: 'crypto',
            reg: /^crypto:(\d*) ([\w_]*) (\S*)(?: (\S*))?/,
            names: [
                'id',
                'suite',
                'config',
                'sessionConfig'
            ],
            format: function(o) {
                return o.sessionConfig != null ? 'crypto:%d %s %s %s' : 'crypto:%d %s %s';
            }
        },
        {
            // a=setup:actpass
            name: 'setup',
            reg: /^setup:(\w*)/,
            format: 'setup:%s'
        },
        {
            // a=connection:new
            name: 'connectionType',
            reg: /^connection:(new|existing)/,
            format: 'connection:%s'
        },
        {
            // a=mid:1
            name: 'mid',
            reg: /^mid:([^\s]*)/,
            format: 'mid:%s'
        },
        {
            // a=msid:0c8b064d-d807-43b4-b434-f92a889d8587 98178685-d409-46e0-8e16-7ef0db0db64a
            name: 'msid',
            reg: /^msid:(.*)/,
            format: 'msid:%s'
        },
        {
            // a=ptime:20
            name: 'ptime',
            reg: /^ptime:(\d*(?:\.\d*)*)/,
            format: 'ptime:%d'
        },
        {
            // a=maxptime:60
            name: 'maxptime',
            reg: /^maxptime:(\d*(?:\.\d*)*)/,
            format: 'maxptime:%d'
        },
        {
            // a=sendrecv
            name: 'direction',
            reg: /^(sendrecv|recvonly|sendonly|inactive)/
        },
        {
            // a=ice-lite
            name: 'icelite',
            reg: /^(ice-lite)/
        },
        {
            // a=ice-ufrag:F7gI
            name: 'iceUfrag',
            reg: /^ice-ufrag:(\S*)/,
            format: 'ice-ufrag:%s'
        },
        {
            // a=ice-pwd:x9cml/YzichV2+XlhiMu8g
            name: 'icePwd',
            reg: /^ice-pwd:(\S*)/,
            format: 'ice-pwd:%s'
        },
        {
            // a=fingerprint:SHA-1 00:11:22:33:44:55:66:77:88:99:AA:BB:CC:DD:EE:FF:00:11:22:33
            name: 'fingerprint',
            reg: /^fingerprint:(\S*) (\S*)/,
            names: [
                'type',
                'hash'
            ],
            format: 'fingerprint:%s %s'
        },
        {
            // a=candidate:0 1 UDP 2113667327 203.0.113.1 54400 typ host
            // a=candidate:1162875081 1 udp 2113937151 192.168.34.75 60017 typ host generation 0 network-id 3 network-cost 10
            // a=candidate:3289912957 2 udp 1845501695 193.84.77.194 60017 typ srflx raddr 192.168.34.75 rport 60017 generation 0 network-id 3 network-cost 10
            // a=candidate:229815620 1 tcp 1518280447 192.168.150.19 60017 typ host tcptype active generation 0 network-id 3 network-cost 10
            // a=candidate:3289912957 2 tcp 1845501695 193.84.77.194 60017 typ srflx raddr 192.168.34.75 rport 60017 tcptype passive generation 0 network-id 3 network-cost 10
            push: 'candidates',
            reg: /^candidate:(\S*) (\d*) (\S*) (\d*) (\S*) (\d*) typ (\S*)(?: raddr (\S*) rport (\d*))?(?: tcptype (\S*))?(?: generation (\d*))?(?: network-id (\d*))?(?: network-cost (\d*))?/,
            names: [
                'foundation',
                'component',
                'transport',
                'priority',
                'ip',
                'port',
                'type',
                'raddr',
                'rport',
                'tcptype',
                'generation',
                'network-id',
                'network-cost'
            ],
            format: function(o) {
                var str = 'candidate:%s %d %s %d %s %d typ %s';
                str += o.raddr != null ? ' raddr %s rport %d' : '%v%v';
                // NB: candidate has three optional chunks, so %void middles one if it's missing
                str += o.tcptype != null ? ' tcptype %s' : '%v';
                if (o.generation != null) str += ' generation %d';
                str += o['network-id'] != null ? ' network-id %d' : '%v';
                str += o['network-cost'] != null ? ' network-cost %d' : '%v';
                return str;
            }
        },
        {
            // a=end-of-candidates (keep after the candidates line for readability)
            name: 'endOfCandidates',
            reg: /^(end-of-candidates)/
        },
        {
            // a=remote-candidates:1 203.0.113.1 54400 2 203.0.113.1 54401 ...
            name: 'remoteCandidates',
            reg: /^remote-candidates:(.*)/,
            format: 'remote-candidates:%s'
        },
        {
            // a=ice-options:google-ice
            name: 'iceOptions',
            reg: /^ice-options:(\S*)/,
            format: 'ice-options:%s'
        },
        {
            // a=ssrc:2566107569 cname:t9YU8M1UxTF8Y1A1
            push: 'ssrcs',
            reg: /^ssrc:(\d*) ([\w_-]*)(?::(.*))?/,
            names: [
                'id',
                'attribute',
                'value'
            ],
            format: function(o) {
                var str = 'ssrc:%d';
                if (o.attribute != null) {
                    str += ' %s';
                    if (o.value != null) str += ':%s';
                }
                return str;
            }
        },
        {
            // a=ssrc-group:FEC 1 2
            // a=ssrc-group:FEC-FR 3004364195 1080772241
            push: 'ssrcGroups',
            // token-char = %x21 / %x23-27 / %x2A-2B / %x2D-2E / %x30-39 / %x41-5A / %x5E-7E
            reg: /^ssrc-group:([\x21\x23\x24\x25\x26\x27\x2A\x2B\x2D\x2E\w]*) (.*)/,
            names: [
                'semantics',
                'ssrcs'
            ],
            format: 'ssrc-group:%s %s'
        },
        {
            // a=msid-semantic: WMS Jvlam5X3SX1OP6pn20zWogvaKJz5Hjf9OnlV
            name: 'msidSemantic',
            reg: /^msid-semantic:\s?(\w*) (\S*)/,
            names: [
                'semantic',
                'token'
            ],
            format: 'msid-semantic: %s %s' // space after ':' is not accidental
        },
        {
            // a=group:BUNDLE audio video
            push: 'groups',
            reg: /^group:(\w*) (.*)/,
            names: [
                'type',
                'mids'
            ],
            format: 'group:%s %s'
        },
        {
            // a=rtcp-mux
            name: 'rtcpMux',
            reg: /^(rtcp-mux)/
        },
        {
            // a=rtcp-rsize
            name: 'rtcpRsize',
            reg: /^(rtcp-rsize)/
        },
        {
            // a=sctpmap:5000 webrtc-datachannel 1024
            name: 'sctpmap',
            reg: /^sctpmap:([\w_/]*) (\S*)(?: (\S*))?/,
            names: [
                'sctpmapNumber',
                'app',
                'maxMessageSize'
            ],
            format: function(o) {
                return o.maxMessageSize != null ? 'sctpmap:%s %s %s' : 'sctpmap:%s %s';
            }
        },
        {
            // a=x-google-flag:conference
            name: 'xGoogleFlag',
            reg: /^x-google-flag:([^\s]*)/,
            format: 'x-google-flag:%s'
        },
        {
            // a=rid:1 send max-width=1280;max-height=720;max-fps=30;depend=0
            push: 'rids',
            reg: /^rid:([\d\w]+) (\w+)(?: ([\S| ]*))?/,
            names: [
                'id',
                'direction',
                'params'
            ],
            format: function(o) {
                return o.params ? 'rid:%s %s %s' : 'rid:%s %s';
            }
        },
        {
            // a=imageattr:97 send [x=800,y=640,sar=1.1,q=0.6] [x=480,y=320] recv [x=330,y=250]
            // a=imageattr:* send [x=800,y=640] recv *
            // a=imageattr:100 recv [x=320,y=240]
            push: 'imageattrs',
            reg: new RegExp(// a=imageattr:97
            "^imageattr:(\\d+|\\*)[\\s\\t]+(send|recv)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*)(?:[\\s\\t]+(recv|send)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*))?"),
            names: [
                'pt',
                'dir1',
                'attrs1',
                'dir2',
                'attrs2'
            ],
            format: function(o) {
                return 'imageattr:%s %s %s' + (o.dir2 ? ' %s %s' : '');
            }
        },
        {
            // a=simulcast:send 1,2,3;~4,~5 recv 6;~7,~8
            // a=simulcast:recv 1;4,5 send 6;7
            name: 'simulcast',
            reg: new RegExp(// a=simulcast:
            "^simulcast:(send|recv) ([a-zA-Z0-9\\-_~;,]+)(?:\\s?(send|recv) ([a-zA-Z0-9\\-_~;,]+))?$"),
            names: [
                'dir1',
                'list1',
                'dir2',
                'list2'
            ],
            format: function(o) {
                return 'simulcast:%s %s' + (o.dir2 ? ' %s %s' : '');
            }
        },
        {
            // old simulcast draft 03 (implemented by Firefox)
            //   https://tools.ietf.org/html/draft-ietf-mmusic-sdp-simulcast-03
            // a=simulcast: recv pt=97;98 send pt=97
            // a=simulcast: send rid=5;6;7 paused=6,7
            name: 'simulcast_03',
            reg: /^simulcast:[\s\t]+([\S+\s\t]+)$/,
            names: [
                'value'
            ],
            format: 'simulcast: %s'
        },
        {
            // a=framerate:25
            // a=framerate:29.97
            name: 'framerate',
            reg: /^framerate:(\d+(?:$|\.\d+))/,
            format: 'framerate:%s'
        },
        {
            // RFC4570
            // a=source-filter: incl IN IP4 239.5.2.31 10.1.15.5
            name: 'sourceFilter',
            reg: /^source-filter: *(excl|incl) (\S*) (IP4|IP6|\*) (\S*) (.*)/,
            names: [
                'filterMode',
                'netType',
                'addressTypes',
                'destAddress',
                'srcList'
            ],
            format: 'source-filter: %s %s %s %s %s'
        },
        {
            // a=bundle-only
            name: 'bundleOnly',
            reg: /^(bundle-only)/
        },
        {
            // a=label:1
            name: 'label',
            reg: /^label:(.+)/,
            format: 'label:%s'
        },
        {
            // RFC version 26 for SCTP over DTLS
            // https://tools.ietf.org/html/draft-ietf-mmusic-sctp-sdp-26#section-5
            name: 'sctpPort',
            reg: /^sctp-port:(\d+)$/,
            format: 'sctp-port:%s'
        },
        {
            // RFC version 26 for SCTP over DTLS
            // https://tools.ietf.org/html/draft-ietf-mmusic-sctp-sdp-26#section-6
            name: 'maxMessageSize',
            reg: /^max-message-size:(\d+)$/,
            format: 'max-message-size:%s'
        },
        {
            // RFC7273
            // a=ts-refclk:ptp=IEEE1588-2008:39-A7-94-FF-FE-07-CB-D0:37
            push: 'tsRefClocks',
            reg: /^ts-refclk:([^\s=]*)(?:=(\S*))?/,
            names: [
                'clksrc',
                'clksrcExt'
            ],
            format: function(o) {
                return 'ts-refclk:%s' + (o.clksrcExt != null ? '=%s' : '');
            }
        },
        {
            // RFC7273
            // a=mediaclk:direct=963214424
            name: 'mediaClk',
            reg: /^mediaclk:(?:id=(\S*))? *([^\s=]*)(?:=(\S*))?(?: *rate=(\d+)\/(\d+))?/,
            names: [
                'id',
                'mediaClockName',
                'mediaClockValue',
                'rateNumerator',
                'rateDenominator'
            ],
            format: function(o) {
                var str = 'mediaclk:';
                str += o.id != null ? 'id=%s %s' : '%v%s';
                str += o.mediaClockValue != null ? '=%s' : '';
                str += o.rateNumerator != null ? ' rate=%s' : '';
                str += o.rateDenominator != null ? '/%s' : '';
                return str;
            }
        },
        {
            // a=keywds:keywords
            name: 'keywords',
            reg: /^keywds:(.+)$/,
            format: 'keywds:%s'
        },
        {
            // a=content:main
            name: 'content',
            reg: /^content:(.+)/,
            format: 'content:%s'
        },
        // BFCP https://tools.ietf.org/html/rfc4583
        {
            // a=floorctrl:c-s
            name: 'bfcpFloorCtrl',
            reg: /^floorctrl:(c-only|s-only|c-s)/,
            format: 'floorctrl:%s'
        },
        {
            // a=confid:1
            name: 'bfcpConfId',
            reg: /^confid:(\d+)/,
            format: 'confid:%s'
        },
        {
            // a=userid:1
            name: 'bfcpUserId',
            reg: /^userid:(\d+)/,
            format: 'userid:%s'
        },
        {
            // a=floorid:1
            name: 'bfcpFloorId',
            reg: /^floorid:(.+) (?:m-stream|mstrm):(.+)/,
            names: [
                'id',
                'mStream'
            ],
            format: 'floorid:%s mstrm:%s'
        },
        {
            // any a= that we don't understand is kept verbatim on media.invalid
            push: 'invalid',
            names: [
                'value'
            ]
        }
    ]
};
// set sensible defaults to avoid polluting the grammar with boring details
Object.keys($71fab0475308d224$var$grammar).forEach(function(key) {
    var objs = $71fab0475308d224$var$grammar[key];
    objs.forEach(function(obj) {
        if (!obj.reg) obj.reg = /(.*)/;
        if (!obj.format) obj.format = '%s';
    });
});


var $503e7b8ecd4140d2$var$validLine = RegExp.prototype.test.bind(/^([a-z])=(.*)/);
$503e7b8ecd4140d2$export$98e6a39c04603d36 = function(sdp) {
    var session = {}, media = [], location = session; // points at where properties go under (one of the above)
    // parse lines we understand
    sdp.split(/(\r\n|\r|\n)/).filter($503e7b8ecd4140d2$var$validLine).forEach(function(l) {
        var type = l[0];
        var content = l.slice(2);
        if (type === 'm') {
            media.push({
                rtp: [],
                fmtp: []
            });
            location = media[media.length - 1]; // point at latest media line
        }
        for(var j = 0; j < ($71fab0475308d224$exports[type] || []).length; j += 1){
            var obj = $71fab0475308d224$exports[type][j];
            if (obj.reg.test(content)) return $503e7b8ecd4140d2$var$parseReg(obj, location, content);
        }
    });
    session.media = media; // link it up
    return session;
};
var $503e7b8ecd4140d2$var$paramReducer = function(acc, expr) {
    var s = expr.split(/=(.+)/, 2);
    if (s.length === 2) acc[s[0]] = $503e7b8ecd4140d2$var$toIntIfInt(s[1]);
    else if (s.length === 1 && expr.length > 1) acc[s[0]] = undefined;
    return acc;
};
$503e7b8ecd4140d2$export$ef804106d1571703 = function(str) {
    return str.split(/;\s?/).reduce($503e7b8ecd4140d2$var$paramReducer, {});
};
$503e7b8ecd4140d2$export$dfeb1045bffe1ff8 = $503e7b8ecd4140d2$export$ef804106d1571703;
$503e7b8ecd4140d2$export$326874e595fb968b = function(str) {
    return str.toString().split(' ').map(Number);
};
$503e7b8ecd4140d2$export$705b3971a35c200 = function(str) {
    var candidates = [];
    var parts = str.split(' ').map($503e7b8ecd4140d2$var$toIntIfInt);
    for(var i = 0; i < parts.length; i += 3)candidates.push({
        component: parts[i],
        ip: parts[i + 1],
        port: parts[i + 2]
    });
    return candidates;
};
$503e7b8ecd4140d2$export$1ca60456d3287987 = function(str) {
    return str.split(' ').map(function(item) {
        return item.substring(1, item.length - 1).split(',').reduce($503e7b8ecd4140d2$var$paramReducer, {});
    });
};
$503e7b8ecd4140d2$export$c61d0126da4c310f = function(str) {
    return str.split(';').map(function(stream) {
        return stream.split(',').map(function(format) {
            var scid, paused = false;
            if (format[0] !== '~') scid = $503e7b8ecd4140d2$var$toIntIfInt(format);
            else {
                scid = $503e7b8ecd4140d2$var$toIntIfInt(format.substring(1, format.length));
                paused = true;
            }
            return {
                scid: scid,
                paused: paused
            };
        });
    });
};


var $3e77024a51de1bbe$exports = {};

// customized util.format - discards excess arguments and can void middle ones
var $3e77024a51de1bbe$var$formatRegExp = /%[sdv%]/g;
var $3e77024a51de1bbe$var$format = function(formatStr) {
    var i = 1;
    var args = arguments;
    var len = args.length;
    return formatStr.replace($3e77024a51de1bbe$var$formatRegExp, function(x) {
        if (i >= len) return x; // missing argument
        var arg = args[i];
        i += 1;
        switch(x){
            case '%%':
                return '%';
            case '%s':
                return String(arg);
            case '%d':
                return Number(arg);
            case '%v':
                return '';
        }
    });
// NB: we discard excess arguments - they are typically undefined from makeLine
};
var $3e77024a51de1bbe$var$makeLine = function(type, obj, location) {
    var str = obj.format instanceof Function ? obj.format(obj.push ? location : location[obj.name]) : obj.format;
    var args = [
        type + '=' + str
    ];
    if (obj.names) for(var i = 0; i < obj.names.length; i += 1){
        var n = obj.names[i];
        if (obj.name) args.push(location[obj.name][n]);
        else args.push(location[obj.names[i]]);
    }
    else args.push(location[obj.name]);
    return $3e77024a51de1bbe$var$format.apply(null, args);
};
// RFC specified order
// TODO: extend this with all the rest
var $3e77024a51de1bbe$var$defaultOuterOrder = [
    'v',
    'o',
    's',
    'i',
    'u',
    'e',
    'p',
    'c',
    'b',
    't',
    'r',
    'z',
    'a'
];
var $3e77024a51de1bbe$var$defaultInnerOrder = [
    'i',
    'c',
    'b',
    'a'
];
$3e77024a51de1bbe$exports = function(session, opts) {
    opts = opts || {};
    // ensure certain properties exist
    if (session.version == null) session.version = 0; // 'v=0' must be there (only defined version atm)
    if (session.name == null) session.name = ' '; // 's= ' must be there if no meaningful name set
    session.media.forEach(function(mLine) {
        if (mLine.payloads == null) mLine.payloads = '';
    });
    var outerOrder = opts.outerOrder || $3e77024a51de1bbe$var$defaultOuterOrder;
    var innerOrder = opts.innerOrder || $3e77024a51de1bbe$var$defaultInnerOrder;
    var sdp = [];
    // loop through outerOrder for matching properties on session
    outerOrder.forEach(function(type) {
        $71fab0475308d224$exports[type].forEach(function(obj) {
            if (obj.name in session && session[obj.name] != null) sdp.push($3e77024a51de1bbe$var$makeLine(type, obj, session));
            else if (obj.push in session && session[obj.push] != null) session[obj.push].forEach(function(el) {
                sdp.push($3e77024a51de1bbe$var$makeLine(type, obj, el));
            });
        });
    });
    // then for each media line, follow the innerOrder
    session.media.forEach(function(mLine) {
        sdp.push($3e77024a51de1bbe$var$makeLine('m', $71fab0475308d224$exports.m[0], mLine));
        innerOrder.forEach(function(type) {
            $71fab0475308d224$exports[type].forEach(function(obj) {
                if (obj.name in mLine && mLine[obj.name] != null) sdp.push($3e77024a51de1bbe$var$makeLine(type, obj, mLine));
                else if (obj.push in mLine && mLine[obj.push] != null) mLine[obj.push].forEach(function(el) {
                    sdp.push($3e77024a51de1bbe$var$makeLine(type, obj, el));
                });
            });
        });
    });
    return sdp.join('\r\n') + '\r\n';
};



$178bb82ca124d09b$export$b3a6900b22e4209 = $71fab0475308d224$exports;
$178bb82ca124d09b$export$68d8715fc104d294 = $3e77024a51de1bbe$exports;
$178bb82ca124d09b$export$98e6a39c04603d36 = $503e7b8ecd4140d2$export$98e6a39c04603d36;
$178bb82ca124d09b$export$ef804106d1571703 = $503e7b8ecd4140d2$export$ef804106d1571703;
$178bb82ca124d09b$export$dfeb1045bffe1ff8 = $503e7b8ecd4140d2$export$dfeb1045bffe1ff8; // Alias of parseParams().
$178bb82ca124d09b$export$326874e595fb968b = $503e7b8ecd4140d2$export$326874e595fb968b;
$178bb82ca124d09b$export$705b3971a35c200 = $503e7b8ecd4140d2$export$705b3971a35c200;
$178bb82ca124d09b$export$1ca60456d3287987 = $503e7b8ecd4140d2$export$1ca60456d3287987;
$178bb82ca124d09b$export$c61d0126da4c310f = $503e7b8ecd4140d2$export$c61d0126da4c310f;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};




function $c1aa42b0603892d6$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}




function $ebe567a061bc80f6$export$128a15b65d1b6041(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}


var $f587043ffd615a90$export$c9648b76fd580c34 = (0, $ebe567a061bc80f6$export$128a15b65d1b6041)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join('\n  ') : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
    };
});


function $2b94c03d07e501cc$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}


var $8343668acd7c4a9b$export$f55210826850c514 = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $f587043ffd615a90$export$c9648b76fd580c34) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $8343668acd7c4a9b$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $f587043ffd615a90$export$c9648b76fd580c34)) errors = (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(errors)), (0, $5c96a02c592fcff1$export$8d051b38c9118094)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $f587043ffd615a90$export$c9648b76fd580c34)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $8343668acd7c4a9b$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $8343668acd7c4a9b$export$610f9c3ca1a38dd8 = $8343668acd7c4a9b$export$f55210826850c514.EMPTY;
function $8343668acd7c4a9b$export$4f9221cbada3c4fc(value) {
    return value instanceof $8343668acd7c4a9b$export$f55210826850c514 || value && 'closed' in value && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.remove) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.add) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.unsubscribe);
}
function $8343668acd7c4a9b$var$execFinalizer(finalizer) {
    if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}


var $ca336efb1b4fb564$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};




var $c07b5bfa3b9d4401$export$365aa6bd3c788e3d = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $c07b5bfa3b9d4401$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(args)));
        return setTimeout.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $c07b5bfa3b9d4401$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};


function $18eb28ff53cc4943$export$ebf645db02d3e99f(err) {
    (0, $c07b5bfa3b9d4401$export$365aa6bd3c788e3d).setTimeout(function() {
        var onUnhandledError = (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}


function $528e75db69787807$export$8793edee2d425525() {}


var $0ba077a4cdfd9739$export$b7f97edb34bc1f87 = function() {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3('C', undefined, undefined);
}();
function $0ba077a4cdfd9739$export$dd472c3d8fe5a85a(error) {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3('E', undefined, error);
}
function $0ba077a4cdfd9739$export$ff9346b0d1d30313(value) {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3('N', value, undefined);
}
function $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}




var $92213d3dd6a83b5d$var$context = null;
function $92213d3dd6a83b5d$export$d974811edc77eafa(cb) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$92213d3dd6a83b5d$var$context;
        if (isRoot) $92213d3dd6a83b5d$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $92213d3dd6a83b5d$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $92213d3dd6a83b5d$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $92213d3dd6a83b5d$export$3e205fbb5df021e0(err) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling && $92213d3dd6a83b5d$var$context) {
        $92213d3dd6a83b5d$var$context.errorThrown = true;
        $92213d3dd6a83b5d$var$context.error = err;
    }
}


var $cf8ce74b80455e9f$export$60959659b2c22881 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $8343668acd7c4a9b$export$4f9221cbada3c4fc)(destination)) destination.add(_this);
        } else _this.destination = $cf8ce74b80455e9f$export$88d395d20619a0af;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $cf8ce74b80455e9f$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$ff9346b0d1d30313)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$dd472c3d8fe5a85a)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$b7f97edb34bc1f87), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $8343668acd7c4a9b$export$f55210826850c514));
var $cf8ce74b80455e9f$var$_bind = Function.prototype.bind;
function $cf8ce74b80455e9f$var$bind(fn, thisArg) {
    return $cf8ce74b80455e9f$var$_bind.call(fn, thisArg);
}
var $cf8ce74b80455e9f$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
        else $cf8ce74b80455e9f$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $cf8ce74b80455e9f$export$94eeb6a328cab6c7 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $cf8ce74b80455e9f$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $cf8ce74b80455e9f$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $cf8ce74b80455e9f$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $cf8ce74b80455e9f$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($cf8ce74b80455e9f$export$60959659b2c22881);
function $cf8ce74b80455e9f$var$handleUnhandledError(error) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) (0, $92213d3dd6a83b5d$export$3e205fbb5df021e0)(error);
    else (0, $18eb28ff53cc4943$export$ebf645db02d3e99f)(error);
}
function $cf8ce74b80455e9f$var$defaultErrorHandler(err) {
    throw err;
}
function $cf8ce74b80455e9f$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).onStoppedNotification;
    onStoppedNotification && (0, $c07b5bfa3b9d4401$export$365aa6bd3c788e3d).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $cf8ce74b80455e9f$export$88d395d20619a0af = {
    closed: true,
    next: (0, $528e75db69787807$export$8793edee2d425525),
    error: $cf8ce74b80455e9f$var$defaultErrorHandler,
    complete: (0, $528e75db69787807$export$8793edee2d425525)
};



var $eaf29fccbded6ed3$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();


function $7569c528cdd9d182$export$f0954fd7d5368655(x) {
    return x;
}


function $0f1e8e2d1fe93adf$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $0f1e8e2d1fe93adf$export$71f88a61afaa14d7(fns);
}
function $0f1e8e2d1fe93adf$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $7569c528cdd9d182$export$f0954fd7d5368655;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}





var $4f562137a990678a$export$77cea355fa80b5f4 = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $4f562137a990678a$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)(observerOrNext, error, complete);
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $4f562137a990678a$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $eaf29fccbded6ed3$export$5ab46cbf6120b33a] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $0f1e8e2d1fe93adf$export$71f88a61afaa14d7)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $4f562137a990678a$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $4f562137a990678a$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $4f562137a990678a$var$isObserver(value) {
    return value && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.next) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.error) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.complete);
}
function $4f562137a990678a$var$isSubscriber(value) {
    return value && value instanceof (0, $cf8ce74b80455e9f$export$60959659b2c22881) || $4f562137a990678a$var$isObserver(value) && (0, $8343668acd7c4a9b$export$4f9221cbada3c4fc)(value);
}




var $43504509ae7aa03d$export$f708eee25634bc80 = (0, $ebe567a061bc80f6$export$128a15b65d1b6041)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = 'ObjectUnsubscribedError';
        this.message = 'object unsubscribed';
    };
});




var $2d63f5ffe6ca8602$export$b6bbab5a9b109038 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new $2d63f5ffe6ca8602$export$155189cde295587d(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, $43504509ae7aa03d$export$f708eee25634bc80)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, $8343668acd7c4a9b$export$610f9c3ca1a38dd8;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, $8343668acd7c4a9b$export$f55210826850c514)(function() {
            _this.currentObservers = null;
            (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, $4f562137a990678a$export$77cea355fa80b5f4)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $2d63f5ffe6ca8602$export$155189cde295587d(destination, source);
    };
    return Subject;
}((0, $4f562137a990678a$export$77cea355fa80b5f4));
var $2d63f5ffe6ca8602$export$155189cde295587d = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, $8343668acd7c4a9b$export$610f9c3ca1a38dd8);
    };
    return AnonymousSubject;
}($2d63f5ffe6ca8602$export$b6bbab5a9b109038);


var $7aced346698c521d$export$cc3d42e6b2b9cf8b = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: false,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        !subscription.closed && subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _value = _a._value;
        if (hasError) throw thrownError;
        this._throwIfClosed();
        return _value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}((0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038));


var $93f4d2c1cc93ee63$var$isArray = Array.isArray;
var $93f4d2c1cc93ee63$var$getPrototypeOf = Object.getPrototypeOf, $93f4d2c1cc93ee63$var$objectProto = Object.prototype, $93f4d2c1cc93ee63$var$getKeys = Object.keys;
function $93f4d2c1cc93ee63$export$8871b3799a14360f(args) {
    if (args.length === 1) {
        var first_1 = args[0];
        if ($93f4d2c1cc93ee63$var$isArray(first_1)) return {
            args: first_1,
            keys: null
        };
        if ($93f4d2c1cc93ee63$var$isPOJO(first_1)) {
            var keys = $93f4d2c1cc93ee63$var$getKeys(first_1);
            return {
                args: keys.map(function(key) {
                    return first_1[key];
                }),
                keys: keys
            };
        }
    }
    return {
        args: args,
        keys: null
    };
}
function $93f4d2c1cc93ee63$var$isPOJO(obj) {
    return obj && typeof obj === 'object' && $93f4d2c1cc93ee63$var$getPrototypeOf(obj) === $93f4d2c1cc93ee63$var$objectProto;
}



var $8821cb8787de9fb5$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === 'number' && typeof x !== 'function';
};



function $9dcf7896928e75dd$export$4369c812aac99591(value) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value === null || value === void 0 ? void 0 : value.then);
}





function $0539b51af1903d0a$export$48c0cddbc99c45c2(input) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(input[0, $eaf29fccbded6ed3$export$5ab46cbf6120b33a]);
}



function $7c74d6a5e2273447$export$edb10ab8dd75a915(obj) {
    return Symbol.asyncIterator && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}


function $d63b3f5b704e6de4$export$7cbe71b9fa263484(input) {
    return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}


function $0b89b4d4fb8bd3fd$export$aa9956be4ae4fe8() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) return '@@iterator';
    return Symbol.iterator;
}
var $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d = $0b89b4d4fb8bd3fd$export$aa9956be4ae4fe8();



function $b8a13650b96f19ab$export$9652023d9040757(input) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(input === null || input === void 0 ? void 0 : input[0, $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d]);
}




function $54b99b9095e84ce4$export$cf4785e597badab3(readableStream) {
    return (0, $5c96a02c592fcff1$export$e427f37a30a4de9b)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        (0, $5c96a02c592fcff1$export$10c90e4f7922046c)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $5c96a02c592fcff1$export$10c90e4f7922046c)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0, $5c96a02c592fcff1$export$10c90e4f7922046c)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function $54b99b9095e84ce4$export$c088ffafdba7405f(obj) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}





function $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910(input) {
    if (input instanceof (0, $4f562137a990678a$export$77cea355fa80b5f4)) return input;
    if (input != null) {
        if ((0, $0539b51af1903d0a$export$48c0cddbc99c45c2)(input)) return $1dc2e2cd8f7c5351$export$aa3d41784b3267fa(input);
        if ((0, $8821cb8787de9fb5$export$1e2f57719e155213)(input)) return $1dc2e2cd8f7c5351$export$4cb2acdbcda2c253(input);
        if ((0, $9dcf7896928e75dd$export$4369c812aac99591)(input)) return $1dc2e2cd8f7c5351$export$60f45028237c39d1(input);
        if ((0, $7c74d6a5e2273447$export$edb10ab8dd75a915)(input)) return $1dc2e2cd8f7c5351$export$e073fccf36d78cc1(input);
        if ((0, $b8a13650b96f19ab$export$9652023d9040757)(input)) return $1dc2e2cd8f7c5351$export$dcccc29c315dd646(input);
        if ((0, $54b99b9095e84ce4$export$c088ffafdba7405f)(input)) return $1dc2e2cd8f7c5351$export$b2dcb11d46e7a4ad(input);
    }
    throw (0, $d63b3f5b704e6de4$export$7cbe71b9fa263484)(input);
}
function $1dc2e2cd8f7c5351$export$aa3d41784b3267fa(obj) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var obs = obj[0, $eaf29fccbded6ed3$export$5ab46cbf6120b33a]();
        if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError('Provided object does not correctly implement Symbol.observable');
    });
}
function $1dc2e2cd8f7c5351$export$4cb2acdbcda2c253(array) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function $1dc2e2cd8f7c5351$export$60f45028237c39d1(promise) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, $18eb28ff53cc4943$export$ebf645db02d3e99f));
    });
}
function $1dc2e2cd8f7c5351$export$dcccc29c315dd646(iterable) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function $1dc2e2cd8f7c5351$export$e073fccf36d78cc1(asyncIterable) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        $1dc2e2cd8f7c5351$var$process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function $1dc2e2cd8f7c5351$export$b2dcb11d46e7a4ad(readableStream) {
    return $1dc2e2cd8f7c5351$export$e073fccf36d78cc1((0, $54b99b9095e84ce4$export$cf4785e597badab3)(readableStream));
}
function $1dc2e2cd8f7c5351$var$process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0, $5c96a02c592fcff1$export$e3b29a3d6162315f)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}


function $3525e15e439f8b93$export$a2b7447487315232(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}



function $992c4a42843eb1d0$export$ebec8610810318c5(source) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(source === null || source === void 0 ? void 0 : source.lift);
}
function $992c4a42843eb1d0$export$871731df685d7753(init) {
    return function(source) {
        if ($992c4a42843eb1d0$export$ebec8610810318c5(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError('Unable to lift unknown Observable type');
    };
}




function $3868f035248205c1$export$b9e075132cc6937f(destination, onNext, onComplete, onError, onFinalize) {
    return new $3868f035248205c1$export$8fbbf0c4d80268e5(destination, onNext, onComplete, onError, onFinalize);
}
var $3868f035248205c1$export$8fbbf0c4d80268e5 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, $cf8ce74b80455e9f$export$60959659b2c22881));


function $25136415cad576bc$export$9007f49c319d1ac7(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            return (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
}



function $daf4fd612cb884aa$export$1eb44d8f5f64733b(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
}


function $e3a1d71c442b5de9$export$ed8bd553a12b6a30(input, scheduler) {
    return (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(input).pipe((0, $daf4fd612cb884aa$export$1eb44d8f5f64733b)(scheduler), (0, $25136415cad576bc$export$9007f49c319d1ac7)(scheduler));
}





function $7ea29ae5d684fb04$export$fc9afd948577f0a8(input, scheduler) {
    return (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(input).pipe((0, $daf4fd612cb884aa$export$1eb44d8f5f64733b)(scheduler), (0, $25136415cad576bc$export$9007f49c319d1ac7)(scheduler));
}



function $0ce5b91768be0a6d$export$b34673931371729a(input, scheduler) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) subscriber.complete();
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) this.schedule();
            }
        });
    });
}






function $3a22bf76b9b6de63$export$2b75c58ab9b5b766(input, scheduler) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var iterator;
        (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
            iterator = input[0, $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d]();
            (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else subscriber.next(value);
            }, 0, true);
        });
        return function() {
            return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
    });
}




function $d2627b52a3f1ff1b$export$7c7f0979b56a32f3(input, scheduler) {
    if (!input) throw new Error('Iterable cannot be null');
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) subscriber.complete();
                    else subscriber.next(result.value);
                });
            }, 0, true);
        });
    });
}











function $7999ea1c5b71ad25$export$3385251aeecad28a(input, scheduler) {
    return (0, $d2627b52a3f1ff1b$export$7c7f0979b56a32f3)((0, $54b99b9095e84ce4$export$cf4785e597badab3)(input), scheduler);
}


function $8f2bbfa9b5105688$export$49c44dfc2bb21d70(input, scheduler) {
    if (input != null) {
        if ((0, $0539b51af1903d0a$export$48c0cddbc99c45c2)(input)) return (0, $e3a1d71c442b5de9$export$ed8bd553a12b6a30)(input, scheduler);
        if ((0, $8821cb8787de9fb5$export$1e2f57719e155213)(input)) return (0, $0ce5b91768be0a6d$export$b34673931371729a)(input, scheduler);
        if ((0, $9dcf7896928e75dd$export$4369c812aac99591)(input)) return (0, $7ea29ae5d684fb04$export$fc9afd948577f0a8)(input, scheduler);
        if ((0, $7c74d6a5e2273447$export$edb10ab8dd75a915)(input)) return (0, $d2627b52a3f1ff1b$export$7c7f0979b56a32f3)(input, scheduler);
        if ((0, $b8a13650b96f19ab$export$9652023d9040757)(input)) return (0, $3a22bf76b9b6de63$export$2b75c58ab9b5b766)(input, scheduler);
        if ((0, $54b99b9095e84ce4$export$c088ffafdba7405f)(input)) return (0, $7999ea1c5b71ad25$export$3385251aeecad28a)(input, scheduler);
    }
    throw (0, $d63b3f5b704e6de4$export$7cbe71b9fa263484)(input);
}



function $2fe2b696577919a5$export$6788812c4e6611e6(input, scheduler) {
    return scheduler ? (0, $8f2bbfa9b5105688$export$49c44dfc2bb21d70)(input, scheduler) : (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(input);
}






function $9853a79d111e4e33$export$871de8747c9eaa88(project, thisArg) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}


var $e6cd63efe08c02de$var$isArray = Array.isArray;
function $e6cd63efe08c02de$var$callOrApply(fn, args) {
    return $e6cd63efe08c02de$var$isArray(args) ? fn.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(args))) : fn(args);
}
function $e6cd63efe08c02de$export$559affaa48f4288d(fn) {
    return (0, $9853a79d111e4e33$export$871de8747c9eaa88)(function(args) {
        return $e6cd63efe08c02de$var$callOrApply(fn, args);
    });
}




function $cd8e5ea142a386bd$export$187e35932e88c15c(value) {
    return value && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.schedule);
}


function $3b29c258456d9a89$var$last(arr) {
    return arr[arr.length - 1];
}
function $3b29c258456d9a89$export$9ae19b645239a61b(args) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)($3b29c258456d9a89$var$last(args)) ? args.pop() : undefined;
}
function $3b29c258456d9a89$export$29534b2f653ae592(args) {
    return (0, $cd8e5ea142a386bd$export$187e35932e88c15c)($3b29c258456d9a89$var$last(args)) ? args.pop() : undefined;
}
function $3b29c258456d9a89$export$3de14b735070dcd5(args, defaultValue) {
    return typeof $3b29c258456d9a89$var$last(args) === 'number' ? args.pop() : defaultValue;
}


function $00d6f9870244ce2a$export$79c7e160a7743efd(keys, values) {
    return keys.reduce(function(result, key, i) {
        return result[key] = values[i], result;
    }, {});
}




function $0e8b72f41887b114$export$77fa7d86f5204e8a() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $3b29c258456d9a89$export$29534b2f653ae592)(args);
    var resultSelector = (0, $3b29c258456d9a89$export$9ae19b645239a61b)(args);
    var _a = (0, $93f4d2c1cc93ee63$export$8871b3799a14360f)(args), observables = _a.args, keys = _a.keys;
    if (observables.length === 0) return (0, $2fe2b696577919a5$export$6788812c4e6611e6)([], scheduler);
    var result = new (0, $4f562137a990678a$export$77cea355fa80b5f4)($0e8b72f41887b114$export$f04dcfb475ed2128(observables, scheduler, keys ? function(values) {
        return (0, $00d6f9870244ce2a$export$79c7e160a7743efd)(keys, values);
    } : (0, $7569c528cdd9d182$export$f0954fd7d5368655)));
    return resultSelector ? result.pipe((0, $e6cd63efe08c02de$export$559affaa48f4288d)(resultSelector)) : result;
}
function $0e8b72f41887b114$export$f04dcfb475ed2128(observables, scheduler, valueTransform) {
    if (valueTransform === void 0) valueTransform = (0, $7569c528cdd9d182$export$f0954fd7d5368655);
    return function(subscriber) {
        $0e8b72f41887b114$var$maybeSchedule(scheduler, function() {
            var length = observables.length;
            var values = new Array(length);
            var active = length;
            var remainingFirstValues = length;
            var _loop_1 = function(i) {
                $0e8b72f41887b114$var$maybeSchedule(scheduler, function() {
                    var source = (0, $2fe2b696577919a5$export$6788812c4e6611e6)(observables[i], scheduler);
                    var hasFirstValue = false;
                    source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
                        values[i] = value;
                        if (!hasFirstValue) {
                            hasFirstValue = true;
                            remainingFirstValues--;
                        }
                        if (!remainingFirstValues) subscriber.next(valueTransform(values.slice()));
                    }, function() {
                        if (!--active) subscriber.complete();
                    }));
                }, subscriber);
            };
            for(var i = 0; i < length; i++)_loop_1(i);
        }, subscriber);
    };
}
function $0e8b72f41887b114$var$maybeSchedule(scheduler, execute, subscription) {
    if (scheduler) (0, $3525e15e439f8b93$export$a2b7447487315232)(subscription, scheduler, execute);
    else execute();
}







function $9cbbbba4f565a378$export$600918ebaa9e0a1b(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function() {
        if (isComplete && !buffer.length && !active) subscriber.complete();
    };
    var outerNext = function(value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(project(value, index++)).subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 || onBeforeNext(innerValue);
            if (expand) outerNext(innerValue);
            else subscriber.next(innerValue);
        }, function() {
            innerComplete = true;
        }, undefined, function() {
            if (innerComplete) try {
                active--;
                var _loop_1 = function() {
                    var bufferedValue = buffer.shift();
                    if (innerSubScheduler) (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, innerSubScheduler, function() {
                        return doInnerSub(bufferedValue);
                    });
                    else doInnerSub(bufferedValue);
                };
                while(buffer.length && active < concurrent)_loop_1();
                checkComplete();
            } catch (err) {
                subscriber.error(err);
            }
        }));
    };
    source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
    }));
    return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 || additionalFinalizer();
    };
}



function $46964ba1b403cbfc$export$6b9f6c0d32c093f9(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(resultSelector)) return $46964ba1b403cbfc$export$6b9f6c0d32c093f9(function(a, i) {
        return (0, $9853a79d111e4e33$export$871de8747c9eaa88)(function(b, ii) {
            return resultSelector(a, b, i, ii);
        })((0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(project(a, i)));
    }, concurrent);
    else if (typeof resultSelector === 'number') concurrent = resultSelector;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        return (0, $9cbbbba4f565a378$export$600918ebaa9e0a1b)(source, subscriber, project, concurrent);
    });
}



function $9ee54e147202c320$export$c28c8388be0ab31a(project, resultSelector) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(resultSelector) ? (0, $46964ba1b403cbfc$export$6b9f6c0d32c093f9)(project, resultSelector, 1) : (0, $46964ba1b403cbfc$export$6b9f6c0d32c093f9)(project, 1);
}




var $25237a26c7d2a6e0$export$e19cd5f9376f8cee = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}((0, $8343668acd7c4a9b$export$f55210826850c514));



var $7031d5c115ea3033$export$f0ca5e16f6f68711 = {
    setInterval: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $7031d5c115ea3033$export$f0ca5e16f6f68711.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) return delegate.setInterval.apply(delegate, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(args)));
        return setInterval.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(args)));
    },
    clearInterval: function(handle) {
        var delegate = $7031d5c115ea3033$export$f0ca5e16f6f68711.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
    },
    delegate: undefined
};



var $d97bc7fc19653fdc$export$b5369ffd7cb2211b = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.pending = true;
        this.delay = delay;
        this.id = (_a = this.id) !== null && _a !== void 0 ? _a : this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, _id, delay) {
        if (delay === void 0) delay = 0;
        return (0, $7031d5c115ea3033$export$f0ca5e16f6f68711).setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(_scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay != null && this.delay === delay && this.pending === false) return id;
        if (id != null) (0, $7031d5c115ea3033$export$f0ca5e16f6f68711).clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error('executing a cancelled action');
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, _delay) {
        var errored = false;
        var errorValue;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = e ? e : new Error('Scheduled action threw falsy error');
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype.unsubscribe = function() {
        if (!this.closed) {
            var _a = this, id = _a.id, scheduler = _a.scheduler;
            var actions = scheduler.actions;
            this.work = this.state = this.scheduler = null;
            this.pending = false;
            (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(actions, this);
            if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
            this.delay = null;
            _super.prototype.unsubscribe.call(this);
        }
    };
    return AsyncAction;
}((0, $25237a26c7d2a6e0$export$e19cd5f9376f8cee));



var $94bcb2181a19339b$export$c1895ea2d519a677 = {
    now: function() {
        return ($94bcb2181a19339b$export$c1895ea2d519a677.delegate || Date).now();
    },
    delegate: undefined
};


var $35afd13d3a3f6ae1$export$d3e54bb8584cda7c = function() {
    function Scheduler(schedulerActionCtor, now) {
        if (now === void 0) now = Scheduler.now;
        this.schedulerActionCtor = schedulerActionCtor;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.schedulerActionCtor(this, work).schedule(state, delay);
    };
    Scheduler.now = (0, $94bcb2181a19339b$export$c1895ea2d519a677).now;
    return Scheduler;
}();


var $5aa4ef89729a15e9$export$4114a3ec92faa3c6 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) now = (0, $35afd13d3a3f6ae1$export$d3e54bb8584cda7c).now;
        var _this = _super.call(this, SchedulerAction, now) || this;
        _this.actions = [];
        _this._active = false;
        return _this;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this._active) {
            actions.push(action);
            return;
        }
        var error;
        this._active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift());
        this._active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}((0, $35afd13d3a3f6ae1$export$d3e54bb8584cda7c));


var $2b2c2daf44a1044e$export$8d6b71a2b178fc32 = new (0, $5aa4ef89729a15e9$export$4114a3ec92faa3c6)((0, $d97bc7fc19653fdc$export$b5369ffd7cb2211b));
var $2b2c2daf44a1044e$export$12af436354f1a4f7 = $2b2c2daf44a1044e$export$8d6b71a2b178fc32;




function $64b486e22e2192ab$export$7843a4469d64c07e(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = (0, $2b2c2daf44a1044e$export$8d6b71a2b178fc32);
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var activeTask = null;
        var lastValue = null;
        var lastTime = null;
        var emit = function() {
            if (activeTask) {
                activeTask.unsubscribe();
                activeTask = null;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        };
        function emitWhenIdle() {
            var targetTime = lastTime + dueTime;
            var now = scheduler.now();
            if (now < targetTime) {
                activeTask = this.schedule(undefined, targetTime - now);
                subscriber.add(activeTask);
                return;
            }
            emit();
        }
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            lastValue = value;
            lastTime = scheduler.now();
            if (!activeTask) {
                activeTask = scheduler.schedule(emitWhenIdle, dueTime);
                subscriber.add(activeTask);
            }
        }, function() {
            emit();
            subscriber.complete();
        }, undefined, function() {
            lastValue = activeTask = null;
        }));
    });
}




function $6fb8b1c12553edae$export$779c5fb865a0172e(comparator, keySelector) {
    if (keySelector === void 0) keySelector = (0, $7569c528cdd9d182$export$f0954fd7d5368655);
    comparator = comparator !== null && comparator !== void 0 ? comparator : $6fb8b1c12553edae$var$defaultCompare;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var previousKey;
        var first = true;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            var currentKey = keySelector(value);
            if (first || !comparator(previousKey, currentKey)) {
                first = false;
                previousKey = currentKey;
                subscriber.next(value);
            }
        }));
    });
}
function $6fb8b1c12553edae$var$defaultCompare(a, b) {
    return a === b;
}


function $5b7702bd13db251d$export$571da16e28367bde(key, compare) {
    return (0, $6fb8b1c12553edae$export$779c5fb865a0172e)(function(x, y) {
        return compare ? compare(x[key], y[key]) : x[key] === y[key];
    });
}


var $6cabd83f99ce6113$export$78f6d1b1dbcda304 = (0, $ebe567a061bc80f6$export$128a15b65d1b6041)(function(_super) {
    return function EmptyErrorImpl() {
        _super(this);
        this.name = 'EmptyError';
        this.message = 'no elements in sequence';
    };
});



function $e61e581d31b1ea5f$export$400f9f949cef996c(source, config) {
    var hasConfig = typeof config === 'object';
    return new Promise(function(resolve, reject) {
        var subscriber = new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)({
            next: function(value) {
                resolve(value);
                subscriber.unsubscribe();
            },
            error: reject,
            complete: function() {
                if (hasConfig) resolve(config.defaultValue);
                else reject(new (0, $6cabd83f99ce6113$export$78f6d1b1dbcda304)());
            }
        });
        source.subscribe(subscriber);
    });
}








var $f65a851e0b190f66$var$nodeEventEmitterMethods = [
    'addListener',
    'removeListener'
];
var $f65a851e0b190f66$var$eventTargetMethods = [
    'addEventListener',
    'removeEventListener'
];
var $f65a851e0b190f66$var$jqueryMethods = [
    'on',
    'off'
];
function $f65a851e0b190f66$export$a36e16046ae8f1bb(target, eventName, options, resultSelector) {
    if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) return $f65a851e0b190f66$export$a36e16046ae8f1bb(target, eventName, options).pipe((0, $e6cd63efe08c02de$export$559affaa48f4288d)(resultSelector));
    var _a = (0, $5c96a02c592fcff1$export$8d051b38c9118094)($f65a851e0b190f66$var$isEventTarget(target) ? $f65a851e0b190f66$var$eventTargetMethods.map(function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler, options);
        };
    }) : $f65a851e0b190f66$var$isNodeStyleEventEmitter(target) ? $f65a851e0b190f66$var$nodeEventEmitterMethods.map($f65a851e0b190f66$var$toCommonHandlerRegistry(target, eventName)) : $f65a851e0b190f66$var$isJQueryStyleEventEmitter(target) ? $f65a851e0b190f66$var$jqueryMethods.map($f65a851e0b190f66$var$toCommonHandlerRegistry(target, eventName)) : [], 2), add = _a[0], remove = _a[1];
    if (!add) {
        if ((0, $8821cb8787de9fb5$export$1e2f57719e155213)(target)) return (0, $46964ba1b403cbfc$export$6b9f6c0d32c093f9)(function(subTarget) {
            return $f65a851e0b190f66$export$a36e16046ae8f1bb(subTarget, eventName, options);
        })((0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(target));
    }
    if (!add) throw new TypeError('Invalid event target');
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var handler = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return subscriber.next(1 < args.length ? args : args[0]);
        };
        add(handler);
        return function() {
            return remove(handler);
        };
    });
}
function $f65a851e0b190f66$var$toCommonHandlerRegistry(target, eventName) {
    return function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler);
        };
    };
}
function $f65a851e0b190f66$var$isNodeStyleEventEmitter(target) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(target.addListener) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(target.removeListener);
}
function $f65a851e0b190f66$var$isJQueryStyleEventEmitter(target) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(target.on) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(target.off);
}
function $f65a851e0b190f66$var$isEventTarget(target) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(target.addEventListener) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(target.removeEventListener);
}




function $d08e84546ee8df12$export$af596f9f0ff848f8(addHandler, removeHandler, resultSelector) {
    if (resultSelector) return $d08e84546ee8df12$export$af596f9f0ff848f8(addHandler, removeHandler).pipe((0, $e6cd63efe08c02de$export$559affaa48f4288d)(resultSelector));
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var handler = function() {
            var e = [];
            for(var _i = 0; _i < arguments.length; _i++)e[_i] = arguments[_i];
            return subscriber.next(e.length === 1 ? e[0] : e);
        };
        var retValue = addHandler(handler);
        return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(removeHandler) ? function() {
            return removeHandler(handler, retValue);
        } : undefined;
    });
}



function $4707859e785b3da6$export$18aef43295bbe906(concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return (0, $46964ba1b403cbfc$export$6b9f6c0d32c093f9)((0, $7569c528cdd9d182$export$f0954fd7d5368655), concurrent);
}




var $8faf6f2806f38bc2$export$ccb33e29d92c9a58 = new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
    return subscriber.complete();
});
function $8faf6f2806f38bc2$export$6e22c362a0406a2c(scheduler) {
    return scheduler ? $8faf6f2806f38bc2$var$emptyScheduled(scheduler) : $8faf6f2806f38bc2$export$ccb33e29d92c9a58;
}
function $8faf6f2806f38bc2$var$emptyScheduled(scheduler) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}




function $75c08a98094ca84a$export$4950aa0f605343fb() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $3b29c258456d9a89$export$29534b2f653ae592)(args);
    var concurrent = (0, $3b29c258456d9a89$export$3de14b735070dcd5)(args, Infinity);
    var sources = args;
    return !sources.length ? (0, $8faf6f2806f38bc2$export$ccb33e29d92c9a58) : sources.length === 1 ? (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(sources[0]) : (0, $4707859e785b3da6$export$18aef43295bbe906)(concurrent)((0, $2fe2b696577919a5$export$6788812c4e6611e6)(sources, scheduler));
}



function $195e3b3043565ec4$export$ba255e9e49e00608() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $3b29c258456d9a89$export$29534b2f653ae592)(args);
    return (0, $2fe2b696577919a5$export$6788812c4e6611e6)(args, scheduler);
}



function $949f1fd33ffd44b7$export$8f9d79d42bff1aac() {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var prev;
        var hasPrev = false;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            var p = prev;
            prev = value;
            hasPrev && subscriber.next([
                p,
                value
            ]);
            hasPrev = true;
        }));
    });
}




var $4a1890c700519557$export$915d2682b0aa0991 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ReplaySubject, _super);
    function ReplaySubject(_bufferSize, _windowTime, _timestampProvider) {
        if (_bufferSize === void 0) _bufferSize = Infinity;
        if (_windowTime === void 0) _windowTime = Infinity;
        if (_timestampProvider === void 0) _timestampProvider = (0, $94bcb2181a19339b$export$c1895ea2d519a677);
        var _this = _super.call(this) || this;
        _this._bufferSize = _bufferSize;
        _this._windowTime = _windowTime;
        _this._timestampProvider = _timestampProvider;
        _this._buffer = [];
        _this._infiniteTimeWindow = true;
        _this._infiniteTimeWindow = _windowTime === Infinity;
        _this._bufferSize = Math.max(1, _bufferSize);
        _this._windowTime = Math.max(1, _windowTime);
        return _this;
    }
    ReplaySubject.prototype.next = function(value) {
        var _a = this, isStopped = _a.isStopped, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow, _timestampProvider = _a._timestampProvider, _windowTime = _a._windowTime;
        if (!isStopped) {
            _buffer.push(value);
            !_infiniteTimeWindow && _buffer.push(_timestampProvider.now() + _windowTime);
        }
        this._trimBuffer();
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._trimBuffer();
        var subscription = this._innerSubscribe(subscriber);
        var _a = this, _infiniteTimeWindow = _a._infiniteTimeWindow, _buffer = _a._buffer;
        var copy = _buffer.slice();
        for(var i = 0; i < copy.length && !subscriber.closed; i += _infiniteTimeWindow ? 1 : 2)subscriber.next(copy[i]);
        this._checkFinalizedStatuses(subscriber);
        return subscription;
    };
    ReplaySubject.prototype._trimBuffer = function() {
        var _a = this, _bufferSize = _a._bufferSize, _timestampProvider = _a._timestampProvider, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow;
        var adjustedBufferSize = (_infiniteTimeWindow ? 1 : 2) * _bufferSize;
        _bufferSize < Infinity && adjustedBufferSize < _buffer.length && _buffer.splice(0, _buffer.length - adjustedBufferSize);
        if (!_infiniteTimeWindow) {
            var now = _timestampProvider.now();
            var last = 0;
            for(var i = 1; i < _buffer.length && _buffer[i] <= now; i += 2)last = i;
            last && _buffer.splice(0, last + 1);
        }
    };
    return ReplaySubject;
}((0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038));







function $0cd9b6b86141760f$export$ed80d9de1d9df928(options) {
    if (options === void 0) options = {};
    var _a = options.connector, connector = _a === void 0 ? function() {
        return new (0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038)();
    } : _a, _b = options.resetOnError, resetOnError = _b === void 0 ? true : _b, _c = options.resetOnComplete, resetOnComplete = _c === void 0 ? true : _c, _d = options.resetOnRefCountZero, resetOnRefCountZero = _d === void 0 ? true : _d;
    return function(wrapperSource) {
        var connection;
        var resetConnection;
        var subject;
        var refCount = 0;
        var hasCompleted = false;
        var hasErrored = false;
        var cancelReset = function() {
            resetConnection === null || resetConnection === void 0 || resetConnection.unsubscribe();
            resetConnection = undefined;
        };
        var reset = function() {
            cancelReset();
            connection = subject = undefined;
            hasCompleted = hasErrored = false;
        };
        var resetAndUnsubscribe = function() {
            var conn = connection;
            reset();
            conn === null || conn === void 0 || conn.unsubscribe();
        };
        return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
            refCount++;
            if (!hasErrored && !hasCompleted) cancelReset();
            var dest = subject = subject !== null && subject !== void 0 ? subject : connector();
            subscriber.add(function() {
                refCount--;
                if (refCount === 0 && !hasErrored && !hasCompleted) resetConnection = $0cd9b6b86141760f$var$handleReset(resetAndUnsubscribe, resetOnRefCountZero);
            });
            dest.subscribe(subscriber);
            if (!connection && refCount > 0) {
                connection = new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)({
                    next: function(value) {
                        return dest.next(value);
                    },
                    error: function(err) {
                        hasErrored = true;
                        cancelReset();
                        resetConnection = $0cd9b6b86141760f$var$handleReset(reset, resetOnError, err);
                        dest.error(err);
                    },
                    complete: function() {
                        hasCompleted = true;
                        cancelReset();
                        resetConnection = $0cd9b6b86141760f$var$handleReset(reset, resetOnComplete);
                        dest.complete();
                    }
                });
                (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(source).subscribe(connection);
            }
        })(wrapperSource);
    };
}
function $0cd9b6b86141760f$var$handleReset(reset, on) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (on === true) {
        reset();
        return;
    }
    if (on === false) return;
    var onSubscriber = new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)({
        next: function() {
            onSubscriber.unsubscribe();
            reset();
        }
    });
    return (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(on.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(args)))).subscribe(onSubscriber);
}


function $cd8167599454f872$export$db61d692014e534e(configOrBufferSize, windowTime, scheduler) {
    var _a, _b, _c;
    var bufferSize;
    var refCount = false;
    if (configOrBufferSize && typeof configOrBufferSize === 'object') _a = configOrBufferSize.bufferSize, bufferSize = _a === void 0 ? Infinity : _a, _b = configOrBufferSize.windowTime, windowTime = _b === void 0 ? Infinity : _b, _c = configOrBufferSize.refCount, refCount = _c === void 0 ? false : _c, scheduler = configOrBufferSize.scheduler;
    else bufferSize = configOrBufferSize !== null && configOrBufferSize !== void 0 ? configOrBufferSize : Infinity;
    return (0, $0cd9b6b86141760f$export$ed80d9de1d9df928)({
        connector: function() {
            return new (0, $4a1890c700519557$export$915d2682b0aa0991)(bufferSize, windowTime, scheduler);
        },
        resetOnError: true,
        resetOnComplete: false,
        resetOnRefCountZero: refCount
    });
}


function $3a4e37c3b56570cb$export$b314777ae20abca9() {
    return (0, $4707859e785b3da6$export$18aef43295bbe906)(1);
}




function $82eda875fdd470db$export$ee1b3e54f0441b22() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return (0, $3a4e37c3b56570cb$export$b314777ae20abca9)()((0, $2fe2b696577919a5$export$6788812c4e6611e6)(args, (0, $3b29c258456d9a89$export$29534b2f653ae592)(args)));
}




function $b52129d9072c7912$export$a4fe86229b0e9bdd() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    var scheduler = (0, $3b29c258456d9a89$export$29534b2f653ae592)(values);
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        (scheduler ? (0, $82eda875fdd470db$export$ee1b3e54f0441b22)(values, source, scheduler) : (0, $82eda875fdd470db$export$ee1b3e54f0441b22)(values, source)).subscribe(subscriber);
    });
}



function $106fa5810fba1e6e$export$9384c7afe4015e42(predicate, inclusive) {
    if (inclusive === void 0) inclusive = false;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            var result = predicate(value, index++);
            (result || inclusive) && subscriber.next(value);
            !result && subscriber.complete();
        }));
    });
}





function $3e7edc5b22925f26$export$3f23594af5f37336(observerOrNext, error, complete) {
    var tapObserver = (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(observerOrNext) || error || complete ? {
        next: observerOrNext,
        error: error,
        complete: complete
    } : observerOrNext;
    return tapObserver ? (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var _a;
        (_a = tapObserver.subscribe) === null || _a === void 0 || _a.call(tapObserver);
        var isUnsub = true;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            var _a;
            (_a = tapObserver.next) === null || _a === void 0 || _a.call(tapObserver, value);
            subscriber.next(value);
        }, function() {
            var _a;
            isUnsub = false;
            (_a = tapObserver.complete) === null || _a === void 0 || _a.call(tapObserver);
            subscriber.complete();
        }, function(err) {
            var _a;
            isUnsub = false;
            (_a = tapObserver.error) === null || _a === void 0 || _a.call(tapObserver, err);
            subscriber.error(err);
        }, function() {
            var _a, _b;
            if (isUnsub) (_a = tapObserver.unsubscribe) === null || _a === void 0 || _a.call(tapObserver);
            (_b = tapObserver.finalize) === null || _b === void 0 || _b.call(tapObserver);
        }));
    }) : (0, $7569c528cdd9d182$export$f0954fd7d5368655);
}



var $86Wyx = parcelRequire("86Wyx");
var $bb514e254ef7ecdd$exports = {};
"use strict";
Object.defineProperty($bb514e254ef7ecdd$exports, "__esModule", {
    value: true
});
$bb514e254ef7ecdd$exports.WorkerTimer = void 0;
var $587965975e9ec554$exports = {};
"use strict";
Object.defineProperty($587965975e9ec554$exports, "__esModule", {
    value: true
});
$587965975e9ec554$exports.timerWorker = void 0;
$587965975e9ec554$exports.timerWorker = {
    src: `const e=new Map;self.addEventListener("message",t=>{const s=t.data;switch(s.type){case"setTimeout":case"setInterval":e.set(s.id,("setTimeout"===s.type?setTimeout:setInterval)(()=>{!function(e){const t={type:"tick",id:e};self.postMessage(t)}(s.id),"setTimeout"===s.type&&e.delete(s.id)},s.timeout));break;case"clearTimeout":case"clearInterval":("clearTimeout"===s.type?clearTimeout:clearInterval)(e.get(s.id)),e.delete(s.id)}});`
};


class $bb514e254ef7ecdd$var$WorkerTimer {
    /**
     * Constructs a new instance of WorkerTimer.
     *
     * @param init the init parameters.
     */ constructor(init = {}){
        this.currentTimerId = 1;
        this.callbacks = new Map();
        this.fallback = false;
        this.setup = ({ useWorker: useWorker = true, name: name = "@stream-io/worker-timer" } = {})=>{
            if (!useWorker) {
                this.fallback = true;
                return;
            }
            try {
                const source = $587965975e9ec554$exports.timerWorker.src;
                const blob = new Blob([
                    source
                ], {
                    type: "application/javascript; charset=utf-8"
                });
                const script = URL.createObjectURL(blob);
                this.worker = new Worker(script, {
                    name: name
                });
                this.worker.addEventListener("message", (e)=>{
                    const { type: type, id: id } = e.data;
                    if (type === "tick") this.callbacks.get(id)?.();
                });
            } catch (err) {
                console.error("Failed to create timer worker: ", err);
                this.fallback = true;
            }
        };
        this.destroy = ()=>{
            this.callbacks.clear();
            this.worker?.terminate();
            this.worker = undefined;
            this.fallback = false;
        };
        this.setInterval = (callback, timeout)=>this.setTimer("setInterval", callback, timeout);
        this.clearInterval = (id)=>{
            this.clearTimer("clearInterval", id);
        };
        this.setTimeout = (callback, timeout)=>this.setTimer("setTimeout", callback, timeout);
        this.clearTimeout = (id)=>{
            this.clearTimer("clearTimeout", id);
        };
        this.setTimer = (type, callback, timeout)=>{
            if (!this.ready) this.setup();
            if (this.fallback) return (type === "setTimeout" ? setTimeout : setInterval)(callback, timeout);
            const id = this.getTimerId();
            this.callbacks.set(id, ()=>{
                callback();
                // Timeouts are one-off operations, so no need to keep callback reference
                // after timer has fired
                if (type === "setTimeout") this.callbacks.delete(id);
            });
            this.sendMessage({
                type: type,
                id: id,
                timeout: timeout
            });
            return id;
        };
        this.clearTimer = (type, id)=>{
            if (!id) return;
            if (!this.ready) this.setup();
            if (this.fallback) {
                (type === "clearTimeout" ? clearTimeout : clearInterval)(id);
                return;
            }
            this.callbacks.delete(id);
            this.sendMessage({
                type: type,
                id: id
            });
        };
        this.getTimerId = ()=>this.currentTimerId++;
        this.sendMessage = (message)=>{
            if (!this.worker) throw new Error("Cannot use timer worker before it's set up");
            this.worker.postMessage(message);
        };
        this.setup(init);
    }
    get ready() {
        return this.fallback || Boolean(this.worker);
    }
}
$bb514e254ef7ecdd$exports.WorkerTimer = $bb514e254ef7ecdd$var$WorkerTimer;


/* tslint:disable */ /**
 * @export
 */ const $8c05ed6f2f331ee8$export$cbbed47a9cfcfc9e = {
    SPEAKER: 'speaker',
    EARPIECE: 'earpiece'
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$ed2db4bafec42e6 = {
    SPEAKER: 'speaker',
    EARPIECE: 'earpiece'
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$a25360b9dd894947 = {
    COMPOSITE: 'composite',
    INDIVIDUAL: 'individual',
    RAW: 'raw'
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$5266b49e03f11910 = {
    COMPOSITE: 'composite',
    INDIVIDUAL: 'individual',
    RAW: 'raw'
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$652aa738e00d999a = {
    COMPOSITE: 'composite',
    INDIVIDUAL: 'individual',
    RAW: 'raw'
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$e780385dcae4d7d1 = {
    COMPOSITE: 'composite',
    INDIVIDUAL: 'individual',
    RAW: 'raw'
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$719b2deea2e55bfa = {
    FIREBASE: 'firebase',
    APN: 'apn',
    HUAWEI: 'huawei',
    XIAOMI: 'xiaomi'
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$c4487f9c0465eba7 = {
    AVAILABLE: 'available',
    DISABLED: 'disabled',
    AUTO_ON: 'auto-on'
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$76769fa0cafd2820 = {
    _360P: '360p',
    _480P: '480p',
    _720P: '720p',
    _1080P: '1080p',
    _1440P: '1440p'
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$f56688ed79a340a3 = {
    AVAILABLE: 'available',
    DISABLED: 'disabled',
    AUTO_ON: 'auto-on'
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$2bd289573782d5ca = {
    AVAILABLE: 'available',
    DISABLED: 'disabled',
    AUTO_ON: 'auto-on'
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$657d681639445945 = {
    AVAILABLE: 'available',
    DISABLED: 'disabled',
    AUTO_ON: 'auto-on'
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$2a878e18539996bb = {
    NUMBER_1: 1,
    NUMBER_2: 2
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$68779461321089a7 = {
    NUMBER_30: 30,
    NUMBER_60: 60
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$70f5190d36df9743 = {
    H264: 'h264',
    VP8: 'vp8'
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$b05f08058b856624 = {
    SPOTLIGHT: 'spotlight',
    GRID: 'grid',
    SINGLE_PARTICIPANT: 'single-participant',
    MOBILE: 'mobile',
    CUSTOM: 'custom'
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$fa8c5a4bee8a4778 = {
    AVAILABLE: 'available',
    DISABLED: 'disabled',
    AUTO_ON: 'auto-on'
};
/**
 * All possibility of string to use
 * @export
 */ const $8c05ed6f2f331ee8$export$9d72b1bd9eedd7a7 = {
    BLOCK_USERS: 'block-users',
    CHANGE_MAX_DURATION: 'change-max-duration',
    CREATE_CALL: 'create-call',
    CREATE_REACTION: 'create-reaction',
    ENABLE_NOISE_CANCELLATION: 'enable-noise-cancellation',
    END_CALL: 'end-call',
    JOIN_BACKSTAGE: 'join-backstage',
    JOIN_CALL: 'join-call',
    JOIN_ENDED_CALL: 'join-ended-call',
    KICK_USER: 'kick-user',
    MUTE_USERS: 'mute-users',
    PIN_FOR_EVERYONE: 'pin-for-everyone',
    READ_CALL: 'read-call',
    REMOVE_CALL_MEMBER: 'remove-call-member',
    SCREENSHARE: 'screenshare',
    SEND_AUDIO: 'send-audio',
    SEND_CLOSED_CAPTIONS_CALL: 'send-closed-captions-call',
    SEND_VIDEO: 'send-video',
    START_BROADCAST_CALL: 'start-broadcast-call',
    START_CLOSED_CAPTIONS_CALL: 'start-closed-captions-call',
    START_FRAME_RECORD_CALL: 'start-frame-record-call',
    START_INDIVIDUAL_RECORD_CALL: 'start-individual-record-call',
    START_RAW_RECORD_CALL: 'start-raw-record-call',
    START_RECORD_CALL: 'start-record-call',
    START_TRANSCRIPTION_CALL: 'start-transcription-call',
    STOP_BROADCAST_CALL: 'stop-broadcast-call',
    STOP_CLOSED_CAPTIONS_CALL: 'stop-closed-captions-call',
    STOP_FRAME_RECORD_CALL: 'stop-frame-record-call',
    STOP_INDIVIDUAL_RECORD_CALL: 'stop-individual-record-call',
    STOP_RAW_RECORD_CALL: 'stop-raw-record-call',
    STOP_RECORD_CALL: 'stop-record-call',
    STOP_TRANSCRIPTION_CALL: 'stop-transcription-call',
    UPDATE_CALL: 'update-call',
    UPDATE_CALL_MEMBER: 'update-call-member',
    UPDATE_CALL_PERMISSIONS: 'update-call-permissions',
    UPDATE_CALL_SETTINGS: 'update-call-settings'
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$15ca0ed5655a7cb3 = {
    _360P: '360p',
    _480P: '480p',
    _720P: '720p',
    _1080P: '1080p',
    _1440P: '1440p',
    PORTRAIT_360X640: 'portrait-360x640',
    PORTRAIT_480X854: 'portrait-480x854',
    PORTRAIT_720X1280: 'portrait-720x1280',
    PORTRAIT_1080X1920: 'portrait-1080x1920',
    PORTRAIT_1440X2560: 'portrait-1440x2560'
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$bed4f78d1c6db2da = {
    _360P: '360p',
    _480P: '480p',
    _720P: '720p',
    _1080P: '1080p',
    _1440P: '1440p',
    PORTRAIT_360X640: 'portrait-360x640',
    PORTRAIT_480X854: 'portrait-480x854',
    PORTRAIT_720X1280: 'portrait-720x1280',
    PORTRAIT_1080X1920: 'portrait-1080x1920',
    PORTRAIT_1440X2560: 'portrait-1440x2560'
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$35024ca16a04f9ee = {
    AVAILABLE: 'available',
    DISABLED: 'disabled',
    AUTO_ON: 'auto-on'
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$734f10730b72688e = {
    AVAILABLE: 'available',
    DISABLED: 'disabled',
    AUTO_ON: 'auto-on'
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$236741d2e710c520 = {
    AVAILABLE: 'available',
    DISABLED: 'disabled',
    AUTO_ON: 'auto-on'
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$75ca1fe9f2ce9b03 = {
    _360P: '360p',
    _480P: '480p',
    _720P: '720p',
    _1080P: '1080p',
    _1440P: '1440p',
    PORTRAIT_360X640: 'portrait-360x640',
    PORTRAIT_480X854: 'portrait-480x854',
    PORTRAIT_720X1280: 'portrait-720x1280',
    PORTRAIT_1080X1920: 'portrait-1080x1920',
    PORTRAIT_1440X2560: 'portrait-1440x2560'
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$90c32b00f02984ae = {
    AUTO: 'auto',
    EN: 'en',
    FR: 'fr',
    ES: 'es',
    DE: 'de',
    IT: 'it',
    NL: 'nl',
    PT: 'pt',
    PL: 'pl',
    CA: 'ca',
    CS: 'cs',
    DA: 'da',
    EL: 'el',
    FI: 'fi',
    ID: 'id',
    JA: 'ja',
    RU: 'ru',
    SV: 'sv',
    TA: 'ta',
    TH: 'th',
    TR: 'tr',
    HU: 'hu',
    RO: 'ro',
    ZH: 'zh',
    AR: 'ar',
    TL: 'tl',
    HE: 'he',
    HI: 'hi',
    HR: 'hr',
    KO: 'ko',
    MS: 'ms',
    NO: 'no',
    UK: 'uk',
    BG: 'bg',
    ET: 'et',
    SL: 'sl',
    SK: 'sk'
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$f87bd3cae6d31a27 = {
    AUTO: 'auto',
    EN: 'en',
    FR: 'fr',
    ES: 'es',
    DE: 'de',
    IT: 'it',
    NL: 'nl',
    PT: 'pt',
    PL: 'pl',
    CA: 'ca',
    CS: 'cs',
    DA: 'da',
    EL: 'el',
    FI: 'fi',
    ID: 'id',
    JA: 'ja',
    RU: 'ru',
    SV: 'sv',
    TA: 'ta',
    TH: 'th',
    TR: 'tr',
    HU: 'hu',
    RO: 'ro',
    ZH: 'zh',
    AR: 'ar',
    TL: 'tl',
    HE: 'he',
    HI: 'hi',
    HR: 'hr',
    KO: 'ko',
    MS: 'ms',
    NO: 'no',
    UK: 'uk',
    BG: 'bg',
    ET: 'et',
    SL: 'sl',
    SK: 'sk'
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$5d0cb5a3aec4cc6d = {
    AVAILABLE: 'available',
    DISABLED: 'disabled',
    AUTO_ON: 'auto-on'
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$bb0304e7b7a8af0 = {
    AUTO: 'auto',
    EN: 'en',
    FR: 'fr',
    ES: 'es',
    DE: 'de',
    IT: 'it',
    NL: 'nl',
    PT: 'pt',
    PL: 'pl',
    CA: 'ca',
    CS: 'cs',
    DA: 'da',
    EL: 'el',
    FI: 'fi',
    ID: 'id',
    JA: 'ja',
    RU: 'ru',
    SV: 'sv',
    TA: 'ta',
    TH: 'th',
    TR: 'tr',
    HU: 'hu',
    RO: 'ro',
    ZH: 'zh',
    AR: 'ar',
    TL: 'tl',
    HE: 'he',
    HI: 'hi',
    HR: 'hr',
    KO: 'ko',
    MS: 'ms',
    NO: 'no',
    UK: 'uk',
    BG: 'bg',
    ET: 'et',
    SL: 'sl',
    SK: 'sk'
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$bfe10604c31e44bb = {
    AVAILABLE: 'available',
    DISABLED: 'disabled',
    AUTO_ON: 'auto-on'
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$73741d8f368c301f = {
    AVAILABLE: 'available',
    DISABLED: 'disabled',
    AUTO_ON: 'auto-on'
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$b7df1639c3a83275 = {
    AUTO: 'auto',
    EN: 'en',
    FR: 'fr',
    ES: 'es',
    DE: 'de',
    IT: 'it',
    NL: 'nl',
    PT: 'pt',
    PL: 'pl',
    CA: 'ca',
    CS: 'cs',
    DA: 'da',
    EL: 'el',
    FI: 'fi',
    ID: 'id',
    JA: 'ja',
    RU: 'ru',
    SV: 'sv',
    TA: 'ta',
    TH: 'th',
    TR: 'tr',
    HU: 'hu',
    RO: 'ro',
    ZH: 'zh',
    AR: 'ar',
    TL: 'tl',
    HE: 'he',
    HI: 'hi',
    HR: 'hr',
    KO: 'ko',
    MS: 'ms',
    NO: 'no',
    UK: 'uk',
    BG: 'bg',
    ET: 'et',
    SL: 'sl',
    SK: 'sk'
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$9d349d30dc5d83f0 = {
    AVAILABLE: 'available',
    DISABLED: 'disabled',
    AUTO_ON: 'auto-on'
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$3fee936cede6b364 = {
    FRONT: 'front',
    BACK: 'back',
    EXTERNAL: 'external'
};
/**
 * @export
 */ const $8c05ed6f2f331ee8$export$5e18c6e50ef003f8 = {
    FRONT: 'front',
    BACK: 'back',
    EXTERNAL: 'external'
};
class $8c05ed6f2f331ee8$export$758a4427671bc10f extends Error {
    constructor({ message: message, code: code, status: status, response: response, unrecoverable: unrecoverable }){
        super(message);
        this.name = 'ErrorFromResponse';
        this.code = code;
        this.response = response;
        this.status = status;
        this.unrecoverable = unrecoverable;
    }
    // Vitest helper (serialized errors are too large to read)
    // https://github.com/vitest-dev/vitest/blob/v3.1.3/packages/utils/src/error.ts#L60-L62
    toJSON() {
        const extra = [
            [
                'status',
                this.status
            ],
            [
                'code',
                this.code
            ],
            [
                'unrecoverable',
                this.unrecoverable
            ]
        ];
        const joinable = [];
        for (const [key, value] of extra)if (typeof value !== 'undefined' && value !== null) joinable.push(`${key}: ${value}`);
        return {
            message: `(${joinable.join(', ')}) - ${this.message}`,
            stack: this.stack,
            name: this.name
        };
    }
}
// @generated by protobuf-ts 2.10.0 with parameter long_type_string,client_generic,server_none,eslint_disable,optimize_code_size
// @generated from protobuf file "google/protobuf/struct.proto" (package "google.protobuf", syntax proto3)
// tslint:disable
//
// Protocol Buffers - Google's data interchange format
// Copyright 2008 Google Inc.  All rights reserved.
// https://developers.google.com/protocol-buffers/
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are
// met:
//
//     * Redistributions of source code must retain the above copyright
// notice, this list of conditions and the following disclaimer.
//     * Redistributions in binary form must reproduce the above
// copyright notice, this list of conditions and the following disclaimer
// in the documentation and/or other materials provided with the
// distribution.
//     * Neither the name of Google Inc. nor the names of its
// contributors may be used to endorse or promote products derived from
// this software without specific prior written permission.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
// "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
// LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
// A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
// OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
// SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
// LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
// DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
// THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
//
/**
 * `NullValue` is a singleton enumeration to represent the null value for the
 * `Value` type union.
 *
 *  The JSON representation for `NullValue` is JSON `null`.
 *
 * @generated from protobuf enum google.protobuf.NullValue
 */ var $8c05ed6f2f331ee8$var$NullValue;
(function(NullValue) {
    /**
     * Null value.
     *
     * @generated from protobuf enum value: NULL_VALUE = 0;
     */ NullValue[NullValue["NULL_VALUE"] = 0] = "NULL_VALUE";
})($8c05ed6f2f331ee8$var$NullValue || ($8c05ed6f2f331ee8$var$NullValue = {}));
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$Struct$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('google.protobuf.Struct', [
            {
                no: 1,
                name: 'fields',
                kind: 'map',
                K: 9 /*ScalarType.STRING*/ ,
                V: {
                    kind: 'message',
                    T: ()=>$8c05ed6f2f331ee8$var$Value
                }
            }
        ]);
    }
    /**
     * Encode `Struct` to JSON object.
     */ internalJsonWrite(message, options) {
        let json = {};
        for (let [k, v] of Object.entries(message.fields))json[k] = $8c05ed6f2f331ee8$var$Value.toJson(v);
        return json;
    }
    /**
     * Decode `Struct` from JSON object.
     */ internalJsonRead(json, options, target) {
        if (!(0, $9b0297e2871b9bc0$export$98727920b98c3cdb)(json)) throw new globalThis.Error('Unable to parse message ' + this.typeName + ' from JSON ' + (0, $9b0297e2871b9bc0$export$664ede5272d59144)(json) + '.');
        if (!target) target = this.create();
        for (let [k, v] of globalThis.Object.entries(json))target.fields[k] = $8c05ed6f2f331ee8$var$Value.fromJson(v);
        return target;
    }
}
/**
 * @generated MessageType for protobuf message google.protobuf.Struct
 */ const $8c05ed6f2f331ee8$var$Struct = new $8c05ed6f2f331ee8$var$Struct$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$Value$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('google.protobuf.Value', [
            {
                no: 1,
                name: 'null_value',
                kind: 'enum',
                oneof: 'kind',
                T: ()=>[
                        'google.protobuf.NullValue',
                        $8c05ed6f2f331ee8$var$NullValue
                    ]
            },
            {
                no: 2,
                name: 'number_value',
                kind: 'scalar',
                oneof: 'kind',
                T: 1 /*ScalarType.DOUBLE*/ 
            },
            {
                no: 3,
                name: 'string_value',
                kind: 'scalar',
                oneof: 'kind',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 4,
                name: 'bool_value',
                kind: 'scalar',
                oneof: 'kind',
                T: 8 /*ScalarType.BOOL*/ 
            },
            {
                no: 5,
                name: 'struct_value',
                kind: 'message',
                oneof: 'kind',
                T: ()=>$8c05ed6f2f331ee8$var$Struct
            },
            {
                no: 6,
                name: 'list_value',
                kind: 'message',
                oneof: 'kind',
                T: ()=>$8c05ed6f2f331ee8$var$ListValue
            }
        ]);
    }
    /**
     * Encode `Value` to JSON value.
     */ internalJsonWrite(message, options) {
        if (message.kind.oneofKind === undefined) throw new globalThis.Error();
        switch(message.kind.oneofKind){
            case undefined:
                throw new globalThis.Error();
            case 'boolValue':
                return message.kind.boolValue;
            case 'nullValue':
                return null;
            case 'numberValue':
                let numberValue = message.kind.numberValue;
                if (typeof numberValue == 'number' && !Number.isFinite(numberValue)) throw new globalThis.Error();
                return numberValue;
            case 'stringValue':
                return message.kind.stringValue;
            case 'listValue':
                let listValueField = this.fields.find((f)=>f.no === 6);
                if (listValueField?.kind !== 'message') throw new globalThis.Error();
                return listValueField.T().toJson(message.kind.listValue);
            case 'structValue':
                let structValueField = this.fields.find((f)=>f.no === 5);
                if (structValueField?.kind !== 'message') throw new globalThis.Error();
                return structValueField.T().toJson(message.kind.structValue);
        }
    }
    /**
     * Decode `Value` from JSON value.
     */ internalJsonRead(json, options, target) {
        if (!target) target = this.create();
        switch(typeof json){
            case 'number':
                target.kind = {
                    oneofKind: 'numberValue',
                    numberValue: json
                };
                break;
            case 'string':
                target.kind = {
                    oneofKind: 'stringValue',
                    stringValue: json
                };
                break;
            case 'boolean':
                target.kind = {
                    oneofKind: 'boolValue',
                    boolValue: json
                };
                break;
            case 'object':
                if (json === null) target.kind = {
                    oneofKind: 'nullValue',
                    nullValue: $8c05ed6f2f331ee8$var$NullValue.NULL_VALUE
                };
                else if (globalThis.Array.isArray(json)) target.kind = {
                    oneofKind: 'listValue',
                    listValue: $8c05ed6f2f331ee8$var$ListValue.fromJson(json)
                };
                else target.kind = {
                    oneofKind: 'structValue',
                    structValue: $8c05ed6f2f331ee8$var$Struct.fromJson(json)
                };
                break;
            default:
                throw new globalThis.Error('Unable to parse ' + this.typeName + ' from JSON ' + (0, $9b0297e2871b9bc0$export$664ede5272d59144)(json));
        }
        return target;
    }
}
/**
 * @generated MessageType for protobuf message google.protobuf.Value
 */ const $8c05ed6f2f331ee8$var$Value = new $8c05ed6f2f331ee8$var$Value$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$ListValue$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('google.protobuf.ListValue', [
            {
                no: 1,
                name: 'values',
                kind: 'message',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: ()=>$8c05ed6f2f331ee8$var$Value
            }
        ]);
    }
    /**
     * Encode `ListValue` to JSON array.
     */ internalJsonWrite(message, options) {
        return message.values.map((v)=>$8c05ed6f2f331ee8$var$Value.toJson(v));
    }
    /**
     * Decode `ListValue` from JSON array.
     */ internalJsonRead(json, options, target) {
        if (!globalThis.Array.isArray(json)) throw new globalThis.Error('Unable to parse ' + this.typeName + ' from JSON ' + (0, $9b0297e2871b9bc0$export$664ede5272d59144)(json));
        if (!target) target = this.create();
        let values = json.map((v)=>$8c05ed6f2f331ee8$var$Value.fromJson(v));
        target.values.push(...values);
        return target;
    }
}
/**
 * @generated MessageType for protobuf message google.protobuf.ListValue
 */ const $8c05ed6f2f331ee8$var$ListValue = new $8c05ed6f2f331ee8$var$ListValue$Type();
// @generated by protobuf-ts 2.10.0 with parameter long_type_string,client_generic,server_none,eslint_disable,optimize_code_size
// @generated from protobuf file "google/protobuf/timestamp.proto" (package "google.protobuf", syntax proto3)
// tslint:disable
//
// Protocol Buffers - Google's data interchange format
// Copyright 2008 Google Inc.  All rights reserved.
// https://developers.google.com/protocol-buffers/
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are
// met:
//
//     * Redistributions of source code must retain the above copyright
// notice, this list of conditions and the following disclaimer.
//     * Redistributions in binary form must reproduce the above
// copyright notice, this list of conditions and the following disclaimer
// in the documentation and/or other materials provided with the
// distribution.
//     * Neither the name of Google Inc. nor the names of its
// contributors may be used to endorse or promote products derived from
// this software without specific prior written permission.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
// "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
// LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
// A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
// OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
// SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
// LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
// DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
// THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
//
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$Timestamp$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('google.protobuf.Timestamp', [
            {
                no: 1,
                name: 'seconds',
                kind: 'scalar',
                T: 3 /*ScalarType.INT64*/ 
            },
            {
                no: 2,
                name: 'nanos',
                kind: 'scalar',
                T: 5 /*ScalarType.INT32*/ 
            }
        ]);
    }
    /**
     * Creates a new `Timestamp` for the current time.
     */ now() {
        const msg = this.create();
        const ms = Date.now();
        msg.seconds = (0, $675e5c20166be613$export$458c11e435f8bbac).from(Math.floor(ms / 1000)).toString();
        msg.nanos = ms % 1000 * 1000000;
        return msg;
    }
    /**
     * Converts a `Timestamp` to a JavaScript Date.
     */ toDate(message) {
        return new Date((0, $675e5c20166be613$export$458c11e435f8bbac).from(message.seconds).toNumber() * 1000 + Math.ceil(message.nanos / 1000000));
    }
    /**
     * Converts a JavaScript Date to a `Timestamp`.
     */ fromDate(date) {
        const msg = this.create();
        const ms = date.getTime();
        msg.seconds = (0, $675e5c20166be613$export$458c11e435f8bbac).from(Math.floor(ms / 1000)).toString();
        msg.nanos = (ms % 1000 + (ms < 0 && ms % 1000 !== 0 ? 1000 : 0)) * 1000000;
        return msg;
    }
    /**
     * In JSON format, the `Timestamp` type is encoded as a string
     * in the RFC 3339 format.
     */ internalJsonWrite(message, options) {
        let ms = (0, $675e5c20166be613$export$458c11e435f8bbac).from(message.seconds).toNumber() * 1000;
        if (ms < Date.parse('0001-01-01T00:00:00Z') || ms > Date.parse('9999-12-31T23:59:59Z')) throw new Error('Unable to encode Timestamp to JSON. Must be from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59Z inclusive.');
        if (message.nanos < 0) throw new Error('Unable to encode invalid Timestamp to JSON. Nanos must not be negative.');
        let z = 'Z';
        if (message.nanos > 0) {
            let nanosStr = (message.nanos + 1000000000).toString().substring(1);
            if (nanosStr.substring(3) === '000000') z = '.' + nanosStr.substring(0, 3) + 'Z';
            else if (nanosStr.substring(6) === '000') z = '.' + nanosStr.substring(0, 6) + 'Z';
            else z = '.' + nanosStr + 'Z';
        }
        return new Date(ms).toISOString().replace('.000Z', z);
    }
    /**
     * In JSON format, the `Timestamp` type is encoded as a string
     * in the RFC 3339 format.
     */ internalJsonRead(json, options, target) {
        if (typeof json !== 'string') throw new Error('Unable to parse Timestamp from JSON ' + (0, $9b0297e2871b9bc0$export$664ede5272d59144)(json) + '.');
        let matches = json.match(/^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2}):([0-9]{2})(?:Z|\.([0-9]{3,9})Z|([+-][0-9][0-9]:[0-9][0-9]))$/);
        if (!matches) throw new Error('Unable to parse Timestamp from JSON. Invalid format.');
        let ms = Date.parse(matches[1] + '-' + matches[2] + '-' + matches[3] + 'T' + matches[4] + ':' + matches[5] + ':' + matches[6] + (matches[8] ? matches[8] : 'Z'));
        if (Number.isNaN(ms)) throw new Error('Unable to parse Timestamp from JSON. Invalid value.');
        if (ms < Date.parse('0001-01-01T00:00:00Z') || ms > Date.parse('9999-12-31T23:59:59Z')) throw new globalThis.Error('Unable to parse Timestamp from JSON. Must be from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59Z inclusive.');
        if (!target) target = this.create();
        target.seconds = (0, $675e5c20166be613$export$458c11e435f8bbac).from(ms / 1000).toString();
        target.nanos = 0;
        if (matches[7]) target.nanos = parseInt('1' + matches[7] + '0'.repeat(9 - matches[7].length)) - 1000000000;
        return target;
    }
}
/**
 * @generated MessageType for protobuf message google.protobuf.Timestamp
 */ const $8c05ed6f2f331ee8$var$Timestamp = new $8c05ed6f2f331ee8$var$Timestamp$Type();
// @generated by protobuf-ts 2.10.0 with parameter long_type_string,client_generic,server_none,eslint_disable,optimize_code_size
// @generated from protobuf file "video/sfu/models/models.proto" (package "stream.video.sfu.models", syntax proto3)
// tslint:disable
/**
 * @generated from protobuf enum stream.video.sfu.models.PeerType
 */ var $8c05ed6f2f331ee8$var$PeerType;
(function(PeerType) {
    /**
     * todo fix me (marcelo)
     *
     * @generated from protobuf enum value: PEER_TYPE_PUBLISHER_UNSPECIFIED = 0;
     */ PeerType[PeerType["PUBLISHER_UNSPECIFIED"] = 0] = "PUBLISHER_UNSPECIFIED";
    /**
     * @generated from protobuf enum value: PEER_TYPE_SUBSCRIBER = 1;
     */ PeerType[PeerType["SUBSCRIBER"] = 1] = "SUBSCRIBER";
})($8c05ed6f2f331ee8$var$PeerType || ($8c05ed6f2f331ee8$var$PeerType = {}));
/**
 * @generated from protobuf enum stream.video.sfu.models.ConnectionQuality
 */ var $8c05ed6f2f331ee8$var$ConnectionQuality;
(function(ConnectionQuality) {
    /**
     * @generated from protobuf enum value: CONNECTION_QUALITY_UNSPECIFIED = 0;
     */ ConnectionQuality[ConnectionQuality["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: CONNECTION_QUALITY_POOR = 1;
     */ ConnectionQuality[ConnectionQuality["POOR"] = 1] = "POOR";
    /**
     * @generated from protobuf enum value: CONNECTION_QUALITY_GOOD = 2;
     */ ConnectionQuality[ConnectionQuality["GOOD"] = 2] = "GOOD";
    /**
     * @generated from protobuf enum value: CONNECTION_QUALITY_EXCELLENT = 3;
     */ ConnectionQuality[ConnectionQuality["EXCELLENT"] = 3] = "EXCELLENT";
})($8c05ed6f2f331ee8$var$ConnectionQuality || ($8c05ed6f2f331ee8$var$ConnectionQuality = {}));
/**
 * @generated from protobuf enum stream.video.sfu.models.VideoQuality
 */ var $8c05ed6f2f331ee8$var$VideoQuality;
(function(VideoQuality) {
    /**
     * @generated from protobuf enum value: VIDEO_QUALITY_LOW_UNSPECIFIED = 0;
     */ VideoQuality[VideoQuality["LOW_UNSPECIFIED"] = 0] = "LOW_UNSPECIFIED";
    /**
     * @generated from protobuf enum value: VIDEO_QUALITY_MID = 1;
     */ VideoQuality[VideoQuality["MID"] = 1] = "MID";
    /**
     * @generated from protobuf enum value: VIDEO_QUALITY_HIGH = 2;
     */ VideoQuality[VideoQuality["HIGH"] = 2] = "HIGH";
    /**
     * @generated from protobuf enum value: VIDEO_QUALITY_OFF = 3;
     */ VideoQuality[VideoQuality["OFF"] = 3] = "OFF";
})($8c05ed6f2f331ee8$var$VideoQuality || ($8c05ed6f2f331ee8$var$VideoQuality = {}));
/**
 * @generated from protobuf enum stream.video.sfu.models.TrackType
 */ var $8c05ed6f2f331ee8$var$TrackType;
(function(TrackType) {
    /**
     * @generated from protobuf enum value: TRACK_TYPE_UNSPECIFIED = 0;
     */ TrackType[TrackType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: TRACK_TYPE_AUDIO = 1;
     */ TrackType[TrackType["AUDIO"] = 1] = "AUDIO";
    /**
     * @generated from protobuf enum value: TRACK_TYPE_VIDEO = 2;
     */ TrackType[TrackType["VIDEO"] = 2] = "VIDEO";
    /**
     * @generated from protobuf enum value: TRACK_TYPE_SCREEN_SHARE = 3;
     */ TrackType[TrackType["SCREEN_SHARE"] = 3] = "SCREEN_SHARE";
    /**
     * @generated from protobuf enum value: TRACK_TYPE_SCREEN_SHARE_AUDIO = 4;
     */ TrackType[TrackType["SCREEN_SHARE_AUDIO"] = 4] = "SCREEN_SHARE_AUDIO";
})($8c05ed6f2f331ee8$var$TrackType || ($8c05ed6f2f331ee8$var$TrackType = {}));
/**
 * must be aligned with kit
 *
 * @generated from protobuf enum stream.video.sfu.models.ParticipantSource
 */ var $8c05ed6f2f331ee8$var$ParticipantSource;
(function(ParticipantSource) {
    /**
     * @generated from protobuf enum value: PARTICIPANT_SOURCE_WEBRTC_UNSPECIFIED = 0;
     */ ParticipantSource[ParticipantSource["WEBRTC_UNSPECIFIED"] = 0] = "WEBRTC_UNSPECIFIED";
    /**
     * @generated from protobuf enum value: PARTICIPANT_SOURCE_RTMP = 1;
     */ ParticipantSource[ParticipantSource["RTMP"] = 1] = "RTMP";
    /**
     * @generated from protobuf enum value: PARTICIPANT_SOURCE_WHIP = 2;
     */ ParticipantSource[ParticipantSource["WHIP"] = 2] = "WHIP";
    /**
     * @generated from protobuf enum value: PARTICIPANT_SOURCE_SIP = 3;
     */ ParticipantSource[ParticipantSource["SIP"] = 3] = "SIP";
    /**
     * @generated from protobuf enum value: PARTICIPANT_SOURCE_RTSP = 4;
     */ ParticipantSource[ParticipantSource["RTSP"] = 4] = "RTSP";
    /**
     * @generated from protobuf enum value: PARTICIPANT_SOURCE_SRT = 5;
     */ ParticipantSource[ParticipantSource["SRT"] = 5] = "SRT";
})($8c05ed6f2f331ee8$var$ParticipantSource || ($8c05ed6f2f331ee8$var$ParticipantSource = {}));
/**
 * @generated from protobuf enum stream.video.sfu.models.AudioBitrateProfile
 */ var $8c05ed6f2f331ee8$var$AudioBitrateProfile;
(function(AudioBitrateProfile) {
    /**
     * @generated from protobuf enum value: AUDIO_BITRATE_PROFILE_VOICE_STANDARD_UNSPECIFIED = 0;
     */ AudioBitrateProfile[AudioBitrateProfile["VOICE_STANDARD_UNSPECIFIED"] = 0] = "VOICE_STANDARD_UNSPECIFIED";
    /**
     * @generated from protobuf enum value: AUDIO_BITRATE_PROFILE_VOICE_HIGH_QUALITY = 1;
     */ AudioBitrateProfile[AudioBitrateProfile["VOICE_HIGH_QUALITY"] = 1] = "VOICE_HIGH_QUALITY";
    /**
     * @generated from protobuf enum value: AUDIO_BITRATE_PROFILE_MUSIC_HIGH_QUALITY = 2;
     */ AudioBitrateProfile[AudioBitrateProfile["MUSIC_HIGH_QUALITY"] = 2] = "MUSIC_HIGH_QUALITY";
})($8c05ed6f2f331ee8$var$AudioBitrateProfile || ($8c05ed6f2f331ee8$var$AudioBitrateProfile = {}));
/**
 * @generated from protobuf enum stream.video.sfu.models.ErrorCode
 */ var $8c05ed6f2f331ee8$var$ErrorCode;
(function(ErrorCode) {
    /**
     * @generated from protobuf enum value: ERROR_CODE_UNSPECIFIED = 0;
     */ ErrorCode[ErrorCode["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: ERROR_CODE_PUBLISH_TRACK_NOT_FOUND = 100;
     */ ErrorCode[ErrorCode["PUBLISH_TRACK_NOT_FOUND"] = 100] = "PUBLISH_TRACK_NOT_FOUND";
    /**
     * @generated from protobuf enum value: ERROR_CODE_PUBLISH_TRACKS_MISMATCH = 101;
     */ ErrorCode[ErrorCode["PUBLISH_TRACKS_MISMATCH"] = 101] = "PUBLISH_TRACKS_MISMATCH";
    /**
     * @generated from protobuf enum value: ERROR_CODE_PUBLISH_TRACK_OUT_OF_ORDER = 102;
     */ ErrorCode[ErrorCode["PUBLISH_TRACK_OUT_OF_ORDER"] = 102] = "PUBLISH_TRACK_OUT_OF_ORDER";
    /**
     * @generated from protobuf enum value: ERROR_CODE_PUBLISH_TRACK_VIDEO_LAYER_NOT_FOUND = 103;
     */ ErrorCode[ErrorCode["PUBLISH_TRACK_VIDEO_LAYER_NOT_FOUND"] = 103] = "PUBLISH_TRACK_VIDEO_LAYER_NOT_FOUND";
    /**
     * @generated from protobuf enum value: ERROR_CODE_LIVE_ENDED = 104;
     */ ErrorCode[ErrorCode["LIVE_ENDED"] = 104] = "LIVE_ENDED";
    /**
     * @generated from protobuf enum value: ERROR_CODE_PARTICIPANT_NOT_FOUND = 200;
     */ ErrorCode[ErrorCode["PARTICIPANT_NOT_FOUND"] = 200] = "PARTICIPANT_NOT_FOUND";
    /**
     * @generated from protobuf enum value: ERROR_CODE_PARTICIPANT_MIGRATING_OUT = 201;
     */ ErrorCode[ErrorCode["PARTICIPANT_MIGRATING_OUT"] = 201] = "PARTICIPANT_MIGRATING_OUT";
    /**
     * @generated from protobuf enum value: ERROR_CODE_PARTICIPANT_MIGRATION_FAILED = 202;
     */ ErrorCode[ErrorCode["PARTICIPANT_MIGRATION_FAILED"] = 202] = "PARTICIPANT_MIGRATION_FAILED";
    /**
     * @generated from protobuf enum value: ERROR_CODE_PARTICIPANT_MIGRATING = 203;
     */ ErrorCode[ErrorCode["PARTICIPANT_MIGRATING"] = 203] = "PARTICIPANT_MIGRATING";
    /**
     * @generated from protobuf enum value: ERROR_CODE_PARTICIPANT_RECONNECT_FAILED = 204;
     */ ErrorCode[ErrorCode["PARTICIPANT_RECONNECT_FAILED"] = 204] = "PARTICIPANT_RECONNECT_FAILED";
    /**
     * @generated from protobuf enum value: ERROR_CODE_PARTICIPANT_MEDIA_TRANSPORT_FAILURE = 205;
     */ ErrorCode[ErrorCode["PARTICIPANT_MEDIA_TRANSPORT_FAILURE"] = 205] = "PARTICIPANT_MEDIA_TRANSPORT_FAILURE";
    /**
     * @generated from protobuf enum value: ERROR_CODE_PARTICIPANT_SIGNAL_LOST = 206;
     */ ErrorCode[ErrorCode["PARTICIPANT_SIGNAL_LOST"] = 206] = "PARTICIPANT_SIGNAL_LOST";
    /**
     * @generated from protobuf enum value: ERROR_CODE_CALL_NOT_FOUND = 300;
     */ ErrorCode[ErrorCode["CALL_NOT_FOUND"] = 300] = "CALL_NOT_FOUND";
    /**
     * @generated from protobuf enum value: ERROR_CODE_CALL_PARTICIPANT_LIMIT_REACHED = 301;
     */ ErrorCode[ErrorCode["CALL_PARTICIPANT_LIMIT_REACHED"] = 301] = "CALL_PARTICIPANT_LIMIT_REACHED";
    /**
     * @generated from protobuf enum value: ERROR_CODE_REQUEST_VALIDATION_FAILED = 400;
     */ ErrorCode[ErrorCode["REQUEST_VALIDATION_FAILED"] = 400] = "REQUEST_VALIDATION_FAILED";
    /**
     * @generated from protobuf enum value: ERROR_CODE_UNAUTHENTICATED = 401;
     */ ErrorCode[ErrorCode["UNAUTHENTICATED"] = 401] = "UNAUTHENTICATED";
    /**
     * @generated from protobuf enum value: ERROR_CODE_PERMISSION_DENIED = 403;
     */ ErrorCode[ErrorCode["PERMISSION_DENIED"] = 403] = "PERMISSION_DENIED";
    /**
     * @generated from protobuf enum value: ERROR_CODE_TOO_MANY_REQUESTS = 429;
     */ ErrorCode[ErrorCode["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
    /**
     * @generated from protobuf enum value: ERROR_CODE_INTERNAL_SERVER_ERROR = 500;
     */ ErrorCode[ErrorCode["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
    /**
     * @generated from protobuf enum value: ERROR_CODE_SFU_SHUTTING_DOWN = 600;
     */ ErrorCode[ErrorCode["SFU_SHUTTING_DOWN"] = 600] = "SFU_SHUTTING_DOWN";
    /**
     * @generated from protobuf enum value: ERROR_CODE_SFU_FULL = 700;
     */ ErrorCode[ErrorCode["SFU_FULL"] = 700] = "SFU_FULL";
})($8c05ed6f2f331ee8$var$ErrorCode || ($8c05ed6f2f331ee8$var$ErrorCode = {}));
/**
 * @generated from protobuf enum stream.video.sfu.models.SdkType
 */ var $8c05ed6f2f331ee8$var$SdkType;
(function(SdkType) {
    /**
     * @generated from protobuf enum value: SDK_TYPE_UNSPECIFIED = 0;
     */ SdkType[SdkType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: SDK_TYPE_REACT = 1;
     */ SdkType[SdkType["REACT"] = 1] = "REACT";
    /**
     * @generated from protobuf enum value: SDK_TYPE_ANGULAR = 2;
     */ SdkType[SdkType["ANGULAR"] = 2] = "ANGULAR";
    /**
     * @generated from protobuf enum value: SDK_TYPE_ANDROID = 3;
     */ SdkType[SdkType["ANDROID"] = 3] = "ANDROID";
    /**
     * @generated from protobuf enum value: SDK_TYPE_IOS = 4;
     */ SdkType[SdkType["IOS"] = 4] = "IOS";
    /**
     * @generated from protobuf enum value: SDK_TYPE_FLUTTER = 5;
     */ SdkType[SdkType["FLUTTER"] = 5] = "FLUTTER";
    /**
     * @generated from protobuf enum value: SDK_TYPE_REACT_NATIVE = 6;
     */ SdkType[SdkType["REACT_NATIVE"] = 6] = "REACT_NATIVE";
    /**
     * @generated from protobuf enum value: SDK_TYPE_UNITY = 7;
     */ SdkType[SdkType["UNITY"] = 7] = "UNITY";
    /**
     * @generated from protobuf enum value: SDK_TYPE_GO = 8;
     */ SdkType[SdkType["GO"] = 8] = "GO";
    /**
     * @generated from protobuf enum value: SDK_TYPE_PLAIN_JAVASCRIPT = 9;
     */ SdkType[SdkType["PLAIN_JAVASCRIPT"] = 9] = "PLAIN_JAVASCRIPT";
    /**
     * @generated from protobuf enum value: SDK_TYPE_PYTHON = 10;
     */ SdkType[SdkType["PYTHON"] = 10] = "PYTHON";
    /**
     * @generated from protobuf enum value: SDK_TYPE_VISION_AGENTS = 11;
     */ SdkType[SdkType["VISION_AGENTS"] = 11] = "VISION_AGENTS";
})($8c05ed6f2f331ee8$var$SdkType || ($8c05ed6f2f331ee8$var$SdkType = {}));
/**
 * @generated from protobuf enum stream.video.sfu.models.TrackUnpublishReason
 */ var $8c05ed6f2f331ee8$var$TrackUnpublishReason;
(function(TrackUnpublishReason) {
    /**
     * Default value which is used when the specific reason
     * for muting the track is not known.
     *
     * @generated from protobuf enum value: TRACK_UNPUBLISH_REASON_UNSPECIFIED = 0;
     */ TrackUnpublishReason[TrackUnpublishReason["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * Represents user muting their tracks.
     *
     * @generated from protobuf enum value: TRACK_UNPUBLISH_REASON_USER_MUTED = 1;
     */ TrackUnpublishReason[TrackUnpublishReason["USER_MUTED"] = 1] = "USER_MUTED";
    /**
     * Represents muting the track because the permission to
     * publish the track has been revoked.
     *
     * @generated from protobuf enum value: TRACK_UNPUBLISH_REASON_PERMISSION_REVOKED = 2;
     */ TrackUnpublishReason[TrackUnpublishReason["PERMISSION_REVOKED"] = 2] = "PERMISSION_REVOKED";
    /**
     * Represents muting the track due to moderation actions.
     * This is different from permission revoked because the
     * participant can unmute themselves here whereas in case
     * of "permission revoke" it is not possible until the
     * call permissions are updated.
     *
     * @generated from protobuf enum value: TRACK_UNPUBLISH_REASON_MODERATION = 3;
     */ TrackUnpublishReason[TrackUnpublishReason["MODERATION"] = 3] = "MODERATION";
})($8c05ed6f2f331ee8$var$TrackUnpublishReason || ($8c05ed6f2f331ee8$var$TrackUnpublishReason = {}));
/**
 * GoAwayReason represents the reason for the SFU to
 * disconnect the client.
 *
 * @generated from protobuf enum stream.video.sfu.models.GoAwayReason
 */ var $8c05ed6f2f331ee8$var$GoAwayReason;
(function(GoAwayReason) {
    /**
     * @generated from protobuf enum value: GO_AWAY_REASON_UNSPECIFIED = 0;
     */ GoAwayReason[GoAwayReason["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: GO_AWAY_REASON_SHUTTING_DOWN = 1;
     */ GoAwayReason[GoAwayReason["SHUTTING_DOWN"] = 1] = "SHUTTING_DOWN";
    /**
     * @generated from protobuf enum value: GO_AWAY_REASON_REBALANCE = 2;
     */ GoAwayReason[GoAwayReason["REBALANCE"] = 2] = "REBALANCE";
})($8c05ed6f2f331ee8$var$GoAwayReason || ($8c05ed6f2f331ee8$var$GoAwayReason = {}));
/**
 * CallEndedReason represents the reason for the call to end.
 *
 * @generated from protobuf enum stream.video.sfu.models.CallEndedReason
 */ var $8c05ed6f2f331ee8$var$CallEndedReason;
(function(CallEndedReason) {
    /**
     * @generated from protobuf enum value: CALL_ENDED_REASON_UNSPECIFIED = 0;
     */ CallEndedReason[CallEndedReason["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: CALL_ENDED_REASON_ENDED = 1;
     */ CallEndedReason[CallEndedReason["ENDED"] = 1] = "ENDED";
    /**
     * @generated from protobuf enum value: CALL_ENDED_REASON_LIVE_ENDED = 2;
     */ CallEndedReason[CallEndedReason["LIVE_ENDED"] = 2] = "LIVE_ENDED";
    /**
     * @generated from protobuf enum value: CALL_ENDED_REASON_KICKED = 3;
     */ CallEndedReason[CallEndedReason["KICKED"] = 3] = "KICKED";
    /**
     * @generated from protobuf enum value: CALL_ENDED_REASON_SESSION_ENDED = 4;
     */ CallEndedReason[CallEndedReason["SESSION_ENDED"] = 4] = "SESSION_ENDED";
})($8c05ed6f2f331ee8$var$CallEndedReason || ($8c05ed6f2f331ee8$var$CallEndedReason = {}));
/**
 * WebsocketReconnectStrategy defines the ws strategies available for handling reconnections.
 *
 * @generated from protobuf enum stream.video.sfu.models.WebsocketReconnectStrategy
 */ var $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy;
(function(WebsocketReconnectStrategy) {
    /**
     * @generated from protobuf enum value: WEBSOCKET_RECONNECT_STRATEGY_UNSPECIFIED = 0;
     */ WebsocketReconnectStrategy[WebsocketReconnectStrategy["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * Sent after reaching the maximum reconnection attempts, or any other unrecoverable error leading to permanent disconnect.
     *
     * @generated from protobuf enum value: WEBSOCKET_RECONNECT_STRATEGY_DISCONNECT = 1;
     */ WebsocketReconnectStrategy[WebsocketReconnectStrategy["DISCONNECT"] = 1] = "DISCONNECT";
    /**
     * SDK should maintaining existing publisher/subscriber pc instances
     * and establish a new WebSocket connection.
     *
     * @generated from protobuf enum value: WEBSOCKET_RECONNECT_STRATEGY_FAST = 2;
     */ WebsocketReconnectStrategy[WebsocketReconnectStrategy["FAST"] = 2] = "FAST";
    /**
     * SDK should obtain new credentials from the coordinator, drops existing pc instances, set a new session_id and initializes
     * a completely new WebSocket connection, ensuring a comprehensive reset.
     *
     * @generated from protobuf enum value: WEBSOCKET_RECONNECT_STRATEGY_REJOIN = 3;
     */ WebsocketReconnectStrategy[WebsocketReconnectStrategy["REJOIN"] = 3] = "REJOIN";
    /**
     * SDK should migrate to a new SFU instance
     *
     * @generated from protobuf enum value: WEBSOCKET_RECONNECT_STRATEGY_MIGRATE = 4;
     */ WebsocketReconnectStrategy[WebsocketReconnectStrategy["MIGRATE"] = 4] = "MIGRATE";
})($8c05ed6f2f331ee8$var$WebsocketReconnectStrategy || ($8c05ed6f2f331ee8$var$WebsocketReconnectStrategy = {}));
/**
 * AndroidThermalState is reported by the Android API. The full list of values is documented here
 * https://developer.android.com/reference/android/os/PowerManager.html#getCurrentThermalStatus()
 *
 * @generated from protobuf enum stream.video.sfu.models.AndroidThermalState
 */ var $8c05ed6f2f331ee8$var$AndroidThermalState;
(function(AndroidThermalState) {
    /**
     * @generated from protobuf enum value: ANDROID_THERMAL_STATE_UNSPECIFIED = 0;
     */ AndroidThermalState[AndroidThermalState["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: ANDROID_THERMAL_STATE_NONE = 1;
     */ AndroidThermalState[AndroidThermalState["NONE"] = 1] = "NONE";
    /**
     * @generated from protobuf enum value: ANDROID_THERMAL_STATE_LIGHT = 2;
     */ AndroidThermalState[AndroidThermalState["LIGHT"] = 2] = "LIGHT";
    /**
     * @generated from protobuf enum value: ANDROID_THERMAL_STATE_MODERATE = 3;
     */ AndroidThermalState[AndroidThermalState["MODERATE"] = 3] = "MODERATE";
    /**
     * @generated from protobuf enum value: ANDROID_THERMAL_STATE_SEVERE = 4;
     */ AndroidThermalState[AndroidThermalState["SEVERE"] = 4] = "SEVERE";
    /**
     * @generated from protobuf enum value: ANDROID_THERMAL_STATE_CRITICAL = 5;
     */ AndroidThermalState[AndroidThermalState["CRITICAL"] = 5] = "CRITICAL";
    /**
     * @generated from protobuf enum value: ANDROID_THERMAL_STATE_EMERGENCY = 6;
     */ AndroidThermalState[AndroidThermalState["EMERGENCY"] = 6] = "EMERGENCY";
    /**
     * @generated from protobuf enum value: ANDROID_THERMAL_STATE_SHUTDOWN = 7;
     */ AndroidThermalState[AndroidThermalState["SHUTDOWN"] = 7] = "SHUTDOWN";
})($8c05ed6f2f331ee8$var$AndroidThermalState || ($8c05ed6f2f331ee8$var$AndroidThermalState = {}));
/**
 * AppleThermalState is the thermal state as reported by Apple devices when available or applicable to the platform.
 * The full list of states (enum) is available here: https://developer.apple.com/documentation/foundation/processinfo/thermalstate
 *
 * @generated from protobuf enum stream.video.sfu.models.AppleThermalState
 */ var $8c05ed6f2f331ee8$var$AppleThermalState;
(function(AppleThermalState) {
    /**
     * @generated from protobuf enum value: APPLE_THERMAL_STATE_UNSPECIFIED = 0;
     */ AppleThermalState[AppleThermalState["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: APPLE_THERMAL_STATE_NOMINAL = 1;
     */ AppleThermalState[AppleThermalState["NOMINAL"] = 1] = "NOMINAL";
    /**
     * @generated from protobuf enum value: APPLE_THERMAL_STATE_FAIR = 2;
     */ AppleThermalState[AppleThermalState["FAIR"] = 2] = "FAIR";
    /**
     * @generated from protobuf enum value: APPLE_THERMAL_STATE_SERIOUS = 3;
     */ AppleThermalState[AppleThermalState["SERIOUS"] = 3] = "SERIOUS";
    /**
     * @generated from protobuf enum value: APPLE_THERMAL_STATE_CRITICAL = 4;
     */ AppleThermalState[AppleThermalState["CRITICAL"] = 4] = "CRITICAL";
})($8c05ed6f2f331ee8$var$AppleThermalState || ($8c05ed6f2f331ee8$var$AppleThermalState = {}));
/**
 * ClientCapability defines a feature that client supports
 *
 * @generated from protobuf enum stream.video.sfu.models.ClientCapability
 */ var $8c05ed6f2f331ee8$var$ClientCapability;
(function(ClientCapability) {
    /**
     * @generated from protobuf enum value: CLIENT_CAPABILITY_UNSPECIFIED = 0;
     */ ClientCapability[ClientCapability["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * Enables SFU pausing inbound video
     *
     * @generated from protobuf enum value: CLIENT_CAPABILITY_SUBSCRIBER_VIDEO_PAUSE = 1;
     */ ClientCapability[ClientCapability["SUBSCRIBER_VIDEO_PAUSE"] = 1] = "SUBSCRIBER_VIDEO_PAUSE";
    /**
     * Instructs SFU that stats will be sent to the coordinator
     *
     * @generated from protobuf enum value: CLIENT_CAPABILITY_COORDINATOR_STATS = 2;
     */ ClientCapability[ClientCapability["COORDINATOR_STATS"] = 2] = "COORDINATOR_STATS";
})($8c05ed6f2f331ee8$var$ClientCapability || ($8c05ed6f2f331ee8$var$ClientCapability = {}));
/**
 * DegradationPreference represents the RTCDegradationPreference from WebRTC.
 * See https://developer.mozilla.org/en-US/docs/Web/API/RTCRtpSender/setParameters#degradationpreference
 *
 * @generated from protobuf enum stream.video.sfu.models.DegradationPreference
 */ var $8c05ed6f2f331ee8$var$DegradationPreference;
(function(DegradationPreference) {
    /**
     * @generated from protobuf enum value: DEGRADATION_PREFERENCE_UNSPECIFIED = 0;
     */ DegradationPreference[DegradationPreference["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: DEGRADATION_PREFERENCE_BALANCED = 1;
     */ DegradationPreference[DegradationPreference["BALANCED"] = 1] = "BALANCED";
    /**
     * @generated from protobuf enum value: DEGRADATION_PREFERENCE_MAINTAIN_FRAMERATE = 2;
     */ DegradationPreference[DegradationPreference["MAINTAIN_FRAMERATE"] = 2] = "MAINTAIN_FRAMERATE";
    /**
     * @generated from protobuf enum value: DEGRADATION_PREFERENCE_MAINTAIN_RESOLUTION = 3;
     */ DegradationPreference[DegradationPreference["MAINTAIN_RESOLUTION"] = 3] = "MAINTAIN_RESOLUTION";
    /**
     * @generated from protobuf enum value: DEGRADATION_PREFERENCE_MAINTAIN_FRAMERATE_AND_RESOLUTION = 4;
     */ DegradationPreference[DegradationPreference["MAINTAIN_FRAMERATE_AND_RESOLUTION"] = 4] = "MAINTAIN_FRAMERATE_AND_RESOLUTION";
})($8c05ed6f2f331ee8$var$DegradationPreference || ($8c05ed6f2f331ee8$var$DegradationPreference = {}));
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$CallState$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.CallState', [
            {
                no: 1,
                name: 'participants',
                kind: 'message',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: ()=>$8c05ed6f2f331ee8$var$Participant
            },
            {
                no: 2,
                name: 'started_at',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Timestamp
            },
            {
                no: 3,
                name: 'participant_count',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$ParticipantCount
            },
            {
                no: 4,
                name: 'pins',
                kind: 'message',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: ()=>$8c05ed6f2f331ee8$var$Pin
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.CallState
 */ const $8c05ed6f2f331ee8$var$CallState$1 = new $8c05ed6f2f331ee8$var$CallState$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$ParticipantCount$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.ParticipantCount', [
            {
                no: 1,
                name: 'total',
                kind: 'scalar',
                T: 13 /*ScalarType.UINT32*/ 
            },
            {
                no: 2,
                name: 'anonymous',
                kind: 'scalar',
                T: 13 /*ScalarType.UINT32*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.ParticipantCount
 */ const $8c05ed6f2f331ee8$var$ParticipantCount = new $8c05ed6f2f331ee8$var$ParticipantCount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$Pin$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.Pin', [
            {
                no: 1,
                name: 'user_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 2,
                name: 'session_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.Pin
 */ const $8c05ed6f2f331ee8$var$Pin = new $8c05ed6f2f331ee8$var$Pin$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$Participant$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.Participant', [
            {
                no: 1,
                name: 'user_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 2,
                name: 'session_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 3,
                name: 'published_tracks',
                kind: 'enum',
                repeat: 1 /*RepeatType.PACKED*/ ,
                T: ()=>[
                        'stream.video.sfu.models.TrackType',
                        $8c05ed6f2f331ee8$var$TrackType,
                        'TRACK_TYPE_'
                    ]
            },
            {
                no: 4,
                name: 'joined_at',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Timestamp
            },
            {
                no: 5,
                name: 'track_lookup_prefix',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 6,
                name: 'connection_quality',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.ConnectionQuality',
                        $8c05ed6f2f331ee8$var$ConnectionQuality,
                        'CONNECTION_QUALITY_'
                    ]
            },
            {
                no: 7,
                name: 'is_speaking',
                kind: 'scalar',
                T: 8 /*ScalarType.BOOL*/ 
            },
            {
                no: 8,
                name: 'is_dominant_speaker',
                kind: 'scalar',
                T: 8 /*ScalarType.BOOL*/ 
            },
            {
                no: 9,
                name: 'audio_level',
                kind: 'scalar',
                T: 2 /*ScalarType.FLOAT*/ 
            },
            {
                no: 10,
                name: 'name',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 11,
                name: 'image',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 12,
                name: 'custom',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Struct
            },
            {
                no: 13,
                name: 'roles',
                kind: 'scalar',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 14,
                name: 'source',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.ParticipantSource',
                        $8c05ed6f2f331ee8$var$ParticipantSource,
                        'PARTICIPANT_SOURCE_'
                    ]
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.Participant
 */ const $8c05ed6f2f331ee8$var$Participant = new $8c05ed6f2f331ee8$var$Participant$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$StreamQuality$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.StreamQuality', [
            {
                no: 1,
                name: 'video_quality',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.VideoQuality',
                        $8c05ed6f2f331ee8$var$VideoQuality,
                        'VIDEO_QUALITY_'
                    ]
            },
            {
                no: 2,
                name: 'user_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.StreamQuality
 */ const $8c05ed6f2f331ee8$var$StreamQuality = new $8c05ed6f2f331ee8$var$StreamQuality$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$VideoDimension$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.VideoDimension', [
            {
                no: 1,
                name: 'width',
                kind: 'scalar',
                T: 13 /*ScalarType.UINT32*/ 
            },
            {
                no: 2,
                name: 'height',
                kind: 'scalar',
                T: 13 /*ScalarType.UINT32*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.VideoDimension
 */ const $8c05ed6f2f331ee8$var$VideoDimension = new $8c05ed6f2f331ee8$var$VideoDimension$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$VideoLayer$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.VideoLayer', [
            {
                no: 1,
                name: 'rid',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 2,
                name: 'video_dimension',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$VideoDimension
            },
            {
                no: 4,
                name: 'bitrate',
                kind: 'scalar',
                T: 13 /*ScalarType.UINT32*/ 
            },
            {
                no: 5,
                name: 'fps',
                kind: 'scalar',
                T: 13 /*ScalarType.UINT32*/ 
            },
            {
                no: 6,
                name: 'quality',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.VideoQuality',
                        $8c05ed6f2f331ee8$var$VideoQuality,
                        'VIDEO_QUALITY_'
                    ]
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.VideoLayer
 */ const $8c05ed6f2f331ee8$var$VideoLayer = new $8c05ed6f2f331ee8$var$VideoLayer$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$SubscribeOption$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.SubscribeOption', [
            {
                no: 1,
                name: 'track_type',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.TrackType',
                        $8c05ed6f2f331ee8$var$TrackType,
                        'TRACK_TYPE_'
                    ]
            },
            {
                no: 2,
                name: 'codecs',
                kind: 'message',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: ()=>$8c05ed6f2f331ee8$var$Codec
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.SubscribeOption
 */ const $8c05ed6f2f331ee8$var$SubscribeOption = new $8c05ed6f2f331ee8$var$SubscribeOption$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$PublishOption$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.PublishOption', [
            {
                no: 1,
                name: 'track_type',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.TrackType',
                        $8c05ed6f2f331ee8$var$TrackType,
                        'TRACK_TYPE_'
                    ]
            },
            {
                no: 2,
                name: 'codec',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Codec
            },
            {
                no: 3,
                name: 'bitrate',
                kind: 'scalar',
                T: 5 /*ScalarType.INT32*/ 
            },
            {
                no: 4,
                name: 'fps',
                kind: 'scalar',
                T: 5 /*ScalarType.INT32*/ 
            },
            {
                no: 5,
                name: 'max_spatial_layers',
                kind: 'scalar',
                T: 5 /*ScalarType.INT32*/ 
            },
            {
                no: 6,
                name: 'max_temporal_layers',
                kind: 'scalar',
                T: 5 /*ScalarType.INT32*/ 
            },
            {
                no: 7,
                name: 'video_dimension',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$VideoDimension
            },
            {
                no: 8,
                name: 'id',
                kind: 'scalar',
                T: 5 /*ScalarType.INT32*/ 
            },
            {
                no: 9,
                name: 'use_single_layer',
                kind: 'scalar',
                T: 8 /*ScalarType.BOOL*/ 
            },
            {
                no: 10,
                name: 'audio_bitrate_profiles',
                kind: 'message',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: ()=>$8c05ed6f2f331ee8$var$AudioBitrate
            },
            {
                no: 11,
                name: 'degradation_preference',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.DegradationPreference',
                        $8c05ed6f2f331ee8$var$DegradationPreference,
                        'DEGRADATION_PREFERENCE_'
                    ]
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.PublishOption
 */ const $8c05ed6f2f331ee8$var$PublishOption = new $8c05ed6f2f331ee8$var$PublishOption$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$Codec$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.Codec', [
            {
                no: 16,
                name: 'payload_type',
                kind: 'scalar',
                T: 13 /*ScalarType.UINT32*/ 
            },
            {
                no: 10,
                name: 'name',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 14,
                name: 'clock_rate',
                kind: 'scalar',
                T: 13 /*ScalarType.UINT32*/ 
            },
            {
                no: 15,
                name: 'encoding_parameters',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 12,
                name: 'fmtp',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.Codec
 */ const $8c05ed6f2f331ee8$var$Codec = new $8c05ed6f2f331ee8$var$Codec$Type();
// @generated message type with reflection information, may provide speed optimized methods
let $8c05ed6f2f331ee8$var$ICETrickle$Type$1 = class ICETrickle$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.ICETrickle', [
            {
                no: 1,
                name: 'peer_type',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.PeerType',
                        $8c05ed6f2f331ee8$var$PeerType,
                        'PEER_TYPE_'
                    ]
            },
            {
                no: 2,
                name: 'ice_candidate',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 3,
                name: 'session_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            }
        ]);
    }
};
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.ICETrickle
 */ const $8c05ed6f2f331ee8$var$ICETrickle$1 = new $8c05ed6f2f331ee8$var$ICETrickle$Type$1();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$AudioBitrate$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.AudioBitrate', [
            {
                no: 1,
                name: 'profile',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.AudioBitrateProfile',
                        $8c05ed6f2f331ee8$var$AudioBitrateProfile,
                        'AUDIO_BITRATE_PROFILE_'
                    ]
            },
            {
                no: 2,
                name: 'bitrate',
                kind: 'scalar',
                T: 5 /*ScalarType.INT32*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.AudioBitrate
 */ const $8c05ed6f2f331ee8$var$AudioBitrate = new $8c05ed6f2f331ee8$var$AudioBitrate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$TrackInfo$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.TrackInfo', [
            {
                no: 1,
                name: 'track_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 2,
                name: 'track_type',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.TrackType',
                        $8c05ed6f2f331ee8$var$TrackType,
                        'TRACK_TYPE_'
                    ]
            },
            {
                no: 5,
                name: 'layers',
                kind: 'message',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: ()=>$8c05ed6f2f331ee8$var$VideoLayer
            },
            {
                no: 6,
                name: 'mid',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 7,
                name: 'dtx',
                kind: 'scalar',
                T: 8 /*ScalarType.BOOL*/ 
            },
            {
                no: 8,
                name: 'stereo',
                kind: 'scalar',
                T: 8 /*ScalarType.BOOL*/ 
            },
            {
                no: 9,
                name: 'red',
                kind: 'scalar',
                T: 8 /*ScalarType.BOOL*/ 
            },
            {
                no: 10,
                name: 'muted',
                kind: 'scalar',
                T: 8 /*ScalarType.BOOL*/ 
            },
            {
                no: 11,
                name: 'codec',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Codec
            },
            {
                no: 12,
                name: 'publish_option_id',
                kind: 'scalar',
                T: 5 /*ScalarType.INT32*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.TrackInfo
 */ const $8c05ed6f2f331ee8$var$TrackInfo = new $8c05ed6f2f331ee8$var$TrackInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
let $8c05ed6f2f331ee8$var$Error$Type$1 = class Error$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.Error', [
            {
                no: 1,
                name: 'code',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.ErrorCode',
                        $8c05ed6f2f331ee8$var$ErrorCode,
                        'ERROR_CODE_'
                    ]
            },
            {
                no: 2,
                name: 'message',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 3,
                name: 'should_retry',
                kind: 'scalar',
                T: 8 /*ScalarType.BOOL*/ 
            }
        ]);
    }
};
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.Error
 */ const $8c05ed6f2f331ee8$var$Error$2 = new $8c05ed6f2f331ee8$var$Error$Type$1();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$ClientDetails$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.ClientDetails', [
            {
                no: 1,
                name: 'sdk',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Sdk
            },
            {
                no: 2,
                name: 'os',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$OS
            },
            {
                no: 3,
                name: 'browser',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Browser
            },
            {
                no: 4,
                name: 'device',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Device
            },
            {
                no: 5,
                name: 'webrtc_version',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.ClientDetails
 */ const $8c05ed6f2f331ee8$var$ClientDetails = new $8c05ed6f2f331ee8$var$ClientDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$Sdk$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.Sdk', [
            {
                no: 1,
                name: 'type',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.SdkType',
                        $8c05ed6f2f331ee8$var$SdkType,
                        'SDK_TYPE_'
                    ]
            },
            {
                no: 2,
                name: 'major',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 3,
                name: 'minor',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 4,
                name: 'patch',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.Sdk
 */ const $8c05ed6f2f331ee8$var$Sdk = new $8c05ed6f2f331ee8$var$Sdk$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$OS$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.OS', [
            {
                no: 1,
                name: 'name',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 2,
                name: 'version',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 3,
                name: 'architecture',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.OS
 */ const $8c05ed6f2f331ee8$var$OS = new $8c05ed6f2f331ee8$var$OS$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$Browser$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.Browser', [
            {
                no: 1,
                name: 'name',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 2,
                name: 'version',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.Browser
 */ const $8c05ed6f2f331ee8$var$Browser = new $8c05ed6f2f331ee8$var$Browser$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$RTMPIngress$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.RTMPIngress', [
            {
                no: 1,
                name: 'width',
                kind: 'scalar',
                T: 13 /*ScalarType.UINT32*/ 
            },
            {
                no: 2,
                name: 'height',
                kind: 'scalar',
                T: 13 /*ScalarType.UINT32*/ 
            },
            {
                no: 3,
                name: 'frame_rate',
                kind: 'scalar',
                T: 1 /*ScalarType.DOUBLE*/ 
            },
            {
                no: 4,
                name: 'software',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 5,
                name: 'version',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 6,
                name: 'encoder',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 7,
                name: 'remote_addr',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.RTMPIngress
 */ const $8c05ed6f2f331ee8$var$RTMPIngress = new $8c05ed6f2f331ee8$var$RTMPIngress$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$Device$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.Device', [
            {
                no: 1,
                name: 'name',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 2,
                name: 'version',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.Device
 */ const $8c05ed6f2f331ee8$var$Device = new $8c05ed6f2f331ee8$var$Device$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$Call$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.Call', [
            {
                no: 1,
                name: 'type',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 2,
                name: 'id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 3,
                name: 'created_by_user_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 4,
                name: 'host_user_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 5,
                name: 'custom',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Struct
            },
            {
                no: 6,
                name: 'created_at',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Timestamp
            },
            {
                no: 7,
                name: 'updated_at',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Timestamp
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.Call
 */ const $8c05ed6f2f331ee8$var$Call$1 = new $8c05ed6f2f331ee8$var$Call$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$CallGrants$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.CallGrants', [
            {
                no: 1,
                name: 'can_publish_audio',
                kind: 'scalar',
                T: 8 /*ScalarType.BOOL*/ 
            },
            {
                no: 2,
                name: 'can_publish_video',
                kind: 'scalar',
                T: 8 /*ScalarType.BOOL*/ 
            },
            {
                no: 3,
                name: 'can_screenshare',
                kind: 'scalar',
                T: 8 /*ScalarType.BOOL*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.CallGrants
 */ const $8c05ed6f2f331ee8$var$CallGrants = new $8c05ed6f2f331ee8$var$CallGrants$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$InputDevices$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.InputDevices', [
            {
                no: 1,
                name: 'available_devices',
                kind: 'scalar',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 2,
                name: 'current_device',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 3,
                name: 'is_permitted',
                kind: 'scalar',
                T: 8 /*ScalarType.BOOL*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.InputDevices
 */ const $8c05ed6f2f331ee8$var$InputDevices = new $8c05ed6f2f331ee8$var$InputDevices$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$AndroidState$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.AndroidState', [
            {
                no: 1,
                name: 'thermal_state',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.AndroidThermalState',
                        $8c05ed6f2f331ee8$var$AndroidThermalState,
                        'ANDROID_THERMAL_STATE_'
                    ]
            },
            {
                no: 2,
                name: 'is_power_saver_mode',
                kind: 'scalar',
                T: 8 /*ScalarType.BOOL*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.AndroidState
 */ const $8c05ed6f2f331ee8$var$AndroidState = new $8c05ed6f2f331ee8$var$AndroidState$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$AppleState$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.AppleState', [
            {
                no: 1,
                name: 'thermal_state',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.AppleThermalState',
                        $8c05ed6f2f331ee8$var$AppleThermalState,
                        'APPLE_THERMAL_STATE_'
                    ]
            },
            {
                no: 2,
                name: 'is_low_power_mode_enabled',
                kind: 'scalar',
                T: 8 /*ScalarType.BOOL*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.AppleState
 */ const $8c05ed6f2f331ee8$var$AppleState = new $8c05ed6f2f331ee8$var$AppleState$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$PerformanceStats$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.PerformanceStats', [
            {
                no: 1,
                name: 'track_type',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.TrackType',
                        $8c05ed6f2f331ee8$var$TrackType,
                        'TRACK_TYPE_'
                    ]
            },
            {
                no: 2,
                name: 'codec',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Codec
            },
            {
                no: 3,
                name: 'avg_frame_time_ms',
                kind: 'scalar',
                T: 2 /*ScalarType.FLOAT*/ 
            },
            {
                no: 4,
                name: 'avg_fps',
                kind: 'scalar',
                T: 2 /*ScalarType.FLOAT*/ 
            },
            {
                no: 5,
                name: 'video_dimension',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$VideoDimension
            },
            {
                no: 6,
                name: 'target_bitrate',
                kind: 'scalar',
                T: 5 /*ScalarType.INT32*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.PerformanceStats
 */ const $8c05ed6f2f331ee8$var$PerformanceStats = new $8c05ed6f2f331ee8$var$PerformanceStats$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$RtpBase$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.RtpBase', [
            {
                no: 1,
                name: 'ssrc',
                kind: 'scalar',
                T: 13 /*ScalarType.UINT32*/ 
            },
            {
                no: 2,
                name: 'kind',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 3,
                name: 'timestamp_ms',
                kind: 'scalar',
                T: 1 /*ScalarType.DOUBLE*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.RtpBase
 */ const $8c05ed6f2f331ee8$var$RtpBase = new $8c05ed6f2f331ee8$var$RtpBase$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$InboundRtp$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.InboundRtp', [
            {
                no: 1,
                name: 'base',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$RtpBase
            },
            {
                no: 2,
                name: 'jitter_seconds',
                kind: 'scalar',
                T: 1 /*ScalarType.DOUBLE*/ 
            },
            {
                no: 3,
                name: 'packets_received',
                kind: 'scalar',
                T: 4 /*ScalarType.UINT64*/ 
            },
            {
                no: 4,
                name: 'packets_lost',
                kind: 'scalar',
                T: 4 /*ScalarType.UINT64*/ 
            },
            {
                no: 5,
                name: 'packet_loss_percent',
                kind: 'scalar',
                T: 1 /*ScalarType.DOUBLE*/ 
            },
            {
                no: 10,
                name: 'concealment_events',
                kind: 'scalar',
                T: 13 /*ScalarType.UINT32*/ 
            },
            {
                no: 11,
                name: 'concealment_percent',
                kind: 'scalar',
                T: 1 /*ScalarType.DOUBLE*/ 
            },
            {
                no: 20,
                name: 'fps',
                kind: 'scalar',
                T: 1 /*ScalarType.DOUBLE*/ 
            },
            {
                no: 21,
                name: 'freeze_duration_seconds',
                kind: 'scalar',
                T: 1 /*ScalarType.DOUBLE*/ 
            },
            {
                no: 22,
                name: 'avg_decode_time_seconds',
                kind: 'scalar',
                T: 1 /*ScalarType.DOUBLE*/ 
            },
            {
                no: 23,
                name: 'min_dimension_px',
                kind: 'scalar',
                T: 13 /*ScalarType.UINT32*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.InboundRtp
 */ const $8c05ed6f2f331ee8$var$InboundRtp = new $8c05ed6f2f331ee8$var$InboundRtp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$OutboundRtp$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.OutboundRtp', [
            {
                no: 1,
                name: 'base',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$RtpBase
            },
            {
                no: 10,
                name: 'fps',
                kind: 'scalar',
                T: 1 /*ScalarType.DOUBLE*/ 
            },
            {
                no: 11,
                name: 'avg_encode_time_seconds',
                kind: 'scalar',
                T: 1 /*ScalarType.DOUBLE*/ 
            },
            {
                no: 12,
                name: 'bitrate_bps',
                kind: 'scalar',
                T: 1 /*ScalarType.DOUBLE*/ 
            },
            {
                no: 13,
                name: 'min_dimension_px',
                kind: 'scalar',
                T: 13 /*ScalarType.UINT32*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.OutboundRtp
 */ const $8c05ed6f2f331ee8$var$OutboundRtp = new $8c05ed6f2f331ee8$var$OutboundRtp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$RemoteInboundRtp$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.RemoteInboundRtp', [
            {
                no: 1,
                name: 'base',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$RtpBase
            },
            {
                no: 2,
                name: 'jitter_seconds',
                kind: 'scalar',
                T: 1 /*ScalarType.DOUBLE*/ 
            },
            {
                no: 3,
                name: 'round_trip_time_s',
                kind: 'scalar',
                T: 1 /*ScalarType.DOUBLE*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.RemoteInboundRtp
 */ const $8c05ed6f2f331ee8$var$RemoteInboundRtp = new $8c05ed6f2f331ee8$var$RemoteInboundRtp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$RemoteOutboundRtp$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.models.RemoteOutboundRtp', [
            {
                no: 1,
                name: 'base',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$RtpBase
            },
            {
                no: 2,
                name: 'jitter_seconds',
                kind: 'scalar',
                T: 1 /*ScalarType.DOUBLE*/ 
            },
            {
                no: 3,
                name: 'round_trip_time_s',
                kind: 'scalar',
                T: 1 /*ScalarType.DOUBLE*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.models.RemoteOutboundRtp
 */ const $8c05ed6f2f331ee8$var$RemoteOutboundRtp = new $8c05ed6f2f331ee8$var$RemoteOutboundRtp$Type();
var $8c05ed6f2f331ee8$export$92370efed7f617c = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    AndroidState: $8c05ed6f2f331ee8$var$AndroidState,
    get AndroidThermalState () {
        return $8c05ed6f2f331ee8$var$AndroidThermalState;
    },
    AppleState: $8c05ed6f2f331ee8$var$AppleState,
    get AppleThermalState () {
        return $8c05ed6f2f331ee8$var$AppleThermalState;
    },
    AudioBitrate: $8c05ed6f2f331ee8$var$AudioBitrate,
    get AudioBitrateProfile () {
        return $8c05ed6f2f331ee8$var$AudioBitrateProfile;
    },
    Browser: $8c05ed6f2f331ee8$var$Browser,
    Call: $8c05ed6f2f331ee8$var$Call$1,
    get CallEndedReason () {
        return $8c05ed6f2f331ee8$var$CallEndedReason;
    },
    CallGrants: $8c05ed6f2f331ee8$var$CallGrants,
    CallState: $8c05ed6f2f331ee8$var$CallState$1,
    get ClientCapability () {
        return $8c05ed6f2f331ee8$var$ClientCapability;
    },
    ClientDetails: $8c05ed6f2f331ee8$var$ClientDetails,
    Codec: $8c05ed6f2f331ee8$var$Codec,
    get ConnectionQuality () {
        return $8c05ed6f2f331ee8$var$ConnectionQuality;
    },
    get DegradationPreference () {
        return $8c05ed6f2f331ee8$var$DegradationPreference;
    },
    Device: $8c05ed6f2f331ee8$var$Device,
    Error: $8c05ed6f2f331ee8$var$Error$2,
    get ErrorCode () {
        return $8c05ed6f2f331ee8$var$ErrorCode;
    },
    get GoAwayReason () {
        return $8c05ed6f2f331ee8$var$GoAwayReason;
    },
    ICETrickle: $8c05ed6f2f331ee8$var$ICETrickle$1,
    InboundRtp: $8c05ed6f2f331ee8$var$InboundRtp,
    InputDevices: $8c05ed6f2f331ee8$var$InputDevices,
    OS: $8c05ed6f2f331ee8$var$OS,
    OutboundRtp: $8c05ed6f2f331ee8$var$OutboundRtp,
    Participant: $8c05ed6f2f331ee8$var$Participant,
    ParticipantCount: $8c05ed6f2f331ee8$var$ParticipantCount,
    get ParticipantSource () {
        return $8c05ed6f2f331ee8$var$ParticipantSource;
    },
    get PeerType () {
        return $8c05ed6f2f331ee8$var$PeerType;
    },
    PerformanceStats: $8c05ed6f2f331ee8$var$PerformanceStats,
    Pin: $8c05ed6f2f331ee8$var$Pin,
    PublishOption: $8c05ed6f2f331ee8$var$PublishOption,
    RTMPIngress: $8c05ed6f2f331ee8$var$RTMPIngress,
    RemoteInboundRtp: $8c05ed6f2f331ee8$var$RemoteInboundRtp,
    RemoteOutboundRtp: $8c05ed6f2f331ee8$var$RemoteOutboundRtp,
    RtpBase: $8c05ed6f2f331ee8$var$RtpBase,
    Sdk: $8c05ed6f2f331ee8$var$Sdk,
    get SdkType () {
        return $8c05ed6f2f331ee8$var$SdkType;
    },
    StreamQuality: $8c05ed6f2f331ee8$var$StreamQuality,
    SubscribeOption: $8c05ed6f2f331ee8$var$SubscribeOption,
    TrackInfo: $8c05ed6f2f331ee8$var$TrackInfo,
    get TrackType () {
        return $8c05ed6f2f331ee8$var$TrackType;
    },
    get TrackUnpublishReason () {
        return $8c05ed6f2f331ee8$var$TrackUnpublishReason;
    },
    VideoDimension: $8c05ed6f2f331ee8$var$VideoDimension,
    VideoLayer: $8c05ed6f2f331ee8$var$VideoLayer,
    get VideoQuality () {
        return $8c05ed6f2f331ee8$var$VideoQuality;
    },
    get WebsocketReconnectStrategy () {
        return $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy;
    }
});
// @generated by protobuf-ts 2.10.0 with parameter long_type_string,client_generic,server_none,eslint_disable,optimize_code_size
// @generated from protobuf file "video/sfu/signal_rpc/signal.proto" (package "stream.video.sfu.signal", syntax proto3)
// tslint:disable
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$StartNoiseCancellationRequest$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.signal.StartNoiseCancellationRequest', [
            {
                no: 1,
                name: 'session_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.signal.StartNoiseCancellationRequest
 */ const $8c05ed6f2f331ee8$var$StartNoiseCancellationRequest = new $8c05ed6f2f331ee8$var$StartNoiseCancellationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$StartNoiseCancellationResponse$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.signal.StartNoiseCancellationResponse', [
            {
                no: 1,
                name: 'error',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Error$2
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.signal.StartNoiseCancellationResponse
 */ const $8c05ed6f2f331ee8$var$StartNoiseCancellationResponse = new $8c05ed6f2f331ee8$var$StartNoiseCancellationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$StopNoiseCancellationRequest$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.signal.StopNoiseCancellationRequest', [
            {
                no: 1,
                name: 'session_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.signal.StopNoiseCancellationRequest
 */ const $8c05ed6f2f331ee8$var$StopNoiseCancellationRequest = new $8c05ed6f2f331ee8$var$StopNoiseCancellationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$StopNoiseCancellationResponse$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.signal.StopNoiseCancellationResponse', [
            {
                no: 1,
                name: 'error',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Error$2
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.signal.StopNoiseCancellationResponse
 */ const $8c05ed6f2f331ee8$var$StopNoiseCancellationResponse = new $8c05ed6f2f331ee8$var$StopNoiseCancellationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$Reconnection$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.signal.Reconnection', [
            {
                no: 1,
                name: 'time_seconds',
                kind: 'scalar',
                T: 2 /*ScalarType.FLOAT*/ 
            },
            {
                no: 2,
                name: 'strategy',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.WebsocketReconnectStrategy',
                        $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy,
                        'WEBSOCKET_RECONNECT_STRATEGY_'
                    ]
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.signal.Reconnection
 */ const $8c05ed6f2f331ee8$var$Reconnection = new $8c05ed6f2f331ee8$var$Reconnection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$Telemetry$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.signal.Telemetry', [
            {
                no: 1,
                name: 'connection_time_seconds',
                kind: 'scalar',
                oneof: 'data',
                T: 2 /*ScalarType.FLOAT*/ 
            },
            {
                no: 2,
                name: 'reconnection',
                kind: 'message',
                oneof: 'data',
                T: ()=>$8c05ed6f2f331ee8$var$Reconnection
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.signal.Telemetry
 */ const $8c05ed6f2f331ee8$var$Telemetry = new $8c05ed6f2f331ee8$var$Telemetry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$SendMetricsRequest$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.signal.SendMetricsRequest', [
            {
                no: 1,
                name: 'session_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 2,
                name: 'unified_session_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 3,
                name: 'inbounds',
                kind: 'message',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: ()=>$8c05ed6f2f331ee8$var$InboundRtp
            },
            {
                no: 4,
                name: 'outbounds',
                kind: 'message',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: ()=>$8c05ed6f2f331ee8$var$OutboundRtp
            },
            {
                no: 5,
                name: 'remote_inbounds',
                kind: 'message',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: ()=>$8c05ed6f2f331ee8$var$RemoteInboundRtp
            },
            {
                no: 6,
                name: 'remote_outbounds',
                kind: 'message',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: ()=>$8c05ed6f2f331ee8$var$RemoteOutboundRtp
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.signal.SendMetricsRequest
 */ const $8c05ed6f2f331ee8$var$SendMetricsRequest = new $8c05ed6f2f331ee8$var$SendMetricsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$SendMetricsResponse$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.signal.SendMetricsResponse', []);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.signal.SendMetricsResponse
 */ const $8c05ed6f2f331ee8$var$SendMetricsResponse = new $8c05ed6f2f331ee8$var$SendMetricsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$SendStatsRequest$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.signal.SendStatsRequest', [
            {
                no: 1,
                name: 'session_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 2,
                name: 'subscriber_stats',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 3,
                name: 'publisher_stats',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 4,
                name: 'webrtc_version',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 5,
                name: 'sdk',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 6,
                name: 'sdk_version',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 7,
                name: 'audio_devices',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$InputDevices
            },
            {
                no: 8,
                name: 'video_devices',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$InputDevices
            },
            {
                no: 9,
                name: 'android',
                kind: 'message',
                oneof: 'deviceState',
                T: ()=>$8c05ed6f2f331ee8$var$AndroidState
            },
            {
                no: 10,
                name: 'apple',
                kind: 'message',
                oneof: 'deviceState',
                T: ()=>$8c05ed6f2f331ee8$var$AppleState
            },
            {
                no: 11,
                name: 'telemetry',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Telemetry
            },
            {
                no: 12,
                name: 'rtmp',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$RTMPIngress
            },
            {
                no: 13,
                name: 'subscriber_rtc_stats',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 14,
                name: 'publisher_rtc_stats',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 15,
                name: 'rtc_stats',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 16,
                name: 'encode_stats',
                kind: 'message',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: ()=>$8c05ed6f2f331ee8$var$PerformanceStats
            },
            {
                no: 17,
                name: 'decode_stats',
                kind: 'message',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: ()=>$8c05ed6f2f331ee8$var$PerformanceStats
            },
            {
                no: 18,
                name: 'unified_session_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.signal.SendStatsRequest
 */ const $8c05ed6f2f331ee8$var$SendStatsRequest = new $8c05ed6f2f331ee8$var$SendStatsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$SendStatsResponse$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.signal.SendStatsResponse', [
            {
                no: 1,
                name: 'error',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Error$2
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.signal.SendStatsResponse
 */ const $8c05ed6f2f331ee8$var$SendStatsResponse = new $8c05ed6f2f331ee8$var$SendStatsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$ICERestartRequest$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.signal.ICERestartRequest', [
            {
                no: 1,
                name: 'session_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 2,
                name: 'peer_type',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.PeerType',
                        $8c05ed6f2f331ee8$var$PeerType,
                        'PEER_TYPE_'
                    ]
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.signal.ICERestartRequest
 */ const $8c05ed6f2f331ee8$var$ICERestartRequest = new $8c05ed6f2f331ee8$var$ICERestartRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$ICERestartResponse$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.signal.ICERestartResponse', [
            {
                no: 1,
                name: 'error',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Error$2
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.signal.ICERestartResponse
 */ const $8c05ed6f2f331ee8$var$ICERestartResponse = new $8c05ed6f2f331ee8$var$ICERestartResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$UpdateMuteStatesRequest$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.signal.UpdateMuteStatesRequest', [
            {
                no: 1,
                name: 'session_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 3,
                name: 'mute_states',
                kind: 'message',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: ()=>$8c05ed6f2f331ee8$var$TrackMuteState
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.signal.UpdateMuteStatesRequest
 */ const $8c05ed6f2f331ee8$var$UpdateMuteStatesRequest = new $8c05ed6f2f331ee8$var$UpdateMuteStatesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$UpdateMuteStatesResponse$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.signal.UpdateMuteStatesResponse', [
            {
                no: 4,
                name: 'error',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Error$2
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.signal.UpdateMuteStatesResponse
 */ const $8c05ed6f2f331ee8$var$UpdateMuteStatesResponse = new $8c05ed6f2f331ee8$var$UpdateMuteStatesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$TrackMuteState$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.signal.TrackMuteState', [
            {
                no: 1,
                name: 'track_type',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.TrackType',
                        $8c05ed6f2f331ee8$var$TrackType,
                        'TRACK_TYPE_'
                    ]
            },
            {
                no: 2,
                name: 'muted',
                kind: 'scalar',
                T: 8 /*ScalarType.BOOL*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.signal.TrackMuteState
 */ const $8c05ed6f2f331ee8$var$TrackMuteState = new $8c05ed6f2f331ee8$var$TrackMuteState$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$AudioMuteChanged$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.signal.AudioMuteChanged', [
            {
                no: 1,
                name: 'muted',
                kind: 'scalar',
                T: 8 /*ScalarType.BOOL*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.signal.AudioMuteChanged
 */ new $8c05ed6f2f331ee8$var$AudioMuteChanged$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$VideoMuteChanged$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.signal.VideoMuteChanged', [
            {
                no: 2,
                name: 'muted',
                kind: 'scalar',
                T: 8 /*ScalarType.BOOL*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.signal.VideoMuteChanged
 */ new $8c05ed6f2f331ee8$var$VideoMuteChanged$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$UpdateSubscriptionsRequest$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.signal.UpdateSubscriptionsRequest', [
            {
                no: 2,
                name: 'session_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 3,
                name: 'tracks',
                kind: 'message',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: ()=>$8c05ed6f2f331ee8$var$TrackSubscriptionDetails
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.signal.UpdateSubscriptionsRequest
 */ const $8c05ed6f2f331ee8$var$UpdateSubscriptionsRequest = new $8c05ed6f2f331ee8$var$UpdateSubscriptionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$UpdateSubscriptionsResponse$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.signal.UpdateSubscriptionsResponse', [
            {
                no: 4,
                name: 'error',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Error$2
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.signal.UpdateSubscriptionsResponse
 */ const $8c05ed6f2f331ee8$var$UpdateSubscriptionsResponse = new $8c05ed6f2f331ee8$var$UpdateSubscriptionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$TrackSubscriptionDetails$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.signal.TrackSubscriptionDetails', [
            {
                no: 1,
                name: 'user_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 2,
                name: 'session_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 3,
                name: 'track_type',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.TrackType',
                        $8c05ed6f2f331ee8$var$TrackType,
                        'TRACK_TYPE_'
                    ]
            },
            {
                no: 4,
                name: 'dimension',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$VideoDimension
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.signal.TrackSubscriptionDetails
 */ const $8c05ed6f2f331ee8$var$TrackSubscriptionDetails = new $8c05ed6f2f331ee8$var$TrackSubscriptionDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$SendAnswerRequest$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.signal.SendAnswerRequest', [
            {
                no: 1,
                name: 'peer_type',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.PeerType',
                        $8c05ed6f2f331ee8$var$PeerType,
                        'PEER_TYPE_'
                    ]
            },
            {
                no: 2,
                name: 'sdp',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 3,
                name: 'session_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 4,
                name: 'negotiation_id',
                kind: 'scalar',
                T: 13 /*ScalarType.UINT32*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.signal.SendAnswerRequest
 */ const $8c05ed6f2f331ee8$var$SendAnswerRequest = new $8c05ed6f2f331ee8$var$SendAnswerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$SendAnswerResponse$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.signal.SendAnswerResponse', [
            {
                no: 4,
                name: 'error',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Error$2
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.signal.SendAnswerResponse
 */ const $8c05ed6f2f331ee8$var$SendAnswerResponse = new $8c05ed6f2f331ee8$var$SendAnswerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$ICETrickleResponse$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.signal.ICETrickleResponse', [
            {
                no: 4,
                name: 'error',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Error$2
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.signal.ICETrickleResponse
 */ const $8c05ed6f2f331ee8$var$ICETrickleResponse = new $8c05ed6f2f331ee8$var$ICETrickleResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$SetPublisherRequest$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.signal.SetPublisherRequest', [
            {
                no: 1,
                name: 'sdp',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 2,
                name: 'session_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 3,
                name: 'tracks',
                kind: 'message',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: ()=>$8c05ed6f2f331ee8$var$TrackInfo
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.signal.SetPublisherRequest
 */ const $8c05ed6f2f331ee8$var$SetPublisherRequest = new $8c05ed6f2f331ee8$var$SetPublisherRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$SetPublisherResponse$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.signal.SetPublisherResponse', [
            {
                no: 1,
                name: 'sdp',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 2,
                name: 'session_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 3,
                name: 'ice_restart',
                kind: 'scalar',
                T: 8 /*ScalarType.BOOL*/ 
            },
            {
                no: 4,
                name: 'error',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Error$2
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.signal.SetPublisherResponse
 */ const $8c05ed6f2f331ee8$var$SetPublisherResponse = new $8c05ed6f2f331ee8$var$SetPublisherResponse$Type();
/**
 * @generated ServiceType for protobuf service stream.video.sfu.signal.SignalServer
 */ const $8c05ed6f2f331ee8$var$SignalServer = new (0, $deb1fa1d99288264$export$a2897b486520c8f3)('stream.video.sfu.signal.SignalServer', [
    {
        name: 'SetPublisher',
        options: {},
        I: $8c05ed6f2f331ee8$var$SetPublisherRequest,
        O: $8c05ed6f2f331ee8$var$SetPublisherResponse
    },
    {
        name: 'SendAnswer',
        options: {},
        I: $8c05ed6f2f331ee8$var$SendAnswerRequest,
        O: $8c05ed6f2f331ee8$var$SendAnswerResponse
    },
    {
        name: 'IceTrickle',
        options: {},
        I: $8c05ed6f2f331ee8$var$ICETrickle$1,
        O: $8c05ed6f2f331ee8$var$ICETrickleResponse
    },
    {
        name: 'UpdateSubscriptions',
        options: {},
        I: $8c05ed6f2f331ee8$var$UpdateSubscriptionsRequest,
        O: $8c05ed6f2f331ee8$var$UpdateSubscriptionsResponse
    },
    {
        name: 'UpdateMuteStates',
        options: {},
        I: $8c05ed6f2f331ee8$var$UpdateMuteStatesRequest,
        O: $8c05ed6f2f331ee8$var$UpdateMuteStatesResponse
    },
    {
        name: 'IceRestart',
        options: {},
        I: $8c05ed6f2f331ee8$var$ICERestartRequest,
        O: $8c05ed6f2f331ee8$var$ICERestartResponse
    },
    {
        name: 'SendStats',
        options: {},
        I: $8c05ed6f2f331ee8$var$SendStatsRequest,
        O: $8c05ed6f2f331ee8$var$SendStatsResponse
    },
    {
        name: 'SendMetrics',
        options: {},
        I: $8c05ed6f2f331ee8$var$SendMetricsRequest,
        O: $8c05ed6f2f331ee8$var$SendMetricsResponse
    },
    {
        name: 'StartNoiseCancellation',
        options: {},
        I: $8c05ed6f2f331ee8$var$StartNoiseCancellationRequest,
        O: $8c05ed6f2f331ee8$var$StartNoiseCancellationResponse
    },
    {
        name: 'StopNoiseCancellation',
        options: {},
        I: $8c05ed6f2f331ee8$var$StopNoiseCancellationRequest,
        O: $8c05ed6f2f331ee8$var$StopNoiseCancellationResponse
    }
]);
// @generated by protobuf-ts 2.10.0 with parameter long_type_string,client_generic,server_none,eslint_disable,optimize_code_size
// @generated from protobuf file "video/sfu/event/events.proto" (package "stream.video.sfu.event", syntax proto3)
// tslint:disable
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$SfuEvent$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.SfuEvent', [
            {
                no: 1,
                name: 'subscriber_offer',
                kind: 'message',
                oneof: 'eventPayload',
                T: ()=>$8c05ed6f2f331ee8$var$SubscriberOffer
            },
            {
                no: 2,
                name: 'publisher_answer',
                kind: 'message',
                oneof: 'eventPayload',
                T: ()=>$8c05ed6f2f331ee8$var$PublisherAnswer
            },
            {
                no: 3,
                name: 'connection_quality_changed',
                kind: 'message',
                oneof: 'eventPayload',
                T: ()=>$8c05ed6f2f331ee8$var$ConnectionQualityChanged
            },
            {
                no: 4,
                name: 'audio_level_changed',
                kind: 'message',
                oneof: 'eventPayload',
                T: ()=>$8c05ed6f2f331ee8$var$AudioLevelChanged
            },
            {
                no: 5,
                name: 'ice_trickle',
                kind: 'message',
                oneof: 'eventPayload',
                T: ()=>$8c05ed6f2f331ee8$var$ICETrickle$1
            },
            {
                no: 6,
                name: 'change_publish_quality',
                kind: 'message',
                oneof: 'eventPayload',
                T: ()=>$8c05ed6f2f331ee8$var$ChangePublishQuality
            },
            {
                no: 10,
                name: 'participant_joined',
                kind: 'message',
                oneof: 'eventPayload',
                T: ()=>$8c05ed6f2f331ee8$var$ParticipantJoined
            },
            {
                no: 11,
                name: 'participant_left',
                kind: 'message',
                oneof: 'eventPayload',
                T: ()=>$8c05ed6f2f331ee8$var$ParticipantLeft
            },
            {
                no: 12,
                name: 'dominant_speaker_changed',
                kind: 'message',
                oneof: 'eventPayload',
                T: ()=>$8c05ed6f2f331ee8$var$DominantSpeakerChanged
            },
            {
                no: 13,
                name: 'join_response',
                kind: 'message',
                oneof: 'eventPayload',
                T: ()=>$8c05ed6f2f331ee8$var$JoinResponse
            },
            {
                no: 14,
                name: 'health_check_response',
                kind: 'message',
                oneof: 'eventPayload',
                T: ()=>$8c05ed6f2f331ee8$var$HealthCheckResponse
            },
            {
                no: 16,
                name: 'track_published',
                kind: 'message',
                oneof: 'eventPayload',
                T: ()=>$8c05ed6f2f331ee8$var$TrackPublished
            },
            {
                no: 17,
                name: 'track_unpublished',
                kind: 'message',
                oneof: 'eventPayload',
                T: ()=>$8c05ed6f2f331ee8$var$TrackUnpublished
            },
            {
                no: 18,
                name: 'error',
                kind: 'message',
                oneof: 'eventPayload',
                T: ()=>$8c05ed6f2f331ee8$var$Error$1
            },
            {
                no: 19,
                name: 'call_grants_updated',
                kind: 'message',
                oneof: 'eventPayload',
                T: ()=>$8c05ed6f2f331ee8$var$CallGrantsUpdated
            },
            {
                no: 20,
                name: 'go_away',
                kind: 'message',
                oneof: 'eventPayload',
                T: ()=>$8c05ed6f2f331ee8$var$GoAway
            },
            {
                no: 21,
                name: 'ice_restart',
                kind: 'message',
                oneof: 'eventPayload',
                T: ()=>$8c05ed6f2f331ee8$var$ICERestart
            },
            {
                no: 22,
                name: 'pins_updated',
                kind: 'message',
                oneof: 'eventPayload',
                T: ()=>$8c05ed6f2f331ee8$var$PinsChanged
            },
            {
                no: 23,
                name: 'call_ended',
                kind: 'message',
                oneof: 'eventPayload',
                T: ()=>$8c05ed6f2f331ee8$var$CallEnded
            },
            {
                no: 24,
                name: 'participant_updated',
                kind: 'message',
                oneof: 'eventPayload',
                T: ()=>$8c05ed6f2f331ee8$var$ParticipantUpdated
            },
            {
                no: 25,
                name: 'participant_migration_complete',
                kind: 'message',
                oneof: 'eventPayload',
                T: ()=>$8c05ed6f2f331ee8$var$ParticipantMigrationComplete
            },
            {
                no: 27,
                name: 'change_publish_options',
                kind: 'message',
                oneof: 'eventPayload',
                T: ()=>$8c05ed6f2f331ee8$var$ChangePublishOptions
            },
            {
                no: 28,
                name: 'inbound_state_notification',
                kind: 'message',
                oneof: 'eventPayload',
                T: ()=>$8c05ed6f2f331ee8$var$InboundStateNotification
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.SfuEvent
 */ const $8c05ed6f2f331ee8$var$SfuEvent = new $8c05ed6f2f331ee8$var$SfuEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$ChangePublishOptions$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.ChangePublishOptions', [
            {
                no: 1,
                name: 'publish_options',
                kind: 'message',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: ()=>$8c05ed6f2f331ee8$var$PublishOption
            },
            {
                no: 2,
                name: 'reason',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.ChangePublishOptions
 */ const $8c05ed6f2f331ee8$var$ChangePublishOptions = new $8c05ed6f2f331ee8$var$ChangePublishOptions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$ChangePublishOptionsComplete$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.ChangePublishOptionsComplete', []);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.ChangePublishOptionsComplete
 */ const $8c05ed6f2f331ee8$var$ChangePublishOptionsComplete = new $8c05ed6f2f331ee8$var$ChangePublishOptionsComplete$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$ParticipantMigrationComplete$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.ParticipantMigrationComplete', []);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.ParticipantMigrationComplete
 */ const $8c05ed6f2f331ee8$var$ParticipantMigrationComplete = new $8c05ed6f2f331ee8$var$ParticipantMigrationComplete$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$PinsChanged$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.PinsChanged', [
            {
                no: 1,
                name: 'pins',
                kind: 'message',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: ()=>$8c05ed6f2f331ee8$var$Pin
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.PinsChanged
 */ const $8c05ed6f2f331ee8$var$PinsChanged = new $8c05ed6f2f331ee8$var$PinsChanged$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$Error$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.Error', [
            {
                no: 4,
                name: 'error',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Error$2
            },
            {
                no: 5,
                name: 'reconnect_strategy',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.WebsocketReconnectStrategy',
                        $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy,
                        'WEBSOCKET_RECONNECT_STRATEGY_'
                    ]
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.Error
 */ const $8c05ed6f2f331ee8$var$Error$1 = new $8c05ed6f2f331ee8$var$Error$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$ICETrickle$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.ICETrickle', [
            {
                no: 1,
                name: 'peer_type',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.PeerType',
                        $8c05ed6f2f331ee8$var$PeerType,
                        'PEER_TYPE_'
                    ]
            },
            {
                no: 2,
                name: 'ice_candidate',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.ICETrickle
 */ const $8c05ed6f2f331ee8$var$ICETrickle = new $8c05ed6f2f331ee8$var$ICETrickle$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$ICERestart$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.ICERestart', [
            {
                no: 1,
                name: 'peer_type',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.PeerType',
                        $8c05ed6f2f331ee8$var$PeerType,
                        'PEER_TYPE_'
                    ]
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.ICERestart
 */ const $8c05ed6f2f331ee8$var$ICERestart = new $8c05ed6f2f331ee8$var$ICERestart$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$SfuRequest$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.SfuRequest', [
            {
                no: 1,
                name: 'join_request',
                kind: 'message',
                oneof: 'requestPayload',
                T: ()=>$8c05ed6f2f331ee8$var$JoinRequest
            },
            {
                no: 2,
                name: 'health_check_request',
                kind: 'message',
                oneof: 'requestPayload',
                T: ()=>$8c05ed6f2f331ee8$var$HealthCheckRequest
            },
            {
                no: 3,
                name: 'leave_call_request',
                kind: 'message',
                oneof: 'requestPayload',
                T: ()=>$8c05ed6f2f331ee8$var$LeaveCallRequest
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.SfuRequest
 */ const $8c05ed6f2f331ee8$var$SfuRequest = new $8c05ed6f2f331ee8$var$SfuRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$LeaveCallRequest$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.LeaveCallRequest', [
            {
                no: 1,
                name: 'session_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 2,
                name: 'reason',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.LeaveCallRequest
 */ const $8c05ed6f2f331ee8$var$LeaveCallRequest = new $8c05ed6f2f331ee8$var$LeaveCallRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$HealthCheckRequest$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.HealthCheckRequest', []);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.HealthCheckRequest
 */ const $8c05ed6f2f331ee8$var$HealthCheckRequest = new $8c05ed6f2f331ee8$var$HealthCheckRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$HealthCheckResponse$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.HealthCheckResponse', [
            {
                no: 1,
                name: 'participant_count',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$ParticipantCount
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.HealthCheckResponse
 */ const $8c05ed6f2f331ee8$var$HealthCheckResponse = new $8c05ed6f2f331ee8$var$HealthCheckResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$TrackPublished$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.TrackPublished', [
            {
                no: 1,
                name: 'user_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 2,
                name: 'session_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 3,
                name: 'type',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.TrackType',
                        $8c05ed6f2f331ee8$var$TrackType,
                        'TRACK_TYPE_'
                    ]
            },
            {
                no: 4,
                name: 'participant',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Participant
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.TrackPublished
 */ const $8c05ed6f2f331ee8$var$TrackPublished = new $8c05ed6f2f331ee8$var$TrackPublished$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$TrackUnpublished$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.TrackUnpublished', [
            {
                no: 1,
                name: 'user_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 2,
                name: 'session_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 3,
                name: 'type',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.TrackType',
                        $8c05ed6f2f331ee8$var$TrackType,
                        'TRACK_TYPE_'
                    ]
            },
            {
                no: 4,
                name: 'cause',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.TrackUnpublishReason',
                        $8c05ed6f2f331ee8$var$TrackUnpublishReason,
                        'TRACK_UNPUBLISH_REASON_'
                    ]
            },
            {
                no: 5,
                name: 'participant',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Participant
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.TrackUnpublished
 */ const $8c05ed6f2f331ee8$var$TrackUnpublished = new $8c05ed6f2f331ee8$var$TrackUnpublished$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$JoinRequest$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.JoinRequest', [
            {
                no: 1,
                name: 'token',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 2,
                name: 'session_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 13,
                name: 'unified_session_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 3,
                name: 'subscriber_sdp',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 8,
                name: 'publisher_sdp',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 4,
                name: 'client_details',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$ClientDetails
            },
            {
                no: 5,
                name: 'migration',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Migration
            },
            {
                no: 6,
                name: 'fast_reconnect',
                kind: 'scalar',
                T: 8 /*ScalarType.BOOL*/ 
            },
            {
                no: 7,
                name: 'reconnect_details',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$ReconnectDetails
            },
            {
                no: 9,
                name: 'preferred_publish_options',
                kind: 'message',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: ()=>$8c05ed6f2f331ee8$var$PublishOption
            },
            {
                no: 10,
                name: 'preferred_subscribe_options',
                kind: 'message',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: ()=>$8c05ed6f2f331ee8$var$SubscribeOption
            },
            {
                no: 11,
                name: 'capabilities',
                kind: 'enum',
                repeat: 1 /*RepeatType.PACKED*/ ,
                T: ()=>[
                        'stream.video.sfu.models.ClientCapability',
                        $8c05ed6f2f331ee8$var$ClientCapability,
                        'CLIENT_CAPABILITY_'
                    ]
            },
            {
                no: 12,
                name: 'source',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.ParticipantSource',
                        $8c05ed6f2f331ee8$var$ParticipantSource,
                        'PARTICIPANT_SOURCE_'
                    ]
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.JoinRequest
 */ const $8c05ed6f2f331ee8$var$JoinRequest = new $8c05ed6f2f331ee8$var$JoinRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$ReconnectDetails$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.ReconnectDetails', [
            {
                no: 1,
                name: 'strategy',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.WebsocketReconnectStrategy',
                        $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy,
                        'WEBSOCKET_RECONNECT_STRATEGY_'
                    ]
            },
            {
                no: 3,
                name: 'announced_tracks',
                kind: 'message',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: ()=>$8c05ed6f2f331ee8$var$TrackInfo
            },
            {
                no: 4,
                name: 'subscriptions',
                kind: 'message',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: ()=>$8c05ed6f2f331ee8$var$TrackSubscriptionDetails
            },
            {
                no: 5,
                name: 'reconnect_attempt',
                kind: 'scalar',
                T: 13 /*ScalarType.UINT32*/ 
            },
            {
                no: 6,
                name: 'from_sfu_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 7,
                name: 'previous_session_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 8,
                name: 'reason',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.ReconnectDetails
 */ const $8c05ed6f2f331ee8$var$ReconnectDetails = new $8c05ed6f2f331ee8$var$ReconnectDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$Migration$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.Migration', [
            {
                no: 1,
                name: 'from_sfu_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 2,
                name: 'announced_tracks',
                kind: 'message',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: ()=>$8c05ed6f2f331ee8$var$TrackInfo
            },
            {
                no: 3,
                name: 'subscriptions',
                kind: 'message',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: ()=>$8c05ed6f2f331ee8$var$TrackSubscriptionDetails
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.Migration
 */ const $8c05ed6f2f331ee8$var$Migration = new $8c05ed6f2f331ee8$var$Migration$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$JoinResponse$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.JoinResponse', [
            {
                no: 1,
                name: 'call_state',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$CallState$1
            },
            {
                no: 2,
                name: 'reconnected',
                kind: 'scalar',
                T: 8 /*ScalarType.BOOL*/ 
            },
            {
                no: 3,
                name: 'fast_reconnect_deadline_seconds',
                kind: 'scalar',
                T: 5 /*ScalarType.INT32*/ 
            },
            {
                no: 4,
                name: 'publish_options',
                kind: 'message',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: ()=>$8c05ed6f2f331ee8$var$PublishOption
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.JoinResponse
 */ const $8c05ed6f2f331ee8$var$JoinResponse = new $8c05ed6f2f331ee8$var$JoinResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$ParticipantJoined$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.ParticipantJoined', [
            {
                no: 1,
                name: 'call_cid',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 2,
                name: 'participant',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Participant
            },
            {
                no: 3,
                name: 'is_pinned',
                kind: 'scalar',
                T: 8 /*ScalarType.BOOL*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.ParticipantJoined
 */ const $8c05ed6f2f331ee8$var$ParticipantJoined = new $8c05ed6f2f331ee8$var$ParticipantJoined$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$ParticipantLeft$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.ParticipantLeft', [
            {
                no: 1,
                name: 'call_cid',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 2,
                name: 'participant',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Participant
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.ParticipantLeft
 */ const $8c05ed6f2f331ee8$var$ParticipantLeft = new $8c05ed6f2f331ee8$var$ParticipantLeft$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$ParticipantUpdated$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.ParticipantUpdated', [
            {
                no: 1,
                name: 'call_cid',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 2,
                name: 'participant',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Participant
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.ParticipantUpdated
 */ const $8c05ed6f2f331ee8$var$ParticipantUpdated = new $8c05ed6f2f331ee8$var$ParticipantUpdated$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$SubscriberOffer$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.SubscriberOffer', [
            {
                no: 1,
                name: 'ice_restart',
                kind: 'scalar',
                T: 8 /*ScalarType.BOOL*/ 
            },
            {
                no: 2,
                name: 'sdp',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 3,
                name: 'negotiation_id',
                kind: 'scalar',
                T: 13 /*ScalarType.UINT32*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.SubscriberOffer
 */ const $8c05ed6f2f331ee8$var$SubscriberOffer = new $8c05ed6f2f331ee8$var$SubscriberOffer$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$PublisherAnswer$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.PublisherAnswer', [
            {
                no: 1,
                name: 'sdp',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.PublisherAnswer
 */ const $8c05ed6f2f331ee8$var$PublisherAnswer = new $8c05ed6f2f331ee8$var$PublisherAnswer$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$ConnectionQualityChanged$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.ConnectionQualityChanged', [
            {
                no: 1,
                name: 'connection_quality_updates',
                kind: 'message',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: ()=>$8c05ed6f2f331ee8$var$ConnectionQualityInfo
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.ConnectionQualityChanged
 */ const $8c05ed6f2f331ee8$var$ConnectionQualityChanged = new $8c05ed6f2f331ee8$var$ConnectionQualityChanged$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$ConnectionQualityInfo$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.ConnectionQualityInfo', [
            {
                no: 1,
                name: 'user_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 2,
                name: 'session_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 3,
                name: 'connection_quality',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.ConnectionQuality',
                        $8c05ed6f2f331ee8$var$ConnectionQuality,
                        'CONNECTION_QUALITY_'
                    ]
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.ConnectionQualityInfo
 */ const $8c05ed6f2f331ee8$var$ConnectionQualityInfo = new $8c05ed6f2f331ee8$var$ConnectionQualityInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$DominantSpeakerChanged$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.DominantSpeakerChanged', [
            {
                no: 1,
                name: 'user_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 2,
                name: 'session_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.DominantSpeakerChanged
 */ const $8c05ed6f2f331ee8$var$DominantSpeakerChanged = new $8c05ed6f2f331ee8$var$DominantSpeakerChanged$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$AudioLevel$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.AudioLevel', [
            {
                no: 1,
                name: 'user_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 2,
                name: 'session_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 3,
                name: 'level',
                kind: 'scalar',
                T: 2 /*ScalarType.FLOAT*/ 
            },
            {
                no: 4,
                name: 'is_speaking',
                kind: 'scalar',
                T: 8 /*ScalarType.BOOL*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.AudioLevel
 */ const $8c05ed6f2f331ee8$var$AudioLevel = new $8c05ed6f2f331ee8$var$AudioLevel$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$AudioLevelChanged$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.AudioLevelChanged', [
            {
                no: 1,
                name: 'audio_levels',
                kind: 'message',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: ()=>$8c05ed6f2f331ee8$var$AudioLevel
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.AudioLevelChanged
 */ const $8c05ed6f2f331ee8$var$AudioLevelChanged = new $8c05ed6f2f331ee8$var$AudioLevelChanged$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$AudioSender$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.AudioSender', [
            {
                no: 2,
                name: 'codec',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Codec
            },
            {
                no: 3,
                name: 'track_type',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.TrackType',
                        $8c05ed6f2f331ee8$var$TrackType,
                        'TRACK_TYPE_'
                    ]
            },
            {
                no: 4,
                name: 'publish_option_id',
                kind: 'scalar',
                T: 5 /*ScalarType.INT32*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.AudioSender
 */ const $8c05ed6f2f331ee8$var$AudioSender = new $8c05ed6f2f331ee8$var$AudioSender$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$VideoLayerSetting$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.VideoLayerSetting', [
            {
                no: 1,
                name: 'name',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 2,
                name: 'active',
                kind: 'scalar',
                T: 8 /*ScalarType.BOOL*/ 
            },
            {
                no: 3,
                name: 'max_bitrate',
                kind: 'scalar',
                T: 5 /*ScalarType.INT32*/ 
            },
            {
                no: 4,
                name: 'scale_resolution_down_by',
                kind: 'scalar',
                T: 2 /*ScalarType.FLOAT*/ 
            },
            {
                no: 6,
                name: 'codec',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Codec
            },
            {
                no: 7,
                name: 'max_framerate',
                kind: 'scalar',
                T: 13 /*ScalarType.UINT32*/ 
            },
            {
                no: 8,
                name: 'scalability_mode',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.VideoLayerSetting
 */ const $8c05ed6f2f331ee8$var$VideoLayerSetting = new $8c05ed6f2f331ee8$var$VideoLayerSetting$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$VideoSender$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.VideoSender', [
            {
                no: 2,
                name: 'codec',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$Codec
            },
            {
                no: 3,
                name: 'layers',
                kind: 'message',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: ()=>$8c05ed6f2f331ee8$var$VideoLayerSetting
            },
            {
                no: 4,
                name: 'track_type',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.TrackType',
                        $8c05ed6f2f331ee8$var$TrackType,
                        'TRACK_TYPE_'
                    ]
            },
            {
                no: 5,
                name: 'publish_option_id',
                kind: 'scalar',
                T: 5 /*ScalarType.INT32*/ 
            },
            {
                no: 6,
                name: 'degradation_preference',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.DegradationPreference',
                        $8c05ed6f2f331ee8$var$DegradationPreference,
                        'DEGRADATION_PREFERENCE_'
                    ]
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.VideoSender
 */ const $8c05ed6f2f331ee8$var$VideoSender = new $8c05ed6f2f331ee8$var$VideoSender$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$ChangePublishQuality$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.ChangePublishQuality', [
            {
                no: 1,
                name: 'audio_senders',
                kind: 'message',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: ()=>$8c05ed6f2f331ee8$var$AudioSender
            },
            {
                no: 2,
                name: 'video_senders',
                kind: 'message',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: ()=>$8c05ed6f2f331ee8$var$VideoSender
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.ChangePublishQuality
 */ const $8c05ed6f2f331ee8$var$ChangePublishQuality = new $8c05ed6f2f331ee8$var$ChangePublishQuality$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$CallGrantsUpdated$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.CallGrantsUpdated', [
            {
                no: 1,
                name: 'current_grants',
                kind: 'message',
                T: ()=>$8c05ed6f2f331ee8$var$CallGrants
            },
            {
                no: 2,
                name: 'message',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.CallGrantsUpdated
 */ const $8c05ed6f2f331ee8$var$CallGrantsUpdated = new $8c05ed6f2f331ee8$var$CallGrantsUpdated$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$GoAway$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.GoAway', [
            {
                no: 1,
                name: 'reason',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.GoAwayReason',
                        $8c05ed6f2f331ee8$var$GoAwayReason,
                        'GO_AWAY_REASON_'
                    ]
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.GoAway
 */ const $8c05ed6f2f331ee8$var$GoAway = new $8c05ed6f2f331ee8$var$GoAway$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$CallEnded$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.CallEnded', [
            {
                no: 1,
                name: 'reason',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.CallEndedReason',
                        $8c05ed6f2f331ee8$var$CallEndedReason,
                        'CALL_ENDED_REASON_'
                    ]
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.CallEnded
 */ const $8c05ed6f2f331ee8$var$CallEnded = new $8c05ed6f2f331ee8$var$CallEnded$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$InboundStateNotification$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.InboundStateNotification', [
            {
                no: 1,
                name: 'inbound_video_states',
                kind: 'message',
                repeat: 2 /*RepeatType.UNPACKED*/ ,
                T: ()=>$8c05ed6f2f331ee8$var$InboundVideoState
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.InboundStateNotification
 */ const $8c05ed6f2f331ee8$var$InboundStateNotification = new $8c05ed6f2f331ee8$var$InboundStateNotification$Type();
// @generated message type with reflection information, may provide speed optimized methods
class $8c05ed6f2f331ee8$var$InboundVideoState$Type extends (0, $20209612832397f7$export$80edbf15fa61a4db) {
    constructor(){
        super('stream.video.sfu.event.InboundVideoState', [
            {
                no: 1,
                name: 'user_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 2,
                name: 'session_id',
                kind: 'scalar',
                T: 9 /*ScalarType.STRING*/ 
            },
            {
                no: 3,
                name: 'track_type',
                kind: 'enum',
                T: ()=>[
                        'stream.video.sfu.models.TrackType',
                        $8c05ed6f2f331ee8$var$TrackType,
                        'TRACK_TYPE_'
                    ]
            },
            {
                no: 4,
                name: 'paused',
                kind: 'scalar',
                T: 8 /*ScalarType.BOOL*/ 
            }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message stream.video.sfu.event.InboundVideoState
 */ const $8c05ed6f2f331ee8$var$InboundVideoState = new $8c05ed6f2f331ee8$var$InboundVideoState$Type();
var $8c05ed6f2f331ee8$export$34d3ab89519a3716 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    AudioLevel: $8c05ed6f2f331ee8$var$AudioLevel,
    AudioLevelChanged: $8c05ed6f2f331ee8$var$AudioLevelChanged,
    AudioSender: $8c05ed6f2f331ee8$var$AudioSender,
    CallEnded: $8c05ed6f2f331ee8$var$CallEnded,
    CallGrantsUpdated: $8c05ed6f2f331ee8$var$CallGrantsUpdated,
    ChangePublishOptions: $8c05ed6f2f331ee8$var$ChangePublishOptions,
    ChangePublishOptionsComplete: $8c05ed6f2f331ee8$var$ChangePublishOptionsComplete,
    ChangePublishQuality: $8c05ed6f2f331ee8$var$ChangePublishQuality,
    ConnectionQualityChanged: $8c05ed6f2f331ee8$var$ConnectionQualityChanged,
    ConnectionQualityInfo: $8c05ed6f2f331ee8$var$ConnectionQualityInfo,
    DominantSpeakerChanged: $8c05ed6f2f331ee8$var$DominantSpeakerChanged,
    Error: $8c05ed6f2f331ee8$var$Error$1,
    GoAway: $8c05ed6f2f331ee8$var$GoAway,
    HealthCheckRequest: $8c05ed6f2f331ee8$var$HealthCheckRequest,
    HealthCheckResponse: $8c05ed6f2f331ee8$var$HealthCheckResponse,
    ICERestart: $8c05ed6f2f331ee8$var$ICERestart,
    ICETrickle: $8c05ed6f2f331ee8$var$ICETrickle,
    InboundStateNotification: $8c05ed6f2f331ee8$var$InboundStateNotification,
    InboundVideoState: $8c05ed6f2f331ee8$var$InboundVideoState,
    JoinRequest: $8c05ed6f2f331ee8$var$JoinRequest,
    JoinResponse: $8c05ed6f2f331ee8$var$JoinResponse,
    LeaveCallRequest: $8c05ed6f2f331ee8$var$LeaveCallRequest,
    Migration: $8c05ed6f2f331ee8$var$Migration,
    ParticipantJoined: $8c05ed6f2f331ee8$var$ParticipantJoined,
    ParticipantLeft: $8c05ed6f2f331ee8$var$ParticipantLeft,
    ParticipantMigrationComplete: $8c05ed6f2f331ee8$var$ParticipantMigrationComplete,
    ParticipantUpdated: $8c05ed6f2f331ee8$var$ParticipantUpdated,
    PinsChanged: $8c05ed6f2f331ee8$var$PinsChanged,
    PublisherAnswer: $8c05ed6f2f331ee8$var$PublisherAnswer,
    ReconnectDetails: $8c05ed6f2f331ee8$var$ReconnectDetails,
    SfuEvent: $8c05ed6f2f331ee8$var$SfuEvent,
    SfuRequest: $8c05ed6f2f331ee8$var$SfuRequest,
    SubscriberOffer: $8c05ed6f2f331ee8$var$SubscriberOffer,
    TrackPublished: $8c05ed6f2f331ee8$var$TrackPublished,
    TrackUnpublished: $8c05ed6f2f331ee8$var$TrackUnpublished,
    VideoLayerSetting: $8c05ed6f2f331ee8$var$VideoLayerSetting,
    VideoSender: $8c05ed6f2f331ee8$var$VideoSender
});
var $8c05ed6f2f331ee8$export$1655277b7107d364;
(function(VisibilityState) {
    VisibilityState["UNKNOWN"] = "UNKNOWN";
    VisibilityState["VISIBLE"] = "VISIBLE";
    VisibilityState["INVISIBLE"] = "INVISIBLE";
})($8c05ed6f2f331ee8$export$1655277b7107d364 || ($8c05ed6f2f331ee8$export$1655277b7107d364 = {}));
var $8c05ed6f2f331ee8$export$3acc78ff76ca7d90;
(function(DebounceType) {
    DebounceType[DebounceType["IMMEDIATE"] = 20] = "IMMEDIATE";
    DebounceType[DebounceType["FAST"] = 100] = "FAST";
    DebounceType[DebounceType["MEDIUM"] = 600] = "MEDIUM";
    DebounceType[DebounceType["SLOW"] = 1200] = "SLOW";
})($8c05ed6f2f331ee8$export$3acc78ff76ca7d90 || ($8c05ed6f2f331ee8$export$3acc78ff76ca7d90 = {}));
/**
 * @generated from protobuf service stream.video.sfu.signal.SignalServer
 */ class $8c05ed6f2f331ee8$var$SignalServerClient {
    constructor(_transport){
        this._transport = _transport;
        this.typeName = $8c05ed6f2f331ee8$var$SignalServer.typeName;
        this.methods = $8c05ed6f2f331ee8$var$SignalServer.methods;
        this.options = $8c05ed6f2f331ee8$var$SignalServer.options;
    }
    /**
     * SetPublisher sends the WebRTC offer for the peer connection used to publish A/V
     *
     * @generated from protobuf rpc: SetPublisher(stream.video.sfu.signal.SetPublisherRequest) returns (stream.video.sfu.signal.SetPublisherResponse);
     */ setPublisher(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return (0, $5cf4629fd19c312e$export$762bd1dd98f14729)('unary', this._transport, method, opt, input);
    }
    /**
     * answer is sent by the client to the SFU after receiving a subscriber_offer.
     *
     * @generated from protobuf rpc: SendAnswer(stream.video.sfu.signal.SendAnswerRequest) returns (stream.video.sfu.signal.SendAnswerResponse);
     */ sendAnswer(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return (0, $5cf4629fd19c312e$export$762bd1dd98f14729)('unary', this._transport, method, opt, input);
    }
    /**
     * SendICECandidate sends an ICE candidate to the client
     *
     * @generated from protobuf rpc: IceTrickle(stream.video.sfu.models.ICETrickle) returns (stream.video.sfu.signal.ICETrickleResponse);
     */ iceTrickle(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return (0, $5cf4629fd19c312e$export$762bd1dd98f14729)('unary', this._transport, method, opt, input);
    }
    /**
     * UpdateSubscribers is used to notify the SFU about the list of video subscriptions
     * TODO: sync subscriptions based on this + update tracks using the dimension info sent by the user
     *
     * @generated from protobuf rpc: UpdateSubscriptions(stream.video.sfu.signal.UpdateSubscriptionsRequest) returns (stream.video.sfu.signal.UpdateSubscriptionsResponse);
     */ updateSubscriptions(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return (0, $5cf4629fd19c312e$export$762bd1dd98f14729)('unary', this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateMuteStates(stream.video.sfu.signal.UpdateMuteStatesRequest) returns (stream.video.sfu.signal.UpdateMuteStatesResponse);
     */ updateMuteStates(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return (0, $5cf4629fd19c312e$export$762bd1dd98f14729)('unary', this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: IceRestart(stream.video.sfu.signal.ICERestartRequest) returns (stream.video.sfu.signal.ICERestartResponse);
     */ iceRestart(input, options) {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return (0, $5cf4629fd19c312e$export$762bd1dd98f14729)('unary', this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SendStats(stream.video.sfu.signal.SendStatsRequest) returns (stream.video.sfu.signal.SendStatsResponse);
     */ sendStats(input, options) {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return (0, $5cf4629fd19c312e$export$762bd1dd98f14729)('unary', this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SendMetrics(stream.video.sfu.signal.SendMetricsRequest) returns (stream.video.sfu.signal.SendMetricsResponse);
     */ sendMetrics(input, options) {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return (0, $5cf4629fd19c312e$export$762bd1dd98f14729)('unary', this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: StartNoiseCancellation(stream.video.sfu.signal.StartNoiseCancellationRequest) returns (stream.video.sfu.signal.StartNoiseCancellationResponse);
     */ startNoiseCancellation(input, options) {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return (0, $5cf4629fd19c312e$export$762bd1dd98f14729)('unary', this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: StopNoiseCancellation(stream.video.sfu.signal.StopNoiseCancellationRequest) returns (stream.video.sfu.signal.StopNoiseCancellationResponse);
     */ stopNoiseCancellation(input, options) {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return (0, $5cf4629fd19c312e$export$762bd1dd98f14729)('unary', this._transport, method, opt, input);
    }
}
const $8c05ed6f2f331ee8$var$defaultOptions = {
    baseUrl: '',
    sendJson: true,
    timeout: 5000,
    jsonOptions: {
        ignoreUnknownFields: true
    }
};
const $8c05ed6f2f331ee8$var$withHeaders = (headers)=>{
    return {
        interceptUnary (next, method, input, options) {
            options.meta = {
                ...options.meta,
                ...headers
            };
            return next(method, input, options);
        }
    };
};
const $8c05ed6f2f331ee8$var$TIMEOUT_SYMBOL = '@@stream-io/timeout';
const $8c05ed6f2f331ee8$var$withTimeout = (timeoutMs, trace)=>{
    const scheduleTimeout = (methodName)=>{
        const controller = new AbortController();
        // aborts with specially crafted error that can be reliably recognized by
        // @protobuf-ts/twirp-transport and our internal retry logic.
        // https://github.com/timostamm/protobuf-ts/blob/657e64e80009e503e94f608fda423fbcbf4fb5a7/packages/twirp-transport/src/twirp-transport.ts#L102-L107
        const timeoutId = setTimeout(()=>{
            trace?.(`${methodName}Timeout`, [
                timeoutMs
            ]);
            const error = new Error($8c05ed6f2f331ee8$var$TIMEOUT_SYMBOL);
            error.name = 'AbortError';
            controller.abort(error);
        }, timeoutMs);
        return [
            controller.signal,
            ()=>clearTimeout(timeoutId)
        ];
    };
    return {
        interceptUnary (next, method, input, options) {
            // respect external abort signals if provided
            if (options.abort) return next(method, input, options);
            // set up a custom abort signal for the RPC call
            const [signal, cancel] = scheduleTimeout(method.name);
            const invocation = next(method, input, {
                ...options,
                abort: signal
            });
            invocation.then(cancel, cancel);
            return invocation;
        }
    };
};
const $8c05ed6f2f331ee8$var$withRequestLogger = (logger, level = 'trace')=>{
    return {
        interceptUnary: (next, method, input, options)=>{
            const invocation = next(method, input, options);
            logger[level](`Invoked SFU RPC method ${method.name}`, {
                request: invocation.request,
                headers: invocation.requestHeaders,
                response: invocation.response
            });
            return invocation;
        }
    };
};
const $8c05ed6f2f331ee8$var$withRequestTracer = (trace)=>{
    const exclusions = new Set([
        'SendStats'
    ]);
    const responseInclusions = new Set([
        'SetPublisher'
    ]);
    const traceError = (name, input, err)=>trace(`${name}OnFailure`, [
            err,
            input
        ]);
    return {
        interceptUnary (next, method, input, options) {
            const methodName = method.name;
            if (exclusions.has(methodName)) return next(method, input, options);
            const { invocationMeta: { attempt: attempt = 0 } = {} } = options;
            const traceName = attempt === 0 ? methodName : `${methodName}(${attempt})`;
            trace(traceName, input);
            const unaryCall = next(method, input, options);
            unaryCall.then((invocation)=>{
                const response = invocation.response;
                if (response.error) traceError(traceName, input, response.error);
                if (responseInclusions.has(methodName)) trace(`${traceName}Response`, response);
            }, (error)=>traceError(methodName, input, error));
            return unaryCall;
        }
    };
};
/**
 * Creates new SignalServerClient instance.
 *
 * @param options the twirp options.
 */ const $8c05ed6f2f331ee8$var$createSignalClient = (options)=>{
    const transport = new (0, $173a986e7ce6493c$export$7172f10038f2ec3f)({
        ...$8c05ed6f2f331ee8$var$defaultOptions,
        ...options
    });
    return new $8c05ed6f2f331ee8$var$SignalServerClient(transport);
};
const $8c05ed6f2f331ee8$var$sleep = (m)=>new Promise((r)=>setTimeout(r, m));
const $8c05ed6f2f331ee8$var$timeboxed = async (promises, ms)=>{
    let timerId;
    const timeout = new Promise((_, reject)=>{
        timerId = setTimeout(()=>reject(new Error('timebox error')), ms);
    });
    try {
        return await Promise.race([
            Promise.all(promises),
            timeout
        ]);
    } finally{
        clearTimeout(timerId);
    }
};
function $8c05ed6f2f331ee8$var$isFunction(value) {
    return value && (Object.prototype.toString.call(value) === '[object Function]' || 'function' === typeof value || value instanceof Function);
}
/**
 * A map of known error codes.
 */ const $8c05ed6f2f331ee8$var$KnownCodes = {
    TOKEN_EXPIRED: 40,
    WS_CLOSED_SUCCESS: 1000
};
/**
 * retryInterval - A retry interval which increases acc to number of failures
 *
 * @return {number} Duration to wait in milliseconds
 */ function $8c05ed6f2f331ee8$var$retryInterval(numberOfFailures) {
    // try to reconnect in 0.25-5 seconds (random to spread out the load from failures)
    const max = Math.min(500 + numberOfFailures * 2000, 5000);
    const min = Math.min(Math.max(250, (numberOfFailures - 1) * 2000), 5000);
    return Math.floor(Math.random() * (max - min) + min);
}
function $8c05ed6f2f331ee8$var$hex(bytes) {
    let s = '';
    for(let i = 0; i < bytes.length; i++)s += bytes[i].toString(16).padStart(2, '0');
    return s;
}
// https://tools.ietf.org/html/rfc4122
function $8c05ed6f2f331ee8$var$generateUUIDv4() {
    const bytes = $8c05ed6f2f331ee8$var$getRandomBytes(16);
    bytes[6] = bytes[6] & 0x0f | 0x40; // version
    bytes[8] = bytes[8] & 0xbf | 0x80; // variant
    return [
        $8c05ed6f2f331ee8$var$hex(bytes.subarray(0, 4)),
        $8c05ed6f2f331ee8$var$hex(bytes.subarray(4, 6)),
        $8c05ed6f2f331ee8$var$hex(bytes.subarray(6, 8)),
        $8c05ed6f2f331ee8$var$hex(bytes.subarray(8, 10)),
        $8c05ed6f2f331ee8$var$hex(bytes.subarray(10, 16))
    ].join('-');
}
const $8c05ed6f2f331ee8$var$getRandomValues = (()=>{
    if (typeof crypto !== 'undefined' && crypto.getRandomValues) return crypto.getRandomValues.bind(crypto);
    return function getRandomValuesWithMathRandom(bytes) {
        const max = Math.pow(2, 8 * bytes.byteLength / bytes.length);
        for(let i = 0; i < bytes.length; i++)bytes[i] = Math.random() * max;
    };
})();
function $8c05ed6f2f331ee8$var$getRandomBytes(length) {
    const bytes = new Uint8Array(length);
    $8c05ed6f2f331ee8$var$getRandomValues(bytes);
    return bytes;
}
/**
 * listenForConnectionChanges - Adds an event listener fired on browser going online or offline
 */ function $8c05ed6f2f331ee8$var$addConnectionEventListeners(cb) {
    if (typeof window !== 'undefined' && window.addEventListener) {
        window.addEventListener('offline', cb);
        window.addEventListener('online', cb);
    }
}
function $8c05ed6f2f331ee8$var$removeConnectionEventListeners(cb) {
    if (typeof window !== 'undefined' && window.removeEventListener) {
        window.removeEventListener('offline', cb);
        window.removeEventListener('online', cb);
    }
}
function $8c05ed6f2f331ee8$var$isErrorResponse(res) {
    return !res.status || res.status < 200 || 300 <= res.status;
}
// Type guards to check WebSocket error type
function $8c05ed6f2f331ee8$var$isCloseEvent(res) {
    return res.code !== undefined;
}
/**
 * Checks whether we are using React Native
 */ const $8c05ed6f2f331ee8$var$isReactNative = ()=>{
    if (typeof navigator === 'undefined') return false;
    return navigator.product?.toLowerCase() === 'reactnative';
};
const $8c05ed6f2f331ee8$export$c86c88f4929407a2 = (logLevel, message, ...args)=>{
    let logMethod;
    switch(logLevel){
        case 'error':
            if ($8c05ed6f2f331ee8$var$isReactNative()) {
                message = `ERROR: ${message}`;
                logMethod = console.info;
                break;
            }
            logMethod = console.error;
            break;
        case 'warn':
            if ($8c05ed6f2f331ee8$var$isReactNative()) {
                message = `WARN: ${message}`;
                logMethod = console.info;
                break;
            }
            logMethod = console.warn;
            break;
        case 'info':
            logMethod = console.info;
            break;
        case 'trace':
            logMethod = console.trace;
            break;
        default:
            logMethod = console.log;
            break;
    }
    logMethod(message, ...args);
};
const $8c05ed6f2f331ee8$export$1f073264fb3f7580 = $1300170f237a6b56$exports.createLoggerSystem();
/**
 * Creates a closure which wraps the given RPC call and retries invoking
 * the RPC until it succeeds or the maximum number of retries is reached.
 *
 * For each retry, there would be a delay to avoid request bursts toward the SFU.
 *
 * @param rpc the closure around the RPC call to execute.
 * @param signal the signal to abort the RPC call and retries loop.
 * @param maxRetries the maximum number of retries to perform. Defaults to `Number.POSITIVE_INFINITY`.
 */ const $8c05ed6f2f331ee8$var$retryable = async (rpc, signal, maxRetries = Number.POSITIVE_INFINITY)=>{
    let attempt = 0;
    let result = undefined;
    do {
        if (attempt > 0) await $8c05ed6f2f331ee8$var$sleep($8c05ed6f2f331ee8$var$retryInterval(attempt));
        try {
            result = await rpc({
                attempt: attempt
            });
        } catch (err) {
            const isRequestCancelled = err instanceof (0, $297ac12f7a07a328$export$5460eff990f31920) && err.message !== $8c05ed6f2f331ee8$var$TIMEOUT_SYMBOL && err.code === (0, $0b292aefa7b441d9$export$55bc18a3e61a4e3c)[(0, $0b292aefa7b441d9$export$55bc18a3e61a4e3c).cancelled];
            const isAborted = signal?.aborted ?? false;
            if (isRequestCancelled || isAborted) throw err;
            if (attempt + 1 >= maxRetries) throw err;
            $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger('sfu-client', {
                tags: [
                    'rpc'
                ]
            }).debug(`rpc failed (${attempt})`, err);
            attempt++;
        }
    }while (!result || result.response.error?.shouldRetry);
    return result;
};
/**
 * Extracts the mid from the transceiver or the SDP.
 *
 * @param transceiver the transceiver.
 * @param transceiverInitIndex the index of the transceiver in the transceiver's init array.
 * @param sdp the SDP.
 */ const $8c05ed6f2f331ee8$var$extractMid = (transceiver, transceiverInitIndex, sdp)=>{
    if (transceiver.mid) return transceiver.mid;
    if (!sdp) return String(transceiverInitIndex);
    const track = transceiver.sender.track;
    const parsedSdp = (0, $178bb82ca124d09b$export$98e6a39c04603d36)(sdp);
    const media = parsedSdp.media.find((m)=>{
        return m.type === track.kind && // if `msid` is not present, we assume that the track is the first one
        (m.msid?.includes(track.id) ?? true);
    });
    if (typeof media?.mid !== 'undefined') return String(media.mid);
    if (transceiverInitIndex < 0) return '';
    return String(transceiverInitIndex);
};
/**
 * Sets the start bitrate for the VP9, H264, and AV1 codecs in the SDP.
 *
 * @param offerSdp the offer SDP to modify.
 * @param maxBitrateKbps the maximum bitrate in kbps.
 * @param startBitrateFactor the factor (0-1) to multiply with maxBitrateKbps to get the start bitrate.
 * @param targetMid the media ID to target.
 */ const $8c05ed6f2f331ee8$var$setStartBitrate = (offerSdp, maxBitrateKbps, startBitrateFactor, targetMid)=>{
    // start bitrate should be between 300kbps and max-bitrate-kbps
    // Clamp to max first, then ensure minimum of 300 (but never exceed max)
    const startBitrate = Math.min(maxBitrateKbps, Math.max(300, startBitrateFactor * maxBitrateKbps));
    const parsedSdp = (0, $178bb82ca124d09b$export$98e6a39c04603d36)(offerSdp);
    const targetCodecs = new Set([
        'av1',
        'vp9',
        'h264'
    ]);
    for (const media of parsedSdp.media){
        if (media.type !== 'video') continue;
        if (String(media.mid) !== targetMid) continue;
        for (const rtp of media.rtp){
            if (!targetCodecs.has(rtp.codec.toLowerCase())) continue;
            // Find existing fmtp entry for this payload
            // Guard against media.fmtp being undefined when SDP has no a=fmtp lines
            const fmtpList = media.fmtp ?? (media.fmtp = []);
            const existingFmtp = fmtpList.find((fmtp)=>fmtp.payload === rtp.payload);
            if (existingFmtp) {
                // Append to existing fmtp if not already present
                // Guard against undefined or empty config from malformed SDP
                const config = existingFmtp.config ?? '';
                if (!config.includes('x-google-start-bitrate')) existingFmtp.config = config ? `${config};x-google-start-bitrate=${startBitrate}` : `x-google-start-bitrate=${startBitrate}`;
            } else // Create new fmtp entry if none exists
            fmtpList.push({
                payload: rtp.payload,
                config: `x-google-start-bitrate=${startBitrate}`
            });
        }
    }
    return (0, $178bb82ca124d09b$export$68d8715fc104d294)(parsedSdp);
};
/**
 * Enables stereo in the answer SDP based on the offered stereo in the offer SDP.
 *
 * @param offerSdp the offer SDP containing the stereo configuration.
 * @param answerSdp the answer SDP to be modified.
 */ const $8c05ed6f2f331ee8$var$enableStereo = (offerSdp, answerSdp)=>{
    const offeredStereoMids = new Set();
    const parsedOfferSdp = (0, $178bb82ca124d09b$export$98e6a39c04603d36)(offerSdp);
    for (const media of parsedOfferSdp.media){
        if (media.type !== 'audio') continue;
        const opus = media.rtp.find((r)=>r.codec === 'opus');
        if (!opus) continue;
        for (const fmtp of media.fmtp)if (fmtp.payload === opus.payload && fmtp.config.includes('stereo=1')) offeredStereoMids.add(media.mid);
    }
    // No stereo offered, return the original answerSdp
    if (offeredStereoMids.size === 0) return answerSdp;
    const parsedAnswerSdp = (0, $178bb82ca124d09b$export$98e6a39c04603d36)(answerSdp);
    for (const media of parsedAnswerSdp.media){
        if (media.type !== 'audio' || !offeredStereoMids.has(media.mid)) continue;
        const opus = media.rtp.find((r)=>r.codec === 'opus');
        if (!opus) continue;
        for (const fmtp of media.fmtp)if (fmtp.payload === opus.payload && !fmtp.config.includes('stereo=1')) fmtp.config += ';stereo=1';
    }
    return (0, $178bb82ca124d09b$export$68d8715fc104d294)(parsedAnswerSdp);
};
/**
 * Removes all codecs from the SDP except the specified codec.
 *
 * @param sdp the SDP to modify.
 * @param codecMimeTypeToKeep the codec mime type to keep (video/h264 or audio/opus).
 * @param fmtpProfileToKeep the fmtp profile to keep (e.g. 'profile-level-id=42e01f' or multiple segments like 'profile-level-id=64001f;packetization-mode=1').
 */ const $8c05ed6f2f331ee8$var$removeCodecsExcept = (sdp, codecMimeTypeToKeep, fmtpProfileToKeep)=>{
    const [kind, codec] = $8c05ed6f2f331ee8$var$toMimeType(codecMimeTypeToKeep).split('/');
    if (!kind || !codec) return sdp;
    const parsed = (0, $178bb82ca124d09b$export$98e6a39c04603d36)(sdp);
    for (const media of parsed.media){
        if (media.type !== kind) continue;
        // Build a set of payloads to KEEP: all payloads whose rtp.codec matches codec
        let payloadsToKeep = new Set();
        for (const rtp of media.rtp){
            if (rtp.codec.toLowerCase() !== codec) continue;
            payloadsToKeep.add(rtp.payload);
        }
        // If a specific fmtp profile is requested, only keep payloads whose fmtp config matches it
        if (fmtpProfileToKeep) {
            const filtered = new Set();
            const required = new Set(fmtpProfileToKeep.split(';'));
            for (const fmtp of media.fmtp)if (payloadsToKeep.has(fmtp.payload) && required.difference(new Set(fmtp.config.split(';'))).size === 0) filtered.add(fmtp.payload);
            payloadsToKeep = filtered;
        }
        // If no payloads to keep AND no fmtpProfile was specified, skip modifications (preserve SDP as-is)
        if (payloadsToKeep.size === 0 && !fmtpProfileToKeep) continue;
        // Keep RTX payloads that are associated with kept primary payloads via apt
        // RTX mappings look like: a=fmtp:<rtxPayload> apt=<primaryPayload>
        for (const fmtp of media.fmtp){
            const matches = /\s*apt\s*=\s*(\d+)\s*/i.exec(fmtp.config);
            if (!matches) continue;
            const primaryPayloadApt = Number(matches[1]);
            if (!payloadsToKeep.has(primaryPayloadApt)) continue;
            payloadsToKeep.add(fmtp.payload);
        }
        // Filter rtp, fmtp and rtcpFb entries
        media.rtp = media.rtp.filter((rtp)=>payloadsToKeep.has(rtp.payload));
        media.fmtp = media.fmtp.filter((fmtp)=>payloadsToKeep.has(fmtp.payload));
        media.rtcpFb = media.rtcpFb?.filter((fb)=>typeof fb.payload === 'number' ? payloadsToKeep.has(fb.payload) : true);
        // Update the m= line payload list to only the kept payloads, preserving original order
        const payloads = [];
        for (const id of (media.payloads || '').split(/\s+/)){
            const payload = Number(id);
            if (!payloadsToKeep.has(payload)) continue;
            payloads.push(payload);
        }
        media.payloads = payloads.join(' ');
    }
    return (0, $178bb82ca124d09b$export$68d8715fc104d294)(parsed);
};
/**
 * Converts the given codec to a mime-type format when necessary.
 * e.g.: `vp9` -> `video/vp9`
 */ const $8c05ed6f2f331ee8$var$toMimeType = (codec, kind = 'video')=>codec.includes('/') ? codec : `${kind}/${codec}`;
/**
 * Returns a generic SDP for the given direction.
 * We use this SDP to send it as part of our JoinRequest so that the SFU
 * can use it to determine the client's codec capabilities.
 *
 * @param direction the direction of the transceiver.
 * @param codecToKeep the codec mime type to keep (video/h264 or audio/opus).
 * @param fmtpProfileToKeep optional fmtp profile to keep.
 */ const $8c05ed6f2f331ee8$var$getGenericSdp = async (direction, codecToKeep, fmtpProfileToKeep)=>{
    const tempPc = new RTCPeerConnection();
    tempPc.addTransceiver('video', {
        direction: direction
    });
    tempPc.addTransceiver('audio', {
        direction: direction
    });
    const offer = await tempPc.createOffer();
    const { sdp: baseSdp = '' } = offer;
    const sdp = codecToKeep ? $8c05ed6f2f331ee8$var$removeCodecsExcept(baseSdp, codecToKeep, fmtpProfileToKeep) : baseSdp;
    tempPc.getTransceivers().forEach((t)=>{
        t.stop?.();
    });
    tempPc.close();
    return sdp;
};
/**
 * Returns whether the codec is an SVC codec.
 *
 * @param codecOrMimeType the codec to check.
 */ const $8c05ed6f2f331ee8$var$isSvcCodec = (codecOrMimeType)=>{
    if (!codecOrMimeType) return false;
    codecOrMimeType = codecOrMimeType.toLowerCase();
    return codecOrMimeType === 'vp9' || codecOrMimeType === 'av1' || codecOrMimeType === 'video/vp9' || codecOrMimeType === 'video/av1';
};
const $8c05ed6f2f331ee8$var$sfuEventKinds = {
    subscriberOffer: undefined,
    publisherAnswer: undefined,
    connectionQualityChanged: undefined,
    audioLevelChanged: undefined,
    iceTrickle: undefined,
    changePublishQuality: undefined,
    participantJoined: undefined,
    participantLeft: undefined,
    dominantSpeakerChanged: undefined,
    joinResponse: undefined,
    healthCheckResponse: undefined,
    trackPublished: undefined,
    trackUnpublished: undefined,
    error: undefined,
    callGrantsUpdated: undefined,
    goAway: undefined,
    iceRestart: undefined,
    pinsUpdated: undefined,
    callEnded: undefined,
    participantUpdated: undefined,
    participantMigrationComplete: undefined,
    changePublishOptions: undefined,
    inboundStateNotification: undefined
};
/**
 * Determines if a given event name belongs to the category of SFU events.
 *
 * @param eventName the name of the event to check.
 * @returns true if the event name is an SFU event, otherwise false.
 */ const $8c05ed6f2f331ee8$var$isSfuEvent = (eventName)=>{
    return Object.prototype.hasOwnProperty.call($8c05ed6f2f331ee8$var$sfuEventKinds, eventName);
};
class $8c05ed6f2f331ee8$var$Dispatcher {
    constructor(){
        this.logger = $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger('Dispatcher');
        this.subscribers = new Map();
        /**
         * Dispatch an event to all subscribers.
         *
         * @param message the event payload to dispatch.
         * @param tag for scoping events to a specific tag. Use `*` dispatch to every tag.
         */ this.dispatch = (message, tag = '*')=>{
            const eventKind = message.eventPayload.oneofKind;
            if (!eventKind) return;
            const payload = message.eventPayload[eventKind];
            this.logger.debug(`Dispatching ${eventKind}, tag=${tag}`, payload);
            const handlers = this.subscribers.get(eventKind);
            if (!handlers) return;
            const { byTag: byTag, dynamic: dynamic } = handlers;
            this.emit(payload, byTag.get(tag));
            if (tag !== '*') this.emit(payload, byTag.get('*'));
            this.emitDynamic(payload, tag, dynamic);
        };
        /**
         * Emit an event to a list of listeners.
         *
         * @param payload the event payload to emit.
         * @param listeners the list of listeners to emit the event to.
         */ this.emit = (payload, listeners = [])=>{
            for (const listener of listeners)this.emitOne(payload, listener);
        };
        /**
         * Emit an event to a list of listeners.
         *
         */ this.emitDynamic = (payload, tag, dynamic)=>{
            for (const { tagSelector: tagSelector, listener: listener } of dynamic){
                const dynamicTag = tagSelector();
                if (dynamicTag === tag || tag !== '*' && dynamicTag === '*') this.emitOne(payload, listener);
            }
        };
        /**
         * Emit an event to a single listener.
         * @param payload the event payload to emit.
         * @param listener the listener to emit the event to.
         */ this.emitOne = (payload, listener)=>{
            try {
                listener(payload);
            } catch (e) {
                this.logger.warn('Listener failed with error', e);
            }
        };
        /**
         * Subscribe to an event.
         *
         * @param eventName the name of the event to subscribe to.
         * @param tag for scoping events to a specific tag. Can be a static tag
         * string or a function that resolves the tag dynamically.
         * @param fn the callback function to invoke when the event is emitted.
         * @returns a function that can be called to unsubscribe from the event.
         */ this.on = (eventName, tag, fn)=>{
            const { byTag: byTag, dynamic: dynamic } = this.getHandlers(eventName);
            const listener = fn;
            if (typeof tag === 'string') {
                const listeners = byTag.get(tag) ?? [];
                listeners.push(listener);
                byTag.set(tag, listeners);
            } else dynamic.push({
                tagSelector: tag,
                listener: listener
            });
            return ()=>{
                this.off(eventName, tag, fn);
            };
        };
        /**
         * Unsubscribe from an event.
         *
         * @param eventName the name of the event to unsubscribe from.
         * @param tag the original static/dynamic tag selector used during subscription.
         * @param fn the callback function to remove from the event listeners.
         */ this.off = (eventName, tag, fn)=>{
            const bucket = this.subscribers.get(eventName);
            if (!bucket) return;
            const { byTag: byTag, dynamic: dynamic } = bucket;
            if (typeof tag === 'string') {
                const listeners = byTag.get(tag) || [];
                const idx = listeners.indexOf(fn);
                if (idx >= 0) listeners.splice(idx, 1);
            } else {
                const idx = dynamic.findIndex(({ tagSelector: tagSelector, listener: listener })=>{
                    return tagSelector === tag && listener === fn;
                });
                if (idx >= 0) dynamic.splice(idx, 1);
            }
        };
        this.getHandlers = (eventName)=>{
            const existing = this.subscribers.get(eventName);
            if (existing) return existing;
            const next = {
                byTag: new Map(),
                dynamic: []
            };
            this.subscribers.set(eventName, next);
            return next;
        };
    }
}
/**
 * NegotiationError is thrown when there is an error during the negotiation process.
 * It extends the built-in Error class and includes an SfuError object for more details.
 */ class $8c05ed6f2f331ee8$var$NegotiationError extends Error {
    /**
     * Creates an instance of NegotiationError.
     */ constructor(error){
        super(error.message);
        this.name = 'NegotiationError';
        this.error = error;
    }
}
/**
 * A buffer for ICE Candidates. Used for ICE Trickle:
 * - https://bloggeek.me/webrtcglossary/trickle-ice/
 */ class $8c05ed6f2f331ee8$var$IceTrickleBuffer {
    constructor(){
        this.subscriberCandidates = new (0, $4a1890c700519557$export$915d2682b0aa0991)();
        this.publisherCandidates = new (0, $4a1890c700519557$export$915d2682b0aa0991)();
        this.push = (iceTrickle)=>{
            const iceCandidate = $8c05ed6f2f331ee8$var$toIceCandidate(iceTrickle);
            if (!iceCandidate) return;
            if (iceTrickle.peerType === $8c05ed6f2f331ee8$var$PeerType.SUBSCRIBER) this.subscriberCandidates.next(iceCandidate);
            else if (iceTrickle.peerType === $8c05ed6f2f331ee8$var$PeerType.PUBLISHER_UNSPECIFIED) this.publisherCandidates.next(iceCandidate);
            else {
                const logger = $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger('sfu-client');
                logger.warn(`ICETrickle, Unknown peer type`, iceTrickle);
            }
        };
        this.dispose = ()=>{
            this.subscriberCandidates.complete();
            this.publisherCandidates.complete();
        };
    }
}
const $8c05ed6f2f331ee8$var$toIceCandidate = (iceTrickle)=>{
    try {
        return JSON.parse(iceTrickle.iceCandidate);
    } catch (e) {
        const logger = $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger('sfu-client');
        logger.error(`Failed to parse ICE Trickle`, e, iceTrickle);
        return undefined;
    }
};
/**
 * Runs async functions serially. Useful for wrapping async actions that
 * should never run simultaneously: if marked with the same tag, functions
 * will run one after another.
 *
 * @param tag Async functions with the same tag will run serially. Async functions
 * with different tags can run in parallel.
 * @param cb Async function to run.
 * @returns Promise that resolves when async functions returns.
 */ const $8c05ed6f2f331ee8$var$withoutConcurrency = $8c05ed6f2f331ee8$var$createRunner($8c05ed6f2f331ee8$var$wrapWithContinuationTracking);
/**
 * Runs async functions serially, and cancels all other actions with the same tag
 * when a new action is scheduled. Useful for wrapping async actions that override
 * each other (e.g. enabling and disabling camera).
 *
 * If an async function hasn't started yet and was canceled, it will never run.
 * If an async function is already running and was canceled, it will be notified
 * via an abort signal passed as an argument.
 *
 * @param tag Async functions with the same tag will run serially and are canceled
 * when a new action with the same tag is scheduled.
 * @param cb Async function to run. Receives AbortSignal as the only argument.
 * @returns Promise that resolves when async functions returns. If the function didn't
 * start and was canceled, will resolve with 'canceled'. If the function started to run,
 * it's up to the function to decide how to react to cancelation.
 */ const $8c05ed6f2f331ee8$var$withCancellation = $8c05ed6f2f331ee8$var$createRunner($8c05ed6f2f331ee8$var$wrapWithCancellation);
const $8c05ed6f2f331ee8$var$pendingPromises = new Map();
function $8c05ed6f2f331ee8$var$hasPending(tag) {
    return $8c05ed6f2f331ee8$var$pendingPromises.has(tag);
}
async function $8c05ed6f2f331ee8$var$settled(tag) {
    let pending;
    while(pending = $8c05ed6f2f331ee8$var$pendingPromises.get(tag))await pending.promise;
}
/**
 * Implements common functionality of running async functions serially, by chaining
 * their promises one after another.
 *
 * Before running, async function is "wrapped" using the provided wrapper. This wrapper
 * can add additional steps to run before or after the function.
 *
 * When async function is scheduled to run, the previous function is notified
 * by calling the associated onContinued callback. This behavior of this callback
 * is defined by the wrapper.
 */ function $8c05ed6f2f331ee8$var$createRunner(wrapper) {
    return function run(tag, cb) {
        const { cb: wrapped, onContinued: onContinued } = wrapper(tag, cb);
        const pending = $8c05ed6f2f331ee8$var$pendingPromises.get(tag);
        pending?.onContinued();
        const promise = pending ? pending.promise.then(wrapped, wrapped) : wrapped();
        $8c05ed6f2f331ee8$var$pendingPromises.set(tag, {
            promise: promise,
            onContinued: onContinued
        });
        return promise;
    };
}
/**
 * Wraps an async function with an additional step run after the function:
 * if the function is the last in the queue, it cleans up the whole chain
 * of promises after finishing.
 */ function $8c05ed6f2f331ee8$var$wrapWithContinuationTracking(tag, cb) {
    let hasContinuation = false;
    const wrapped = ()=>cb().finally(()=>{
            if (!hasContinuation) $8c05ed6f2f331ee8$var$pendingPromises.delete(tag);
        });
    const onContinued = ()=>hasContinuation = true;
    return {
        cb: wrapped,
        onContinued: onContinued
    };
}
/**
 * Wraps an async function with additional functionalilty:
 * 1. Associates an abort signal with every function, that is passed to it
 *    as an argument. When a new function is scheduled to run after the current
 *    one, current signal is aborted.
 * 2. If current function didn't start and was aborted, in will never start.
 * 3. If the function is the last in the queue, it cleans up the whole chain
 *    of promises after finishing.
 */ function $8c05ed6f2f331ee8$var$wrapWithCancellation(tag, cb) {
    const ac = new AbortController();
    const wrapped = ()=>{
        if (ac.signal.aborted) return Promise.resolve('canceled');
        return cb(ac.signal).finally(()=>{
            if (!ac.signal.aborted) $8c05ed6f2f331ee8$var$pendingPromises.delete(tag);
        });
    };
    const onContinued = ()=>ac.abort();
    return {
        cb: wrapped,
        onContinued: onContinued
    };
}
/**
 * Checks if the provided update is a function patch.
 *
 * @param update the value to check.
 */ const $8c05ed6f2f331ee8$var$isFunctionPatch = (update)=>typeof update === 'function';
/**
 * Gets the current value of an observable, or undefined if the observable has
 * not emitted a value yet.
 *
 * @param observable$ the observable to get the value from.
 */ const $8c05ed6f2f331ee8$var$getCurrentValue = (observable$)=>{
    let value;
    let err = undefined;
    (0, $0e8b72f41887b114$export$77fa7d86f5204e8a)([
        observable$
    ]).subscribe({
        next: ([v])=>{
            value = v;
        },
        error: (e)=>{
            err = e;
        }
    }).unsubscribe();
    if (err) throw err;
    return value;
};
/**
 * Updates the value of the provided Subject.
 * An `update` can either be a new value or a function which takes
 * the current value and returns a new value.
 *
 * @param subject the subject to update.
 * @param update the update to apply to the subject.
 * @return the updated value.
 */ const $8c05ed6f2f331ee8$var$setCurrentValue = (subject, update)=>{
    const next = $8c05ed6f2f331ee8$var$isFunctionPatch(update) ? update($8c05ed6f2f331ee8$var$getCurrentValue(subject)) : update;
    subject.next(next);
    return next;
};
/**
 * Updates the value of the provided Subject asynchronously.
 * Locks the subject to prevent concurrent updates.
 *
 * @param subject the subject to update.
 * @param update the update to apply to the subject.
 */ const $8c05ed6f2f331ee8$var$setCurrentValueAsync = async (subject, update)=>{
    return $8c05ed6f2f331ee8$var$withoutConcurrency(subject, async ()=>{
        const next = await update($8c05ed6f2f331ee8$var$getCurrentValue(subject));
        subject.next(next);
        return next;
    });
};
/**
 * Updates the value of the provided Subject and returns the previous value
 * and a function to roll back the update.
 * This is useful when you want to optimistically update a value
 * and roll back the update if an error occurs.
 *
 * @param subject the subject to update.
 * @param update the update to apply to the subject.
 */ const $8c05ed6f2f331ee8$var$updateValue = (subject, update)=>{
    const lastValue = subject.getValue();
    const value = $8c05ed6f2f331ee8$var$setCurrentValue(subject, update);
    return {
        lastValue: lastValue,
        value: value,
        rollback: ()=>$8c05ed6f2f331ee8$var$setCurrentValue(subject, lastValue)
    };
};
/**
 * Creates a subscription and returns a function to unsubscribe.
 *
 * @param observable the observable to subscribe to.
 * @param handler the handler to call when the observable emits a value.
 * @param onError an optional error handler.
 */ const $8c05ed6f2f331ee8$var$createSubscription = (observable, handler, onError = (error)=>$8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger('RxUtils').warn('An observable emitted an error', error))=>{
    const subscription = observable.subscribe({
        next: handler,
        error: onError
    });
    return ()=>{
        subscription.unsubscribe();
    };
};
/**
 * Creates a subscription and returns a function to unsubscribe. Makes sure that
 * only one async handler runs at the same time. If updates come in quicker than
 * it takes for the current handler to finish, other handlers will wait.
 *
 * @param observable the observable to subscribe to.
 * @param handler the async handler to call when the observable emits a value.
 */ const $8c05ed6f2f331ee8$var$createSafeAsyncSubscription = (observable, handler)=>{
    const tag = Symbol();
    return $8c05ed6f2f331ee8$var$createSubscription(observable, (value)=>{
        $8c05ed6f2f331ee8$var$withoutConcurrency(tag, ()=>handler(value));
    });
};
var $8c05ed6f2f331ee8$export$f94b03ba77372d8d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    createSafeAsyncSubscription: $8c05ed6f2f331ee8$var$createSafeAsyncSubscription,
    createSubscription: $8c05ed6f2f331ee8$var$createSubscription,
    getCurrentValue: $8c05ed6f2f331ee8$var$getCurrentValue,
    setCurrentValue: $8c05ed6f2f331ee8$var$setCurrentValue,
    setCurrentValueAsync: $8c05ed6f2f331ee8$var$setCurrentValueAsync,
    updateValue: $8c05ed6f2f331ee8$var$updateValue
});
/**
 * Represents the state of the current call.
 */ var $8c05ed6f2f331ee8$export$e10ca39c0aa31acc;
(function(CallingState) {
    /**
     * The call is in an unknown state.
     */ CallingState["UNKNOWN"] = "unknown";
    /**
     * The call is in an idle state.
     */ CallingState["IDLE"] = "idle";
    /**
     * The call is in the process of ringing.
     * (User hasn't accepted nor rejected the call yet.)
     */ CallingState["RINGING"] = "ringing";
    /**
     * The call is in the process of joining.
     */ CallingState["JOINING"] = "joining";
    /**
     * The call is currently active.
     */ CallingState["JOINED"] = "joined";
    /**
     * The call has been left.
     */ CallingState["LEFT"] = "left";
    /**
     * The call is in the process of reconnecting.
     */ CallingState["RECONNECTING"] = "reconnecting";
    /**
     * The call is in the process of migrating from one node to another.
     */ CallingState["MIGRATING"] = "migrating";
    /**
     * The call has failed to reconnect.
     */ CallingState["RECONNECTING_FAILED"] = "reconnecting-failed";
    /**
     * The call is in offline mode.
     */ CallingState["OFFLINE"] = "offline";
})($8c05ed6f2f331ee8$export$e10ca39c0aa31acc || ($8c05ed6f2f331ee8$export$e10ca39c0aa31acc = {}));
class $8c05ed6f2f331ee8$export$8da656e2640438dd {
    constructor(){
        /**
         * A store keeping data of a successfully connected user over WS to the coordinator server.
         */ this.connectedUserSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(undefined);
        /**
         * A list of {@link Call} objects created/tracked by this client.
         */ this.callsSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)([]);
        /**
         * Sets the currently connected user.
         *
         * @internal
         * @param user the user to set as connected.
         */ this.setConnectedUser = (user)=>{
            return $8c05ed6f2f331ee8$var$setCurrentValue(this.connectedUserSubject, user);
        };
        /**
         * Sets the list of {@link Call} objects created/tracked by this client.
         * @param calls
         */ this.setCalls = (calls)=>{
            return $8c05ed6f2f331ee8$var$setCurrentValue(this.callsSubject, calls);
        };
        /**
         * Adds a {@link Call} object to the list of {@link Call} objects created/tracked by this client.
         *
         * @param call the call to add.
         */ this.registerCall = (call)=>{
            if (!this.calls.find((c)=>c.cid === call.cid)) this.setCalls((calls)=>[
                    ...calls,
                    call
                ]);
        };
        /**
         * Registers a {@link Call} object if it doesn't exist, otherwise updates it.
         *
         * @param call the call to register or update.
         */ this.registerOrUpdateCall = (call)=>{
            if (this.calls.find((c)=>c.cid === call.cid)) return this.setCalls((calls)=>calls.map((c)=>c.cid === call.cid ? call : c));
            else return this.registerCall(call);
        };
        /**
         * Removes a {@link Call} object from the list of {@link Call} objects created/tracked by this client.
         *
         * @param call the call to remove
         */ this.unregisterCall = (call)=>{
            const logger = $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger('client-state');
            logger.trace(`Unregistering call: ${call.cid}`);
            return this.setCalls((calls)=>calls.filter((c)=>c !== call));
        };
        /**
         * Finds a {@link Call} object in the list of {@link Call} objects created/tracked by this client.
         *
         * @param type the type of call to find.
         * @param id the id of the call to find.
         */ this.findCall = (type, id)=>{
            return this.calls.find((c)=>c.type === type && c.id === id);
        };
        this.connectedUserSubject.subscribe(async (user)=>{
            // leave all calls when the user disconnects.
            if (!user) {
                const logger = $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger('client-state');
                for (const call of this.calls){
                    if (call.state.callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.LEFT) continue;
                    logger.info(`User disconnected, leaving call: ${call.cid}`);
                    await call.leave({
                        message: 'client.disconnectUser() called'
                    }).catch((err)=>{
                        logger.error(`Error leaving call: ${call.cid}`, err);
                    });
                }
            }
        });
    }
    /**
     * The currently connected user.
     */ get connectedUser() {
        return this.connectedUserSubject.getValue();
    }
    /**
     * A list of {@link Call} objects created/tracked by this client.
     */ get calls() {
        return $8c05ed6f2f331ee8$var$getCurrentValue(this.callsSubject);
    }
}
/**
 * A reactive store that exposes state variables in a reactive manner.
 * You can subscribe to changes of the different state variables.
 * This central store contains all the state variables related to [`StreamVideoClient`](./StreamVideClient.md) and [`Call`](./Call.md).
 */ class $8c05ed6f2f331ee8$export$d30353056ebb432d {
    constructor(store){
        // convert and expose subjects as observables
        this.connectedUser$ = store.connectedUserSubject.asObservable();
        this.calls$ = store.callsSubject.asObservable();
    }
    /**
     * The current user connected over WS to the backend.
     */ get connectedUser() {
        return $8c05ed6f2f331ee8$var$getCurrentValue(this.connectedUser$);
    }
    /**
     * A list of {@link Call} objects created/tracked by this client.
     */ get calls() {
        return $8c05ed6f2f331ee8$var$getCurrentValue(this.calls$);
    }
}
/**
 * Creates a new combined {@link Comparator<T>} which sorts items by the given comparators.
 * The comparators are applied in the order they are given (left -> right).
 *
 * @param comparators the comparators to use for sorting.
 * @returns a combined {@link Comparator<T>}.
 */ const $8c05ed6f2f331ee8$export$d1c8e506ae873875 = (...comparators)=>{
    return (a, b)=>{
        for (const comparator of comparators){
            const result = comparator(a, b);
            if (result !== 0) return result;
        }
        return 0;
    };
};
/**
 * Creates a new comparator which sorts items in descending order.
 *
 * @example
 * const byValue = (a, b) => a < b ? - 1 : a > b ? 1 : 0;
 * const byValueDesc = descending(byValue);
 *
 * @param comparator the comparator to wrap.
 */ const $8c05ed6f2f331ee8$export$4fa3190a997c3d8f = (comparator)=>{
    return (a, b)=>comparator(b, a);
};
/**
 * Creates a new comparator which conditionally applies the given comparator.
 *
 * @example
 * const shouldSortByValue = (a, b) => a % 2 === 0; // return false to turn it off
 * const byValue = (a, b) => a < b ? - 1 : a > b ? 1 : 0;
 * const comparator = conditional(shouldSortByValue)(byValue);
 *
 * @param predicate the predicate to use for determining whether to apply the comparator.
 */ const $8c05ed6f2f331ee8$export$c327da55a124987a = (predicate)=>{
    return (comparator)=>{
        return (a, b)=>{
            if (!predicate(a, b)) return 0;
            return comparator(a, b);
        };
    };
};
/**
 * A no-op comparator which always returns 0.
 */ const $8c05ed6f2f331ee8$export$632fd4bcc8238f02 = ()=>{
    return ()=>0;
};
/**
 * Check if a participant has a video.
 *
 * @param p the participant to check.
 */ const $8c05ed6f2f331ee8$export$554515ce821ba4ab = (p)=>p.publishedTracks.includes($8c05ed6f2f331ee8$var$TrackType.VIDEO);
/**
 * Check if a participant has audio.
 *
 * @param p the participant to check.
 */ const $8c05ed6f2f331ee8$export$2e009d8a44827b31 = (p)=>p.publishedTracks.includes($8c05ed6f2f331ee8$var$TrackType.AUDIO);
/**
 * Check if a participant is screen sharing.
 *
 * @param p the participant to check.
 */ const $8c05ed6f2f331ee8$export$30c686c84ce95811 = (p)=>p.publishedTracks.includes($8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE);
/**
 * Check if a participant is screen sharing audio.
 *
 * @param p the participant to check.
 */ const $8c05ed6f2f331ee8$export$daa118aa3a3add81 = (p)=>p.publishedTracks.includes($8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE_AUDIO);
/**
 * Check if the participant is pinned.
 *
 * @param p the participant.
 */ const $8c05ed6f2f331ee8$export$1466786e40868dda = (p)=>!!p.pin && (p.pin.isLocalPin || p.pin.pinnedAt > 0);
/**
 * Check if a participant has a track that is currently interrupted: the
 * participant intends to publish it (it is in `publishedTracks`) but no
 * media is flowing right now (it is in `interruptedTracks`).
 *
 * @param p the participant to check.
 * @param trackType the track type to check.
 */ const $8c05ed6f2f331ee8$export$c39776b95f04b0b2 = (p, trackType)=>!!p.interruptedTracks?.includes(trackType) && p.publishedTracks.includes(trackType);
/**
 * Check if a participant has a paused track of the specified type.
 *
 * @param p the participant to check.
 * @param videoTrackType the type of video track to check for ('videoTrack' or 'screenShareTrack').
 */ const $8c05ed6f2f331ee8$export$9916df356b1b4d15 = (p, videoTrackType)=>{
    if (!p.pausedTracks) return false;
    const trackType = videoTrackType === 'videoTrack' ? $8c05ed6f2f331ee8$var$TrackType.VIDEO : videoTrackType === 'screenShareTrack' ? $8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE : undefined;
    if (!trackType) return false;
    return p.pausedTracks.includes(trackType);
};
/**
 * A comparator which sorts participants by the fact that they are the dominant speaker or not.
 *
 * @param a the first participant.
 * @param b the second participant.
 */ const $8c05ed6f2f331ee8$export$f52a863faac6eff = (a, b)=>{
    if (a.isDominantSpeaker && !b.isDominantSpeaker) return -1;
    if (!a.isDominantSpeaker && b.isDominantSpeaker) return 1;
    return 0;
};
/**
 * A comparator which sorts participants by the fact that they are speaking or not.
 *
 * @param a the first participant.
 * @param b the second participant.
 */ const $8c05ed6f2f331ee8$export$18744ed00d8e9d98 = (a, b)=>{
    if (a.isSpeaking && !b.isSpeaking) return -1;
    if (!a.isSpeaking && b.isSpeaking) return 1;
    return 0;
};
/**
 * A comparator which sorts participants by screen sharing status.
 *
 * @param a the first participant.
 * @param b the second participant.
 */ const $8c05ed6f2f331ee8$export$91e23e47a67fc7a2 = (a, b)=>{
    const hasA = $8c05ed6f2f331ee8$export$30c686c84ce95811(a);
    const hasB = $8c05ed6f2f331ee8$export$30c686c84ce95811(b);
    if (hasA && !hasB) return -1;
    if (!hasA && hasB) return 1;
    return 0;
};
/**
 * A comparator which sorts participants by video status.
 *
 * @param a the first participant.
 * @param b the second participant.
 */ const $8c05ed6f2f331ee8$export$6e750c8c3fe5480e = (a, b)=>{
    const hasA = $8c05ed6f2f331ee8$export$554515ce821ba4ab(a);
    const hasB = $8c05ed6f2f331ee8$export$554515ce821ba4ab(b);
    if (hasA && !hasB) return -1;
    if (!hasA && hasB) return 1;
    return 0;
};
/**
 * A comparator which sorts participants by audio status.
 *
 * @param a the first participant.
 * @param b the second participant.
 */ const $8c05ed6f2f331ee8$export$631849a167e15f8a = (a, b)=>{
    const hasA = $8c05ed6f2f331ee8$export$2e009d8a44827b31(a);
    const hasB = $8c05ed6f2f331ee8$export$2e009d8a44827b31(b);
    if (hasA && !hasB) return -1;
    if (!hasA && hasB) return 1;
    return 0;
};
/**
 * A comparator which prioritizes participants who are pinned.
 *
 * @param a the first participant.
 * @param b the second participant.
 */ const $8c05ed6f2f331ee8$export$9cea6167b1171147 = (a, b)=>{
    if (a.pin && b.pin) {
        if (!a.pin.isLocalPin && b.pin.isLocalPin) return -1;
        if (a.pin.isLocalPin && !b.pin.isLocalPin) return 1;
        if (a.pin.pinnedAt > b.pin.pinnedAt) return -1;
        if (a.pin.pinnedAt < b.pin.pinnedAt) return 1;
    }
    if (a.pin && !b.pin) return -1;
    if (!a.pin && b.pin) return 1;
    return 0;
};
/**
 * A comparator creator which will set up a comparator which prioritizes
 * participants who are from a specific source (e.g., WebRTC, RTMP, WHIP...).
 *
 * The priority of a source is determined by the order of the sources passed in.
 * e.g. [SRT, RTMP, WHIP] will prioritize SRT sources first, then RTMP, then WHIP.
 *
 * @param sources the sources to prioritize.
 */ const $8c05ed6f2f331ee8$export$750db869e6a10565 = (...sources)=>{
    const priority = (i)=>i === -1 ? Number.MAX_SAFE_INTEGER : i;
    return (a, b)=>{
        const priorityA = priority(sources.indexOf(a.source));
        const priorityB = priority(sources.indexOf(b.source));
        if (priorityA < priorityB) return -1;
        if (priorityA > priorityB) return 1;
        return 0;
    };
};
/**
 * A comparator creator which will set up a comparator which prioritizes
 * participants who have a specific reaction.
 *
 * @param type the reaction type.
 */ const $8c05ed6f2f331ee8$export$94ea91818e0e6b58 = (type)=>{
    return (a, b)=>{
        if (a.reaction?.type === type && b.reaction?.type !== type) return -1;
        if (a.reaction?.type !== type && b.reaction?.type === type) return 1;
        return 0;
    };
};
/**
 * A comparator creator which will set up a comparator which prioritizes
 * participants who have a specific role.
 *
 * @param roles the roles to prioritize.
 */ const $8c05ed6f2f331ee8$export$3100efae45e879 = (...roles)=>(a, b)=>{
        const hasA = $8c05ed6f2f331ee8$var$hasAnyRole(a, roles);
        const hasB = $8c05ed6f2f331ee8$var$hasAnyRole(b, roles);
        if (hasA && !hasB) return -1;
        if (!hasA && hasB) return 1;
        return 0;
    };
/**
 * A comparator which sorts participants by name.
 *
 * @param a the first participant.
 * @param b the second participant.
 */ const $8c05ed6f2f331ee8$export$a8ff84c12d48cfa6 = (a, b)=>{
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;
    return 0;
};
const $8c05ed6f2f331ee8$var$hasAnyRole = (p, roles)=>(p.roles || []).some((r)=>roles.includes(r));
// a comparator decorator which applies the decorated comparator only if the
// participant is invisible.
// This ensures stable sorting when all participants are visible.
const $8c05ed6f2f331ee8$var$ifInvisibleBy = $8c05ed6f2f331ee8$export$c327da55a124987a((a, b)=>a.viewportVisibilityState?.videoTrack === $8c05ed6f2f331ee8$export$1655277b7107d364.INVISIBLE || b.viewportVisibilityState?.videoTrack === $8c05ed6f2f331ee8$export$1655277b7107d364.INVISIBLE);
/**
 * A comparator that applies the decorated comparator when a participant is
 * either invisible or its visibility state isn't known.
 * For visible participants, it ensures stable sorting.
 */ const $8c05ed6f2f331ee8$var$ifInvisibleOrUnknownBy = $8c05ed6f2f331ee8$export$c327da55a124987a((a, b)=>a.viewportVisibilityState?.videoTrack === $8c05ed6f2f331ee8$export$1655277b7107d364.INVISIBLE || a.viewportVisibilityState?.videoTrack === $8c05ed6f2f331ee8$export$1655277b7107d364.UNKNOWN || b.viewportVisibilityState?.videoTrack === $8c05ed6f2f331ee8$export$1655277b7107d364.INVISIBLE || b.viewportVisibilityState?.videoTrack === $8c05ed6f2f331ee8$export$1655277b7107d364.UNKNOWN);
/**
 * A comparator that prioritizes participants with video ingress sources.
 */ const $8c05ed6f2f331ee8$var$withVideoIngressSource = $8c05ed6f2f331ee8$export$750db869e6a10565($8c05ed6f2f331ee8$var$ParticipantSource.RTMP, $8c05ed6f2f331ee8$var$ParticipantSource.SRT, $8c05ed6f2f331ee8$var$ParticipantSource.WHIP, $8c05ed6f2f331ee8$var$ParticipantSource.RTSP);
/**
 * The default sorting preset.
 */ const $8c05ed6f2f331ee8$export$e866caabda0ac9d1 = $8c05ed6f2f331ee8$export$d1c8e506ae873875($8c05ed6f2f331ee8$export$91e23e47a67fc7a2, $8c05ed6f2f331ee8$export$9cea6167b1171147, $8c05ed6f2f331ee8$var$ifInvisibleBy($8c05ed6f2f331ee8$export$d1c8e506ae873875($8c05ed6f2f331ee8$export$f52a863faac6eff, $8c05ed6f2f331ee8$export$18744ed00d8e9d98, $8c05ed6f2f331ee8$export$94ea91818e0e6b58('raised-hand'), $8c05ed6f2f331ee8$export$6e750c8c3fe5480e, $8c05ed6f2f331ee8$export$631849a167e15f8a)));
/**
 * The sorting preset for speaker layout.
 */ const $8c05ed6f2f331ee8$export$2cbe7072781a93bd = $8c05ed6f2f331ee8$export$d1c8e506ae873875($8c05ed6f2f331ee8$export$91e23e47a67fc7a2, $8c05ed6f2f331ee8$export$9cea6167b1171147, $8c05ed6f2f331ee8$export$f52a863faac6eff, $8c05ed6f2f331ee8$var$ifInvisibleBy($8c05ed6f2f331ee8$export$d1c8e506ae873875($8c05ed6f2f331ee8$export$18744ed00d8e9d98, $8c05ed6f2f331ee8$export$94ea91818e0e6b58('raised-hand'), $8c05ed6f2f331ee8$var$withVideoIngressSource, $8c05ed6f2f331ee8$export$6e750c8c3fe5480e, $8c05ed6f2f331ee8$export$631849a167e15f8a)));
/**
 * The sorting preset for layouts that don't render all participants but
 * instead, render them in pages.
 */ const $8c05ed6f2f331ee8$export$cc8c1c9b90e43435 = $8c05ed6f2f331ee8$export$d1c8e506ae873875($8c05ed6f2f331ee8$export$9cea6167b1171147, $8c05ed6f2f331ee8$var$ifInvisibleOrUnknownBy($8c05ed6f2f331ee8$export$d1c8e506ae873875($8c05ed6f2f331ee8$export$f52a863faac6eff, $8c05ed6f2f331ee8$export$18744ed00d8e9d98, $8c05ed6f2f331ee8$export$94ea91818e0e6b58('raised-hand'), $8c05ed6f2f331ee8$var$withVideoIngressSource, $8c05ed6f2f331ee8$export$6e750c8c3fe5480e, $8c05ed6f2f331ee8$export$631849a167e15f8a)));
/**
 * The sorting preset for livestreams and audio rooms.
 */ const $8c05ed6f2f331ee8$export$f6dee05b485e0fc = $8c05ed6f2f331ee8$export$d1c8e506ae873875($8c05ed6f2f331ee8$var$ifInvisibleOrUnknownBy($8c05ed6f2f331ee8$export$d1c8e506ae873875($8c05ed6f2f331ee8$export$f52a863faac6eff, $8c05ed6f2f331ee8$export$18744ed00d8e9d98, $8c05ed6f2f331ee8$export$94ea91818e0e6b58('raised-hand'), $8c05ed6f2f331ee8$var$withVideoIngressSource, $8c05ed6f2f331ee8$export$6e750c8c3fe5480e, $8c05ed6f2f331ee8$export$631849a167e15f8a)), $8c05ed6f2f331ee8$export$3100efae45e879('admin', 'host', 'speaker'));
const $8c05ed6f2f331ee8$var$ensureExhausted = (x, message)=>{
    $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger('helpers').warn(message, x);
};
/**
 * Returns the default egress object - when no egress data is available.
 */ const $8c05ed6f2f331ee8$var$defaultEgress = {
    broadcasting: false,
    hls: {
        playlist_url: '',
        status: ''
    },
    rtmps: []
};
/**
 * Holds the state of the current call.
 * @react You don't have to use this class directly, as we are exposing the state through Hooks.
 */ class $8c05ed6f2f331ee8$export$ab5ecb1e832001a8 {
    /**
     * Creates a new instance of the CallState class.
     *
     */ constructor(){
        this.backstageSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(true);
        this.blockedUserIdsSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)([]);
        this.createdAtSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(new Date());
        this.endedAtSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(undefined);
        this.startsAtSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(undefined);
        this.updatedAtSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(new Date());
        this.createdBySubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(undefined);
        this.customSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)({});
        this.egressSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(undefined);
        this.ingressSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(undefined);
        this.recordingSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(false);
        this.individualRecordingSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(false);
        this.rawRecordingSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(false);
        this.sessionSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(undefined);
        this.settingsSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(undefined);
        this.transcribingSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(false);
        this.captioningSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(false);
        this.endedBySubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(undefined);
        this.thumbnailsSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(undefined);
        this.membersSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)([]);
        this.ownCapabilitiesSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)([]);
        this.callingStateSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)($8c05ed6f2f331ee8$export$e10ca39c0aa31acc.UNKNOWN);
        this.startedAtSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(undefined);
        this.participantCountSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(0);
        this.anonymousParticipantCountSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(0);
        this.participantsSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)([]);
        this.callStatsReportSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(undefined);
        this.closedCaptionsSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)([]);
        // These are tracks that were delivered to the Subscriber's onTrack event
        // that we couldn't associate with a participant yet.
        // This happens when the participantJoined event hasn't been received yet.
        // We keep these tracks around until we can associate them with a participant.
        this.orphanedTracks = [];
        this.callGrantsSubject = new (0, $4a1890c700519557$export$915d2682b0aa0991)(1);
        this.logger = $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger('CallState');
        /**
         * A list of comparators that are used to sort the participants.
         */ this.sortParticipantsBy = $8c05ed6f2f331ee8$export$e866caabda0ac9d1;
        this.closedCaptionsTasks = new Map();
        /**
         * Runs the cleanup tasks.
         */ this.dispose = ()=>{
            for (const [ccKey, taskId] of this.closedCaptionsTasks.entries()){
                clearTimeout(taskId);
                this.closedCaptionsTasks.delete(ccKey);
            }
        };
        /**
         * Sets the list of criteria that are used to sort the participants.
         * To disable sorting, you can pass `noopComparator()`.
         *
         * @param comparator the comparator to use to sort the participants.
         */ this.setSortParticipantsBy = (comparator)=>{
            this.sortParticipantsBy = comparator;
            // trigger re-sorting of participants
            this.setCurrentValue(this.participantsSubject, (ps)=>ps);
        };
        /**
         * Gets the current value of an observable, or undefined if the observable has
         * not emitted a value yet.
         *
         * @param observable$ the observable to get the value from.
         */ this.getCurrentValue = $8c05ed6f2f331ee8$var$getCurrentValue;
        /**
         * Updates the value of the provided Subject.
         * An `update` can either be a new value or a function which takes
         * the current value and returns a new value.
         *
         * @internal
         *
         * @param subject the subject to update.
         * @param update the update to apply to the subject.
         * @return the updated value.
         */ this.setCurrentValue = $8c05ed6f2f331ee8$var$setCurrentValue;
        /**
         * Sets the number of participants in the current call.
         *
         * @internal
         * @param count the number of participants.
         */ this.setParticipantCount = (count)=>{
            return this.setCurrentValue(this.participantCountSubject, count);
        };
        /**
         * Sets the time the call session actually started.
         *
         * @internal
         * @param startedAt the time the call session actually started.
         */ this.setStartedAt = (startedAt)=>{
            return this.setCurrentValue(this.startedAtSubject, startedAt);
        };
        /**
         * Sets the closed captioning state of the current call.
         *
         * @internal
         * @param captioning the closed captioning state.
         */ this.setCaptioning = (captioning)=>{
            return $8c05ed6f2f331ee8$var$updateValue(this.captioningSubject, captioning);
        };
        /**
         * Sets the number of anonymous participants in the current call.
         *
         * @internal
         * @param count the number of anonymous participants.
         */ this.setAnonymousParticipantCount = (count)=>{
            return this.setCurrentValue(this.anonymousParticipantCountSubject, count);
        };
        /**
         * Returns the current participants array directly from the BehaviorSubject.
         * This bypasses the observable pipeline and is guaranteed to be synchronous.
         * Use this when you need the absolute latest value without any potential
         * timing issues from shareReplay/refCount.
         *
         * @internal
         */ this.getParticipantsSnapshot = ()=>{
            return this.participantsSubject.getValue();
        };
        /**
         * Sets the list of participants in the current call.
         *
         * @internal
         *
         * @param participants the list of participants.
         */ this.setParticipants = (participants)=>{
            return this.setCurrentValue(this.participantsSubject, participants);
        };
        /**
         * Sets the calling state.
         *
         * @internal
         * @param state the new calling state.
         */ this.setCallingState = (state)=>{
            return this.setCurrentValue(this.callingStateSubject, state);
        };
        /**
         * Sets the call stats report.
         *
         * @internal
         * @param report the report to set.
         */ this.setCallStatsReport = (report)=>{
            return this.setCurrentValue(this.callStatsReportSubject, report);
        };
        /**
         * Sets the members of the current call.
         *
         * @internal
         * @param members the members to set.
         */ this.setMembers = (members)=>{
            this.setCurrentValue(this.membersSubject, members);
        };
        /**
         * Sets the own capabilities.
         *
         * @internal
         * @param capabilities the capabilities to set.
         */ this.setOwnCapabilities = (capabilities)=>{
            return this.setCurrentValue(this.ownCapabilitiesSubject, capabilities);
        };
        /**
         * Sets the call grants (used for own capabilities).
         *
         * @internal
         * @param grants the grants to set.
         */ this.setCallGrants = (grants)=>{
            return this.setCurrentValue(this.callGrantsSubject, grants);
        };
        /**
         * Sets the backstage state.
         * @param backstage the backstage state.
         */ this.setBackstage = (backstage)=>{
            return this.setCurrentValue(this.backstageSubject, backstage);
        };
        /**
         * Sets the time when this call has been ended.
         * @param endedAt the time when this call has been ended.
         */ this.setEndedAt = (endedAt)=>{
            return this.setCurrentValue(this.endedAtSubject, endedAt);
        };
        /**
         * Will try to find the participant with the given sessionId in the current call.
         *
         * @param sessionId the sessionId of the participant to find.
         * @returns the participant with the given sessionId or undefined if not found.
         */ this.findParticipantBySessionId = (sessionId)=>{
            return this.participants.find((p)=>p.sessionId === sessionId);
        };
        /**
         * Returns a new lookup table of participants indexed by their session ID.
         */ this.getParticipantLookupBySessionId = ()=>{
            return this.participants.reduce((lookupTable, participant)=>{
                lookupTable[participant.sessionId] = participant;
                return lookupTable;
            }, {});
        };
        /**
         * Updates a participant in the current call identified by the given `sessionId`.
         * If the participant can't be found, this operation is no-op.
         *
         * @internal
         *
         * @param sessionId the session ID of the participant to update.
         * @param patch the patch to apply to the participant.
         * @returns the updated participant or `undefined` if the participant couldn't be found.
         */ this.updateParticipant = (sessionId, patch)=>{
            const participant = this.findParticipantBySessionId(sessionId);
            if (!participant) {
                this.logger.debug(`Participant with sessionId ${sessionId} not found`);
                return;
            }
            const thePatch = typeof patch === 'function' ? patch(participant) : patch;
            const updatedParticipant = {
                ...participant,
                ...thePatch
            };
            return this.setParticipants((participants)=>participants.map((p)=>p.sessionId === sessionId ? updatedParticipant : p));
        };
        /**
         * Updates a participant in the current call identified by the given `sessionId`.
         * If a participant with matching `sessionId` can't be found, the provided
         * `participant` is added to the list of participants.
         *
         * @param sessionId the session ID of the participant to update.
         * @param participant the participant to update or add.
         * @param patch an optional patch to apply to the participant.
         */ this.updateOrAddParticipant = (sessionId, participant, patch)=>{
            return this.setParticipants((participants)=>{
                let add = true;
                const nextParticipants = participants.map((p)=>{
                    if (p.sessionId === sessionId) {
                        add = false;
                        const updated = {
                            ...p,
                            ...participant
                        };
                        const thePatch = typeof patch === 'function' ? patch(updated) : patch;
                        return Object.assign(updated, thePatch);
                    }
                    return p;
                });
                if (add) nextParticipants.push(participant);
                return nextParticipants;
            });
        };
        /**
         * Updates all participants in the current call whose session ID is in the given `sessionIds`.
         * If no patches are provided, this operation is no-op.
         *
         * @internal
         *
         * @param patch the patch to apply to the participants.
         * @returns all participants, with all patch applied.
         */ this.updateParticipants = (patch)=>{
            if (Object.keys(patch).length === 0) return this.participants;
            return this.setParticipants((participants)=>participants.map((p)=>{
                    const thePatch = patch[p.sessionId];
                    if (thePatch) return {
                        ...p,
                        ...thePatch
                    };
                    return p;
                }));
        };
        /**
         * Update track subscription configuration for one or more participants.
         * You have to create a subscription for each participant for all the different kinds of tracks you want to receive.
         * You can only subscribe for tracks after the participant started publishing the given kind of track.
         *
         * @param trackType the kind of subscription to update.
         * @param changes the list of subscription changes to do.
         */ this.updateParticipantTracks = (trackType, changes)=>{
            return this.updateParticipants(Object.entries(changes).reduce((acc, [sessionId, change])=>{
                if (change.dimension) {
                    change.dimension.height = Math.ceil(change.dimension.height);
                    change.dimension.width = Math.ceil(change.dimension.width);
                }
                const prop = trackType === 'videoTrack' ? 'videoDimension' : trackType === 'screenShareTrack' ? 'screenShareDimension' : undefined;
                if (prop) acc[sessionId] = {
                    [prop]: change.dimension
                };
                return acc;
            }, {}));
        };
        /**
         * Updates the call state with the data received from the server.
         *
         * @internal
         *
         * @param event the video event that our backend sent us.
         */ this.updateFromEvent = (event)=>{
            const update = this.eventHandlers[event.type];
            if (update) update(event);
        };
        /**
         * Updates the participant pinned state with server side pinning data.
         *
         * @param pins the latest pins from the server.
         */ this.setServerSidePins = (pins)=>{
            const now = Date.now();
            const unknownSymbol = Symbol('unknown');
            // generate a lookup table of pinnedAt timestamps by userId and sessionId
            // if there are multiple pins for the same userId, then we set the pinnedAt
            // to `unknown` (for that userId lookup) so that we don't apply any pin for that participant
            // this is to avoid conflicts during reconstruction of the pin state after reconnections
            // as sessionIds can change
            const pinnedAtByIdentifier = pins.reduce((lookup, pin, index)=>{
                var _a;
                const pinnedAt = now + (pins.length - index);
                if (lookup[pin.userId]) lookup[pin.userId] = unknownSymbol;
                else lookup[pin.userId] = pinnedAt;
                lookup[_a = pin.sessionId] ?? (lookup[_a] = pinnedAt);
                return lookup;
            }, {});
            return this.setParticipants((participants)=>participants.map((participant)=>{
                    // first check by sessionId as that is 100% correct, then by attempt reconstruction by userId
                    const serverSidePinnedAt = pinnedAtByIdentifier[participant.sessionId] ?? pinnedAtByIdentifier[participant.userId];
                    // the participant is newly pinned
                    if (typeof serverSidePinnedAt === 'number' && typeof participant.pin?.pinnedAt !== 'number') return {
                        ...participant,
                        pin: {
                            isLocalPin: false,
                            pinnedAt: serverSidePinnedAt
                        }
                    };
                    // the participant is no longer pinned server side
                    // we need to reset the pin
                    if (typeof serverSidePinnedAt !== 'number' && participant.pin?.isLocalPin === false) return {
                        ...participant,
                        pin: undefined
                    };
                    // no changes to be applied
                    return participant;
                }));
        };
        /**
         * Adds an orphaned track to the call state.
         *
         * @internal
         *
         * @param orphanedTrack the orphaned track to add.
         */ this.registerOrphanedTrack = (orphanedTrack)=>{
            this.orphanedTracks.push(orphanedTrack);
        };
        /**
         * Removes an orphaned track from the call state.
         *
         * @internal
         *
         * @param id the ID of the orphaned track to remove.
         */ this.removeOrphanedTrack = (id)=>{
            this.orphanedTracks = this.orphanedTracks.filter((o)=>o.id !== id);
        };
        /**
         * Takes all orphaned tracks with the given track lookup prefix.
         * All orphaned tracks with the given track lookup prefix are removed from the call state.
         *
         * @internal
         *
         * @param trackLookupPrefix the track lookup prefix to match the orphaned tracks by.
         */ this.takeOrphanedTracks = (trackLookupPrefix)=>{
            const orphans = this.orphanedTracks.filter((orphan)=>orphan.trackLookupPrefix === trackLookupPrefix);
            if (orphans.length > 0) this.orphanedTracks = this.orphanedTracks.filter((orphan)=>orphan.trackLookupPrefix !== trackLookupPrefix);
            return orphans;
        };
        /**
         * Updates the closed captions settings.
         *
         * @param config the new closed captions settings.
         */ this.updateClosedCaptionSettings = (config)=>{
            this.closedCaptionsSettings = {
                ...this.closedCaptionsSettings,
                ...config
            };
        };
        /**
         * Updates the call state with the data received from the server.
         *
         * @internal
         *
         * @param call the call response from the server.
         */ this.updateFromCallResponse = (call)=>{
            this.setBackstage(call.backstage);
            this.setCurrentValue(this.blockedUserIdsSubject, call.blocked_user_ids);
            this.setCurrentValue(this.createdAtSubject, new Date(call.created_at));
            this.setCurrentValue(this.updatedAtSubject, new Date(call.updated_at));
            this.setCurrentValue(this.startsAtSubject, call.starts_at ? new Date(call.starts_at) : undefined);
            this.setEndedAt(call.ended_at ? new Date(call.ended_at) : undefined);
            this.setCurrentValue(this.createdBySubject, call.created_by);
            this.setCurrentValue(this.customSubject, call.custom);
            this.setCurrentValue(this.egressSubject, call.egress);
            this.setCurrentValue(this.ingressSubject, call.ingress);
            const { individual_recording: individual_recording, composite_recording: composite_recording, raw_recording: raw_recording } = call.egress;
            this.setCurrentValue(this.recordingSubject, call.recording || composite_recording?.status === 'running');
            this.setCurrentValue(this.individualRecordingSubject, individual_recording?.status === 'running');
            this.setCurrentValue(this.rawRecordingSubject, raw_recording?.status === 'running');
            const s = this.setCurrentValue(this.sessionSubject, call.session);
            this.updateParticipantCountFromSession(s);
            this.setCurrentValue(this.settingsSubject, call.settings);
            this.setCurrentValue(this.transcribingSubject, call.transcribing);
            this.setCurrentValue(this.captioningSubject, call.captioning);
            this.setCurrentValue(this.thumbnailsSubject, call.thumbnails);
        };
        /**
         * Updates the call state with the data received from the SFU server.
         *
         * @internal
         *
         * @param callState the call state from the SFU server.
         * @param currentSessionId the session ID of the current user.
         * @param reconnectDetails optional reconnect details.
         */ this.updateFromSfuCallState = (callState, currentSessionId, reconnectDetails)=>{
            const { participants: participants, participantCount: participantCount, startedAt: startedAt, pins: pins } = callState;
            const localPublishedTracks = reconnectDetails?.announcedTracks.map((t)=>t.trackType) ?? [];
            this.setParticipants(()=>{
                const participantLookup = this.getParticipantLookupBySessionId();
                return participants.map((p)=>{
                    // We need to preserve the local state of the participant
                    // (e.g. videoDimension, visibilityState, pinnedAt, etc.)
                    // as it doesn't exist on the server.
                    const existingParticipant = participantLookup[p.sessionId];
                    const isLocalParticipant = p.sessionId === currentSessionId;
                    return Object.assign({}, existingParticipant, p, {
                        isLocalParticipant: isLocalParticipant,
                        publishedTracks: isLocalParticipant ? localPublishedTracks : p.publishedTracks,
                        viewportVisibilityState: existingParticipant?.viewportVisibilityState ?? {
                            videoTrack: $8c05ed6f2f331ee8$export$1655277b7107d364.UNKNOWN,
                            screenShareTrack: $8c05ed6f2f331ee8$export$1655277b7107d364.UNKNOWN
                        }
                    });
                });
            });
            this.setParticipantCount(participantCount?.total || 0);
            this.setAnonymousParticipantCount(participantCount?.anonymous || 0);
            this.setStartedAt(startedAt ? $8c05ed6f2f331ee8$var$Timestamp.toDate(startedAt) : new Date());
            this.setServerSidePins(pins);
        };
        this.updateFromMemberRemoved = (event)=>{
            this.updateFromCallResponse(event.call);
            this.setCurrentValue(this.membersSubject, (members)=>members.filter((m)=>event.members.indexOf(m.user_id) === -1));
        };
        this.updateFromMemberAdded = (event)=>{
            this.updateFromCallResponse(event.call);
            this.setCurrentValue(this.membersSubject, (members)=>[
                    ...members,
                    ...event.members
                ]);
        };
        this.updateFromHLSBroadcastStopped = ()=>{
            this.setCurrentValue(this.egressSubject, (egress = $8c05ed6f2f331ee8$var$defaultEgress)=>({
                    ...egress,
                    broadcasting: false,
                    hls: {
                        ...egress.hls,
                        status: ''
                    }
                }));
        };
        this.updateFromHLSBroadcastingFailed = ()=>{
            this.setCurrentValue(this.egressSubject, (egress = $8c05ed6f2f331ee8$var$defaultEgress)=>({
                    ...egress,
                    broadcasting: false,
                    hls: {
                        ...egress.hls,
                        status: ''
                    }
                }));
        };
        this.updateFromRecordingEvent = (type, running)=>{
            // handle the legacy format, where `type` is absent in the emitted events
            if (type === undefined || type === 'composite') this.setCurrentValue(this.recordingSubject, running);
            else if (type === 'individual') this.setCurrentValue(this.individualRecordingSubject, running);
            else if (type === 'raw') this.setCurrentValue(this.rawRecordingSubject, running);
            else $8c05ed6f2f331ee8$var$ensureExhausted(type, 'Unknown recording type');
        };
        this.updateParticipantCountFromSession = (session)=>{
            // when in JOINED state, we should use the participant count coming through
            // the SFU healthcheck event, as it's more accurate.
            if (!session || this.callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.JOINED) return;
            const byRoleCount = Object.values(session.participants_count_by_role).reduce((total, countByRole)=>total + countByRole, 0);
            const participantCount = Math.max(byRoleCount, session.participants.length);
            this.setParticipantCount(participantCount);
            this.setAnonymousParticipantCount(session.anonymous_participant_count || 0);
        };
        this.updateFromSessionParticipantCountUpdate = (event)=>{
            const s = this.setCurrentValue(this.sessionSubject, (session)=>{
                if (!session) return session;
                return {
                    ...session,
                    anonymous_participant_count: event.anonymous_participant_count,
                    participants_count_by_role: event.participants_count_by_role
                };
            });
            this.updateParticipantCountFromSession(s);
        };
        this.updateFromSessionParticipantLeft = (event)=>{
            const s = this.setCurrentValue(this.sessionSubject, (session)=>{
                if (!session) return session;
                const { participants: participants, participants_count_by_role: participants_count_by_role } = session;
                const { user: user, user_session_id: user_session_id } = event.participant;
                return {
                    ...session,
                    participants: participants.filter((p)=>p.user_session_id !== user_session_id),
                    participants_count_by_role: {
                        ...participants_count_by_role,
                        [user.role]: Math.max(0, (participants_count_by_role[user.role] || 0) - 1)
                    }
                };
            });
            this.updateParticipantCountFromSession(s);
        };
        this.updateFromSessionParticipantJoined = (event)=>{
            const s = this.setCurrentValue(this.sessionSubject, (session)=>{
                if (!session) return session;
                const { participants: participants, participants_count_by_role: participants_count_by_role } = session;
                const { user: user, user_session_id: user_session_id } = event.participant;
                // It could happen that the backend delivers the same participant more than once.
                // Once with the call.session_started event and once again with the
                // call.session_participant_joined event. In this case,
                // we should update the existing participant and prevent duplicating it.
                let shouldInsertParticipant = true;
                const updatedParticipants = participants.map((p)=>{
                    if (p.user_session_id === user_session_id) {
                        shouldInsertParticipant = false;
                        return event.participant;
                    }
                    return p;
                });
                if (shouldInsertParticipant) // this is a new array, we can safely push the new participant
                updatedParticipants.push(event.participant);
                // If we are updating an existing participant, we don't want to increment
                // the participant_by_role count.
                const increment = shouldInsertParticipant ? 1 : 0;
                return {
                    ...session,
                    participants: updatedParticipants,
                    participants_count_by_role: {
                        ...participants_count_by_role,
                        [user.role]: (participants_count_by_role[user.role] || 0) + increment
                    }
                };
            });
            this.updateParticipantCountFromSession(s);
        };
        this.updateMembers = (event)=>{
            this.updateFromCallResponse(event.call);
            this.setCurrentValue(this.membersSubject, (members)=>members.map((member)=>{
                    const memberUpdate = event.members.find((m)=>m.user_id === member.user_id);
                    return memberUpdate ? memberUpdate : member;
                }));
        };
        this.updateParticipantReaction = (event)=>{
            const { user: user, custom: custom, type: type, emoji_code: emoji_code } = event.reaction;
            this.setParticipants((participants)=>{
                return participants.map((p)=>{
                    // skip if the reaction is not for this participant
                    if (p.userId !== user.id) return p;
                    // update the participant with the new reaction
                    return {
                        ...p,
                        reaction: {
                            type: type,
                            emoji_code: emoji_code,
                            custom: custom
                        }
                    };
                });
            });
        };
        this.unblockUser = (event)=>{
            this.setCurrentValue(this.blockedUserIdsSubject, (current)=>{
                if (!current) return current;
                return current.filter((id)=>id !== event.user.id);
            });
        };
        this.blockUser = (event)=>{
            this.setCurrentValue(this.blockedUserIdsSubject, (current)=>[
                    ...current || [],
                    event.user.id
                ]);
        };
        this.updateOwnCapabilities = (event)=>{
            if (event.user.id === this.localParticipant?.userId) this.setOwnCapabilities(event.own_capabilities);
        };
        this.updateFromClosedCaptions = (event)=>{
            this.setCurrentValue(this.closedCaptionsSubject, (queue)=>{
                const { closed_caption: closed_caption } = event;
                const keyOf = (c)=>`${c.speaker_id}/${c.start_time}`;
                const currentKey = keyOf(closed_caption);
                const duplicate = queue.some((caption)=>keyOf(caption) === currentKey);
                if (duplicate) return queue;
                const nextQueue = [
                    ...queue,
                    closed_caption
                ];
                const { visibilityDurationMs: visibilityDurationMs = 2700, maxVisibleCaptions: maxVisibleCaptions = 2 } = this.closedCaptionsSettings || {};
                // schedule the removal of the closed caption after the retention time
                if (visibilityDurationMs > 0) {
                    const taskId = setTimeout(()=>{
                        this.setCurrentValue(this.closedCaptionsSubject, (captions)=>captions.filter((caption)=>caption !== closed_caption));
                        this.closedCaptionsTasks.delete(currentKey);
                    }, visibilityDurationMs);
                    this.closedCaptionsTasks.set(currentKey, taskId);
                    // cancel the cleanup tasks for the closed captions that are no longer in the queue
                    for(let i = 0; i < nextQueue.length - maxVisibleCaptions; i++){
                        const key = keyOf(nextQueue[i]);
                        const task = this.closedCaptionsTasks.get(key);
                        clearTimeout(task);
                        this.closedCaptionsTasks.delete(key);
                    }
                }
                // trim the queue
                return nextQueue.slice(-maxVisibleCaptions);
            });
        };
        this.rawParticipants$ = this.participantsSubject.asObservable().pipe((0, $cd8167599454f872$export$db61d692014e534e)({
            bufferSize: 1,
            refCount: true
        }));
        this.participants$ = this.participantsSubject.asObservable().pipe(// maintain stable-sort by mutating the participants stored
        // in the original subject
        (0, $9853a79d111e4e33$export$871de8747c9eaa88)((ps)=>ps.sort(this.sortParticipantsBy)), (0, $cd8167599454f872$export$db61d692014e534e)({
            bufferSize: 1,
            refCount: true
        }));
        this.localParticipant$ = this.participants$.pipe((0, $9853a79d111e4e33$export$871de8747c9eaa88)((participants)=>participants.find((p)=>p.isLocalParticipant)), (0, $cd8167599454f872$export$db61d692014e534e)({
            bufferSize: 1,
            refCount: true
        }));
        this.remoteParticipants$ = this.participants$.pipe((0, $9853a79d111e4e33$export$871de8747c9eaa88)((participants)=>participants.filter((p)=>!p.isLocalParticipant)), (0, $cd8167599454f872$export$db61d692014e534e)({
            bufferSize: 1,
            refCount: true
        }));
        this.pinnedParticipants$ = this.participants$.pipe((0, $9853a79d111e4e33$export$871de8747c9eaa88)((participants)=>participants.filter((p)=>!!p.pin)), (0, $cd8167599454f872$export$db61d692014e534e)({
            bufferSize: 1,
            refCount: true
        }));
        this.dominantSpeaker$ = this.participants$.pipe((0, $9853a79d111e4e33$export$871de8747c9eaa88)((participants)=>participants.find((p)=>p.isDominantSpeaker)), (0, $cd8167599454f872$export$db61d692014e534e)({
            bufferSize: 1,
            refCount: true
        }));
        this.hasOngoingScreenShare$ = this.participants$.pipe((0, $9853a79d111e4e33$export$871de8747c9eaa88)((participants)=>participants.some((p)=>$8c05ed6f2f331ee8$export$30c686c84ce95811(p))), (0, $6fb8b1c12553edae$export$779c5fb865a0172e)(), (0, $cd8167599454f872$export$db61d692014e534e)({
            bufferSize: 1,
            refCount: true
        }));
        // dates
        this.createdAt$ = this.createdAtSubject.asObservable();
        this.endedAt$ = this.endedAtSubject.asObservable();
        this.startsAt$ = this.startsAtSubject.asObservable();
        this.startedAt$ = this.startedAtSubject.asObservable();
        this.updatedAt$ = this.updatedAtSubject.asObservable();
        this.callStatsReport$ = this.callStatsReportSubject.asObservable();
        this.members$ = this.membersSubject.asObservable();
        // complex objects should work as streams of data
        this.createdBy$ = this.createdBySubject.asObservable();
        this.custom$ = this.customSubject.asObservable();
        this.egress$ = this.egressSubject.asObservable();
        this.ingress$ = this.ingressSubject.asObservable();
        this.session$ = this.sessionSubject.asObservable();
        this.settings$ = this.settingsSubject.asObservable();
        this.endedBy$ = this.endedBySubject.asObservable();
        this.thumbnails$ = this.thumbnailsSubject.asObservable();
        this.closedCaptions$ = this.closedCaptionsSubject.asObservable();
        /**
         * Performs shallow comparison of two arrays.
         * Expects primitive values: [1, 2, 3] is equal to [2, 1, 3].
         */ const isShallowEqual = (a, b)=>{
            if (a.length !== b.length) return false;
            for (const item of a){
                if (!b.includes(item)) return false;
            }
            for (const item of b){
                if (!a.includes(item)) return false;
            }
            return true;
        };
        /**
         * Creates an Observable from the given subject by piping to the
         * `distinctUntilChanged()` operator.
         */ const duc = (subject, comparator)=>subject.pipe((0, $6fb8b1c12553edae$export$779c5fb865a0172e)(comparator));
        // primitive values should only emit once the value they hold changes
        this.anonymousParticipantCount$ = duc(this.anonymousParticipantCountSubject);
        this.blockedUserIds$ = duc(this.blockedUserIdsSubject, isShallowEqual);
        this.backstage$ = duc(this.backstageSubject);
        this.callingState$ = duc(this.callingStateSubject);
        this.ownCapabilities$ = (0, $0e8b72f41887b114$export$77fa7d86f5204e8a)([
            this.ownCapabilitiesSubject,
            this.callGrantsSubject.pipe((0, $b52129d9072c7912$export$a4fe86229b0e9bdd)(undefined))
        ]).pipe((0, $9853a79d111e4e33$export$871de8747c9eaa88)(([capabilities, grants])=>{
            if (!grants) return capabilities;
            const { canPublishAudio: canPublishAudio, canPublishVideo: canPublishVideo, canScreenshare: canScreenshare } = grants;
            const update = {
                [$8c05ed6f2f331ee8$export$9d72b1bd9eedd7a7.SEND_AUDIO]: canPublishAudio,
                [$8c05ed6f2f331ee8$export$9d72b1bd9eedd7a7.SEND_VIDEO]: canPublishVideo,
                [$8c05ed6f2f331ee8$export$9d72b1bd9eedd7a7.SCREENSHARE]: canScreenshare
            };
            const nextCapabilities = [
                ...capabilities
            ];
            for(const _capability in update){
                const capability = _capability;
                const allowed = update[capability];
                // grants take precedence over capabilities, reconstruct the capabilities
                if (allowed && !nextCapabilities.includes(capability)) nextCapabilities.push(capability);
                else if (!allowed && nextCapabilities.includes(capability)) {
                    const index = nextCapabilities.indexOf(capability);
                    nextCapabilities.splice(index, 1);
                }
            }
            return nextCapabilities;
        }), (0, $6fb8b1c12553edae$export$779c5fb865a0172e)(isShallowEqual), (0, $cd8167599454f872$export$db61d692014e534e)({
            bufferSize: 1,
            refCount: true
        }));
        this.participantCount$ = duc(this.participantCountSubject);
        this.recording$ = duc(this.recordingSubject);
        this.individualRecording$ = duc(this.individualRecordingSubject);
        this.rawRecording$ = duc(this.rawRecordingSubject);
        this.transcribing$ = duc(this.transcribingSubject);
        this.captioning$ = duc(this.captioningSubject);
        this.eventHandlers = {
            // these events are not updating the call state:
            'call.frame_recording_ready': undefined,
            'call.kicked_user': undefined,
            'call.moderation_blur': undefined,
            'call.moderation_warning': undefined,
            'call.permission_request': undefined,
            'call.recording_ready': undefined,
            'call.rtmp_broadcast_failed': undefined,
            'call.rtmp_broadcast_started': undefined,
            'call.rtmp_broadcast_stopped': undefined,
            'call.stats_report_ready': undefined,
            'call.transcription_ready': undefined,
            'call.user_feedback_submitted': undefined,
            'call.user_muted': undefined,
            'connection.error': undefined,
            'connection.ok': undefined,
            'health.check': undefined,
            'user.updated': undefined,
            custom: undefined,
            // events that update call state:
            'call.accepted': (e)=>this.updateFromCallResponse(e.call),
            'call.blocked_user': this.blockUser,
            'call.closed_caption': this.updateFromClosedCaptions,
            'call.closed_captions_failed': ()=>{
                this.setCurrentValue(this.captioningSubject, false);
            },
            'call.closed_captions_started': ()=>{
                this.setCurrentValue(this.captioningSubject, true);
            },
            'call.closed_captions_stopped': ()=>{
                this.setCurrentValue(this.captioningSubject, false);
            },
            'call.created': (e)=>this.updateFromCallResponse(e.call),
            'call.deleted': (e)=>this.updateFromCallResponse(e.call),
            'call.ended': (e)=>{
                this.updateFromCallResponse(e.call);
                this.setCurrentValue(this.endedBySubject, e.user);
            },
            'call.frame_recording_failed': (e)=>{
                this.updateFromCallResponse(e.call);
            },
            'call.frame_recording_started': (e)=>{
                this.updateFromCallResponse(e.call);
            },
            'call.frame_recording_stopped': (e)=>{
                this.updateFromCallResponse(e.call);
            },
            'call.hls_broadcasting_failed': this.updateFromHLSBroadcastingFailed,
            'call.hls_broadcasting_started': (e)=>{
                this.updateFromCallResponse(e.call);
            },
            'call.hls_broadcasting_stopped': this.updateFromHLSBroadcastStopped,
            'call.live_started': (e)=>this.updateFromCallResponse(e.call),
            'call.member_added': this.updateFromMemberAdded,
            'call.member_removed': this.updateFromMemberRemoved,
            'call.member_updated_permission': this.updateMembers,
            'call.member_updated': this.updateMembers,
            'call.notification': (e)=>{
                this.updateFromCallResponse(e.call);
                this.setMembers(e.members);
            },
            'call.permissions_updated': this.updateOwnCapabilities,
            'call.reaction_new': this.updateParticipantReaction,
            'call.recording_started': (e)=>{
                this.updateFromRecordingEvent(e.recording_type, true);
            },
            'call.recording_stopped': (e)=>{
                this.updateFromRecordingEvent(e.recording_type, false);
            },
            'call.recording_failed': (e)=>{
                this.updateFromRecordingEvent(e.recording_type, false);
            },
            'call.rejected': (e)=>this.updateFromCallResponse(e.call),
            'call.ring': (e)=>this.updateFromCallResponse(e.call),
            'call.missed': (e)=>this.updateFromCallResponse(e.call),
            'call.session_ended': (e)=>this.updateFromCallResponse(e.call),
            'call.session_participant_count_updated': this.updateFromSessionParticipantCountUpdate,
            'call.session_participant_joined': this.updateFromSessionParticipantJoined,
            'call.session_participant_left': this.updateFromSessionParticipantLeft,
            'call.session_started': (e)=>this.updateFromCallResponse(e.call),
            'call.transcription_started': ()=>{
                this.setCurrentValue(this.transcribingSubject, true);
            },
            'call.transcription_stopped': ()=>{
                this.setCurrentValue(this.transcribingSubject, false);
            },
            'call.transcription_failed': ()=>{
                this.setCurrentValue(this.transcribingSubject, false);
            },
            'call.unblocked_user': this.unblockUser,
            'call.updated': (e)=>this.updateFromCallResponse(e.call)
        };
    }
    /**
     * The server-side counted number of participants connected to the current call.
     * This number includes the anonymous participants as well.
     */ get participantCount() {
        return this.getCurrentValue(this.participantCount$);
    }
    /**
     * The time the call session actually started.
     * Useful for displaying the call duration.
     */ get startedAt() {
        return this.getCurrentValue(this.startedAt$);
    }
    /**
     * Returns whether closed captions are enabled in the current call.
     */ get captioning() {
        return this.getCurrentValue(this.captioning$);
    }
    /**
     * The server-side counted number of anonymous participants connected to the current call.
     * This number includes the anonymous participants as well.
     */ get anonymousParticipantCount() {
        return this.getCurrentValue(this.anonymousParticipantCount$);
    }
    /**
     * The list of participants in the current call.
     */ get participants() {
        return this.getCurrentValue(this.participants$);
    }
    /**
     * The stable list of participants in the current call, unsorted.
     */ get rawParticipants() {
        return this.getCurrentValue(this.rawParticipants$);
    }
    /**
     * The local participant in the current call.
     */ get localParticipant() {
        return this.getCurrentValue(this.localParticipant$);
    }
    /**
     * The list of remote participants in the current call.
     */ get remoteParticipants() {
        return this.getCurrentValue(this.remoteParticipants$);
    }
    /**
     * The dominant speaker in the current call.
     */ get dominantSpeaker() {
        return this.getCurrentValue(this.dominantSpeaker$);
    }
    /**
     * The list of pinned participants in the current call.
     */ get pinnedParticipants() {
        return this.getCurrentValue(this.pinnedParticipants$);
    }
    /**
     * Tell if there is an ongoing screen share in this call.
     */ get hasOngoingScreenShare() {
        return this.getCurrentValue(this.hasOngoingScreenShare$);
    }
    /**
     * The calling state.
     */ get callingState() {
        return this.getCurrentValue(this.callingState$);
    }
    /**
     * The call stats report.
     */ get callStatsReport() {
        return this.getCurrentValue(this.callStatsReport$);
    }
    /**
     * Returns whether the call stats report is being observed or not.
     * @internal
     */ get isCallStatsReportObserved() {
        return this.callStatsReportSubject.observed;
    }
    /**
     * The members of the current call.
     */ get members() {
        return this.getCurrentValue(this.members$);
    }
    /**
     * The capabilities of the current user for the current call.
     */ get ownCapabilities() {
        return this.getCurrentValue(this.ownCapabilities$);
    }
    /**
     * The backstage state.
     */ get backstage() {
        return this.getCurrentValue(this.backstage$);
    }
    /**
     * Will provide the list of blocked user IDs.
     */ get blockedUserIds() {
        return this.getCurrentValue(this.blockedUserIds$);
    }
    /**
     * Will provide the time when this call has been created.
     */ get createdAt() {
        return this.getCurrentValue(this.createdAt$);
    }
    /**
     * Will provide the time when this call has been ended.
     */ get endedAt() {
        return this.getCurrentValue(this.endedAt$);
    }
    /**
     * Will provide the time when this call has been scheduled to start.
     */ get startsAt() {
        return this.getCurrentValue(this.startsAt$);
    }
    /**
     * Will provide the time when this call has been updated.
     */ get updatedAt() {
        return this.getCurrentValue(this.updatedAt$);
    }
    /**
     * Will provide the user who created this call.
     */ get createdBy() {
        return this.getCurrentValue(this.createdBy$);
    }
    /**
     * Will provide the custom data of this call.
     */ get custom() {
        return this.getCurrentValue(this.custom$);
    }
    /**
     * Will provide the egress data of this call.
     */ get egress() {
        return this.getCurrentValue(this.egress$);
    }
    /**
     * Will provide the ingress data of this call.
     */ get ingress() {
        return this.getCurrentValue(this.ingress$);
    }
    /**
     * Will provide the composite recording state of this call.
     */ get recording() {
        return this.getCurrentValue(this.recording$);
    }
    /**
     * Will provide the individual recording state of this call.
     */ get individualRecording() {
        return this.getCurrentValue(this.individualRecording$);
    }
    /**
     * Will provide the raw recording state of this call.
     */ get rawRecording() {
        return this.getCurrentValue(this.rawRecording$);
    }
    /**
     * Will provide the session data of this call.
     */ get session() {
        return this.getCurrentValue(this.session$);
    }
    /**
     * Will provide the settings of this call.
     */ get settings() {
        return this.getCurrentValue(this.settings$);
    }
    /**
     * Will provide the transcribing state of this call.
     */ get transcribing() {
        return this.getCurrentValue(this.transcribing$);
    }
    /**
     * Will provide the user who ended this call.
     */ get endedBy() {
        return this.getCurrentValue(this.endedBy$);
    }
    /**
     * Will provide the thumbnails of this call, if enabled in the call settings.
     */ get thumbnails() {
        return this.getCurrentValue(this.thumbnails$);
    }
    /**
     * Returns the current queue of closed captions.
     */ get closedCaptions() {
        return this.getCurrentValue(this.closedCaptions$);
    }
}
/**
 * Flatten the stats report into an array of stats objects.
 *
 * @param report the report to flatten.
 */ const $8c05ed6f2f331ee8$var$flatten = (report)=>{
    const stats = [];
    report.forEach((s)=>{
        stats.push(s);
    });
    return stats;
};
/**
 * Dump the provided MediaStream into a JSON object.
 */ const $8c05ed6f2f331ee8$var$dumpStream = (stream)=>({
        id: stream.id,
        tracks: stream.getTracks().map((track)=>({
                id: track.id,
                kind: track.kind,
                label: track.label,
                enabled: track.enabled,
                muted: track.muted,
                readyState: track.readyState
            }))
    });
const $8c05ed6f2f331ee8$var$getSdkSignature = (clientDetails)=>{
    const { sdk: sdk, ...platform } = clientDetails;
    const sdkName = $8c05ed6f2f331ee8$var$getSdkName(sdk);
    const sdkVersion = $8c05ed6f2f331ee8$var$getSdkVersion(sdk);
    return {
        sdkName: sdkName,
        sdkVersion: sdkVersion,
        ...platform
    };
};
const $8c05ed6f2f331ee8$var$getSdkName = (sdk)=>{
    return sdk && sdk.type === $8c05ed6f2f331ee8$var$SdkType.REACT ? 'stream-react' : sdk && sdk.type === $8c05ed6f2f331ee8$var$SdkType.REACT_NATIVE ? 'stream-react-native' : 'stream-js';
};
const $8c05ed6f2f331ee8$var$getSdkVersion = (sdk)=>{
    return sdk ? `${sdk.major}.${sdk.minor}.${sdk.patch}` : '0.0.0-development';
};
const $8c05ed6f2f331ee8$var$version = "1.54.0";
const [$8c05ed6f2f331ee8$var$major, $8c05ed6f2f331ee8$var$minor, $8c05ed6f2f331ee8$var$patch] = $8c05ed6f2f331ee8$var$version.split('.');
let $8c05ed6f2f331ee8$var$sdkInfo = {
    type: $8c05ed6f2f331ee8$var$SdkType.PLAIN_JAVASCRIPT,
    major: $8c05ed6f2f331ee8$var$major,
    minor: $8c05ed6f2f331ee8$var$minor,
    patch: $8c05ed6f2f331ee8$var$patch
};
let $8c05ed6f2f331ee8$var$osInfo;
let $8c05ed6f2f331ee8$var$deviceInfo;
let $8c05ed6f2f331ee8$var$webRtcInfo;
let $8c05ed6f2f331ee8$var$deviceState = {
    oneofKind: undefined
};
const $8c05ed6f2f331ee8$export$fe878306896c8ea7 = (info)=>{
    $8c05ed6f2f331ee8$var$sdkInfo = info;
};
const $8c05ed6f2f331ee8$export$c290d519cd828ce1 = ()=>{
    return $8c05ed6f2f331ee8$var$sdkInfo;
};
const $8c05ed6f2f331ee8$export$66450b6c59803926 = (info)=>{
    $8c05ed6f2f331ee8$var$osInfo = info;
};
const $8c05ed6f2f331ee8$export$37e5956a9ea49f6b = (info)=>{
    $8c05ed6f2f331ee8$var$deviceInfo = info;
};
const $8c05ed6f2f331ee8$export$4076adf241a03afe = ()=>{
    return $8c05ed6f2f331ee8$var$webRtcInfo;
};
const $8c05ed6f2f331ee8$export$df3dfa35dcd1be7e = (info)=>{
    $8c05ed6f2f331ee8$var$webRtcInfo = info;
};
const $8c05ed6f2f331ee8$export$b7cfa0d2f7123374 = (state)=>{
    if (!$8c05ed6f2f331ee8$var$osInfo) {
        $8c05ed6f2f331ee8$var$deviceState = {
            oneofKind: undefined
        };
        return;
    }
    if ($8c05ed6f2f331ee8$var$osInfo.name === 'android') {
        const thermalState = $8c05ed6f2f331ee8$var$AndroidThermalState[state] || $8c05ed6f2f331ee8$var$AndroidThermalState.UNSPECIFIED;
        $8c05ed6f2f331ee8$var$deviceState = {
            oneofKind: 'android',
            android: {
                thermalState: thermalState,
                isPowerSaverMode: $8c05ed6f2f331ee8$var$deviceState?.oneofKind === 'android' && $8c05ed6f2f331ee8$var$deviceState.android.isPowerSaverMode
            }
        };
    }
    if ($8c05ed6f2f331ee8$var$osInfo.name.toLowerCase() === 'ios') {
        const thermalState = $8c05ed6f2f331ee8$var$AppleThermalState[state] || $8c05ed6f2f331ee8$var$AppleThermalState.UNSPECIFIED;
        $8c05ed6f2f331ee8$var$deviceState = {
            oneofKind: 'apple',
            apple: {
                thermalState: thermalState,
                isLowPowerModeEnabled: $8c05ed6f2f331ee8$var$deviceState?.oneofKind === 'apple' && $8c05ed6f2f331ee8$var$deviceState.apple.isLowPowerModeEnabled
            }
        };
    }
};
const $8c05ed6f2f331ee8$export$663635fcaae37e9e = (powerMode)=>{
    if (!$8c05ed6f2f331ee8$var$osInfo) {
        $8c05ed6f2f331ee8$var$deviceState = {
            oneofKind: undefined
        };
        return;
    }
    if ($8c05ed6f2f331ee8$var$osInfo.name === 'android') $8c05ed6f2f331ee8$var$deviceState = {
        oneofKind: 'android',
        android: {
            thermalState: $8c05ed6f2f331ee8$var$deviceState?.oneofKind === 'android' ? $8c05ed6f2f331ee8$var$deviceState.android.thermalState : $8c05ed6f2f331ee8$var$AndroidThermalState.UNSPECIFIED,
            isPowerSaverMode: powerMode
        }
    };
    if ($8c05ed6f2f331ee8$var$osInfo.name.toLowerCase() === 'ios') $8c05ed6f2f331ee8$var$deviceState = {
        oneofKind: 'apple',
        apple: {
            thermalState: $8c05ed6f2f331ee8$var$deviceState?.oneofKind === 'apple' ? $8c05ed6f2f331ee8$var$deviceState.apple.thermalState : $8c05ed6f2f331ee8$var$AppleThermalState.UNSPECIFIED,
            isLowPowerModeEnabled: powerMode
        }
    };
};
const $8c05ed6f2f331ee8$export$a9e9314ea57e8922 = ()=>{
    return $8c05ed6f2f331ee8$var$deviceState;
};
const $8c05ed6f2f331ee8$export$9d409e1fdb877bc1 = async ()=>{
    if ($8c05ed6f2f331ee8$var$isReactNative()) // Since RN doesn't support web, sharing browser info is not required
    return {
        sdk: $8c05ed6f2f331ee8$var$sdkInfo,
        os: $8c05ed6f2f331ee8$var$osInfo,
        device: $8c05ed6f2f331ee8$var$deviceInfo,
        webrtcVersion: $8c05ed6f2f331ee8$var$webRtcInfo?.version || ''
    };
    // @ts-expect-error - userAgentData is not yet in the TS types
    const userAgentDataApi = navigator.userAgentData;
    let userAgentData;
    if (userAgentDataApi && userAgentDataApi.getHighEntropyValues) try {
        userAgentData = await userAgentDataApi.getHighEntropyValues([
            'platform',
            'platformVersion',
            'fullVersionList'
        ]);
    } catch  {
    // Ignore the error
    }
    const userAgent = new (0, $86Wyx.UAParser)(navigator.userAgent);
    const { browser: browser, os: os, device: device, cpu: cpu } = userAgent.getResult();
    // If userAgentData is available, it means we are in a modern Chromium browser,
    // and we can use it to get more accurate browser information.
    // We hook into the fullVersionList to find the browser name and version and
    // eventually detect exotic browsers like Samsung Internet, AVG Secure Browser, etc.
    // who by default they identify themselves as "Chromium" in the user agent string.
    // Eliminates the generic "Chromium" name and "Not)A_Brand" name from the list.
    // https://wicg.github.io/ua-client-hints/#create-arbitrary-brands-section
    const uaBrowser = userAgentData?.fullVersionList?.find((v)=>!v.brand.includes('Chromium') && !v.brand.match(/[()\-./:;=?_]/g));
    const browserVersion = uaBrowser?.version || browser.version || '';
    return {
        sdk: $8c05ed6f2f331ee8$var$sdkInfo,
        browser: {
            name: uaBrowser?.brand || browser.name || navigator.userAgent,
            version: browserVersion
        },
        os: {
            name: userAgentData?.platform || os.name || '',
            version: userAgentData?.platformVersion || os.version || '',
            architecture: cpu.architecture || ''
        },
        device: {
            name: [
                device.vendor,
                device.model,
                device.type
            ].filter(Boolean).join(' '),
            version: ''
        },
        webrtcVersion: browserVersion
    };
};
/**
 * Checks whether the current browser is Safari.
 */ const $8c05ed6f2f331ee8$var$isSafari = ()=>{
    if (typeof navigator === 'undefined') return false;
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent || '');
};
/**
 * Checks whether the current runtime is a WebKit-engine browser.
 *
 * Returns true for desktop Safari, iOS Safari, bare iOS WKWebView hosts
 * (in-app browsers, React Native WebView, Tauri-on-macOS, etc.), and for
 * Chromium / Gecko-branded iOS browsers (`CriOS`, `EdgiOS`, `OPiOS`,
 * `FxiOS`) since Apple forces every iOS browser onto WKWebView and they
 * share the underlying WebKit quirks.
 *
 * Returns false for desktop Chromium-based browsers (which reuse the
 * `AppleWebKit/` token in their UA) and Android.
 */ const $8c05ed6f2f331ee8$var$isWebKit = ()=>{
    if (typeof navigator === 'undefined') return false;
    const ua = navigator.userAgent || '';
    if (!/AppleWebKit\//.test(ua)) return false;
    // Desktop Chromium reuses the AppleWebKit/ token. The `Chrome/` and
    // `Chromium/` markers are only present on desktop Chromium builds
    // (their iOS counterparts use `CriOS/` instead). `Android` rules out
    // the mobile Blink stack.
    const regExp = /Chrome\/|Chromium\/|Android/;
    return !regExp.test(ua);
};
/**
 * Checks whether the current browser is Firefox.
 */ const $8c05ed6f2f331ee8$var$isFirefox = ()=>{
    if (typeof navigator === 'undefined') return false;
    return navigator.userAgent?.includes('Firefox');
};
/**
 * Checks whether the current browser is Google Chrome.
 */ const $8c05ed6f2f331ee8$var$isChrome = ()=>{
    if (typeof navigator === 'undefined') return false;
    return navigator.userAgent?.includes('Chrome');
};
/**
 * Checks whether the current browser is among the list of first-class supported browsers.
 * This includes Chrome, Edge, Firefox, and Safari.
 *
 * Although the Stream Video SDK may work in other browsers, these are the ones we officially support.
 */ const $8c05ed6f2f331ee8$var$isSupportedBrowser = async ()=>{
    const { browser: browser } = await $8c05ed6f2f331ee8$export$9d409e1fdb877bc1();
    if (!browser) return false; // we aren't running in a browser
    const name = browser.name.toLowerCase();
    const [major] = browser.version.split('.');
    const version = parseInt(major, 10);
    return name.includes('chrome') && version >= 124 || name.includes('edge') && version >= 124 || name.includes('firefox') && version >= 124 || name.includes('safari') && version >= 17 || name.includes('webkit') && version >= 605 || // WebView on iOS
    name.includes('webview') && version >= 124 // WebView on Android
    ;
};
var $8c05ed6f2f331ee8$export$c4be745dbdec8b4 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    isChrome: $8c05ed6f2f331ee8$var$isChrome,
    isFirefox: $8c05ed6f2f331ee8$var$isFirefox,
    isSafari: $8c05ed6f2f331ee8$var$isSafari,
    isSupportedBrowser: $8c05ed6f2f331ee8$var$isSupportedBrowser,
    isWebKit: $8c05ed6f2f331ee8$var$isWebKit
});
/**
 * Creates a new StatsReporter instance that collects metrics about the ongoing call and reports them to the state store
 */ const $8c05ed6f2f331ee8$var$createStatsReporter = ({ subscriber: subscriber, publisher: publisher, state: state, datacenter: datacenter, pollingIntervalInMs: pollingIntervalInMs = 2000 })=>{
    const logger = $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger('stats');
    const getRawStatsForTrack = async (kind, selector)=>{
        if (kind === 'subscriber' && subscriber) return subscriber.getStats(selector);
        else if (kind === 'publisher' && publisher) return publisher.getStats(selector);
        else return undefined;
    };
    const getStatsForStream = async (kind, tracks)=>{
        const pc = kind === 'subscriber' ? subscriber : publisher;
        if (!pc) return [];
        const statsForStream = [];
        for (const track of tracks){
            const report = await pc.getStats(track);
            const stats = $8c05ed6f2f331ee8$var$transform(report, {
                trackKind: track.kind,
                kind: kind,
                publisher: undefined
            });
            statsForStream.push(stats);
        }
        return statsForStream;
    };
    const startReportingStatsFor = (sessionId)=>{
        sessionIdsToTrack.add(sessionId);
        run();
    };
    const stopReportingStatsFor = (sessionId)=>{
        sessionIdsToTrack.delete(sessionId);
        run();
    };
    const sessionIdsToTrack = new Set();
    /**
     * The main stats reporting loop.
     */ const run = async ()=>{
        const participantStats = {};
        if (sessionIdsToTrack.size > 0) {
            const sessionIds = new Set(sessionIdsToTrack);
            for (const participant of state.participants){
                if (!sessionIds.has(participant.sessionId)) continue;
                const { audioStream: audioStream, isLocalParticipant: isLocalParticipant, sessionId: sessionId, userId: userId, videoStream: videoStream } = participant;
                const kind = isLocalParticipant ? 'publisher' : 'subscriber';
                try {
                    const tracks = isLocalParticipant ? publisher?.getPublishedTracks() || [] : [
                        ...videoStream?.getVideoTracks() || [],
                        ...audioStream?.getAudioTracks() || []
                    ];
                    participantStats[sessionId] = await getStatsForStream(kind, tracks);
                } catch (e) {
                    logger.warn(`Failed to collect ${kind} stats for ${userId}`, e);
                }
            }
        }
        const [subscriberRawStats, publisherRawStats] = await Promise.all([
            getRawStatsForTrack('subscriber'),
            publisher ? getRawStatsForTrack('publisher') : undefined
        ]);
        const process = (report, kind)=>{
            const videoStats = $8c05ed6f2f331ee8$var$aggregate($8c05ed6f2f331ee8$var$transform(report, {
                kind: kind,
                trackKind: 'video',
                publisher: publisher
            }));
            const audioStats = $8c05ed6f2f331ee8$var$aggregateAudio($8c05ed6f2f331ee8$var$transform(report, {
                kind: kind,
                trackKind: 'audio',
                publisher: publisher
            }));
            return {
                videoStats: videoStats,
                audioStats: audioStats
            };
        };
        const subscriberResult = subscriberRawStats ? process(subscriberRawStats, 'subscriber') : {
            videoStats: $8c05ed6f2f331ee8$var$getEmptyVideoStats(),
            audioStats: $8c05ed6f2f331ee8$var$getEmptyAudioStats()
        };
        const publisherResult = publisherRawStats ? process(publisherRawStats, 'publisher') : {
            videoStats: $8c05ed6f2f331ee8$var$getEmptyVideoStats(),
            audioStats: $8c05ed6f2f331ee8$var$getEmptyAudioStats()
        };
        state.setCallStatsReport({
            datacenter: datacenter,
            publisherStats: publisherResult.videoStats,
            publisherAudioStats: publisherResult.audioStats,
            subscriberStats: subscriberResult.videoStats,
            subscriberAudioStats: subscriberResult.audioStats,
            subscriberRawStats: subscriberRawStats,
            publisherRawStats: publisherRawStats,
            participants: participantStats,
            timestamp: Date.now()
        });
    };
    let timeoutId;
    if (pollingIntervalInMs > 0) {
        const loop = async ()=>{
            // bail out of the loop as we don't want to collect stats
            // (they are expensive) if no one is listening to them
            if (state.isCallStatsReportObserved) await run().catch((e)=>{
                logger.debug('Failed to collect stats', e);
            });
            timeoutId = setTimeout(loop, pollingIntervalInMs);
        };
        loop();
    }
    const stop = ()=>{
        if (timeoutId) clearTimeout(timeoutId);
    };
    return {
        getRawStatsForTrack: getRawStatsForTrack,
        getStatsForStream: getStatsForStream,
        startReportingStatsFor: startReportingStatsFor,
        stopReportingStatsFor: stopReportingStatsFor,
        stop: stop
    };
};
/**
 * Extracts camera statistics from a media source.
 *
 * @param mediaSource the media source stats to extract camera info from.
 */ const $8c05ed6f2f331ee8$var$getCameraStats = (mediaSource)=>({
        frameRate: mediaSource.framesPerSecond,
        frameWidth: mediaSource.width,
        frameHeight: mediaSource.height
    });
/**
 * Transforms raw RTC stats into a slimmer and uniform across browsers format.
 *
 * @param report the report to transform.
 * @param opts the transform options.
 */ const $8c05ed6f2f331ee8$var$transform = (report, opts)=>{
    const { trackKind: trackKind, kind: kind, publisher: publisher } = opts;
    const direction = kind === 'subscriber' ? 'inbound-rtp' : 'outbound-rtp';
    const stats = $8c05ed6f2f331ee8$var$flatten(report);
    const streams = stats.filter((stat)=>stat.type === direction && stat.kind === trackKind).map((stat)=>{
        const rtcStreamStats = stat;
        const codec = stats.find((s)=>s.type === 'codec' && s.id === rtcStreamStats.codecId);
        const transport = stats.find((s)=>s.type === 'transport' && s.id === rtcStreamStats.transportId);
        let roundTripTime;
        if (transport && transport.dtlsState === 'connected') {
            const candidatePair = stats.find((s)=>s.type === 'candidate-pair' && s.id === transport.selectedCandidatePairId);
            roundTripTime = candidatePair?.currentRoundTripTime;
        }
        let trackType;
        let audioLevel;
        let camera;
        let concealedSamples;
        let concealmentEvents;
        let packetsReceived;
        let packetsLost;
        if (kind === 'publisher' && publisher) {
            const firefox = $8c05ed6f2f331ee8$var$isFirefox();
            const mediaSource = stats.find((s)=>s.type === 'media-source' && // Firefox doesn't have mediaSourceId, so we need to guess the media source
                (firefox ? true : s.id === rtcStreamStats.mediaSourceId));
            if (mediaSource) {
                trackType = publisher.getTrackType(mediaSource.trackIdentifier);
                if (trackKind === 'audio' && typeof mediaSource.audioLevel === 'number') audioLevel = mediaSource.audioLevel;
                if (trackKind === 'video') camera = $8c05ed6f2f331ee8$var$getCameraStats(mediaSource);
            }
        } else if (kind === 'subscriber' && trackKind === 'audio') {
            const inboundStats = rtcStreamStats;
            const inboundLevel = inboundStats.audioLevel;
            if (typeof inboundLevel === 'number') audioLevel = inboundLevel;
            concealedSamples = inboundStats.concealedSamples;
            concealmentEvents = inboundStats.concealmentEvents;
            packetsReceived = inboundStats.packetsReceived;
            packetsLost = inboundStats.packetsLost;
        }
        return {
            bytesSent: rtcStreamStats.bytesSent,
            bytesReceived: rtcStreamStats.bytesReceived,
            codec: codec?.mimeType,
            currentRoundTripTime: roundTripTime,
            frameHeight: rtcStreamStats.frameHeight,
            frameWidth: rtcStreamStats.frameWidth,
            framesPerSecond: rtcStreamStats.framesPerSecond,
            jitter: rtcStreamStats.jitter,
            kind: rtcStreamStats.kind,
            mediaSourceId: rtcStreamStats.mediaSourceId,
            qualityLimitationReason: rtcStreamStats.qualityLimitationReason,
            rid: rtcStreamStats.rid,
            ssrc: rtcStreamStats.ssrc,
            trackType: trackType,
            audioLevel: audioLevel,
            concealedSamples: concealedSamples,
            concealmentEvents: concealmentEvents,
            packetsReceived: packetsReceived,
            packetsLost: packetsLost,
            camera: camera
        };
    });
    return {
        rawStats: report,
        streams: streams,
        timestamp: Date.now()
    };
};
const $8c05ed6f2f331ee8$var$getEmptyVideoStats = (stats)=>{
    return {
        rawReport: stats ?? {
            streams: [],
            timestamp: Date.now()
        },
        totalBytesSent: 0,
        totalBytesReceived: 0,
        averageJitterInMs: 0,
        averageRoundTripTimeInMs: 0,
        qualityLimitationReasons: 'none',
        highestFrameWidth: 0,
        highestFrameHeight: 0,
        highestFramesPerSecond: 0,
        camera: {},
        codec: '',
        codecPerTrackType: {},
        timestamp: Date.now()
    };
};
const $8c05ed6f2f331ee8$var$getEmptyAudioStats = ()=>{
    return {
        totalBytesSent: 0,
        totalBytesReceived: 0,
        averageJitterInMs: 0,
        averageRoundTripTimeInMs: 0,
        codec: '',
        codecPerTrackType: {},
        timestamp: Date.now(),
        totalConcealedSamples: 0,
        totalConcealmentEvents: 0,
        totalPacketsReceived: 0,
        totalPacketsLost: 0
    };
};
/**
 * Aggregates generic stats.
 *
 * @param stats the stats to aggregate.
 */ const $8c05ed6f2f331ee8$var$aggregate = (stats)=>{
    const aggregatedStats = $8c05ed6f2f331ee8$var$getEmptyVideoStats(stats);
    let maxArea = -1;
    const area = (w, h)=>w * h;
    const qualityLimitationReasons = new Set();
    const streams = stats.streams;
    const report = streams.reduce((acc, stream)=>{
        acc.totalBytesSent += stream.bytesSent || 0;
        acc.totalBytesReceived += stream.bytesReceived || 0;
        acc.averageJitterInMs += stream.jitter || 0;
        acc.averageRoundTripTimeInMs += stream.currentRoundTripTime || 0;
        // naive calculation of the highest resolution
        const streamArea = area(stream.frameWidth || 0, stream.frameHeight || 0);
        if (streamArea > maxArea) {
            acc.highestFrameWidth = stream.frameWidth || 0;
            acc.highestFrameHeight = stream.frameHeight || 0;
            acc.highestFramesPerSecond = stream.framesPerSecond || 0;
            maxArea = streamArea;
        }
        if (stream.trackType === $8c05ed6f2f331ee8$var$TrackType.VIDEO) acc.camera = stream.camera;
        qualityLimitationReasons.add(stream.qualityLimitationReason || '');
        return acc;
    }, aggregatedStats);
    if (streams.length > 0) {
        report.averageJitterInMs = Math.round(report.averageJitterInMs / streams.length * 1000);
        report.averageRoundTripTimeInMs = Math.round(report.averageRoundTripTimeInMs / streams.length * 1000);
        // we take the first codec we find, as it should be the same for all streams
        report.codec = streams[0].codec || '';
        report.codecPerTrackType = streams.reduce((acc, stream)=>{
            if (stream.trackType) acc[stream.trackType] = stream.codec || '';
            return acc;
        }, {});
    }
    const qualityLimitationReason = [
        qualityLimitationReasons.has('cpu') && 'cpu',
        qualityLimitationReasons.has('bandwidth') && 'bandwidth',
        qualityLimitationReasons.has('other') && 'other'
    ].filter(Boolean).join(', ');
    if (qualityLimitationReason) report.qualityLimitationReasons = qualityLimitationReason;
    return report;
};
/**
 * Aggregates audio stats from a stats report.
 *
 * @param stats the stats report containing audio streams.
 * @returns aggregated audio stats.
 */ const $8c05ed6f2f331ee8$var$aggregateAudio = (stats)=>{
    const streams = stats.streams;
    const audioStats = $8c05ed6f2f331ee8$var$getEmptyAudioStats();
    const report = streams.reduce((acc, stream)=>{
        acc.totalBytesSent += stream.bytesSent || 0;
        acc.totalBytesReceived += stream.bytesReceived || 0;
        acc.averageJitterInMs += stream.jitter || 0;
        acc.averageRoundTripTimeInMs += stream.currentRoundTripTime || 0;
        acc.totalConcealedSamples += stream.concealedSamples || 0;
        acc.totalConcealmentEvents += stream.concealmentEvents || 0;
        acc.totalPacketsReceived += stream.packetsReceived || 0;
        acc.totalPacketsLost += stream.packetsLost || 0;
        return acc;
    }, audioStats);
    if (streams.length > 0) {
        report.averageJitterInMs = Math.round(report.averageJitterInMs / streams.length * 1000);
        report.averageRoundTripTimeInMs = Math.round(report.averageRoundTripTimeInMs / streams.length * 1000);
        report.codec = streams[0].codec || '';
        report.codecPerTrackType = streams.reduce((acc, stream)=>{
            if (stream.trackType) acc[stream.trackType] = stream.codec || '';
            return acc;
        }, {});
    }
    return report;
};
class $8c05ed6f2f331ee8$var$SfuStatsReporter {
    constructor(sfuClient, { options: options, clientDetails: clientDetails, subscriber: subscriber, publisher: publisher, microphone: microphone, camera: camera, state: state, tracer: tracer, unifiedSessionId: unifiedSessionId }){
        this.logger = $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger('SfuStatsReporter');
        this.reportCount = 0;
        this.inputDevices = new Map();
        this.observeDevice = (device, kind)=>{
            const { browserPermissionState$: browserPermissionState$ } = device.state;
            this.unsubscribeDevicePermissionsSubscription?.();
            this.unsubscribeDevicePermissionsSubscription = $8c05ed6f2f331ee8$var$createSubscription((0, $0e8b72f41887b114$export$77fa7d86f5204e8a)([
                browserPermissionState$,
                this.state.ownCapabilities$
            ]), ([browserPermissionState, ownCapabilities])=>{
                // cleanup the previous listDevices() subscription in case
                // permissions or capabilities have changed.
                // we will subscribe again if everything is in order.
                this.unsubscribeListDevicesSubscription?.();
                const hasCapability = kind === 'mic' ? ownCapabilities.includes($8c05ed6f2f331ee8$export$9d72b1bd9eedd7a7.SEND_AUDIO) : ownCapabilities.includes($8c05ed6f2f331ee8$export$9d72b1bd9eedd7a7.SEND_VIDEO);
                if (browserPermissionState !== 'granted' || !hasCapability) {
                    this.inputDevices.set(kind, {
                        currentDevice: '',
                        availableDevices: [],
                        isPermitted: false
                    });
                    return;
                }
                this.unsubscribeListDevicesSubscription = $8c05ed6f2f331ee8$var$createSubscription((0, $0e8b72f41887b114$export$77fa7d86f5204e8a)([
                    device.listDevices(),
                    device.state.selectedDevice$
                ]), ([devices, deviceId])=>{
                    const selected = devices.find((d)=>d.deviceId === deviceId);
                    this.inputDevices.set(kind, {
                        currentDevice: selected?.label || deviceId || '',
                        availableDevices: devices.map((d)=>d.label),
                        isPermitted: true
                    });
                });
            });
        };
        this.sendConnectionTime = (connectionTimeSeconds)=>{
            this.sendTelemetryData({
                data: {
                    oneofKind: 'connectionTimeSeconds',
                    connectionTimeSeconds: connectionTimeSeconds
                }
            });
        };
        this.sendReconnectionTime = (strategy, timeSeconds)=>{
            this.sendTelemetryData({
                data: {
                    oneofKind: 'reconnection',
                    reconnection: {
                        strategy: strategy,
                        timeSeconds: timeSeconds
                    }
                }
            });
        };
        this.sendTelemetryData = (telemetryData)=>{
            // intentionally not awaiting the promise here
            // to avoid impeding with the ongoing actions.
            this.run(telemetryData).catch((err)=>{
                this.logger.warn('Failed to send telemetry data', err);
            });
        };
        this.run = async (telemetry)=>{
            const [subscriberStats, publisherStats] = await Promise.all([
                this.subscriber.stats.get(),
                this.publisher?.stats.get()
            ]);
            this.subscriber.tracer?.trace('getstats', subscriberStats.delta);
            if (publisherStats) this.publisher?.tracer?.trace('getstats', publisherStats.delta);
            const subscriberTrace = this.subscriber.tracer?.take();
            const publisherTrace = this.publisher?.tracer?.take();
            const tracer = this.tracer.take();
            const sfuTrace = this.sfuClient.getTrace();
            const traces = [
                ...tracer.snapshot,
                ...sfuTrace?.snapshot ?? [],
                ...publisherTrace?.snapshot ?? [],
                ...subscriberTrace?.snapshot ?? []
            ];
            try {
                await this.sfuClient.sendStats({
                    sdk: this.sdkName,
                    sdkVersion: this.sdkVersion,
                    webrtcVersion: this.webRTCVersion,
                    subscriberStats: JSON.stringify($8c05ed6f2f331ee8$var$flatten(subscriberStats.stats)),
                    publisherStats: publisherStats ? JSON.stringify($8c05ed6f2f331ee8$var$flatten(publisherStats.stats)) : '[]',
                    subscriberRtcStats: '',
                    publisherRtcStats: '',
                    rtcStats: JSON.stringify(traces),
                    encodeStats: publisherStats?.performanceStats ?? [],
                    decodeStats: subscriberStats.performanceStats,
                    audioDevices: this.inputDevices.get('mic'),
                    videoDevices: this.inputDevices.get('camera'),
                    unifiedSessionId: this.unifiedSessionId,
                    deviceState: $8c05ed6f2f331ee8$export$a9e9314ea57e8922(),
                    telemetry: telemetry
                });
            } catch (err) {
                publisherTrace?.rollback();
                subscriberTrace?.rollback();
                tracer.rollback();
                sfuTrace?.rollback();
                throw err;
            }
        };
        this.scheduleNextReport = ()=>{
            const intervals = [
                1500,
                3000,
                3000,
                5000
            ];
            if (this.reportCount < intervals.length) this.timeoutId = setTimeout(()=>{
                this.flush();
                this.reportCount++;
                this.scheduleNextReport();
            }, intervals[this.reportCount]);
            else {
                clearInterval(this.intervalId);
                this.intervalId = setInterval(()=>{
                    this.flush();
                }, this.options.reporting_interval_ms);
            }
        };
        this.start = ()=>{
            if (this.options.reporting_interval_ms <= 0) return;
            this.observeDevice(this.microphone, 'mic');
            this.observeDevice(this.camera, 'camera');
            this.reportCount = 0;
            clearInterval(this.intervalId);
            clearTimeout(this.timeoutId);
            this.scheduleNextReport();
        };
        this.stop = ()=>{
            this.unsubscribeDevicePermissionsSubscription?.();
            this.unsubscribeDevicePermissionsSubscription = undefined;
            this.unsubscribeListDevicesSubscription?.();
            this.unsubscribeListDevicesSubscription = undefined;
            this.inputDevices.clear();
            clearInterval(this.intervalId);
            this.intervalId = undefined;
            clearTimeout(this.timeoutId);
            this.timeoutId = undefined;
            this.reportCount = 0;
        };
        this.flush = ()=>{
            this.run().catch((err)=>{
                this.logger.warn('Failed to flush report stats', err);
            });
        };
        this.sfuClient = sfuClient;
        this.options = options;
        this.subscriber = subscriber;
        this.publisher = publisher;
        this.microphone = microphone;
        this.camera = camera;
        this.state = state;
        this.tracer = tracer;
        this.unifiedSessionId = unifiedSessionId;
        const { sdk: sdk, browser: browser } = clientDetails;
        this.sdkName = $8c05ed6f2f331ee8$var$getSdkName(sdk);
        this.sdkVersion = $8c05ed6f2f331ee8$var$getSdkVersion(sdk);
        // use the WebRTC version if set by the SDK (React Native) otherwise,
        // use the browser version as a fallback
        const webRTCInfo = $8c05ed6f2f331ee8$export$4076adf241a03afe();
        this.webRTCVersion = webRTCInfo?.version || `${browser?.name || ''}-${browser?.version || ''}` || 'N/A';
    }
}
const $8c05ed6f2f331ee8$var$traceRTCPeerConnection = (pc, trace)=>{
    pc.addEventListener('icecandidate', (e)=>{
        trace('onicecandidate', e.candidate);
    });
    pc.addEventListener('track', (e)=>{
        const streams = e.streams.map((stream)=>`stream:${stream.id}`);
        trace('ontrack', `${e.track.kind}:${e.track.id} ${streams}`);
    });
    pc.addEventListener('signalingstatechange', ()=>{
        trace('signalingstatechange', pc.signalingState);
    });
    pc.addEventListener('iceconnectionstatechange', ()=>{
        trace('iceconnectionstatechange', pc.iceConnectionState);
    });
    pc.addEventListener('icegatheringstatechange', ()=>{
        trace('icegatheringstatechange', pc.iceGatheringState);
    });
    pc.addEventListener('connectionstatechange', ()=>{
        trace('connectionstatechange', pc.connectionState);
    });
    pc.addEventListener('negotiationneeded', ()=>{
        trace('negotiationneeded', undefined);
    });
    pc.addEventListener('datachannel', ({ channel: channel })=>{
        trace('datachannel', [
            channel.id,
            channel.label
        ]);
    });
    const origClose = pc.close;
    pc.close = function tracedClose() {
        trace('close', undefined);
        return origClose.call(this);
    };
    for (const method of [
        'createOffer',
        'createAnswer',
        'setLocalDescription',
        'setRemoteDescription',
        'addIceCandidate'
    ]){
        const original = pc[method];
        if (!original) continue;
        // @ts-expect-error we don't use deprecated APIs
        pc[method] = async function tracedMethod(...args) {
            try {
                trace(method, args);
                // @ts-expect-error improper types
                const result = await original.apply(this, args);
                trace(`${method}OnSuccess`, result);
                return result;
            } catch (err) {
                trace(`${method}OnFailure`, err.toString());
                throw err;
            }
        };
    }
};
/**
 * StatsTracer is a class that collects and processes WebRTC stats.
 * It is used to track the performance of the WebRTC connection
 * and to provide information about the media streams.
 * It is used by both the Publisher and Subscriber classes.
 *
 * @internal
 */ class $8c05ed6f2f331ee8$var$StatsTracer {
    /**
     * Creates a new StatsTracer instance.
     */ constructor(pc, peerType, trackIdToTrackType, statsTimestampDriftThresholdMs = 0){
        this.previousStats = {};
        this.frameTimeHistory = [];
        this.fpsHistory = [];
        /**
         * Get the stats from the RTCPeerConnection.
         * When called, it will return the stats for the current connection.
         * It will also return the delta between the current stats and the previous stats.
         * This is used to track the performance of the connection.
         *
         * @internal
         */ this.get = async ()=>{
            const stats = await this.pc.getStats();
            const currentStats = $8c05ed6f2f331ee8$var$toObjectWithCorrectedTimestamp(stats, Date.now(), this.driftThresholdMs);
            const performanceStats = this.withOverrides(this.peerType === $8c05ed6f2f331ee8$var$PeerType.SUBSCRIBER ? this.getDecodeStats(currentStats) : this.getEncodeStats(currentStats));
            const delta = $8c05ed6f2f331ee8$var$deltaCompression(this.previousStats, currentStats);
            // store the current data for the next iteration
            this.previousStats = currentStats;
            this.frameTimeHistory = this.frameTimeHistory.slice(-2);
            this.fpsHistory = this.fpsHistory.slice(-2);
            return {
                performanceStats: performanceStats,
                delta: delta,
                stats: stats
            };
        };
        /**
         * Collects encode stats from the RTCPeerConnection.
         */ this.getEncodeStats = (currentStats)=>{
            const encodeStats = [];
            for (const rtp of Object.values(currentStats)){
                if (rtp.type !== 'outbound-rtp') continue;
                const { codecId: codecId, framesSent: framesSent = 0, kind: kind, id: id, totalEncodeTime: totalEncodeTime = 0, framesPerSecond: framesPerSecond = 0, frameHeight: frameHeight = 0, frameWidth: frameWidth = 0, targetBitrate: targetBitrate = 0, mediaSourceId: mediaSourceId } = rtp;
                if (kind === 'audio' || !this.previousStats[id]) continue;
                const prevRtp = this.previousStats[id];
                const deltaTotalEncodeTime = totalEncodeTime - (prevRtp.totalEncodeTime || 0);
                const deltaFramesSent = framesSent - (prevRtp.framesSent || 0);
                const framesEncodeTime = deltaFramesSent > 0 ? deltaTotalEncodeTime / deltaFramesSent * 1000 : 0;
                this.frameTimeHistory.push(framesEncodeTime);
                this.fpsHistory.push(framesPerSecond);
                let trackType = $8c05ed6f2f331ee8$var$TrackType.VIDEO;
                if (mediaSourceId && currentStats[mediaSourceId]) {
                    const mediaSource = currentStats[mediaSourceId];
                    trackType = this.trackIdToTrackType.get(mediaSource.trackIdentifier) || trackType;
                }
                encodeStats.push({
                    trackType: trackType,
                    codec: $8c05ed6f2f331ee8$var$getCodecFromStats(currentStats, codecId),
                    avgFrameTimeMs: $8c05ed6f2f331ee8$var$average(this.frameTimeHistory),
                    avgFps: $8c05ed6f2f331ee8$var$average(this.fpsHistory),
                    targetBitrate: Math.round(targetBitrate),
                    videoDimension: {
                        width: frameWidth,
                        height: frameHeight
                    }
                });
            }
            return encodeStats;
        };
        /**
         * Collects decode stats from the RTCPeerConnection.
         */ this.getDecodeStats = (currentStats)=>{
            let rtp = undefined;
            let max = 0;
            for (const item of Object.values(currentStats)){
                if (item.type !== 'inbound-rtp') continue;
                const rtpItem = item;
                const { kind: kind, frameWidth: frameWidth = 0, frameHeight: frameHeight = 0 } = rtpItem;
                const area = frameWidth * frameHeight;
                if (kind === 'video' && area > max) {
                    rtp = rtpItem;
                    max = area;
                }
            }
            if (!rtp || !this.previousStats[rtp.id]) return [];
            const prevRtp = this.previousStats[rtp.id];
            const { framesDecoded: framesDecoded = 0, framesPerSecond: framesPerSecond = 0, totalDecodeTime: totalDecodeTime = 0, trackIdentifier: trackIdentifier } = rtp;
            const deltaTotalDecodeTime = totalDecodeTime - (prevRtp.totalDecodeTime || 0);
            const deltaFramesDecoded = framesDecoded - (prevRtp.framesDecoded || 0);
            const framesDecodeTime = deltaFramesDecoded > 0 ? deltaTotalDecodeTime / deltaFramesDecoded * 1000 : 0;
            this.frameTimeHistory.push(framesDecodeTime);
            this.fpsHistory.push(framesPerSecond);
            const trackType = this.trackIdToTrackType.get(trackIdentifier) || $8c05ed6f2f331ee8$var$TrackType.VIDEO;
            return [
                $8c05ed6f2f331ee8$var$PerformanceStats.create({
                    trackType: trackType,
                    codec: $8c05ed6f2f331ee8$var$getCodecFromStats(currentStats, rtp.codecId),
                    avgFrameTimeMs: $8c05ed6f2f331ee8$var$average(this.frameTimeHistory),
                    avgFps: $8c05ed6f2f331ee8$var$average(this.fpsHistory),
                    videoDimension: {
                        width: rtp.frameWidth,
                        height: rtp.frameHeight
                    }
                })
            ];
        };
        /**
         * Applies cost overrides to the performance stats.
         * This is used to override the default encode/decode times with custom values.
         * This is useful for testing and debugging purposes, and it shouldn't be used in production.
         */ this.withOverrides = (performanceStats)=>{
            if (this.costOverrides) for (const s of performanceStats){
                const override = this.costOverrides.get(s.trackType);
                if (override !== undefined) // override the average encode/decode time with the provided cost.
                // format: [override].[original-frame-time]
                s.avgFrameTimeMs = override + (s.avgFrameTimeMs || 0) / 1000;
            }
            return performanceStats;
        };
        /**
         * Set the encode/decode cost for a specific track type.
         * This is used to override the default encode/decode times with custom values.
         * This is useful for testing and debugging purposes, and it shouldn't be used in production.
         *
         * @internal
         */ this.setCost = (cost, trackType = $8c05ed6f2f331ee8$var$TrackType.VIDEO)=>{
            if (!this.costOverrides) this.costOverrides = new Map();
            this.costOverrides.set(trackType, cost);
        };
        this.pc = pc;
        this.peerType = peerType;
        this.trackIdToTrackType = trackIdToTrackType;
        this.driftThresholdMs = statsTimestampDriftThresholdMs;
    }
}
/**
 * Convert the stat report to an object, correcting clock drift along the way.
 * Entries whose `timestamp` differs from `wallNow` by more than `thresholdMs`
 * are replaced with a clone whose `timestamp` is set to `wallNow`. The platform
 * clock backing `DOMHighResTimeStamp` can desynchronise from `Date.now()` after
 * system sleep or clock-jump events (notably on Electron/Chromium), which
 * corrupts the delta-compressed stats payload. A non-positive `thresholdMs`
 * disables correction.
 *
 * @param report the stat report to convert.
 * @param wallNow current wall-clock time used as the drift reference.
 * @param thresholdMs maximum tolerated drift in milliseconds.
 */ const $8c05ed6f2f331ee8$var$toObjectWithCorrectedTimestamp = (report, wallNow, thresholdMs)=>{
    const obj = {};
    const correct = thresholdMs > 0;
    report.forEach((v, k)=>{
        const drift = Math.abs(v.timestamp - wallNow);
        obj[k] = correct && drift > thresholdMs ? {
            ...v,
            timestamp: wallNow
        } : v;
    });
    return obj;
};
/**
 * Apply delta compression to the stats report.
 * Reduces size by ~90%.
 * To reduce further, report keys could be compressed.
 */ const $8c05ed6f2f331ee8$var$deltaCompression = (oldStats, newStats)=>{
    newStats = JSON.parse(JSON.stringify(newStats));
    for (const [id, report] of Object.entries(newStats)){
        delete report.id;
        if (!oldStats[id]) continue;
        for (const [name, value] of Object.entries(report))if (value === oldStats[id][name]) delete report[name];
    }
    let timestamp = -Infinity;
    const values = Object.values(newStats);
    for (const report of values)if (report.timestamp > timestamp) timestamp = report.timestamp;
    for (const report of values)if (report.timestamp === timestamp) report.timestamp = 0;
    newStats.timestamp = timestamp;
    return newStats;
};
/**
 * Calculates an average value.
 */ const $8c05ed6f2f331ee8$var$average = (arr)=>arr.reduce((a, b)=>a + b, 0) / arr.length;
/**
 * Create a Codec object from the codec stats.
 *
 * @param stats the stats report.
 * @param codecId the codec ID to look for.
 */ const $8c05ed6f2f331ee8$var$getCodecFromStats = (stats, codecId)=>{
    if (!codecId || !stats[codecId]) return;
    const codecStats = stats[codecId];
    return $8c05ed6f2f331ee8$var$Codec.create({
        name: codecStats.mimeType.split('/').pop(),
        clockRate: codecStats.clockRate,
        payloadType: codecStats.payloadType,
        fmtp: codecStats.sdpFmtpLine
    });
};
class $8c05ed6f2f331ee8$var$Tracer {
    constructor(id){
        this.buffer = [];
        this.enabled = true;
        this.setEnabled = (enabled)=>{
            if (this.enabled === enabled) return;
            this.enabled = enabled;
            this.buffer = [];
        };
        this.trace = (tag, data)=>{
            if (!this.enabled) return;
            this.buffer.push([
                tag,
                this.id,
                data,
                Date.now()
            ]);
        };
        this.traceOnce = (key, tag, data)=>{
            if (this.keys?.has(key)) return;
            this.trace(tag, data);
            (this.keys ?? (this.keys = new Map())).set(key, true);
        };
        this.resetTrace = (key)=>{
            this.keys?.delete(key);
        };
        this.take = ()=>{
            const snapshot = this.buffer;
            this.buffer = [];
            return {
                snapshot: snapshot,
                rollback: ()=>{
                    this.buffer.unshift(...snapshot);
                }
            };
        };
        this.dispose = ()=>{
            this.buffer = [];
            this.keys?.clear();
        };
        this.id = id;
    }
}
/**
 * Canonical reasons the SDK uses to trigger a reconnection. Free-form strings
 * are still accepted at the callback boundary (e.g. when forwarding an SFU
 * error message), but only the members below influence reconnect-loop
 * behavior. In particular, `Call.reconnect` programmatically inspects
 * `ICE_NEVER_CONNECTED` to drive the unsupported-network detector — pass a
 * canonical member when you want the SDK to react to the reason; pass a
 * free-form string when the value is purely diagnostic.
 */ const $8c05ed6f2f331ee8$var$ReconnectReason = {
    /** ICE never reached `connected`/`completed`, escalate to REJOIN. */ ICE_NEVER_CONNECTED: 'ice_never_connected',
    /** RTCPeerConnection.connectionState became `failed`. */ CONNECTION_FAILED: 'connection_failed',
    /** `restartIce()` rejected. */ RESTART_ICE_FAILED: 'restart_ice_failed',
    /** SFU `goAway` event, migrate to a new SFU. */ GO_AWAY: 'go_away',
    /** Network came back online after going offline. */ NETWORK_BACK_ONLINE: 'network_back_online',
    /** SFU error event with no descriptive message. */ SFU_ERROR: 'sfu_error'
};
/**
 * A base class for the `Publisher` and `Subscriber` classes.
 * @internal
 */ class $8c05ed6f2f331ee8$var$BasePeerConnection {
    /**
     * Constructs a new `BasePeerConnection` instance.
     */ constructor(peerType, { sfuClient: sfuClient, connectionConfig: connectionConfig, state: state, dispatcher: dispatcher, onReconnectionNeeded: onReconnectionNeeded, onIceConnected: onIceConnected, onPeerConnectionStateChange: onPeerConnectionStateChange, onRemoteTrackUnmute: onRemoteTrackUnmute, tag: tag, enableTracing: enableTracing, clientPublishOptions: clientPublishOptions, iceRestartDelay: iceRestartDelay = 2500, statsTimestampDriftThresholdMs: statsTimestampDriftThresholdMs = 0 }){
        this.iceHasEverConnected = false;
        this.isIceRestarting = false;
        this.isDisposed = false;
        this.trackIdToTrackType = new Map();
        this.subscriptions = [];
        this.lock = Math.random().toString(36).slice(2);
        this.createPeerConnection = (connectionConfig)=>{
            const pc = new RTCPeerConnection(connectionConfig);
            pc.addEventListener('icecandidate', this.onIceCandidate);
            pc.addEventListener('icecandidateerror', this.onIceCandidateError);
            pc.addEventListener('iceconnectionstatechange', this.onIceConnectionStateChange);
            pc.addEventListener('icegatheringstatechange', this.onIceGatherChange);
            pc.addEventListener('signalingstatechange', this.onSignalingChange);
            pc.addEventListener('connectionstatechange', this.onConnectionStateChange);
            return pc;
        };
        /**
         * Attempts to restart ICE on the `RTCPeerConnection`.
         * This method intentionally doesn't await the `restartIce()` method,
         * allowing it to run in the background and handle any errors that may occur.
         */ this.tryRestartIce = ()=>{
            this.restartIce().catch((e)=>{
                this.logger.error('restartICE() failed, initiating reconnect', e);
                const strategy = e instanceof $8c05ed6f2f331ee8$var$NegotiationError && e.error.code === $8c05ed6f2f331ee8$var$ErrorCode.PARTICIPANT_SIGNAL_LOST ? $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.FAST : $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.REJOIN;
                this.onReconnectionNeeded?.(strategy, $8c05ed6f2f331ee8$var$ReconnectReason.RESTART_ICE_FAILED, this.peerType);
            });
        };
        /**
         * Handles events synchronously.
         * Consecutive events are queued and executed one after the other.
         */ this.on = (event, fn)=>{
            const getTag = ()=>this.tag;
            this.subscriptions.push(this.dispatcher.on(event, getTag, (e)=>{
                const lockKey = this.eventLockKey(event);
                $8c05ed6f2f331ee8$var$withoutConcurrency(lockKey, async ()=>fn(e)).catch((err)=>{
                    if (this.isDisposed) return;
                    this.logger.warn(`Error handling ${event}`, err);
                });
            }));
        };
        /**
         * Returns the per-event `withoutConcurrency` tag used to serialize the
         * dispatcher handler for `event` on this peer connection.
         */ this.eventLockKey = (event)=>{
            return `pc.${this.lock}.${event}`;
        };
        /**
         * Appends the trickled ICE candidates to the `RTCPeerConnection`.
         */ this.addTrickledIceCandidates = ()=>{
            const { iceTrickleBuffer: iceTrickleBuffer } = this.sfuClient;
            const observable = this.peerType === $8c05ed6f2f331ee8$var$PeerType.SUBSCRIBER ? iceTrickleBuffer.subscriberCandidates : iceTrickleBuffer.publisherCandidates;
            this.unsubscribeIceTrickle?.();
            this.unsubscribeIceTrickle = $8c05ed6f2f331ee8$var$createSafeAsyncSubscription(observable, async (candidate)=>{
                return this.pc.addIceCandidate(candidate).catch((e)=>{
                    if (this.isDisposed) return;
                    this.logger.warn(`ICE candidate error`, e, candidate);
                });
            });
        };
        /**
         * Sets the SFU client to use.
         *
         * @param sfuClient the SFU client to use.
         */ this.setSfuClient = (sfuClient)=>{
            this.sfuClient = sfuClient;
            this.tag = sfuClient.tag;
        };
        /**
         * Returns the result of the `RTCPeerConnection.getStats()` method
         * @param selector an optional `MediaStreamTrack` to get the stats for.
         */ this.getStats = (selector)=>{
            return this.pc.getStats(selector);
        };
        /**
         * Maps the given track ID to the corresponding track type.
         */ this.getTrackType = (trackId)=>{
            return this.trackIdToTrackType.get(trackId);
        };
        /**
         * Checks if the `RTCPeerConnection` is healthy.
         * It checks the ICE connection state and the peer connection state.
         * If either state is `failed`, `disconnected`, or `closed`,
         * it returns `false`, otherwise it returns `true`.
         */ this.isHealthy = ()=>{
            const failedStates = new Set([
                'failed',
                'closed'
            ]);
            const iceState = this.pc.iceConnectionState;
            const connectionState = this.pc.connectionState;
            return !failedStates.has(iceState) && !failedStates.has(connectionState);
        };
        /**
         * Returns true only when the peer connection is currently fully established
         * (ICE `connected`/`completed` AND connection state `connected`).
         * Transient states like `disconnected`, `checking`, or `new` return false.
         */ this.isStable = ()=>{
            const iceState = this.pc.iceConnectionState;
            const connectionState = this.pc.connectionState;
            return (iceState === 'connected' || iceState === 'completed') && connectionState === 'connected';
        };
        /**
         * Handles the ICECandidate event and
         * Initiates an ICE Trickle process with the SFU.
         */ this.onIceCandidate = (e)=>{
            const { candidate: candidate } = e;
            if (!candidate) {
                this.logger.debug('null ice candidate');
                return;
            }
            const iceCandidate = this.asJSON(candidate);
            this.sfuClient.iceTrickle({
                peerType: this.peerType,
                iceCandidate: iceCandidate
            }).catch((err)=>{
                if (this.isDisposed) return;
                this.logger.warn(`ICETrickle failed`, err);
            });
        };
        /**
         * Converts the ICE candidate to a JSON string.
         */ this.asJSON = (candidate)=>{
            if (!candidate.usernameFragment) {
                // react-native-webrtc doesn't include usernameFragment in the candidate
                const segments = candidate.candidate.split(' ');
                const ufragIndex = segments.findIndex((s)=>s === 'ufrag') + 1;
                const usernameFragment = segments[ufragIndex];
                return JSON.stringify({
                    ...candidate,
                    usernameFragment: usernameFragment
                });
            }
            return JSON.stringify(candidate.toJSON());
        };
        /**
         * Handles the ConnectionStateChange event.
         */ this.onConnectionStateChange = async ()=>{
            const state = this.pc.connectionState;
            this.logger.debug(`Connection state changed`, state);
            this.fireOnPeerConnectionStateChange({
                stateType: 'peerConnection',
                state: state
            });
            if (this.tracer && (state === 'connected' || state === 'failed')) try {
                const stats = await this.stats.get();
                this.tracer.trace('getstats', stats.delta);
            } catch (err) {
                this.tracer.trace('getstatsOnFailure', err.toString());
            }
            // we can't recover from a failed connection state (contrary to ICE)
            if (state === 'failed') {
                this.onReconnectionNeeded?.($8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.REJOIN, $8c05ed6f2f331ee8$var$ReconnectReason.CONNECTION_FAILED, this.peerType);
                return;
            }
            this.handleConnectionStateUpdate(state);
        };
        /**
         * Handles the ICE connection state change event.
         */ this.onIceConnectionStateChange = ()=>{
            const state = this.pc.iceConnectionState;
            this.logger.debug(`ICE connection state changed`, state);
            this.fireOnPeerConnectionStateChange({
                stateType: 'ice',
                state: state
            });
            this.handleConnectionStateUpdate(state);
        };
        this.fireOnPeerConnectionStateChange = (event)=>{
            try {
                this.onPeerConnectionStateChange?.({
                    peerType: this.peerType,
                    ...event
                });
            } catch (err) {
                this.logger.warn('onPeerConnectionStateChange listener threw', err);
            }
        };
        this.handleConnectionStateUpdate = (state)=>{
            const { callingState: callingState } = this.state;
            if (callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.OFFLINE) return;
            if (callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.RECONNECTING) return;
            // do nothing when ICE is restarting
            if (this.isIceRestarting) return;
            // Pre-connect handling: ICE has never reached `connected`/`completed`.
            // Restart is futile here (the data plane was never established), but
            // these two terminal-ish states need different treatment:
            // - `failed` is terminal, escalate to REJOIN so a new SFU/credentials
            //   /PC configuration gets a chance, and let `Call.reconnect` count
            //   this toward the unsupported-network budget.
            // - `disconnected` is transient, the browser may yet move back to
            //   `checking`/`connected`. Don't restart, don't escalate; wait it
            //   out. If it ultimately fails, ICE will transition to `failed` and
            //   the branch above will take over.
            if (!this.iceHasEverConnected) {
                if (state === 'failed') {
                    this.logger.info('ICE failed before connected, escalating to REJOIN');
                    clearTimeout(this.preConnectStuckTimeout);
                    this.preConnectStuckTimeout = undefined;
                    this.onReconnectionNeeded?.($8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.REJOIN, $8c05ed6f2f331ee8$var$ReconnectReason.ICE_NEVER_CONNECTED, this.peerType);
                    return;
                }
                if (state === 'disconnected') {
                    this.logger.info('ICE disconnected before connected, wait to recover');
                    // Watchdog: if the browser stays in `disconnected` without ever
                    // reaching `connected` or transitioning to `failed`, escalate to
                    // REJOIN ourselves so we don't wait silently forever. Rare but
                    // observed on flaky mobile networks.
                    clearTimeout(this.preConnectStuckTimeout);
                    this.preConnectStuckTimeout = setTimeout(()=>{
                        if (!this.iceHasEverConnected && this.pc.iceConnectionState === 'disconnected') {
                            this.logger.info('ICE stuck in pre-connect disconnected, escalating to REJOIN');
                            this.onReconnectionNeeded?.($8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.REJOIN, $8c05ed6f2f331ee8$var$ReconnectReason.ICE_NEVER_CONNECTED, this.peerType);
                        }
                    }, this.iceRestartDelay * 2);
                    return;
                }
            }
            switch(state){
                case 'failed':
                    // in the `failed` state, we try to restart ICE immediately
                    this.logger.info('restartICE due to failed connection');
                    this.tryRestartIce();
                    break;
                case 'disconnected':
                    // in the `disconnected` state, we schedule a restartICE() after a delay
                    // as the browser might recover the connection in the meantime
                    this.logger.info('disconnected connection, scheduling restartICE');
                    clearTimeout(this.iceRestartTimeout);
                    this.iceRestartTimeout = setTimeout(()=>{
                        const currentState = this.pc.iceConnectionState;
                        if (currentState === 'disconnected' || currentState === 'failed') this.tryRestartIce();
                    }, this.iceRestartDelay);
                    break;
                case 'connected':
                case 'completed':
                    // Fire `onIceConnected` exactly once per peer-connection lifetime —
                    // the first time ICE reaches `connected`/`completed` end-to-end.
                    // Used by `Call` to reset the unsupported-network failure counter
                    // only after WebRTC has actually recovered, not merely on SFU join.
                    if (!this.iceHasEverConnected) {
                        this.iceHasEverConnected = true;
                        this.onIceConnected?.(this.peerType);
                    }
                    // clear any scheduled restartICE since the connection is healthy
                    if (this.iceRestartTimeout) {
                        this.logger.info('connected connection, canceling restartICE');
                        clearTimeout(this.iceRestartTimeout);
                        this.iceRestartTimeout = undefined;
                    }
                    // clear the pre-connect watchdog if it was armed
                    clearTimeout(this.preConnectStuckTimeout);
                    this.preConnectStuckTimeout = undefined;
                    break;
            }
        };
        /**
         * Handles the ICE candidate error event.
         */ this.onIceCandidateError = (e)=>{
            const errorMessage = e instanceof RTCPeerConnectionIceErrorEvent ? `${e.errorCode}: ${e.errorText}` : e;
            this.logger.debug('ICE Candidate error', errorMessage);
        };
        /**
         * Handles the ICE gathering state change event.
         */ this.onIceGatherChange = ()=>{
            this.logger.debug(`ICE Gathering State`, this.pc.iceGatheringState);
        };
        /**
         * Handles the signaling state change event.
         */ this.onSignalingChange = ()=>{
            this.logger.debug(`Signaling state changed`, this.pc.signalingState);
        };
        this.peerType = peerType;
        this.sfuClient = sfuClient;
        this.state = state;
        this.dispatcher = dispatcher;
        this.iceRestartDelay = iceRestartDelay;
        this.clientPublishOptions = clientPublishOptions;
        this.tag = tag;
        this.onReconnectionNeeded = onReconnectionNeeded;
        this.onIceConnected = onIceConnected;
        this.onPeerConnectionStateChange = onPeerConnectionStateChange;
        this.onRemoteTrackUnmute = onRemoteTrackUnmute;
        this.logger = $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger(peerType === $8c05ed6f2f331ee8$var$PeerType.SUBSCRIBER ? 'Subscriber' : 'Publisher', {
            tags: [
                tag
            ]
        });
        this.pc = this.createPeerConnection(connectionConfig);
        this.stats = new $8c05ed6f2f331ee8$var$StatsTracer(this.pc, peerType, this.trackIdToTrackType, statsTimestampDriftThresholdMs);
        if (enableTracing) {
            this.tracer = new $8c05ed6f2f331ee8$var$Tracer(`${tag}-${peerType === $8c05ed6f2f331ee8$var$PeerType.SUBSCRIBER ? 'sub' : 'pub'}`);
            this.tracer.trace('create', {
                url: sfuClient.edgeName,
                ...connectionConfig
            });
            $8c05ed6f2f331ee8$var$traceRTCPeerConnection(this.pc, this.tracer.trace);
        }
    }
    /**
     * Disposes the `RTCPeerConnection` instance.
     */ async dispose() {
        clearTimeout(this.iceRestartTimeout);
        this.iceRestartTimeout = undefined;
        clearTimeout(this.preConnectStuckTimeout);
        this.preConnectStuckTimeout = undefined;
        this.onReconnectionNeeded = undefined;
        this.onIceConnected = undefined;
        this.onPeerConnectionStateChange = undefined;
        this.onRemoteTrackUnmute = undefined;
        this.isDisposed = true;
        this.detachEventHandlers();
        this.pc.close();
        this.tracer?.dispose();
    }
    /**
     * Detaches the event handlers from the `RTCPeerConnection`.
     */ detachEventHandlers() {
        const pc = this.pc;
        pc.removeEventListener('icecandidate', this.onIceCandidate);
        pc.removeEventListener('icecandidateerror', this.onIceCandidateError);
        pc.removeEventListener('signalingstatechange', this.onSignalingChange);
        pc.removeEventListener('iceconnectionstatechange', this.onIceConnectionStateChange);
        pc.removeEventListener('icegatheringstatechange', this.onIceGatherChange);
        pc.removeEventListener('connectionstatechange', this.onConnectionStateChange);
        this.unsubscribeIceTrickle?.();
        this.subscriptions.forEach((unsubscribe)=>unsubscribe());
        this.subscriptions = [];
    }
}
class $8c05ed6f2f331ee8$var$TransceiverCache {
    constructor(){
        this.cache = [];
        this.layers = [];
        /**
         * An array maintaining the order how transceivers were added to the peer connection.
         * This is needed because some browsers (Firefox) don't reliably report
         * trackId and `mid` parameters.
         */ this.transceiverOrder = [];
        /**
         * Adds a transceiver to the cache.
         */ this.add = (bundle)=>{
            this.cache.push(bundle);
            this.transceiverOrder.push(bundle.transceiver);
        };
        /**
         * Gets the transceiver for the given publish option.
         */ this.get = (publishOption)=>{
            return this.getBy(publishOption.id, publishOption.trackType);
        };
        /**
         * Gets the transceiver for the given publish option id and track type.
         */ this.getBy = (publishOptionId, trackType)=>{
            return this.cache.find((bundle)=>bundle.publishOption.id === publishOptionId && bundle.publishOption.trackType === trackType);
        };
        /**
         * Updates the cached bundle with the given patch.
         */ this.update = (publishOption, patch)=>{
            const bundle = this.get(publishOption);
            if (bundle) Object.assign(bundle, patch);
        };
        /**
         * Checks if the cache has the given publish option.
         */ this.has = (publishOption)=>{
            return !!this.get(publishOption);
        };
        /**
         * Finds the first transceiver that satisfies the given predicate.
         */ this.find = (predicate)=>{
            return this.cache.find(predicate);
        };
        /**
         * Provides all the items in the cache.
         */ this.items = ()=>{
            return this.cache;
        };
        /**
         * Init index of the transceiver in the cache.
         */ this.indexOf = (transceiver)=>{
            return this.transceiverOrder.indexOf(transceiver);
        };
        /**
         * Gets cached video layers for the given track.
         */ this.getLayers = (publishOption)=>{
            const entry = this.layers.find((item)=>item.publishOption.id === publishOption.id && item.publishOption.trackType === publishOption.trackType);
            return entry?.layers;
        };
        /**
         * Sets the video layers for the given track.
         */ this.setLayers = (publishOption, layers = [])=>{
            const entry = this.findLayer(publishOption);
            if (entry) entry.layers = layers;
            else this.layers.push({
                publishOption: publishOption,
                layers: layers
            });
        };
        this.findLayer = (publishOption)=>{
            return this.layers.find((item)=>item.publishOption.id === publishOption.id && item.publishOption.trackType === publishOption.trackType);
        };
    }
}
const $8c05ed6f2f331ee8$var$trackTypeToParticipantStreamKey = (trackType)=>{
    switch(trackType){
        case $8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE:
            return 'screenShareStream';
        case $8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE_AUDIO:
            return 'screenShareAudioStream';
        case $8c05ed6f2f331ee8$var$TrackType.VIDEO:
            return 'videoStream';
        case $8c05ed6f2f331ee8$var$TrackType.AUDIO:
            return 'audioStream';
        case $8c05ed6f2f331ee8$var$TrackType.UNSPECIFIED:
            throw new Error('Track type is unspecified');
        default:
            $8c05ed6f2f331ee8$var$ensureExhausted(trackType, 'Unknown track type');
    }
};
const $8c05ed6f2f331ee8$var$muteTypeToTrackType = (muteType)=>{
    switch(muteType){
        case 'audio':
            return $8c05ed6f2f331ee8$var$TrackType.AUDIO;
        case 'video':
            return $8c05ed6f2f331ee8$var$TrackType.VIDEO;
        case 'screenshare':
            return $8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE;
        case 'screenshare_audio':
            return $8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE_AUDIO;
        default:
            $8c05ed6f2f331ee8$var$ensureExhausted(muteType, 'Unknown mute type');
    }
};
const $8c05ed6f2f331ee8$var$toTrackType = (trackType)=>{
    switch(trackType){
        case 'TRACK_TYPE_AUDIO':
            return $8c05ed6f2f331ee8$var$TrackType.AUDIO;
        case 'TRACK_TYPE_VIDEO':
            return $8c05ed6f2f331ee8$var$TrackType.VIDEO;
        case 'TRACK_TYPE_SCREEN_SHARE':
            return $8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE;
        case 'TRACK_TYPE_SCREEN_SHARE_AUDIO':
            return $8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE_AUDIO;
        default:
            return undefined;
    }
};
const $8c05ed6f2f331ee8$var$isAudioTrackType = (trackType)=>trackType === $8c05ed6f2f331ee8$var$TrackType.AUDIO || trackType === $8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE_AUDIO;
/**
 * Prepares the audio layer for the given track.
 * Based on the provided audio bitrate profile, we apply the appropriate bitrate.
 */ const $8c05ed6f2f331ee8$var$computeAudioLayers = (publishOption, options)=>{
    const { audioBitrateProfile: audioBitrateProfile } = options;
    const profileConfig = publishOption.audioBitrateProfiles?.find((config)=>config.profile === audioBitrateProfile);
    const maxBitrate = profileConfig?.bitrate || ({
        [$8c05ed6f2f331ee8$var$AudioBitrateProfile.VOICE_STANDARD_UNSPECIFIED]: 64000,
        [$8c05ed6f2f331ee8$var$AudioBitrateProfile.VOICE_HIGH_QUALITY]: 128000,
        [$8c05ed6f2f331ee8$var$AudioBitrateProfile.MUSIC_HIGH_QUALITY]: 128000
    })[audioBitrateProfile || $8c05ed6f2f331ee8$var$AudioBitrateProfile.VOICE_STANDARD_UNSPECIFIED];
    return [
        {
            maxBitrate: maxBitrate
        }
    ];
};
/**
 * In SVC, we need to send only one video encoding (layer).
 * this layer will have the additional spatial and temporal layers
 * defined via the scalabilityMode property.
 *
 * @param layers the layers to process.
 */ const $8c05ed6f2f331ee8$var$toSvcEncodings = (layers)=>{
    if (!layers) return;
    // we take the highest quality layer, and we assign it to `q` encoder.
    const withRid = (rid)=>(layer)=>layer.rid === rid;
    const highestLayer = layers.find(withRid('f')) || layers.find(withRid('h')) || layers.find(withRid('q'));
    return [
        {
            ...highestLayer,
            rid: 'q'
        }
    ];
};
/**
 * Converts the rid to a video quality.
 */ const $8c05ed6f2f331ee8$var$ridToVideoQuality = (rid)=>{
    return rid === 'q' ? $8c05ed6f2f331ee8$var$VideoQuality.LOW_UNSPECIFIED : rid === 'h' ? $8c05ed6f2f331ee8$var$VideoQuality.MID : $8c05ed6f2f331ee8$var$VideoQuality.HIGH; // default to HIGH
};
/**
 * Converts the given video layers to SFU video layers.
 */ const $8c05ed6f2f331ee8$var$toVideoLayers = (layers = [])=>{
    return layers.map((layer)=>({
            rid: layer.rid || '',
            bitrate: layer.maxBitrate || 0,
            fps: layer.maxFramerate || 0,
            quality: $8c05ed6f2f331ee8$var$ridToVideoQuality(layer.rid || ''),
            videoDimension: {
                width: layer.width,
                height: layer.height
            }
        }));
};
/**
 * Converts the spatial and temporal layers to a scalability mode.
 */ const $8c05ed6f2f331ee8$var$toScalabilityMode = (spatialLayers, temporalLayers)=>`L${spatialLayers}T${temporalLayers}${spatialLayers > 1 ? '_KEY' : ''}`;
/**
 * Determines the most optimal video layers for the given track.
 *
 * @param videoTrack the video track to find optimal layers for.
 * @param publishOption the publish options for the track.
 */ const $8c05ed6f2f331ee8$var$computeVideoLayers = (videoTrack, publishOption)=>{
    if ($8c05ed6f2f331ee8$var$isAudioTrackType(publishOption.trackType)) return;
    const optimalVideoLayers = [];
    const { bitrate: bitrate, codec: codec, fps: fps = 30, maxSpatialLayers: maxSpatialLayers = 3, maxTemporalLayers: maxTemporalLayers = 3, videoDimension: videoDimension = {
        width: 1280,
        height: 720
    }, useSingleLayer: useSingleLayer } = publishOption;
    const { width: width = videoDimension.width, height: height = videoDimension.height } = videoTrack.getSettings();
    const maxBitrate = $8c05ed6f2f331ee8$var$getComputedMaxBitrate(videoDimension, width, height, bitrate);
    let downscaleFactor = 1;
    let bitrateFactor = 1;
    const svcCodec = $8c05ed6f2f331ee8$var$isSvcCodec(codec?.name);
    for (const rid of [
        'f',
        'h',
        'q'
    ].slice(0, maxSpatialLayers)){
        const layer = {
            active: true,
            rid: rid,
            width: Math.round(width / downscaleFactor),
            height: Math.round(height / downscaleFactor),
            maxBitrate: Math.round(maxBitrate / bitrateFactor) || ({
                q: 300000,
                h: 750000,
                f: 1250000
            })[rid],
            maxFramerate: fps
        };
        if (svcCodec) // for SVC codecs, we need to set the scalability mode, and the
        // codec will handle the rest (layers, temporal layers, etc.)
        layer.scalabilityMode = $8c05ed6f2f331ee8$var$toScalabilityMode(useSingleLayer ? 1 : maxSpatialLayers, maxTemporalLayers);
        else // for non-SVC codecs, we need to downscale proportionally (simulcast)
        layer.scaleResolutionDownBy = downscaleFactor;
        downscaleFactor *= 2;
        bitrateFactor *= 2;
        // Reversing the order [f, h, q] to [q, h, f] as Chrome uses encoding index
        // when deciding which layer to disable when CPU or bandwidth is constrained.
        // Encodings should be ordered in increasing spatial resolution order.
        optimalVideoLayers.unshift(layer);
    }
    // for simplicity, we start with all layers enabled, then this function
    // will clear/reassign the layers that are not needed
    return $8c05ed6f2f331ee8$var$withSimulcastConstraints(width, height, optimalVideoLayers, useSingleLayer);
};
/**
 * Computes the maximum bitrate for a given resolution.
 * If the current resolution is lower than the target resolution,
 * we want to proportionally reduce the target bitrate.
 * If the current resolution is higher than the target resolution,
 * we want to use the target bitrate.
 *
 * @param targetResolution the target resolution.
 * @param currentWidth the current width of the track.
 * @param currentHeight the current height of the track.
 * @param bitrate the target bitrate.
 */ const $8c05ed6f2f331ee8$var$getComputedMaxBitrate = (targetResolution, currentWidth, currentHeight, bitrate)=>{
    // if the current resolution is lower than the target resolution,
    // we want to proportionally reduce the target bitrate
    const { width: targetWidth, height: targetHeight } = targetResolution;
    if (currentWidth < targetWidth || currentHeight < targetHeight) {
        const currentPixels = currentWidth * currentHeight;
        const targetPixels = targetWidth * targetHeight;
        const reductionFactor = currentPixels / targetPixels;
        return Math.round(bitrate * reductionFactor);
    }
    return bitrate;
};
/**
 * Browsers have different simulcast constraints for different video resolutions.
 *
 * This function modifies the provided list of video layers according to the
 * current implementation of simulcast constraints in the Chromium based browsers.
 *
 * https://chromium.googlesource.com/external/webrtc/+/refs/heads/main/media/engine/simulcast.cc#90
 */ const $8c05ed6f2f331ee8$var$withSimulcastConstraints = (width, height, optimalVideoLayers, useSingleLayer)=>{
    let layers;
    const size = Math.max(width, height);
    if (size <= 320) // provide only one layer 320x240 (f), the one with the highest quality
    layers = optimalVideoLayers.filter((layer)=>layer.rid === 'f');
    else if (size <= 640) // provide two layers, 320x240 (h) and 640x480 (f)
    layers = optimalVideoLayers.filter((layer)=>layer.rid !== 'q');
    else // provide three layers for sizes > 640x480
    layers = optimalVideoLayers;
    // we might have removed some layers, so we need to reassign the rid
    // to match the expected order of [q, h, f] for simulcast
    const ridMapping = [
        'q',
        'h',
        'f'
    ];
    return layers.map((layer, index, arr)=>({
            ...layer,
            rid: ridMapping[index],
            active: useSingleLayer && index < arr.length - 1 ? false : layer.active
        }));
};
const $8c05ed6f2f331ee8$var$toRTCDegradationPreference = (preference)=>{
    switch(preference){
        case $8c05ed6f2f331ee8$var$DegradationPreference.BALANCED:
            return 'balanced';
        case $8c05ed6f2f331ee8$var$DegradationPreference.MAINTAIN_FRAMERATE:
            return 'maintain-framerate';
        case $8c05ed6f2f331ee8$var$DegradationPreference.MAINTAIN_RESOLUTION:
            return 'maintain-resolution';
        case $8c05ed6f2f331ee8$var$DegradationPreference.MAINTAIN_FRAMERATE_AND_RESOLUTION:
            // @ts-expect-error not in the typedefs yet
            return 'maintain-framerate-and-resolution';
        case $8c05ed6f2f331ee8$var$DegradationPreference.UNSPECIFIED:
            return undefined;
        default:
            $8c05ed6f2f331ee8$var$ensureExhausted(preference, 'Unknown degradation preference');
    }
};
const $8c05ed6f2f331ee8$var$fromRTCDegradationPreference = (preference)=>{
    switch(preference){
        case 'balanced':
            return $8c05ed6f2f331ee8$var$DegradationPreference.BALANCED;
        case 'maintain-framerate':
            return $8c05ed6f2f331ee8$var$DegradationPreference.MAINTAIN_FRAMERATE;
        case 'maintain-resolution':
            return $8c05ed6f2f331ee8$var$DegradationPreference.MAINTAIN_RESOLUTION;
        // @ts-expect-error not in the typedefs yet
        case 'maintain-framerate-and-resolution':
            return $8c05ed6f2f331ee8$var$DegradationPreference.MAINTAIN_FRAMERATE_AND_RESOLUTION;
        default:
            return $8c05ed6f2f331ee8$var$DegradationPreference.UNSPECIFIED;
    }
};
/**
 * The `Publisher` is responsible for publishing/unpublishing media streams to/from the SFU
 *
 * @internal
 */ class $8c05ed6f2f331ee8$var$Publisher extends $8c05ed6f2f331ee8$var$BasePeerConnection {
    /**
     * Constructs a new `Publisher` instance.
     */ constructor(baseOptions, publishOptions){
        super($8c05ed6f2f331ee8$var$PeerType.PUBLISHER_UNSPECIFIED, baseOptions);
        this.transceiverCache = new $8c05ed6f2f331ee8$var$TransceiverCache();
        this.clonedTracks = new Set();
        /**
         * Starts publishing the given track of the given media stream.
         *
         * Consecutive calls to this method will replace the stream.
         * The previous stream will be stopped.
         *
         * @param track the track to publish.
         * @param trackType the track type to publish.
         * @param options the publish options to use.
         */ this.publish = async (track, trackType, options = {})=>{
            if (!this.publishOptions.some((o)=>o.trackType === trackType)) throw new Error(`No publish options found for ${$8c05ed6f2f331ee8$var$TrackType[trackType]}`);
            for (const publishOption of this.publishOptions){
                if (publishOption.trackType !== trackType) continue;
                // create a clone of the track as otherwise the same trackId will
                // appear in the SDP in multiple transceivers
                const trackToPublish = this.cloneTrack(track);
                const bundle = this.transceiverCache.get(publishOption);
                if (!bundle) await this.addTransceiver(trackToPublish, publishOption, options);
                else {
                    const previousTrack = bundle.transceiver.sender.track;
                    await this.updateTransceiver(bundle, trackToPublish, options);
                    if (!$8c05ed6f2f331ee8$var$isReactNative()) this.stopTrack(previousTrack);
                }
            }
        };
        /**
         * Adds a new transceiver carrying the given track to the peer connection.
         */ this.addTransceiver = async (track, publishOption, options)=>{
            const encodings = $8c05ed6f2f331ee8$var$isAudioTrackType(publishOption.trackType) ? $8c05ed6f2f331ee8$var$computeAudioLayers(publishOption, options) : $8c05ed6f2f331ee8$var$computeVideoLayers(track, publishOption);
            const sendEncodings = $8c05ed6f2f331ee8$var$isSvcCodec(publishOption.codec?.name) ? $8c05ed6f2f331ee8$var$toSvcEncodings(encodings) : encodings;
            const transceiver = this.pc.addTransceiver(track, {
                direction: 'sendonly',
                sendEncodings: sendEncodings
            });
            const params = transceiver.sender.getParameters();
            params.degradationPreference = $8c05ed6f2f331ee8$var$toRTCDegradationPreference(publishOption.degradationPreference) ?? 'maintain-framerate';
            await transceiver.sender.setParameters(params);
            const trackType = publishOption.trackType;
            this.logger.debug(`Added ${$8c05ed6f2f331ee8$var$TrackType[trackType]} transceiver`);
            this.transceiverCache.add({
                publishOption: publishOption,
                transceiver: transceiver,
                options: options
            });
            this.trackIdToTrackType.set(track.id, trackType);
            await this.negotiate();
        };
        /**
         * Updates the transceiver with the given track and track type.
         */ this.updateTransceiver = async (bundle, track, options = {})=>{
            const { transceiver: transceiver, publishOption: publishOption } = bundle;
            const trackType = publishOption.trackType;
            const sender = transceiver.sender;
            if (sender.track) this.trackIdToTrackType.delete(sender.track.id);
            await sender.replaceTrack(track);
            if (track) {
                this.trackIdToTrackType.set(track.id, trackType);
                if ($8c05ed6f2f331ee8$var$isFirefox() && bundle.videoSender) // restore the encoding config from the cache, if any
                await this.changePublishQuality(bundle.videoSender, bundle);
            }
            if ($8c05ed6f2f331ee8$var$isAudioTrackType(trackType)) await this.updateAudioPublishOptions(trackType, options);
        };
        /**
         * Updates the publish options for the given track type.
         */ this.updateAudioPublishOptions = async (trackType, options)=>{
            for (const publishOption of this.publishOptions){
                if (publishOption.trackType !== trackType) continue;
                const bundle = this.transceiverCache.get(publishOption);
                if (!bundle) continue;
                const { transceiver: transceiver, options: current } = bundle;
                if (current.audioBitrateProfile !== options.audioBitrateProfile) {
                    const encodings = $8c05ed6f2f331ee8$var$computeAudioLayers(publishOption, options);
                    if (encodings && encodings.length > 0) {
                        const params = transceiver.sender.getParameters();
                        const [currentEncoding] = params.encodings;
                        const [targetEncoding] = encodings;
                        if (currentEncoding.maxBitrate !== targetEncoding.maxBitrate) currentEncoding.maxBitrate = targetEncoding.maxBitrate;
                        await transceiver.sender.setParameters(params);
                    }
                }
                this.transceiverCache.update(publishOption, {
                    options: options
                });
            }
        };
        /**
         * Synchronizes the current Publisher state with the provided publish options.
         */ this.syncPublishOptions = async ()=>{
            // enable publishing with new options -> [av1, vp9]
            for (const publishOption of this.publishOptions){
                const { trackType: trackType } = publishOption;
                if (!this.isPublishing(trackType)) continue;
                if (this.transceiverCache.has(publishOption)) continue;
                const item = this.transceiverCache.find((i)=>!!i.transceiver.sender.track && i.publishOption.trackType === trackType);
                if (!item) continue;
                // take the track from the existing transceiver for the same track type,
                // clone it and publish it with the new publish options
                const track = this.cloneTrack(item.transceiver.sender.track);
                await this.addTransceiver(track, publishOption, item.options);
            }
            // stop publishing with options not required anymore -> [vp9]
            for (const item of this.transceiverCache.items()){
                const { publishOption: publishOption, transceiver: transceiver } = item;
                const hasPublishOption = this.publishOptions.some((option)=>option.id === publishOption.id && option.trackType === publishOption.trackType);
                if (hasPublishOption) continue;
                // it is safe to stop the track here, it is a clone
                this.stopTrack(transceiver.sender.track);
                await this.updateTransceiver(item, null);
            }
        };
        /**
         * Returns true if the given track type is currently being published to the SFU.
         *
         * @param trackType the track type to check. If omitted, checks if any track is being published.
         */ this.isPublishing = (trackType)=>{
            for (const item of this.transceiverCache.items()){
                if (trackType && item.publishOption.trackType !== trackType) continue;
                const track = item.transceiver.sender.track;
                if (!track) continue;
                if (track.readyState === 'live' && track.enabled) return true;
            }
            return false;
        };
        /**
         * Re-arms the encoder for the given track type by detaching and
         * reattaching the currently published track on each matching sender.
         *
         * Workaround for a WebKit / iOS Safari quirk: after a system audio
         * session interruption (Siri, PSTN call), the `RTCRtpSender` encoder
         * can stop producing RTP packets even though the underlying
         * `MediaStreamTrack` is `live` and `track.muted === false`.
         * `replaceTrack(null)` followed by `replaceTrack(track)` resets the
         * sender's encoder pipeline without renegotiation, restoring packet
         * flow with the same SSRC.
         *
         * No-op when nothing is published for the given track type.
         *
         * @param trackType the track type to refresh.
         */ this.refreshTrack = async (trackType)=>{
            for (const item of this.transceiverCache.items()){
                if (item.publishOption.trackType !== trackType) continue;
                const { sender: sender } = item.transceiver;
                const track = sender.track;
                if (!track || track.readyState !== 'live') continue;
                try {
                    await sender.replaceTrack(null);
                    await sender.replaceTrack(track);
                    this.logger.debug(`Refreshed ${$8c05ed6f2f331ee8$var$TrackType[trackType]} sender`);
                } catch (err) {
                    this.logger.warn(`Failed to refresh ${$8c05ed6f2f331ee8$var$TrackType[trackType]}`, err);
                }
            }
        };
        /**
         * Stops the cloned track that is being published to the SFU.
         */ this.stopTracks = async (...trackTypes)=>{
            return $8c05ed6f2f331ee8$var$withoutConcurrency(this.eventLockKey('changePublishQuality'), async ()=>{
                for (const item of this.transceiverCache.items()){
                    const { publishOption: publishOption, transceiver: transceiver } = item;
                    if (!trackTypes.includes(publishOption.trackType)) continue;
                    const track = transceiver.sender.track;
                    await this.silenceSenderOnFirefox(item);
                    this.stopTrack(track);
                }
            });
        };
        /**
         * Stops all the cloned tracks that are being published to the SFU.
         */ this.stopAllTracks = async ()=>{
            return $8c05ed6f2f331ee8$var$withoutConcurrency(this.eventLockKey('changePublishQuality'), async ()=>{
                for (const item of this.transceiverCache.items()){
                    const track = item.transceiver.sender.track;
                    await this.silenceSenderOnFirefox(item);
                    this.stopTrack(track);
                }
                for (const track of this.clonedTracks)this.stopTrack(track);
            });
        };
        this.changePublishQuality = async (videoSender, bundle)=>{
            const enabledLayers = videoSender.layers.filter((l)=>l.active);
            const tag = 'Update publish quality:';
            this.logger.info(`${tag} requested layers by SFU:`, enabledLayers);
            const sender = bundle?.transceiver.sender;
            if (!sender) return this.logger.warn(`${tag} no video sender found.`);
            const params = sender.getParameters();
            if (params.encodings.length === 0) return this.logger.warn(`${tag} there are no encodings set.`);
            const codecInUse = bundle?.publishOption.codec?.name;
            const usesSvcCodec = codecInUse && $8c05ed6f2f331ee8$var$isSvcCodec(codecInUse);
            let changed = false;
            for (const encoder of params.encodings){
                const layer = usesSvcCodec ? enabledLayers[0] : enabledLayers.find((l)=>l.name === encoder.rid) ?? (params.encodings.length === 1 ? enabledLayers[0] : undefined);
                // flip 'active' flag only when necessary
                const shouldActivate = !!layer?.active;
                if (shouldActivate !== encoder.active) {
                    encoder.active = shouldActivate;
                    changed = true;
                }
                // skip the rest of the settings if the layer is disabled or not found
                if (!layer) continue;
                const { maxFramerate: maxFramerate, scaleResolutionDownBy: scaleResolutionDownBy, maxBitrate: maxBitrate, scalabilityMode: scalabilityMode } = layer;
                if (scaleResolutionDownBy >= 1 && scaleResolutionDownBy !== encoder.scaleResolutionDownBy) {
                    encoder.scaleResolutionDownBy = scaleResolutionDownBy;
                    changed = true;
                }
                if (maxBitrate > 0 && maxBitrate !== encoder.maxBitrate) {
                    encoder.maxBitrate = maxBitrate;
                    changed = true;
                }
                if (maxFramerate > 0 && maxFramerate !== encoder.maxFramerate) {
                    encoder.maxFramerate = maxFramerate;
                    changed = true;
                }
                // @ts-expect-error scalabilityMode is not in the typedefs yet
                if (scalabilityMode && scalabilityMode !== encoder.scalabilityMode) {
                    // @ts-expect-error scalabilityMode is not in the typedefs yet
                    encoder.scalabilityMode = scalabilityMode;
                    changed = true;
                }
            }
            const degradationPreference = $8c05ed6f2f331ee8$var$toRTCDegradationPreference(videoSender.degradationPreference);
            if (degradationPreference && params.degradationPreference !== degradationPreference) {
                params.degradationPreference = degradationPreference;
                changed = true;
            }
            const activeEncoders = params.encodings.filter((e)=>e.active);
            if (!changed) return this.logger.info(`${tag} no change:`, activeEncoders);
            await sender.setParameters(params);
            this.logger.info(`${tag} enabled rids:`, activeEncoders);
        };
        /**
         * Restarts the ICE connection and renegotiates with the SFU.
         */ this.restartIce = async ()=>{
            this.logger.debug('Restarting ICE connection');
            const signalingState = this.pc.signalingState;
            if (this.isIceRestarting || signalingState === 'have-local-offer') {
                this.logger.debug('ICE restart is already in progress');
                return;
            }
            await this.negotiate({
                iceRestart: true
            });
        };
        /**
         * Initiates a new offer/answer exchange with the currently connected SFU.
         *
         * @param options the optional offer options to use.
         */ this.negotiate = async (options)=>{
            return $8c05ed6f2f331ee8$var$withoutConcurrency(`publisher.negotiate.${this.lock}`, async ()=>{
                const offer = await this.pc.createOffer(options);
                const tracks = this.getAnnouncedTracks(offer.sdp);
                if (!tracks.length) throw new Error(`Can't negotiate without any tracks`);
                try {
                    this.isIceRestarting = options?.iceRestart ?? false;
                    await this.pc.setLocalDescription(offer);
                    const { sdp: baseSdp = '' } = offer;
                    const { dangerouslyForceCodec: dangerouslyForceCodec, dangerouslySetStartBitrateFactor: dangerouslySetStartBitrateFactor, fmtpLine: fmtpLine } = this.clientPublishOptions || {};
                    let sdp = dangerouslyForceCodec ? $8c05ed6f2f331ee8$var$removeCodecsExcept(baseSdp, dangerouslyForceCodec, fmtpLine) : baseSdp;
                    if (dangerouslySetStartBitrateFactor !== undefined) this.transceiverCache.items().forEach((t)=>{
                        if (t.publishOption.trackType !== $8c05ed6f2f331ee8$var$TrackType.VIDEO) return;
                        const maxBitrateBps = t.publishOption.bitrate;
                        const trackId = t.transceiver.sender.track?.id;
                        if (!trackId) return;
                        const mid = tracks.find((x)=>x.trackId === trackId)?.mid;
                        if (!mid) return;
                        sdp = $8c05ed6f2f331ee8$var$setStartBitrate(sdp, maxBitrateBps / 1000, dangerouslySetStartBitrateFactor, mid);
                    });
                    const { response: response } = await this.sfuClient.setPublisher({
                        sdp: sdp,
                        tracks: tracks
                    });
                    if (response.error) throw new $8c05ed6f2f331ee8$var$NegotiationError(response.error);
                    const { sdp: answerSdp } = response;
                    await this.pc.setRemoteDescription({
                        type: 'answer',
                        sdp: answerSdp
                    });
                } catch (err) {
                    // negotiation failed, rollback to the previous state
                    if (this.pc.signalingState === 'have-local-offer') await this.pc.setLocalDescription({
                        type: 'rollback'
                    });
                    throw err;
                } finally{
                    this.isIceRestarting = false;
                }
                this.addTrickledIceCandidates();
            });
        };
        /**
         * Returns a list of tracks that are currently being published.
         */ this.getPublishedTracks = ()=>{
            const tracks = [];
            for (const { transceiver: transceiver } of this.transceiverCache.items()){
                const track = transceiver.sender.track;
                if (track && track.readyState === 'live') tracks.push(track);
            }
            return tracks;
        };
        /**
         * Returns a list of tracks that are currently being published.
         * @param sdp an optional SDP to extract the `mid` from.
         */ this.getAnnouncedTracks = (sdp)=>{
            const trackInfos = [];
            for (const bundle of this.transceiverCache.items()){
                if (!bundle.transceiver.sender.track) continue;
                trackInfos.push(this.toTrackInfo(bundle, sdp));
            }
            return trackInfos;
        };
        /**
         * Returns a list of tracks that are currently being published.
         * This method shall be used for the reconnection flow.
         * There we shouldn't announce the tracks that have been stopped due to a codec switch.
         */ this.getAnnouncedTracksForReconnect = ()=>{
            const sdp = this.pc.localDescription?.sdp;
            const trackInfos = [];
            for (const publishOption of this.publishOptions){
                const bundle = this.transceiverCache.get(publishOption);
                const track = bundle?.transceiver.sender.track;
                if (!bundle || !track || track.readyState !== 'live') continue;
                trackInfos.push(this.toTrackInfo(bundle, sdp));
            }
            return trackInfos;
        };
        /**
         * Converts the given transceiver to a `TrackInfo` object.
         */ this.toTrackInfo = (bundle, sdp)=>{
            const { transceiver: transceiver, publishOption: publishOption } = bundle;
            const track = transceiver.sender.track;
            const isTrackLive = track.readyState === 'live';
            const layers = isTrackLive ? $8c05ed6f2f331ee8$var$computeVideoLayers(track, publishOption) : this.transceiverCache.getLayers(publishOption);
            this.transceiverCache.setLayers(publishOption, layers);
            const isAudioTrack = $8c05ed6f2f331ee8$var$isAudioTrackType(publishOption.trackType);
            const transceiverIndex = this.transceiverCache.indexOf(transceiver);
            const audioSettings = this.state.settings?.audio;
            const stereo = publishOption.trackType === $8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE_AUDIO || isAudioTrack && !!audioSettings?.hifi_audio_enabled;
            return {
                trackId: track.id,
                layers: $8c05ed6f2f331ee8$var$toVideoLayers(layers),
                trackType: publishOption.trackType,
                mid: $8c05ed6f2f331ee8$var$extractMid(transceiver, transceiverIndex, sdp),
                stereo: stereo,
                dtx: isAudioTrack && !!audioSettings?.opus_dtx_enabled,
                red: isAudioTrack && !!audioSettings?.redundant_coding_enabled,
                muted: !isTrackLive,
                codec: publishOption.codec,
                publishOptionId: publishOption.id
            };
        };
        this.cloneTrack = (track)=>{
            const clone = track.clone();
            this.clonedTracks.add(clone);
            return clone;
        };
        this.stopTrack = (track)=>{
            if (!track) return;
            track.stop();
            this.clonedTracks.delete(track);
        };
        /**
         * Silences a Firefox sender on the wire during unpublish.
         *
         * Firefox keeps emitting RTP after track.stop(), but the right lever
         * differs by track type:
         *   - audio: `replaceTrack(null)` is the only reliable silencer;
         *     `setParameters({encodings:[...active:false]})` does NOT stop
         *     the Opus encoder.
         *   - video: `setParameters({encodings:[...active:false]})` pauses
         *     the encoder; `replaceTrack(null)` does NOT reliably stop the
         *     video encoder. The prior active=true configuration is captured
         *     onto `bundle.videoSender` so `updateTransceiver` can restore
         *     it on the next publish.
         *
         * No-op on non-Firefox browsers and during teardown.
         */ this.silenceSenderOnFirefox = async (bundle)=>{
            if (this.isDisposed || !$8c05ed6f2f331ee8$var$isFirefox()) return;
            const { transceiver: transceiver, publishOption: publishOption } = bundle;
            if ($8c05ed6f2f331ee8$var$isAudioTrackType(publishOption.trackType)) {
                await transceiver.sender.replaceTrack(null).catch((err)=>{
                    this.logger.warn('Failed to clear audio sender track', err);
                });
                return;
            }
            await this.disableAllEncodings(bundle);
        };
        this.disableAllEncodings = async (bundle)=>{
            const { transceiver: transceiver, publishOption: publishOption } = bundle;
            const sender = transceiver.sender;
            const params = sender.getParameters();
            if (!params.encodings || params.encodings.length === 0) return;
            if (!bundle.videoSender) this.transceiverCache.update(publishOption, {
                videoSender: {
                    trackType: publishOption.trackType,
                    publishOptionId: publishOption.id,
                    codec: publishOption.codec,
                    degradationPreference: $8c05ed6f2f331ee8$var$fromRTCDegradationPreference(params.degradationPreference),
                    layers: params.encodings.map((e)=>({
                            name: e.rid ?? 'q',
                            active: e.active ?? true,
                            maxBitrate: e.maxBitrate ?? 0,
                            scaleResolutionDownBy: e.scaleResolutionDownBy ?? 0,
                            maxFramerate: e.maxFramerate ?? 0,
                            // @ts-expect-error scalabilityMode is not in the typedefs yet
                            scalabilityMode: e.scalabilityMode ?? ''
                        }))
                }
            });
            let changed = false;
            for (const encoding of params.encodings)if (encoding.active !== false) {
                encoding.active = false;
                changed = true;
            }
            if (!changed) return;
            await sender.setParameters(params).catch((err)=>{
                this.logger.error('Failed to disable video sender encodings:', err);
            });
        };
        this.publishOptions = publishOptions;
        this.on('iceRestart', (iceRestart)=>{
            if (iceRestart.peerType !== $8c05ed6f2f331ee8$var$PeerType.PUBLISHER_UNSPECIFIED) return;
            this.tryRestartIce();
        });
        this.on('changePublishQuality', async (event)=>{
            for (const videoSender of event.videoSenders){
                // if not publishing, update the encodingConfigCache and don't modify the state.
                // we'll apply this config on the next publish/unmute.
                const { trackType: trackType, publishOptionId: publishOptionId } = videoSender;
                const bundle = this.transceiverCache.getBy(publishOptionId, trackType);
                if (bundle) this.transceiverCache.update(bundle.publishOption, {
                    videoSender: videoSender
                });
                if ($8c05ed6f2f331ee8$var$isFirefox() && !this.isPublishing(trackType)) continue;
                await this.changePublishQuality(videoSender, bundle);
            }
        });
        this.on('changePublishOptions', (event)=>{
            this.publishOptions = event.publishOptions;
            return this.syncPublishOptions();
        });
    }
    /**
     * Disposes this Publisher instance.
     */ async dispose() {
        await super.dispose();
        try {
            await this.stopAllTracks();
        } catch (err) {
            this.logger.warn('Failed to stop tracks during dispose', err);
        }
        this.clonedTracks.clear();
    }
}
/**
 * Adds unique values to an array.
 *
 * @param arr the array to add to.
 * @param values the values to add.
 */ const $8c05ed6f2f331ee8$var$pushToIfMissing = (arr, ...values)=>{
    for (const v of values)if (!arr.includes(v)) arr.push(v);
    return arr;
};
/**
 * Removes values from an array if they are present.
 *
 * @param arr the array to remove from.
 * @param values the values to remove.
 */ const $8c05ed6f2f331ee8$var$removeFromIfPresent = (arr, ...values)=>{
    for (const v of values){
        const index = arr.indexOf(v);
        if (index !== -1) arr.splice(index, 1);
    }
    return arr;
};
/**
 * A wrapper around the `RTCPeerConnection` that handles the incoming
 * media streams from the SFU.
 *
 * @internal
 */ class $8c05ed6f2f331ee8$var$Subscriber extends $8c05ed6f2f331ee8$var$BasePeerConnection {
    /**
     * Constructs a new `Subscriber` instance.
     */ constructor(opts){
        super($8c05ed6f2f331ee8$var$PeerType.SUBSCRIBER, opts);
        /**
         * Restarts the ICE connection and renegotiates with the SFU.
         */ this.restartIce = async ()=>{
            this.logger.debug('Restarting ICE connection');
            if (this.pc.signalingState === 'have-remote-offer') {
                this.logger.debug('ICE restart is already in progress');
                return;
            }
            if (this.pc.connectionState === 'new') {
                this.logger.debug(`ICE connection is not yet established, skipping restart.`);
                return;
            }
            const previousIsIceRestarting = this.isIceRestarting;
            this.isIceRestarting = true;
            try {
                const { response: response } = await this.sfuClient.iceRestart({
                    peerType: $8c05ed6f2f331ee8$var$PeerType.SUBSCRIBER
                });
                if (response.error) throw new $8c05ed6f2f331ee8$var$NegotiationError(response.error);
            } catch (e) {
                // restore the previous state, as our intent for restarting ICE failed
                this.isIceRestarting = previousIsIceRestarting;
                throw e;
            }
        };
        this.handleOnTrack = (e)=>{
            const { streams: streams, track: track } = e;
            const [primaryStream] = streams;
            // example: `e3f6aaf8-b03d-4911-be36-83f47d37a76a:TRACK_TYPE_VIDEO`
            const [trackId, rawTrackType] = primaryStream.id.split(':');
            const participantToUpdate = this.state.participants.find((p)=>p.trackLookupPrefix === trackId);
            this.logger.debug(`[onTrack]: Got remote ${rawTrackType} track for userId: ${participantToUpdate?.userId}`, track.id, track);
            const trackType = $8c05ed6f2f331ee8$var$toTrackType(rawTrackType);
            if (!trackType) return this.logger.error(`Unknown track type: ${rawTrackType}`);
            const trackDebugInfo = `${participantToUpdate?.userId} ${rawTrackType}:${trackId}`;
            track.addEventListener('mute', ()=>{
                this.logger.info(`[onTrack]: Track muted: ${trackDebugInfo}`);
                this.setRemoteTrackInterrupted(trackId, trackType, true);
            });
            track.addEventListener('unmute', ()=>{
                this.logger.info(`[onTrack]: Track unmuted: ${trackDebugInfo}`);
                this.setRemoteTrackInterrupted(trackId, trackType, false);
                this.onRemoteTrackUnmute?.(trackType, track.id);
            });
            track.addEventListener('ended', ()=>{
                this.logger.info(`[onTrack]: Track ended: ${trackDebugInfo}`);
                this.setRemoteTrackInterrupted(trackId, trackType, false);
                this.state.removeOrphanedTrack(primaryStream.id);
            });
            if (track.muted) this.setRemoteTrackInterrupted(trackId, trackType, true);
            this.trackIdToTrackType.set(track.id, trackType);
            if (!participantToUpdate) {
                this.logger.warn(`[onTrack]: Received track for unknown participant: ${trackId}`, e);
                this.state.registerOrphanedTrack({
                    id: primaryStream.id,
                    trackLookupPrefix: trackId,
                    track: primaryStream,
                    trackType: trackType
                });
                return;
            }
            const streamKindProp = $8c05ed6f2f331ee8$var$trackTypeToParticipantStreamKey(trackType);
            if (!streamKindProp) {
                this.logger.error(`Unknown track type: ${rawTrackType}`);
                return;
            }
            // get the previous stream to dispose it later
            // usually this happens during migration, when the stream is replaced
            // with a new one but the old one is still in the state
            const previousStream = participantToUpdate[streamKindProp];
            // replace the previous stream with the new one, prevents flickering
            this.state.updateParticipant(participantToUpdate.sessionId, {
                [streamKindProp]: primaryStream
            });
            // now, dispose the previous stream if it exists
            if (previousStream) {
                this.logger.info(`[onTrack]: Cleaning up previous remote ${track.kind} tracks for userId: ${participantToUpdate.userId}`);
                previousStream.getTracks().forEach((t)=>{
                    t.stop();
                    previousStream.removeTrack(t);
                });
            }
        };
        this.setRemoteTrackInterrupted = (trackId, trackType, interrupted)=>{
            if (trackType !== $8c05ed6f2f331ee8$var$TrackType.AUDIO) return;
            const target = this.state.participants.find((p)=>p.trackLookupPrefix === trackId);
            if (!target) return;
            this.state.updateParticipant(target.sessionId, (p)=>{
                const current = p.interruptedTracks ?? [];
                const has = current.includes(trackType);
                if (interrupted === has) return {};
                const next = interrupted ? $8c05ed6f2f331ee8$var$pushToIfMissing([
                    ...current
                ], trackType) : $8c05ed6f2f331ee8$var$removeFromIfPresent([
                    ...current
                ], trackType);
                return {
                    interruptedTracks: next
                };
            });
        };
        this.negotiate = async (subscriberOffer)=>{
            await this.pc.setRemoteDescription({
                type: 'offer',
                sdp: subscriberOffer.sdp
            });
            this.addTrickledIceCandidates();
            const answer = await this.pc.createAnswer();
            if (answer.sdp) {
                answer.sdp = $8c05ed6f2f331ee8$var$enableStereo(subscriberOffer.sdp, answer.sdp);
                const { dangerouslyForceCodec: dangerouslyForceCodec, subscriberFmtpLine: subscriberFmtpLine } = this.clientPublishOptions || {};
                if (dangerouslyForceCodec) answer.sdp = $8c05ed6f2f331ee8$var$removeCodecsExcept(answer.sdp, dangerouslyForceCodec, subscriberFmtpLine);
            }
            await this.pc.setLocalDescription(answer);
            await this.sfuClient.sendAnswer({
                peerType: $8c05ed6f2f331ee8$var$PeerType.SUBSCRIBER,
                sdp: answer.sdp || '',
                negotiationId: subscriberOffer.negotiationId
            });
            this.isIceRestarting = false;
        };
        this.pc.addEventListener('track', this.handleOnTrack);
        this.on('subscriberOffer', async (subscriberOffer)=>{
            return this.negotiate(subscriberOffer).catch((err)=>{
                this.logger.error(`Negotiation failed.`, err);
            });
        });
    }
    /**
     * Detaches the event handlers from the `RTCPeerConnection`.
     * This is useful when we want to replace the `RTCPeerConnection`
     * instance with a new one (in case of migration).
     */ detachEventHandlers() {
        super.detachEventHandlers();
        this.pc.removeEventListener('track', this.handleOnTrack);
    }
}
const $8c05ed6f2f331ee8$var$createWebSocketSignalChannel = (opts)=>{
    const { endpoint: endpoint, onMessage: onMessage, tag: tag, tracer: tracer } = opts;
    const logger = $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger('SfuClientWS', {
        tags: [
            tag
        ]
    });
    logger.debug('Creating signaling WS channel:', endpoint);
    const ws = new WebSocket(endpoint);
    ws.binaryType = 'arraybuffer'; // do we need this?
    ws.addEventListener('error', (e)=>{
        logger.error('Signaling WS channel error', e);
        tracer?.trace('signal.ws.error', e);
    });
    ws.addEventListener('close', (e)=>{
        logger.info('Signaling WS channel is closed', e);
        tracer?.trace('signal.ws.close', e);
    });
    ws.addEventListener('open', (e)=>{
        logger.info('Signaling WS channel is open', e);
        tracer?.trace('signal.ws.open', e);
    });
    ws.addEventListener('message', (e)=>{
        try {
            const message = e.data instanceof ArrayBuffer ? $8c05ed6f2f331ee8$var$SfuEvent.fromBinary(new Uint8Array(e.data)) : $8c05ed6f2f331ee8$var$SfuEvent.fromJsonString(e.data.toString());
            onMessage(message);
        } catch (err) {
            const message = 'Failed to decode a message. Check whether the Proto models match.';
            logger.error(message, {
                event: e,
                error: err
            });
            tracer?.trace('signal.ws.message.error', message);
        }
    });
    return ws;
};
const $8c05ed6f2f331ee8$var$toRtcConfiguration = (config)=>{
    return {
        bundlePolicy: 'max-bundle',
        iceServers: config.map((ice)=>({
                urls: ice.urls,
                username: ice.username,
                credential: ice.password
            }))
    };
};
/**
 * Saving a long-lived reference to a promise that can reject can be unsafe,
 * since rejecting the promise causes an unhandled rejection error (even if the
 * rejection is handled everywhere promise result is expected).
 *
 * To avoid that, we add both resolution and rejection handlers to the promise.
 * That way, the saved promise never rejects. A callback is provided as return
 * value to build a *new* promise, that resolves and rejects along with
 * the original promise.
 * @param promise Promise to wrap, which possibly rejects
 * @returns Callback to build a new promise, which resolves and rejects along
 * with the original promise
 */ function $8c05ed6f2f331ee8$var$makeSafePromise(promise) {
    let isPending = true;
    const safePromise = promise.then((result)=>({
            status: 'resolved',
            result: result
        }), (error)=>({
            status: 'rejected',
            error: error
        })).finally(()=>isPending = false);
    const unwrapPromise = ()=>safePromise.then((fulfillment)=>{
            if (fulfillment.status === 'rejected') throw fulfillment.error;
            return fulfillment.result;
        });
    unwrapPromise.checkPending = ()=>isPending;
    return unwrapPromise;
}
/**
 * Creates a new promise with resolvers.
 *
 * Based on:
 * - https://github.com/tc39/proposal-promise-with-resolvers/blob/main/polyfills.js
 */ const $8c05ed6f2f331ee8$var$promiseWithResolvers = ()=>{
    let resolve;
    let reject;
    const promise = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    let isResolved = false;
    let isRejected = false;
    const resolver = (value)=>{
        isResolved = true;
        resolve(value);
    };
    const rejecter = (reason)=>{
        isRejected = true;
        reject(reason);
    };
    return {
        promise: promise,
        resolve: resolver,
        reject: rejecter,
        isResolved: ()=>isResolved,
        isRejected: ()=>isRejected
    };
};
const $8c05ed6f2f331ee8$var$uninitialized = Symbol('uninitialized');
/**
 * Lazily creates a value using a provided factory
 */ function $8c05ed6f2f331ee8$var$lazy(factory) {
    let value = $8c05ed6f2f331ee8$var$uninitialized;
    return (...args)=>{
        if (value === $8c05ed6f2f331ee8$var$uninitialized) value = factory(...args);
        return value;
    };
}
let $8c05ed6f2f331ee8$var$timerWorkerEnabled = false;
const $8c05ed6f2f331ee8$var$enableTimerWorker = ()=>{
    $8c05ed6f2f331ee8$var$timerWorkerEnabled = true;
};
const $8c05ed6f2f331ee8$var$getTimers = $8c05ed6f2f331ee8$var$lazy(()=>{
    return new (0, $bb514e254ef7ecdd$exports.WorkerTimer)({
        useWorker: $8c05ed6f2f331ee8$var$timerWorkerEnabled
    });
});
class $8c05ed6f2f331ee8$export$7aa89efb7e5fd7cd extends Error {
    constructor(event){
        super(event.error?.message || 'Join Error');
        this.errorEvent = event;
        this.unrecoverable = event.reconnectStrategy === $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.DISCONNECT;
    }
    static isJoinErrorCode(event) {
        const code = event.error?.code;
        return code === $8c05ed6f2f331ee8$var$ErrorCode.SFU_FULL || code === $8c05ed6f2f331ee8$var$ErrorCode.SFU_SHUTTING_DOWN || code === $8c05ed6f2f331ee8$var$ErrorCode.CALL_PARTICIPANT_LIMIT_REACHED;
    }
}
/**
 * An error thrown when a client-side SFU deadline (e.g., waiting for the
 * signaling WS to open or for the `joinResponse` to arrive) fires before
 * the awaited operation resolves. Allows consumers (e.g., the client event
 * reporter) to classify timeouts without relying on message wording.
 */ class $8c05ed6f2f331ee8$export$31251169af4bd1eb extends Error {
}
/**
 * Creates a fresh `joinResponseTask` with a no-op rejection handler attached
 * to the underlying promise. The handler marks the rejection path as handled
 * so a teardown-time reject (e.g., from `close()` during disposal) does not
 * surface as an `UnhandledPromiseRejection`. Explicit awaiters of
 * `StreamSfuClient.joinTask` still observe the rejection through their own
 * `then`/`catch` chain. `.catch()` returns a new promise; the original is
 * unchanged.
 */ const $8c05ed6f2f331ee8$var$makeJoinResponseTask = ()=>{
    const task = $8c05ed6f2f331ee8$var$promiseWithResolvers();
    task.promise.catch(()=>{}); // see the comment above
    return task;
};
/**
 * The client used for exchanging information with the SFU.
 */ class $8c05ed6f2f331ee8$export$4ca676c4bfc66c17 {
    /**
     * Constructs a new SFU client.
     */ constructor({ dispatcher: dispatcher, credentials: credentials, sessionId: sessionId, cid: cid, tag: tag, joinResponseTimeout: joinResponseTimeout = 5000, rpcRequestTimeout: rpcRequestTimeout = 5000, onSignalClose: onSignalClose, streamClient: streamClient, enableTracing: enableTracing }){
        /**
         * A buffer for ICE Candidates that are received before
         * the Publisher and Subscriber Peer Connections are ready to handle them.
         */ this.iceTrickleBuffer = new $8c05ed6f2f331ee8$var$IceTrickleBuffer();
        /**
         * Flag to indicate if the client is in the process of leaving the call.
         * This is set to `true` when the user initiates the leave process.
         */ this.isLeaving = false;
        /**
         * Flag to indicate if the client is in the process of clean closing the connection.
         * When set to `true`, the client will not attempt to reconnect
         * and will close the WebSocket connection gracefully.
         * Otherwise, it will close the connection with an error code and
         * trigger a reconnection attempt.
         */ this.isClosingClean = false;
        this.pingIntervalInMs = 5000;
        this.unhealthyTimeoutInMs = 15000;
        this.subscriptionsConcurrencyTag = Symbol('subscriptionsConcurrencyTag');
        /**
         * Promise that resolves when the JoinResponse is received.
         * Rejects after a certain threshold if the response is not received,
         * or when the SFU client is disposed before a join completes.
         */ this.joinResponseTask = $8c05ed6f2f331ee8$var$makeJoinResponseTask();
        /**
         * A controller to abort the current requests.
         */ this.abortController = new AbortController();
        this.createWebSocket = (params)=>{
            const eventsToTrace = {
                callEnded: true,
                changePublishQuality: true,
                changePublishOptions: true,
                connectionQualityChanged: true,
                error: true,
                goAway: true,
                inboundStateNotification: true
            };
            this.signalWs = $8c05ed6f2f331ee8$var$createWebSocketSignalChannel({
                tag: this.tag,
                endpoint: `${this.credentials.server.ws_endpoint}?${new URLSearchParams(params).toString()}`,
                tracer: this.tracer,
                onMessage: (message)=>{
                    this.lastMessageTimestamp = new Date();
                    this.scheduleConnectionCheck();
                    const eventKind = message.eventPayload.oneofKind;
                    if (eventsToTrace[eventKind]) this.tracer?.trace(eventKind, message);
                    this.dispatcher.dispatch(message, this.tag);
                }
            });
            let timeoutId;
            this.signalReady = $8c05ed6f2f331ee8$var$makeSafePromise(Promise.race([
                new Promise((resolve, reject)=>{
                    let didOpen = false;
                    const onOpen = ()=>{
                        didOpen = true;
                        clearTimeout(timeoutId);
                        this.signalWs.removeEventListener('open', onOpen);
                        resolve(this.signalWs);
                    };
                    this.signalWs.addEventListener('open', onOpen);
                    this.signalWs.addEventListener('close', (e)=>{
                        this.handleWebSocketClose(e);
                        // Normally, this shouldn't have any effect, because WS should never emit 'close'
                        // before emitting 'open'. However, stranger things have happened, and we don't
                        // want to leave signalReady in a pending state.
                        const message = didOpen ? `SFU WS closed: ${e.code} ${e.reason}` : `SFU WS connection can't be established: ${e.code} ${e.reason}`;
                        this.tracer?.trace('signal.close', message);
                        clearTimeout(timeoutId);
                        reject(new Error(message));
                    });
                }),
                new Promise((resolve, reject)=>{
                    timeoutId = setTimeout(()=>{
                        const message = `SFU WS connection failed to open after ${this.joinResponseTimeout}ms`;
                        this.tracer?.trace('signal.timeout', message);
                        reject(new $8c05ed6f2f331ee8$export$31251169af4bd1eb(message));
                    }, this.joinResponseTimeout);
                })
            ]));
        };
        this.handleWebSocketClose = (e)=>{
            this.signalWs.removeEventListener('close', this.handleWebSocketClose);
            $8c05ed6f2f331ee8$var$getTimers().clearInterval(this.keepAliveInterval);
            clearTimeout(this.connectionCheckTimeout);
            this.onSignalClose?.(`${e.code} ${e.reason}`);
        };
        this.close = (code = $8c05ed6f2f331ee8$export$4ca676c4bfc66c17.NORMAL_CLOSURE, reason)=>{
            this.isClosingClean = code !== $8c05ed6f2f331ee8$export$4ca676c4bfc66c17.ERROR_CONNECTION_UNHEALTHY;
            // Close the WebSocket whether it has fully opened (`OPEN`) or is still
            // mid-handshake (`CONNECTING`). The WebSocket spec aborts the handshake
            // when `close()` is called on a CONNECTING socket. Without this, an
            // SFU socket that opens just after teardown would dispatch events into
            // a Call instance that has already moved on.
            const ws = this.signalWs;
            if (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING) {
                this.logger.debug(`Closing SFU WS connection: ${code} - ${reason}`);
                ws.close(code, `js-client: ${reason}`);
                ws.removeEventListener('close', this.handleWebSocketClose);
            }
            this.dispose(reason);
        };
        this.dispose = (reason)=>{
            this.logger.debug('Disposing SFU client');
            this.unsubscribeIceTrickle();
            this.unsubscribeNetworkChanged();
            clearInterval(this.keepAliveInterval);
            clearTimeout(this.connectionCheckTimeout);
            clearTimeout(this.migrateAwayTimeout);
            this.abortController.abort();
            this.migrationTask?.resolve();
            // Settle a pending `joinResponseTask` so `leaveAndClose`, `join()`, and
            // any other awaiters (`await this.joinTask`) don't hang indefinitely
            // when the SFU client is torn down before the SFU sent a JoinResponse.
            if (!this.joinResponseTask.isResolved() && !this.joinResponseTask.isRejected()) this.joinResponseTask.reject(new Error(`SFU client disposed before join completed${reason ? `: ${reason}` : ''}`));
            this.iceTrickleBuffer.dispose();
        };
        this.getTrace = ()=>{
            return this.tracer?.take();
        };
        this.leaveAndClose = async (reason)=>{
            try {
                this.isLeaving = true;
                // Best-effort: give an in-flight join a short grace period to complete
                // so we can send a graceful `leaveCallRequest`. Bounded so we never hang
                // here if the SFU is unresponsive. If the task settles either way during
                // the wait, the re-check below decides whether to notify.
                if (!this.joinResponseTask.isResolved() && !this.joinResponseTask.isRejected()) await Promise.race([
                    // swallow rejection — we re-check `isResolved()` below to decide
                    this.joinResponseTask.promise.catch(()=>{}),
                    $8c05ed6f2f331ee8$var$sleep($8c05ed6f2f331ee8$export$4ca676c4bfc66c17.LEAVE_NOTIFY_GRACE_MS)
                ]);
                if (this.joinResponseTask.isResolved()) await this.notifyLeave(reason);
                else this.logger.debug('[leaveAndClose] join not completed within grace period, skipping notifyLeave');
            } catch (err) {
                this.logger.debug('Error notifying SFU about leaving call', err);
            }
            this.close($8c05ed6f2f331ee8$export$4ca676c4bfc66c17.NORMAL_CLOSURE, reason.substring(0, 115));
        };
        this.updateSubscriptions = async (tracks)=>{
            return $8c05ed6f2f331ee8$var$withoutConcurrency(this.subscriptionsConcurrencyTag, async ()=>{
                await this.joinTask;
                return $8c05ed6f2f331ee8$var$retryable((invocationMeta)=>this.rpc.updateSubscriptions({
                        sessionId: this.sessionId,
                        tracks: tracks
                    }, {
                        invocationMeta: invocationMeta
                    }), this.abortController.signal);
            });
        };
        this.setPublisher = async (data)=>{
            await this.joinTask;
            return $8c05ed6f2f331ee8$var$retryable((invocationMeta)=>this.rpc.setPublisher({
                    ...data,
                    sessionId: this.sessionId
                }, {
                    invocationMeta: invocationMeta
                }), this.abortController.signal, 3);
        };
        this.sendAnswer = async (data)=>{
            await this.joinTask;
            return $8c05ed6f2f331ee8$var$retryable((invocationMeta)=>this.rpc.sendAnswer({
                    ...data,
                    sessionId: this.sessionId
                }, {
                    invocationMeta: invocationMeta
                }), this.abortController.signal);
        };
        this.iceTrickle = async (data)=>{
            await this.joinTask;
            return $8c05ed6f2f331ee8$var$retryable((invocationMeta)=>this.rpc.iceTrickle({
                    ...data,
                    sessionId: this.sessionId
                }, {
                    invocationMeta: invocationMeta
                }), this.abortController.signal);
        };
        this.iceRestart = async (data)=>{
            await this.joinTask;
            return $8c05ed6f2f331ee8$var$retryable((invocationMeta)=>this.rpc.iceRestart({
                    ...data,
                    sessionId: this.sessionId
                }, {
                    invocationMeta: invocationMeta
                }), this.abortController.signal);
        };
        this.updateMuteStates = async (muteStates)=>{
            await this.joinTask;
            return $8c05ed6f2f331ee8$var$retryable((invocationMeta)=>this.rpc.updateMuteStates({
                    muteStates: muteStates,
                    sessionId: this.sessionId
                }, {
                    invocationMeta: invocationMeta
                }), this.abortController.signal);
        };
        this.sendStats = async (stats)=>{
            await this.joinTask;
            // NOTE: we don't retry sending stats
            return this.rpc.sendStats({
                ...stats,
                sessionId: this.sessionId
            });
        };
        this.startNoiseCancellation = async ()=>{
            await this.joinTask;
            return $8c05ed6f2f331ee8$var$retryable((invocationMeta)=>this.rpc.startNoiseCancellation({
                    sessionId: this.sessionId
                }, {
                    invocationMeta: invocationMeta
                }), this.abortController.signal);
        };
        this.stopNoiseCancellation = async ()=>{
            await this.joinTask;
            return $8c05ed6f2f331ee8$var$retryable((invocationMeta)=>this.rpc.stopNoiseCancellation({
                    sessionId: this.sessionId
                }, {
                    invocationMeta: invocationMeta
                }), this.abortController.signal);
        };
        this.enterMigration = async (opts = {})=>{
            this.isLeaving = true;
            const { timeout: timeout = 7000 } = opts;
            this.migrationTask?.reject(new Error('Cancelled previous migration'));
            const task = this.migrationTask = $8c05ed6f2f331ee8$var$promiseWithResolvers();
            const unsubscribe = this.dispatcher.on('participantMigrationComplete', this.tag, ()=>{
                unsubscribe();
                clearTimeout(this.migrateAwayTimeout);
                task.resolve();
            });
            this.migrateAwayTimeout = setTimeout(()=>{
                unsubscribe();
                task.reject(new Error(`Migration (${this.tag}) failed to complete in ${timeout}ms`));
            }, timeout);
            return task.promise;
        };
        this.join = async (data)=>{
            // wait for the signal web socket to be ready before sending "joinRequest"
            await this.signalReady();
            if (this.joinResponseTask.isResolved() || this.joinResponseTask.isRejected()) // we need to lock the RPC requests until we receive a JoinResponse.
            // that's why we have this primitive lock mechanism.
            // the client starts with an already initialized joinResponseTask,
            // and this code creates a new one for the next join request.
            this.joinResponseTask = $8c05ed6f2f331ee8$var$makeJoinResponseTask();
            // capture a reference to the current joinResponseTask as it might
            // be replaced with a new one in case a second join request is made
            const current = this.joinResponseTask;
            let timeoutId = undefined;
            let unsubscribeJoinResponse = undefined;
            let unsubscribeJoinErrorEvents = undefined;
            const cleanupJoinSubscriptions = ()=>{
                clearTimeout(timeoutId);
                timeoutId = undefined;
                unsubscribeJoinErrorEvents?.();
                unsubscribeJoinErrorEvents = undefined;
                unsubscribeJoinResponse?.();
                unsubscribeJoinResponse = undefined;
            };
            unsubscribeJoinErrorEvents = this.dispatcher.on('error', this.tag, (event)=>{
                if ($8c05ed6f2f331ee8$export$7aa89efb7e5fd7cd.isJoinErrorCode(event)) {
                    cleanupJoinSubscriptions();
                    current.reject(new $8c05ed6f2f331ee8$export$7aa89efb7e5fd7cd(event));
                }
            });
            unsubscribeJoinResponse = this.dispatcher.on('joinResponse', this.tag, (joinResponse)=>{
                cleanupJoinSubscriptions();
                this.keepAlive();
                current.resolve(joinResponse);
            });
            timeoutId = setTimeout(()=>{
                cleanupJoinSubscriptions();
                const message = `Waiting for "joinResponse" has timed out after ${this.joinResponseTimeout}ms`;
                this.tracer?.trace('joinRequestTimeout', message);
                current.reject(new $8c05ed6f2f331ee8$export$31251169af4bd1eb(message));
            }, this.joinResponseTimeout);
            const joinRequest = $8c05ed6f2f331ee8$var$SfuRequest.create({
                requestPayload: {
                    oneofKind: 'joinRequest',
                    joinRequest: $8c05ed6f2f331ee8$var$JoinRequest.create({
                        ...data,
                        sessionId: this.sessionId,
                        token: this.credentials.token
                    })
                }
            });
            this.tracer?.trace('joinRequest', joinRequest);
            await this.send(joinRequest);
            return current.promise;
        };
        this.ping = async ()=>{
            return this.send($8c05ed6f2f331ee8$var$SfuRequest.create({
                requestPayload: {
                    oneofKind: 'healthCheckRequest',
                    healthCheckRequest: {}
                }
            }));
        };
        this.notifyLeave = async (reason)=>{
            return this.send($8c05ed6f2f331ee8$var$SfuRequest.create({
                requestPayload: {
                    oneofKind: 'leaveCallRequest',
                    leaveCallRequest: {
                        sessionId: this.sessionId,
                        reason: reason
                    }
                }
            }));
        };
        this.send = async (message)=>{
            await this.signalReady(); // wait for the signal ws to be open
            const msgJson = $8c05ed6f2f331ee8$var$SfuRequest.toJson(message);
            if (this.signalWs.readyState !== WebSocket.OPEN) {
                this.logger.debug('Signal WS is not open. Skipping message', msgJson);
                return;
            }
            this.logger.debug(`Sending message to: ${this.edgeName}`, msgJson);
            this.signalWs.send($8c05ed6f2f331ee8$var$SfuRequest.toBinary(message));
        };
        this.keepAlive = ()=>{
            const timers = $8c05ed6f2f331ee8$var$getTimers();
            timers.clearInterval(this.keepAliveInterval);
            this.keepAliveInterval = timers.setInterval(()=>{
                this.ping().catch((e)=>{
                    this.logger.error('Error sending healthCheckRequest to SFU', e);
                });
            }, this.pingIntervalInMs);
        };
        this.scheduleConnectionCheck = ()=>{
            clearTimeout(this.connectionCheckTimeout);
            this.connectionCheckTimeout = setTimeout(()=>{
                if (this.lastMessageTimestamp) {
                    const timeSinceLastMessage = new Date().getTime() - this.lastMessageTimestamp.getTime();
                    if (timeSinceLastMessage > this.unhealthyTimeoutInMs) this.close($8c05ed6f2f331ee8$export$4ca676c4bfc66c17.ERROR_CONNECTION_UNHEALTHY, `SFU connection unhealthy. Didn't receive any message for ${this.unhealthyTimeoutInMs}ms`);
                }
            }, this.unhealthyTimeoutInMs);
        };
        this.dispatcher = dispatcher;
        this.sessionId = sessionId || $8c05ed6f2f331ee8$var$generateUUIDv4();
        this.onSignalClose = onSignalClose;
        this.credentials = credentials;
        const { server: server, token: token } = credentials;
        this.edgeName = server.edge_name;
        this.joinResponseTimeout = joinResponseTimeout;
        this.tag = tag;
        this.logger = $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger('SfuClient', {
            tags: [
                tag
            ]
        });
        this.tracer = enableTracing ? new $8c05ed6f2f331ee8$var$Tracer(`${tag}-${this.edgeName}`) : undefined;
        this.rpc = $8c05ed6f2f331ee8$var$createSignalClient({
            baseUrl: server.url,
            interceptors: [
                $8c05ed6f2f331ee8$var$withHeaders({
                    Authorization: `Bearer ${token}`
                }),
                this.tracer && $8c05ed6f2f331ee8$var$withRequestTracer(this.tracer.trace),
                this.logger.getLogLevel() === 'trace' && $8c05ed6f2f331ee8$var$withRequestLogger(this.logger),
                $8c05ed6f2f331ee8$var$withTimeout(rpcRequestTimeout, this.tracer?.trace)
            ].filter((v)=>!!v)
        });
        // Special handling for the ICETrickle kind of events.
        // The SFU might trigger these events before the initial RTC
        // connection is established or "JoinResponse" received.
        // In that case, those events (ICE candidates) need to be buffered
        // and later added to the appropriate PeerConnection
        // once the remoteDescription is known and set.
        this.unsubscribeIceTrickle = dispatcher.on('iceTrickle', tag, (t)=>{
            this.iceTrickleBuffer.push(t);
        });
        // listen to network changes to handle offline state
        // we shouldn't attempt to recover websocket connection when offline
        this.unsubscribeNetworkChanged = streamClient.on('network.changed', (e)=>{
            if (!e.online) this.networkAvailableTask = $8c05ed6f2f331ee8$var$promiseWithResolvers();
            else this.networkAvailableTask?.resolve();
        });
        this.createWebSocket({
            attempt: tag,
            user_id: streamClient.user?.id || '',
            api_key: streamClient.key,
            user_session_id: this.sessionId,
            cid: cid
        });
    }
    get isHealthy() {
        return this.signalWs.readyState === WebSocket.OPEN && this.joinResponseTask.isResolved();
    }
    get joinTask() {
        return this.joinResponseTask.promise;
    }
}
/**
 * The normal closure code. Used for controlled shutdowns.
 */ $8c05ed6f2f331ee8$export$4ca676c4bfc66c17.NORMAL_CLOSURE = 1000;
/**
 * The error code used when the SFU connection is unhealthy.
 * Usually, this means that no message has been received from the SFU for
 * a certain amount of time (`connectionCheckTimeout`).
 */ $8c05ed6f2f331ee8$export$4ca676c4bfc66c17.ERROR_CONNECTION_UNHEALTHY = 4001;
/**
 * The error code used when the SFU connection is disposed because a new
 * connection is established or is about to be established.
 * Here, we don't use 1000 (normal closure) because we don't want the
 * SFU to clean up the resources associated with the current participant.
 */ $8c05ed6f2f331ee8$export$4ca676c4bfc66c17.DISPOSE_OLD_SOCKET = 4100;
/**
 * The close code used when the client fails to join the call (on the SFU).
 */ $8c05ed6f2f331ee8$export$4ca676c4bfc66c17.JOIN_FAILED = 4101;
/**
 * Best-effort grace period in `leaveAndClose` for an in-flight join to
 * complete before we give up and close without sending `leaveCallRequest`.
 * Bounded so a stuck join can never hang the leave path.
 */ $8c05ed6f2f331ee8$export$4ca676c4bfc66c17.LEAVE_NOTIFY_GRACE_MS = 1000;
/**
 * Event handler that watched the delivery of `call.accepted`.
 * Once the event is received, the call is joined.
 */ const $8c05ed6f2f331ee8$var$watchCallAccepted = (call)=>{
    return async function onCallAccepted(event) {
        // We want to discard the event if it's from the current user
        if (event.user.id === call.currentUserId) return;
        const { state: state } = call;
        if (event.call.created_by.id === call.currentUserId && state.callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.RINGING) await call.join();
    };
};
/**
 * Event handler that watches delivery of `call.rejected` Websocket event.
 * Once the event is received, the call is left.
 */ const $8c05ed6f2f331ee8$var$watchCallRejected = (call)=>{
    return async function onCallRejected(event) {
        // We want to discard the event if it's from the current user
        if (event.user.id === call.currentUserId) return;
        const { call: eventCall } = event;
        const { session: callSession } = eventCall;
        if (!callSession) {
            call.logger.warn('No call session provided. Ignoring call.rejected event.', event);
            return;
        }
        const rejectedBy = callSession.rejected_by;
        const { members: members, callingState: callingState } = call.state;
        if (callingState !== $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.RINGING) {
            call.logger.info('Call is not in ringing mode (it is either accepted or rejected already). Ignoring call.rejected event.', event);
            return;
        }
        if (call.isCreatedByMe) {
            const everyoneElseRejected = members.filter((m)=>m.user_id !== call.currentUserId).every((m)=>rejectedBy[m.user_id]);
            if (everyoneElseRejected) {
                call.logger.info('everyone rejected, leaving the call');
                await call.leave({
                    reject: true,
                    reason: 'cancel',
                    message: 'ring: everyone rejected'
                });
            }
        } else if (rejectedBy[eventCall.created_by.id]) {
            call.logger.info('call creator rejected, leaving call');
            globalThis.streamRNVideoSDK?.callingX?.endCall(call, 'remote');
            await call.leave({
                message: 'ring: creator rejected'
            });
        }
    };
};
/**
 * Event handler that watches the delivery of `call.ended` Websocket event.
 */ const $8c05ed6f2f331ee8$var$watchCallEnded = (call)=>{
    return function onCallEnded() {
        globalThis.streamRNVideoSDK?.callingX?.endCall(call, 'remote');
        const { callingState: callingState } = call.state;
        if (callingState !== $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.IDLE && callingState !== $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.LEFT) {
            call.clientEventReporter.abort(call.cid, {
                code: 'BACKEND_LEAVE',
                reason: 'call.ended event received'
            });
            call.leave({
                message: 'call.ended event received',
                reject: false
            }).catch((err)=>{
                call.logger.error('Failed to leave call after call.ended ', err);
            });
        }
    };
};
/**
 * Watches for `callEnded` events.
 */ const $8c05ed6f2f331ee8$var$watchSfuCallEnded = (call)=>{
    return call.on('callEnded', async (e)=>{
        if (call.state.callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.LEFT) return;
        try {
            if (e.reason === $8c05ed6f2f331ee8$var$CallEndedReason.LIVE_ENDED) {
                call.state.setBackstage(true);
                // don't leave the call if the user has permission to join backstage
                const { hasPermission: hasPermission } = call.permissionsContext;
                if (hasPermission($8c05ed6f2f331ee8$export$9d72b1bd9eedd7a7.JOIN_BACKSTAGE)) return;
            }
            // `call.ended` event arrived after the call is already left
            // and all event handlers are detached. We need to manually
            // update the call state to reflect the call has ended.
            call.state.setEndedAt(new Date());
            const reason = $8c05ed6f2f331ee8$var$CallEndedReason[e.reason];
            globalThis.streamRNVideoSDK?.callingX?.endCall(call, 'remote');
            call.clientEventReporter.abort(call.cid, {
                code: 'BACKEND_LEAVE',
                reason: `callEnded received: ${reason}`
            });
            await call.leave({
                message: `callEnded received: ${reason}`
            });
        } catch (err) {
            call.logger.error('Failed to leave call after being ended by the SFU', err);
        }
    });
};
/**
 * Event handler that watches for `callGrantsUpdated` events.
 *
 * @param state the call state to update.
 */ const $8c05ed6f2f331ee8$var$watchCallGrantsUpdated = (state)=>{
    return function onCallGrantsUpdated(event) {
        const { currentGrants: currentGrants } = event;
        if (!currentGrants) return;
        state.setCallGrants(currentGrants);
    };
};
const $8c05ed6f2f331ee8$var$watchConnectionQualityChanged = (dispatcher, state)=>{
    return dispatcher.on('connectionQualityChanged', '*', (e)=>{
        const { connectionQualityUpdates: connectionQualityUpdates } = e;
        if (!connectionQualityUpdates) return;
        state.updateParticipants(connectionQualityUpdates.reduce((patches, update)=>{
            const { sessionId: sessionId, connectionQuality: connectionQuality } = update;
            patches[sessionId] = {
                connectionQuality: connectionQuality
            };
            return patches;
        }, {}));
    });
};
/**
 * Updates the approximate number of participants in the call by peeking at the
 * health check events that our SFU sends.
 */ const $8c05ed6f2f331ee8$var$watchParticipantCountChanged = (dispatcher, state)=>{
    return dispatcher.on('healthCheckResponse', '*', (e)=>{
        const { participantCount: participantCount } = e;
        if (participantCount) {
            state.setParticipantCount(participantCount.total);
            state.setAnonymousParticipantCount(participantCount.anonymous);
        }
    });
};
const $8c05ed6f2f331ee8$var$watchLiveEnded = (dispatcher, call)=>{
    return dispatcher.on('error', '*', (e)=>{
        if (e.error && e.error.code !== $8c05ed6f2f331ee8$var$ErrorCode.LIVE_ENDED) return;
        call.state.setBackstage(true);
        if (!call.permissionsContext.hasPermission($8c05ed6f2f331ee8$export$9d72b1bd9eedd7a7.JOIN_BACKSTAGE)) call.leave({
            message: 'live ended'
        }).catch((err)=>{
            call.logger.error('Failed to leave call after live ended', err);
        });
    });
};
/**
 * Watches and logs the errors reported by the currently connected SFU.
 */ const $8c05ed6f2f331ee8$var$watchSfuErrorReports = (dispatcher)=>{
    return dispatcher.on('error', '*', (e)=>{
        if (!e.error) return;
        const logger = $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger('SfuClient');
        const { error: error, reconnectStrategy: reconnectStrategy } = e;
        logger.error('SFU reported error', {
            code: $8c05ed6f2f331ee8$var$ErrorCode[error.code],
            reconnectStrategy: $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy[reconnectStrategy],
            message: error.message,
            shouldRetry: error.shouldRetry
        });
    });
};
/**
 * Watches for `pinsUpdated` events and updates the pinned state of participants
 * in the call.
 */ const $8c05ed6f2f331ee8$var$watchPinsUpdated = (state)=>{
    return function onPinsUpdated(e) {
        const { pins: pins } = e;
        state.setServerSidePins(pins);
    };
};
/**
 * Watches for inbound state notifications and updates the paused tracks
 *
 * @param state the call state to update.
 */ const $8c05ed6f2f331ee8$var$watchInboundStateNotification = (state)=>{
    return function onInboundStateNotification(e) {
        const { inboundVideoStates: inboundVideoStates } = e;
        const current = state.getParticipantLookupBySessionId();
        const patches = {};
        for (const { sessionId: sessionId, trackType: trackType, paused: paused } of inboundVideoStates){
            const pausedTracks = [
                ...current[sessionId]?.pausedTracks ?? []
            ];
            if (paused) $8c05ed6f2f331ee8$var$pushToIfMissing(pausedTracks, trackType);
            else $8c05ed6f2f331ee8$var$removeFromIfPresent(pausedTracks, trackType);
            patches[sessionId] = {
                pausedTracks: pausedTracks
            };
        }
        state.updateParticipants(patches);
    };
};
/**
 * An event handler that handles soft mutes.
 *
 * @param call the call.
 */ const $8c05ed6f2f331ee8$var$handleRemoteSoftMute = (call)=>{
    return call.on('trackUnpublished', async (event)=>{
        const { cause: cause, type: type, sessionId: sessionId } = event;
        const { localParticipant: localParticipant } = call.state;
        if (cause === $8c05ed6f2f331ee8$var$TrackUnpublishReason.MODERATION && sessionId === localParticipant?.sessionId) {
            const logger = call.logger;
            logger.info(`Local participant's ${$8c05ed6f2f331ee8$var$TrackType[type]} track is muted remotely`);
            try {
                if (type === $8c05ed6f2f331ee8$var$TrackType.VIDEO) await call.camera.disable();
                else if (type === $8c05ed6f2f331ee8$var$TrackType.AUDIO) await call.microphone.disable();
                else if (type === $8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE || type === $8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE_AUDIO) await call.screenShare.disable();
                else logger.warn('Unsupported track type to soft mute', $8c05ed6f2f331ee8$var$TrackType[type]);
            } catch (error) {
                logger.error('Failed to stop publishing', error);
            }
        }
    });
};
/**
 * An event responder which handles the `participantJoined` event.
 */ const $8c05ed6f2f331ee8$var$watchParticipantJoined = (state)=>{
    return function onParticipantJoined(e) {
        const { participant: participant } = e;
        if (!participant) return;
        // `state.updateOrAddParticipant` acts as a safeguard against
        // potential duplicate events from the SFU.
        //
        // Although the SFU should not send duplicate events, we have seen
        // some race conditions in the past during the `join-flow`.
        // The SFU would send participant info as part of the `join`
        // response and then follow up with a `participantJoined` event for
        // already announced participants.
        const orphanedTracks = $8c05ed6f2f331ee8$var$reconcileOrphanedTracks(state, participant);
        state.updateOrAddParticipant(participant.sessionId, Object.assign(participant, orphanedTracks, {
            ...e.isPinned && {
                pin: {
                    isLocalPin: false,
                    pinnedAt: Date.now()
                }
            },
            viewportVisibilityState: {
                videoTrack: $8c05ed6f2f331ee8$export$1655277b7107d364.UNKNOWN,
                screenShareTrack: $8c05ed6f2f331ee8$export$1655277b7107d364.UNKNOWN
            }
        }));
    };
};
/**
 * An event responder which handles the `participantLeft` event.
 */ const $8c05ed6f2f331ee8$var$watchParticipantLeft = (state)=>{
    return function onParticipantLeft(e) {
        const { participant: participant } = e;
        if (!participant) return;
        state.setParticipants((participants)=>participants.filter((p)=>p.sessionId !== participant.sessionId));
    };
};
/**
 * An event responder which handles the `participantUpdated` event.
 */ const $8c05ed6f2f331ee8$var$watchParticipantUpdated = (state)=>{
    return function onParticipantUpdated(e) {
        const { participant: participant } = e;
        if (!participant) return;
        state.updateParticipant(participant.sessionId, participant);
    };
};
/**
 * An event responder which handles the `trackPublished` event.
 * The SFU will send this event when a participant publishes a track.
 */ const $8c05ed6f2f331ee8$var$watchTrackPublished = (state)=>{
    return function onTrackPublished(e) {
        const { type: type, sessionId: sessionId } = e;
        // An optimization for large calls.
        // After a certain threshold, the SFU would stop emitting `participantJoined`
        // events, and instead, it would only provide the participant's information
        // once they start publishing a track.
        if (e.participant) {
            const orphanedTracks = $8c05ed6f2f331ee8$var$reconcileOrphanedTracks(state, e.participant);
            const participant = Object.assign(e.participant, orphanedTracks);
            state.updateOrAddParticipant(sessionId, participant);
        } else state.updateParticipant(sessionId, (p)=>({
                publishedTracks: $8c05ed6f2f331ee8$var$pushToIfMissing([
                    ...p.publishedTracks
                ], type)
            }));
    };
};
/**
 * An event responder which handles the `trackUnpublished` event.
 * The SFU will send this event when a participant unpublishes a track.
 */ const $8c05ed6f2f331ee8$var$watchTrackUnpublished = (state)=>{
    return function onTrackUnpublished(e) {
        const { type: type, sessionId: sessionId } = e;
        // An optimization for large calls. See `watchTrackPublished`.
        if (e.participant) {
            const orphanedTracks = $8c05ed6f2f331ee8$var$reconcileOrphanedTracks(state, e.participant);
            const participant = Object.assign(e.participant, orphanedTracks);
            state.updateOrAddParticipant(sessionId, participant, (p)=>({
                    pausedTracks: p.pausedTracks?.filter((t)=>t !== type)
                }));
        } else state.updateParticipant(sessionId, (p)=>({
                publishedTracks: p.publishedTracks.filter((t)=>t !== type),
                pausedTracks: p.pausedTracks?.filter((t)=>t !== type)
            }));
    };
};
/**
 * Reconciles orphaned tracks (if any) for the given participant.
 *
 * @param state the call state.
 * @param participant the participant.
 */ const $8c05ed6f2f331ee8$var$reconcileOrphanedTracks = (state, participant)=>{
    const orphanTracks = state.takeOrphanedTracks(participant.trackLookupPrefix);
    if (!orphanTracks.length) return;
    const reconciledTracks = {};
    for (const orphan of orphanTracks){
        const key = $8c05ed6f2f331ee8$var$trackTypeToParticipantStreamKey(orphan.trackType);
        if (!key) continue;
        reconciledTracks[key] = orphan.track;
    }
    return reconciledTracks;
};
/**
 * Watches for `dominantSpeakerChanged` events.
 */ const $8c05ed6f2f331ee8$var$watchDominantSpeakerChanged = (dispatcher, state)=>{
    return dispatcher.on('dominantSpeakerChanged', '*', (e)=>{
        const { sessionId: sessionId } = e;
        if (sessionId === state.dominantSpeaker?.sessionId) return;
        state.setParticipants((participants)=>participants.map((participant)=>{
                // mark the new dominant speaker
                if (participant.sessionId === sessionId) return {
                    ...participant,
                    isDominantSpeaker: true
                };
                // unmark the old dominant speaker
                if (participant.isDominantSpeaker) return {
                    ...participant,
                    isDominantSpeaker: false
                };
                return participant; // no change
            }));
    });
};
/**
 * Watches for `audioLevelChanged` events.
 */ const $8c05ed6f2f331ee8$var$watchAudioLevelChanged = (dispatcher, state)=>{
    return dispatcher.on('audioLevelChanged', '*', (e)=>{
        const { audioLevels: audioLevels } = e;
        state.updateParticipants(audioLevels.reduce((patches, current)=>{
            patches[current.sessionId] = {
                audioLevel: current.level,
                isSpeaking: current.isSpeaking
            };
            return patches;
        }, {}));
    });
};
/**
 * Registers the default event handlers for a call during its lifecycle.
 *
 * @param call the call to register event handlers for.
 * @param dispatcher the dispatcher.
 */ const $8c05ed6f2f331ee8$var$registerEventHandlers = (call, dispatcher)=>{
    const state = call.state;
    const eventHandlers = [
        call.on('call.ended', $8c05ed6f2f331ee8$var$watchCallEnded(call)),
        $8c05ed6f2f331ee8$var$watchSfuCallEnded(call),
        $8c05ed6f2f331ee8$var$watchLiveEnded(dispatcher, call),
        $8c05ed6f2f331ee8$var$watchSfuErrorReports(dispatcher),
        $8c05ed6f2f331ee8$var$watchConnectionQualityChanged(dispatcher, state),
        $8c05ed6f2f331ee8$var$watchParticipantCountChanged(dispatcher, state),
        call.on('participantJoined', $8c05ed6f2f331ee8$var$watchParticipantJoined(state)),
        call.on('participantLeft', $8c05ed6f2f331ee8$var$watchParticipantLeft(state)),
        call.on('participantUpdated', $8c05ed6f2f331ee8$var$watchParticipantUpdated(state)),
        call.on('trackPublished', $8c05ed6f2f331ee8$var$watchTrackPublished(state)),
        call.on('trackUnpublished', $8c05ed6f2f331ee8$var$watchTrackUnpublished(state)),
        $8c05ed6f2f331ee8$var$watchAudioLevelChanged(dispatcher, state),
        $8c05ed6f2f331ee8$var$watchDominantSpeakerChanged(dispatcher, state),
        call.on('callGrantsUpdated', $8c05ed6f2f331ee8$var$watchCallGrantsUpdated(state)),
        call.on('pinsUpdated', $8c05ed6f2f331ee8$var$watchPinsUpdated(state)),
        call.on('inboundStateNotification', $8c05ed6f2f331ee8$var$watchInboundStateNotification(state)),
        $8c05ed6f2f331ee8$var$handleRemoteSoftMute(call)
    ];
    return ()=>{
        eventHandlers.forEach((unsubscribe)=>unsubscribe());
    };
};
/**
 * Registers event handlers for a call that is of ringing type.
 *
 * @param call the call to register event handlers for.
 */ const $8c05ed6f2f331ee8$var$registerRingingCallEventHandlers = (call)=>{
    const coordinatorRingEvents = {
        'call.accepted': $8c05ed6f2f331ee8$var$watchCallAccepted(call),
        'call.rejected': $8c05ed6f2f331ee8$var$watchCallRejected(call)
    };
    const eventHandlers = Object.keys(coordinatorRingEvents).map((event)=>{
        const eventName = event;
        return call.on(eventName, coordinatorRingEvents[eventName]);
    });
    return ()=>{
        eventHandlers.forEach((unsubscribe)=>unsubscribe());
    };
};
const $8c05ed6f2f331ee8$var$toBindingKey = (sessionId, trackType = 'audioTrack')=>`${sessionId}/${trackType}`;
/**
 * Tracks audio element bindings and periodically warns about
 * remote participants whose audio streams have no bound element.
 */ class $8c05ed6f2f331ee8$var$AudioBindingsWatchdog {
    constructor(state, tracer){
        this.bindings = new Map();
        this.enabled = true;
        this.logger = $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger('AudioBindingsWatchdog');
        /**
         * Registers an audio element binding for the given session and track type.
         * Warns if a different element is already bound to the same key.
         */ this.register = (element, sessionId, trackType)=>{
            const key = $8c05ed6f2f331ee8$var$toBindingKey(sessionId, trackType);
            const existing = this.bindings.get(key);
            if (existing && existing !== element) {
                this.logger.warn(`Audio element already bound to ${sessionId} and ${trackType}`);
                this.tracer.trace('audioBinding.alreadyBoundWarning', trackType);
            }
            this.bindings.set(key, element);
        };
        /**
         * Removes the audio element binding for the given session and track type.
         */ this.unregister = (sessionId, trackType)=>{
            this.bindings.delete($8c05ed6f2f331ee8$var$toBindingKey(sessionId, trackType));
        };
        /**
         * Enables or disables the watchdog.
         * When disabled, the periodic check stops but bindings are still tracked.
         */ this.setEnabled = (enabled)=>{
            this.enabled = enabled;
            if (enabled) this.start();
            else this.stop();
        };
        /**
         * Stops the watchdog and unsubscribes from callingState changes.
         */ this.dispose = ()=>{
            this.stop();
            this.bindings.clear();
            this.unsubscribeCallingState();
        };
        this.start = ()=>{
            clearInterval(this.watchdogInterval);
            this.watchdogInterval = setInterval(()=>{
                const danglingUserIds = [];
                for (const p of this.state.participants){
                    if (p.isLocalParticipant) continue;
                    const { audioStream: audioStream, screenShareAudioStream: screenShareAudioStream, sessionId: sessionId, userId: userId, publishedTracks: publishedTracks } = p;
                    if (audioStream && publishedTracks.includes($8c05ed6f2f331ee8$var$TrackType.AUDIO) && !this.bindings.has($8c05ed6f2f331ee8$var$toBindingKey(sessionId))) danglingUserIds.push(userId);
                    if (screenShareAudioStream && publishedTracks.includes($8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE_AUDIO) && !this.bindings.has($8c05ed6f2f331ee8$var$toBindingKey(sessionId, 'screenShareAudioTrack'))) danglingUserIds.push(userId);
                }
                if (danglingUserIds.length > 0) {
                    const key = 'audioBinding.danglingWarning';
                    this.tracer.traceOnce(key, key, danglingUserIds);
                    this.logger.warn(`Dangling audio bindings detected. Did you forget to bind the audio element? user_ids: ${danglingUserIds}.`);
                }
            }, 3000);
        };
        this.stop = ()=>{
            clearInterval(this.watchdogInterval);
        };
        this.tracer = tracer;
        this.state = state;
        this.unsubscribeCallingState = $8c05ed6f2f331ee8$var$createSubscription(state.callingState$, (callingState)=>{
            if (!this.enabled) return;
            if (callingState !== $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.JOINED) this.stop();
            else this.start();
        });
    }
}
/**
 * Tracks audio elements that the browser's autoplay policy has blocked.
 */ class $8c05ed6f2f331ee8$var$BlockedAudioTracker {
    constructor(tracer){
        this.logger = $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger('BlockedAudioTracker');
        this.blockedElementsSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(new Set());
        /**
         * Whether the browser's autoplay policy is blocking audio playback.
         * Will be `true` when at least one audio element is currently blocked.
         * Use {@link resumeAudio} within a user gesture to unblock.
         */ this.autoplayBlocked$ = this.blockedElementsSubject.pipe((0, $9853a79d111e4e33$export$871de8747c9eaa88)((elements)=>elements.size > 0), (0, $6fb8b1c12553edae$export$779c5fb865a0172e)());
        /**
         * Registers an audio element as blocked by the browser's autoplay policy.
         */ this.markBlocked = (audioElement, blocked)=>{
            $8c05ed6f2f331ee8$var$setCurrentValue(this.blockedElementsSubject, (elements)=>{
                if (blocked) elements.add(audioElement);
                else elements.delete(audioElement);
                return elements;
            });
        };
        /**
         * Returns whether the given audio element is currently flagged as blocked
         * by the browser's autoplay policy.
         */ this.isBlocked = (audioElement)=>{
            return this.blockedElementsSubject.getValue().has(audioElement);
        };
        /**
         * Plays all audio elements blocked by the browser's autoplay policy.
         * Must be called from within a user gesture (e.g., click handler).
         */ this.resumeAudio = async ()=>{
            this.tracer.trace('resumeAudio', null);
            await $8c05ed6f2f331ee8$var$setCurrentValueAsync(this.blockedElementsSubject, async (elements)=>{
                await Promise.all(Array.from(elements, async (element)=>{
                    try {
                        if (element.srcObject) await $8c05ed6f2f331ee8$var$timeboxed([
                            element.play()
                        ], 2000);
                        elements.delete(element);
                    } catch (err) {
                        this.logger.warn(`Can't resume audio for element`, element, err);
                    }
                }));
                return elements;
            });
        };
        this.tracer = tracer;
    }
}
/** Symbol key for the "applies to all participants" override slot. */ const $8c05ed6f2f331ee8$var$globalOverrideKey = Symbol('globalOverrideKey');
/**
 * Owns the SFU-side video-subscription machinery for a `Call`:
 *
 * - Holds the per-session / global override state in a
 *   `BehaviorSubject<VideoTrackSubscriptionOverrides>`.
 * - Derives the SFU subscription list from `CallState` participants +
 *   current overrides via the `subscriptions` getter.
 * - Debounces and pushes the list to the SFU through
 *   `sfuClient.updateSubscriptions`.
 * - Exposes `incomingVideoSettings$`: a consumer-friendly projection of
 *   the override state for React hooks.
 *
 * Owned by `DynascaleManager` as `readonly trackSubscriptionManager`.
 * `DynascaleManager.bindVideoElement` triggers `apply()` on every
 * dimension / visibility change.
 */ class $8c05ed6f2f331ee8$var$TrackSubscriptionManager {
    /**
     * Constructs new TrackSubscriptionManager instance.
     *
     * @param callState the call state.
     * @param tracer the tracer to use.
     */ constructor(callState, tracer){
        this.logger = $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger('TrackSubscriptionManager');
        this.pendingUpdate = null;
        this.overridesSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)({});
        this.overrides$ = this.overridesSubject.asObservable();
        /**
         * Consumer-friendly projection of the override state. Used by the
         * `useIncomingVideoSettings()` React hook.
         */ this.incomingVideoSettings$ = this.overrides$.pipe((0, $9853a79d111e4e33$export$871de8747c9eaa88)((overrides)=>{
            const { [$8c05ed6f2f331ee8$var$globalOverrideKey]: globalSettings, ...participants } = overrides;
            return {
                enabled: globalSettings?.enabled !== false,
                preferredResolution: globalSettings?.enabled ? globalSettings.dimension : undefined,
                participants: Object.fromEntries(Object.entries(participants).map(([sessionId, participantOverride])=>[
                        sessionId,
                        {
                            enabled: participantOverride?.enabled !== false,
                            preferredResolution: participantOverride?.enabled ? participantOverride.dimension : undefined
                        }
                    ])),
                isParticipantVideoEnabled: (sessionId)=>overrides[sessionId]?.enabled ?? overrides[$8c05ed6f2f331ee8$var$globalOverrideKey]?.enabled ?? true
            };
        }), (0, $cd8167599454f872$export$db61d692014e534e)(1));
        /**
         * Sets the SFU client used by `apply()` to push subscription updates.
         * Called by the owner on call join; cleared on leave.
         */ this.setSfuClient = (sfuClient)=>{
            this.sfuClient = sfuClient;
        };
        /**
         * Cancels any pending debounced subscription push. Idempotent.
         */ this.dispose = ()=>{
            if (this.pendingUpdate) {
                clearTimeout(this.pendingUpdate);
                this.pendingUpdate = null;
            }
        };
        /**
         * Sets video-subscription overrides. Called by
         * `Call.setIncomingVideoEnabled` and
         * `Call.setPreferredIncomingVideoResolution`.
         *
         * - `sessionIds` omitted → applies `override` globally (or clears the
         *   global override if `override` is `undefined`).
         * - `sessionIds` provided → applies `override` to each listed session.
         */ this.setOverrides = (override, sessionIds)=>{
            this.tracer.trace('setOverrides', [
                override,
                sessionIds
            ]);
            if (!sessionIds) return $8c05ed6f2f331ee8$var$setCurrentValue(this.overridesSubject, override ? {
                [$8c05ed6f2f331ee8$var$globalOverrideKey]: override
            } : {});
            return $8c05ed6f2f331ee8$var$setCurrentValue(this.overridesSubject, (overrides)=>({
                    ...overrides,
                    ...Object.fromEntries(sessionIds.map((id)=>[
                            id,
                            override
                        ]))
                }));
        };
        /**
         * Pushes `subscriptions` to the SFU. Debounced by `debounceType`
         * (SLOW by default). Multiple rapid calls coalesce into one RPC.
         * Passing `0` fires synchronously.
         */ this.apply = (debounceType = $8c05ed6f2f331ee8$export$3acc78ff76ca7d90.SLOW)=>{
            if (this.pendingUpdate) clearTimeout(this.pendingUpdate);
            const updateSubscriptions = ()=>{
                this.pendingUpdate = null;
                this.sfuClient?.updateSubscriptions(this.subscriptions).catch((err)=>{
                    this.logger.debug(`Failed to update track subscriptions`, err);
                });
            };
            if (debounceType) this.pendingUpdate = setTimeout(updateSubscriptions, debounceType);
            else updateSubscriptions();
        };
        this.tracer = tracer;
        this.callState = callState;
    }
    /**
     * The current SFU subscription list, computed from `CallState`
     * participants and the override state. Used by:
     *
     * - `apply()` to push to the SFU each time the set changes.
     * - `Call.getReconnectDetails` to include the subscription list in
     *   the reconnect payload.
     */ get subscriptions() {
        const subscriptions = [];
        // Use getParticipantsSnapshot() to bypass the observable pipeline
        // and avoid stale data caused by shareReplay with no active subscribers
        const participants = this.callState.getParticipantsSnapshot();
        const overrides = this.overridesSubject.getValue();
        for (const p of participants){
            if (p.isLocalParticipant) continue;
            // NOTE: audio tracks don't have to be requested explicitly
            // as the SFU will implicitly subscribe us to all of them,
            // once they become available.
            if (p.videoDimension && $8c05ed6f2f331ee8$export$554515ce821ba4ab(p)) {
                const override = overrides[p.sessionId] ?? overrides[$8c05ed6f2f331ee8$var$globalOverrideKey];
                if (override?.enabled !== false) subscriptions.push({
                    userId: p.userId,
                    sessionId: p.sessionId,
                    trackType: $8c05ed6f2f331ee8$var$TrackType.VIDEO,
                    dimension: override?.dimension ?? p.videoDimension
                });
            }
            if (p.screenShareDimension && $8c05ed6f2f331ee8$export$30c686c84ce95811(p)) subscriptions.push({
                userId: p.userId,
                sessionId: p.sessionId,
                trackType: $8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE,
                dimension: p.screenShareDimension
            });
            if ($8c05ed6f2f331ee8$export$daa118aa3a3add81(p)) subscriptions.push({
                userId: p.userId,
                sessionId: p.sessionId,
                trackType: $8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE_AUDIO
            });
        }
        return subscriptions;
    }
    get overrides() {
        return $8c05ed6f2f331ee8$var$getCurrentValue(this.overrides$);
    }
}
/**
 * Watches a single audio or video element and attempts to recover playback
 * after the element transitions to a paused or suspended state unexpectedly.
 */ class $8c05ed6f2f331ee8$var$MediaPlaybackWatchdog {
    constructor(opts){
        this.logger = $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger('MediaPlaybackWatchdog');
        this.controller = new AbortController();
        this.attempt = 0;
        this.disposed = false;
        this.attach = ()=>{
            if (this.disposed) return;
            const { signal: signal } = this.controller;
            this.element.addEventListener('pause', this.onPauseOrSuspend, {
                signal: signal
            });
            this.element.addEventListener('suspend', this.onPauseOrSuspend, {
                signal: signal
            });
            this.element.addEventListener('playing', this.onPlaying, {
                signal: signal
            });
        };
        this.dispose = ()=>{
            if (this.disposed) return;
            this.disposed = true;
            this.controller.abort();
            if (this.pendingTimer) clearTimeout(this.pendingTimer);
            this.pendingTimer = undefined;
        };
        this.onPlaying = ()=>{
            if (this.attempt > 0) this.tracer.trace('mediaPlayback.recover.success', {
                kind: this.kind,
                attempts: this.attempt
            });
            this.attempt = 0;
            if (this.pendingTimer) clearTimeout(this.pendingTimer);
            this.pendingTimer = undefined;
        };
        this.onPauseOrSuspend = (event)=>{
            if (this.disposed) return;
            this.tracer.trace('mediaPlayback.paused', {
                kind: this.kind,
                reason: event.type
            });
            this.scheduleRecovery();
        };
        this.scheduleRecovery = ()=>{
            if (this.disposed || this.pendingTimer) return;
            const skipReason = this.computeSkipReason();
            if (skipReason) {
                this.tracer.trace('mediaPlayback.recover.skipped', {
                    kind: this.kind,
                    reason: skipReason
                });
                return;
            }
            const delay = this.attempt === 0 ? 0 : $8c05ed6f2f331ee8$var$retryInterval(this.attempt);
            this.pendingTimer = setTimeout(this.attemptPlay, delay);
        };
        this.computeSkipReason = ()=>{
            if (this.disposed) return 'disposed';
            if (!this.element.srcObject) return 'noSrc';
            if (this.element.ended) return 'ended';
            if (this.isBlocked()) return 'blocked';
            const HAVE_CURRENT_DATA = 2;
            if (this.element.readyState < HAVE_CURRENT_DATA) return 'notReady';
            if (!this.element.paused) return 'notPaused';
        };
        this.attemptPlay = async ()=>{
            this.pendingTimer = undefined;
            if (this.disposed) return;
            this.attempt += 1;
            this.tracer.trace('mediaPlayback.recover.attempt', {
                kind: this.kind,
                attempt: this.attempt
            });
            try {
                await $8c05ed6f2f331ee8$var$timeboxed([
                    this.element.play()
                ], 2000);
            } catch (err) {
                if (this.disposed) return;
                this.logger.warn(`Failed to recover ${this.kind} playback`, err);
                if (this.attempt >= 10) {
                    this.tracer.trace('mediaPlayback.recover.giveUp', {
                        kind: this.kind,
                        attempts: this.attempt
                    });
                    return;
                }
                this.scheduleRecovery();
            }
        };
        this.element = opts.element;
        this.kind = opts.kind;
        this.tracer = opts.tracer;
        this.isBlocked = opts.isBlocked ?? (()=>false);
        this.attach();
    }
}
/**
 * A manager class that handles dynascale related tasks like:
 *
 * - binding video elements to session ids
 * - binding audio elements to session ids
 */ class $8c05ed6f2f331ee8$export$da5c04fd91fda94 {
    /**
     * Creates a new DynascaleManager instance.
     */ constructor(callState, speaker, tracer, trackSubscriptionManager, blockedAudioTracker){
        this.logger = $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger('DynascaleManager');
        this.useWebAudio = false;
        /**
         * Closes the audio context if it was created.
         */ this.dispose = async ()=>{
            const context = this.audioContext;
            if (context && context.state !== 'closed') {
                document.removeEventListener('click', this.resumeAudioContext);
                await context.close();
                this.audioContext = undefined;
            }
        };
        /**
         * Sets whether to use WebAudio API for audio playback.
         * Must be set before joining the call.
         *
         * @internal
         *
         * @param useWebAudio whether to use WebAudio API.
         */ this.setUseWebAudio = (useWebAudio)=>{
            this.tracer.trace('setUseWebAudio', useWebAudio);
            this.useWebAudio = useWebAudio;
        };
        /**
         * Binds a DOM <video> element to the given session id.
         * This method will make sure that the video element will play
         * the correct video stream for the given session id.
         *
         * Under the hood, it would also keep track of the video element dimensions
         * and update the subscription accordingly in order to optimize the bandwidth.
         *
         * If a "viewport" is configured, the video element will be automatically
         * tracked for visibility and the subscription will be updated accordingly.
         *
         * @param videoElement the video element to bind to.
         * @param sessionId the session id.
         * @param trackType the kind of video.
         */ this.bindVideoElement = (videoElement, sessionId, trackType)=>{
            const boundParticipant = this.callState.findParticipantBySessionId(sessionId);
            if (!boundParticipant) return;
            const requestTrackWithDimensions = (debounceType, dimension)=>{
                if (dimension && (dimension.width === 0 || dimension.height === 0)) {
                    // ignore 0x0 dimensions. this can happen when the video element
                    // is not visible (e.g., has display: none).
                    // we treat this as "unsubscription" as we don't want to keep
                    // consuming bandwidth for a video that is not visible on the screen.
                    this.logger.debug(`Ignoring 0x0 dimension`, boundParticipant);
                    dimension = undefined;
                }
                this.callState.updateParticipantTracks(trackType, {
                    [sessionId]: {
                        dimension: dimension
                    }
                });
                this.trackSubscriptionManager.apply(debounceType);
            };
            const participant$ = this.callState.participants$.pipe((0, $9853a79d111e4e33$export$871de8747c9eaa88)((ps)=>ps.find((p)=>p.sessionId === sessionId)), (0, $106fa5810fba1e6e$export$9384c7afe4015e42)((participant)=>!!participant), (0, $6fb8b1c12553edae$export$779c5fb865a0172e)(), (0, $cd8167599454f872$export$db61d692014e534e)({
                bufferSize: 1,
                refCount: true
            }));
            /**
             * Since the video elements are now being removed from the DOM (React SDK) upon
             * visibility change, this subscription is not in use an stays here only for the
             * plain JS integrations where integrators might choose not to remove the video
             * elements from the DOM.
             */ // keep copy for resize observer handler
            let viewportVisibilityState;
            const viewportVisibilityStateSubscription = boundParticipant.isLocalParticipant ? null : participant$.pipe((0, $9853a79d111e4e33$export$871de8747c9eaa88)((p)=>p.viewportVisibilityState?.[trackType]), (0, $6fb8b1c12553edae$export$779c5fb865a0172e)()).subscribe((nextViewportVisibilityState)=>{
                // skip initial trigger
                if (!viewportVisibilityState) {
                    viewportVisibilityState = nextViewportVisibilityState ?? $8c05ed6f2f331ee8$export$1655277b7107d364.UNKNOWN;
                    return;
                }
                viewportVisibilityState = nextViewportVisibilityState ?? $8c05ed6f2f331ee8$export$1655277b7107d364.UNKNOWN;
                if (nextViewportVisibilityState === $8c05ed6f2f331ee8$export$1655277b7107d364.INVISIBLE) return requestTrackWithDimensions($8c05ed6f2f331ee8$export$3acc78ff76ca7d90.MEDIUM, undefined);
                requestTrackWithDimensions($8c05ed6f2f331ee8$export$3acc78ff76ca7d90.MEDIUM, {
                    width: videoElement.clientWidth,
                    height: videoElement.clientHeight
                });
            });
            let lastDimensions;
            const resizeObserver = boundParticipant.isLocalParticipant ? null : new ResizeObserver(()=>{
                const currentDimensions = {
                    width: videoElement.clientWidth,
                    height: videoElement.clientHeight
                };
                // skip initial trigger
                if (!lastDimensions) {
                    lastDimensions = currentDimensions;
                    return;
                }
                if (lastDimensions.width === currentDimensions.width && lastDimensions.height === currentDimensions.height || viewportVisibilityState === $8c05ed6f2f331ee8$export$1655277b7107d364.INVISIBLE) return;
                const relativeDelta = Math.max(currentDimensions.width / lastDimensions.width, currentDimensions.height / lastDimensions.height);
                // Low quality video in an upscaled video element is very noticable.
                // We try to upscale faster, and downscale slower. We also update debounce
                // more if the size change is not significant, gurading against fast-firing
                // resize events.
                const debounceType = relativeDelta > 1.2 ? $8c05ed6f2f331ee8$export$3acc78ff76ca7d90.IMMEDIATE : $8c05ed6f2f331ee8$export$3acc78ff76ca7d90.MEDIUM;
                requestTrackWithDimensions(debounceType, {
                    width: videoElement.clientWidth,
                    height: videoElement.clientHeight
                });
                lastDimensions = currentDimensions;
            });
            resizeObserver?.observe(videoElement);
            const isVideoTrack = trackType === 'videoTrack';
            // element renders and gets bound - track subscription gets
            // triggered first other ones get skipped on initial subscriptions
            const publishedTracksSubscription = boundParticipant.isLocalParticipant ? null : participant$.pipe((0, $5b7702bd13db251d$export$571da16e28367bde)('publishedTracks'), (0, $9853a79d111e4e33$export$871de8747c9eaa88)((p)=>isVideoTrack ? $8c05ed6f2f331ee8$export$554515ce821ba4ab(p) : $8c05ed6f2f331ee8$export$30c686c84ce95811(p)), (0, $6fb8b1c12553edae$export$779c5fb865a0172e)()).subscribe((isPublishing)=>{
                if (isPublishing) // the participant just started to publish a track
                requestTrackWithDimensions($8c05ed6f2f331ee8$export$3acc78ff76ca7d90.IMMEDIATE, {
                    width: videoElement.clientWidth,
                    height: videoElement.clientHeight
                });
                else // the participant just stopped publishing a track
                requestTrackWithDimensions($8c05ed6f2f331ee8$export$3acc78ff76ca7d90.FAST, undefined);
            });
            videoElement.autoplay = true;
            videoElement.playsInline = true;
            // explicitly marking the element as muted will allow autoplay to work
            // without prior user interaction:
            // https://developer.mozilla.org/en-US/docs/Web/Media/Autoplay_guide
            videoElement.muted = true;
            const playbackWatchdog = new $8c05ed6f2f331ee8$var$MediaPlaybackWatchdog({
                element: videoElement,
                kind: 'video',
                tracer: this.tracer
            });
            const trackKey = isVideoTrack ? 'videoStream' : 'screenShareStream';
            const streamSubscription = participant$.pipe((0, $5b7702bd13db251d$export$571da16e28367bde)(trackKey)).subscribe((p)=>{
                const source = isVideoTrack ? p.videoStream : p.screenShareStream;
                if (videoElement.srcObject === source) return;
                videoElement.srcObject = source ?? null;
                if ($8c05ed6f2f331ee8$var$isSafari() || $8c05ed6f2f331ee8$var$isFirefox()) setTimeout(async ()=>{
                    videoElement.srcObject = source ?? null;
                    try {
                        await $8c05ed6f2f331ee8$var$timeboxed([
                            videoElement.play()
                        ], 2000);
                    } catch (e) {
                        this.logger.warn(`Failed to play stream`, e);
                    }
                }, 25);
            });
            return ()=>{
                requestTrackWithDimensions($8c05ed6f2f331ee8$export$3acc78ff76ca7d90.FAST, undefined);
                viewportVisibilityStateSubscription?.unsubscribe();
                publishedTracksSubscription?.unsubscribe();
                streamSubscription.unsubscribe();
                resizeObserver?.disconnect();
                playbackWatchdog.dispose();
            };
        };
        /**
         * Binds a DOM <audio> element to the given session id.
         *
         * This method will make sure that the audio element will
         * play the correct audio stream for the given session id.
         *
         * @param audioElement the audio element to bind to.
         * @param sessionId the session id.
         * @param trackType the kind of audio.
         * @returns a cleanup function that will unbind the audio element.
         */ this.bindAudioElement = (audioElement, sessionId, trackType)=>{
            const participant = this.callState.findParticipantBySessionId(sessionId);
            if (!participant || participant.isLocalParticipant) return;
            const participant$ = this.callState.participants$.pipe((0, $9853a79d111e4e33$export$871de8747c9eaa88)((ps)=>ps.find((p)=>p.sessionId === sessionId)), (0, $106fa5810fba1e6e$export$9384c7afe4015e42)((p)=>!!p), (0, $6fb8b1c12553edae$export$779c5fb865a0172e)(), (0, $cd8167599454f872$export$db61d692014e534e)({
                bufferSize: 1,
                refCount: true
            }));
            const updateSinkId = (deviceId, audioContext)=>{
                if (!deviceId) return;
                if ('setSinkId' in audioElement) audioElement.setSinkId(deviceId).catch((e)=>{
                    this.logger.warn(`Can't to set AudioElement sinkId`, e);
                });
                if (audioContext && 'setSinkId' in audioContext) // @ts-expect-error setSinkId is not available in all browsers
                audioContext.setSinkId(deviceId).catch((e)=>{
                    this.logger.warn(`Can't to set AudioContext sinkId`, e);
                });
            };
            let sourceNode = undefined;
            let gainNode = undefined;
            let audioWatchdog = undefined;
            const isAudioTrack = trackType === 'audioTrack';
            const trackKey = isAudioTrack ? 'audioStream' : 'screenShareAudioStream';
            const updateMediaStreamSubscription = participant$.pipe((0, $5b7702bd13db251d$export$571da16e28367bde)(trackKey)).subscribe((p)=>{
                const source = isAudioTrack ? p.audioStream : p.screenShareAudioStream;
                if (audioElement.srcObject === source) return;
                setTimeout(()=>{
                    audioElement.srcObject = source ?? null;
                    audioWatchdog?.dispose();
                    audioWatchdog = undefined;
                    if (!source) {
                        this.blockedAudioTracker.markBlocked(audioElement, false);
                        return;
                    }
                    // Safari has a special quirk that prevents playing audio until the user
                    // interacts with the page or focuses on the tab where the call happens.
                    // This is a workaround for the issue where:
                    // - A and B are in a call
                    // - A switches to another tab
                    // - B mutes their microphone and unmutes it
                    // - A does not hear B's unmuted audio until they focus the tab
                    const audioContext = this.getOrCreateAudioContext();
                    if (audioContext) {
                        // we will play audio through the audio context in Safari
                        audioElement.muted = true;
                        sourceNode?.disconnect();
                        sourceNode = audioContext.createMediaStreamSource(source);
                        gainNode ?? (gainNode = audioContext.createGain());
                        gainNode.gain.value = p.audioVolume ?? this.speaker.state.volume;
                        sourceNode.connect(gainNode).connect(audioContext.destination);
                        this.resumeAudioContext();
                    } else {
                        // we will play audio directly through the audio element in other browsers
                        audioElement.muted = false;
                        audioElement.play().catch((e)=>{
                            this.tracer.trace('audioPlaybackError', e.message);
                            if (e.name === 'NotAllowedError') {
                                this.tracer.trace('audioPlaybackBlocked', null);
                                this.blockedAudioTracker.markBlocked(audioElement, true);
                            }
                            this.logger.warn(`Failed to play audio stream`, e);
                        });
                        audioWatchdog = new $8c05ed6f2f331ee8$var$MediaPlaybackWatchdog({
                            element: audioElement,
                            kind: 'audio',
                            tracer: this.tracer,
                            isBlocked: ()=>this.blockedAudioTracker.isBlocked(audioElement)
                        });
                    }
                    const { selectedDevice: selectedDevice } = this.speaker.state;
                    if (selectedDevice) updateSinkId(selectedDevice, audioContext);
                });
            });
            const sinkIdSubscription = !('setSinkId' in audioElement) ? null : this.speaker.state.selectedDevice$.subscribe((deviceId)=>{
                const audioContext = this.getOrCreateAudioContext();
                updateSinkId(deviceId, audioContext);
            });
            const volumeSubscription = (0, $0e8b72f41887b114$export$77fa7d86f5204e8a)([
                this.speaker.state.volume$,
                participant$.pipe((0, $5b7702bd13db251d$export$571da16e28367bde)('audioVolume'))
            ]).subscribe(([volume, p])=>{
                const participantVolume = p.audioVolume ?? volume;
                audioElement.volume = participantVolume;
                if (gainNode) gainNode.gain.value = participantVolume;
            });
            audioElement.autoplay = true;
            return ()=>{
                this.blockedAudioTracker.markBlocked(audioElement, false);
                sinkIdSubscription?.unsubscribe();
                volumeSubscription.unsubscribe();
                updateMediaStreamSubscription.unsubscribe();
                audioElement.srcObject = null;
                sourceNode?.disconnect();
                gainNode?.disconnect();
                audioWatchdog?.dispose();
                audioWatchdog = undefined;
            };
        };
        this.getOrCreateAudioContext = ()=>{
            if (!this.useWebAudio) return;
            if (this.audioContext) return this.audioContext;
            const context = new AudioContext();
            this.tracer.trace('audioContext.create', context.state);
            if (context.state === 'suspended') document.addEventListener('click', this.resumeAudioContext);
            context.addEventListener('statechange', ()=>{
                this.tracer.trace('audioContext.state', context.state);
                if (context.state === 'interrupted') this.resumeAudioContext();
            });
            const audioSession = navigator.audioSession;
            if (audioSession) {
                // https://github.com/w3c/audio-session/blob/main/explainer.md
                audioSession.type = 'play-and-record';
                let isSessionInterrupted = false;
                audioSession.addEventListener('statechange', ()=>{
                    this.tracer.trace('audioSession.state', audioSession.state);
                    if (audioSession.state === 'interrupted') isSessionInterrupted = true;
                    else if (isSessionInterrupted) {
                        this.resumeAudioContext();
                        isSessionInterrupted = false;
                    }
                });
            }
            return this.audioContext = context;
        };
        this.resumeAudioContext = ()=>{
            if (!this.audioContext) return;
            const { state: state } = this.audioContext;
            if (state === 'suspended' || state === 'interrupted') {
                const tag = 'audioContext.resume';
                this.audioContext.resume().then(()=>{
                    this.tracer.trace(tag, this.audioContext?.state);
                    document.removeEventListener('click', this.resumeAudioContext);
                }, (err)=>{
                    this.tracer.trace(`${tag}Error`, this.audioContext?.state);
                    this.logger.warn(`Can't resume audio context`, err);
                });
            }
        };
        this.callState = callState;
        this.speaker = speaker;
        this.tracer = tracer;
        this.trackSubscriptionManager = trackSubscriptionManager;
        this.blockedAudioTracker = blockedAudioTracker;
    }
}
/**
 * Invokes `onFirstFrame` once when the video element renders a frame.
 *
 * Uses `requestVideoFrameCallback` when available, falling back to `loadeddata`
 * for browsers that don't support it.
 */ const $8c05ed6f2f331ee8$var$createFirstVideoFrameDetector = (videoElement, onFirstFrame)=>{
    let done = false;
    const notify = ()=>{
        if (done) return;
        done = true;
        onFirstFrame();
    };
    if (typeof videoElement.requestVideoFrameCallback === 'function') {
        const handle = videoElement.requestVideoFrameCallback(notify);
        return ()=>{
            done = true;
            videoElement.cancelVideoFrameCallback(handle);
        };
    }
    if (videoElement.readyState >= videoElement.HAVE_CURRENT_DATA) {
        queueMicrotask(notify);
        return ()=>{
            done = true;
        };
    }
    videoElement.addEventListener('loadeddata', notify, {
        once: true
    });
    return ()=>{
        done = true;
        videoElement.removeEventListener('loadeddata', notify);
    };
};
const $8c05ed6f2f331ee8$var$DEFAULT_THRESHOLD = 0.35;
const $8c05ed6f2f331ee8$var$DEFAULT_VIEWPORT_VISIBILITY_STATE = {
    videoTrack: $8c05ed6f2f331ee8$export$1655277b7107d364.UNKNOWN,
    screenShareTrack: $8c05ed6f2f331ee8$export$1655277b7107d364.UNKNOWN
};
class $8c05ed6f2f331ee8$export$cce50747fc92288 {
    constructor(callState){
        this.elementHandlerMap = new Map();
        this.observer = null;
        // in React children render before viewport is set, add
        // them to the queue and observe them once the observer is ready
        this.queueSet = new Set();
        /**
         * Method to set scrollable viewport as root for the IntersectionObserver, returns
         * cleanup function to be invoked upon disposing of the DOM element to prevent memory leaks
         */ this.setViewport = (viewportElement, options)=>{
            const cleanup = ()=>{
                this.observer?.disconnect();
                this.observer = null;
                this.elementHandlerMap.clear();
            };
            this.observer = new IntersectionObserver((entries)=>{
                entries.forEach((entry)=>{
                    const handler = this.elementHandlerMap.get(entry.target);
                    handler?.(entry);
                });
            }, {
                root: viewportElement,
                ...options,
                threshold: options?.threshold ?? $8c05ed6f2f331ee8$var$DEFAULT_THRESHOLD
            });
            if (this.queueSet.size) {
                this.queueSet.forEach(([queueElement, queueHandler])=>{
                    // check if element which requested observation is
                    // a child of a viewport element, skip if isn't
                    if (!viewportElement.contains(queueElement)) return;
                    this.observer.observe(queueElement);
                    this.elementHandlerMap.set(queueElement, queueHandler);
                });
                this.queueSet.clear();
            }
            return cleanup;
        };
        /**
         * Method to set element to observe and handler to be triggered whenever IntersectionObserver
         * detects a possible change in element's visibility within specified viewport, returns
         * cleanup function to be invoked upon disposing of the DOM element to prevent memory leaks
         */ this.observe = (element, handler)=>{
            const queueItem = [
                element,
                handler
            ];
            const cleanup = ()=>{
                this.elementHandlerMap.delete(element);
                this.observer?.unobserve(element);
                this.queueSet.delete(queueItem);
            };
            if (this.elementHandlerMap.has(element)) return cleanup;
            if (!this.observer) {
                this.queueSet.add(queueItem);
                return cleanup;
            }
            if (this.observer.root.contains(element)) {
                this.elementHandlerMap.set(element, handler);
                this.observer.observe(element);
            }
            return cleanup;
        };
        /**
         * Tracks the given element for visibility changes and mirrors the result
         * into `participant.viewportVisibilityState[trackType]` in `CallState`.
         * Returns a function that unobserves the element and resets the visibility
         * state back to `UNKNOWN`.
         */ this.trackElementVisibility = (element, sessionId, trackType)=>{
            const cleanup = this.observe(element, (entry)=>{
                this.callState.updateParticipant(sessionId, (participant)=>{
                    const previousVisibilityState = participant.viewportVisibilityState ?? $8c05ed6f2f331ee8$var$DEFAULT_VIEWPORT_VISIBILITY_STATE;
                    // observer triggers when the element is "moved" to be a fullscreen element
                    // keep it VISIBLE if that happens to prevent fullscreen with placeholder
                    const isVisible = entry.isIntersecting || document.fullscreenElement === element ? $8c05ed6f2f331ee8$export$1655277b7107d364.VISIBLE : $8c05ed6f2f331ee8$export$1655277b7107d364.INVISIBLE;
                    return {
                        ...participant,
                        viewportVisibilityState: {
                            ...previousVisibilityState,
                            [trackType]: isVisible
                        }
                    };
                });
            });
            return ()=>{
                cleanup();
                // reset visibility state to UNKNOWN upon cleanup
                // so that the layouts that are not actively observed
                // can still function normally (runtime layout switching)
                this.callState.updateParticipant(sessionId, (participant)=>{
                    const previousVisibilityState = participant.viewportVisibilityState ?? $8c05ed6f2f331ee8$var$DEFAULT_VIEWPORT_VISIBILITY_STATE;
                    return {
                        ...participant,
                        viewportVisibilityState: {
                            ...previousVisibilityState,
                            [trackType]: $8c05ed6f2f331ee8$export$1655277b7107d364.UNKNOWN
                        }
                    };
                });
            };
        };
        this.callState = callState;
    }
}
/**
 * Stores the permissions for the current user and exposes
 * a few helper methods which make it easier to work with permissions.
 *
 * This is an internal class meant to be used in combination with
 * a {@link Call} instance.
 *
 * @internal
 */ class $8c05ed6f2f331ee8$var$PermissionsContext {
    constructor(){
        this.permissions = [];
        /**
         * Sets the permissions for the current user.
         *
         * @param permissions the permissions to set.
         */ this.setPermissions = (permissions)=>{
            this.permissions = permissions || [];
        };
        /**
         * Sets the settings for the bound call.
         * @param settings
         */ this.setCallSettings = (settings)=>{
            this.settings = settings;
        };
        /**
         * Checks if the current user has a specific permission.
         *
         * @param permission the permission to check for.
         */ this.hasPermission = (permission)=>{
            return this.permissions.includes(permission);
        };
        /**
         * Helper method that checks whether the current user has the permission
         * to publish the given track type.
         */ this.canPublish = (trackType)=>{
            switch(trackType){
                case $8c05ed6f2f331ee8$var$TrackType.AUDIO:
                    return this.hasPermission($8c05ed6f2f331ee8$export$9d72b1bd9eedd7a7.SEND_AUDIO);
                case $8c05ed6f2f331ee8$var$TrackType.VIDEO:
                    return this.hasPermission($8c05ed6f2f331ee8$export$9d72b1bd9eedd7a7.SEND_VIDEO);
                case $8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE:
                case $8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE_AUDIO:
                    return this.hasPermission($8c05ed6f2f331ee8$export$9d72b1bd9eedd7a7.SCREENSHARE);
                case $8c05ed6f2f331ee8$var$TrackType.UNSPECIFIED:
                    return false;
                default:
                    $8c05ed6f2f331ee8$var$ensureExhausted(trackType, 'Unknown track type');
                    return false;
            }
        };
        /**
         * Checks if the current user can request a specific permission
         * within the call.
         *
         * @param permission the permission to check for.
         * @param settings the call settings to check against (optional).
         */ this.canRequest = (permission, settings = this.settings)=>{
            if (!settings) return false;
            const { audio: audio, video: video, screensharing: screensharing } = settings;
            switch(permission){
                case $8c05ed6f2f331ee8$export$9d72b1bd9eedd7a7.SEND_AUDIO:
                    return audio.access_request_enabled;
                case $8c05ed6f2f331ee8$export$9d72b1bd9eedd7a7.SEND_VIDEO:
                    return video.access_request_enabled;
                case $8c05ed6f2f331ee8$export$9d72b1bd9eedd7a7.SCREENSHARE:
                    return screensharing.access_request_enabled;
                default:
                    return false;
            }
        };
    }
}
/**
 * Represents a call type.
 */ class $8c05ed6f2f331ee8$export$ff80acda7f860bb4 {
    /**
     * Constructs a new CallType.
     *
     * @param name the name of the call type.
     * @param options the options for the call type.
     */ constructor(name, options = {
        sortParticipantsBy: $8c05ed6f2f331ee8$export$e866caabda0ac9d1
    }){
        this.name = name;
        this.options = options;
    }
}
/**
 * A registry of {@link CallType}s.
 * You can register and unregister call types.
 */ class $8c05ed6f2f331ee8$var$CallTypesRegistry {
    /**
     * Constructs a new CallTypesRegistry.
     *
     * @param callTypes the initial call types to register.
     */ constructor(callTypes){
        /**
         * Registers a new call type.
         *
         * @param callType the call type to register.
         */ this.register = (callType)=>{
            this.callTypes[callType.name] = callType;
        };
        /**
         * Unregisters a call type.
         *
         * @param name the name of the call type to unregister.
         */ this.unregister = (name)=>{
            delete this.callTypes[name];
        };
        /**
         * Gets a call type by name.
         *
         * @param name the name of the call type to get.
         */ this.get = (name)=>{
            if (!this.callTypes[name]) this.register(new $8c05ed6f2f331ee8$export$ff80acda7f860bb4(name));
            return this.callTypes[name];
        };
        this.callTypes = callTypes.reduce((acc, callType)=>{
            acc[callType.name] = callType;
            return acc;
        }, {});
    }
}
/**
 * The default call types registry.
 * You can use this instance to dynamically register and unregister call types.
 */ const $8c05ed6f2f331ee8$export$6983c6d5a7dfc9ea = new $8c05ed6f2f331ee8$var$CallTypesRegistry([
    new $8c05ed6f2f331ee8$export$ff80acda7f860bb4('default', {
        sortParticipantsBy: $8c05ed6f2f331ee8$export$e866caabda0ac9d1
    }),
    new $8c05ed6f2f331ee8$export$ff80acda7f860bb4('development', {
        sortParticipantsBy: $8c05ed6f2f331ee8$export$e866caabda0ac9d1
    }),
    new $8c05ed6f2f331ee8$export$ff80acda7f860bb4('livestream', {
        sortParticipantsBy: $8c05ed6f2f331ee8$export$f6dee05b485e0fc
    }),
    new $8c05ed6f2f331ee8$export$ff80acda7f860bb4('audio_room', {
        sortParticipantsBy: $8c05ed6f2f331ee8$export$f6dee05b485e0fc
    })
]);
/**
 * A generic sliding-window rate limiter.
 *
 * Allows at most `maxAttempts` registrations inside a rolling `windowMs`.
 * Attempts spaced further apart than `windowMs` are always allowed.
 */ class $8c05ed6f2f331ee8$var$SlidingWindowRateLimiter {
    constructor(maxAttempts, windowMs){
        this.timestamps = [];
        /**
         * Attempts to register a new event at `now`. Returns `true` if the attempt
         * fits inside the budget (and records it), or `false` if the budget is
         * exhausted (in which case no timestamp is recorded).
         */ this.tryRegister = (now = Date.now())=>{
            this.prune(now);
            if (this.timestamps.length >= this.maxAttempts) return false;
            this.timestamps.push(now);
            return true;
        };
        /**
         * Clears the attempt history.
         */ this.reset = ()=>{
            this.timestamps = [];
        };
        /**
         * Updates the budget and window size. Existing timestamps are kept; they
         * will be pruned by the next `tryRegister` call.
         */ this.setLimits = (maxAttempts, windowMs)=>{
            this.maxAttempts = maxAttempts;
            this.windowMs = windowMs;
        };
        this.prune = (now)=>{
            const cutoff = now - this.windowMs;
            this.timestamps = this.timestamps.filter((t)=>t >= cutoff);
        };
        this.maxAttempts = maxAttempts;
        this.windowMs = windowMs;
    }
}
/**
 * Deactivates MediaStream (stops and removes tracks) to be later garbage collected
 *
 * @param stream MediaStream
 * @returns void
 */ const $8c05ed6f2f331ee8$export$25e2adef97670503 = (stream)=>{
    if (!stream.active) return;
    stream.getTracks().forEach((track)=>{
        track.stop();
    });
    // @ts-expect-error release() is present in react-native-webrtc and must be called to dispose the stream
    if (typeof stream.release === 'function') // @ts-expect-error - release() is present in react-native-webrtc
    stream.release();
};
class $8c05ed6f2f331ee8$var$BrowserPermission {
    constructor(permission){
        this.permission = permission;
        this.disposeController = new AbortController();
        this.wasPrompted = false;
        this.listeners = new Set();
        this.logger = $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger('permissions');
        const signal = this.disposeController.signal;
        this.ready = (async ()=>{
            const assumeGranted = ()=>{
                if ($8c05ed6f2f331ee8$var$isReactNative()) this.setState('granted');
                else this.setState('prompt');
            };
            if (!$8c05ed6f2f331ee8$var$canQueryPermissions()) return assumeGranted();
            try {
                const status = await navigator.permissions.query({
                    name: permission.queryName
                });
                if (!signal.aborted) {
                    this.setState(status.state);
                    status.addEventListener('change', ()=>this.setState(status.state), {
                        signal: signal
                    });
                }
            } catch (err) {
                this.logger.debug('Failed to query permission status', err);
                assumeGranted();
            }
        })();
    }
    dispose() {
        this.state = undefined;
        this.disposeController.abort();
    }
    async getState() {
        await this.ready;
        if (!this.state) throw new Error('BrowserPermission instance possibly disposed');
        return this.state;
    }
    async prompt({ forcePrompt: forcePrompt = false, throwOnNotAllowed: throwOnNotAllowed = false } = {}) {
        return await $8c05ed6f2f331ee8$var$withoutConcurrency(`permission-prompt-${this.permission.queryName}`, async ()=>{
            if (await this.getState() !== 'prompt' || this.wasPrompted && !forcePrompt) {
                const isGranted = this.state === 'granted';
                if (!isGranted && throwOnNotAllowed) throw new Error('Permission was not granted previously, and prompting again is not allowed');
                return isGranted;
            }
            try {
                this.wasPrompted = true;
                this.setState('prompting');
                const stream = await navigator.mediaDevices.getUserMedia(this.permission.constraints);
                $8c05ed6f2f331ee8$export$25e2adef97670503(stream);
                this.setState('granted');
                return true;
            } catch (e) {
                if (e && typeof e === 'object' && 'name' in e && (e.name === 'NotAllowedError' || e.name === 'SecurityError')) {
                    this.logger.info('Browser permission was not granted', {
                        permission: this.permission
                    });
                    this.setState('denied');
                    if (throwOnNotAllowed) throw e;
                    return false;
                }
                this.logger.error(`Failed to getUserMedia`, {
                    error: e,
                    permission: this.permission
                });
                this.setState('prompt');
                throw e;
            }
        });
    }
    listen(cb) {
        this.listeners.add(cb);
        if (this.state) cb(this.state);
        return ()=>this.listeners.delete(cb);
    }
    asObservable() {
        return this.getStateObservable().pipe(// In some browsers, the 'change' event doesn't reliably emit and hence,
        // permissionState stays in 'prompt' state forever.
        // Typically, this happens when a user grants one-time permission.
        // Instead of checking if a permission is granted, we check if it isn't denied
        (0, $9853a79d111e4e33$export$871de8747c9eaa88)((state)=>state !== 'denied'));
    }
    asStateObservable() {
        return this.getStateObservable();
    }
    getIsPromptingObservable() {
        return this.getStateObservable().pipe((0, $9853a79d111e4e33$export$871de8747c9eaa88)((state)=>state === 'prompting'));
    }
    getStateObservable() {
        return (0, $d08e84546ee8df12$export$af596f9f0ff848f8)((handler)=>this.listen(handler), (handler, unlisten)=>unlisten());
    }
    setState(state) {
        if (this.state !== state) {
            const { tracer: tracer, queryName: queryName } = this.permission;
            const traceKey = `navigator.mediaDevices.${queryName}.permission`;
            tracer?.trace(traceKey, {
                previous: this.state,
                state: state
            });
            this.state = state;
            this.listeners.forEach((listener)=>listener(state));
        }
    }
}
function $8c05ed6f2f331ee8$var$canQueryPermissions() {
    return !$8c05ed6f2f331ee8$var$isReactNative() && typeof navigator !== 'undefined' && !!navigator.permissions?.query;
}
/**
 * Returns an Observable that emits the list of available devices
 * that meet the given constraints.
 *
 * @param permission a BrowserPermission instance.
 * @param kind the kind of devices to enumerate.
 * @param tracer the tracer to use for tracing the device enumeration.
 */ const $8c05ed6f2f331ee8$var$getDevices = (permission, kind, tracer)=>{
    return (0, $2fe2b696577919a5$export$6788812c4e6611e6)((async ()=>{
        let devices = await navigator.mediaDevices.enumerateDevices();
        // for privacy reasons, most browsers don't give you device labels
        // unless you have a corresponding camera or microphone permission
        const shouldPromptForBrowserPermission = devices.some((device)=>device.kind === kind && device.label === '');
        if (shouldPromptForBrowserPermission && await permission.prompt()) devices = await navigator.mediaDevices.enumerateDevices();
        tracer?.traceOnce('device-enumeration', 'navigator.mediaDevices.enumerateDevices', devices);
        return devices.filter((device)=>device.kind === kind && device.label !== '' && device.deviceId !== 'default');
    })());
};
/**
 * Tells if the browser supports audio output change on 'audio' elements,
 * see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/setSinkId.
 */ const $8c05ed6f2f331ee8$export$3479a1b64a9a82cf = ()=>{
    if (typeof document === 'undefined') return false;
    const element = document.createElement('audio');
    return 'setSinkId' in element;
};
/**
 * The default constraints used to request audio devices.
 */ const $8c05ed6f2f331ee8$var$audioDeviceConstraints = {
    audio: {
        autoGainControl: true,
        noiseSuppression: true,
        echoCancellation: true
    }
};
/**
 * The default constraints used to request video devices.
 */ const $8c05ed6f2f331ee8$var$videoDeviceConstraints = {
    video: {
        width: 1280,
        height: 720
    }
};
/**
 * Keeps track of the browser permission to use microphone. This permission also
 * affects an ability to enumerate audio devices.
 */ const $8c05ed6f2f331ee8$export$d0940718070360d2 = $8c05ed6f2f331ee8$var$lazy((tracer)=>new $8c05ed6f2f331ee8$var$BrowserPermission({
        constraints: $8c05ed6f2f331ee8$var$audioDeviceConstraints,
        queryName: 'microphone',
        tracer: tracer
    }));
/**
 * Keeps track of the browser permission to use camera. This permission also
 * affects an ability to enumerate video devices.
 */ const $8c05ed6f2f331ee8$export$c0f343b08c967c50 = $8c05ed6f2f331ee8$var$lazy((tracer)=>new $8c05ed6f2f331ee8$var$BrowserPermission({
        constraints: $8c05ed6f2f331ee8$var$videoDeviceConstraints,
        queryName: 'camera',
        tracer: tracer
    }));
const $8c05ed6f2f331ee8$var$getDeviceChangeObserver = $8c05ed6f2f331ee8$var$lazy((tracer)=>{
    // 'addEventListener' is not available in React Native, returning
    // an observable that will never fire
    if (!navigator.mediaDevices.addEventListener) return (0, $2fe2b696577919a5$export$6788812c4e6611e6)([]);
    return (0, $f65a851e0b190f66$export$a36e16046ae8f1bb)(navigator.mediaDevices, 'devicechange').pipe((0, $3e7edc5b22925f26$export$3f23594af5f37336)(()=>tracer?.resetTrace('device-enumeration')), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(()=>undefined), (0, $64b486e22e2192ab$export$7843a4469d64c07e)(500));
});
/**
 * Prompts the user for a permission to use audio devices (if not already granted
 * and was not prompted before) and lists the available 'audioinput' devices,
 * if devices are added/removed the list is updated, and if the permission is revoked,
 * the observable errors.
 */ const $8c05ed6f2f331ee8$export$c9c435b44f16339f = $8c05ed6f2f331ee8$var$lazy((tracer)=>{
    return (0, $75c08a98094ca84a$export$4950aa0f605343fb)($8c05ed6f2f331ee8$var$getDeviceChangeObserver(tracer), $8c05ed6f2f331ee8$export$d0940718070360d2(tracer).asObservable()).pipe((0, $b52129d9072c7912$export$a4fe86229b0e9bdd)([]), (0, $9ee54e147202c320$export$c28c8388be0ab31a)(()=>$8c05ed6f2f331ee8$var$getDevices($8c05ed6f2f331ee8$export$d0940718070360d2(tracer), 'audioinput', tracer)), (0, $cd8167599454f872$export$db61d692014e534e)(1));
});
/**
 * Prompts the user for a permission to use video devices (if not already granted
 * and was not prompted before) and lists the available 'videoinput' devices,
 * if devices are added/removed the list is updated, and if the permission is revoked,
 * the observable errors.
 */ const $8c05ed6f2f331ee8$export$4a7ff4b5d982ac98 = $8c05ed6f2f331ee8$var$lazy((tracer)=>{
    return (0, $75c08a98094ca84a$export$4950aa0f605343fb)($8c05ed6f2f331ee8$var$getDeviceChangeObserver(tracer), $8c05ed6f2f331ee8$export$c0f343b08c967c50(tracer).asObservable()).pipe((0, $b52129d9072c7912$export$a4fe86229b0e9bdd)([]), (0, $9ee54e147202c320$export$c28c8388be0ab31a)(()=>$8c05ed6f2f331ee8$var$getDevices($8c05ed6f2f331ee8$export$c0f343b08c967c50(tracer), 'videoinput', tracer)), (0, $cd8167599454f872$export$db61d692014e534e)(1));
});
/**
 * Prompts the user for a permission to use video devices (if not already granted
 * and was not prompted before) and lists the available 'audiooutput' devices,
 * if devices are added/removed the list is updated, and if the permission is revoked,
 * the observable errors.
 */ const $8c05ed6f2f331ee8$export$e98be94900d6e6bb = $8c05ed6f2f331ee8$var$lazy((tracer)=>{
    return (0, $75c08a98094ca84a$export$4950aa0f605343fb)($8c05ed6f2f331ee8$var$getDeviceChangeObserver(tracer), $8c05ed6f2f331ee8$export$d0940718070360d2(tracer).asObservable()).pipe((0, $b52129d9072c7912$export$a4fe86229b0e9bdd)([]), (0, $9ee54e147202c320$export$c28c8388be0ab31a)(()=>$8c05ed6f2f331ee8$var$getDevices($8c05ed6f2f331ee8$export$d0940718070360d2(tracer), 'audiooutput', tracer)), (0, $cd8167599454f872$export$db61d692014e534e)(1));
});
let $8c05ed6f2f331ee8$var$getUserMediaExecId = 0;
const $8c05ed6f2f331ee8$var$getStream = async (constraints, tracer)=>{
    const tag = `navigator.mediaDevices.getUserMedia.${$8c05ed6f2f331ee8$var$getUserMediaExecId++}.`;
    try {
        tracer?.trace(tag, constraints);
        const stream = await navigator.mediaDevices.getUserMedia(constraints);
        tracer?.trace(`${tag}OnSuccess`, $8c05ed6f2f331ee8$var$dumpStream(stream));
        if ($8c05ed6f2f331ee8$var$isFirefox()) // When enumerating devices, Firefox will hide device labels unless there's been
        // an active user media stream on the page. So we force device list updates after
        // every successful getUserMedia call.
        navigator.mediaDevices.dispatchEvent(new Event('devicechange'));
        if (constraints.video) {
            const [videoTrack] = stream.getVideoTracks();
            if (videoTrack) {
                const { width: width, height: height } = videoTrack.getSettings();
                const target = constraints.video;
                if (width !== target.width || height !== target.height) tracer?.trace(`${tag}Warn`, `Requested resolution ${target.width}x${target.height} but got ${width}x${height}`);
            }
        }
        return stream;
    } catch (error) {
        tracer?.trace(`${tag}OnFailure`, error.name);
        throw error;
    }
};
function $8c05ed6f2f331ee8$var$isNotFoundOrOverconstrainedError(error) {
    if (!error || typeof error !== 'object') return false;
    if ('name' in error && typeof error.name === 'string') {
        const name = error.name;
        if ([
            'OverconstrainedError',
            'NotFoundError'
        ].includes(name)) return true;
    }
    if ('message' in error && typeof error.message === 'string') {
        const message = error.message;
        if (message.startsWith('OverconstrainedError')) return true;
    }
    return false;
}
/**
 * Returns an audio media stream that fulfills the given constraints.
 * If no constraints are provided, it uses the browser's default ones.
 *
 * @param trackConstraints the constraints to use when requesting the stream.
 * @param tracer the tracer to use for tracing the stream creation.
 * @returns a new `MediaStream` fulfilling the given constraints.
 */ const $8c05ed6f2f331ee8$export$f85bf5b5313d2d23 = async (trackConstraints, tracer)=>{
    const constraints = {
        audio: {
            ...$8c05ed6f2f331ee8$var$audioDeviceConstraints.audio,
            ...trackConstraints
        }
    };
    try {
        await $8c05ed6f2f331ee8$export$d0940718070360d2(tracer).prompt({
            throwOnNotAllowed: true,
            forcePrompt: true
        });
        return await $8c05ed6f2f331ee8$var$getStream(constraints, tracer);
    } catch (error) {
        const logger = $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger('devices');
        if ($8c05ed6f2f331ee8$var$isNotFoundOrOverconstrainedError(error) && trackConstraints?.deviceId) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { deviceId: deviceId, ...relaxedConstraints } = trackConstraints;
            logger.warn('Failed to get audio stream, will try again with relaxed constraints', {
                error: error,
                constraints: constraints,
                relaxedConstraints: relaxedConstraints
            });
            return $8c05ed6f2f331ee8$export$f85bf5b5313d2d23(relaxedConstraints, tracer);
        }
        logger.error('Failed to get audio stream', {
            error: error,
            constraints: constraints
        });
        throw error;
    }
};
/**
 * Returns a video media stream that fulfills the given constraints.
 * If no constraints are provided, it uses the browser's default ones.
 *
 * @param trackConstraints the constraints to use when requesting the stream.
 * @param tracer the tracer to use for tracing the stream creation.
 * @returns a new `MediaStream` fulfilling the given constraints.
 */ const $8c05ed6f2f331ee8$export$1dad1ad182e4457a = async (trackConstraints, tracer)=>{
    const constraints = {
        video: {
            ...$8c05ed6f2f331ee8$var$videoDeviceConstraints.video,
            ...trackConstraints
        }
    };
    try {
        await $8c05ed6f2f331ee8$export$c0f343b08c967c50(tracer).prompt({
            throwOnNotAllowed: true,
            forcePrompt: true
        });
        return await $8c05ed6f2f331ee8$var$getStream(constraints, tracer);
    } catch (error) {
        const logger = $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger('devices');
        if ($8c05ed6f2f331ee8$var$isNotFoundOrOverconstrainedError(error) && trackConstraints?.deviceId) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { deviceId: deviceId, ...relaxedConstraints } = trackConstraints;
            logger.warn('Failed to get video stream, will try again with relaxed constraints', {
                error: error,
                constraints: constraints,
                relaxedConstraints: relaxedConstraints
            });
            return $8c05ed6f2f331ee8$export$1dad1ad182e4457a(relaxedConstraints, tracer);
        }
        logger.error('Failed to get video stream', {
            error: error,
            constraints: constraints
        });
        throw error;
    }
};
let $8c05ed6f2f331ee8$var$getDisplayMediaExecId = 0;
/**
 * Prompts the user for a permission to share a screen.
 * If the user grants the permission, a screen sharing stream is returned. Throws otherwise.
 *
 * The callers of this API are responsible to handle the possible errors.
 *
 * @param options any additional options to pass to the [`getDisplayMedia`](https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getDisplayMedia) API.
 * @param tracer the tracer to use for tracing the stream creation.
 */ const $8c05ed6f2f331ee8$export$af5e380bd3bbac54 = async (options, tracer)=>{
    const tag = `navigator.mediaDevices.getDisplayMedia.${$8c05ed6f2f331ee8$var$getDisplayMediaExecId++}.`;
    try {
        const constraints = {
            systemAudio: 'include',
            ...options,
            video: typeof options?.video === 'boolean' ? options.video // must be 'true'
             : {
                width: {
                    max: 2560
                },
                height: {
                    max: 1440
                },
                frameRate: {
                    ideal: 30
                },
                ...options?.video
            },
            audio: typeof options?.audio === 'boolean' ? options.audio : {
                channelCount: {
                    ideal: 2
                },
                // @ts-expect-error not yet present in the types
                restrictOwnAudio: true,
                echoCancellation: false,
                autoGainControl: false,
                noiseSuppression: false,
                ...options?.audio
            }
        };
        tracer?.trace(tag, constraints);
        const stream = await navigator.mediaDevices.getDisplayMedia(constraints);
        tracer?.trace(`${tag}OnSuccess`, $8c05ed6f2f331ee8$var$dumpStream(stream));
        return stream;
    } catch (e) {
        tracer?.trace(`${tag}OnFailure`, e.name);
        $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger('devices').error('Failed to get screen share stream', e);
        throw e;
    }
};
const $8c05ed6f2f331ee8$export$3a118dd49eed156c = typeof navigator !== 'undefined' && typeof navigator.mediaDevices !== 'undefined' ? $8c05ed6f2f331ee8$var$getDeviceChangeObserver().pipe((0, $b52129d9072c7912$export$a4fe86229b0e9bdd)(undefined), (0, $9ee54e147202c320$export$c28c8388be0ab31a)(()=>navigator.mediaDevices.enumerateDevices()), (0, $cd8167599454f872$export$db61d692014e534e)(1)) : undefined;
/**
 * Resolves `default` device id into the real device id. Some browsers (notably,
 * Chromium-based) report device with id `default` among audio input and output
 * devices. Since not every browser does that, we never want `default` id to be
 * used within our SDK. This function tries to find the real id for the `default`
 * device.
 */ function $8c05ed6f2f331ee8$export$3221e2b6340be5d0(deviceId, kind) {
    if (deviceId !== 'default') return deviceId;
    const devices = $8c05ed6f2f331ee8$export$3a118dd49eed156c && $8c05ed6f2f331ee8$var$getCurrentValue($8c05ed6f2f331ee8$export$3a118dd49eed156c);
    if (!devices) return deviceId;
    const defaultDeviceInfo = devices.find((d)=>d.deviceId === deviceId);
    if (!defaultDeviceInfo) return deviceId;
    const groupId = defaultDeviceInfo.groupId;
    const candidates = devices.filter((d)=>d.kind === kind && d.deviceId !== 'default' && d.groupId === groupId);
    return candidates.length === 1 ? candidates[0].deviceId : deviceId;
}
/**
 * Checks if the current platform is a mobile device.
 *
 * See:
 * https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent
 */ const $8c05ed6f2f331ee8$var$isMobile = ()=>/Mobi/i.test(navigator.userAgent);
const $8c05ed6f2f331ee8$var$defaultDeviceId = 'default';
const $8c05ed6f2f331ee8$var$isLocalStorageAvailable = ()=>typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
const $8c05ed6f2f331ee8$var$normalize = (options)=>{
    return {
        storageKey: options?.storageKey ?? `@stream-io/device-preferences`,
        enabled: $8c05ed6f2f331ee8$var$isLocalStorageAvailable() && !$8c05ed6f2f331ee8$var$isReactNative() ? options?.enabled ?? true : false
    };
};
const $8c05ed6f2f331ee8$var$createSyntheticDevice = (deviceId, kind, label = '')=>{
    return {
        deviceId: deviceId,
        kind: kind,
        label: label,
        groupId: ''
    };
};
const $8c05ed6f2f331ee8$var$readPreferences = (storageKey)=>{
    try {
        const raw = window.localStorage.getItem(storageKey) || '{}';
        return JSON.parse(raw);
    } catch  {
        return {};
    }
};
const $8c05ed6f2f331ee8$var$writePreferences = (currentDevice, deviceKey, muted, storageKey)=>{
    if (!$8c05ed6f2f331ee8$var$isLocalStorageAvailable()) return;
    const selectedDeviceId = currentDevice?.deviceId ?? $8c05ed6f2f331ee8$var$defaultDeviceId;
    const selectedDeviceLabel = currentDevice?.label ?? '';
    const preferences = $8c05ed6f2f331ee8$var$readPreferences(storageKey);
    const preferenceHistory = [
        preferences[deviceKey] ?? []
    ].flat().filter((p)=>p.selectedDeviceId !== selectedDeviceId && (p.selectedDeviceLabel === '' || p.selectedDeviceLabel !== selectedDeviceLabel));
    const nextPreferences = {
        ...preferences,
        [deviceKey]: [
            {
                selectedDeviceId: selectedDeviceId,
                selectedDeviceLabel: selectedDeviceLabel,
                ...typeof muted === 'boolean' ? {
                    muted: muted
                } : {}
            },
            ...preferenceHistory
        ].slice(0, 3)
    };
    try {
        window.localStorage.setItem(storageKey, JSON.stringify(nextPreferences));
    } catch (err) {
        const logger = $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger('DevicePersistence');
        logger.error('failed to save device preferences', err);
    }
};
const $8c05ed6f2f331ee8$var$toPreferenceList = (preference)=>preference ? [
        preference
    ].flat() : [];
class $8c05ed6f2f331ee8$export$eba397ca40625ced {
    constructor(call, state, trackType, devicePersistence){
        /**
         * if true, stops the media stream when call is left
         */ this.stopOnLeave = true;
        this.subscriptions = [];
        this.currentStreamCleanups = [];
        this.areSubscriptionsSetUp = false;
        this.isTrackStoppedDueToTrackEnd = false;
        this.filters = [];
        this.virtualDevicesSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)([]);
        this.virtualDeviceConcurrencyTag = Symbol('virtualDeviceConcurrencyTag');
        this.statusChangeConcurrencyTag = Symbol('statusChangeConcurrencyTag');
        this.filterRegistrationConcurrencyTag = Symbol('filterRegistrationConcurrencyTag');
        /**
         * Disposes the manager.
         *
         * @internal
         */ this.dispose = ()=>{
            this.runCurrentStreamCleanups();
            this.subscriptions.forEach((s)=>s());
            this.subscriptions = [];
            this.areSubscriptionsSetUp = false;
            this.virtualDevicesSubject.next([]);
        };
        this.runCurrentStreamCleanups = ()=>{
            this.currentStreamCleanups.forEach((c)=>c());
            this.currentStreamCleanups = [];
        };
        this.setLocalInterrupted = (interrupted)=>{
            const localParticipant = this.call.state.localParticipant;
            if (!localParticipant) return;
            this.call.state.updateParticipant(localParticipant.sessionId, (p)=>{
                const current = p.interruptedTracks ?? [];
                const has = current.includes(this.trackType);
                if (interrupted === has) return {};
                const next = interrupted ? $8c05ed6f2f331ee8$var$pushToIfMissing([
                    ...current
                ], this.trackType) : $8c05ed6f2f331ee8$var$removeFromIfPresent([
                    ...current
                ], this.trackType);
                return {
                    interruptedTracks: next
                };
            });
        };
        this.call = call;
        this.state = state;
        this.trackType = trackType;
        this.devicePersistence = devicePersistence;
        this.logger = $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger(`${$8c05ed6f2f331ee8$var$TrackType[trackType].toLowerCase()} manager`);
        this.setup();
    }
    setup() {
        if (this.areSubscriptionsSetUp) return;
        this.areSubscriptionsSetUp = true;
        if ($8c05ed6f2f331ee8$export$3a118dd49eed156c && !$8c05ed6f2f331ee8$var$isReactNative() && (this.trackType === $8c05ed6f2f331ee8$var$TrackType.AUDIO || this.trackType === $8c05ed6f2f331ee8$var$TrackType.VIDEO)) this.handleDisconnectedOrReplacedDevices();
        if (this.devicePersistence.enabled) this.subscriptions.push($8c05ed6f2f331ee8$var$createSubscription((0, $0e8b72f41887b114$export$77fa7d86f5204e8a)([
            this.state.selectedDevice$,
            this.state.status$,
            this.state.browserPermissionState$
        ]), ([selectedDevice, status, browserPermissionState])=>{
            if (!status || this.isTrackStoppedDueToTrackEnd && status === 'disabled' || browserPermissionState !== 'granted') return;
            this.persistPreference(selectedDevice, status);
        }));
    }
    /**
     * Lists the available audio/video devices
     *
     * Note: It prompts the user for a permission to use devices (if not already granted)
     *
     * @returns an Observable that will be updated if a device is connected or disconnected
     */ listDevices() {
        return (0, $0e8b72f41887b114$export$77fa7d86f5204e8a)([
            this.getDevices(),
            this.virtualDevicesSubject
        ]).pipe((0, $9853a79d111e4e33$export$871de8747c9eaa88)(([real, virtual])=>[
                ...real,
                ...virtual.map((d)=>$8c05ed6f2f331ee8$var$createSyntheticDevice(d.deviceId, d.kind, d.label))
            ]));
    }
    /**
     * Registers a virtual camera or microphone backed by a caller-supplied
     * stream factory. The device appears in `listDevices()` and can be selected
     * via `select()` like any real device.
     *
     * Web only. React Native is not supported.
     *
     * Only supported for camera and microphone managers; calling on any other
     * manager throws.
     */ registerVirtualDevice(virtualDevice) {
        if ($8c05ed6f2f331ee8$var$isReactNative()) throw new Error('Virtual devices are not supported on React Native.');
        if (this.trackType !== $8c05ed6f2f331ee8$var$TrackType.AUDIO && this.trackType !== $8c05ed6f2f331ee8$var$TrackType.VIDEO) throw new Error('Virtual devices are only supported for camera and microphone.');
        const deviceId = `stream-virtual:${$8c05ed6f2f331ee8$var$generateUUIDv4()}`;
        const entry = {
            deviceId: deviceId,
            kind: this.mediaDeviceKind,
            ...virtualDevice
        };
        $8c05ed6f2f331ee8$var$setCurrentValue(this.virtualDevicesSubject, (current)=>[
                ...current,
                entry
            ]);
        return {
            deviceId: entry.deviceId,
            unregister: async ()=>{
                await $8c05ed6f2f331ee8$var$withoutConcurrency(this.virtualDeviceConcurrencyTag, async ()=>{
                    $8c05ed6f2f331ee8$var$setCurrentValue(this.virtualDevicesSubject, (current)=>current.filter((d)=>d !== entry));
                    if (this.activeVirtualSession?.deviceId === deviceId) await this.stopActiveVirtualSession();
                });
                if (this.state.selectedDevice === deviceId) {
                    await this.statusChangeSettled();
                    await this.disable({
                        forceStop: true
                    });
                    await this.select(undefined);
                }
            }
        };
    }
    sanitizeVirtualStream(stream) {
        stream.getTracks().forEach((track)=>{
            const originalGetSettings = track.getSettings.bind(track);
            track.getSettings = ()=>{
                const settings = originalGetSettings();
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const { deviceId: deviceId, ...rest } = settings;
                return rest;
            };
        });
        return stream;
    }
    findVirtualDevice(deviceId) {
        if (!deviceId) return undefined;
        return $8c05ed6f2f331ee8$var$getCurrentValue(this.virtualDevicesSubject).find((d)=>d.deviceId === deviceId);
    }
    async stopActiveVirtualSession() {
        const session = this.activeVirtualSession;
        this.activeVirtualSession = undefined;
        await session?.stop?.();
    }
    async getSelectedStream(constraints) {
        const deviceId = this.state.selectedDevice;
        if (!deviceId?.startsWith('stream-virtual')) return this.getStream(constraints);
        return $8c05ed6f2f331ee8$var$withoutConcurrency(this.virtualDeviceConcurrencyTag, async ()=>{
            const virtualDevice = this.findVirtualDevice(deviceId);
            if (!virtualDevice) throw new Error(`Virtual device is not registered: ${deviceId}`);
            await this.stopActiveVirtualSession();
            const { stream: stream, stop: stop } = await virtualDevice.getUserMedia(constraints);
            this.activeVirtualSession = {
                deviceId: deviceId,
                stop: stop
            };
            return this.sanitizeVirtualStream(stream);
        });
    }
    /**
     * Returns `true` when this device is in enabled state.
     */ get enabled() {
        return this.state.status === 'enabled';
    }
    /**
     * Starts stream.
     */ async enable() {
        this.state.prevStatus = this.state.optimisticStatus;
        if (this.state.optimisticStatus === 'enabled') return;
        this.state.setPendingStatus('enabled');
        await $8c05ed6f2f331ee8$var$withCancellation(this.statusChangeConcurrencyTag, async (signal)=>{
            try {
                await this.unmuteStream();
                this.state.setStatus('enabled');
            } finally{
                if (!signal.aborted) this.state.setPendingStatus(this.state.status);
            }
        });
    }
    async disable(forceStopOrOptions) {
        const forceStop = typeof forceStopOrOptions === 'boolean' ? forceStopOrOptions : forceStopOrOptions?.forceStop ?? false;
        this.state.prevStatus = this.state.optimisticStatus;
        if (!forceStop && this.state.optimisticStatus === 'disabled') return;
        this.state.setPendingStatus('disabled');
        await $8c05ed6f2f331ee8$var$withCancellation(this.statusChangeConcurrencyTag, async (signal)=>{
            try {
                const stopTracks = forceStop || this.state.disableMode === 'stop-tracks';
                await this.muteStream(stopTracks);
                this.state.setStatus('disabled');
            } finally{
                if (!signal.aborted) this.state.setPendingStatus(this.state.status);
            }
        });
    }
    /**
     * Returns a promise that resolves when all pe
     */ async statusChangeSettled() {
        await $8c05ed6f2f331ee8$var$settled(this.statusChangeConcurrencyTag);
    }
    /**
     * If status was previously enabled, it will re-enable the device.
     */ async resume() {
        if (this.state.prevStatus === 'enabled' && this.state.status !== 'enabled') await this.enable();
    }
    /**
     * If the current device status is disabled, it will enable the device,
     * else it will disable it.
     */ async toggle() {
        if (this.state.optimisticStatus === 'enabled') return await this.disable();
        else return await this.enable();
    }
    /**
     * Registers a filter that will be applied to the stream.
     *
     * The registered filter will get the existing stream, and it should return
     * a new stream with the applied filter.
     *
     * @param filter the filter to register.
     * @returns MediaStreamFilterRegistrationResult
     */ registerFilter(filter) {
        const entry = {
            start: filter,
            stop: undefined
        };
        this.call.tracer.trace(`registerFilter.${$8c05ed6f2f331ee8$var$TrackType[this.trackType]}`, null);
        const registered = $8c05ed6f2f331ee8$var$withoutConcurrency(this.filterRegistrationConcurrencyTag, async ()=>{
            await $8c05ed6f2f331ee8$var$settled(this.statusChangeConcurrencyTag);
            this.filters.push(entry);
            await this.applySettingsToStream();
        });
        return {
            registered: registered,
            unregister: ()=>$8c05ed6f2f331ee8$var$withoutConcurrency(this.filterRegistrationConcurrencyTag, async ()=>{
                    await $8c05ed6f2f331ee8$var$settled(this.statusChangeConcurrencyTag);
                    entry.stop?.();
                    this.filters = this.filters.filter((f)=>f !== entry);
                    await this.applySettingsToStream();
                    this.call.tracer.trace(`unregisterFilter.${$8c05ed6f2f331ee8$var$TrackType[this.trackType]}`, null);
                })
        };
    }
    /**
     * Will set the default constraints for the device.
     *
     * @param constraints the constraints to set.
     */ setDefaultConstraints(constraints) {
        this.state.setDefaultConstraints(constraints);
    }
    /**
     * Selects a device.
     *
     * Note: This method is not supported in React Native
     * @param deviceId the device id to select.
     */ async select(deviceId) {
        if ($8c05ed6f2f331ee8$var$isReactNative()) throw new Error('This method is not supported in React Native.');
        const prevDeviceId = this.state.selectedDevice;
        if (deviceId === prevDeviceId) return;
        try {
            this.state.setDevice(deviceId);
            await this.applySettingsToStream();
        } catch (error) {
            this.state.setDevice(prevDeviceId);
            throw error;
        }
    }
    async applySettingsToStream() {
        await $8c05ed6f2f331ee8$var$withCancellation(this.statusChangeConcurrencyTag, async (signal)=>{
            if (this.enabled) try {
                await this.muteStream();
                this.state.setStatus('disabled');
                if (signal.aborted) return;
                await this.unmuteStream();
                this.state.setStatus('enabled');
            } finally{
                if (!signal.aborted) this.state.setPendingStatus(this.state.status);
            }
        });
    }
    getResolvedConstraints(constraints) {
        return constraints;
    }
    publishStream(stream, options) {
        return this.call.publish(stream, this.trackType, options);
    }
    stopPublishStream() {
        return this.call.stopPublish(this.trackType);
    }
    getTracks() {
        return this.state.mediaStream?.getTracks() ?? [];
    }
    async muteStream(stopTracks = true) {
        const mediaStream = this.state.mediaStream;
        if (!mediaStream) return;
        this.logger.debug(`${stopTracks ? 'Stopping' : 'Disabling'} stream`);
        if (this.call.state.callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.JOINED) await this.stopPublishStream();
        this.muteLocalStream(stopTracks);
        const allEnded = this.getTracks().every((t)=>t.readyState === 'ended');
        if (allEnded) {
            await this.stopActiveVirtualSession();
            // @ts-expect-error release() is present in react-native-webrtc
            if (typeof mediaStream.release === 'function') // @ts-expect-error called to dispose the stream in RN
            mediaStream.release();
            this.runCurrentStreamCleanups();
            this.state.setMediaStream(undefined, undefined);
            this.setLocalInterrupted(false);
            this.filters.forEach((entry)=>entry.stop?.());
        }
    }
    disableTracks() {
        this.getTracks().forEach((track)=>{
            if (track.enabled) track.enabled = false;
        });
    }
    enableTracks() {
        this.getTracks().forEach((track)=>{
            if (!track.enabled) track.enabled = true;
        });
    }
    stopTracks() {
        this.getTracks().forEach((track)=>{
            if (track.readyState === 'live') track.stop();
        });
    }
    muteLocalStream(stopTracks) {
        if (!this.state.mediaStream) return;
        if (stopTracks) this.stopTracks();
        else this.disableTracks();
    }
    async unmuteStream() {
        this.logger.debug('Starting stream');
        let stream;
        let rootStreamPromise;
        if (this.state.mediaStream && this.getTracks().every((t)=>t.readyState === 'live')) {
            stream = this.state.mediaStream;
            this.enableTracks();
        } else {
            // We are about to compose a fresh filter chain and acquire a new
            // root stream. Drop any listeners bound to the previous root stream
            // before chainWith below registers new ones for the new chain.
            this.runCurrentStreamCleanups();
            const defaultConstraints = this.state.defaultConstraints;
            const constraints = this.getResolvedConstraints({
                ...defaultConstraints,
                deviceId: this.state.selectedDevice ? {
                    exact: this.state.selectedDevice
                } : undefined
            });
            /**
             * Chains two media streams together.
             *
             * In our case, filters MediaStreams are derived from their parent MediaStream.
             * However, once a child filter's track is stopped,
             * the tracks of the parent MediaStream aren't automatically stopped.
             * This leads to a situation where the camera indicator light is still on
             * even though the user stopped publishing video.
             *
             * This function works around this issue by stopping the parent MediaStream's tracks
             * as well once the child filter's tracks are stopped.
             *
             * It works by patching the stop() method of the child filter's tracks to also stop
             * the parent MediaStream's tracks of the same type. Here we assume that
             * the parent MediaStream has only one track of each type.
             *
             * @param parentStream the parent MediaStream. Omit for the root stream.
             */ const chainWith = (parentStream)=>async (filterStream)=>{
                    if (!parentStream) return filterStream;
                    // TODO OL: take care of track.enabled property as well
                    const parent = await parentStream;
                    filterStream.getTracks().forEach((track)=>{
                        const originalStop = track.stop;
                        track.stop = function stop() {
                            originalStop.call(track);
                            parent.getTracks().forEach((parentTrack)=>{
                                if (parentTrack.kind === track.kind) parentTrack.stop();
                            });
                        };
                    });
                    parent.getTracks().forEach((parentTrack)=>{
                        // When the parent stream abruptly ends, we propagate the event
                        // to the filter stream.
                        // This usually happens when the camera/microphone permissions
                        // are revoked or when the device is disconnected.
                        const handleParentTrackEnded = ()=>{
                            filterStream.getTracks().forEach((track)=>{
                                if (parentTrack.kind !== track.kind) return;
                                track.stop();
                                track.dispatchEvent(new Event('ended')); // propagate the event
                            });
                        };
                        parentTrack.addEventListener('ended', handleParentTrackEnded);
                        this.currentStreamCleanups.push(()=>{
                            parentTrack.removeEventListener('ended', handleParentTrackEnded);
                        });
                    });
                    return filterStream;
                };
            // the rootStream represents the stream coming from the actual device
            // e.g. camera or microphone stream
            rootStreamPromise = this.getSelectedStream(constraints);
            // we publish the last MediaStream of the chain
            stream = await this.filters.reduce((parent, entry)=>parent.then((inputStream)=>{
                    const { stop: stop, output: output } = entry.start(inputStream);
                    entry.stop = stop;
                    return output;
                }).then(chainWith(parent), (error)=>{
                    this.logger.warn('Filter failed to start and will be ignored', error);
                    return parent;
                }), rootStreamPromise);
        }
        if (this.call.state.callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.JOINED) await this.publishStream(stream);
        if (this.state.mediaStream !== stream) {
            const rootStream = await rootStreamPromise;
            this.state.setMediaStream(stream, rootStream);
            if (rootStream) {
                const handleTrackEnded = async ()=>{
                    this.setLocalInterrupted(false);
                    await this.statusChangeSettled();
                    if (this.enabled) {
                        this.isTrackStoppedDueToTrackEnd = true;
                        setTimeout(()=>{
                            this.isTrackStoppedDueToTrackEnd = false;
                        }, 2000);
                        await this.disable();
                    }
                };
                const createTrackMuteHandler = (muted)=>()=>{
                        this.setLocalInterrupted(muted);
                        // WebKit's RTCRtpSender encoder can stay stalled after an iOS /
                        // macOS audio session interruption even though the track is
                        // unmuted. Re-arm the sender on every unmute for any WebKit
                        // runtime (Safari + plain iOS WKWebViews). Skipped when the
                        // page is hidden because the encoder won't resume until
                        // foreground anyway.
                        if (!muted && $8c05ed6f2f331ee8$var$isWebKit() && document.visibilityState !== 'hidden') this.call.refreshPublishedTrack(this.trackType).catch((err)=>{
                            this.logger.warn('Failed to refresh track on system unmute', err);
                        });
                        // report all tracks on mobile, and only Video on desktop browsers
                        if ($8c05ed6f2f331ee8$var$isMobile() || this.trackType == $8c05ed6f2f331ee8$var$TrackType.VIDEO) {
                            this.call.tracer.trace('navigator.mediaDevices.muteStateUpdated', {
                                trackType: $8c05ed6f2f331ee8$var$TrackType[this.trackType],
                                muted: muted
                            });
                            this.call.notifyTrackMuteState(muted, this.trackType).catch((err)=>{
                                this.logger.warn('Error while notifying track mute state', err);
                            });
                        }
                    };
                rootStream.getTracks().forEach((track)=>{
                    const muteHandler = createTrackMuteHandler(true);
                    const unmuteHandler = createTrackMuteHandler(false);
                    track.addEventListener('mute', muteHandler);
                    track.addEventListener('unmute', unmuteHandler);
                    track.addEventListener('ended', handleTrackEnded);
                    this.currentStreamCleanups.push(()=>{
                        track.removeEventListener('mute', muteHandler);
                        track.removeEventListener('unmute', unmuteHandler);
                        track.removeEventListener('ended', handleTrackEnded);
                    });
                });
                const initialMuted = rootStream.getTracks().some((t)=>t.muted);
                this.setLocalInterrupted(initialMuted);
            } else this.setLocalInterrupted(false);
        }
    }
    get mediaDeviceKind() {
        if (this.trackType === $8c05ed6f2f331ee8$var$TrackType.AUDIO) return 'audioinput';
        if (this.trackType === $8c05ed6f2f331ee8$var$TrackType.VIDEO) return 'videoinput';
        throw new Error('Invalid track type');
    }
    handleDisconnectedOrReplacedDevices() {
        this.subscriptions.push($8c05ed6f2f331ee8$var$createSubscription((0, $0e8b72f41887b114$export$77fa7d86f5204e8a)([
            $8c05ed6f2f331ee8$export$3a118dd49eed156c.pipe((0, $949f1fd33ffd44b7$export$8f9d79d42bff1aac)()),
            this.state.selectedDevice$
        ]), async ([[prevDevices, currentDevices], deviceId])=>{
            try {
                if (!deviceId) return;
                await this.statusChangeSettled();
                let isDeviceDisconnected = false;
                let isDeviceReplaced = false;
                const currentDevice = this.findDevice(currentDevices, deviceId);
                const prevDevice = this.findDevice(prevDevices, deviceId);
                if (!currentDevice && prevDevice) isDeviceDisconnected = true;
                else if (currentDevice && prevDevice && currentDevice.deviceId === prevDevice.deviceId && currentDevice.groupId !== prevDevice.groupId) isDeviceReplaced = true;
                if (isDeviceDisconnected) {
                    this.dispatchDeviceDisconnectedEvent(prevDevice);
                    await this.disable();
                    await this.select(undefined);
                }
                if (isDeviceReplaced) {
                    if (this.isTrackStoppedDueToTrackEnd && this.state.status === 'disabled') {
                        await this.enable();
                        this.isTrackStoppedDueToTrackEnd = false;
                    } else if (!$8c05ed6f2f331ee8$var$hasPending(this.statusChangeConcurrencyTag)) await this.applySettingsToStream();
                }
            } catch (err) {
                this.logger.warn('Unexpected error while handling disconnected or replaced device', err);
            }
        }));
    }
    findDevice(devices, deviceId) {
        const kind = this.mediaDeviceKind;
        return devices.find((d)=>d.deviceId === deviceId && d.kind === kind);
    }
    dispatchDeviceDisconnectedEvent(device) {
        const event = {
            type: 'device.disconnected',
            call_cid: this.call.cid,
            status: this.isTrackStoppedDueToTrackEnd ? this.state.prevStatus : this.state.status,
            deviceId: device.deviceId,
            label: device.label,
            kind: device.kind
        };
        this.call.tracer.trace('device.disconnected', event);
        this.call.streamClient.dispatchEvent(event);
    }
    persistPreference(selectedDevice, status) {
        const deviceKind = this.mediaDeviceKind;
        const deviceKey = deviceKind === 'audioinput' ? 'microphone' : 'camera';
        const muted = status === 'disabled' ? true : status === 'enabled' ? false : undefined;
        const { storageKey: storageKey } = this.devicePersistence;
        if (!selectedDevice) {
            $8c05ed6f2f331ee8$var$writePreferences(undefined, deviceKey, muted, storageKey);
            return;
        }
        const devices = $8c05ed6f2f331ee8$var$getCurrentValue(this.listDevices()) || [];
        const currentDevice = this.findDevice(devices, selectedDevice) ?? $8c05ed6f2f331ee8$var$createSyntheticDevice(selectedDevice, deviceKind);
        $8c05ed6f2f331ee8$var$writePreferences(currentDevice, deviceKey, muted, storageKey);
    }
    async applyPersistedPreferences(enabledInCallType) {
        const deviceKey = this.trackType === $8c05ed6f2f331ee8$var$TrackType.AUDIO ? 'microphone' : 'camera';
        const preferences = $8c05ed6f2f331ee8$var$readPreferences(this.devicePersistence.storageKey);
        const preferenceList = $8c05ed6f2f331ee8$var$toPreferenceList(preferences[deviceKey]);
        if (preferenceList.length === 0) return false;
        let muted;
        let appliedDevice = false;
        let appliedMute = false;
        const devices = await (0, $e61e581d31b1ea5f$export$400f9f949cef996c)(this.listDevices());
        for (const preference of preferenceList){
            muted ?? (muted = preference.muted);
            if (preference.selectedDeviceId === $8c05ed6f2f331ee8$var$defaultDeviceId) break;
            const device = devices.find((d)=>d.deviceId === preference.selectedDeviceId) ?? devices.find((d)=>d.label === preference.selectedDeviceLabel);
            if (device) {
                appliedDevice = true;
                if (!this.state.selectedDevice) await this.select(device.deviceId);
                muted = preference.muted;
                break;
            }
        }
        const canPublish = this.call.permissionsContext.canPublish(this.trackType);
        if (typeof muted === 'boolean' && enabledInCallType && canPublish) {
            await this.applyMutedState(muted);
            appliedMute = true;
        }
        return appliedDevice || appliedMute;
    }
    async applyMutedState(muted) {
        if (this.state.status !== undefined) return;
        if (muted) await this.disable();
        else await this.enable();
    }
}
class $8c05ed6f2f331ee8$export$397ca2ea8a727e40 {
    /**
     * Constructs a new InputMediaDeviceManagerState instance.
     *
     * @param disableMode the disable mode to use.
     * @param permission the BrowserPermission to use for querying.
     * `undefined` means no permission is required.
     */ constructor(disableMode, permission){
        this.statusSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(undefined);
        this.optimisticStatusSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(undefined);
        this.mediaStreamSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(undefined);
        this.rootMediaStreamSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(undefined);
        this.selectedDeviceSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(undefined);
        this.defaultConstraintsSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(undefined);
        /**
         * An Observable that emits the current media stream, or `undefined` if the device is currently disabled.
         */ this.mediaStream$ = this.mediaStreamSubject.asObservable();
        /**
         * An Observable that emits the raw device media stream (before any filters are applied),
         * or `undefined` if the device is currently disabled. When no filters are active, this
         * emits the same stream as `mediaStream$`.
         */ this.rootMediaStream$ = this.rootMediaStreamSubject.asObservable();
        /**
         * An Observable that emits the currently selected device
         */ this.selectedDevice$ = this.selectedDeviceSubject.asObservable().pipe((0, $6fb8b1c12553edae$export$779c5fb865a0172e)());
        /**
         * An Observable that emits the device status
         */ this.status$ = this.statusSubject.asObservable().pipe((0, $6fb8b1c12553edae$export$779c5fb865a0172e)());
        /**
         * An Observable the reflects the requested device status. Useful for optimistic UIs
         */ this.optimisticStatus$ = this.optimisticStatusSubject.asObservable().pipe((0, $6fb8b1c12553edae$export$779c5fb865a0172e)());
        /**
         * The default constraints for the device.
         */ this.defaultConstraints$ = this.defaultConstraintsSubject.asObservable();
        this.disableMode = disableMode;
        this.hasBrowserPermission$ = permission ? permission.asObservable().pipe((0, $cd8167599454f872$export$db61d692014e534e)(1)) : (0, $195e3b3043565ec4$export$ba255e9e49e00608)(true);
        this.browserPermissionState$ = permission ? permission.asStateObservable().pipe((0, $cd8167599454f872$export$db61d692014e534e)(1)) : (0, $195e3b3043565ec4$export$ba255e9e49e00608)('prompt');
        this.isPromptingPermission$ = permission ? permission.getIsPromptingObservable().pipe((0, $cd8167599454f872$export$db61d692014e534e)(1)) : (0, $195e3b3043565ec4$export$ba255e9e49e00608)(false);
    }
    /**
     * The device status
     */ get status() {
        return $8c05ed6f2f331ee8$var$getCurrentValue(this.status$);
    }
    /**
     * The requested device status. Useful for optimistic UIs
     */ get optimisticStatus() {
        return $8c05ed6f2f331ee8$var$getCurrentValue(this.optimisticStatus$);
    }
    /**
     * The currently selected device
     */ get selectedDevice() {
        return $8c05ed6f2f331ee8$var$getCurrentValue(this.selectedDevice$);
    }
    /**
     * The current media stream, or `undefined` if the device is currently disabled.
     */ get mediaStream() {
        return $8c05ed6f2f331ee8$var$getCurrentValue(this.mediaStream$);
    }
    /**
     * The raw device media stream (before any filters are applied), or `undefined`
     * if the device is currently disabled. When no filters are active, this is the
     * same as `mediaStream`.
     */ get rootMediaStream() {
        return $8c05ed6f2f331ee8$var$getCurrentValue(this.rootMediaStream$);
    }
    /**
     * @internal
     * @param status
     */ setStatus(status) {
        $8c05ed6f2f331ee8$var$setCurrentValue(this.statusSubject, status);
    }
    /**
     * @internal
     * @param pendingStatus
     */ setPendingStatus(pendingStatus) {
        $8c05ed6f2f331ee8$var$setCurrentValue(this.optimisticStatusSubject, pendingStatus);
    }
    /**
     * Updates the `mediaStream` state variable.
     *
     * @internal
     * @param stream the stream to set.
     * @param rootStream the root stream, applicable when filters are used
     * as this is the stream that holds the actual deviceId information.
     */ setMediaStream(stream, rootStream) {
        $8c05ed6f2f331ee8$var$setCurrentValue(this.mediaStreamSubject, stream);
        $8c05ed6f2f331ee8$var$setCurrentValue(this.rootMediaStreamSubject, rootStream);
        if (rootStream) {
            const derived = this.getDeviceIdFromStream(rootStream);
            if (derived) this.setDevice(derived);
        }
    }
    /**
     * @internal
     * @param deviceId the device id to set.
     */ setDevice(deviceId) {
        $8c05ed6f2f331ee8$var$setCurrentValue(this.selectedDeviceSubject, deviceId);
    }
    /**
     * Gets the default constraints for the device.
     */ get defaultConstraints() {
        return $8c05ed6f2f331ee8$var$getCurrentValue(this.defaultConstraints$);
    }
    /**
     * Sets the default constraints for the device.
     *
     * @internal
     * @param constraints the constraints to set.
     */ setDefaultConstraints(constraints) {
        $8c05ed6f2f331ee8$var$setCurrentValue(this.defaultConstraintsSubject, constraints);
    }
}
class $8c05ed6f2f331ee8$export$d4ec46415bca8c07 extends $8c05ed6f2f331ee8$export$397ca2ea8a727e40 {
    constructor(tracer){
        super('stop-tracks', $8c05ed6f2f331ee8$export$c0f343b08c967c50(tracer));
        this.directionSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(undefined);
        /**
         * Observable that emits the preferred camera direction
         * front - means the camera facing the user
         * back - means the camera facing the environment
         */ this.direction$ = this.directionSubject.asObservable().pipe((0, $6fb8b1c12553edae$export$779c5fb865a0172e)());
    }
    /**
     * The preferred camera direction
     * front - means the camera facing the user
     * back - means the camera facing the environment
     */ get direction() {
        return $8c05ed6f2f331ee8$var$getCurrentValue(this.direction$);
    }
    /**
     * @internal
     */ setDirection(direction) {
        $8c05ed6f2f331ee8$var$setCurrentValue(this.directionSubject, direction);
    }
    /**
     * @internal
     */ setMediaStream(stream, rootStream) {
        super.setMediaStream(stream, rootStream);
        if (stream) {
            // RN getSettings() doesn't return facingMode, so we don't verify camera direction
            const direction = $8c05ed6f2f331ee8$var$isReactNative() ? this.direction : stream.getVideoTracks()[0]?.getSettings().facingMode === 'environment' ? 'back' : 'front';
            this.setDirection(direction);
        }
    }
    getDeviceIdFromStream(stream) {
        const [track] = stream.getVideoTracks();
        return track?.getSettings().deviceId;
    }
}
class $8c05ed6f2f331ee8$export$2c292fd153a01657 extends $8c05ed6f2f331ee8$export$eba397ca40625ced {
    /**
     * Constructs a new CameraManager.
     *
     * @param call the call instance.
     * @param devicePersistence the device persistence preferences to use.
     */ constructor(call, devicePersistence){
        super(call, new $8c05ed6f2f331ee8$export$d4ec46415bca8c07(call.tracer), $8c05ed6f2f331ee8$var$TrackType.VIDEO, devicePersistence);
        this.targetResolution = {
            width: 1280,
            height: 720
        };
    }
    isDirectionSupportedByDevice() {
        return $8c05ed6f2f331ee8$var$isReactNative() || $8c05ed6f2f331ee8$var$isMobile();
    }
    /**
     * Select the camera direction.
     *
     * @param direction the direction of the camera to select.
     * @param options additional direction selection options.
     */ async selectDirection(direction, options = {}) {
        if (!this.isDirectionSupportedByDevice()) {
            this.logger.warn('Setting direction is not supported on this device');
            return;
        }
        if ($8c05ed6f2f331ee8$var$isReactNative()) {
            const videoTrack = this.getTracks()[0];
            await videoTrack?.applyConstraints({
                facingMode: direction === 'front' ? 'user' : 'environment'
            });
        }
        // providing both device id and direction doesn't work, so we deselect the device
        this.state.setDirection(direction);
        this.state.setDevice(undefined);
        const { enableCamera: enableCamera = true } = options;
        if ($8c05ed6f2f331ee8$var$isReactNative() || !enableCamera) return;
        this.getTracks().forEach((track)=>track.stop());
        try {
            await this.unmuteStream();
        } catch (error) {
            if (error instanceof Error && error.name === 'NotReadableError') {
                // the camera is already in use, and the device can't use it unless it's released.
                // in that case, we need to stop the stream and start it again.
                await this.muteStream();
                await this.unmuteStream();
            }
            throw error;
        }
    }
    /**
     * Flips the camera direction: if it's front it will change to back, if it's back, it will change to front.
     *
     * Note: if there is no available camera with the desired direction, this method will do nothing.
     * @returns
     */ async flip() {
        const newDirection = this.state.direction === 'front' ? 'back' : 'front';
        await this.selectDirection(newDirection);
    }
    /**
     * @internal
     */ async selectTargetResolution(resolution) {
        // normalize target resolution to landscape format.
        // on mobile devices, the device itself adjusts the resolution to portrait or landscape
        // depending on the orientation of the device. using portrait resolution
        // will result in falling back to the default resolution (640x480).
        let { width: width, height: height } = resolution;
        if (width < height) [width, height] = [
            height,
            width
        ];
        this.targetResolution.height = height;
        this.targetResolution.width = width;
        if (this.state.optimisticStatus === 'enabled') try {
            await this.statusChangeSettled();
        } catch (error) {
            // couldn't enable device, target resolution will be applied the next time user attempts to start the device
            this.logger.warn('could not apply target resolution', error);
        }
        if (this.enabled && this.state.mediaStream) {
            const [videoTrack] = this.state.mediaStream.getVideoTracks();
            if (!videoTrack) return;
            const { width: w, height: h } = videoTrack.getSettings();
            if (w !== width || h !== height) {
                await this.applySettingsToStream();
                this.logger.debug(`${width}x${height} target resolution applied to media stream`);
            }
        }
    }
    /**
     * Applies the video settings to the camera.
     *
     * @param settings the video settings to apply.
     * @param publish whether to publish the stream after applying the settings.
     */ async apply(settings, publish) {
        // Wait for any in progress camera operation
        await this.statusChangeSettled();
        await this.selectTargetResolution(settings.target_resolution);
        const enabledInCallType = settings.enabled ?? true;
        const shouldApplyDefaults = this.state.status === undefined && this.state.optimisticStatus === undefined;
        let persistedPreferencesApplied = false;
        const permissionState = await (0, $e61e581d31b1ea5f$export$400f9f949cef996c)(this.state.browserPermissionState$);
        if (shouldApplyDefaults && this.devicePersistence.enabled && permissionState === 'granted') persistedPreferencesApplied = await this.applyPersistedPreferences(enabledInCallType);
        // apply a direction and enable the camera only if in "pristine" state,
        // and there are no persisted preferences
        const canPublish = this.call.permissionsContext.canPublish(this.trackType);
        if (shouldApplyDefaults && !persistedPreferencesApplied) {
            if (!this.state.direction && !this.state.selectedDevice) {
                const direction = settings.camera_facing === 'front' ? 'front' : 'back';
                await this.selectDirection(direction, {
                    enableCamera: false
                });
            }
            if (canPublish && settings.camera_default_on && enabledInCallType) await this.enable();
        }
        const { mediaStream: mediaStream } = this.state;
        if (canPublish && publish && this.enabled && mediaStream) await this.publishStream(mediaStream);
    }
    getDevices() {
        return $8c05ed6f2f331ee8$export$4a7ff4b5d982ac98(this.call.tracer);
    }
    getResolvedConstraints(constraints) {
        constraints.width = this.targetResolution.width;
        constraints.height = this.targetResolution.height;
        // We can't set both device id and facing mode
        // Device id has higher priority
        if (!constraints.deviceId && this.state.direction && this.isDirectionSupportedByDevice()) constraints.facingMode = this.state.direction === 'front' ? 'user' : 'environment';
        return constraints;
    }
    getStream(constraints) {
        return $8c05ed6f2f331ee8$export$1dad1ad182e4457a(constraints, this.call.tracer);
    }
}
/**
 * Base class for High Fidelity enabled Device Managers.
 */ class $8c05ed6f2f331ee8$var$AudioDeviceManager extends $8c05ed6f2f331ee8$export$eba397ca40625ced {
    /**
     * Sets the audio bitrate profile and stereo mode.
     */ async setAudioBitrateProfile(profile) {
        if (!this.call.state.settings?.audio.hifi_audio_enabled) throw new Error('High Fidelity audio is not enabled for this call');
        this.doSetAudioBitrateProfile(profile);
        this.state.setAudioBitrateProfile(profile);
        if (this.enabled) await this.applySettingsToStream();
    }
    /**
     * Overrides the default `publishStream` method to inject the audio bitrate profile.
     */ publishStream(stream, options) {
        return super.publishStream(stream, {
            audioBitrateProfile: this.state.audioBitrateProfile,
            ...options
        });
    }
}
/**
 * Prepares a new MediaTrackConstraints set based on the provided arguments.
 */ const $8c05ed6f2f331ee8$var$createAudioConstraints = (profile)=>{
    const stereo = profile === $8c05ed6f2f331ee8$var$AudioBitrateProfile.MUSIC_HIGH_QUALITY;
    return {
        echoCancellation: !stereo,
        noiseSuppression: !stereo,
        autoGainControl: !stereo,
        channelCount: {
            ideal: stereo ? 2 : 1
        }
    };
};
/**
 * Base state class for High Fidelity enabled device managers.
 */ class $8c05ed6f2f331ee8$var$AudioDeviceManagerState extends $8c05ed6f2f331ee8$export$397ca2ea8a727e40 {
    /**
     * Constructs a new AudioDeviceManagerState instance.
     */ constructor(disableMode, permission, profile){
        super(disableMode, permission);
        this.audioBitrateProfileSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(profile);
        this.audioBitrateProfile$ = this.audioBitrateProfileSubject.asObservable().pipe((0, $6fb8b1c12553edae$export$779c5fb865a0172e)());
    }
    /**
     * Returns the current audio bitrate profile.
     */ get audioBitrateProfile() {
        return $8c05ed6f2f331ee8$var$getCurrentValue(this.audioBitrateProfile$);
    }
    /**
     * Sets the audio bitrate profile and stereo mode.
     */ setAudioBitrateProfile(profile) {
        $8c05ed6f2f331ee8$var$setCurrentValue(this.audioBitrateProfileSubject, profile);
    }
}
class $8c05ed6f2f331ee8$export$8dd681274b08c92f extends $8c05ed6f2f331ee8$var$AudioDeviceManagerState {
    constructor(disableMode, tracer){
        super(disableMode, $8c05ed6f2f331ee8$export$d0940718070360d2(tracer), $8c05ed6f2f331ee8$var$AudioBitrateProfile.VOICE_STANDARD_UNSPECIFIED);
        this.speakingWhileMutedSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(false);
        /**
         * An Observable that emits `true` if the user's microphone is muted, but they're speaking.
         */ this.speakingWhileMuted$ = this.speakingWhileMutedSubject.asObservable().pipe((0, $6fb8b1c12553edae$export$779c5fb865a0172e)());
    }
    /**
     * `true` if the user's microphone is muted but they're speaking.
     */ get speakingWhileMuted() {
        return $8c05ed6f2f331ee8$var$getCurrentValue(this.speakingWhileMuted$);
    }
    /**
     * @internal
     */ setSpeakingWhileMuted(isSpeaking) {
        $8c05ed6f2f331ee8$var$setCurrentValue(this.speakingWhileMutedSubject, isSpeaking);
    }
    getDeviceIdFromStream(stream) {
        const [track] = stream.getAudioTracks();
        const unresolvedDeviceId = track?.getSettings().deviceId;
        return $8c05ed6f2f331ee8$export$3221e2b6340be5d0(unresolvedDeviceId, 'audioinput');
    }
}
/**
 * Creates a new sound detector.
 *
 * @param audioStream the audio stream to observe. Depending on the provided configuration, this stream might be destroyed when the sound detector is stopped.
 * @param onSoundDetectedStateChanged a callback which is called when the sound state changes.
 * @param options custom options for the sound detector.
 * @returns a clean-up function which once invoked stops the sound detector.
 */ const $8c05ed6f2f331ee8$export$9f29a566f11763f3 = (audioStream, onSoundDetectedStateChanged, options = {})=>{
    const { detectionFrequencyInMs: detectionFrequencyInMs = 500, audioLevelThreshold: audioLevelThreshold = 150, fftSize: fftSize = 128, destroyStreamOnStop: destroyStreamOnStop = true } = options;
    const audioContext = new AudioContext();
    const analyser = audioContext.createAnalyser();
    analyser.fftSize = fftSize;
    const microphone = audioContext.createMediaStreamSource(audioStream);
    microphone.connect(analyser);
    const intervalId = setInterval(()=>{
        const data = new Uint8Array(analyser.frequencyBinCount);
        analyser.getByteFrequencyData(data);
        const isSoundDetected = data.some((value)=>value >= audioLevelThreshold);
        const averagedDataValue = data.reduce((pv, cv)=>pv + cv, 0) / data.length;
        const percentage = averagedDataValue > audioLevelThreshold ? 100 : Math.round(averagedDataValue / audioLevelThreshold * 100);
        // When the track is disabled, it takes time for the buffer to empty
        // This check will ensure that we don't send anything if the track is disabled
        if (audioStream.getAudioTracks()[0]?.enabled) onSoundDetectedStateChanged({
            isSoundDetected: isSoundDetected,
            audioLevel: percentage
        });
        else onSoundDetectedStateChanged({
            isSoundDetected: false,
            audioLevel: 0
        });
    }, detectionFrequencyInMs);
    return async function stop() {
        clearInterval(intervalId);
        // clean-up the AudioContext elements
        microphone.disconnect();
        analyser.disconnect();
        if (audioContext.state !== 'closed') await audioContext.close();
        // stop the stream
        if (destroyStreamOnStop) audioStream.getTracks().forEach((track)=>{
            track.stop();
            audioStream.removeTrack(track);
        });
    };
};
/**
 * Analyzes time-domain waveform data to determine if audio is being captured.
 * Uses the waveform RMS around the 128 midpoint for robust silence detection.
 */ const $8c05ed6f2f331ee8$var$hasAudio = (analyser)=>{
    const data = new Uint8Array(analyser.fftSize);
    analyser.getByteTimeDomainData(data);
    let squareSum = 0;
    for (const sample of data){
        const centered = sample - 128;
        // Ignore tiny quantization/jitter around midpoint (e.g. 127/128 samples).
        const signal = Math.abs(centered) <= 1 ? 0 : centered;
        squareSum += signal * signal;
    }
    const rms = Math.sqrt(squareSum / data.length);
    return rms > 0;
};
/** Helper for "no event" transitions */ const $8c05ed6f2f331ee8$var$noEmit = (nextState)=>({
        shouldEmit: false,
        nextState: nextState
    });
/** Helper for event-emitting transitions */ const $8c05ed6f2f331ee8$var$emit = (capturesAudio, nextState)=>({
        shouldEmit: true,
        nextState: nextState,
        capturesAudio: capturesAudio
    });
/**
 * State transition function - computes next state and whether to emit an event.
 */ const $8c05ed6f2f331ee8$var$transitionState = (state, audioDetected, options)=>{
    if (audioDetected) // Any observed audio means the microphone is capturing.
    // Emit recovery/success and let the caller stop the detector.
    return $8c05ed6f2f331ee8$var$emit(true, {
        kind: 'IDLE'
    });
    const { noAudioThresholdMs: noAudioThresholdMs, emitIntervalMs: emitIntervalMs } = options;
    const now = Date.now();
    switch(state.kind){
        case 'IDLE':
            return $8c05ed6f2f331ee8$var$noEmit({
                kind: 'DETECTING',
                noAudioStartTime: now
            });
        case 'DETECTING':
            {
                const { noAudioStartTime: noAudioStartTime } = state;
                const elapsed = now - noAudioStartTime;
                return elapsed >= noAudioThresholdMs ? $8c05ed6f2f331ee8$var$emit(false, {
                    kind: 'EMITTING',
                    noAudioStartTime: noAudioStartTime,
                    lastEmitTime: now
                }) : $8c05ed6f2f331ee8$var$noEmit(state);
            }
        case 'EMITTING':
            {
                const timeSinceLastEmit = now - state.lastEmitTime;
                return timeSinceLastEmit >= emitIntervalMs ? $8c05ed6f2f331ee8$var$emit(false, {
                    ...state,
                    lastEmitTime: now
                }) : $8c05ed6f2f331ee8$var$noEmit(state);
            }
    }
};
/**
 * Creates and configures an audio analyzer for the given stream.
 */ const $8c05ed6f2f331ee8$var$createAudioAnalyzer = (audioStream, fftSize)=>{
    const audioContext = new AudioContext();
    const analyser = audioContext.createAnalyser();
    analyser.fftSize = fftSize;
    const microphone = audioContext.createMediaStreamSource(audioStream);
    microphone.connect(analyser);
    return {
        audioContext: audioContext,
        analyser: analyser
    };
};
/**
 * Creates a new no-audio detector that monitors continuous absence of audio on an audio stream.
 *
 * @param audioStream the audio stream to observe.
 * @param options custom options for the no-audio detector.
 * @returns a cleanup function which once invoked stops the no-audio detector.
 */ const $8c05ed6f2f331ee8$var$createNoAudioDetector = (audioStream, options)=>{
    const { detectionFrequencyInMs: detectionFrequencyInMs = 350, fftSize: fftSize = 512, onCaptureStatusChange: onCaptureStatusChange } = options;
    let state = {
        kind: 'IDLE'
    };
    const { audioContext: audioContext, analyser: analyser } = $8c05ed6f2f331ee8$var$createAudioAnalyzer(audioStream, fftSize);
    const detectionIntervalId = setInterval(()=>{
        const [track] = audioStream.getAudioTracks();
        if (track && !track.enabled) {
            state = {
                kind: 'IDLE'
            };
            return;
        }
        // Missing or ended track is treated as no-audio to surface abrupt capture loss.
        const audioDetected = track?.readyState === 'live' && $8c05ed6f2f331ee8$var$hasAudio(analyser);
        const transition = $8c05ed6f2f331ee8$var$transitionState(state, audioDetected, options);
        state = transition.nextState;
        if (!transition.shouldEmit) return;
        const { capturesAudio: capturesAudio } = transition;
        onCaptureStatusChange(capturesAudio);
        if (capturesAudio) stop().catch((err)=>{
            const logger = $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger('NoAudioDetector');
            logger.error('Error stopping no-audio detector', err);
        });
    }, detectionFrequencyInMs);
    async function stop() {
        clearInterval(detectionIntervalId);
        if (audioContext.state !== 'closed') await audioContext.close();
    }
    return stop;
};
class $8c05ed6f2f331ee8$export$e454f5428368fe79 extends $8c05ed6f2f331ee8$var$AudioDeviceManager {
    constructor(call, devicePersistence, disableMode = 'stop-tracks'){
        super(call, new $8c05ed6f2f331ee8$export$8dd681274b08c92f(disableMode, call.tracer), $8c05ed6f2f331ee8$var$TrackType.AUDIO, devicePersistence);
        this.speakingWhileMutedNotificationEnabled = true;
        this.soundDetectorConcurrencyTag = Symbol('soundDetectorConcurrencyTag');
        this.silenceThresholdMs = 5000;
    }
    setup() {
        if (this.areSubscriptionsSetUp) return;
        super.setup();
        this.subscriptions.push($8c05ed6f2f331ee8$var$createSafeAsyncSubscription((0, $0e8b72f41887b114$export$77fa7d86f5204e8a)([
            this.call.state.callingState$,
            this.call.state.ownCapabilities$,
            this.state.selectedDevice$,
            this.state.status$,
            this.state.browserPermissionState$
        ]), async ([callingState, ownCapabilities, deviceId, status, permissionState])=>{
            try {
                if (callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.LEFT) {
                    this.setMutedRecordingPrepared(false);
                    await this.stopSpeakingWhileMutedDetection();
                }
                if (callingState !== $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.JOINED) return;
                if (!this.speakingWhileMutedNotificationEnabled) return;
                if (ownCapabilities.includes($8c05ed6f2f331ee8$export$9d72b1bd9eedd7a7.SEND_AUDIO)) {
                    const hasPermission = await this.hasPermission(permissionState);
                    if (hasPermission && status !== 'enabled') {
                        this.setMutedRecordingPrepared(true);
                        await this.startSpeakingWhileMutedDetection(deviceId);
                    } else {
                        this.setMutedRecordingPrepared(false);
                        await this.stopSpeakingWhileMutedDetection();
                    }
                } else {
                    this.setMutedRecordingPrepared(false);
                    await this.stopSpeakingWhileMutedDetection();
                }
            } catch (err) {
                this.logger.warn('Could not enable speaking while muted', err);
            }
        }));
        this.subscriptions.push($8c05ed6f2f331ee8$var$createSubscription(this.call.state.callingState$, (callingState)=>{
            // do nothing when noise filtering isn't turned on
            if (!this.noiseCancellationRegistration || !this.noiseCancellation) return;
            const autoOn = this.call.state.settings?.audio.noise_cancellation?.mode === $8c05ed6f2f331ee8$export$fa8c5a4bee8a4778.AUTO_ON;
            if (autoOn && callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.JOINED) this.noiseCancellationRegistration.then(()=>{
                if (this.noiseCancellation?.canAutoEnable) return this.noiseCancellation.canAutoEnable();
                return true;
            }).then((canAutoEnable)=>{
                if (canAutoEnable) this.noiseCancellation?.enable().catch((err)=>{
                    this.logger.warn('Failed to enable noise cancellation', err);
                });
            }).catch((err)=>{
                this.logger.warn(`Failed to enable noise cancellation`, err);
                return this.call.notifyNoiseCancellationStopped();
            });
            else if (callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.LEFT) this.noiseCancellationRegistration.then(()=>this.noiseCancellation?.disable()).catch((err)=>{
                this.logger.warn(`Failed to disable noise cancellation`, err);
            });
        }));
        if (!$8c05ed6f2f331ee8$var$isReactNative()) {
            const unsubscribe = $8c05ed6f2f331ee8$var$createSafeAsyncSubscription((0, $0e8b72f41887b114$export$77fa7d86f5204e8a)([
                this.state.status$,
                this.state.mediaStream$
            ]), async ([status, mediaStream])=>{
                if (this.noAudioDetectorCleanup) {
                    const cleanup = this.noAudioDetectorCleanup;
                    this.noAudioDetectorCleanup = undefined;
                    await cleanup().catch((err)=>{
                        this.logger.warn('Failed to stop no-audio detector', err);
                    });
                }
                if (status !== 'enabled' || !mediaStream) return;
                if (this.silenceThresholdMs <= 0) return;
                const deviceId = this.state.selectedDevice;
                const devices = await (0, $e61e581d31b1ea5f$export$400f9f949cef996c)(this.listDevices());
                const label = devices.find((d)=>d.deviceId === deviceId)?.label;
                let lastCapturesAudio;
                this.noAudioDetectorCleanup = $8c05ed6f2f331ee8$var$createNoAudioDetector(mediaStream, {
                    noAudioThresholdMs: this.silenceThresholdMs,
                    emitIntervalMs: this.silenceThresholdMs,
                    onCaptureStatusChange: (capturesAudio)=>{
                        const event = {
                            type: 'mic.capture_report',
                            call_cid: this.call.cid,
                            capturesAudio: capturesAudio,
                            deviceId: deviceId,
                            label: label
                        };
                        if (capturesAudio !== lastCapturesAudio) {
                            lastCapturesAudio = capturesAudio;
                            this.call.tracer.trace('mic.capture_report', event);
                        }
                        this.call.streamClient.dispatchEvent(event);
                    }
                });
            });
            this.subscriptions.push(unsubscribe);
        }
    }
    /**
     * Enables noise cancellation for the microphone.
     *
     * @param noiseCancellation - a noise cancellation instance to use.
     */ async enableNoiseCancellation(noiseCancellation) {
        const { ownCapabilities: ownCapabilities, settings: settings } = this.call.state;
        const hasNoiseCancellationCapability = ownCapabilities.includes($8c05ed6f2f331ee8$export$9d72b1bd9eedd7a7.ENABLE_NOISE_CANCELLATION);
        if (!hasNoiseCancellationCapability) throw new Error('Noise cancellation is not available.');
        const noiseCancellationSettings = settings?.audio.noise_cancellation;
        if (!noiseCancellationSettings || noiseCancellationSettings.mode === $8c05ed6f2f331ee8$export$fa8c5a4bee8a4778.DISABLED) throw new Error('Noise cancellation is disabled for this call type.');
        try {
            this.noiseCancellation = noiseCancellation;
            // listen for change events and notify the SFU
            this.noiseCancellationChangeUnsubscribe = this.noiseCancellation.on('change', (enabled)=>{
                this.call.tracer.trace('noiseCancellation.enabled', enabled);
                if (enabled) this.call.notifyNoiseCancellationStarting().catch((err)=>{
                    this.logger.warn(`notifyNoiseCancellationStart failed`, err);
                });
                else this.call.notifyNoiseCancellationStopped().catch((err)=>{
                    this.logger.warn(`notifyNoiseCancellationStop failed`, err);
                });
            });
            if ($8c05ed6f2f331ee8$var$isReactNative()) // no filter registration in React Native, its done in the native code on app init
            this.noiseCancellationRegistration = Promise.resolve();
            else {
                const registrationResult = this.registerFilter(noiseCancellation.toFilter());
                this.noiseCancellationRegistration = registrationResult.registered;
                this.unregisterNoiseCancellation = registrationResult.unregister;
                await this.noiseCancellationRegistration;
            }
            // handles an edge case where a noise cancellation is enabled after
            // the participant as joined the call -> we immediately enable NC
            if (noiseCancellationSettings.mode === $8c05ed6f2f331ee8$export$fa8c5a4bee8a4778.AUTO_ON && this.call.state.callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.JOINED) {
                let canAutoEnable = true;
                if (noiseCancellation.canAutoEnable) canAutoEnable = await noiseCancellation.canAutoEnable();
                if (canAutoEnable) noiseCancellation.enable().catch((err)=>{
                    this.logger.warn('Failed to enable noise cancellation', err);
                });
            }
        } catch (e) {
            this.logger.warn('Failed to enable noise cancellation', e);
            await this.disableNoiseCancellation().catch((err)=>{
                this.logger.warn('Failed to disable noise cancellation', err);
            });
            throw e;
        }
    }
    /**
     * Disables noise cancellation for the microphone.
     */ async disableNoiseCancellation() {
        await (this.unregisterNoiseCancellation?.() ?? Promise.resolve()).then(()=>this.noiseCancellation?.disable()).then(()=>this.noiseCancellationChangeUnsubscribe?.()).catch((err)=>{
            this.logger.warn('Failed to unregister noise cancellation', err);
        });
        this.call.tracer.trace('noiseCancellation.disabled', true);
        await this.call.notifyNoiseCancellationStopped();
    }
    /**
     * Enables speaking while muted notification.
     */ async enableSpeakingWhileMutedNotification() {
        this.speakingWhileMutedNotificationEnabled = true;
        if (this.state.status === 'disabled') await this.startSpeakingWhileMutedDetection(this.state.selectedDevice);
    }
    /**
     * Disables speaking while muted notification.
     */ async disableSpeakingWhileMutedNotification() {
        this.speakingWhileMutedNotificationEnabled = false;
        await this.stopSpeakingWhileMutedDetection();
    }
    /**
     * Sets the silence threshold in milliseconds for no-audio detection.
     * When the microphone is enabled but produces no audio for this duration,
     * a 'mic.capture_report' event will be emitted.
     *
     * @param thresholdMs the threshold in milliseconds (default: 5000).
     *   Set to 0 or a negative value to disable no-audio detection.
     */ setSilenceThreshold(thresholdMs) {
        this.silenceThresholdMs = thresholdMs;
    }
    /**
     * Performs audio capture test on a specific microphone.
     *
     * This method is only available in browser environments (not React Native).
     *
     * @param deviceId The device ID to test.
     * @param options Optional test configuration.
     * @returns Promise that resolves with the test result (true or false).
     */ async performTest(deviceId, options) {
        if ($8c05ed6f2f331ee8$var$isReactNative()) throw new Error('Not available in React Native');
        const stream = await this.getStream({
            deviceId: {
                exact: deviceId
            }
        });
        const { testDurationMs: testDurationMs = 3000 } = options || {};
        const { promise: promise, resolve: resolve } = $8c05ed6f2f331ee8$var$promiseWithResolvers();
        const cleanup = $8c05ed6f2f331ee8$var$createNoAudioDetector(stream, {
            noAudioThresholdMs: testDurationMs,
            emitIntervalMs: testDurationMs,
            onCaptureStatusChange: async (capturesAudio)=>{
                resolve(capturesAudio);
                await cleanup().catch((err)=>{
                    this.logger.warn('Failed to stop detector during test', err);
                });
                $8c05ed6f2f331ee8$export$25e2adef97670503(stream);
            }
        });
        return promise;
    }
    /**
     * Applies the audio settings to the microphone.
     * @param settings the audio settings to apply.
     * @param publish whether to publish the stream after applying the settings.
     */ async apply(settings, publish) {
        // Wait for any in progress mic operation
        await this.statusChangeSettled();
        // apply server-side settings only when the device state is pristine
        // and there are no persisted preferences
        const shouldApplyDefaults = this.state.status === undefined && this.state.optimisticStatus === undefined;
        let persistedPreferencesApplied = false;
        const permissionState = await (0, $e61e581d31b1ea5f$export$400f9f949cef996c)(this.state.browserPermissionState$);
        if (shouldApplyDefaults && this.devicePersistence.enabled && permissionState === 'granted') persistedPreferencesApplied = await this.applyPersistedPreferences(true);
        const canPublish = this.call.permissionsContext.canPublish(this.trackType);
        if (shouldApplyDefaults && !persistedPreferencesApplied) {
            if (canPublish && settings.mic_default_on) await this.enable();
        }
        const { mediaStream: mediaStream } = this.state;
        if (canPublish && publish && this.enabled && mediaStream) await this.publishStream(mediaStream);
    }
    getDevices() {
        return $8c05ed6f2f331ee8$export$c9c435b44f16339f(this.call.tracer);
    }
    getStream(constraints) {
        return $8c05ed6f2f331ee8$export$f85bf5b5313d2d23(constraints, this.call.tracer);
    }
    doSetAudioBitrateProfile(profile) {
        this.setDefaultConstraints({
            ...this.state.defaultConstraints,
            ...$8c05ed6f2f331ee8$var$createAudioConstraints(profile)
        });
        if (this.noiseCancellation) {
            const disableAudioProcessing = profile === $8c05ed6f2f331ee8$var$AudioBitrateProfile.MUSIC_HIGH_QUALITY;
            if (disableAudioProcessing) this.noiseCancellation.disable().catch((err)=>{
                this.logger.warn('Failed to disable noise cancellation for music mode', err);
            }); // disable for high quality music mode
            else this.noiseCancellation.enable().catch((err)=>{
                this.logger.warn('Failed to enable noise cancellation', err);
            }); // restore it for other modes if available
        }
    }
    async startSpeakingWhileMutedDetection(deviceId) {
        await $8c05ed6f2f331ee8$var$withoutConcurrency(this.soundDetectorConcurrencyTag, async ()=>{
            if (this.soundDetectorCleanup && this.soundDetectorDeviceId === deviceId) return;
            await this.teardownSpeakingWhileMutedDetection();
            if ($8c05ed6f2f331ee8$var$isReactNative()) {
                const speechActivity = globalThis.streamRNVideoSDK?.nativeEvents?.speechActivity;
                if (!speechActivity) {
                    this.logger.warn('Native speech activity not available, make sure the "@stream-io/react-native-webrtc" peer dependency version is satisfied');
                    return;
                }
                const unsubscribe = speechActivity.subscribe((event)=>{
                    this.state.setSpeakingWhileMuted(event.isSoundDetected);
                });
                this.soundDetectorCleanup = async ()=>{
                    unsubscribe();
                };
            } else {
                // Need to start a new stream that's not connected to publisher
                const stream = await this.getStream({
                    ...this.state.defaultConstraints,
                    deviceId: {
                        exact: deviceId
                    }
                });
                this.soundDetectorCleanup = $8c05ed6f2f331ee8$export$9f29a566f11763f3(stream, (event)=>{
                    this.state.setSpeakingWhileMuted(event.isSoundDetected);
                });
            }
            this.soundDetectorDeviceId = deviceId;
        });
    }
    async stopSpeakingWhileMutedDetection() {
        await $8c05ed6f2f331ee8$var$withoutConcurrency(this.soundDetectorConcurrencyTag, async ()=>{
            return this.teardownSpeakingWhileMutedDetection();
        });
    }
    async teardownSpeakingWhileMutedDetection() {
        const soundDetectorCleanup = this.soundDetectorCleanup;
        this.soundDetectorCleanup = undefined;
        this.soundDetectorDeviceId = undefined;
        this.state.setSpeakingWhileMuted(false);
        if (!soundDetectorCleanup) return;
        await soundDetectorCleanup().catch((err)=>{
            this.logger.warn('Failed to stop speaking while muted detector', err);
        });
    }
    /**
     * iOS-only: keep the mic-input chain prepared while muted
     * so the `AVAudioEngine` stays full-duplex and remote audio renders on a
     * muted join.
     */ setMutedRecordingPrepared(enabled) {
        if (!$8c05ed6f2f331ee8$var$isReactNative()) return;
        globalThis.streamRNVideoSDK?.callManager.setMutedRecordingPrepared?.(enabled);
    }
    async hasPermission(permissionState) {
        if (!$8c05ed6f2f331ee8$var$isReactNative()) return permissionState === 'granted';
        const nativePermissions = globalThis.streamRNVideoSDK?.permissions;
        if (!nativePermissions) return true; // assume granted
        try {
            return await nativePermissions.check('microphone');
        } catch (err) {
            this.logger.warn('Failed to check permission', err);
            return false;
        }
    }
}
class $8c05ed6f2f331ee8$export$cd901d18ccfcf545 extends $8c05ed6f2f331ee8$var$AudioDeviceManagerState {
    /**
     * Constructs a new ScreenShareState instance.
     */ constructor(){
        super('stop-tracks', undefined, $8c05ed6f2f331ee8$var$AudioBitrateProfile.MUSIC_HIGH_QUALITY);
        this.audioEnabledSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(true);
        this.settingsSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(undefined);
        /**
         * An Observable that emits the current screen share audio status.
         */ this.audioEnabled$ = this.audioEnabledSubject.asObservable().pipe((0, $6fb8b1c12553edae$export$779c5fb865a0172e)());
        /**
         * An Observable that emits the current screen share settings.
         */ this.settings$ = this.settingsSubject.asObservable();
        /**
         * @internal
         */ this.getDeviceIdFromStream = (stream)=>{
            const [track] = stream.getTracks();
            return track?.getSettings().deviceId;
        };
    }
    /**
     * The current screen share audio status.
     */ get audioEnabled() {
        return $8c05ed6f2f331ee8$var$getCurrentValue(this.audioEnabled$);
    }
    /**
     * Set the current screen share audio status.
     */ setAudioEnabled(isEnabled) {
        $8c05ed6f2f331ee8$var$setCurrentValue(this.audioEnabledSubject, isEnabled);
    }
    /**
     * The current screen share settings.
     */ get settings() {
        return $8c05ed6f2f331ee8$var$getCurrentValue(this.settings$);
    }
    /**
     * Set the current screen share settings.
     *
     * @param settings the screen share settings to set.
     */ setSettings(settings) {
        $8c05ed6f2f331ee8$var$setCurrentValue(this.settingsSubject, settings);
    }
}
class $8c05ed6f2f331ee8$export$dd56c7406f7afaf3 extends $8c05ed6f2f331ee8$var$AudioDeviceManager {
    constructor(call){
        super(call, new $8c05ed6f2f331ee8$export$cd901d18ccfcf545(), $8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE, $8c05ed6f2f331ee8$var$normalize({
            enabled: false
        }));
    }
    setup() {
        if (this.areSubscriptionsSetUp) return;
        super.setup();
        this.subscriptions.push($8c05ed6f2f331ee8$var$createSubscription(this.call.state.settings$, (settings)=>{
            const maybeTargetResolution = settings?.screensharing.target_resolution;
            if (maybeTargetResolution) this.setDefaultConstraints({
                ...this.state.defaultConstraints,
                video: {
                    width: maybeTargetResolution.width,
                    height: maybeTargetResolution.height
                }
            });
        }));
    }
    /**
     * Will enable screen share audio options on supported platforms.
     *
     * Note: for ongoing screen share, audio won't be enabled until you
     * re-publish the screen share stream.
     */ enableScreenShareAudio() {
        this.state.setAudioEnabled(true);
    }
    /**
     * Will disable screen share audio options on supported platforms.
     */ async disableScreenShareAudio() {
        this.state.setAudioEnabled(false);
        if (this.call.publisher?.isPublishing($8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE_AUDIO)) await this.call.stopPublish($8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE_AUDIO);
    }
    /**
     * Returns the current screen share settings.
     */ getSettings() {
        return this.state.settings;
    }
    /**
     * Sets the current screen share settings.
     *
     * @param settings the settings to set.
     */ setSettings(settings) {
        this.state.setSettings(settings);
    }
    getDevices() {
        return (0, $195e3b3043565ec4$export$ba255e9e49e00608)([]); // there are no devices to be listed for Screen Share
    }
    async getStream(constraints) {
        if (!this.state.audioEnabled) constraints.audio = false;
        const stream = await $8c05ed6f2f331ee8$export$af5e380bd3bbac54(constraints, this.call.tracer);
        const [track] = stream.getVideoTracks();
        const { contentHint: contentHint } = this.state.settings || {};
        if (typeof contentHint !== 'undefined' && track && 'contentHint' in track) {
            this.call.tracer.trace('navigator.mediaDevices.getDisplayMedia.contentHint', contentHint);
            track.contentHint = contentHint;
        }
        return stream;
    }
    doSetAudioBitrateProfile(profile) {
        const { defaultConstraints: defaultConstraints } = this.state;
        const baseAudioConstraints = typeof defaultConstraints?.audio !== 'boolean' ? defaultConstraints?.audio : null;
        this.setDefaultConstraints({
            ...defaultConstraints,
            audio: {
                ...baseAudioConstraints,
                ...$8c05ed6f2f331ee8$var$createAudioConstraints(profile)
            }
        });
    }
    async stopPublishStream() {
        return this.call.stopPublish($8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE, $8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE_AUDIO);
    }
    /**
     * Overrides the default `select` method to throw an error.
     */ async select() {
        throw new Error('Not supported');
    }
}
class $8c05ed6f2f331ee8$export$fdc4601369bb334f {
    constructor(tracer){
        this.tracer = tracer;
        this.selectedDeviceSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)('');
        this.volumeSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(1);
        /**
         * [Tells if the browser supports audio output change on 'audio' elements](https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/setSinkId).
         */ this.isDeviceSelectionSupported = $8c05ed6f2f331ee8$export$3479a1b64a9a82cf();
        /**
         * An Observable that emits the currently selected device
         *
         * Note: this feature is not supported in React Native
         */ this.selectedDevice$ = this.selectedDeviceSubject.asObservable().pipe((0, $6fb8b1c12553edae$export$779c5fb865a0172e)());
        /**
         * An Observable that emits the currently selected volume
         *
         * Note: this feature is not supported in React Native
         */ this.volume$ = this.volumeSubject.asObservable().pipe((0, $6fb8b1c12553edae$export$779c5fb865a0172e)());
    }
    /**
     * The currently selected device
     *
     * Note: this feature is not supported in React Native
     */ get selectedDevice() {
        return $8c05ed6f2f331ee8$var$getCurrentValue(this.selectedDevice$);
    }
    /**
     * The currently selected volume
     *
     * Note: this feature is not supported in React Native
     */ get volume() {
        return $8c05ed6f2f331ee8$var$getCurrentValue(this.volume$);
    }
    /**
     * @internal
     * @param deviceId
     */ setDevice(deviceId) {
        $8c05ed6f2f331ee8$var$setCurrentValue(this.selectedDeviceSubject, deviceId);
        this.tracer.trace('navigator.mediaDevices.setSinkId', deviceId);
    }
    /**
     * @internal
     * @param volume
     */ setVolume(volume) {
        $8c05ed6f2f331ee8$var$setCurrentValue(this.volumeSubject, volume);
    }
}
class $8c05ed6f2f331ee8$export$aefaf8e7d93e41ca {
    constructor(call, devicePreferences){
        this.subscriptions = [];
        this.areSubscriptionsSetUp = false;
        /**
         * Disposes the manager.
         *
         * @internal
         */ this.dispose = ()=>{
            this.subscriptions.forEach((unsubscribe)=>unsubscribe());
            this.subscriptions = [];
            this.areSubscriptionsSetUp = false;
        };
        this.call = call;
        this.state = new $8c05ed6f2f331ee8$export$fdc4601369bb334f(call.tracer);
        this.devicePersistence = devicePreferences;
        this.setup();
    }
    apply(settings) {
        return $8c05ed6f2f331ee8$var$isReactNative() ? this.applyRN(settings) : this.applyWeb();
    }
    applyWeb() {
        const { enabled: enabled, storageKey: storageKey } = this.devicePersistence;
        if (!enabled) return;
        const preferences = $8c05ed6f2f331ee8$var$readPreferences(storageKey);
        const preferenceList = $8c05ed6f2f331ee8$var$toPreferenceList(preferences.speaker);
        if (preferenceList.length === 0) return;
        const preference = preferenceList[0];
        const nextDeviceId = preference.selectedDeviceId === $8c05ed6f2f331ee8$var$defaultDeviceId ? '' : preference.selectedDeviceId;
        if (this.state.selectedDevice !== nextDeviceId) this.select(nextDeviceId);
    }
    applyRN(settings) {
        /// Determines if the speaker should be enabled based on a priority hierarchy of
        /// settings.
        ///
        /// The priority order is as follows:
        /// 1. If video camera is set to be on by default, speaker is enabled
        /// 2. If audio speaker is set to be on by default, speaker is enabled
        /// 3. If the default audio device is set to speaker, speaker is enabled
        ///
        /// This ensures that the speaker state aligns with the most important user
        /// preference or system requirement.
        const speakerOnWithSettingsPriority = settings.video.camera_default_on || settings.audio.speaker_default_on || settings.audio.default_device === $8c05ed6f2f331ee8$export$cbbed47a9cfcfc9e.SPEAKER;
        const defaultDevice = speakerOnWithSettingsPriority ? $8c05ed6f2f331ee8$export$cbbed47a9cfcfc9e.SPEAKER : $8c05ed6f2f331ee8$export$cbbed47a9cfcfc9e.EARPIECE;
        if (this.defaultDevice !== defaultDevice) {
            this.call.logger.debug('SpeakerManager: setting default device', {
                defaultDevice: defaultDevice
            });
            this.defaultDevice = defaultDevice;
            globalThis.streamRNVideoSDK?.callManager.setup({
                defaultDevice: defaultDevice,
                isRingingTypeCall: this.call.ringing
            });
        }
    }
    setup() {
        if (this.areSubscriptionsSetUp) return;
        this.areSubscriptionsSetUp = true;
        if ($8c05ed6f2f331ee8$export$3a118dd49eed156c && !$8c05ed6f2f331ee8$var$isReactNative()) this.subscriptions.push($8c05ed6f2f331ee8$var$createSubscription((0, $0e8b72f41887b114$export$77fa7d86f5204e8a)([
            $8c05ed6f2f331ee8$export$3a118dd49eed156c,
            this.state.selectedDevice$
        ]), ([devices, deviceId])=>{
            if (!deviceId) return;
            const device = devices.find((d)=>d.deviceId === deviceId && d.kind === 'audiooutput');
            if (!device) this.select('');
        }));
        if (!$8c05ed6f2f331ee8$var$isReactNative() && this.devicePersistence.enabled) this.subscriptions.push($8c05ed6f2f331ee8$var$createSubscription((0, $0e8b72f41887b114$export$77fa7d86f5204e8a)([
            this.state.selectedDevice$,
            $8c05ed6f2f331ee8$export$d0940718070360d2(this.call.tracer).asStateObservable()
        ]), ([selectedDevice, browserPermissionState])=>{
            if (!selectedDevice || browserPermissionState !== 'granted') return;
            this.persistSpeakerDevicePreference(selectedDevice);
        }));
    }
    /**
     * Lists the available audio output devices
     *
     * Note: It prompts the user for a permission to use devices (if not already granted)
     * Note: This method is not supported in React Native
     *
     * @returns an Observable that will be updated if a device is connected or disconnected
     */ listDevices() {
        $8c05ed6f2f331ee8$var$assertUnsupportedInReactNative();
        return $8c05ed6f2f331ee8$export$e98be94900d6e6bb(this.call.tracer);
    }
    /**
     * Select a device.
     *
     * Note: This method is not supported in React Native
     *
     * @param deviceId empty string means the system default
     */ select(deviceId) {
        $8c05ed6f2f331ee8$var$assertUnsupportedInReactNative();
        this.state.setDevice(deviceId);
    }
    /**
     * Set the volume of the audio elements
     * @param volume a number between 0 and 1.
     *
     * Note: This method is not supported in React Native
     */ setVolume(volume) {
        $8c05ed6f2f331ee8$var$assertUnsupportedInReactNative();
        if (volume && (volume < 0 || volume > 1)) throw new Error('Volume must be between 0 and 1');
        this.state.setVolume(volume);
    }
    /**
     * Set the volume of a participant.
     *
     * @param sessionId the participant's session id.
     * @param volume a number between 0 and 1. Set it to `undefined` to use the default volume.
     */ setParticipantVolume(sessionId, volume) {
        if (volume && (volume < 0 || volume > 1)) throw new Error('Volume must be between 0 and 1, or undefined');
        this.call.state.updateParticipant(sessionId, (p)=>{
            if ($8c05ed6f2f331ee8$var$isReactNative() && p.audioStream) for (const track of p.audioStream.getAudioTracks())// @ts-expect-error track._setVolume is present in react-native-webrtc
            track?._setVolume(volume);
            return {
                audioVolume: volume
            };
        });
    }
    persistSpeakerDevicePreference(selectedDevice) {
        const { storageKey: storageKey } = this.devicePersistence;
        const devices = $8c05ed6f2f331ee8$var$getCurrentValue(this.listDevices()) || [];
        const currentDevice = devices.find((d)=>d.deviceId === selectedDevice) ?? $8c05ed6f2f331ee8$var$createSyntheticDevice(selectedDevice, 'audiooutput');
        $8c05ed6f2f331ee8$var$writePreferences(currentDevice, 'speaker', undefined, storageKey);
    }
}
const $8c05ed6f2f331ee8$var$assertUnsupportedInReactNative = ()=>{
    if ($8c05ed6f2f331ee8$var$isReactNative()) throw new Error('Unsupported in React Native. See: https://getstream.io/video/docs/react-native/guides/camera-and-microphone/#speaker-management');
};
/**
 * An object representation of a `Call`.
 */ class $8c05ed6f2f331ee8$export$e01e40655568efad {
    /**
     * Constructs a new `Call` instance.
     *
     * NOTE: Don't call the constructor directly, instead
     * Use the [`StreamVideoClient.call`](./StreamVideoClient.md/#call)
     * method to construct a `Call` instance.
     */ constructor({ type: type, id: id, streamClient: streamClient, clientEventReporter: clientEventReporter, members: members, ownCapabilities: ownCapabilities, sortParticipantsBy: sortParticipantsBy, clientStore: clientStore, ringing: ringing = false, watching: watching = false }){
        /**
         * The state of this call.
         */ this.state = new $8c05ed6f2f331ee8$export$ab5ecb1e832001a8();
        /**
         * The permissions context of this call.
         */ this.permissionsContext = new $8c05ed6f2f331ee8$var$PermissionsContext();
        this.tracer = new $8c05ed6f2f331ee8$var$Tracer(null);
        /**
         * The event dispatcher instance dedicated to this Call instance.
         * @private
         */ this.dispatcher = new $8c05ed6f2f331ee8$var$Dispatcher();
        this.statsReportingIntervalInMs = 2000;
        this.sfuClientTag = 0;
        this.reconnectConcurrencyTag = Symbol('reconnectConcurrencyTag');
        this.reconnectAttempts = 0;
        this.reconnectStrategy = $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.UNSPECIFIED;
        this.reconnectReason = '';
        this.fastReconnectDeadlineSeconds = 0;
        this.disconnectionTimeoutSeconds = 0;
        this.lastOfflineTimestamp = 0;
        // (10 attempts per rolling 120 s window).
        this.rejoinRateLimiter = new $8c05ed6f2f331ee8$var$SlidingWindowRateLimiter(10, 120000);
        // "Network doesn't support WebRTC" detector: counts peer-connection
        // failures where ICE never reached `connected`/`completed`.
        this.maxIceFailuresWithoutConnect = 2;
        this.iceFailuresWithoutConnect = 0;
        // Consecutive-negotiation-failure detector: stops the reconnect loop when
        // the SFU keeps failing to negotiate SDP for us.
        this.maxConsecutiveNegotiationFailures = 3;
        this.consecutiveNegotiationFailures = 0;
        // maintain the order of publishing tracks to restore them after a reconnection
        // it shouldn't contain duplicates
        this.trackPublishOrder = [];
        this.hasJoinedOnce = false;
        this.deviceSettingsAppliedOnce = false;
        this.initialized = false;
        this.acceptRejectConcurrencyTag = Symbol('acceptRejectTag');
        this.joinLeaveConcurrencyTag = Symbol('joinLeaveConcurrencyTag');
        /**
         * A list hooks/functions to invoke when the call is left.
         * A typical use case is to clean up some global event handlers.
         * @private
         */ this.leaveCallHooks = new Set();
        this.streamClientEventHandlers = new Map();
        /**
         * A list of capabilities that the client supports and are enabled.
         */ this.clientCapabilities = new Set([
            $8c05ed6f2f331ee8$var$ClientCapability.SUBSCRIBER_VIDEO_PAUSE
        ]);
        /**
         * Sets up the call instance.
         *
         * @internal an internal method and should not be used outside the SDK.
         */ this.setup = async ()=>{
            await $8c05ed6f2f331ee8$var$withoutConcurrency(this.joinLeaveConcurrencyTag, async ()=>{
                if (this.initialized) return;
                this.leaveCallHooks.add(this.on('all', (event)=>{
                    // update state with the latest event data
                    this.state.updateFromEvent(event);
                }));
                this.leaveCallHooks.add(this.on('changePublishOptions', (event)=>{
                    this.currentPublishOptions = event.publishOptions;
                }));
                this.leaveCallHooks.add($8c05ed6f2f331ee8$var$registerEventHandlers(this, this.dispatcher));
                this.registerEffects();
                this.registerReconnectHandlers();
                // Set up the device managers again. Although this is already done
                // in the DeviceManager's constructor, they'll need to be re-set up
                // in the cases where a call instance is recycled (join -> leave -> join).
                this.camera.setup();
                this.microphone.setup();
                this.screenShare.setup();
                this.speaker.setup();
                if (this.state.callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.LEFT) this.state.setCallingState($8c05ed6f2f331ee8$export$e10ca39c0aa31acc.IDLE);
                this.initialized = true;
            });
        };
        this.registerEffects = ()=>{
            this.leaveCallHooks.add(// handles updating the permissions context when the settings change.
            $8c05ed6f2f331ee8$var$createSubscription(this.state.settings$, (settings)=>{
                if (!settings) return;
                this.permissionsContext.setCallSettings(settings);
            }));
            this.leaveCallHooks.add(// handle the case when the user permissions are modified.
            $8c05ed6f2f331ee8$var$createSafeAsyncSubscription(this.state.ownCapabilities$, this.handleOwnCapabilitiesUpdated));
            this.leaveCallHooks.add(// handles the case when the user is blocked by the call owner.
            $8c05ed6f2f331ee8$var$createSubscription(this.state.blockedUserIds$, async (blockedUserIds)=>{
                if (!blockedUserIds || blockedUserIds.length === 0) return;
                const currentUserId = this.currentUserId;
                if (currentUserId && blockedUserIds.includes(currentUserId)) {
                    this.logger.info('Leaving call because of being blocked');
                    globalThis.streamRNVideoSDK?.callingX?.endCall(this, 'restricted');
                    await this.leave({
                        message: 'user blocked'
                    }).catch((err)=>{
                        this.logger.error('Error leaving call after being blocked', err);
                    });
                }
            }));
            if (this.ringing) // if the call is ringing, we need to register the ringing call effects
            this.handleRingingCall();
            else // if the call is not ringing, we need to register the ringing call subscriptions
            // to handle the case when the call gets ringing flag after creation event
            this.leaveCallHooks.add(// "ringing" mode effects and event handlers
            $8c05ed6f2f331ee8$var$createSubscription(this.ringingSubject, (isRinging)=>{
                if (!isRinging) return;
                this.handleRingingCall();
            }));
            this.leaveCallHooks.add(// cancel auto-drop when call is accepted or rejected
            $8c05ed6f2f331ee8$var$createSubscription(this.state.session$, (session)=>{
                if (!this.ringing) return;
                const receiverId = this.clientStore.connectedUser?.id;
                if (!receiverId) return;
                const isAcceptedByMe = Boolean(session?.accepted_by[receiverId]);
                const isRejectedByMe = Boolean(session?.rejected_by[receiverId]);
                if (isAcceptedByMe || isRejectedByMe) this.cancelAutoDrop();
                const isAcceptedElsewhere = isAcceptedByMe && this.state.callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.RINGING;
                if ((isAcceptedElsewhere || isRejectedByMe) && !$8c05ed6f2f331ee8$var$hasPending(this.joinLeaveConcurrencyTag)) {
                    globalThis.streamRNVideoSDK?.callingX?.endCall(this, isAcceptedElsewhere ? 'answeredElsewhere' : 'rejected');
                    this.leave().catch(()=>{
                        this.logger.error('Could not leave a call that was accepted or rejected elsewhere');
                    });
                }
            }));
        };
        this.handleRingingCall = ()=>{
            const callSession = this.state.session;
            const receiver_id = this.clientStore.connectedUser?.id;
            const ended_at = callSession?.ended_at;
            const created_by_id = this.state.createdBy?.id;
            if (this.currentUserId && created_by_id === this.currentUserId) globalThis.streamRNVideoSDK?.callingX?.registerOutgoingCall(this);
            const rejected_by = callSession?.rejected_by;
            const accepted_by = callSession?.accepted_by;
            let leaveCallIdle = false;
            if (ended_at) // call was ended before it was accepted or rejected so we should leave it to idle
            leaveCallIdle = true;
            else if (created_by_id && rejected_by) {
                if (rejected_by[created_by_id]) // call was cancelled by the caller
                leaveCallIdle = true;
            } else if (receiver_id && rejected_by) {
                if (rejected_by[receiver_id]) // call was rejected by the receiver in some other device
                leaveCallIdle = true;
            } else if (receiver_id && accepted_by) {
                if (accepted_by[receiver_id]) // call was accepted by the receiver in some other device
                leaveCallIdle = true;
            }
            if (leaveCallIdle) {
                if (this.state.callingState !== $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.IDLE) this.state.setCallingState($8c05ed6f2f331ee8$export$e10ca39c0aa31acc.IDLE);
            } else {
                if (this.state.callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.IDLE) this.state.setCallingState($8c05ed6f2f331ee8$export$e10ca39c0aa31acc.RINGING);
                this.scheduleAutoDrop();
                this.leaveCallHooks.add($8c05ed6f2f331ee8$var$registerRingingCallEventHandlers(this));
            }
        };
        this.handleOwnCapabilitiesUpdated = async (ownCapabilities)=>{
            // update the permission context.
            this.permissionsContext.setPermissions(ownCapabilities);
            if (!this.publisher) return;
            // check if the user still has publishing permissions and stop publishing if not.
            const permissionToTrackType = {
                [$8c05ed6f2f331ee8$export$9d72b1bd9eedd7a7.SEND_AUDIO]: $8c05ed6f2f331ee8$var$TrackType.AUDIO,
                [$8c05ed6f2f331ee8$export$9d72b1bd9eedd7a7.SEND_VIDEO]: $8c05ed6f2f331ee8$var$TrackType.VIDEO,
                [$8c05ed6f2f331ee8$export$9d72b1bd9eedd7a7.SCREENSHARE]: $8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE
            };
            for (const [permission, trackType] of Object.entries(permissionToTrackType)){
                const hasPermission = this.permissionsContext.hasPermission(permission);
                if (hasPermission) continue;
                try {
                    switch(trackType){
                        case $8c05ed6f2f331ee8$var$TrackType.AUDIO:
                            if (this.microphone.enabled) await this.microphone.disable();
                            break;
                        case $8c05ed6f2f331ee8$var$TrackType.VIDEO:
                            if (this.camera.enabled) await this.camera.disable();
                            break;
                        case $8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE:
                            if (this.screenShare.enabled) await this.screenShare.disable();
                            break;
                    }
                } catch (err) {
                    this.logger.error(`Can't disable mic/camera/screenshare after revoked permissions`, err);
                }
            }
        };
        /**
         * You can subscribe to WebSocket events provided by the API. To remove a subscription, call the `off` method.
         * Please note that subscribing to WebSocket events is an advanced use-case.
         * For most use-cases, it should be enough to watch for state changes.
         *
         * @param eventName the event name.
         * @param fn the event handler.
         */ this.on = (eventName, fn)=>{
            if ($8c05ed6f2f331ee8$var$isSfuEvent(eventName)) return this.dispatcher.on(eventName, '*', fn);
            const offHandler = this.streamClient.on(eventName, (e)=>{
                const event = e;
                if (event.call_cid && event.call_cid === this.cid) fn(event);
            });
            // keep the 'off' reference returned by the stream client
            this.streamClientEventHandlers.set(fn, offHandler);
            return ()=>{
                this.off(eventName, fn);
            };
        };
        /**
         * Remove subscription for WebSocket events that were created by the `on` method.
         *
         * @param eventName the event name.
         * @param fn the event handler.
         */ this.off = (eventName, fn)=>{
            if ($8c05ed6f2f331ee8$var$isSfuEvent(eventName)) return this.dispatcher.off(eventName, '*', fn);
            // unsubscribe from the stream client event by using the 'off' reference
            const registeredOffHandler = this.streamClientEventHandlers.get(fn);
            if (registeredOffHandler) registeredOffHandler();
        };
        /**
         * Leave the call and stop the media streams that were published by the call.
         */ this.leave = async ({ reject: reject, reason: reason, message: message } = {})=>{
            if (this.state.callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.LEFT) throw new Error('Cannot leave call that has already been left.');
            await $8c05ed6f2f331ee8$var$withoutConcurrency(this.joinLeaveConcurrencyTag, async ()=>{
                const callingState = this.state.callingState;
                if (callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.LEFT) return;
                if (callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.JOINING) {
                    const waitUntilCallJoined = ()=>{
                        return new Promise((resolve)=>{
                            this.state.callingState$.pipe((0, $106fa5810fba1e6e$export$9384c7afe4015e42)((state)=>state !== $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.JOINED, true)).subscribe(()=>resolve());
                        });
                    };
                    await waitUntilCallJoined();
                }
                if (callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.RINGING && reject !== false) {
                    if (reject) {
                        const reasonToEndCallReason = {
                            timeout: 'missed',
                            cancel: 'canceled',
                            busy: 'busy',
                            decline: 'rejected'
                        };
                        const rejectReason = reason ?? 'decline';
                        const endCallReason = reasonToEndCallReason[rejectReason] ?? 'rejected';
                        await this.reject(rejectReason);
                        globalThis.streamRNVideoSDK?.callingX?.endCall(this, endCallReason);
                    } else {
                        // if reject was undefined, we still have to cancel the call automatically
                        // when I am the creator and everyone else left the call
                        const hasOtherParticipants = this.state.remoteParticipants.length > 0;
                        if (this.isCreatedByMe && !hasOtherParticipants) {
                            await this.reject('cancel');
                            globalThis.streamRNVideoSDK?.callingX?.endCall(this, 'canceled');
                        }
                    }
                }
                globalThis.streamRNVideoSDK?.callingX?.endCall(this);
                this.statsReporter?.stop();
                this.statsReporter = undefined;
                const leaveReason = message ?? reason ?? 'user is leaving the call';
                this.tracer.trace('call.leaveReason', leaveReason);
                this.sfuStatsReporter?.flush();
                this.sfuStatsReporter?.stop();
                this.sfuStatsReporter = undefined;
                this.lastStatsOptions = undefined;
                await this.subscriber?.dispose();
                this.clientEventReporter.abort(this.cid, {
                    code: 'CLIENT_ABORTED',
                    reason: leaveReason
                });
                this.subscriber = undefined;
                await this.publisher?.dispose();
                this.publisher = undefined;
                this.clientEventReporter.unregisterCall(this.cid);
                await this.sfuClient?.leaveAndClose(leaveReason);
                this.sfuClient = undefined;
                this.trackSubscriptionManager.setSfuClient(undefined);
                this.trackSubscriptionManager.dispose();
                this.audioBindingsWatchdog?.dispose();
                await this.dynascaleManager?.dispose();
                this.state.setCallingState($8c05ed6f2f331ee8$export$e10ca39c0aa31acc.LEFT);
                this.state.setParticipants([]);
                this.state.dispose();
                // Reset reconnect-related accumulators so a future `call.join()` on the
                // same instance starts with a fresh budget. The `Call` may be reused
                // (see `Call.test.ts` "can reuse call instance") so this is required.
                // Strategy/reason/attempts must also be cleared: when `leave()` is
                // reached via `giveUpAndLeave()` the success-path reset at the end of
                // `joinFlow` never runs, leaving stale values that would make the next
                // fresh `join()` send a stale `ReconnectDetails` to the SFU.
                this.rejoinRateLimiter.reset();
                this.iceFailuresWithoutConnect = 0;
                this.consecutiveNegotiationFailures = 0;
                this.reconnectStrategy = $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.UNSPECIFIED;
                this.reconnectReason = '';
                this.reconnectAttempts = 0;
                // Call all leave call hooks, e.g. to clean up global event handlers
                this.leaveCallHooks.forEach((hook)=>hook());
                this.initialized = false;
                this.hasJoinedOnce = false;
                this.unifiedSessionId = undefined;
                this.ringingSubject.next(false);
                this.cancelAutoDrop();
                this.clientStore.unregisterCall(this);
                globalThis.streamRNVideoSDK?.callManager.stop({
                    isRingingTypeCall: this.ringing
                });
                this.camera.dispose();
                this.microphone.dispose();
                this.screenShare.dispose();
                this.speaker.dispose();
                this.deviceSettingsAppliedOnce = false;
                const stopOnLeavePromises = [];
                if (this.camera.stopOnLeave) stopOnLeavePromises.push(this.camera.disable(true));
                if (this.microphone.stopOnLeave) stopOnLeavePromises.push(this.microphone.disable(true));
                if (this.screenShare.stopOnLeave) stopOnLeavePromises.push(this.screenShare.disable(true));
                await Promise.all(stopOnLeavePromises);
            });
        };
        /**
         * Update from the call response from the "call.ring" event
         * @internal
         */ this.updateFromRingingEvent = async (event)=>{
            await this.setup();
            // call.ring event excludes the call creator in the members list
            // as the creator does not get the ring event
            // so update the member list accordingly
            const { created_by: created_by, settings: settings } = event.call;
            const creator = this.state.members.find((m)=>m.user.id === created_by.id);
            if (!creator) this.state.setMembers(event.members);
            else this.state.setMembers([
                creator,
                ...event.members
            ]);
            // update the call state with the latest event data
            this.state.updateFromCallResponse(event.call);
            this.watching = true;
            this.ringingSubject.next(true);
            // we remove the instance from the calls list to enable the following filter in useCalls hook
            // const calls = useCalls().filter((c) => c.ringing);
            const calls = this.clientStore.calls.filter((c)=>c.cid !== this.cid);
            this.clientStore.setCalls([
                this,
                ...calls
            ]);
            const skipSpeakerApply = $8c05ed6f2f331ee8$var$isReactNative();
            await this.applyDeviceConfig(settings, false, skipSpeakerApply);
        };
        /**
         * Loads the information about the call.
         *
         * @param params.ring if set to true, a `call.ring` event will be sent to the call members.
         * @param params.notify if set to true, a `call.notification` event will be sent to the call members.
         * @param params.members_limit the total number of members to return as part of the response.
         * @param params.video if set to true, in a ringing scenario, mobile SDKs will show "incoming video call", audio only otherwise.
         */ this.get = async (params)=>{
            await this.setup();
            const response = await this.streamClient.get(this.streamClientBasePath, params);
            this.state.updateFromCallResponse(response.call);
            this.state.setMembers(response.members);
            this.state.setOwnCapabilities(response.own_capabilities);
            if (params?.ring) this.ringingSubject.next(true);
            if (this.streamClient._hasConnectionID()) {
                this.watching = true;
                this.clientStore.registerOrUpdateCall(this);
            }
            // Skip speaker setup on RN if ringing was requested or the call is already ringing
            const skipSpeakerApply = $8c05ed6f2f331ee8$var$isReactNative() ? params?.ring === true ? true : this.ringing : false;
            await this.applyDeviceConfig(response.call.settings, false, skipSpeakerApply);
            return response;
        };
        /**
         * Loads the information about the call and creates it if it doesn't exist.
         *
         * @param data the data to create the call with.
         */ this.getOrCreate = async (data)=>{
            await this.setup();
            const response = await this.streamClient.post(this.streamClientBasePath, data);
            this.state.updateFromCallResponse(response.call);
            this.state.setMembers(response.members);
            this.state.setOwnCapabilities(response.own_capabilities);
            if (data?.ring) this.ringingSubject.next(true);
            if (this.streamClient._hasConnectionID()) {
                this.watching = true;
                this.clientStore.registerOrUpdateCall(this);
            }
            // Skip speaker setup on RN if ringing was requested or the call is already ringing
            const skipSpeakerApply = $8c05ed6f2f331ee8$var$isReactNative() ? data?.ring === true ? true : this.ringing : false;
            await this.applyDeviceConfig(response.call.settings, false, skipSpeakerApply);
            return response;
        };
        /**
         * Creates a call
         *
         * @param data the data to create the call with.
         */ this.create = async (data)=>{
            return this.getOrCreate(data);
        };
        /**
         * Deletes the call.
         */ this.delete = async (data = {})=>{
            return this.streamClient.post(`${this.streamClientBasePath}/delete`, data);
        };
        /**
         * Sends a ring notification to the provided users who are not already in the call.
         * All users should be members of the call.
         */ this.ring = async (data = {})=>{
            return this.streamClient.post(`${this.streamClientBasePath}/ring`, data);
        };
        /**
         * A shortcut for {@link Call.get} with `notify` parameter set to `true`.
         * Will send a `call.notification` event to the call members.
         */ this.notify = async ()=>{
            return await this.get({
                notify: true
            });
        };
        /**
         * Marks the incoming call as accepted.
         *
         * This method should be used only for "ringing" call flows.
         * {@link Call.join} invokes this method automatically for you when joining a call.
         * Unless you are implementing a custom "ringing" flow, you should not use this method.
         */ this.accept = async ()=>{
            return $8c05ed6f2f331ee8$var$withoutConcurrency(this.acceptRejectConcurrencyTag, ()=>{
                this.tracer.trace('call.accept', '');
                return this.streamClient.post(`${this.streamClientBasePath}/accept`);
            });
        };
        /**
         * Marks the incoming call as rejected.
         *
         * This method should be used only for "ringing" call flows.
         * {@link Call.leave} invokes this method automatically for you when you leave or reject this call.
         * Unless you are implementing a custom "ringing" flow, you should not use this method.
         *
         * @param reason the reason for rejecting the call.
         */ this.reject = async (reason = 'decline')=>{
            return $8c05ed6f2f331ee8$var$withoutConcurrency(this.acceptRejectConcurrencyTag, ()=>{
                this.tracer.trace('call.reject', reason);
                return this.streamClient.post(`${this.streamClientBasePath}/reject`, {
                    reason: reason
                });
            });
        };
        /**
         * Will start to watch for call related WebSocket events and initiate a call session with the server.
         *
         * @returns a promise which resolves once the call join-flow has finished.
         */ this.join = async ({ maxJoinRetries: maxJoinRetries = 3, joinResponseTimeout: joinResponseTimeout, rpcRequestTimeout: rpcRequestTimeout, ...data } = {})=>{
            const callingState = this.state.callingState;
            if ([
                $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.JOINED,
                $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.JOINING
            ].includes(callingState)) throw new Error(`Illegal State: call.join() shall be called only once`);
            if (data?.ring) this.ringingSubject.next(true);
            const callingX = globalThis.streamRNVideoSDK?.callingX;
            if (callingX) // for Android/iOS, we need to start the call in the callingx library as soon as possible
            await callingX.joinCall(this, this.clientStore.calls);
            await this.setup();
            this.clientEventReporter.registerCall(this.cid, {
                callType: this.type,
                callId: this.id,
                getCallSessionId: ()=>this.state.session?.id ?? '',
                getSfuId: ()=>this.credentials?.server.edge_name ?? '',
                getUserSessionId: ()=>this.sfuClient?.sessionId ?? ''
            });
            this.joinResponseTimeout = joinResponseTimeout;
            this.rpcRequestTimeout = rpcRequestTimeout;
            // we will count the number of join failures per SFU.
            // once the number of failures reaches 2, we will piggyback on the `migrating_from`
            // field to force the coordinator to provide us another SFU
            const sfuJoinFailures = new Map();
            const joinData = data;
            maxJoinRetries = Math.max(maxJoinRetries, 1);
            try {
                await this.clientEventReporter.withJoinLifecycle(this.cid, 'first-attempt', async ()=>{
                    for(let attempt = 0; attempt < maxJoinRetries; attempt++){
                        try {
                            this.logger.trace(`Joining call (${attempt})`, this.cid);
                            await this.doJoin(data);
                            delete joinData.migrating_from;
                            delete joinData.migrating_from_list;
                            return;
                        } catch (err) {
                            this.logger.warn(`Failed to join call (${attempt})`, this.cid);
                            if (err instanceof $8c05ed6f2f331ee8$export$758a4427671bc10f && err.unrecoverable || err instanceof $8c05ed6f2f331ee8$export$7aa89efb7e5fd7cd && err.unrecoverable) throw err;
                            const switchSfu = err instanceof $8c05ed6f2f331ee8$export$7aa89efb7e5fd7cd && $8c05ed6f2f331ee8$export$7aa89efb7e5fd7cd.isJoinErrorCode(err.errorEvent);
                            const sfuId = this.credentials?.server.edge_name;
                            if (sfuId) {
                                const failures = (sfuJoinFailures.get(sfuId) || 0) + 1;
                                sfuJoinFailures.set(sfuId, failures);
                                if (switchSfu || failures >= 2) {
                                    joinData.migrating_from = sfuId;
                                    joinData.migrating_from_list = Array.from(sfuJoinFailures.keys());
                                    if (attempt < maxJoinRetries - 1) this.clientEventReporter.startCorrelation(this.cid, 'first-attempt');
                                }
                            }
                            if (attempt === maxJoinRetries - 1) throw err;
                        }
                        await $8c05ed6f2f331ee8$var$sleep($8c05ed6f2f331ee8$var$retryInterval(attempt));
                    }
                });
            } catch (error) {
                callingX?.endCall(this, 'error');
                throw error;
            }
        };
        /**
         * Will make a single attempt to watch for call related WebSocket events
         * and initiate a call session with the server.
         *
         * @returns a promise which resolves once the call join-flow has finished.
         */ this.doJoin = async (data)=>{
            const connectStartTime = Date.now();
            const callingState = this.state.callingState;
            this.joinCallData = data;
            this.logger.debug('Starting join flow');
            this.state.setCallingState($8c05ed6f2f331ee8$export$e10ca39c0aa31acc.JOINING);
            const performingMigration = this.reconnectStrategy === $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.MIGRATE;
            const performingRejoin = this.reconnectStrategy === $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.REJOIN;
            const performingFastReconnect = this.reconnectStrategy === $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.FAST;
            let statsOptions = this.lastStatsOptions;
            if (!this.credentials || !statsOptions || performingRejoin || performingMigration || data?.migrating_from) try {
                const joinResponse = await this.clientEventReporter.track(this.cid, 'CoordinatorJoin', ()=>this.doJoinRequest(data));
                this.credentials = joinResponse.credentials;
                statsOptions = joinResponse.stats_options;
                this.lastStatsOptions = statsOptions;
            } catch (error) {
                // prevent triggering reconnect flow if the state is OFFLINE
                const avoidRestoreState = this.state.callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.OFFLINE;
                if (!avoidRestoreState) // restore the previous call state if the join-flow fails
                this.state.setCallingState(callingState);
                throw error;
            }
            const previousSfuClient = this.sfuClient;
            const previousSessionId = previousSfuClient?.sessionId;
            const isWsHealthy = !!previousSfuClient?.isHealthy;
            const sfuClient = performingRejoin || performingMigration || !isWsHealthy ? new $8c05ed6f2f331ee8$export$4ca676c4bfc66c17({
                tag: String(this.sfuClientTag++),
                cid: this.cid,
                dispatcher: this.dispatcher,
                credentials: this.credentials,
                streamClient: this.streamClient,
                enableTracing: statsOptions.enable_rtc_stats,
                joinResponseTimeout: this.joinResponseTimeout,
                rpcRequestTimeout: this.rpcRequestTimeout,
                // a new session_id is necessary for the REJOIN strategy.
                // we use the previous session_id if available
                sessionId: performingRejoin ? undefined : previousSessionId,
                onSignalClose: (reason)=>this.handleSfuSignalClose(sfuClient, reason)
            }) : previousSfuClient;
            this.sfuClient = sfuClient;
            this.unifiedSessionId ?? (this.unifiedSessionId = sfuClient.sessionId);
            this.trackSubscriptionManager.setSfuClient(sfuClient);
            const clientDetails = await $8c05ed6f2f331ee8$export$9d409e1fdb877bc1();
            // we don't need to send JoinRequest if we are re-using an existing healthy SFU client
            if (previousSfuClient !== sfuClient) {
                // prepare a generic SDP and send it to the SFU.
                // these are throw-away SDPs that the SFU will use to determine
                // the capabilities of the client (codec support, etc.)
                const { dangerouslyForceCodec: dangerouslyForceCodec, fmtpLine: fmtpLine, subscriberFmtpLine: subscriberFmtpLine } = this.clientPublishOptions || {};
                const [subscriberSdp, publisherSdp] = await Promise.all([
                    $8c05ed6f2f331ee8$var$getGenericSdp('recvonly', dangerouslyForceCodec, subscriberFmtpLine),
                    $8c05ed6f2f331ee8$var$getGenericSdp('sendonly', dangerouslyForceCodec, fmtpLine)
                ]);
                const isReconnecting = this.reconnectStrategy !== $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.UNSPECIFIED;
                const reconnectDetails = isReconnecting ? this.getReconnectDetails(previousSfuClient?.edgeName, previousSessionId) : undefined;
                const preferredPublishOptions = !isReconnecting ? this.getPreferredPublishOptions() : this.currentPublishOptions || [];
                const preferredSubscribeOptions = !isReconnecting ? this.getPreferredSubscribeOptions() : [];
                const unifiedSessionId = this.unifiedSessionId;
                const capabilities = Array.from(this.clientCapabilities);
                try {
                    const { callState: callState, fastReconnectDeadlineSeconds: fastReconnectDeadlineSeconds, publishOptions: publishOptions } = await this.clientEventReporter.track(this.cid, 'WSJoin', ()=>sfuClient.join({
                            unifiedSessionId: unifiedSessionId,
                            subscriberSdp: subscriberSdp,
                            publisherSdp: publisherSdp,
                            clientDetails: clientDetails,
                            fastReconnect: performingFastReconnect,
                            reconnectDetails: reconnectDetails,
                            preferredPublishOptions: preferredPublishOptions,
                            preferredSubscribeOptions: preferredSubscribeOptions,
                            capabilities: capabilities,
                            source: $8c05ed6f2f331ee8$var$ParticipantSource.WEBRTC_UNSPECIFIED
                        }));
                    this.currentPublishOptions = publishOptions;
                    this.fastReconnectDeadlineSeconds = fastReconnectDeadlineSeconds;
                    if (callState) this.state.updateFromSfuCallState(callState, sfuClient.sessionId, reconnectDetails);
                } catch (error) {
                    this.logger.warn('Join SFU request failed', error);
                    sfuClient.close($8c05ed6f2f331ee8$export$4ca676c4bfc66c17.JOIN_FAILED, 'Join request failed, connection considered unhealthy');
                    // restore the previous call state if the join-flow fails
                    this.state.setCallingState(callingState);
                    throw error;
                }
            }
            if (!performingMigration) // in MIGRATION, `JOINED` state is set in `this.reconnectMigrate()`
            this.state.setCallingState($8c05ed6f2f331ee8$export$e10ca39c0aa31acc.JOINED);
            this.hasJoinedOnce = true;
            // when performing fast reconnect, or when we reuse the same SFU client,
            // (ws remained healthy), we just need to restore the ICE connection
            if (performingFastReconnect) {
                // The SFU automatically issues an ICE restart on the subscriber,
                // so we only need to decide about the publisher. If the publisher's
                // peer connection is still stable (ICE still connected end-to-end),
                // the signal WebSocket drop was the only problem — the new WS alone
                // is enough, and restarting ICE would add unnecessary SDP/ICE churn.
                const publisherIsStable = this.publisher?.isStable() ?? true;
                const includePublisher = !!this.publisher?.isPublishing() && !publisherIsStable;
                if (!includePublisher && this.publisher?.isPublishing()) this.logger.info('[Reconnect] FAST: skipping publisher ICE restart, publisher PC is stable');
                await this.restoreICE(sfuClient, {
                    includeSubscriber: false,
                    includePublisher: includePublisher
                });
            } else {
                const connectionConfig = $8c05ed6f2f331ee8$var$toRtcConfiguration(this.credentials.ice_servers);
                await this.initPublisherAndSubscriber({
                    sfuClient: sfuClient,
                    connectionConfig: connectionConfig,
                    clientDetails: clientDetails,
                    statsOptions: statsOptions,
                    publishOptions: this.currentPublishOptions || [],
                    closePreviousInstances: !performingMigration,
                    unifiedSessionId: this.unifiedSessionId
                });
            }
            // make sure we only track connection timing if we are not calling this method as part of a reconnection flow
            if (!performingRejoin && !performingFastReconnect && !performingMigration) this.sfuStatsReporter?.sendConnectionTime((Date.now() - connectStartTime) / 1000);
            if (performingRejoin && isWsHealthy) {
                const strategy = $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy[this.reconnectStrategy];
                await previousSfuClient?.leaveAndClose(`Closing previous WS after reconnect with strategy: ${strategy}`);
            } else if (!isWsHealthy) previousSfuClient?.close($8c05ed6f2f331ee8$export$4ca676c4bfc66c17.DISPOSE_OLD_SOCKET, 'Closing unhealthy WS after reconnect');
            // device settings should be applied only once, we don't have to
            // re-apply them on later reconnections or server-side data fetches
            if (!this.deviceSettingsAppliedOnce && this.state.settings) {
                await this.applyDeviceConfig(this.state.settings, true, false);
                globalThis.streamRNVideoSDK?.callManager.start({
                    isRingingTypeCall: this.ringing
                });
                this.deviceSettingsAppliedOnce = true;
            }
            // We shouldn't persist the `ring` and `notify` state after joining the call
            // as it's a one-time event and clashes with the potential reconnection attempts.
            // When reconnecting, if provided with `ring: true` or `notify: true`,
            // we will spam the other participants with push notifications and `call.ring` events.
            delete this.joinCallData?.ring;
            delete this.joinCallData?.notify;
            // reset the reconnect strategy to unspecified after a successful reconnection
            this.reconnectStrategy = $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.UNSPECIFIED;
            this.reconnectReason = '';
            // A successful SFU join handshake resets the consecutive-negotiation
            // counter (negotiation just succeeded). It does NOT reset
            // `iceFailuresWithoutConnect` or the rolling `rejoinRateLimiter`;
            // those track WebRTC-level health and rejoin frequency, which are not
            // proven by the SFU handshake alone. ICE-failures-without-connect is
            // cleared via the `onIceConnected` callback when the peer connection
            // actually reaches `connected`/`completed` end-to-end. The rejoin
            // rolling window decays naturally as old timestamps age out.
            this.consecutiveNegotiationFailures = 0;
            this.logger.info(`Joined call ${this.cid}`);
        };
        /**
         * Prepares Reconnect Details object.
         * @internal
         */ this.getReconnectDetails = (migratingFromSfuId, previousSessionId)=>{
            const strategy = this.reconnectStrategy;
            const performingRejoin = strategy === $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.REJOIN;
            const announcedTracks = this.publisher?.getAnnouncedTracksForReconnect() || [];
            return {
                strategy: strategy,
                announcedTracks: announcedTracks,
                subscriptions: this.trackSubscriptionManager.subscriptions,
                reconnectAttempt: this.reconnectAttempts,
                fromSfuId: migratingFromSfuId || '',
                previousSessionId: performingRejoin ? previousSessionId || '' : '',
                reason: this.reconnectReason
            };
        };
        /**
         * Prepares the preferred codec for the call.
         * This is an experimental client feature and subject to change.
         * @internal
         */ this.getPreferredPublishOptions = ()=>{
            const { preferredCodec: preferredCodec, fmtpLine: fmtpLine, preferredBitrate: preferredBitrate, maxSimulcastLayers: maxSimulcastLayers } = this.clientPublishOptions || {};
            if (!preferredCodec && !preferredBitrate && !maxSimulcastLayers) return [];
            const codec = preferredCodec ? $8c05ed6f2f331ee8$var$Codec.create({
                name: preferredCodec.split('/').pop(),
                fmtp: fmtpLine
            }) : undefined;
            const preferredPublishOptions = [
                $8c05ed6f2f331ee8$var$PublishOption.create({
                    trackType: $8c05ed6f2f331ee8$var$TrackType.VIDEO,
                    codec: codec,
                    bitrate: preferredBitrate,
                    maxSpatialLayers: maxSimulcastLayers
                })
            ];
            const screenShareSettings = this.screenShare.getSettings();
            if (screenShareSettings) preferredPublishOptions.push($8c05ed6f2f331ee8$var$PublishOption.create({
                trackType: $8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE,
                fps: screenShareSettings.maxFramerate,
                bitrate: screenShareSettings.maxBitrate
            }));
            return preferredPublishOptions;
        };
        /**
         * Prepares the preferred options for subscribing to tracks.
         * This is an experimental client feature and subject to change.
         * @internal
         */ this.getPreferredSubscribeOptions = ()=>{
            const { subscriberCodec: subscriberCodec, subscriberFmtpLine: subscriberFmtpLine } = this.clientPublishOptions || {};
            if (!subscriberCodec || !subscriberFmtpLine) return [];
            return [
                $8c05ed6f2f331ee8$var$SubscribeOption.create({
                    trackType: $8c05ed6f2f331ee8$var$TrackType.VIDEO,
                    codecs: [
                        {
                            name: subscriberCodec.split('/').pop(),
                            fmtp: subscriberFmtpLine
                        }
                    ]
                })
            ];
        };
        /**
         * Performs an ICE restart on both the Publisher and Subscriber Peer Connections.
         * Uses the provided SFU client to restore the ICE connection.
         *
         * This method can throw an error if the ICE restart fails.
         * This error should be handled by the reconnect loop,
         * and a new reconnection shall be attempted.
         *
         * @internal
         */ this.restoreICE = async (nextSfuClient, opts = {})=>{
            const { includeSubscriber: includeSubscriber = true, includePublisher: includePublisher = true } = opts;
            if (this.subscriber) {
                this.subscriber.setSfuClient(nextSfuClient);
                if (includeSubscriber) await this.subscriber.restartIce();
            }
            if (this.publisher) {
                this.publisher.setSfuClient(nextSfuClient);
                if (includePublisher && this.publisher.isPublishing()) await this.publisher.restartIce();
            }
        };
        /**
         * Initializes the Publisher and Subscriber Peer Connections.
         * @internal
         */ this.initPublisherAndSubscriber = async (opts)=>{
            const { sfuClient: sfuClient, connectionConfig: connectionConfig, clientDetails: clientDetails, statsOptions: statsOptions, publishOptions: publishOptions, closePreviousInstances: closePreviousInstances, unifiedSessionId: unifiedSessionId } = opts;
            const { enable_rtc_stats: enableTracing, reporting_interval_ms: reportingIntervalMs } = statsOptions;
            if (closePreviousInstances && this.subscriber) await this.subscriber.dispose();
            const basePeerConnectionOptions = {
                sfuClient: sfuClient,
                dispatcher: this.dispatcher,
                state: this.state,
                connectionConfig: connectionConfig,
                tag: sfuClient.tag,
                enableTracing: enableTracing,
                statsTimestampDriftThresholdMs: reportingIntervalMs / 2,
                clientPublishOptions: this.clientPublishOptions,
                onReconnectionNeeded: (kind, reason, peerType)=>{
                    this.reconnect(kind, reason).catch((err)=>{
                        const message = `[Reconnect] Error reconnecting, after a ${$8c05ed6f2f331ee8$var$PeerType[peerType]} error: ${reason}`;
                        this.logger.warn(message, err);
                    });
                },
                onIceConnected: ()=>{
                    // ICE has reached `connected`/`completed` end-to-end on at least
                    // one peer connection, WebRTC is actually working, so the
                    // "ICE never connected" failure budget can be cleared.
                    this.iceFailuresWithoutConnect = 0;
                },
                onPeerConnectionStateChange: (event)=>{
                    this.clientEventReporter.onPeerConnectionStateChange(this.cid, event);
                },
                onRemoteTrackUnmute: (trackType, trackId)=>{
                    const reportable = trackType === $8c05ed6f2f331ee8$var$TrackType.AUDIO || $8c05ed6f2f331ee8$var$isReactNative() && trackType === $8c05ed6f2f331ee8$var$TrackType.VIDEO;
                    if (!reportable) return;
                    this.clientEventReporter.reportFirstFrame(this.cid, trackType, trackId);
                }
            };
            this.subscriber = new $8c05ed6f2f331ee8$var$Subscriber(basePeerConnectionOptions);
            // anonymous users can't publish anything hence, there is no need
            // to create Publisher Peer Connection for them
            const isAnonymous = this.streamClient.user?.type === 'anonymous';
            if (!isAnonymous) {
                if (closePreviousInstances && this.publisher) await this.publisher.dispose();
                this.publisher = new $8c05ed6f2f331ee8$var$Publisher(basePeerConnectionOptions, publishOptions);
            }
            this.statsReporter?.stop();
            if (this.statsReportingIntervalInMs > 0) this.statsReporter = $8c05ed6f2f331ee8$var$createStatsReporter({
                subscriber: this.subscriber,
                publisher: this.publisher,
                state: this.state,
                datacenter: sfuClient.edgeName,
                pollingIntervalInMs: this.statsReportingIntervalInMs
            });
            this.tracer.setEnabled(enableTracing);
            this.sfuStatsReporter?.flush();
            this.sfuStatsReporter?.stop();
            if (statsOptions?.reporting_interval_ms > 0) {
                this.sfuStatsReporter = new $8c05ed6f2f331ee8$var$SfuStatsReporter(sfuClient, {
                    clientDetails: clientDetails,
                    options: statsOptions,
                    subscriber: this.subscriber,
                    publisher: this.publisher,
                    microphone: this.microphone,
                    camera: this.camera,
                    state: this.state,
                    tracer: this.tracer,
                    unifiedSessionId: unifiedSessionId
                });
                this.sfuStatsReporter.start();
            }
        };
        /**
         * Retrieves credentials for joining the call.
         *
         * @internal
         *
         * @param data the join call data.
         */ this.doJoinRequest = async (data)=>{
            const location = await this.streamClient.getLocationHint();
            const request = {
                ...data,
                location: location
            };
            const joinResponse = await this.streamClient.post(`${this.streamClientBasePath}/join`, request);
            this.state.updateFromCallResponse(joinResponse.call);
            this.state.setMembers(joinResponse.members);
            this.state.setOwnCapabilities(joinResponse.own_capabilities);
            if (data?.ring) this.ringingSubject.next(true);
            const isReconnecting = this.reconnectStrategy !== $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.UNSPECIFIED;
            if (!isReconnecting && this.ringing && !this.isCreatedByMe) // signals other users that I have accepted the incoming call.
            await this.accept();
            if (this.streamClient._hasConnectionID()) {
                this.watching = true;
                this.clientStore.registerOrUpdateCall(this);
            }
            return joinResponse;
        };
        /**
         * Handles the closing of the SFU signal connection.
         *
         * @internal
         * @param sfuClient the SFU client instance that was closed.
         * @param reason the reason for the closure.
         */ this.handleSfuSignalClose = (sfuClient, reason)=>{
            this.logger.debug('[Reconnect] SFU signal connection closed');
            const { callingState: callingState } = this.state;
            if (// SFU WS closed before we finished current join,
            // no need to schedule reconnecting
            callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.JOINING || // we are already in the process of reconnecting,
            // no need to schedule another one
            callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.RECONNECTING || // SFU WS closed as a result of unsuccessful join,
            // and no further retries need to be made
            callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.IDLE || callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.LEFT) return;
            // normal close, no need to reconnect
            if (sfuClient.isLeaving || sfuClient.isClosingClean) return;
            const strategy = this.publisher?.isHealthy() && this.subscriber?.isHealthy() ? $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.FAST : $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.REJOIN;
            this.reconnect(strategy, reason).catch((err)=>{
                this.logger.warn('[Reconnect] Error reconnecting', err);
            });
        };
        /**
         * Handles the reconnection flow.
         *
         * @internal
         *
         * @param strategy the reconnection strategy to use.
         * @param reason the reason for the reconnection. Pass a `ReconnectReason.*`
         *   constant when the SDK should react to it (e.g.
         *   `ICE_NEVER_CONNECTED` increments the unsupported-network counter).
         */ this.reconnect = async (strategy, reason)=>{
            if (this.state.callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.JOINING || this.state.callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.RECONNECTING || this.state.callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.MIGRATING || this.state.callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.RECONNECTING_FAILED) return;
            // Drop redundant reconnect calls. If a reconnect is already queued or
            // running for this Call, that entry will resolve whatever broke;
            // queueing more entries just replays the full REJOIN cycle (one extra
            // `POST /join` per entry) once the call is already healthy again.
            if ($8c05ed6f2f331ee8$var$hasPending(this.reconnectConcurrencyTag)) return;
            return $8c05ed6f2f331ee8$var$withoutConcurrency(this.reconnectConcurrencyTag, async ()=>{
                const reconnectStartTime = Date.now();
                this.reconnectStrategy = strategy;
                this.reconnectReason = reason;
                const sfuRejoinFailures = new Map();
                const markAsReconnectingFailed = async ()=>{
                    try {
                        // attempt to fetch the call data from the server, as the call
                        // state might have changed while we were reconnecting or were offline
                        await this.get();
                    } finally{
                        this.state.setCallingState($8c05ed6f2f331ee8$export$e10ca39c0aa31acc.RECONNECTING_FAILED);
                    }
                };
                const giveUpAndLeave = async (message)=>{
                    this.logger.warn(`[Reconnect] Giving up: ${message}. Leaving the call.`);
                    // If we're mid-iteration, the state can be JOINING; `Call.leave` would
                    // then wait for JOINED before proceeding, but no more attempts will run
                    // so JOINED never comes. Transition to RECONNECTING so `leave()` proceeds.
                    if (this.state.callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.JOINING) this.state.setCallingState($8c05ed6f2f331ee8$export$e10ca39c0aa31acc.RECONNECTING);
                    try {
                        await this.leave({
                            message: message
                        });
                    } catch (err) {
                        this.logger.warn(`[Reconnect] leave() failed after ${message}`, err);
                    }
                };
                // Count this entry into reconnect if it was triggered by a peer
                // connection that never reached `connected`/`completed`.
                if (reason === $8c05ed6f2f331ee8$var$ReconnectReason.ICE_NEVER_CONNECTED) {
                    this.iceFailuresWithoutConnect++;
                    if (this.iceFailuresWithoutConnect >= this.maxIceFailuresWithoutConnect) {
                        await giveUpAndLeave('webrtc_unsupported_network');
                        return;
                    }
                }
                let attempt = 0;
                do {
                    const reconnectingTime = Date.now() - reconnectStartTime;
                    const shouldGiveUpReconnecting = this.disconnectionTimeoutSeconds > 0 && reconnectingTime / 1000 > this.disconnectionTimeoutSeconds;
                    if (shouldGiveUpReconnecting) {
                        this.logger.warn('[Reconnect] Stopping reconnection attempts after reaching disconnection timeout');
                        await markAsReconnectingFailed();
                        return;
                    }
                    // Rejoin rate limit: bound the number of REJOIN (and MIGRATE)
                    // transitions inside a rolling window. FAST is not counted because
                    // it does not issue a new backend `joinCall`.
                    if (this.reconnectStrategy === $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.REJOIN || this.reconnectStrategy === $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.MIGRATE) {
                        if (!this.rejoinRateLimiter.tryRegister()) {
                            await giveUpAndLeave('rejoin_attempt_limit_exceeded');
                            return;
                        }
                    }
                    // we don't increment reconnect attempts for the FAST strategy.
                    if (this.reconnectStrategy !== $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.FAST) this.reconnectAttempts++;
                    const attemptedStrategy = this.reconnectStrategy;
                    const currentStrategy = $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy[attemptedStrategy];
                    try {
                        // wait until the network is available
                        await this.networkAvailableTask?.promise;
                        this.logger.info(`[Reconnect] Reconnecting with strategy ${$8c05ed6f2f331ee8$var$WebsocketReconnectStrategy[this.reconnectStrategy]}`);
                        switch(this.reconnectStrategy){
                            case $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.UNSPECIFIED:
                            case $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.DISCONNECT:
                                this.logger.debug(`[Reconnect] No-op strategy ${currentStrategy}`);
                                break;
                            case $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.FAST:
                                await this.reconnectFast();
                                break;
                            case $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.REJOIN:
                                {
                                    const confirmedBadSfus = Array.from(sfuRejoinFailures).filter(([, failures])=>failures >= 2).map(([sfu])=>sfu);
                                    if (this.joinCallData && confirmedBadSfus.length) {
                                        this.joinCallData.migrating_from = confirmedBadSfus[confirmedBadSfus.length - 1];
                                        this.joinCallData.migrating_from_list = confirmedBadSfus;
                                    }
                                    try {
                                        await this.reconnectRejoin();
                                    } finally{
                                        delete this.joinCallData?.migrating_from;
                                        delete this.joinCallData?.migrating_from_list;
                                    }
                                    break;
                                }
                            case $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.MIGRATE:
                                await this.reconnectMigrate();
                                break;
                            default:
                                $8c05ed6f2f331ee8$var$ensureExhausted(this.reconnectStrategy, 'Unknown reconnection strategy');
                                break;
                        }
                        // reconnection worked — reset the negotiation-failure streak.
                        this.consecutiveNegotiationFailures = 0;
                        break; // do-while loop, reconnection worked, exit the loop
                    } catch (error) {
                        if (attemptedStrategy === $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.REJOIN) {
                            const failedSfu = this.credentials?.server.edge_name;
                            if (failedSfu) {
                                const switchSfu = error instanceof $8c05ed6f2f331ee8$export$7aa89efb7e5fd7cd && $8c05ed6f2f331ee8$export$7aa89efb7e5fd7cd.isJoinErrorCode(error.errorEvent);
                                const failures = (sfuRejoinFailures.get(failedSfu) ?? 0) + 1;
                                sfuRejoinFailures.set(failedSfu, switchSfu ? Math.max(failures, 2) : failures);
                            }
                        }
                        if (this.state.callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.OFFLINE) {
                            this.logger.debug(`[Reconnect] Can't reconnect while offline, stopping reconnection attempts`);
                            break;
                        // we don't need to handle the error if the call is offline
                        // network change event will trigger the reconnection
                        }
                        if (error instanceof $8c05ed6f2f331ee8$export$758a4427671bc10f && error.unrecoverable) {
                            this.logger.warn(`[Reconnect] Can't reconnect due to coordinator unrecoverable error`, error);
                            await markAsReconnectingFailed();
                            return;
                        }
                        if (error instanceof $8c05ed6f2f331ee8$var$NegotiationError) {
                            this.consecutiveNegotiationFailures++;
                            if (this.consecutiveNegotiationFailures >= this.maxConsecutiveNegotiationFailures) {
                                await giveUpAndLeave('repeated_negotiation_failures');
                                return;
                            }
                        }
                        // exponential backoff with jitter, capped at 5 s
                        await $8c05ed6f2f331ee8$var$sleep($8c05ed6f2f331ee8$var$retryInterval(attempt));
                        const wasMigrating = this.reconnectStrategy === $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.MIGRATE;
                        const mustPerformRejoin = (Date.now() - reconnectStartTime) / 1000 > this.fastReconnectDeadlineSeconds;
                        // don't immediately switch to the REJOIN strategy, but instead attempt
                        // to reconnect with the FAST strategy for a few times before switching.
                        // in some cases, we immediately switch to the REJOIN strategy.
                        const shouldRejoin = mustPerformRejoin || // if we are past the fast reconnect deadline
                        wasMigrating || // if we were migrating, but the migration failed
                        attempt >= 3 || // after 3 failed attempts
                        !(this.publisher?.isHealthy() ?? true) || // if the publisher is not healthy
                        !(this.subscriber?.isHealthy() ?? true); // if the subscriber is not healthy
                        attempt++;
                        const nextStrategy = shouldRejoin ? $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.REJOIN : $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.FAST;
                        this.reconnectStrategy = nextStrategy;
                        this.logger.info(`[Reconnect] ${currentStrategy} (${this.reconnectAttempts}) failed. Attempting with ${$8c05ed6f2f331ee8$var$WebsocketReconnectStrategy[nextStrategy]}`, error);
                    }
                }while (this.state.callingState !== $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.JOINED && this.state.callingState !== $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.RECONNECTING_FAILED && this.state.callingState !== $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.LEFT);
                this.logger.info('[Reconnect] Reconnection flow finished');
            });
        };
        /**
         * Initiates the reconnection flow with the "fast" strategy.
         * @internal
         */ this.reconnectFast = async ()=>{
            const reconnectStartTime = Date.now();
            this.reconnectStrategy = $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.FAST;
            this.state.setCallingState($8c05ed6f2f331ee8$export$e10ca39c0aa31acc.RECONNECTING);
            await this.doJoin(this.joinCallData);
            await this.get(); // fetch the latest call state, as it might have changed
            this.sfuStatsReporter?.sendReconnectionTime($8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.FAST, (Date.now() - reconnectStartTime) / 1000);
        };
        /**
         * Initiates the reconnection flow with the "rejoin" strategy.
         * @internal
         */ this.reconnectRejoin = async ()=>{
            const reconnectStartTime = Date.now();
            this.reconnectStrategy = $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.REJOIN;
            this.state.setCallingState($8c05ed6f2f331ee8$export$e10ca39c0aa31acc.RECONNECTING);
            const joinReason = this.reconnectReason === $8c05ed6f2f331ee8$var$ReconnectReason.NETWORK_BACK_ONLINE ? 'network-available' : 'full-rejoin';
            await this.clientEventReporter.withJoinLifecycle(this.cid, joinReason, ()=>this.doJoin(this.joinCallData));
            await this.restorePublishedTracks();
            this.restoreSubscribedTracks();
            this.sfuStatsReporter?.sendReconnectionTime($8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.REJOIN, (Date.now() - reconnectStartTime) / 1000);
        };
        /**
         * Initiates the reconnection flow with the "migrate" strategy.
         * @internal
         */ this.reconnectMigrate = async ()=>{
            const reconnectStartTime = Date.now();
            const currentSfuClient = this.sfuClient;
            if (!currentSfuClient) throw new Error('Cannot migrate without an active SFU client');
            this.reconnectStrategy = $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.MIGRATE;
            this.state.setCallingState($8c05ed6f2f331ee8$export$e10ca39c0aa31acc.MIGRATING);
            const currentSubscriber = this.subscriber;
            const currentPublisher = this.publisher;
            currentSubscriber?.detachEventHandlers();
            currentPublisher?.detachEventHandlers();
            const migrationTask = $8c05ed6f2f331ee8$var$makeSafePromise(currentSfuClient.enterMigration());
            try {
                const currentSfu = currentSfuClient.edgeName;
                await this.clientEventReporter.withJoinLifecycle(this.cid, 'migration', ()=>this.doJoin({
                        ...this.joinCallData,
                        migrating_from: currentSfu,
                        migrating_from_list: [
                            currentSfu
                        ]
                    }));
            } finally{
                // cleanup the migration_from field after the migration is complete or failed
                // as we don't want to keep dirty data in the join call data
                delete this.joinCallData?.migrating_from;
                delete this.joinCallData?.migrating_from_list;
            }
            await this.restorePublishedTracks();
            this.restoreSubscribedTracks();
            try {
                // Wait for the migration to complete, then close the previous SFU client
                // and the peer connection instances. In case of failure, the migration
                // task would throw an error and REJOIN would be attempted.
                await migrationTask();
                // in MIGRATE, we can consider the call as joined only after
                // `participantMigrationComplete` event is received, signaled by
                // the `migrationTask`
                this.state.setCallingState($8c05ed6f2f331ee8$export$e10ca39c0aa31acc.JOINED);
            } finally{
                await currentSubscriber?.dispose();
                await currentPublisher?.dispose();
                // and close the previous SFU client, without specifying close code
                currentSfuClient.close($8c05ed6f2f331ee8$export$4ca676c4bfc66c17.NORMAL_CLOSURE, 'Migrating away');
            }
            this.sfuStatsReporter?.sendReconnectionTime($8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.MIGRATE, (Date.now() - reconnectStartTime) / 1000);
        };
        /**
         * Registers the various event handlers for reconnection.
         *
         * @internal
         */ this.registerReconnectHandlers = ()=>{
            // handles the legacy "goAway" event
            const unregisterGoAway = this.on('goAway', ()=>{
                this.clientEventReporter.captureWsError(this.cid, {
                    code: 'SFU_GO_AWAY',
                    reason: 'SFU goAway received during WS join'
                });
                this.reconnect($8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.MIGRATE, $8c05ed6f2f331ee8$var$ReconnectReason.GO_AWAY).catch((err)=>this.logger.warn('[Reconnect] Error reconnecting', err));
            });
            // handles the "error" event, through which the SFU can request a reconnect
            const unregisterOnError = this.on('error', (e)=>{
                const { reconnectStrategy: strategy, error: error } = e;
                if (!$8c05ed6f2f331ee8$export$7aa89efb7e5fd7cd.isJoinErrorCode(e)) {
                    const code = error?.code ? $8c05ed6f2f331ee8$var$ErrorCode[error.code] : undefined;
                    this.clientEventReporter.captureWsError(this.cid, {
                        code: code ?? 'SFU_ERROR',
                        reason: error?.message || 'SFU error during WS join'
                    });
                }
                // SFU_FULL is a join error, and when emitted, although it specifies a
                // `migrate` strategy, we should actually perform a REJOIN to a new SFU.
                // This is now handled separately in the `call.join()` method.
                if ($8c05ed6f2f331ee8$export$7aa89efb7e5fd7cd.isJoinErrorCode(e)) return;
                if (strategy === $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.UNSPECIFIED) return;
                if (strategy === $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.DISCONNECT) {
                    globalThis.streamRNVideoSDK?.callingX?.endCall(this, 'error');
                    this.leave({
                        message: 'SFU instructed to disconnect'
                    }).catch((err)=>{
                        this.logger.warn(`Can't leave call after disconnect request`, err);
                    });
                } else this.reconnect(strategy, error?.message || $8c05ed6f2f331ee8$var$ReconnectReason.SFU_ERROR).catch((err)=>{
                    this.logger.warn('[Reconnect] Error reconnecting', err);
                });
            });
            const unregisterNetworkChanged = this.streamClient.on('network.changed', (e)=>{
                this.tracer.trace('network.changed', e);
                if (!e.online) {
                    this.logger.debug('[Reconnect] Going offline');
                    if (!this.hasJoinedOnce) return;
                    this.lastOfflineTimestamp = Date.now();
                    // create a new task that would resolve when the network is available
                    const networkAvailableTask = $8c05ed6f2f331ee8$var$promiseWithResolvers();
                    networkAvailableTask.promise.then(()=>{
                        let strategy = $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.FAST;
                        if (this.lastOfflineTimestamp) {
                            const offline = (Date.now() - this.lastOfflineTimestamp) / 1000;
                            if (offline > this.fastReconnectDeadlineSeconds) // We shouldn't attempt FAST if we have exceeded the deadline.
                            // The SFU would have already wiped out the session.
                            strategy = $8c05ed6f2f331ee8$var$WebsocketReconnectStrategy.REJOIN;
                        }
                        this.reconnect(strategy, $8c05ed6f2f331ee8$var$ReconnectReason.NETWORK_BACK_ONLINE).catch((err)=>{
                            this.logger.warn('[Reconnect] Error reconnecting after going online', err);
                        });
                    });
                    this.networkAvailableTask = networkAvailableTask;
                    this.sfuStatsReporter?.stop();
                    this.state.setCallingState($8c05ed6f2f331ee8$export$e10ca39c0aa31acc.OFFLINE);
                } else {
                    if (!this.networkAvailableTask) return;
                    this.logger.debug('[Reconnect] Going online');
                    this.sfuClient?.close($8c05ed6f2f331ee8$export$4ca676c4bfc66c17.DISPOSE_OLD_SOCKET, 'Closing WS to reconnect after going online');
                    // we went online, release the previous waiters and reset the state
                    this.networkAvailableTask?.resolve();
                    this.networkAvailableTask = undefined;
                    this.sfuStatsReporter?.start();
                }
            });
            this.leaveCallHooks.add(unregisterGoAway).add(unregisterOnError).add(unregisterNetworkChanged);
        };
        /**
         * Restores the published tracks after a reconnection.
         * @internal
         */ this.restorePublishedTracks = async ()=>{
            // the tracks need to be restored in their original order of publishing
            // otherwise, we might get `m-lines order mismatch` errors
            for (const trackType of this.trackPublishOrder){
                let mediaStream;
                switch(trackType){
                    case $8c05ed6f2f331ee8$var$TrackType.AUDIO:
                        mediaStream = this.microphone.state.mediaStream;
                        break;
                    case $8c05ed6f2f331ee8$var$TrackType.VIDEO:
                        mediaStream = this.camera.state.mediaStream;
                        break;
                    case $8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE:
                        mediaStream = this.screenShare.state.mediaStream;
                        break;
                    // screen share audio can't exist without a screen share, so we handle it there
                    case $8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE_AUDIO:
                    case $8c05ed6f2f331ee8$var$TrackType.UNSPECIFIED:
                        break;
                    default:
                        $8c05ed6f2f331ee8$var$ensureExhausted(trackType, 'Unknown track type');
                        break;
                }
                if (mediaStream) await this.publish(mediaStream, trackType);
            }
        };
        /**
         * Restores the subscribed tracks after a reconnection.
         * @internal
         */ this.restoreSubscribedTracks = ()=>{
            const { remoteParticipants: remoteParticipants } = this.state;
            if (remoteParticipants.length <= 0) return;
            this.trackSubscriptionManager.apply(undefined);
        };
        /**
         * Starts publishing the given video stream to the call.
         * @deprecated use `call.publish()`.
         */ this.publishVideoStream = async (videoStream)=>{
            await this.publish(videoStream, $8c05ed6f2f331ee8$var$TrackType.VIDEO);
        };
        /**
         * Starts publishing the given audio stream to the call.
         * @deprecated use `call.publish()`
         */ this.publishAudioStream = async (audioStream)=>{
            await this.publish(audioStream, $8c05ed6f2f331ee8$var$TrackType.AUDIO);
        };
        /**
         * Starts publishing the given screen-share stream to the call.
         * @deprecated use `call.publish()`
         */ this.publishScreenShareStream = async (screenShareStream)=>{
            await this.publish(screenShareStream, $8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE);
        };
        /**
         * Publishes the given media stream.
         *
         * @param mediaStream the media stream to publish.
         * @param trackType the type of the track to announce.
         * @param options the publish options.
         */ this.publish = async (mediaStream, trackType, options)=>{
            if (!this.sfuClient) throw new Error(`Call is not joined yet`);
            // joining is in progress, and we should wait until the client is ready
            await this.sfuClient.joinTask;
            if (!this.permissionsContext.canPublish(trackType)) throw new Error(`No permission to publish ${$8c05ed6f2f331ee8$var$TrackType[trackType]}`);
            if (!this.publisher) throw new Error('Publisher is not initialized');
            const [track] = $8c05ed6f2f331ee8$var$isAudioTrackType(trackType) ? mediaStream.getAudioTracks() : mediaStream.getVideoTracks();
            if (!track) throw new Error(`There is no ${$8c05ed6f2f331ee8$var$TrackType[trackType]} track in the stream`);
            if (track.readyState === 'ended') throw new Error(`Can't publish ended tracks.`);
            $8c05ed6f2f331ee8$var$pushToIfMissing(this.trackPublishOrder, trackType);
            await this.publisher.publish(track, trackType, options);
            const trackTypes = [
                trackType
            ];
            if (trackType === $8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE) {
                const [audioTrack] = mediaStream.getAudioTracks();
                if (audioTrack) {
                    const screenShareAudio = $8c05ed6f2f331ee8$var$TrackType.SCREEN_SHARE_AUDIO;
                    $8c05ed6f2f331ee8$var$pushToIfMissing(this.trackPublishOrder, screenShareAudio);
                    await this.publisher.publish(audioTrack, screenShareAudio, options);
                    trackTypes.push(screenShareAudio);
                }
            }
            await this.updateLocalStreamState(mediaStream, ...trackTypes);
        };
        /**
         * Stops publishing the given track type to the call, if it is currently being published.
         *
         * @param trackTypes the track types to stop publishing.
         */ this.stopPublish = async (...trackTypes)=>{
            if (!this.sfuClient || !this.publisher) return;
            await this.publisher.stopTracks(...trackTypes);
            await this.updateLocalStreamState(undefined, ...trackTypes);
        };
        /**
         * Updates the call state with the new stream.
         *
         * @param mediaStream the new stream to update the call state with.
         * If undefined, the stream will be removed from the call state.
         * @param trackTypes the track types to update the call state with.
         */ this.updateLocalStreamState = async (mediaStream, ...trackTypes)=>{
            const sessionId = this.sfuClient?.sessionId;
            if (!sessionId) return;
            await this.notifyTrackMuteState(!mediaStream, ...trackTypes);
            if (this.sfuClient?.sessionId !== sessionId) return;
            for (const trackType of trackTypes){
                const streamStateProp = $8c05ed6f2f331ee8$var$trackTypeToParticipantStreamKey(trackType);
                if (!streamStateProp) continue;
                this.state.updateParticipant(sessionId, (p)=>({
                        publishedTracks: mediaStream ? $8c05ed6f2f331ee8$var$pushToIfMissing([
                            ...p.publishedTracks
                        ], trackType) : p.publishedTracks.filter((t)=>t !== trackType),
                        [streamStateProp]: mediaStream
                    }));
            }
        };
        /**
         * Re-arms the encoder for a currently published track type. Useful for
         * working around WebKit's stalled sender bug after an iOS audio session
         * interruption (Siri, PSTN call).
         *
         * @internal
         *
         * @param trackType the track type to refresh.
         */ this.refreshPublishedTrack = async (trackType)=>{
            if (!this.publisher) return;
            await this.publisher.refreshTrack(trackType);
        };
        /**
         * Updates the preferred publishing options
         *
         * @internal
         * @param options the options to use.
         */ this.updatePublishOptions = (options)=>{
            this.logger.warn("[call.updatePublishOptions]: You are manually overriding the publish options for this call. This is not recommended, and it can cause call stability/compatibility issues. Use with caution.");
            if (this.state.callingState === $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.JOINED) this.logger.warn('Updating publish options after joining the call does not have an effect');
            this.tracer.trace('updatePublishOptions', options);
            this.clientPublishOptions = {
                ...this.clientPublishOptions,
                ...options
            };
        };
        /**
         * Notifies the SFU that a noise cancellation process has started.
         *
         * @internal
         */ this.notifyNoiseCancellationStarting = async ()=>{
            return this.sfuClient?.startNoiseCancellation().catch((err)=>{
                this.logger.warn('Failed to notify start of noise cancellation', err);
            });
        };
        /**
         * Notifies the SFU that a noise cancellation process has stopped.
         *
         * @internal
         */ this.notifyNoiseCancellationStopped = async ()=>{
            return this.sfuClient?.stopNoiseCancellation().catch((err)=>{
                this.logger.warn('Failed to notify stop of noise cancellation', err);
            });
        };
        /**
         * Notifies the SFU about the mute state of the given track types.
         * @internal
         */ this.notifyTrackMuteState = async (muted, ...trackTypes)=>{
            const key = `muteState.${this.cid}.${trackTypes.join('-')}`;
            await $8c05ed6f2f331ee8$var$withoutConcurrency(key, async ()=>{
                if (!this.sfuClient) return;
                await this.sfuClient.updateMuteStates(trackTypes.map((trackType)=>({
                        trackType: trackType,
                        muted: muted
                    })));
            });
        };
        /**
         * Will enhance the reported stats with additional participant-specific information (`callStatsReport$` state [store variable](./StreamVideoClient.md/#readonlystatestore)).
         * This is usually helpful when detailed stats for a specific participant are needed.
         *
         * @param sessionId the sessionId to start reporting for.
         */ this.startReportingStatsFor = (sessionId)=>{
            return this.statsReporter?.startReportingStatsFor(sessionId);
        };
        /**
         * Opposite of `startReportingStatsFor`.
         * Will turn off stats reporting for a specific participant.
         *
         * @param sessionId the sessionId to stop reporting for.
         */ this.stopReportingStatsFor = (sessionId)=>{
            return this.statsReporter?.stopReportingStatsFor(sessionId);
        };
        /**
         * Sets the frequency of the call stats reporting.
         *
         * @param intervalInMs the interval in milliseconds to report the stats.
         */ this.setStatsReportingIntervalInMs = (intervalInMs)=>{
            this.statsReportingIntervalInMs = intervalInMs;
        };
        /**
         * Resets the last sent reaction for the user holding the given `sessionId`. This is a local action, it won't reset the reaction on the backend.
         *
         * @param sessionId the session id.
         */ this.resetReaction = (sessionId)=>{
            this.state.updateParticipant(sessionId, {
                reaction: undefined
            });
        };
        /**
         * Sets the list of criteria to sort the participants by.
         *
         * @param criteria the list of criteria to sort the participants by.
         */ this.setSortParticipantsBy = (criteria)=>{
            return this.state.setSortParticipantsBy(criteria);
        };
        /**
         * Sends a reaction to the other call participants.
         *
         * @param reaction the reaction to send.
         */ this.sendReaction = async (reaction)=>{
            return this.streamClient.post(`${this.streamClientBasePath}/reaction`, reaction);
        };
        /**
         * Blocks the user with the given `userId`.
         *
         * @param userId the id of the user to block.
         */ this.blockUser = async (userId)=>{
            return this.streamClient.post(`${this.streamClientBasePath}/block`, {
                user_id: userId
            });
        };
        /**
         * Unblocks the user with the given `userId`.
         *
         * @param userId the id of the user to unblock.
         */ this.unblockUser = async (userId)=>{
            return this.streamClient.post(`${this.streamClientBasePath}/unblock`, {
                user_id: userId
            });
        };
        /**
         * Kicks the user with the given `userId`.
         * @param data the kick request.
         */ this.kickUser = async (data)=>{
            return this.streamClient.post(`${this.streamClientBasePath}/kick`, data);
        };
        /**
         * Mutes the current user.
         *
         * @param type the type of the mute operation.
         */ this.muteSelf = (type)=>{
            const myUserId = this.currentUserId;
            if (myUserId) return this.muteUser(myUserId, type);
        };
        /**
         * Mutes all the other participants.
         *
         * @param type the type of the mute operation.
         */ this.muteOthers = (type)=>{
            const trackType = $8c05ed6f2f331ee8$var$muteTypeToTrackType(type);
            if (!trackType) return;
            const userIdsToMute = [];
            for (const participant of this.state.remoteParticipants)if (participant.publishedTracks.includes(trackType)) userIdsToMute.push(participant.userId);
            if (userIdsToMute.length > 0) return this.muteUser(userIdsToMute, type);
        };
        /**
         * Mutes the user with the given `userId`.
         *
         * @param userId the id of the user to mute.
         * @param type the type of the mute operation.
         */ this.muteUser = (userId, type)=>{
            return this.streamClient.post(`${this.streamClientBasePath}/mute_users`, {
                user_ids: Array.isArray(userId) ? userId : [
                    userId
                ],
                [type]: true
            });
        };
        /**
         * Will mute all users in the call.
         *
         * @param type the type of the mute operation.
         */ this.muteAllUsers = (type)=>{
            return this.streamClient.post(`${this.streamClientBasePath}/mute_users`, {
                mute_all_users: true,
                [type]: true
            });
        };
        /**
         * Starts recording the call
         */ this.startRecording = async (dataOrType, type)=>{
            type = typeof dataOrType === 'string' ? dataOrType : type;
            dataOrType = typeof dataOrType === 'string' ? undefined : dataOrType;
            const endpoint = !type ? `/start_recording` : `/recordings/${encodeURIComponent(type)}/start`;
            return this.streamClient.post(`${this.streamClientBasePath}${endpoint}`, dataOrType);
        };
        /**
         * Stops recording the call
         */ this.stopRecording = async (type)=>{
            const endpoint = !type ? `/stop_recording` : `/recordings/${encodeURIComponent(type)}/stop`;
            return this.streamClient.post(`${this.streamClientBasePath}${endpoint}`);
        };
        /**
         * Starts the transcription of the call.
         *
         * @param request the request data.
         */ this.startTranscription = async (request)=>{
            return this.streamClient.post(`${this.streamClientBasePath}/start_transcription`, request);
        };
        /**
         * Stops the transcription of the call.
         */ this.stopTranscription = async ()=>{
            return this.streamClient.post(`${this.streamClientBasePath}/stop_transcription`);
        };
        /**
         * Starts the closed captions of the call.
         */ this.startClosedCaptions = async (options)=>{
            const trx = this.state.setCaptioning(true); // optimistic update
            try {
                return await this.streamClient.post(`${this.streamClientBasePath}/start_closed_captions`, options);
            } catch (err) {
                trx.rollback(); // revert the optimistic update
                throw err;
            }
        };
        /**
         * Stops the closed captions of the call.
         */ this.stopClosedCaptions = async (options)=>{
            const trx = this.state.setCaptioning(false); // optimistic update
            try {
                return await this.streamClient.post(`${this.streamClientBasePath}/stop_closed_captions`, options);
            } catch (err) {
                trx.rollback(); // revert the optimistic update
                throw err;
            }
        };
        /**
         * Updates the closed caption settings.
         *
         * @param config the closed caption settings to apply
         */ this.updateClosedCaptionSettings = (config)=>{
            this.state.updateClosedCaptionSettings(config);
        };
        /**
         * Sends a `call.permission_request` event to all users connected to the call.
         * The call settings object contains information about which permissions can be requested during a call
         * (for example, a user might be allowed to request permission to publish audio, but not video).
         */ this.requestPermissions = async (data)=>{
            const { permissions: permissions } = data;
            const canRequestPermissions = permissions.every((permission)=>this.permissionsContext.canRequest(permission));
            if (!canRequestPermissions) throw new Error(`You are not allowed to request permissions: ${permissions.join(', ')}`);
            return this.streamClient.post(`${this.streamClientBasePath}/request_permission`, data);
        };
        /**
         * Allows you to grant certain permissions to a user in a call.
         * The permissions are specific to the call experience and do not survive the call itself.
         *
         * Supported permissions that can be granted are:
         * - `send-audio`
         * - `send-video`
         * - `screenshare`
         *
         * @param userId the id of the user to grant permissions to.
         * @param permissions the permissions to grant.
         */ this.grantPermissions = async (userId, permissions)=>{
            return this.updateUserPermissions({
                user_id: userId,
                grant_permissions: permissions
            });
        };
        /**
         * Allows you to revoke certain permissions from a user in a call.
         * The permissions are specific to the call experience and do not survive the call itself.
         *
         * Supported permissions that can be revoked are:
         * - `send-audio`
         * - `send-video`
         * - `screenshare`
         *
         * @param userId the id of the user to revoke permissions from.
         * @param permissions the permissions to revoke.
         */ this.revokePermissions = async (userId, permissions)=>{
            return this.updateUserPermissions({
                user_id: userId,
                revoke_permissions: permissions
            });
        };
        /**
         * Allows you to grant or revoke a specific permission to a user in a call. The permissions are specific to the call experience and do not survive the call itself.
         * When revoking a permission, this endpoint will also mute the relevant track from the user. This is similar to muting a user with the difference that the user will not be able to unmute afterwards.
         * Supported permissions that can be granted or revoked: `send-audio`, `send-video` and `screenshare`.
         *
         * `call.permissions_updated` event is sent to all members of the call.
         */ this.updateUserPermissions = async (data)=>{
            return this.streamClient.post(`${this.streamClientBasePath}/user_permissions`, data);
        };
        /**
         * Starts the livestreaming of the call.
         *
         * @param data the request data.
         * @param params the request params.
         */ this.goLive = async (data = {}, params)=>{
            return this.streamClient.post(`${this.streamClientBasePath}/go_live`, data, params);
        };
        /**
         * Stops the livestreaming of the call.
         */ this.stopLive = async (data = {})=>{
            return this.streamClient.post(`${this.streamClientBasePath}/stop_live`, data);
        };
        /**
         * Starts the broadcasting of the call.
         */ this.startHLS = async ()=>{
            return this.streamClient.post(`${this.streamClientBasePath}/start_broadcasting`, {});
        };
        /**
         * Stops the broadcasting of the call.
         */ this.stopHLS = async ()=>{
            return this.streamClient.post(`${this.streamClientBasePath}/stop_broadcasting`, {});
        };
        /**
         * Starts the RTMP-out broadcasting of the call.
         */ this.startRTMPBroadcasts = async (data)=>{
            return this.streamClient.post(`${this.streamClientBasePath}/rtmp_broadcasts`, data);
        };
        /**
         * Stops all RTMP-out broadcasting of the call.
         */ this.stopAllRTMPBroadcasts = async ()=>{
            return this.streamClient.post(`${this.streamClientBasePath}/rtmp_broadcasts/stop`);
        };
        /**
         * Stops the RTMP-out broadcasting of the call specified by it's name.
         */ this.stopRTMPBroadcast = async (name)=>{
            return this.streamClient.post(`${this.streamClientBasePath}/rtmp_broadcasts/${name}/stop`);
        };
        /**
         * Starts frame by frame recording.
         * Sends call.frame_recording_started events
         */ this.startFrameRecording = async (data)=>{
            return this.streamClient.post(`${this.streamClientBasePath}/start_frame_recording`, data);
        };
        /**
         * Stops frame recording.
         */ this.stopFrameRecording = async ()=>{
            return this.streamClient.post(`${this.streamClientBasePath}/stop_frame_recording`);
        };
        /**
         * Updates the call settings or custom data.
         *
         * @param updates the updates to apply to the call.
         */ this.update = async (updates)=>{
            const response = await this.streamClient.patch(`${this.streamClientBasePath}`, updates);
            const { call: call, members: members, own_capabilities: own_capabilities } = response;
            this.state.updateFromCallResponse(call);
            this.state.setMembers(members);
            this.state.setOwnCapabilities(own_capabilities);
            return response;
        };
        /**
         * Ends the call. Once the call is ended, it cannot be re-joined.
         */ this.endCall = async ()=>{
            return this.streamClient.post(`${this.streamClientBasePath}/mark_ended`);
        };
        /**
         * Pins the given session to the top of the participants list.
         *
         * @param sessionId the sessionId to pin.
         */ this.pin = (sessionId)=>{
            this.state.updateParticipant(sessionId, {
                pin: {
                    isLocalPin: true,
                    pinnedAt: Date.now()
                }
            });
        };
        /**
         * Unpins the given session from the top of the participants list.
         *
         * @param sessionId the sessionId to unpin.
         */ this.unpin = (sessionId)=>{
            this.state.updateParticipant(sessionId, {
                pin: undefined
            });
        };
        /**
         * Pins the given session to the top of the participants list for everyone
         * in the call.
         * You can execute this method only if you have the `pin-for-everyone` capability.
         *
         * @param request the request object.
         */ this.pinForEveryone = async (request)=>{
            return this.streamClient.post(`${this.streamClientBasePath}/pin`, request);
        };
        /**
         * Unpins the given session from the top of the participants list for everyone
         * in the call.
         * You can execute this method only if you have the `pin-for-everyone` capability.
         *
         * @param request the request object.
         */ this.unpinForEveryone = async (request)=>{
            return this.streamClient.post(`${this.streamClientBasePath}/unpin`, request);
        };
        /**
         * Query call members with filter query. The result won't be stored in call state.
         * @param request
         * @returns
         */ this.queryMembers = (request)=>{
            return this.streamClient.post('/call/members', {
                ...request || {},
                id: this.id,
                type: this.type
            });
        };
        /**
         * Query call participants with optional filters.
         *
         * @param data the request data.
         * @param params optional query parameters.
         */ this.queryParticipants = async (data = {}, params = {})=>{
            return this.streamClient.post(`${this.streamClientBasePath}/participants`, data, params);
        };
        /**
         * Will update the call members.
         *
         * @param data the request data.
         */ this.updateCallMembers = async (data)=>{
            return this.streamClient.post(`${this.streamClientBasePath}/members`, data);
        };
        /**
         * Schedules an auto-drop timeout based on the call settings.
         * Applicable only for ringing calls.
         */ this.scheduleAutoDrop = ()=>{
            this.cancelAutoDrop();
            const settings = this.state.settings;
            if (!settings) return;
            // ignore if the call is not ringing
            if (this.state.callingState !== $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.RINGING) return;
            const timeoutInMs = this.isCreatedByMe ? settings.ring.auto_cancel_timeout_ms : settings.ring.incoming_call_timeout_ms;
            // 0 means no auto-drop
            if (timeoutInMs <= 0) return;
            this.dropTimeout = setTimeout(()=>{
                // the call might have stopped ringing by this point,
                // e.g. it was already accepted and joined
                if (this.state.callingState !== $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.RINGING) return;
                this.leave({
                    reject: true,
                    reason: 'timeout',
                    message: `ringing timeout - ${this.isCreatedByMe ? 'no one accepted' : `user didn't interact with incoming call screen`}`
                }).catch((err)=>{
                    this.logger.error('Failed to drop call', err);
                });
            }, timeoutInMs);
        };
        /**
         * Cancels a scheduled auto-drop timeout.
         */ this.cancelAutoDrop = ()=>{
            clearTimeout(this.dropTimeout);
            this.dropTimeout = undefined;
        };
        /**
         * Retrieves the list of recordings for the current call or call session.
         *
         * If `callSessionId` is provided, it will return the recordings for that call session.
         * Otherwise, all recordings for the current call will be returned.
         *
         * @param callSessionId the call session id to retrieve recordings for.
         * @deprecated use {@link listRecordings} instead.
         */ this.queryRecordings = async (callSessionId)=>{
            return this.listRecordings(callSessionId);
        };
        /**
         * Retrieves the list of recordings for the current call or call session.
         *
         * If `callSessionId` is provided, it will return the recordings for that call session.
         * Otherwise, all recordings for the current call will be returned.
         *
         * @param callSessionId the call session id to retrieve recordings for.
         */ this.listRecordings = async (callSessionId)=>{
            let endpoint = this.streamClientBasePath;
            if (callSessionId) endpoint = `${endpoint}/${callSessionId}`;
            return this.streamClient.get(`${endpoint}/recordings`);
        };
        /**
         * Deletes a recording for the given call session.
         *
         * @param callSessionId the call session id that the recording belongs to.
         * @param filename the recording filename.
         */ this.deleteRecording = async (callSessionId, filename)=>{
            return this.streamClient.delete(`${this.streamClientBasePath}/${encodeURIComponent(callSessionId)}/recordings/${encodeURIComponent(filename)}`);
        };
        /**
         * Deletes a transcription for the given call session.
         *
         * @param callSessionId the call session id that the transcription belongs to.
         * @param filename the transcription filename.
         */ this.deleteTranscription = async (callSessionId, filename)=>{
            return this.streamClient.delete(`${this.streamClientBasePath}/${encodeURIComponent(callSessionId)}/transcriptions/${encodeURIComponent(filename)}`);
        };
        /**
         * Retrieves the list of transcriptions for the current call.
         *
         * @returns the list of transcriptions.
         * @deprecated use {@link listTranscriptions} instead.
         */ this.queryTranscriptions = async ()=>{
            return this.listTranscriptions();
        };
        /**
         * Retrieves the list of transcriptions for the current call.
         *
         * @returns the list of transcriptions.
         */ this.listTranscriptions = async ()=>{
            return this.streamClient.get(`${this.streamClientBasePath}/transcriptions`);
        };
        /**
         * Retrieve call statistics for a particular call session (historical).
         * Here `callSessionID` is mandatory.
         *
         * @param callSessionID the call session ID to retrieve statistics for.
         * @returns The call stats.
         * @deprecated use `call.getCallReport` instead.
         * @internal
         */ this.getCallStats = async (callSessionID)=>{
            const endpoint = `${this.streamClientBasePath}/stats/${callSessionID}`;
            return this.streamClient.get(endpoint);
        };
        /**
         * Retrieve call report. If the `callSessionID` is not specified, then the
         * report for the latest call session is retrieved. If it is specified, then
         * the report for that particular session is retrieved if it exists.
         *
         * @param callSessionID the optional call session ID to retrieve statistics for
         * @returns the call report
         */ this.getCallReport = async (callSessionID = '')=>{
            const endpoint = `${this.streamClientBasePath}/report`;
            const params = callSessionID !== '' ? {
                session_id: callSessionID
            } : {};
            return this.streamClient.get(endpoint, params);
        };
        /**
         * Loads the call participant stats for the given parameters.
         */ this.getCallParticipantsStats = async (opts)=>{
            const { sessionId: sessionId = this.state.session?.id, userId: userId = this.currentUserId, userSessionId: userSessionId = this.unifiedSessionId, kind: kind = 'details' } = opts;
            if (!sessionId) return;
            const base = `${this.streamClient.baseURL}/call_stats/${this.type}/${this.id}/${sessionId}`;
            if (!userId || !userSessionId) return this.streamClient.get(`${base}/participants`);
            if (kind === 'details') return this.streamClient.get(`${base}/participant/${userId}/${userSessionId}/details`);
            return this.streamClient.get(`${base}/participants/${userId}/${userSessionId}/timeline`);
        };
        /**
         * Submit user feedback for the call
         *
         * @param rating Rating between 1 and 5 denoting the experience of the user in the call
         * @param reason The reason/description for the rating
         * @param custom Custom data
         */ this.submitFeedback = async (rating, { reason: reason, custom: custom } = {})=>{
            const { sdkName: sdkName, sdkVersion: sdkVersion, ...platform } = $8c05ed6f2f331ee8$var$getSdkSignature(await $8c05ed6f2f331ee8$export$9d409e1fdb877bc1());
            return this.streamClient.post(`${this.streamClientBasePath}/feedback`, {
                rating: rating,
                reason: reason,
                user_session_id: this.sfuClient?.sessionId,
                sdk: sdkName,
                sdk_version: sdkVersion,
                custom: {
                    ...custom,
                    'x-stream-platform-data': platform
                }
            });
        };
        /**
         * Retrieves the call stats for the current call session in a format suitable
         * for displaying in map-like UIs.
         */ this.getCallStatsMap = async (params = {}, callSessionId = this.state.session?.id)=>{
            if (!callSessionId) throw new Error('callSessionId is required');
            return this.streamClient.get(`${this.streamClient.baseURL}/call_stats/${this.type}/${this.id}/${callSessionId}/map`, params);
        };
        /**
         * Sends a custom event to all call participants.
         *
         * @param payload the payload to send.
         */ this.sendCustomEvent = async (payload)=>{
            return this.streamClient.post(`${this.streamClientBasePath}/event`, {
                custom: payload
            });
        };
        /**
         * Applies the device configuration from the backend.
         *
         * @internal
         */ this.applyDeviceConfig = async (settings, publish, skipSpeakerApply)=>{
            if (!skipSpeakerApply) this.speaker.apply(settings);
            await this.camera.apply(settings.video, publish).catch((err)=>{
                this.logger.warn('Camera init failed', err);
            });
            await this.microphone.apply(settings.audio, publish).catch((err)=>{
                this.logger.warn('Mic init failed', err);
            });
        };
        /**
         * Will begin tracking the given element for visibility changes within the
         * configured viewport element (`call.setViewport`).
         *
         * @param element the element to track.
         * @param sessionId the session id.
         * @param trackType the video mode.
         */ this.trackElementVisibility = (element, sessionId, trackType)=>{
            return this.viewportTracker?.trackElementVisibility(element, sessionId, trackType);
        };
        /**
         * Sets the viewport element to track bound video elements for visibility.
         *
         * @param element the viewport element.
         */ this.setViewport = (element)=>{
            return this.viewportTracker?.setViewport(element);
        };
        /**
         * Binds a DOM <video> element to the given session id.
         * This method will make sure that the video element will play
         * the correct video stream for the given session id.
         *
         * Under the hood, it would also keep track of the video element dimensions
         * and update the subscription accordingly in order to optimize the bandwidth.
         *
         * If a "viewport" is configured, the video element will be automatically
         * tracked for visibility and the subscription will be updated accordingly.
         *
         * @param videoElement the video element to bind to.
         * @param sessionId the session id.
         * @param trackType the kind of video.
         */ this.bindVideoElement = (videoElement, sessionId, trackType)=>{
            const unbindDynascale = this.dynascaleManager?.bindVideoElement(videoElement, sessionId, trackType);
            const stopFirstFrameDetector = this.bindFirstVideoFrameDetector(videoElement, sessionId, trackType);
            if (!unbindDynascale && !stopFirstFrameDetector) return;
            const unbind = ()=>{
                stopFirstFrameDetector?.();
                unbindDynascale?.();
            };
            this.leaveCallHooks.add(unbind);
            return ()=>{
                this.leaveCallHooks.delete(unbind);
                unbind();
            };
        };
        this.bindFirstVideoFrameDetector = (videoElement, sessionId, trackType)=>{
            if (trackType !== 'videoTrack') return;
            return $8c05ed6f2f331ee8$var$createFirstVideoFrameDetector(videoElement, ()=>{
                this.reportFirstRenderedVideoFrame(sessionId);
            });
        };
        this.reportFirstRenderedVideoFrame = (sessionId)=>{
            const participant = this.state.findParticipantBySessionId(sessionId);
            if (participant?.isLocalParticipant) return;
            const trackId = participant?.videoStream?.getVideoTracks()[0]?.id;
            if (!trackId) return;
            this.clientEventReporter.reportFirstFrame(this.cid, $8c05ed6f2f331ee8$var$TrackType.VIDEO, trackId);
        };
        /**
         * Binds a DOM <audio> element to the given session id.
         *
         * This method will make sure that the audio element will
         * play the correct audio stream for the given session id.
         *
         * @param audioElement the audio element to bind to.
         * @param sessionId the session id.
         * @param trackType the kind of audio.
         */ this.bindAudioElement = (audioElement, sessionId, trackType = 'audioTrack')=>{
            const unbind = this.dynascaleManager?.bindAudioElement(audioElement, sessionId, trackType);
            if (!unbind) return;
            this.audioBindingsWatchdog?.register(audioElement, sessionId, trackType);
            const cleanup = ()=>{
                unbind();
                this.audioBindingsWatchdog?.unregister(sessionId, trackType);
            };
            this.leaveCallHooks.add(cleanup);
            return ()=>{
                this.leaveCallHooks.delete(cleanup);
                cleanup();
            };
        };
        /**
         * Plays all audio elements blocked by the browser's autoplay policy.
         * Must be called from within a user gesture (e.g., click handler).
         *
         * Subscribe to `call.blockedAudioTracker.autoplayBlocked$` to know when a
         * gesture is required.
         */ this.resumeAudio = ()=>this.blockedAudioTracker.resumeAudio();
        /**
         * Binds a DOM <img> element to this call's thumbnail (if enabled in settings).
         *
         * @param imageElement the image element to bind to.
         * @param opts options for the binding.
         */ this.bindCallThumbnailElement = (imageElement, opts = {})=>{
            const handleError = ()=>{
                imageElement.src = opts.fallbackImageSource || 'https://getstream.io/random_svg/?name=x&id=x';
            };
            const unsubscribe = $8c05ed6f2f331ee8$var$createSubscription(this.state.thumbnails$, (thumbnails)=>{
                if (!thumbnails) return;
                imageElement.addEventListener('error', handleError);
                const thumbnailUrl = new URL(thumbnails.image_url);
                thumbnailUrl.searchParams.set('w', String(imageElement.clientWidth));
                thumbnailUrl.searchParams.set('h', String(imageElement.clientHeight));
                imageElement.src = thumbnailUrl.toString();
            });
            return ()=>{
                unsubscribe();
                imageElement.removeEventListener('error', handleError);
            };
        };
        /**
         * Specify preference for incoming video resolution. The preference will
         * be matched as close as possible, but actual resolution will depend
         * on the video source quality and client network conditions. Will enable
         * incoming video, if previously disabled.
         *
         * @param resolution preferred resolution, or `undefined` to clear preference
         * @param sessionIds optionally specify session ids of the participants this
         * preference has effect on. Affects all participants by default.
         */ this.setPreferredIncomingVideoResolution = (resolution, sessionIds)=>{
            this.trackSubscriptionManager.setOverrides(resolution ? {
                enabled: true,
                dimension: resolution
            } : undefined, sessionIds);
            this.trackSubscriptionManager.apply();
        };
        /**
         * Enables or disables incoming video from all remote call participants,
         * and removes any preference for preferred resolution.
         */ this.setIncomingVideoEnabled = (enabled)=>{
            this.trackSubscriptionManager.setOverrides(enabled ? undefined : {
                enabled: false
            });
            this.trackSubscriptionManager.apply();
        };
        /**
         * Sets the maximum amount of time a user can remain waiting for a reconnect
         * after a network disruption
         * @param timeoutSeconds Timeout in seconds, or 0 to keep reconnecting indefinetely
         */ this.setDisconnectionTimeout = (timeoutSeconds)=>{
            this.disconnectionTimeoutSeconds = timeoutSeconds;
        };
        /**
         * Configures the rolling-window limit for REJOIN/MIGRATE attempts. Once
         * `maxAttempts` rejoins have been registered inside `windowSeconds`, the
         * SDK stops retrying and transitions the call to `LEFT` with the
         * `rejoin_attempt_limit_exceeded` leave message.
         *
         * Defaults: 10 attempts per 120 seconds (aligned with the Swift SDK).
         * Both arguments are clamped to a minimum of 1.
         */ this.setRejoinAttemptLimit = (maxAttempts, windowSeconds)=>{
            this.rejoinRateLimiter.setLimits(Math.max(1, maxAttempts), Math.max(1, windowSeconds) * 1000);
        };
        /**
         * Configures how many peer-connection failures where ICE never reached
         * `connected`/`completed` are tolerated before the SDK concludes that the
         * current network cannot support WebRTC and transitions the call to
         * `LEFT` with the `webrtc_unsupported_network` leave message.
         *
         * Default: 2. Clamped to a minimum of 1.
         */ this.setMaxIceFailuresWithoutConnect = (n)=>{
            this.maxIceFailuresWithoutConnect = Math.max(1, n);
        };
        /**
         * Configures how many consecutive SDP `NegotiationError`s are tolerated
         * before the SDK stops retrying and transitions the call to `LEFT` with
         * the `repeated_negotiation_failures` leave message.
         *
         * Default: 3. Clamped to a minimum of 1.
         */ this.setMaxConsecutiveNegotiationFailures = (n)=>{
            this.maxConsecutiveNegotiationFailures = Math.max(1, n);
        };
        /**
         * Enables the provided client capabilities.
         */ this.enableClientCapabilities = (...capabilities)=>{
            for (const capability of capabilities)this.clientCapabilities.add(capability);
        };
        /**
         * Disables the provided client capabilities.
         */ this.disableClientCapabilities = (...capabilities)=>{
            for (const capability of capabilities)this.clientCapabilities.delete(capability);
        };
        this.type = type;
        this.id = id;
        this.cid = `${type}:${id}`;
        this.ringingSubject = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(ringing);
        this.watching = watching;
        this.streamClient = streamClient;
        this.clientEventReporter = clientEventReporter;
        this.clientStore = clientStore;
        this.streamClientBasePath = `/call/${this.type}/${this.id}`;
        this.logger = $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger('Call');
        const callTypeConfig = $8c05ed6f2f331ee8$export$6983c6d5a7dfc9ea.get(type);
        const participantSorter = sortParticipantsBy || callTypeConfig.options.sortParticipantsBy;
        if (participantSorter) this.state.setSortParticipantsBy(participantSorter);
        this.state.setMembers(members || []);
        this.state.setOwnCapabilities(ownCapabilities || []);
        this.state.setCallingState(ringing ? $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.RINGING : $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.IDLE);
        const preferences = $8c05ed6f2f331ee8$var$normalize(streamClient.options.devicePersistence);
        this.camera = new $8c05ed6f2f331ee8$export$2c292fd153a01657(this, preferences);
        this.microphone = new $8c05ed6f2f331ee8$export$e454f5428368fe79(this, preferences);
        this.speaker = new $8c05ed6f2f331ee8$export$aefaf8e7d93e41ca(this, preferences);
        this.screenShare = new $8c05ed6f2f331ee8$export$dd56c7406f7afaf3(this);
        this.trackSubscriptionManager = new $8c05ed6f2f331ee8$var$TrackSubscriptionManager(this.state, this.tracer);
        this.blockedAudioTracker = new $8c05ed6f2f331ee8$var$BlockedAudioTracker(this.tracer);
        if (typeof document !== 'undefined') {
            this.audioBindingsWatchdog = new $8c05ed6f2f331ee8$var$AudioBindingsWatchdog(this.state, this.tracer);
            this.viewportTracker = new $8c05ed6f2f331ee8$export$cce50747fc92288(this.state);
            this.dynascaleManager = new $8c05ed6f2f331ee8$export$da5c04fd91fda94(this.state, this.speaker, this.tracer, this.trackSubscriptionManager, this.blockedAudioTracker);
        }
    }
    /**
     * A flag indicating whether the call is "ringing" type of call.
     */ get ringing() {
        return $8c05ed6f2f331ee8$var$getCurrentValue(this.ringingSubject);
    }
    /**
     * Retrieves the current user ID.
     */ get currentUserId() {
        return this.clientStore.connectedUser?.id;
    }
    /**
     * A flag indicating whether the call was created by the current user.
     */ get isCreatedByMe() {
        return this.currentUserId && this.state.createdBy?.id === this.currentUserId;
    }
}
var $8c05ed6f2f331ee8$var$https = null;
const $8c05ed6f2f331ee8$var$APIErrorCodes = {
    [-1]: 'InternalSystemError',
    2: 'AccessKeyError',
    3: 'AuthenticationFailedError',
    4: 'InputError',
    5: 'AuthenticationError',
    6: 'DuplicateUsernameError',
    9: 'RateLimitError',
    16: 'DoesNotExistError',
    17: 'NotAllowedError',
    18: 'EventNotSupportedError',
    19: 'ChannelFeatureNotSupportedError',
    20: 'MessageTooLongError',
    21: 'MultipleNestingLevelError',
    22: 'PayloadTooBigError',
    23: 'RequestTimeoutError',
    24: 'MaxHeaderSizeExceededError',
    40: 'AuthErrorTokenExpired',
    41: 'AuthErrorTokenNotValidYet',
    42: 'AuthErrorTokenUsedBeforeIssuedAt',
    43: 'AuthErrorTokenSignatureInvalid',
    44: 'CustomCommandEndpointMissingError',
    45: 'CustomCommandEndpointCallError',
    46: 'ConnectionIDNotFoundError',
    60: 'CoolDownError',
    69: 'ErrWrongRegion',
    70: 'ErrQueryChannelPermissions',
    71: 'ErrTooManyConnections',
    73: 'MessageModerationFailedError',
    99: 'AppSuspendedError'
};
/**
 * StableWSConnection - A WS connection that reconnects upon failure.
 * - the browser will sometimes report that you're online or offline
 * - the WS connection can break and fail (there is a 30s health check)
 * - sometimes your WS connection will seem to work while the user is in fact offline
 * - to speed up online/offline detection you can use the window.addEventListener('offline');
 *
 * There are 4 ways in which a connection can become unhealthy:
 * - websocket.onerror is called
 * - websocket.onclose is called
 * - the health check fails and no event is received for ~40 seconds
 * - the browser indicates the connection is now offline
 *
 * There are 2 assumptions we make about the server:
 * - state can be recovered by querying the channel again
 * - if the servers fails to publish a message to the client, the WS connection is destroyed
 */ class $8c05ed6f2f331ee8$var$StableWSConnection {
    constructor(client){
        /** Incremented when a new WS connection is made */ this.wsID = 1;
        // Connection lifecycle flags.
        /** We only make 1 attempt to reconnect at the same time.. */ this.isConnecting = false;
        /** To avoid reconnect if client is disconnected */ this.isDisconnected = false;
        /** Boolean that indicates if we have a working connection to the server */ this.isHealthy = false;
        /** Boolean that indicates if the connection promise is resolved */ this.isConnectionOpenResolved = false;
        // Failure counters (drive retry/backoff scheduling).
        /** consecutive failures influence the duration of the timeout */ this.consecutiveFailures = 0;
        /** keep track of the total number of failures */ this.totalFailures = 0;
        // Health-check pings + connection-staleness check.
        /** Send a health check message every 25 seconds */ this.pingInterval = 25000;
        this.connectionCheckTimeout = this.pingInterval + 10000;
        /** Store the last event time for health checks */ this.lastEvent = null;
        this._log = (msg, extra = {}, level = 'info')=>{
            this.client.logger[level](`connection:${msg}`, extra);
        };
        this.setClient = (client)=>{
            this.client = client;
        };
        /**
         * connect - Connect to the WS URL
         * the default 15s timeout allows between 2~3 tries
         * @return Promise that completes once the first health check message is received
         */ this.connect = async (timeout = 15000)=>{
            if (this.isConnecting) throw Error(`You've called connect twice, can only attempt 1 connection at the time`);
            this.isDisconnected = false;
            try {
                const healthCheck = await this._connect(timeout);
                this.consecutiveFailures = 0;
                this._log(`connect() - Established ws connection with healthcheck: ${healthCheck}`);
            } catch (caught) {
                const error = caught;
                this.isHealthy = false;
                this.consecutiveFailures += 1;
                if (error.code === $8c05ed6f2f331ee8$var$KnownCodes.TOKEN_EXPIRED && !this.client.tokenManager.isStatic()) {
                    this._log('connect() - WS failure due to expired token, so going to try to reload token and reconnect');
                    this._reconnect({
                        refreshToken: true
                    });
                } else if (!error.isWSFailure) // API rejected the connection and we should not retry
                throw new Error(JSON.stringify({
                    code: error.code,
                    StatusCode: error.StatusCode,
                    message: error.message,
                    isWSFailure: error.isWSFailure
                }));
                else // Transient WS failure (e.g., handshake watchdog). Kick off a
                // reconnect chain so _waitForHealthy(timeout) below has something
                // to poll for. Owning the trigger here (rather than inside
                // _connect()'s catch) keeps a single failure from spawning two
                // parallel chains - one from this catch and one from _reconnect's
                // own catch when _connect was called from there.
                this._reconnect();
            }
            return await this._waitForHealthy(timeout);
        };
        /**
         * _waitForHealthy polls the promise connection to see if its resolved until it times out
         * the default 15s timeout allows between 2~3 tries
         * @param timeout duration(ms)
         */ this._waitForHealthy = async (timeout = 15000)=>{
            return Promise.race([
                (async ()=>{
                    const interval = 50; // ms
                    for(let i = 0; i <= timeout; i += interval)try {
                        return await this.connectionOpen;
                    } catch (caught) {
                        const error = caught;
                        if (i === timeout) throw new Error(JSON.stringify({
                            code: error.code,
                            StatusCode: error.StatusCode,
                            message: error.message,
                            isWSFailure: error.isWSFailure
                        }));
                        await $8c05ed6f2f331ee8$var$sleep(interval);
                    }
                })(),
                (async ()=>{
                    await $8c05ed6f2f331ee8$var$sleep(timeout);
                    this.isConnecting = false;
                    throw new Error(JSON.stringify({
                        code: '',
                        StatusCode: '',
                        message: 'initial WS connection could not be established',
                        isWSFailure: true
                    }));
                })()
            ]);
        };
        /**
         * Builds and returns the url for websocket.
         * @private
         * @returns url string
         */ this._buildUrl = ()=>{
            const params = new URLSearchParams();
            params.set('api_key', this.client.key);
            params.set('stream-auth-type', this.client.getAuthType());
            params.set('X-Stream-Client', this.client.getUserAgent());
            return `${this.client.wsBaseURL}/connect?${params.toString()}`;
        };
        /**
         * disconnect - Disconnect the connection and doesn't recover...
         */ this.disconnect = (timeout)=>{
            this._log(`disconnect() - Closing the websocket connection for wsID ${this.wsID}`);
            this.wsID += 1;
            this.isConnecting = false;
            this.isDisconnected = true;
            // start by removing all the listeners
            if (this.healthCheckTimeoutRef) $8c05ed6f2f331ee8$var$getTimers().clearInterval(this.healthCheckTimeoutRef);
            if (this.connectionCheckTimeoutRef) clearInterval(this.connectionCheckTimeoutRef);
            $8c05ed6f2f331ee8$var$removeConnectionEventListeners(this.onlineStatusChanged);
            this.isHealthy = false;
            let isClosedPromise;
            // and finally close...
            // Assigning to local here because we will remove it from this before the
            // promise resolves.
            const { ws: ws } = this;
            if (ws && ws.close && ws.readyState === ws.OPEN) {
                isClosedPromise = new Promise((resolve)=>{
                    const onclose = (event)=>{
                        this._log(`disconnect() - resolving isClosedPromise ${event ? 'with' : 'without'} close frame`, {
                            event: event
                        });
                        resolve();
                    };
                    ws.onclose = onclose;
                    // In case we don't receive close frame websocket server in time,
                    // lets not wait for more than 1 second.
                    setTimeout(onclose, timeout != null ? timeout : 1000);
                });
                this._log(`disconnect() - Manually closed connection by calling client.disconnect()`);
                ws.close($8c05ed6f2f331ee8$var$KnownCodes.WS_CLOSED_SUCCESS, 'Manually closed connection by calling client.disconnect()');
            } else {
                this._log(`disconnect() - ws connection doesn't exist or it is already closed.`);
                isClosedPromise = Promise.resolve();
            }
            delete this.ws;
            return isClosedPromise;
        };
        /**
         * _connect - Connect to the WS endpoint
         *
         * @param timeoutMs handshake watchdog deadline in ms. Defaults to
         *   `client.defaultWSTimeout` when not provided. Top-level `connect(timeout)`
         *   passes its own timeout through so caller-supplied deadlines are honored.
         * @return Promise that completes once the first health check message is received
         */ this._connect = async (timeoutMs)=>{
            if (this.isConnecting) return; // ignore _connect if it's currently trying to connect
            this.isConnecting = true;
            // Snapshot of the connection-id reject closure owned by THIS attempt.
            // Captured at function entry so that even early failures (e.g.,
            // tokenManager.loadToken throwing before we reach the WS phase) can
            // settle the promise the caller is awaiting. Re-captured below if
            // _connect itself sets up a fresh promise. If a concurrent
            // openConnection() rotates `client.rejectConnectionId` later, our
            // captured closure still settles only the original promise (P1) and
            // never poisons the newer one (P2).
            let ownRejectConnectionId = this.client.rejectConnectionId;
            let isTokenReady = false;
            try {
                this._log(`_connect() - waiting for token`);
                await this.client.tokenManager.tokenReady();
                isTokenReady = true;
            } catch  {
            // token provider has failed before, so try again
            }
            try {
                if (!isTokenReady) {
                    this._log(`_connect() - tokenProvider failed before, so going to retry`);
                    await this.client.tokenManager.loadToken();
                }
                if (!this.client.isConnectionIdPromisePending) {
                    this.client._setupConnectionIdPromise();
                    // recapture: we just rotated the resolver ourselves, the new
                    // closure is the one bound to the promise this attempt owns.
                    ownRejectConnectionId = this.client.rejectConnectionId;
                }
                this._setupConnectionPromise();
                const wsURL = this._buildUrl();
                this._log(`_connect() - Connecting to ${wsURL}`);
                const WS = this.client.options.WebSocketImpl ?? WebSocket;
                this.ws = new WS(wsURL);
                this.ws.onopen = this.onopen.bind(this, this.wsID);
                this.ws.onclose = this.onclose.bind(this, this.wsID);
                this.ws.onerror = this.onerror.bind(this, this.wsID);
                this.ws.onmessage = this.onmessage.bind(this, this.wsID);
                // race the WS handshake against an explicit deadline so a silent
                // network drop (e.g., carrier NAT or firewall) cannot wedge _connect()
                const handshakeTimeout = timeoutMs ?? this.client.defaultWSTimeout;
                const timers = $8c05ed6f2f331ee8$var$getTimers();
                let handshakeTimeoutId;
                let response;
                try {
                    response = await Promise.race([
                        this.connectionOpen,
                        new Promise((_, reject)=>{
                            handshakeTimeoutId = timers.setTimeout(()=>{
                                const err = new Error(`WS handshake timed out after ${handshakeTimeout}ms`);
                                err.isWSFailure = true;
                                reject(err);
                            }, handshakeTimeout);
                        })
                    ]);
                } finally{
                    timers.clearTimeout(handshakeTimeoutId);
                }
                this.isConnecting = false;
                // If we were disconnected during the handshake (e.g. closeConnection()
                // ran while a background _reconnect's _connect was in flight), tear
                // down the new WS and throw so the caller of connect() does not get
                // a misleading "success" for a connection that has already been
                // aborted. We must NOT skip the throw and just return undefined: the
                // outer connect() would otherwise fall through to _waitForHealthy(),
                // which would observe the already-resolved connectionOpen promise
                // and resolve with a ConnectedEvent for a torn-down connection.
                if (this.isDisconnected) {
                    if (this.ws && this.ws.readyState !== this.ws.CLOSED) this._destroyCurrentWSConnection();
                    throw new Error('WS handshake aborted: disconnect() ran while connecting');
                }
                if (response) {
                    this.connectionID = response.connection_id;
                    this.client.resolveConnectionId?.(this.connectionID);
                    return response;
                }
            } catch (caught) {
                const err = caught;
                this.isConnecting = false;
                this._log(`_connect() - Error - `, err);
                // Reject THIS attempt's connection-id promise (P1) directly via the
                // captured closure. Whether or not a concurrent openConnection() has
                // since rotated client.rejectConnectionId to a newer promise (P2),
                // calling ownRejectConnectionId only settles P1 - P2 is untouched.
                // P1's awaiters (e.g., doAxiosRequest awaiting connectionIdPromise)
                // therefore fail fast instead of being orphaned.
                ownRejectConnectionId?.(err);
                // connectionOpen is per-instance and not subject to rotation, so
                // calling it unconditionally is safe (and a no-op if already settled).
                this.rejectConnectionOpen?.(err);
                // tear down a half-open WS so it does not linger and fire a stale wsID later
                if (this.ws && this.ws.readyState !== this.ws.CLOSED) this._destroyCurrentWSConnection();
                throw err;
            }
        };
        /**
         * onlineStatusChanged - this function is called when the browser connects or disconnects from the internet.
         *
         * @param {Event} event Event with type online or offline
         */ this.onlineStatusChanged = (event)=>{
            if (event.type === 'offline') {
                // mark the connection as down
                this._log('onlineStatusChanged() - Status changing to offline');
                // we know that the app is offline so dispatch the unhealthy connection event immediately
                this._setHealth(false, true);
            } else if (event.type === 'online') {
                // retry right now...
                // We check this.isHealthy, not sure if it's always
                // smart to create a new WS connection if the old one is still up and running.
                // it's possible we didn't miss any messages, so this process is just expensive and not needed.
                this._log(`onlineStatusChanged() - Status changing to online. isHealthy: ${this.isHealthy}`);
                if (!this.isHealthy) this._reconnect({
                    interval: 10
                });
            }
        };
        this.onopen = (wsID)=>{
            if (this.wsID !== wsID) return;
            const user = this.client.user;
            if (!user) {
                this.client.logger.error(`User not set, can't connect to WS`);
                return;
            }
            const token = this.client._getToken();
            if (!token) {
                this.client.logger.error(`Token not set, can't connect authenticate`);
                return;
            }
            const authMessage = JSON.stringify({
                token: token,
                user_details: {
                    id: user.id,
                    name: user.name,
                    image: user.image,
                    custom: user.custom
                }
            });
            this._log(`onopen() - Sending auth message ${authMessage}`, {}, 'trace');
            this.ws?.send(authMessage);
            this._log('onopen() - onopen callback', {
                wsID: wsID
            });
        };
        this.onmessage = (wsID, event)=>{
            if (this.wsID !== wsID) return;
            const data = typeof event.data === 'string' ? JSON.parse(event.data) : null;
            // we wait till the first message before we consider the connection open.
            // the reason for this is that auth errors and similar errors trigger a ws.onopen and immediately
            // after that a ws.onclose.
            if (!this.isConnectionOpenResolved && data && data.type === 'connection.error') {
                this.isConnectionOpenResolved = true;
                if (data.error) {
                    this.rejectConnectionOpen?.(this._errorFromWSEvent(data, false));
                    return;
                }
            }
            // trigger the event..
            this.lastEvent = new Date();
            if (data && (data.type === 'health.check' || data.type === 'connection.ok')) // the initial health-check should come from the client
            this.scheduleNextPing();
            if (data && data.type === 'connection.ok') {
                this.resolveConnectionOpen?.(data);
                this._setHealth(true);
            }
            if (data && data.type === 'connection.error' && data.error) {
                const { code: code } = data.error;
                this.isHealthy = false;
                this.isConnecting = false;
                this.consecutiveFailures += 1;
                if (code === $8c05ed6f2f331ee8$var$KnownCodes.TOKEN_EXPIRED && !this.client.tokenManager.isStatic()) {
                    clearTimeout(this.connectionCheckTimeoutRef);
                    this._log('connect() - WS failure due to expired token, so going to try to reload token and reconnect');
                    this._reconnect({
                        refreshToken: true
                    });
                }
            }
            if (data) {
                data.received_at = new Date();
                this.client.dispatchEvent(data);
            }
            this.scheduleConnectionCheck();
        };
        this.onclose = (wsID, event)=>{
            if (this.wsID !== wsID) return;
            this._log('onclose() - onclose callback - ' + event.code, {
                event: event,
                wsID: wsID
            });
            if (event.code === $8c05ed6f2f331ee8$var$KnownCodes.WS_CLOSED_SUCCESS) {
                // this is a permanent error raised by stream.
                // usually caused by invalid auth details
                const error = new Error(`WS connection reject with error ${event.reason}`);
                error.reason = event.reason;
                error.code = event.code;
                error.wasClean = event.wasClean;
                error.target = event.target;
                this.rejectConnectionOpen?.(error);
                this._log(`onclose() - WS connection reject with error ${event.reason}`, {
                    event: event
                });
            } else {
                this.consecutiveFailures += 1;
                this.totalFailures += 1;
                this._setHealth(false);
                this.isConnecting = false;
                this.rejectConnectionOpen?.(this._errorFromWSEvent(event));
                this._log(`onclose() - WS connection closed. Calling reconnect ...`, {
                    event: event
                });
                // reconnect if its an abnormal failure
                this._reconnect();
            }
        };
        this.onerror = (wsID, event)=>{
            if (this.wsID !== wsID) return;
            this.consecutiveFailures += 1;
            this.totalFailures += 1;
            this._setHealth(false);
            this.isConnecting = false;
            this._log(`onerror() - WS connection resulted into error`, {
                event: event
            });
            this._reconnect();
        };
        /**
         * _setHealth - Sets the connection to healthy or unhealthy.
         * Broadcasts an event in case the connection status changed.
         *
         * @param {boolean} healthy boolean indicating if the connection is healthy or not
         * @param {boolean} dispatchImmediately boolean indicating to dispatch event immediately even if the connection is unhealthy
         */ this._setHealth = (healthy, dispatchImmediately = false)=>{
            if (healthy === this.isHealthy) return;
            this.isHealthy = healthy;
            if (this.isHealthy || dispatchImmediately) {
                this.client.dispatchEvent({
                    type: 'connection.changed',
                    online: this.isHealthy
                });
                return;
            }
            // we're offline, wait few seconds and fire and event if still offline
            setTimeout(()=>{
                if (this.isHealthy) return;
                this.client.dispatchEvent({
                    type: 'connection.changed',
                    online: this.isHealthy
                });
            }, 5000);
        };
        /**
         * _errorFromWSEvent - Creates an error object for the WS event
         */ this._errorFromWSEvent = (event, isWSFailure = true)=>{
            let code;
            let statusCode;
            let message;
            if ($8c05ed6f2f331ee8$var$isCloseEvent(event)) {
                code = event.code;
                message = event.reason;
                statusCode = 0;
            } else {
                const { error: error } = event;
                code = error.code;
                message = error.message;
                statusCode = error.StatusCode;
            }
            const msg = `WS failed with code: ${code}: ${$8c05ed6f2f331ee8$var$APIErrorCodes[code] || code} and reason: ${message}`;
            this._log(msg, {
                event: event
            }, 'warn');
            const error = new Error(msg);
            error.code = code;
            /**
             * StatusCode does not exist on any event types but has been left
             * as is to preserve JS functionality during the TS implementation
             */ error.StatusCode = statusCode;
            error.isWSFailure = isWSFailure;
            return error;
        };
        /**
         * _setupPromise - sets up the this.connectOpen promise
         */ this._setupConnectionPromise = ()=>{
            this.isConnectionOpenResolved = false;
            /** a promise that is resolved once ws.open is called */ this.connectionOpenSafe = $8c05ed6f2f331ee8$var$makeSafePromise(new Promise((resolve, reject)=>{
                this.resolveConnectionOpen = resolve;
                this.rejectConnectionOpen = reject;
            }));
        };
        /**
         * Schedules a next health check ping for websocket.
         */ this.scheduleNextPing = ()=>{
            const timers = $8c05ed6f2f331ee8$var$getTimers();
            if (this.healthCheckTimeoutRef) timers.clearTimeout(this.healthCheckTimeoutRef);
            // 30 seconds is the recommended interval (messenger uses this)
            this.healthCheckTimeoutRef = timers.setTimeout(()=>{
                // send the healthcheck..., server replies with a health check event
                const data = [
                    {
                        type: 'health.check',
                        client_id: this.client.clientID
                    }
                ];
                // try to send on the connection
                try {
                    this.ws?.send(JSON.stringify(data));
                } catch  {
                // error will already be detected elsewhere
                }
            }, this.pingInterval);
        };
        /**
         * scheduleConnectionCheck - schedules a check for time difference between last received event and now.
         * If the difference is more than 35 seconds, it means our health check logic has failed and websocket needs
         * to be reconnected.
         */ this.scheduleConnectionCheck = ()=>{
            clearTimeout(this.connectionCheckTimeoutRef);
            this.connectionCheckTimeoutRef = setTimeout(()=>{
                const now = new Date();
                if (this.lastEvent && now.getTime() - this.lastEvent.getTime() > this.connectionCheckTimeout) {
                    this._log('scheduleConnectionCheck - going to reconnect');
                    this._setHealth(false);
                    this._reconnect();
                }
            }, this.connectionCheckTimeout);
        };
        this.client = client;
        $8c05ed6f2f331ee8$var$addConnectionEventListeners(this.onlineStatusChanged);
    }
    /**
     * _reconnect - Retry the connection to WS endpoint
     *
     * @param {{ interval?: number; refreshToken?: boolean }} options Following options are available
     *
     * - `interval`	{int}			number of ms that function should wait before reconnecting
     * - `refreshToken` {boolean}	reload/refresh user token be refreshed before attempting reconnection.
     */ async _reconnect(options = {}) {
        this._log('_reconnect() - Initiating the reconnect');
        // only allow 1 connection at the time
        if (this.isConnecting || this.isHealthy) {
            this._log('_reconnect() - Abort (1) since already connecting or healthy');
            return;
        }
        // reconnect in case of on error or on close
        // also reconnect if the health check cycle fails
        let interval = options.interval;
        if (!interval) interval = $8c05ed6f2f331ee8$var$retryInterval(this.consecutiveFailures);
        // reconnect, or try again after a little while...
        await $8c05ed6f2f331ee8$var$sleep(interval);
        // Check once again if by some other call to _reconnect is active or connection is
        // already restored, then no need to proceed.
        if (this.isConnecting || this.isHealthy) {
            this._log('_reconnect() - Abort (2) since already connecting or healthy');
            return;
        }
        if (this.isDisconnected) {
            this._log('_reconnect() - Abort (3) since disconnect() is called');
            return;
        }
        this._log('_reconnect() - Destroying current WS connection');
        // cleanup the old connection
        this._destroyCurrentWSConnection();
        if (options.refreshToken) await this.client.tokenManager.loadToken();
        try {
            await this._connect();
            this._log('_reconnect() - Waiting for recoverCallBack');
            // await this.client.recoverState();
            this._log('_reconnect() - Finished recoverCallBack');
            this.consecutiveFailures = 0;
        } catch (caught) {
            const error = caught;
            this.isHealthy = false;
            this.consecutiveFailures += 1;
            if (error.code === $8c05ed6f2f331ee8$var$KnownCodes.TOKEN_EXPIRED && !this.client.tokenManager.isStatic()) {
                this._log('_reconnect() - WS failure due to expired token, so going to try to reload token and reconnect');
                return this._reconnect({
                    refreshToken: true
                });
            }
            // reconnect on WS failures, don't reconnect if there is a code bug
            if (error.isWSFailure) {
                this._log('_reconnect() - WS failure, so going to try to reconnect');
                this._reconnect();
            }
        }
        this._log('_reconnect() - == END ==');
    }
    /**
     * _destroyCurrentWSConnection - Removes the current WS connection
     *
     */ _destroyCurrentWSConnection() {
        // increment the ID, meaning we will ignore all messages from the old
        // ws connection from now on.
        this.wsID += 1;
        try {
            this?.ws?.close();
        } catch  {
        // we don't care
        }
    }
    get connectionOpen() {
        return this.connectionOpenSafe?.();
    }
}
function $8c05ed6f2f331ee8$var$getUserFromToken(token) {
    const fragments = token.split('.');
    if (fragments.length !== 3) return '';
    const b64Payload = fragments[1];
    const payload = $8c05ed6f2f331ee8$var$decodeBase64(b64Payload);
    const data = JSON.parse(payload);
    return data.user_id;
}
// base-64 decoder throws exception if encoded string is not padded by '=' to make string length
// in multiples of 4. So gonna use our own method for this purpose to keep backwards compatibility
// https://github.com/beatgammit/base64-js/blob/master/index.js#L26
const $8c05ed6f2f331ee8$var$decodeBase64 = (s)=>{
    const e = {}, w = String.fromCharCode, L = s.length;
    let i, b = 0, c, x, l = 0, a, r = '';
    const A = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    for(i = 0; i < 64; i++)e[A.charAt(i)] = i;
    for(x = 0; x < L; x++){
        c = e[s.charAt(x)];
        b = (b << 6) + c;
        l += 6;
        while(l >= 8)if ((a = b >>> (l -= 8) & 0xff) || x < L - 2) r += w(a);
    }
    return r;
};
/**
 * TokenManager
 *
 * Handles all the operations around user token.
 */ class $8c05ed6f2f331ee8$var$TokenManager {
    constructor(secret){
        this.loadTokenPromise = null;
        this.type = 'static';
        /**
         * Set the static string token or token provider.
         * Token provider should return a token string or a promise which resolves to string token.
         *
         * @param {TokenOrProvider} tokenOrProvider - the token or token provider.
         * @param {UserResponse} user - the user object.
         * @param {boolean} isAnonymous - whether the user is anonymous or not.
         */ this.setTokenOrProvider = async (tokenOrProvider, user, isAnonymous)=>{
            this.user = user;
            this.isAnonymous = isAnonymous;
            this.validateToken(tokenOrProvider);
            if ($8c05ed6f2f331ee8$var$isFunction(tokenOrProvider)) {
                this.tokenProvider = tokenOrProvider;
                this.type = 'provider';
            }
            if (typeof tokenOrProvider === 'string') {
                this.token = tokenOrProvider;
                this.type = 'static';
            }
            await this.loadToken();
        };
        /**
         * Resets the token manager.
         * Useful for client disconnection or switching user.
         */ this.reset = ()=>{
            this.token = undefined;
            this.tokenProvider = undefined;
            this.type = 'static';
            this.user = undefined;
            this.loadTokenPromise = null;
        };
        // Validates the user token.
        this.validateToken = (tokenOrProvider)=>{
            // allow empty token for anon user
            if (this.user && this.isAnonymous && !tokenOrProvider) return;
            // Don't allow empty token for non-server side client.
            if (!this.secret && !tokenOrProvider) throw new Error('User token can not be empty');
            if (typeof tokenOrProvider !== 'string' && !$8c05ed6f2f331ee8$var$isFunction(tokenOrProvider)) throw new Error('User token should either be a string or a function');
            if (typeof tokenOrProvider === 'string') {
                // Allow empty token for anonymous users
                if (this.isAnonymous && tokenOrProvider === '') return;
                const tokenUserId = $8c05ed6f2f331ee8$var$getUserFromToken(tokenOrProvider);
                if (tokenOrProvider != null && (tokenUserId == null || tokenUserId === '' || !this.isAnonymous && tokenUserId !== this.user.id)) throw new Error('userToken does not have a user_id or is not matching with user.id');
            }
        };
        // Resolves when token is ready. This function is simply to check if loadToken is in progress, in which
        // case a function should wait.
        this.tokenReady = ()=>this.loadTokenPromise;
        // Fetches a token from tokenProvider function and sets in tokenManager.
        // In case of static token, it will simply resolve to static token.
        this.loadToken = ()=>{
            this.loadTokenPromise = new Promise(async (resolve, reject)=>{
                if (this.type === 'static') return resolve(this.token);
                if (this.tokenProvider && typeof this.tokenProvider !== 'string') {
                    try {
                        const token = await this.tokenProvider();
                        this.validateToken(token);
                        this.token = token;
                    } catch (e) {
                        return reject(new Error(`Call to tokenProvider failed with message: ${e}`, {
                            cause: e
                        }));
                    }
                    resolve(this.token);
                }
            });
            return this.loadTokenPromise;
        };
        // Returns a current token
        this.getToken = ()=>{
            if (this.token) return this.token;
            if (this.user && !this.token) return this.token;
            throw new Error(`User token is not set. Either client.connectUser wasn't called or client.disconnect was called`);
        };
        this.isStatic = ()=>this.type === 'static';
        this.secret = secret;
    }
}
const $8c05ed6f2f331ee8$var$getLocationHint = async (hintUrl = `https://hint.stream-io-video.com/`, timeout = 2000, maxAttempts = 3)=>{
    const logger = $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger('location-hint');
    let attempt = 0;
    let locationHint = 'ERR';
    do {
        const abortController = new AbortController();
        const timeoutId = setTimeout(()=>abortController.abort(), timeout);
        try {
            const response = await fetch(hintUrl, {
                method: 'HEAD',
                signal: abortController.signal
            });
            const awsPop = response.headers.get('x-amz-cf-pop') || 'ERR';
            logger.debug(`Location header: ${awsPop}`);
            locationHint = awsPop.substring(0, 3); // AMS1-P2 -> AMS
        } catch (e) {
            logger.warn(`Failed to get location hint from ${hintUrl}`, e);
            locationHint = 'ERR';
        } finally{
            clearTimeout(timeoutId);
        }
    }while (locationHint === 'ERR' && ++attempt < maxAttempts);
    return locationHint;
};
class $8c05ed6f2f331ee8$var$StreamClient {
    /**
     * Initialize a client.
     *
     * @param {string} key - the api key
     * @param {StreamClientOptions} [options] - additional options, here you can pass custom options to axios instance
     * @param {string} [options.secret] - the api secret
     * @param {boolean} [options.browser] - enforce the client to be in browser mode
     * @param {boolean} [options.warmUp] - default to false, if true, client will open a connection as soon as possible to speed up following requests
     * @param {Logger} [options.Logger] - custom logger
     * @param {number} [options.timeout] - default to 3000
     * @param {httpsAgent} [options.httpsAgent] - custom httpsAgent, in node it's default to https.agent()
     */ constructor(key, options){
        this.listeners = {};
        this.getAuthType = ()=>{
            return this.anonymous ? 'anonymous' : 'jwt';
        };
        this.setBaseURL = (baseURL)=>{
            this.baseURL = baseURL;
            this.wsBaseURL = this.baseURL.replace('http', 'ws').replace(':3030', ':8800');
        };
        this.getLocationHint = async (hintUrl, timeout)=>{
            const hint = await this.locationHint;
            if (!hint || hint === 'ERR') {
                this.locationHint = $8c05ed6f2f331ee8$var$getLocationHint(hintUrl ?? this.options.locationHintUrl, timeout ?? this.options.locationHintTimeout);
                return this.locationHint;
            }
            return hint;
        };
        this._getConnectionID = ()=>this.wsConnection?.connectionID;
        this._hasConnectionID = ()=>Boolean(this._getConnectionID());
        /**
         * connectUser - Set the current user and open a WebSocket connection
         *
         * @param user Data about this user. IE {name: "john"}
         * @param {TokenOrProvider} tokenOrProvider Token or provider
         *
         * @return {ConnectAPIResponse} Returns a promise that resolves when the connection is setup
         */ this.connectUser = async (user, tokenOrProvider)=>{
            if (!user.id) throw new Error('The "id" field on the user is missing');
            /**
             * Calling connectUser multiple times is potentially the result of a  bad integration, however,
             * If the user id remains the same we don't throw error
             */ if (this.userID === user.id && this.connectUserTask) {
                this.logger.warn('Consecutive calls to connectUser is detected, ideally you should only call this function once in your app.');
                return this.connectUserTask;
            }
            if (this.userID) throw new Error('Use client.disconnect() before trying to connect as a different user. connectUser was called twice.');
            if ((this.secret || this.node) && !this.options.allowServerSideConnect) this.logger.warn('Please do not use connectUser server side. Use our @stream-io/node-sdk instead: https://getstream.io/video/docs/api/');
            // we generate the client id client side
            this.userID = user.id;
            this.anonymous = false;
            await this.tokenManager.setTokenOrProvider(tokenOrProvider, user, false);
            this._setUser(user);
            this.connectUserTask = this.openConnection();
            try {
                $8c05ed6f2f331ee8$var$addConnectionEventListeners(this.updateNetworkConnectionStatus);
                return await this.connectUserTask;
            } catch (err) {
                if (this.persistUserOnConnectionFailure) // cleanup client to allow the user to retry connectUser again
                await this.closeConnection();
                else await this.disconnectUser();
                throw err;
            }
        };
        this._setUser = (user)=>{
            /**
             * This one is used by the frontend. This is a copy of the current user object stored on backend.
             * It contains reserved properties and own user properties which are not present in `this._user`.
             */ this.user = user;
            this.userID = user.id;
            // this one is actually used for requests. This is a copy of current user provided to `connectUser` function.
            this._user = {
                ...user
            };
        };
        /**
         * Disconnects the websocket connection, without removing the user set on client.
         * client.closeConnection will not trigger default auto-retry mechanism for reconnection. You need
         * to call client.openConnection to reconnect to websocket.
         *
         * This is mainly useful on mobile side. You can only receive push notifications
         * if you don't have active websocket connection.
         * So when your app goes to background, you can call `client.closeConnection`.
         * And when app comes back to foreground, call `client.openConnection`.
         *
         * @param timeout Max number of ms, to wait for close event of websocket, before forcefully assuming succesful disconnection.
         *                https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent
         */ this.closeConnection = async (timeout)=>{
            await this.wsConnection?.disconnect(timeout);
        };
        /**
         * Creates a new WebSocket connection with the current user. Returns empty promise, if there is an active connection
         */ this.openConnection = async ()=>{
            if (!this.userID) throw Error('UserWithId is not set on client, use client.connectUser or client.connectAnonymousUser instead');
            const wsPromise = this.wsPromiseSafe?.();
            if (this.wsConnection?.isConnecting && wsPromise) {
                this.logger.info('client:openConnection() - connection already in progress');
                return await wsPromise;
            }
            if (this.wsConnection?.isHealthy && this._hasConnectionID()) {
                this.logger.info('client:openConnection() - openConnection called twice, healthy connection already exists');
                return;
            }
            this._setupConnectionIdPromise();
            this.clientID = `${this.userID}--${$8c05ed6f2f331ee8$var$generateUUIDv4()}`;
            const newWsPromise = this.connect();
            this.wsPromiseSafe = $8c05ed6f2f331ee8$var$makeSafePromise(newWsPromise);
            return await newWsPromise;
        };
        /**
         * Disconnects the websocket and removes the user from client.
         *
         * @param timeout Max number of ms, to wait for close event of websocket, before forcefully assuming successful disconnection.
         *                https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent
         */ this.disconnectUser = async (timeout)=>{
            this.logger.info('client:disconnect() - Disconnecting the client');
            // remove the user specific fields
            delete this.user;
            delete this._user;
            delete this.userID;
            this.anonymous = false;
            await this.closeConnection(timeout);
            $8c05ed6f2f331ee8$var$removeConnectionEventListeners(this.updateNetworkConnectionStatus);
            this.tokenManager.reset();
            this.connectionIdPromiseSafe = undefined;
            this.rejectConnectionId = undefined;
            this.resolveConnectionId = undefined;
        };
        this.connectGuestUser = async (user)=>{
            this.guestUserCreatePromise = this.doAxiosRequest('post', '/guest', {
                user: user
            }, {
                publicEndpoint: true
            });
            const response = await this.guestUserCreatePromise;
            this.guestUserCreatePromise.finally(()=>this.guestUserCreatePromise = undefined);
            return this.connectUser(response.user, response.access_token);
        };
        /**
         * connectAnonymousUser - Set an anonymous user and open a WebSocket connection
         */ this.connectAnonymousUser = async (user, tokenOrProvider)=>{
            $8c05ed6f2f331ee8$var$addConnectionEventListeners(this.updateNetworkConnectionStatus);
            this._setupConnectionIdPromise();
            this.anonymous = true;
            await this.tokenManager.setTokenOrProvider(tokenOrProvider, user, true);
            this._setUser(user);
            // some endpoints require a connection_id to be resolved.
            // as anonymous users aren't allowed to open WS connections, we just
            // resolve the connection_id here.
            this.resolveConnectionId?.();
        };
        /**
         * on - Listen to events on all channels and users your watching
         *
         * client.on('message.new', event => {console.log("my new message", event, channel.state.messages)})
         *
         * @param eventName The event type to listen for (optional)
         * @param callback The callback to call
         *
         * @return  Returns a function which, when called, unsubscribes the event handler.
         */ this.on = (eventName, callback)=>{
            if (!this.listeners[eventName]) this.listeners[eventName] = [];
            this.logger.debug(`Adding listener for ${eventName} event`);
            this.listeners[eventName]?.push(callback);
            return ()=>{
                this.off(eventName, callback);
            };
        };
        /**
         * off - Remove the event handler
         */ this.off = (eventName, callback)=>{
            if (!this.listeners[eventName]) this.listeners[eventName] = [];
            this.logger.debug(`Removing listener for ${eventName} event`);
            this.listeners[eventName] = this.listeners[eventName]?.filter((value)=>value !== callback);
        };
        /**
         * sets up the this.connectionIdPromise
         */ this._setupConnectionIdPromise = ()=>{
            /** a promise that is resolved once connection id is set */ this.connectionIdPromiseSafe = $8c05ed6f2f331ee8$var$makeSafePromise(new Promise((resolve, reject)=>{
                this.resolveConnectionId = resolve;
                this.rejectConnectionId = reject;
            }));
        };
        this._logApiRequest = (type, url, data, config)=>{
            if (this.logger.getLogLevel() !== 'trace') return;
            this.logger.trace(`client: ${type} - Request - ${url}`, {
                payload: data,
                config: config
            });
        };
        this._logApiResponse = (type, url, response)=>{
            if (this.logger.getLogLevel() !== 'trace') return;
            this.logger.trace(`client:${type} - Response - url: ${url} > status ${response.status}`, {
                response: response
            });
        };
        this.doAxiosRequest = async (type, url, data, options = {})=>{
            if (!options.publicEndpoint) {
                await Promise.all([
                    this.tokenManager.tokenReady(),
                    this.guestUserCreatePromise
                ]);
                // we need to wait for presence of connection id before making requests
                try {
                    await this.connectionIdPromise;
                } catch  {
                    // in case connection id was rejected
                    // reconnection maybe in progress
                    // we can wait for healthy connection to resolve, which rejects when 15s timeout is reached
                    await this.wsConnection?._waitForHealthy();
                    await this.connectionIdPromise;
                }
            }
            const requestConfig = this._enrichAxiosOptions(options);
            try {
                let response;
                this._logApiRequest(type, url, data, requestConfig);
                switch(type){
                    case 'get':
                        response = await this.axiosInstance.get(url, requestConfig);
                        break;
                    case 'delete':
                        response = await this.axiosInstance.delete(url, requestConfig);
                        break;
                    case 'post':
                        response = await this.axiosInstance.post(url, data, requestConfig);
                        break;
                    case 'put':
                        response = await this.axiosInstance.put(url, data, requestConfig);
                        break;
                    case 'patch':
                        response = await this.axiosInstance.patch(url, data, requestConfig);
                        break;
                    case 'options':
                        response = await this.axiosInstance.options(url, requestConfig);
                        break;
                    default:
                        throw new Error('Invalid request type');
                }
                this._logApiResponse(type, url, response);
                this.consecutiveFailures = 0;
                return response.data;
            } catch (e /**TODO: generalize error types  */ ) {
                e.client_request_id = requestConfig.headers?.['x-client-request-id'];
                this.consecutiveFailures += 1;
                const { response: response } = e;
                if (!response || !$8c05ed6f2f331ee8$var$isErrorResponse(response)) {
                    this.logger.error(`client:${type} url: ${url}`, e);
                    throw e;
                }
                const { data: responseData, status: status } = response;
                const isTokenExpired = responseData.code === $8c05ed6f2f331ee8$var$KnownCodes.TOKEN_EXPIRED;
                if (isTokenExpired && !this.tokenManager.isStatic()) {
                    this.logger.warn(`client:${type}: url: ${url}`, response);
                    if (this.consecutiveFailures > 1) await $8c05ed6f2f331ee8$var$sleep($8c05ed6f2f331ee8$var$retryInterval(this.consecutiveFailures));
                    // refresh and retry the request
                    await this.tokenManager.loadToken();
                    return await this.doAxiosRequest(type, url, data, options);
                } else {
                    this.logger.error(`client:${type} url: ${url}`, response);
                    throw new $8c05ed6f2f331ee8$export$758a4427671bc10f({
                        message: `Stream error code ${responseData.code}: ${responseData.message}`,
                        code: responseData.code ?? null,
                        unrecoverable: responseData.unrecoverable ?? null,
                        response: response,
                        status: status
                    });
                }
            }
        };
        this.get = (url, params)=>{
            return this.doAxiosRequest('get', url, null, {
                params: params
            });
        };
        this.put = (url, data, params)=>{
            return this.doAxiosRequest('put', url, data, {
                params: params
            });
        };
        this.post = (url, data, params)=>{
            return this.doAxiosRequest('post', url, data, {
                params: params
            });
        };
        this.patch = (url, data, params)=>{
            return this.doAxiosRequest('patch', url, data, {
                params: params
            });
        };
        this.delete = (url, params)=>{
            return this.doAxiosRequest('delete', url, null, {
                params: params
            });
        };
        this.dispatchEvent = (event)=>{
            this.logger.debug(`Dispatching event: ${event.type}`, event);
            if (!this.listeners) return;
            // call generic listeners
            for (const listener of this.listeners.all || [])listener(event);
            // call type specific listeners
            for (const listener of this.listeners[event.type] || [])listener(event);
        };
        /**
         * @private
         */ this.connect = async ()=>{
            if (!this.userID || !this._user) throw Error('Call connectUser or connectAnonymousUser before starting the connection');
            if (!this.wsBaseURL) throw Error('Websocket base url not set');
            if (!this.clientID) throw Error('clientID is not set');
            // The StableWSConnection handles all the reconnection logic.
            this.wsConnection = new $8c05ed6f2f331ee8$var$StableWSConnection(this);
            this.logger.info('StreamClient.connect: this.wsConnection.connect()');
            return await this.wsConnection.connect(this.defaultWSTimeout);
        };
        this.getSdkVersion = ()=>this.options.clientAppIdentifier?.sdkVersion || "1.54.0";
        this.getUserAgent = ()=>{
            if (!this.cachedUserAgent) {
                const { clientAppIdentifier: clientAppIdentifier = {} } = this.options;
                const { sdkName: sdkName = 'js', sdkVersion: sdkVersion = "1.54.0", ...extras } = clientAppIdentifier;
                this.cachedUserAgent = [
                    `stream-video-${sdkName}-v${sdkVersion}`,
                    ...Object.entries(extras).map(([key, value])=>`${key}=${value}`),
                    `client_bundle=${"browser-esm"}`
                ].join('|');
            }
            return this.cachedUserAgent;
        };
        this._enrichAxiosOptions = (options = {
            params: {},
            headers: {},
            config: {}
        })=>{
            const token = options.publicEndpoint && !this.user ? undefined : this._getToken();
            const authorization = token ? {
                Authorization: token
            } : undefined;
            if (!options.headers?.['x-client-request-id']) options.headers = {
                ...options.headers,
                'x-client-request-id': $8c05ed6f2f331ee8$var$generateUUIDv4()
            };
            const { params: axiosConfigParams, headers: axiosConfigHeaders, ...axiosRequestConfig } = this.options.axiosRequestConfig || {};
            return {
                params: {
                    user_id: this.userID,
                    connection_id: this._getConnectionID(),
                    api_key: this.key,
                    ...options.params,
                    ...axiosConfigParams
                },
                headers: {
                    ...authorization,
                    'stream-auth-type': options.publicEndpoint && !this.user ? 'anonymous' : this.getAuthType(),
                    'X-Stream-Client': this.getUserAgent(),
                    ...options.headers,
                    ...axiosConfigHeaders
                },
                ...options.config,
                ...axiosRequestConfig
            };
        };
        this._getToken = ()=>{
            if (!this.tokenManager) return null;
            return this.tokenManager.getToken();
        };
        this.updateNetworkConnectionStatus = (event)=>{
            if (event.type === 'offline') {
                this.logger.debug('device went offline');
                this.dispatchEvent({
                    type: 'network.changed',
                    online: false
                });
            } else if (event.type === 'online') {
                this.logger.debug('device went online');
                this.dispatchEvent({
                    type: 'network.changed',
                    online: true
                });
            }
        };
        // set the key
        this.key = key;
        // set the secret
        this.secret = options?.secret;
        // set the options... and figure out defaults...
        const inputOptions = options ? options : {
            browser: typeof window !== 'undefined'
        };
        this.browser = inputOptions.browser || typeof window !== 'undefined';
        this.node = !this.browser;
        if (this.browser) this.locationHint = $8c05ed6f2f331ee8$var$getLocationHint(options?.locationHintUrl, options?.locationHintTimeout, options?.locationHintMaxAttempts);
        this.options = {
            timeout: 5000,
            withCredentials: false,
            ...inputOptions
        };
        if (this.node && !this.options.httpsAgent) this.options.httpsAgent = new $8c05ed6f2f331ee8$var$https.Agent({
            keepAlive: true,
            keepAliveMsecs: 3000
        });
        this.setBaseURL(this.options.baseURL || 'https://video.stream-io-api.com/video');
        this.axiosInstance = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).create({
            ...this.options,
            baseURL: this.baseURL
        });
        // WS connection is initialized when setUser is called
        this.wsConnection = null;
        this.wsPromiseSafe = null;
        this.connectUserTask = null;
        // mapping between channel groups and configs
        this.anonymous = false;
        this.persistUserOnConnectionFailure = this.options?.persistUserOnConnectionFailure;
        // If it is a server-side client, then lets initialize the tokenManager, since token will be
        // generated from secret.
        this.tokenManager = new $8c05ed6f2f331ee8$var$TokenManager(this.secret);
        this.consecutiveFailures = 0;
        this.defaultWSTimeout = this.options.defaultWsTimeout ?? 15000;
        this.logger = $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger('coordinator');
    }
    get connectionIdPromise() {
        return this.connectionIdPromiseSafe?.();
    }
    get isConnectionIdPromisePending() {
        return this.connectionIdPromiseSafe?.checkPending() ?? false;
    }
    get wsPromise() {
        return this.wsPromiseSafe?.();
    }
}
/**
 * Utility function to get the instance key.
 */ const $8c05ed6f2f331ee8$var$getInstanceKey = (apiKey, user)=>{
    return `${apiKey}/${user.id}`;
};
/**
 * Returns a concurrency tag for call initialization.
 * @internal
 *
 * @param cid the call cid.
 */ const $8c05ed6f2f331ee8$var$getCallInitConcurrencyTag = (cid)=>`call.init-${cid}`;
/**
 * Utility function to get the client app identifier.
 */ const $8c05ed6f2f331ee8$var$getClientAppIdentifier = (options)=>{
    const appId = options?.clientAppIdentifier || {};
    const sdkInfo = $8c05ed6f2f331ee8$export$c290d519cd828ce1();
    if (sdkInfo) {
        // ensure the sdk name and version are set correctly,
        // overriding any user-provided values
        appId.sdkName = $8c05ed6f2f331ee8$var$SdkType[sdkInfo.type].toLowerCase();
        appId.sdkVersion = `${sdkInfo.major}.${sdkInfo.minor}.${sdkInfo.patch}`;
    }
    return appId;
};
/**
 * Creates a coordinator client.
 */ const $8c05ed6f2f331ee8$var$createCoordinatorClient = (apiKey, options)=>{
    const clientAppIdentifier = $8c05ed6f2f331ee8$var$getClientAppIdentifier(options);
    return new $8c05ed6f2f331ee8$var$StreamClient(apiKey, {
        persistUserOnConnectionFailure: true,
        ...options,
        clientAppIdentifier: clientAppIdentifier
    });
};
/**
 * Creates a token provider and allows integrators to provide
 * a static token and a token provider at the same time.
 *
 * When both of them are provided, this function will create an internal
 * token provider that will use the static token on the first invocation
 * and the token provider on the later invocations.
 */ const $8c05ed6f2f331ee8$var$createTokenOrProvider = (options)=>{
    const { token: token, tokenProvider: tokenProvider } = options;
    if (token && tokenProvider) {
        let initialTokenUsed = false;
        return async function wrappedTokenProvider() {
            if (!initialTokenUsed) {
                initialTokenUsed = true;
                return token;
            }
            return tokenProvider();
        };
    }
    return token || tokenProvider;
};
const $8c05ed6f2f331ee8$var$pcKey = (cid, role)=>`${cid}:${role}`;
class $8c05ed6f2f331ee8$var$ClientEventReporter {
    constructor(options){
        this.logger = $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger('ClientEventReporter');
        this.callContexts = new Map();
        this.joinAttemptIds = new Map();
        this.joinReasons = new Map();
        this.coordinatorPairs = new Map();
        this.wsPairs = new Map();
        this.peerConnectionPairs = new Map();
        this.pcEverConnected = new Map();
        this.firstFrameReported = new Set();
        /**
         * Starts a new coordinator connection correlation scope.
         *
         * @param userId the id of the user being connected. Captured here because
         * the `CoordinatorWS` stage emits before the connection flow assigns
         * the user to the client, so it can't be read from the client yet.
         */ this.startCoordinatorConnection = (userId)=>{
            this.coordinatorConnectId = $8c05ed6f2f331ee8$var$generateUUIDv4();
            this.coordinatorConnectUserId = userId;
            return this.coordinatorConnectId;
        };
        this.trackCoordinatorWs = async (op)=>{
            this.beginCoordinatorWs();
            try {
                const result = await op();
                this.succeedCoordinatorWs();
                return result;
            } catch (err) {
                $8c05ed6f2f331ee8$var$applyError(this.coordinatorWsPair, $8c05ed6f2f331ee8$var$mapCoordinatorWsError(err));
                throw err;
            }
        };
        this.beginCoordinatorWs = ()=>{
            if (!this.coordinatorWsPair) {
                this.coordinatorWsPair = {
                    sid: $8c05ed6f2f331ee8$var$generateUUIDv4(),
                    attempts: 0,
                    startedAt: Date.now(),
                    userIdSnapshot: this.coordinatorConnectUserId
                };
                this.send({
                    ...this.buildCoordinatorWsCommon(this.coordinatorWsPair),
                    event_type: 'initiated'
                });
            }
            this.coordinatorWsPair.attempts++;
        };
        this.succeedCoordinatorWs = ()=>{
            const pair = this.coordinatorWsPair;
            if (!pair) return;
            this.send({
                ...this.buildCoordinatorWsCommon(pair),
                event_type: 'completed',
                outcome: 'success',
                retry_count_attempt: pair.attempts - 1,
                elapsed_time: Date.now() - pair.startedAt
            });
            this.coordinatorWsPair = undefined;
        };
        this.closeCoordinatorWs = ()=>{
            const pair = this.coordinatorWsPair;
            if (!pair || !pair.lastError) {
                this.coordinatorWsPair = undefined;
                return;
            }
            const { reason: reason, code: code } = pair.lastError;
            this.send({
                ...this.buildCoordinatorWsCommon(pair),
                event_type: 'completed',
                outcome: 'failure',
                retry_count_attempt: pair.attempts - 1,
                elapsed_time: Date.now() - pair.startedAt,
                retry_failure_reason: reason,
                retry_failure_code: code
            });
            this.coordinatorWsPair = undefined;
        };
        this.buildCoordinatorWsCommon = (pair)=>({
                user_id: pair.userIdSnapshot ?? this.streamClient.userID,
                stage: 'CoordinatorWS',
                stage_id: pair.sid,
                ...this.coordinatorConnectId && {
                    coordinator_connect_id: this.coordinatorConnectId
                },
                timestamp: new Date().toISOString(),
                user_agent: this.streamClient.getUserAgent(),
                sdk_version: this.streamClient.getSdkVersion()
            });
        this.emitMediaPermission = (cid)=>{
            if ($8c05ed6f2f331ee8$var$isReactNative() || !this.callContexts.has(cid)) return;
            const pair = {
                sid: $8c05ed6f2f331ee8$var$generateUUIDv4(),
                attempts: 0,
                startedAt: Date.now(),
                joinAttemptIdSnapshot: this.joinAttemptIds.get(cid)
            };
            this.send({
                ...this.buildCommon(cid, 'MediaDevicePermission', pair),
                ...this.sessionIdField(cid),
                microphone_permission_status: $8c05ed6f2f331ee8$var$readPermissionStatus($8c05ed6f2f331ee8$export$d0940718070360d2()),
                camera_permission_status: $8c05ed6f2f331ee8$var$readPermissionStatus($8c05ed6f2f331ee8$export$c0f343b08c967c50()),
                event_type: 'initiated'
            });
        };
        this.registerCall = (cid, ctx)=>{
            this.callContexts.set(cid, ctx);
        };
        this.unregisterCall = (cid)=>{
            this.callContexts.delete(cid);
            this.joinAttemptIds.delete(cid);
            this.joinReasons.delete(cid);
            this.coordinatorPairs.delete(cid);
            this.wsPairs.delete(cid);
            this.firstFrameReported.delete(`${cid}:FirstVideoFrame`);
            this.firstFrameReported.delete(`${cid}:FirstAudioFrame`);
            for (const role of [
                'publish',
                'subscribe'
            ]){
                const key = $8c05ed6f2f331ee8$var$pcKey(cid, role);
                this.peerConnectionPairs.delete(key);
                this.pcEverConnected.delete(key);
            }
        };
        this.startCorrelation = (cid, joinReason)=>{
            try {
                this.closeCallPairs(cid);
                this.joinAttemptIds.set(cid, $8c05ed6f2f331ee8$var$generateUUIDv4());
                this.joinReasons.set(cid, joinReason);
                this.firstFrameReported.delete(`${cid}:FirstVideoFrame`);
                this.firstFrameReported.delete(`${cid}:FirstAudioFrame`);
                this.emitJoinInitiated(cid);
                this.emitMediaPermission(cid);
            } catch (err) {
                this.logger.warn('Failed to start join correlation', err);
            }
        };
        this.withJoinLifecycle = async (cid, joinReason, op)=>{
            this.startCorrelation(cid, joinReason);
            try {
                return await op();
            } catch (err) {
                this.closeCallPairs(cid);
                throw err;
            }
        };
        this.track = async (cid, stage, op)=>{
            this.beginAttempt(cid, stage);
            try {
                const result = await op();
                this.succeedAttempt(cid, stage);
                return result;
            } catch (err) {
                this.applyStageError(cid, stage, err);
                throw err;
            }
        };
        this.reportFirstFrame = (cid, trackType, trackId)=>{
            const stage = trackType === $8c05ed6f2f331ee8$var$TrackType.VIDEO ? 'FirstVideoFrame' : trackType === $8c05ed6f2f331ee8$var$TrackType.AUDIO ? 'FirstAudioFrame' : undefined;
            if (!stage) return;
            const key = `${cid}:${stage}`;
            if (this.firstFrameReported.has(key)) return;
            this.firstFrameReported.add(key);
            const pair = {
                sid: $8c05ed6f2f331ee8$var$generateUUIDv4(),
                attempts: 0,
                startedAt: Date.now(),
                joinAttemptIdSnapshot: this.joinAttemptIds.get(cid)
            };
            const resolvedSfuId = this.getSfuId(cid);
            this.send({
                ...this.buildCommon(cid, stage, pair),
                ...this.sessionIdField(cid),
                ...resolvedSfuId && {
                    sfu_id: resolvedSfuId
                },
                track_id: trackId,
                event_type: 'initiated'
            });
        };
        this.captureWsError = (cid, opts)=>{
            const pair = this.wsPairs.get(cid);
            if (!pair) return;
            $8c05ed6f2f331ee8$var$applyError(pair, {
                reason: opts.reason,
                code: opts.code
            });
        };
        this.close = (cid)=>{
            this.closeCallPairs(cid);
        };
        this.abort = (cid, opts)=>{
            try {
                const { code: code, reason: reason } = opts;
                const stageError = {
                    code: code,
                    reason: reason
                };
                $8c05ed6f2f331ee8$var$applyErrorIfAbsent(this.coordinatorPairs.get(cid), stageError);
                $8c05ed6f2f331ee8$var$applyErrorIfAbsent(this.wsPairs.get(cid), stageError);
                this.failCoordinator(cid);
                this.failWs(cid);
                this.emitPeerConnectionFailure(cid, 'publish', code, reason, 'NOT_CONNECTED');
                this.emitPeerConnectionFailure(cid, 'subscribe', code, reason, 'NOT_CONNECTED');
            } catch (err) {
                this.logger.warn('Failed to report abort', err);
            }
        };
        this.closeCallPairs = (cid)=>{
            if (this.coordinatorPairs.get(cid)) this.failCoordinator(cid);
            if (this.wsPairs.get(cid)) this.failWs(cid);
            for (const role of [
                'publish',
                'subscribe'
            ])this.emitPeerConnectionFailure(cid, role, 'CLIENT_ABORTED', 'superseded by a new join attempt', 'NOT_CONNECTED');
        };
        this.emitJoinInitiated = (cid)=>{
            const joinAttemptId = this.joinAttemptIds.get(cid);
            if (!joinAttemptId) return;
            const coordinatorConnectId = this.coordinatorConnectId;
            const ctx = this.callContexts.get(cid);
            this.send({
                user_id: this.streamClient.userID || this.coordinatorConnectUserId,
                type: ctx?.callType,
                id: ctx?.callId,
                call_cid: cid,
                stage: 'JoinInitiated',
                join_attempt_id: joinAttemptId,
                ...coordinatorConnectId && {
                    coordinator_connect_id: coordinatorConnectId
                },
                timestamp: new Date().toISOString(),
                user_agent: this.streamClient.getUserAgent(),
                sdk_version: this.streamClient.getSdkVersion(),
                event_type: 'initiated'
            });
        };
        this.beginAttempt = (cid, stage)=>{
            if (stage === 'CoordinatorJoin') this.beginCoordinatorAttempt(cid);
            else this.beginWsAttempt(cid);
        };
        this.succeedAttempt = (cid, stage)=>{
            if (stage === 'CoordinatorJoin') this.succeedCoordinator(cid);
            else this.succeedWs(cid);
        };
        this.applyStageError = (cid, stage, err)=>{
            const pair = stage === 'CoordinatorJoin' ? this.coordinatorPairs.get(cid) : this.wsPairs.get(cid);
            $8c05ed6f2f331ee8$var$applyErrorIfAbsent(pair, stage === 'CoordinatorJoin' ? $8c05ed6f2f331ee8$var$mapCoordinatorHttpError(err) : $8c05ed6f2f331ee8$var$mapWsJoinError(err));
        };
        this.beginCoordinatorAttempt = (cid)=>{
            let pair = this.coordinatorPairs.get(cid);
            if (!pair) {
                pair = {
                    sid: $8c05ed6f2f331ee8$var$generateUUIDv4(),
                    attempts: 0,
                    startedAt: Date.now(),
                    joinAttemptIdSnapshot: this.joinAttemptIds.get(cid),
                    joinReasonSnapshot: this.joinReasons.get(cid)
                };
                this.coordinatorPairs.set(cid, pair);
                this.send({
                    ...this.buildCommon(cid, 'CoordinatorJoin', pair),
                    ...pair.joinReasonSnapshot && {
                        join_reason: pair.joinReasonSnapshot
                    },
                    event_type: 'initiated'
                });
            }
            pair.lastError = undefined;
            pair.attempts++;
        };
        this.succeedCoordinator = (cid)=>{
            const pair = this.coordinatorPairs.get(cid);
            if (!pair) return;
            this.send({
                ...this.buildCommon(cid, 'CoordinatorJoin', pair),
                ...this.sessionIdField(cid),
                ...pair.joinReasonSnapshot && {
                    join_reason: pair.joinReasonSnapshot
                },
                event_type: 'completed',
                outcome: 'success',
                retry_count_attempt: pair.attempts - 1,
                elapsed_time: Date.now() - pair.startedAt
            });
            this.coordinatorPairs.delete(cid);
        };
        this.failCoordinator = (cid)=>{
            const pair = this.coordinatorPairs.get(cid);
            if (!pair || !pair.lastError) {
                this.coordinatorPairs.delete(cid);
                return;
            }
            const { reason: reason, code: code } = pair.lastError;
            this.send({
                ...this.buildCommon(cid, 'CoordinatorJoin', pair),
                ...this.sessionIdField(cid),
                ...pair.joinReasonSnapshot && {
                    join_reason: pair.joinReasonSnapshot
                },
                event_type: 'completed',
                outcome: 'failure',
                retry_count_attempt: pair.attempts - 1,
                elapsed_time: Date.now() - pair.startedAt,
                retry_failure_reason: reason,
                retry_failure_code: code
            });
            this.coordinatorPairs.delete(cid);
        };
        this.beginWsAttempt = (cid)=>{
            let pair = this.wsPairs.get(cid);
            if (!pair) {
                pair = {
                    sid: $8c05ed6f2f331ee8$var$generateUUIDv4(),
                    attempts: 0,
                    startedAt: Date.now(),
                    joinAttemptIdSnapshot: this.joinAttemptIds.get(cid)
                };
                this.wsPairs.set(cid, pair);
                const sfuId = this.getSfuId(cid);
                this.send({
                    ...this.buildCommon(cid, 'WSJoin', pair),
                    ...this.sessionIdField(cid),
                    ...sfuId && {
                        sfu_id: sfuId
                    },
                    event_type: 'initiated'
                });
            }
            pair.lastError = undefined;
            pair.attempts++;
        };
        this.succeedWs = (cid)=>{
            const pair = this.wsPairs.get(cid);
            if (!pair) return;
            const sfuId = this.getSfuId(cid);
            this.send({
                ...this.buildCommon(cid, 'WSJoin', pair),
                ...this.sessionIdField(cid),
                ...sfuId && {
                    sfu_id: sfuId
                },
                event_type: 'completed',
                outcome: 'success',
                retry_count_attempt: pair.attempts - 1,
                elapsed_time: Date.now() - pair.startedAt
            });
            this.wsPairs.delete(cid);
        };
        this.failWs = (cid)=>{
            const pair = this.wsPairs.get(cid);
            if (!pair || !pair.lastError) {
                this.wsPairs.delete(cid);
                return;
            }
            const { reason: reason, code: code } = pair.lastError;
            const sfuId = this.getSfuId(cid);
            this.send({
                ...this.buildCommon(cid, 'WSJoin', pair),
                ...this.sessionIdField(cid),
                event_type: 'completed',
                outcome: 'failure',
                retry_count_attempt: pair.attempts - 1,
                elapsed_time: Date.now() - pair.startedAt,
                ...sfuId && {
                    sfu_id: sfuId
                },
                retry_failure_reason: reason,
                retry_failure_code: code
            });
            this.wsPairs.delete(cid);
        };
        this.onPeerConnectionStateChange = (cid, event)=>{
            const role = event.peerType === $8c05ed6f2f331ee8$var$PeerType.SUBSCRIBER ? 'subscribe' : 'publish';
            if (event.stateType === 'ice' && event.state === 'failed') {
                this.emitPeerConnectionFailure(cid, role, 'ICE_CONNECTIVITY_FAILED', 'ICE connectivity checks failed', 'FAILED');
                return;
            }
            if (event.stateType === 'peerConnection' && event.state === 'failed') {
                this.emitPeerConnectionFailure(cid, role, 'DTLS_CONNECTIVITY_FAILED', 'DTLS connectivity checks failed', 'CONNECTED');
                return;
            }
            if (event.stateType !== 'peerConnection') return;
            switch(event.state){
                case 'connecting':
                    if (this.peerConnectionPairs.has($8c05ed6f2f331ee8$var$pcKey(cid, role))) return;
                    this.openPeerConnectionPair(cid, role);
                    break;
                case 'connected':
                    this.emitPeerConnectionSuccess(cid, role);
                    this.pcEverConnected.set($8c05ed6f2f331ee8$var$pcKey(cid, role), true);
                    break;
            }
        };
        this.openPeerConnectionPair = (cid, role)=>{
            const key = $8c05ed6f2f331ee8$var$pcKey(cid, role);
            const pair = {
                sid: $8c05ed6f2f331ee8$var$generateUUIDv4(),
                attempts: 0,
                startedAt: Date.now(),
                joinAttemptIdSnapshot: this.joinAttemptIds.get(cid),
                sfuId: this.getSfuId(cid),
                userSessionId: this.getUserSessionId(cid),
                wasPreviouslyConnected: this.pcEverConnected.get(key) === true
            };
            this.peerConnectionPairs.set(key, pair);
            this.send({
                ...this.buildCommon(cid, 'PeerConnectionConnect', pair),
                ...this.sessionIdField(cid),
                peer_connection: role,
                was_previously_connected: pair.wasPreviouslyConnected,
                ...pair.sfuId && {
                    sfu_id: pair.sfuId
                },
                ...pair.userSessionId && {
                    user_session_id: pair.userSessionId
                },
                event_type: 'initiated'
            });
        };
        this.emitPeerConnectionSuccess = (cid, role)=>{
            const key = $8c05ed6f2f331ee8$var$pcKey(cid, role);
            const pair = this.peerConnectionPairs.get(key);
            if (!pair) return;
            this.send({
                ...this.buildCommon(cid, 'PeerConnectionConnect', pair),
                ...this.sessionIdField(cid),
                peer_connection: role,
                was_previously_connected: pair.wasPreviouslyConnected,
                ...pair.sfuId && {
                    sfu_id: pair.sfuId
                },
                ...pair.userSessionId && {
                    user_session_id: pair.userSessionId
                },
                event_type: 'completed',
                outcome: 'success',
                retry_count_attempt: 0,
                elapsed_time: Date.now() - pair.startedAt
            });
            this.peerConnectionPairs.delete(key);
        };
        this.emitPeerConnectionFailure = (cid, role, code, reason, iceState)=>{
            const key = $8c05ed6f2f331ee8$var$pcKey(cid, role);
            const pair = this.peerConnectionPairs.get(key);
            if (!pair) return;
            this.send({
                ...this.buildCommon(cid, 'PeerConnectionConnect', pair),
                ...this.sessionIdField(cid),
                peer_connection: role,
                was_previously_connected: pair.wasPreviouslyConnected,
                ...pair.userSessionId && {
                    user_session_id: pair.userSessionId
                },
                ...pair.sfuId && {
                    sfu_id: pair.sfuId
                },
                event_type: 'completed',
                outcome: 'failure',
                retry_count_attempt: 0,
                elapsed_time: Date.now() - pair.startedAt,
                ice_state: iceState,
                retry_failure_reason: reason,
                retry_failure_code: code
            });
            this.peerConnectionPairs.delete(key);
        };
        this.getSfuId = (cid)=>this.callContexts.get(cid)?.getSfuId() ?? '';
        this.getUserSessionId = (cid)=>this.callContexts.get(cid)?.getUserSessionId() ?? '';
        this.sessionIdField = (cid)=>{
            const callSessionId = this.callContexts.get(cid)?.getCallSessionId() ?? '';
            return callSessionId ? {
                call_session_id: callSessionId
            } : {};
        };
        this.buildCommon = (cid, stage, pair)=>{
            const ctx = this.callContexts.get(cid);
            const coordinatorConnectId = this.coordinatorConnectId;
            return {
                user_id: this.streamClient.userID || this.coordinatorConnectUserId,
                type: ctx?.callType ?? '',
                id: ctx?.callId ?? '',
                call_cid: cid,
                stage: stage,
                stage_id: pair.sid,
                ...pair.joinAttemptIdSnapshot && {
                    join_attempt_id: pair.joinAttemptIdSnapshot
                },
                ...coordinatorConnectId && {
                    coordinator_connect_id: coordinatorConnectId
                },
                timestamp: new Date().toISOString(),
                user_agent: this.streamClient.getUserAgent(),
                sdk_version: this.streamClient.getSdkVersion()
            };
        };
        this.send = (body)=>{
            if (!this.enabled) return;
            this.sendWithRetry(body);
        };
        this.sendWithRetry = async (body)=>{
            for(let attempt = 0; attempt < 5; attempt++)try {
                await this.streamClient.doAxiosRequest('post', '/call_client_event', {
                    events: [
                        body
                    ]
                }, {
                    publicEndpoint: true
                });
                return true;
            } catch (err) {
                const status = err?.response?.status;
                if (typeof status === 'number' && status >= 400 && status < 500) {
                    this.logger.debug(`Client event rejected (${status}), not retrying`, body.stage, body.event_type);
                    return false;
                }
                if (attempt === 4) {
                    this.logger.debug('Client event delivery failed after retries', body.stage, body.event_type, err);
                    return false;
                }
                await $8c05ed6f2f331ee8$var$sleep($8c05ed6f2f331ee8$var$retryInterval(attempt));
            }
            return false;
        };
        this.streamClient = options.streamClient;
        this.enabled = options.enabled ?? true;
    }
}
const $8c05ed6f2f331ee8$var$readPermissionStatus = (permission)=>{
    const state = $8c05ed6f2f331ee8$var$getCurrentValue(permission.asStateObservable());
    switch(state){
        case 'granted':
            return 'GRANTED';
        case 'denied':
            return 'FAILED';
        case 'prompting':
            return 'INITIATED';
        case 'prompt':
        default:
            return 'NOT_INITIATED';
    }
};
const $8c05ed6f2f331ee8$var$errorMessage = (err)=>err instanceof Error ? err.message : String(err);
const $8c05ed6f2f331ee8$var$applyError = (pair, next)=>{
    if (!pair) return;
    pair.lastError = next;
};
const $8c05ed6f2f331ee8$var$applyErrorIfAbsent = (pair, next)=>{
    if (!pair || pair.lastError) return;
    pair.lastError = next;
};
const $8c05ed6f2f331ee8$var$mapCoordinatorHttpError = (err)=>{
    if (err instanceof $8c05ed6f2f331ee8$export$758a4427671bc10f) return {
        reason: err.message,
        code: err.code != null ? String(err.code) : 'SERVER_ERROR'
    };
    return {
        reason: $8c05ed6f2f331ee8$var$errorMessage(err),
        code: 'SERVER_ERROR'
    };
};
const $8c05ed6f2f331ee8$var$mapCoordinatorWsError = (err)=>{
    if (err instanceof $8c05ed6f2f331ee8$export$758a4427671bc10f) return {
        reason: err.message,
        code: err.code != null ? String(err.code) : 'SERVER_ERROR'
    };
    if (err instanceof Error) try {
        const parsed = JSON.parse(err.message);
        if (typeof parsed.isWSFailure === 'boolean') return {
            reason: parsed.message || err.message,
            code: !parsed.isWSFailure && parsed.code ? String(parsed.code) : 'SERVER_ERROR'
        };
    } catch  {}
    return {
        reason: $8c05ed6f2f331ee8$var$errorMessage(err),
        code: 'SERVER_ERROR'
    };
};
const $8c05ed6f2f331ee8$var$mapWsJoinError = (err)=>{
    if (err instanceof $8c05ed6f2f331ee8$export$7aa89efb7e5fd7cd) {
        const sfuError = err.errorEvent.error;
        return {
            reason: sfuError?.message || err.message,
            code: sfuError && $8c05ed6f2f331ee8$var$ErrorCode[sfuError.code] || 'SFU_ERROR'
        };
    }
    const reason = $8c05ed6f2f331ee8$var$errorMessage(err);
    if (err instanceof $8c05ed6f2f331ee8$export$31251169af4bd1eb) return {
        reason: reason,
        code: 'REQUEST_TIMEOUT'
    };
    return {
        reason: reason,
        code: 'SFU_ERROR'
    };
};
/**
 * A `StreamVideoClient` instance lets you communicate with our API, and authenticate users.
 */ class $8c05ed6f2f331ee8$export$42ba3bdc276d86f6 {
    constructor(apiKeyOrArgs, opts){
        this.effectsRegistered = false;
        this.eventHandlersToUnregister = [];
        this.connectionConcurrencyTag = Symbol('connectionConcurrencyTag');
        this.rejectCallWhenBusy = false;
        this.registerClientInstance = (apiKey, user)=>{
            const instanceKey = $8c05ed6f2f331ee8$var$getInstanceKey(apiKey, user);
            if ($8c05ed6f2f331ee8$export$42ba3bdc276d86f6._instances.has(instanceKey)) this.logger.warn(`A StreamVideoClient already exists for ${user.id}; Prefer using getOrCreateInstance method`);
            $8c05ed6f2f331ee8$export$42ba3bdc276d86f6._instances.set(instanceKey, this);
        };
        this.registerEffects = ()=>{
            if (this.effectsRegistered) return;
            this.eventHandlersToUnregister.push(this.on('call.created', (event)=>this.initCallFromEvent(event)), this.on('call.ring', (event)=>this.initCallFromEvent(event)), this.on('connection.changed', (event)=>{
                if (!event.online) return;
                const callsToReWatch = this.writeableStateStore.calls.filter((call)=>call.watching).map((call)=>call.cid);
                if (callsToReWatch.length <= 0) return;
                this.rewatchCalls(callsToReWatch).catch((err)=>{
                    this.logger.error('Failed to re-watch calls', err);
                });
            }));
            this.effectsRegistered = true;
        };
        /**
         * Initializes a call from a call created or ringing event.
         * @param e the event.
         */ this.initCallFromEvent = async (e)=>{
            try {
                const concurrencyTag = $8c05ed6f2f331ee8$var$getCallInitConcurrencyTag(e.call_cid);
                await $8c05ed6f2f331ee8$var$withoutConcurrency(concurrencyTag, async ()=>{
                    const ringing = e.type === 'call.ring';
                    let call = this.writeableStateStore.findCall(e.call.type, e.call.id);
                    if (call) {
                        if (ringing) {
                            if (this.shouldRejectCall(call.cid)) {
                                this.logger.info(`Leaving call with busy reject reason ${call.cid} because user is busy`);
                                // remove the instance from the state store
                                await call.leave();
                                // explicitly reject the call with busy reason as calling state was not ringing before and leave would not call it therefore
                                await call.reject('busy');
                            } else await call.updateFromRingingEvent(e);
                        } else call.state.updateFromCallResponse(e.call);
                        return;
                    }
                    call = new $8c05ed6f2f331ee8$export$e01e40655568efad({
                        streamClient: this.streamClient,
                        clientEventReporter: this.clientEventReporter,
                        type: e.call.type,
                        id: e.call.id,
                        members: e.members,
                        clientStore: this.writeableStateStore,
                        ringing: ringing
                    });
                    if (ringing) {
                        if (this.shouldRejectCall(call.cid)) {
                            this.logger.info(`Rejecting call ${call.cid} because user is busy`);
                            // call is not in the state store yet, so just reject api is enough
                            await call.reject('busy');
                        } else {
                            await call.updateFromRingingEvent(e);
                            await call.get();
                        }
                    } else {
                        call.state.updateFromCallResponse(e.call);
                        this.writeableStateStore.registerCall(call);
                        this.logger.info(`New call created and registered: ${call.cid}`);
                    }
                });
            } catch (err) {
                this.logger.error(`Failed to init call from event ${e.type}`, err);
            }
        };
        /**
         * Rewatches the given calls with retry logic.
         * @param callsToReWatch array of call IDs to rewatch
         */ this.rewatchCalls = async (callsToReWatch)=>{
            this.logger.info(`Rewatching calls ${callsToReWatch.join(', ')}`);
            const maxRetries = 3;
            for(let attempt = 0; attempt < maxRetries; attempt++){
                try {
                    this.logger.info(`Rewatching calls ${callsToReWatch.join(', ')} attempt ${attempt + 1}`);
                    await this.queryCalls({
                        watch: true,
                        filter_conditions: {
                            cid: {
                                $in: callsToReWatch
                            }
                        }
                    });
                    return;
                } catch (err) {
                    if (err instanceof $8c05ed6f2f331ee8$export$758a4427671bc10f && err.unrecoverable) throw err;
                    this.logger.warn(`Failed to re-watch calls (attempt ${attempt + 1}/${maxRetries}), retrying.`, err);
                    if (attempt === maxRetries - 1) throw err;
                }
                await $8c05ed6f2f331ee8$var$sleep($8c05ed6f2f331ee8$var$retryInterval(attempt));
            }
        };
        /**
         * Connects the given user to the client.
         * Only one user can connect at a time, if you want to change users, call `disconnectUser` before connecting a new user.
         * If the connection is successful, the connected user [state variable](#readonlystatestore) will be updated accordingly.
         *
         * @param user the user to connect.
         * @param tokenOrProvider a token or a function that returns a token.
         */ this.connectUser = async (user, tokenOrProvider)=>{
            if (user.type === 'anonymous') {
                user.id = '!anon';
                return this.connectAnonymousUser(user, tokenOrProvider);
            }
            const reporter = this.clientEventReporter;
            reporter.startCoordinatorConnection(user.id);
            const connectUserResponse = await $8c05ed6f2f331ee8$var$withoutConcurrency(this.connectionConcurrencyTag, async ()=>{
                const client = this.streamClient;
                const { onConnectUserError: onConnectUserError, persistUserOnConnectionFailure: persistUserOnConnectionFailure } = client.options;
                let { maxConnectUserRetries: maxConnectUserRetries = 5 } = client.options;
                maxConnectUserRetries = Math.max(maxConnectUserRetries, 1);
                const errorQueue = [];
                for(let attempt = 0; attempt < maxConnectUserRetries; attempt++)try {
                    this.logger.trace(`Connecting user (${attempt})`, user);
                    return await reporter.trackCoordinatorWs(()=>user.type === 'guest' ? client.connectGuestUser(user) : client.connectUser(user, tokenOrProvider));
                } catch (err) {
                    this.logger.warn(`Failed to connect a user (${attempt})`, err);
                    errorQueue.push(err);
                    if (attempt === maxConnectUserRetries - 1) {
                        reporter.closeCoordinatorWs();
                        onConnectUserError?.(err, errorQueue);
                        throw err;
                    }
                    // we need to force to disconnect the user if the client is
                    // configured to persist the user on connection failure
                    if (persistUserOnConnectionFailure) await client.disconnectUser();
                    await $8c05ed6f2f331ee8$var$sleep($8c05ed6f2f331ee8$var$retryInterval(attempt));
                }
            });
            // connectUserResponse will be void if connectUser called twice for the same user
            if (connectUserResponse?.me) this.writeableStateStore.setConnectedUser(connectUserResponse.me);
            this.registerEffects();
            return connectUserResponse;
        };
        /**
         * Disconnects the currently connected user from the client.
         *
         * If the connection is successfully disconnected, the connected user [state variable](#readonlystatestore) will be updated accordingly
         *
         * @param timeout Max number of ms, to wait for close event of websocket, before forcefully assuming successful disconnection.
         *                https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent
         */ this.disconnectUser = async (timeout)=>{
            await $8c05ed6f2f331ee8$var$withoutConcurrency(this.connectionConcurrencyTag, async ()=>{
                const { user: user, key: key } = this.streamClient;
                if (!user) return;
                await this.streamClient.disconnectUser(timeout);
                if (user.id) $8c05ed6f2f331ee8$export$42ba3bdc276d86f6._instances.delete($8c05ed6f2f331ee8$var$getInstanceKey(key, user));
                this.eventHandlersToUnregister.forEach((unregister)=>unregister());
                this.eventHandlersToUnregister = [];
                this.effectsRegistered = false;
                this.writeableStateStore.setConnectedUser(undefined);
            });
        };
        /**
         * You can subscribe to WebSocket events provided by the API.
         * To remove a subscription, call the `off` method or, execute the returned unsubscribe function.
         * Please note that subscribing to WebSocket events is an advanced use-case, for most use-cases it should be enough to watch for changes in the reactive [state store](#readonlystatestore).
         *
         * @param eventName the event name or 'all'.
         * @param callback the callback which will be called when the event is emitted.
         * @returns an unsubscribe function.
         */ this.on = (eventName, callback)=>{
            return this.streamClient.on(eventName, callback);
        };
        /**
         * Remove subscription for WebSocket events that were created by the `on` method.
         *
         * @param eventName the event name.
         * @param callback the callback which was passed to the `on` method.
         */ this.off = (eventName, callback)=>{
            return this.streamClient.off(eventName, callback);
        };
        /**
         * Creates a new call.
         *
         * @param type the type of the call.
         * @param id the id of the call.
         * @param options additional options for call creation.
         */ this.call = (type, id, options = {})=>{
            const call = options.reuseInstance ? this.writeableStateStore.findCall(type, id) : undefined;
            return call ?? new $8c05ed6f2f331ee8$export$e01e40655568efad({
                streamClient: this.streamClient,
                clientEventReporter: this.clientEventReporter,
                id: id,
                type: type,
                clientStore: this.writeableStateStore
            });
        };
        /**
         * Creates a new guest user with the given data.
         *
         * @param data the data for the guest user.
         */ this.createGuestUser = async (data)=>{
            return this.streamClient.doAxiosRequest('post', '/guest', data, {
                publicEndpoint: true
            });
        };
        /**
         * Will query the API for calls matching the given filters.
         *
         * @param data the query data.
         */ this.queryCalls = async (data = {})=>{
            const response = await this.streamClient.post('/calls', data);
            const calls = [];
            for (const c of response.calls){
                const call = new $8c05ed6f2f331ee8$export$e01e40655568efad({
                    streamClient: this.streamClient,
                    clientEventReporter: this.clientEventReporter,
                    id: c.call.id,
                    type: c.call.type,
                    members: c.members,
                    ownCapabilities: c.own_capabilities,
                    watching: data.watch,
                    clientStore: this.writeableStateStore
                });
                call.state.updateFromCallResponse(c.call);
                await call.applyDeviceConfig(c.call.settings, false, $8c05ed6f2f331ee8$var$isReactNative());
                if (data.watch) {
                    await call.setup();
                    this.writeableStateStore.registerCall(call);
                }
                calls.push(call);
            }
            return {
                ...response,
                calls: calls
            };
        };
        /**
         * Retrieve the list of available call statistics reports matching a particular condition.
         *
         * @param data Filter and sort conditions for retrieving available call report summaries.
         * @returns List with summary of available call reports matching the condition.
         */ this.queryCallStats = async (data = {})=>{
            return this.streamClient.post(`/call/stats`, data);
        };
        /**
         * Retrieve the list of available reports aggregated from the call stats.
         *
         * @param data Specify filter conditions like from and to (within last 30 days) and the report types
         * @returns Requested reports with (mostly) raw daily data for each report type requested
         */ this.queryAggregateCallStats = async (data = {})=>{
            return this.streamClient.post(`/stats`, data);
        };
        /**
         * Returns a list of available data centers available for hosting calls.
         */ this.edges = async ()=>{
            return this.streamClient.get(`/edges`);
        };
        /**
         * addDevice - Adds a push device for a user.
         *
         * @param {string} id the device id
         * @param {string} push_provider the push provider name (eg. apn, firebase)
         * @param {string} push_provider_name user provided push provider name
         * @param {string} [userID] the user id (defaults to current user)
         * @param {boolean} [voip_token] enables use of VoIP token for push notifications on iOS platform
         */ this.addDevice = async (id, push_provider, push_provider_name, userID, voip_token)=>{
            return await this.streamClient.post('/devices', {
                id: id,
                push_provider: push_provider,
                voip_token: voip_token,
                ...userID != null ? {
                    user_id: userID
                } : {},
                ...push_provider_name != null ? {
                    push_provider_name: push_provider_name
                } : {}
            });
        };
        /**
         * addDevice - Adds a push device for a user.
         *
         * @param {string} id the device id
         * @param {string} push_provider the push provider name (eg. apn, firebase)
         * @param {string} push_provider_name user provided push provider name
         * @param {string} [userID] the user id (defaults to current user)
         */ this.addVoipDevice = async (id, push_provider, push_provider_name, userID)=>{
            return await this.addDevice(id, push_provider, push_provider_name, userID, true);
        };
        /**
         * getDevices - Returns the devices associated with a current user
         * @param {string} [userID] User ID. Only works on serverside
         */ this.getDevices = async (userID)=>{
            return await this.streamClient.get('/devices', userID ? {
                user_id: userID
            } : {});
        };
        /**
         * removeDevice - Removes the device with the given id.
         *
         * @param {string} id The device id
         * @param {string} [userID] The user id. Only specify this for serverside requests
         */ this.removeDevice = async (id, userID)=>{
            return await this.streamClient.delete('/devices', {
                id: id,
                ...userID ? {
                    user_id: userID
                } : {}
            });
        };
        /**
         * A callback that can be used to create ringing calls from push notifications. If the call already exists, it will do nothing.
         * @param call_cid
         * @returns
         */ this.onRingingCall = async (call_cid)=>{
            return $8c05ed6f2f331ee8$var$withoutConcurrency($8c05ed6f2f331ee8$var$getCallInitConcurrencyTag(call_cid), async ()=>{
                // if we find the call and is already ringing, we don't need to create a new call
                // as client would have received the call.ring state because the app had WS alive when receiving push notifications
                let call = this.state.calls.find((c)=>c.cid === call_cid && c.ringing);
                if (!call) {
                    // if not it means that WS is not alive when receiving the push notifications and we need to fetch the call
                    const [callType, callId] = call_cid.split(':');
                    call = new $8c05ed6f2f331ee8$export$e01e40655568efad({
                        streamClient: this.streamClient,
                        clientEventReporter: this.clientEventReporter,
                        type: callType,
                        id: callId,
                        clientStore: this.writeableStateStore,
                        ringing: true
                    });
                    await call.get();
                }
                return call;
            });
        };
        /**
         * Connects the given anonymous user to the client.
         *
         * @param user the user to connect.
         * @param tokenOrProvider a token or a function that returns a token.
         */ this.connectAnonymousUser = async (user, tokenOrProvider)=>{
            return $8c05ed6f2f331ee8$var$withoutConcurrency(this.connectionConcurrencyTag, ()=>this.streamClient.connectAnonymousUser(user, tokenOrProvider));
        };
        this.shouldRejectCall = (currentCallId)=>{
            if (!this.rejectCallWhenBusy) return false;
            return this.state.calls.some((c)=>c.cid !== currentCallId && c.ringing && c.state.callingState !== $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.IDLE && c.state.callingState !== $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.LEFT && c.state.callingState !== $8c05ed6f2f331ee8$export$e10ca39c0aa31acc.RECONNECTING_FAILED);
        };
        const apiKey = typeof apiKeyOrArgs === 'string' ? apiKeyOrArgs : apiKeyOrArgs.apiKey;
        const clientOptions = typeof apiKeyOrArgs === 'string' ? opts : apiKeyOrArgs.options;
        if (clientOptions?.enableTimerWorker) $8c05ed6f2f331ee8$var$enableTimerWorker();
        const rootLogger = clientOptions?.logger || $8c05ed6f2f331ee8$export$c86c88f4929407a2;
        $8c05ed6f2f331ee8$export$1f073264fb3f7580.configureLoggers({
            default: {
                sink: rootLogger,
                level: clientOptions?.logLevel || 'warn'
            },
            ...clientOptions?.logOptions
        });
        this.logger = $8c05ed6f2f331ee8$export$1f073264fb3f7580.getLogger('client');
        this.rejectCallWhenBusy = clientOptions?.rejectCallWhenBusy ?? false;
        this.streamClient = $8c05ed6f2f331ee8$var$createCoordinatorClient(apiKey, clientOptions);
        this.clientEventReporter = new $8c05ed6f2f331ee8$var$ClientEventReporter({
            streamClient: this.streamClient,
            enabled: clientOptions?.clientEventsReportingEnabled ?? true
        });
        this.writeableStateStore = new $8c05ed6f2f331ee8$export$8da656e2640438dd();
        this.readOnlyStateStore = new $8c05ed6f2f331ee8$export$d30353056ebb432d(this.writeableStateStore);
        if (typeof apiKeyOrArgs !== 'string' && apiKeyOrArgs.user) {
            const user = apiKeyOrArgs.user;
            if (user.type === 'anonymous') user.id = '!anon';
            if (user.id) this.registerClientInstance(apiKey, user);
            const tokenOrProvider = $8c05ed6f2f331ee8$var$createTokenOrProvider(apiKeyOrArgs);
            this.connectUser(user, tokenOrProvider).catch((err)=>{
                this.logger.error('Failed to connect', err);
            });
        }
    }
    /**
     * Gets or creates a StreamVideoClient instance based on the given options.
     */ static getOrCreateInstance(args) {
        const { apiKey: apiKey, user: user, token: token, tokenProvider: tokenProvider } = args;
        if (!user.id && user.type !== 'anonymous') throw new Error('user.id is required for a non-anonymous user');
        if (!token && !tokenProvider && user.type !== 'anonymous' && user.type !== 'guest') throw new Error('tokenProvider or token is required for a authenticated users');
        return $8c05ed6f2f331ee8$export$42ba3bdc276d86f6._instances.get($8c05ed6f2f331ee8$var$getInstanceKey(apiKey, user)) || new $8c05ed6f2f331ee8$export$42ba3bdc276d86f6(args);
    }
    /**
     * Return the reactive state store, use this if you want to be notified about changes to the client state
     */ get state() {
        return this.readOnlyStateStore;
    }
}
$8c05ed6f2f331ee8$export$42ba3bdc276d86f6._instances = new Map();
/**
 * Formats large numbers into a compact, human-friendly form: 1k, 1.5k, 2M, etc.
 */ const $8c05ed6f2f331ee8$export$cfb8c2be79648c4 = (n)=>{
    if (n < 1000) return String(n);
    const units = [
        {
            value: 1000000000,
            suffix: 'B'
        },
        {
            value: 1000000,
            suffix: 'M'
        },
        {
            value: 1000,
            suffix: 'k'
        }
    ];
    for (const { value: value, suffix: suffix } of units)if (n >= value) {
        const num = n / value;
        const precision = num < 100 ? 1 : 0; // show one decimal only for small leading numbers
        const formatted = num.toFixed(precision).replace(/\.0$/g, '');
        return `${formatted}${suffix}`;
    }
    return String(n);
};



// SVGs for UI elements
const $ae1732977a50e3d7$var$USER_ICON = `<svg viewBox="0 0 24 24"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>`;
const $ae1732977a50e3d7$var$MIC_OFF_ICON = `<svg viewBox="0 0 24 24"><path d="M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l2.97 2.97c-.85.35-1.76.53-2.62.53-3.31 0-6-2.69-6-6v-2.29l-1.67-1.67L3.54 12c0 3.71 2.63 6.84 6.46 7.74V22h4v-2.26c1.19-.28 2.27-.79 3.23-1.46L19.73 21 21 19.73 4.27 3z"/></svg>`;
const $ae1732977a50e3d7$var$videoDimension = {
    width: 333,
    height: 250
};
const $ae1732977a50e3d7$var$videoBindingsCache = new Map();
const $ae1732977a50e3d7$var$audioBindingsCache = new Map();
const $ae1732977a50e3d7$var$renderVideo = (call, participant, parentContainer)=>{
    const id = `video-${participant.sessionId}`;
    let videoEl = document.getElementById(id);
    if (!videoEl) {
        videoEl = document.createElement("video");
        videoEl.id = id;
        videoEl.dataset.sessionId = participant.sessionId;
        parentContainer.insertBefore(videoEl, parentContainer.firstChild);
        const unbind = call.bindVideoElement(videoEl, participant.sessionId, "videoTrack");
        $ae1732977a50e3d7$var$videoBindingsCache.set(id, unbind);
    }
    const placeholderId = `placeholder-${participant.sessionId}`;
    let placeholderEl = document.getElementById(placeholderId);
    if (!placeholderEl) {
        placeholderEl = document.createElement("div");
        placeholderEl.id = placeholderId;
        placeholderEl.className = "video-placeholder";
        placeholderEl.innerHTML = $ae1732977a50e3d7$var$USER_ICON;
        parentContainer.appendChild(placeholderEl);
    }
    if ((0, $8c05ed6f2f331ee8$export$554515ce821ba4ab)(participant)) {
        videoEl.style.display = "block";
        placeholderEl.style.display = "none";
    } else {
        videoEl.style.display = "none";
        placeholderEl.style.display = "flex";
    }
};
const $ae1732977a50e3d7$var$renderAudio = (call, participant, parentContainer)=>{
    if (participant.isLocalParticipant) return;
    const id = `audio-${participant.sessionId}`;
    let audioEl = document.getElementById(id);
    if (!audioEl) {
        audioEl = document.createElement("audio");
        audioEl.id = id;
        audioEl.dataset.sessionId = participant.sessionId;
        parentContainer.appendChild(audioEl);
        const unbind = call.bindAudioElement(audioEl, participant.sessionId);
        $ae1732977a50e3d7$var$audioBindingsCache.set(id, unbind);
    }
};
const $ae1732977a50e3d7$var$renderStatusIcons = (participant, parentContainer)=>{
    const micId = `mic-status-${participant.sessionId}`;
    let micEl = document.getElementById(micId);
    if (!micEl) {
        micEl = document.createElement("div");
        micEl.id = micId;
        micEl.className = "mic-status";
        micEl.innerHTML = $ae1732977a50e3d7$var$MIC_OFF_ICON;
        parentContainer.appendChild(micEl);
    }
    micEl.style.display = (0, $8c05ed6f2f331ee8$export$2e009d8a44827b31)(participant) ? "none" : "flex";
};
const $ae1732977a50e3d7$export$ba106a60edcf9cbc = (call, participant, parentContainer, screenShareContainer)=>{
    $ae1732977a50e3d7$var$renderVideo(call, participant, parentContainer);
    $ae1732977a50e3d7$var$renderAudio(call, participant, parentContainer);
    $ae1732977a50e3d7$var$renderStatusIcons(participant, parentContainer);
    (0, $8c05ed6f2f331ee8$export$30c686c84ce95811)(participant) && screenShareContainer;
};
const $ae1732977a50e3d7$export$e855ba20cf420751 = (sessionId)=>{
    const unbindVideo = $ae1732977a50e3d7$var$videoBindingsCache.get(`video-${sessionId}`);
    if (unbindVideo) unbindVideo();
    $ae1732977a50e3d7$var$videoBindingsCache.delete(`video-${sessionId}`);
    const unbindAudio = $ae1732977a50e3d7$var$audioBindingsCache.get(`audio-${sessionId}`);
    if (unbindAudio) unbindAudio();
    $ae1732977a50e3d7$var$audioBindingsCache.delete(`audio-${sessionId}`);
};


// Icons
const $302b5bb12cc47461$var$MIC_ON = `<svg viewBox="0 0 24 24"><path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z"/><path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"/></svg>`;
const $302b5bb12cc47461$var$CAM_ON = `<svg viewBox="0 0 24 24"><path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"/></svg>`;
const $302b5bb12cc47461$var$SCREEN_SHARE = `<svg viewBox="0 0 24 24"><path d="M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.11-.9-2-2-2H4c-1.11 0-2 .89-2 2v10c0 1.1.89 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"/></svg>`;
const $302b5bb12cc47461$var$CAM_FLIP = `<svg viewBox="0 0 24 24"><path d="M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 11.5V13H9v2.5L5.5 12 9 8.5V11h6V8.5l3.5 3.5-3.5 3.5z"/></svg>`;
const $302b5bb12cc47461$var$SETTINGS = `<svg viewBox="0 0 24 24"><path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L3.16 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.04.24.24.41.48.41h3.84c.24 0 .43-.17.47-.41l.36-2.54c.59-.24 1.13-.57 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"/></svg>`;
const $302b5bb12cc47461$var$LEAVE = `<svg viewBox="0 0 24 24"><path d="M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .39-.23.74-.56.9-.98.49-1.87 1.12-2.66 1.85-.18.18-.43.28-.7.28-.28 0-.53-.11-.71-.29L.29 13.08c-.18-.17-.29-.42-.29-.7 0-.28.11-.53.29-.71C3.34 8.78 7.46 7 12 7s8.66 1.78 11.71 4.67c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2.48 2.48c-.18.18-.43.29-.71.29-.27 0-.52-.11-.7-.28-.79-.74-1.69-1.36-2.67-1.85-.33-.16-.56-.5-.56-.9v-3.1C15.15 9.25 13.6 9 12 9z"/></svg>`;
const $302b5bb12cc47461$var$CHAT_ICON = `<svg viewBox="0 0 24 24"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"/></svg>`;
const $302b5bb12cc47461$var$createBtn = (iconSvg, className = "")=>{
    const btn = document.createElement("button");
    btn.className = `control-btn ${className}`;
    btn.innerHTML = iconSvg;
    return btn;
};
const $302b5bb12cc47461$export$6d535e4753f6abc4 = (call, onLeave)=>{
    // Audio
    const audioButton = $302b5bb12cc47461$var$createBtn($302b5bb12cc47461$var$MIC_ON);
    audioButton.addEventListener("click", ()=>call.microphone.toggle());
    call.microphone.state.status$.subscribe((status)=>{
        audioButton.classList.toggle("off", status === "disabled");
    });
    // Video
    const videoButton = $302b5bb12cc47461$var$createBtn($302b5bb12cc47461$var$CAM_ON);
    videoButton.addEventListener("click", ()=>call.camera.toggle());
    call.camera.state.status$.subscribe((status)=>{
        videoButton.classList.toggle("off", status === "disabled");
    });
    // Chat Button
    const chatButton = $302b5bb12cc47461$var$createBtn($302b5bb12cc47461$var$CHAT_ICON);
    // Screen Share
    const screenShareButton = $302b5bb12cc47461$var$createBtn($302b5bb12cc47461$var$SCREEN_SHARE);
    screenShareButton.addEventListener("click", ()=>call.screenShare.toggle());
    call.screenShare.state.status$.subscribe((status)=>{
        screenShareButton.classList.toggle("active", status === "enabled");
    });
    // Flip (Mobile)
    const flipButton = $302b5bb12cc47461$var$createBtn($302b5bb12cc47461$var$CAM_FLIP);
    flipButton.addEventListener("click", ()=>call.camera.flip());
    // Settings
    const settingsButton = $302b5bb12cc47461$var$createBtn($302b5bb12cc47461$var$SETTINGS);
    // Leave - UPDATED
    const leaveButton = $302b5bb12cc47461$var$createBtn($302b5bb12cc47461$var$LEAVE, "danger");
    if (onLeave) leaveButton.addEventListener("click", onLeave);
    return {
        audioButton: audioButton,
        videoButton: videoButton,
        screenShareButton: screenShareButton,
        flipButton: flipButton,
        settingsButton: settingsButton,
        leaveButton: leaveButton,
        chatButton: chatButton
    };
};


const $352d8f777a97466a$export$6b8f03eaf45fe3b8 = (call)=>{
    const element = document.createElement("select");
    element.addEventListener("change", (e)=>{
        const target = e.target;
        call.microphone.select(target.value);
    });
    call.microphone.listDevices().subscribe({
        next: (devices)=>{
            element.innerHTML = "";
            devices?.forEach((device)=>{
                const option = document.createElement("option");
                option.value = device.deviceId;
                option.innerText = device.label;
                element.appendChild(option);
            });
        },
        error: (error)=>alert(`Can't list devices ${error}`)
    });
    return element;
};
const $352d8f777a97466a$export$3027322e3fd75560 = (call)=>{
    const element = document.createElement("select");
    element.addEventListener("change", async (e)=>{
        const target = e.target;
        await call.camera.select(target.value);
    });
    call.camera.listDevices().subscribe({
        next: (devices)=>{
            element.innerHTML = "";
            devices?.forEach((device)=>{
                const option = document.createElement("option");
                option.value = device.deviceId;
                option.innerText = device.label;
                element.appendChild(option);
            });
        },
        error: (error)=>alert(`Can't list devices ${error}`)
    });
    return element;
};
const $352d8f777a97466a$export$e73acf91ab165693 = (call)=>{
    if (!call.speaker.state.isDeviceSelectionSupported) return;
    const element = document.createElement("select");
    element.addEventListener("change", (e)=>{
        const target = e.target;
        call.speaker.select(target.value);
    });
    call.speaker.listDevices().subscribe({
        next: (devices)=>{
            element.innerHTML = "";
            devices.forEach((device)=>{
                const option = document.createElement("option");
                option.value = device.deviceId;
                option.innerText = device.label;
                element.appendChild(option);
            });
        },
        error: (error)=>alert(`Can't list devices ${error}`)
    });
    return element;
};
const $352d8f777a97466a$export$3a91319fc9073867 = (call)=>{
    const element = document.createElement("input");
    element.type = "range";
    element.min = "0";
    element.max = "1";
    element.step = "0.1";
    element.addEventListener("change", (event)=>{
        call.speaker.setVolume(event.target.value);
    });
    call.speaker.state.volume$.subscribe((volume)=>{
        element.value = "" + volume;
    });
    return element;
};


// Source https://stackoverflow.com/a/13819253/21226642
const $0073ed07eb3af726$export$d0a8044dce8ff2fc = {
    Android: function() {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function() {
        return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
    },
    any: function() {
        return $0073ed07eb3af726$export$d0a8044dce8ff2fc.Android() || $0073ed07eb3af726$export$d0a8044dce8ff2fc.BlackBerry() || $0073ed07eb3af726$export$d0a8044dce8ff2fc.iOS() || $0073ed07eb3af726$export$d0a8044dce8ff2fc.Opera() || $0073ed07eb3af726$export$d0a8044dce8ff2fc.Windows();
    }
};


class $09d892b85c18f647$export$446e355f79c9563c {
    constructor(apiUrl, appointmentId, userId, token){
        this.apiUrl = apiUrl;
        this.appointmentId = appointmentId;
        this.userId = userId;
        this.token = token;
        this.messages = [];
        this.lastMessageTime = null;
        this.intervalId = null;
        this.listeners = [];
        this.isPolling = false;
    }
    subscribe(listener) {
        this.listeners.push(listener);
        // Send current messages immediately upon subscription
        listener(this.messages);
        return ()=>{
            this.listeners = this.listeners.filter((l)=>l !== listener);
        };
    }
    notify() {
        this.listeners.forEach((l)=>l(this.messages));
    }
    startPolling(intervalMs = 2500) {
        if (this.isPolling) return;
        this.isPolling = true;
        this.fetchMessages();
        this.intervalId = setInterval(()=>this.fetchMessages(), intervalMs);
    }
    stopPolling() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
        this.isPolling = false;
    }
    async fetchMessages() {
        try {
            const params = new URLSearchParams({
                token: this.token,
                appointmentId: this.appointmentId
            });
            if (this.lastMessageTime) params.append("since", this.lastMessageTime);
            const res = await fetch(`${this.apiUrl}/chat?${params}`);
            if (!res.ok) return;
            const newMessages = await res.json();
            if (newMessages.length > 0) {
                this.lastMessageTime = newMessages[newMessages.length - 1].createdAt;
                const existingIds = new Set(this.messages.map((m)=>m.id));
                const filtered = newMessages.filter((m)=>!existingIds.has(m.id));
                if (filtered.length > 0) {
                    this.messages = [
                        ...this.messages,
                        ...filtered
                    ];
                    this.notify();
                }
            }
        } catch (error) {
            console.error("Error polling messages:", error);
        }
    }
    async uploadFile(file) {
        const presignRes = await fetch(`${this.apiUrl}/chat/upload/presign?token=${this.token}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                appointmentId: this.appointmentId,
                fileName: file.name,
                fileType: file.type,
                fileSize: file.size
            })
        });
        if (!presignRes.ok) throw new Error("Error obtaining upload URL");
        const { uploadUrl: uploadUrl, fileUrl: fileUrl } = await presignRes.json();
        const uploadRes = await fetch(uploadUrl, {
            method: "PUT",
            headers: {
                "Content-Type": file.type
            },
            body: file
        });
        if (!uploadRes.ok) throw new Error("Error uploading file to cloud");
        return fileUrl;
    }
    async sendMessage(text, fileUrl, fileName, fileType) {
        const body = {
            appointmentId: this.appointmentId,
            text: text
        };
        if (fileUrl) {
            body.fileUrl = fileUrl;
            body.fileName = fileName;
            body.fileType = fileType;
        }
        const res = await fetch(`${this.apiUrl}/chat?token=${this.token}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body)
        });
        if (!res.ok) throw new Error("Error sending message");
        this.fetchMessages();
    }
    getUserId() {
        return this.userId;
    }
}


// Icons
const $33eec13820dbe7df$var$ICON_SEND = `<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg>`;
const $33eec13820dbe7df$var$ICON_CLIP = `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path></svg>`;
const $33eec13820dbe7df$var$ICON_X = `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>`;
const $33eec13820dbe7df$var$ICON_FILE = `<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline></svg>`;
class $33eec13820dbe7df$export$dc0ba17f632b90a8 {
    constructor(service, parentElement){
        this.service = service;
        this.parentElement = parentElement;
        this.selectedFile = null;
        this.isOpen = false;
        this.container = document.createElement("div");
        this.container.id = "chat-panel";
        this.container.className = "chat-panel hidden";
        // --- Header ---
        const header = document.createElement("div");
        header.className = "chat-header";
        header.innerHTML = `<h3>Chat de la consulta</h3>`;
        const closeBtn = document.createElement("button");
        closeBtn.innerHTML = $33eec13820dbe7df$var$ICON_X;
        closeBtn.onclick = ()=>this.toggle();
        header.appendChild(closeBtn);
        this.container.appendChild(header);
        // --- Messages List ---
        this.messagesContainer = document.createElement("div");
        this.messagesContainer.className = "chat-messages";
        this.container.appendChild(this.messagesContainer);
        // --- Input Area ---
        const inputArea = document.createElement("div");
        inputArea.className = "chat-input-area";
        // File Preview
        this.filePreview = document.createElement("div");
        this.filePreview.className = "file-preview hidden";
        inputArea.appendChild(this.filePreview);
        // Form
        const form = document.createElement("form");
        form.className = "chat-form";
        // File Input (Hidden)
        this.fileInput = document.createElement("input");
        this.fileInput.type = "file";
        this.fileInput.style.display = "none";
        this.fileInput.onchange = (e)=>this.handleFileSelect(e.target.files?.[0]);
        // Paperclip Button
        const attachBtn = document.createElement("button");
        attachBtn.type = "button";
        attachBtn.className = "icon-btn";
        attachBtn.innerHTML = $33eec13820dbe7df$var$ICON_CLIP;
        attachBtn.onclick = ()=>this.fileInput.click();
        // Text Input
        this.input = document.createElement("input");
        this.input.placeholder = "Escribe un mensaje...";
        this.input.className = "message-input";
        // Send Button
        const sendBtn = document.createElement("button");
        sendBtn.type = "submit";
        sendBtn.className = "send-btn";
        sendBtn.innerHTML = $33eec13820dbe7df$var$ICON_SEND;
        form.appendChild(this.fileInput);
        form.appendChild(attachBtn);
        form.appendChild(this.input);
        form.appendChild(sendBtn);
        inputArea.appendChild(form);
        this.container.appendChild(inputArea);
        form.onsubmit = (e)=>this.handleSubmit(e);
        this.parentElement.appendChild(this.container);
        this.service.subscribe((messages)=>this.renderMessages(messages));
    }
    toggle() {
        this.isOpen = !this.isOpen;
        if (this.isOpen) {
            this.container.classList.remove("hidden");
            this.service.startPolling();
            this.scrollToBottom();
        } else {
            this.container.classList.add("hidden");
            this.service.stopPolling();
        }
        return this.isOpen;
    }
    renderMessages(messages) {
        this.messagesContainer.innerHTML = "";
        const myId = this.service.getUserId();
        messages.forEach((msg)=>{
            const isMe = msg.senderId === myId;
            const msgEl = document.createElement("div");
            msgEl.className = `chat-message ${isMe ? "me" : "other"}`;
            let contentHtml = "";
            if (msg.text) contentHtml += `<p>${msg.text}</p>`;
            if (msg.fileUrl) contentHtml += `
          <a href="${msg.fileUrl}" target="_blank" class="file-attachment ${isMe ? 'me' : 'other'}">
            ${$33eec13820dbe7df$var$ICON_FILE}
            <span>${msg.fileName || "Adjunto"}</span>
          </a>
        `;
            msgEl.innerHTML = `
        <div class="bubble">${contentHtml}</div>
        <span class="sender-name">${isMe ? "T\xfa" : msg.sender.name}</span>
      `;
            this.messagesContainer.appendChild(msgEl);
        });
        this.scrollToBottom();
    }
    handleFileSelect(file) {
        if (!file) return;
        this.selectedFile = file;
        this.filePreview.innerHTML = `
      <div class="file-tag">
        ${$33eec13820dbe7df$var$ICON_FILE} <span>${file.name}</span>
        <button type="button" class="remove-file-btn">${$33eec13820dbe7df$var$ICON_X}</button>
      </div>
    `;
        this.filePreview.querySelector("button").onclick = ()=>{
            this.selectedFile = null;
            this.filePreview.classList.add("hidden");
            this.fileInput.value = "";
        };
        this.filePreview.classList.remove("hidden");
    }
    async handleSubmit(e) {
        e.preventDefault();
        const text = this.input.value.trim();
        if (!text && !this.selectedFile) return;
        const submitBtn = this.container.querySelector("button[type=submit]");
        submitBtn.disabled = true;
        try {
            let fileUrl;
            if (this.selectedFile) fileUrl = await this.service.uploadFile(this.selectedFile);
            await this.service.sendMessage(text || (this.selectedFile ? "\uD83D\uDCCE Adjunto" : ""), fileUrl, this.selectedFile?.name, this.selectedFile?.type);
            // Reset
            this.input.value = "";
            this.selectedFile = null;
            this.filePreview.classList.add("hidden");
            this.fileInput.value = "";
        } catch (err) {
            alert("Failed to send message");
            console.error(err);
        } finally{
            submitBtn.disabled = false;
        }
    }
    scrollToBottom() {
        this.messagesContainer.scrollTop = this.messagesContainer.scrollHeight;
    }
}


var $99b79a786cd20e57$exports = {};
// This file is a compatibility shim for bundlers (e.g. webpack 4) that do not
// support the package.json `exports` field for resolving subpath exports.

$99b79a786cd20e57$exports = (parcelRequire("4HTAf"));




function $da44c4ed1c95cf80$export$a6c2d27607295951(stackParser, ex) {
    const frames = $da44c4ed1c95cf80$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $da44c4ed1c95cf80$export$2e9ae379995d99e3(ex),
        value: $da44c4ed1c95cf80$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === void 0 && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function $da44c4ed1c95cf80$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $99b79a786cd20e57$exports.getClient)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    const errorFromProp = $da44c4ed1c95cf80$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $99b79a786cd20e57$exports.normalizeToSize)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $da44c4ed1c95cf80$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $99b79a786cd20e57$exports.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $da44c4ed1c95cf80$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $da44c4ed1c95cf80$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $da44c4ed1c95cf80$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $da44c4ed1c95cf80$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
function $da44c4ed1c95cf80$var$parseStackFrames(stackParser, ex) {
    const stacktrace = ex.stacktrace || ex.stack || "";
    const skipLines = $da44c4ed1c95cf80$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $da44c4ed1c95cf80$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch  {}
    return [];
}
const $da44c4ed1c95cf80$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $da44c4ed1c95cf80$var$getSkipFirstStackStringLines(ex) {
    if (ex && $da44c4ed1c95cf80$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
function $da44c4ed1c95cf80$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === "number") return ex.framesToPop;
    return 0;
}
function $da44c4ed1c95cf80$var$isWebAssemblyException(exception) {
    if (typeof WebAssembly !== "undefined" && typeof WebAssembly.Exception !== "undefined") return exception instanceof WebAssembly.Exception;
    else return false;
}
function $da44c4ed1c95cf80$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    if (!name && $da44c4ed1c95cf80$var$isWebAssemblyException(ex)) {
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : "WebAssembly.Exception";
    }
    return name;
}
function $da44c4ed1c95cf80$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($da44c4ed1c95cf80$var$isWebAssemblyException(ex)) {
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return "wasm exception";
    }
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return (0, $99b79a786cd20e57$exports._INTERNAL_enhanceErrorWithSentryInfo)(message.error);
    return (0, $99b79a786cd20e57$exports._INTERNAL_enhanceErrorWithSentryInfo)(ex);
}
function $da44c4ed1c95cf80$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || void 0;
    const event = $da44c4ed1c95cf80$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $99b79a786cd20e57$exports.addExceptionMechanism)(event);
    event.level = "error";
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $99b79a786cd20e57$exports.resolvedSyncPromise)(event);
}
function $da44c4ed1c95cf80$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || void 0;
    const event = $da44c4ed1c95cf80$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $99b79a786cd20e57$exports.resolvedSyncPromise)(event);
}
function $da44c4ed1c95cf80$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $99b79a786cd20e57$exports.isErrorEvent)(exception) && exception.error) {
        const errorEvent = exception;
        return $da44c4ed1c95cf80$var$eventFromError(stackParser, errorEvent.error);
    }
    if ((0, $99b79a786cd20e57$exports.isDOMError)(exception) || (0, $99b79a786cd20e57$exports.isDOMException)(exception)) {
        const domException = exception;
        if ("stack" in exception) {
            event = $da44c4ed1c95cf80$var$eventFromError(stackParser, exception);
            const firstException = event.exception?.values?.[0];
            if (attachStacktrace && syntheticException && firstException && !firstException.stacktrace) {
                const frames = $da44c4ed1c95cf80$var$parseStackFrames(stackParser, syntheticException);
                if (frames.length) {
                    firstException.stacktrace = {
                        frames: frames
                    };
                    (0, $99b79a786cd20e57$exports.addExceptionMechanism)(event, {
                        synthetic: true
                    });
                }
            }
        } else {
            const name = domException.name || ((0, $99b79a786cd20e57$exports.isDOMError)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $da44c4ed1c95cf80$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $99b79a786cd20e57$exports.addExceptionTypeValue)(event, message);
        }
        if ("code" in domException) event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $99b79a786cd20e57$exports.isError)(exception)) return $da44c4ed1c95cf80$var$eventFromError(stackParser, exception);
    if ((0, $99b79a786cd20e57$exports.isPlainObject)(exception) || (0, $99b79a786cd20e57$exports.isEvent)(exception)) {
        const objectException = exception;
        event = $da44c4ed1c95cf80$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $99b79a786cd20e57$exports.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    event = $da44c4ed1c95cf80$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $99b79a786cd20e57$exports.addExceptionTypeValue)(event, `${exception}`, void 0);
    (0, $99b79a786cd20e57$exports.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $da44c4ed1c95cf80$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $da44c4ed1c95cf80$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $99b79a786cd20e57$exports.addExceptionMechanism)(event, {
            synthetic: true
        });
    }
    if ((0, $99b79a786cd20e57$exports.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $da44c4ed1c95cf80$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $99b79a786cd20e57$exports.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    if ((0, $99b79a786cd20e57$exports.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $99b79a786cd20e57$exports.isEvent)(exception)) {
        const className = $da44c4ed1c95cf80$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $da44c4ed1c95cf80$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch  {}
}
function $da44c4ed1c95cf80$var$getErrorPropertyFromObject(obj) {
    return Object.values(obj).find((0, $99b79a786cd20e57$exports.isError));
}



const $c4f894bad0037563$export$56d8a8a25bd48b81 = (0, $99b79a786cd20e57$exports.GLOBAL_OBJ);
let $c4f894bad0037563$var$ignoreOnError = 0;
function $c4f894bad0037563$export$b79738ab10c590b2() {
    return $c4f894bad0037563$var$ignoreOnError > 0;
}
function $c4f894bad0037563$export$1265a142ff5ba165() {
    $c4f894bad0037563$var$ignoreOnError++;
    setTimeout(()=>{
        $c4f894bad0037563$var$ignoreOnError--;
    });
}
function $c4f894bad0037563$export$4997ffc0176396a6(fn, options = {}) {
    function isFunction(fn2) {
        return typeof fn2 === "function";
    }
    if (!isFunction(fn)) return fn;
    try {
        const hasOwnWrapper = Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__");
        if (hasOwnWrapper) {
            const wrapper = fn.__sentry_wrapped__;
            if (typeof wrapper === "function") return wrapper;
            else return fn;
        }
        if ((0, $99b79a786cd20e57$exports.getOriginalFunction)(fn)) return fn;
    } catch  {
        return fn;
    }
    const sentryWrapped = function(...args) {
        (0, $99b79a786cd20e57$exports.GLOBAL_OBJ)._sentryWrappedDepth = ((0, $99b79a786cd20e57$exports.GLOBAL_OBJ)._sentryWrappedDepth || 0) + 1;
        try {
            const wrappedArguments = args.map((arg)=>$c4f894bad0037563$export$4997ffc0176396a6(arg, options));
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $c4f894bad0037563$export$1265a142ff5ba165();
            (0, $99b79a786cd20e57$exports.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $99b79a786cd20e57$exports.addExceptionTypeValue)(event, void 0, void 0);
                        (0, $99b79a786cd20e57$exports.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $99b79a786cd20e57$exports.captureException)(ex);
            });
            throw ex;
        } finally{
            (0, $99b79a786cd20e57$exports.GLOBAL_OBJ)._sentryWrappedDepth = ((0, $99b79a786cd20e57$exports.GLOBAL_OBJ)._sentryWrappedDepth || 0) - 1;
        }
    };
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {}
    (0, $99b79a786cd20e57$exports.markFunctionWrapped)(sentryWrapped, fn);
    (0, $99b79a786cd20e57$exports.addNonEnumerableProperty)(fn, "__sentry_wrapped__", sentryWrapped);
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    } catch  {}
    return sentryWrapped;
}
function $c4f894bad0037563$export$a3c4a8453e8936f0() {
    const url = (0, $99b79a786cd20e57$exports.getLocationHref)();
    const { referrer: referrer } = $c4f894bad0037563$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $c4f894bad0037563$export$56d8a8a25bd48b81.navigator || {};
    const headers = {
        ...referrer && {
            Referer: referrer
        },
        ...userAgent && {
            "User-Agent": userAgent
        }
    };
    const request = {
        url: url,
        headers: headers
    };
    return request;
}


class $cdacc4c56d076bd1$export$1df9218a526d318d extends (0, $99b79a786cd20e57$exports.Client) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = $cdacc4c56d076bd1$export$4e107b20a7f977(options);
        const sdkSource = (0, $c4f894bad0037563$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $99b79a786cd20e57$exports.getSDKSource)();
        (0, $99b79a786cd20e57$exports.applySdkMetadata)(opts, "browser", [
            "browser"
        ], sdkSource);
        super(opts);
        const { userInfo: userInfo } = this.getDataCollectionOptions();
        if (opts._metadata?.sdk) opts._metadata.sdk.settings = {
            // Only allow IP inferral by Relay if the user opted in via dataCollection
            infer_ip: userInfo ? "auto" : "never",
            // purposefully allowing already passed settings to override the default
            ...opts._metadata.sdk.settings
        };
        const { sendClientReports: sendClientReports } = this._options;
        if ((0, $c4f894bad0037563$export$56d8a8a25bd48b81).document) (0, $c4f894bad0037563$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $c4f894bad0037563$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
                if (sendClientReports) this._flushOutcomes();
                queueMicrotask(()=>{
                    this.flush();
                });
            }
        });
        if (userInfo) this.on("beforeSendSession", (0, $99b79a786cd20e57$exports.addAutoIpAddressToSession));
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $da44c4ed1c95cf80$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = "info", hint) {
        return (0, $da44c4ed1c95cf80$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}
function $cdacc4c56d076bd1$export$4e107b20a7f977(optionsArg) {
    return {
        release: typeof __SENTRY_RELEASE__ === "string" ? __SENTRY_RELEASE__ : (0, $c4f894bad0037563$export$56d8a8a25bd48b81).SENTRY_RELEASE?.id,
        // This supports the variable that sentry-webpack-plugin injects
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true,
        ...optionsArg
    };
}



const $b776c95debaa4af0$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;


const $11bf1cb92955813c$export$31499a9cd224b78c = "10.73.0";


const $8ba6f69784fd6ba1$export$f1a6cdb1459e81d1 = globalThis;


function $db00931c27c5ec41$export$19eade501500c6c1() {
    $db00931c27c5ec41$export$c8bfa33e4e8ae492((0, $8ba6f69784fd6ba1$export$f1a6cdb1459e81d1));
    return 0, $8ba6f69784fd6ba1$export$f1a6cdb1459e81d1;
}
function $db00931c27c5ec41$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.version = __SENTRY__.version || (0, $11bf1cb92955813c$export$31499a9cd224b78c);
    return __SENTRY__[0, $11bf1cb92955813c$export$31499a9cd224b78c] = __SENTRY__[0, $11bf1cb92955813c$export$31499a9cd224b78c] || {};
}
function $db00931c27c5ec41$export$7e223ec222791509(name, creator, obj = (0, $8ba6f69784fd6ba1$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $11bf1cb92955813c$export$31499a9cd224b78c] = __SENTRY__[0, $11bf1cb92955813c$export$31499a9cd224b78c] || {};
    return carrier[name] || (carrier[name] = creator());
}




const $b4f23915afcea35b$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
const $b4f23915afcea35b$var$PREFIX = "Sentry Logger ";
const $b4f23915afcea35b$export$77c4ce905194557b = {};
function $b4f23915afcea35b$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $8ba6f69784fd6ba1$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $8ba6f69784fd6ba1$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($b4f23915afcea35b$export$77c4ce905194557b);
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $b4f23915afcea35b$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $b4f23915afcea35b$var$enable() {
    $b4f23915afcea35b$var$_getLoggerSettings().enabled = true;
}
function $b4f23915afcea35b$var$disable() {
    $b4f23915afcea35b$var$_getLoggerSettings().enabled = false;
}
function $b4f23915afcea35b$var$isEnabled() {
    return $b4f23915afcea35b$var$_getLoggerSettings().enabled;
}
function $b4f23915afcea35b$var$log(...args) {
    $b4f23915afcea35b$var$_maybeLog("log", ...args);
}
function $b4f23915afcea35b$var$warn(...args) {
    $b4f23915afcea35b$var$_maybeLog("warn", ...args);
}
function $b4f23915afcea35b$var$error(...args) {
    $b4f23915afcea35b$var$_maybeLog("error", ...args);
}
function $b4f23915afcea35b$var$_maybeLog(level, ...args) {
    if (!(0, $b776c95debaa4af0$export$16a28057038b10ef)) return;
    if ($b4f23915afcea35b$var$isEnabled()) $b4f23915afcea35b$export$cda52e2a8927a2ca(()=>{
        (0, $8ba6f69784fd6ba1$export$f1a6cdb1459e81d1).console[level](`${$b4f23915afcea35b$var$PREFIX}[${level}]:`, ...args);
    });
}
function $b4f23915afcea35b$var$_getLoggerSettings() {
    if (!(0, $b776c95debaa4af0$export$16a28057038b10ef)) return {
        enabled: false
    };
    return (0, $db00931c27c5ec41$export$7e223ec222791509)("loggerSettings", ()=>({
            enabled: false
        }));
}
const $b4f23915afcea35b$export$1c9f709888824e05 = {
    enable: /** Enable logging. */ $b4f23915afcea35b$var$enable,
    disable: /** Disable logging. */ $b4f23915afcea35b$var$disable,
    isEnabled: /** Check if logging is enabled. */ $b4f23915afcea35b$var$isEnabled,
    log: /** Log a message. */ $b4f23915afcea35b$var$log,
    warn: /** Log a warning. */ $b4f23915afcea35b$var$warn,
    error: /** Log an error. */ $b4f23915afcea35b$var$error
};


const $9bc1c3df29e4c429$var$STACKTRACE_FRAME_LIMIT = 50;
const $9bc1c3df29e4c429$export$27c7e15d453fc0ac = "?";
const $9bc1c3df29e4c429$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $9bc1c3df29e4c429$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
function $9bc1c3df29e4c429$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            if (line.length > 1024) line = line.slice(0, 1024);
            const cleanedLine = $9bc1c3df29e4c429$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($9bc1c3df29e4c429$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            if (cleanedLine.includes("Error: ")) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $9bc1c3df29e4c429$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $9bc1c3df29e4c429$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
function $9bc1c3df29e4c429$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $9bc1c3df29e4c429$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
function $9bc1c3df29e4c429$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    if (/sentryWrapped/.test($9bc1c3df29e4c429$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    localStack.reverse();
    if ($9bc1c3df29e4c429$var$STRIP_FRAME_REGEXP.test($9bc1c3df29e4c429$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        if ($9bc1c3df29e4c429$var$STRIP_FRAME_REGEXP.test($9bc1c3df29e4c429$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $9bc1c3df29e4c429$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $9bc1c3df29e4c429$var$getLastStackFrame(localStack).filename,
            function: frame.function || $9bc1c3df29e4c429$export$27c7e15d453fc0ac
        }));
}
function $9bc1c3df29e4c429$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $9bc1c3df29e4c429$var$defaultFunctionName = "<anonymous>";
function $9bc1c3df29e4c429$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $9bc1c3df29e4c429$var$defaultFunctionName;
        return fn.name || $9bc1c3df29e4c429$var$defaultFunctionName;
    } catch  {
        return $9bc1c3df29e4c429$var$defaultFunctionName;
    }
}
function $9bc1c3df29e4c429$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            exception.values.forEach((value)=>{
                if (value.stacktrace.frames) frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return void 0;
        }
    }
    return void 0;
}
function $9bc1c3df29e4c429$export$60c0d6c8e038267a(path) {
    let filename = path?.startsWith("file://") ? path.slice(7) : path;
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}


const $768eb4ec7543092d$var$handlers = {};
const $768eb4ec7543092d$var$instrumented = {};
function $768eb4ec7543092d$export$a4e09611e30da72e(type, handler) {
    $768eb4ec7543092d$var$handlers[type] = $768eb4ec7543092d$var$handlers[type] || [];
    $768eb4ec7543092d$var$handlers[type].push(handler);
    return ()=>{
        const typeHandlers = $768eb4ec7543092d$var$handlers[type];
        if (typeHandlers) {
            const index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
function $768eb4ec7543092d$export$b17eab759a1cb5fe() {
    Object.keys($768eb4ec7543092d$var$handlers).forEach((key)=>{
        $768eb4ec7543092d$var$handlers[key] = void 0;
    });
}
function $768eb4ec7543092d$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$768eb4ec7543092d$var$instrumented[type]) {
        $768eb4ec7543092d$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $b4f23915afcea35b$export$1c9f709888824e05).error(`Error while instrumenting ${type}`, e);
        }
    }
}
function $768eb4ec7543092d$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $768eb4ec7543092d$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $b4f23915afcea35b$export$1c9f709888824e05).error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${(0, $9bc1c3df29e4c429$export$aad197c7121a6651)(handler)}
Error:`, e);
    }
}



const $318f9d4f4df46a08$var$objectToString = Object.prototype.toString;
function $318f9d4f4df46a08$export$e6127cc7fe7395c3(wat) {
    switch($318f9d4f4df46a08$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $318f9d4f4df46a08$export$49034edbe6b62415(wat, Error);
    }
}
function $318f9d4f4df46a08$var$isBuiltin(wat, className) {
    return $318f9d4f4df46a08$var$objectToString.call(wat) === `[object ${className}]`;
}
function $318f9d4f4df46a08$export$9f9636d330b71954(wat) {
    return $318f9d4f4df46a08$var$isBuiltin(wat, "ErrorEvent");
}
function $318f9d4f4df46a08$export$ef9e2056653f0c8e(wat) {
    return $318f9d4f4df46a08$var$isBuiltin(wat, "DOMError");
}
function $318f9d4f4df46a08$export$12e869b2a583f783(wat) {
    return $318f9d4f4df46a08$var$isBuiltin(wat, "DOMException");
}
function $318f9d4f4df46a08$export$844ec244b1367d54(wat) {
    return $318f9d4f4df46a08$var$isBuiltin(wat, "String");
}
function $318f9d4f4df46a08$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
function $318f9d4f4df46a08$export$c3825b437cbdea5c(wat) {
    return wat === null || $318f9d4f4df46a08$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
function $318f9d4f4df46a08$export$53b83ca8eaab0383(wat) {
    return $318f9d4f4df46a08$var$isBuiltin(wat, "Object");
}
function $318f9d4f4df46a08$export$c10d0b04eaa80a43(wat) {
    return typeof wat === "object" && wat !== null;
}
function $318f9d4f4df46a08$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $318f9d4f4df46a08$export$49034edbe6b62415(wat, Event);
}
function $318f9d4f4df46a08$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $318f9d4f4df46a08$export$49034edbe6b62415(wat, Element);
}
function $318f9d4f4df46a08$export$49841c62b9eff15(wat) {
    return $318f9d4f4df46a08$var$isBuiltin(wat, "RegExp");
}
function $318f9d4f4df46a08$export$f5b060c2914b97c8(wat) {
    return Boolean(wat?.then && typeof wat.then === "function");
}
function $318f9d4f4df46a08$export$bc2894c7158efbac(wat) {
    return $318f9d4f4df46a08$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $318f9d4f4df46a08$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
function $318f9d4f4df46a08$export$7916fad0ebc23f48(wat) {
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
function $318f9d4f4df46a08$export$6d3d1f317d7cda57(request) {
    return typeof Request !== "undefined" && $318f9d4f4df46a08$export$49034edbe6b62415(request, Request);
}


function $5947e8be75daee48$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    if (typeof wrapped === "function") $5947e8be75daee48$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $b4f23915afcea35b$export$1c9f709888824e05).log(`Failed to replace method "${name}" in object`, source);
    }
}
function $5947e8be75daee48$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch  {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $b4f23915afcea35b$export$1c9f709888824e05).log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
    }
}
function $5947e8be75daee48$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $5947e8be75daee48$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch  {}
}
function $5947e8be75daee48$export$e00416b3cd122575(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== "function") throw new Error(`Cannot wrap method: ${field} is not a function`);
    if ($5947e8be75daee48$export$e6cc1e135e2092e5(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    $5947e8be75daee48$export$5c1499e2e5d010ae(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
function $5947e8be75daee48$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $5947e8be75daee48$export$62ff257738bf57f5(value) {
    if ((0, $318f9d4f4df46a08$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$5947e8be75daee48$var$getOwnProperties(value)
    };
    if ((0, $318f9d4f4df46a08$export$9671ea99bd126ace)(value)) {
        const { type: type, target: target, currentTarget: currentTarget, detail: detail } = value;
        return {
            type: type,
            target: target,
            currentTarget: currentTarget,
            ...detail ? {
                detail: detail
            } : {},
            ...$5947e8be75daee48$var$getOwnProperties(value)
        };
    }
    return value;
}
function $5947e8be75daee48$var$getOwnProperties(obj) {
    if ((0, $318f9d4f4df46a08$export$c10d0b04eaa80a43)(obj)) return Object.fromEntries(Object.entries(obj));
    return {};
}
function $5947e8be75daee48$export$b0244d5063c0b61b(exception) {
    const keys = Object.keys($5947e8be75daee48$export$62ff257738bf57f5(exception));
    keys.sort();
    return !keys[0] ? "[object has no keys]" : keys.join(", ");
}
function $5947e8be75daee48$export$d25f2688db1bb433(inputValue) {
    const memoizationMap = /* @__PURE__ */ new Map();
    return $5947e8be75daee48$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $5947e8be75daee48$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== void 0) return memoVal;
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($5947e8be75daee48$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($5947e8be75daee48$var$isPojo(inputValue)) {
        const returnValue = {};
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== void 0) returnValue[key] = $5947e8be75daee48$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    return inputValue;
}
function $5947e8be75daee48$var$isPojo(input) {
    const constructor = input.constructor;
    return constructor === Object || constructor === void 0;
}
function $5947e8be75daee48$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == void 0:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $318f9d4f4df46a08$export$c3825b437cbdea5c)(wat):
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}



let $9728f2305ef485df$var$RESOLVED_RUNNER;
function $9728f2305ef485df$export$ff239213cb80e2da(cb) {
    if ($9728f2305ef485df$var$RESOLVED_RUNNER !== void 0) return $9728f2305ef485df$var$RESOLVED_RUNNER ? $9728f2305ef485df$var$RESOLVED_RUNNER(cb) : cb();
    const sym = /* @__PURE__ */ Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__");
    const globalWithSymbol = (0, $8ba6f69784fd6ba1$export$f1a6cdb1459e81d1);
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === "function") {
        $9728f2305ef485df$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $9728f2305ef485df$var$RESOLVED_RUNNER(cb);
    }
    $9728f2305ef485df$var$RESOLVED_RUNNER = null;
    return cb();
}
function $9728f2305ef485df$export$9869d72de32a3917() {
    return $9728f2305ef485df$export$ff239213cb80e2da(()=>Math.random());
}
function $9728f2305ef485df$export$65b1bada40c91b34() {
    return $9728f2305ef485df$export$ff239213cb80e2da(()=>Date.now());
}




const $5f9801bdc36a685d$var$SENTRY_SKIP_NORMALIZATION = /* @__PURE__ */ Symbol.for("sentry.skipNormalization");
const $5f9801bdc36a685d$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH = /* @__PURE__ */ Symbol.for("sentry.overrideNormalizationDepth");
function $5f9801bdc36a685d$export$280812de8e91ea53(obj) {
    (0, $5947e8be75daee48$export$e73679ffaf56810e)(obj, $5f9801bdc36a685d$var$SENTRY_SKIP_NORMALIZATION, true);
}
function $5f9801bdc36a685d$export$610d1422c4bdc4c1(obj, depth) {
    (0, $5947e8be75daee48$export$e73679ffaf56810e)(obj, $5f9801bdc36a685d$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
function $5f9801bdc36a685d$export$c8d26b7b28f926c7(value) {
    return Boolean(value[$5f9801bdc36a685d$var$SENTRY_SKIP_NORMALIZATION]);
}
function $5f9801bdc36a685d$export$fe95a19841c4b155(value) {
    const v = value[$5f9801bdc36a685d$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
    return typeof v === "number" ? v : void 0;
}




let $9125ee0593b99e14$var$stringifier;
function $9125ee0593b99e14$export$575c40989754ba4d(newStringifier) {
    $9125ee0593b99e14$var$stringifier = newStringifier;
}
function $9125ee0593b99e14$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        return $9125ee0593b99e14$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
function $9125ee0593b99e14$export$23fbbb20bed71033(object, depth = 3, maxSize = 102400) {
    const normalized = $9125ee0593b99e14$export$a3295358bff77e(object, depth);
    if ($9125ee0593b99e14$var$jsonSize(normalized) > maxSize) return $9125ee0593b99e14$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
function $9125ee0593b99e14$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $9125ee0593b99e14$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $9125ee0593b99e14$export$a110e5bc79f44a84(key, value);
    if (!stringified.startsWith("[object ")) return stringified;
    if ((0, $5f9801bdc36a685d$export$c8d26b7b28f926c7)(value)) return value;
    const overrideDepth = (0, $5f9801bdc36a685d$export$fe95a19841c4b155)(value);
    const remainingDepth = overrideDepth !== void 0 ? overrideDepth : depth;
    if (remainingDepth === 0) return stringified.replace("object ", "");
    if (memoize(value)) return "[Circular ~]";
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        return $9125ee0593b99e14$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {}
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    const visitable = (0, $5947e8be75daee48$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $9125ee0593b99e14$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    unmemoize(value);
    return normalized;
}
function $9125ee0593b99e14$export$a110e5bc79f44a84(key, value) {
    try {
        if ($9125ee0593b99e14$var$stringifier) {
            const stringified = $9125ee0593b99e14$var$stringifier(value);
            if (stringified) return stringified;
        }
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${(0, $9bc1c3df29e4c429$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        const objName = $9125ee0593b99e14$var$getConstructorName(value);
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
function $9125ee0593b99e14$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}
function $9125ee0593b99e14$var$utf8Length(value) {
    return ~-encodeURI(value).split(/%..|./).length;
}
function $9125ee0593b99e14$var$jsonSize(value) {
    return $9125ee0593b99e14$var$utf8Length(JSON.stringify(value));
}
function $9125ee0593b99e14$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath.replace(/\\/g, "/").replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {}
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "").replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
function $9125ee0593b99e14$var$memoBuilder() {
    const inner = /* @__PURE__ */ new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}


function $a4e9d6ee49d302a1$export$fac44ee5b035f737(value, fallback = "[unserializable]") {
    if (typeof value === "string") return value;
    try {
        return JSON.stringify(value);
    } catch  {
        return typeof fallback === "function" ? fallback(value) : fallback;
    }
}
function $a4e9d6ee49d302a1$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
function $a4e9d6ee49d302a1$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
function $a4e9d6ee49d302a1$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        if ((0, $318f9d4f4df46a08$export$c3825b437cbdea5c)(value)) output.push(String(value));
        else if (value instanceof Error) output.push(value.message ? `${value.name}: ${value.message}` : value.name);
        else output.push((0, $9125ee0593b99e14$export$a110e5bc79f44a84)(void 0, value));
    }
    return output.join(delimiter);
}
function $a4e9d6ee49d302a1$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $318f9d4f4df46a08$export$844ec244b1367d54)(value)) return false;
    if ((0, $318f9d4f4df46a08$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $318f9d4f4df46a08$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === "function") return pattern(value);
    return false;
}
function $a4e9d6ee49d302a1$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    for (const pattern of patterns){
        if ($a4e9d6ee49d302a1$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch)) return true;
    }
    return false;
}



function $54571dc039e84828$var$getCrypto() {
    const gbl = (0, $8ba6f69784fd6ba1$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
let $54571dc039e84828$var$emptyUuid;
function $54571dc039e84828$var$getRandomByte() {
    return (0, $9728f2305ef485df$export$9869d72de32a3917)() * 16;
}
function $54571dc039e84828$export$19f53698e68b2496(crypto = $54571dc039e84828$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) return (0, $9728f2305ef485df$export$ff239213cb80e2da)(()=>crypto.randomUUID()).replace(/-/g, "");
    } catch  {}
    if (!$54571dc039e84828$var$emptyUuid) $54571dc039e84828$var$emptyUuid = "10000000100040008000100000000000";
    return $54571dc039e84828$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($54571dc039e84828$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $54571dc039e84828$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
function $54571dc039e84828$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $54571dc039e84828$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
function $54571dc039e84828$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
function $54571dc039e84828$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $54571dc039e84828$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
const $54571dc039e84828$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $54571dc039e84828$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
function $54571dc039e84828$export$d364f2020ab30578(input) {
    const match = input.match($54571dc039e84828$var$SEMVER_REGEXP) || [];
    const major = $54571dc039e84828$var$_parseInt(match[1]);
    const minor = $54571dc039e84828$var$_parseInt(match[2]);
    const patch = $54571dc039e84828$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? void 0 : major,
        minor: isNaN(minor) ? void 0 : minor,
        patch: isNaN(patch) ? void 0 : patch,
        prerelease: match[4]
    };
}
function $54571dc039e84828$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    if (frame.lineno === void 0) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $a4e9d6ee49d302a1$export$4215662d762d6f9d)(line, 0));
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    frame.context_line = (0, $a4e9d6ee49d302a1$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $a4e9d6ee49d302a1$export$4215662d762d6f9d)(line, 0));
}
function $54571dc039e84828$export$6de4ffac6a2f1098(exception) {
    if ($54571dc039e84828$export$4a38e013f66150b(exception)) return true;
    try {
        (0, $5947e8be75daee48$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch  {}
    return false;
}
function $54571dc039e84828$export$4a38e013f66150b(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {}
}



const $55811081a41de9b1$export$56d8a8a25bd48b81 = (0, $8ba6f69784fd6ba1$export$f1a6cdb1459e81d1);


const $52ac64c3600b557b$var$DEBOUNCE_DURATION = 1e3;
let $52ac64c3600b557b$var$debounceTimerID;
let $52ac64c3600b557b$var$lastCapturedEventType;
let $52ac64c3600b557b$var$lastCapturedEventTargetId;
function $52ac64c3600b557b$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $768eb4ec7543092d$export$a4e09611e30da72e)(type, handler);
    (0, $768eb4ec7543092d$export$e18d6c5462c01368)(type, $52ac64c3600b557b$export$3014bbf0af0e1d4a);
}
function $52ac64c3600b557b$export$3014bbf0af0e1d4a() {
    if (!(0, $55811081a41de9b1$export$56d8a8a25bd48b81).document) return;
    const triggerDOMHandler = (0, $768eb4ec7543092d$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $52ac64c3600b557b$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $55811081a41de9b1$export$56d8a8a25bd48b81).document.addEventListener("click", globalDOMEventHandler, false);
    (0, $55811081a41de9b1$export$56d8a8a25bd48b81).document.addEventListener("keypress", globalDOMEventHandler, false);
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        const globalObject = (0, $55811081a41de9b1$export$56d8a8a25bd48b81);
        const proto = globalObject[target]?.prototype;
        if (!proto?.hasOwnProperty?.("addEventListener")) return;
        (0, $5947e8be75daee48$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $52ac64c3600b557b$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch  {}
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $5947e8be75daee48$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = void 0;
                            delete handlers[type];
                        }
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch  {}
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
function $52ac64c3600b557b$var$isSimilarToLastCapturedEvent(event) {
    if (event.type !== $52ac64c3600b557b$var$lastCapturedEventType) return false;
    try {
        if (!event.target || event.target._sentryId !== $52ac64c3600b557b$var$lastCapturedEventTargetId) return false;
    } catch  {}
    return true;
}
function $52ac64c3600b557b$var$shouldSkipDOMEvent(eventType, target) {
    if (eventType !== "keypress") return false;
    if (!target?.tagName) return true;
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
function $52ac64c3600b557b$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        if (!event || event["_sentryCaptured"]) return;
        const target = $52ac64c3600b557b$var$getEventTarget(event);
        if ($52ac64c3600b557b$var$shouldSkipDOMEvent(event.type, target)) return;
        (0, $5947e8be75daee48$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) (0, $5947e8be75daee48$export$e73679ffaf56810e)(target, "_sentryId", (0, $54571dc039e84828$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        if (!$52ac64c3600b557b$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $52ac64c3600b557b$var$lastCapturedEventType = event.type;
            $52ac64c3600b557b$var$lastCapturedEventTargetId = target ? target._sentryId : void 0;
        }
        clearTimeout($52ac64c3600b557b$var$debounceTimerID);
        $52ac64c3600b557b$var$debounceTimerID = (0, $55811081a41de9b1$export$56d8a8a25bd48b81).setTimeout(()=>{
            $52ac64c3600b557b$var$lastCapturedEventTargetId = void 0;
            $52ac64c3600b557b$var$lastCapturedEventType = void 0;
        }, $52ac64c3600b557b$var$DEBOUNCE_DURATION);
    };
}
function $52ac64c3600b557b$var$getEventTarget(event) {
    try {
        return event.target;
    } catch  {
        return null;
    }
}




const $c4fd0f5da06af62e$var$WINDOW = (0, $8ba6f69784fd6ba1$export$f1a6cdb1459e81d1);
function $c4fd0f5da06af62e$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch  {
        return false;
    }
}
function $c4fd0f5da06af62e$export$1c08bd1a7eb3c472() {
    try {
        new DOMError("");
        return true;
    } catch  {
        return false;
    }
}
function $c4fd0f5da06af62e$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch  {
        return false;
    }
}
function $c4fd0f5da06af62e$export$67fc34576016d6ec() {
    return "history" in $c4fd0f5da06af62e$var$WINDOW && !!$c4fd0f5da06af62e$var$WINDOW.history;
}
const $c4fd0f5da06af62e$export$edf3cb81fd7d2a3e = $c4fd0f5da06af62e$var$_isFetchSupported;
function $c4fd0f5da06af62e$var$_isFetchSupported() {
    if (!("fetch" in $c4fd0f5da06af62e$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("data:,");
        new Response();
        return true;
    } catch  {
        return false;
    }
}
function $c4fd0f5da06af62e$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $c4fd0f5da06af62e$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$c4fd0f5da06af62e$var$_isFetchSupported()) return false;
    if ($c4fd0f5da06af62e$export$d5f608b368e73f38($c4fd0f5da06af62e$var$WINDOW.fetch)) return true;
    let result = false;
    const doc = $c4fd0f5da06af62e$var$WINDOW.document;
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) result = $c4fd0f5da06af62e$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $b4f23915afcea35b$export$1c9f709888824e05).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function $c4fd0f5da06af62e$export$531055a6c684a70a() {
    return "ReportingObserver" in $c4fd0f5da06af62e$var$WINDOW;
}
function $c4fd0f5da06af62e$export$2d308b428295192f() {
    if (!$c4fd0f5da06af62e$var$_isFetchSupported()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch  {
        return false;
    }
}



let $9658afb47e9e02d1$var$lastHref;
function $9658afb47e9e02d1$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $768eb4ec7543092d$export$a4e09611e30da72e)(type, handler);
    (0, $768eb4ec7543092d$export$e18d6c5462c01368)(type, $9658afb47e9e02d1$export$d9b613a6254a184e);
}
function $9658afb47e9e02d1$export$d9b613a6254a184e() {
    (0, $55811081a41de9b1$export$56d8a8a25bd48b81).addEventListener("popstate", ()=>{
        const to = (0, $55811081a41de9b1$export$56d8a8a25bd48b81).location.href;
        const from = $9658afb47e9e02d1$var$lastHref;
        $9658afb47e9e02d1$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $768eb4ec7543092d$export$b18c893e424d3127)("history", handlerData);
    });
    if (!(0, $c4fd0f5da06af62e$export$67fc34576016d6ec)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : void 0;
            if (url) {
                const from = $9658afb47e9e02d1$var$lastHref;
                const to = $9658afb47e9e02d1$var$getAbsoluteUrl(String(url));
                $9658afb47e9e02d1$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $768eb4ec7543092d$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $5947e8be75daee48$export$9563e054e6f787fb)((0, $55811081a41de9b1$export$56d8a8a25bd48b81).history, "pushState", historyReplacementFunction);
    (0, $5947e8be75daee48$export$9563e054e6f787fb)((0, $55811081a41de9b1$export$56d8a8a25bd48b81).history, "replaceState", historyReplacementFunction);
}
function $9658afb47e9e02d1$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $55811081a41de9b1$export$56d8a8a25bd48b81).location.origin);
        return url.toString();
    } catch  {
        return urlOrPath;
    }
}



const $e9e0be11d1a44c19$var$ONE_SECOND_IN_MS = 1e3;
function $e9e0be11d1a44c19$export$7740643b9eeaf0c4() {
    return (0, $9728f2305ef485df$export$65b1bada40c91b34)() / $e9e0be11d1a44c19$var$ONE_SECOND_IN_MS;
}
function $e9e0be11d1a44c19$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $8ba6f69784fd6ba1$export$f1a6cdb1459e81d1);
    if (!performance?.now || !performance.timeOrigin) return $e9e0be11d1a44c19$export$7740643b9eeaf0c4;
    const timeOrigin = performance.timeOrigin;
    return ()=>{
        return (timeOrigin + (0, $9728f2305ef485df$export$ff239213cb80e2da)(()=>performance.now())) / $e9e0be11d1a44c19$var$ONE_SECOND_IN_MS;
    };
}
let $e9e0be11d1a44c19$var$_cachedTimestampInSeconds;
function $e9e0be11d1a44c19$export$ee52dced521e3e18() {
    const func = $e9e0be11d1a44c19$var$_cachedTimestampInSeconds ?? ($e9e0be11d1a44c19$var$_cachedTimestampInSeconds = $e9e0be11d1a44c19$var$createUnixTimestampInSecondsFunc());
    return func();
}
let $e9e0be11d1a44c19$var$cachedTimeOrigin = null;
function $e9e0be11d1a44c19$var$getBrowserTimeOrigin() {
    const { performance: performance } = (0, $8ba6f69784fd6ba1$export$f1a6cdb1459e81d1);
    if (!performance?.now) return void 0;
    const threshold = 3e5;
    const performanceNow = (0, $9728f2305ef485df$export$ff239213cb80e2da)(()=>performance.now());
    const dateNow = (0, $9728f2305ef485df$export$65b1bada40c91b34)();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === "number") {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    const navigationStart = performance.timing?.navigationStart;
    if (typeof navigationStart === "number") {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    return dateNow - performanceNow;
}
function $e9e0be11d1a44c19$export$baf075a948ffc0bf() {
    if ($e9e0be11d1a44c19$var$cachedTimeOrigin === null) $e9e0be11d1a44c19$var$cachedTimeOrigin = $e9e0be11d1a44c19$var$getBrowserTimeOrigin();
    return $e9e0be11d1a44c19$var$cachedTimeOrigin;
}



const $ba038b200e2f1b21$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
function $ba038b200e2f1b21$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $768eb4ec7543092d$export$a4e09611e30da72e)(type, handler);
    (0, $768eb4ec7543092d$export$e18d6c5462c01368)(type, $ba038b200e2f1b21$export$c67d533bf77cbf54);
}
function $ba038b200e2f1b21$export$c67d533bf77cbf54() {
    if (!(0, $55811081a41de9b1$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            const virtualError = new Error();
            const startTimestamp = (0, $e9e0be11d1a44c19$export$ee52dced521e3e18)() * 1e3;
            const method = (0, $318f9d4f4df46a08$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : void 0;
            const url = $ba038b200e2f1b21$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$ba038b200e2f1b21$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            if (method === "POST" && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                const xhrInfo = xhrOpenThisArg[$ba038b200e2f1b21$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch  {}
                    const handlerData = {
                        endTimestamp: (0, $e9e0be11d1a44c19$export$ee52dced521e3e18)() * 1e3,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $768eb4ec7543092d$export$b18c893e424d3127)("xhr", handlerData);
                    xhrOpenThisArg.removeEventListener("readystatechange", onreadystatechangeHandler);
                }
            };
            if ("onreadystatechange" in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === "function") xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener("readystatechange", onreadystatechangeHandler);
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$ba038b200e2f1b21$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $318f9d4f4df46a08$export$844ec244b1367d54)(header) && (0, $318f9d4f4df46a08$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$ba038b200e2f1b21$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== void 0) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $e9e0be11d1a44c19$export$ee52dced521e3e18)() * 1e3,
                xhr: sendThisArg
            };
            (0, $768eb4ec7543092d$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
function $ba038b200e2f1b21$var$parseXhrUrlArg(url) {
    if ((0, $318f9d4f4df46a08$export$844ec244b1367d54)(url)) return url;
    try {
        return url.toString();
    } catch  {}
    return void 0;
}


const $d8fc20c6284d49a2$var$DEFAULT_MAX_STRING_LENGTH = 80;
const $d8fc20c6284d49a2$var$accessors = {};
try {
    if (typeof Node !== "undefined") $d8fc20c6284d49a2$var$accessors.parentNode = Object.getOwnPropertyDescriptor(Node.prototype, "parentNode").get;
    if (typeof Element !== "undefined") {
        $d8fc20c6284d49a2$var$accessors.tagName = Object.getOwnPropertyDescriptor(Element.prototype, "tagName").get;
        $d8fc20c6284d49a2$var$accessors.id = Object.getOwnPropertyDescriptor(Element.prototype, "id").get;
        $d8fc20c6284d49a2$var$accessors.className = Object.getOwnPropertyDescriptor(Element.prototype, "className").get;
        $d8fc20c6284d49a2$var$accessors.getAttribute = Element.prototype.getAttribute;
    }
    if (typeof HTMLElement !== "undefined") $d8fc20c6284d49a2$var$accessors.dataset = Object.getOwnPropertyDescriptor(HTMLElement.prototype, "dataset").get;
} catch  {}
function $d8fc20c6284d49a2$var$_safeRead(el, prop, arg) {
    const fn = $d8fc20c6284d49a2$var$accessors[prop];
    if (fn) try {
        return fn.call(el, arg);
    } catch  {}
    const val = el[prop];
    return typeof val === "function" ? val.call(el, arg) : val;
}
function $d8fc20c6284d49a2$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $d8fc20c6284d49a2$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $d8fc20c6284d49a2$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = $d8fc20c6284d49a2$var$_safeRead(currentElem, "parentNode");
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
function $d8fc20c6284d49a2$var$_htmlElementAsString(el, keyAttrs) {
    const out = [];
    const tagName = $d8fc20c6284d49a2$var$_safeRead(el, "tagName");
    if (!tagName) return "";
    if (typeof HTMLElement !== "undefined") {
        if (el instanceof HTMLElement) {
            const dataset = $d8fc20c6284d49a2$var$_safeRead(el, "dataset");
            if (dataset) {
                if (dataset["sentryComponent"]) return dataset["sentryComponent"];
                if (dataset["sentryElement"]) return dataset["sentryElement"];
            }
        }
    }
    out.push(tagName.toLowerCase());
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>$d8fc20c6284d49a2$var$_safeRead(el, "getAttribute", keyAttr)).map((keyAttr)=>[
            keyAttr,
            $d8fc20c6284d49a2$var$_safeRead(el, "getAttribute", keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        const id = $d8fc20c6284d49a2$var$_safeRead(el, "id");
        if (id) out.push(`#${id}`);
        const className = $d8fc20c6284d49a2$var$_safeRead(el, "className");
        if (className && (0, $318f9d4f4df46a08$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = $d8fc20c6284d49a2$var$_safeRead(el, "getAttribute", k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}


const $73d341bc35cc3264$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



const $c47744e8a60c3091$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $c47744e8a60c3091$var$INTEGRATION_NAME = "Breadcrumbs";
const $c47744e8a60c3091$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $c47744e8a60c3091$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.console) (0, $99b79a786cd20e57$exports.addConsoleInstrumentationHandler)($c47744e8a60c3091$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $52ac64c3600b557b$export$5aeffd3db2cf9df7)($c47744e8a60c3091$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $ba038b200e2f1b21$export$26ace48dd54c9aea)($c47744e8a60c3091$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $99b79a786cd20e57$exports.addFetchInstrumentationHandler)($c47744e8a60c3091$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $9658afb47e9e02d1$export$3f18c56c58114e75)($c47744e8a60c3091$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on("beforeSendEvent", $c47744e8a60c3091$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $c47744e8a60c3091$export$c079d904b326663a = (0, $99b79a786cd20e57$exports.defineIntegration)($c47744e8a60c3091$var$_breadcrumbsIntegration);
function $c47744e8a60c3091$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $99b79a786cd20e57$exports.getClient)() !== client) return;
        (0, $99b79a786cd20e57$exports.addBreadcrumb)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $99b79a786cd20e57$exports.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
function $c47744e8a60c3091$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $99b79a786cd20e57$exports.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : void 0;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : void 0;
        if (maxStringLength && maxStringLength > $c47744e8a60c3091$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $73d341bc35cc3264$export$16a28057038b10ef) && (0, $99b79a786cd20e57$exports.debug).warn(`\`dom.maxStringLength\` cannot exceed ${$c47744e8a60c3091$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$c47744e8a60c3091$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $c47744e8a60c3091$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        try {
            const event = handlerData.event;
            const element = $c47744e8a60c3091$var$_isEvent(event) ? event.target : event;
            target = (0, $d8fc20c6284d49a2$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $99b79a786cd20e57$exports.getComponentName)(element);
        } catch  {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $99b79a786cd20e57$exports.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
function $c47744e8a60c3091$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $99b79a786cd20e57$exports.getClient)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $99b79a786cd20e57$exports.severityLevelFromString)(handlerData.level),
            message: (0, $99b79a786cd20e57$exports.safeJoin)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $99b79a786cd20e57$exports.safeJoin)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else return;
        }
        (0, $99b79a786cd20e57$exports.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
function $c47744e8a60c3091$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $99b79a786cd20e57$exports.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $ba038b200e2f1b21$export$55b6bb1e45c6cf59];
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: "xhr",
            data: data,
            type: "http",
            level: (0, $99b79a786cd20e57$exports.getBreadcrumbLogLevelFromHttpStatusCode)(status_code)
        };
        client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
        (0, $99b79a786cd20e57$exports.addBreadcrumb)(breadcrumb, hint);
    };
}
function $c47744e8a60c3091$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $99b79a786cd20e57$exports.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") return;
        if (handlerData.error) {
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: handlerData.fetchData,
                level: "error",
                type: "http"
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $99b79a786cd20e57$exports.addBreadcrumb)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: data,
                type: "http",
                level: (0, $99b79a786cd20e57$exports.getBreadcrumbLogLevelFromHttpStatusCode)(data.status_code)
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $99b79a786cd20e57$exports.addBreadcrumb)(breadcrumb, hint);
        }
    };
}
function $c47744e8a60c3091$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $99b79a786cd20e57$exports.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $99b79a786cd20e57$exports.parseUrl)((0, $c4f894bad0037563$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $99b79a786cd20e57$exports.parseUrl)(from) : void 0;
        const parsedTo = (0, $99b79a786cd20e57$exports.parseUrl)(to);
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $99b79a786cd20e57$exports.addBreadcrumb)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $c47744e8a60c3091$var$_isEvent(event) {
    return !!event && !!event.target;
}




const $415c37fe32b0feca$var$DEFAULT_EVENT_TARGET = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,BroadcastChannel,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,SharedWorker,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");
const $415c37fe32b0feca$var$INTEGRATION_NAME = "BrowserApiErrors";
const $415c37fe32b0feca$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false,
        ...options
    };
    return {
        name: $415c37fe32b0feca$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $99b79a786cd20e57$exports.fill)((0, $c4f894bad0037563$export$56d8a8a25bd48b81), "setTimeout", $415c37fe32b0feca$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $99b79a786cd20e57$exports.fill)((0, $c4f894bad0037563$export$56d8a8a25bd48b81), "setInterval", $415c37fe32b0feca$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $99b79a786cd20e57$exports.fill)((0, $c4f894bad0037563$export$56d8a8a25bd48b81), "requestAnimationFrame", $415c37fe32b0feca$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $c4f894bad0037563$export$56d8a8a25bd48b81)) (0, $99b79a786cd20e57$exports.fill)(XMLHttpRequest.prototype, "send", $415c37fe32b0feca$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $415c37fe32b0feca$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$415c37fe32b0feca$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
const $415c37fe32b0feca$export$59bfe9f1c76150e = (0, $99b79a786cd20e57$exports.defineIntegration)($415c37fe32b0feca$var$_browserApiErrorsIntegration);
function $415c37fe32b0feca$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $c4f894bad0037563$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                handled: false,
                type: `auto.browser.browserapierrors.${(0, $99b79a786cd20e57$exports.getFunctionName)(original)}`
            }
        });
        return original.apply(this, args);
    };
}
function $415c37fe32b0feca$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $c4f894bad0037563$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        handler: (0, $99b79a786cd20e57$exports.getFunctionName)(original)
                    },
                    handled: false,
                    type: "auto.browser.browserapierrors.requestAnimationFrame"
                }
            })
        ]);
    };
}
function $415c37fe32b0feca$var$_wrapXHR(originalSend) {
    return function(...args) {
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") (0, $99b79a786cd20e57$exports.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            handler: (0, $99b79a786cd20e57$exports.getFunctionName)(original)
                        },
                        handled: false,
                        type: `auto.browser.browserapierrors.xhr.${prop}`
                    }
                };
                const originalFunction = (0, $99b79a786cd20e57$exports.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $99b79a786cd20e57$exports.getFunctionName)(originalFunction);
                return (0, $c4f894bad0037563$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $415c37fe32b0feca$var$_wrapEventTarget(target, integrationOptions) {
    const globalObject = (0, $c4f894bad0037563$export$56d8a8a25bd48b81);
    const proto = globalObject[target]?.prototype;
    if (!proto?.hasOwnProperty?.("addEventListener")) return;
    (0, $99b79a786cd20e57$exports.fill)(proto, "addEventListener", function(original) {
        return function(eventName, fn, options) {
            try {
                if ($415c37fe32b0feca$var$isEventListenerObject(fn)) fn.handleEvent = (0, $c4f894bad0037563$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            handler: (0, $99b79a786cd20e57$exports.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.handleEvent"
                    }
                });
            } catch  {}
            if (integrationOptions.unregisterOriginalCallbacks) $415c37fe32b0feca$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $c4f894bad0037563$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            handler: (0, $99b79a786cd20e57$exports.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.addEventListener"
                    }
                }),
                options
            ]);
        };
    });
    (0, $99b79a786cd20e57$exports.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            try {
                if (Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__")) {
                    const originalEventHandler = fn.__sentry_wrapped__;
                    if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
                }
            } catch  {}
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $415c37fe32b0feca$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === "function";
}
function $415c37fe32b0feca$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === "object" && "removeEventListener" in target && typeof target.removeEventListener === "function") target.removeEventListener(eventName, fn);
}





function $f26f97ab02848856$export$26d3d892edc56833(type, listener, options) {
    if ((0, $55811081a41de9b1$export$56d8a8a25bd48b81).document) (0, $55811081a41de9b1$export$56d8a8a25bd48b81).addEventListener(type, listener, options);
}
function $f26f97ab02848856$export$324d7b4b46528191(type, listener, options) {
    if ((0, $55811081a41de9b1$export$56d8a8a25bd48b81).document) (0, $55811081a41de9b1$export$56d8a8a25bd48b81).removeEventListener(type, listener, options);
}


const $bb0885b3fbf58d3c$export$b841d51e31c12bab = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};


const $1655bae6c468185a$export$d3314d5863fc1fef = (cb)=>{
    const rIC = (0, $55811081a41de9b1$export$56d8a8a25bd48b81).requestIdleCallback || (0, $55811081a41de9b1$export$56d8a8a25bd48b81).setTimeout;
    if ((0, $55811081a41de9b1$export$56d8a8a25bd48b81).document?.visibilityState === "hidden") cb();
    else {
        cb = (0, $bb0885b3fbf58d3c$export$b841d51e31c12bab)(cb);
        (0, $f26f97ab02848856$export$26d3d892edc56833)("visibilitychange", cb, {
            once: true,
            capture: true
        });
        (0, $f26f97ab02848856$export$26d3d892edc56833)("pagehide", cb, {
            once: true,
            capture: true
        });
        rIC(()=>{
            cb();
            (0, $f26f97ab02848856$export$324d7b4b46528191)("visibilitychange", cb, {
                capture: true
            });
            (0, $f26f97ab02848856$export$324d7b4b46528191)("pagehide", cb, {
                capture: true
            });
        });
    }
};




const $8805b82778feb647$export$1baa7880e357371c = (0, $99b79a786cd20e57$exports.defineIntegration)((options = {})=>{
    const lifecycle = options.lifecycle ?? "route";
    return {
        name: "BrowserSession",
        setupOnce () {
            if (typeof (0, $c4f894bad0037563$export$56d8a8a25bd48b81).document === "undefined") {
                (0, $73d341bc35cc3264$export$16a28057038b10ef) && (0, $99b79a786cd20e57$exports.debug).warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
                return;
            }
            (0, $99b79a786cd20e57$exports.startSession)({
                ignoreDuration: true
            });
            let initialSessionSent = false;
            (0, $1655bae6c468185a$export$d3314d5863fc1fef)(()=>{
                if (!initialSessionSent) {
                    (0, $99b79a786cd20e57$exports.captureSession)();
                    initialSessionSent = true;
                }
            });
            const isolationScope = (0, $99b79a786cd20e57$exports.getIsolationScope)();
            let previousUser = isolationScope.getUser();
            isolationScope.addScopeListener((scope)=>{
                const maybeNewUser = scope.getUser();
                if (previousUser?.id !== maybeNewUser?.id || previousUser?.ip_address !== maybeNewUser?.ip_address) {
                    previousUser = maybeNewUser;
                    if (initialSessionSent) (0, $99b79a786cd20e57$exports.captureSession)();
                }
            });
            if (lifecycle === "route") (0, $9658afb47e9e02d1$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                if (from !== to) {
                    (0, $99b79a786cd20e57$exports.startSession)({
                        ignoreDuration: true
                    });
                    (0, $99b79a786cd20e57$exports.captureSession)();
                    initialSessionSent = true;
                }
            });
        }
    };
});




const $a7a6fe3c55b4cfcf$var$INTEGRATION_NAME = "CultureContext";
const $a7a6fe3c55b4cfcf$var$_cultureContextIntegration = ()=>{
    return {
        name: $a7a6fe3c55b4cfcf$var$INTEGRATION_NAME,
        preprocessEvent (event) {
            const culture = $a7a6fe3c55b4cfcf$var$getCultureContext();
            if (culture) event.contexts = {
                ...event.contexts,
                culture: {
                    ...culture,
                    ...event.contexts?.culture
                }
            };
        },
        processSegmentSpan (span) {
            const culture = $a7a6fe3c55b4cfcf$var$getCultureContext();
            if (culture) (0, $99b79a786cd20e57$exports.safeSetSpanJSONAttributes)(span, {
                "culture.locale": culture.locale,
                "culture.timezone": culture.timezone,
                "culture.calendar": culture.calendar
            });
        }
    };
};
const $a7a6fe3c55b4cfcf$export$ec5976aacdc85985 = (0, $99b79a786cd20e57$exports.defineIntegration)($a7a6fe3c55b4cfcf$var$_cultureContextIntegration);
function $a7a6fe3c55b4cfcf$var$getCultureContext() {
    try {
        const intl = (0, $c4f894bad0037563$export$56d8a8a25bd48b81).Intl;
        if (!intl) return void 0;
        const options = intl.DateTimeFormat().resolvedOptions();
        return {
            locale: options.locale,
            timezone: options.timeZone,
            calendar: options.calendar
        };
    } catch  {
        return void 0;
    }
}






const $bf5be06dce57cf17$var$INTEGRATION_NAME = "GlobalHandlers";
const $bf5be06dce57cf17$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $bf5be06dce57cf17$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $bf5be06dce57cf17$var$_installGlobalOnErrorHandler(client);
                $bf5be06dce57cf17$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $bf5be06dce57cf17$var$_installGlobalOnUnhandledRejectionHandler(client);
                $bf5be06dce57cf17$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $bf5be06dce57cf17$export$66acc70e8cf2b71a = (0, $99b79a786cd20e57$exports.defineIntegration)($bf5be06dce57cf17$var$_globalHandlersIntegration);
function $bf5be06dce57cf17$var$_installGlobalOnErrorHandler(client) {
    (0, $99b79a786cd20e57$exports.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $bf5be06dce57cf17$var$getOptions();
        if ((0, $99b79a786cd20e57$exports.getClient)() !== client || (0, $c4f894bad0037563$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $bf5be06dce57cf17$var$_enhanceEventWithInitialFrame((0, $da44c4ed1c95cf80$export$9dd56ed1ef0c3420)(stackParser, error || msg, void 0, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $99b79a786cd20e57$exports.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onerror"
            }
        });
    });
}
function $bf5be06dce57cf17$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $99b79a786cd20e57$exports.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $bf5be06dce57cf17$var$getOptions();
        if ((0, $99b79a786cd20e57$exports.getClient)() !== client || (0, $c4f894bad0037563$export$b79738ab10c590b2)()) return;
        const error = $bf5be06dce57cf17$export$b2cc40fa8241780(e);
        const event = (0, $99b79a786cd20e57$exports.isPrimitive)(error) ? $bf5be06dce57cf17$export$1353b5b36844a9ed(error) : (0, $da44c4ed1c95cf80$export$9dd56ed1ef0c3420)(stackParser, error, void 0, attachStacktrace, true);
        event.level = "error";
        (0, $99b79a786cd20e57$exports.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onunhandledrejection"
            }
        });
    });
}
function $bf5be06dce57cf17$export$b2cc40fa8241780(error) {
    if ((0, $99b79a786cd20e57$exports.isPrimitive)(error)) return error;
    try {
        if ("reason" in error) return error.reason;
        if ("detail" in error && "reason" in error.detail) return error.detail.reason;
    } catch  {}
    return error;
}
function $bf5be06dce57cf17$export$1353b5b36844a9ed(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $bf5be06dce57cf17$var$_enhanceEventWithInitialFrame(event, url, lineno, colno) {
    const e = event.exception = event.exception || {};
    const ev = e.values = e.values || [];
    const ev0 = ev[0] = ev[0] || {};
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    const ev0sf = ev0s.frames = ev0s.frames || [];
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        lineno: lineno,
        filename: $bf5be06dce57cf17$var$getFilenameFromUrl(url) ?? (0, $99b79a786cd20e57$exports.getLocationHref)(),
        function: (0, $99b79a786cd20e57$exports.UNKNOWN_FUNCTION),
        in_app: true
    });
    return event;
}
function $bf5be06dce57cf17$var$globalHandlerLog(type) {
    (0, $73d341bc35cc3264$export$16a28057038b10ef) && (0, $99b79a786cd20e57$exports.debug).log(`Global Handler attached: ${type}`);
}
function $bf5be06dce57cf17$var$getOptions() {
    const client = (0, $99b79a786cd20e57$exports.getClient)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}
function $bf5be06dce57cf17$var$getFilenameFromUrl(url) {
    if (!(0, $99b79a786cd20e57$exports.isString)(url) || url.length === 0) return void 0;
    if (url.startsWith("data:")) return `<${(0, $99b79a786cd20e57$exports.stripDataUrlContent)(url, false)}>`;
    return url;
}





var $iuxoj = parcelRequire("iuxoj");
const $cf0cccd0bf9feebc$export$1378794447170364 = (0, $99b79a786cd20e57$exports.defineIntegration)(()=>{
    return {
        name: "HttpContext",
        preprocessEvent (event) {
            if (!(0, $c4f894bad0037563$export$56d8a8a25bd48b81).navigator && !(0, $c4f894bad0037563$export$56d8a8a25bd48b81).location && !(0, $c4f894bad0037563$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $c4f894bad0037563$export$a3c4a8453e8936f0)();
            const headers = {
                ...reqData.headers,
                ...event.request?.headers
            };
            event.request = {
                ...reqData,
                ...event.request,
                headers: headers
            };
        },
        processSegmentSpan (span) {
            const spanOp = span.attributes?.[0, $99b79a786cd20e57$exports.SEMANTIC_ATTRIBUTE_SENTRY_OP];
            if (!(0, $c4f894bad0037563$export$56d8a8a25bd48b81).navigator && !(0, $c4f894bad0037563$export$56d8a8a25bd48b81).location && !(0, $c4f894bad0037563$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $c4f894bad0037563$export$a3c4a8453e8936f0)();
            (0, $99b79a786cd20e57$exports.safeSetSpanJSONAttributes)(span, {
                // Coerce empty string to undefined so the helper's nullish check drops it,
                // rather than writing an empty `url.full` attribute onto the span.
                [(0, $iuxoj.URL_FULL)]: spanOp !== "http.client" ? reqData.url : void 0,
                "http.request.header.user_agent": reqData.headers["User-Agent"],
                "http.request.header.referer": reqData.headers["Referer"]
            });
        }
    };
});




const $8c635a5e5b8ee948$var$DEFAULT_KEY = "cause";
const $8c635a5e5b8ee948$var$DEFAULT_LIMIT = 5;
const $8c635a5e5b8ee948$var$INTEGRATION_NAME = "LinkedErrors";
const $8c635a5e5b8ee948$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $8c635a5e5b8ee948$var$DEFAULT_LIMIT;
    const key = options.key || $8c635a5e5b8ee948$var$DEFAULT_KEY;
    return {
        name: $8c635a5e5b8ee948$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options2 = client.getOptions();
            (0, $99b79a786cd20e57$exports.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $da44c4ed1c95cf80$export$a6c2d27607295951), options2.stackParser, key, limit, event, hint);
        }
    };
};
const $8c635a5e5b8ee948$export$ebabb00eb7f3a395 = (0, $99b79a786cd20e57$exports.defineIntegration)($8c635a5e5b8ee948$var$_linkedErrorsIntegration);



const $1752d4c2aae71095$var$OPERA10_PRIORITY = 10;
const $1752d4c2aae71095$var$OPERA11_PRIORITY = 20;
const $1752d4c2aae71095$var$CHROME_PRIORITY = 30;
const $1752d4c2aae71095$var$WINJS_PRIORITY = 40;
const $1752d4c2aae71095$var$GECKO_PRIORITY = 50;
function $1752d4c2aae71095$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === "<anonymous>" ? (0, $99b79a786cd20e57$exports.UNKNOWN_FUNCTION) : func,
        in_app: true
    };
    if (lineno !== void 0) frame.lineno = lineno;
    if (colno !== void 0) frame.colno = colno;
    return frame;
}
const $1752d4c2aae71095$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
const $1752d4c2aae71095$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $1752d4c2aae71095$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
const $1752d4c2aae71095$var$chromeDataUriRegex = /at (.+?) ?\(data:(.+?),/;
const $1752d4c2aae71095$var$chromeStackParserFn = (line)=>{
    const dataUriMatch = line.match($1752d4c2aae71095$var$chromeDataUriRegex);
    if (dataUriMatch) return {
        filename: `<data:${dataUriMatch[2]}>`,
        function: dataUriMatch[1]
    };
    const noFnParts = $1752d4c2aae71095$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line2, col] = noFnParts;
        return $1752d4c2aae71095$var$createFrame(filename, (0, $99b79a786cd20e57$exports.UNKNOWN_FUNCTION), +line2, +col);
    }
    const parts = $1752d4c2aae71095$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2]?.indexOf("eval") === 0;
        if (isEval) {
            const subMatch = $1752d4c2aae71095$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                parts[2] = subMatch[1];
                parts[3] = subMatch[2];
                parts[4] = subMatch[3];
            }
        }
        const [func, filename] = $1752d4c2aae71095$var$extractSafariExtensionDetails(parts[1] || (0, $99b79a786cd20e57$exports.UNKNOWN_FUNCTION), parts[2]);
        return $1752d4c2aae71095$var$createFrame(filename, func, parts[3] ? +parts[3] : void 0, parts[4] ? +parts[4] : void 0);
    }
    return;
};
const $1752d4c2aae71095$export$263a749fff749872 = [
    $1752d4c2aae71095$var$CHROME_PRIORITY,
    $1752d4c2aae71095$var$chromeStackParserFn
];
const $1752d4c2aae71095$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $1752d4c2aae71095$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $1752d4c2aae71095$var$gecko = (line)=>{
    const parts = $1752d4c2aae71095$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $1752d4c2aae71095$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = "";
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $99b79a786cd20e57$exports.UNKNOWN_FUNCTION);
        [func, filename] = $1752d4c2aae71095$var$extractSafariExtensionDetails(func, filename);
        return $1752d4c2aae71095$var$createFrame(filename, func, parts[4] ? +parts[4] : void 0, parts[5] ? +parts[5] : void 0);
    }
    return;
};
const $1752d4c2aae71095$export$cdba47a5dd2804d = [
    $1752d4c2aae71095$var$GECKO_PRIORITY,
    $1752d4c2aae71095$var$gecko
];
const $1752d4c2aae71095$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $1752d4c2aae71095$var$winjs = (line)=>{
    const parts = $1752d4c2aae71095$var$winjsRegex.exec(line);
    return parts ? $1752d4c2aae71095$var$createFrame(parts[2], parts[1] || (0, $99b79a786cd20e57$exports.UNKNOWN_FUNCTION), +parts[3], parts[4] ? +parts[4] : void 0) : void 0;
};
const $1752d4c2aae71095$export$179460296da408e8 = [
    $1752d4c2aae71095$var$WINJS_PRIORITY,
    $1752d4c2aae71095$var$winjs
];
const $1752d4c2aae71095$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $1752d4c2aae71095$var$opera10 = (line)=>{
    const parts = $1752d4c2aae71095$var$opera10Regex.exec(line);
    return parts ? $1752d4c2aae71095$var$createFrame(parts[2], parts[3] || (0, $99b79a786cd20e57$exports.UNKNOWN_FUNCTION), +parts[1]) : void 0;
};
const $1752d4c2aae71095$export$f892b52c880ffc7a = [
    $1752d4c2aae71095$var$OPERA10_PRIORITY,
    $1752d4c2aae71095$var$opera10
];
const $1752d4c2aae71095$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $1752d4c2aae71095$var$opera11 = (line)=>{
    const parts = $1752d4c2aae71095$var$opera11Regex.exec(line);
    return parts ? $1752d4c2aae71095$var$createFrame(parts[5], parts[3] || parts[4] || (0, $99b79a786cd20e57$exports.UNKNOWN_FUNCTION), +parts[1], +parts[2]) : void 0;
};
const $1752d4c2aae71095$export$af11af13f09fb0dc = [
    $1752d4c2aae71095$var$OPERA11_PRIORITY,
    $1752d4c2aae71095$var$opera11
];
const $1752d4c2aae71095$export$7197c0fe6554c079 = [
    $1752d4c2aae71095$export$263a749fff749872,
    $1752d4c2aae71095$export$cdba47a5dd2804d
];
const $1752d4c2aae71095$export$2b2b997d81bf3907 = (0, $99b79a786cd20e57$exports.createStackParser)(...$1752d4c2aae71095$export$7197c0fe6554c079);
const $1752d4c2aae71095$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : (0, $99b79a786cd20e57$exports.UNKNOWN_FUNCTION),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};




const $35ef5e79775de1d7$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



const $80bab3750535e21b$var$cachedImplementations = {};
function $80bab3750535e21b$export$e464f4a514ac28a8(name) {
    const cached = $80bab3750535e21b$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $55811081a41de9b1$export$56d8a8a25bd48b81)[name];
    if ((0, $c4fd0f5da06af62e$export$d5f608b368e73f38)(impl)) return $80bab3750535e21b$var$cachedImplementations[name] = impl.bind((0, $55811081a41de9b1$export$56d8a8a25bd48b81));
    const document = (0, $55811081a41de9b1$export$56d8a8a25bd48b81).document;
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $35ef5e79775de1d7$export$16a28057038b10ef) && (0, $b4f23915afcea35b$export$1c9f709888824e05).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    if (!impl) return impl;
    return $80bab3750535e21b$var$cachedImplementations[name] = impl.bind((0, $55811081a41de9b1$export$56d8a8a25bd48b81));
}
function $80bab3750535e21b$export$8aa36702e8c8978(name) {
    $80bab3750535e21b$var$cachedImplementations[name] = void 0;
}
function $80bab3750535e21b$export$e7aa7bc5c1b3cfb3(...rest) {
    return $80bab3750535e21b$export$e464f4a514ac28a8("fetch")(...rest);
}
function $80bab3750535e21b$export$831dc9f2ab0a617b(...rest) {
    return $80bab3750535e21b$export$e464f4a514ac28a8("setTimeout")(...rest);
}


const $4bdf530bfa8b7fb7$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE = 40;
function $4bdf530bfa8b7fb7$export$b2311068c46d7cc8(options, nativeFetch = (0, $80bab3750535e21b$export$e464f4a514ac28a8)("fetch")) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    async function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "strict-origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 6e4 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            const response = await nativeFetch(options.url, requestOptions);
            return {
                statusCode: response.status,
                headers: {
                    "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                    "retry-after": response.headers.get("Retry-After")
                }
            };
        } catch (e) {
            (0, $80bab3750535e21b$export$8aa36702e8c8978)("fetch");
            throw e;
        } finally{
            pendingBodySize -= requestSize;
            pendingCount--;
        }
    }
    return (0, $99b79a786cd20e57$exports.createTransport)(options, makeRequest, (0, $99b79a786cd20e57$exports.makePromiseBuffer)(options.bufferSize || $4bdf530bfa8b7fb7$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE));
}


function $7b36f82a96b8a1d4$export$45a5e7f76e0caa8d(wat) {
    if (typeof Element === "undefined") return false;
    try {
        return wat instanceof Element;
    } catch  {
        return false;
    }
}


const $6ce4f511ef2cd38e$var$HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX = /^HTML(\w*)Element$/;
function $6ce4f511ef2cd38e$export$4c88c355e6072df5(value) {
    if (typeof window !== "undefined" && value === window) return "[Window]";
    if (typeof document !== "undefined" && value === document) return "[Document]";
    if ((0, $7b36f82a96b8a1d4$export$45a5e7f76e0caa8d)(value)) {
        const objName = $6ce4f511ef2cd38e$var$getConstructorName(value);
        if ($6ce4f511ef2cd38e$var$HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX.test(objName)) return `[HTMLElement: ${(0, $d8fc20c6284d49a2$export$5647df6b7814ac86)(value)}]`;
    }
    return void 0;
}
function $6ce4f511ef2cd38e$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}





function $7797a02ddb8c8915$export$dc236a86065879fc() {
    if ($7797a02ddb8c8915$var$_isEmbeddedBrowserExtension()) {
        if (0, $73d341bc35cc3264$export$16a28057038b10ef) (0, $99b79a786cd20e57$exports.consoleSandbox)(()=>{
            console.error("[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/");
        });
        return true;
    }
    return false;
}
function $7797a02ddb8c8915$var$_isEmbeddedBrowserExtension() {
    if (typeof (0, $c4f894bad0037563$export$56d8a8a25bd48b81).window === "undefined") return false;
    const _window = (0, $c4f894bad0037563$export$56d8a8a25bd48b81);
    if (_window.nw) return false;
    const extensionObject = _window["chrome"] || _window["browser"];
    if (!extensionObject?.runtime?.id) return false;
    const href = (0, $99b79a786cd20e57$exports.getLocationHref)();
    const isDedicatedExtensionPage = (0, $c4f894bad0037563$export$56d8a8a25bd48b81) === (0, $c4f894bad0037563$export$56d8a8a25bd48b81).top && /^(?:chrome-extension|moz-extension|ms-browser-extension|safari-web-extension):\/\//.test(href);
    return !isDedicatedExtensionPage;
}


function $e5d24ac3ebddaa42$export$5783b2920b1d62b9(_options) {
    return [
        // TODO(v11): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line typescript/no-deprecated
        (0, $99b79a786cd20e57$exports.inboundFiltersIntegration)(),
        (0, $99b79a786cd20e57$exports.functionToStringIntegration)(),
        (0, $99b79a786cd20e57$exports.conversationIdIntegration)(),
        (0, $415c37fe32b0feca$export$59bfe9f1c76150e)(),
        (0, $c47744e8a60c3091$export$c079d904b326663a)(),
        (0, $bf5be06dce57cf17$export$66acc70e8cf2b71a)(),
        (0, $8c635a5e5b8ee948$export$ebabb00eb7f3a395)(),
        (0, $99b79a786cd20e57$exports.dedupeIntegration)(),
        (0, $cf0cccd0bf9feebc$export$1378794447170364)(),
        (0, $a7a6fe3c55b4cfcf$export$ec5976aacdc85985)(),
        (0, $8805b82778feb647$export$1baa7880e357371c)()
    ];
}
function $e5d24ac3ebddaa42$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $7797a02ddb8c8915$export$dc236a86065879fc)();
    let defaultIntegrations = options.defaultIntegrations == null ? $e5d24ac3ebddaa42$export$5783b2920b1d62b9() : options.defaultIntegrations;
    const clientOptions = {
        ...options,
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $99b79a786cd20e57$exports.stackParserFromStackParserOptions)(options.stackParser || (0, $1752d4c2aae71095$export$2b2b997d81bf3907)),
        integrations: (0, $99b79a786cd20e57$exports.getIntegrationsToSetup)({
            integrations: options.integrations,
            defaultIntegrations: defaultIntegrations
        }),
        transport: options.transport || (0, $4bdf530bfa8b7fb7$export$b2311068c46d7cc8)
    };
    (0, $99b79a786cd20e57$exports.setNormalizeStringifier)((0, $6ce4f511ef2cd38e$export$4c88c355e6072df5));
    return (0, $99b79a786cd20e57$exports.initAndBind)((0, $cdacc4c56d076bd1$export$1df9218a526d318d), clientOptions);
}
function $e5d24ac3ebddaa42$export$a3f323d81eede727() {}
function $e5d24ac3ebddaa42$export$4e4d8b287d028b6b(callback) {
    callback();
}


const $c21e717f342a51d7$var$SENTRY_DSN = "https://aa1bd358d76d46f7a4d96f8b49fd94e4@crashlog.saludindependiente.com/8";
const $c21e717f342a51d7$var$SENTRY_ENVIRONMENT = "production";
let $c21e717f342a51d7$var$initialized = false;
function $c21e717f342a51d7$export$69fba9dfccdfe741() {
    if ($c21e717f342a51d7$var$initialized || !$c21e717f342a51d7$var$SENTRY_DSN) return;
    $e5d24ac3ebddaa42$export$2cd8252107eb640b({
        dsn: $c21e717f342a51d7$var$SENTRY_DSN,
        environment: $c21e717f342a51d7$var$SENTRY_ENVIRONMENT,
        attachStacktrace: true
    });
    $c21e717f342a51d7$var$initialized = true;
}
function $c21e717f342a51d7$export$5540dc42223417c0() {
    return Boolean($c21e717f342a51d7$var$SENTRY_DSN);
}
function $c21e717f342a51d7$export$313cbcf78ffd5537(user) {
    if (!$c21e717f342a51d7$export$5540dc42223417c0()) return;
    $99b79a786cd20e57$exports.setUser({
        id: user.id,
        username: user.username
    });
}
function $c21e717f342a51d7$export$b8d6a5bb16cbac24(context) {
    if (!$c21e717f342a51d7$export$5540dc42223417c0()) return;
    $99b79a786cd20e57$exports.setTag("page", context.page);
    if (context.appointmentId) $99b79a786cd20e57$exports.setTag("appointment_id", context.appointmentId);
    if (context.participantRole) $99b79a786cd20e57$exports.setTag("participant_role", context.participantRole);
    $99b79a786cd20e57$exports.setContext("telemedicina", context);
}
function $c21e717f342a51d7$export$836669cc2ed6fccb(message, level = "info", extra) {
    if (!$c21e717f342a51d7$export$5540dc42223417c0()) return;
    $99b79a786cd20e57$exports.withScope((scope)=>{
        if (extra) scope.setContext("details", extra);
        scope.setLevel(level);
        $99b79a786cd20e57$exports.captureMessage(message);
    });
}
function $c21e717f342a51d7$export$169b788eb44b1d5a(error, extra) {
    if (!$c21e717f342a51d7$export$5540dc42223417c0()) return;
    $99b79a786cd20e57$exports.withScope((scope)=>{
        if (extra) scope.setContext("details", extra);
        $99b79a786cd20e57$exports.captureException(error);
    });
}


class $bd798fc4a94d22ad$export$119dceb9b5803d83 {
    constructor(apiUrl, token){
        this.apiUrl = apiUrl;
        this.token = token;
    }
    async submitReview(reviewData) {
        const url = `${this.apiUrl}/reviews?token=${encodeURIComponent(this.token)}`;
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(reviewData)
        });
        if (!response.ok) {
            let errorMessage = `Error ${response.status}: ${response.statusText}`;
            try {
                const errorData = await response.json();
                if (errorData.message) errorMessage = errorData.message;
                else if (errorData.error) errorMessage = typeof errorData.error === "string" ? errorData.error : errorData.error.message || errorMessage;
            } catch  {
            // Ignore JSON parsing errors
            }
            (0, $c21e717f342a51d7$export$169b788eb44b1d5a)(new Error(errorMessage), {
                feature: "review-submit",
                appointmentId: reviewData.appointmentId,
                status: response.status
            });
            throw new Error(errorMessage);
        }
    }
}



const $9bc723c13c8fb76d$var$STEPS = [
    {
        id: "rating",
        title: "Como fue su experiencia?",
        subtitle: "Califique la atencion recibida"
    },
    {
        id: "punctuality",
        title: "El medico fue puntual?",
        subtitle: "Cuentenos sobre la puntualidad"
    },
    {
        id: "comment",
        title: "Algo mas que compartir?",
        subtitle: "Tu comentario es opcional"
    }
];
class $9bc723c13c8fb76d$export$a98d1c96a8503bd8 {
    constructor(appointmentId, token, apiUrl){
        this.currentStep = 0;
        this.selectedRating = 0;
        this.selectedPunctuality = "";
        this.comment = "";
        this.platformFeedback = {
            npsScore: null,
            feedbackType: undefined,
            comment: ""
        };
        this.appointmentId = appointmentId;
        this.reviewService = new (0, $bd798fc4a94d22ad$export$119dceb9b5803d83)(apiUrl, token);
        this.container = document.getElementById("app-container");
        (0, $c21e717f342a51d7$export$b8d6a5bb16cbac24)({
            page: "review",
            appointmentId: appointmentId
        });
        this.render();
    }
    render() {
        this.container.innerHTML = `
      <div class="review-page">
        <div class="review-container">
          <div class="review-brand-header">
            <h2>Su consulta ha finalizado</h2>
          </div>

          <div class="review-content">
            <div class="step-progress">
              ${$9bc723c13c8fb76d$var$STEPS.map((_, i)=>`
                <div class="step-dot ${i < this.currentStep ? "done" : i === this.currentStep ? "active" : ""}"></div>
              `).join("")}
            </div>

            <div class="review-header">
              <h1>${$9bc723c13c8fb76d$var$STEPS[this.currentStep].title}</h1>
              <p class="review-subtitle">${$9bc723c13c8fb76d$var$STEPS[this.currentStep].subtitle}</p>
            </div>

            <div class="step-content">
              ${this.renderStep()}
            </div>

            <div class="step-actions">
              ${this.currentStep > 0 ? `<button class="back-button" id="back-btn">Atras</button>` : "<div></div>"}
              <button class="next-button" id="next-btn">
                ${this.currentStep === $9bc723c13c8fb76d$var$STEPS.length - 1 ? "Enviar calificacion" : "Continuar"}
              </button>
            </div>

            <div class="error-message" id="step-error"></div>
          </div>
        </div>
      </div>
    `;
        this.attachStepListeners();
    }
    renderStep() {
        switch(this.currentStep){
            case 0:
                return `
          <div class="star-rating" id="star-rating">
            ${[
                    1,
                    2,
                    3,
                    4,
                    5
                ].map((v)=>`
              <button type="button" class="star ${v <= this.selectedRating ? "selected" : ""}" data-value="${v}">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
                </svg>
              </button>
            `).join("")}
          </div>
          <div class="rating-label" id="rating-label">${this.getRatingLabel(this.selectedRating)}</div>
        `;
            case 1:
                return `
          <div class="punctuality-options">
            ${[
                    {
                        value: "ON_TIME",
                        icon: "OK",
                        text: "A tiempo"
                    },
                    {
                        value: "LATE",
                        icon: "T",
                        text: "Con retraso"
                    },
                    {
                        value: "NO_SHOW",
                        icon: "X",
                        text: "No se presento"
                    }
                ].map((opt)=>`
              <label class="punctuality-option">
                <input type="radio" name="punctualityRating" value="${opt.value}" ${this.selectedPunctuality === opt.value ? "checked" : ""}>
                <span class="option-content ${this.selectedPunctuality === opt.value ? "selected" : ""}">
                  <span class="option-icon">${opt.icon}</span>
                  <span class="option-text">${opt.text}</span>
                </span>
              </label>
            `).join("")}
          </div>
          <p class="skip-hint">Este paso es opcional</p>
        `;
            case 2:
                return `
          <div class="review-form-section">
            <label class="form-label" for="comment">Comentario sobre la consulta</label>
            <textarea
              id="comment"
              rows="5"
              class="form-textarea"
              placeholder="Comparte tu experiencia con la consulta..."
              maxlength="500"
            >${this.comment}</textarea>
            <div class="char-count"><span id="char-count">${this.comment.length}</span>/500</div>
          </div>

          <div class="platform-feedback-section">
            <div class="platform-feedback-header">
              <h2>Feedback sobre la plataforma</h2>
              <p>Estos campos son opcionales y nos ayudan a mejorar la experiencia.</p>
            </div>

            <div class="review-form-section">
              <label class="form-label" for="platform-nps">\xbfQu\xe9 probabilidad hay de que recomiende nuestro servicio a un amigo o familiar?</label>
              <input
                id="platform-nps"
                type="number"
                min="0"
                max="10"
                step="1"
                class="form-input"
                placeholder="0 a 10"
                value="${this.platformFeedback.npsScore ?? ""}"
              />
            </div>

            <div class="review-form-section">
              <label class="form-label" for="platform-feedback-type">Tipo de feedback</label>
              <select id="platform-feedback-type" class="form-select">
                <option value="">Seleccionar</option>
                ${this.renderPlatformFeedbackOption("GENERAL_COMMENT", "Comentario general")}
                ${this.renderPlatformFeedbackOption("BUG_REPORT", "Reportar un error")}
                ${this.renderPlatformFeedbackOption("FEATURE_REQUEST", "Sugerir una mejora")}
              </select>
            </div>

            <div class="review-form-section">
              <label class="form-label" for="platform-comment">Comentario sobre la plataforma</label>
              <textarea
                id="platform-comment"
                rows="4"
                class="form-textarea"
                placeholder="Cuentanos si algo fallo o que podriamos mejorar..."
                maxlength="500"
              >${this.platformFeedback.comment}</textarea>
              <div class="char-count"><span id="platform-char-count">${this.platformFeedback.comment.length}</span>/500</div>
            </div>
          </div>
        `;
            default:
                return "";
        }
    }
    renderPlatformFeedbackOption(value, label) {
        const selected = this.platformFeedback.feedbackType === value ? "selected" : "";
        return `<option value="${value}" ${selected}>${label}</option>`;
    }
    getRatingLabel(rating) {
        const labels = [
            "",
            "Muy malo",
            "Malo",
            "Regular",
            "Bueno",
            "Excelente"
        ];
        return labels[rating] ?? "";
    }
    attachStepListeners() {
        const nextBtn = document.getElementById("next-btn");
        const backBtn = document.getElementById("back-btn");
        const errorEl = document.getElementById("step-error");
        backBtn?.addEventListener("click", ()=>{
            this.currentStep--;
            this.render();
        });
        nextBtn.addEventListener("click", async ()=>{
            errorEl.textContent = "";
            if (this.currentStep === 0) {
                if (!this.selectedRating) {
                    errorEl.textContent = "Por favor, selecciona una calificacion";
                    return;
                }
                this.currentStep++;
                this.render();
                return;
            }
            if (this.currentStep === 1) {
                const checked = document.querySelector('input[name="punctualityRating"]:checked');
                this.selectedPunctuality = checked?.value ?? "";
                this.currentStep++;
                this.render();
                return;
            }
            if (this.currentStep === 2) {
                const textarea = document.getElementById("comment");
                this.comment = textarea?.value.trim() ?? "";
                this.platformFeedback = this.readPlatformFeedback();
                await this.submit(nextBtn, errorEl);
            }
        });
        if (this.currentStep === 0) {
            const stars = document.querySelectorAll(".star");
            const label = document.getElementById("rating-label");
            const updateStars = (rating)=>{
                stars.forEach((s, i)=>s.classList.toggle("selected", i < rating));
                label.textContent = this.getRatingLabel(rating);
            };
            stars.forEach((star)=>{
                star.addEventListener("click", ()=>{
                    this.selectedRating = parseInt(star.dataset.value, 10);
                    updateStars(this.selectedRating);
                });
                star.addEventListener("mouseenter", ()=>{
                    updateStars(parseInt(star.dataset.value, 10));
                });
            });
            document.getElementById("star-rating").addEventListener("mouseleave", ()=>{
                updateStars(this.selectedRating);
            });
        }
        if (this.currentStep === 2) {
            const textarea = document.getElementById("comment");
            const charCount = document.getElementById("char-count");
            const platformTextarea = document.getElementById("platform-comment");
            const platformCharCount = document.getElementById("platform-char-count");
            textarea?.addEventListener("input", ()=>{
                if (charCount) charCount.textContent = textarea.value.length.toString();
            });
            platformTextarea?.addEventListener("input", ()=>{
                if (platformCharCount) platformCharCount.textContent = platformTextarea.value.length.toString();
            });
        }
    }
    readPlatformFeedback() {
        const npsInput = document.getElementById("platform-nps");
        const feedbackTypeSelect = document.getElementById("platform-feedback-type");
        const commentTextarea = document.getElementById("platform-comment");
        const rawValue = npsInput?.value?.trim() ?? "";
        const parsedScore = rawValue ? Number(rawValue) : null;
        const npsScore = typeof parsedScore === "number" && !Number.isNaN(parsedScore) && parsedScore >= 0 && parsedScore <= 10 ? parsedScore : null;
        return {
            npsScore: npsScore,
            feedbackType: feedbackTypeSelect?.value || undefined,
            comment: commentTextarea?.value ?? ""
        };
    }
    async submit(btn, errorEl) {
        const reviewData = {
            appointmentId: this.appointmentId,
            overallScore: this.selectedRating
        };
        if (this.comment) reviewData.comment = this.comment;
        if (this.selectedPunctuality) {
            const map = {
                ON_TIME: 5,
                LATE: 3,
                NO_SHOW: 1
            };
            reviewData.punctualityScore = map[this.selectedPunctuality];
        }
        const hasPlatformFeedback = this.platformFeedback.npsScore !== null || Boolean(this.platformFeedback.feedbackType) || Boolean(this.platformFeedback.comment.trim());
        if (hasPlatformFeedback) reviewData.platformFeedback = {
            npsScore: this.platformFeedback.npsScore ?? null,
            feedbackType: this.platformFeedback.feedbackType ?? "GENERAL_COMMENT",
            comment: this.platformFeedback.comment.trim()
        };
        try {
            btn.disabled = true;
            btn.textContent = "Enviando...";
            await this.reviewService.submitReview(reviewData);
            this.showSuccess();
        } catch (error) {
            (0, $c21e717f342a51d7$export$169b788eb44b1d5a)(error, {
                feature: "review-ui-submit",
                appointmentId: this.appointmentId
            });
            const message = error instanceof Error ? error.message : "Error al enviar. Por favor, intenta de nuevo.";
            errorEl.textContent = message;
            btn.disabled = false;
            btn.textContent = "Enviar calificacion";
        }
    }
    showSuccess() {
        this.container.innerHTML = `
      <div class="review-page">
        <div class="review-container">
          <div class="review-brand-header">
            <h2>Su consulta ha finalizado</h2>
          </div>

          <div class="review-content">
            <div class="success-message">
              <div class="success-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                </svg>
              </div>
              <h1>Gracias por tu calificacion.</h1>
              <p class="success-subtitle">Tu opinion nos ayuda a seguir mejorando</p>
              <button class="close-button" onclick="window.close()">Cerrar ventana</button>
            </div>
          </div>
        </div>
      </div>
    `;
    }
}



const $b4e14b6b8da86996$var$API_URL = "https://dev-api.saludindependiente.com/v1";
const $b4e14b6b8da86996$var$DEFAULT_DISCONNECTION_TIMEOUT_SECONDS = 30;
const $b4e14b6b8da86996$var$DISCONNECTION_TIMEOUT_SECONDS = Number.parseInt("40", 10);
const $b4e14b6b8da86996$var$appContainer = document.getElementById("app-container");
const $b4e14b6b8da86996$var$speakerView = document.getElementById("speaker-view");
const $b4e14b6b8da86996$var$sidebarParticipants = document.getElementById("sidebar-participants");
const $b4e14b6b8da86996$var$controlsContainer = document.getElementById("controls-container");
const $b4e14b6b8da86996$var$callControls = document.getElementById("call-controls");
const $b4e14b6b8da86996$var$mainView = document.getElementById("main-view");
const $b4e14b6b8da86996$var$createOverlay = (content, id)=>{
    const div = document.createElement("div");
    div.id = id;
    div.className = "full-screen-overlay";
    div.innerHTML = content;
    document.body.appendChild(div);
    return div;
};
const $b4e14b6b8da86996$var$loadingScreen = $b4e14b6b8da86996$var$createOverlay(`
  <div class="spinner"></div>
  <div class="loading-text">Conectandose al turno...</div>
`, "loading-screen");
const $b4e14b6b8da86996$var$errorScreen = $b4e14b6b8da86996$var$createOverlay("", "error-screen");
$b4e14b6b8da86996$var$errorScreen.classList.add("hidden");
const $b4e14b6b8da86996$var$connectionStatusBanner = document.createElement("div");
$b4e14b6b8da86996$var$connectionStatusBanner.id = "connection-status-banner";
$b4e14b6b8da86996$var$connectionStatusBanner.className = "connection-status-banner hidden";
$b4e14b6b8da86996$var$connectionStatusBanner.setAttribute("role", "status");
$b4e14b6b8da86996$var$connectionStatusBanner.setAttribute("aria-live", "polite");
document.body.appendChild($b4e14b6b8da86996$var$connectionStatusBanner);
const $b4e14b6b8da86996$var$thankYouScreen = $b4e14b6b8da86996$var$createOverlay(`
  <div class="thank-you-container">
    <div class="thank-you-title">Consulta finalizada</div>
    <div class="thank-you-desc">Ahora puede cerrar esta pestana.</div>
  </div>
`, "thank-you-screen");
$b4e14b6b8da86996$var$thankYouScreen.classList.add("hidden");
const $b4e14b6b8da86996$var$welcomeScreen = $b4e14b6b8da86996$var$createOverlay(`
  <div class="welcome-container">
    <div class="welcome-title">Bienvenido a SI Telemedicina</div>
    <div class="welcome-desc">Para comenzar, abra el enlace de la consulta.</div>
  </div>
`, "welcome-screen");
$b4e14b6b8da86996$var$welcomeScreen.classList.add("hidden");
const $b4e14b6b8da86996$var$showError = (message)=>{
    $b4e14b6b8da86996$var$loadingScreen.classList.add("hidden");
    $b4e14b6b8da86996$var$errorScreen.innerHTML = `
    <div class="error-container">
      <div class="error-title">No se pudo unir</div>
      <div class="error-desc">${message}</div>
      <button onclick="window.location.reload()" style="padding: 8px 16px; border-radius: 4px; border:none; background:#444; color:white; cursor:pointer;">Intentar de nuevo</button>
    </div>
  `;
    $b4e14b6b8da86996$var$errorScreen.classList.remove("hidden");
};
const $b4e14b6b8da86996$var$createWaitingState = (participantRole)=>{
    const waitingState = document.createElement("div");
    waitingState.id = "waiting-state";
    waitingState.className = "waiting-state hidden";
    const isDoctor = participantRole === "doctor";
    const title = isDoctor ? "Esperando al paciente" : "Esperando al profesional";
    const description = isDoctor ? "La consulta comenzara cuando el paciente se una a la videollamada." : "La consulta comenzara cuando el profesional se una a la videollamada.";
    waitingState.innerHTML = `
    <div class="waiting-card">
      <div class="waiting-badge">Sala de espera</div>
      <div class="waiting-title">${title}</div>
      <div class="waiting-desc">${description}</div>
    </div>
  `;
    $b4e14b6b8da86996$var$speakerView.appendChild(waitingState);
    return waitingState;
};
const $b4e14b6b8da86996$var$navigateBackOrShowThankYou = ()=>{
    if (window.history.length > 1) {
        window.history.back();
        return;
    }
    $b4e14b6b8da86996$var$appContainer.classList.add("hidden");
    $b4e14b6b8da86996$var$thankYouScreen.classList.remove("hidden");
};
async function $b4e14b6b8da86996$var$init() {
    (0, $c21e717f342a51d7$export$69fba9dfccdfe741)();
    try {
        const pathname = window.location.pathname || "";
        const reviewMatch = pathname.match(/\/appointments\/([^\/]+)\/reviews?/);
        if (reviewMatch) {
            const appointmentId = reviewMatch[1];
            const urlParams = new URLSearchParams(window.location.search);
            const token = urlParams.get("token");
            if (!token) {
                $b4e14b6b8da86996$var$showError("Token de autenticacion requerido.");
                return;
            }
            $b4e14b6b8da86996$var$loadingScreen.classList.add("hidden");
            new (0, $9bc723c13c8fb76d$export$a98d1c96a8503bd8)(appointmentId, token, $b4e14b6b8da86996$var$API_URL);
            return;
        }
        if (!pathname.includes("/call")) {
            $b4e14b6b8da86996$var$loadingScreen.classList.add("hidden");
            $b4e14b6b8da86996$var$welcomeScreen.classList.remove("hidden");
            return;
        }
        const urlParams = new URLSearchParams(window.location.search);
        const tokenParam = urlParams.get("token");
        let appointmentId = urlParams.get("appointmentId");
        if (!appointmentId) {
            const pathSegments = window.location.pathname.split("/");
            const callIndex = pathSegments.indexOf("call");
            if (callIndex !== -1 && pathSegments[callIndex + 1]) appointmentId = pathSegments[callIndex + 1];
        }
        if (!tokenParam || !appointmentId) {
            (0, $c21e717f342a51d7$export$836669cc2ed6fccb)("Missing call credentials in URL", "warning", {
                pathname: pathname,
                hasToken: Boolean(tokenParam),
                hasAppointmentId: Boolean(appointmentId)
            });
            throw new Error("Faltan token o ID de turno.");
        }
        (0, $c21e717f342a51d7$export$b8d6a5bb16cbac24)({
            page: "call",
            appointmentId: appointmentId
        });
        const res = await fetch(`${$b4e14b6b8da86996$var$API_URL}/video/token?token=${tokenParam}`, {
            method: "POST",
            body: JSON.stringify({
                appointmentId: appointmentId
            }),
            headers: {
                "Content-Type": "application/json"
            }
        });
        if (!res.ok) {
            let errMsg = `Error ${res.status}: ${res.statusText || "Error de conexion al servidor"}`;
            try {
                const errData = await res.json();
                if (errData) {
                    if (typeof errData.error === "string") errMsg = errData.error;
                    else if (errData.error?.message) errMsg = errData.error.message;
                    else if (errData.message) errMsg = errData.message;
                }
            } catch  {
            // Ignore JSON errors
            }
            (0, $c21e717f342a51d7$export$169b788eb44b1d5a)(new Error(errMsg), {
                feature: "video-token",
                appointmentId: appointmentId,
                status: res.status
            });
            throw new Error(errMsg);
        }
        const data = await res.json();
        const participantRole = data.participant?.role || "patient";
        (0, $c21e717f342a51d7$export$b8d6a5bb16cbac24)({
            page: "call",
            appointmentId: appointmentId,
            participantRole: participantRole
        });
        (0, $c21e717f342a51d7$export$313cbcf78ffd5537)({
            id: data.userId,
            username: data.participant?.name
        });
        const client = new (0, $8c05ed6f2f331ee8$export$42ba3bdc276d86f6)({
            apiKey: data.apiKey,
            user: {
                id: data.userId,
                name: data.participant.name,
                image: data.participant.imageUrl
            },
            token: data.token,
            options: {
                logLevel: "warn",
                timeout: 10000
            }
        });
        const chatService = new (0, $09d892b85c18f647$export$446e355f79c9563c)($b4e14b6b8da86996$var$API_URL, appointmentId, data.userId, tokenParam);
        const chatUI = new (0, $33eec13820dbe7df$export$dc0ba17f632b90a8)(chatService, $b4e14b6b8da86996$var$mainView);
        const call = client.call("telehealth", appointmentId);
        $b4e14b6b8da86996$var$setupDisconnectionTimeout(call, appointmentId, participantRole);
        $b4e14b6b8da86996$var$registerMonitoring(client, call, appointmentId, participantRole);
        const handleLeave = async ()=>{
            const isDoctor = participantRole === "doctor";
            const confirmMessage = isDoctor ? "Estas seguro que queres finalizar la consulta para todos?" : "Estas seguro que queres salir de la consulta?";
            if (window.confirm(confirmMessage)) try {
                chatService.stopPolling();
                if (isDoctor) await call.endCall();
                else await call.leave();
            } catch (error) {
                console.error("Error leaving call:", error);
                (0, $c21e717f342a51d7$export$169b788eb44b1d5a)(error, {
                    feature: "leave-call",
                    appointmentId: appointmentId,
                    participantRole: participantRole,
                    action: isDoctor ? "endCall" : "leave"
                });
            } finally{
                $b4e14b6b8da86996$var$navigateBackOrShowThankYou();
            }
        };
        const toggleChat = ()=>chatUI.toggle();
        $b4e14b6b8da86996$var$setupUI(call, handleLeave, toggleChat);
        await call.join({
            create: true
        });
        try {
            call.camera.enable();
            call.microphone.enable();
        } catch (error) {
            (0, $c21e717f342a51d7$export$169b788eb44b1d5a)(error, {
                feature: "device-enable",
                appointmentId: appointmentId
            });
        }
        $b4e14b6b8da86996$var$setupLayoutManager(call, participantRole);
        $b4e14b6b8da86996$var$loadingScreen.classList.add("hidden");
    } catch (err) {
        console.error(err);
        (0, $c21e717f342a51d7$export$169b788eb44b1d5a)(err, {
            feature: "app-init"
        });
        const message = err instanceof Error ? err.message : "Ocurrio un error desconocido.";
        $b4e14b6b8da86996$var$showError(message);
    }
}
function $b4e14b6b8da86996$var$setupUI(call, onLeave, onToggleChat) {
    const settingsMenu = document.createElement("div");
    settingsMenu.id = "settings-menu";
    const micLabel = document.createElement("label");
    micLabel.innerText = "Microfono";
    settingsMenu.appendChild(micLabel);
    settingsMenu.appendChild((0, $352d8f777a97466a$export$6b8f03eaf45fe3b8)(call));
    const speakerLabel = document.createElement("label");
    speakerLabel.innerText = "Altavoz";
    settingsMenu.appendChild(speakerLabel);
    const audioOutput = (0, $352d8f777a97466a$export$e73acf91ab165693)(call);
    if (audioOutput) settingsMenu.appendChild(audioOutput);
    if (!(0, $0073ed07eb3af726$export$d0a8044dce8ff2fc).any()) {
        const camLabel = document.createElement("label");
        camLabel.innerText = "Camara";
        settingsMenu.appendChild(camLabel);
        settingsMenu.appendChild((0, $352d8f777a97466a$export$3027322e3fd75560)(call));
    }
    $b4e14b6b8da86996$var$controlsContainer.appendChild(settingsMenu);
    const controls = (0, $302b5bb12cc47461$export$6d535e4753f6abc4)(call, onLeave);
    $b4e14b6b8da86996$var$callControls.appendChild(controls.audioButton);
    $b4e14b6b8da86996$var$callControls.appendChild(controls.videoButton);
    if ((0, $0073ed07eb3af726$export$d0a8044dce8ff2fc).any()) $b4e14b6b8da86996$var$callControls.appendChild(controls.flipButton);
    controls.chatButton.addEventListener("click", ()=>{
        const isOpen = onToggleChat();
        controls.chatButton.classList.toggle("active", isOpen);
    });
    $b4e14b6b8da86996$var$callControls.appendChild(controls.chatButton);
    controls.settingsButton.addEventListener("click", ()=>{
        settingsMenu.classList.toggle("open");
        controls.settingsButton.classList.toggle("active");
    });
    $b4e14b6b8da86996$var$callControls.appendChild(controls.settingsButton);
    $b4e14b6b8da86996$var$callControls.appendChild(controls.leaveButton);
    window.addEventListener("beforeunload", ()=>{
        call.leave();
    });
}
function $b4e14b6b8da86996$var$setupLayoutManager(call, participantRole) {
    call.setViewport($b4e14b6b8da86996$var$speakerView || document.body);
    const waitingState = $b4e14b6b8da86996$var$createWaitingState(participantRole);
    let dominantSpeakerSessionId = null;
    const updateLayout = (participants)=>{
        const localUserId = call.currentUserId;
        const remoteParticipants = participants.filter((p)=>p.userId !== localUserId);
        waitingState.classList.toggle("hidden", remoteParticipants.length > 0);
        let speakerParticipant = participants.find((p)=>p.sessionId === dominantSpeakerSessionId && p.userId !== localUserId);
        if (!speakerParticipant) speakerParticipant = participants.find((p)=>p.userId !== localUserId);
        participants.forEach((participant)=>{
            const isLocalUser = participant.userId === localUserId;
            const isSpeaker = participant.sessionId === speakerParticipant?.sessionId;
            let container = document.querySelector(`.participant-tile[data-session-id="${participant.sessionId}"]`);
            if (!container) {
                container = document.createElement("div");
                container.className = "participant-tile";
                container.dataset.sessionId = participant.sessionId;
                const nameLabel = document.createElement("div");
                nameLabel.className = "participant-name";
                nameLabel.textContent = participant.name || participant.userId || "Invitado";
                if (isLocalUser) nameLabel.textContent += " (Ud)";
                container.appendChild(nameLabel);
            }
            const targetParent = isSpeaker && !isLocalUser ? $b4e14b6b8da86996$var$speakerView : $b4e14b6b8da86996$var$sidebarParticipants;
            if (container.parentElement !== targetParent) targetParent.appendChild(container);
            (0, $ae1732977a50e3d7$export$ba106a60edcf9cbc)(call, participant, container, $b4e14b6b8da86996$var$speakerView);
        });
        const currentSessionIds = participants.map((p)=>p.sessionId);
        document.querySelectorAll(".participant-tile").forEach((tile)=>{
            const tileSessionId = tile.dataset.sessionId;
            if (tileSessionId && !currentSessionIds.includes(tileSessionId)) {
                tile.remove();
                (0, $ae1732977a50e3d7$export$e855ba20cf420751)(tileSessionId);
            }
        });
    };
    call.state.dominantSpeaker$.subscribe((dominantSpeaker)=>{
        dominantSpeakerSessionId = dominantSpeaker?.sessionId || null;
        updateLayout(call.state.participants);
    });
    call.state.participants$.subscribe((participants)=>{
        updateLayout(participants);
    });
}
function $b4e14b6b8da86996$var$setupDisconnectionTimeout(call, appointmentId, participantRole) {
    const timeoutSeconds = Number.isFinite($b4e14b6b8da86996$var$DISCONNECTION_TIMEOUT_SECONDS) ? Math.max(0, $b4e14b6b8da86996$var$DISCONNECTION_TIMEOUT_SECONDS) : $b4e14b6b8da86996$var$DEFAULT_DISCONNECTION_TIMEOUT_SECONDS;
    call.setDisconnectionTimeout(timeoutSeconds);
    (0, $c21e717f342a51d7$export$836669cc2ed6fccb)("Stream disconnection timeout configured", "info", {
        appointmentId: appointmentId,
        participantRole: participantRole,
        timeoutSeconds: timeoutSeconds
    });
}
function $b4e14b6b8da86996$var$updateConnectionStatusBanner(state) {
    const isReconnecting = state === (0, $8c05ed6f2f331ee8$export$e10ca39c0aa31acc).RECONNECTING || state === (0, $8c05ed6f2f331ee8$export$e10ca39c0aa31acc).OFFLINE;
    const hasFailed = state === (0, $8c05ed6f2f331ee8$export$e10ca39c0aa31acc).RECONNECTING_FAILED;
    $b4e14b6b8da86996$var$connectionStatusBanner.classList.toggle("connection-status-banner--failed", hasFailed);
    if (isReconnecting) {
        $b4e14b6b8da86996$var$connectionStatusBanner.innerHTML = `
      <div class="connection-status-title">Conexion inestable</div>
      <div class="connection-status-desc">Estamos intentando reconectar la llamada.</div>
    `;
        $b4e14b6b8da86996$var$connectionStatusBanner.classList.remove("hidden");
        return;
    }
    if (hasFailed) {
        $b4e14b6b8da86996$var$connectionStatusBanner.innerHTML = `
      <div>
        <div class="connection-status-title">No pudimos reconectar</div>
        <div class="connection-status-desc">Revisa tu conexion e intenta ingresar nuevamente.</div>
      </div>
      <button type="button" class="connection-status-action">Reintentar</button>
    `;
        $b4e14b6b8da86996$var$connectionStatusBanner.querySelector(".connection-status-action")?.addEventListener("click", ()=>window.location.reload());
        $b4e14b6b8da86996$var$connectionStatusBanner.classList.remove("hidden");
        return;
    }
    $b4e14b6b8da86996$var$connectionStatusBanner.classList.add("hidden");
}
function $b4e14b6b8da86996$var$registerMonitoring(client, call, appointmentId, participantRole) {
    client.on("network.changed", (event)=>{
        if (!event.online) (0, $c21e717f342a51d7$export$836669cc2ed6fccb)("Client network went offline during call", "warning", {
            appointmentId: appointmentId,
            participantRole: participantRole
        });
    });
    client.on("connection.changed", (event)=>{
        if (!event.online) (0, $c21e717f342a51d7$export$836669cc2ed6fccb)("Client connection lost during call", "warning", {
            appointmentId: appointmentId,
            participantRole: participantRole
        });
    });
    client.on("connection.recovered", ()=>{
        (0, $c21e717f342a51d7$export$836669cc2ed6fccb)("Client connection recovered", "info", {
            appointmentId: appointmentId,
            participantRole: participantRole
        });
    });
    call.on("call.session_ended", (event)=>{
        (0, $c21e717f342a51d7$export$836669cc2ed6fccb)("Call session ended", "warning", {
            appointmentId: appointmentId,
            participantRole: participantRole,
            eventType: event.type
        });
    });
    call.on("call.ended", (event)=>{
        (0, $c21e717f342a51d7$export$836669cc2ed6fccb)("Call ended", "info", {
            appointmentId: appointmentId,
            participantRole: participantRole,
            eventType: event.type
        });
    });
    call.on("call.session_participant_left", (event)=>{
        (0, $c21e717f342a51d7$export$836669cc2ed6fccb)("Participant left call session", "info", {
            appointmentId: appointmentId,
            participantRole: participantRole,
            eventType: event.type
        });
    });
    let lastReportedCallingState = null;
    let interruptedAt = null;
    call.state.callingState$.subscribe((state)=>{
        $b4e14b6b8da86996$var$updateConnectionStatusBanner(state);
        const isInterrupted = state === (0, $8c05ed6f2f331ee8$export$e10ca39c0aa31acc).RECONNECTING || state === (0, $8c05ed6f2f331ee8$export$e10ca39c0aa31acc).OFFLINE;
        if (isInterrupted && !interruptedAt) interruptedAt = Date.now();
        if (state === (0, $8c05ed6f2f331ee8$export$e10ca39c0aa31acc).JOINED && interruptedAt) {
            (0, $c21e717f342a51d7$export$836669cc2ed6fccb)("Call connection restored", "info", {
                appointmentId: appointmentId,
                participantRole: participantRole,
                callingState: state,
                disconnectedDurationMs: Date.now() - interruptedAt
            });
            interruptedAt = null;
        }
        if (state === lastReportedCallingState) return;
        lastReportedCallingState = state;
        if (isInterrupted) (0, $c21e717f342a51d7$export$836669cc2ed6fccb)("Call connection interrupted", "warning", {
            appointmentId: appointmentId,
            participantRole: participantRole,
            callingState: state
        });
        if (state === (0, $8c05ed6f2f331ee8$export$e10ca39c0aa31acc).RECONNECTING_FAILED) {
            (0, $c21e717f342a51d7$export$836669cc2ed6fccb)("Call reconnection failed", "error", {
                appointmentId: appointmentId,
                participantRole: participantRole,
                callingState: state,
                disconnectedDurationMs: interruptedAt ? Date.now() - interruptedAt : null
            });
            interruptedAt = null;
        }
        if (state === (0, $8c05ed6f2f331ee8$export$e10ca39c0aa31acc).LEFT) (0, $c21e717f342a51d7$export$836669cc2ed6fccb)("Call left", "info", {
            appointmentId: appointmentId,
            participantRole: participantRole,
            callingState: state
        });
    });
}
$b4e14b6b8da86996$var$init();


//# sourceMappingURL=app.e504c71f.js.map
